export const subtitles = {
    "L05yAJbhq6Y": {
        "1": {
            "start": 5.33,
            "end": 9.9,
            "transcript": "Niicugni, niicugnikina cali."
        },
        "2": {
            "start": 9.9,
            "end": 13.41,
            "transcript": "Pingayun luuskaat taiski."
        },
        "3": {
            "start": 16.27,
            "end": 18.12,
            "transcript": "Quyana."
        },
        "4": {
            "start": 22.07,
            "end": 27.84,
            "transcript": "Cali niicugniurqia, cetaman luuskaat taiski."
        },
        "5": {
            "start": 34.55,
            "end": 36.95,
            "transcript": "Assirpaa."
        },
        "6": {
            "start": 41.24,
            "end": 46.66,
            "transcript": "Niicugniurqia, arvinlegen luuskaat taiski."
        },
        "7": {
            "start": 66.16,
            "end": 67.92,
            "transcript": "Assirpaa."
        },
        "8": {
            "start": 139.35,
            "end": 141.11,
            "transcript": "Tang una block-aq."
        },
        "9": {
            "start": 147.31,
            "end": 151.39,
            "transcript": "Niicugniurqia, qanruciqamken callerkarpenek."
        },
        "10": {
            "start": 157.86,
            "end": 161.49,
            "transcript": "Block-aq yaassiigem qainganun elliu."
        },
        "11": {
            "start": 163.09,
            "end": 165.29,
            "transcript": "Assirpaa."
        },
        "12": {
            "start": 168.5,
            "end": 172.43,
            "transcript": "Block-aq yaassiigem iluanun ekiu."
        },
        "13": {
            "start": 174.12,
            "end": 175.84,
            "transcript": "Assirpaa."
        },
        "14": {
            "start": 181.82,
            "end": 186.8,
            "transcript": "Block-aq yaassiigem canianun elliu."
        },
        "15": {
            "start": 192.46,
            "end": 196.25,
            "transcript": "Block-aq yaassiigem acianun elliu."
        },
        "16": {
            "start": 203.6,
            "end": 206.94,
            "transcript": "Assirpaa. Assirtuq."
        },
        "17": {
            "start": 222.39,
            "end": 230.82,
            "transcript": "Kitak niicugniqernga atam. Kitak niiqerru pikna."
        },
        "18": {
            "start": 234.6,
            "end": 238.55,
            "transcript": "Niiqerru pikna."
        },
        "19": {
            "start": 248.84,
            "end": 251.65,
            "transcript": "Kitak niiqerru kan'a."
        },
        "20": {
            "start": 258.9,
            "end": 260.77,
            "transcript": "Nauwa pikna."
        },
        "21": {
            "start": 268.57,
            "end": 274.66,
            "transcript": "Nauwa kan'a. Assirtuq."
        },
        "22": {
            "start": 274.71,
            "end": 277.28,
            "transcript": "Nauwa kiugna."
        },
        "23": {
            "start": 288.94,
            "end": 291.2,
            "transcript": "Nauwa ugna."
        },
        "24": {
            "start": 298.66,
            "end": 300.16,
            "transcript": "Kitak-wa."
        },
        "25": {
            "start": 348.16,
            "end": 351.1,
            "transcript": "Atam niicugniqerr'u una."
        },
        "26": {
            "start": 355.55,
            "end": 361.6,
            "transcript": "Una-llu. Una-llu."
        },
        "27": {
            "start": 377.85,
            "end": 380.98,
            "transcript": "Atam cali niicugniqerr'u."
        },
        "28": {
            "start": 385.01,
            "end": 393.6,
            "transcript": "Una-llu. Una-llu. Niitaten?"
        },
        "29": {
            "start": 405.6,
            "end": 408.15,
            "transcript": "Patuqataranka."
        },
        "30": {
            "start": 414.22,
            "end": 422.32,
            "transcript": "Iliit neplirciquq. Neplirceciiqaqa iliit. Qanruskia naliata pillranek, okay?"
        },
        "31": {
            "start": 428.6,
            "end": 434.24,
            "transcript": "Caullrua? Caullrua? Una. Assirpaa."
        },
        "32": {
            "start": 439.8,
            "end": 442.82,
            "transcript": "Cali niicugnikina."
        },
        "33": {
            "start": 449.6,
            "end": 456.78,
            "transcript": "Caullrua? Ii-i, assirtuq."
        },
        "34": {
            "start": 461.62,
            "end": 468.6,
            "transcript": "Niitan? Caullrua? Ii-i, assirpaa."
        },
        "35": {
            "start": 489.66,
            "end": 492.5,
            "transcript": "Ukut cali waniwa."
        },
        "36": {
            "start": 495.82,
            "end": 504.06,
            "transcript": "Niitan? Una-llu. Una-llu."
        },
        "37": {
            "start": 506.6,
            "end": 509.4,
            "transcript": "Patuqataranka."
        },
        "38": {
            "start": 516.38,
            "end": 520.6,
            "transcript": "Iliit neplirceciiqaqa qanruskia naliata pillratni?"
        },
        "39": {
            "start": 529.6,
            "end": 533.34,
            "transcript": "Naliat pillrua? Ii-i."
        },
        "40": {
            "start": 542.78,
            "end": 546.72,
            "transcript": "Naliat pillrua? Ii-i, assirpaa."
        },
        "41": {
            "start": 552.72,
            "end": 556.08,
            "transcript": "Naliat pillrua? Ii-i, assirpaa."
        },
        "42": {
            "start": 658.98,
            "end": 662.4,
            "transcript": "Tang atam ukut tangerqerki."
        },
        "43": {
            "start": 662.76,
            "end": 666.64,
            "transcript": "Una qerrutet."
        },
        "44": {
            "start": 672.2,
            "end": 687.26,
            "transcript": "Sass'aq. Keggutet. Saskaq."
        },
        "45": {
            "start": 688.56,
            "end": 700.88,
            "transcript": "Nauwa. Niicugninqegcaarqina. Nauwa saskaq? Assirpaa."
        },
        "46": {
            "start": 700.88,
            "end": 706.8,
            "transcript": "Nauwa sass'aq? Ii-i."
        },
        "47": {
            "start": 706.8,
            "end": 711.7,
            "transcript": "Nauwa keggutet? Ii-i."
        },
        "48": {
            "start": 711.7,
            "end": 716.78,
            "transcript": "Nauwa-mi qerrutet? Ii-i. Assirpaa."
        },
        "49": {
            "start": 755.84,
            "end": 763.24,
            "transcript": "Atam una piluguum tarenra, tangrran? Piluguum tarenra."
        },
        "50": {
            "start": 776.16,
            "end": 781.04,
            "transcript": "Murilkeqa atam waten piaqama, piluguk."
        },
        "51": {
            "start": 792.04,
            "end": 794.46,
            "transcript": "Una-llu waniw' cali..."
        },
        "52": {
            "start": 858.6,
            "end": 864.78,
            "transcript": "Atam tangerqerru piluguum tarenra."
        },
        "53": {
            "start": 864.78,
            "end": 869.44,
            "transcript": "Una-llu tarenraunani."
        },
        "54": {
            "start": 870.2,
            "end": 875.82,
            "transcript": "Waten niicugnikia waten piaqama, piluguk, murilkellua piluguk."
        },
        "55": {
            "start": 880.52,
            "end": 894.92,
            "transcript": "Tua-ll' cali waten pikuma, kacik, tarenranek kaciim piitukuk. Waten ekluku."
        },
        "56": {
            "start": 900.22,
            "end": 905.24,
            "transcript": "Elpet ikayuqlunuk pinaurtukuk."
        },
        "57": {
            "start": 909.84,
            "end": 920.16,
            "transcript": "Ikayurniararpenga. Piluguk, natmun piciqa?"
        },
        "58": {
            "start": 923.28,
            "end": 929.0,
            "transcript": "Piluguk, ii-i assirpaa."
        },
        "59": {
            "start": 929.0,
            "end": 934.18,
            "transcript": "Pingayun, ii-i assirpaa."
        },
        "60": {
            "start": 941.12,
            "end": 948.34,
            "transcript": "Kalikaq, ii-i assirpaa."
        },
        "61": {
            "start": 951.06,
            "end": 956.92,
            "transcript": "Palayaq, ii-i assirpaa."
        },
        "62": {
            "start": 956.92,
            "end": 964.64,
            "transcript": "Piluguk, ii-i. Piluguk, ii-i assirpaa."
        },
        "63": {
            "start": 964.64,
            "end": 972.86,
            "transcript": "Kiluguk, ii-i assirpaa. Piluguk, ii-i assirtuq."
        },
        "64": {
            "start": 972.86,
            "end": 976.54,
            "transcript": "Piluguk, assirpaa."
        },
        "65": {
            "start": 983.7,
            "end": 993.92,
            "transcript": "Kitak nutaan, niicugninqegcaarqina, piluguk."
        },
        "66": {
            "start": 993.92,
            "end": 1006.54,
            "transcript": "Picuvuk, piluguk, assirpaa, siluguk."
        },
        "67": {
            "start": 1006.96,
            "end": 1014.56,
            "transcript": "Paacaq, assirpaa, piluguk."
        },
        "68": {
            "start": 1015.6,
            "end": 1025.54,
            "transcript": "Pigg', pilagak."
        },
        "69": {
            "start": 1025.54,
            "end": 1038.18,
            "transcript": "Piluguk, Evviluguk, assirpaa."
        },
        "70": {
            "start": 1038.18,
            "end": 1045.1,
            "transcript": "Pailgan, assirpaa."
        },
        "71": {
            "start": 1045.1,
            "end": 1052.36,
            "transcript": "Piluguk, ii-i, piluguk, assirpaa."
        },
        "72": {
            "start": 1052.36,
            "end": 1059.6,
            "transcript": "Piluguk, kiluguk, assirpaa."
        },
        "73": {
            "start": 1072.5,
            "end": 1088.08,
            "transcript": "Kitak cali, qantam tarenra, un'a-ll' tarenraunani."
        },
        "74": {
            "start": 1088.08,
            "end": 1094.9,
            "transcript": "Tangvaurqia, waten pikuma qantaq."
        },
        "75": {
            "start": 1102.9,
            "end": 1112.8,
            "transcript": "Igcaqunak. Qantaq."
        },
        "76": {
            "start": 1112.8,
            "end": 1124.22,
            "transcript": "Qantaq, assirpaa. Qaltak, ii-i assirpaa."
        },
        "77": {
            "start": 1124.22,
            "end": 1135.16,
            "transcript": "Quupak, assirpaa. Qantaq, qal'taq, assirpaa."
        },
        "78": {
            "start": 1136.56,
            "end": 1148.36,
            "transcript": "Nutaan cali pinaurtukuk. Niicugninqegcaarqina. Qantaq, assirpaa."
        },
        "79": {
            "start": 1148.36,
            "end": 1161.18,
            "transcript": "Qantaq, qip'aq, ii-i, qantak."
        },
        "80": {
            "start": 1167.18,
            "end": 1183.76,
            "transcript": "Qantaq, assirpaa. Qaltak, qantaq, kastak."
        },
        "81": {
            "start": 1186.6,
            "end": 1197.98,
            "transcript": "Qan, assirpaa, qantaq, kamtak."
        },
        "82": {
            "start": 1197.98,
            "end": 1206.4,
            "transcript": "Qantaq, hunt-aq, assirpaa."
        },
        "83": {
            "start": 1206.4,
            "end": 1217.82,
            "transcript": "Antaq, assirpaa. Qantaq. Qat'aq, assirpaa."
        },
        "84": {
            "start": 1266.96,
            "end": 1270.1,
            "transcript": "Atam ukuk tangerqerkek."
        },
        "85": {
            "start": 1273.0,
            "end": 1281.98,
            "transcript": "Kitak nasvitqernga angelria block-aq, ii-i assirpaa."
        },
        "86": {
            "start": 1296.84,
            "end": 1311.36,
            "transcript": "Tua-ll', kitak nasvitqernga mikellria candle-aaq. Una? Assirpaa."
        },
        "87": {
            "start": 1316.74,
            "end": 1324.04,
            "transcript": "Kitak nasvitqernga mikellria angqaq, ii-i, assirpaa."
        },
        "88": {
            "start": 1379.1,
            "end": 1382.18,
            "transcript": "Atam ukuk."
        },
        "89": {
            "start": 1384.1,
            "end": 1388.86,
            "transcript": "Una agteqerr'u."
        },
        "90": {
            "start": 1394.12,
            "end": 1402.16,
            "transcript": "Naliak, nasvitqernga teggellriamek. Ii-i, assirpaa."
        },
        "91": {
            "start": 1409.92,
            "end": 1419.84,
            "transcript": "Tua-ll' ukuk. Nasvitqernga unailngurmek, ii-i."
        },
        "92": {
            "start": 1424.48,
            "end": 1433.56,
            "transcript": "Ukuk-llu. Nasvitqernga unailngurmek, ii-i, assirtuq."
        },
        "93": {
            "start": 1486.6,
            "end": 1494.4,
            "transcript": "Tua-ll' ukuk cali. Naliak keggagceta?"
        },
        "94": {
            "start": 1527.86,
            "end": 1532.86,
            "transcript": "Tua-ll' ukuk, agtuqerkek atam."
        },
        "95": {
            "start": 1535.2,
            "end": 1538.3,
            "transcript": "Waten elliu."
        },
        "96": {
            "start": 1543.06,
            "end": 1549.58,
            "transcript": "Naliak keggagceta? Assirtuq."
        },
        "97": {
            "start": 1557.52,
            "end": 1561.86,
            "transcript": "Cali agturlukek taukuk."
        },
        "98": {
            "start": 1568.74,
            "end": 1571.74,
            "transcript": "Naliak manigceta?"
        },
        "99": {
            "start": 1581.2,
            "end": 1587.04,
            "transcript": "Una? Ii-i."
        },
        "100": {
            "start": 1589.64,
            "end": 1600.4,
            "transcript": "Cali, agturlukek. Naliak keggagceta?"
        },
        "101": {
            "start": 1602.62,
            "end": 1607.82,
            "transcript": "Assirpaa."
        }
    },
    "XYlmYCH4t8I": {
        "1": {
            "start": 0.0,
            "end": 10.5,
            "transcript": "Yaa, tailluku. Ellu'urtaarluk. Ellu'urtaarluk."
        },
        "2": {
            "start": 18.24,
            "end": 31.37,
            "transcript": "Apa'urluqa atakutarkamek akakiigmek qeltairiuq, nerairluku-llu."
        },
        "3": {
            "start": 31.37,
            "end": 38.7,
            "transcript": "Maurluq mingquq kameksaliluni."
        },
        "4": {
            "start": 38.7,
            "end": 44.54,
            "transcript": "Anerneq uyangqauq egalermi. Pukista..."
        },
        "5": {
            "start": 51.22,
            "end": 55.93,
            "transcript": "Ukut-gguq nani-llu ellu'urtaartat?"
        },
        "6": {
            "start": 59.15,
            "end": 68.49,
            "transcript": "(Mountain-aami.) Waten. Qengarugmi. (Nuu)."
        },
        "7": {
            "start": 72.26,
            "end": 75.65,
            "transcript": "Camek atak, easy-lriamek."
        },
        "8": {
            "start": 80.82,
            "end": 89.77,
            "transcript": "Caugat? (Cauga? Qimugta.)"
        },
        "9": {
            "start": 89.77,
            "end": 96.18,
            "transcript": "Yaa, maaten an'ut-gguq ukut qimugtet. (Kusqaq waniwa.)"
        },
        "10": {
            "start": 96.18,
            "end": 104.29,
            "transcript": "Nuu qimugtet, una-mi? (Yaqulek!) Yup, yaqulek."
        },
        "11": {
            "start": 110.83,
            "end": 113.35,
            "transcript": "Kiiryugtua."
        },
        "12": {
            "start": 116.81,
            "end": 127.2,
            "transcript": "Qanertuq Kavissuk, \"Unuakutanerrartuten-ggem ava-i Kavissuuq.\""
        },
        "13": {
            "start": 127.2,
            "end": 147.92,
            "transcript": "Qanertuq anerneq, \"Kitak-wa tangercetaaq iquklituq anglanakaqa ellu'urtaaneq. Ellu'urtaaryarluk anerneq.\""
        },
        "14": {
            "start": 151.15,
            "end": 164.56,
            "transcript": "Maurluq takuyarluni qanertuq, \"Ikamracuaraak elaturrami uitaut aturyukuvkek.\""
        },
        "15": {
            "start": 169.9,
            "end": 177.58,
            "transcript": "Maqaqluten piniartuten nunakuarcuutet tau͡gaam tumyaraatni'..."
        }
    },
    "zo_F-7rNWg0": {
        "1": {
            "start": 116.0,
            "end": 120.44,
            "transcript": "College-aami elitnaurat Europe-aamtellruut ataucimek iraluq cipluku."
        },
        "2": {
            "start": 120.44,
            "end": 126.0,
            "transcript": "Tengmiirviim iraluani ayagluteng kayangut anutiitmi tekilluteng."
        },
        "3": {
            "start": 126.0,
            "end": 131.0,
            "transcript": "Europe-aami-llu uitallermegni kangarturluteng kesianek pilallruut."
        },
        "4": {
            "start": 131.0,
            "end": 137.58,
            "transcript": "Amllermek wani arulaiqsaunata, kesianek wani ayagglainarluta pillruukut."
        },
        "5": {
            "start": 140.48,
            "end": 153.08,
            "transcript": "Atauciq wani nuna eliteqanemteggu ayagnerinaurtuq allamun nutaramun nunamun."
        },
        "6": {
            "start": 153.08,
            "end": 158.893,
            "transcript": "Malrunlegnun country-nun ayallruut. Cumikluki-llu ayuqenrilnguut yuuyarait."
        },
        "7": {
            "start": 158.92,
            "end": 166.5,
            "transcript": "Museum-aanun ak'allat laavkaanun paqtellruluteng-llu. Ayagallruut ukunun nunanun."
        },
        "8": {
            "start": 166.52,
            "end": 184.78,
            "transcript": "Ayallruukut Netherlands-aamun, Germany-aamun-llu, Italy-aamun, Switzerland-aamun, France-aamun, Belgium, Britain-aamun-llu. Amllertut."
        },
        "9": {
            "start": 184.78,
            "end": 192.24,
            "transcript": "Tanglalput tiiviini irrinarqellriit ullallrulliniat, agayuvigpiit ilakluki-llu."
        },
        "10": {
            "start": 192.24,
            "end": 197.92,
            "transcript": "Europe-armiut yuuyarait cali taringnaqumaluki cumikellruut."
        },
        "11": {
            "start": 197.92,
            "end": 212.78,
            "transcript": "Ancestor-ait wani yuuyarait cakneq qunukluku assikluki nasvagluki-ll' wangkucicetun cakneq tuaten ayuqelliniut."
        },
        "12": {
            "start": 212.78,
            "end": 221.66,
            "transcript": "Amllernek wani cakneq ak'allauqapiaralrianek can', amllernek wani tangellruukut."
        },
        "13": {
            "start": 221.66,
            "end": 236.34,
            "transcript": "Cakneq Europe-armiut yuuyarit tegumiaqengnaqkiit alangaavkarluki-ll' elitnaulriit elitaqevkarluki Yupiit, Europe-armiucetun yuuyaraput cali qaneryaraput tegumiaqengnaqelput."
        },
        "14": {
            "start": 236.34,
            "end": 250.0,
            "transcript": "Yuut amlleret qavcinek, language, qaneryaranek nalluvkenateng cakneq."
        },
        "15": {
            "start": 250.0,
            "end": 260.7,
            "transcript": "Tamana cucunarqelluni umyuamni-llu waten maani tuaten ayuqsuumaluta."
        },
        "16": {
            "start": 260.7,
            "end": 269.0,
            "transcript": "Amllernek-wa qaneryarangqellriit cali mumigciyugmaluteng allakarrauluni yuuyaramteńek."
        },
        "17": {
            "start": 269.0,
            "end": 281.14,
            "transcript": "Nutaramek yuuyaramek tanglleq anglanarqelalria tau͡gaam piciatun yug'ulriani Yupiit wall'u yuukunrilnguut nunamteńi ca taicimasciigalngukut."
        },
        "18": {
            "start": 281.14,
            "end": 283.8,
            "transcript": "Cakneq quyallruunga utertellemnek."
        },
        "19": {
            "start": 283.8,
            "end": 295.74,
            "transcript": "Yugtun quyanaqvaa-ll' tekilluteng, French-artun, bienvenue, tauna Kass'artun welcome-auguq, KYUK-mek Qangaallugaugua."
        }
    },
    "FucFOXEZj2c": {
        "1": {
            "start": 0.0,
            "end": 4.74,
            "transcript": "...pingayunlegnek allrakut cipluku."
        },
        "2": {
            "start": 4.74,
            "end": 15.2,
            "transcript": "Wangkuta-llu Yugtun, wiinga-llu Kass'atun Yugtun-llu elitnaurituunga. Kass'atun ayagnerani piqallruunga maa-i-llu Yugtun piaqlua."
        },
        "3": {
            "start": 15.96,
            "end": 24.3,
            "transcript": "Unuamek taillruunga qanrutnaluci wangkuta Yug'igni qaneryaraput atuyuilkumteggu."
        },
        "4": {
            "start": 24.3,
            "end": 31.2,
            "transcript": "Taringyuilengraameng yuut, tauna qaneryaraqa pininrituq."
        },
        "5": {
            "start": 32.94,
            "end": 42.48,
            "transcript": "Wiinga irniamnun nasvitaqa wangkuta qanraqamta allanun Kass'atun piarkaugukut, kiingan Kass'atun."
        },
        "6": {
            "start": 42.48,
            "end": 50.32,
            "transcript": "Wiinga Kass'atun piyugngaunga elpeci Kass'atun piyugngauci taumek Kass'atun qalarciiqukut. Tauna-llu qaneryaraq pininruluni."
        },
        "7": {
            "start": 50.32,
            "end": 64.7,
            "transcript": "Tua-llu wiinga kiingan Yugtun nevni piaqluten. Kiingan nevni piaqluten. Wiinga-qaa kipusvigmun agkuma qitevtelngu' iliini qitevtelngulartua. Kipusvigmun-llu pilua."
        },
        "8": {
            "start": 64.7,
            "end": 74.66,
            "transcript": "Tua-i-llu kina apluku camek tuar tang Yugtun qantuyalria apluku camek taringyuituq-gguq. Allamek yugmek tailluni, manager-aara tailuni."
        },
        "9": {
            "start": 74.72,
            "end": 82.56,
            "transcript": "Ellii-gguq-qaa Yugtun una-qaa taringyuituq-gguq. Tua-llu yuarluteng Yugtun qantulriamek."
        },
        "10": {
            "start": 82.56,
            "end": 88.86,
            "transcript": "Tau͡gken wiinga Kass'atun piyugngangraama iliini qitevtelngulartua."
        },
        "11": {
            "start": 88.86,
            "end": 100.56,
            "transcript": "Tuaten-llu taringaqlua. Atam-llu akiliurtenun piaqama akimka cimirluki kalikamek akipianun."
        },
        "12": {
            "start": 100.56,
            "end": 111.6,
            "transcript": "Tuani-llu atauciq calista tuani Yugtun qantuuq, wiinga tauna quyakepiarluku, wiinga iliitni qitevtelngulua taikuma uumun piciqua."
        },
        "13": {
            "start": 111.6,
            "end": 122.92,
            "transcript": "Tau͡gaam tegganreput qaillun piyartat? Taumek-qaa tegganreput iliitni qalamciyuitut, una qaneryaraq pininrituq, kiingan Kass'atun pici."
        },
        "14": {
            "start": 122.92,
            "end": 137.46,
            "transcript": "Waten-llu tauna iciw' neqlineq, wangkuta-gguq maani nunacuani uitalalriani piunrunritukut tauna neqlineq-llu."
        },
        "15": {
            "start": 139.2,
            "end": 152.72,
            "transcript": "Wangkuta-gguq iciw' wiinga waten taringtuaqa, taukut nunarpani uitalalriit wangkuta-gguq ciuniuqngaitaput neqnun, tamamta ayuqngamta."
        },
        "16": {
            "start": 153.22,
            "end": 162.12,
            "transcript": "Tau͡gken wangkuta neqkaput, elpeci-llu neqkaci ayuqevkenateng, aang wiinga dorito-ryugngaunga, aang chicken-atuunga."
        },
        "17": {
            "start": 162.12,
            "end": 172.5,
            "transcript": "Tau͡gaam kiimi taumek nerkuma yuguungaitua, kiingan qitevtelaquma anngaqama nemnek yuguungaitua."
        },
        "18": {
            "start": 172.5,
            "end": 179.42,
            "transcript": "Waten-llu yuuyaraput ayuqenritut, umyuaqelartut ilait, wangkuta maani nunarpagmi ayuqukut tamamta."
        },
        "19": {
            "start": 179.42,
            "end": 190.84,
            "transcript": "Tau͡gken piciryaraput ayuqepianritut, Kass'atun elpeci yungcarivci qantuut, pingayunrirnek-gguq mernek, saskanek mernek imangqelluni mer'arkauluci."
        },
        "20": {
            "start": 190.84,
            "end": 199.78,
            "transcript": "Tau͡gken tauna Yugtun mumigcimauq, wangkuta-gguq Yupiani kiingan ataucirramek saskamek mermek mer'arkaugukut."
        },
        "21": {
            "start": 199.78,
            "end": 212.52,
            "transcript": "Temput-gguq mermek imiquutgu nani yuilqumi cikuyaurtukut tamaqumta, tauna-gguq meq ilumteńi ciumek cikungciquq."
        },
        "22": {
            "start": 212.52,
            "end": 218.9,
            "transcript": "Tua-i-wa iqlutmun makuk ayuqlutek."
        },
        "23": {
            "start": 220.98,
            "end": 231.94,
            "transcript": "Elpeci qaneryaraci piciryaraci, wangkuta-llu piciryaraput tua-i ayuqepianritevkenatek allaulutek."
        },
        "24": {
            "start": 231.94,
            "end": 238.12,
            "transcript": "Tau͡gken wangkuta atauciurkauluta, wangkuta piciryaraput atauciurkauluni."
        },
        "25": {
            "start": 238.12,
            "end": 246.56,
            "transcript": "Tau͡gaam wiinga McDonald-aamun itquma, \"Aa, camek ca tepsarta?\" Tuaten yuglua qanerngaitua."
        },
        "26": {
            "start": 246.56,
            "end": 256.7,
            "transcript": "Wangkuta-llu McDonald-aatuni nertulriit, iciw' makut caulriit, cow-at-wa."
        },
        "27": {
            "start": 256.7,
            "end": 274.28,
            "transcript": "Taukut-gguq canegnek nertuut, niitelartua-gguq au͡gkut naparpiit, South Africa, South America-mi uitalriit kepuurluki makut ungungssirpat neqkaitnek nauluteng canegnek."
        },
        "28": {
            "start": 274.28,
            "end": 279.84,
            "transcript": "Tua-i-wa man'a ellarpak cimingluni-llu."
        },
        "29": {
            "start": 279.84,
            "end": 291.34,
            "transcript": "Wangkuta American-aani tang allat pii yuuyarat tegumiaqesciigat'laraput, yuuyarat pikluku tuantaurluten."
        },
        "30": {
            "start": 291.34,
            "end": 297.52,
            "transcript": "Tau͡gaam wangkuta tamamta American-aarukut waniwa piciryaraput Kass'atun piarkaput."
        },
        "31": {
            "start": 297.58,
            "end": 303.04,
            "transcript": "Hamburger-aat piarkaput, tau͡gaam taukut tepsaqellriit nerevkenaki."
        },
        "32": {
            "start": 306.74,
            "end": 321.98,
            "transcript": "Tamakut-llu pilput, wangkuta United States-ami uitalriani, 80% of the electric, or 80% of all the world's resources, wangkuta atutuaput."
        },
        "33": {
            "start": 321.98,
            "end": 328.48,
            "transcript": "Wangkuta-llu Yup'igni tauna piciryarat aturarkauluku, tegumiaqarkauluku,"
        },
        "34": {
            "start": 328.62,
            "end": 338.5,
            "transcript": "Qang'a, tauna iqlutmun uitauq wangkuta piciryaramteńi, wangkuta ca cuamek aturarkauluta."
        },
        "35": {
            "start": 338.5,
            "end": 351.56,
            "transcript": "Nuna amllermek aturpek'naku, kiingan neqkaarkamtenek piluta, cat cuanek-llu piluta piarkaugukut amllernek pingnaqevkenata."
        },
        "36": {
            "start": 354.06,
            "end": 362.78,
            "transcript": "Cat-llu egqaqivkenateng, egqaqivkenaki. Tuaten wangkuta yuuyaraput tuaten qanertuq."
        },
        "37": {
            "start": 363.86,
            "end": 381.12,
            "transcript": "Wangkuta tang yuuyaraput American-aaq tauna tegumiaqekumku yuuyaraqa au͡g'angqiquq, irungciquq, estuulumek tuaken igtengciquq ayuqenrilamek."
        },
        "38": {
            "start": 383.26,
            "end": 393.62,
            "transcript": "Atauciq tungulria atauciq qatellria, ayuqepianrituk. Qukaagni-llu tuar tang pisciigatellriik ayuqenrilamek, contradiction-aarulutek."
        },
        "39": {
            "start": 393.62,
            "end": 407.34,
            "transcript": "Una pingayunlegnek mer'arkauluni mermek, una-llu ataucimek, tau͡gaam yungcaristem qanrutaanga, kia-am tauna yugcarista elitnaullrua, au͡gkut-wa Kass'at, taumek-wa alartellriaten?"
        },
        "40": {
            "start": 409.76,
            "end": 428.7,
            "transcript": "Qaillun-kiq teggan' niicugniarkauceta tegganremteńun, maurlumteńun apa'urlumteńun ellaita wangkuta elitnaulput Kass'atun allaukuni Yugtun piciryaraat yuuyarait? Yaaqsigtuk."
        },
        "41": {
            "start": 431.02,
            "end": 445.72,
            "transcript": "Taukut-llu Kass'atun umyuaqelalriit. Wiinga iliitni qalarut'laranka, ukut teggan' angayuqat, ellaita-llu taringevkenii, iciw' tua-i tangesciiganaku qanelqa."
        },
        "42": {
            "start": 445.72,
            "end": 462.66,
            "transcript": "Wiinga-llu qanrulluki, elpet-wa anglillruavet makut Kass'at piciryarait yuuyarait aturluku, wiinga-llu taringaqa uitallren, wiinga tuaten-llu anglillruama, wiinga Kass'atun elitnaullruunga."
        },
        "43": {
            "start": 462.66,
            "end": 473.72,
            "transcript": "Taug͡aam cali-llu tegumiaqelaraqa wangkuta Yup'igni yuuyaraput, taumek nallunritaqa una alla yuuyaraq."
        },
        "44": {
            "start": 473.72,
            "end": 480.1,
            "transcript": "Kiingan atauciunrituq caarkaput yuut ataucikun nauyuitut."
        },
        "45": {
            "start": 481.06,
            "end": 493.9,
            "transcript": "Tau͡gaam wangkuta ataucikun-gguq, iciw' cat atanrurarkaugut ataucikun-gguq wangkuta ayuqluta."
        },
        "46": {
            "start": 493.9,
            "end": 507.72,
            "transcript": "Iciw', one law, tau͡gken yuuyarat taukut ayuqenritellriik, medium-aamek nalaqesciiganateng."
        },
        "47": {
            "start": 507.72,
            "end": 514.74,
            "transcript": "Qukaanun tekitesciiganateng allausiyaaramek."
        },
        "48": {
            "start": 514.74,
            "end": 530.5,
            "transcript": "Tua-i-llu wangkuta maani rural Alaska-mi uitalalriit, wiinga ayagyuarengraama, puqailengraama, piciryaramteńi, yuuyaramteńi-llu, qaneryaramteńi-llu niitelartua."
        },
        "49": {
            "start": 530.5,
            "end": 538.54,
            "transcript": "Wangkuta-gguq Eben Hobson-aaq, Eben Hobson-aam umyuaqellra, tegumiaqelaraput."
        },
        "50": {
            "start": 538.54,
            "end": 548.6,
            "transcript": "Wangkuta allakaryugngaukut, ukut American-aat kiimeng piciryarait assinrunrituq, allat-llu piuyugngaut."
        },
        "51": {
            "start": 548.6,
            "end": 564.1,
            "transcript": "Kiingan wangkuta akikun ayagangaitukut, allat-llu cat piciryarat ayagavkaryugngaakut assililuta-llu."
        },
        "52": {
            "start": 564.1,
            "end": 572.46,
            "transcript": "Tamana kiingan qanrucugluci, elpeci ilavceńun amaken nunarpani qanrutniaraci."
        },
        "53": {
            "start": 572.46,
            "end": 580.96,
            "transcript": "Wangkuta ayagyuani puqialengraamta au͡gkut tegganret Eben Hobson-aacetun niitelaaput qanellrit."
        },
        "54": {
            "start": 580.96,
            "end": 595.1,
            "transcript": "Wangkuta allakaryugngaukut, yuuyaraput ayuqessiiyaanrilkuneng, allakaussiiyaagkuneng, wangkuta allakaryugngaukut. Kiingan."
        }
    },
    "7Vv53OpV6wU": {
        "1": {
            "start": 548.04,
            "end": 551.77,
            "transcript": "Kinguqlillrani iliini-ll' qanengcuaqercia [?]."
        },
        "2": {
            "start": 551.77,
            "end": 559.57,
            "transcript": "Wani-llu uumi [?] quyaunga cakneq wani uumi atqanek maavet ellillratnek mat'umun-llu atra ellillranek."
        },
        "3": {
            "start": 559.57,
            "end": 570.76,
            "transcript": "Wani wangkuta umyuaqutek'larciqngamteku atra tangrraqamteku maani uitallra ellavkenani uitallrani cali umyuaqutekluku piqarniarput."
        },
        "4": {
            "start": 570.76,
            "end": 577.58,
            "transcript": "Waniwa catairuteng'e'rmi uniiteng'e'rmi-llu caniqurrallmi [?] caliaqellrui cali ilagaraakut."
        },
        "5": {
            "start": 579.06,
            "end": 583.92,
            "transcript": "Waniw' nallunritaqa-llu wiinga imumi ayagyuallemegni."
        },
        "6": {
            "start": 583.92,
            "end": 590.74,
            "transcript": "Aipaqungalallruukuk piani caliurlunuk-llu aipaqlunuk pitullruukuk."
        },
        "7": {
            "start": 590.74,
            "end": 603.1,
            "transcript": "Waniwa tamatum nalliini aipaq'lagpegni yuut tamalkuita qalarutetullrit, qalaruten nallunguurpek'naki."
        },
        "8": {
            "start": 603.1,
            "end": 614.5,
            "transcript": "Tekitelpuk tamalkuita mikelnguungauta-llu upulluki ayuqluki. Tua-i mikelnguut qalarulluki ayuqluki ilaliurluki pitullrukai."
        },
        "9": {
            "start": 615.72,
            "end": 622.12,
            "transcript": "Ilaita tau͡gaam nalluvtai nunuryukluteng umyuarteq'lallrui."
        },
        "10": {
            "start": 622.12,
            "end": 632.86,
            "transcript": "Nunurnilutek-llu qanaaqluteng [?] taumun yuk nutaan ping'em tangeng'ermeng [?] nunuqii watua tuaten ayuqelallruuq."
        },
        "11": {
            "start": 632.86,
            "end": 640.64,
            "transcript": "Tua-i nallunritellrua ak'a tangrramiu wiinga cali [?] piuralallrukiinga kesianek."
        },
        "12": {
            "start": 640.64,
            "end": 647.66,
            "transcript": "Cali yuut tamalkuita cali, yuut tamalkum ca watua yugni."
        },
        "13": {
            "start": 647.66,
            "end": 655.16,
            "transcript": "Iqlutnun cingumakelriatellruakut [?] tau͡gaam elluarrluta kesianek pisqumaluta pisqukiikut."
        },
        "14": {
            "start": 659.56,
            "end": 665.98,
            "transcript": "Tamana tua-i umyuaqutkaqerput waniwa tamartevkenaku uum atra tuaten ayuqniartukut."
        },
        "15": {
            "start": 665.98,
            "end": 672.96,
            "transcript": "Kesianek umyuaqaqamteku tamana yuullra cavkenani umyuaqaqluku piniarput qanrilallratun."
        },
        "16": {
            "start": 675.72,
            "end": 685.48,
            "transcript": "Amllernek qanerngaitua tamatumek qanerciqua qalartaqama erina [?] cakneq waten [?] tua-i."
        },
        "17": {
            "start": 685.48,
            "end": 691.0,
            "transcript": "Umyuarteqluni waniwa tangerrluku waniwa yugnek kenkicacillra."
        },
        "18": {
            "start": 691.0,
            "end": 697.98,
            "transcript": "Yugnikekngian amllertaciit nallunritestaat ilungallruuq [?] nunanek maaken avatemteńi."
        },
        "19": {
            "start": 697.98,
            "end": 706.46,
            "transcript": "Tua-i tamana cali ayuqnianarqelriaruuq waten ilaminek kenkillra waten tua-i [?] ilain tamarmeng."
        },
        "20": {
            "start": 706.46,
            "end": 715.58,
            "transcript": "Yuut navnguavkenaki umyugaan yuullran tamaa-i nallunairutii, nallunairutii wangkuta-llu cali tuaten ayuqniartukut."
        },
        "21": {
            "start": 715.58,
            "end": 727.1,
            "transcript": "Ilaput nallunguavpek'naki elluam tau͡gaam tungiinun piluarrluteng elluarrluteng pillerkaatnun canek maqyartungnaqluki [?] ilaput piniartukut."
        },
        "22": {
            "start": 727.1,
            "end": 736.34,
            "transcript": "Caungraata qaillun pituungrata qaillun ik'ikevkenaki ciutek'suarluki [?] kesianek pingnaqevkarniaput."
        },
        "23": {
            "start": 736.34,
            "end": 745.44,
            "transcript": "Tuaten ayuqengnaqniartukut-llu wangkuta ava-i tuaten ayuqellmikun nasvaumallrua yugni kenkitacini."
        },
        "24": {
            "start": 745.44,
            "end": 756.38,
            "transcript": "Tuaten tua-i pitaqerluku una qanrutkaqa, tau͡gaam cali qanerkangqertua uumek ava-i imkuciiqlugput, ciivvaqlugput [?] wangkuta."
        },
        "25": {
            "start": 756.38,
            "end": 762.86,
            "transcript": "Tayima keniunak tegustengeksailamta tayima tauna cali yuut."
        },
        "26": {
            "start": 762.86,
            "end": 770.82,
            "transcript": "Tua-i-wa iiqumteggu assinruyartuq tauna eniit tauna maa-i calillermini uitallruuq."
        },
        "27": {
            "start": 770.82,
            "end": 778.68,
            "transcript": "Wiinga umyuaq ingna [?], waniwa kitumun maligtengqerquma taumek [?] assiryartuq."
        },
        "28": {
            "start": 778.68,
            "end": 785.18,
            "transcript": "Nallunritaa-llu maantellermini, natengtekluku-llu [?] maani ak'a [?]."
        },
        "29": {
            "start": 785.18,
            "end": 798.6,
            "transcript": "Cali-llu ayuqutnun nalluvkenaku, cali-llu quyurtaarqameng cali ilakluku tuaten quyurtaalallrulriit. Tayima nallunritua elluarrluni calillra yugnun."
        },
        "30": {
            "start": 798.6,
            "end": 809.84,
            "transcript": "Tamana umyuarrluku tayima calilartuq elluarrluni piyukuvciu tua-i umyuangcautekluku taumun eniinun ellikuvci tayima cayartaalpeceńi."
        },
        "31": {
            "start": 809.84,
            "end": 820.54,
            "transcript": "Piyukuvci tayim' umyuangcautekerraarluku tuavet cimiukuvci assinruciquq eniinun, tua-i tuaten pitaqerluku tuaten qanertua quyana."
        }
    },
    "-pmJJag2xLs": {
        "1": {
            "start": 12.8,
            "end": 20.38,
            "transcript": "Nuna uitavigput ang'uq, nunacuaraat-llu yaaqsiutaqluteng [?]."
        },
        "2": {
            "start": 20.52,
            "end": 28.91,
            "transcript": "Uksuq akemkumiunun caperrnaq'lartuq, ayagasciigatnaqluni-llu ellaitnun nunacuaraat alianaq'lartut."
        },
        "3": {
            "start": 35.17,
            "end": 45.95,
            "transcript": "Yuut tau͡gken tamaanelnguut aliayuksaunateng nunakngamegteggu, cailkamek carrluanek aturluteng anglanissaagaryugngaut."
        },
        "4": {
            "start": 46.05,
            "end": 57.91,
            "transcript": "Ak'allaat piciryarateng qelkelarait cat cimingraata, tan'gaurluq kitugcissuutmek mumigcilria qerraryaratun ayuquq allat yuyaraitnun."
        },
        "5": {
            "start": 60.63,
            "end": 65.84,
            "transcript": "Yupiit snuukuutgun ayagciigalkuneng qimugteńun cayugngaut [?]."
        },
        "6": {
            "start": 77.84,
            "end": 88.84,
            "transcript": "Ilait ak'allaat cimirciigatut nutaranun, [tua-i-ll' waniw' tamamta] ciuqvanek cat ayagnillret kingunrulrianun elitnaurumalartut."
        },
        "7": {
            "start": 96.12,
            "end": 99.68,
            "transcript": "Elitelteng cali allanek nutaranek ilalarait."
        },
        "8": {
            "start": 104.3,
            "end": 110.35,
            "transcript": "Makut mikelnguut kinguqvaarni qayagaurumaarkaungameng amlleret caarkat caliaqesqelluki,"
        },
        "9": {
            "start": 111.85,
            "end": 113.54,
            "transcript": "kalikiurteńguluteng,"
        },
        "10": {
            "start": 119.29,
            "end": 121.16,
            "transcript": "yungcaristeńguluteng."
        },
        "11": {
            "start": 127.84,
            "end": 133.84,
            "transcript": "Allakarmeng yuungnaqluteng. Ilait-llu elitnauristeńguluteng."
        },
        "12": {
            "start": 134.04,
            "end": 141.22,
            "transcript": "Atauciq. Malrun. Malrun. Pingayun. Pingayun."
        },
        "13": {
            "start": 141.84,
            "end": 149.08,
            "transcript": "Alaska-mi elitnaurilleq anglanaqsugngauq. Mikelnguut-llu angayuqrit ikayuutngurpagaqluteng."
        },
        "14": {
            "start": 156.84,
            "end": 163.84,
            "transcript": "Mikelnguut ilaita ciunerkaat assirngatuq, Kass'atun qalarcugngariameng Yugcetun pitaluteng."
        },
        "15": {
            "start": 170.58,
            "end": 177.84,
            "transcript": "Ukut mikelnguut nunameggnun akqiyugngaut Kass'acetun, nunanirqutii-llu atuutekluku Yugcetun."
        },
        "16": {
            "start": 177.84,
            "end": 183.71,
            "transcript": "America [?] agayutem."
        },
        "17": {
            "start": 187.01,
            "end": 199.32,
            "transcript": "Una qanemciuguq qaneryarignegun elitnauriyaramek aterluni Primary Eskimo Program (PEP). Yugceturpalleq qalarcetulit nuniitni atuuluni."
        },
        "18": {
            "start": 202.22,
            "end": 206.84,
            "transcript": "Una qanemciuguq nasaurlucuarmek allanek-llu mikelngurnek."
        },
        "19": {
            "start": 206.84,
            "end": 209.84,
            "transcript": "Qanemciuguq qulnek allrakungqerrluni."
        },
        "20": {
            "start": 218.51,
            "end": 222.19,
            "transcript": "Igangukut? Yaa, igangellruuci."
        },
        "21": {
            "start": 233.84,
            "end": 237.55,
            "transcript": "Igangukut!"
        },
        "22": {
            "start": 278.49,
            "end": 282.78,
            "transcript": "Tarenran tegullruaqa assirtuq. Waniwa pika."
        },
        "23": {
            "start": 282.89,
            "end": 290.73,
            "transcript": "Ciuqvaarni ikgetellruut mikelnguut elitnaullret nunameggni Kass'acetun, naaqituluteng wall' mumigcituluteng."
        },
        "24": {
            "start": 291.53,
            "end": 299.84,
            "transcript": "Amlleret-llu Yugcetun qalarcetulit Kass'acetun naaqisciiganateng, igarciiganateng wall' taringesciiganateng."
        },
        "25": {
            "start": 299.96,
            "end": 302.99,
            "transcript": "Akimni Osaka Japan-armiunguuq."
        },
        "26": {
            "start": 333.75,
            "end": 341.19,
            "transcript": "Qang'a, Deborah-m kinguqlia Wassilie igangnariksaitaa. Kass'acetun naaqiyaarpailegmi Yugcetun ciumek pinarqaa."
        },
        "27": {
            "start": 341.77,
            "end": 346.85,
            "transcript": "Ayagnerralriit qaneryaragnegun ilagarluki eliciiquq canek Yugcetun."
        },
        "28": {
            "start": 347.31,
            "end": 354.36,
            "transcript": "Aperyarat cauciit Yugcetun elicimarikuniki, Kass'acetun nutaan elitnaurciqai."
        },
        "29": {
            "start": 356.22,
            "end": 362.85,
            "transcript": "PEP-q pinqegcaraumaluni taqumauq. Taktaciit cuqcimaluteng elitnaullrata."
        },
        "30": {
            "start": 363.38,
            "end": 370.89,
            "transcript": "Yugcetun Kass'acetun-llu elitnauristet quyurtelartut. Yugcetun elitnaullrat Kass'acetun cali piarkauluku."
        },
        "31": {
            "start": 376.84,
            "end": 383.36,
            "transcript": "Maa-i anglanarquq elitnaurilleq elitelleq-llu qaneryaragnegun PEP-q ayagnirraanranek."
        },
        "32": {
            "start": 383.36,
            "end": 387.36,
            "transcript": "Waten tau͡gaam ciungani ayuqellrunrituq."
        },
        "33": {
            "start": 387.36,
            "end": 392.56,
            "transcript": "Allrakut amlleret aturluki Yupiit nasaurluut qanemcit'lallruut yaaruiluteng."
        },
        "34": {
            "start": 392.56,
            "end": 396.84,
            "transcript": "Naaqisciigatellruut umyuaqelteng-llu igaucesciiganaki."
        },
        "35": {
            "start": 396.84,
            "end": 404.84,
            "transcript": "Yugcetun igaryarartaitellruan kalikaunateng-llu naaqerkameggnek. [Ingqiyarturlutek-gguq waten]"
        },
        "36": {
            "start": 404.84,
            "end": 411.22,
            "transcript": "Igaryarartaunaku qulirat qanemcit wall'u cat ak'allaat cimiryugngaut wall'u nalluyagucugngaluki."
        },
        "37": {
            "start": 411.22,
            "end": 415.84,
            "transcript": "Waten-gguq uitaarqellriik arnassagankuk apa'urluq-llu."
        },
        "38": {
            "start": 417.84,
            "end": 422.84,
            "transcript": "Elitnauringnaqellret Kass'acetun imumi elluaturqessiyaallrunritut."
        },
        "39": {
            "start": 445.23,
            "end": 447.84,
            "transcript": "Kass'acetun eliculriit piyugngaut."
        },
        "40": {
            "start": 447.84,
            "end": 458.31,
            "transcript": "Tamakut ikayurnaluki BIA-q ayagcecillruuq elitnauristenek Alaska-mun, tau͡gaam tamakut elitnaurciigatellriit Kass'acetun elitnauriyaramegteggun."
        },
        "41": {
            "start": 498.6,
            "end": 506.84,
            "transcript": "Mikelnguut elitesciiganateng pillrunritut. Eligarrngigtut. Yugcetun-llu camek qanrutellriani nalluyagucuunaku."
        },
        "42": {
            "start": 548.32,
            "end": 551.84,
            "transcript": "Ayuqenrilnguut naspaatet amllellruut tekitarkat."
        },
        "43": {
            "start": 551.84,
            "end": 560.84,
            "transcript": "Tau͡gaam assirikanirpallruuq picirkiullratni elitnauriyaurcugluteng Yugcetun elitellrit-llu kingumek Kass'acetun elitnaurluki."
        },
        "44": {
            "start": 560.84,
            "end": 568.84,
            "transcript": "Tuani pinarqellria-urtuq [?] taqutellerkaat Yugcetun nallunailngurnek igaryaranek."
        },
        "45": {
            "start": 568.84,
            "end": 575.84,
            "transcript": "BIA-q anguyagta taitellruuq elitnauristenek University of Alaska-mek taqutesqelluki igaryaranek."
        },
        "46": {
            "start": 575.84,
            "end": 581.55,
            "transcript": "Yugcetun naaqiyugngariarkaurtut. Yugcetun-llu kalikanek taqucugngariluteng."
        },
        "47": {
            "start": 581.55,
            "end": 584.84,
            "transcript": "Pingraan tau͡gaam Yugcetun elitnauristet ikgetut."
        },
        "48": {
            "start": 593.46,
            "end": 604.27,
            "transcript": "Qaneryaragnegun calivigmek taqutellruut Mamterillermi, elisngalriit calillgutkesqelluki Yugcetun elitnauristet elitnaurissuutnek-llu taqulluteng."
        },
        "49": {
            "start": 610.37,
            "end": 617.79,
            "transcript": "Elitnaurissuutnek taqutellruut ikayuutngusqelluki Yugcetun elitnauristenun Kass'acetun-llu."
        },
        "50": {
            "start": 617.79,
            "end": 621.84,
            "transcript": "Yugcetun igausngalriit tarenrakegtaarnek avauqluki [?]."
        },
        "51": {
            "start": 625.24,
            "end": 631.84,
            "transcript": "Makut-llu nunanun ayautellruit nasviknaluki elitnauristet qaillun aturarkauciit elitnaurvigni."
        },
        "52": {
            "start": 634.2,
            "end": 642.84,
            "transcript": "Murilkestet-llu waken education research associates nunanun tarrirtelartut assirtassiarluku qaneryaragnegun elitnaurilleq."
        },
        "53": {
            "start": 646.73,
            "end": 654.84,
            "transcript": "Atauciuraqluteng-qaa elitut? Quyungqaluteng-qaa elitenruut? Qaku Kass'acetun naaqiyugngariciqat?"
        },
        "54": {
            "start": 655.23,
            "end": 664.84,
            "transcript": "Makut allanek cali apyutnek ilaluteng alulalaraat PEP-q assirillerkaanun, mikelnguut-llu elitnaullrata cukataciat cuqluku."
        },
        "55": {
            "start": 668.84,
            "end": 671.84,
            "transcript": "Cagluaq. [Mik'uq.]"
        },
        "56": {
            "start": 671.84,
            "end": 677.84,
            "transcript": "Elitnauqerraalriit nanilngurnek elitnaulartut. Allamikuani-llu [?] takenritnek."
        },
        "57": {
            "start": 677.84,
            "end": 682.45,
            "transcript": "Quyauq. Kuk'uq."
        },
        "58": {
            "start": 694.8,
            "end": 699.87,
            "transcript": "Allakarmeng naaqiluteng, quyurmeng kiutengqerrluteng,"
        },
        "59": {
            "start": 699.87,
            "end": 707.48,
            "transcript": "allat naaqillgucirluten ikayuutnguyugngaut ayagniqarraallerpeni, naspaanrilnguq elitesciigatuq."
        },
        "60": {
            "start": 721.27,
            "end": 729.84,
            "transcript": "Naaqutet ayuqelartut qaneryarat ayuqenrilengraata. Ukut mikelnguut elitnaurtut naaqut'liuryaranek Yugcetun."
        },
        "61": {
            "start": 736.25,
            "end": 740.3,
            "transcript": "Alareskuni iliit ciumek Yugcetun nallunrirciqaa."
        },
        "62": {
            "start": 771.84,
            "end": 775.84,
            "transcript": "Naanguarluni naaqutnek elitnaulleq anglanarquq."
        },
        "63": {
            "start": 791.2,
            "end": 797.67,
            "transcript": "Naaqiyaraq, igaryaraq, naaqut'liuryaraq, waniwa-llu ellarpiim yuin-llu ayuqucia."
        },
        "64": {
            "start": 797.67,
            "end": 801.38,
            "transcript": "Qaillun kiircetellriani nunani mikelnguut yuulartut."
        },
        "65": {
            "start": 801.38,
            "end": 804.84,
            "transcript": "Necuaraat alla yuut canegnek qaliqalget."
        },
        "66": {
            "start": 804.84,
            "end": 808.84,
            "transcript": "Yupiit-qaa ilumun qanikcanek nengqertut?"
        },
        "67": {
            "start": 808.84,
            "end": 813.84,
            "transcript": "Caugat ayuqenriluteput allanek yaaqvarmiunek mikelngurnek?"
        },
        "68": {
            "start": 827.16,
            "end": 837.23,
            "transcript": "Naanguatgun, kalikatgun, allatgun-llu cetamani allrakuni elitnaullret Yugcetun Kass'acetun-llu Kass'aturrlainaq elitnauryugngarilartut."
        },
        "69": {
            "start": 859.98,
            "end": 868.21,
            "transcript": "Cup'uq, yuut-llu caarkait cimiqatarluteng, elitnaulriit taq'ut, yuut-llu upluteng neqsurnaluteng."
        },
        "70": {
            "start": 868.74,
            "end": 871.76,
            "transcript": "Kiak calirpagnarquq anglanaqluni tuaten."
        },
        "71": {
            "start": 881.04,
            "end": 889.24,
            "transcript": "Amlleret nunat unguvallrat tusngalartuq ungungssinun neqnun-llu. Kiagmi cangtait uksurpak neqnguarkaugut."
        },
        "72": {
            "start": 891.58,
            "end": 897.43,
            "transcript": "Kiagmi qaneryarignegun elitnauritulit ayalartut elitnauryarturluteng Mammoth Oregon-aamun."
        },
        "73": {
            "start": 914.19,
            "end": 923.84,
            "transcript": "Ilaku'urluteng calilartut elitnaurcuutnek upluteng anglanariluki-llu. Tamakut-llu elitelteng nunameggnun ut'rulluki."
        },
        "74": {
            "start": 939.17,
            "end": 944.74,
            "transcript": "Ikayutnguciqellria yuarun mikelngurnun elitnauqerraalrianun igaryarameggnek."
        },
        "75": {
            "start": 949.84,
            "end": 953.22,
            "transcript": "Nanguarutet ikayularait caperrsuaralriit."
        },
        "76": {
            "start": 958.23,
            "end": 963.21,
            "transcript": "Cat avatmeggni taringekanirarkauluki calilartut unatmegteggun."
        },
        "77": {
            "start": 969.52,
            "end": 976.78,
            "transcript": "Mikelnguut nunani tuskanek nengqertut, tau͡gaam ilaita naken tuskat tailauciiit nalluit."
        },
        "78": {
            "start": 988.32,
            "end": 992.56,
            "transcript": "Tarrirrluteng elitnauristet avulartut elitnaurutkameggnek."
        },
        "79": {
            "start": 1001.5,
            "end": 1007.12,
            "transcript": "Iqvarnertulliniami [?] una nunamini ciumek ak'a mayuuqerrluni iqvartuq."
        },
        "80": {
            "start": 1014.07,
            "end": 1019.71,
            "transcript": "Kiagmi elitnauryallret umyuaqerkait amllelartut, tangrrarkat amllelaameng."
        },
        "81": {
            "start": 1021.06,
            "end": 1029.38,
            "transcript": "Kalikaci ikirrluki Page One-aamun naaqiqatartukut. Kitek Cagluaq naaqiqaa."
        },
        "82": {
            "start": 1029.38,
            "end": 1034.22,
            "transcript": "Waniwa Kuk'uq una qimugteni."
        },
        "83": {
            "start": 1034.22,
            "end": 1040.1,
            "transcript": "Assirpaa-ll' kitek, Alciiq Page Two-aaq naaqiqerr'u."
        },
        "84": {
            "start": 1041.5,
            "end": 1046.84,
            "transcript": "Kuk'uq aanangqertuq. Waniwa ukut Kuk'um ilai."
        },
        "85": {
            "start": 1047.1,
            "end": 1052.43,
            "transcript": "Assirpaa-ll' kitek Nayak'aq, Page Three-aaq naaqiqer'."
        },
        "86": {
            "start": 1052.43,
            "end": 1054.54,
            "transcript": "Kuk'uq neryunqegtuq."
        },
        "87": {
            "start": 1057.17,
            "end": 1066.41,
            "transcript": "Qaneryaragnegun elitnaulriit mikelnguut ilait yuarutet maliggluki aturcetaaryugngaut, kinguqvaarni-llu niitenriyugngaluteng."
        },
        "88": {
            "start": 1072.02,
            "end": 1077.84,
            "transcript": "Cheer leader-aat tangvallrat cali anglanarquq, wrestle-aalriit cingumaurluki."
        },
        "89": {
            "start": 1086.84,
            "end": 1088.73,
            "transcript": "Kitek Mary dial-aarru."
        },
        "90": {
            "start": 1091.84,
            "end": 1096.84,
            "transcript": "Malruk qaneryarak, malriim-llu aipani qayagauryugngaluku."
        },
        "91": {
            "start": 1101.84,
            "end": 1103.16,
            "transcript": "Waqaa."
        },
        "92": {
            "start": 1119.83,
            "end": 1131.86,
            "transcript": "Aperyarat kalikaitnek elitnaurtut. Yugtun-llu tamakunek pingellruukut. Qaneryaragnegun elitnaullret quyigikanirqata Kass'artaat aperyaraita kalikait elitnaularait."
        },
        "93": {
            "start": 1134.93,
            "end": 1141.04,
            "transcript": "Makut tau͡gaam caperrnaqsartut yuut angayuqerrulriit-llu ikayuutellrunrilkata."
        },
        "94": {
            "start": 1141.5,
            "end": 1147.85,
            "transcript": "Quyurtelartut mikelnguut angayuqrit ilakluki ikayuusqelluteng elitnaurutnek yuallratni."
        },
        "95": {
            "start": 1148.45,
            "end": 1156.02,
            "transcript": "Angayuqrulriit elitnauristet ikayualarait. Taumek PEP-q assiirikanirluni ayagturalalria."
        },
        "96": {
            "start": 1173.84,
            "end": 1176.51,
            "transcript": "Yaaggun massiinaqatarluki."
        },
        "97": {
            "start": 1178.84,
            "end": 1189.84,
            "transcript": "Waten-llu maa-i elirqelararkauluki, maa-i-ll' makunek makuatgun asgurualirarkauluku wall'u unavet ellakuanun elliluku."
        },
        "98": {
            "start": 1189.84,
            "end": 1191.84,
            "transcript": "[?]"
        },
        "99": {
            "start": 1191.84,
            "end": 1193.84,
            "transcript": "Unuaqu cauciqa?"
        },
        "100": {
            "start": 1193.84,
            "end": 1196.57,
            "transcript": "[?]"
        },
        "101": {
            "start": 1196.57,
            "end": 1200.13,
            "transcript": "Qaill' piciqceci unuaqu?"
        },
        "102": {
            "start": 1279.66,
            "end": 1287.55,
            "transcript": "[Igarcuun.] Elluatuqluni ayallra elitellni-llu nalluyagutevkenaki cuqcimakuni assirciqut."
        },
        "103": {
            "start": 1287.63,
            "end": 1309.97,
            "transcript": "Yugcetun elitnaulleq igalleq-llu ikayuutngulartut cat avaken ayagnillret tamarcetevkenaki."
        },
        "104": {
            "start": 1310.35,
            "end": 1314.55,
            "transcript": "Assirluteng elitnauquneng tamana caarkaq cayaraiciiquq."
        },
        "105": {
            "start": 1420.96,
            "end": 1426.09,
            "transcript": "Nasvag- [?] Yugtun qaqitengnaqluki nunat pikuneng assirikanirciqut"
        },
        "106": {
            "start": 1426.09,
            "end": 1433.62,
            "transcript": "Qaneryaragnegun-llu qalarcetulit amllerikanillrat maliggluku caarkait quyigikanilriacetun piciqut."
        },
        "107": {
            "start": 1435.27,
            "end": 1448.28,
            "transcript": "Yugcetun qalarcugngaunga. Yugcetun naaqiyugngaunga. Yugcetun igaryugngaunga. Wii puqigtua."
        },
        "108": {
            "start": 1461.83,
            "end": 1474.56,
            "transcript": "Yugcetun qalarcugngaunga. Yugcetun naaqiyugngaunga. Yugcetun igaryugngaunga. Wii puqigtua."
        },
        "109": {
            "start": 1486.88,
            "end": 1496.05,
            "transcript": "PEP-q allani amllerni elitnaurillerneq [?] qaneryaragnegun assinruuq. Taitellni nunarrarnun ikayuutngurpagciquq."
        },
        "110": {
            "start": 1498.9,
            "end": 1506.8,
            "transcript": "Irr'inarqellriit PEP-mi ukuugut, Yupiit mikelnguut. Ayuqluki angayuqateng ellarpagmi ayuqailnguut."
        },
        "111": {
            "start": 1519.93,
            "end": 1532.64,
            "transcript": "Pektayunateng temem [?] piniutai anaggluki. Yupiit Kuiggayagarmek, Marayaarmiunek, Kuigglugmek, Cevv'armiuneng-llu. Ikamrarluteng Alarnermek, Nunapicuarmek-llu."
        },
        "112": {
            "start": 1532.64,
            "end": 1538.72,
            "transcript": "Cat caperrnarqellriit pairrluki egmiateng [?] cingumaluki ikayurluki tekitarkat ullagluki."
        },
        "113": {
            "start": 1538.72,
            "end": 1544.64,
            "transcript": "Tau͡gaam arcaqalria piniutiit uitangaituq yualuitni anagtassiigutellriit [?]."
        },
        "114": {
            "start": 1544.64,
            "end": 1557.97,
            "transcript": "Tamaklagmeng mikelnguut taringyugngaciqngamegteki pinerrlugutet Kusquqviim avatiini. Piniutiit-llu cuqcimaarkauluni elitellrit-llu, man'a-llu piniutiit ayagyugngaluni yaaqvanun."
        },
        "115": {
            "start": 1567.45,
            "end": 1570.82,
            "transcript": "Qanemciq ayagnilleq nasaurlucuarmek."
        },
        "116": {
            "start": 1570.82,
            "end": 1576.34,
            "transcript": "Caullruuq elitnauryaramun qaneryaragnegun. Amlleq-llu qanrutkumavkenani."
        },
        "117": {
            "start": 1580.04,
            "end": 1590.07,
            "transcript": "Anglilleq mikelnguum atuarkaqai [?] yuullermini. Anglilleq mikelngurugaat avatiitni irr'inarquq."
        },
        "118": {
            "start": 1590.07,
            "end": 1595.37,
            "transcript": "Yuut unguvalriit pinerrlugutet anaggluki tukuucetun nunarquamtenun ayuqut."
        },
        "119": {
            "start": 1597.64,
            "end": 1605.5,
            "transcript": "Arcaqalriaruuq taringellrat qalaruskumteki. Arcaqalriaruuq-llu niicugniullerkarput ellaita qalaruskavkut."
        },
        "120": {
            "start": 1605.65,
            "end": 1608.66,
            "transcript": "Amllernek umyugait imangqelaameng."
        },
        "121": {
            "start": 1615.71,
            "end": 1623.5,
            "transcript": "Anglirikuni uum caurcillni nallunriqsaitaa. Qanemciyunqegtuq qanemcinek-gguq igarteńgurciqsugnarquq."
        },
        "122": {
            "start": 1623.5,
            "end": 1627.73,
            "transcript": "Qaneryaragnegun qalarcugngakuni piyullmitun piyugngauq."
        },
        "123": {
            "start": 1634.91,
            "end": 1640.52,
            "transcript": "Ciunerkaami PEP-m angnirnaqluni ukut mikelnguut kegginaicetun ayuquq."
        }
    },
    "pVBFhkmpje4": {
        "1": {
            "start": 45.36,
            "end": 52.0,
            "transcript": "Yugtun igautellra Paskelaavken-aam [?], qanerta Ted Brink-auguq [?]."
        },
        "2": {
            "start": 59.0,
            "end": 68.0,
            "transcript": "Nunat Akiacuarmiungut Kusquqvim ceńiini ukut nunat uitaut kanavalirnerani Alaska-m nunain."
        },
        "3": {
            "start": 68.0,
            "end": 73.0,
            "transcript": "Nunacuaraat maani imarpiim tunglirnerani uitalriit ilakaat."
        },
        "4": {
            "start": 79.31,
            "end": 90.0,
            "transcript": "Makumiut tua-i Alaska-mi ataucimek qallacaralget quyurmeng angenkacagaugut yuuyarait piciryarait-llu ayuqut."
        },
        "5": {
            "start": 113.0,
            "end": 127.0,
            "transcript": "Yuungnaqleq maani yuilqumi makuggnarquq, uksumi-llu ayagaluni pissurnarqelaami, muragqaqleq-llu yuilqumek, mertartulleq-llu kuigmek."
        },
        "6": {
            "start": 134.83,
            "end": 139.87,
            "transcript": "Assiqatarqa una imirru [?]"
        },
        "7": {
            "start": 146.65,
            "end": 149.04,
            "transcript": "Tauna-llu-qaa?"
        },
        "8": {
            "start": 186.09,
            "end": 189.86,
            "transcript": "Mertartuten-qaa, quyana."
        },
        "9": {
            "start": 192.13,
            "end": 202.54,
            "transcript": "Caqata qakemna nenglaikan. Qimugcetet tarrilluki [?]. Moses-aankulaarqatartua. [?]"
        },
        "10": {
            "start": 207.63,
            "end": 213.7,
            "transcript": "Maani uitalriani amllermek qitevcaramek pinarqenrituq."
        },
        "11": {
            "start": 216.38,
            "end": 222.15,
            "transcript": "Tua-llu-q' Joella'-m cali ciutii maklirtuq? [?]"
        },
        "12": {
            "start": 222.15,
            "end": 229.0,
            "transcript": "Tau͡gaam cali Kass'atun qaneryaraq paivngauq yuut yuuciatni."
        },
        "13": {
            "start": 248.13,
            "end": 258.86,
            "transcript": "Ilaput maa-i Kass'atun qantungraata taringetungraata-llu naaqinek iganeq-llu amllerinartuq yuullemteńi."
        },
        "14": {
            "start": 279.43,
            "end": 290.59,
            "transcript": "Kass'ilugcaramek nallunringramta amlleringiinartut cat nutarat taringenqegcaumanarqellriit-llu."
        },
        "15": {
            "start": 296.36,
            "end": 308.56,
            "transcript": "Cali-am waten ayuqliringraan maa-i yuut caaqameng piciryarallermegcetun piulartut yuut tua-i nallunrilamegteggu una waten ayuqucia."
        },
        "16": {
            "start": 308.56,
            "end": 322.81,
            "transcript": "Nutaan mikelngurmeggnek ayagnirluteng elitnaurulrianek pingut maa-i, ayagyualriit waniwa elitnarqut nutaranek umyuangutnek cali nutaranek qallacaramek."
        },
        "17": {
            "start": 325.95,
            "end": 339.0,
            "transcript": "Nallunailkutaa kavircetuq calinqigcenani nunam quliin qigcikaakut. [???]"
        },
        "18": {
            "start": 340.2,
            "end": 350.58,
            "transcript": "Qangvarpak mikelnguut elitnaulallruit Kass'aturrlainaq. Tau͡gaam nutaan maa-i Kass'atun qaneryaraq kinguqliuku elitnauringut."
        },
        "19": {
            "start": 350.74,
            "end": 358.93,
            "transcript": "Cat tamaita elitelteng naaqiuryarat naaqiyarat cali amlleret yugceturrlainaq elitengait."
        },
        "20": {
            "start": 358.93,
            "end": 367.0,
            "transcript": "Yugturrlainaq elitnaurluteng elitnaurimeggni Akiacuarmi cali allani nunani waten pingut."
        },
        "21": {
            "start": 376.19,
            "end": 386.78,
            "transcript": "Waten una pilria ayunguq elluarrluni ikayurcirluni BIA-mek kavmamek cali Yup'ignek waten pillrem cingumestainek."
        },
        "22": {
            "start": 387.22,
            "end": 400.0,
            "transcript": "Nasvaumauq tua-i ak'a waten piluni mikelnguut patagmek [?] elitarkaullrit ellmengnekmin [?] qaneryarameggnek nallunrilkengameggnek aturluteng elitnauquneng elitenrutlerkaat."
        },
        "23": {
            "start": 406.51,
            "end": 407.89,
            "transcript": "Pekyun!"
        },
        "24": {
            "start": 412.09,
            "end": 426.32,
            "transcript": "Aipirin! Aipiritem-llu tua-i kinguanek, kina? Pingayirin. Kia aperyugngaagu yagtellerpagluten [?]? Pingayirin. Pingayirin!"
        },
        "25": {
            "start": 426.39,
            "end": 435.57,
            "transcript": "Kia una aperyugngaagu? Qastuluten. Pekyun. Tamarpeci yuaqerluku? [???]"
        },
        "26": {
            "start": 449.0,
            "end": 465.0,
            "transcript": "Mat'umi-gguq meeting-aallemteńi [?] qanrucugaak mat'umek qaillun elitnaurat maa-i Yugcetun, Yugcetun elitnaulriit elitnauruciitnek wangkutnek-llu qaill' ayuqucinek taringyugluteng."
        },
        "27": {
            "start": 465.0,
            "end": 468.66,
            "transcript": "Yuut-llu maani tamarmeng assikat tamana."
        },
        "28": {
            "start": 483.7,
            "end": 496.71,
            "transcript": "Uumi angayuqat elitnauristet-llu quyurtellratni angayuqat quyatekellruat mikelnguut elitellrat Kass'atun cukaluteng. Nallunrilamegteggu-wa qaneryaraicunaitellra Kass'atun."
        },
        "29": {
            "start": 496.88,
            "end": 510.14,
            "transcript": "Angnirnarqellruut-llu Kass'atun elitnauristiitnun tangvallrat angayuqat kegginait niicugnillratki irniateng naaqillratni ellaita qaneryaramegcetun ukveraitqapiarallruut."
        },
        "30": {
            "start": 522.28,
            "end": 531.42,
            "transcript": "Umyuarteqellermini Kass'atun elitnauristiit mikelnguut taqengyuirutut elitengnaqlermegteggu alla yuk qaneryaraq."
        },
        "31": {
            "start": 531.42,
            "end": 540.0,
            "transcript": "Elilluteng tau͡gaam qaneryaramek taringyukngakekmeggnek qalaruteksugngakekmeggnek, cali-llu umyuangcauteksugngakekmeggnek."
        },
        "32": {
            "start": 540.0,
            "end": 550.94,
            "transcript": "Arcaqerluku umyuarteqellermini elitnauristiit angnirikanirtut caperrsuyuirutkanirluteng-llu elitnaurat elitnaurvigmi."
        },
        "33": {
            "start": 550.94,
            "end": 564.42,
            "transcript": "Umyuarteqellermini Yup'igtun elitnauristiit angnirikanirtut mikelnguut elitnaurvigmi. Elitnauriyunqegiikanirluteng-llu qanllerkameggnek-llu ancurtunrirluteng."
        },
        "34": {
            "start": 566.0,
            "end": 572.84,
            "transcript": "Egmian patagmek waten elitnaurilleq pinarqenrilan ak'anun upcimanarquq."
        },
        "35": {
            "start": 572.84,
            "end": 584.99,
            "transcript": "Qaneryaramek elitnaurilriani tumarcingnaqellriatun ayuquq, cat amlleq quyurqurluki tumarrluki-llu atauciurtellratnun pinarquq."
        },
        "36": {
            "start": 589.0,
            "end": 602.6,
            "transcript": "Ayagnirpailgat-llu una caliaq elitnaurviit angayuqrita taringengnaqellruat qaillun ayagnillerkarteng cali naken akinek pillerkarteng elluaringnaqluku."
        },
        "37": {
            "start": 604.58,
            "end": 620.0,
            "transcript": "Nuuqellrata iliit waniwa kalikat elitnaurutkat igausngalriit tamakut yuut qalarcaraacetun, akaurteksaituq-llu nutaan ellualriamek yuut igaryaraatnek pitangellra."
        },
        "38": {
            "start": 621.0,
            "end": 635.67,
            "transcript": "Qaneryariurtut University of Alaska-mi caliaqumallruat una nutaraq igaryaraq Yupiit Alaska-m kanavalirnerani qaneryaraacetun elluarrluku-llu taqluku 1969-aami."
        },
        "39": {
            "start": 641.53,
            "end": 643.21,
            "transcript": "Ata, aata."
        },
        "40": {
            "start": 646.38,
            "end": 649.63,
            "transcript": "Igta, Iirtuq.  Ii-i, assirpaa."
        },
        "41": {
            "start": 650.31,
            "end": 659.83,
            "transcript": "Una nutaraq igaryaraq taqellrat elluarcimauq ciuqliit allat igaryarat maliggluki ayuquciit-llu nasperturluki."
        },
        "42": {
            "start": 670.26,
            "end": 680.84,
            "transcript": "Elisngalrianek elitnauristeng qenarqellruameng nunanek elitnauristekanek cucukillruut tamaani nunani elisngalrianek pitailan."
        },
        "43": {
            "start": 680.84,
            "end": 686.61,
            "transcript": "Cali tamakut cucukellrit elitnauristeńguyugarkauluteng."
        },
        "44": {
            "start": 686.61,
            "end": 696.69,
            "transcript": "Tamakut-llu-am cali elitnauristekat igaryugngaarkaullruut Yugcetun Kass'atun-llu tua-i assirluteng elitnauriarkauluteng."
        },
        "45": {
            "start": 698.23,
            "end": 711.96,
            "transcript": "Uitallruukut kiagpak University of Alaska-mi elicungcarluta nutaramek Yup'igtun igaryaramek naaqiyaramek-llu. Caperrnaqellrunrituq wangnun naaqsaurtellra nutaram piyaram,"
        },
        "46": {
            "start": 711.96,
            "end": 724.0,
            "transcript": "Tau͡gaam caperrnaqellruuq igaucaurtellra tua-i ilait igat cimiumiimeng [?], tau͡gaam amllermek elitellruunga kiagem iquklitellrani."
        },
        "47": {
            "start": 734.2,
            "end": 750.0,
            "transcript": "Cali nutaraq Yugtun igaryaraq naaqiyaraq-llu kiigkenka pivkenakek cali qaillun elitnaurillerkarteng elicarluku allat elisngalriit tua-i ikayullruit tamakut nallunritnarqekaitnek."
        },
        "48": {
            "start": 761.41,
            "end": 774.7,
            "transcript": "Tuatenainanratni [?] University of Alaska-mi ukut qaneryariurtut cali elitnaurutkanek kalikanek mumigtaliluteng nutaranek cali allanek mumigciluteng pilingualiluki-llu."
        },
        "49": {
            "start": 780.33,
            "end": 794.66,
            "transcript": "Makut tua-i ilait qanemcipiuluteng igaupaalulriit Yup'igtaat."
        },
        "50": {
            "start": 794.66,
            "end": 803.62,
            "transcript": "Makut kalikaat mumigtaat university-mi taqellret tamaavet elitnaulrianun tuyuqluki naspaavkaraqluki."
        },
        "51": {
            "start": 803.71,
            "end": 812.55,
            "transcript": "Nutaan-am kitugumaraita utercelluki university-mun taqumapiarluki kalikapiurcetlerkaatnun."
        },
        "52": {
            "start": 812.55,
            "end": 820.84,
            "transcript": "Cali elicaut ilait pimanrilnguut tamaani elitnaurvigni ellmeggnek piilketeng taqevsiaraqluki."
        },
        "53": {
            "start": 820.84,
            "end": 827.26,
            "transcript": "Kass'atun qalarcaramek elitnauristeńek ikayurcirluteng makut ellmeggnek pilarait."
        },
        "54": {
            "start": 828.52,
            "end": 841.23,
            "transcript": "Ciuqlirmi waten elitnaurilriit ayagnillruut pingayuni nunani malruugurluteng-am waten atauciq ikayurteńguluni, aipaa-llu elitnauristeńguluni."
        },
        "55": {
            "start": 841.23,
            "end": 850.27,
            "transcript": "Yugturrlainaq elitnaurilartut carrarmi tau͡gaam unuakumi apiatam-llu kinguani Kass'atun picuaqaqluteng."
        },
        "56": {
            "start": 850.27,
            "end": 859.0,
            "transcript": "Cetamiita tau͡gaam allrakut kinguatgun Kass'aturpalluq [?] elitnauruyaurtesqumait waten Yugtun elitnaulriit."
        },
        "57": {
            "start": 859.0,
            "end": 868.2,
            "transcript": "Cauga? Atkuk. Qaill' ayagnirluni? A. Assirpaa."
        },
        "58": {
            "start": 869.23,
            "end": 883.32,
            "transcript": "Kina-am makucingqerta? Cauga? Qaill' pia? Airraq. Qaill' ayagnirluni? A."
        },
        "59": {
            "start": 886.46,
            "end": 897.79,
            "transcript": "Waten akercirluni, Aanaran tangvagnga. Irr'iman [?] tunguluni. Ellmacuar piluki. [?]"
        },
        "60": {
            "start": 922.44,
            "end": 929.58,
            "transcript": "Qaa, tamarpeci? Qastuluci? Iciw' kepluni."
        },
        "61": {
            "start": 929.79,
            "end": 942.96,
            "transcript": "Tua-i-llu una qangqiiq cami waten ayuqetuat? Uksumi. Kiagmi. Waten qangqiiq game [?] ayuqluku waten-mi? Uksumi. Tua-i-llu."
        },
        "62": {
            "start": 942.96,
            "end": 957.9,
            "transcript": "Tua-i-llu yuut allat wangkunrilnguut elitnauryaqataraqameng ellmeng qallacaramegtun elitnaullerkarteng neryuniurutkelaraat tau͡gaam wangkutni Yup'igni una nutarauguq."
        },
        "63": {
            "start": 958.03,
            "end": 967.69,
            "transcript": "Aipirin. Pingayirin. Cetamirin. Tallimirin. Maqineq."
        },
        "64": {
            "start": 967.7,
            "end": 976.18,
            "transcript": "Cagni malrugni ernerni elitnauyuiceci? (Agayuneq.) Agayuneq, cami-llu? (Maqineq.) Maqineq."
        },
        "65": {
            "start": 976.18,
            "end": 990.43,
            "transcript": "Cani-mi elitnaularceci ernerni? (Pekyun. Aipirin. Pingayirin. Cetamirin. Tallimirin.)"
        },
        "66": {
            "start": 1048.06,
            "end": 1053.0,
            "transcript": "Wani Kass'atun elitnauristii elitnaurilartuq mikelngurnun."
        },
        "67": {
            "start": 1053.0,
            "end": 1061.0,
            "transcript": "Elitnaurilartuq sass'am avgani malrurqugnek ernerpak Kass'atun qaneryaraq mikelngurnun allayuuguq."
        },
        "68": {
            "start": 1061.0,
            "end": 1066.09,
            "transcript": "Taumek elitengnaqleq Kass'aturrlainaq qenarqeqapiartuq."
        },
        "69": {
            "start": 1069.0,
            "end": 1077.56,
            "transcript": "Elitnauristiita elpek'laraa cukanruluni elitellrat ukugni sass'am avgegni ernerpak Kass'atun elitnaullratni."
        },
        "70": {
            "start": 1077.56,
            "end": 1089.05,
            "transcript": "Elliin naaqivkaqsaunaki wall'u igarceteksaunaki allrakum tau͡gaam aipaani, ciuqlirmi allrakumi elitut qaneryaramek Kass'atun."
        },
        "71": {
            "start": 1089.05,
            "end": 1095.87,
            "transcript": "Pililartuq aperyaranek elicautekanek-llu mikelnguut elitellritnek Yup'igtun."
        },
        "72": {
            "start": 1118.0,
            "end": 1122.29,
            "transcript": "Una cauga? (Taryaqvak.) Nani pilarta?"
        },
        "73": {
            "start": 1122.29,
            "end": 1132.35,
            "transcript": "(Qusquqvak.) Kusquqvagmi. Qaill' pit'lartat? (Manakun.) Tua-i-ll' qaill' piluki? Ulliggluki? Una cauga?"
        },
        "74": {
            "start": 1132.67,
            "end": 1138.33,
            "transcript": "Yup'igtun Kass'atun-llu elitnaulriit assilingatelartut elitnaullermeggni maani."
        },
        "75": {
            "start": 1138.33,
            "end": 1148.34,
            "transcript": "Arenqiallugutaitut-llu elitnauristemeggnun. Tau͡gaam egmian pilerngaitellruuq [?]. Eliyutellra [?] Yugturrlainaq qanenermek elitnaurvigmi."
        },
        "76": {
            "start": 1148.44,
            "end": 1151.55,
            "transcript": "Maa-i tau͡gaam assikeqapiararaput."
        },
        "77": {
            "start": 1151.57,
            "end": 1159.63,
            "transcript": "Manakun? Cakun-llu? Kuvyakun. (Kuvyakun.) Uksumi wall' kiagmi? Una-am cauga?"
        },
        "78": {
            "start": 1159.63,
            "end": 1167.0,
            "transcript": "Manignaq, nau͡ggun pit'lartat manignanek? Manakun, taluyakun."
        },
        "79": {
            "start": 1167.0,
            "end": 1173.48,
            "transcript": "(Ciugun taiguq.) Kina taiga? (Ciugun.) Nauw' Ciugun?"
        },
        "80": {
            "start": 1173.48,
            "end": 1182.07,
            "transcript": "(It'aq taiguq.) Nauw' It'aq? Qaill' pia wani? Taiguq."
        },
        "81": {
            "start": 1182.07,
            "end": 1187.0,
            "transcript": "Wani tangercetaalillratni una caliaq nutaraullruuq."
        },
        "82": {
            "start": 1187.22,
            "end": 1191.51,
            "transcript": "Tamarmeng caliaqestain murilkeciqaat una caliaq."
        },
        "83": {
            "start": 1191.58,
            "end": 1199.54,
            "transcript": "Ak'a maa-i mikelnguut waten elitnaulriit. Assirluteng patagmek-llu elitenrullrat tangraat."
        },
        "84": {
            "start": 1199.54,
            "end": 1204.97,
            "transcript": "Waten elitnaullrem ikayurciqai Yupiit yuuyaraitni."
        },
        "85": {
            "start": 1205.03,
            "end": 1210.27,
            "transcript": "Cali kiingita pivkenaki, allat cali yuut ikayurciqai."
        },
        "86": {
            "start": 1210.27,
            "end": 1216.0,
            "transcript": "Taringekanircelluki Yupiit yuuyaraitnek maani nunamteńi."
        },
        "87": {
            "start": 1216.0,
            "end": 1220.0,
            "transcript": "(Nuk'aq.) Qastuluci."
        },
        "88": {
            "start": 1222.0,
            "end": 1231.95,
            "transcript": "(Ciugun taiguq.) Kina una? Ciugun. Nauw' Ciugun?"
        },
        "89": {
            "start": 1232.0,
            "end": 1238.04,
            "transcript": "(It'aq taiguq). Kina taiga? (It'aq) Nauw' It'aq?"
        },
        "90": {
            "start": 1238.04,
            "end": 1245.29,
            "transcript": "(Ataataq.) Nauw' Ataataq? (Ciugun Sak'aq-llu ner'uk.)"
        },
        "91": {
            "start": 1245.29,
            "end": 1254.28,
            "transcript": "Tanqiktaalria agyacuar, caucin' paqnak'larqa wii?"
        },
        "92": {
            "start": 1254.28,
            "end": 1261.92,
            "transcript": "Ak'aki ellam quliini, qilkirtaatun qilagmi."
        },
        "93": {
            "start": 1261.96,
            "end": 1269.74,
            "transcript": "Tanqiktaalria agyacuar, caucin' paqnak'larqa wii?"
        },
        "94": {
            "start": 1269.74,
            "end": 1276.68,
            "transcript": "Tanqiktaalria agyacuar, caucin' paqnak'larqa wii?"
        },
        "95": {
            "start": 1276.69,
            "end": 1283.35,
            "transcript": "Ak'aki ellam quliini, qilkirtaatun qilagmi."
        },
        "96": {
            "start": 1283.35,
            "end": 1290.0,
            "transcript": "Tanqiktaalria agyacuar, caucin' paqnak'larqa wii?"
        }
    },
    "P-ZIBMX6_3U": {
        "1": {
            "start": 30.0,
            "end": 43.52,
            "transcript": "Calista Elders Council-aaq una ayagnillruuq Calista shareholder-aat ellimerrutiitgun 1990-mi Kassiglugmi quyurtellratni."
        },
        "2": {
            "start": 43.52,
            "end": 56.68,
            "transcript": "Tua-i-ll' allamikuan 1991-aami kalikartangluni apqiitnek 501(c)3 non-profit-aurrluni kanani Kuinerrami."
        },
        "3": {
            "start": 56.68,
            "end": 70.82,
            "transcript": "Arcaqerluku una caliaqesqumaluku ellmeggnek elder-at tegganret."
        },
        "4": {
            "start": 70.82,
            "end": 85.88,
            "transcript": "Aulukesciigalilriit nekaatnek unangengnaq', aulukvigkaatnek unangengnaqleq caliaqesqumaluku nautellruyaaquq una Calista Elders Council-aq."
        },
        "5": {
            "start": 85.88,
            "end": 95.62,
            "transcript": "Tau͡gaam ilaluku caliarkai ukunek tallimanek apqiitnek mission statement-aanek ilallruat."
        },
        "6": {
            "start": 95.62,
            "end": 110.12,
            "transcript": "Ciuqliuluku man'a yuuyararput, ciumuulluku yuusqelluki cali-llu man'a qaneryararput."
        },
        "7": {
            "start": 110.12,
            "end": 119.26,
            "transcript": "Cali-llu nutemllaq piciryararput maani Calista-m iluani ciumuulluku ayautesqelluku."
        },
        "8": {
            "start": 119.26,
            "end": 134.96,
            "transcript": "Kinguqlia-wa man'a calritlerkaput cali ikayuutait elder-at unakengnaqluki Calista-m iluani pisqumaluki."
        },
        "9": {
            "start": 134.96,
            "end": 145.16,
            "transcript": "Cali-llu makut pingayuat una elder-aat aulukvigkait upluki caliaqluku-llu pillerkaat."
        },
        "10": {
            "start": 145.16,
            "end": 154.84,
            "transcript": "Cetamiit-wa waten makut ciulirneret ikayuutekaitnek qanaagaqata."
        },
        "11": {
            "start": 154.84,
            "end": 168.9,
            "transcript": "Wall'u-q' ciulirnernun tusngaarkat qanaatekaqatki, waten elder-aat qanqeryugngallerkaat, wall'u-q' vote-auteksugngallerkaat tamana cumikluku pillerkaa."
        },
        "12": {
            "start": 168.9,
            "end": 180.46,
            "transcript": "Nangneruluku-llu nauciluteng wall'u-qaa cingumailuteng ayagyuat elissallerkaatnek maani Calista-m iluani."
        },
        "13": {
            "start": 196.7,
            "end": 215.7,
            "transcript": ""
        },
        "14": {
            "start": 218.16,
            "end": 229.5,
            "transcript": "Cali-llu taukut yaatiitgun quyurciluteng elder-aanek qanaagaqluteng ayuqenrilngunek yugtarnek."
        },
        "15": {
            "start": 229.5,
            "end": 243.68,
            "transcript": "Una camp-allrat kiagmi pingayuuluteng kiak camp-allruut, camp-anek-wa tua-i pingqellruut."
        },
        "16": {
            "start": 243.68,
            "end": 255.06,
            "transcript": "Ciuqliq ceńami Umkumiuni ceńarmiut tua-i nunat keggaken Marayaarmek kanavet Arviirmun aulukluki."
        },
        "17": {
            "start": 255.06,
            "end": 266.82,
            "transcript": "Tua-i-llu aipaa Kuigglugmi Kusquqvagmiunek waten Naparyarrarmek qavavet Stony River-aamun imaluni."
        },
        "18": {
            "start": 266.82,
            "end": 272.4,
            "transcript": "Tua-i-ll' Kuigpagmek cali Kuigpiim painganek kiavet Nunam Iquanun."
        },
        "19": {
            "start": 277.4,
            "end": 291.66,
            "transcript": "Alartelliniunga, Kuigpiim painganek kiavet Iqugmiunun tuani tua-i camp-ani malrugnek nasaurlumek wall'u-qaa tan'gurrarmek."
        },
        "20": {
            "start": 291.66,
            "end": 305.7,
            "transcript": "Nasaurlumek-wa tan'gurrarmek-llu nunanek tua-i ataucinek tegutaqluteng tamakut teguskengait seventh grade-auluteng-wa, sixth grade-auluteng wall'u-q' seventh grade-auluteng piarkauluteng."
        },
        "21": {
            "start": 305.7,
            "end": 313.22,
            "transcript": "Allragni eighth grade-at ilakellruyaaqaput, tau͡gaam taukunun kiingan maa-i allrakumi piciqsugnarqukut."
        },
        "22": {
            "start": 313.22,
            "end": 328.1,
            "transcript": "Camp-allermeggni-llu tua-i yugtarnek nerangnaqsaram tungiinun calilrianek qanruyutnek-llu tamatum nerangnaqsaram tapeqtukainek caliarluteng."
        },
        "23": {
            "start": 328.1,
            "end": 340.98,
            "transcript": "Elder-aat tua-i tallimauluteng piaqluteng, elder-aat aren elder-angqerraqluteng ataucimek talliman ukut mikelnguut."
        },
        "24": {
            "start": 340.98,
            "end": 347.78,
            "transcript": "Elder-aat tua-i elissaristeńguluteng ayagyuanek tamakunek."
        },
        "25": {
            "start": 347.78,
            "end": 359.94,
            "transcript": "Qanruyutaitnek apertuulluki cali qaillun nerangnaqsaram ayuqellranek, qaillun tamaani ayuqenrilngurni nerangnaq'lallratnek."
        },
        "26": {
            "start": 359.94,
            "end": 369.22,
            "transcript": "Tamaaggun tua-i ikayurluki qanruyun-llu man'a anlluku naivvluku makunun ayagyuanun."
        },
        "27": {
            "start": 369.22,
            "end": 377.82,
            "transcript": "Convention-aani-ll' maani convention-aarqameng topic-aamek tegulluteng yugtamek."
        },
        "28": {
            "start": 377.82,
            "end": 388.26,
            "transcript": "Nutaan tua-i tauna topic-aq qanruyuteka elissautekluku pingayun ernerni caliaqluku pilalriit."
        },
        "29": {
            "start": 388.26,
            "end": 395.6,
            "transcript": "Tua-i-ll' nutaan tauna qanaateklerteng kalikarmun elliluku mumiggluku."
        },
        "30": {
            "start": 395.6,
            "end": 411.24,
            "transcript": "Tua-i-ll' nutaan cali camek uunguciilngurtangqerqan [?] atatakuan quyurciluteng cali elder-anek tamana qanaatekarkauluku."
        },
        "31": {
            "start": 455.34,
            "end": 466.18,
            "transcript": "Pingayuurtut maa-i convention-alput annual conventiona-alput ciuqliq Kassiglurmi pillruuq."
        },
        "32": {
            "start": 466.18,
            "end": 475.48,
            "transcript": "Tuani-llu Kassiglurmi pillemteni yuuyaramek qanaaluteng."
        },
        "33": {
            "start": 475.48,
            "end": 485.82,
            "transcript": "Qaillun yugni qanruyutengqelallemteńek qanerturluteng."
        },
        "34": {
            "start": 485.82,
            "end": 498.62,
            "transcript": "Yugnun tamaitnun iliini-llu angutnun tusngalriit nallunairluki, arnanun-llu call' tusngalriit nallunairluki."
        },
        "35": {
            "start": 498.62,
            "end": 510.7,
            "transcript": "Tua-i-llu kinguakun St. Mary's-aami pillermeggni Negeqlirmi qanaaluteng Yup'igtarnek piciryaranek."
        },
        "36": {
            "start": 510.7,
            "end": 524.28,
            "transcript": "Qaillun allrakum iluani yuut piciryarangqelallratnek yuramek iqulegnek."
        },
        "37": {
            "start": 524.28,
            "end": 534.68,
            "transcript": "Tua-i-llu allragni Nunakauyami Toksook Bay-mi Kass'at apqiitnek traditional care and discipline."
        },
        "38": {
            "start": 534.68,
            "end": 546.34,
            "transcript": "Mikelngurmek aulukillermek ayagnirluteng yaavet angliriqertellranun aulukiyaramek qanaaluteng."
        },
        "39": {
            "start": 546.34,
            "end": 554.38,
            "transcript": "Qaillun-llu qanrut'lallranek, qaillun nunualallra [?]."
        },
        "40": {
            "start": 567.66,
            "end": 582.76,
            "transcript": "Elders convention-aaraqamta arcaqarluku una avullerkaput ciurlirnemta elisngaitnek arcaqakluku pilartukut."
        },
        "41": {
            "start": 582.76,
            "end": 593.86,
            "transcript": "Maa-i quyurtaqameng convention-aani 65-aalriit, yuinaat pingayun tallimanek allrakulget."
        },
        "42": {
            "start": 593.86,
            "end": 606.24,
            "transcript": "Tuaken ayagluteng allrakuit tauna-ll' cipingakait quyurtelartut."
        },
        "43": {
            "start": 606.24,
            "end": 612.34,
            "transcript": "Tamakut tamaa-i quyungqalriit nutemllaq nallunritestekaat."
        },
        "44": {
            "start": 612.34,
            "end": 622.66,
            "transcript": "Kass'atangvailgan ilait tamakut nunacuarni uitallruut piciryarat-llu cimingvailgata aturluki."
        },
        "45": {
            "start": 622.66,
            "end": 628.62,
            "transcript": "Nutaan ellaitnun qanemcikcetaarluki piciryarapiaput."
        },
        "46": {
            "start": 628.62,
            "end": 639.58,
            "transcript": "Tua-i-llu qanemcikellratni wangkuta video-mun suuliluki wall'u-qaa cali tape-amun ekluki qanellrit."
        },
        "47": {
            "start": 639.58,
            "end": 657.84,
            "transcript": "Nutaan tua-i tamakut qanerturallrit kalikamun ellimarikata school-arvignun caggluki cali-llu aturyugtaitnun caggluki yuut tua-i niiculriit tamakunek niicugngariavkauvkarluki."
        },
        "48": {
            "start": 657.84,
            "end": 667.9,
            "transcript": "Wall'u-qaa calistet tamakunek nallunrilriit cali nallunritevkararkauluki."
        },
        "49": {
            "start": 696.98,
            "end": 710.82,
            "transcript": "Au͡gkut ava-i  convention-am nalliini quyurtelput elder-aanek kalikaurrluki school-aranun aturyugngarivkarluki."
        },
        "50": {
            "start": 710.82,
            "end": 718.98,
            "transcript": "Cali-llu allat yuut nallunricukata ellaitnun call' paivngaluni."
        },
        "51": {
            "start": 719.1,
            "end": 734.8,
            "transcript": "Cali-llu video-nek video-rumalriit tamakut quyurrluki video-melnguut ilairtaarluku man'a elissautellrat."
        },
        "52": {
            "start": 734.8,
            "end": 743.42,
            "transcript": "Yugnun tua-i tauna tuniaqluku wall' aruquteksugngariluki piarkauluta aturyugtaitnun."
        },
        "53": {
            "start": 764.24,
            "end": 772.24,
            "transcript": "Man'a Calista Elders Council-at aulukumauq board-atgun, board-at tua-i ataneqluki."
        },
        "54": {
            "start": 772.24,
            "end": 781.78,
            "transcript": "Qulngunrita'araan ukut board-at elder-augut 65-aamek ayagluteng allrakulget."
        },
        "55": {
            "start": 781.78,
            "end": 791.5,
            "transcript": "Taukut-llu tua-i elder-at vote-autekluki, vote-aqsagutaqluki."
        },
        "56": {
            "start": 794.22,
            "end": 807.62,
            "transcript": "Tua-i-llu allamiaquaqan pingayuuluteng term-ait, uitallrit tuani board-ani naugaqata vote-autekenqigtaqluki."
        },
        "57": {
            "start": 807.62,
            "end": 818.62,
            "transcript": "Tua-i-ll allamiakuan, allamiaquan call' pingayun allamiaquan cali pingayun, tua-i ataucikun au͡g'arpek'nateng tau͡gaam uivvaaliatun ayuqluteng."
        },
        "58": {
            "start": 818.62,
            "end": 827.26,
            "transcript": "Board-ani-llu cali pingayunek Calista Corporation-aaq ellimaluni board-anun ikayuutellrianek."
        },
        "59": {
            "start": 827.26,
            "end": 840.88,
            "transcript": "Taukut tua-i board-at qula malruuluteng quyurrluteng, tua-i-llu taukut calistengqerrluteng executive director-aamek, wiinga tua-i executive director-aulua."
        },
        "60": {
            "start": 840.88,
            "end": 853.5,
            "transcript": "Allanek-llu calistengqerrlua wanirpak calisteput amllenritut tau͡gaam culture and history coordinator-artarluni, office manager-aartarluni."
        },
        "61": {
            "start": 853.5,
            "end": 863.1,
            "transcript": "Yaani-llu consultant-aurluta Anchorage-ami Ann Riordan-aamek, allat-llu cali."
        },
        "62": {
            "start": 863.1,
            "end": 872.94,
            "transcript": "Allanek calisterluta mumigcitulinek makut maa-i quyurestengaput mumigtaqluki."
        },
        "63": {
            "start": 872.94,
            "end": 879.58,
            "transcript": "Tuaten tua-i man'a caliarput ayagluni board-anek atanerluta."
        },
        "64": {
            "start": 879.62,
            "end": 890.62,
            "transcript": "Board-at-llu taukut cucukumaluteng, elder-aat vote-autekaqluki, wangkuta-ll' tua-i ellimerrutait caliaqaqluta."
        },
        "65": {
            "start": 906.7,
            "end": 914.48,
            "transcript": "Waniwa angenqurrauguq akikamteńi taimalriami una National Science Foundation."
        },
        "66": {
            "start": 914.48,
            "end": 926.6,
            "transcript": "Taum tua-i National Science Foundation-am anguyagtmek kingunelgem akikiumaluta 217,000 tekilluku allrakumi,"
        },
        "67": {
            "start": 926.6,
            "end": 940.38,
            "transcript": "Tauna tua-i aki atulararput makunek nutemllarnek quyurcissuutekluku kalikamun-llu tamaa-i quyurteput ellimaarrluteng."
        },
        "68": {
            "start": 940.38,
            "end": 954.8,
            "transcript": "Waken cali apqiitnek hut-amek [?], ukut camp-aput akilium avallartut tau͡gaam akika tamana camp-at ikayuumaluni cali-ll' National Science Foundation-aamek."
        },
        "69": {
            "start": 954.8,
            "end": 966.22,
            "transcript": "Taukuk yaatiikun angelria cali Calista Corporation-aamek taimalria 50,000."
        },
        "70": {
            "start": 966.22,
            "end": 978.98,
            "transcript": "Tauna tua-i board-amtenun aturaqluku wiinga-llu akiliutma ilii tuaken taimaaqluni, taukut yaatiitgun grant-acuanek unangelartukut."
        },
        "71": {
            "start": 978.98,
            "end": 992.58,
            "transcript": "Waken allamiaquaqan Alaska State Council on the Arts, Alaska Humanities Forum, allanek-llu mikcuarnek, allanek cali unangaqluta."
        },
        "72": {
            "start": 992.58,
            "end": 1004.62,
            "transcript": "Taukut tua-i man'a ayalput akiliusngaluku. Ayuqelartuq tuaten."
        },
        "73": {
            "start": 1030.76,
            "end": 1037.58,
            "transcript": "Arcaqan-wa [?] caliarput waniwa wangkuta tangllemteńi."
        },
        "74": {
            "start": 1037.58,
            "end": 1044.76,
            "transcript": "Quyurcillerkaput yugtarmek ciuliamta nallunrilkenga'atnek."
        },
        "75": {
            "start": 1044.76,
            "end": 1059.24,
            "transcript": "Waniwa convention-aarqamta quyurcilartukut ayagyuanqurrauluteng 65-aalriit tua-i-llu tuaken ayagluteng, allrakurturiinarluteng tailriit."
        },
        "76": {
            "start": 1059.24,
            "end": 1067.7,
            "transcript": "Tuaten tua-i ayuqluni tamakut tamaa-i nutemllaq atupiartellrat."
        },
        "77": {
            "start": 1067.7,
            "end": 1080.32,
            "transcript": "Ellaita Kass'aq amllerivailgan, Kass'artaq amllerivailgan nunacuarni yugtaq atupiarluku, allamek avunaku tamakut atullruat."
        },
        "78": {
            "start": 1080.32,
            "end": 1094.7,
            "transcript": "Tua-i tamaa-i ellaita elisngiit [?] man'a nutemllarput ellaitnek niilluta qanemcikevkarluku wangkuta Yugni piciryaralput elliulluku-ll' kalikamun."
        },
        "79": {
            "start": 1094.7,
            "end": 1102.94,
            "transcript": "Wangkuta tua-i ayagyualriani tamana pirpakarput nutemllaq ellaita elder-aat nallunrilatgu."
        },
        "80": {
            "start": 1102.94,
            "end": 1113.28,
            "transcript": "Tauna tua-i arcaqakluku maa-i caliukut ciulirneput makut unguvallratni nallunrilnguut mat'umek nutemllarmek."
        },
        "81": {
            "start": 1113.28,
            "end": 1121.42,
            "transcript": "Mat'um kinguani tayima waten elder-aanun ikayuutnguarkanek calingeciqukut."
        },
        "82": {
            "start": 1121.42,
            "end": 1132.3,
            "transcript": "Elder-aat makut aulukumallerkait wall'u-qaa elder-aat ikayuumallerkait tamakunek calingluta akikaitnek yuangeciqukut."
        },
        "83": {
            "start": 1132.3,
            "end": 1142.34,
            "transcript": "Tau͡gaam cali taum yaatiikun ayagyuanek ikayuriyugluta pilartukut elder-aat-wa tua-i tamana cingumiitegu."
        },
        "84": {
            "start": 1142.34,
            "end": 1154.62,
            "transcript": "Maaggun elissaumallerkaatnek wall'u-qaa picurlanritlerkaatnek caliarluta tamana tamaa-i nautengluku piciqukut mat'um kinguakun."
        },
        "85": {
            "start": 1160.4,
            "end": 1172.98,
            "transcript": "Waniwa tua-i wani Calista Elders Council-aani elder-aat calillguteksugluki ayagyuat-llu calillguteksugluki piyuumilartukut."
        },
        "86": {
            "start": 1172.98,
            "end": 1184.6,
            "transcript": "Waken elder-aat nallunritellrat naivcugyaaqluku makunun ayagyuanun ellaita ellmeggnek nallunriyutekenruciqngatgu."
        },
        "87": {
            "start": 1184.62,
            "end": 1193.94,
            "transcript": "Cali yuullermeggni man'a elder-aanek yuullerteng elilluku, aturluku-llu yuullermeggni piciqngata."
        },
        "88": {
            "start": 1193.94,
            "end": 1202.8,
            "transcript": "Waniwa tua-i caliarput una ciumuucugyaaqeput, taqevkenaku elder-aat-llu cali cingumaluki."
        },
        "89": {
            "start": 1202.8,
            "end": 1215.36,
            "transcript": "Tua-i-w' elluarrluteng ikayungqellerkaata tungiinun makut-llu cali ayagyuaput elluarrluteng yuullerkaata tungiinun."
        },
        "90": {
            "start": 1217.6,
            "end": 1227.3,
            "transcript": "Atunem tua-i ikayurtagulluta wani Calista Elders Council-ani piyugyaaqukut, tua-i quyana."
        },
        "91": {
            "start": 1317.22,
            "end": 1321.62,
            "transcript": "Ii-i. Tua-i?"
        }
    },
    "WLm5aPZ7x4M": {
        "1": {
            "start": 95.56,
            "end": 103.38,
            "transcript": "Wiinga waniwa Paul John-augua Kass'atun. Yugtun-llu Kangrilnguulua."
        },
        "2": {
            "start": 103.38,
            "end": 111.46,
            "transcript": "Tua-i wiinga waniwa school-aqallemnek caitqapik ukanirpagnek qanaitua."
        },
        "3": {
            "start": 111.46,
            "end": 117.94,
            "transcript": "Tau͡gaam tamaani school-aqsailengramta-wa wangkuta."
        },
        "4": {
            "start": 118.0,
            "end": 124.94,
            "transcript": "Mat'um, nutem, nutemllamta piciryaraikun eglertellruukut."
        },
        "5": {
            "start": 124.94,
            "end": 134.76,
            "transcript": "Uum Agayutem ayuqenrilngurni wangkuta ellam iluani camani-ll' acimteni."
        },
        "6": {
            "start": 134.76,
            "end": 141.14,
            "transcript": "Piciryararkillruyaaqelliniakut yuliaqellerminikut wangkuta."
        },
        "7": {
            "start": 141.14,
            "end": 150.16,
            "transcript": "Nutemllaqluku tua-i ukanirpak camek piunrirvianun piciryararkamteńek."
        },
        "8": {
            "start": 150.16,
            "end": 161.7,
            "transcript": "Tua-i-llu cali elliin Agayutem tua-i piciryararkaput wangkutnun nutemllaqluki pikarkauvkarluki piamiki."
        },
        "9": {
            "start": 161.7,
            "end": 167.4,
            "transcript": "Ilaminek uumek anerneminek anernirluta."
        },
        "10": {
            "start": 167.4,
            "end": 176.32,
            "transcript": "Tamayunaitqapiaryaaqelliniarput man'a nutem qaneryararput yuucimta piniqngaku."
        },
        "11": {
            "start": 176.32,
            "end": 190.1,
            "transcript": "Tua-i maa-i watua avanirpak nutemllarput man'a tamarivkenaku piurallrukumta."
        },
        "12": {
            "start": 190.1,
            "end": 200.66,
            "transcript": "Kass'am-llu maa-i makunek umyuarrlugutekiuteksaguskeminek wagg'uq law-nek."
        },
        "13": {
            "start": 200.66,
            "end": 206.36,
            "transcript": "Nunakenrilkiit-llu man'a iterluteng ataniuryanritliniakut."
        },
        "14": {
            "start": 206.36,
            "end": 210.98,
            "transcript": "Wangkutnek ataniurluta pialliniukut."
        },
        "15": {
            "start": 210.98,
            "end": 222.06,
            "transcript": "Tau͡gaam tua-i cam man'a iliini alarun igvalaami kayuluni."
        },
        "16": {
            "start": 222.06,
            "end": 232.9,
            "transcript": "Maa-i qatellriamta wagg'uq law-tgun apeqmikun law-tgun kayungqerrluni."
        },
        "17": {
            "start": 232.9,
            "end": 240.06,
            "transcript": "Wangkuta yuucirliurput imutun tua-i kayuilriatun tamalriatun-ll' ayuqlirivkaqii."
        },
        "18": {
            "start": 240.06,
            "end": 253.98,
            "transcript": "Elpeci makunun kinguqlirpeceńun elpeci iqugtanguumayaaqerci waten pitalriani, angayuqavceńek ciulirnerpeceńek-llu niiteqaqustek'lallrini iqugtangumayaaqerci."
        },
        "19": {
            "start": 254.0,
            "end": 268.4,
            "transcript": "Makut tau͡gaam maa-i ayagmek Kass'artaryarakun irniamta ilait tutgaraput-llu ellangameng tua-i nanluciilngurtun watua ellirtut."
        },
        "20": {
            "start": 269.0,
            "end": 283.62,
            "transcript": "Yupiucirteng niitelange'rmegteggu Kass'artaryarakun call' school-akun maaggun piameng nanluciilngurtun ayuqerlurluteng naliagnegun-kiq ayakatarcia?"
        },
        "21": {
            "start": 283.62,
            "end": 292.56,
            "transcript": "Tau͡gaam tuaten ellingraata watua wangkuta apa'urlurni elpeci-ll' aanani aatani-llu"
        },
        "22": {
            "start": 292.56,
            "end": 302.08,
            "transcript": "Taringengluku maa-i pillerpeciuggun uterrvikluku yuucirput elpeci eglerucugngaaci."
        },
        "23": {
            "start": 302.08,
            "end": 307.12,
            "transcript": "Pisciigatenritut una aturluku nutemllaq."
        },
        "24": {
            "start": 307.42,
            "end": 319.76,
            "transcript": "Agayutem yuucirkiutellra wangkutnun anerneminek-ll' anernirluta tua-i nutem pikamteńek yaavet tuqungellemta ngeliinun."
        },
        "25": {
            "start": 319.76,
            "end": 339.18,
            "transcript": "Iqungelangramta-llu wangkuta ciulirnerpeceńi elpeci nutemllaq man'a egmiulluku paiciutekngamteggu ciuliamteńek ayaucugngaluku elpeci, aanaulriani aataulriani-llu."
        },
        "26": {
            "start": 1940.7,
            "end": 1954.34,
            "transcript": "Iinruartuqluki. Quserluni. Kineryugluni. Iciw' mikelnguut maa-i kapegnateng, qusraqameng kineryugluteng nanicuayaganun."
        },
        "27": {
            "start": 1954.34,
            "end": 1964.0,
            "transcript": "Tuaten cali makut maa'i wangkuta iinrutellruaput. Mat'um tegellra [?]."
        },
        "28": {
            "start": 1964.0,
            "end": 1970.36,
            "transcript": "Kenirpek'naku mermun (kenirpek'naku ii-i). Qaill' amllertalriamek mermek?"
        },
        "29": {
            "start": 1970.36,
            "end": 1976.12,
            "transcript": "Tuai au͡gna qasuaq-im [?] imiqerluku mer'em tua-i-ll' akurrluku uitaarcelluku."
        },
        "30": {
            "start": 1976.12,
            "end": 1982.38,
            "transcript": "Paciiq tamalkuita? Yaa paciik. Ii-i. Makut [?]."
        },
        "31": {
            "start": 2283.88,
            "end": 2292.9,
            "transcript": "Una waniwa nutemllarput qigcignaqsugngayaaqelliniuq ukanirpak."
        },
        "32": {
            "start": 2292.9,
            "end": 2306.44,
            "transcript": "Kia-llu makumiungunrilnguum mat'um nutem yui Alaska-m qigcikarkauyaaqelliniluki."
        },
        "33": {
            "start": 2306.44,
            "end": 2316.8,
            "transcript": "Tua-i-w' Agayutem piciryararkiutekellruyaaqelliniaki tamararkauvkenaki nutemllaqluki aturarkauluki."
        }
    },
    "dqUXBwpkQOs": {
        "1": {
            "start": 17.68,
            "end": 22.24,
            "transcript": "Waqaa Aangaarraaruunga. Tuntuliarmi yuurtellrulua."
        },
        "2": {
            "start": 22.24,
            "end": 26.52,
            "transcript": "Angayuqaagka-wa arnarkangkuk Anguteliunrill'eq-llu. [?]"
        },
        "3": {
            "start": 26.52,
            "end": 33.16,
            "transcript": "Waniw' waniwa tunriutekeng'e'rma [?] irnianka pitekluki wani qalartua."
        },
        "4": {
            "start": 33.16,
            "end": 39.0,
            "transcript": "Man'a qanerkaqa angturpaggluku qalarcumiileng'e'rma tau͡gaam."
        },
        "5": {
            "start": 39.0,
            "end": 47.48,
            "transcript": "Niitekluku [?] ciin wani qalarut'lugutka nangnerani [?] tau͡gaam qanrutekciqaqa."
        },
        "6": {
            "start": 47.48,
            "end": 58.8,
            "transcript": "Atam maa-i yuulput yuvriqaqernauput, man'a tua-i yuulput tamarmi Kass'aturrlainaurrluni."
        },
        "7": {
            "start": 58.8,
            "end": 64.64,
            "transcript": "Neqkaput-wa call' makut Kass'atun. Kass'atun-llu keniumaluteng."
        },
        "8": {
            "start": 64.64,
            "end": 74.16,
            "transcript": "Soup-at tua-i pilaryaaqellriit neqet-llu tua-i keniumalaryaaqellriit tau͡gaam Kass'artarpalluurrluteng irnianka neqait."
        },
        "9": {
            "start": 74.16,
            "end": 90.48,
            "transcript": "Tuamtell' makut akluput maa-i Kass'aturpalluurrluteng, nauwa-ll' tayima piluguurtua [?] Kass'atun, Kass'artarnek sap'akirlua makut-wa tua-i aturanka tamarmeng cali Kass'artaat."
        },
        "10": {
            "start": 90.48,
            "end": 119.84,
            "transcript": "Tuamtell' ilait ikamrat maa-i wall' angyat Kass'artarrlainauluteng, makut-wa cali nep'ut Kass'artauluteng angluteng, nauwa imkut quyurrarmeng waten pilakellriit pingayun wall' cetaman ataucirrarmi nem'i uitaaqluteng, tamakut call' tayima."
        },
        "11": {
            "start": 119.84,
            "end": 138.05,
            "transcript": "Nemteńi-wa cali una, irniaq bedroom-aarrarluni, una-w' cali bedroom-aarrarluni, waten tua-i catairulluni yuulput ataucirrarmi nem'i avqavqengluta [?] cakneq Kass'at piciryaraicetun."
        },
        "12": {
            "start": 138.05,
            "end": 152.5,
            "transcript": "Man'a Yugcetun qaneryaraput yuuyaramta ilaakaa, nangneqliurrnganani-llu maa-i tegumiaqertarturainanemteńi Yugtun qalarcaraq."
        },
        "13": {
            "start": 152.56,
            "end": 179.76,
            "transcript": "Makut allat tayima ayainanemteńi maa-i una ca wani qayaq cukaitessiiyaagtuq pegglaput, allamek cimirlaut massiinalegmek una wani neput pegglaut angenrituq angtuanek pilta, makut akluput cimirlaut pegtaqluki tua-i kinirturluki Kass'at piyaraicetun, man'a tau͡gken tua-i qaneryaramta ilii, tua-i-wa ilakluku."
        },
        "14": {
            "start": 179.84,
            "end": 208.64,
            "transcript": "Piciryaramta atam maani naaqiungallemni wall' niiqurallemni, Yugtun-gguq qaneryaraq wall' ingqilicetun, cukauq-gguq catairtellra, ukut-gguq mikelnguut anglicaquneng Kass'atun qalarqurtelluki, tuaken-gguq atam ayagnirluteng, qanriqerrniartuq catairrluni-llu qaneryaraq, ellmegcetun qaneryaraq."
        },
        "15": {
            "start": 208.64,
            "end": 236.52,
            "transcript": "Maa-i taumek elliimelriacetun-wa [?] tua-i cungiyutkellriacetun, amlleret akmani-llu pingkiit [?], naugga-wa imna qaneryaraat, ellmegcetun qaneryaraat, elitnaurvigmi-llu maa-i amlleret elitnaurutkengnaqsaaqluku ugaan' qunuksaaqellrum, cukaluni tayim' cataircetulliniani."
        },
        "16": {
            "start": 238.64,
            "end": 267.76,
            "transcript": "Atam maani avatemteńi yuvriagurqernaurtukut maaten una piciqan Kass'atun igaumaluni, maaten tauna piciqan Kass'atun igaumaluni, kipusvigmun maaten iterciquten Kass'atun igaumaluni, maaten-llu tiiviiq kumarciiqan Kass'aturrlainaq, irniaci elicuiqut Kass'atun piinanermeggni, kia allan' wani."
        },
        "17": {
            "start": 269.12,
            "end": 294.84,
            "transcript": "Tailuni Yugtun elicungcarngaitai, Mamterillermek tailuni kina pingaituq, irniama Yugtun elicungcarnaurqa, maa-i iciw' amllelriit nunavcenun tekitellriit, canek tua-i elicungcariyarturluteng cayaramek, kina wani watqapiar tekisngaituq waten qanerluni, irniam' elicungcarnaurqa Yugtun qanen'ermek."
        },
        "18": {
            "start": 296.84,
            "end": 325.64,
            "transcript": "Atam wani una tangerqaqerlaut, wani-wa-rraacuayaar una [?] mikpiarluni, unu wani Yugtun qaneryaraqaput Kusquqvagmi Kuigpagmi-llu, Kuigpagmi tayima ilait qanen'eq nalluyagutengkiit qavcirraurrluta mikpiarluta, atam wani una tangerqercu, camkut [?]."
        },
        "19": {
            "start": 327.84,
            "end": 357.41,
            "transcript": "Yuum wani angtacia, Kass'atun wani-w' qantulit amllepiartut, un' tang wani qaneryaraurlurput Yugtun nerqatalriacetun pikii, murilkenrilkumta nerciqelriatun [?] piciqaa, catairuciiqluni-llu akmani ingqilit pillracetun, amani Fairbanks-aami uitamaqallruunga, allrakuni akimiarni."
        },
        "20": {
            "start": 357.84,
            "end": 369.08,
            "transcript": "Tua-i-ll' maavet tailua caliyaurrlua maani district office-aami, tua-i-ll' nunanun ayaganga'arrlua, maaten nunanun ayaganga'arrlua piunga makut wani mikelnguut."
        },
        "21": {
            "start": 369.08,
            "end": 393.88,
            "transcript": "broken English-aarluteng, broken Yup'ik-aarluteng-llu tua-i taukut pingraagnek irnian wani broken English-aangqengraan Yugtun kiiki elicungcarru, wangkuta Yugtun qalartelput puqigyaaquq, assiryaaquq qalarcetukumek [?] Yugcetun, Yugtun irnian elicungcarru."
        },
        "22": {
            "start": 393.88,
            "end": 418.72,
            "transcript": "broken English-aangqeng'e'rmi atataku eliciiqaa, tamana Kass'atun qalarcarani Kass'aturyaraq man'a paivngiimi, broken Yup'ik-aangqellra man'a, tua-i-w' assinrituq, atam wangkutnek tangerqaqernaurtukut, wiinga waniwa Yugtun qalarqurlua ellangellruunga."
        },
        "23": {
            "start": 420.76,
            "end": 449.44,
            "transcript": "Tua-i-llu irnianka, aren ukut-wa tua-i irnianka Kass'atun qalarcetuut, tau͡gaam Kass'amek aatarluteng, aatameggnek elilluteng Kass'atun qalarcaramek, wiinga waniwa apqiitnek role model-aukegtaaraunritua Kass'atun elicungcarillerkamnek, Yugtun qalartelqa angenruuq, Kass'atun qalartellemni."
        },
        "24": {
            "start": 451.04,
            "end": 463.72,
            "transcript": "Taumek ava-i qanelrianga wangkuta, role model-aaqegtaurauniluta, una wani mikelnguum Yugturrlainaq anglivkallerkaa."
        },
        "25": {
            "start": 463.72,
            "end": 485.15,
            "transcript": "Apqiitnek wangkuta yug'ulriami Yugtun qalarqurluta ellangellerni, limited English-aangqertukut, una-ll' tua-i Yugtun, aren Kass'atun, mikelnguun, qalarqurluku anglicarceskuvgu anglivkaquvgu, limited English-aangqerciquq."
        },
        "26": {
            "start": 485.27,
            "end": 504.66,
            "transcript": "Taringuraci man'a qanelqa, elitnaurillrukuvci tamamta wangkuta Yugni role model-aaruqegtaunritukut, Yugturrlainaq tau͡gaam qaneryaraput nallunritaput,"
        },
        "27": {
            "start": 504.66,
            "end": 534.56,
            "transcript": "Tua-ll' waniwa qanluuvutka [?], nutaan kingumek qanrutkeqatarqa, atam maavet upalriakut Mamterillernun, tua-i-ll' una panigpuk kiuqliq elitnaunermek taqngami caliarkaminek yuangertuq, maaten tang cimirinaurtuq waten qanraqluteng, prefer a bilingual person, taumek-gguq,"
        },
        "28": {
            "start": 535.56,
            "end": 564.56,
            "transcript": "Calistaryugtut malrugnek qantulignek, Kass'atun Yugtun-llu, tua-i imirilpuk [?] tamalkuan, wiinga-ll' maligtellruamku tauna tangerturluku, tua-llu taum kinguakun waten allakarrarmek ukuk paniigka nallullutek-llu qanertuk, \"Aan, ciin Yugtun qanen'ermek elicungcallrunricia?\" Nallullutek, tua-ll' kiulararka wiinga,"
        },
        "29": {
            "start": 565.56,
            "end": 594.56,
            "transcript": "\"Fairbanks-aami ak'anun uitamanayukluta elicungcallrunritamtek.\" Tamana irniarpeceńun niitesqumavkenaku, aren qanrutkesqumavkenaku, wall' kiutkesqumavkenaku qanrut'luugutkaqa man'a Yugtun qaneryararput ciumurutesqelluku, cali-llu tamanritlerkaa pitekluku, au͡gkut allat amlleriata tamarilriit,"
        },
        "30": {
            "start": 594.66,
            "end": 600.56,
            "transcript": "ellmegcetun qaneryaramek. Tua-i waten man'a pitaaq [?] quyana."
        }
    },
    "LXDyg6Kotd0": {
        "1": {
            "start": 0.0,
            "end": 12.02,
            "transcript": "Ayagalaamta tamaa-i au͡gkut angukara'urluut tua-i qasgiicuitellruameng, qasgimek pitangqetullruameng,"
        },
        "2": {
            "start": 12.02,
            "end": 21.52,
            "transcript": "angukara'urlurnek yugluni qasgiq, tan'gaurluut-llu cali iterluteng uitavikluku."
        },
        "3": {
            "start": 21.52,
            "end": 28.12,
            "transcript": "Tuani tua-i qasgim iluani qalartetullruut alerquagiluteng ayagyualrianek,"
        },
        "4": {
            "start": 28.12,
            "end": 38.56,
            "transcript": "qamigallerkaat-llu man'a kiagniararqan arcaqerluku qalarutketullruat."
        },
        "5": {
            "start": 38.56,
            "end": 46.6,
            "transcript": "Tua-i-llu tamaa-i alerqualuki,"
        },
        "6": {
            "start": 46.6,
            "end": 58.04,
            "transcript": "qaciggluteng piyuitellermegni, levaayuitellermegni, anguarluteng pitullermegni pitarkarnurnalriatun ayuqellruuq, yaaqvanun ayayuitellruameng."
        },
        "7": {
            "start": 58.47,
            "end": 66.17,
            "transcript": "Tua-i-llu tamaa-i paivngalillerkaat angukara'urluut qalarutaqamegteki,"
        },
        "8": {
            "start": 66.17,
            "end": 74.93,
            "transcript": "qavarpiiqnaki pisqelluki, qavanrilengraata, qavamek makugtengraata,"
        },
        "9": {
            "start": 74.93,
            "end": 81.12,
            "transcript": "pisqelluki, waten qamigaraugngalriit [?] tamaa-i ayagyualriit, ayagyuaqlilriit."
        },
        "10": {
            "start": 82.72,
            "end": 96.6,
            "transcript": "Alerqualuki-llu caarrluut unugmi caliaqluki qasgim kenillra carrirluku, wall'u elaturratnek qagkut elaturrai carrirluki unugmi."
        },
        "11": {
            "start": 98.93,
            "end": 108.35,
            "transcript": "Iterluteng-llu caniraqluki enet, caarrluut maavet canimaungun piugnaunaki,"
        },
        "12": {
            "start": 108.35,
            "end": 119.26,
            "transcript": "tutmaallek kangarayaraita [?] nunat taukut elatiitnun elliluki caarrluut, tuaten tua-i pisqelluki alerquagaqluki,"
        },
        "13": {
            "start": 119.26,
            "end": 126.68,
            "transcript": "paivngalillerkaatnek pissulriit tamakut alerquagaqamegteki."
        },
        "14": {
            "start": 129.6,
            "end": 143.5,
            "transcript": "Qavamek makuggluki, amiik carrirluku, qimugtet anait qimugtaiciitellruameng, kiingicakayaqngamegteki, pituumayuunateng-llu,"
        },
        "15": {
            "start": 143.5,
            "end": 157.55,
            "transcript": "anai carrirluki, elaturraq-llu carrirluki tamaa-i tuaten alerquucirteng [?] aturluku pitullruameng, tuaten, tuaten-am pilria maligutellria."
        },
        "16": {
            "start": 157.55,
            "end": 164.23,
            "transcript": "Tuana-ll' arullu nutarkaanek [?], pitarkanek paivngaliqerivaqluni [?],"
        },
        "17": {
            "start": 164.23,
            "end": 172.42,
            "transcript": "Cunawa tung'um piliaqestemta pivkalallinikut maa-i mat'um nalliini taringaqa nutaan,"
        },
        "18": {
            "start": 172.42,
            "end": 185.4,
            "transcript": "elliin pikngamiki piliaqngamiki tuaten makugtellria pitapiutlerkani umyuaqerluku qavarning'e'rmi-llu qavayuunani ciuqlirmi,"
        },
        "19": {
            "start": 185.4,
            "end": 191.43,
            "transcript": "pilria tuaten tua-i alerquuteteng aturluku pitullruameng."
        },
        "20": {
            "start": 191.43,
            "end": 207.04,
            "transcript": "Tua-i-llu maa-i anguarluteng tau͡gaam pitullruameng yaqesvanrilengraan cayaqlirluku ullakeng'erteng tekicetullruluku,"
        },
        "21": {
            "start": 207.04,
            "end": 218.04,
            "transcript": "ilait-am paivngaliluteng tuatenalriit tamaa-i-w' qanruyuteteng aturtait, atungnaquurtait."
        },
        "22": {
            "start": 218.04,
            "end": 227.12,
            "transcript": "Paivngalitullrulliniut tamaani pitarkanek, alerquateteng aturluki,"
        },
        "23": {
            "start": 227.12,
            "end": 232.88,
            "transcript": "una-ll' waniwa arrsaqerluku aarutkelallrat [?] akusrarutekiyaraq."
        },
        "24": {
            "start": 232.88,
            "end": 241.24,
            "transcript": "Tamatum akusrarutekiyaram tan'gaurluq pitengnaqlerkaan, naugciqlinia [?] umgutellriatun ayuqluku."
        },
        "25": {
            "start": 241.24,
            "end": 251.56,
            "transcript": "Pingnatungraan, ayagengraan, makuggluni pingraan egmian paivngalingairuciiqelliniluni tuaten pilleq."
        },
        "26": {
            "start": 251.56,
            "end": 261.75,
            "transcript": "Assiinani-ll' maa-i cali uumi agayumaacimi, inerquutnguyaaqluni arcaqerluni aarutnguluni,"
        },
        "27": {
            "start": 261.75,
            "end": 270.0,
            "transcript": "yuum navguuteksiqliniaku waten akusrarutekissaagluni-llu pikuni."
        },
        "28": {
            "start": 270.0,
            "end": 278.72,
            "transcript": "Tua-i assiilan arcaqerluku inerquutektullruat, taumta-llu waten qanernaurtut:"
        },
        "29": {
            "start": 278.72,
            "end": 289.79,
            "transcript": "Yuilqumi ilavet akluanek uitalriim caaksuaraqengyaqunek pikenrilkekngarpenek,"
        },
        "30": {
            "start": 289.79,
            "end": 297.08,
            "transcript": "ellam yuan tangvagaaten, tangvagciqaaten alerrngailnguum."
        },
        "31": {
            "start": 297.08,
            "end": 304.44,
            "transcript": "Cunawa tang una piliaqestevvut Agayun agayutkunayuitellruameng,"
        },
        "32": {
            "start": 304.44,
            "end": 310.28,
            "transcript": "ellam yuanek tau͡gaam aterpagtaqluku tangvagtevvut."
        },
        "33": {
            "start": 310.28,
            "end": 318.35,
            "transcript": "Tua-i tuaten pillrukumta tua-i calerkarput, canek-llu calillerkarput,"
        },
        "34": {
            "start": 318.35,
            "end": 322.81,
            "transcript": "tua-i navegluku taum tuaten piciqelliniki."
        },
        "35": {
            "start": 322.81,
            "end": 333.74,
            "transcript": "Tau͡gken navyuilnguut navgenrilnguq qaneryaramek atungnaqiilria,"
        },
        "36": {
            "start": 333.74,
            "end": 342.28,
            "transcript": "pitarkaq-llu piciqngailengraan paivngaliqerluni pitullrulliniluni."
        },
        "37": {
            "start": 342.28,
            "end": 349.48,
            "transcript": "Tua-i wiinga-ll angullruluku tamana anguarluta tau͡gaam pissutullemteńi,"
        },
        "38": {
            "start": 349.48,
            "end": 356.28,
            "transcript": "tuamta-llu uksumi uksuaqan melqulegnek pingnaqkumta,"
        },
        "39": {
            "start": 356.28,
            "end": 365.83,
            "transcript": "Cali tamaa-i ilakluku tuaten tua-i yuk tamatumek atuquni aarcirtuutmek [?],"
        },
        "40": {
            "start": 365.83,
            "end": 373.96,
            "transcript": "cali tua-i paivngalillerkani tua-i umgulluku piqalang'e'rmi cam iliini,"
        },
        "41": {
            "start": 373.96,
            "end": 381.66,
            "transcript": "yuilqumun ayagaluni ping'e'rmi egmianun anglirciiganani tuaten piarkaulliniuq,"
        },
        "42": {
            "start": 381.66,
            "end": 387.2,
            "transcript": "maa-i-llu tua-i mat'um nalliini qaciggluteng pingameng angyarluteng."
        },
        "43": {
            "start": 387.24,
            "end": 397.8,
            "transcript": "Tua-i makut wiinga tutgaraanka, iluraanka-llu au͡g'umek ava-i qanrut'laranka,"
        },
        "44": {
            "start": 397.8,
            "end": 404.46,
            "transcript": "pitniaqata nallungelarniluki, nallungulriatun pilarniluki,"
        },
        "45": {
            "start": 404.46,
            "end": 414.23,
            "transcript": "aqumgaluni uitaurraaluni tua-ll' pitarkamek tangerquni nutek tau͡gaam teguluku kiingan nutegluku,"
        },
        "46": {
            "start": 414.23,
            "end": 421.83,
            "transcript": "Makugteqarraaryugnaunani, tuaten pilangluteng maa-i mat'um nalliini,"
        },
        "47": {
            "start": 421.83,
            "end": 432.39,
            "transcript": "avani ciuqvani tuaten unugluki-llu iliini, unugluta wiinga-ll' tuatnatullrulrianga ilagaullua,"
        },
        "48": {
            "start": 432.39,
            "end": 441.55,
            "transcript": "unugluki uterrnginanratni unuuqluku ilameggnun kangimeggnun tekitaqluteng tuaten pitullruut."
        },
        "49": {
            "start": 441.55,
            "end": 450.61,
            "transcript": "Makut maa-i niicuirusngaaci, Kass'am tau͡gaam uum pianek niitengelriaci,"
        },
        "50": {
            "start": 450.61,
            "end": 461.0,
            "transcript": "man'a tau͡gaam cali agayulirtet qanruyutiit neq'akengnaqluku, teggutekengnaqluku pinarqerkaugaci."
        },
        "51": {
            "start": 462.12,
            "end": 479.4,
            "transcript": "Maa-i-llu tua-i makut nallunailkutat cali apertuumalriit, tekitengluteng alaitengluteng tua-i maana apertuumacirmegcetun,"
        },
        "52": {
            "start": 479.4,
            "end": 491.12,
            "transcript": "yuk-llu yuuk nakmiin-llu anelgutkeng'e'rmi, wall'u ilakutaqeng'e'rmi nunalgutkeng'e'rmi-llu."
        },
        "53": {
            "start": 492.83,
            "end": 503.93,
            "transcript": "Inglukluku umyugaan pilangluku maa-i im' nallunaiterpagluni assirpek'nani tamani tuatenangnaqsunaunani [?],"
        },
        "54": {
            "start": 503.93,
            "end": 513.2,
            "transcript": "tau͡gaam maliguqu'urluni ilani kiunrirtulriatun piurluki nunalgutniini [?],"
        },
        "55": {
            "start": 513.2,
            "end": 519.51,
            "transcript": "nengaugiskuni-lli [?] kina imna tuaten pikuni atawauqapiarciquq,"
        },
        "56": {
            "start": 519.51,
            "end": 526.73,
            "transcript": "tau͡gken umyuani aterturluku caunrilciaqluni pikuni-llu yugnek,"
        },
        "57": {
            "start": 526.73,
            "end": 535.97,
            "transcript": "tamana tamaa-i alerquut aturarkaqenrilkek [?] atuamiu pisciigaliciqluni-llu umyuani aturluku."
        },
        "58": {
            "start": 535.97,
            "end": 539.13,
            "transcript": "Qaillun tayima taktarkaugaa?"
        },
        "59": {
            "start": 539.13,
            "end": 547.79,
            "transcript": "Arulaiqeryukuvet, arulaiqeryukuvet."
        },
        "60": {
            "start": 547.79,
            "end": 553.63,
            "transcript": "[?] maligtaquliki piaqama makuk tau͡gaam waniwa,"
        },
        "61": {
            "start": 553.63,
            "end": 565.12,
            "transcript": "kiagmi, uksumi-llu makuk aturlukek tuaten-gguq pitullruukut qanrusgu."
        },
        "62": {
            "start": 596.43,
            "end": 608.08,
            "transcript": "Qaillun-llu-gguq nallunrit'larcellruceciu natmun nal'ucirci tua-i ella assiilengraan wall'?"
        },
        "63": {
            "start": 608.08,
            "end": 619.54,
            "transcript": "Assiilengraan-qaa? Kiarnailengraan. Alerquatelput-gguq aturluki pilaamta, wiinga waniwa,"
        },
        "64": {
            "start": 619.54,
            "end": 626.31,
            "transcript": "ikamrayuirutua qimugtetgun snuukuuraqlua tau͡gaam maa-i mat'um nalliini."
        },
        "65": {
            "start": 626.31,
            "end": 636.19,
            "transcript": "Ataucirqumek-gguq tau͡gaam qanerlua-llu taunguyukluku aruliarvigqa pircillrani."
        },
        "66": {
            "start": 636.19,
            "end": 643.67,
            "transcript": "Maaten unuaquan nercian [?] piaqata ilanka qanrutellruluki."
        },
        "67": {
            "start": 643.67,
            "end": 653.5,
            "transcript": "Tauna tua-i apelqa taungullinilria nanvaq, ilama nalluvkenaku cali niitetuluku. Nanvaq tauna."
        },
        "68": {
            "start": 653.5,
            "end": 656.85,
            "transcript": "Tuancukluta qanrutellruanka ilanka."
        },
        "69": {
            "start": 656.85,
            "end": 671.05,
            "transcript": "Tauna-gguq tua-i uungucicarpialqaqa. Nani uitaciini-gguq yuilqumi kiimi arulailang'e'rma unugaqanga nanluciini pivailegma waten ellirtua."
        },
        "70": {
            "start": 675.2,
            "end": 686.16,
            "transcript": "Makutgun, kuigteggun, nanvatgun, iqalluguatmek qemariyagarteggun [?] nallunrit'lallruaput."
        },
        "71": {
            "start": 686.16,
            "end": 688.61,
            "transcript": "Kampaassartaitellrani tamaani?"
        },
        "72": {
            "start": 688.61,
            "end": 695.84,
            "transcript": "Kampaassaiceteller'. Kampassiartaitellrani."
        },
        "73": {
            "start": 695.84,
            "end": 701.45,
            "transcript": "Unugmi-llu tan'gercetaqan agyat nallunritanka."
        },
        "74": {
            "start": 701.49,
            "end": 706.55,
            "transcript": "Tunturyuk [?] arcaqerluku tuquitngullruuq. Tunturyuk atliq [?]."
        },
        "75": {
            "start": 715.16,
            "end": 718.5,
            "transcript": "Tua-i waten pitaqumegnek [?] cayarta?"
        },
        "76": {
            "start": 721.57,
            "end": 725.83,
            "transcript": "Au͡g'umek qanruteksaitell'"
        }
    },
    "6DQTE6b6YQk": {
        "1": {
            "start": 604.2,
            "end": 607.92,
            "transcript": "Waten-gguq akaar yuurqatullruut."
        },
        "2": {
            "start": 639.14,
            "end": 641.24,
            "transcript": "Yuurqaqcaaqerluni."
        },
        "3": {
            "start": 641.24,
            "end": 646.46,
            "transcript": "Tua-ll' piaqa, \"Ciin ulur akaar [?] yuurqasit?\""
        },
        "4": {
            "start": 646.46,
            "end": 650.54,
            "transcript": "Qaillun? Waten piqerluni."
        },
        "5": {
            "start": 650.54,
            "end": 656.14,
            "transcript": "Ilait imkut waten miktellemni [?] yuurqatullrulriit."
        },
        "6": {
            "start": 656.8,
            "end": 661.2,
            "transcript": "Niitelaryugnarqua."
        },
        "7": {
            "start": 662.5,
            "end": 666.9,
            "transcript": "Kenkayalleq-wa [?] call'-am yuurqeqam [?]."
        },
        "8": {
            "start": 666.9,
            "end": 670.48,
            "transcript": "Tuaken avumek pitullrulriit."
        },
        "9": {
            "start": 670.48,
            "end": 678.22,
            "transcript": "Tamuanguarturluni tua-i uunguangqelallrulriit [?]."
        },
        "10": {
            "start": 687.48,
            "end": 689.12,
            "transcript": "Piqatall'."
        },
        "11": {
            "start": 689.12,
            "end": 692.64,
            "transcript": "Ciuqliit-llu akurtallrenka."
        },
        "12": {
            "start": 730.76,
            "end": 735.22,
            "transcript": "Caququluki qimugteńun neqkiurluki."
        },
        "13": {
            "start": 742.4,
            "end": 745.8,
            "transcript": "Yaa, piksait' tau͡gaam ready-rtut."
        },
        "14": {
            "start": 748.04,
            "end": 753.2,
            "transcript": "Qanerkangqellriaci-w' tua-i, iciw'."
        },
        "15": {
            "start": 756.02,
            "end": 766.18,
            "transcript": "Atam elissaaryugngacimnek umyuartellerpeci iciw' wangkuta nalluyagu' niicuilkeput makut."
        },
        "16": {
            "start": 766.18,
            "end": 774.14,
            "transcript": "Iciw' cali ak'a tamaani qanrut'lallrukici qaillun yullerkarpecenek assirluci."
        },
        "17": {
            "start": 774.14,
            "end": 780.72,
            "transcript": "Cali elissaraqluci caliyaramek cali pisqaqluci."
        },
        "18": {
            "start": 782.12,
            "end": 785.18,
            "transcript": "Tangvagluki cuculuki ayuqelissaulu'."
        },
        "19": {
            "start": 785.18,
            "end": 798.04,
            "transcript": "Ii-i, tamakunek-llu qanerluki tangvagluki elitelallruniluci tua-llu, tangvaurarrarluki nutaan caliluci tangvallerpecicetun."
        },
        "20": {
            "start": 802.02,
            "end": 809.54,
            "transcript": "Cali qaneqcautescilallerpeceńek [?] tamakucinek niitelallerpeceńek qanrulluki."
        },
        "21": {
            "start": 809.54,
            "end": 823.2,
            "transcript": "Iciw' Agayutmek niipailegpeci cali iciw' yuuyaraq assirluni niitelallrunillrukeci tua-ll' nallunrilngurcetun."
        },
        "22": {
            "start": 826.32,
            "end": 833.86,
            "transcript": "Piciatun wall' waniwa calilriaci makunek kiugmek cakainek."
        },
        "23": {
            "start": 837.38,
            "end": 839.82,
            "transcript": "Tua-llu."
        },
        "24": {
            "start": 858.94,
            "end": 863.2,
            "transcript": "Tua-i. Kina ciumek qanerta?"
        },
        "25": {
            "start": 891.9,
            "end": 898.96,
            "transcript": "Yaa, avani qanrulletullru'... wiinga qanerkaitua camek niitetullemnek qanerciqua."
        },
        "26": {
            "start": 900.76,
            "end": 913.2,
            "transcript": "Qanrutetullrukaitkut tang avani yuullerkamteńek waten caliyuilkumta iqmiyuiciiqniluta."
        },
        "27": {
            "start": 913.2,
            "end": 931.54,
            "transcript": "Tupiyuilkumta tupigarmek-gguq akikiuviit [?] tupinernat [?] calineq nallukumteggu cuya pirpakellruamegteggu iqmigkarniarutkaiciiqukut caliyuilkumta tupiyuilkumta."
        },
        "28": {
            "start": 931.54,
            "end": 945.3,
            "transcript": "Tupitukumta-gguq tau͡gken cuyaniarutkamteńek tamaita taqucugngaluta issratmek, wall'u curunek, wall'u ikaraliitnek, wall'u kangciranek."
        },
        "29": {
            "start": 945.3,
            "end": 949.18,
            "transcript": "Wall'u alliqsanek."
        },
        "30": {
            "start": 949.18,
            "end": 954.3,
            "transcript": "Alliqsitullruut-am imkut nauwa makuunrilngurnek iitarnek."
        },
        "31": {
            "start": 954.3,
            "end": 967.64,
            "transcript": "Uugnaraat nauw' aciitnek neqkaulriit tamakunek kangritnek pagkunek tupigluki alliqsitullruut."
        },
        "32": {
            "start": 967.64,
            "end": 974.8,
            "transcript": "Tamakut arilluut tuaten kevirkiurluki kelugkarnek."
        },
        "33": {
            "start": 974.8,
            "end": 982.48,
            "transcript": "Tamakunek-gguq caliyuilkumta cuyayungramta cuyaniarutkaiciiqukut."
        },
        "34": {
            "start": 982.48,
            "end": 991.54,
            "transcript": "Tau͡gken-gguq tupineq waten nallunrilkumteggu cuyaniarutkamteńek tua-i taqucugngaluta."
        },
        "35": {
            "start": 991.54,
            "end": 1000.72,
            "transcript": "Cali-llam pinauraakut iruluar-gguq pitekluku qingarciqukut tamaa-i tuaten pikailkumta."
        },
        "36": {
            "start": 1000.72,
            "end": 1009.42,
            "transcript": "Iciw' angutem akilirluta iruluarmek wall'u iquk'uallermek qingirluta."
        },
        "37": {
            "start": 1009.42,
            "end": 1013.5,
            "transcript": "Tuaten-am pisqevkenata inerqutullrukaitkut."
        },
        "38": {
            "start": 1013.5,
            "end": 1017.04,
            "transcript": "Uingunata qingasqevkenata."
        },
        "39": {
            "start": 1017.04,
            "end": 1025.48,
            "transcript": "Tamana qingiryaraq tamaani atengqerrluni angurrlugmek acuniaqengisqevkenata."
        },
        "40": {
            "start": 1025.48,
            "end": 1028.42,
            "transcript": "Uingunata qingasqevkenata."
        },
        "41": {
            "start": 1028.42,
            "end": 1036.06,
            "transcript": "Wagg'uq tamaa-i uingunata acuniaqengiluta."
        },
        "42": {
            "start": 1036.06,
            "end": 1042.0,
            "transcript": "Uingunata qingaqumta mikelnguq alaiqan acuniaqengauluni tauna."
        },
        "43": {
            "start": 1042.0,
            "end": 1047.36,
            "transcript": "Maa-i aatailngurnek maa-i pilaqeput makut qingaqullriit."
        },
        "44": {
            "start": 1047.36,
            "end": 1052.2,
            "transcript": "Tuaten-am tua-i inerqutullrukaitkut."
        },
        "45": {
            "start": 1052.2,
            "end": 1065.58,
            "transcript": "Cali angun mallguura' tua-w' imkucisqevkenaku, iciw' tua-i cakneq piitesqevkenaku."
        },
        "46": {
            "start": 1065.58,
            "end": 1075.64,
            "transcript": "Angun-gguq qimugkauyartun ayuquq ungaqercukaarluni, tan'gurraq, tan'gaurluq nulirrilnguq."
        },
        "47": {
            "start": 1075.64,
            "end": 1089.04,
            "transcript": "Ungaqercuk' qimugkauyartun-gguq ayuquq. Ingluliuqaquni-gguq egmian ungaqerrluni tamaa-i tuatnaarkauluni. Avalitngusqevkenata angutmun."
        },
        "48": {
            "start": 1089.04,
            "end": 1097.64,
            "transcript": "Tamaa' alingcetaarutengqellruut tamaani angutet picuiruceciiqniluki-ll' wall' arniqevkarciqniluki."
        },
        "49": {
            "start": 1097.64,
            "end": 1106.28,
            "transcript": "Tamakut arniqelriit assiitellrulliniut tamatum nuniini."
        },
        "50": {
            "start": 1106.28,
            "end": 1118.22,
            "transcript": "Tua-i-w' ellarrlain' tangvayunaunateng caaqluteng tamaa-i nuyai-llu-gguq nangertengluteng tamakut arniqelriit kegginait-wa-gguq akirpak."
        },
        "51": {
            "start": 1118.22,
            "end": 1126.66,
            "transcript": "Tamaa-i tamakut wangkut elluarrluki yuutelput ukvekluki aturluki yuullruukut."
        },
        "52": {
            "start": 1126.66,
            "end": 1135.6,
            "transcript": "Kiagmi-llu waten avani marami uitaaqamta-w' tua-i-w' it'gairnairutaqan kamilaamta pek'ngaqamta."
        },
        "53": {
            "start": 1135.6,
            "end": 1146.2,
            "transcript": "Curumteńun makucinun it'gaput unugmi ungirvangaqata-wa it'gaput talurrulluki aunrarqengaqluteng."
        },
        "54": {
            "start": 1146.2,
            "end": 1155.5,
            "transcript": "Avalitkevkenaki-llu ellimeqakut ayagluta mermun tussutaqamceteng iliini qacervatulriit."
        },
        "55": {
            "start": 1155.5,
            "end": 1164.98,
            "transcript": "Waterrlainaq kesiin kangarluta maaggun callarqelluteng, akunlait-llu callarqelluteng."
        },
        "56": {
            "start": 1164.98,
            "end": 1175.16,
            "transcript": "Cakneq tua-i maavet yuilqumun ayagaqamta aunraarassiyaalria camek qecukaulluta nemraqluku."
        },
        "57": {
            "start": 1175.16,
            "end": 1180.2,
            "transcript": "Camek-llu avaliciyuunata nepaunata yuuluta."
        },
        "58": {
            "start": 1182.34,
            "end": 1187.6,
            "transcript": "Enem iluani nepliryugnaunata yuugaqluta."
        },
        "59": {
            "start": 1187.6,
            "end": 1197.84,
            "transcript": "Nepliryarpiaqumta-llu uyuraput-llu anglaniluta piyarpiaqumta inerqurluta usviircaasqevkenata."
        },
        "60": {
            "start": 1199.6,
            "end": 1203.0,
            "transcript": "(Cani) Muiqa' yugyagluci uitatullerpeceni."
        },
        "61": {
            "start": 1203.0,
            "end": 1208.2,
            "transcript": "Wiinga ellangellruunga allamek yugnek ilangqessuumiitua."
        },
        "62": {
            "start": 1209.06,
            "end": 1219.24,
            "transcript": "Kassaurrnerratgun-wa pillrulrianga tau͡gaam tamaa-i tamakunek inerqutullruitkut qaner' tuaten pisqevkenata."
        },
        "63": {
            "start": 1219.24,
            "end": 1227.08,
            "transcript": "Cali allaneq tekiskan elluarrluku ciuniuresqelluku."
        },
        "64": {
            "start": 1227.08,
            "end": 1231.46,
            "transcript": "Iciwa-gguq nek'artulriit yuut irniaput-llu irnia'..."
        }
    },
    "ClklQ0IntQU": {
        "1": {
            "start": 7.29,
            "end": 13.0,
            "transcript": "Au͡gna-gguq-qaa imaicillratni qanqallren qanruteksugnganritan?"
        },
        "2": {
            "start": 13.0,
            "end": 27.08,
            "transcript": "Tua-i-w' au͡gna iciw' imna au͡gna kinguneni-gguq allanret-llu tekitaqata elluarrluki pilqaqluki."
        },
        "3": {
            "start": 27.08,
            "end": 37.24,
            "transcript": "Kinguneni-gguq yuum nalluyagucuitai irniangekuni irniaput tamaa-i nek'artulriit ayallerkartuluteng."
        },
        "4": {
            "start": 37.24,
            "end": 47.3,
            "transcript": "Elluarrluni taumun pillruniluni irniaminun call' irniangqerquni alerquulluku tauna atra apertuumaluku."
        },
        "5": {
            "start": 47.3,
            "end": 57.26,
            "transcript": "Tungelquput-llu nalluvkaasqevkenaki alerquutngutullrulria, nunani allani apertuagurluki irniamteńun."
        },
        "6": {
            "start": 57.26,
            "end": 66.3,
            "transcript": "Ayakuneng-gguq nutaan tauna nalluvkenaku ayagluni ciunirvikarkauluku."
        },
        "7": {
            "start": 66.3,
            "end": 73.48,
            "transcript": "Tuaten alerquatullruuq. Ca tamalkuan qanruyutngutullruuq."
        },
        "8": {
            "start": 73.48,
            "end": 83.5,
            "transcript": "Cali irnialegni wangkutni uingekumta uiput elluarrluki pirpakluki ataneqluki aulukesqelluki."
        },
        "9": {
            "start": 83.5,
            "end": 89.9,
            "transcript": "Unuakumi call' ayakata inangqau[rluta], ayakataqata makluta upluki."
        },
        "10": {
            "start": 89.9,
            "end": 101.4,
            "transcript": "Irniaput-llu cali irniangyugaqamta inangqaurautesqevkenaki unuakumi alerqutullrukaitkut."
        },
        "11": {
            "start": 101.4,
            "end": 105.7,
            "transcript": "Tupakata egmianun makyulluki caluta tua-i."
        },
        "12": {
            "start": 105.7,
            "end": 116.18,
            "transcript": "Cali-ll' uimta tamakut aipamta ca unangkengait ikiurcetenrilkurrluki aulukesqelluki elluarrluki."
        },
        "13": {
            "start": 116.18,
            "end": 123.66,
            "transcript": "Irniamteńek, irniatullrulriakut wangkuta babysit-artengssagaunata caitqapik."
        },
        "14": {
            "start": 123.66,
            "end": 140.18,
            "transcript": "Qava'arqata, atakumi-llu qavaqata caarkaput caluki  ngelmagtengnaqluki [?] nangutenrilkumta-ll' inareskumta call' unuakumi qavacurlautekluki irniaput qavarturallratni qaqiutengnaqluta."
        },
        "15": {
            "start": 144.48,
            "end": 148.12,
            "transcript": "Ilanka qanerkairucuanka taqua."
        },
        "16": {
            "start": 148.68,
            "end": 151.76,
            "transcript": "Ii-i, waniku call' qaneryukuvet qanerniartuten."
        },
        "17": {
            "start": 158.12,
            "end": 161.34,
            "transcript": "Egmian kiingan taqsaaqnaurtukut."
        },
        "18": {
            "start": 163.24,
            "end": 167.58,
            "transcript": "Arnaqull', tupigaten qanemcikluki."
        },
        "19": {
            "start": 171.66,
            "end": 174.24,
            "transcript": "Tau͡g' maku'urqunek [?]."
        },
        "20": {
            "start": 174.24,
            "end": 178.48,
            "transcript": "Makut iluani kingum [?] qasgim pikaqai."
        },
        "21": {
            "start": 178.48,
            "end": 180.6,
            "transcript": "Ii-i, kangcirarkaa."
        },
        "22": {
            "start": 181.12,
            "end": 182.48,
            "transcript": "Tamalkuan-qaa."
        },
        "23": {
            "start": 182.48,
            "end": 188.26,
            "transcript": "Nuu, yuum tau͡gaam keluni, acini. Cailkaq pivkenaku."
        },
        "24": {
            "start": 193.84,
            "end": 195.56,
            "transcript": "Canek pisit?"
        },
        "25": {
            "start": 195.56,
            "end": 198.26,
            "transcript": "Pinritnguartua. [?]"
        },
        "26": {
            "start": 198.26,
            "end": 199.6,
            "transcript": "Ciin?"
        },
        "27": {
            "start": 199.6,
            "end": 203.92,
            "transcript": "Ayuqevkenateng yuut tamakut wani piitailengraraluni [?]."
        },
        "28": {
            "start": 203.92,
            "end": 208.6,
            "transcript": "Ii-i, camek-mi qanerciqceta?"
        },
        "29": {
            "start": 209.84,
            "end": 216.48,
            "transcript": "Pikiurniluku tauna, tauna nat'um [?] akaurcetutegnganani [?]."
        },
        "30": {
            "start": 216.48,
            "end": 221.36,
            "transcript": "Tupigat yugnun ak'a teguyaraqluni."
        },
        "31": {
            "start": 221.36,
            "end": 229.16,
            "transcript": "Atam ak'a tam'. (Taukunek-llu qanemcikina.) Ak'a tamaan'."
        },
        "32": {
            "start": 229.16,
            "end": 231.08,
            "transcript": "Qaillun piceci?"
        },
        "33": {
            "start": 231.08,
            "end": 244.02,
            "transcript": "Ak'a tamaani-gguq yullret taukut ak'allat man'a canek aklukellruat, caranglluk aklukellruat tua-i pirpakluku."
        },
        "34": {
            "start": 244.02,
            "end": 259.64,
            "transcript": "Cali-llu waten laavkaangqerrsuilameng nevumek enengqerturatullruameng uitangaunani aci una uitangaunani, kangciraunani, curuunani."
        },
        "35": {
            "start": 259.64,
            "end": 278.32,
            "transcript": "Pau͡gna tau͡gaam yuum acini upeskuniu, makut-llu kangcirat kelupailitat ellivailegmegteki canegnek ellivikluki, kelukarteng acikarteng-llu camna cali ellivikluku."
        },
        "36": {
            "start": 278.32,
            "end": 290.32,
            "transcript": "Ellivikaalug' [?] nutaan makut kangcirat iciw' taperrnat capluki, waten kangciraunateng piyuitkacagallruut."
        },
        "37": {
            "start": 290.32,
            "end": 300.12,
            "transcript": "Capluki cali-ll' curuluteng, tua-i curuluteng, curulugnek call' curunek tupiganek capluki."
        },
        "38": {
            "start": 300.12,
            "end": 318.98,
            "transcript": "Tua-i aturluku man'a canek cakluku can'guciluteng qasgicuartun angtalrianek tua-i canek, canek tua-i pikngamegteggu piilkaunritkacagarluku."
        },
        "39": {
            "start": 318.98,
            "end": 336.52,
            "transcript": "Pilugumeggnun keviqluku kenik'acagarluki mecungaqata, qang'a-llu cuukiingsagaunateng kesianek pilugukuklasngaunaku [?] camek can'ggarmek piinak."
        },
        "40": {
            "start": 336.52,
            "end": 352.48,
            "transcript": "Cuukiingsagaunateng can'get ulugturluki maqercarraarluki piyuneqluki tapluki piirrayagiluteng cali nemerkiurluki, nemerraarluku-llu nutaan piluguk all'uku."
        },
        "41": {
            "start": 352.48,
            "end": 358.26,
            "transcript": "Tua-i teguyaraqluku tua-i piinaku yuusciiganateng."
        },
        "42": {
            "start": 358.26,
            "end": 370.0,
            "transcript": "Waten cali yuilqumi arenqiallugtaqameng iciw' tua-i kit'aqameng canegnek qaiseng ellivikluku maqarqutekluku."
        },
        "43": {
            "start": 370.0,
            "end": 377.04,
            "transcript": "Tua-i teguyaraqluku canek pilugumeggnun, acimeggnun."
        },
        "44": {
            "start": 377.04,
            "end": 385.24,
            "transcript": "Taumek canegmek amllermek yuut imkut tamakut yuullret pilitullrulriit."
        },
        "45": {
            "start": 385.24,
            "end": 391.62,
            "transcript": "Amllernek qillerciiluteng atuamegteggu kesianek canek tamana."
        },
        "46": {
            "start": 397.1,
            "end": 398.76,
            "transcript": "Neqmeggnun tuaten assigtaqluku."
        },
        "47": {
            "start": 398.76,
            "end": 401.74,
            "transcript": "Neqmeggnun assigtaqluku."
        },
        "48": {
            "start": 401.74,
            "end": 410.42,
            "transcript": "Tua-i cat tuani neqet tupigluteng. Tupigluteng neqet caquliluki."
        },
        "49": {
            "start": 410.42,
            "end": 423.04,
            "transcript": "Taumtell'-am neqteng iniateng waten tua-i canek plastic-anek piyugnanaki, tupingqullugluteng kelugkanek canegnek qang'a-ll' taperrnanek."
        },
        "50": {
            "start": 423.04,
            "end": 433.08,
            "transcript": "Qivsungkan-llu tua-i neqteng patuluki tamakut net tupigacillernek iciw' taqerqullugluteng arvirrluki ikiungraata."
        },
        "51": {
            "start": 433.08,
            "end": 439.12,
            "transcript": "Tamaa-i teguyaraqluku canek tua-i callermeggnun tamiini."
        },
        "52": {
            "start": 439.12,
            "end": 446.32,
            "transcript": "Alliqsaqluku piineqluku iciw' alliqsanek tupigauluki."
        },
        "53": {
            "start": 446.32,
            "end": 451.28,
            "transcript": "Cali arilluut makut wani mecunglliurrsuutet."
        },
        "54": {
            "start": 451.28,
            "end": 458.6,
            "transcript": "Cali tupigarnek cali iluqlilirluku aliimateteng pitullruluki."
        },
        "55": {
            "start": 462.36,
            "end": 467.98,
            "transcript": "Yugurluut imkut ak'a tamaani TB-ngyuitellrullinivagtat [?]."
        },
        "56": {
            "start": 467.98,
            "end": 479.18,
            "transcript": "Taum marayamek natengqeng'e'rmeng taa [?] quserturarraarluteng qecip'agluki."
        },
        "57": {
            "start": 481.16,
            "end": 489.18,
            "transcript": "Tua-i ellimllituli [?] nevkuneg' [?], kevluteng [?] una unavet igqaqu[luku]."
        },
        "58": {
            "start": 489.18,
            "end": 494.64,
            "transcript": "Qailleramek perrir' tissue-mek-llu qaneryugluku."
        },
        "59": {
            "start": 494.64,
            "end": 505.76,
            "transcript": "Nererraarluteng tuamtell' tua-i irniateng qaillun pikata pilugullrameggnun perriqcaqarraarluteng caluki piluku."
        },
        "60": {
            "start": 505.76,
            "end": 512.7,
            "transcript": "Tua-i aren yugurluut imkut miilaat-wa teq'uq."
        },
        "61": {
            "start": 512.7,
            "end": 522.42,
            "transcript": "Yug' una tua-i up'nerkami taqukaq tegukuniu nuyaq tua-i agturngairulluku."
        },
        "62": {
            "start": 522.42,
            "end": 527.78,
            "transcript": "Qaill' pilartat? Nuyiurngairulluteng, comb-arngairulluteng."
        },
        "63": {
            "start": 527.78,
            "end": 531.4,
            "transcript": "Mingeqngairulluteng."
        },
        "64": {
            "start": 531.4,
            "end": 534.4,
            "transcript": "Taqukaq tau͡gaam tua-i tegumiaqluku."
        },
        "65": {
            "start": 534.4,
            "end": 540.12,
            "transcript": "Tua-i-ll' yuum-wa tau͡gaam quliciiqekii."
        },
        "66": {
            "start": 540.12,
            "end": 542.96,
            "transcript": "Tuaten teq'umek."
        },
        "67": {
            "start": 542.96,
            "end": 554.34,
            "transcript": "Tuamtell'-am tua-i qulicaqliquni teq'iciriluteng teq'umun akleng naryalnguyuunateng tepellriamek [?] nek'ess'anek [?] narumall'."
        },
        "68": {
            "start": 554.34,
            "end": 564.06,
            "transcript": "Tua-i neresciriluteng, lots."
        },
        "69": {
            "start": 564.06,
            "end": 575.76,
            "transcript": "Nakleng ellirararluut makut aulukestailnguut arcaqerluteng nerestem piurlurluki iciw' tua-i cimiriuranrilata."
        },
        "70": {
            "start": 577.82,
            "end": 595.76,
            "transcript": "Tua-i yugurluut imkut camek wangkuta qiperrluutaunata angayuqaput maligtaqu'urlurluki, uumek pisqaqakut qessarpangramta qaillun kiuqerciiganaki maligtaquaqluki piyuumiitepangramta-llu."
        },
        "71": {
            "start": 606.38,
            "end": 609.3,
            "transcript": "Canek-llu cali."
        },
        "72": {
            "start": 614.36,
            "end": 625.94,
            "transcript": "Tuamtell'-am makut wani elluami ayakata tan'gurraat elluamivkaryugnaunaki anglicarluki."
        },
        "73": {
            "start": 625.94,
            "end": 638.76,
            "transcript": "Caluteng aklungqessuunateng waten-llu qasgimi qava'urluquneng uukuk tau͡gaam aliumallugaagni qamiqumi acianun taalliqerlukek kiingan taklukluku."
        },
        "74": {
            "start": 638.76,
            "end": 652.22,
            "transcript": "Maqarqelluki pivkaryugnaunaki maqarqumanrilkuneng iciw' elluarrluteng qavanritellerkaatnun pivkarluku."
        },
        "75": {
            "start": 652.22,
            "end": 662.76,
            "transcript": "Qavarcecugnaitetullruamegteki ak'a imkut ayakatat wagg'uq elluarrluki piuraasqelluki."
        },
        "76": {
            "start": 662.76,
            "end": 674.8,
            "transcript": "Cat tua-i cucukluku piu͡rlullruameng yuut au͡gkut nukalpiarullerkarteng picullerkarteng pirpakurluku pitullrat."
        },
        "77": {
            "start": 680.98,
            "end": 683.9,
            "transcript": "Qaillun piluteng cali."
        },
        "78": {
            "start": 687.26,
            "end": 702.08,
            "transcript": "Wangkurluumta-wa tua-i yug' una tan'gurraq-llu enemi uitakaunritkacagarluki qasgimi tau͡gaam qanerturalrianek ayuqucirtualrianek kesianek niicugnisqumaarluki."
        },
        "79": {
            "start": 702.08,
            "end": 714.48,
            "transcript": "Tua-i-ll' uitakata enemi uitaqaqata agesqelluku qasgimun qanerturalianun amkunun maani usviircarniluki."
        },
        "80": {
            "start": 714.48,
            "end": 725.22,
            "transcript": "Usviircakluki enemi uitallrat. Arnat-gguq picimegcetun qanaatuata. Queen-at."
        },
        "81": {
            "start": 729.9,
            "end": 732.76,
            "transcript": "Tua-i-wa."
        },
        "82": {
            "start": 734.98,
            "end": 737.66,
            "transcript": "Unuakumi camek qaneryarcit?"
        },
        "83": {
            "start": 737.66,
            "end": 740.92,
            "transcript": "Qanerkat amllertut yuut qemangq' [?]."
        },
        "84": {
            "start": 745.44,
            "end": 746.76,
            "transcript": "Aren, tua-i."
        },
        "85": {
            "start": 746.76,
            "end": 755.52,
            "transcript": "[?] qanlallruunga taum aglelriaqata arnat qaillun iciw' pitullruat?"
        },
        "86": {
            "start": 755.52,
            "end": 764.02,
            "transcript": "Tua-i yug' una nasaurluq augmek tangerqerraqan,"
        },
        "87": {
            "start": 764.02,
            "end": 767.94,
            "transcript": "tua-i-ll' natmun, caniqaarmun."
        },
        "88": {
            "start": 767.94,
            "end": 781.52,
            "transcript": "Enem caniqerranun nuavet [?], nepiam caniqerranun aqumluni five days aqumgaluni tupiganek capluni waten ketii."
        },
        "89": {
            "start": 781.52,
            "end": 785.76,
            "transcript": "Tua-i-am petugluki natmun."
        },
        "90": {
            "start": 785.76,
            "end": 791.76,
            "transcript": "Tua-i waten casgurluni five days aqumgaluni."
        },
        "91": {
            "start": 791.76,
            "end": 805.46,
            "transcript": "Aqumgaluni tua-i enemini tua-i-ll' anqataquni aliimatengqerrluni tauna aglenrar kumluilngurmek."
        },
        "92": {
            "start": 805.46,
            "end": 810.28,
            "transcript": "Ukuk wani anumalutek kumlungssagaunatek."
        },
        "93": {
            "start": 810.28,
            "end": 816.42,
            "transcript": "Tua-i-ll' anqataquni anluni akuni tumenqegcaarluku."
        },
        "94": {
            "start": 816.42,
            "end": 827.76,
            "transcript": "Cakneq tua-i un'a [?] cagnilluku akuni pull'uni-llu anluni tua-i pusngaurluni kiarcaaqevkenani-llu quyungq' [?]."
        },
        "95": {
            "start": 837.9,
            "end": 845.76,
            "transcript": "Yaa, tua-i-llu anluteng tua-i pull'uteng aciteng tua-i tangssugluku kan'a."
        },
        "96": {
            "start": 845.76,
            "end": 859.64,
            "transcript": "Tuamtell'-am yuuqerrluteng nunam qainganun uyungekuneng tua-i pusngaluteng alerquucirmegcetun kiareskata iciw' takvialiciqniluki."
        },
        "97": {
            "start": 859.64,
            "end": 864.3,
            "transcript": "Tua-i tuaten tua-i qanrucimi."
        },
        "98": {
            "start": 864.3,
            "end": 872.12,
            "transcript": "Tuamtell'-am tua-i ut'reskuni uterrluni iterluni aqumluni cali."
        },
        "99": {
            "start": 872.12,
            "end": 878.82,
            "transcript": "Waten tupigat amatiitni capkucirluni tallimani ernerni."
        },
        "100": {
            "start": 878.82,
            "end": 884.12,
            "transcript": "Qaillun ekuatni [?], arvinratni-w' pilallil' unuakumi."
        },
        "101": {
            "start": 884.12,
            "end": 891.38,
            "transcript": "Arvinratni nangreskan yuut imkut uayaryarluteng."
        },
        "102": {
            "start": 891.38,
            "end": 896.14,
            "transcript": "Tengrunaqluteng uayaryalriit. (Cat-am uayaryaq?) Akluitnek."
        },
        "103": {
            "start": 896.14,
            "end": 904.4,
            "transcript": "Akluitnek camek inuguaritnek, (Kakivignek.) kakiviteng, carrateng tunturluki."
        },
        "104": {
            "start": 904.4,
            "end": 914.72,
            "transcript": "Inuguani-ll' allakaqtaarturluki uumun yugmun uayaryaq aqvatarkanun upqurrluki nangreskan."
        },
        "105": {
            "start": 914.72,
            "end": 918.08,
            "transcript": "Qang'a-ll' yaaruitengqerkuni, story knife-angqerquni."
        },
        "106": {
            "start": 918.08,
            "end": 920.36,
            "transcript": "Allanun-qaa nasaurlurnun tunluki?"
        },
        "107": {
            "start": 920.36,
            "end": 935.48,
            "transcript": "Ii-i. Tua-i inuguani qaqilluki imkut pikellni cani kakivini tuaten kakivingqerkuni tunluki tamakunun tamaa-i nangercami, nangerrluni."
        },
        "108": {
            "start": 935.48,
            "end": 937.46,
            "transcript": "Inuguanqiggngairulluni?"
        },
        "109": {
            "start": 937.46,
            "end": 942.38,
            "transcript": "Mm. Tua-i-wa allanek pililuni piyuumallilria."
        },
        "110": {
            "start": 942.38,
            "end": 945.22,
            "transcript": "Tuaten-wa tua-i pitullrulriit."
        },
        "111": {
            "start": 945.22,
            "end": 949.7,
            "transcript": "Tuar inuguatulruut. Kiika? Aglellrem kinguani [?]."
        },
        "112": {
            "start": 949.7,
            "end": 968.76,
            "transcript": "Tua-i waten aglenrar tauna nangertaqami pikitarkauluki yuut tamaa-i aruqerkauluten.  Nasaurluut agleqsailngurnun aruqutekluku. cikirciulleq avtengrunaqluni [?]."
        },
        "113": {
            "start": 968.76,
            "end": 971.36,
            "transcript": "Elpeci-qaa cikirciulallruuci?"
        },
        "114": {
            "start": 971.36,
            "end": 977.12,
            "transcript": "Nuu, tengrunaqluni tupagyara'arluta uayaryaraqluteng."
        },
        "115": {
            "start": 977.12,
            "end": 982.32,
            "transcript": "Wangkuta tau͡gken aqumgallruvkenata. Iciw' tua-i."
        },
        "116": {
            "start": 982.32,
            "end": 994.56,
            "transcript": "Aqumganritngellratni, wiinga waniw' 67-aalrianga aqumgallrunrilngukut, aqumganritellratni tamaa-i yuurtellruamta."
        },
        "117": {
            "start": 994.56,
            "end": 998.48,
            "transcript": "Tamaa-i-qaa agayulirtet tekirqengaitaa [?] wall'u-qaa tekirqeksaitaa [?]?"
        },
        "118": {
            "start": 998.48,
            "end": 1001.24,
            "transcript": "Tekirqeksaunateng agayulirtet."
        },
        "119": {
            "start": 1001.24,
            "end": 1004.54,
            "transcript": "[?] Cayaraci pegcararangellrulliniluni."
        },
        "120": {
            "start": 1004.54,
            "end": 1010.58,
            "transcript": "Tua-i-wa, they told us you know, agayulirtet pivkallruit."
        },
        "121": {
            "start": 1010.58,
            "end": 1017.74,
            "transcript": "Agayumaciq man'a teguamegteggu caciryaraq pegtellruat."
        },
        "122": {
            "start": 1017.74,
            "end": 1021.16,
            "transcript": "Yuraryaraq-llu pegcaaqellruluku cali."
        },
        "123": {
            "start": 1021.16,
            "end": 1033.32,
            "transcript": "Uqiquryaraq, aruqsaryaraq tamaa-i, apeqmegnek ukvengameng tua-i peggluki Yup'igtaat cayarait."
        },
        "124": {
            "start": 1033.32,
            "end": 1045.58,
            "transcript": "Peggngaicaaqelliniluteng. Maa-i-llu camek-llu tua-i iquilkan yuraryaraq man'a atungesqeńgatgu cali utermun teguluku."
        },
        "125": {
            "start": 1045.58,
            "end": 1057.8,
            "transcript": "Cunaw' maa-i pegtarkaunritcaaqell', ik'imek kangiilengraata, pegqaqlinikput makut-llu maa-i ayut, tundra tea-at."
        },
        "126": {
            "start": 1057.8,
            "end": 1071.46,
            "transcript": "Yuum tua-i teguyaraqluki, yuungcautekluki, leggluki, yug' una tarvaraqluku-ll' caarrlua waten elucira'arluteng caarrluiruarluku."
        },
        "127": {
            "start": 1071.46,
            "end": 1076.6,
            "transcript": "Leg'arrluki kangrit tarvarluki."
        },
        "128": {
            "start": 1078.52,
            "end": 1087.5,
            "transcript": "Caluteng tuaten? Kumarrluki tuaten qumigluki.  Qumigturluteng-gguq."
        },
        "129": {
            "start": 1087.5,
            "end": 1098.48,
            "transcript": "Tua-i wavet kumarrluki imumek kenengqerkata puyurpakata ekuavkenateng, waten piqerluki, uuggun puyuq anluni."
        },
        "130": {
            "start": 1098.48,
            "end": 1102.6,
            "transcript": "Qimugcinrarmek anamek ilaluki."
        },
        "131": {
            "start": 1102.6,
            "end": 1110.32,
            "transcript": "Qimugcinrarmek anamek ilaluki, tuamtell'-am tua-i yug'e'u͡rluut imkut akngiallakuneng."
        },
        "132": {
            "start": 1110.32,
            "end": 1122.92,
            "transcript": "Ayumian-llu tua-i qimugcinrarmek anamek piluteng anaq ca tauna, natmun akngimun minguulluku."
        },
        "133": {
            "start": 1122.92,
            "end": 1128.84,
            "transcript": "Tua-i qimugtet anait-llu pirpakluki."
        },
        "134": {
            "start": 1128.84,
            "end": 1137.84,
            "transcript": "Tuamtell'-am tua-i yuk kineryukaku imumek nuagicukan ellatuuvkenani pikan."
        },
        "135": {
            "start": 1137.84,
            "end": 1149.96,
            "transcript": "Uugnaraat anayagait quyurrluki passiluki mermun akuyulluku mevkarluki tamaa-i. Aspirin-aarullilria."
        },
        "136": {
            "start": 1149.96,
            "end": 1155.82,
            "transcript": "Tamaa-i tua-i kitugutai."
        },
        "137": {
            "start": 1155.82,
            "end": 1162.76,
            "transcript": "Tua-i yug'e'u͡rluut. Ai? (Yuumauganek.)"
        },
        "138": {
            "start": 1162.76,
            "end": 1165.64,
            "transcript": "Ii-i kineryukata."
        },
        "139": {
            "start": 1165.64,
            "end": 1167.46,
            "transcript": "Yuk-qaa kilirluku?"
        },
        "140": {
            "start": 1167.46,
            "end": 1175.5,
            "transcript": "Nuu, aunrarluni. Qang'a-llu camaken camaggun anllermek."
        },
        "141": {
            "start": 1175.5,
            "end": 1179.3,
            "transcript": "Qengaa qang'a-llu kakegtellranek."
        },
        "142": {
            "start": 1179.3,
            "end": 1182.94,
            "transcript": "Callarciqaci call' mikelnguut."
        },
        "143": {
            "start": 1182.94,
            "end": 1190.88,
            "transcript": "Kineryugaqata-llu. (Ii-i.) Yuk kineryukan augarmek ilaluku meq mevkarluku."
        },
        "144": {
            "start": 1190.88,
            "end": 1193.76,
            "transcript": "Tamaa-i tua-i iinruaqetutellri."
        },
        "145": {
            "start": 1193.76,
            "end": 1197.52,
            "transcript": "Assiilnguunritqapiarallinilriit."
        },
        "146": {
            "start": 1197.52,
            "end": 1200.76,
            "transcript": "Maa-i tang makut pegqaqevkallrit."
        },
        "147": {
            "start": 1200.76,
            "end": 1208.32,
            "transcript": "Tua-i wangkutnek tua-i pegqaqput atawakenrilatki assiilnguukluki."
        },
        "148": {
            "start": 1208.32,
            "end": 1214.14,
            "transcript": "Cunaw' tang anagulluni imna Father Discard-aq [?] pillrullinii."
        },
        "149": {
            "start": 1214.14,
            "end": 1219.76,
            "transcript": "Tua-i maa-i utermun cali tua-i tegussaagtelluki."
        },
        "150": {
            "start": 1219.76,
            "end": 1223.48,
            "transcript": "Tallirpinkut [?] ullallrit pilagtuat [?]."
        },
        "151": {
            "start": 1223.48,
            "end": 1230.76,
            "transcript": "Atam tau͡gaam au͡gkut Caninermiut pikaa cali man'a pegtellerput."
        },
        "152": {
            "start": 1230.76,
            "end": 1242.62,
            "transcript": "Pikluku tua-i yuk-llu aunraquni, nasaurluq aunraquni uksurpak aunrallrukuni, iqvarnaunani kiagpak."
        },
        "153": {
            "start": 1242.62,
            "end": 1256.22,
            "transcript": "Tua-llu-gguq iqvaryukuni naunraq im' naumalria nuyamek qilqerraarluku, nunapigmun maavet qillrulluku petugluku naunraq atauciq petuguarluku."
        },
        "154": {
            "start": 1256.22,
            "end": 1258.76,
            "transcript": "Petuggaarluku nutaan tua-i..."
        }
    },
    "vQLhJ0pxQlk": {
        "1": {
            "start": 0.11,
            "end": 8.05,
            "transcript": "Ii-i. Wiinga James Peter-aaruunga, Yugcetun-llu Ayaprun [?]."
        },
        "2": {
            "start": 8.05,
            "end": 26.17,
            "transcript": "Wangkuta-w' tua-i ak'a yuurtellerni [?] ayuqucirtuutengqellrulriakut ciuliamta ayuqucirtuutaitnek."
        },
        "3": {
            "start": 26.17,
            "end": 39.28,
            "transcript": "Imum-llu wiinga ayuqucirtutullruanga atertayagarmek pilallrata ap'ama atertaullrem nunani imarpigmi."
        },
        "4": {
            "start": 39.28,
            "end": 50.26,
            "transcript": "Tamalkuan tua-i elliin qalarutketullrua [?] ayuqucir' qalarutaqami-w' [?] tua-i."
        },
        "5": {
            "start": 50.26,
            "end": 69.74,
            "transcript": "Unani pissuucetkamnek pingnatulleramni imarpigmi, cali-llu yuilqumi cat maani ayagakuma alertuutekanka cali qanrutekluki nalluvkarpek'naki."
        },
        "6": {
            "start": 69.74,
            "end": 84.34,
            "transcript": "Makut arcaqerluki can'get kiskuma aturciqniluki tamakut kiaqluki aturamnun."
        },
        "7": {
            "start": 84.34,
            "end": 94.24,
            "transcript": "Amllernek ayuqucirtetullruanga imumun waniw' taum atertayagaat unani imarpigmi atertaullermun,"
        },
        "8": {
            "start": 94.24,
            "end": 114.69,
            "transcript": "Cali agna aga-i akilirnerqut, qayarlua at'reskuma, at'reskagugtua agna-llu elatmun piciiruskuma [?], agaavet pisqevkenia akilirnermun Kusquqviim akilirneranun."
        },
        "9": {
            "start": 114.69,
            "end": 124.77,
            "transcript": "Mayurngaitnilua tekitengramku-llu naumaluku qulvanun tuangqetuniluku agna,"
        },
        "10": {
            "start": 124.77,
            "end": 141.91,
            "transcript": "Man'a-gguq tau͡gken maani Kusquqviim-wa man'a neglerlua [?] assinruluni nautua piketvanun [?]."
        },
        "11": {
            "start": 141.91,
            "end": 157.11,
            "transcript": "Marayangqetua piketvanun [?] assinrutuluni, agaani tau͡gaam tua-i ping'e'rma mayurngaitnilua qanrutullruagavkut anagtuusqevkenii."
        },
        "12": {
            "start": 157.11,
            "end": 166.93,
            "transcript": "Tua-i atuqsailramki iliini nalluyaguteksailanka makut ayuqucirtuutek'lallriu ug'um [?] apa'urluma,"
        },
        "13": {
            "start": 166.93,
            "end": 176.52,
            "transcript": "Uum-llu cali aipama apa'urlua cali ayuqucirtetullruama cali cakneq,"
        },
        "14": {
            "start": 176.52,
            "end": 191.72,
            "transcript": "Yuutellerkaa-wa man'a qanrutekluku ayagluta qanruyutaunii ayuqucirtuutaunani-wa tua-i nalluyagulluki yuusqevkenii qanruyutet nalluyagulluki."
        },
        "15": {
            "start": 192.22,
            "end": 205.49,
            "transcript": "Taumek waniwa waniw' qanruskaqatnga taukut tamakunek tua-i qalartelalrianga qanllerkenka [?] ayuqucirtuutekellernek atertayagaam-llu"
        },
        "16": {
            "start": 205.49,
            "end": 215.44,
            "transcript": "Atertayagaq tauna caperqellruat caperrnarqellrulliniut atertausngamini nunani qanemcitaqngamta,"
        },
        "17": {
            "start": 215.44,
            "end": 233.65,
            "transcript": "Iliini-llu erenra-wa tua-i iliini tauna-ll' qanengyuaqluku ayallruniluni unani imarpigmi yugmek tangerqengaunani cataunateng au͡gkut cataitaqluteng,"
        },
        "18": {
            "start": 233.65,
            "end": 252.59,
            "transcript": "Taugaam-gguq waten niitetullruunga, qanelrianek qasgimi qalartellrianek, waten qanelrianek ilait qanrucilallruut, ca-gguq murak mikleng'e'rmi,"
        },
        "19": {
            "start": 252.59,
            "end": 257.58,
            "transcript": "Imarpiim arulataqengraani piungraqami teptua [?]."
        },
        "20": {
            "start": 257.58,
            "end": 273.84,
            "transcript": "Tuaten-gguq call' wangkuta imum' qamqevkenata [?] pikumta, qamqertevkenata pikumta tua-i arulateng amani imarpiimi cikutailengraan-llu arulataqengraakut."
        },
        "21": {
            "start": 273.84,
            "end": 285.18,
            "transcript": "Tepsugngaukut piyugukuni-llu [?] tua-i ceńamun."
        },
        "22": {
            "start": 285.18,
            "end": 302.2,
            "transcript": "Amllermek ayuqucirtutullruyaaqanga taukuk tua-i ayuqucirkamnek wii tau͡gaam cali imna qanruyutek'lallrat cali arcaqerrluku,"
        },
        "23": {
            "start": 302.2,
            "end": 318.61,
            "transcript": "Ankan nunat, elatiitnun elliquma, nunat makut, nunat ukut uitaviim avatiit kiartesqelluku cat tua-i naparraat, wall'u makut imkut,"
        },
        "24": {
            "start": 322.12,
            "end": 333.81,
            "transcript": "Maligcetellriami imkut quagciit angutaitnek, tamakut-gguq tamaa-i call' nallunailkutnguarkaugut wangkutnun yugnun,"
        },
        "25": {
            "start": 333.81,
            "end": 351.13,
            "transcript": "Nunat tunglirnerat, asgulirnerama avanem [?] tunglirnera cikutangqetuniluku mecungellret."
        },
        "26": {
            "start": 351.13,
            "end": 365.21,
            "transcript": "Cali-llu makut caliankaat [?] elivtetuniluki ungalamun tau͡gaam nallunaunateng cikutangqetuluteng,"
        },
        "27": {
            "start": 365.21,
            "end": 376.43,
            "transcript": "Waniwa tua-i piingama amllermek [?] qanerkaitua, au͡gg'un tua-i qanqertua waten pitua [?]."
        }
    },
    "52ouDZAkuvc": {
        "1": {
            "start": 35.07,
            "end": 38.45,
            "transcript": "Tua-i-qaa? (Yaa, ii-i)"
        },
        "2": {
            "start": 38.45,
            "end": 49.94,
            "transcript": "Au͡gna ava-i ciumni qanlleq puyu'urqaqa, aanallgutkaqa, qanemcika tamcekaqalria [?]."
        },
        "3": {
            "start": 49.94,
            "end": 65.37,
            "transcript": "Tua-i-w' wii-urluq-llu wantaungellrungraan [?] cullrunrilngurnun, cailngurnun."
        },
        "4": {
            "start": 65.37,
            "end": 79.84,
            "transcript": "Tua-i-wa uksuar taqngan [?] arnat imkut, arnat imkut cumertaqelriit keluk'agnek."
        },
        "5": {
            "start": 79.84,
            "end": 90.66,
            "transcript": "Qayat-wa ayagnek-llu, canegnek-llu amllerinivkenaki, nulataq-llu qavciingunek amllernek."
        },
        "6": {
            "start": 90.66,
            "end": 109.51,
            "transcript": "Tua-i-llu uksuumainanrani tamakut tamaa-i keluvkarnek piknganka au͡gkut tupigluki, ikaralriciluki. Wagg'uq tua-i qayat ikaraliciluki."
        },
        "7": {
            "start": 109.51,
            "end": 130.58,
            "transcript": "Angutegken arnat imkut mingeqengnaurait ivrucinek imarnitkaitnek qarillugnek ellait-wa call' amani qasgimi qayateng call' ukuskait [?] caskuvkiurluteng."
        },
        "8": {
            "start": 133.82,
            "end": 147.37,
            "transcript": "Arnat-llu tua-i makut tamaa-i taquskuneng, eggluki tamakut caqelteng, arilliut iluqlirirluki call' tupiganek."
        },
        "9": {
            "start": 147.37,
            "end": 167.39,
            "transcript": "Imkunek makut imkut iitallrat, iitallrarnek iluqlilitullruit tupigluki, kaumatngurrluki, tua-i-llu taqkunerteki puliit teggluki, tuavet iluqliliulluki, arilluut."
        },
        "10": {
            "start": 167.39,
            "end": 177.97,
            "transcript": "Makut neqerrluut qeltait. Canek im' pilaqeput iqalluut."
        },
        "11": {
            "start": 177.97,
            "end": 195.17,
            "transcript": "Tua-i-ll' tamakut cali tamaa-i taquarvigkait call' issratnek, canek yaassiillernek, qemagviliggluta taquaviliyuitullruit issratnek tau͡gaam."
        },
        "12": {
            "start": 195.17,
            "end": 221.66,
            "transcript": "Tua-i-ll' puukaat taqkunegteggu piirriluki, iquk takliriluki, tua-i-ll' tauna imiqunegteggu issran muiqan arviqtauluku waten uutaqluku qillrucirluki, tua-i call' taquarkiurluki imarpiqukata."
        },
        "13": {
            "start": 221.66,
            "end": 240.26,
            "transcript": "Ayuqlutek uksurtun tuaten upingaumaanaqluteng. Arnat-llu imkut pilnguniluteng tua-i kumlat' [?] qanivikellrulriit, ata'urluqa-ll' imna-ll' tua-i pingnaquqcaarlallruami."
        },
        "14": {
            "start": 240.26,
            "end": 255.12,
            "transcript": "Tua-i angyiangnariateng call' angyangluteng upagatkameggnek. Tamana-w' ciuqliq angyaq qerraallrat wii angullrunrilkeka."
        },
        "15": {
            "start": 255.12,
            "end": 267.2,
            "transcript": "Tauna tau͡gaam apa'urlulqa qanerluni enria akallaurniluki tamatum angyam nutaranek cimirluki."
        },
        "16": {
            "start": 267.2,
            "end": 283.05,
            "transcript": "Wii tua-i tamakut naparyat atulaitput itqerrluam' [?] aqvaquangaqama cevv'aqkiinga [?] caliyaqniluku. Tauna nakmiin apa'urluqellruyuksaaqaqa."
        },
        "17": {
            "start": 283.05,
            "end": 298.08,
            "transcript": "Atama alqaan uinga una-wa Qanrilaq [?] piaqluki, angayuqaqsug' [?] pillruyaaquq, alarpikluku."
        },
        "18": {
            "start": 298.08,
            "end": 324.16,
            "transcript": "Maurlumun-kiq tauna piaqluku angutiigka taun' ap'agmek [?], cunaw' tua-i iqelvaglua iluraagutma [?] nulriran nakmiin ataucirii angun angutem taum, Maniggarmek piaqluku tauna, atengqerrluni malrugnek Ayagiinaarmek-llu piaqluku."
        },
        "19": {
            "start": 324.16,
            "end": 338.6,
            "transcript": "Tua-i uitakegtayuunii-ll' wiinga tua-i elliin pisquciatnun, uksuyallatnun [?] ayaglua uitauraraqlua utercungaqama ut'rutaqlua."
        },
        "20": {
            "start": 338.6,
            "end": 357.25,
            "transcript": "Tua-i yuut imkut uitaviinka neqnun tau͡gaam tua-i canun canek-llu kanangircuunateng, cakameggnek pikameggnek, snuukuurkameggnek-llu anyuunateng ikamrat tau͡gaam."
        },
        "21": {
            "start": 357.25,
            "end": 374.44,
            "transcript": "Tuamta-ll' call' tua-i tamakut angutet qamigauteken tamakut call' apqiitnek qirlinaurait, asveret imkut tegliurritnek [?] kegglarturluki."
        },
        "22": {
            "start": 374.44,
            "end": 390.95,
            "transcript": "Canek tegglinek piurlaama [?] ikamralugpiak call' tamakut call' tanglallruakeka ilama ikamralugpiarnek. Tamakunek call' pirlaarlutek kaugpiit agluqritnek."
        },
        "23": {
            "start": 390.95,
            "end": 404.1,
            "transcript": "Tua-i tugguulriamek [?] wii tangvallrunritua yugmek, tua-i nangteqluta tamalkumta ciuliaritni maani pillruukut."
        },
        "24": {
            "start": 404.1,
            "end": 416.54,
            "transcript": "Ciuliaqapiarait au͡gkut wii angullrunritanka, au͡gkut-llu tua-i ciuni qanlleq-llu amaqliqu'urluta iliini-ll' nunaliutekluta uita'aqluta."
        },
        "25": {
            "start": 416.54,
            "end": 432.78,
            "transcript": "Tua-i qaillun qupucuunata-ll' kenkuqu'urautmun call' tau͡gaam yuullrulriakut tamaa-i, ilateng tuvqakluki piit qallerkait ellulluku [?] pigem payugtaqluku."
        },
        "26": {
            "start": 433.78,
            "end": 444.15,
            "transcript": "Cailliqenrilengraan pikangaqameng payugqurluki-ll' payugqurluki ilateng tangnarrluki yuunateng-llu."
        },
        "27": {
            "start": 444.15,
            "end": 467.06,
            "transcript": "Taum-llu tua-i acairutma pinauraanga aullu-wa-i ak'a wii-ll' atraun [?] ilagnek pikina atam qukilaqut' tungelqurritniartuten man'a maa-i tekilluku piuqcaaraurlulrianga piani Ayalpigmi."
        },
        "28": {
            "start": 467.06,
            "end": 482.51,
            "transcript": "Tau͡gaam ilanka piani assilartut ullaglua canek qaneqsailngatnun [?], wiinga-ll' ullautengrama canek qanyuunateng wangni ilakegcilua piani Ayalpigmi."
        },
        "29": {
            "start": 483.02,
            "end": 496.15,
            "transcript": "Tuar' ilumun uqesngaurarqelria [?] ilugma tau͡gaam waniw' piuraagnga waniwa-am kingulirnera-ll' ingluan qeluyugngakilriit [?]."
        },
        "30": {
            "start": 496.15,
            "end": 508.54,
            "transcript": "Iliini-llu yuqercarpiarma [?] tua-i waten pitaani man'a qanrut' [?]. Yaa quyana."
        }
    },
    "hncI1F7ADyY": {
        "1": {
            "start": 1.73,
            "end": 9.5,
            "transcript": "Avelngaat mikulallratnek, ciin mikullritnek, cali-llu can'get qanrutekluki cali."
        },
        "2": {
            "start": 11.34,
            "end": 27.74,
            "transcript": "Yaa, tua-i-wa ak'a tamaani yuullret tangerrluku ca imna uksum qaillun ayuqellerkaa qanrutkenguaqalallrukiit."
        },
        "3": {
            "start": 27.74,
            "end": 43.18,
            "transcript": "Tayima uksuarpak uksuarmi-llu cali tua-i-w' yuut piciryarait ella [?] taillerkam ayuqucianek qanqerniartuten."
        },
        "4": {
            "start": 43.7,
            "end": 56.28,
            "transcript": "Atam ap'artaqlua-llu tua-i Olinka-m piaqamia ap'artaqlua pituanga nalluyagutetuunga, nalluyaguskemnek apniarpenga."
        },
        "5": {
            "start": 58.96,
            "end": 75.98,
            "transcript": "Uksuarmi-qaa qaillun uksumi ellakaa wall'u-qaa qanikcangqellerkaa qanrutkelallruat, qaillun-llu nallunrit'lallruat-wa?"
        },
        "6": {
            "start": 78.7,
            "end": 90.6,
            "transcript": "Aataka-gguq qanlallrulria uksuarmi can'get-gguq naugaqata mikurluteng."
        },
        "7": {
            "start": 90.6,
            "end": 102.86,
            "transcript": "Canlirqami nunam maqarqucituat, maqarqucilarraat, tua-i-llu-gguq qanikcaryagpek'nani, qanikcarpagpek'nani."
        },
        "8": {
            "start": 102.86,
            "end": 110.76,
            "transcript": "Tau͡gken-gguq can'gilan, kiagmi can'get naunrilata."
        },
        "9": {
            "start": 110.76,
            "end": 120.84,
            "transcript": "Cali-gguq qanugpagaluni qanikcaq mamturrluku, tua-i-gguq nunam maqarqucirluku."
        },
        "10": {
            "start": 120.84,
            "end": 133.26,
            "transcript": "Tau͡gken cali uugnar atamlleraqata qanraqluteng uksuarrlugteqatarniluku."
        },
        "11": {
            "start": 133.26,
            "end": 151.68,
            "transcript": "Tamakut-gguq uugnaraat elagaqameng ellangllirnarqut anitaarluni-llu-gguq piaqluni uksuarrlugluku nenglaicugluni."
        },
        "12": {
            "start": 151.84,
            "end": 169.78,
            "transcript": "Asvairnaciaryugluni asvairnaciaraqluni. (Ciku?) Ii-i, ciku, angitaarluni piaqami ellarvagaaqluni-llu, nengllirraarluni-llu ellarvaggaaqluni."
        },
        "13": {
            "start": 169.78,
            "end": 187.34,
            "transcript": "Qakma tuar uksuryukaaralria, tamatumek-qaa ak'a tamaani piciatun niiteqaqsaituten uksuryararallranek-llu qaillun-llu taktalallrua tamakut?"
        },
        "14": {
            "start": 187.34,
            "end": 198.3,
            "transcript": "Tamana tang umyuaqesciigalkeka tua-i niitelaryaaqaqa tau͡gaam umyuaqenritaqa."
        },
        "15": {
            "start": 198.3,
            "end": 212.2,
            "transcript": "Umyuaqkemku neq'akekumku-llu qanruteksarqaa, nallukemnek, nallukemnek wiinga niitelqenrilkemnek qanerciigatua tau͡gaam niitelallemnek."
        },
        "16": {
            "start": 212.2,
            "end": 221.54,
            "transcript": "Kiugpak-qaa niiteksaituten qanengssaarnek piciatun ellam ayuqucirkaanek?"
        },
        "17": {
            "start": 221.54,
            "end": 231.84,
            "transcript": "Ii-i, niiteksaitellruunga niiteksaunii-llu-ggem tua-i kanani nerpagmi uitallruama, yugnek-llu tangyuunii."
        },
        "18": {
            "start": 237.86,
            "end": 248.8,
            "transcript": "Allanek atak', qaaritaaq-wa, qaaritaanek-qaa nallunrilkengengqertuten?"
        },
        "19": {
            "start": 248.8,
            "end": 261.56,
            "transcript": "Qaariitaat-wa tamakut tamaani-wa ataki qanengssaaratullruuq, kiimekuuratullramta-llu pavani yuilqumi."
        },
        "20": {
            "start": 261.56,
            "end": 270.12,
            "transcript": "Tau͡gaam qanengssalallruuq tamakut piciryarallritnek."
        },
        "21": {
            "start": 270.12,
            "end": 281.36,
            "transcript": "Maa-i tang tua-i nall'arqurluki makut piciryarangqelalriit maa-i umyuarteqaqama, tamakut-llu qanengssalallri."
        },
        "22": {
            "start": 281.36,
            "end": 288.72,
            "transcript": "Umyuaqaqamki waten-llu pilallruuq tua-i tayim' 72-aami arulairlullruuq."
        },
        "23": {
            "start": 288.72,
            "end": 299.8,
            "transcript": "Qanlallruuq ciin yuut piciryarateng taquciitnek-llu."
        },
        "24": {
            "start": 299.8,
            "end": 306.92,
            "transcript": "Tau͡gken-gguq maa-i makut aipaiput tua-i nall'arqurluki piciryarangqerraqluteng."
        },
        "25": {
            "start": 306.92,
            "end": 314.26,
            "transcript": "Tamakut-llu tamaa-i Qaariitaaryaraq uksuarmi."
        },
        "26": {
            "start": 314.26,
            "end": 322.92,
            "transcript": "Taukut-gguq-am Qaariitaalriit, tamakut-gguq Qaariitaatuut nepliryaaqevkenateng."
        },
        "27": {
            "start": 322.92,
            "end": 333.24,
            "transcript": "Tua-i-gguq inerqurraqluki mingugaqluki-llu-gguq canek tua-i mingugcarluki uiterarrluki ilait qaterrluki."
        },
        "28": {
            "start": 333.24,
            "end": 339.52,
            "transcript": "Tua-i-gguq elatiitni uupuurarraarluteng itraqluteng."
        },
        "29": {
            "start": 339.52,
            "end": 347.48,
            "transcript": "Tua-i akutarrarnek-llu tamakut nerevkaraqluki itellriit mertelluki tuaten."
        },
        "30": {
            "start": 347.48,
            "end": 361.16,
            "transcript": "Tua-i-am taukut Qaariitaalriit taukut neplirluteng-gguq taukut pillret aciirutlinilriit nem'un."
        },
        "31": {
            "start": 361.16,
            "end": 371.96,
            "transcript": "Tua-i-gguq tayima nuna qaillun pisciiganateng neplirluteng cama-i nanikualuteng ayagluteng nunakun neplirluteng niilluki."
        },
        "32": {
            "start": 371.96,
            "end": 386.2,
            "transcript": "Tua-i-gguq qagaaggun naugg'un ingrim qacarnerakun pilliut anluteng anellruut-gguq tua-i taukut qaillun tau͡gaam tamana call' ilii nalluyagutaqa."
        },
        "33": {
            "start": 386.2,
            "end": 394.46,
            "transcript": "Tua-i inerquutam-gguq tua-i Qaariitaqata neplirluki pisqevkenaki iquat."
        },
        "34": {
            "start": 397.48,
            "end": 408.56,
            "transcript": "Imkuni-qaa qasgit-wa caqtaalallritni, caqtaalallritnek nallullilriaten?"
        },
        "35": {
            "start": 408.56,
            "end": 412.96,
            "transcript": "Tua-i nalluunga. Nallukemnek pisciigatua."
        },
        "36": {
            "start": 422.5,
            "end": 428.12,
            "transcript": "Tua-i im' tau͡gaam makut-llu iralut aterluteng. (Iralut.) Ii-i."
        },
        "37": {
            "start": 428.12,
            "end": 441.32,
            "transcript": "Tua-i tamakut-am qanlallrullinilriit imna ava-i January-q pitullrulliniat iralull'ermek."
        },
        "38": {
            "start": 441.32,
            "end": 446.74,
            "transcript": "Kinguq' tamaani nenglairucaratullrani."
        },
        "39": {
            "start": 446.74,
            "end": 457.92,
            "transcript": "Tamaa-i-gguq tamaani kinguqliani February-mi kepnercimi, amiiget-gguq kalvagyarat, tua-i maa-i qanengssalalria atam."
        },
        "40": {
            "start": 457.92,
            "end": 467.82,
            "transcript": "Amiiget-gguq kalvagyarat mengyunga'artaqata kepnetullruit, qaillun-llu tayima kepnilallruitki?"
        },
        "41": {
            "start": 467.82,
            "end": 474.08,
            "transcript": "Tua-i kepnerciutii tauna February-m, tua-i-ll' kinguqlia March-aaq."
        },
        "42": {
            "start": 475.78,
            "end": 490.46,
            "transcript": "Tengmiirviguaq-gguq. Kinguqliq call' imna tengmiirvik, yaqulget April-aaq tengmiirvik, tua-i-w' imna kinguqlia cali."
        },
        "43": {
            "start": 490.46,
            "end": 499.48,
            "transcript": "Tamaa-i tamaani tengaungelaata April-aami tengmiirvik tauna nenglairucaratullrani tamaani."
        },
        "44": {
            "start": 499.48,
            "end": 510.08,
            "transcript": "Tua-i-ll' May-q kayangut anutiit, tua-i-ll' im' June-aq kaugun-gguq."
        },
        "45": {
            "start": 510.08,
            "end": 517.28,
            "transcript": "Imna-w' July-aq ingun. Kinguqlia-wa-gguq amirraiyaaq."
        },
        "46": {
            "start": 517.28,
            "end": 532.98,
            "transcript": "Tamakut-gguq tuntucuaraat ciruneteng tamaani amiituit. Tua-i-gguq amirraiyaaq. Kinguqlia-gguq amirrairvik."
        },
        "47": {
            "start": 532.98,
            "end": 544.6,
            "transcript": "Tua-i-ll' October-aaq tauna tua-i qaariitaarvik."
        },
        "48": {
            "start": 544.6,
            "end": 558.48,
            "transcript": "Kinguqlia-wa October-aaq, November-aaq qerrlurcarturvik. Tauna-wa December-aq cauyarvik."
        },
        "49": {
            "start": 558.48,
            "end": 566.98,
            "transcript": "Tuaten tua-i qanengssatullruuq, umyuaqeksaitelallruyaaqanka."
        },
        "50": {
            "start": 566.98,
            "end": 579.0,
            "transcript": "Niitaqamki kiituani elitanka. Elicuitellruyaaqanka elilluki. Umyuaqetuviluki."
        },
        "51": {
            "start": 580.66,
            "end": 589.48,
            "transcript": "Imkut-mi canek ap'lartatki iciw' north, south, east, west?"
        },
        "52": {
            "start": 589.48,
            "end": 598.6,
            "transcript": "North-aq negeqvaq, west-aq kana', kanavaq."
        },
        "53": {
            "start": 598.6,
            "end": 614.22,
            "transcript": "Northwest-aq keggakneq. Northeast-aq kiugkeneq kanavaq."
        },
        "54": {
            "start": 618.48,
            "end": 626.88,
            "transcript": "Negeqvaq, ungalankuk tang akuliigem im' cauga?"
        },
        "55": {
            "start": 626.88,
            "end": 640.1,
            "transcript": "Caunilaryaaqam tauna nalluyagutaqa tau͡gaam ungalaq. Ukuk tang nalluyagusngagka neq'aryugngaaqagka tau͡gaam cam iliini."
        },
        "56": {
            "start": 655.34,
            "end": 664.06,
            "transcript": "Yaa anuqet, anuqet piaqata tamakunek ungalamek wall'u-qaa, tua-ll'."
        },
        "57": {
            "start": 664.06,
            "end": 675.28,
            "transcript": "Uivaqata ca imna ella piqatarniluku, tua-ll' allakun uivkan ca imna ella ellakaq tainiluku tamakunek."
        },
        "58": {
            "start": 675.28,
            "end": 693.14,
            "transcript": "Ii-i atam, negeqvamek, ungalamek, naken-mi ungalamek."
        },
        "59": {
            "start": 693.14,
            "end": 704.48,
            "transcript": "Aren negeqvamek uksuarmi east-aq anuqellunilaraat."
        },
        "60": {
            "start": 704.48,
            "end": 716.58,
            "transcript": "Tua-llu ellamelliquni ukatmun, ukatmun ungalamek ukatmun tageskani."
        },
        "61": {
            "start": 722.66,
            "end": 732.42,
            "transcript": "Ukatmun tageskani piyugnarquq qaillun ima tanem tageskani atam."
        },
        "62": {
            "start": 732.42,
            "end": 745.54,
            "transcript": "Ellam ellangllengkuni negeqvarluni tamaa-i assiringaituq."
        },
        "63": {
            "start": 745.54,
            "end": 761.16,
            "transcript": "Tau͡gken ungalirluni tageskani tuaggun negeqvamnun assiriluni, assiriarkauluni."
        },
        "64": {
            "start": 761.16,
            "end": 767.74,
            "transcript": "Tau͡gken ukatmun calaratmun uivuskani negeqvamun assiringaunani."
        },
        "65": {
            "start": 770.38,
            "end": 779.24,
            "transcript": "Cali ilii wani neq'akesciigataqa, umyuaqesciigataqa."
        },
        "66": {
            "start": 779.4,
            "end": 793.2,
            "transcript": "Ilait-llu atam tayima pau͡gkut amirlut yuvrirraarluki qanrualartut-am waten cagniniluku cauga tamana?"
        },
        "67": {
            "start": 793.2,
            "end": 806.48,
            "transcript": "Iciw' amirluq wani caaqami qulvaggun pagaaggun nengumalalria, nacetmun wall' ukatmun. Tua-i-gguq anuqek'a, tua-i-gguq anuqengqataquni."
        },
        "68": {
            "start": 806.48,
            "end": 813.48,
            "transcript": "Tau͡gken anuqlinanermini cali cagnikuni kayukelliqatartuq-gguq."
        },
        "69": {
            "start": 813.48,
            "end": 821.3,
            "transcript": "Tuamtell' imumek wani kayukunani amirluq cali quyigluni."
        },
        "70": {
            "start": 821.3,
            "end": 829.48,
            "transcript": "Tua-i imucetun iciw' waten ayuqelalria iliini akaggluggluni, tua-i-gguq akaggluggluni."
        },
        "71": {
            "start": 829.48,
            "end": 833.48,
            "transcript": "Tua-i call' anuqengqataquni."
        },
        "72": {
            "start": 833.48,
            "end": 837.02,
            "transcript": "Naken-qaa tamana anuqa taigarkauluni?"
        },
        "73": {
            "start": 837.02,
            "end": 848.5,
            "transcript": "Tuaten cagnillran aipaagnek, cagnillran tungiinun, akagglugeskuni call' nallunaituq ukatmun piciquq."
        },
        "74": {
            "start": 862.66,
            "end": 869.62,
            "transcript": "Tayima iqvalallemteńi grandma-qa-llu capurciuqallruukut avani yaaqvani un'gani."
        },
        "75": {
            "start": 869.62,
            "end": 877.94,
            "transcript": "Tua-llu capurciurumaluta alla ayagtur' anuqlirluni ulerpagaluni, kiituan neqkairulluta."
        },
        "76": {
            "start": 877.94,
            "end": 888.74,
            "transcript": "Tua-i-ll' atakuani, atakuat iliitni anuq'vagluni qakma ellallirturluni taqeksaunani inartellemteńi."
        },
        "77": {
            "start": 888.74,
            "end": 903.26,
            "transcript": "Ca imna tua-i waten puu piqalria, tua-i-ll' grandma-qa piuq ella keggiqatartuq-gguq. Tamakunek-qaa niiteqaqsaituten?"
        },
        "78": {
            "start": 903.26,
            "end": 911.48,
            "transcript": "Ii-i niiteqaqsaitua tamakunek. Niiteksailkemnek pisciigat'lartua."
        },
        "79": {
            "start": 912.94,
            "end": 917.48,
            "transcript": "Yaa, tua-i-wa allakailnguq allamek tau͡gaam qanqeryukuvet piciatun."
        },
        "80": {
            "start": 917.48,
            "end": 921.4,
            "transcript": "Yaa, allamek-wa qanerkailngua. Yaa okay."
        },
        "81": {
            "start": 921.4,
            "end": 925.48,
            "transcript": "Quyanaqvaa tailuten (Ii-i.) taigarluten."
        }
    },
    "oizXyqk5R1U": {
        "1": {
            "start": 27.36,
            "end": 31.08,
            "transcript": "Waqaa Qaariitaarviim atakuani."
        },
        "2": {
            "start": 31.08,
            "end": 35.4,
            "transcript": "Mikelngullraat-llu tayima Qaariitaarluteng."
        },
        "3": {
            "start": 35.4,
            "end": 38.14,
            "transcript": "Aullu-ggu-ggu-ggu-guu."
        },
        "4": {
            "start": 38.14,
            "end": 55.7,
            "transcript": "Unuamek ataku tangvakatartuci niicugniqatarluci-llu ukunek tegganernek qalamciqatalrianek Qaariitaalallermeggnek-wa ellaita ak'a tamaani."
        },
        "5": {
            "start": 55.7,
            "end": 62.98,
            "transcript": "Ciumek niiciquci uumek Callerkuamek, Jesse Oscar-aamek Mamterillermiumek."
        },
        "6": {
            "start": 62.98,
            "end": 74.2,
            "transcript": "Tua-i-llu una Puallar, Billy Bean-aq [?] Negeqlirmiu qalamciarkauluni."
        },
        "7": {
            "start": 74.2,
            "end": 81.78,
            "transcript": "Cali-llu una Qiavigga'ar Nunivaarmiu, Kay Hendrikson-aaq [?]."
        },
        "8": {
            "start": 81.78,
            "end": 90.12,
            "transcript": "Nangneqliuluku-llu una Al'aq Tununermiu, Carl Flynn-aq."
        },
        "9": {
            "start": 90.12,
            "end": 93.84,
            "transcript": "Qaariitaalallermeggnek ak'a tamaani qalamciqatartut."
        },
        "10": {
            "start": 93.84,
            "end": 98.8,
            "transcript": "Ciumek waniwa Callerkuaq Mamterillermiu."
        },
        "11": {
            "start": 104.3,
            "end": 119.38,
            "transcript": "Wiinga-wa Qaariitaalallrat ak'a tamaani angullrunrilkeka qaillun pilauciata ak'a tamaani ciumteńi."
        },
        "12": {
            "start": 119.38,
            "end": 129.08,
            "transcript": "Tau͡gaam wangkuta tan'gaurluuluta imumi maani Qaariitaalallruukut."
        },
        "13": {
            "start": 129.08,
            "end": 136.62,
            "transcript": "Enenun-wa itertaarluta pilallrulriakut."
        },
        "14": {
            "start": 136.62,
            "end": 144.3,
            "transcript": "Cat-wa tua-i tamalkuita itengnaqluki pilallrulriakut."
        },
        "15": {
            "start": 144.3,
            "end": 152.0,
            "transcript": "Cali-llu kass'arraat imkut maani amllellrunrilnguut Mamterillerni."
        },
        "16": {
            "start": 152.0,
            "end": 169.54,
            "transcript": "Tayima-llu 10-aam avatiintelliut it'lallruaput cikirralaitkut canek-ll' candy-rrarnek-llu cikilaitkut it'lallrukput."
        },
        "17": {
            "start": 169.54,
            "end": 173.58,
            "transcript": "Kass'at imkut maani assillruameng."
        },
        "18": {
            "start": 173.58,
            "end": 182.34,
            "transcript": "Tua-i-wa maa-i cali assilriit ilakluta uitiimta."
        },
        "19": {
            "start": 182.34,
            "end": 195.74,
            "transcript": "Tau͡gaam wangkuta Yugni enenun-llu itraqamta cikilallruitkut piciatun yugtarnek neqnek, neqerrluarnek,akutarrarnek-llu."
        },
        "20": {
            "start": 195.74,
            "end": 211.62,
            "transcript": "Tua-i-llu qantatgun cikiraqatkut anluta tua-i ellami qayagpagasqelaitkut empaaraluta [?], empaaraaqluta [?]."
        },
        "21": {
            "start": 211.62,
            "end": 228.64,
            "transcript": "Kegginaqunek-llu kass'artarnek piilamta kegginaput iliini mingugluki kangiplugmek-llu temcinariluki kegginaput Qaariitaalallrulriakut."
        },
        "22": {
            "start": 228.64,
            "end": 241.16,
            "transcript": "Cali-llu ilait kegginaqiluteng canek kalikallernek-llu kegginaqiluteng temcinariluki pilallrulriit."
        },
        "23": {
            "start": 241.16,
            "end": 257.7,
            "transcript": "Tua-i-llu tegumiaput amlleriaqata qasgimun pisqelaitkut, qasgimun agulluki tamakut wangkuta cikiuteput ner'aqluta qasgimi."
        },
        "24": {
            "start": 257.7,
            "end": 267.62,
            "transcript": "Qasgit-llu imkut iqaiteksailnguut tepsarqelaameng-llu, aruvagnimek-llu tepsarqaqluteng."
        },
        "25": {
            "start": 267.62,
            "end": 273.74,
            "transcript": "Tau͡gaam wangkuta tamaani cangalliurpek'nata pilallruukut."
        },
        "26": {
            "start": 273.74,
            "end": 285.76,
            "transcript": "Camek-llu pelleryugmek umyuarteqeksaunata, aqumaqluta piciatun nat'ermun-llu iqaitenrilengraan qasgim ilua."
        },
        "27": {
            "start": 285.76,
            "end": 296.94,
            "transcript": "tepsarqaqluteng, tau͡gaam wangkuta tamaani angalliurpek'nata pilallruukut, camek-llu pelleryugmek umyuarteqeksaunata, aqumaqluta piciatun at'ermun-llu iqaitenrilengraan qasgim ilua, wangkuta imumi caneksuivenrilameng yuut pork chops-aartaunani, hamburger steak-artaunani-llu,"
        },
        "28": {
            "start": 296.94,
            "end": 302.32,
            "transcript": "Cali-llu makunek cookies-aat enurnaitevkenateng candy-t-llu."
        },
        "29": {
            "start": 302.32,
            "end": 316.2,
            "transcript": "Tau͡gaam piyugngalriit pikarralget tamakuni candy-rrarnek-llu cikiqaqulaqaitkut amllerpek'nateng-llu tua-i, wall'u three or four piece of candy."
        },
        "30": {
            "start": 316.2,
            "end": 320.42,
            "transcript": "Wangkutni tua-i carugaugaqluteng."
        },
        "31": {
            "start": 320.42,
            "end": 331.22,
            "transcript": "Imumi aanama qanemcit'lallruitkut ak'a tamaani Qaariitaalallernek."
        },
        "32": {
            "start": 331.22,
            "end": 341.12,
            "transcript": "Yugyallratni yuut nunat, yuut nunait Qaariitaarqata alingnarqelallruniluki."
        },
        "33": {
            "start": 341.12,
            "end": 357.08,
            "transcript": "Tua-i-wa superstition-aarameng tamaani ca tamalkuan piciukluku ukvekluku pilallruameng tamakut."
        },
        "34": {
            "start": 357.08,
            "end": 366.4,
            "transcript": "Tua-i-wa cali-gguq ugna Cikiyakinraq qanemcik'lallrua,"
        },
        "35": {
            "start": 366.4,
            "end": 374.06,
            "transcript": "Qaariitaalriit-gguq enemek an'aqameng marurpalallruut."
        },
        "36": {
            "start": 374.06,
            "end": 385.26,
            "transcript": "Tua-i-llu-gguq uitaqerluteng cakmaken Cikiyakinram tungiinek akiluki marurpagluteng keglunret,"
        },
        "37": {
            "start": 385.26,
            "end": 394.74,
            "transcript": "ugna qanemcik'lallruat ca tamalkuitua ukveklermeggni Cikiyakinraq ircenrrauniluku."
        },
        "38": {
            "start": 394.74,
            "end": 400.2,
            "transcript": "Tua-i-gguq tuaten akilarait iliini."
        },
        "39": {
            "start": 400.2,
            "end": 403.88,
            "transcript": "Iliini-wa pirrlainarpek'nateng."
        },
        "40": {
            "start": 403.88,
            "end": 421.46,
            "transcript": "Makunek qanemcilallruut cali imkut yuut, yuullret-wa tua-i nangelriit tayima wiinga pitatenka-llu amlleret catairutellriit,"
        },
        "41": {
            "start": 421.46,
            "end": 432.26,
            "transcript": "nakukutlerput amllellrunrituq, tau͡gaam ilakuyulluta kenkuyulluta-llu yuullemteńi ayagyuarluta."
        },
        "42": {
            "start": 432.26,
            "end": 440.08,
            "transcript": "Ilaput cingumaluki cali-llu nangyucuunata atunem."
        },
        "43": {
            "start": 440.08,
            "end": 450.24,
            "transcript": "Tua-i-wa camek-llu picurlagmek maa-i atutukiitnek pitailami tamatum nalliini."
        },
        "44": {
            "start": 450.24,
            "end": 456.16,
            "transcript": "Man'a tua-i Qaariitaaq wiinga atulararput."
        },
        "45": {
            "start": 456.16,
            "end": 470.48,
            "transcript": "Kanani-llu old Moravian mission uitalallemni kegginaqurqamta ilaut'lallruunga kegginaqurlua taqnerurtengramta wangkuta anglanilaamta,"
        },
        "46": {
            "start": 470.48,
            "end": 483.78,
            "transcript": "temcinarqellrianek nutaan aturluta kegginaqunek-llu makunek kass'artarnek aturluta temcinarqellrianek ilaput elitaqengnaqaqluki,"
        },
        "47": {
            "start": 483.78,
            "end": 488.14,
            "transcript": "ilait tua-i cayaqlirluki elitaqaqluki."
        },
        "48": {
            "start": 488.14,
            "end": 495.5,
            "transcript": "Tua-i makunek wiinga amllermek qanerkailama waten pitalua taqua."
        },
        "49": {
            "start": 495.5,
            "end": 502.4,
            "transcript": "Qaariitaatuut waten atakumi cali ilama [?] angutet qasgimi."
        },
        "50": {
            "start": 502.4,
            "end": 515.46,
            "transcript": "Tua-i-llu Qaariitaaryungaqata, Qaariitaaryungaqameng ellimerrnaurait ukut tan'gurraat."
        },
        "51": {
            "start": 515.46,
            "end": 524.88,
            "transcript": "Usvingllemni-wa tuani pituut tuaten naliak allani nunani, qayuw' allakarmek pilaryaaqaat."
        },
        "52": {
            "start": 525.36,
            "end": 538.1,
            "transcript": "Maqiqata'arqameng atakuarmi qanrutnaurait maruaresqelluki."
        },
        "53": {
            "start": 538.1,
            "end": 553.88,
            "transcript": "Tua-i-llu qavcin imkut tan'gurraat tamaani uitalriit maruaraluteng qasgim elaturraa marurpaanaurtut."
        },
        "54": {
            "start": 553.88,
            "end": 558.64,
            "transcript": "Marurparraarluteng qanernaurtut,"
        },
        "55": {
            "start": 558.64,
            "end": 564.42,
            "transcript": "\"Qaariiciiskicikut ata kumlanernek!\""
        },
        "56": {
            "start": 564.42,
            "end": 567.06,
            "transcript": "Cetamarqunek pinaurtut."
        },
        "57": {
            "start": 567.06,
            "end": 570.04,
            "transcript": "Iliini-ll' pinaurtut,"
        },
        "58": {
            "start": 570.04,
            "end": 581.4,
            "transcript": "\"Mau-wuu, mau-wuu, Qaariiciiskicikut ata atsanek!\""
        },
        "59": {
            "start": 581.4,
            "end": 584.28,
            "transcript": "Tuam pilrilmiameng [?] pinaurtut,"
        },
        "60": {
            "start": 584.28,
            "end": 594.52,
            "transcript": "\"Mau-wuu, mau-wuu, Qaariiciiskicikut ata akutamek!\""
        },
        "61": {
            "start": 594.52,
            "end": 598.36,
            "transcript": "Tua-i tuaten cetamarqunek pinaurtut."
        },
        "62": {
            "start": 598.36,
            "end": 615.34,
            "transcript": "Tua-ll' atakuan ukut wani calilnguqercameng tamaani 11-klaallrani-llu pilallilriit, 10-klaallrani imumi, ayagnariniluku qanernaurtut."
        },
        "63": {
            "start": 615.34,
            "end": 626.04,
            "transcript": "Tua-i tau͡gken tan'gurraat upluteng ayagluteng qalriagurluteng pinaurtut."
        },
        "64": {
            "start": 626.04,
            "end": 631.88,
            "transcript": "\"Ii, ii, ii\", iiraluteng."
        },
        "65": {
            "start": 631.88,
            "end": 641.8,
            "transcript": "Tua-i qukliitnek nunat yaaqlikalaung [?] ayagluteng uterrluteng itqaqluteng tamaaten."
        },
        "66": {
            "start": 641.8,
            "end": 657.02,
            "transcript": "Itrata tau͡gken tua-i piciatun cikirluki qang'a-llu aqumluki nerevkarluki canek assirturalrianek canek kumlanrrarnek tuaten nerevkarluki."
        },
        "67": {
            "start": 657.02,
            "end": 665.04,
            "transcript": "Ilait-ll' miilluki mermek kumlamek mertanrrarmek."
        },
        "68": {
            "start": 665.04,
            "end": 671.86,
            "transcript": "Qantanek cikirluki, qantamek cikirluki imarluni canek."
        },
        "69": {
            "start": 671.86,
            "end": 676.44,
            "transcript": "Kumlanernek akutamek-ll' piaqluteng."
        },
        "70": {
            "start": 676.44,
            "end": 684.82,
            "transcript": "Kiagtaat-llu nasqurrutnek egaanek kinertanek, nasqurrlugnek pilarait tamakut, tamakunek."
        },
        "71": {
            "start": 684.82,
            "end": 702.34,
            "transcript": "Piginanek-llu, kiagtaat pilianek-wa, kiagtaat piginaitnek qemaggluki slice-arluki tau͡gken cikiutekluki piginanek piaqluki."
        },
        "72": {
            "start": 702.34,
            "end": 706.12,
            "transcript": "Assiq'apiggluteng cakneq."
        },
        "73": {
            "start": 706.12,
            "end": 710.6,
            "transcript": "Tua-i tau͡gaam qasgilluki tamakut cikiuteteng."
        },
        "74": {
            "start": 710.6,
            "end": 719.92,
            "transcript": "Qasgim tau͡gken itrucateki nutaan tamakunun aruqutekluki qasgim iluani uitalria."
        },
        "75": {
            "start": 719.92,
            "end": 725.18,
            "transcript": "Neral'uteng kumlaneq piyullermeggnek nerluteng [?]."
        },
        "76": {
            "start": 725.2,
            "end": 742.52,
            "transcript": "Tamaatum nalliini, tamaatumi Qaariitaami aturkameggnek makunek qantarkameggnek uksuarpak calimaaqut Qaariitaami taumi aturkameggnek."
        },
        "77": {
            "start": 742.52,
            "end": 749.16,
            "transcript": "Cali-llu ivarutkameggnek cali elissarturluteng."
        },
        "78": {
            "start": 749.16,
            "end": 769.86,
            "transcript": "Tau͡ga-i-llu Qaariitaallerkaq tauna tekiskan carkairucaqameng pillerkar' tauna tekiskan angukaraat iliita qanruciiqai,"
        },
        "79": {
            "start": 769.86,
            "end": 780.66,
            "transcript": "umyugait ataucirrluku ata pisqelluku mat'umi tau͡ga-i tamaani atullermeggni."
        },
        "80": {
            "start": 780.66,
            "end": 795.16,
            "transcript": "Tau͡ga-llu tamakut taqkunegteki qantat akirtat-llu nutarat nutaan unuakut illiitni anciqut."
        },
        "81": {
            "start": 795.16,
            "end": 805.96,
            "transcript": "Anluteng [?] wani qerarluteng [?] ellami nutaan itrutnaurait tamakut taqleteng qantat akirtat-llu."
        },
        "82": {
            "start": 805.96,
            "end": 817.5,
            "transcript": "Itrulluki imumek kavirutmek urciluteng au͡g'umek-llu tungulriamek."
        },
        "83": {
            "start": 817.5,
            "end": 832.9,
            "transcript": "Tamakut qaralirnaurait mingugluki-llu qantat tamakut akirtat-llu, qaltauraat-llu, emrutet-llu tan'gurraat emrutait taqleteng."
        },
        "84": {
            "start": 832.9,
            "end": 841.26,
            "transcript": "Ernerpak nutaan alngarnaurait qaralirnaurait alungitgun, terr'itgun, iluitgun [?]."
        },
        "85": {
            "start": 841.26,
            "end": 851.46,
            "transcript": "Aturaluteng ivarutkameggnek tamakut taqkunegteki ivarutkameggnek."
        },
        "86": {
            "start": 851.46,
            "end": 857.74,
            "transcript": "Tau͡ga-i-llu taqngamegteki nutaan maqililuteng."
        },
        "87": {
            "start": 857.74,
            "end": 873.22,
            "transcript": "Maqirraarluteng tamakut qaraliteng nepcelluki ata qameskuneng nutaan agutnaurait."
        },
        "88": {
            "start": 873.22,
            "end": 877.48,
            "transcript": "Agutevkarnaurait tamakut qantat akirtat-llu."
        },
        "89": {
            "start": 877.48,
            "end": 889.76,
            "transcript": "Tau͡ga-i nutaan camek pikameggnek iqukliuskuneng Qaariitaalriarkak up'eciliqug [?]."
        },
        "90": {
            "start": 889.76,
            "end": 909.02,
            "transcript": "Qasgim qukaani kanani, aqumlutek upeciquk imarniterluteg' canegneg'-llu mauggun nemerluteg', qerrullirluteg', ivrucirluteg'-llu."
        },
        "91": {
            "start": 909.02,
            "end": 919.88,
            "transcript": "Tau͡ga-llu taqkuneg' nutaan anciqiaqunek kukumyarrar uteg' [?] tau͡ga-i an'urtug'."
        },
        "92": {
            "start": 919.88,
            "end": 931.38,
            "transcript": "Anutigni nutaan cauyarkaurnauraat. Cauyat pingayuuyukuneng pingayuuciqut qang'a-llu malruuyukunek malruuluteg'."
        },
        "93": {
            "start": 931.38,
            "end": 938.42,
            "transcript": "Unugpak atuamanaurtut kinguagni."
        },
        "94": {
            "start": 938.42,
            "end": 951.24,
            "transcript": "Atuanginanratni tau͡ga-llu tapiarrluni [?] qantar' kan'a qasgim iituan [?] kayimqerciquq akutamek imarluni."
        },
        "95": {
            "start": 951.24,
            "end": 961.0,
            "transcript": "Tau͡ga-llu tamakut aturpalriit qalarirrarluteng taq'errluteng."
        },
        "96": {
            "start": 961.0,
            "end": 975.72,
            "transcript": "Taq'ertellratni nutaan taq'errluteng uitaqallratni Qaariitaar' kan'a imna anller' akirtamek tegumirluni uyangciiquq,"
        },
        "97": {
            "start": 975.72,
            "end": 986.72,
            "transcript": "qantanek akirtar' tauna imirluku akutanek imalegnek ayuqenrilngurnek neqnek-llu."
        },
        "98": {
            "start": 986.72,
            "end": 1000.88,
            "transcript": "Nutaan kasmurnaurakek unavet, qasgimillua ak'akika un'a, qasgimillua akirtar' yagiluku."
        },
        "99": {
            "start": 1000.88,
            "end": 1016.26,
            "transcript": "Nutaan tamakut nangkunegneki enugkunek matarqerrarlutek qantar' tegukunegnegu qanerciquq imna"
        },
        "100": {
            "start": 1016.26,
            "end": 1029.06,
            "transcript": "aperluku taum qantamcua [?] aterpaggluku uum nulirranun uumeg' cikirniluni."
        },
        "101": {
            "start": 1029.06,
            "end": 1040.24,
            "transcript": "Nutaan tau͡gaten aterpagqurluki tamakut unangkengatek apertuaqerrarluki apertuaqernaurakek nangellritnun."
        },
        "102": {
            "start": 1040.24,
            "end": 1050.94,
            "transcript": "Tau͡ga-i-llu nangkata nutaan, tuamta-llu imkut tan'gurraat arnat imkut tan'gurraat kiiyavkarluki."
        },
        "103": {
            "start": 1050.94,
            "end": 1060.54,
            "transcript": "Nutaan tamakunek aruqnaurait neqnek tamakut akutat ilaitneg'."
        },
        "104": {
            "start": 1060.54,
            "end": 1079.26,
            "transcript": "Aruqrarluki tayima tamakut aruquteng nangkata, nutaan imkut anluteng tayima tan'gurraat tamakunek aruqucillret."
        },
        "105": {
            "start": 1079.26,
            "end": 1085.7,
            "transcript": "Akutat nutaan tamakut akirtat imait angukartenun aruquteknaurait."
        },
        "106": {
            "start": 1085.7,
            "end": 1092.02,
            "transcript": "Aruqutekluki akutaq amlleq amellriluku."
        },
        "107": {
            "start": 1092.02,
            "end": 1101.82,
            "transcript": "Taqkuneng nutaan tamakut taqkunegteki anuqerrarluki, tuamta-ll'-am yuurqernaurtut nutaan."
        },
        "108": {
            "start": 1101.82,
            "end": 1119.78,
            "transcript": "Yuurqerluteng pirraarluteng taqkuneng tau͡alutnek [?] akutairnek-am tuamta-llu neqnaranek nulirrita payugnaurit qasgimun, qasgimi-llu nerluteng."
        },
        "109": {
            "start": 1119.78,
            "end": 1127.96,
            "transcript": "Qasgimi ceńirtungameng, nani nervigni neryuilameng, au͡gkut tangellrenka."
        },
        "110": {
            "start": 1127.96,
            "end": 1134.74,
            "transcript": "Qaariitaaryarar' tamaa-i tamana tau͡gaten ayuquq kanani kingunemni."
        },
        "111": {
            "start": 1134.74,
            "end": 1143.54,
            "transcript": "Ava-i ayuquciatun tangertaallemtun qanemcikqaqaqa, tau͡ga-i qanemcikairutua."
        },
        "112": {
            "start": 1146.72,
            "end": 1157.72,
            "transcript": "Tua-i avani tan'gurraullemni wii ak'a avani kass'at, kass'anek-llu tangyuunii mikelngullemni."
        },
        "113": {
            "start": 1157.72,
            "end": 1167.14,
            "transcript": "Waten Qaariitaarnariaqan uksuarmi qasgimek anevkalaraitkut upqaarluta ciumek."
        },
        "114": {
            "start": 1167.14,
            "end": 1172.46,
            "transcript": "Upciiqaakut kegginaput kangiplugmek mingugluki."
        },
        "115": {
            "start": 1172.46,
            "end": 1183.4,
            "transcript": "Qaralirrluki talluryukapiaraqamta-llu pisqum', piaqaitkut."
        },
        "116": {
            "start": 1183.4,
            "end": 1187.24,
            "transcript": "Maligtaquuraulluta pilallruukut."
        },
        "117": {
            "start": 1187.24,
            "end": 1201.94,
            "transcript": "Tua-llu cali nutaan cali tuaten kangiplugqaarluta muraganek pilianek qengaput patuluki uskurirluki igcugnairluki."
        },
        "118": {
            "start": 1201.94,
            "end": 1211.16,
            "transcript": "Tuamta-llu tua-i anulluta wiinga-wa kiima pisciigalama atama malikelaqiinga."
        },
        "119": {
            "start": 1211.16,
            "end": 1214.68,
            "transcript": "Qantaq-wa tegumiaqaa."
        },
        "120": {
            "start": 1214.68,
            "end": 1223.1,
            "transcript": "Qantamek muragmek tegumiartellua enemun itquma."
        },
        "121": {
            "start": 1223.1,
            "end": 1230.94,
            "transcript": "Itresqekanga iteryuumiileng'erma talluryukapigteng'erma itquma."
        },
        "122": {
            "start": 1230.94,
            "end": 1243.9,
            "transcript": "Iterciqua arnaq una ciuqerrani-wa qantaq neqnek imarluni neqkegtaarnek piciatun,"
        },
        "123": {
            "start": 1243.9,
            "end": 1251.78,
            "transcript": "akutanek tuaten, kinernernek tuaten, kumlanermek tau͡gaam ilangqessuitut."
        },
        "124": {
            "start": 1251.78,
            "end": 1265.1,
            "transcript": "Tua-llu itrutemni imkunek, wangkuta tarvanek pituaput maani nunapiim qaingani naumatulinek,"
        },
        "125": {
            "start": 1265.1,
            "end": 1274.18,
            "transcript": "maani ilaita aterpagtelarait ayunek,"
        },
        "126": {
            "start": 1274.18,
            "end": 1291.66,
            "transcript": "tamakut kenurramun, kenurramun uqumek uqulegmun kenranek aku'urpiit [?] kumarrluki ekuavkenateng-llu puyugngarrluteng lek'arluki ekuavkenateng tau͡gken."
        },
        "127": {
            "start": 1291.66,
            "end": 1304.48,
            "transcript": "Nutaan-am qaimteńun kauksuaralluki atrarrluki tepkeggniriqerrluni man'a cakneq."
        },
        "128": {
            "start": 1304.48,
            "end": 1309.42,
            "transcript": "Talluryulleq tua-i ilalqerluku."
        },
        "129": {
            "start": 1309.42,
            "end": 1327.0,
            "transcript": "Tamakut-llu tangertenka ngel'arluteng tuani pugutemni temciklua kegginaqa ikiungan qengarpallraqa-wa man'a muragaq piliaq."
        },
        "130": {
            "start": 1327.0,
            "end": 1341.18,
            "transcript": "Tuatnaurluta tua-i neqellgutkevkenateng ayuqevkenateng qantat imait itraqama."
        },
        "131": {
            "start": 1341.18,
            "end": 1350.64,
            "transcript": "Ngel'arraarluteng tuaten tarvanek qaika leg'arrluki qaika, qaimnun piqertuaksuaralluki [?],"
        },
        "132": {
            "start": 1350.64,
            "end": 1358.22,
            "transcript": "pirraarluki nutaan qantaqa neqkuinrermek carraquinermek imiqerluku."
        },
        "133": {
            "start": 1358.22,
            "end": 1369.46,
            "transcript": "Umyuamkun tua-i kiiki ilasqumayaaqnauqa tau͡gken tua-i elarang'erma carraquinermek imiqerluku."
        },
        "134": {
            "start": 1369.46,
            "end": 1378.28,
            "transcript": "Neryugnaunaku nunat imkut enet iterturciqanka."
        },
        "135": {
            "start": 1378.28,
            "end": 1386.94,
            "transcript": "Nutaan iterpaalugturluki ceńirtaaneq nalluamku."
        },
        "136": {
            "start": 1386.94,
            "end": 1394.46,
            "transcript": "Iterpaalugturluki talluryukapiaralua cakneq."
        },
        "137": {
            "start": 1394.46,
            "end": 1400.78,
            "transcript": "Itraqama tua-i qerrucugnaitelaraanga talluryuum ugaani."
        },
        "138": {
            "start": 1400.78,
            "end": 1410.52,
            "transcript": "Kiituani tang iquklipailgata tamakut enet qantaqa un' uqamairinguq."
        },
        "139": {
            "start": 1410.52,
            "end": 1421.82,
            "transcript": "Tua-i-ll' iquklilluteng iliini pakmaarangaqluni qantaqa una imaiterraarluni carraquinraugurluki [?]."
        },
        "140": {
            "start": 1421.82,
            "end": 1427.66,
            "transcript": "Nutaan tua-i utrulluki qasgimun."
        },
        "141": {
            "start": 1427.66,
            "end": 1434.62,
            "transcript": "Arenqianii tua-i quyakacagarlua piaqelrianga tuaten Qaariitaam nalliini."
        },
        "142": {
            "start": 1434.62,
            "end": 1440.5,
            "transcript": "Tamaa-i tamamta tan'gurrarni, tan'gurrarrlainarni,"
        },
        "143": {
            "start": 1440.5,
            "end": 1444.3,
            "transcript": "arnat tau͡gaam nallularanka tangvayuilamki,"
        },
        "144": {
            "start": 1444.3,
            "end": 1457.88,
            "transcript": "wangkuta tau͡gaam tan'gurrarrlainarni tangvallerput una ayuqeqapiarpegnani, kegginamta tangvallra."
        },
        "145": {
            "start": 1457.88,
            "end": 1472.88,
            "transcript": "Cali imkunek aturanek ik'inek ik'inqurrarnek yuarulluta pilallikaitkut at'evkarluta temcinariluta pinauraitkut."
        },
        "146": {
            "start": 1472.88,
            "end": 1478.27,
            "transcript": "Tua-i tau͡gaam Qaariitaaq pellugaqan wii quyatuunga cakneq."
        },
        "147": {
            "start": 1478.27,
            "end": 1486.86,
            "transcript": "Tamana talluryullagalqa yugnek tangertemnek pitekluku talluryullalallruunga cakneq."
        },
        "148": {
            "start": 1486.86,
            "end": 1498.14,
            "transcript": "Waten tua-i pitaluku qanrutkeqerlaku qanrutkaqa una Qaariitaallerput unani."
        },
        "149": {
            "start": 1498.14,
            "end": 1505.08,
            "transcript": "Ak'a-w' avani nunani ukuni atengqerrluteng Nerevkartulirmiuni [?]."
        },
        "150": {
            "start": 1505.08,
            "end": 1509.66,
            "transcript": "Tau͡gaam yuirutut maa-i nallemteńi."
        },
        "151": {
            "start": 1509.66,
            "end": 1519.86,
            "transcript": "Tua-llu waniwa tauna taqeqerluku au͡gna cali aipiqaqernauqa [?] uumek."
        },
        "152": {
            "start": 1519.86,
            "end": 1538.3,
            "transcript": "Inerqulallrukaitkut pulengtaq amllerqunek angutet tan'germi atakumi angayuqaamta nalluatni anesqevkenata."
        },
        "153": {
            "start": 1538.3,
            "end": 1548.68,
            "transcript": "Umyuarput aturluku ellamun ellami aquisqevkenata tan'germi unugssuutailngurmi."
        },
        "154": {
            "start": 1548.68,
            "end": 1556.28,
            "transcript": "Atakuq una iliini erucim iliini nunanirquq cakneq."
        },
        "155": {
            "start": 1556.28,
            "end": 1568.9,
            "transcript": "Nunanirqelartuq tamatum nalliini, nunaniqsaaqelartuq tau͡gaam nunanirqengraan wangkuta mikelngurni atuyuitellruarput."
        },
        "156": {
            "start": 1568.9,
            "end": 1578.12,
            "transcript": "Tamana alingcirtuuteput ukvekluku akurtuumatuamteggu tamatum nalliini."
        },
        "157": {
            "start": 1578.12,
            "end": 1582.24,
            "transcript": "Wagg'uq inerquutiita kangia,"
        },
        "158": {
            "start": 1582.24,
            "end": 1598.72,
            "transcript": "atam-gguq tan'germi nunaniryugpakarluta qagaani atakumi tan'germi nunaniryugpakarluta aquivakarluta,"
        },
        "159": {
            "start": 1598.72,
            "end": 1609.16,
            "transcript": "atam-gguq alingnarqelriim ullagturainarniaraakut nallumteńi tangvagpakarluta aglumayagulluta."
        },
        "160": {
            "start": 1609.16,
            "end": 1624.82,
            "transcript": "Aglumayaguskunikut-gguq atam nutaan itervigkamteńun wall'u-qaa enemteńun itqumta puukarniartukut."
        },
        "161": {
            "start": 1624.82,
            "end": 1633.12,
            "transcript": "Puukaqumta piciqerput-gguq yug' una pektaunani carayak."
        },
        "162": {
            "start": 1633.12,
            "end": 1652.76,
            "transcript": "Tuamta-llu cukarikanirluta allamun enemun nallunrilkemteńun alingellerput pitekluku itqumta cali uaqvaqanirluni uitaarkauluni tauna carayak."
        },
        "163": {
            "start": 1652.76,
            "end": 1662.74,
            "transcript": "Qaillun mengliikuni iterviitqapiarluni menglairviinani pektenrilngermi amiigmi tua-i keviutaqluni."
        },
        "164": {
            "start": 1662.74,
            "end": 1671.48,
            "transcript": "Uuggun piqatar', itengnaqeqataryaaqaqan qengmiutaqluku."
        },
        "165": {
            "start": 1671.48,
            "end": 1675.32,
            "transcript": "Qaillun iterciiganani."
        },
        "166": {
            "start": 1675.32,
            "end": 1684.5,
            "transcript": "Nunat imkut qaqiciiqai aqvaqualuni pikuni cukanrarluni uaqsigillra."
        },
        "167": {
            "start": 1684.5,
            "end": 1701.08,
            "transcript": "Amiigmun itquni, amiigmun, amiigmek ankuni elaturramun elliquni uatmun caumangarkaulliniluni tauna."
        },
        "168": {
            "start": 1701.08,
            "end": 1706.8,
            "transcript": "Aqvaqualuni enemun yaavet agqetaqluni."
        },
        "169": {
            "start": 1706.8,
            "end": 1716.52,
            "transcript": "Itqerciiquq elaturramun uatmun caumaluni carayak."
        },
        "170": {
            "start": 1716.52,
            "end": 1722.32,
            "transcript": "Alingnarqelria qaillun iterviitqapiarluni."
        },
        "171": {
            "start": 1722.32,
            "end": 1725.66,
            "transcript": "Wagg'uq tua-i amiigirluku."
        },
        "172": {
            "start": 1725.66,
            "end": 1742.66,
            "transcript": "Tua-i-ll' pivakarluni, pivakarluni tauna ca im' taum teguyukuniu teguluku."
        },
        "173": {
            "start": 1742.66,
            "end": 1746.58,
            "transcript": "Tua-i paqrunani tayima tamarluni."
        },
        "174": {
            "start": 1746.58,
            "end": 1750.84,
            "transcript": "Yuarayaaqluku-llu nalkevkenaku tayima."
        },
        "175": {
            "start": 1750.84,
            "end": 1760.54,
            "transcript": "Tua-i maa-i inerquutekluku, \"Usuuq, tan'germi aquiyaqunak, ellamun anyaqunak\", mikelnguq piciquq."
        },
        "176": {
            "start": 1760.54,
            "end": 1772.84,
            "transcript": "Piciqaat angayuqaagken, \"Usuuq, ellamun anyaqunak. Carayiim piciqaaten. Amiigirciqaaten.\""
        },
        "177": {
            "start": 1772.84,
            "end": 1788.22,
            "transcript": "Wangkuta-am ukvekluku tauna kangirqutvut, au͡g'uuguq ava-i, ukvekluki ellami aquiyugpangramta aquiyuunata waten atakumi tan'germi."
        },
        "178": {
            "start": 1788.22,
            "end": 1796.83,
            "transcript": "Unugssuukara'arqan tau͡gaam tan'gercetaqan, tanqigcetaqan ella aquicuaqalallruunga wii."
        },
        "179": {
            "start": 1796.83,
            "end": 1806.7,
            "transcript": "Aquicuaqalallruukut ak'anun pivkenata iterluta tan'gerissiy', unugssuutairupailgan."
        },
        "180": {
            "start": 1806.7,
            "end": 1815.46,
            "transcript": "Ak'anissiyaagpek'nata utertaqluta enemteńun, enenun allanun ityuilnguungamta avani ak'a."
        }
    },
    "E6HFnxvL3rw": {
        "1": {
            "start": 47.46,
            "end": 57.02,
            "transcript": "Tamaani ak'a murilkeqarraallemni waten kevgiurluteng tau͡gaam pitullruut."
        },
        "2": {
            "start": 57.02,
            "end": 71.74,
            "transcript": "Waten allanun-wa nunanun malruk yuk ayagcet'larait tau͡gaam qaneryaramek taquillukek."
        },
        "3": {
            "start": 71.74,
            "end": 83.54,
            "transcript": "Makut-am ciunrit kaigavikluki carrarnek tua-i piyugtacimegcetun."
        },
        "4": {
            "start": 83.54,
            "end": 90.74,
            "transcript": "Tau͡gaam qasgiq ciukluku qasgim aturyullri makut ciumek aperturluki."
        },
        "5": {
            "start": 90.74,
            "end": 101.98,
            "transcript": "Egalra ciumek imkut alkua-llu, alkui qaltaa-llu ikircuqurra-llu."
        },
        "6": {
            "start": 101.98,
            "end": 119.5,
            "transcript": "Tua-i tamakunek kaigaluteng pirraarluteng, nutaan yuut makut irniaritnun piluteng irniaq aperluku tauna taumek cikiusqelluteng tua-i piaqluteng."
        },
        "7": {
            "start": 119.5,
            "end": 127.72,
            "transcript": "Tau͡gken tua-i nutaan pirraarluki tuaten kaigavikerraarluki, tua-i-am-gguq kingullugluki."
        },
        "8": {
            "start": 127.72,
            "end": 137.88,
            "transcript": "Iluriurulluki, nutaan arivvluki, ilait temcinaqluteng pilartut."
        },
        "9": {
            "start": 137.88,
            "end": 149.82,
            "transcript": "Tua-i-w' cakneq ilurateng tamakut piluki, tua-i-w' kingullugluki-gguq tuaten piluki."
        },
        "10": {
            "start": 149.82,
            "end": 161.26,
            "transcript": "Nutaan tuaten piluteng, pinariateng nutaan, ataam yuk atauciq ayagcelluku yuk."
        },
        "11": {
            "start": 161.26,
            "end": 171.38,
            "transcript": "Taukunun imkunun kevgillermeggni aqvaluki taukut imkut yuut."
        },
        "12": {
            "start": 171.38,
            "end": 181.32,
            "transcript": "Nutaan tua-i tekicata, agiircata cali paiqaqluki tekipailgata."
        },
        "13": {
            "start": 181.32,
            "end": 192.8,
            "transcript": "Ukuk ciumek ayallruuk utertaqagnek, allam malruulutek cali cimiqaqlukek, cat tuaten piluki tekicarturcetaqluki."
        },
        "14": {
            "start": 192.8,
            "end": 206.68,
            "transcript": "Nutaan tekicata tuavet nunanun tua-i-am qasgimun itrata payugarrluki neqkaitnek."
        },
        "15": {
            "start": 206.68,
            "end": 225.74,
            "transcript": "Cali nutaan qaqicata nerngarcata nutaan neqnek, tamakunek payugutmeggnek nerngata ataam yuarutmek at'ullaulluki, nernerrlugcetaarluki-gguq tuaten."
        },
        "16": {
            "start": 225.74,
            "end": 241.2,
            "transcript": "Tua-i, allanrulria iliini nerelqia assiirtaqluni, assiirtenrilngurmi-wa piluni nakriarrluni piaqluni."
        },
        "17": {
            "start": 241.2,
            "end": 247.32,
            "transcript": "Tau͡gaam cangalliurpek'nateng iluriurutekluku cali tamana."
        },
        "18": {
            "start": 247.32,
            "end": 259.58,
            "transcript": "Nutaan atakuan tekitellrat atakuan nunalget imkut, aqvastait imkut nutaan yurarrluteng,"
        },
        "19": {
            "start": 259.58,
            "end": 274.04,
            "transcript": "Una yuk taukuk-am kegvak, kevgak taukuk aipaa nunanun tuavet unegtelartuq."
        },
        "20": {
            "start": 274.04,
            "end": 290.68,
            "transcript": "Tau͡gken taukut allanret tekicameng yuraq ataam carrarmek itrucelluku tauna kevgak."
        },
        "21": {
            "start": 290.68,
            "end": 308.28,
            "transcript": "Nutaan atungengameng una yuk yuarut aturqatni tauna yura'aqluni, carrarnek itrutaqluni pikangquucimitun tamakut kaigavikellret."
        },
        "22": {
            "start": 308.28,
            "end": 319.56,
            "transcript": "Tau͡gken nutaan kaigavikerraarluku nangengata, iqukliqa nutaan ataam tuaten kingullugluku."
        },
        "23": {
            "start": 319.56,
            "end": 332.38,
            "transcript": "Ellaita tua-i piyugtacimegtun kapkaanaakluku aitarrluku taumun iluraminun alingcirarautekaqluku tuaten."
        },
        "24": {
            "start": 332.38,
            "end": 345.28,
            "transcript": "Anglanaqluteng tangvallrat tua-i piaqluteng, nutaan tua-i tuaten imkut allanret qaqilluki tuaten piluki, kaigavikurluki."
        },
        "25": {
            "start": 349.54,
            "end": 369.08,
            "transcript": "Kaigavikluki qaqilluki tua-i nutaan, tua-i-am nutaan imkut allanret ataam atakumi taqsarararqata qang'a-ll' taqnaciarqata unuaqan iliini yurarlartut taukut allanret."
        },
        "26": {
            "start": 369.08,
            "end": 380.4,
            "transcript": "Nasqungqerrluteng cali nasqunek-gguq ukugnek nunat allanret-llu pingqerrluteng."
        },
        "27": {
            "start": 380.4,
            "end": 391.72,
            "transcript": "Nutaan im'um tuani yurallratni, allanrem imum tua-i pikangqerrucimitun payuggluku tauna imna tukuni."
        },
        "28": {
            "start": 396.44,
            "end": 405.3,
            "transcript": "Tau͡gaam amllernek pikangqerrucimitun tua-i piaqluku tauna imna nasqum tukuni."
        },
        "29": {
            "start": 405.3,
            "end": 414.48,
            "transcript": "Tuaten cali ataam umigarutaqata ataam im' nunalek cali piaqluni."
        },
        "30": {
            "start": 414.48,
            "end": 427.62,
            "transcript": "Tauna ingluni makiluku amllertacingnaqluki imkut pillri taitellri taum allanrem, tua-i tamaani tuaten pitullruut."
        },
        "31": {
            "start": 427.62,
            "end": 446.5,
            "transcript": "Tau͡gken iliini waten-llu erenret takliriqerluki ataam-gguq imkucetun cukailngurnek yuarutnek aturluteng, elicarluteng, arulassuutnek imkunek."
        },
        "32": {
            "start": 446.5,
            "end": 457.0,
            "transcript": "Tua-i-am nutaan tuaten pivkenateng, iluriurutevkenateng nutaan."
        },
        "33": {
            "start": 457.0,
            "end": 468.7,
            "transcript": "Elitaqamegteki tamakut yuarutet atulteng imkut ingluteng ataam aqvaluki piaqluteng."
        },
        "34": {
            "start": 469.84,
            "end": 475.12,
            "transcript": "Cavkenaki kaigavikevkenaki taivkarngiinarluki tau͡gaam."
        },
        "35": {
            "start": 475.12,
            "end": 491.24,
            "transcript": "Nutaan pikangqerrucirramegcetun cali aruqluki qasgimun itrutraarluteng neqkarrarnek canek-wa piciatun, piciatun canek aturnarterranek [?] makunek."
        },
        "36": {
            "start": 491.44,
            "end": 506.84,
            "transcript": "Tua-i tuatnalartut tamaani, tau͡gaam kegginaqituluteng tamaani tuaten cukalngurnek piaqam kegginaqunek pililuteng muragnek."
        },
        "37": {
            "start": 507.18,
            "end": 524.78,
            "transcript": "Cat makut ayuqeliluki pilartut, kaviaret-llu caat piciatun tua-i-wa yuarutnun, yuarutnun kangikluki tamakut."
        },
        "38": {
            "start": 525.44,
            "end": 542.14,
            "transcript": "Tau͡gken cali tuaten aruliimeng imkut tamakut kegginaqut nalqiggluki taunguniluku una piaqluku, canguaruniluku piaqluku."
        },
        "39": {
            "start": 542.14,
            "end": 550.54,
            "transcript": "Cali ilait nepcetarluteng-gguq pilartut tamakut yuut ilait angalkut-wa."
        },
        "40": {
            "start": 550.54,
            "end": 571.02,
            "transcript": "Atkugmek ciumek ellivikluku qaingakun, ataam-llu imarnitegnek ciumek pirraarluku tuaten pilaraat. Tua-i taqutaqameng taq'aqluteng tua-i."
        },
        "41": {
            "start": 571.44,
            "end": 581.26,
            "transcript": "Tua-i tuaten pitullruut tamaani ak'a tamaani murilkeqarraallemni tuaten."
        },
        "42": {
            "start": 581.26,
            "end": 591.32,
            "transcript": "Kevgirpallurluteng tamaa-i pitullruut tuaten una arcaqakenrillruluku arulayaraq man'a."
        },
        "43": {
            "start": 591.44,
            "end": 601.7,
            "transcript": "Tua-i-am nutaan wangkuta ukut nunaurcat tua-i pitaciramtun piamken."
        },
        "44": {
            "start": 601.7,
            "end": 614.56,
            "transcript": "Nutaan ukut tupiita maani kinguatgun wii-ll' upaglua maavet Negeqlirmun uum [?] wavet Negeqlirmun."
        },
        "45": {
            "start": 614.56,
            "end": 622.44,
            "transcript": "Tua-i camek piksaunata tuaten nall' wanirpak [?] uitaluta taum kinguani maavet elliluta."
        },
        "46": {
            "start": 622.44,
            "end": 636.44,
            "transcript": "Tua-i-am caqerluteng qakuumainanrani kiugkut kiaqsim' [?] aqvaluta camek nalluluta wangkuta aqvaqatallerput nalluluku."
        },
        "47": {
            "start": 636.58,
            "end": 648.54,
            "transcript": "Nutaan kiavet tua-i ayagluta pisqengatkumta arulaliluteng ellait kiugkut cunawa piluteng."
        },
        "48": {
            "start": 648.54,
            "end": 659.34,
            "transcript": "Nutaan kinguani uitaluta wangkuta piksaunata-ll' tuaten cakaituamta, pikaicuamta-wa."
        },
        "49": {
            "start": 659.44,
            "end": 670.42,
            "transcript": "Nutaan caqerluta cam iliini uksut iliitni ellait-llu aqvamiluki tua-i piyugngaut."
        },
        "50": {
            "start": 670.42,
            "end": 684.16,
            "transcript": "Nutaan tuakenirnek waniw' tua-i caqtarturluta akiaqluki-wa, akiaqluki caaqata arulaiqata."
        },
        "51": {
            "start": 687.44,
            "end": 696.62,
            "transcript": "Maani tua-i tuaten pingluta ataucirqumek uksumi pillrunritukut kiakaakut tuani maani."
        },
        "52": {
            "start": 697.44,
            "end": 710.9,
            "transcript": "Cali tamaani tamakut tua-i kasgutullermeggni merqurluteng neqliterraarluku una yuk."
        },
        "53": {
            "start": 710.9,
            "end": 723.26,
            "transcript": "Mikelnguaraat makut pirraarluki mermek-llu piluki. Calingani kenurrarrirluki, kenurrarrarmek kumarciluteng."
        },
        "54": {
            "start": 723.44,
            "end": 735.82,
            "transcript": "Cali tua-i nalqigciaqameng tuaten tamakunek imkunek unangkengameggnek tua-i iqluqulriatun piaqluteng tua-i qanaagaqluteng."
        },
        "55": {
            "start": 735.82,
            "end": 758.22,
            "transcript": "Una naken avaken aqvasquniluku-ll' piaqluku kitumun-llu uumun yugmun cikirniluteng. Ilurami-ll' una pia iliita pia ayakautniaqluku tuaten, tua-i tuaten pitullruut tamaani."
        },
        "56": {
            "start": 758.22,
            "end": 773.8,
            "transcript": "Nutaan uksuq tuani maani tua-i-wa pikangqerrucirramcetun pilarmiukut tua-i maani carrarnek makunek."
        },
        "57": {
            "start": 773.8,
            "end": 790.34,
            "transcript": "Tua-i-w' yuk una irniani caaqan, qang'a-ll' maqaruartellruaqan, qang'a-ll' manaqengellruaqan piksailnguq tauna yuk tua-i tauna pitekluku pilartut."
        },
        "58": {
            "start": 790.34,
            "end": 801.26,
            "transcript": "Tauna taum ayanqarrluku tauna itruciaqluteng pikangqerrucirramegcetun tuaten."
        },
        "59": {
            "start": 801.26,
            "end": 814.8,
            "transcript": "Canek makunek aklurrarnek. Cali neqkarrarnek piciatun pikangqerrucimegcetun-llu tua-i tuaten pilartut maani."
        },
        "60": {
            "start": 814.8,
            "end": 818.06,
            "transcript": "Tua-i-qaa cali apyutkangqertuten?"
        },
        "61": {
            "start": 824.06,
            "end": 830.84,
            "transcript": "Watua qucillgaq pikaggun kituurtuq qulemtenun. Aryuqngamikut [?]."
        },
        "62": {
            "start": 830.84,
            "end": 837.32,
            "transcript": "Tangrramikut qulemteggun. (Ii-i.) Tamaatmek aren yaani tangrrami ukatmun [?]."
        },
        "63": {
            "start": 837.32,
            "end": 852.5,
            "transcript": "Tau͡gaam tua-i nallunrilucirramci tua-i maa-i qanrucamtek waniwa taukunek ak'a tamaani aturlallritnek watua-ll' maa-i cali aturyaullemteńek."
        },
        "64": {
            "start": 853.74,
            "end": 855.72,
            "transcript": "Camek cali paqnayugcit?"
        },
        "65": {
            "start": 855.9,
            "end": 863.02,
            "transcript": "Maani-qaa nunani tua-i-w' maani Kuigpagmi Kusquqvagmi-ll' tuaten atullrutenritaat [?]?"
        },
        "66": {
            "start": 863.02,
            "end": 877.54,
            "transcript": "Murilkeqarraallemni tamaani piciatun maani niitnarrlartut nunat kevgirniluki piniaqluki tuaten allanun nunanun."
        },
        "67": {
            "start": 877.54,
            "end": 888.56,
            "transcript": "Au͡gkut-ll' avani pitullruut avani nunaci au͡gkut. Niitnarrlartut tamaani kevgirniluki piaqluki."
        },
        "68": {
            "start": 888.56,
            "end": 897.94,
            "transcript": "Man'a tau͡gken arulat tumigupakanritaat imkut yuut caqapiararqameng tau͡gaam waten yagiraluteng pilartut."
        },
        "69": {
            "start": 906.04,
            "end": 909.1,
            "transcript": "Camek qanrucirkaugat makut wani?"
        },
        "70": {
            "start": 922.2,
            "end": 929.18,
            "transcript": "Cali man'a ayuquciat watqapiaq ayuqevkenani."
        },
        "71": {
            "start": 929.18,
            "end": 946.58,
            "transcript": "Tua-i-w' elluarrluteng uitangnaqluteng makut cali makut ayaaniilteng irniateng irniaqenrilngem'egteki-llu qanrutaqluki tua-i picirkaatnek ayuqucirkaatnek."
        },
        "72": {
            "start": 946.58,
            "end": 959.44,
            "transcript": "Man'a assiilnguq atuusqevkenaku tua-i qanrutaqluki. Cali qavaryallrat niicelluku. Calillruat unugpak-ll' qavaryugpakallratnek piaqluku."
        },
        "73": {
            "start": 964.9,
            "end": 979.34,
            "transcript": "Tau͡gken naklikluki makut cingumaluki yuuteng yuk'enrilngerqemegteki-llu tua-i qasgimi qanrutaqluki tamakut yuut ayuqucirkaatnek mat'umek."
        },
        "74": {
            "start": 979.34,
            "end": 993.92,
            "transcript": "Qang'a-llu yuilqumi qaill' ayuqluteng eglercellerkaat qanrutekluku. Cali pitengnaqellerkaat cali qanrutekluku. Amlleq-llu qanyuunani."
        },
        "75": {
            "start": 998.54,
            "end": 1007.3,
            "transcript": "Nunani wani ataucirpak-llu [?] qantuuq murilkellemni tamaani yuk amlleq qanyuicaaquq tau͡gaam."
        },
        "76": {
            "start": 1007.3,
            "end": 1018.82,
            "transcript": "Elluarrluni tua-i-w' uitasqelluki tamakut kinguliani qanrutetuit ayuqucirkaatnek mat'umek."
        },
        "77": {
            "start": 1021.14,
            "end": 1029.12,
            "transcript": "Iqlutmun umyuartequtekevkenaki cingumaluki tau͡gaam assirluki uitasqelluki."
        },
        "78": {
            "start": 1029.12,
            "end": 1043.48,
            "transcript": "Cali inerqurrluki camek assiilnguq atuusqevkenaku cali, cali arnat makut caumavakayuitait tamaani murilkellemni."
        },
        "79": {
            "start": 1043.48,
            "end": 1055.08,
            "transcript": "Tua-i-wa apqut', aurneraat-gguq ayuqenritut makut arnat ilait kayuluni, ilii tau͡gaam pivkenani."
        },
        "80": {
            "start": 1055.08,
            "end": 1064.82,
            "transcript": "Cali malkaquyuunaki, tan'gurraita, tau͡gaam inerqullerteng niilluku tuaten."
        },
        "81": {
            "start": 1064.82,
            "end": 1074.56,
            "transcript": "Tuaten cali niilluteng tamakut waten caumapakayuunateng watuacetun maanicetun."
        },
        "82": {
            "start": 1074.56,
            "end": 1082.34,
            "transcript": "Tua-i elluarrluteng pitangnaqluteng piameng, ilateng apqucimek-llu cikinritengnaqluki tuani."
        },
        "83": {
            "start": 1084.44,
            "end": 1098.28,
            "transcript": "Watua tau͡gaam maa-i arenqiacit piyugtacimegcetun pingameng yuut makut cali ukuk aipaq cali tamaani murilkeqarraalluni."
        }
    },
    "U7nclYvsQ9c": {
        "1": {
            "start": 10.43,
            "end": 11.23,
            "transcript": "Tua-llu."
        },
        "2": {
            "start": 27.54,
            "end": 34.21,
            "transcript": "Kitek waniwa ava-i ayagnirluku iciw' Alussistuatun ayuqulluku."
        },
        "3": {
            "start": 34.21,
            "end": 36.0,
            "transcript": "Ii-i."
        },
        "4": {
            "start": 36.0,
            "end": 41.22,
            "transcript": "Tua-i tuaten Kevgirqameng pitullruut."
        },
        "5": {
            "start": 41.22,
            "end": 51.86,
            "transcript": "Maa-i tua-i waten wangkuta maa-i mat'um nalliini Alussistuami aternek tegutetulriakut atput-llu cali alla tayim' qakmani teguluki."
        },
        "6": {
            "start": 51.86,
            "end": 61.34,
            "transcript": "Tua-ll' tuaten piaqameng Kevgirqameng makut wani irniarit tuaten tua-i petugtarluteng."
        },
        "7": {
            "start": 61.34,
            "end": 65.08,
            "transcript": "Petugtamek atengqetullruut, taum atra teguluku."
        },
        "8": {
            "start": 65.08,
            "end": 71.26,
            "transcript": "Tua-llu cali agyukluku, tuaten tamana ayuquq, agyukluteng."
        },
        "9": {
            "start": 71.26,
            "end": 75.98,
            "transcript": "Agyukluteng nallunritelluki taukut tuaten pitaciit."
        },
        "10": {
            "start": 75.98,
            "end": 86.46,
            "transcript": "Tua-i ukut wani allanret piaqameng yuraqata'arqameng yuarucetateng meng'aqatki."
        },
        "11": {
            "start": 86.46,
            "end": 95.06,
            "transcript": "Tua-i-ll' meng'atgu imna una yuraqatalria iterluni irniamni agyui tunluki."
        },
        "12": {
            "start": 95.06,
            "end": 98.1,
            "transcript": "Aklukaitnek cikirluki."
        },
        "13": {
            "start": 98.1,
            "end": 100.42,
            "transcript": "Ii-i, nutaan tua-i."
        },
        "14": {
            "start": 100.42,
            "end": 112.76,
            "transcript": "Ilii-llu itraqami imna angutet iliit tuaten agyui tunluki, tua-i-ll' anluni."
        },
        "15": {
            "start": 112.76,
            "end": 119.26,
            "transcript": "Nutaan-llu tua-i yuarucetaa aturluku nutaan yurarluteng."
        },
        "16": {
            "start": 119.26,
            "end": 124.66,
            "transcript": "Nutaan tua-i iterqurluki tegumiaqluki yurautai."
        },
        "17": {
            "start": 124.66,
            "end": 132.46,
            "transcript": "Wangkuta-ll' ilautetullruukut tuaten tegumiaqestekailngurni."
        },
        "18": {
            "start": 132.46,
            "end": 142.84,
            "transcript": "Tegumiaqestekailnguut cat amlleraqata itrulluki tua-i cauyallri ciuqerratni waten piluki."
        },
        "19": {
            "start": 142.84,
            "end": 153.14,
            "transcript": "Tua-i-llu iliini tan'gaurlullraata picingssaulriit yuralqerturluteng [?] tua-i waten anqerrluteng-llu tayima."
        },
        "20": {
            "start": 153.14,
            "end": 155.76,
            "transcript": "Tuaten-am call' pituluteng."
        },
        "21": {
            "start": 155.76,
            "end": 164.46,
            "transcript": "Tua-i-llu unuaquani cali-am nunalget yuraameng."
        },
        "22": {
            "start": 164.46,
            "end": 169.52,
            "transcript": "Tua-i imkut cali tuaten au͡gkucetun."
        },
        "23": {
            "start": 169.52,
            "end": 184.0,
            "transcript": "Tua-i-llu cali ilii tamakut yurautni qaqitaqata itrutellni, qaqitaqata."
        },
        "24": {
            "start": 184.0,
            "end": 194.58,
            "transcript": "Ilii tua-i kanavet uatiitnun nangerrluni aarpagaluni."
        },
        "25": {
            "start": 194.58,
            "end": 201.08,
            "transcript": "Tua-i waten piluni, anerquciaraluni-gguq."
        },
        "26": {
            "start": 201.08,
            "end": 216.6,
            "transcript": "Nani-llu tuani capliurcuutellregminek irugminek-llu ayagassuutellregminek [?] talligviik-llu piluni."
        },
        "27": {
            "start": 216.6,
            "end": 228.58,
            "transcript": "Canek tegulautessuutellregminek [?] piluni arraarraaraluni ayagangarraaruni anqerrluni tayima."
        },
        "28": {
            "start": 228.58,
            "end": 238.42,
            "transcript": "Tua-i-gguq anerquciaraluni tuaten Kevgirqata pitullruut."
        },
        "29": {
            "start": 238.42,
            "end": 247.8,
            "transcript": "Tua-i ciuneteng tua-i tukilluki, yurautmeggnek tukilluki."
        },
        "30": {
            "start": 247.8,
            "end": 255.24,
            "transcript": "Taukut-llu nunalgita cali allaneteng cali tukilluki tua-i."
        },
        "31": {
            "start": 255.24,
            "end": 262.02,
            "transcript": "Erneregni malrugni waten pingatelallruut."
        },
        "32": {
            "start": 262.02,
            "end": 276.46,
            "transcript": "Imkut tua-i allaneteng agyuteng allaneqluki, ataucimun pivkarpek'naki avveqluki."
        },
        "33": {
            "start": 276.46,
            "end": 290.66,
            "transcript": "Tua-i aqsaqurrit murilkelluki arenqililuki uitavkangnaqluki uitavkarluki."
        },
        "34": {
            "start": 290.66,
            "end": 296.3,
            "transcript": "Cacirteng nalluluku nunaniryugluteng."
        },
        "35": {
            "start": 296.3,
            "end": 310.72,
            "transcript": "Nutaan tua-i iquklitaqan imkut allanret pitarraarluteng pitarkateng avenqegqaarluki nutaan ayagluteng."
        },
        "36": {
            "start": 310.72,
            "end": 327.04,
            "transcript": "Imkut-llu ayiita nutaan cali nunalget, imkut aklut yurautellrit ak'allaunemeggnek ayagluki cali aruqutekluki."
        },
        "37": {
            "start": 327.04,
            "end": 333.8,
            "transcript": "Tuaten tua-i taman' yuraq atutullruat, Kevgiryaraq."
        },
        "38": {
            "start": 333.8,
            "end": 335.94,
            "transcript": "Tua-i nang'uq."
        },
        "39": {
            "start": 335.94,
            "end": 348.64,
            "transcript": "Ilii tamalkuan pivkenaku cukaluku tau͡gaam qanengssakaqa waniw' tangvakarraalqa kanani murilkelluki."
        },
        "40": {
            "start": 348.64,
            "end": 361.66,
            "transcript": "Kanavet tuaten pillruukut, Kevgillruut malrurqugnek kankut pingayirivkenateng-llu."
        },
        "41": {
            "start": 361.66,
            "end": 367.78,
            "transcript": "Tua-i taqluteng. Tua-i tamana tuaten piyaraq umegluku."
        },
        "42": {
            "start": 367.78,
            "end": 370.4,
            "transcript": "[?] taqellruat?"
        },
        "43": {
            "start": 370.4,
            "end": 375.44,
            "transcript": "Tau͡gaam Itruka'ar atuluteng."
        },
        "44": {
            "start": 375.44,
            "end": 383.8,
            "transcript": "Iciw' wangkuta atralalriakut pimun Mamterillernun kelgaqavcikut."
        },
        "45": {
            "start": 383.8,
            "end": 395.42,
            "transcript": "Tuaten tua-ll' Itruka'arqatarqameng elitnautullruit cali mat'umek yuraryaranek yurarkiurluki."
        },
        "46": {
            "start": 395.42,
            "end": 397.62,
            "transcript": "Tua-i yurarkiurluki."
        },
        "47": {
            "start": 397.62,
            "end": 405.12,
            "transcript": "Nutaan tamana March-aami atutullruat up'nerkami wall' March-aaq nangqerluku."
        },
        "48": {
            "start": 405.12,
            "end": 413.76,
            "transcript": "Nutaan tuaten Itruka'arqameng waten-llu nunanun cetamanun kel'tullruut."
        },
        "49": {
            "start": 413.76,
            "end": 417.38,
            "transcript": "Tua-i taivkarluki."
        },
        "50": {
            "start": 417.38,
            "end": 426.58,
            "transcript": "Nunacuarmiut, Nanvarnarrlagmiut, Paingarmiut, Naparyarrarmiut. Cetamakluki."
        },
        "51": {
            "start": 426.58,
            "end": 434.98,
            "transcript": "Tuaten tua-i kel'tullruit. Amllermeng kel'tullruut Itruka'arqatarqameng."
        },
        "52": {
            "start": 434.98,
            "end": 444.72,
            "transcript": "Tua-i au͡g'utun tuaten tua-i cali aklunek piluteng."
        },
        "53": {
            "start": 444.72,
            "end": 447.1,
            "transcript": "Tukuqluteng."
        },
        "54": {
            "start": 447.1,
            "end": 458.72,
            "transcript": "Cali tua-i anglanaqluteng tua-i yuralriit nang'erqaqluteng-llu kanani piciryaraicetun."
        },
        "55": {
            "start": 458.72,
            "end": 470.42,
            "transcript": "Una tua-i nang'ertaqluni piyugngelria, tutgarani-llu yura'arqan apa'urluan nang'ertaqluku akiqlilirluku yuraraqluni."
        },
        "56": {
            "start": 473.46,
            "end": 478.32,
            "transcript": "Tamana tamaa-i tuaten atutullruat man'a."
        },
        "57": {
            "start": 478.32,
            "end": 487.92,
            "transcript": "Maa-i tua-i kanani Mamterillerni yugyagpagluki kelelartut, yurarpagluteng."
        },
        "58": {
            "start": 487.92,
            "end": 491.62,
            "transcript": "Cama-i-aamek aterluni."
        },
        "59": {
            "start": 491.62,
            "end": 501.52,
            "transcript": "Ii-i, nauwa tua-i man'a, tuaten man'a atutullruat."
        },
        "60": {
            "start": 501.52,
            "end": 509.8,
            "transcript": "Wavet nunaullratni Nanvarnarrlagmun Itrukaraliyatullruukut."
        },
        "61": {
            "start": 509.8,
            "end": 517.82,
            "transcript": "Nunacuarmun-llu cali Itrukaraliyaqluta, Paingarmun-llu."
        },
        "62": {
            "start": 517.82,
            "end": 521.88,
            "transcript": "Naparyarrarmiut yaaqsiata wii piyuitellruunga."
        },
        "63": {
            "start": 521.88,
            "end": 530.72,
            "transcript": "Naparyarrarmiut tua-i waniw' Naparyarrarmiut yurartelluki tangerqallrunritanka."
        },
        "64": {
            "start": 530.72,
            "end": 538.46,
            "transcript": "Nanvarnarrlagmiut ukut kass'ikellruut, yurayullruut."
        },
        "65": {
            "start": 538.46,
            "end": 543.26,
            "transcript": "Atuyuluteng-ll' aturtait, erinakeggluteng."
        },
        "66": {
            "start": 543.26,
            "end": 548.72,
            "transcript": "Tuaten tua-i ayuqellruut Nanvarnarrlagmiut."
        },
        "67": {
            "start": 549.86,
            "end": 556.86,
            "transcript": "Kinguvrit-mi taukut Nanvarnarrlagmiut kinguvengqertut maa-i?"
        },
        "68": {
            "start": 556.86,
            "end": 560.82,
            "transcript": "Kinguvrit kana-i Atmaulluarmi quyungqaut."
        },
        "69": {
            "start": 560.82,
            "end": 567.74,
            "transcript": "Kana-i Atmaulluarmiut Nanvarnarrlagmiunguut kinguveqait."
        },
        "70": {
            "start": 567.74,
            "end": 571.12,
            "transcript": "Ayagyuanek aturtellget."
        },
        "71": {
            "start": 571.12,
            "end": 576.7,
            "transcript": "Atutuluteng ayagyuarit yuratuluteng."
        },
        "72": {
            "start": 580.0,
            "end": 584.54,
            "transcript": "Uumiku kitek Apanuugpak, Apanuugpiim-qaa qanemcia tak'uq?"
        },
        "73": {
            "start": 584.54,
            "end": 595.5,
            "transcript": "Apanuugpiim qanemcia cali tak'uryugnarquq pillra ayallrat Apanuugpiim."
        },
        "74": {
            "start": 595.5,
            "end": 601.04,
            "transcript": "Ii-i. Uumiku kitek pikumegnegu cangaciiqa?"
        },
        "75": {
            "start": 601.06,
            "end": 603.78,
            "transcript": "Ii-i, caci [?]."
        },
        "76": {
            "start": 603.78,
            "end": 625.3,
            "transcript": "Tau͡gaam ikgetellrianek waniwa aptutengqertua alerquutnek ak'a tamaanirrlarnek niiculartut yuut watua niicuirulkaitnek."
        },
        "77": {
            "start": 625.3,
            "end": 638.98,
            "transcript": "Tamatumek-qaa ilait alerquuteklallritnek yuut atulallrit ak'a tamaanirrlarnek qanqeryuumiituten piciatun?"
        },
        "78": {
            "start": 641.0,
            "end": 652.8,
            "transcript": "Alerquutet, tua-i-w' qalarutetullrukaitkut mat'umek agayuyaraq man'a tua-i piyaurrluku Nunapicuarmun kanavet pillruukut."
        },
        "79": {
            "start": 652.8,
            "end": 661.06,
            "transcript": "Una qaneryaraq caliaqsaurrluku tau͡gaam qasgimi, qasgirrlainarnek, qasgimi tua-i."
        },
        "80": {
            "start": 661.06,
            "end": 670.08,
            "transcript": "Tua-i kanani Nunapicuarmi qalarutetullruitkut."
        },
        "81": {
            "start": 670.08,
            "end": 677.02,
            "transcript": "Mat'umek tua-i yuullerkamteńek elluarrluta yuullerkamteńek qalarutetullruitkut."
        },
        "82": {
            "start": 677.02,
            "end": 689.2,
            "transcript": "Waten atakumi qinuitaqata, qinuirutaqan qasgi qalarutetullruitkut mat'umek qalaruyutmek."
        },
        "83": {
            "start": 689.2,
            "end": 697.02,
            "transcript": "Qalarutetullruitkut elluarrluta-wa tua-i tan'gaurlurni pillerkamteńek."
        },
        "84": {
            "start": 697.02,
            "end": 704.06,
            "transcript": "Tua-i qanruyuteput makut maligtaquluki-wa yuusqelluta."
        },
        "85": {
            "start": 704.06,
            "end": 710.28,
            "transcript": "Cali man'a arcaqerluku neqa qanrutketullruat."
        },
        "86": {
            "start": 710.28,
            "end": 719.76,
            "transcript": "Tua-i cali waten uksuarmi kiagmi-llu paivngallrani qaa [?] tegutevkenaku tua-i unakengnaquralaasqelluku."
        },
        "87": {
            "start": 719.76,
            "end": 726.58,
            "transcript": "Qanruyutengqellruamta, qanruyutengqellruameng tamatumek piitnaryaramek."
        },
        "88": {
            "start": 726.58,
            "end": 731.62,
            "transcript": "Piitnatullrulliniuq tamaani amllerqurpaunrilngurnek."
        },
        "89": {
            "start": 731.62,
            "end": 738.0,
            "transcript": "Tua-i-gguq tamana mat'um neqem piitellra nangtequanarquq."
        },
        "90": {
            "start": 738.0,
            "end": 745.12,
            "transcript": "Cani tamarmi nangtequanarqenruluni naulluutni aqsaqum imaitellra."
        },
        "91": {
            "start": 745.12,
            "end": 748.06,
            "transcript": "Nangtequanaqluni tua-i."
        },
        "92": {
            "start": 748.06,
            "end": 756.98,
            "transcript": "Wani-gguq tua-i aqsaqum imaitellra, neq' amllermek nernanrillra."
        },
        "93": {
            "start": 756.98,
            "end": 765.82,
            "transcript": "Aqsaquq qamna mikliriyugqami eqluni, eqsugqami nangteqnaqpiatuuq."
        },
        "94": {
            "start": 765.82,
            "end": 771.26,
            "transcript": "Tua-i-llu-gguq equmariqercan tuacetun pitanrirluni."
        },
        "95": {
            "start": 771.26,
            "end": 777.9,
            "transcript": "Alerquutkellruat tamatum neqem piitellrani nalliini tamaani."
        },
        "96": {
            "start": 777.9,
            "end": 794.5,
            "transcript": "Tua-i canek piciatun yuk ner'arkauvkenani, wall'u-llu qassarluku, qassarluku takuikuni-llu angutem inerquutekluku imna alungyaracuar can'giicuayaaq."
        },
        "97": {
            "start": 794.5,
            "end": 802.24,
            "transcript": "Tamana tamaa-i qenuirluku waten tapqaruskan aglumangraaku angu nerqaasqevkenaku."
        },
        "98": {
            "start": 802.24,
            "end": 805.64,
            "transcript": "Taumun tau͡gaam tua-i kalngiinun ek'arrluku."
        },
        "99": {
            "start": 805.64,
            "end": 815.62,
            "transcript": "Tua-i-gguq kemgiutaqami taumek tua-i inerqaquni, tua-i ellminek tua-i pitaqluni, aqsaquni qamna tua-i."
        },
        "100": {
            "start": 815.62,
            "end": 825.08,
            "transcript": "Waten qanruyuterluni, cingilegmek-gguq umimek elluatun [?] ellminek pitgarciquq aqsaqumikun."
        },
        "101": {
            "start": 825.08,
            "end": 831.56,
            "transcript": "Tua-i yuvgermek qam' [?] iluni piqerluku."
        },
        "102": {
            "start": 831.56,
            "end": 837.88,
            "transcript": "Tuaten tua-i man'a tamaa-i [?] neraituryaraa ayuqelliniuq."
        },
        "103": {
            "start": 837.88,
            "end": 843.42,
            "transcript": "Tua-i angu tamakut aglumaqaasqevkenaki."
        },
        "104": {
            "start": 843.42,
            "end": 850.08,
            "transcript": "Tau͡gaam cali qanruyuterluni tamana tuaten neraituryaraq."
        },
        "105": {
            "start": 850.08,
            "end": 862.1,
            "transcript": "Tua-i-gguq tuaten piaqan nutaan ilakellriit, ilakaqut nepaitengnaqluteng assirluteng, assingnaqluteng."
        },
        "106": {
            "start": 862.1,
            "end": 865.74,
            "transcript": "Assirluteng avullugutaitengnaqluteng."
        },
        "107": {
            "start": 865.74,
            "end": 874.84,
            "transcript": "Tua-i-gguq avullugutailnguut iliini kanatuut cavkenateng."
        },
        "108": {
            "start": 874.84,
            "end": 888.18,
            "transcript": "Tau͡gken-gguq tua-i waten tua-i neqkaitqapiarassiyaagaqameng ilait angayuqaagket-llu tau͡gaam kiimek kanaraqlutek unguvalutek."
        },
        "109": {
            "start": 888.18,
            "end": 894.24,
            "transcript": "Cali tua-i tamana tuaten-gguq pilleq canganaunani, canganarqevkenani."
        },
        "110": {
            "start": 894.24,
            "end": 910.5,
            "transcript": "Tau͡gken-gguq angayuqaagni irniakenka tua-i piunrirkelluki-ll' piaqameng tamana-gguq qanertangqetuluni cali qaillun qanertangqerrami ayuqut tamakut."
        },
        "111": {
            "start": 910.5,
            "end": 914.7,
            "transcript": "Maa-i man'a alerquutek'lallruat."
        },
        "112": {
            "start": 914.7,
            "end": 921.72,
            "transcript": "Cali makut wani angukengat-wa tua-i elluarrluki aulukesqelluki."
        },
        "113": {
            "start": 921.72,
            "end": 934.44,
            "transcript": "Tuaten-gguq tamaani waten neqa piitevkenaku-llu elluarrluki imna aulukinrilnguq cali-llu uqlautetuluki."
        },
        "114": {
            "start": 934.44,
            "end": 942.66,
            "transcript": "Cali-llu camun-wa tua-i tutmallermi maani alaunateng tuaten neqkaq."
        },
        "115": {
            "start": 942.66,
            "end": 955.84,
            "transcript": "Tamaa-i-gguq neqa enurnarqan tuaten ayuqellra imna aulukluaqarinritleq."
        },
        "116": {
            "start": 955.84,
            "end": 961.14,
            "transcript": "Tua-i ping'e'rmi unangyuitaquq. Unangyuunani tua-i."
        },
        "117": {
            "start": 961.14,
            "end": 978.08,
            "transcript": "Cali-gguq tau͡gken imna tua-i neqa enurnaitmi enuqiqaqluni-llu pitulilleq, tua-i cali unangyunruluni tamakuni."
        },
        "118": {
            "start": 978.08,
            "end": 991.7,
            "transcript": "Tamaa-i-gguq tuaten elluarrluku unangkengani auluktullruamiu, aulukestiin-llu wall'u nulirran auluktullruamiu."
        },
        "119": {
            "start": 991.7,
            "end": 1000.52,
            "transcript": "Tamana tuaten cali ayuqelliniuq mat'um neqa iqukluku qaneryaraq."
        },
        "120": {
            "start": 1000.52,
            "end": 1006.96,
            "transcript": "Elluarrluku aulukuraasqelluku maa-i man'a neqa alerquutem iqua tamana."
        },
        "121": {
            "start": 1006.96,
            "end": 1011.02,
            "transcript": "Neqa paivngarrlainayuitniluku."
        },
        "122": {
            "start": 1011.02,
            "end": 1021.58,
            "transcript": "Cali-llu wangkuta qanruyuterluta-w' tua-i elluarrluta yuullerkamteńek."
        },
        "123": {
            "start": 1021.58,
            "end": 1025.04,
            "transcript": "Cali-llu uitayunqeggianata."
        },
        "124": {
            "start": 1025.04,
            "end": 1028.94,
            "transcript": "Uitayunqellria-gguq cangqessuituq."
        },
        "125": {
            "start": 1028.94,
            "end": 1035.88,
            "transcript": "Cali-llu qanruyutmi maligtaqunrilnguq cangqessuunani tua-i."
        },
        "126": {
            "start": 1035.88,
            "end": 1048.62,
            "transcript": "Cali-llu man'a inerqutngullruluni waten camrulkarluni-wa tua-i yuk, camrulkarluni pilria."
        },
        "127": {
            "start": 1048.62,
            "end": 1053.52,
            "transcript": "Tua-i-gguq cali ullagtaanqurrulluni ilaminun."
        },
        "128": {
            "start": 1053.52,
            "end": 1059.84,
            "transcript": "Cali-gguq cangqessuillruuq tamana waten elluarrluni pilriami."
        },
        "129": {
            "start": 1059.84,
            "end": 1063.98,
            "transcript": "Cali-llu makut irniat angliyugallratni."
        },
        "130": {
            "start": 1063.98,
            "end": 1070.26,
            "transcript": "Cali inerquutetullruluki elalirtaarulluki enenun pisqevkenaki."
        },
        "131": {
            "start": 1070.26,
            "end": 1077.34,
            "transcript": "Tua-i-gguq cali elalirtaarucimalria tan'gaurluq wall'u-llu nasaurluq."
        },
        "132": {
            "start": 1077.34,
            "end": 1082.88,
            "transcript": "Asguraunani-gguq ilaminek, yuugaq angliaquq [?]."
        },
        "133": {
            "start": 1082.88,
            "end": 1086.92,
            "transcript": "Tuaten tua-i qanruyutengqellruukut."
        },
        "134": {
            "start": 1086.92,
            "end": 1097.98,
            "transcript": "Cali-llu wangkuta qanruyuterluta, tua-i-wa ilaput elluarrluki pisqelluki."
        },
        "135": {
            "start": 1097.98,
            "end": 1105.14,
            "transcript": "Cali-llu tua-i-w' qaillun tayima ilaknitkevkenaki."
        },
        "136": {
            "start": 1105.14,
            "end": 1108.0,
            "transcript": "Cali-llu takaqluki."
        },
        "137": {
            "start": 1108.0,
            "end": 1111.86,
            "transcript": "Cali-llu akluit takaqluki."
        },
        "138": {
            "start": 1111.86,
            "end": 1126.08,
            "transcript": "Akluit takaqluki pikenrilkevvut wangkuta agturayuunaku, tau͡gaam tua-i ikayurnarqellria tua-i aklua-llu tangerrluku, ikayurnarqellria ikayurarkauluku."
        },
        "139": {
            "start": 1126.08,
            "end": 1131.22,
            "transcript": "Cali man'a maa-i arcaqerluku alerquutngullruuq."
        },
        "140": {
            "start": 1131.22,
            "end": 1141.16,
            "transcript": "Ilamta piit akluit takaqesqelluki, tau͡gaam apelcirluki-llu tau͡gaam aturyukumteki atulaasqelluki."
        },
        "141": {
            "start": 1141.16,
            "end": 1150.38,
            "transcript": "Cali man'a apelciinani ilii tegutetuuq tua-i ilamek pianek."
        },
        "142": {
            "start": 1150.38,
            "end": 1155.8,
            "transcript": "Tamana assiinani. Assiinani tua-i."
        },
        "143": {
            "start": 1155.8,
            "end": 1163.76,
            "transcript": "Cali-ll' arnani tamana tapeqluku cali alerquutekaat cangallruvkenaku."
        },
        "144": {
            "start": 1163.76,
            "end": 1171.64,
            "transcript": "Tamana apelciinani pillri ilami pianek-llu tegucugluni ilami nalluatni."
        },
        "145": {
            "start": 1171.64,
            "end": 1174.94,
            "transcript": "Tamana-am iqungqertuq waten,"
        },
        "146": {
            "start": 1174.94,
            "end": 1184.66,
            "transcript": "tamana-gguq tuaten ilami piinek tegutetuli, ping'e'rmi-gguq unangyuirutetuuq."
        },
        "147": {
            "start": 1184.66,
            "end": 1194.2,
            "transcript": "Tangerrluku maa-i nutem qanruyun piulliniami, pakemna-ll' aulukesteput nutem piulliniami."
        },
        "148": {
            "start": 1194.2,
            "end": 1199.3,
            "transcript": "Tamana-gguq tuaten pituli unangyuirutetuuq pingnaq'ngermi."
        },
        "149": {
            "start": 1199.3,
            "end": 1214.52,
            "transcript": "Tamakut waniw' mat'um nalliini niicuilkeput, tamakut-gguq kiimeng piuyungaqut taumi, taumi yugmi. Tuaten picirkartuluni pillilria, picirkartuyartetuluni."
        },
        "150": {
            "start": 1214.52,
            "end": 1225.32,
            "transcript": "Iciw' maa-i tamarilrianek niitelalriakut carpall'ernek snuukuurpall'ernek angyanek-llu tayim' tamariaqluteng nataqsuunateng."
        },
        "151": {
            "start": 1225.32,
            "end": 1234.68,
            "transcript": "Tamana tamaa-i waten iqukaa mat'um ilamta piit takaqesqelluki."
        },
        "152": {
            "start": 1234.68,
            "end": 1240.28,
            "transcript": "Tuaten tua-i arcaqerluku tamana alerquutekellruarput tua-i."
        },
        "153": {
            "start": 1241.52,
            "end": 1252.46,
            "transcript": "Ciin elpeni maa-irpak, oh okay, teglegiyugpakameng."
        },
        "154": {
            "start": 1252.46,
            "end": 1264.82,
            "transcript": "Qaillun teglegiyugpakangeyukanka wii mat'um nalliini maa-i makunek tang aturrlugluteng mat'umek."
        },
        "155": {
            "start": 1264.82,
            "end": 1273.46,
            "transcript": "Kuingirrlugluteng taangarluteng tuaten ayuqucimek ayuqenricaraqaa yuum."
        },
        "156": {
            "start": 1273.46,
            "end": 1283.32,
            "transcript": "Taangiqluni, kuingirrlugluni, imkunek-llu narluki pilarngatut, cali iinrurrlugnek nerluteng."
        },
        "157": {
            "start": 1283.32,
            "end": 1289.74,
            "transcript": "Tamaa-i tuaten piaqameng umyuarteqelteng maligtelaryugnarqait."
        },
        "158": {
            "start": 1289.74,
            "end": 1292.82,
            "transcript": "Maligtelaryukluki pilaranka."
        },
        "159": {
            "start": 1292.82,
            "end": 1301.58,
            "transcript": "Wall'u-llu tua-i ilait, ilait tua-i, amller' maa-i arenqialluvingalilria [?] caunani."
        },
        "160": {
            "start": 1301.58,
            "end": 1311.52,
            "transcript": "Waten tuaten pilria wangkuta ap'laraput arrsauniluku tauna, caitniluku, arrsauluni."
        },
        "161": {
            "start": 1311.52,
            "end": 1317.24,
            "transcript": "Tua-i-llu tuaten maa-i tegucungelriit tamakunek."
        },
        "162": {
            "start": 1317.24,
            "end": 1323.8,
            "transcript": "Tamaa-i tamana man'a qanrutkelqa imna ava-i iqukaa."
        },
        "163": {
            "start": 1323.8,
            "end": 1335.02,
            "transcript": "Tamakunek tegutetukuni canek-ll' allanek pitukuni tamakut piuciqut elliini kiingan, piuyugciqut."
        },
        "164": {
            "start": 1335.02,
            "end": 1340.2,
            "transcript": "Tua-i tamaa-i tuaten wii pilartua, takairulluteng."
        },
        "165": {
            "start": 1340.2,
            "end": 1350.12,
            "transcript": "Wall'u-llu makuni tangvalalriakut cali makuni maa-i tangvayuitellemteńek tiiviini makuni."
        },
        "166": {
            "start": 1350.12,
            "end": 1357.98,
            "transcript": "Imkut iciw' tangvalaqput akirugarnek-ll' amllernek tegulluteng qemaggluteng ayakarluteng-llu tua-i."
        },
        "167": {
            "start": 1357.98,
            "end": 1368.6,
            "transcript": "Tamaa-i-llu ilaitni tuaten ilateng maa-i piyaurtengyugnarqait akiutait-llu piaqluteng tuaten."
        },
        "168": {
            "start": 1368.6,
            "end": 1381.28,
            "transcript": "Tua-i-llu-wa pilallilriit, pilallilria waten, \"Wiinga nangteqvakartua caipakarlua, caipakartua, tuaten ataki piqerlii.\""
        },
        "169": {
            "start": 1381.28,
            "end": 1386.74,
            "transcript": "Tuaten wii umyuarteq'lartua mat'umek."
        },
        "170": {
            "start": 1386.74,
            "end": 1388.44,
            "transcript": "Ii-i, tua-i."
        },
        "171": {
            "start": 1388.44,
            "end": 1391.12,
            "transcript": "Natrurvakan natrurvanricugnarqaqa."
        },
        "172": {
            "start": 1391.12,
            "end": 1395.2,
            "transcript": "Ii-i. Yaa. (Yaa, assirtuq. Quyana!)"
        }
    },
    "lJn8MqurjGM": {
        "1": {
            "start": 243.12,
            "end": 252.42,
            "transcript": "Assilivkallruanga mat'um mumigcillma ak'allarnek umyuarteqlua."
        },
        "2": {
            "start": 252.42,
            "end": 265.4,
            "transcript": "Yugnek imkunek catairutellermek, my old grandma, my daddy's mother, because she was alive, alerteqellruanga."
        },
        "3": {
            "start": 265.4,
            "end": 282.62,
            "transcript": "Tamarmeng my daddy, daddy-ma kinguqlii tamarmeng, anngai, sister-ai-llu, cousin-ai-llu tamarmeng."
        },
        "4": {
            "start": 282.62,
            "end": 296.72,
            "transcript": "Tamakut nek'aqluki makut aturlalqa ellaita, tamatumek picirlua iluka ayuq' assiliuq."
        },
        "5": {
            "start": 296.72,
            "end": 314.98,
            "transcript": "Aturcelluki tamakunek tangerrlallruamki tan'gurraallraulua, ilagautellallruama tangvagluki-llu tamakunek caliaqata taluyanek kuigni caputelegnek."
        },
        "6": {
            "start": 315.98,
            "end": 333.96,
            "transcript": "Amllernek neqtelallruata ikamrak imirlukek, ikamrak muirrlukek, neqtellallruut taluyameggnek taquigaqameng cikullran kinguani."
        },
        "7": {
            "start": 333.96,
            "end": 352.94,
            "transcript": "Tuatelluteng qimugcitkangqerrlartut amllermek neqkangqerrluteng-llu kuignek neqnek anllernek, taluyatgun tau͡gken neqet tamakut unakluki."
        },
        "8": {
            "start": 365.32,
            "end": 372.84,
            "transcript": "Mikelnguaraat mikellriit makut apqalallrit qaillun umyuarteqsit?"
        },
        "9": {
            "start": 388.06,
            "end": 398.66,
            "transcript": "Quyalartua camek aptaqatnga, aplua mumigcitesqelluta nallunritlemnek wiinga."
        },
        "10": {
            "start": 398.66,
            "end": 409.5,
            "transcript": "Quyalkialartut cat nallullerteng atawaunrilnguq school-ami piani public school-ami atawaunrilnguq ca."
        },
        "11": {
            "start": 409.5,
            "end": 416.68,
            "transcript": "Cali elicallemnek, elicarillemnek taq'aqama, tamaani-ll' akuliini."
        },
        "12": {
            "start": 416.68,
            "end": 427.86,
            "transcript": "Qanrutlaranka mat'umek kiucimek wani ilateng makut."
        },
        "13": {
            "start": 427.86,
            "end": 433.88,
            "transcript": "Tua-i-wa nakmiin ilakellriatun treat-arlaasqelluki."
        },
        "14": {
            "start": 434.66,
            "end": 446.5,
            "transcript": "Ilait-llu qanengraata ilameggnek uputaarluki man'a ayuquciat akngirtengnaqluku umyugaat."
        },
        "15": {
            "start": 447.58,
            "end": 459.0,
            "transcript": "Tuaten pilaasqevkenaki, tamaani inerqurrlallruatnga ak'a wiinga. Grandma-ma tuquvailegmi."
        },
        "16": {
            "start": 459.0,
            "end": 469.5,
            "transcript": "Yuuminanemni ilanka makut qaillun pingraata wiinga maligtaquteksaunii pinengnaqlasqell'."
        },
        "17": {
            "start": 469.5,
            "end": 478.86,
            "transcript": "Ciuqliuluku alerqurlallruanga tegleglaasqevkenii wii pikenrilkemnek."
        },
        "18": {
            "start": 478.86,
            "end": 493.62,
            "transcript": "Camek piilkuma piyukuma apluku kina imna pikestii pisqell', avegvingqerquni piciqaanga, avegviilkuni nalqigciiqaanga pisciigatnillua."
        },
        "19": {
            "start": 493.62,
            "end": 506.62,
            "transcript": "Tua-i tauna alerquuteklallruaqa tegleglaasqevkenii, aipaani-llu second man'a neighbor-aaqa."
        },
        "20": {
            "start": 506.62,
            "end": 524.82,
            "transcript": "Tau͡gaam gossip-arlaasqevkenii uputaarluku yugtun ilama callrit atawaunrilnguut, whenever, tau͡ga-ll' allanek yugnek niitaqama tuaten pilrianek."
        },
        "21": {
            "start": 524.82,
            "end": 540.96,
            "transcript": "To ignore them, ilangcivkenaki pisqellua wii ciuqliuluku alerqurruanga, first thing, ciuqliuluku waten elpet you."
        },
        "22": {
            "start": 540.96,
            "end": 555.66,
            "transcript": "Elpet alutukenritan. You're not supporting that family, which is your neighbor, tauna elaqliin, allami nem'i uitalria."
        },
        "23": {
            "start": 555.66,
            "end": 568.64,
            "transcript": "Elpet irniaten tau͡gaam piyugtacirpetun qanrutarkaugaten camek inerqurnarqellriamek."
        },
        "24": {
            "start": 568.64,
            "end": 580.68,
            "transcript": "Niicunrilengraata qarulluki tau͡gaam avani elpet tuqukuvet neq'akarkaatnek."
        },
        "25": {
            "start": 585.84,
            "end": 586.9,
            "transcript": "Tua-i tau͡gaam."
        },
        "26": {
            "start": 589.14,
            "end": 593.96,
            "transcript": "Tau͡gaam tamatumek nalqigut'lallruatnga."
        }
    },
    "-Xm9v1IGzDA": {
        "1": {
            "start": 14.5,
            "end": 29.16,
            "transcript": "Maavet taiterraallerpeni maavet, makut wani maantellruciat-qaa nallunritellruan?"
        },
        "2": {
            "start": 29.16,
            "end": 41.74,
            "transcript": "Allragni qangvaq-wa taillruukuk una-llu apqauyaaqelliniluni imna Andy Paukan."
        },
        "3": {
            "start": 45.16,
            "end": 52.48,
            "transcript": "Waskie Walter-aq-llu apcaaqelliniluku arenqinrilamek pivkenani."
        },
        "4": {
            "start": 52.48,
            "end": 65.08,
            "transcript": "Tua-llu tuqluurlua uumek-llu maligkamnek piyunaaqngama."
        },
        "5": {
            "start": 65.08,
            "end": 75.4,
            "transcript": "Quyallruunga cakneq, yaaqsikap'igcaaquk kingunerpuk, kuuciirlunuk."
        },
        "6": {
            "start": 75.62,
            "end": 84.62,
            "transcript": "Maani-ll' tekicameng nerevkarlunuk akiircetevkenanuk caitqapik alangaallrulrianga."
        },
        "7": {
            "start": 84.62,
            "end": 98.18,
            "transcript": "Quyaqapigglua-llu nallunrilamku, miklemnek ayaglua nallunrilamku una Suruartalegmi [?] uitallruut angayuqaak."
        },
        "8": {
            "start": 99.62,
            "end": 112.62,
            "transcript": "Tau͡gaam school-arvingameng nunaillruyaaqut yuratuluteng Suruartalegmi [?] uitallermeggni."
        },
        "9": {
            "start": 112.62,
            "end": 121.88,
            "transcript": "School-arvingameng tau͡gaam ungna ketemteni-llu Marami katurqellruit."
        },
        "10": {
            "start": 123.3,
            "end": 139.64,
            "transcript": "Nunallrat ungani Scammon Bay-m akuliini akunlemteni Marami amllerrsaaqellruut, tau͡gaam school-arvignek naparciameng."
        },
        "11": {
            "start": 144.58,
            "end": 165.64,
            "transcript": "Katurqellruit tamakut nunat unani yuilqumi, school-arvignek ullaucunailnguut Alarnermun Nunapiggluugarmun tamakunun."
        },
        "12": {
            "start": 167.42,
            "end": 179.58,
            "transcript": "Maavet taillerpeni man'akauluku kiingan piqerr'u, (man'a-qaa?) umyuaqutkellren tangllerpeni makut paivngallratnek?"
        },
        "13": {
            "start": 180.62,
            "end": 192.62,
            "transcript": "Allragni paacami taillruukut, taitellruitkut, kingunerput uksuuluni."
        },
        "14": {
            "start": 192.62,
            "end": 208.82,
            "transcript": "Tua-llu Bethel-aamek ayaglua, camek Anchorage-amek ayallemteni qanikcau' kiagurrngiinarluni."
        },
        "15": {
            "start": 208.82,
            "end": 224.36,
            "transcript": "Tua-ll' Juneau-mek miqatateng ukut, angyanek tuaten tangaaluta eglerrluteng maani kiarnarqellruami taillemni."
        },
        "16": {
            "start": 224.36,
            "end": 238.68,
            "transcript": "Tua-llu wavet tekilluta, ik'ik unani imna-llu meq qaterluni ceńaq cunaw' imkut herring-at."
        },
        "17": {
            "start": 239.62,
            "end": 254.46,
            "transcript": "Tut'-llu tuani angyat-llu kuvyalriit amlleqap'ig' angyarpiit tuaten nunani, kicaumaluteng kipurqellriit cunaw' tamakut."
        },
        "18": {
            "start": 256.62,
            "end": 265.6,
            "transcript": "Arenqiallurnek [?] kiagullran cikuunani, kingunerpuk cikumamilriit."
        },
        "19": {
            "start": 265.6,
            "end": 287.88,
            "transcript": "Iillaullruunga tau͡gaam tangerpaluama-llu, ikegken-llu cunaw' akimtenek misviim misuucaakut, aqvastevut tekican ekluta tailluta."
        },
        "20": {
            "start": 295.02,
            "end": 303.62,
            "transcript": "Yugyakap'igtelluni uum neqet tamakunek herring-aanek pilriit."
        },
        "21": {
            "start": 304.38,
            "end": 316.94,
            "transcript": "Ukut kiingan qanaatqerki ukut tamakut pivkenaki ukut kiingan paivngallrit, maani-ll' ciumek makut wani tangerqerraalten."
        },
        "22": {
            "start": 317.34,
            "end": 332.24,
            "transcript": "Kitak-wa caut [?] mic'amta taistevut, aqvastevut tekican ekluta tailluta."
        },
        "23": {
            "start": 332.24,
            "end": 344.18,
            "transcript": "Nalluluku wii, cunawa mer'em qaingakun tailluku, nalluluku wii tekitellra."
        },
        "24": {
            "start": 344.18,
            "end": 359.78,
            "transcript": "Maavet-llu itrulluta makunek tangerpaluvanek ilait, mat'um iluani carraat tau͡gaam ellitaqluki."
        },
        "25": {
            "start": 359.78,
            "end": 375.36,
            "transcript": "Iillalrianga cakneq, yaaqvarmiutaungata makut ilait, mat'um iluani, mat'um ukut caliit."
        },
        "26": {
            "start": 380.22,
            "end": 395.5,
            "transcript": "Allatun-llu nunatun Anchorage-atun-wa ayuqevkenani yuut ilaliun neqkap'iggluteng."
        },
        "27": {
            "start": 395.5,
            "end": 407.76,
            "transcript": "Tangrraqamegteki pairtaqamegteki-llu, allarraun' [?] nalliamta tangllerput."
        },
        "28": {
            "start": 408.62,
            "end": 420.42,
            "transcript": "Aptenauraitkut, where you from? Quyanaqluteng pairtellra tamarmeng."
        },
        "29": {
            "start": 420.42,
            "end": 429.7,
            "transcript": "Ilaliunqelliniameng makut Kassaungermeng maani."
        },
        "30": {
            "start": 433.62,
            "end": 446.96,
            "transcript": "Makut imai-llu mat'um cali tangrrat apertuqluki piit, ilait tau͡gaam wii tangtuluki mat'um imai."
        },
        "31": {
            "start": 446.96,
            "end": 459.12,
            "transcript": "Aataurluma aaniin meluskalitullruami-llu cuyanek aramek auluku."
        },
        "32": {
            "start": 459.12,
            "end": 467.66,
            "transcript": "Tuatnatullruut tamakucutellrit iliit imkut iqmigviutaat cuyanek imirluki."
        },
        "33": {
            "start": 467.66,
            "end": 479.06,
            "transcript": "Tangssiurucaaqluki caitqapik kingunem maani tau͡gaam alaitelliniut ak'allaat."
        },
        "34": {
            "start": 481.62,
            "end": 493.12,
            "transcript": "Kass'at tekitellrunrilkata au͡gkunek atkunek tuaten aturyarapuk-wa aturyarapuk tamakut."
        },
        "35": {
            "start": 493.12,
            "end": 504.62,
            "transcript": "Neqet-ll' amiit au͡gkut tamakunek tau͡gaam aturangqercallruukut iillaullrulrianga cakneq mat'um imai."
        },
        "36": {
            "start": 505.88,
            "end": 517.98,
            "transcript": "Tua-i taumek qanemciugua mat'um pisqellerpenek."
        },
        "37": {
            "start": 519.26,
            "end": 533.42,
            "transcript": "Ingna qikuq, qikuq, tauna kitak' tayim' nallunritacirrarpecenun qanrutkarraaqerru."
        },
        "38": {
            "start": 533.42,
            "end": 535.88,
            "transcript": "Qikuq imna agaani."
        },
        "39": {
            "start": 538.64,
            "end": 540.42,
            "transcript": "Tua-i-qaa?"
        },
        "40": {
            "start": 552.58,
            "end": 563.24,
            "transcript": "Qikuq-wa ingna caullrua, camek, camek piliaqellraci qaillun piliaqelallratki camun-llu atuullra?"
        },
        "41": {
            "start": 563.66,
            "end": 579.38,
            "transcript": "Wii tangvaksaicaaqanka tau͡gaam aanaurluma qanrut'laraanga Pilot Station-amek yaatiini cuilngurmek atengqertuq ingrinun carvaq."
        },
        "42": {
            "start": 579.62,
            "end": 594.56,
            "transcript": "Tamatum iluani atauciq carvaq, qikumek clay-amek, uumek clay-auguq Kass'atun qikuuguq."
        },
        "43": {
            "start": 594.56,
            "end": 606.72,
            "transcript": "Pategluki, teggacilarniluki, teggacilarniluki tamatumek qikumek."
        },
        "44": {
            "start": 610.0,
            "end": 623.54,
            "transcript": "Kinerciamegteggu tau͡gken kinercirluku mermek ciqertaqa'aqluku."
        },
        "45": {
            "start": 625.62,
            "end": 636.16,
            "transcript": "Meciulluni pulalriatnun ayuqaqluni tamatum."
        },
        "46": {
            "start": 636.16,
            "end": 643.16,
            "transcript": "Tuatnanrian tau͡gaam nutaan kinrami mer'urcaarrluni qaingaa."
        },
        "47": {
            "start": 646.62,
            "end": 657.62,
            "transcript": "Kinerpailegmi qam'utuumi ilutuumarmi ak'anun mecungcauqerluni piliaqluni."
        },
        "48": {
            "start": 659.14,
            "end": 670.6,
            "transcript": "Kinermi tau͡gken ilutuumarmi nutaan mermek kuv'ikengraatni."
        },
        "49": {
            "start": 672.7,
            "end": 689.66,
            "transcript": "Ak'anun mecungyaurrni nutaan kenermun eggaatekluku neqnun piciatun eggaateklalliniat."
        },
        "50": {
            "start": 690.62,
            "end": 705.8,
            "transcript": "Tua-i qallarvak boil-aat pitengmianun neqnun piciatun-wa egaqameng tua-i aturluku."
        },
        "51": {
            "start": 706.62,
            "end": 721.48,
            "transcript": "Wii tamakunek pililrianga tangeqsaicaaqaqa tau͡gaam aanaurluma qanemcik'lallratun elliin tangtullrulliniamiki eggacilriit tamakut."
        },
        "52": {
            "start": 721.62,
            "end": 731.68,
            "transcript": "Qanellratun waniwa piitlemtun qanrutkaqa tua-i."
        },
        "53": {
            "start": 735.26,
            "end": 755.38,
            "transcript": "Tau͡gaam wii atunrinritgun, tamakut-ll' qikutleraat atunrinritgun, atunrinriatgun yuurtellruunga."
        },
        "54": {
            "start": 755.38,
            "end": 773.32,
            "transcript": "Cat tamarmeng eggatet qantat-llu caaskat-llu makut-llu pan-at inamelaarrlainaullruut alaiqerraallermeggni."
        },
        "55": {
            "start": 773.32,
            "end": 785.08,
            "transcript": "Aluminum-aat-llu piunateng, pan-at, caaskat-llu qantat, makuuvkenateng."
        },
        "56": {
            "start": 790.62,
            "end": 801.34,
            "transcript": "Minguligglainaat eggaatet, cainiit, qaltat-llu mertarcuutet."
        },
        "57": {
            "start": 803.64,
            "end": 813.48,
            "transcript": "Tau͡gaam atumangluku taum minguurtaqameng ak'anivkenateng ukinaurtut."
        },
        "58": {
            "start": 815.62,
            "end": 823.28,
            "transcript": "Tau͡gaam niitenglua ataam."
        },
        "59": {
            "start": 825.66,
            "end": 841.62,
            "transcript": "Aluminum-aanek-gguq ataam alairciciqut, kiputellriit-wa ilait qanerluni."
        },
        "60": {
            "start": 841.9,
            "end": 857.9,
            "transcript": "Aluminum-aat-gguq alaiqata tamakunek tunyaryaurciiqut tua-i ellailuteng maa-i aluminum pots coffee pots tamakut aluminum."
        },
        "61": {
            "start": 1039.62,
            "end": 1053.06,
            "transcript": "Ayuqevkenateng ilait anglanaqluteng. Yuratuut. (Arnait-llu putuluteng.)  Arnait-llu putulriamek atengqerrluteng."
        },
        "62": {
            "start": 1053.06,
            "end": 1056.28,
            "transcript": "Wavet naspaaluten."
        },
        "63": {
            "start": 1058.88,
            "end": 1071.62,
            "transcript": "Waten piaqameng yuralrianek acirpek'naki makut puallalrianek, puallalriamek atengqertut ukut."
        },
        "64": {
            "start": 1072.62,
            "end": 1085.04,
            "transcript": "Piciatun arulalartut pivtacimegcetun ayuqevkenateng puallaaqameng. (Ii-i.)"
        },
        "65": {
            "start": 1085.04,
            "end": 1097.84,
            "transcript": "Arnait-llu cali arnat piyugaqameng putuluteng. (Nang'arrluteng.)"
        },
        "66": {
            "start": 1097.84,
            "end": 1108.4,
            "transcript": "Maa-i tua-i tamakuugut yurarluteng, puallaluteng tuaten pilriit cayurrluteng."
        },
        "67": {
            "start": 1108.4,
            "end": 1119.7,
            "transcript": "Tamaa-i nunameggni piyuicaaqut makucit tau͡gaam niitellaraput qagkumiungulkiagut [?] tamakut. (Qagkumiuni-wa.)"
        },
        "68": {
            "start": 1119.7,
            "end": 1132.02,
            "transcript": "Ii-i cayurrluteng pilatuut. (Ii-i tamakuugut.) Cayurrluteng. Nunamteńi tau͡gaam waten nangermeng puallalriamek atengqertut."
        },
        "69": {
            "start": 1132.02,
            "end": 1142.32,
            "transcript": "Puallaluteng ayuqevkenateng yagirallra ilait yagirallra picirtaarluteng tuaten."
        },
        "70": {
            "start": 1142.32,
            "end": 1160.06,
            "transcript": "Anglanaqluteng ilait pilartuut puallaaqameng. Tuaten atengqertut piciatun nunat Qagkumiut cayurrluteng. Nangermeng waten. (Ii-i.) Cayurrluteng-gguq."
        },
        "71": {
            "start": 1160.06,
            "end": 1170.2,
            "transcript": "Erini tau͡ga wii puallalria ukum'i-ll' tau͡gaam tang tau͡ga Qagkumiunguluni puallaluni cayurutek-llu aturluni pituluteng. [?]"
        },
        "72": {
            "start": 1170.2,
            "end": 1174.66,
            "transcript": "Wii-llu nallunrit' [?] Qagkumiut amlleq."
        },
        "73": {
            "start": 1222.1,
            "end": 1226.62,
            "transcript": "Pikartaullra qanrutekluku. Makut."
        },
        "74": {
            "start": 1228.62,
            "end": 1240.02,
            "transcript": "Pilot Station-am kiatiini qiku carvaq atauciq makucimek pingqertuq."
        },
        "75": {
            "start": 1240.02,
            "end": 1256.5,
            "transcript": "Ateqluku-llu tuavet carvam qiku clay-arrlainarmek pik'evngilgem [?] eggateqarcaraaqluku."
        }
    },
    "uxz-q2ZiZvo": {
        "1": {
            "start": 14.6,
            "end": 19.82,
            "transcript": "Uitaurluten ata piniartuten. (Uitaurlua? Ii-i.)"
        },
        "2": {
            "start": 19.82,
            "end": 27.84,
            "transcript": "Yaa, waten piaqavet una meciirtelartuq tua-i. (Ii-i, neq'akenriqertaqama uumek pila'ar' [?])"
        },
        "3": {
            "start": 27.84,
            "end": 32.0,
            "transcript": "Nanluciirrluten tua-i. Kitak'."
        },
        "4": {
            "start": 37.06,
            "end": 50.12,
            "transcript": "Ciuqlirmek wani maavet-wa itqerraallerpeni qaillun makut, makut uitalriit tangllerpeki qaillun umyuarteqellrusit?"
        },
        "5": {
            "start": 50.12,
            "end": 59.1,
            "transcript": "Iillakellrukenka-wa tau͡gaam ak'allaullrat nalluvkenaku maavet itqarraallemni."
        },
        "6": {
            "start": 59.1,
            "end": 78.84,
            "transcript": "Iillakluki tangvallruanka makut ak'allaungata nallunrilamki cali piinii nunamteńi waten Kassauluni atengqerrluni Neqiacaagarmek, tauna Waskie Kass'atun, Yugtun-ll' Neqiacaagaq."
        },
        "7": {
            "start": 78.84,
            "end": 95.92,
            "transcript": "Makunek ak'allarnek qantanek-llu canek pilianek ak'allarnek kipuqluni, cunaw' maavet ayautlallinikai mat'umun, natmun qanrucuunata ayautlallerminek."
        },
        "8": {
            "start": 95.92,
            "end": 104.3,
            "transcript": "Imkut-llu nunamteńi ilagluteng nunam iluanek ak'allaat nalkutait tamakut cali ayautaqluki."
        },
        "9": {
            "start": 104.3,
            "end": 116.46,
            "transcript": "Yuut pillrit tamaani ciuqvani nunam iluanun aciqsigilriit tamakut nugtaqamteki iillaklaraput cali elagluki pilaamteki tamakut."
        },
        "10": {
            "start": 116.46,
            "end": 127.1,
            "transcript": "Ciuliamta au͡gkut sassuutekellrit-wa tua-i yuungnaqsuutekellrit iillaklaranka tamakut."
        },
        "11": {
            "start": 127.1,
            "end": 134.86,
            "transcript": "Cunawa maavet taitellallinikai taum Neqiacagamek, qagaani kipurqerraarluki nunamteńi."
        },
        "12": {
            "start": 137.0,
            "end": 148.16,
            "transcript": "Tekitellaami tauna Yugtun qantuluni amta-ll' Kass'auluni, Mamterillermek kingunengqellallruuq tamaani nunangqerrniluni."
        },
        "13": {
            "start": 148.16,
            "end": 160.88,
            "transcript": "Tua-llu cannery-ryaurcama amani Bristol Bay-ami tangturiluku tamaavet nugtartelliniluni, irniangqelliniluni-ll' paningqerrluni malrugnek nuliangqerrluni."
        },
        "14": {
            "start": 160.88,
            "end": 174.3,
            "transcript": "Taukuk irniak panik qanerturlutek Yugtun Kassaungeng' tangellrak, elliin elicetellruyugnarqai yugni uitauraulluki ak'anek ayagluni."
        },
        "15": {
            "start": 174.3,
            "end": 187.6,
            "transcript": "Tua-i kiani Marshall-aami apqaurteggunqarraallrulliniuq tauna Neqiacaagaq, commissioner-auluni apqaurtengauqarraallrulliniuq."
        },
        "16": {
            "start": 187.6,
            "end": 200.46,
            "transcript": "Tua-llu maa-i waten ellaita-w' piuranrilkuneng makut cataicartut. Tamana qaillun umyuaquteksiu?"
        },
        "17": {
            "start": 200.46,
            "end": 221.76,
            "transcript": "Cataicartut-qaa? Aulukestailkuneng-wa makunek cataicalriit tua-i makut tau͡gaam aulukluki, waten elluaqluki aulukluki uitaurcetliniamegteki tangerrnauvkaqait. Aulukestailkuneng cataitartut tangerrnauyanritut."
        },
        "18": {
            "start": 221.76,
            "end": 235.94,
            "transcript": "Tua-i tamatumek aulukestengqelliniameng maani assirluki pilalliniamegteki ak'allaungraata tua-i uitaurluteng navguumavkenateng. Quyanaqluni tangvallrat."
        },
        "19": {
            "start": 236.46,
            "end": 255.28,
            "transcript": "Tua-llu maa-i-wa waten akluluteng yuuguranrilnguut makut-llu yun'erraat-wa tangyuitellruluki, kuigpagmun tau͡gaam ut'rutellratni."
        },
        "20": {
            "start": 255.28,
            "end": 263.94,
            "transcript": "Tamana qaillun yugnun tangevkallrit paivtellrit umyuaquciu?"
        },
        "21": {
            "start": 263.94,
            "end": 277.58,
            "transcript": "Watua-qaa maa-i? Wangkuta-wa tua-i makutun yun'errartun ayuqenritukut. Makut young guys kass'artarnek aturluteng."
        },
        "22": {
            "start": 277.58,
            "end": 289.54,
            "transcript": "Wangkuta tau͡gken kass'artarnek aturpakayuunata. Miklicararrarnek tau͡gaam wii aturangqetullruunga tamaani engelqamnek pingqessuilata."
        },
        "23": {
            "start": 289.54,
            "end": 304.04,
            "transcript": "Cunawa laavkaat nurnallratni qiini kupcaartaitellrani-w' atauciq tau͡gaam atengqerrluni support [?], support-aamek."
        },
        "24": {
            "start": 331.02,
            "end": 344.7,
            "transcript": "Watua ava-i taq'erpailegmegnuk au͡gkut maa-i waten mikelnguut-wa makut capeqluki tangyuitellratnek."
        },
        "25": {
            "start": 344.7,
            "end": 355.38,
            "transcript": "Qaillun umyuarteqellrucin tamaani paivtellratki tamaani. (Ii-i, ak'a tamaani mikelnguut.)"
        },
        "26": {
            "start": 355.38,
            "end": 361.48,
            "transcript": "Mikelnguut maa-i tangyuilkait umyuartequciu qaillun ellaita tangerqallrit."
        },
        "27": {
            "start": 361.48,
            "end": 370.12,
            "transcript": "Ii-i, ii-i tamakunek wii ellillayuglartua [?] tangyuilemnun [?] mikelngurnek wangkucicetun kiartevkenateng."
        },
        "28": {
            "start": 370.12,
            "end": 384.08,
            "transcript": "Tau͡gaam tua-i, tua-i-wa tuaten ayuqluteng yuurtaqameng tangyuunateng qaill' pisciigatut tamatum nalliini."
        },
        "29": {
            "start": 384.08,
            "end": 391.46,
            "transcript": "Tau͡gaam Jesus-aam canritlermini tamakut tangyuitellret tangqerrsaurtevkatullrullriinii."
        },
        "30": {
            "start": 391.46,
            "end": 413.04,
            "transcript": "Alartua, alartuten. Au͡gkut wani tua-i-w' maa-i kinguqliput makut yun'erraat-wa makunek paivcilluki ellait tua-i tangevkarluki-wa ak'allanek pillrit wani tamatum tungiinun."
        },
        "31": {
            "start": 413.04,
            "end": 429.64,
            "transcript": "Oh, alartelliniunga. Tamakut-wa iillayuglartut makunek ak'allarnek tangrraqamek, qaillun-llu yuullrullratnek wii-ll' aptellaraatnga tut'garama-llu."
        },
        "32": {
            "start": 429.64,
            "end": 445.06,
            "transcript": "Tuaten-llu makut mat'um nalliini cassuutnek makunek cellangameng ellait qanerlartut, qaillun-llu ski doo-ngqerrlallemnek-llu."
        },
        "33": {
            "start": 445.06,
            "end": 459.82,
            "transcript": "Cali-llu kass'artaat makut qaill' piluki wangkutnun aturyaurtellrat. Pilaranka melqulek akiullrani tamakut tua-i kipulluki cat kass'artaat wangkuta."
        },
        "34": {
            "start": 459.82,
            "end": 466.78,
            "transcript": "Cikiutngunritut. Kipulluki tau͡gaam pituaput, atutuaput."
        },
        "35": {
            "start": 466.78,
            "end": 485.08,
            "transcript": "Taumek alarrluteng ellait tamatumek. Wangkutnun piksukluki tamakut tua-i ak'allaat waten-llu aptellaraatnga, \"Miklerpenek-qaa ski doo-cuarluten-llu pilallruuten?\" Ski doo-rtaitellruuq tamaani miklemteńi."
        },
        "36": {
            "start": 485.08,
            "end": 499.74,
            "transcript": "Tua-i makunek tau͡gaam cellangutemteńek-wa canek tua-i Yup'igtarnek aturturatullruukut ellangutemteńek, ellangellemteńi pilallritnek."
        },
        "37": {
            "start": 499.74,
            "end": 511.96,
            "transcript": "Qimugtet-llu tua-i makut eglertessukaqluki cellangaq' qimugtelilriamek-ll' tangssuunii. Tua-i pingayurrarnek qimugtengqerrnaurtuq yuk."
        },
        "38": {
            "start": 511.96,
            "end": 524.9,
            "transcript": "Cali-llu avani ciuqvani uitavkayuunaki, wavet tau͡gaam ikamrak caniagnun uyaqurratnun petukarluki ikayurtekluki ayautetullrulliniluki qimugtet."
        },
        "39": {
            "start": 524.9,
            "end": 549.1,
            "transcript": "Wii tau͡gaam takumni avaancaurtellruut ciuqvani. Qimugtet tua-i qanerlartut, pingayurrarnek-gguq tua-i qimugtelitullruuq tamaani cellangvailemta malrurrarpalluuk-gguq tua-i qimugteklukek ikayurtekluki ellaita."
        },
        "40": {
            "start": 549.1,
            "end": 565.96,
            "transcript": "Taum makut-llu ikamrat angelriaruvkenateng, canek tau͡gaam upagaqameng upagcuutait qamisviit angelriit, canun angyanun-llu pissuuteteng tamakut atuyuunaki."
        },
        "41": {
            "start": 565.96,
            "end": 573.34,
            "transcript": "Tuaten tau͡gaam upagaqameng aturluki, angyateng-llu ikamrirluki eglerutaqluki."
        },
        "42": {
            "start": 573.34,
            "end": 586.74,
            "transcript": "Tua-i tamana ayuqucillrat wii angunricaaqaqa avani ciuqvaarni tuaten piluteng pilallrat."
        },
        "43": {
            "start": 586.74,
            "end": 603.6,
            "transcript": "Tau͡gaam caunaki caskuunaki amllermek, nut'lek-ll' amllerpek'nani, makunek tau͡gaam pitganek narulkanek-llu tamakunek pissuutengqerrluteng."
        },
        "44": {
            "start": 604.02,
            "end": 620.06,
            "transcript": "Cali nunameggni maani negartura'arluteng, can'giirtura'arluteng, Kass'artarmek aturpek'nateng, wangkuta-llu amllermek Kass'artarnek neryuunata, mukaaq tua-i caarralaq-llu tamaani piuluni."
        },
        "45": {
            "start": 620.06,
            "end": 637.4,
            "transcript": "Tau͡ga caayutuqluteng-llu, caayuturyaurtellruunga wii anglirimkun tau͡gaam, imarrlugarnek tau͡gaam tua-i can'giiret-ll' imarrluit assikluki maa-i cali neqkellruamki tamaani can'giiret-llu imarrlugait."
        },
        "46": {
            "start": 637.4,
            "end": 651.2,
            "transcript": "Tua-i cat mulukuuq-llu nurnarluni, tau͡gaam tamakunek neqet imarrluitnek anglicaucirluta aanavet anglicallruut, aulukellruitkut."
        },
        "47": {
            "start": 651.2,
            "end": 659.12,
            "transcript": "Tua-i kaituluki cali wii angunritanka, kaiyuirutenratgun tau͡gaam cellangellruunga."
        },
        "48": {
            "start": 659.12,
            "end": 669.96,
            "transcript": "Tau͡gaam tamakut kaitulit wii nallunritlemni aanaurluma-llam tauna qetunrani."
        },
        "49": {
            "start": 669.96,
            "end": 688.54,
            "transcript": "Apa'urluqa-w' tauna pilallinia cellangan murilkengan ataki tauna yuucirkaanek qanrutaqluku yuungnaqucirkaanek waten-llu uitarrlainarniungaitelliuq."
        },
        "50": {
            "start": 688.54,
            "end": 706.4,
            "transcript": "Kiularaa-gguq taum apa'urluma upcungaamta, tamatumek wii qanrusngaitaqa nutengkuneng pissurluteng nut'galuteng yuularciqut wangkucicenun pitgaquluteng pingaitut."
        },
        "51": {
            "start": 706.4,
            "end": 721.52,
            "transcript": "Kass'artarnek aturluteng nutegnek ellmegnek pingnaq' kaingaitut tamakut alairluki, qanrutesciigaliirturlurlaraat tua-i aanamta tamatugmek kiugaqata, qanruquraasqessaaqluku."
        },
        "52": {
            "start": 721.52,
            "end": 738.44,
            "transcript": "Tau͡gaam cassuutnek tamakunek aturanek makunek-llu qayanek, tamakut tau͡gaam aturturcelluki tua-i, qimugtet-llu, qimugcirluki-ll' piuraturiluki."
        },
        "53": {
            "start": 738.44,
            "end": 749.5,
            "transcript": "Tamatum tua-i nalliini unaken-llu yaaqvanek Kass'artellriit Tununermek-llu Tacimun ayalriit tekiqlartut uksumi."
        },
        "54": {
            "start": 749.5,
            "end": 767.74,
            "transcript": "Mulumaluteng tua-i-w' tayima qimugteliyuilameng-ll' amllerneng. Cayaqlirluteng [?] utertaqluteng caayumek nutegcuukarkameggnek cuyarraqluteng tua-i aqvaluku tamana Tacimun keggani qevingatuat [?] Tacimi."
        },
        "55": {
            "start": 767.74,
            "end": 781.92,
            "transcript": "Maani tau͡gken nunamteńi Kass'artaunani, Kass'artangqessuunani, tamaavet tau͡gaam ayagaluteng Tacimun Kass'artarnek pingnaqaqluteng."
        },
        "56": {
            "start": 782.24,
            "end": 796.08,
            "transcript": "Tua-i tuaten wii cellangllemni ayuqellruut. Unarciarqurluteng, amaarrluteng, nemiarluteng, taluyanek angussuuciurluteng, tamakut nengnaqu'urluki."
        },
        "57": {
            "start": 796.08,
            "end": 809.74,
            "transcript": "Cali piirriluteng uliutnek, tuntut uliutaitnek piirriurluki, arnat kuvyakiurluki anguceteng tamakunek kuvyangqercetaqluteng, narrlutuunani-ll' kuvyaq kiagtarcuun."
        },
        "58": {
            "start": 809.98,
            "end": 824.46,
            "transcript": "Tua-i akimiarmek-ll' narrlirluki, narrlutulriit qilagaqamegteki, tau͡gaam pugtaucirluki uyatulria takellrianek elugluqussaalirluku-ll' pakemkaangraan [?]."
        },
        "59": {
            "start": 824.46,
            "end": 834.48,
            "transcript": "Civingavkatuluki camavet terr'anun neq'liqsuunateng-llu cunaw' neq'lituyaaqellrullinilriat tamaani."
        },
        "60": {
            "start": 835.5,
            "end": 843.14,
            "transcript": "Tua-i, tuaten nallunricetacimtun [?] qalartua ava-i, murilketacimtun."
        },
        "61": {
            "start": 843.14,
            "end": 854.18,
            "transcript": "Maavet, maavet call' taillren-wa camek quyatek'larciu?"
        },
        "62": {
            "start": 854.18,
            "end": 868.2,
            "transcript": "Yaa, [?] wall' mat'umek. (Ii-i.) Yaa, quyalartua cakneq taiqarraallemegni ikna-llu au͡g'um, Andy, Andy Paukan [?], taitellruakuk."
        },
        "63": {
            "start": 868.2,
            "end": 879.4,
            "transcript": "Camek wii nalluyaaqlua Mountain Village-amun anelrarlua aqvasteḿa tengssuutekun maaten ikna taiguq ikna quyalrianga cakneq."
        },
        "64": {
            "start": 879.4,
            "end": 895.4,
            "transcript": "Waten apeskatkuk ikayuqu'urlunuk qanerciqngamnuk, ikayuqciqngamku nallunritenruan wangni aturlallritni ak'allarnek quyalunuk tua-i maani ciuliamta aklui tangaaluki."
        },
        "65": {
            "start": 896.22,
            "end": 914.26,
            "transcript": "Quyamalartua tua-i, tuaten tua-i castuqukaqlarqa wii ikna ciuqliqngamku maani pektaqamnuk."
        },
        "66": {
            "start": 920.7,
            "end": 940.48,
            "transcript": "Ciumek qanerciqua Asaacaryami yuurtellruunga malruk-wa Kass'ak School-arta Umay'aq-llu, Charlie Umayaamek atengqerrluni."
        },
        "67": {
            "start": 941.78,
            "end": 954.24,
            "transcript": "Enet-llu tamarmeng loghouse-arrlainauluteng nunamek qaingqerrluteng."
        },
        "68": {
            "start": 957.28,
            "end": 970.5,
            "transcript": "Enait-llu nep'ut-llu usviingllemni [?] caputaunateng tamarmi qavarviit alaunateng."
        },
        "69": {
            "start": 972.78,
            "end": 988.3,
            "transcript": "Estuulucuarput-llu pingayunek kepuranek aqumllitarluni makut alaitevkenateng piliaraat estuulucuar carraq."
        },
        "70": {
            "start": 993.14,
            "end": 1005.86,
            "transcript": "Ellaturait tau͡gken, ellaturaput tau͡gken eggavinek [?] acirluki. Ellaturanek pivkenaki eggavinek [?]."
        },
        "71": {
            "start": 1005.86,
            "end": 1018.4,
            "transcript": "Imkut ciuqlimta angayuqaamta Kass'at pivailgata ellaturakun eggatullrulliniameng."
        },
        "72": {
            "start": 1022.42,
            "end": 1032.84,
            "transcript": "Kenirluteng eggan agarluku taumek eggavinek [?] atengqellruut ellaturat."
        },
        "73": {
            "start": 1035.82,
            "end": 1050.44,
            "transcript": "Tuaten tua-i kiagaqan-llu ketemteni tangllertaciluteng ker'angqerrluteng, fishrack-angqerrluteng."
        },
        "74": {
            "start": 1050.78,
            "end": 1057.6,
            "transcript": "Ellatmeggni-llu mamterarluteng tamaq'apiarmeng."
        },
        "75": {
            "start": 1057.6,
            "end": 1064.62,
            "transcript": "Uakarput tau͡gken qamanerpallraurluni Asaacaryam aciani."
        },
        "76": {
            "start": 1064.62,
            "end": 1078.58,
            "transcript": "Nangneqliuguq ingriq, ingrini Kuigpagmi nunavut, ingrim ateqluku taum Asaacaryaq."
        },
        "77": {
            "start": 1081.48,
            "end": 1097.02,
            "transcript": "Uum Ayam tau͡gaam tamakurmiunek piumek nuliarluni Kass'atun atngevkarluku Mountain Village nangneqliugan Kuigpagmi."
        },
        "78": {
            "start": 1097.62,
            "end": 1110.12,
            "transcript": "Tuaten tua-i ayuqukut qasgimi-llu qilagnaurtut kuvyarpagnek five pound, five pound, cunawa."
        },
        "79": {
            "start": 1111.04,
            "end": 1122.92,
            "transcript": "Number thirty six twine [?] caavkenateng, nalianauvkenateng [?] lodging cutting-at [?]."
        },
        "80": {
            "start": 1122.92,
            "end": 1137.96,
            "transcript": "Apqaurutnaurtut asngirkameng qavcinek tamana narrlirciu ilait pinaurtut uksumi asngiit taumeng qasgimi."
        },
        "81": {
            "start": 1137.96,
            "end": 1158.58,
            "transcript": "Akimiarmek-guq narrliraa qanernaurtut, ak'akika, naarrlutussila'alriit uqamaitelartut tegulallrat, tak'ullrat-llu."
        },
        "82": {
            "start": 1158.58,
            "end": 1168.5,
            "transcript": "Qula malrunek-gguq tau͡gaam naarrlivik pitalkellartuq."
        },
        "83": {
            "start": 1168.5,
            "end": 1184.9,
            "transcript": "Kuvyarpait king salmon net-at five pound amllertanaurtut angtalriamek takevkenateng-llu."
        },
        "84": {
            "start": 1184.9,
            "end": 1196.14,
            "transcript": "Apa'urluqa takuiyaqan maligtaqamku five-auluteng tuaten king salmon-at."
        },
        "85": {
            "start": 1196.14,
            "end": 1206.94,
            "transcript": "Pegnem eknaurai twelve miles pitangraan."
        },
        "86": {
            "start": 1208.62,
            "end": 1222.98,
            "transcript": "Kisngaaqluni neq'lirraqami kiak taumi nalliini neq'lirenrilami tau͡gken kisngaqtaraulriim [?]."
        },
        "87": {
            "start": 1223.7,
            "end": 1236.46,
            "transcript": "Mikuriqertaqata ukuk tau͡gaam ikuugken pugtautuk alaitaqluki."
        },
        "88": {
            "start": 1236.46,
            "end": 1251.94,
            "transcript": "Five pound taktauralria caaqapigtengluni [?] king salmon-aanek atrarnaurtuq cataunani elliqeryaraunateng."
        },
        "89": {
            "start": 1252.7,
            "end": 1268.44,
            "transcript": "Cavluteng tau͡gaam utqerrluteng, tuaten tau͡gaam pilallruut."
        }
    },
    "5GrgzHo-OSU": {
        "1": {
            "start": 2.74,
            "end": 16.61,
            "transcript": "Alerquutmek wangkuta elitaamteńek, cali-llu makut wani ayagyuat, cali-llu ayagyuarunrilnge'rmeng."
        },
        "2": {
            "start": 16.61,
            "end": 29.73,
            "transcript": "Tua-i-gguq yuk, yuk una, yuullmi-gguq taktaciatun camek-gguq eliqurararkauguq mat'um yuuyaram atutukiinek."
        },
        "3": {
            "start": 35.79,
            "end": 48.63,
            "transcript": "Wiinga yugnek elluatuneq anglillrunritua, tau͡gaam nurtekluteng mat'umun Kass'artaarmun."
        },
        "4": {
            "start": 48.63,
            "end": 62.88,
            "transcript": "Au͡gkuk tangvalleq ayuqellruuq, tau͡gaam cali alerquumanalqa ii nallunrita'arqa waniwa uumun-llu kalikamun ellivkallruaqa yuuma ayiitnun [?]."
        },
        "5": {
            "start": 62.88,
            "end": 80.82,
            "transcript": "Waniwa naaqsugngaaqa kingumek piyunarqutaciamtun nasvigniarqa [?]. Naaqut-llem? Ii-i."
        },
        "6": {
            "start": 253.29,
            "end": 260.54,
            "transcript": "Qaneryugtuten-am im' iciw' qaillun...?"
        },
        "7": {
            "start": 260.54,
            "end": 274.0,
            "transcript": "[?] yuilqumun ayaksuaraullemteńi alerquutengqelallruukut qanikciurunun ayaruq-llu malikesqelluku-llu."
        },
        "8": {
            "start": 274.0,
            "end": 290.93,
            "transcript": "Tua-i cam iliini ellaqerruskakut wall'u pellaakumta tauna ayaruq qaniksiurun-llu [?] aturciqniluku."
        },
        "9": {
            "start": 290.93,
            "end": 307.09,
            "transcript": "Au͡gkut yuullreurluut alerquilallruitkut yuilqum-llu ayuqucianek, man'a-llu neqallerruar' ellaanguaratesqevkenaku tau͡gaam kencikluku."
        },
        "10": {
            "start": 307.09,
            "end": 319.94,
            "transcript": "Waniwa uum kalikam ilii igautekellruyaaqa. Waniwa wangkuta mat'um nalliini qanelriamek niicuirutua."
        },
        "11": {
            "start": 319.94,
            "end": 331.47,
            "transcript": "Wangkuta avani ciuqvaani ciuliamta, ciuliamta-wa qanrutallruitkut qasgingqetullratni-llu qasgimi iluani."
        },
        "12": {
            "start": 331.47,
            "end": 341.06,
            "transcript": "Qasgiq-llu quyurviklallruat yuut tamarmeng nunacuaraat qavallemteńi [?] tamarmeng qasgirluteng."
        },
        "13": {
            "start": 341.06,
            "end": 351.61,
            "transcript": "Calissuutekluku, calivikluku, cali-llu quyurrvikluku wangkuta-llu ayagaulriani qalarucetullruitkut."
        },
        "14": {
            "start": 351.61,
            "end": 362.4,
            "transcript": "Watua maa-i [?] nalliini qanelriamun niicuirutua, mat'umek-llu ayuqucircuitput niicuirullua."
        },
        "15": {
            "start": 362.4,
            "end": 382.23,
            "transcript": "Man'a waniwa yuilqumun-llu ayagalalriani, au͡gkuk-llu tang angayuqaagma man'a meq atuusqellrunricaaqaat, wii tua-i nallukamku atu' maligcaqunallruagka."
        },
        "16": {
            "start": 382.23,
            "end": 397.37,
            "transcript": "Man'a-llu yuurqeryaraq inerquutekluku, yuilqumun tangvaileg' ayagyaurcama yuurqeryaaqellruunga. Camun-llu atuuciicaiqaa tamana."
        },
        "17": {
            "start": 397.37,
            "end": 408.59,
            "transcript": "Au͡gkut ciullrurluut qallerqualallrulliniitkut wangkuta kenek'amikun pitekluku-llu man'a elluarrluta pinarkarput."
        },
        "18": {
            "start": 408.59,
            "end": 425.9,
            "transcript": "Ava-i alertua uum nalliini ayuqucirtuaralrianga niicuirulluku [?], waniwa elluararyaaquq apau͡rluq qanercuucessgun piaqluki elluaraqluki pilaasqelluki."
        },
        "19": {
            "start": 425.9,
            "end": 440.7,
            "transcript": "Tau͡gaam cali piurteqelriartaitelartuq [?], tua-i-wa wangkurlumta-llu elluarluta tua-llu waten elitnauraallrunritukut, maa-i mat'um nalliini elitnauryalriacetun."
        },
        "20": {
            "start": 440.7,
            "end": 453.51,
            "transcript": "Wangkuta qanrucimalriaqellruukut maani nunam-llu qainga yuucirramteńek nunavet-llu una kencikesqelluku mertuuman."
        },
        "21": {
            "start": 453.51,
            "end": 473.92,
            "transcript": "Tua-i-wa wangkuta neqekngamteggu mer'em-llu cai neqii tangerrluku [?] kencikesqui sagcevkenaki, una-ll' neqallruamtararamta [?] tutmalriamek malrugmi yuarmun [?] elliqaallraat ilalluku-llu natmun."
        },
        "22": {
            "start": 473.92,
            "end": 487.97,
            "transcript": "Makut maa-i alerquatemta ilait, amllerrsaaqut tayima, wiinga-llu waten pellinge'rma tua-i umyuaqluku, waten nalluyagucugyaaqua."
        },
        "23": {
            "start": 487.97,
            "end": 501.58,
            "transcript": "Tau͡gaam yurluut tayim' maa-i alerquutput, watua-llu maa-i mat'um nalliini, tuarpiaq wangkuta iqlutmun-llu elitnaurvailartukut uum nalliini."
        },
        "24": {
            "start": 501.58,
            "end": 517.81,
            "transcript": "Tau͡gaam pingramta qanruyutput umyuaqluku, umyuaqluku-llu makut kinguliaput ayuqucirtuaraqluki pikumteki atawaayartuq wangkuta tegganerni unguvacuayaaqalemteńi."
        },
        "25": {
            "start": 517.81,
            "end": 525.96,
            "transcript": "Qanritevkenaki, uitatevkenaki qanrutaqluki, kituuniveknaki, allaunivkenaki."
        },
        "26": {
            "start": 525.96,
            "end": 538.72,
            "transcript": "Waniwa-llu una nalluyaguteksaitaqa [?] yuut kingunratgun yuugurciqellriat uum meaning-aaryaumallruut."
        },
        "27": {
            "start": 538.72,
            "end": 549.47,
            "transcript": "Waten pillinianga yugni piyuyuklua umyuarqesqellemni, tau͡gaam umyuaqa kanavirterrlainarluni."
        },
        "28": {
            "start": 549.47,
            "end": 566.24,
            "transcript": "Ellam-llu yuan tangvallinia umyugaa kanavigterrlainarluni pilria. Ucuvagtellria nanunricaaq'ngamiu [?] ucuvagtellria tangvanritaa tangvang'e'rmi ca tamalkuan."
        },
        "29": {
            "start": 566.24,
            "end": 582.93,
            "transcript": "Waniwa wiingaurluq waten ellirlua ukuni-ll' nunani ciulirnermek aprumalua, quyaunga-llu waniwa uum wani, uumek-wa tua-i piqallrat."
        },
        "30": {
            "start": 582.93,
            "end": 599.24,
            "transcript": "Au͡g'umek-llu ava-i qanqertua amllerrsaaquq qanruyuteput yuucikarput ilamteńun yuullrullemteńun, amllerrsaaqut qau͡gkuciullret [?] wangkut qanrut'lallrit."
        },
        "31": {
            "start": 599.24,
            "end": 609.32,
            "transcript": "Arcaqerluki elliraat wall'u pisciiganelnguut makut ikayuarluki akimek pivkenata."
        },
        "32": {
            "start": 609.32,
            "end": 626.62,
            "transcript": "Yuum-gguq umyugaa tukniuq tua-i cam iliini wii umyuartelartua anqialluga'artellriim aturciqsugyaarqa tuaten pilria yugni ikayualria akusrartarluni."
        },
        "33": {
            "start": 626.62,
            "end": 633.72,
            "transcript": "Wiinga-llu waniwa qalartua wiinga atullemnek piliam pivkenii."
        },
        "34": {
            "start": 633.72,
            "end": 642.36,
            "transcript": "Caqerlua tang unani imarpigmi anqiallugtellruukut pingayun [?] ekumaluta."
        },
        "35": {
            "start": 642.36,
            "end": 655.26,
            "transcript": "Tamaani imarpigmi qairem pia ukut kitngutellruikut, wiinga-llu camani mer'em iluani nanikuayiima caamek allamek umyuarteqenritua."
        },
        "36": {
            "start": 655.26,
            "end": 668.94,
            "transcript": "Aanama qanrutkellra umyuaqa neq'akaqa yuilqumun-llu natmun ayange'rma kiimecukeng'e'rma-gguq kiimetenritua."
        },
        "37": {
            "start": 668.94,
            "end": 684.26,
            "transcript": "Tamana umyuaqa kaigallruunga [?] mer'em iluani ikayuqaasqellua."
        },
        "38": {
            "start": 684.26,
            "end": 700.26,
            "transcript": "Pitsaqenritamci, nanikuar' umyuar' [?]."
        },
        "39": {
            "start": 700.26,
            "end": 716.26,
            "transcript": "Kaigallemni tau͡gaam assiilngurtung'e'rma niisgallrulliniama ikayualua-llu ikayuasqengameng, ukugnek-llu irr'ilartua maa-i mat'um-llu nalliini."
        },
        "40": {
            "start": 716.26,
            "end": 727.61,
            "transcript": "Mayullemni pikani yuum nullugem [?] nullruanga qulmun, amta-ll' ava-i yugtaunani,"
        },
        "41": {
            "start": 727.61,
            "end": 743.27,
            "transcript": "Man'a [?] neq'ala'arqa ilumun kaigallemni niitellrulliniama yuk tamarmi assiiteningraan assiilkingaitelliniuq."
        },
        "42": {
            "start": 743.27,
            "end": 754.68,
            "transcript": "Elliin atanemta taillruami, atiin taivkallruani wangkuta pitekluta assiilngurtulriani. Man'a cali umyuartelarnaurput."
        },
        "43": {
            "start": 754.68,
            "end": 764.69,
            "transcript": "Arca picautussiyaak [?] piviiqnata ilamteńun-llu qanqautaqluki ilaput-llu pilarnaurtukut."
        },
        "44": {
            "start": 764.69,
            "end": 774.89,
            "transcript": "Waten pitaaqa amllerissiyaalria wiinga umyuaqsuilamku nalluyagucukamun [?] quyana cakneq."
        }
    },
    "khHHc_ACqlA": {
        "1": {
            "start": 0.77,
            "end": 8.8,
            "transcript": "Tan'gurraat-wa tamana maa-i mat'umi maa-i navguutekaat."
        },
        "2": {
            "start": 8.8,
            "end": 18.63,
            "transcript": "Yuulleq una wani tuarpiaq nanilicarluku mat'ukun inerciigatlermegteggun."
        },
        "3": {
            "start": 18.63,
            "end": 32.4,
            "transcript": "Tua-i imkut qanrutetullruitkut yuk-gguq niicuilkuni qanerciigalkuni qanrun atunrilkuniu yuullra yaaqvanun ayagngaituq."
        },
        "4": {
            "start": 32.4,
            "end": 42.37,
            "transcript": "Taumek tuaten aarutet tua-i-wa inerqutullruitkut tuaten pisqelluta."
        },
        "5": {
            "start": 42.37,
            "end": 57.37,
            "transcript": "Tamana inerquun-wa tamana ellaita inerquun atuusqelluku una yuullerput uitaqaasqumaluku qunukluku."
        },
        "6": {
            "start": 57.37,
            "end": 72.28,
            "transcript": "Tua-i maa-i maani canek avani ciuqvaarni niicuicaaqluta tamakunek cayaranek cali yuut ellmeggnek akngirqelluteng-llu waten yuullerteng iquklicuitellruat."
        },
        "7": {
            "start": 72.28,
            "end": 80.44,
            "transcript": "Tamakunek tamaa-i watua tamana tuarpiaq tua-i amlleriqapigtuq."
        },
        "8": {
            "start": 80.44,
            "end": 89.5,
            "transcript": "Tua-i makut tan'gurraraat tamatum, cat mat'um-llu melullermek mat'umek ayalgunarqellriamek."
        },
        "9": {
            "start": 89.5,
            "end": 100.98,
            "transcript": "Cali mat'umek taangamek tamakut tamaa-i tamakut mat'umun navguutekait-wa maa-i."
        },
        "10": {
            "start": 100.98,
            "end": 110.21,
            "transcript": "Tamakunek pitangqellrunrituq avani wangkuta yuungnaqlemteńi tamana nurnallruuq."
        },
        "11": {
            "start": 110.21,
            "end": 118.17,
            "transcript": "Cali maa-i qanruteng'e'rmeng niicuirutut makut irniaput nakleksaaqluki."
        },
        "12": {
            "start": 118.17,
            "end": 126.1,
            "transcript": "Tau͡gaam anqiatuq ellaita piullerteng aturluku eglengameng mat'ukun state law man'a."
        },
        "13": {
            "start": 126.1,
            "end": 138.83,
            "transcript": "Man'a-wa state law puqigiameng makut tan'gurraat imna wangkuta ak'a avani piciryarallerput pinikenriraat."
        },
        "14": {
            "start": 138.83,
            "end": 156.31,
            "transcript": "Tau͡gaam ellaita nallunritlermegteggun elisngallermegteggun maa-i neglengameng [?] tamana-llu waten inerquqtangramceteng man'a piciryararput ak'allaq piciunritniluku ilait tua-i kiulartut."
        },
        "15": {
            "start": 156.31,
            "end": 166.92,
            "transcript": "Tau͡gaam elitellermegteggun elisngangameng watua maaggun school-akun cat-wa bylaw-t-wa makut."
        },
        "16": {
            "start": 166.92,
            "end": 174.07,
            "transcript": "Ellaita maa-i state-aurcami tamaaggun neglengameng caperrnariut."
        },
        "17": {
            "start": 174.07,
            "end": 183.107,
            "transcript": "Tamatumek watua qunuksaaqluki makut yunerraraat tuaten-wa pisqenricaaqluki."
        },
        "18": {
            "start": 183.107,
            "end": 189.387,
            "transcript": "Tua-i tau͡gaam tua-i aturlararput piunrilengremteggu tua-i."
        },
        "19": {
            "start": 196.0,
            "end": 218.893,
            "transcript": "Watua maa-i avani ciuqvaarni imkut inerqutullruitkut waten-llu yugmek-llu akngirkengluta yuullra tua-i-w' iquklicetqumavkenaku maaggun inerquutekut."
        },
        "20": {
            "start": 218.893,
            "end": 226.147,
            "transcript": "Tamana iquggliqniluku tua-i tamana alerquuteksaaqluku."
        },
        "21": {
            "start": 226.147,
            "end": 240.04,
            "transcript": "Tau͡gaam maa-i tamana-wa alairiinartuq, tamana man'a-wa mat'um nuna."
        }
    },
    "Uer-AItnthI": {
        "1": {
            "start": 59.0,
            "end": 61.64,
            "transcript": "Cama-i wii Alaalaugua."
        },
        "2": {
            "start": 61.64,
            "end": 69.04,
            "transcript": "Waniwa niiteqatartuci tegganret quyurtellritnek piciryarallritnek cali yuuyarallritnek ak'arrar."
        },
        "3": {
            "start": 69.04,
            "end": 74.54,
            "transcript": "Ukut quyurtellruut Kepnercim iraluani March 1982."
        },
        "4": {
            "start": 77.34,
            "end": 90.76,
            "transcript": "Angun ciumek umyuangetuuq aipangnaluni twenty one years-arluni wall'u-qaa ciguaraani [?]."
        },
        "5": {
            "start": 90.76,
            "end": 100.9,
            "transcript": "Twenty one years-arluni tuaken ayagnirpallurluni arnamun umyuarteq'lartuq."
        },
        "6": {
            "start": 100.9,
            "end": 120.66,
            "transcript": "Una-llun angun arnaq cali una, arnaq cali una eighteen years wall'u-qaa six seventeen years pitariluni umyuangeciquq angutmek."
        },
        "7": {
            "start": 120.66,
            "end": 129.4,
            "transcript": "Tau͡gaam angun, arnaq una yaqingaituq angutmek uikaminek aiparkaminek."
        },
        "8": {
            "start": 129.4,
            "end": 138.28,
            "transcript": "Nutaan eighteen years-aq only nutaan kassuuteng'e'rmi cavkenani atawaluni kemga pinirniartuq."
        },
        "9": {
            "start": 138.28,
            "end": 147.74,
            "transcript": "Tuaten kassuupailegmek taukuk angutem arnat yuarciqai umyuamikun."
        },
        "10": {
            "start": 147.74,
            "end": 158.7,
            "transcript": "Umyuartungnaqsarauguq arnaq aipangnaluni pilriani tangerrminarpegnaku, kegginaqegcillra tangvagpegnaku."
        },
        "11": {
            "start": 158.7,
            "end": 170.08,
            "transcript": "Qaikegcillra tangvagpeggnaku, qamna tau͡gaam iluakun yuvrirluku caurallrakun mat'ukun kangingengciiqellinia."
        },
        "12": {
            "start": 170.08,
            "end": 176.82,
            "transcript": "Tua-llu piinanermini elpengcarciqaa kiimetqerluni."
        },
        "13": {
            "start": 177.0,
            "end": 188.88,
            "transcript": "Angun-llu cingarangaitqapiarluku, cingarqerngaitqapiararaa, cingausngaituq atunem tass'uqsugngayaaquk erenrani."
        },
        "14": {
            "start": 188.88,
            "end": 200.0,
            "transcript": "Nutaan ciuniuqani angengqani arnam nutaan unilluku."
        },
        "15": {
            "start": 200.0,
            "end": 217.88,
            "transcript": "Uniteqataquniu piciqaa kitaki wangkunek yuvriurqernaurtuq allaaliurpegnani ayuqucimegnegnun tau͡gaam tuatnaurlutek piurqunek."
        },
        "16": {
            "start": 217.88,
            "end": 229.68,
            "transcript": "Atam tekitellininiartuq kassuumariluteng, kassuumarillmek kinguani qaillun ayuqellerkartek."
        },
        "17": {
            "start": 230.0,
            "end": 246.0,
            "transcript": "Atam tekitellininiaraak tamakut au͡gkut irniangekunek-llu qaill' ayuqucirkartek atunem apqaurullutek piarkaulliniuq aipaqutellriik."
        },
        "18": {
            "start": 246.0,
            "end": 261.0,
            "transcript": "Ilumun arnaq yuarciigatuq, niicetullruunga tan'gurraullemni arnaq yuarciigatuq, ayuquciqellilria pilallinilua, maaten piaqa maa-i kangingengqa kinguakun."
        },
        "19": {
            "start": 261.0,
            "end": 278.12,
            "transcript": "Kitaki taukuk kassuuskunek nutaan kassuuskilik tauna arnarnun nunaniryullertek kesianek irrsaqurmiutaqluku unguvaqallermek taktaciatun navguutenritniartuk."
        },
        "20": {
            "start": 278.22,
            "end": 288.08,
            "transcript": "Tua-i-w' angutem taum qanruskakut wangkutni arnarni aipangqatalriani."
        },
        "21": {
            "start": 288.08,
            "end": 302.72,
            "transcript": "Angutem qanruskakut umyuarteqciqurluku wangkuta. Qaillun waniw' piniarcia, qaill' pilua kassuusngaciiqsia qaill' ayuqlua?"
        },
        "22": {
            "start": 302.72,
            "end": 312.14,
            "transcript": "Waniwa una aiparkaqa, ilumun aipaqsukanga aipaqkumku qaillun-kiq waniw' aipaqniarcia?"
        },
        "23": {
            "start": 312.14,
            "end": 322.0,
            "transcript": "Nutaan apluku. Naamikika elpet qaillun tayim' ayuquciqa tangvagceńun?"
        },
        "24": {
            "start": 323.38,
            "end": 336.82,
            "transcript": "Tua-i tayim' tangvagpek'naku-ll' tayima tauna aiparkani, kalikakun tau͡gaam tua-i elliin piluku."
        },
        "25": {
            "start": 336.82,
            "end": 345.0,
            "transcript": "Tua-i-ll' nutaan arnaq tauna watua umyuarteq'lartukut qaill'-kiq waniwa piniarcia?"
        },
        "26": {
            "start": 345.92,
            "end": 359.76,
            "transcript": "Waten ayuqelliniuq angun. Nulirqutqerraalriik ukuk imutun mulngalarqeqapiaralriatun ayuqelliniuq."
        },
        "27": {
            "start": 362.02,
            "end": 377.56,
            "transcript": "Una makut nasaurluut arcaqerluteng ukvertalliniuq, ukveryukaaralliniuq tamarmeng tayima qaqilluteng pinricaaqut."
        },
        "28": {
            "start": 377.56,
            "end": 385.62,
            "transcript": "Angutem iqlukani, uingqeng'e'rmi nuliqsugluku."
        },
        "29": {
            "start": 385.62,
            "end": 397.4,
            "transcript": "Ukverluni uini tauna cakaarciqlinia ilumun piyukluni tauna."
        },
        "30": {
            "start": 397.4,
            "end": 413.58,
            "transcript": "Maa-i nulirqutellriim, nulirqutellriik navguutek, ilii-llu uingqeng'e'rmi allam piniaran qingaraqluni."
        },
        "31": {
            "start": 413.58,
            "end": 426.5,
            "transcript": "Tamaa-i iqluralriim-gguq caliaraa angutet qanrutkumauq wangkutni yugni avaken ayagluteng."
        },
        "32": {
            "start": 426.5,
            "end": 436.62,
            "transcript": "Taumek qanruyutengqertukut avaken ciuliamteńek ayagluta waten."
        },
        "33": {
            "start": 436.62,
            "end": 446.86,
            "transcript": "Nulirquskiluk-gguq nulirqa-llu navguutevkenani ciuqlirem ava-i qanellrucia."
        },
        "34": {
            "start": 446.86,
            "end": 459.56,
            "transcript": "Maligtaquuraulluku, maaten-llu bible-aartangan bible-aat naaqsaurtaput man'a cali nutem piullinilria."
        },
        "35": {
            "start": 459.56,
            "end": 474.0,
            "transcript": "Tua-llu maligtaqutenrilnguuq tanglaraput maa-i maligtaquurautenrilnguut nulirqellriit."
        },
        "36": {
            "start": 474.0,
            "end": 487.76,
            "transcript": "Kapusnganrilngermek-llu maligtaquurautenrilnguuk nuniik hospital-aam qanrutkellratun."
        },
        "37": {
            "start": 487.76,
            "end": 502.84,
            "transcript": "Eniinun-llu ilaa nunanirpek'nani, cakek-llu aklukek assirpek'nani."
        },
        "38": {
            "start": 502.84,
            "end": 512.84,
            "transcript": "Maa-i maligtaquurautenrilnguuk nuniirqellriik tangerrnaqlutek ayuquciat."
        },
        "39": {
            "start": 512.84,
            "end": 523.14,
            "transcript": "Taumek ciuqliuyaaquq una, maligtaquuraullemnuk-llu nulirqa-llu nulirquskinuk."
        },
        "40": {
            "start": 523.14,
            "end": 531.06,
            "transcript": "Maligtaqutenrilkumegnuk-gguq ca-gguq tamarmeng elluarngaitut."
        },
        "41": {
            "start": 531.06,
            "end": 542.92,
            "transcript": "Avani ciuqvani waten tan'gurraq nasaurluq-llu ayuqellruuk."
        },
        "42": {
            "start": 542.92,
            "end": 558.28,
            "transcript": "Una tan'gurraq nulirkaminek nalluluni, una-ll' cali nasaurluq uikaminek nalluluni."
        },
        "43": {
            "start": 558.28,
            "end": 564.78,
            "transcript": "Tua-i angayuqameggnek niisngaillermeggni."
        },
        "44": {
            "start": 564.78,
            "end": 574.14,
            "transcript": "Tua-llu tauna tan'gurraq angayuqaagken nulirtuusqumangamegnegu."
        },
        "45": {
            "start": 574.14,
            "end": 585.26,
            "transcript": "Tauna yurteq [?] aptevkenaku elkenka [?] tau͡gaam yuucuqtaarraarluki."
        },
        "46": {
            "start": 585.26,
            "end": 598.56,
            "transcript": "Aglumakekpegnek elliinun caliarkamek, elliinun maligtaqutarkamek elluarrluni-llu taumun qetunraarminun piarkamek."
        },
        "47": {
            "start": 598.56,
            "end": 608.22,
            "transcript": "Tauna qetunrartek aptevkenaku nulirkartelallrullinikiik tamaani."
        },
        "48": {
            "start": 608.22,
            "end": 621.72,
            "transcript": "Tauna-llu nasaurluq tua-i umyuani nall'artenrilengraan angayuqaagmi kalmaqagni tuavet."
        },
        "49": {
            "start": 621.72,
            "end": 630.4,
            "transcript": "Watqapiar umyuani aturciiganaku, umyuani aturpek'naku aipangluni taumek."
        },
        "50": {
            "start": 630.4,
            "end": 641.84,
            "transcript": "Tua-i-gguq tuaten aipaqliutaqamek ciuqlirmi nallucamek-wa tua-i."
        },
        "51": {
            "start": 641.84,
            "end": 648.14,
            "transcript": "Ciungani-llu malkuussaaguteksailameng."
        },
        "52": {
            "start": 648.14,
            "end": 656.02,
            "transcript": "Wangkuta nallumteńi ciuqvaarni avani, aarutnguqapiarallruuq arnaq."
        },
        "53": {
            "start": 656.02,
            "end": 663.44,
            "transcript": "Nulirturpailemta agu arniuresqevkenata inerquungallruukut."
        },
        "54": {
            "start": 663.44,
            "end": 669.6,
            "transcript": "Tau͡gaam yuut iqlungraameng, iqlungapigtelliniameng."
        },
        "55": {
            "start": 669.6,
            "end": 679.26,
            "transcript": "Ilateng piksailengraata iqluqutek'lallruit, iqluqutektullrulliniut avani."
        },
        "56": {
            "start": 679.26,
            "end": 689.18,
            "transcript": "Tua-i taukuk tuaten kenkutqapiarpek'natek ciuqlirmi pitulliniuq."
        },
        "57": {
            "start": 689.18,
            "end": 698.5,
            "transcript": "Nutaan-llu nallunriu camek nulirput-ll' [?] kinguani."
        },
        "58": {
            "start": 698.5,
            "end": 707.0,
            "transcript": "Nutaan taukugni kenka uitatulliniuq."
        },
        "59": {
            "start": 707.24,
            "end": 715.02,
            "transcript": "Tua-i-wa nutaan kenkullutek yuungnaqlerkartek nallunrirluku."
        },
        "60": {
            "start": 715.02,
            "end": 725.78,
            "transcript": "Tua-llu taukuk, taukuk tegutuk imkuk au͡gkuk waten ciungani, ciungani kenkuruteksaunatek."
        },
        "61": {
            "start": 725.78,
            "end": 747.58,
            "transcript": "Nutaan tegucagnek angayuqerrulriim qalarutqataraak waten arnaq qalarutaa ciumek. Kitaki tauna uini, uikevkiu waten ayuqluten."
        },
        "62": {
            "start": 747.58,
            "end": 758.98,
            "transcript": "Qikirtevkenaku arnaullgutuvnun-llu ellilarpek'naku."
        },
        "63": {
            "start": 759.84,
            "end": 774.96,
            "transcript": "Arnaullgutevnun ellilaquvgu elpenek uitangqercillerkan avitellriatun ayuqeciqaa."
        },
        "64": {
            "start": 774.96,
            "end": 788.76,
            "transcript": "Tuamta-llu angutii au͡g'utun qanrulluku kitaki tauna nulian aipan aipaqkiu."
        },
        "65": {
            "start": 788.76,
            "end": 795.44,
            "transcript": "Angutnun-llu ellilaqsaunaku."
        },
        "66": {
            "start": 795.44,
            "end": 809.26,
            "transcript": "Tau͡gaam iiqapiaraagpenun elpet angllerpegun, angutmek allamek pikan tuani tau͡gaam ukveqina."
        },
        "67": {
            "start": 809.26,
            "end": 815.54,
            "transcript": "Ukuk-gguq nulirqutqerraalriik pillugcetaakek amllertut."
        },
        "68": {
            "start": 815.54,
            "end": 829.72,
            "transcript": "Pillugcilriit-gguq yuut cailkaat amllertut, arnat makut alingcircuutngullruut wangkutnun. Maa-i nalleqlima nallunritai."
        },
        "69": {
            "start": 829.72,
            "end": 844.92,
            "transcript": "Agu waten caniqsissaagluku-llu pisqevkenaku, ellami-llu qagaani tungiinek anuqlillalria."
        },
        "70": {
            "start": 844.92,
            "end": 852.04,
            "transcript": "Yaalinerkun tau͡gaam kituusqelluku asgulirlerakun."
        },
        "71": {
            "start": 852.04,
            "end": 863.72,
            "transcript": "Maa-i au͡gkut tua-i ellangvillemta qalaruyutait, qalarut'lallruitkut tua-i cat tekilluku."
        },
        "72": {
            "start": 863.72,
            "end": 872.3,
            "transcript": "Tuarpiaq elagarluteng, tua-i imna camani aciqvanelnguq tekilluku."
        },
        "73": {
            "start": 872.3,
            "end": 880.36,
            "transcript": "Tamaani wangkutnek yuk ellminek saskukellruuq."
        },
        "74": {
            "start": 880.36,
            "end": 896.18,
            "transcript": "Tua-i-gguq arnaq tauna narkuniu, au͡gna wani ciunerkaqegtaarani tan'gurraam iliin navtua."
        },
        "75": {
            "start": 896.18,
            "end": 902.46,
            "transcript": "Tamana pitekluku tuaten inerquusngalliniuq arnaq."
        },
        "76": {
            "start": 902.46,
            "end": 911.32,
            "transcript": "Yuungnaqesciigan, yuungnaqellra elluatuuvkenani, elluatuugarkauvkenani."
        },
        "77": {
            "start": 911.32,
            "end": 919.98,
            "transcript": "Ava-i-llu qanrutkeqara neqkarcullra-llu natrianani, callra tamarmi elagirpek'nani."
        },
        "78": {
            "start": 919.98,
            "end": 929.96,
            "transcript": "Tamana pitekluku, elakinritlerkaa pitekluku inerquusngauq tuaten arnaq nulirturpailgan."
        },
        "79": {
            "start": 929.96,
            "end": 936.58,
            "transcript": "Yun'errarmun nulirturpailgan arnaq malkuussaagasqevkenaku."
        },
        "80": {
            "start": 936.58,
            "end": 951.74,
            "transcript": "Tua-llu cakingqelartuq ilii arnam wall'u tan'gurraam tan'gurraq cakingqerrluni."
        },
        "81": {
            "start": 951.74,
            "end": 960.56,
            "transcript": "Tamaa-i cali inerquutnguuq, wiinga-gguq panika aipangkan."
        },
        "82": {
            "start": 960.56,
            "end": 968.84,
            "transcript": "Ataniussiiyaanrilkilaku, tua-i cat-llu elluarrluni pillerkaakun ataniungramkek."
        },
        "83": {
            "start": 968.84,
            "end": 981.24,
            "transcript": "Tau͡gaam maaggun kenkutellrak man'a navtellerkaak pitekluku, tamana-gguq ataniussiiyaanrilkilaput qetunrarput wall'u panigput."
        },
        "84": {
            "start": 981.52,
            "end": 992.12,
            "transcript": "Ava-i-w' tua-i au͡gna waten qanruyutem iqua kangia, kitaki nulirqusquvtek."
        },
        "85": {
            "start": 992.12,
            "end": 1000.02,
            "transcript": "Nulian kenkekiu, wall'u uingekuvet uin kenkekiu tamaa-i."
        },
        "86": {
            "start": 1000.02,
            "end": 1018.1,
            "transcript": "Aipaqutellriik arnaq angun-llu yuum-ll' angcarturciqak pistekaken, wall'u-q' angayuqaken kallangcarturciquk qanqaullukek."
        },
        "87": {
            "start": 1018.1,
            "end": 1031.66,
            "transcript": "Imumun maliguskunek ellmegnun tau͡gaam qanruyutarkauguk, arenqialligutegtek aruliartengnaqlukek."
        },
        "88": {
            "start": 1031.66,
            "end": 1051.46,
            "transcript": "Ellmegnun, ellmegnun tau͡gaam elluarrlutek calitarkauguk, tuaten tau͡gken maligtaqutunrilkagnek pistekakenka nallunritestekegenka qanrutaqluku ellangcartuqa'aqluku piarkaugai."
        },
        "89": {
            "start": 1051.46,
            "end": 1067.82,
            "transcript": "Yugni wangkuta wangkutnek ilautlerput iliini nallulararput assirluta canganaunata ilua ayuqluta umyuarteq'laryaaqukut tamamta ayagyuat nallmegteggun pivkenatek ukivtequngermi."
        },
        "90": {
            "start": 1067.82,
            "end": 1082.2,
            "transcript": "Yuum-llu cailkaam tangerquniki qanenrilengraan caurallrakun egilriikun taingluku, una tang waten pitullinilria, arumata aipani waten pitullinikii."
        },
        "91": {
            "start": 1082.2,
            "end": 1094.44,
            "transcript": "Tuaten, tuaten tamakunun qanaalluku pilaqunek pikunek yuilngiqaullukek yugnun niiteqarpek'nani."
        },
        "92": {
            "start": 1094.44,
            "end": 1108.26,
            "transcript": "Yugnun niiceterluteng yugnek qanrucet'engqerqunek taukuk, ellmegneng nallunrilamek atawaunritellra ellmegnun uumikutellriatun ayuqngamek."
        },
        "93": {
            "start": 1108.26,
            "end": 1116.36,
            "transcript": "Umyugaak ikayurciquq niicet' tamakut yuut piteklukek."
        },
        "94": {
            "start": 1116.36,
            "end": 1123.0,
            "transcript": "Tau͡gaam kiirraraan, kiirraraakenka qanqaullukek carrarmek ellangkartuqerlukek."
        },
        "95": {
            "start": 1123.0,
            "end": 1135.92,
            "transcript": "Nutaan ellam yugngakunek ellangareskunek wangkuk tang kiimeteqerlutek, kiimenatek piciquk ellmegnun caullutek."
        },
        "96": {
            "start": 1135.92,
            "end": 1150.22,
            "transcript": "Wangkuk tang iqlutmun ayallinilriakuk, ataki tang wangkunek kitugglunuk man'a egilrallerpuk, kassuusngallerpuk elluartellria ullaglarpuk."
        },
        "97": {
            "start": 1150.22,
            "end": 1159.0,
            "transcript": "Tuaten maligngatellria ilii tuaten kitugtarkauralput elluarrlutek."
        },
        "98": {
            "start": 1159.12,
            "end": 1168.9,
            "transcript": "Yuum iliin qanruyutni qalaruyutni taringluku maligtetullinia."
        },
        "99": {
            "start": 1168.9,
            "end": 1182.32,
            "transcript": "Tua-i-llu nulirqellriyug' tua-i kenkuterrlainarlutek piyuilamek cam iliini arenqiallugciiqelliniuq."
        },
        "100": {
            "start": 1182.32,
            "end": 1192.92,
            "transcript": "Tua-llu tamarkenka angun tauna qalarucimaarkaulliniuq."
        },
        "101": {
            "start": 1192.92,
            "end": 1203.68,
            "transcript": "Tuaten tamana avvucullrak atuqaku elluatuungaitni yuk assirngaitniluku."
        },
        "102": {
            "start": 1203.68,
            "end": 1225.0,
            "transcript": "Tuamta-llu cali arnaq qalarucimaarkaulliniluni tamana avvutmek umyuarteqellra tamana elliinun atawaungaitniluku, ikayuutngungaitniluku-llu."
        },
        "103": {
            "start": 1225.12,
            "end": 1232.8,
            "transcript": "Cali-llu tamaa angutmun aglumangaitniluku."
        },
        "104": {
            "start": 1232.8,
            "end": 1247.5,
            "transcript": "Tuamta-llu cali angun qanrucimaluni tuaten nulirra uniskaku arnamun ukaqvaggun aglumangaitniluku."
        },
        "105": {
            "start": 1247.5,
            "end": 1263.7,
            "transcript": "Tua-i-llu ukvertaqunek tamarmek qanruyutsik, qalaruyutsik waten elluatuunritqaarlutek."
        },
        "106": {
            "start": 1263.7,
            "end": 1279.28,
            "transcript": "Qanruyutmegen'gun tau͡gaam ayuqucirtuutmegen'gun imutun tumarilriatun wall'u tangenqegcinarilriatun ilukegcinarilriatun-llu ayuqerkaulliniuq."
        },
        "107": {
            "start": 1279.28,
            "end": 1294.72,
            "transcript": "Tau͡gken-am aipaak angun qanrucesciigalkuni arnii tauna qanruyutmun maligucaaqeng'e'rmi angun maligutenrilkan."
        },
        "108": {
            "start": 1294.72,
            "end": 1302.2,
            "transcript": "Tua-i tauna angun imutun ellminek ikayunrilngurtun ayuquq."
        },
        "109": {
            "start": 1302.2,
            "end": 1318.56,
            "transcript": "Tuamta-llu cali arnaq ukvenrilkuni, ukvekenrilkuniu ikayuucini qalaruyutekun tuamta-llu ellminek ikayurpek'nani ellminek-llu qaralililriatun ayuqluni."
        },
        "110": {
            "start": 1319.7,
            "end": 1328.7,
            "transcript": "Qingaqatararqamta inerquumatukiikut. Yuk alaiqatararqa."
        },
        "111": {
            "start": 1328.7,
            "end": 1337.28,
            "transcript": "Tua-i qingausqelluta cakviusqurluta [?] aaqataraasqevkenata."
        },
        "112": {
            "start": 1337.28,
            "end": 1349.36,
            "transcript": "Tua-i cakviurturluta imumek cakviurutkurluku-w' tuani iciw'."
        },
        "113": {
            "start": 1349.36,
            "end": 1357.46,
            "transcript": "Maa-i qingaqerraalriit makut aaqata'arturluteng ilait pilalriit camek niiskengaileng'e'rmi."
        },
        "114": {
            "start": 1357.46,
            "end": 1363.72,
            "transcript": "Avani tau͡gaam wangkuta qingaqatarallemteńi aaqataraasqumavkenata."
        },
        "115": {
            "start": 1363.72,
            "end": 1375.46,
            "transcript": "Cali-llu unuakumi egmian yuut tupagpailgata, pek'ngarpailgata egmian anengnaqa'artesqelluta."
        },
        "116": {
            "start": 1375.46,
            "end": 1384.32,
            "transcript": "Tuamtellu ankumta anqatarluta imumek uyangqauraqaqumta inerqurluta."
        },
        "117": {
            "start": 1384.32,
            "end": 1395.18,
            "transcript": "Tua-i-gguq anqata'arqameng uyangqauralaaqumta."
        },
        "118": {
            "start": 1395.18,
            "end": 1404.78,
            "transcript": "Anesciiganateng waten kegginakaarluteng uitaurciqut, imutun amiigmi wangkuta uyangqaurallemcetun."
        },
        "119": {
            "start": 1404.78,
            "end": 1411.36,
            "transcript": "Anesciiganateng uitaurciqut canramceteng tuani tua-i cayaqlirluteng anluteng."
        },
        "120": {
            "start": 1411.36,
            "end": 1423.16,
            "transcript": "Tuamtellu maaken tegulluta [?] carraarluta pirraar' elatmun eggluku ellamun waken amigmek."
        },
        "121": {
            "start": 1423.16,
            "end": 1431.64,
            "transcript": "Eggluku egeskumteggu wagg'uq tua-i ciulicugluteng."
        },
        "122": {
            "start": 1431.64,
            "end": 1443.6,
            "transcript": "Yugtun aknirnarqetaluteng anqerrluteng taukut alqunarmek qamaken ciuvani taum yuum anqerreskan akngirrluni cakneq."
        },
        "123": {
            "start": 1443.6,
            "end": 1456.0,
            "transcript": "Tua-i-gguq ciulicugtuq, imkut wangkuta teguluki cat elatmun egtelalput tamaa-i tuaten ayuqluni ciulicuuluki."
        },
        "124": {
            "start": 1456.02,
            "end": 1460.24,
            "transcript": "Tuaten-am inerqurturalallrukiikut qinga'arqumta."
        },
        "125": {
            "start": 1460.24,
            "end": 1473.68,
            "transcript": "Cali-llu uitatevkenaku aqsii arulaqu'urlukek elliuraqlukek apengqavkenata-llu."
        },
        "126": {
            "start": 1473.68,
            "end": 1483.0,
            "transcript": "Avilluku uitavkenata. Imumek apengluta tua-i qemengkarluku uitauralaasqelluta."
        },
        "127": {
            "start": 1483.08,
            "end": 1495.62,
            "transcript": "Waten-gguq avilluta, avilluta pikumta aqsaput angqayagciqut, anesciiganateng-llu anqataquni inerquutnguluni."
        },
        "128": {
            "start": 1495.62,
            "end": 1506.98,
            "transcript": "Aqsigminek aviciluni, aviciluku aqsignek qingaasqevkenaku, tau͡gaam eqluku [?] qumalluku cali cakviurturaulluku."
        },
        "129": {
            "start": 1506.98,
            "end": 1515.26,
            "transcript": "Qamanelengraan cakviurturautekluku, tauna tua-i tuaten piuralria."
        },
        "130": {
            "start": 1515.26,
            "end": 1521.56,
            "transcript": "Mikcuayagauluni ankuni camek qanernaunani an'arkauluni."
        },
        "131": {
            "start": 1521.56,
            "end": 1535.44,
            "transcript": "Tau͡gaam ilakuallernek melqulget ikuaritnek, melqulget makut ungungssit ilakuallritnek agu neresqevkenata, atam-gguq aniartuq civcillerluni."
        },
        "132": {
            "start": 1535.44,
            "end": 1544.68,
            "transcript": "Tauna melqulget ilakuallritnek nertuli, nertulim irniara."
        },
        "133": {
            "start": 1545.0,
            "end": 1556.94,
            "transcript": "Civcillirtuut-gguq tuaten tamakut unguvalriit ilakuallritnek nerlalriit upumaluteng qilagait."
        },
        "134": {
            "start": 1556.94,
            "end": 1567.54,
            "transcript": "Inerquumanaurautkut ilakuallemteńek-llu wangkuta wangkuungraamta ilakualput nerenqigtesqevkenaki."
        },
        "135": {
            "start": 1569.1,
            "end": 1574.94,
            "transcript": "Aminariqnitullruyugnarqai tuaten pitullret."
        },
        "136": {
            "start": 1574.94,
            "end": 1588.8,
            "transcript": "Tua-i tuaten inerquumatullrukiikut tamakunek unguvalriit ilakuaritnek neresqevkenata piaqluta inerquumaluta."
        },
        "137": {
            "start": 1589.0,
            "end": 1602.08,
            "transcript": "Cali kingupimta neresqevkenata, cali-ll' makut aturaput kanarrluki ulikesqevkenaki."
        },
        "138": {
            "start": 1602.08,
            "end": 1614.88,
            "transcript": "Tua-i-gguq-am kingupirmeng tuaten antuut mikelnguq, mikelnguq im' tauna anluni, aanani tuqulluki ilii-gguq tuquciicaaqaa."
        },
        "139": {
            "start": 1614.88,
            "end": 1624.82,
            "transcript": "Aananita aqumgaluki. Yungcaristaitellermek maa-i makut qanruyutek'lalput."
        },
        "140": {
            "start": 1624.82,
            "end": 1639.94,
            "transcript": "Waten tau͡gaam aipaqutellri maligtaquuraullutek cali irniangekunek irniatek elluarrluki aulukengnaqu'urluki nepaunateng, nepaistengnaqluki."
        },
        "141": {
            "start": 1639.94,
            "end": 1648.48,
            "transcript": "Aulukengnaqkunegneki angayuqateng takaqenrilngaitait, takaqeciqait."
        },
        "142": {
            "start": 1649.0,
            "end": 1665.44,
            "transcript": "Tau͡gken imumek aarpagalluki irniarkuunegenki, takaqngaunaki angayuqaat, angayuqa irniamta takaqngaunata iluteqevkaraqluta."
        },
        "143": {
            "start": 1665.44,
            "end": 1675.38,
            "transcript": "Unumek tau͡gken nepaunata yuukumta umyuarput iliini navkangraatgu pivkenata."
        },
        "144": {
            "start": 1675.38,
            "end": 1684.22,
            "transcript": "Pileryarpek'naku, qaruarrluku tau͡gaam pikumteńi, tauna im' mikelnguuq ayagciquq nepaunani."
        },
        "145": {
            "start": 1685.0,
            "end": 1697.22,
            "transcript": "Aipaqutellriik ukuk, aipaqucimarillragni qanruyutengqertuk."
        },
        "146": {
            "start": 1697.22,
            "end": 1710.04,
            "transcript": "Tauna arnaq nulirra qanrutestengqertuq aanaminek alerquastengqertuq, alerquastengqetuuq."
        },
        "147": {
            "start": 1710.04,
            "end": 1721.48,
            "transcript": "Qingaqan qaillun qingaa auluklerkaanek alerquastengqertuq aanaminek tau͡gaam."
        },
        "148": {
            "start": 1721.48,
            "end": 1736.34,
            "transcript": "Tauna-llu cali angutii irniangekan qaillun irniaraa, irniaran qainga patungnaqlerkaatnun qanruyuterluni."
        },
        "149": {
            "start": 1736.34,
            "end": 1749.9,
            "transcript": "Qaillun-llu cali anglicallerkaa ankan auluklerkaa aaniin cali aanani aptelarciqaa, aptelaraa."
        },
        "150": {
            "start": 1749.9,
            "end": 1758.38,
            "transcript": "Qaillun mikelnguq auluklerkaanek aanamini, aanani aptelaraa."
        },
        "151": {
            "start": 1758.38,
            "end": 1770.7,
            "transcript": "Taum nall'arani aturluku arnam qaillun mikelngurmek aulukesciigatuq, anglicarisciigatuq."
        },
        "152": {
            "start": 1771.0,
            "end": 1777.08,
            "transcript": "Qanruyutekun tau͡gaam anglicarituuq arnaq."
        },
        "153": {
            "start": 1777.08,
            "end": 1787.8,
            "transcript": "Angutiin-llu ayakuni angungnaqluku, neqkangengnaqlukek taukuk aipani irniani-llu."
        },
        "154": {
            "start": 1787.8,
            "end": 1800.98,
            "transcript": "Ayakuni yuilqumun, allamek umyuarteqenrituq pitarkaq irniani-ll' tauna nutaraq ciuqliqapiar, umyuarrluku tayima kenekngamiu cakneq."
        },
        "155": {
            "start": 1800.98,
            "end": 1813.38,
            "transcript": "Tuatluku [?] kenkucini aturluku qanruyutengqerrluni qanerturaucimalutek."
        },
        "156": {
            "start": 1813.38,
            "end": 1821.02,
            "transcript": "Kenkuyucini aturluku tamarmek irniartek anglicangarkaugaa."
        },
        "157": {
            "start": 1821.02,
            "end": 1836.46,
            "transcript": "Angutem nayuyuit' nayurpakayuitaa, arnam tau͡gaam kesianek tangvakaa, picurlakallerkaa tangvagluku murilkelluku cakneq qanrutaa-ll' murilkelluku tuaten."
        },
        "158": {
            "start": 1836.46,
            "end": 1848.42,
            "transcript": "Egilreskunegnegu mikelnguq angliurallranek ayaulluku elluarrluku aulukluku."
        },
        "159": {
            "start": 1848.42,
            "end": 1859.0,
            "transcript": "Au͡gna-llu tekitarkarteng uyungellerkaa-llu-llam maa-i umyuaqaqluku iliini pinarqetuluni."
        },
        "160": {
            "start": 1861.0,
            "end": 1871.16,
            "transcript": "Tamaa-i qanruyutekun tau͡gaam ak'a avani qanruyutekun alerquatkun ciulirnemeggnek."
        },
        "161": {
            "start": 1871.16,
            "end": 1883.12,
            "transcript": "Yug'urtelartut angturiluteng-llu aulukcurluamalria elluarrluni iluangaituq."
        },
        "162": {
            "start": 1883.12,
            "end": 1889.88,
            "transcript": "Tua-llu imumek ciuteng yug'em iik puqigilutek."
        },
        "163": {
            "start": 1890.0,
            "end": 1907.86,
            "transcript": "Kiarteturiluni tauna mikelnguq pikan anguq'apiar tangvagtelluni arnaq tauna aanii qaillun atawaunrilngurmek aturyaqunani."
        },
        "164": {
            "start": 1907.86,
            "end": 1922.16,
            "transcript": "Wall'u-qaa aipani umyuani ik'iqeskan maligarcaqunaniu aipani pileryagyaqunaku, pileryaasqumavkenaku."
        },
        "165": {
            "start": 1922.16,
            "end": 1939.86,
            "transcript": "Taum mikelnguum takuani niitevkarluku-llu, tuaten elluarrluku anglivkaryukunegen'gu takuani carrlugmek aturciqenritqapigtuk taukuk nulirqelriik."
        },
        "166": {
            "start": 1940.0,
            "end": 1955.02,
            "transcript": "Mat'um cuum pingnaqurallra ayuqenrituq, cuum ilii elilrat [?] tua-i-wa catuvkani nalluluku."
        },
        "167": {
            "start": 1955.02,
            "end": 1967.7,
            "transcript": "Maaken tau͡gaam ilaminek nerunurnaqluni pituuq, qetun'e'rmi-llu mikelngumi angussangnaqellret."
        },
        "168": {
            "start": 1967.7,
            "end": 1979.24,
            "transcript": "Tayima tauna angussangnaqellret atuluku. Maaken tau͡gken ukugnek [?]."
        },
        "169": {
            "start": 1979.24,
            "end": 1985.46,
            "transcript": "Tauna tau͡gaten ayuqelria ayuqsuuminarqenritua."
        },
        "170": {
            "start": 1985.46,
            "end": 1997.8,
            "transcript": "Mikelnguq mikelngua anglikuni imumek taum aanami angu-llu atami tumi atuqauraa."
        },
        "171": {
            "start": 2001.0,
            "end": 2016.92,
            "transcript": "Cali kenkurpegnaki mikelnguut tamakut kenkengengmegteki cakneq keneksiyaagpek'naki elluukarpek'naki [?] anglicararait."
        },
        "172": {
            "start": 2016.92,
            "end": 2026.74,
            "transcript": "Waten umyuirestevkenaki [?] camek tua-i piullrat-llu umyuirestevkenaki."
        },
        "173": {
            "start": 2026.74,
            "end": 2040.12,
            "transcript": "Tua-i tamana umyuiyurciimelria qaillun-llu-wa munarpegnani usvitussiyaagpek'nani-ll' ayuquq tamana tua-i umyuiryullruami."
        },
        "174": {
            "start": 2040.12,
            "end": 2061.64,
            "transcript": "Arenqililuku arenivkarluku anglicallruagni ayuqaagmek pikaniritekluku [?] tuaten elliiqapiarcetevkenaku anglicarilartut imkut yullret."
        },
        "175": {
            "start": 2062.38,
            "end": 2080.9,
            "transcript": "Imai tua-i tauna umyukuuqapiarallra angliaqami cali nallurrlularaa cali-llu civlussiyaarpeknani [?] cali-llu tua-i-qaa cayaraq nalluluku, cat-wa tua-i ilait nalluluku."
        },
        "176": {
            "start": 2084.92,
            "end": 2095.26,
            "transcript": "Tua-i tauna mikelnguq angliurquni angliurciquq tua-i angayuqaagnek tungii aturluki"
        },
        "177": {
            "start": 2095.26,
            "end": 2101.42,
            "transcript": "Angayuqaarni ikiukagnek ellii-llu ikiuluni."
        },
        "178": {
            "start": 2101.42,
            "end": 2115.3,
            "transcript": "Tuamtellu angayuqaagnek taukuk ikiuyukagnek cali ikiuluni, pingqaarli-ll' angayuqaagni niicuunani."
        },
        "179": {
            "start": 2115.3,
            "end": 2125.62,
            "transcript": "Cairirtuq anguarnek [?] niicuunani angliurluni, kiituani taukuk angayuqaagnek cakenrirak."
        },
        "180": {
            "start": 2125.62,
            "end": 2136.8,
            "transcript": "Yugtun aulukesteqenrilngurtun cakengssaaranrirak caken iluteqsaaqerraarlutek tua-i pelugtaqluni."
        },
        "181": {
            "start": 2136.8,
            "end": 2151.5,
            "transcript": "Iliini mikelngullrem taum [?] aulukellragnek iluteqevkarluki ayagnirluki tuqutaqluki tuquvkaraqluki aanagni."
        },
        "182": {
            "start": 2151.5,
            "end": 2164.8,
            "transcript": "Iluteqsaaqlutek angayuqaagken iluteqevkarlukek irniaran-wa tua-i iluteqevkarluku taum aanani wall' atani."
        },
        "183": {
            "start": 2164.8,
            "end": 2171.32,
            "transcript": "Qaillun piluteng, iluteqellret makut tuqutuat. Wiinga-ll' tua-i-w'."
        },
        "184": {
            "start": 2171.32,
            "end": 2183.3,
            "transcript": "Tua-i iluteqellermeng angtaciatun tuqutekaqluku tamana iluteqellren, irniameng-ll' navgullri."
        },
        "185": {
            "start": 2183.3,
            "end": 2189.78,
            "transcript": "Tua-i tamana tamaa-i tuaten ayuquq anglicurlalria."
        },
        "186": {
            "start": 2189.78,
            "end": 2197.82,
            "transcript": "Imna tau͡gken anglikegtaaralria elluarrluni angayuqaagni aulugkellra."
        },
        "187": {
            "start": 2197.82,
            "end": 2213.16,
            "transcript": "Ayagturluni ilani-llu caugallagavkenaki, wall'u tan'gurraam-llu tan'gurraugutni caugarrluki qanlaagciiganani."
        },
        "188": {
            "start": 2213.16,
            "end": 2223.48,
            "transcript": "Ayagturluni angayuqaarmi tungii aturluku angayuqaagni yagiracuilkagnek ca-ll' umyuilkagnek."
        },
        "189": {
            "start": 2223.48,
            "end": 2238.4,
            "transcript": "Ayagturluni imna mikelnguq angliriurciquq pengssagaunani ilani takaqluki tamalkuita, pitatni takaqluki ilagarciiganaki."
        },
        "190": {
            "start": 2238.4,
            "end": 2254.54,
            "transcript": "Tau͡gken ilani makut caugartarpek'naki tua-i-wa ancurtukluki nalluyuqluki angayuqaarmi yuciartuni."
        },
        "191": {
            "start": 2254.54,
            "end": 2268.0,
            "transcript": "Angayuqaak-llu taukuk tuaten ayuqekunek ilatek qigcikarkaugak, takaqerkaugak elluarrlutek aipaqutellriik."
        },
        "192": {
            "start": 2268.14,
            "end": 2286.88,
            "transcript": "Ayuqucirtuacetek egmian maliggluki, cali-ll' irniakenka ayuqluteng, irniakenka angayuqaarmek tungii aturluku, alerquatai ircaqumegnun elliluku uitatarkaugaa."
        },
        "193": {
            "start": 2286.88,
            "end": 2299.78,
            "transcript": "Tamakut tau͡gken elluarrluki ayagcetenritestai qanrutek tangraat, ircaqugni tamakut qanruyutek uitangaunatek."
        },
        "194": {
            "start": 2299.78,
            "end": 2307.28,
            "transcript": "Katagluki tau͡gaam tuavet elluarrluteng uitallrunrilameng."
        },
        "195": {
            "start": 2307.28,
            "end": 2326.28,
            "transcript": "Tua-i tamaa-i tamakut imumek tatamqelluki uitatesciigat', puqialngullem uitatesqitgu irniaput tatamkesqevkenaki."
        },
        "196": {
            "start": 2327.98,
            "end": 2338.86,
            "transcript": "Tan'gurraani ayuqucirkai arcaqerluku qanruyutengqellruut, tan'gurraat."
        },
        "197": {
            "start": 2338.86,
            "end": 2353.06,
            "transcript": "Avavet yun'erruarvigmeggnun qanruyutekuratullruat ukuk malruk arcaqerlukek qavan ukuk qessasqevkenata."
        },
        "198": {
            "start": 2353.06,
            "end": 2365.34,
            "transcript": "Qessangramta ellimaqutput egmian wanirpak ciuniulaasqelluku, niitesqelluta wanirpak niitesqelluta atatakutevkenaku."
        },
        "199": {
            "start": 2365.34,
            "end": 2376.42,
            "transcript": "Atam-gguq qessamun qessavakarluta wangkutnek pikairniartukut qessamkaurrluta, kiituani cananrillertukut."
        },
        "200": {
            "start": 2376.42,
            "end": 2390.04,
            "transcript": "Ilaput imkut anluutelput arenqialnguut aturaqegciluteng ellmeng pika'artameggnek, qainga tangalaluni ellmeng pikartameggnek."
        },
        "201": {
            "start": 2390.04,
            "end": 2407.26,
            "transcript": "Qanruyutekun iliiralriit [?], tamakut tau͡gaam qessaluteng yuulriit qessap'ikluku inerquutekeng'e'rmegteggu tamaani ilameggnek ayuqniarluteng picuunateng."
        },
        "202": {
            "start": 2407.26,
            "end": 2420.2,
            "transcript": "Qavaq-llu cali aturluku, arcaqerlukek unguvani [?] qavankuk qessa-llu qanruyutekellruagkut ulingta'arturluki."
        },
        "203": {
            "start": 2420.2,
            "end": 2430.06,
            "transcript": "Wangkuta-mun niicugnilriani niitellmeksuunaki tamakut caangengiinautnguluteng tau͡gaam pitulliniluteng."
        },
        "204": {
            "start": 2430.06,
            "end": 2438.04,
            "transcript": "Cali-llu ellimerrilriamek niitellriani waten qasgim iluani."
        },
        "205": {
            "start": 2438.04,
            "end": 2448.62,
            "transcript": "Ellii carraquinaayarmun tusngaqernaqluni elluarrluni ilgalriit. Carraquinayagarmun tusngaqernaqluni."
        },
        "206": {
            "start": 2448.62,
            "end": 2460.3,
            "transcript": "Ellimeqngaan aqumgaluni ak'a pinami, tauna-llu kangilirluku cali qessayaram."
        },
        "207": {
            "start": 2460.3,
            "end": 2478.76,
            "transcript": "Atam-gguq qessatukumta qessaluta yuukumta, qessalruluta yuugumta, yuilqumun ayagayauraskumta, picurlaureskamteńun tekiskumta, alapenerrluni."
        },
        "208": {
            "start": 2478.76,
            "end": 2490.4,
            "transcript": "Unguvan aqsaaqluni tataunata, qessaunata yuullrukumta unguvan atatakuciitellrukumta tan'gurraullem."
        },
        "209": {
            "start": 2490.4,
            "end": 2500.38,
            "transcript": "Picurlavigkaqenrilengramteggu-gguq atam picurlavikniarput tua-i tuqutekluku-llu."
        },
        "210": {
            "start": 2500.38,
            "end": 2517.98,
            "transcript": "Tamakut cali man'a piqunqerrsaraq man'a cali qanruyutekluku tamatumun tamaa-i qessamun ilakniluku qessayaramun."
        },
        "211": {
            "start": 2517.98,
            "end": 2533.06,
            "transcript": "Yuk-gguq qessange'rmi pingnatugpakarluni, tuarpiaq-gguq pingnatuinermini allguciiqalria.Allguskuni-llu capernariluni."
        },
        "212": {
            "start": 2533.06,
            "end": 2548.24,
            "transcript": "Maaten-gguq allgutuq piturniryaaqellinilria, uqinrarcaarturluki-llu pitullrulriit, pinirtaarturluteng-llu pitullrulriit yun'errait."
        },
        "213": {
            "start": 2548.24,
            "end": 2558.0,
            "transcript": "Nangyutevkenateng ellmeggnun, akngirqutevkenateng ellmegnun tamaa-i qerrircarluku ayuqucirtun."
        },
        "214": {
            "start": 2558.3,
            "end": 2570.04,
            "transcript": "Tamaa-i-gguq qessatuli pingnatungekuni qessangermi-gguq ayakuni qessamun puukarpailegmi tauna ellimerrem tekiciiqaa."
        },
        "215": {
            "start": 2570.04,
            "end": 2578.08,
            "transcript": "Qessaksaunaki piuralaasqelluta, qessangramta qessallerpetalnguurluku yuusqelluta."
        },
        "216": {
            "start": 2578.08,
            "end": 2594.06,
            "transcript": "Tuamta-ll' cali unuakumi qavami, unuakumi tupangnaqesqelluta tamaa-i. Pitsaqevkenata ilamteńek tupagcesciurmek."
        },
        "217": {
            "start": 2594.06,
            "end": 2608.36,
            "transcript": "Atatakutevkenaku qanqerpegnata-llu nauwa tupagtellriani ilait tupagkekngat ilait wanikuarpatata atatakuarpagan ak'akiki parungluni callerkani imegluku."
        },
        "218": {
            "start": 2608.36,
            "end": 2623.96,
            "transcript": "Egmianun tupagutmini, egmian maktesqelluku atam-gguq makeskan, egmian qessangraan maksuumilengraan makeskan, tuatnauratukan elitniartuq-gguq atam."
        },
        "219": {
            "start": 2624.0,
            "end": 2632.48,
            "transcript": "Pisuryaurpailgan, caliyaurpailgan tan'gurraq tauna aipangyugnaunaku."
        },
        "220": {
            "start": 2632.48,
            "end": 2642.82,
            "transcript": "Umyualgukuni apqiitnek umyualgukuni iigmikun ellminek qanrutarkauguq ellminek elissararkauguq."
        },
        "221": {
            "start": 2642.82,
            "end": 2650.2,
            "transcript": "Elissarciquq maaten cumikurluki piciqai, imkut makut qanruyutellri ilii."
        },
        "222": {
            "start": 2650.2,
            "end": 2665.3,
            "transcript": "Niitetullri tamaa-i waten ayuqekuni illii cayaraq nallunriciiqellinikii yuut muk'egciluni, niisngalriaruluni yuukuni waten ayuqeciqelliniluni."
        },
        "223": {
            "start": 2665.3,
            "end": 2675.7,
            "transcript": "Maaten caliyaurciiquq piqarraami piumanrilliqluni niitelmikun au͡g'ukun tangvallmikun-llu caliluku."
        },
        "224": {
            "start": 2675.7,
            "end": 2688.86,
            "transcript": "Kinguqlilirikuni assirikanirmek, patagmek-llu assiriluni caliaritesciiganani qessaunani yuullrukuni, tataunani yuullrukuni."
        },
        "225": {
            "start": 2689.0,
            "end": 2698.06,
            "transcript": "Anguteput pamatmun elliqalriatun piilengraata, arnani wangkuta ayuqucimteńi qanerciqertua."
        },
        "226": {
            "start": 2698.06,
            "end": 2705.66,
            "transcript": "Angayuqaagma wii qanruterpakayuitarnga, marrlugarma tau͡gaam ayuqucirtutullruanga."
        },
        "227": {
            "start": 2705.66,
            "end": 2715.9,
            "transcript": "Waten ayuqucirtutullruanga avani miktellemni carraullemni malikurlaklianek ayatullrungami."
        },
        "228": {
            "start": 2715.9,
            "end": 2729.02,
            "transcript": "Tau͡ga elitnaurturlua school-arlua, tau͡ga tayima graduate-arngama tuqumalluruciani piirulluni."
        },
        "229": {
            "start": 2729.02,
            "end": 2737.98,
            "transcript": "Piurutengraan-llu qaneryarai wii enqakuratuluki, illiini enqakurrlainaariingaarluki enqerraatuluki."
        },
        "230": {
            "start": 2737.98,
            "end": 2748.24,
            "transcript": "Waten qanrutulqaanga wiinga yaqelguureskuvet [?], uingekuvet cai cumikluki piciqaten."
        },
        "231": {
            "start": 2748.24,
            "end": 2756.28,
            "transcript": "Cumikluki ayagciq'lallrani-llu, natmun ayagciq'lallrani."
        },
        "232": {
            "start": 2756.28,
            "end": 2773.38,
            "transcript": "Imkunek issraggnek pitukevciki. Issrat assiirutngerma [?] tamakunek qanertua. Issratnek pitukevcinek. Cai cuvrirluki elpeci-llu tuc'inarkanek pitukevcinek tamakunek ang'aqulirluku."
        },
        "233": {
            "start": 2773.38,
            "end": 2785.98,
            "transcript": "Neqa'armek uqumek ang'aqilluku, wall'u cimiritekangqerkan, cimiritekaanek ang'aqilluku."
        },
        "234": {
            "start": 2785.98,
            "end": 2795.72,
            "transcript": "Imarniitnek au͡gkunek qilunek pingqetullratni tamakuitevkenaku pisqelluku uksungraan kiagungraan-llu."
        },
        "235": {
            "start": 2795.72,
            "end": 2800.78,
            "transcript": "Tamakunek piinaku ayagcetesqevkenaku."
        },
        "236": {
            "start": 2800.78,
            "end": 2810.38,
            "transcript": "Tau͡gaten-gguq piinaku ayagceskumteggu aaparput tuqutelriatun ayuqciqerput, qerru'uvkarluku, angu-llu paluvkarluku."
        },
        "237": {
            "start": 2810.38,
            "end": 2822.46,
            "transcript": "Tamakunek marrlugarma wiinga qanruquratullruanga, tau͡ga amlleruanrilama-llu kiirran anglivikluku, anglillrungama marrlugaqa."
        },
        "238": {
            "start": 2822.46,
            "end": 2831.94,
            "transcript": "Tau͡gaten qanrutullruanga aapangqerkuma tamakunek piitevkenaku ayagcetesqelluku."
        },
        "239": {
            "start": 2831.94,
            "end": 2847.32,
            "transcript": "Angu-llu maa-i-llu cukanraqaluteng ayaturilriit cali neq'akaqamku una aapaqa waten ellingraan ayagaqan cimiritekaunaku ayagcetellra cali ayagcecuunaku."
        },
        "240": {
            "start": 2847.32,
            "end": 2863.0,
            "transcript": "Cali qetunrapuk piqa'ar' pituluki, tau͡ga-i ayaga'arrlain' assiirutelriit maa-i qetunraput calliamamek kesian igcaumangameng, mat'um Kass'at calliaritnun."
        },
        "241": {
            "start": 2863.0,
            "end": 2871.9,
            "transcript": "Au͡gna kiivet [?] kesianek piitullrani tau͡gaten cali piqa'aqluku, tau͡gaten qanruyutaciatun marrlugarma."
        },
        "242": {
            "start": 2871.9,
            "end": 2882.56,
            "transcript": "Angliarallemnek tamaken ayaglua qanruquratulqaanga, how to take care of the husband, and how to take care of the kids, tau͡gaten qanrutullruanga."
        },
        "243": {
            "start": 2882.56,
            "end": 2895.28,
            "transcript": "Kasngunangnaqevkenii ilamnun pisqellua, ilama-gguq im'um ciulgutma tangerciqaanga uuggun aapamkun qaillun ayuqkuma."
        },
        "244": {
            "start": 2895.28,
            "end": 2904.84,
            "transcript": "Nutaan-llu cali qanrutaqlua qanrutengramni-gguq, qanrutengraanga-gguq niitenrilkumni, allam-llu niicugnikuni."
        },
        "245": {
            "start": 2904.84,
            "end": 2917.0,
            "transcript": "Wii qanruyuteka allam ing'um arnam teguluku eliciiqa wangnun elitevkarpek'naku, tau͡gaten-gguq qaneryaramek niiqunrilnguq elluatun cuuyuituq."
        },
        "246": {
            "start": 2917.0,
            "end": 2927.36,
            "transcript": "Arcaqerluku kat'um imarpigem qanrutevkatullrui uukugnek qessanqugnek qavaqluki."
        },
        "247": {
            "start": 2927.36,
            "end": 2940.68,
            "transcript": "Cali uum pingayirluki piqunqengnaqluki yuusqelluki imarpik umyuaqluku, imarpiim cali kat'um qanertaa amllerluni."
        },
        "248": {
            "start": 2940.68,
            "end": 2962.34,
            "transcript": "Akerta anuqa qairet, tengmiaqsaraat qalria-ll' erinait quarruugngalnguum inerqualuni ayagareskekun' [?], tamakut tamaa-i qanrutekluki kangiit, wiinga-ll' wani nalluvkenaki."
        },
        "249": {
            "start": 2962.34,
            "end": 2976.28,
            "transcript": "Nalluyagucuunaki tamaa-i niitellemnek anirta pitullrullinianka tamakut wangni kasruranaunaki akurtuumallrulliniami."
        },
        "250": {
            "start": 2976.28,
            "end": 2990.58,
            "transcript": "Tuaten piurnarqamana [?] tan'gurraq ayaulluku atiin ayauciiqaa yuilqumun maligkaqenrilkuni ikayuureskan."
        },
        "251": {
            "start": 2990.58,
            "end": 3003.22,
            "transcript": "Atiin elissarciqaa nutaan elluarrluku cayaramek, nunamini uitallermini elissang'e'rmi, yuilquq cali elissautekarkauguq."
        },
        "252": {
            "start": 3003.22,
            "end": 3011.86,
            "transcript": "Taluyat civtellerkaa qaillun taluyam civtellerkaa qaillun nallunrirtelluku tangvagtelluni."
        },
        "253": {
            "start": 3011.86,
            "end": 3028.88,
            "transcript": "Tuamtell' cali piyugallermini nuqlicetaarluku ayagarkauluni, qetunrani taum elluarrluku yuusqumakuniu, puqilaluku yuusqumakuniu, piyugturnirluku yuusqumakuniu, yuilqumek pekeskan."
        },
        "254": {
            "start": 3029.0,
            "end": 3042.54,
            "transcript": "Nuqlicetaarluku naklekeng'e'rmi ilrutarkaulliniluku cali tamaa-i yuilqumun, yuilqumi ellissaquniu elluarrluku."
        },
        "255": {
            "start": 3042.54,
            "end": 3056.58,
            "transcript": "Piqarraami tauna qetunraa iluteq'laryaaqeciquq elluarrluni maligngatellria ukuni, iluteqellni anngaitaa, maningaitaa, tuavet ataminun."
        },
        "256": {
            "start": 3058.0,
            "end": 3076.98,
            "transcript": "Iluteqsaqligminek atam taqlininiartuq nutaan nuqlitnanriqan atiin, atii nuqlicaureskuni nutaan tamatumek taqluku puqilaryuq tua-i."
        },
        "257": {
            "start": 3076.98,
            "end": 3090.86,
            "transcript": "Elissarluku waten-llu cali kiagmi ayagaskuniu yuilqumun elliin ayagviksuilkengaminun ayautaqluku waten elliarturluku kesianek."
        },
        "258": {
            "start": 3090.86,
            "end": 3101.04,
            "transcript": "Caqanrilkuvet igelraunginanerpeni [?] pingnatugyaureskuni makut maa-i nallunritarkait."
        },
        "259": {
            "start": 3101.04,
            "end": 3109.0,
            "transcript": "Nanvat cingigaurai kiagmi waten anguaryarat."
        },
        "260": {
            "start": 3109.0,
            "end": 3117.0,
            "transcript": "Cali-llu ingrimi, ingrini pekeskuvet cegnayuut cali nallunritniarai."
        },
        "261": {
            "start": 3117.04,
            "end": 3124.58,
            "transcript": "Apertualluku tangvagluku qanrusngina'arpek'naku."
        },
        "262": {
            "start": 3124.58,
            "end": 3142.04,
            "transcript": "Tangvagtelluki agturavkarluki-llu ugaani tua-i elitesqumayaaqetacirmi qetunrani tauna pitekluku, tangvagtelluki agturavkarluki-llu."
        },
        "263": {
            "start": 3142.04,
            "end": 3151.44,
            "transcript": "Tuaten pimalria ukuni nuqlik'ngarqapiarluni tauna-ll' elluarteqapiarluni yuugarkauguq."
        },
        "264": {
            "start": 3151.44,
            "end": 3166.12,
            "transcript": "Canek elissararkaugaa neqsuutet qaillun anangnaqlerkaat, anangnaqlerkaa, kuiget-llu cali nalluvkarpek'naki atuqengaat tamakunek."
        },
        "265": {
            "start": 3166.12,
            "end": 3182.44,
            "transcript": "Pissuryaraq-llu cali makut qimagayulit makut melqulget piciatun qaillun terigulnarqelriit, qaillun terigucaraaci nallunritevkarluku terigulluku pissuryarait."
        },
        "266": {
            "start": 3182.44,
            "end": 3194.58,
            "transcript": "Kanani cali imarpigmi, yuk una pissurteńi taqukam nallunrilngurcetun ayuq' apqiita ukugtam [?]."
        },
        "267": {
            "start": 3194.58,
            "end": 3203.02,
            "transcript": "Pissurteńi nallunrilngurcetun ayuqetullinia."
        },
        "268": {
            "start": 3203.02,
            "end": 3211.06,
            "transcript": "Uugtar imna tekicarturluku, taringulluku yaaqvani tangerqerraallrani makcugpagni."
        },
        "269": {
            "start": 3211.06,
            "end": 3220.88,
            "transcript": "Ayuquciakun yuk tauna pissurteńi tangvagpigainarluku ayuqetulliniuq."
        },
        "270": {
            "start": 3220.88,
            "end": 3234.8,
            "transcript": "Tekitniarallni maliggluku maknanrirluni, nut'garkaureskani-llu makcuirulluni qavarluni nutaan."
        },
        "271": {
            "start": 3234.8,
            "end": 3250.34,
            "transcript": "Tamaa-i-gguq ayakatarallermini elliin taum tan'gurraam pikiuraanek mat'ukun qaneryarakut tamaa-i-am pitamek cali nuqlitevkenani, caliamek-llu cali nuqlitevkenani."
        },
        "272": {
            "start": 3250.4,
            "end": 3267.6,
            "transcript": "Elitengnaqellermini tamaa-i kalikamek aturyugnaunrinek, kalikamun igauciyugnaunrinek, niicugnissuutnek niicugnaunrinek, ataminek tau͡gaam yugnek-llu qasgimi."
        },
        "273": {
            "start": 3267.6,
            "end": 3280.46,
            "transcript": "Waten inerqulallruitkut arnam malkuussaagasqevkenaku iqulirluku-llu arnaq-gguq turuuguq."
        },
        "274": {
            "start": 3280.46,
            "end": 3293.94,
            "transcript": "Tua-i tuqullerkaput alikngamteggu tamana ukvekellruarput ayagyuallemteńi ilaitni caarrlugmek apaalangraitkut."
        },
        "275": {
            "start": 3296.72,
            "end": 3306.6,
            "transcript": "Ayagyuarluni-gguq tan'gurraq arnamek akusrarutekikuni."
        },
        "276": {
            "start": 3306.6,
            "end": 3315.96,
            "transcript": "Waten ayuqeciquq tua-i umyugaanek au͡g'arpek'nani."
        },
        "277": {
            "start": 3315.96,
            "end": 3326.78,
            "transcript": "Tua-i-ll' au͡g'anrilami taum ayagyuam umyugaani tukniriinarluni."
        },
        "278": {
            "start": 3327.04,
            "end": 3341.0,
            "transcript": "Kiingan tua-i umyuaqengluku umyugaanek au͡g'arnanrirluni callrani tamalkuan kiituani assiiruq."
        },
        "279": {
            "start": 3341.0,
            "end": 3350.84,
            "transcript": "Kiituani taum tan'gurraam tauna tuaten pillni."
        },
        "280": {
            "start": 3350.84,
            "end": 3360.14,
            "transcript": "Umyuarteqvakarluni assiiruyutekngamiu kiimi tangerkengaqengllinia."
        },
        "281": {
            "start": 3360.14,
            "end": 3374.42,
            "transcript": "Tangerkengaqengamiu-llu qalarut'langluku, amta-llu allat tangyuunaku, elliin kiimi tangvagluku."
        },
        "282": {
            "start": 3374.42,
            "end": 3391.68,
            "transcript": "Kiituani qalarut'langellmi kinguani ellakun ellarrlainarkun maaggun camek cikiutminek akurtulangelliniuq."
        },
        "283": {
            "start": 3392.08,
            "end": 3401.96,
            "transcript": "Tuaten ellilriamek tangvallem-llu qanrutellruanga qanemcitellruanga."
        },
        "284": {
            "start": 3401.96,
            "end": 3411.9,
            "transcript": "Akurturraarluni-llu nerluni, amta-llu neqai qantaa-llu tangrruvkenani."
        },
        "285": {
            "start": 3411.9,
            "end": 3430.42,
            "transcript": "Nerluni tua-i taqngami, tauna tangrrumanrilnguq umyuaqekngani qalarulluku tua-i ngel'araluni-llu-gguq, amta-llu kiimenani."
        },
        "286": {
            "start": 3430.42,
            "end": 3446.64,
            "transcript": "Tuaten-gguq pilria tuqunaciatulliniuq, alingnaqluni, tua-i-wa aturyuuminaicaaqluni."
        },
        "287": {
            "start": 3446.72,
            "end": 3459.86,
            "transcript": "Kiituani maketnanrirluni tangvallem qanrullua."
        },
        "288": {
            "start": 3459.86,
            "end": 3476.64,
            "transcript": "Tau͡gaam nevengqallrani-llu-gguq aqsiigkeni qamani uivat nusngaluteng, aqsiik imairulluteng, kemegmek catairutqapiarluni."
        },
        "289": {
            "start": 3476.72,
            "end": 3484.44,
            "transcript": "Tua-i tamana tuaten qanruyutangqertuq."
        },
        "290": {
            "start": 3484.44,
            "end": 3498.12,
            "transcript": "Tuamta-llu cakanirpek'nani nasaurlurmun-gguq tuc'ugngauq, tuc'etuuq tamana, wagg'u-qaa uinguarluni."
        },
        "291": {
            "start": 3498.12,
            "end": 3507.34,
            "transcript": "Tauna-llu angun nulirruarluni-ggem tamaani ciuqvaarni."
        },
        "292": {
            "start": 3507.34,
            "end": 3521.38,
            "transcript": "Inerquutnguluni nasaurluq cali inerquumaluni uingvailgan angutmun akusrarutekevkaasqevkenani."
        },
        "293": {
            "start": 3521.38,
            "end": 3535.32,
            "transcript": "Akusrarutekesqevkenani-w' tua-i cikiutekesqevkenaku angutmun uingvailgan elliinek tuaten ellirarkauniluku."
        },
        "294": {
            "start": 3535.32,
            "end": 3549.74,
            "transcript": "Tamatum nalliini maa-i wangkuta ciuqvaarni tamamta man'a niitellruarput, ukut-llu nalleqlima waniwa niitellruat."
        }
    },
    "xkXkFYzxypo": {
        "1": {
            "start": 3.2,
            "end": 12.48,
            "transcript": "Makut kingunrit angayuqait-llu. Tamaa-i-gguq kenkutni nasvagluku tua-i taumun cali yuum allam yuk'engraaku."
        },
        "2": {
            "start": 12.48,
            "end": 17.02,
            "transcript": "Camek pikangqerqan cikiqerluku neqkamek."
        },
        "3": {
            "start": 17.02,
            "end": 26.16,
            "transcript": "Tua-i-gguq atam taum-llu tua-i taun cikiqautni mikelnguum quyaqapiarniaraat tua-i."
        },
        "4": {
            "start": 26.16,
            "end": 31.0,
            "transcript": "Tua-i-gguq tuaten wangkuta kenkutvut cali nasvagarkauluku."
        },
        "5": {
            "start": 31.0,
            "end": 42.68,
            "transcript": "Taumun yuum allam yuk'engraaku irniamek tunlluku tuaten cali elicungcaarallra anglillra malirqurluku."
        },
        "6": {
            "start": 42.68,
            "end": 47.72,
            "transcript": "Neqkaq-llu man'a tua-i nutaan elicungcautekluku."
        },
        "7": {
            "start": 47.72,
            "end": 53.92,
            "transcript": "Cali uqlaulluku aulukesqevkenaku piyaureskan."
        },
        "8": {
            "start": 53.92,
            "end": 60.82,
            "transcript": "Tamakut qanrutkurluki nutaan elliinun taumun miklengurmun."
        },
        "9": {
            "start": 75.24,
            "end": 86.8,
            "transcript": "Au͡gna-w' ava-i tua-i waten pitaqerluku mikelnguut tungiitnun amllercaaqellria tua-i qanruyutii mikelnguum qaillun kenekluku anglicallerkaa."
        },
        "10": {
            "start": 86.8,
            "end": 95.84,
            "transcript": "Tau͡gaam tua-i wavet nugtarrluta piqatartukut."
        },
        "11": {
            "start": 95.84,
            "end": 102.92,
            "transcript": "Makunun ciulirnemteńun makut qigcikillerkat ayagyuat."
        },
        "12": {
            "start": 104.84,
            "end": 115.64,
            "transcript": "Imumi tang wangkuta ayagyuallemteńi angayuqamta aanamta-llu."
        },
        "13": {
            "start": 115.64,
            "end": 125.38,
            "transcript": "Waten qagkunek aperluki ciulirneret wall'u yuut allat angayuqait-llu qagkut pii."
        },
        "14": {
            "start": 126.12,
            "end": 133.78,
            "transcript": "Qigcikluki alerqualaqaitkut elicungcarluta qanruqu'urluta."
        },
        "15": {
            "start": 133.78,
            "end": 140.24,
            "transcript": "Tamakut wani qigcikluki pilaasqelluki wangkutnun ayagyuanun."
        },
        "16": {
            "start": 140.3,
            "end": 147.12,
            "transcript": "Tua-i taqneruata taqneruniluki."
        },
        "17": {
            "start": 147.12,
            "end": 155.72,
            "transcript": "Ciulirneruniluki wangkuta mikelnguuniluta tamakut tuaten qigcikarkaput tamaa-i."
        },
        "18": {
            "start": 157.16,
            "end": 169.44,
            "transcript": "Angayuqaput-llu qigcikluki tamakut-llu cali tua-i ilaput, ilamta cali angayuqait ciulirneput qigcikluki."
        },
        "19": {
            "start": 169.44,
            "end": 176.78,
            "transcript": "Tua-i elicungcarluki tamakunek tua-i qigcikekumteki-gguq."
        },
        "20": {
            "start": 176.78,
            "end": 187.56,
            "transcript": "Qigcikekumteki qagkut tungiitnun-llu watqapik qanqataitevkenata qanemteńek ancisqevkenata."
        },
        "21": {
            "start": 187.56,
            "end": 194.78,
            "transcript": "Tau͡gaam imutun tuarpiaq talluryuaralriatun pagnek au͡g'ukun taringeciqeput."
        },
        "22": {
            "start": 195.0,
            "end": 203.72,
            "transcript": "Tua-i-wa ancurtulriacetun wangkuta tungiitnun piluta."
        },
        "23": {
            "start": 203.72,
            "end": 212.62,
            "transcript": "Tua-i wall' takaqitellriacetun takaqluki alerquutkamteki tua-i tamakunun ciulirnemteńun."
        },
        "24": {
            "start": 214.0,
            "end": 223.68,
            "transcript": "Cait-llu tua-i akluit-llu qaillun piluki."
        },
        "25": {
            "start": 223.68,
            "end": 235.94,
            "transcript": "Apelciutevkenaki tegulirluki wangkutnun atuusqevkenaki, yuk tau͡gaam tauna pikeskii taum angutem."
        },
        "26": {
            "start": 235.94,
            "end": 246.9,
            "transcript": "Ellimeqakut uum angayuqamta taumun camek navraasqelluta apelcirraarluku tau͡gaam."
        },
        "27": {
            "start": 246.9,
            "end": 257.3,
            "transcript": "Nalluani teguvkenaku apelcirraarluku tau͡gaam yua taum pikestiin taum uum ellimerutemta."
        },
        "28": {
            "start": 257.3,
            "end": 267.6,
            "transcript": "Qigcikluku nalluani tegunritlerkaa tamatum piluku apelcirraarluku tau͡gaam."
        },
        "29": {
            "start": 267.6,
            "end": 274.76,
            "transcript": "Tua-i-llu taum angutem pisqekaku atuusqekaku tauna waten qanrulluta."
        },
        "30": {
            "start": 274.76,
            "end": 284.98,
            "transcript": "Kitaki taqkuvgu egmianun taiskiu tua-i au͡gna ava-i niilluku tuaten qanruyutii taum navaarvikestemta."
        },
        "31": {
            "start": 284.98,
            "end": 297.0,
            "transcript": "Tua-i-llu aturluku tauna tua-i navraqluku tua-i-ll' ut'rutesqeńgaku qanrutellruakut egmianun cali ut'rutesqelluku."
        },
        "32": {
            "start": 297.0,
            "end": 310.94,
            "transcript": "Maa-i-am tua-i navrateng yuut, tua-i usviturilriit taqnerurtellriit irniangelriit-llu, nuliqsarutellriit-llu navrateng."
        },
        "33": {
            "start": 310.94,
            "end": 318.14,
            "transcript": "Yugmun imumun pillermeggnun ut'rutevkenaku imna-llu tua-i qanerluni."
        },
        "34": {
            "start": 318.14,
            "end": 328.0,
            "transcript": "Tua-i-w' im' navruaqellruamiu tayima taiteksailkii taum navralrit-ll' amllerameng kitumun piciitaqluku."
        },
        "35": {
            "start": 328.0,
            "end": 343.36,
            "transcript": "Tau͡gaam wangkuta tua-i tuaten alerquutengqellruukut tauna-llu ut'rucamteggu nutaan imna navraqvikellerput taun' angun wall'u arnaq, arnam pianek pikumta."
        },
        "36": {
            "start": 343.36,
            "end": 353.1,
            "transcript": "Ullagluku qanrulluku waniwa, waniwa taitaqa. Tua-i-ll' tauna quyaluni, quyanaqvaa-lli tua-i tailluku."
        },
        "37": {
            "start": 353.1,
            "end": 370.12,
            "transcript": "Tua-i nutaan kingunranun ataam ut'rulluku, tua-i cali tuaten alerquuterluta qigcikluki tamakut ciulirneput piarkauluki."
        },
        "38": {
            "start": 370.12,
            "end": 382.22,
            "transcript": "Cali-am qanruyutengqerrluteng au͡gkut ciulirneput canek alerquutaitnek-am ayuqenrilngurnek cali qigcikarkamteńek wangkuta."
        },
        "39": {
            "start": 382.22,
            "end": 393.16,
            "transcript": "Tuaten qanruyuterluta apqemteńek alerquuterluta ciulirnernek."
        },
        "40": {
            "start": 393.16,
            "end": 402.88,
            "transcript": "Ca imna wangkuta ellimerutvut ellaitnek tuaken niitarkauluku."
        },
        "41": {
            "start": 402.88,
            "end": 414.68,
            "transcript": "Qang'aarpek'nata pingaitniluta-ll' qaneryugnaunata tau͡gaam qanrutkellra imna umyuamta qessangraan man'a qanruyutii egmianun tua-i piluku."
        },
        "42": {
            "start": 414.68,
            "end": 422.24,
            "transcript": "Tua-i una-gguq-wa ciulirnerput tua-i respect-arluku. Tua-i qigcikelriatun piluteng."
        },
        "43": {
            "start": 422.24,
            "end": 431.38,
            "transcript": "Tua-i-am ellimerutii qessanarqengraan pingnaqluku, mertaqaasqekakut-ll' egmian mertarluku."
        },
        "44": {
            "start": 431.38,
            "end": 439.22,
            "transcript": "Muragkiuresqekakut-llu yuum taum angayuqaqenrilkemta ellimeqakut tua-i pingnaqaqluku."
        },
        "45": {
            "start": 439.22,
            "end": 448.96,
            "transcript": "Tua-i-llu cali tuaten pisqekakut allamek tua-i cali pingnaqluku."
        },
        "46": {
            "start": 448.96,
            "end": 456.86,
            "transcript": "Tua-i-gguq tauna qigcikluku qanruyutput ciulirnemteńek katagpek'naku."
        },
        "47": {
            "start": 458.04,
            "end": 473.24,
            "transcript": "Nasvarpek'nata wangkutnek pingaitniluta takuani. Tua-i nutaan-am tauna tua-i ellimerutii taqngamteggu piluta nutaan tua-i taum quyavikluta quyanaqvaa-ll' tanem."
        },
        "48": {
            "start": 473.24,
            "end": 483.62,
            "transcript": "Tua-i tauna pisqutka piluku, quyavikluta tua-i waten cali."
        },
        "49": {
            "start": 483.62,
            "end": 493.3,
            "transcript": "Tua-i mat'um nalliini maa-i makut ayagyuat tukninrurrluteng."
        },
        "50": {
            "start": 493.3,
            "end": 508.84,
            "transcript": "Makut-llu ciulirneteng, qanpaucugngariluki, tua-i umyugaat-llu nall'artevkenaku qanrucec'urlagaqluki."
        },
        "51": {
            "start": 508.84,
            "end": 515.18,
            "transcript": "Amta-llu allauluteng angayuqaqevkenaki ellaita."
        },
        "52": {
            "start": 515.18,
            "end": 524.14,
            "transcript": "Tua-i cal' angayuqateng maa-i qigcikevkenaki qancurlagacungluki, ellmeggnek."
        },
        "53": {
            "start": 524.14,
            "end": 540.82,
            "transcript": "Tuarpiaq tua-i umyuarteng aturluku tau͡gaam imna anglillerteng mikcuayagauluteng umyuaqevkenaku casciigatlermegnek nerqumallermeggnek angayuqameggni."
        },
        "54": {
            "start": 540.82,
            "end": 548.48,
            "transcript": "Tuaten nutaan-gguq tua-i waten kitaki wangkuta ayagyuani elpeci pikici."
        },
        "55": {
            "start": 548.48,
            "end": 553.98,
            "transcript": "Akinauryuumirluku tauna angayuqaagken."
        },
        "56": {
            "start": 553.98,
            "end": 559.92,
            "transcript": "Unguvaqallerpeni taqnerurteng'e'rpet irnialingeng'e'rpet."
        },
        "57": {
            "start": 559.92,
            "end": 576.86,
            "transcript": "Angayuqaagken taukuk nutaan tuaten elpet akinauqeryuumirluku quyatengqerrluten au͡g'umek anglicaumallermani waten au͡gna pitaqerluku tua-i piaqa."
        },
        "58": {
            "start": 578.98,
            "end": 588.18,
            "transcript": "Tua-i-w' qigcikiyaraq au͡gkunek qigcikelrianek ciunemteńi au͡gkunek yuullranek."
        },
        "59": {
            "start": 588.18,
            "end": 596.8,
            "transcript": "Qigcikelrianek canek tamaitnek nallunrilkengangqertukut wangkuta ilaitnek."
        },
        "60": {
            "start": 596.8,
            "end": 606.54,
            "transcript": "Au͡gkut yuut ciuqliit cat tamalkuan, nunam-llu qaingani naumalriit qagkut naunraat."
        },
        "61": {
            "start": 606.54,
            "end": 618.8,
            "transcript": "Neqet-llu makut cait erutellrit-llu qeltait-llu cat cait tamalkuita qigcikluki taungutngatellruit [?] aulukelriit canek."
        },
        "62": {
            "start": 618.8,
            "end": 630.12,
            "transcript": "Makut-llu naunrarraungraata nunam qaingani naulriit cumertengateng, carrluguateng-llu tutmallermun elliqicuitellruit."
        },
        "63": {
            "start": 630.12,
            "end": 644.86,
            "transcript": "Tua-i-wa kencikngamegteki, kenciknarquciat nallunritliniat au͡gkut yuut ciumeggni yuullret cat tamalkuita."
        },
        "64": {
            "start": 644.86,
            "end": 657.22,
            "transcript": "Cat neqngurtelaameng up'nerkami cat naugaqata arnat cumertetullruut yuilqumek ayagaluteng canek neqkanek."
        },
        "65": {
            "start": 657.22,
            "end": 668.8,
            "transcript": "Qanraqluni tauna wiinga aanaka. Nunam-gguq qainga up'nerkami neqngurtelartuq, neqem mer'anek auluteng neqkanek."
        },
        "66": {
            "start": 668.8,
            "end": 675.88,
            "transcript": "Cat tua-i nunam qaingani naulriit tamarmeng neryunarqellriit neqngurrluki."
        },
        "67": {
            "start": 675.88,
            "end": 682.34,
            "transcript": "Taum-llu wiinga qigcikluki auluk'lauciit aanama nallunritellrua."
        },
        "68": {
            "start": 682.34,
            "end": 693.32,
            "transcript": "Imkut quagcit quagcinek pitukeput wiinga atagput acilqurluteng tua-i cumertetullrui tamakut amlleriluki."
        },
        "69": {
            "start": 693.32,
            "end": 702.66,
            "transcript": "Tua-ll' imna aciit kankut keniqataraqamiki au͡g'arturluki, carrluirturluki quyurtelarait cailkamun."
        },
        "70": {
            "start": 702.66,
            "end": 711.26,
            "transcript": "Tua-i-llu quyurqaarluki wiinga ellimelaraanga waten qaspellrama manuanun tamakut elliluki."
        },
        "71": {
            "start": 711.26,
            "end": 722.04,
            "transcript": "Tua-i-ll' nungulluku anutesqai, anuteqataamki alerqularaanga waten tutmallermun agu kuvyaqunaku."
        },
        "72": {
            "start": 722.04,
            "end": 727.28,
            "transcript": "Tutmallrunrilngurmun tarricaraunrilngurmun ciqiski."
        },
        "73": {
            "start": 727.28,
            "end": 734.0,
            "transcript": "Tua-i piaqluki, wiinga-am apcuunaku tamaa-i apteksaunaku."
        },
        "74": {
            "start": 734.0,
            "end": 743.22,
            "transcript": "Tua-i-ll' caqerlua cat iliitni aptaqa, imkut atsat qeltait au͡g'arraarluki-am."
        },
        "75": {
            "start": 743.22,
            "end": 752.76,
            "transcript": "Tua-i tamakut kencikqapiaranrungatnaurai pilaraanga, agurrluku tarricaramun tamakut kuvqeryaqunaki."
        },
        "76": {
            "start": 752.76,
            "end": 757.5,
            "transcript": "Ayautelaranka tua-i-ll' tarricaraungenrilngurmun kuvluki."
        },
        "77": {
            "start": 757.5,
            "end": 769.04,
            "transcript": "Caqerlua aptaqa, \"Ciin makut wani atunqigngailengraata tuaten pisqelarciki?\""
        },
        "78": {
            "start": 769.04,
            "end": 783.06,
            "transcript": "Tua-ll' pianga, \"Makut-gguq naunraat kenciknarqelriaruut, neqnguameng-gguq-wa tutmallermun ciqicetevkenaku.\""
        },
        "79": {
            "start": 783.06,
            "end": 796.98,
            "transcript": "Cat tamalkuan au͡gkut yuut avani yuullret qigcikellruit, takaqellruit cat naunrarrluaraungraata, takaqluki yuullruut."
        },
        "80": {
            "start": 796.98,
            "end": 804.7,
            "transcript": "Cat tamalkuan umyuarciutetullrulliniat au͡gkut ciuqlimta."
        },
        "81": {
            "start": 804.7,
            "end": 816.94,
            "transcript": "Canek-llu-wa tua-i anglaniyaranek-llu cayaranek tiiviinek, suuryaranek canek akusrarutengqellrunrilami."
        },
        "82": {
            "start": 816.94,
            "end": 829.68,
            "transcript": "Yuraryaraq kiingan au͡gkut mat'umi March-aami, April-aami-llu tamaa-i yuut quyurcaraqellruit."
        },
        "83": {
            "start": 829.68,
            "end": 839.48,
            "transcript": "Tua-i ayagaluteng, yuraliaraluteng pitullruut au͡gkut wii tangvallemteńek."
        },
        "84": {
            "start": 854.0,
            "end": 863.82,
            "transcript": "Ava-i qigcikillerkarput au͡gkunek ilakluki ciulirneput ava-i niigartellrukput ava-i ciuqvani."
        },
        "85": {
            "start": 863.82,
            "end": 878.52,
            "transcript": "Makunek ava-i uum-llu Lucy-m tapirluku makunek yuilqurmiutarnek cali qigcikillerkamteńek uqlaulluki aturarkaqenrilkemteńek."
        },
        "86": {
            "start": 878.52,
            "end": 889.24,
            "transcript": "Tua-llu una cali waniw' pikumta uumek, sharing."
        },
        "87": {
            "start": 889.24,
            "end": 900.34,
            "transcript": "Una wani, au͡g'um arulaciquq camek."
        },
        "88": {
            "start": 918.42,
            "end": 921.62,
            "transcript": "Takaqevkenata-qaa pillrukata?"
        },
        "89": {
            "start": 927.92,
            "end": 936.52,
            "transcript": "Tamakut-wa nallumteńi, wangkuta-llu ciumteńi."
        },
        "90": {
            "start": 939.32,
            "end": 957.88,
            "transcript": "Wangkuta uum makut ayuqamta-llu nalliini ayagyuallratni tamana ayagniumalria kinguvalria wangkutnun tan'gaurlullraullemteńi wangkuta tamana atuuguq ayagyuarluta tamaani."
        },
        "91": {
            "start": 958.92,
            "end": 975.2,
            "transcript": "Wangkuta tua-i qanruyutemteggun tamaaggun atungnaqellruaput, takuatni-llu nasvagciiganata camek piyunailkekiitnek ciulirnemta."
        },
        "92": {
            "start": 975.2,
            "end": 984.08,
            "transcript": "Tua-i nalluat pituyaaqukut, tau͡gaam takuatni qanerciiganata."
        },
        "93": {
            "start": 984.08,
            "end": 1005.66,
            "transcript": "Tau͡gaam cali angayuqamteńun qigcikinrilngurmek nallunrilkengangqerraqamta, wall'u nunamteńi pinrilengraan, allani-llu nunani."
        },
        "94": {
            "start": 1006.22,
            "end": 1020.5,
            "transcript": "Tamakut qigcikenritaqata angayuqameggnek-llu angayuqaita."
        },
        "95": {
            "start": 1020.5,
            "end": 1029.7,
            "transcript": "Mikluki waten pilaamegteki, waten piyugngallratni."
        },
        "96": {
            "start": 1029.7,
            "end": 1046.02,
            "transcript": "Kass'at piciryarangqertut tuaten irniameggnun qigcikinritaqata egmianun piqpalarai, piqertualarai tua-i ciumuqcetevkenaki."
        },
        "97": {
            "start": 1046.02,
            "end": 1064.7,
            "transcript": "Tamatum-llu nalliini tuaten pitullruitkut ayagyuarluta mikluta tuaten qigcikenritaqamteki inerquun narurtaqamki piqpalaraat, piqertualaraitkut nullumteggun canek."
        },
        "98": {
            "start": 1064.7,
            "end": 1078.5,
            "transcript": "Unatemteggun pivkenateng muragnek tua-i, tua-i qalervagamta takumcukevkenata, tua-i nutaan kinguani tuaten-llu piyuumiitarkauluta."
        },
        "99": {
            "start": 1078.5,
            "end": 1085.64,
            "transcript": "Tua-i au͡gna assikevkenaku piqpagallra tamana wangkutnun."
        },
        "100": {
            "start": 1085.64,
            "end": 1101.34,
            "transcript": "Tua-i nutaan tuaten kinguani-am kenekluta au͡g'umek, au͡gna kingulirluku assiriaqamta, qanrutenqegcaarluta pitullruitkut tuaten, tua-llu."
        },
        "101": {
            "start": 1103.46,
            "end": 1118.44,
            "transcript": "Tua-i piyunailngurmek pillrukan, piyunailngurmek ellmeggni pillrukan, tau͡gaam pirrlainarpek'naku, tua-i im' inerquutnguan pirrlainarluku pisqevkenaku."
        },
        "102": {
            "start": 1118.44,
            "end": 1132.44,
            "transcript": "Tau͡gaam tua-i pinarqellriamek assinrilngurmek pikan piqertuarluku ellangcarluku-gguq, tua-i nutaan ellangartelallilria ellangcarniaqatni ellangcarluku."
        },
        "103": {
            "start": 1132.44,
            "end": 1143.2,
            "transcript": "Tua-i tuaten pilallruitkut, tau͡gaam kinguani nutaan cali qanrutenqegcaarluta manigikumta."
        },
        "104": {
            "start": 1143.2,
            "end": 1152.52,
            "transcript": "Tua-i tuaten pilallruitkut tua-llu, tua-i au͡gna taringecuaraqa."
        },
        "105": {
            "start": 1152.52,
            "end": 1160.68,
            "transcript": "Tua-i qanrucunailkan irnian tua-i piqertuaniaran [?]."
        },
        "106": {
            "start": 1164.72,
            "end": 1172.64,
            "transcript": "Tua-llu uumun nugtara'arrluta ikayuutellerkamun, sharing each other."
        },
        "107": {
            "start": 1178.22,
            "end": 1189.2,
            "transcript": "Uum wani akim-wa tua-i tamatumun emergency nunat aturarkam amllerikanillerkaa umyuaqluku tua-i piciqukut."
        },
        "108": {
            "start": 1189.2,
            "end": 1204.38,
            "transcript": "Tayima aipaagni LKSD Central Support budget-aq ikegglikanirciqerput ilii im' ilanga'arrluku-ll' aipaagni pimaciquq-wa."
        },
        "109": {
            "start": 1204.38,
            "end": 1214.52,
            "transcript": "[?] ernerpak quyurciiqukut, tayima-ll' tua-i quyurtenriqumta nallunrilput tangerrluki."
        },
        "110": {
            "start": 1214.52,
            "end": 1225.22,
            "transcript": "LKSD Board-amun recommend-arciqukut tua-i qaillun pillerkaatnek mat'um central office budget-aam tungiinun."
        }
    },
    "KJQtj7e3uzg": {
        "1": {
            "start": 8.25,
            "end": 13.78,
            "transcript": "Tamalkuita angutet cap'iqatarniluteng kuigmek."
        },
        "2": {
            "start": 13.78,
            "end": 27.42,
            "transcript": "Tua-i-am nutaan tua-i taukut up'ngarrluteng yuut piqatartukut-gguq qanrutait. Tua-i-am anguterugaat atrarluteng. Kuik tua-i tamana nutaan capluku."
        },
        "3": {
            "start": 27.42,
            "end": 34.4,
            "transcript": "Nutaan tua-i avayanek tuaten kapurqiluteng muragnek elliirraarluteng."
        },
        "4": {
            "start": 34.4,
            "end": 43.7,
            "transcript": "Tua-i-am atanerrarluteng tau͡gaam tua-i alerquasterluteng ciulirnermegni tuaten atam piluku, tuaten atam piluku."
        },
        "5": {
            "start": 43.7,
            "end": 47.44,
            "transcript": "Alartaqan piluku tuaten piyunaitniluku."
        },
        "6": {
            "start": 47.44,
            "end": 54.74,
            "transcript": "Tua-i-am ciulirnerem alerquutiikun tua-i imna kuik tull'uni ikavet tut'aqluni."
        },
        "7": {
            "start": 54.74,
            "end": 66.94,
            "transcript": "Tua-i wangkuta-llu waten tua-i alerquutaitmun makut ciulirnemta camek imumek caliaqamta tua-i elluarrluta pilartukut."
        },
        "8": {
            "start": 66.94,
            "end": 78.92,
            "transcript": "Tua-llam wangkuta ciulirneput narurtaarluki piaqamteńi una-am tua-i calinguaryaaqellerput, piciurtevkenani assiinani nakrianani."
        },
        "9": {
            "start": 78.92,
            "end": 83.46,
            "transcript": "Tua-i ciulirnemta qanellra maligtenrilamteggu."
        },
        "10": {
            "start": 83.46,
            "end": 94.78,
            "transcript": "Tua-i-am tuaten calillgutkellriit mat'umek ikayurtaagulluteng atunem una waten ilii ayuquq."
        },
        "11": {
            "start": 107.12,
            "end": 116.74,
            "transcript": "Ikayuucarait-llu. Yaa, tua-i-w' nallunrilkemnek wiinga tua-i qalertellrianga."
        },
        "12": {
            "start": 116.74,
            "end": 125.06,
            "transcript": "Avani-llu niitelallemnek atulallemteńek-llu, nallullemnek wii pisciigani."
        },
        "13": {
            "start": 125.06,
            "end": 137.64,
            "transcript": "Niitelallruunga ayagyuaruluta camek unangengramta apailemta angayuqamteńek."
        },
        "14": {
            "start": 137.64,
            "end": 147.94,
            "transcript": "Camek-kiq qanerciigatniluta.Tangvallrenka au͡gkut ayuqellruut tan'gaurlurnek ellirnialget [?]."
        },
        "15": {
            "start": 147.94,
            "end": 159.86,
            "transcript": "Tan'gaurluut yuilqumek melqulegnek una pissutullruut arulainqayuunateng tangvallemni-ll' wii."
        },
        "16": {
            "start": 159.86,
            "end": 169.86,
            "transcript": "Tua-i-llu pitateng amlleriluki quyurrluki tun'ing'e'rmeng angayuqateng unguvaluki."
        },
        "17": {
            "start": 169.86,
            "end": 180.6,
            "transcript": "Kass'angan akimek unangengermeng ellaita pikniluki tamakut qanyuunateng piinateng."
        },
        "18": {
            "start": 180.6,
            "end": 188.92,
            "transcript": "Angayuqameggnun ikayuutekluki, angayuqameggnun tau͡gaam ataniumavkarluki."
        },
        "19": {
            "start": 188.92,
            "end": 193.92,
            "transcript": "Ellaita pilqeng'e'rmegteki pimeggnek qanyuunateng."
        },
        "20": {
            "start": 193.92,
            "end": 207.0,
            "transcript": "Waten qaneryararluni, \"Tan'gaurluq-gguq angayuqaagminek apailegmi, allakarmi-llu nengvailegmi piminek qanrarkaunrituq.\""
        },
        "21": {
            "start": 207.38,
            "end": 222.42,
            "transcript": "Nengluni tau͡gaam allakarmi aulukaangluni-llu arnamek piami irniaminek nutaan pitani, pitami-llu akiit nutaan elliin pikarkaurtelaraat."
        },
        "22": {
            "start": 222.42,
            "end": 233.72,
            "transcript": "Atanrussaalriarullrunritut au͡gkut ciuqliit ellaita-llu unangellmeng pitameng akiitnek, akiitnek atanrunritut."
        },
        "23": {
            "start": 233.72,
            "end": 251.48,
            "transcript": "Angayuqateng unguvaluki angayuqameggnun tunumiat [?], piminek qanyuitellruuq tan'gaurluq nasaurluq-llu piminek, elliin piminek angayuqaagni uumipailegmi [?] qanyuitellruut."
        },
        "24": {
            "start": 251.48,
            "end": 265.94,
            "transcript": "Tua-i-wa angayuqaagmi, angayuqaagminun ikayutekngamiki tamakut pitami akiit amllenrraata-llu akiit angayuqaagminun tunumiimi."
        },
        "25": {
            "start": 265.94,
            "end": 276.66,
            "transcript": "Maa-i mat'um nalliini tanglartua wiinga-llu irniamta pingqertut, caliluteng akingaqameng takarnarqelartut."
        },
        "26": {
            "start": 276.66,
            "end": 284.02,
            "transcript": "Wiinga-llu atanerciiganaki ellaita pikluki qanrut'laryaaqaqa."
        },
        "27": {
            "start": 284.02,
            "end": 294.08,
            "transcript": "Avani yuullemteńek mat'umek pingqerrniluta qanyuitellruukut."
        },
        "28": {
            "start": 294.08,
            "end": 303.56,
            "transcript": "Cat pillemta unangkengamta cat akiitnek pingqerrniluta qanyuitellruukut."
        },
        "29": {
            "start": 303.56,
            "end": 314.28,
            "transcript": "Angutet-llu tuaten pillutullruut angayuqateng unguvaluki pitateng egmianun ellitaqameng tua-i tangvalarai."
        },
        "30": {
            "start": 314.28,
            "end": 322.52,
            "transcript": "Tua-i-llu amiit-llu pinrata tayima tua-i nalluluki camun-llu tunguciinaki angayuqaagminun."
        },
        "31": {
            "start": 322.52,
            "end": 337.86,
            "transcript": "Tuaten yuut ayuqellruut mat'um nalliini akingirpagaluteng tan'gaurluut nasaurluut-llu calilaurcata angayuqaateng unguvangraata ellaita pik'larait."
        },
        "32": {
            "start": 337.86,
            "end": 350.36,
            "transcript": "Ikayuutekevkenaki-llu angayuqameng. Man'a cali maa-i au͡gkut ciuqliit cimiutaita ilakaat."
        },
        "33": {
            "start": 471.18,
            "end": 480.92,
            "transcript": "Una-w' tua-i calillgutkellerkaqa ava-i tua-i niiqurqeput waten ava-i au͡g'utun ayuqluku ilii tua-i cali tayima."
        },
        "34": {
            "start": 480.92,
            "end": 494.88,
            "transcript": "Calillgutkellerkam ikayurtaagutlerkaqa tua-i tuaten cali tayim' ilii qagvagtenrilengramteggu tau͡gaam avaggun ava-i taringua."
        },
        "35": {
            "start": 494.88,
            "end": 513.46,
            "transcript": "Tau͡gaam wavet nugtarrluta pikumta, family rules, yuk'elrit alerquatait, alerquutait, inerquutait-llu. Man'a nunamiutaq pitekluku."
        },
        "36": {
            "start": 513.46,
            "end": 527.08,
            "transcript": "Tamana naniteqerluku pikuvteggu one more hour pingqertukut, wangkuta-ll' panel-aami piksaunata time-aarrnayukluta."
        },
        "37": {
            "start": 527.08,
            "end": 534.4,
            "transcript": "Yaa, naniteqerluku una tua-i una-w' tua-i cass'arput pinariqataan."
        },
        "38": {
            "start": 545.26,
            "end": 555.26,
            "transcript": "Allami elitnaurarkaulriaten ima three o'clock, three to four. Maani avani cali? Yaa."
        },
        "39": {
            "start": 556.7,
            "end": 571.78,
            "transcript": "Una wani qalartellruuq, qalartellrani waten iciw' ikayuryugyaaqluni ilaitni car-akun natmun kina ayautesqumaluni."
        },
        "40": {
            "start": 571.78,
            "end": 587.0,
            "transcript": "Tua-i-ll' cali caliyaaqluni. Caliyaaqngami-ll' tua-i time-amek piluni cali tauna ikayuryugyaaqluku tau͡gaam tua-i cukangnaqluni iciw' atanemni [?] piluku."
        },
        "41": {
            "start": 587.0,
            "end": 603.78,
            "transcript": "Cali-ll' tua-i tauna tuavet piyaaqelliniluku tau͡gaam natmun cali ayautesqumaluni tauna ikayurkii, I mean ikayuqii, ikyuqngaa."
        },
        "42": {
            "start": 603.78,
            "end": 621.46,
            "transcript": "Tua-i-ll' uum aptesqaaten qaillun-gguq elpet piyarcit, qaillun umyuarteklerpeni tauna ikayullerkan umyuaqellerpegu qaillun-gguq piyarcit?"
        },
        "43": {
            "start": 621.46,
            "end": 628.86,
            "transcript": "Tauna-qaa ikayusqessaaqlua-qaa taumun taukut pivkenii iciw'?"
        },
        "44": {
            "start": 628.86,
            "end": 642.62,
            "transcript": "Malrussuarluni waten calivigluni elpet-llu ikayuusqumaluten uum natmun tuavet ayaucuggluten tua-i-ll' Oscar-aam piyaaqluten piyungermitun caliangqerrniluni amkunun time-airutnileng'."
        },
        "45": {
            "start": 642.62,
            "end": 655.62,
            "transcript": "Tua-i-ll' piyuumiileng'e'rmiten elpet peggluten ellii caliyarturluni. Qaillun-gguq tua-i-ll' waten piluni. Tamarkenka-gguq arenqiallugtesciiqak elpet amna-ll' atamini."
        },
        "46": {
            "start": 655.62,
            "end": 662.2,
            "transcript": "Elpet ikayuryaaqekuniten atanran qenruciiqaat tau͡gken."
        },
        "47": {
            "start": 662.2,
            "end": 666.9,
            "transcript": "Ca-ll' arenqiallugciiqlua ikayunrilkuma umyuarniurturlua."
        },
        "48": {
            "start": 666.9,
            "end": 674.68,
            "transcript": "Tua-i-ll' ilii wall' waten wavet ayakataryaaqluten wiinga-wa calivika wani."
        },
        "49": {
            "start": 674.68,
            "end": 685.72,
            "transcript": "Tua-i-ll' tuavet ayaulluten, tua-i-ll' tuavet piavet waten qanerluten, qamavet itqerrlua suukiigka cimilaggaarlukek yaani taguskia."
        },
        "50": {
            "start": 685.72,
            "end": 695.46,
            "transcript": "Tua-i-ll wii waten piyugyaaqlua, wani wavet ayagyugyaaqua caliyarturlua kingurautua, kingurautaqata atanrit pilaqait."
        },
        "51": {
            "start": 695.46,
            "end": 708.64,
            "transcript": "Tua-i-ll' wii waniw' uum assiillekciqua wani, agaucugyaaqluten amta-ll' caliyarturarkauyaaqlua. Qaillun-llu tayim' piciqsia?"
        },
        "52": {
            "start": 708.64,
            "end": 722.84,
            "transcript": "Ataneqa assilriarukan nunuyuilkan aipaagni tuavet ayaucaamten ikayuqeng'ellerkaqa piluku, ikayuqengelleq assilaa."
        },
        "53": {
            "start": 722.84,
            "end": 739.16,
            "transcript": "Tau͡gken ataneq-qaa assiilkan wavet utercet' ayagyugyaaqsartua, qaill' tau͡gaam picirkait aipaagni qanruciiqamken usuuq pisciigatua tua-i-ll ayakpaglua uniaqluten tua-i im' umyuarniurciqua."
        },
        "54": {
            "start": 739.16,
            "end": 753.4,
            "transcript": "Tau͡gken elpet-gguq tua-i ikayuqengluten pikuvet, elpet drive-arluten car-amek, kina tauna ikayurcetaaqan qaill'-gguq piyarcit? Taum wani aptesqaaten."
        },
        "55": {
            "start": 753.4,
            "end": 762.06,
            "transcript": "Tauna arcaqakenruyaqeka wii atanqa, atanranek kiiki pisteku-gguq [?]."
        },
        "56": {
            "start": 836.46,
            "end": 848.22,
            "transcript": "Tuaten piaqata ciulirneret-gguq-qaa taringlarait makut iciw' tua-i piyugyaaqemta tau͡gaam pisciiganateng ilaitni."
        },
        "57": {
            "start": 848.22,
            "end": 857.24,
            "transcript": "Tua-i-w' taringlaaqeput atanrit arcaqakuciit piyugluteng tua-i ataneteng tau͡gken takaqluki."
        },
        "58": {
            "start": 857.24,
            "end": 865.52,
            "transcript": "Taringlaaraput tua-i atanrit takaqngatki pinritellratnek wangkuta ikayugcetaang'e'rmi."
        },
        "59": {
            "start": 865.52,
            "end": 869.74,
            "transcript": "Pitsaqutmek-llu-qaa tua-i niitenricukevkenateng piluteng."
        },
        "60": {
            "start": 869.74,
            "end": 877.98,
            "transcript": "Pitsaqevteńek-llu niitenricukevkenata atanrit tau͡gaam takaquciit nallunrilaraput."
        },
        "61": {
            "start": 919.9,
            "end": 933.66,
            "transcript": "Man'a ilii yugcetun piqa'aqluku piqataraput ilagautellarniartuten. Pingayun, three-aam, okay, taukut."
        },
        "62": {
            "start": 939.9,
            "end": 951.74,
            "transcript": "Man'a waten mikluta niicugnisqelluta pilaqaikut tuaten elitalarniluta."
        },
        "63": {
            "start": 951.74,
            "end": 967.52,
            "transcript": "Tua-i-ll' ilaitni Kass'at tangvagaqakut tamana imkucirniluki tang mikelngulriani pilaraakut, passive-aaq qaillun pilarta Yugcetun?"
        },
        "64": {
            "start": 968.9,
            "end": 974.44,
            "transcript": "Tua-i-w' elicuumiinata wall' caperrsuarluta-wa?"
        },
        "65": {
            "start": 985.04,
            "end": 989.62,
            "transcript": "Murilkessiyaagpek'nateng qalartellria murilkessiyaagpek'nateng, yaa."
        },
        "66": {
            "start": 989.62,
            "end": 1007.1,
            "transcript": "Tuaten-gguq Kass'at tangvagaqamegteki tangerrngat'larait, nepaitessiyaagaqata, tau͡gken-gguq wangkuta yuuyaraput aturluki elicungcarikumta mikelnguut, niicugniyaaqluni tua-i mikelnguq."
        },
        "67": {
            "start": 1007.1,
            "end": 1019.68,
            "transcript": "Tau͡gaam apqaussiyaagpek'nani. Tamakut tuaten imkucilartuk."
        },
        "68": {
            "start": 1022.28,
            "end": 1026.64,
            "transcript": "Conflict, puukautelartuk."
        },
        "69": {
            "start": 1031.52,
            "end": 1034.3,
            "transcript": "Pairut'lartuk."
        },
        "70": {
            "start": 1089.34,
            "end": 1098.88,
            "transcript": "Qanlallrulriit qalartellriim kiugum, qanra murilkuraasqelluku uluquvgu tayim' qanellra cauciiqniluku."
        },
        "71": {
            "start": 1098.88,
            "end": 1117.5,
            "transcript": "Tau͡gken imkulriit ataucirrarmek tegganraurtellriim, tegganraurtellria wall' qallarvagtellriim [?] nunurluku wall' qalarulluku kina pikuniu iigken'gun tangvagciigat'laraa nallunritliken [?]."
        },
        "72": {
            "start": 1117.5,
            "end": 1128.58,
            "transcript": "Tayima-ll' wiinga-ll' qalarutesciigaqama tua-i-w' iignun pikavet tangvagluku pisciigatua takaqluku."
        },
        "73": {
            "start": 1128.58,
            "end": 1144.36,
            "transcript": "Tau͡gken imkut wani elitnauristet Kass'at allanek naken tailuit tamakut wani allaunrulartut tuaten pillret, qanlartut tangvaglukek iigka niicugninga."
        },
        "74": {
            "start": 1144.36,
            "end": 1165.06,
            "transcript": "Tamana imkulartuq alingnaq'lallruuq wangkutnun mikelnguuluta assiitellruuq takaqsaaqluku takaqluku tangvagciiganaku piaqamegteki ellaita nunurluta pilallruitkut tangvagluten pisqelluteng qalarrnginanermeggni."
        },
        "75": {
            "start": 1167.38,
            "end": 1171.06,
            "transcript": "Tua-ll' pinrilkumta takaqenritniluteng."
        },
        "76": {
            "start": 1171.06,
            "end": 1178.82,
            "transcript": "Tangvanrilkekumteki ellait takaqenritniluteng qenertaqluteng."
        },
        "77": {
            "start": 1178.82,
            "end": 1184.42,
            "transcript": "Ilait tua-i piqertua qiaqluteng tangvagluteng [?]."
        },
        "78": {
            "start": 1184.42,
            "end": 1193.52,
            "transcript": "Tangvanritniluteng. Iciw' elitnauristet Kass'at."
        },
        "79": {
            "start": 1193.52,
            "end": 1200.06,
            "transcript": "Tua-llu allat cali piqerlaut time-akut tang cukari'."
        },
        "80": {
            "start": 1203.16,
            "end": 1213.02,
            "transcript": "Atam tua-i qalarut'larkauyaaqai yuum ciulirnerem mikelnguq tua-i mikelnguungraan wall' taqnerungraan."
        },
        "81": {
            "start": 1213.02,
            "end": 1223.3,
            "transcript": "Tua-i tangerrluku qanrut'larkauyaaqaaqa qagaanun-llu ellami ayuqucirturluku ayuqucirtun-llu tamana quyakumaarkauluni."
        },
        "82": {
            "start": 1223.3,
            "end": 1228.52,
            "transcript": "Yuum iliinun, iliinun tau͡gaam cangayuutngutekluki."
        },
        "83": {
            "start": 1228.52,
            "end": 1237.26,
            "transcript": "Maa-i tua-i-w' tuatnalriartairullemtun [?] ellami-ll' qagaani tarrarteng'e'rma kia qalaruteksaunani."
        },
        "84": {
            "start": 1237.26,
            "end": 1249.14,
            "transcript": "Maani tau͡gaam una iciw' ava-i watua qanrutkeqallratgen ciuqliussaagesqevkenata inerquutngurtell' maa-i tau͡gken ayagyuani wangkuta elitnaurumalriani."
        },
        "85": {
            "start": 1249.14,
            "end": 1259.52,
            "transcript": "Man'a elitelput aturluku waten qalarcugngariluta tegganret ciuqerrarki, ciullegluki."
        },
        "86": {
            "start": 1259.52,
            "end": 1273.52,
            "transcript": "Tua-ll' tegganret tayim' assiilkelaryaaqelliki tamana tuaten tamatum. Wall'u-qaa picimek qalartellriani cangana' [?]?"
        },
        "87": {
            "start": 1273.52,
            "end": 1285.82,
            "transcript": "Tua-i assilriamek qanquni ayagyuaq ellangnarquq atam wangkutnun ciulirnerni nallunrilkemeggnek tua-i nallunritqapiarqemteńek qalartetuukut."
        },
        "88": {
            "start": 1285.82,
            "end": 1301.4,
            "transcript": "Wiinga-ll' ava-i watua ava-i waniw' qalartua nallunrilkemnek wii-ll' atullemnek nallukemnek pisciiganii, qanerciiganii tau͡gaam tua-i nallunrillemnek."
        },
        "89": {
            "start": 1301.4,
            "end": 1319.04,
            "transcript": "Au͡gkunek-llu ciulirnernek au͡gkunek-llu callemnek tua-i nallunrillemnek assillrullinilrianek-llu, assillrulliniaqluteng-llu cangalkevkenaki atullrenka. Tua-i assiilalliniluteng ilait."
        },
        "90": {
            "start": 1330.82,
            "end": 1343.52,
            "transcript": "Maa-i iciw' in the modern world, imkucirrniluta qaillun competitive-aanritniluta pilaqiikut."
        },
        "91": {
            "start": 1343.52,
            "end": 1351.26,
            "transcript": "Kia? Nalaita? Others or Kass'at?"
        },
        "92": {
            "start": 1351.26,
            "end": 1367.52,
            "transcript": "Tau͡gaam competitive-aaryaaqluta, tau͡gaam piyaaqluta, tau͡gaam qaillun tamakut alaitat. Qaillun pilarceta, qaillun...?"
        }
    },
    "31balluMwfE": {
        "1": {
            "start": 7.07,
            "end": 18.34,
            "transcript": "Qaruyun kenkun irniarput wangkuta kitugtarkaqerput taqnerurtengraan kitugtarkarput wangkuta angayuqaaritni."
        },
        "2": {
            "start": 18.34,
            "end": 29.0,
            "transcript": "Qaill' ayuq' uum mikluni waten elluar' ukut tangssuirutnarqut tua-i quyana taum' taqua [?]."
        },
        "3": {
            "start": 30.13,
            "end": 32.61,
            "transcript": "Quyanarquten pitsaqevkenak'..."
        },
        "4": {
            "start": 32.61,
            "end": 49.86,
            "transcript": "Wiinga qanqasqumiitnga waniwa wiinga elitarenritqapiartua au͡g'umek nulir' aipaqsagutnerraaram ayuqucianek irniamni."
        },
        "5": {
            "start": 49.86,
            "end": 62.98,
            "transcript": "Tau͡gken wii elpenllemni [?] au͡gkut ciuliaput elitnaurilallruluteng aipaqsaram uum ayuqucianek aipangniaralriamek."
        },
        "6": {
            "start": 62.98,
            "end": 74.0,
            "transcript": "Wiinga-ll' ilaklua elitnauraita tamaa-i aipangniaralriit elitnaurviaqata qanaalluki."
        },
        "7": {
            "start": 74.0,
            "end": 84.32,
            "transcript": "Tua-i tau͡gken wiinga watua maa-i irniamni aipangyaramek elitnaunritqapiartua qanemkun."
        },
        "8": {
            "start": 84.32,
            "end": 94.0,
            "transcript": "Avani wiinga ciulirneput wangkuta elissaritullruameng elissatullruitkut."
        },
        "9": {
            "start": 94.0,
            "end": 105.02,
            "transcript": "Arnartuungamta tan'gurrarni-ll' wangkuta aipaqucaram uum ayuquciqsaraanek cunawa tua-i-ll' elissarautullruluta."
        },
        "10": {
            "start": 105.02,
            "end": 117.0,
            "transcript": "Wangkuta tan'gurrarni elitnaurqamegteki aipangelkamteńek uum aiparkamta ayuqucirkaanek qanrutaqluta."
        },
        "11": {
            "start": 117.0,
            "end": 129.0,
            "transcript": "Aiparput una aturallerkainek pisciigalkumteggu man'a pingnaqsaraq aturluku pikilkumta."
        },
        "12": {
            "start": 129.0,
            "end": 140.0,
            "transcript": "Aturallerkainek aiparput pisciigalkumteggu nulirtuguarluta-gguq kepeqevkararkamteńek nulirturciqukut."
        },
        "13": {
            "start": 140.0,
            "end": 153.66,
            "transcript": "Tuamta-llu angussayuilkumteggu-gguq aiparput nulirturuarluta kainginqevkararkamtenek nulirturciqukut."
        },
        "14": {
            "start": 153.66,
            "end": 171.44,
            "transcript": "Cali-llu murillniankumta irniarput unatminek meluulangareskuni tua-i-gguq taum irniamta ellimerraakut angungnaqia aataa neqkamnek."
        },
        "15": {
            "start": 171.44,
            "end": 179.56,
            "transcript": "Unataikun cali tua-i umyuarteqlerkamteńek irniamta cikiumaluta."
        },
        "16": {
            "start": 179.56,
            "end": 190.2,
            "transcript": "Irniaput unatmeggnek meluuryugngareskata ellimerciullerkarput irniamteńek aata neqkangengnaqia."
        },
        "17": {
            "start": 190.2,
            "end": 199.66,
            "transcript": "Tamakutgun tamaa-i wangkuta elissallruitkut aipangllerkarput tekilluku tua-i aipangkumta."
        },
        "18": {
            "start": 199.66,
            "end": 211.1,
            "transcript": "Cali-llu aiparput-gguq una piipiaraluni enem iluani qankut. Tua-i-gguq taum aipamta."
        },
        "19": {
            "start": 211.1,
            "end": 226.0,
            "transcript": "Taumek atu'urkaminek unangengnaqutesqelluni piipiarakuni qanrutaanga. Tua-i tamakunek tamaa-i nallunritevkallruitkut."
        },
        "20": {
            "start": 226.0,
            "end": 238.06,
            "transcript": "Nengaugisngaurlukumta-gguq taum aipaqliuskengamta ilailngullaulluta."
        },
        "21": {
            "start": 238.06,
            "end": 255.82,
            "transcript": "Cassurpek'nata-gguq neqkaaraitnek nanguluugutnguyarturciqukut wangkuta ikayuulluta taukunun ciunemteńun nengaugisvimteńun, neqka'arqun maaggun muragkun-llu pinrilkumta."
        },
        "22": {
            "start": 255.82,
            "end": 273.0,
            "transcript": "Tua-i-gguq cauvkenata taukunun nengaugisvimteńun angulurutnguciqukut neqkaitnek wall'u ikayuanrilkumteki muraggarkun qessaluta-gguq uitastenguciqukut."
        },
        "23": {
            "start": 273.0,
            "end": 281.84,
            "transcript": "Tua-i tamakunek tamaa-i elitnaurucirluta waten aipangyaram tungiinun pillruitkut."
        },
        "24": {
            "start": 281.84,
            "end": 294.76,
            "transcript": "Ayagmek-llu wangkuta tua-i aipangnaluta umyuarteqaqamta una nemguuq usvigaitellerkaq [?] ciuqliuluku umyuaqetullruarput."
        },
        "25": {
            "start": 294.76,
            "end": 304.38,
            "transcript": "Aipaput-llu quyumta uitakumta nengaugisvigaitellerkam una umyuam ciuqliqluku."
        },
        "26": {
            "start": 304.38,
            "end": 320.82,
            "transcript": "Cali-llu aipangkumta nernariaqan qancuunguaq teguluku tungelqerruanek [?] imiqassaagallerkai neqkaminek tauna tua-i elkasgunaqluni waten aipangllem kinguani."
        },
        "27": {
            "start": 320.82,
            "end": 332.14,
            "transcript": "Tua-i tamaani elissaumiitkut ciulirnemta waten nulirturluni, aipaqliinerraarluni ayuqucirkamek."
        },
        "28": {
            "start": 332.14,
            "end": 355.92,
            "transcript": "Cali-ll' una wiinga qanruyutekqallruaqa irniaqa-gguq umyuartektusqumaqumku pikamangkengraan tua-i-wa imumek atu'urkaanek umyugailka cautekaanek manamaarpiiqnaku pikilaku."
        },
        "29": {
            "start": 356.0,
            "end": 365.0,
            "transcript": "Tua-i tamana call' tua-i-w' piciunlikluni [?] waten mikelnguq man'a avgerutekaanek man'a maarpakaqumteku."
        },
        "30": {
            "start": 365.0,
            "end": 373.04,
            "transcript": "Tua-i cali tauna umyugailkaa cautnguyugngacia wii taringumallruaqa mikelngurmun."
        },
        "31": {
            "start": 373.04,
            "end": 386.92,
            "transcript": "Cali-llu wangkuta angayuqrulriani ava-i qanqertua irniamek elicarinritqapiarallemnek aipaqucaram tungiinun."
        },
        "32": {
            "start": 387.0,
            "end": 399.04,
            "transcript": "Tau͡gaam tuaten elicarinrilngerma waniwa aanasneng-llu [?] pinerrluatevkarlunuk tangertailgakuk man'a tekitarpuk."
        },
        "33": {
            "start": 399.04,
            "end": 418.86,
            "transcript": "Tamaaggun tamaa-i qaneksailengramegnek irniapuk tangaalilingnaqluki aipaqutellerkaatnek elluarrluteng tua-i qanaatepigainalrateng [?] wangni ayuqelarapuk tuaten qaralirinrilkurtellmegnegem [?] pinerrlua-llu."
        },
        "34": {
            "start": 418.86,
            "end": 436.5,
            "transcript": "Qanllamegnegem tallimegnek tua-i man'a maa-i tekilluku cali-ll' ava-i Ben qanelria aipaagni pinqigcuumirallran keniryaramek mat'umek nalluniqellranek."
        },
        "35": {
            "start": 436.56,
            "end": 453.36,
            "transcript": "Wiinga keniternillerkaqugtua wii apsiyaanrilamku makunek keniryaranek cumikluki pilaamki waten cali yuilqumun ayagayaurteqarraullemteńi alerquumatullruamta."
        },
        "36": {
            "start": 453.36,
            "end": 461.9,
            "transcript": "Unakut ciulirnerput maligeskengarput ken'ingeskilai yuilqumi tamaa-i wangkuta."
        },
        "37": {
            "start": 461.9,
            "end": 479.3,
            "transcript": "Waten tan'gurrameggni ciulirnemta malikaqamegteku kimutun tua-i tegussuukelriatun ayuqetullruitkut arulaiquneng kenirnarqelriamek neqkangqerquneng ellimerrluta."
        },
        "38": {
            "start": 479.3,
            "end": 491.74,
            "transcript": "Kitak muragkiurluki kenia tua-i tamaa-i maligtaquluki tamaaggun ayagniutekluki keninek imutun nallunrilriatun ayuqluku."
        },
        "39": {
            "start": 491.74,
            "end": 503.88,
            "transcript": "Una waniwa nangenruluku una waniw' caliqliqa ukanirpak can'giilegmiunguuq ayakatarallerminek-ll' ayagluni can'giiq nerluni."
        },
        "40": {
            "start": 503.88,
            "end": 514.08,
            "transcript": "Wiinga-ll' tua-i tuaten ayaglua piukuma uksuaq qayagaraanga kelgaraa [?] neryartuusqellua."
        },
        "41": {
            "start": 514.08,
            "end": 529.32,
            "transcript": "Tua-i itrama pianga kenilaagtua, ikayua kenilaagtua pianga can'giirnek, aren tua-i can'giirnek keniryarait nallunrilamki."
        },
        "42": {
            "start": 529.32,
            "end": 539.1,
            "transcript": "Waten-llu uyangqaarluku tegulluku ayagtuq qallangqa'atarluni aren ipugnarilriit-wa."
        },
        "43": {
            "start": 539.1,
            "end": 551.0,
            "transcript": "Tua-i-llu piaqa, \"Qallangeqatarnillruaten-ggem ciin tua-i ipuunriciikii.\" Pianga, \"Uugai-qaa?\" [?]"
        },
        "44": {
            "start": 551.0,
            "end": 564.5,
            "transcript": "Tua-i ak'a apcimaurallruaqa cangayuusqevkenaku tauna qanemciyaaq' [?], yaa au͡g'um tua-i engel'aqerciqngavci iquliqa'arqa caningqakngamku cali wani."
        },
        "45": {
            "start": 564.5,
            "end": 572.0,
            "transcript": "Ii-i quyana tua-i au͡g'umek angayuqaat, una piqatartuq."
        },
        "46": {
            "start": 572.0,
            "end": 583.62,
            "transcript": "Kingingarcetaanga au͡g'um qanemci' [?], wiinga waniwa qanqatartua."
        },
        "47": {
            "start": 583.62,
            "end": 597.22,
            "transcript": "Imkut qanpiatullrat, wangkurluta ngelkekqapiarngataitkut qasgimi alingara'arpek'nateng qantullret."
        },
        "48": {
            "start": 597.22,
            "end": 613.56,
            "transcript": "Waniwa-llu ayagyuarrarni murilkelluci niicugniurluci. Grandma-t ayuqucillrat tangvallrenka qanrutekeqataranka."
        },
        "49": {
            "start": 613.56,
            "end": 633.0,
            "transcript": "Uingaqameng tang ukut arnarkaraurluurluteng maa-i, uiteng upnaurait nuqairluki keniulluki."
        },
        "50": {
            "start": 633.0,
            "end": 643.0,
            "transcript": "Ellaita neqkaq tegularpek'naku arnaitat [?] tau͡gaam, cali wii man'a qanruteksugqa."
        },
        "51": {
            "start": 643.0,
            "end": 663.54,
            "transcript": "Paningqertua fifty tua-i apurluku allrakuqernganani, arnam cimillra aipaqsagucamku ukut yaaqsinrilamegteggu."
        },
        "52": {
            "start": 663.54,
            "end": 676.08,
            "transcript": "Watqapik neryaraq kitungraan nerngaituq tekicimavkenii qanruyuci aturluku pillilriit."
        },
        "53": {
            "start": 676.08,
            "end": 688.0,
            "transcript": "Arnarkaraurluq uum man'a uqitarrallaagluni arnauluni."
        },
        "54": {
            "start": 688.0,
            "end": 709.36,
            "transcript": "Angangurluma nulirtuama caunrirlua pilaraanga nakleng nulirturlulria kaaka ayuqmiarcelluku nulirqekuvgu nulirturyuguarraarluni."
        },
        "55": {
            "start": 709.36,
            "end": 721.0,
            "transcript": "Picalnguq'larqa tamana ellii qanellra nengaqerratekluku, nengaqercetaarlua pingatelaama."
        },
        "56": {
            "start": 721.0,
            "end": 743.0,
            "transcript": "Waniwa ukut ang'urallruyaaqut assirluteng tau͡gaam wii panimnek cuqyutekluku fifty-q piqerrirluku [?] arnat piyarait cimiqngatellruuq."
        },
        "57": {
            "start": 743.0,
            "end": 763.0,
            "transcript": "Nakleng uingami irniangengami angutii tau͡gaam terr'ilicirnauraa, angutii-llu keniryaraq teguluku kenirnaurtuq."
        },
        "58": {
            "start": 763.0,
            "end": 777.04,
            "transcript": "Panika suukiicuarluni anciquq qanerluni nernariuq-qaa, neqkat-qaa upingariut."
        },
        "59": {
            "start": 777.04,
            "end": 794.62,
            "transcript": "Nakleng-lli kasnguyularyaaqvaa wangnun tuaten qanqaqan, tamana cali engel'engqerrngatellruuq wii panika tuaten piyaurtellranek."
        },
        "60": {
            "start": 794.62,
            "end": 804.46,
            "transcript": "Pispayugaqluki angutet, terr'iliciurtekluki anguceteng."
        },
        "61": {
            "start": 804.46,
            "end": 814.16,
            "transcript": "Tamana assinrituq ciuliamta qanruyutekenritait."
        },
        "62": {
            "start": 814.16,
            "end": 822.0,
            "transcript": "Tuaten ayagyuani nasaurluni piqeryaqunaci."
        },
        "63": {
            "start": 823.0,
            "end": 830.56,
            "transcript": "Wangkuta waniwa ayallurturlurciqukut nunam qainganun."
        },
        "64": {
            "start": 830.56,
            "end": 846.0,
            "transcript": "Elpeceńun-llu waniwa ciqertauteksaaqerput elpeceńun ciuliamta piciryaraat, alaicestegnaqelqelluku [?]."
        },
        "65": {
            "start": 846.0,
            "end": 852.72,
            "transcript": "Una cali wiinga akikelalqa qanqautekeqata'arqa."
        },
        "66": {
            "start": 852.72,
            "end": 872.0,
            "transcript": "Tan'guraulullemteńi inerqutullruitkut anguvagu [?] nasaurlurmek cingaqutaraasqevkenata alaunata malikluku."
        },
        "67": {
            "start": 872.0,
            "end": 890.2,
            "transcript": "Mat'um nalliini nunanun ayagaqamta nasaurluq tan'gurraq-llu nuliqsagucugnailnguum-wa cingaqumyara'uciiquq tass'uq tuaten ceńirtaarlutek."
        },
        "68": {
            "start": 890.2,
            "end": 904.16,
            "transcript": "Tauna ciuliamta nallunritaat iqugglirrnganrem wangkuta pitsaqulallrulliniakut assiituq [?]."
        },
        "69": {
            "start": 904.16,
            "end": 917.5,
            "transcript": "Iqniangqerrsaraq ayuqucia anguvagu [?] maurluq cakaarpek'naku."
        },
        "70": {
            "start": 917.5,
            "end": 926.96,
            "transcript": "Irniangqerrsaram ayuqucia tekitnaunallerpeceńun kangingengnaqkiciu nasaurluni."
        },
        "71": {
            "start": 926.96,
            "end": 948.72,
            "transcript": "Tan'gurrarni-llu nulirqucaram auluklerkatmi aipam taringengnaqkiciu qunusngaitaaci qanruyutmek tengruluteng imkucirturciqaaci."
        },
        "72": {
            "start": 948.72,
            "end": 968.0,
            "transcript": "Waniwa wangkuta nangyaryuutengqurrlurtukut mat'umek kingu ciuliamta qanellra cali wangkutnun elpeceńun tuquturpailgata paitaqesqelluku."
        },
        "73": {
            "start": 968.0,
            "end": 978.5,
            "transcript": "Atam-wa angukarlaaraat iliit una tuqu'urlurpailegmi."
        },
        "74": {
            "start": 978.5,
            "end": 991.26,
            "transcript": "Caqnerutekluku nangteqeng'e'rmi tekituq iigemkun-llu tangrraqa, temni una arenqiallugaat."
        },
        "75": {
            "start": 991.26,
            "end": 1003.78,
            "transcript": "Terr'ilitaq tua-i maakung'e'rmeng [?] paicitengnaqaakut paicitengnaqaaci temni una assiit' [?]."
        },
        "76": {
            "start": 1003.78,
            "end": 1022.0,
            "transcript": "Qiarlullruukut tauna ayuqngailamtekun ayuqucirtuut pitekluku nangtequrang'e'rmi paitaqevkangnaqluku."
        },
        "77": {
            "start": 1022.0,
            "end": 1028.62,
            "transcript": "Naskutagarni man'a nalluyagucaqunaciu."
        },
        "78": {
            "start": 1028.62,
            "end": 1044.44,
            "transcript": "Wangkuta ciuliamteńek tuqu'urluqumta elpeceńun atuusqelluku cumigturluryaaqukut man'a elpeceńun taringesqelluku."
        },
        "79": {
            "start": 1044.44,
            "end": 1059.0,
            "transcript": "Quyakluku-llu Calistem taringevkangnaqaa elliin akilingluta. Quyanaqsaaqluni cali Calista. Quyanarpiit-lli."
        },
        "80": {
            "start": 1061.18,
            "end": 1078.5,
            "transcript": "[?] unugmi-ll' [?] tua-i-ll' au͡g'um [?] qanqallra ilii piksaitaat qanaangermeng."
        },
        "81": {
            "start": 1078.5,
            "end": 1089.04,
            "transcript": "Tua-i qancuaqaqatartua amllenrilengraan [?] nurtengaan."
        },
        "82": {
            "start": 1089.04,
            "end": 1103.8,
            "transcript": "Au͡g'um qanqallrulria nauwa aipaqumta aipaquc'araraat makut tutgaraalriik ayuquciarkaagnek. Irniam-ll' ayuqucirkaanek."
        },
        "83": {
            "start": 1103.82,
            "end": 1116.0,
            "transcript": "Tamana mikelnguum anglicaarallra qacignarqenrituq, qacignarqelriarunrituq. Nallunritarcia aipalegni irnialegni-llu."
        },
        "84": {
            "start": 1119.0,
            "end": 1128.86,
            "transcript": "Tamana pitekluku ketevassiima, mitu'akama [?]."
        },
        "85": {
            "start": 1128.86,
            "end": 1142.34,
            "transcript": "Tua-i tayima qancuaqerciqua amllerpek'nak waten-am qanellruuq au͡g'umek qanruyutmek."
        },
        "86": {
            "start": 1142.34,
            "end": 1158.54,
            "transcript": "Angliyugallrani mikelnguq auluklerkaanek. Ilaita qanqatek'laraqaat iliit tau͡gaam elluarrluku qanruteksaitait."
        },
        "87": {
            "start": 1158.54,
            "end": 1173.02,
            "transcript": "Tua-i mikelnguma cacuurtellerkaa tau͡gaam unugyalarquq arcaqalriaruuq. Aipaqutellriit caliaqaqngamegnegu."
        },
        "88": {
            "start": 1173.02,
            "end": 1187.04,
            "transcript": "Una wani mikelnguum anglicaarallra anglicarluku-w' tua-i qanrutenrisqurrluku piyunaitaat."
        },
        "89": {
            "start": 1187.04,
            "end": 1205.22,
            "transcript": "Tau͡gaam qanqautaqluku amllenrilengraan piurquni mikelnguq nasaurluq wall'u angun tan'gurraq."
        },
        "90": {
            "start": 1205.22,
            "end": 1216.98,
            "transcript": "Waten ilumun pilegyagaluni mikelnguq qan'angcuunaitaa."
        },
        "91": {
            "start": 1216.98,
            "end": 1230.24,
            "transcript": "Waten ilii pilartuq. Agayutkun tau͡gaam elluarrluni niicugninelguciquq mikelnguq."
        },
        "92": {
            "start": 1230.24,
            "end": 1246.78,
            "transcript": "Uuggun qanpagakun, eyagtaakun, unatetgun ikayugaitai yuum ayagyuam mikelnguq waten ciitengilria."
        },
        "93": {
            "start": 1246.78,
            "end": 1262.68,
            "transcript": "Tuaten, tuaten-gguq ayuqequni qanrutek'lallrukuit-am nunurluku qatpagalluku, qanpagalluku piaqami."
        },
        "94": {
            "start": 1262.68,
            "end": 1276.9,
            "transcript": "Umyugait-llu naigterrlainarluku caunrilkelluku irniaqenrilengramteggu qanruyutkut tau͡gaam piarkaulliniarput, piarkaulria yuum yaaqerput."
        },
        "95": {
            "start": 1279.6,
            "end": 1292.66,
            "transcript": "Una wani mikelngumek navguilkak, tau͡gaam itqapiaralriaruuq assirpek'nani-llu iqua."
        },
        "96": {
            "start": 1295.0,
            "end": 1308.16,
            "transcript": "Waten-gguq ayagyuaq qanpavaqurluni, unatet-llu yagtepiaqluni, teguleraaluku piyunaituq."
        },
        "97": {
            "start": 1308.16,
            "end": 1329.6,
            "transcript": "Tuaten-gguq tamana aturluku anglicayaaqekuni irniarak tauna caacurciiquq tegulegarluni, iqlungarluni, ca tua-i aturyugluku, ellminek pik'uni."
        },
        "98": {
            "start": 1329.6,
            "end": 1345.18,
            "transcript": "Qanpauteng'e'rmi-llu qanruciuqellriim unaksuunaku, unakesciigaliluku, wa-gguq-qaa asmuarrluku, asmuarrluku pavairulluku [?]."
        },
        "99": {
            "start": 1345.18,
            "end": 1360.42,
            "transcript": "Tamana tamaa-i ilumaga qanrutekcuarallruyaaqa, tau͡gaam elluarrluku qanrutekestiinek niiteqaqsaitua."
        },
        "100": {
            "start": 1360.42,
            "end": 1383.78,
            "transcript": "Uutun wani taangaqlainaq-llu pivkenaku, navgutullinia yuum wall' angayuqaqenrilnge'rmi, irniani-gguq yuum qanruquvararkauga imutun."
        },
        "101": {
            "start": 1384.0,
            "end": 1405.7,
            "transcript": "Kenkeqapiaraliatun qaruqerluku piurkuni tau͡gaam mikelnguq elluarrluni-gguq angliciquq, wiinga apa'urluraankuk qanruaqlua yuullruyaaquk, ukuk wani Uksulluku [?] ukuk, Cinguquq-llu [?]."
        },
        "102": {
            "start": 1408.0,
            "end": 1426.18,
            "transcript": "Tua-i tamana tamaa-i aarnarqelriarulliniuq makunun mikelngurnun irnianun tan'gurraq arcaqerluni, arnamun-llu ping'e'rmi tua-i tegumanruluni."
        },
        "103": {
            "start": 1430.0,
            "end": 1445.02,
            "transcript": "Tuaten-gguq pileryagaluku qanpagalluki piyaaqekumteggun pamailcarciqerput [?], pamaunani qanqauteng'e'rmi maligarucuunani."
        },
        "104": {
            "start": 1445.02,
            "end": 1460.62,
            "transcript": "Waten qanqaulluku pikumteggu inerqurluku, tua-i-ll' elitenrirkan anglirikanirluku qanrulluku erinaa tegg'ikanirluku."
        },
        "105": {
            "start": 1462.54,
            "end": 1475.68,
            "transcript": "Tua-i tauna mikelnguq navgurciqliniarput tuaggun, yugnam muriciqliniuq tuaggun ulumikun, erinamikun."
        },
        "106": {
            "start": 1476.0,
            "end": 1484.62,
            "transcript": "Tamaa-i wangkuk acivrurrluku [?] pamairulluku qanqam' ngelqaqenrirluku."
        },
        "107": {
            "start": 1484.62,
            "end": 1493.14,
            "transcript": "Ilii-am tamallra catataitelartuq tua-i qanelriamek niiskuni."
        },
        "108": {
            "start": 1493.14,
            "end": 1509.22,
            "transcript": "Una waten pikuni acillerkaanek qanqaqan, ilii tua-i uitacurlagluni tauna qanrutkellraa qasgimi pitullrukiit ilait."
        },
        "109": {
            "start": 1509.22,
            "end": 1522.18,
            "transcript": "Tua-i cunaw' tuaten ayuqellinia. Iliit tau͡gken qanelriamek niitelriit tua-i camek niitenrilnguq ayuqluni."
        },
        "110": {
            "start": 1522.18,
            "end": 1528.88,
            "transcript": "Tuaten ayuqelliniuq tamana mikelnguq anglica'aryaraq."
        },
        "111": {
            "start": 1528.88,
            "end": 1544.2,
            "transcript": "Imutun-gguq mikelnguq tan'gaurluq arcaqerluni miklenguq-gguq imutun kiimitun ayuquq aqsaaraam ngelqaqluku."
        },
        "112": {
            "start": 1544.2,
            "end": 1562.4,
            "transcript": "Cali-llu angayuqaarulriani mikelnguq tauna takurqeraluku piyunaunani atunem qanqallagallumteńek piyunaunatek tua-i. Tua-i tuaten ayuq'liluni."
        },
        "113": {
            "start": 1566.82,
            "end": 1575.44,
            "transcript": "Uum-wa cukatnginiki time-aq, cukacillinait cass'at, kitak tua-i."
        },
        "114": {
            "start": 1579.5,
            "end": 1585.56,
            "transcript": "Quyalartuten ingna watua atraryaaqluni tauna."
        },
        "115": {
            "start": 1591.98,
            "end": 1606.0,
            "transcript": "Yaa, uumi atraryaaqellruunga au͡gna qanqalria ikayuqernaluku amllenrilengraan."
        },
        "116": {
            "start": 1606.0,
            "end": 1619.72,
            "transcript": "Wii Hooper Bay-rmiunguunga atengqerrlua Utuan Yugtun. Kass'atun-llu David Simon Sr."
        },
        "117": {
            "start": 1619.72,
            "end": 1638.8,
            "transcript": "Au͡gna quyakluku watua qanqallra [?] civuqlia civuqlirluku ilakeqerluku amllermek qanerngaileng'e'rma ateryaaqlua ikayuqatnayuklua au͡g'umun."
        },
        "118": {
            "start": 1638.8,
            "end": 1655.78,
            "transcript": "Tamaani una wani Utuan atqa, watua qan'allrulriaci makuneng au͡gkuneng miskenga'artuutellerpecineng qaygimi."
        },
        "119": {
            "start": 1655.78,
            "end": 1667.28,
            "transcript": "Tauna-llu atqagyugutua [?] apa'urluma aciaqaanga qetunraminun pinritermun atqullua."
        },
        "120": {
            "start": 1667.28,
            "end": 1680.86,
            "transcript": "Cali keneklua anglicalqaanga, miklemneng ayaglua qaygimi-llu inarutaqameng."
        },
        "121": {
            "start": 1680.86,
            "end": 1701.62,
            "transcript": "Qanrutuanga tamana-llu kenekngam iqlutun ayasqenrilamia, qanruyucia-llu tamaayaqaarcaarru miktellemneng ayaglua."
        },
        "122": {
            "start": 1701.62,
            "end": 1724.8,
            "transcript": "Tau͡gaam maa-i waten pitaring'e'rma cali nutaan aklukangnem cikiumallra quyakumaaqaqa maa-i cal' pikluku tangyuunaku-llu cali qamani pelkumaluku."
        },
        "123": {
            "start": 1726.8,
            "end": 1742.46,
            "transcript": "Waten pituanga tamaani cunaga pinrirniarallerni cali im' ellillrani."
        },
        "124": {
            "start": 1742.46,
            "end": 1757.94,
            "transcript": "Wani-gguq kenekngamia qanrutqataraanga, elliin-gguq cameng tuqukuni catairuskuni-gga."
        },
        "125": {
            "start": 1757.94,
            "end": 1768.48,
            "transcript": "Pikamneng caliyaaqeciquq, calituami makuneng keneknarqelrianeng assinriluki-llu taqluki."
        },
        "126": {
            "start": 1768.48,
            "end": 1780.08,
            "transcript": "Elliin-gguq tamakuneng cikiryaaqeciqaanga, tau͡gaam-wa ak'anivkenateng nangesquut pinrirluteng-llu."
        },
        "127": {
            "start": 1780.08,
            "end": 1802.96,
            "transcript": "Au͡gkuneng tuaten pirraarluni ciutegka-gguq ikirrlukek niicugnilaaku waniwa-gguq elliin cikiqataraanga nang'arkaunrilngurmeng cat kevkarkaunrilngurmeng wii pikamneng."
        },
        "128": {
            "start": 1802.96,
            "end": 1812.8,
            "transcript": "Ciutegka agu ikirrlukek niicugnikiilaku, taringengnaqluki qanellri."
        },
        "129": {
            "start": 1816.36,
            "end": 1829.14,
            "transcript": "Tau͡gaten pirraarlua qantuuq ak'anun qanerngialeng'e'rma tamatum quyakluku."
        },
        "130": {
            "start": 1829.14,
            "end": 1849.12,
            "transcript": "Ukuneng cal' [?] kinguqlianeng egmilriaci wanigga ayagnilriaci, irniangqerrngama wii anguterrlianarneng, ten-aavut, irnianka angutet."
        },
        "131": {
            "start": 1849.12,
            "end": 1860.04,
            "transcript": "Tau͡gaam ataucimeng ilangqertellruluteng ilameng maa-i anerteqluteng anguterrlianat."
        },
        "132": {
            "start": 1860.04,
            "end": 1871.26,
            "transcript": "Tau͡gaam avurriangata waten arnameng makut-llu arnanelgem-llu."
        },
        "133": {
            "start": 1871.26,
            "end": 1880.76,
            "transcript": "Ayuqnilriatun piata anglicarillruunga ataucimeng, arnameng, kinguqlikacagauluni maa-i."
        },
        "134": {
            "start": 1880.76,
            "end": 1889.68,
            "transcript": "Anglisqumananeng cali piipiqsugmi cali egmian angliqerrluut cukaluni."
        },
        "135": {
            "start": 1889.68,
            "end": 1903.12,
            "transcript": "Taumeng ilumun makut arcaqerluteng angutet al'utkelriit maligarutarluteng pitullinuit ilaluteng piaqan."
        },
        "136": {
            "start": 1903.12,
            "end": 1917.88,
            "transcript": "Tua-i ilamegcetun algutmegcetun piaqluteng, imutun qimugkauyartun ayakayulriatun, qil'ulriulriatun-llu qiuqluteng."
        },
        "137": {
            "start": 1917.88,
            "end": 1933.18,
            "transcript": "Tau͡gaam ping'e'rmeng ilumun anguterrlainarneng yuungqelleq tan'gurrarrlainaneng qaciggluni yuunarqenritliniuq angayuqaarulriani."
        },
        "138": {
            "start": 1935.8,
            "end": 1947.34,
            "transcript": "Au͡gna kinguqliat ping'e'rmi ukutun angucetun ayuqenrituq cali qaruarcunaqluni."
        },
        "139": {
            "start": 1947.34,
            "end": 1964.02,
            "transcript": "Tau͡gaam ping'ermiu ukuneng angutnun ilangqerrngami iliini cali angucetun ayuqliriqertut tua-i uutun anngamitun nakmiin irniamteneng."
        },
        "140": {
            "start": 1964.02,
            "end": 1980.0,
            "transcript": "Tua-i tamalkumta pinertutacimcetun waten ikayuuqluni pilleq cal' maa-i quyakumaaqa man'a."
        },
        "141": {
            "start": 1980.0,
            "end": 1994.78,
            "transcript": "Tailua maavet cali qanqetaaralrianeng niicama cali ikayuqaucugyaaqlua amllenrilngermi qaneryaraq amlleriatun ayuquq."
        },
        "142": {
            "start": 1994.78,
            "end": 2006.2,
            "transcript": "Tau͡gaam taringnariluni amllessiyagluni-llu piaqami imutun qalliquurulluni uunguciulluni-llu pinaqngami."
        },
        "143": {
            "start": 2009.48,
            "end": 2031.14,
            "transcript": "Tamalkumta nunani irniaput tamalkuita casqumanritaaput, tau͡gaam elluarrluku wangkuta angayuqaulriani mianikluki qavulluki."
        },
        "144": {
            "start": 2031.14,
            "end": 2045.8,
            "transcript": "Taringevkarluki cali asautekengnaqarkaugaput nani, nunani-llu piciatun uitangamta ataucimi nunami uitalriatun pitarrluta."
        },
        "145": {
            "start": 2046.1,
            "end": 2060.32,
            "transcript": "Tua-i taumeng amllenrilengraan taumeng ikayuqaata kina imna qaneryulria."
        },
        "146": {
            "start": 2060.32,
            "end": 2068.8,
            "transcript": "Kenkirluku tuaten ten niicetnanrilengraata ikayuqaata quyana."
        },
        "147": {
            "start": 2072.54,
            "end": 2081.14,
            "transcript": "Quyana qanellruangama ataam qanerciqua."
        },
        "148": {
            "start": 2081.14,
            "end": 2097.82,
            "transcript": "Maa-i quyatengqertua ukut elitnaurat school-arat note-anek igauqurluteng waten pillrat ingkut pik'ut quyakaqa."
        },
        "149": {
            "start": 2097.82,
            "end": 2117.12,
            "transcript": "Tamakut makut elitnauraput elitnaurumalriit acitngun pivkenaki mayurtengnaqluki taug͡aam quyungqaukut future-aaqat elluarrluku pekelra assikluku [?]."
        },
        "150": {
            "start": 2117.12,
            "end": 2127.72,
            "transcript": "Cali young adults married-aarumalriit qakma-i waten qanruyutengqelliniukut wangkuta Yugni."
        },
        "151": {
            "start": 2127.8,
            "end": 2145.58,
            "transcript": "Elpecenun aipaqsagutenrraarnun, wall'u aipaqsagutengssaanerpeci iliini married-arciquci."
        },
        "152": {
            "start": 2145.58,
            "end": 2162.52,
            "transcript": "Waten qanruyutengqelliniut makut nasaurluut married-aaraqameng-gguq. Uiteng waten ellimerturluki kiiki qanrulluki."
        },
        "153": {
            "start": 2162.52,
            "end": 2174.86,
            "transcript": "Yuilqumek-llu apriluteng wall'u imarpigmek piyugniluteng, neryugniluteng tamakut qasqumayuitelliniut tau͡gaten."
        },
        "154": {
            "start": 2175.0,
            "end": 2188.1,
            "transcript": "Waten-gguq illii yuum pissurluni, qessurluni-llu [?] call' qumyuksumi ellapagni imarpigmi-llu."
        },
        "155": {
            "start": 2188.1,
            "end": 2203.72,
            "transcript": "Ayagaqami im'um aiparmi qanellra enqakluku pissugnaringraan imarpik wall'u yuilquq callu'ungran uternaciatur'."
        },
        "156": {
            "start": 2203.8,
            "end": 2220.1,
            "transcript": "Nutaan-llu illii picurlagluni tayima tekitevkenani unangengnaqluni kiiki ella assiirutengraan piknaqvirluni."
        },
        "157": {
            "start": 2220.8,
            "end": 2241.8,
            "transcript": "Tamana qanruyutet ilakliniat makunun ayagyuanun tau͡ga wangkuta wangkutnun qanruyutnguller nayagamtenun-llu aipamtenun-llu enqaqemku qanrutkaqa."
        },
        "158": {
            "start": 2241.8,
            "end": 2253.0,
            "transcript": "Cali-llu married-aarpailegmeng girls-at makut mingqeneq nalluarkaqenritliniat murilkelluki aanaci."
        },
        "159": {
            "start": 2253.0,
            "end": 2261.42,
            "transcript": "Piarkaqliniaci mingqenermek wall'u-w' cook-anermek keninermek nalluvkenaci."
        },
        "160": {
            "start": 2261.42,
            "end": 2274.24,
            "transcript": "Piarkaulliniuci wii angutnguqtaangerma kenituunga keniutanka irnanka au͡gkut kiirran aipaqa kenirturcetevkenaku."
        },
        "161": {
            "start": 2274.8,
            "end": 2284.8,
            "transcript": "Nutaan-llu nerraarluteng quyavikluku good cook-aam ilua irniama au͡g'umun."
        },
        "162": {
            "start": 2285.8,
            "end": 2294.84,
            "transcript": "Cali-llu elpeci young ladies."
        },
        "163": {
            "start": 2294.84,
            "end": 2312.4,
            "transcript": "Cut fish-aanermek nalluarkaunritliniuci dry-arluki-llu kinerrluki kiagmi taum murilkelluki aanaci tamaaggun elitarkauguci."
        },
        "164": {
            "start": 2312.4,
            "end": 2326.58,
            "transcript": "Cali-llu boys-ani wangkuta boys-at qanruyutengqelliniut aipangvailemta-gguq wangkuta umyugangqerkauguku."
        },
        "165": {
            "start": 2326.58,
            "end": 2343.82,
            "transcript": "Yuilqumek pissurluta pituarkaullerput una qayangqerkauluta, angullua angyangqerkauluta, imarpik una ayagatuarkaukumta pissurluta."
        },
        "166": {
            "start": 2343.82,
            "end": 2354.9,
            "transcript": "Cali-llu maani uksumi pikumta kilgaurutengqerrluta qakma-i machine-anek kilgaurut' [?]."
        },
        "167": {
            "start": 2354.9,
            "end": 2366.58,
            "transcript": "Qessatarpek'nateng pilriit caliluteng kilgaurutnek unangtuut transportation-angluteng-llu."
        },
        "168": {
            "start": 2370.8,
            "end": 2390.62,
            "transcript": "Cali-llu qanruyutengqerrluta young people-aani waten-gguq qessatalria nangu-llu [?] qavanertulria au͡gna acinra cakartaituq-gguq."
        },
        "169": {
            "start": 2390.62,
            "end": 2404.68,
            "transcript": "Tau͡gaam qessatarpek'nata pingnatugluta pikumta tuaten nutaan atu'urkamnek unangarkaulliniukut."
        },
        "170": {
            "start": 2407.22,
            "end": 2422.14,
            "transcript": "Maa-i makut qanerturalriit elitnauristekaci young people-aani wiinga-llu elitekanirtua qanerturalrianga."
        },
        "171": {
            "start": 2422.14,
            "end": 2434.82,
            "transcript": "Man'a yuuqallerkarput, yuuqallerkarci-llu pitekluku quyungqaukut elluarrluta pingnaqlerkarput."
        },
        "172": {
            "start": 2434.82,
            "end": 2449.8,
            "transcript": "Canek tan'gurraput makut elluarrluteng yuuqallerkat umyugaqluku au͡gkut erenret takluki atullerkait pisqumaluki."
        },
        "173": {
            "start": 2449.8,
            "end": 2462.18,
            "transcript": "Ernerpak-gguq ellait makut ayagyuat qessatalriit inerciigaliillrit qakma-i."
        },
        "174": {
            "start": 2462.18,
            "end": 2467.92,
            "transcript": "Taangamek angu-llu drug-arnek atu'ungellrit."
        },
        "175": {
            "start": 2467.92,
            "end": 2478.3,
            "transcript": "Ciuneqa cakartaituq ellaita picurlagmi tamaani terpakarluteng pingnaqluteng itercivignun."
        },
        "176": {
            "start": 2478.3,
            "end": 2491.52,
            "transcript": "Ek'aqluteng nerumallerkarmeggnun angu-llu qavallerkarmeggnun akiinateng tau͡gaten pivkenaci umyugarteqevkenaci piyugluci tau͡gaten."
        },
        "177": {
            "start": 2491.52,
            "end": 2507.74,
            "transcript": "Tau͡gaam caliluci elpecenek ikayungnaqluci illiini irniangarkauguci qetunrangluci qanturiluci-llu ukuucetun."
        },
        "178": {
            "start": 2507.74,
            "end": 2527.8,
            "transcript": "Irniateng cuqyutekluki angulluaq arnat au͡gkut qanerturalriit elicinaqluteng umyugarnaqluteng-llu cali au͡gkut aanamta apa'urlumta qanerturatullrit."
        },
        "179": {
            "start": 2527.8,
            "end": 2538.16,
            "transcript": "Tamana qanruyutvut wangkut tamarcetevkenaku yuugarkaulliniukut Yupiukut wangkuta."
        },
        "180": {
            "start": 2538.16,
            "end": 2553.28,
            "transcript": "Ernerpak ava-i cover-allruarci ilavci eighteen years old-allrit atugaqamegtegu una piyullelteng [?] ellaita picurlagluteng uitatuut."
        },
        "181": {
            "start": 2553.28,
            "end": 2572.94,
            "transcript": "Ellmeggnek future-aanek cut off-arluku. Yuk'egtaarallerkarteng tau͡gaam niici ukut qanrucilrit professor-augut Yugtun elisngarpalriaruut."
        },
        "182": {
            "start": 2770.8,
            "end": 2792.38,
            "transcript": "Wangnek cuq'ekuma tamana cuqyutka taringengaitaci, tau͡gaam una yuum piciryaraa alerquutii-llu nalluvkayungaitaput makunek kinguliarramteńun."
        },
        "183": {
            "start": 2792.38,
            "end": 2805.3,
            "transcript": "Qanruyun atauciuguq, yuum qanruyutii ellarpallermi tamarmeng wangkuta yugni taringetulriani qanruyuteput ataucimek."
        },
        "184": {
            "start": 2805.3,
            "end": 2816.8,
            "transcript": "Kia inerqukakut nani nunani allani taum inerquutiin inerqurciqaat ataucimek qaneryaraq man'a."
        },
        "185": {
            "start": 2816.8,
            "end": 2831.86,
            "transcript": "Tua-i au͡g'utem waten court-arilartua qamani uum Kass'am piciryaraa aturpek'naku, tau͡gaam yuum piciryaraa aturluku kenekluku umanaqluni."
        },
        "186": {
            "start": 2831.86,
            "end": 2847.64,
            "transcript": "Umanarqengnaqluni ukunun caliaminun, elliin mikliriluni pinerqelliniuq waten, ukuni-llu mikellrurrluni caliaminun."
        },
        "187": {
            "start": 2847.8,
            "end": 2863.6,
            "transcript": "Kiani amllersaaqut calillrutenka tau͡gaam wiinga kiima kiani cucuquralaatnga court-arliurutuunga amllerrsaaput ilanka arnat tuaten tamakut cucukellrunritait cucuksuunaki."
        },
        "188": {
            "start": 2863.6,
            "end": 2878.2,
            "transcript": "Piqatarqata tauna caliqatarqata yug'ayuunani tua-i waten qancurlagaaluni, wall'u qenerrluni, wall'u cacurlagaluni, yuumta ciuqurratni piarkaunritliniluni."
        },
        "189": {
            "start": 2878.2,
            "end": 2893.0,
            "transcript": "Taugaam assirluta umanaqluta-llu wangkuta caliarkaulliniukut nutaan una qanruyun aturciqliniaput kenkeknguan, kenkekun allatun pisciigatukut."
        }
    },
    "0BjSTW_ZvZ4": {
        "1": {
            "start": 7.4,
            "end": 19.7,
            "transcript": "Organization-aat quyurrluteng calivkenateng. Aptengluteng tau͡gaam."
        },
        "2": {
            "start": 19.7,
            "end": 32.8,
            "transcript": "Tua-i imkut tayima ataataqengermegteki wall'u angyarqengermegteki ilait kiutaigucangluteng."
        },
        "3": {
            "start": 32.8,
            "end": 36.54,
            "transcript": "Calillgutkenrilama."
        },
        "4": {
            "start": 36.54,
            "end": 44.18,
            "transcript": "Tuaten ayuqliriut nunat ilait maa-i pinruyungluteng ilait."
        },
        "5": {
            "start": 44.18,
            "end": 52.04,
            "transcript": "Au͡gna inerquun imkuluku piamegteggu, navegluku."
        },
        "6": {
            "start": 52.04,
            "end": 61.7,
            "transcript": "Tamatum tau͡gaam, calillgutekluta tau͡gaam pikumta man'a piurallerput elluariciqsugnarquq."
        },
        "7": {
            "start": 61.7,
            "end": 65.22,
            "transcript": "Well organized Kass'at apqiitnek."
        },
        "8": {
            "start": 65.22,
            "end": 71.1,
            "transcript": "Quyurquyuumaluta wangkuta avvingavkenata ikayuqluta ayakumta."
        },
        "9": {
            "start": 71.1,
            "end": 81.9,
            "transcript": "Una wani picirkaq pug'aqan, tauna wani ciuniuraqluku quyurrluteng tau͡gaam nunat."
        },
        "10": {
            "start": 81.9,
            "end": 91.0,
            "transcript": "Tuatnakuneng tau͡gaam tua-i assinruciquq picirkiutet makut aturluki."
        },
        "11": {
            "start": 91.0,
            "end": 98.1,
            "transcript": "Avturyarpek'nateng, avvingavkenateng quyurmeng tau͡gaam."
        },
        "12": {
            "start": 98.1,
            "end": 101.66,
            "transcript": "Una tayima cali."
        },
        "13": {
            "start": 101.66,
            "end": 106.82,
            "transcript": "Wiinga call' au͡g'um Kass'am qanellran ilii nalluyaguartelliniaqa."
        },
        "14": {
            "start": 106.82,
            "end": 116.56,
            "transcript": "Yup'igurlurni-gguq wangkuta itertaunaitqapiarangraata Yup'ut itengqaluki."
        },
        "15": {
            "start": 116.56,
            "end": 123.86,
            "transcript": "Ca-gguq pitkevkenaku. Akinguteklerkaat tau͡gaam ellaita Kass'at pitekluku."
        },
        "16": {
            "start": 123.86,
            "end": 134.24,
            "transcript": "Itertaunaitqapiarangraata-gguq itengqamalangluki akingutkeqallerkait tau͡gaam pitekluki."
        },
        "17": {
            "start": 145.46,
            "end": 154.08,
            "transcript": "Yaa, waqaa. Wiinga wani Yugtun Qapurrluugua atqa Alarnamek pillrulua."
        },
        "18": {
            "start": 154.08,
            "end": 160.44,
            "transcript": "Kass'atun atengqerrsaaqellrianga aperciigataqa, aperciigataqa."
        },
        "19": {
            "start": 160.44,
            "end": 163.22,
            "transcript": "Tau͡gaam aper' [?] nallunritarpecia taumek."
        },
        "20": {
            "start": 163.22,
            "end": 176.22,
            "transcript": "Qanemcicuaqernaluci waniw' uumek quyurtellratnek ilaliranka ukut piani uitangerma kelumi."
        },
        "21": {
            "start": 176.22,
            "end": 186.72,
            "transcript": "Ukut tuaten inglukurutellrianek-wa tuar tua-i qanqalria tang ukuk wani teggneput [?]."
        },
        "22": {
            "start": 186.72,
            "end": 207.32,
            "transcript": "Tamatumek uluryara'arpek'nata ciuniurluku man'a Yupiit piciryaraat camek inglukestekamteńek-llu uluryara'arpek'nata ciumuulluku pikumteggu ingluk'ngermegtekut wani man'a qaneryaraq"
        },
        "23": {
            "start": 207.32,
            "end": 215.24,
            "transcript": "elluarrluku atuqumteggu inglulirciigataitkut Kass'at."
        },
        "24": {
            "start": 215.24,
            "end": 225.92,
            "transcript": "Cali Kass'anek atanirluta piarkaunritukut, wangkutnek tau͡gaam ataneqluta piarkaugukut ilaput."
        },
        "25": {
            "start": 225.92,
            "end": 231.76,
            "transcript": "Iciwa qanerlalriit umyuallgutekluta tau͡gaam pikumta assirciqniluku."
        },
        "26": {
            "start": 231.76,
            "end": 241.64,
            "transcript": "Tua-i tamana tamaa-i qanellrat man'a aturluku umyuallgutekluta yua [?] waten yaaqsiutengramta katurtall'."
        },
        "27": {
            "start": 241.64,
            "end": 250.32,
            "transcript": "Waniwa atam caperrnaqellriamek aturtukut yaaqsiutengramta katurtukut ikayuulluta wangkutnek."
        },
        "28": {
            "start": 250.32,
            "end": 260.48,
            "transcript": "Tua-i quyanaqluni cakneq man'a maani nutaraunrilnguq qaneryaraq piurcugluku."
        },
        "29": {
            "start": 260.48,
            "end": 275.06,
            "transcript": "Waniwa una pegg'arrluku au͡g'umek school-aranek, school-artenek caumallemnek allragni qanemcicuaqataramci Alarnermi."
        },
        "30": {
            "start": 275.06,
            "end": 291.22,
            "transcript": "Allragni ullaketaarpakarluki school-artet, school-artet angayuqrata qanrutellruanga school-artet-gguq ukut qanaateqerlaki wii, ca pillruyaaqua tuani cakneq."
        },
        "31": {
            "start": 291.22,
            "end": 301.02,
            "transcript": "Tua-llu school-artet taukut katurtut yugyaqapiggluki natecuar tua-i imirluku muirluku Yup'ignek."
        },
        "32": {
            "start": 301.02,
            "end": 309.5,
            "transcript": "Tua-llu tua-i umyuarteqellruyaaqua wangnek caunrilkellua atanrunrilama."
        },
        "33": {
            "start": 309.5,
            "end": 321.16,
            "transcript": "Qang'a-llu nallunritevkenii cali nallulriarulua, qaillun-llu ayuquciat nalluluku, tua-i tuaten ayagnirtua."
        },
        "34": {
            "start": 321.16,
            "end": 333.0,
            "transcript": "Tua-llu tangvagtegka malruk ilagka, Joe Joseph-aq Fannie Joseph-aq [?] tan'geqlutek [?] taukuk."
        },
        "35": {
            "start": 333.0,
            "end": 340.12,
            "transcript": "Ilu'urqa tauna aptaqa, \"Elpet-qaa qancuaqerngaituten carrarmek?\""
        },
        "36": {
            "start": 340.12,
            "end": 346.48,
            "transcript": "Tua-llu kiugaanga, ellii-gguq angayuqevkenani qanerngaituq."
        },
        "37": {
            "start": 346.48,
            "end": 351.88,
            "transcript": "Tua-i umyuaqa qaill' qercaaqluni ataam tua-i nak'riluni."
        },
        "38": {
            "start": 351.88,
            "end": 361.76,
            "transcript": "Malrugnek qanercirlua qanerturautanka school-artet Yup'ignek ilangqertut school-arteput Alarnermi."
        },
        "39": {
            "start": 361.76,
            "end": 368.76,
            "transcript": "Tua-i caliyugngariluteng school-allruameng high school-aq iqukliluku."
        },
        "40": {
            "start": 368.76,
            "end": 376.38,
            "transcript": "Tua-llu qanemcitanka school-araitnek makunek high school-anek."
        },
        "41": {
            "start": 376.38,
            "end": 384.68,
            "transcript": "Makut elluarrluteng school-aumanritniluki makut ellaitnek, ellaitnek school-acirluki."
        },
        "42": {
            "start": 384.68,
            "end": 401.02,
            "transcript": "Maa-i-llu high school-aq iquklitengraan caliarkangengaitniluki kalikat imkut imirarkat imirciigaciiqniluki high school-aq iqukliqaarluku."
        },
        "43": {
            "start": 401.02,
            "end": 414.24,
            "transcript": "Tuaten-llu qanruqaarluki qanrutanka ellait wani piluaqerniluki school-arteńi Yup'igni qanrulluki qanercirlua."
        },
        "44": {
            "start": 414.24,
            "end": 420.92,
            "transcript": "Assirluci school-allruuci ciungatni ukut elilluci-llu."
        },
        "45": {
            "start": 420.92,
            "end": 431.68,
            "transcript": "Maa-i-ll' aturluku school-arteńguluci imiriyuumiivci kalikat imkut caliqatalriani imiarkat qaqilluki."
        },
        "46": {
            "start": 431.68,
            "end": 438.3,
            "transcript": "Makut wani school-araci elpecicetun ayuqngaituq."
        },
        "47": {
            "start": 438.3,
            "end": 442.26,
            "transcript": "Elisngaitut nallunritaci elpeci."
        },
        "48": {
            "start": 442.26,
            "end": 461.36,
            "transcript": "Tua-i tamatumek qanrutellruanka ciungani tua-i qanaaqurlallruanka tua-i ikayurluki pilaamki tua-i ellimellruanga principle-am taum ellii-ll' ilakluki qanrutesqelluki."
        },
        "49": {
            "start": 461.36,
            "end": 476.4,
            "transcript": "Tua-llu taq'ukut. Taqngata aptanka, apyucirkangqerqata-ll' taqngamug', taq' [?], ataam aptanka, apyucirkangqerqata ellaitnun wiinga-ll' aptesqellua."
        },
        "50": {
            "start": 476.4,
            "end": 480.54,
            "transcript": "Alareskuma qang'a-llu piciukan."
        },
        "51": {
            "start": 480.54,
            "end": 486.42,
            "transcript": "Caitqapik yuuqallunritut tamakut school-arterugaat Kass'anek avuluteng."
        },
        "52": {
            "start": 486.42,
            "end": 496.22,
            "transcript": "Tua-llu atakuan niitua taqngamta niicecurlagtut-gguq school-artet."
        },
        "53": {
            "start": 496.22,
            "end": 505.24,
            "transcript": "Nall'arcamku ayuqucirteng tamatumek pilliniluteng."
        },
        "54": {
            "start": 505.24,
            "end": 516.48,
            "transcript": "Tua-llu niicecuq niitaa [?] niiqeqngamki [?] atakurpak school-arta unuakumi ullagaqa atanra taun atanerput."
        },
        "55": {
            "start": 516.48,
            "end": 523.92,
            "transcript": "Qanrutaqa niitellrunilua akwaugaq atakumi school-arteńek niicecurlalrianek."
        },
        "56": {
            "start": 523.92,
            "end": 528.86,
            "transcript": "Ataam taringyugniluki tamakut niicurlallret."
        },
        "57": {
            "start": 528.86,
            "end": 538.56,
            "transcript": "Tua-llu pianga, qang'a-gguq assiriut-gguq ak'a. Niicurlallret-gguq tamana ak'a taringellruat."
        },
        "58": {
            "start": 538.56,
            "end": 553.82,
            "transcript": "Tua-llu school-artem pincipal-aam pianga, atata-gguq aanat school-artet aanat aatat-llu kinguqliput makut atata-gguq wii qanruskilaki."
        },
        "59": {
            "start": 553.82,
            "end": 566.88,
            "transcript": "Tua-llu atatakuanrarraarluta ataam nutaan qanrulluki yup'ut wangkuta makut, makut pitalgutai."
        },
        "60": {
            "start": 566.88,
            "end": 582.44,
            "transcript": "Alerquaguraranka ellait atanruniluki, ilumun makut yun', kinguqliput-wa tua-i qetunraput ellait atanruut."
        },
        "61": {
            "start": 582.44,
            "end": 585.9,
            "transcript": "Aanait-llu cali atanruluki."
        },
        "62": {
            "start": 585.9,
            "end": 593.94,
            "transcript": "Tamatukun maa-i anglicurlaumalriatun ayuqut school-allermegteggu."
        },
        "63": {
            "start": 593.94,
            "end": 602.82,
            "transcript": "Angayuqaateng ataneqenrirluki school-artet tau͡gaam school-allrit kitum [?] ataneqluku."
        },
        "64": {
            "start": 602.82,
            "end": 620.26,
            "transcript": "Tamana tamaani ilangcitevkenaku-llu tapeqluku wangkuta caliarkaqerput nunamta mat'um yugkainek school-angengqerrata makut school-arteput."
        },
        "65": {
            "start": 620.26,
            "end": 627.32,
            "transcript": "Tua-llu tua-i taqlua quyaluteng tamakut qanaatellrenka."
        },
        "66": {
            "start": 627.32,
            "end": 636.8,
            "transcript": "Aplua-llu ataam cali piciqellemnek aplua ataam pisqumalua ataam."
        },
        "67": {
            "start": 636.8,
            "end": 651.94,
            "transcript": "Tua-llu tua-i taqluta uitalua qayutun [?] tayim' uikarteqerluta tua-i-am principal-aam pianga, ataam-gguq school-arteńi ellait qanrullaki ataam."
        },
        "68": {
            "start": 651.94,
            "end": 659.32,
            "transcript": "Tua-i capinritqerlua tua-i nutaan patagaurlua piaqa, kina imna qaneryugciqngan ataam."
        },
        "69": {
            "start": 659.32,
            "end": 666.0,
            "transcript": "Tua-i taringesqelluku taun tua-i iquklitellranun qanrutqeqatarqa."
        },
        "70": {
            "start": 666.0,
            "end": 675.96,
            "transcript": "Ataam-am tua-i nererraarluteng tua-i-am quyurcata school-arterugaat tamakut qanrutanka. Nutaan ca pinritqerlua,"
        },
        "71": {
            "start": 675.96,
            "end": 691.78,
            "transcript": "waten-llu piluki qanaaterraarluki, \"Principal-aam uum elluarrluci alerquumakaci assirluci school-ariyartuci."
        },
        "72": {
            "start": 691.78,
            "end": 700.02,
            "transcript": "Principal-aam wani elluarrluci alerquumanrilaci elluarluci school-arinrituci.\""
        },
        "73": {
            "start": 700.02,
            "end": 709.46,
            "transcript": "Tua-i nutaan school-arceteng tauna atanerteng qaillun qanaatekaquqerluku taringenritanka tau͡gaam wii."
        },
        "74": {
            "start": 709.46,
            "end": 720.06,
            "transcript": "Cunawa tua-i taqniararluki school-aq pillrulua, cunawa tua-i tuaken au͡g'alliuq tayim' tauna atanra tauna."
        },
        "75": {
            "start": 720.06,
            "end": 732.46,
            "transcript": "Tua-i nallarrluku pikuneng, nallarrluki pikumteki ikayuangnaqelput makut school-arteput aanait-llu atait-llu."
        },
        "76": {
            "start": 732.46,
            "end": 740.34,
            "transcript": "Tua-i tamaaggun ikayunruciqaput, ikayuqluki-w' piciqaput Yup'ut wangkuta."
        },
        "77": {
            "start": 740.34,
            "end": 753.32,
            "transcript": "Watua piyunarqurallemteńi camek alinguryugpek'nata ellam au͡gkut ciuliamta man'a qaneryaraq pikaat."
        },
        "78": {
            "start": 753.32,
            "end": 766.22,
            "transcript": "Wangkutnun elluarrluni yuuyaraq atuusqelluku ciuniurluku wangkuta naklekluki makut kenekluki ilaput tamalkuita piarkaugaput."
        },
        "79": {
            "start": 766.22,
            "end": 773.92,
            "transcript": "Cali-llu capirpek'nata [?] qanrucukumteki qanrutarkaugaput nalqigulluki."
        },
        "80": {
            "start": 773.92,
            "end": 783.16,
            "transcript": "Tamaa-i tamana nalqiguqurluta wangkuta pillruitkut au͡gkut school-allrunrilengramta."
        },
        "81": {
            "start": 783.16,
            "end": 793.82,
            "transcript": "Tua-i-w' ilii nallunritaqa wii carraq nallunriqu'uralqa tua-i antela'arqa maa-i qanercetaamek tekitaqama."
        },
        "82": {
            "start": 793.82,
            "end": 798.64,
            "transcript": "Tua-i kina imna qaneryugciq' [?] tua-i."
        },
        "83": {
            "start": 798.64,
            "end": 801.32,
            "transcript": "(Atren-qaa Thomas-aaruuq?) No."
        },
        "84": {
            "start": 801.32,
            "end": 803.92,
            "transcript": "Fred Augustine-augua."
        },
        "85": {
            "start": 803.92,
            "end": 813.42,
            "transcript": "Aa, ava-i at'ni aperciigatellruagu ap'ritnaluku piyaaqegka. Aperyugngariluku iquklitliniuq qanellra."
        },
        "86": {
            "start": 813.42,
            "end": 815.16,
            "transcript": "Quyanarqellria-wa tua-i."
        },
        "87": {
            "start": 815.16,
            "end": 818.66,
            "transcript": "Au͡gna chairman-arput utaqacuaqeqerlaut."
        },
        "88": {
            "start": 818.66,
            "end": 828.46,
            "transcript": "Ukut-wa iliit qanerkangqellilria utaqainanerpeci chairman-arput-wa."
        },
        "89": {
            "start": 828.46,
            "end": 833.64,
            "transcript": "Waniwa tailliniuq."
        },
        "90": {
            "start": 833.64,
            "end": 844.44,
            "transcript": "Una wani unipailemteggu kan'a school-artet atanra catailani."
        },
        "91": {
            "start": 844.44,
            "end": 851.36,
            "transcript": "Working with schools, traditional systems, and other organizations."
        },
        "92": {
            "start": 851.36,
            "end": 861.64,
            "transcript": "Mark-amun qanrutkevsiaqausqumayaaqaqa pikavet uterpailemta."
        },
        "93": {
            "start": 870.9,
            "end": 885.82,
            "transcript": "Man'a quyurta uptellemteńi umyuarteqluta qaillun una-w' tua-i taqukaqngamteggu,"
        },
        "94": {
            "start": 885.82,
            "end": 903.86,
            "transcript": "mikelnguut ayagyuat yun'erraat-llu aulukellrat taqukaqluku quyurteqataamta, umyuarteqellruukut qaillun elluarrluku man'a caliaqellerkamteńek."
        },
        "95": {
            "start": 903.86,
            "end": 920.92,
            "transcript": "Tua-i-llu piinanemteńi piukut ukut waniwa arcaqerluki: school-arviit, man'a-llu anguyagtem court-ai, cali ukut social services system."
        },
        "96": {
            "start": 920.92,
            "end": 934.72,
            "transcript": "Amllerqunek, amllrem ayagyuam, tua-i-wa ayagyuat tamarmeng school-arvik man'a nagguirviitaat, maa-i-llu atungluku, aturaqluku tamarmeng."
        },
        "97": {
            "start": 934.72,
            "end": 938.44,
            "transcript": "Una-llu cali judicial system."
        },
        "98": {
            "start": 938.44,
            "end": 945.06,
            "transcript": "Court-at makut arenqiallugtaqata mikelnguut tamaagguirluteng tau͡gaam pilalriit."
        },
        "99": {
            "start": 945.06,
            "end": 952.48,
            "transcript": "Man'a-llu cali maa-i ilangyaaqluni tamana tribal court-anek."
        },
        "100": {
            "start": 952.48,
            "end": 958.04,
            "transcript": "Cali-llu makut other organizations."
        },
        "101": {
            "start": 958.04,
            "end": 973.88,
            "transcript": "Social services system-at it'lartut, tua-i-wa tailartut arenqiallugtaqata angayuqaak apqaurlukek wall'u-qaa allat yuut avatiitni pilriit apqaurluki."
        },
        "102": {
            "start": 973.88,
            "end": 990.44,
            "transcript": "Waten umyuarteqluta una ellillruyaaqerput, qaillun elluarrluki calistellguteksugngallemteńek yugtaq man'a aturluku."
        },
        "103": {
            "start": 990.44,
            "end": 1000.72,
            "transcript": "Maa-i example-aaqluku school-atgun, school-at ilait ikingqalartut elder-aanek taivkariaqluteng-llu."
        },
        "104": {
            "start": 1000.72,
            "end": 1006.98,
            "transcript": "Tau͡gken ilaita school-at tengrukevkenaku tamana elder-aanek taivkarilteng niitellrat."
        },
        "105": {
            "start": 1006.98,
            "end": 1011.48,
            "transcript": "Ilaita tau͡gken tua-i kiiki kiiki elder-at taisqumaluki."
        },
        "106": {
            "start": 1011.48,
            "end": 1017.54,
            "transcript": "Maaggun tua-i school-allratgun, school-aq man'a Kass'allauluku nagguirviilan."
        },
        "107": {
            "start": 1017.54,
            "end": 1031.6,
            "transcript": "School-atgun-llu calillguteksugngallrit school-at makut ayagyuat niitarkaitnek elicelluki, ellangutkaitnek elicelluki, tamaaggun piyugngallrat."
        },
        "108": {
            "start": 1031.6,
            "end": 1038.26,
            "transcript": "Una-llu tribal court-at court system-aq-llu cali man'a."
        },
        "109": {
            "start": 1038.26,
            "end": 1045.74,
            "transcript": "Pulengtaq ilaita, ilaita pinrilngermeng, umyuallguteksaunateng cali."
        },
        "110": {
            "start": 1045.74,
            "end": 1057.84,
            "transcript": "Yugtaq man' taringyugyaaqluku Yugtarkun-llu qaillun una arenqiallugtellria ikayuryuumallra taringyugyaaqluku."
        },
        "111": {
            "start": 1057.84,
            "end": 1065.16,
            "transcript": "Tamaa-i tamana pugtelaquvciu waniwa record-aumalarciquq."
        },
        "112": {
            "start": 1065.16,
            "end": 1078.68,
            "transcript": "Record-aumalarciqut tamakut qaillun ikayuryuumallra uum arenqialluggluni pilriim, picurlagluni pilriim, qaillun ikayuryuumallra."
        },
        "113": {
            "start": 1078.7,
            "end": 1086.12,
            "transcript": "Tamana maa-i pugevsiangeciquq makut tribal court-at naullrat maliggluku."
        },
        "114": {
            "start": 1086.12,
            "end": 1106.22,
            "transcript": "Maa-i-llu cali grant-angell', Bob-am akwaugaq qanrutkellrukii, grant-aput-wa tua-i elluaryuka'arniluku qavcin nunat calillgutekluki man'a tribal court-aq caliaqellerkaa."
        },
        "115": {
            "start": 1108.88,
            "end": 1121.9,
            "transcript": "Man'a tua-i caliaqngamteggu Yugtaq atungluku pillerkaa, Yugtaam pugtellerkaa."
        },
        "116": {
            "start": 1121.9,
            "end": 1126.66,
            "transcript": "Maa-i caliuralriaci qaillun Yugtarkun auluklerkaa."
        },
        "117": {
            "start": 1126.66,
            "end": 1134.9,
            "transcript": "Makut agayuviit school-arvik-llu itellratni amlleq qanyuirutellruuq."
        },
        "118": {
            "start": 1134.9,
            "end": 1142.58,
            "transcript": "Ataam-llu tua-i maa-i qanrutkengluku iirumayaaqerraarluku amllerem."
        },
        "119": {
            "start": 1142.58,
            "end": 1150.7,
            "transcript": "Ilaita qan'ngellruyaaqluteng, \"Agayuviim elissaqciqai wangkuta qanrutenrilengramteki canrituq.\""
        },
        "120": {
            "start": 1150.7,
            "end": 1157.82,
            "transcript": "Tau͡gaam Yugtaq cali."
        },
        "121": {
            "start": 1157.82,
            "end": 1176.34,
            "transcript": "Tua-i-wa nutemllaqngamteggu wangkuta-ll' taringumaluku  atullra aturyaurtellerkaa record-aumarillerkaa tamana."
        },
        "122": {
            "start": 1176.34,
            "end": 1198.5,
            "transcript": "Tamana-w' tua-i qanrutkekuvciu tape-amun ellimarillerkaa igamun-llu cali kinguakun ellimarillerkaa piluku piyaaqukut makut tribal court-at atungekatki calissuutekluki qanelci piyugngaciqngamta."
        },
        "123": {
            "start": 1204.04,
            "end": 1209.7,
            "transcript": "Caliaqeqatarceta wangkuta Yugni."
        },
        "124": {
            "start": 1209.7,
            "end": 1214.58,
            "transcript": "Pivailegpeci cali nallunrilkemnek [?] qanqauternaamci [?]."
        },
        "125": {
            "start": 1214.58,
            "end": 1229.46,
            "transcript": "Nunamni ak'a tan'gaurluulua inerciigatsiyaalria inerqurrsaaqvimeggnek iterciviilameng antellruat nunatek."
        },
        "126": {
            "start": 1229.46,
            "end": 1237.56,
            "transcript": "Ellangcinra tau͡gaam umyuaqluku, taringesqumayaaqluku man'a inerciigalliqluni piurallra."
        },
        "127": {
            "start": 1237.56,
            "end": 1245.88,
            "transcript": "Tuatnatullrulliniut au͡gkut ciuliaput qanemcituluteng nunanek inerciigalliqessiyaalrianek."
        },
        "128": {
            "start": 1245.88,
            "end": 1255.08,
            "transcript": "Tua-i wangni Kass'at ap'laraat tamana discipline, anucimircetaarluku."
        },
        "129": {
            "start": 1255.08,
            "end": 1258.0,
            "transcript": "Tuatnatullrulliniut."
        },
        "130": {
            "start": 1258.0,
            "end": 1267.78,
            "transcript": "Au͡g'um iquanek qaillun makut wani tuaten ayuqelriit inerciigalliiqelriit kitugteqatarceta."
        },
        "131": {
            "start": 1267.78,
            "end": 1277.34,
            "transcript": "Unuaq ava-i ilaita qanrutkurallruat maaggun tau͡gaam kenkekun kitugciiqniluki tamakut."
        },
        "132": {
            "start": 1277.34,
            "end": 1285.16,
            "transcript": "Cali ilangqerqamta tayima ikiruciquq waniwa qaneryulria cali."
        },
        "133": {
            "start": 1290.64,
            "end": 1295.0,
            "transcript": "Atqa aperturait-qaa? Ak'a apertullrua?"
        },
        "134": {
            "start": 1298.78,
            "end": 1303.56,
            "transcript": "Taklinrilengraan qanqerciqua au͡g'umek."
        },
        "135": {
            "start": 1303.56,
            "end": 1313.06,
            "transcript": "Maa-i qanerciigalliqellriani makunek niiteqtaarlartua maa-i."
        },
        "136": {
            "start": 1313.06,
            "end": 1321.54,
            "transcript": "Makunun ayagyuamteńek irniamteńek ca niiteqtaarlar'."
        },
        "137": {
            "start": 1321.54,
            "end": 1336.88,
            "transcript": "Wiinga ikani makut niicuitessiyaalriit utaqatanritanka makunun pistekaitni."
        },
        "138": {
            "start": 1336.88,
            "end": 1345.2,
            "transcript": "Kitumek utaqalanritua [?] una yuk tangerrluku, wall'u Kass'anun utaqat'lanritaqa [?]."
        },
        "139": {
            "start": 1345.2,
            "end": 1350.16,
            "transcript": "Qunukluku natmun ayallerkaa."
        },
        "140": {
            "start": 1350.16,
            "end": 1362.58,
            "transcript": "Waten kiimeqaulluku, kiimeqaulluku tau͡gaam tauna qanerciigalnguq waten kiirarmeng [?] caumaarkaugarci."
        },
        "141": {
            "start": 1362.58,
            "end": 1369.4,
            "transcript": "Yugyagluku qanaasngaitqapiarci tauna niicuilngurmek pikuvci."
        },
        "142": {
            "start": 1369.4,
            "end": 1375.32,
            "transcript": "Waten qanaatarkaugarci waten aipaqu'urluku wavet ciuqerpecenun aqumluku."
        },
        "143": {
            "start": 1375.32,
            "end": 1382.2,
            "transcript": "Ciuqerpenun wavet aqumluku tangvagcelluku."
        },
        "144": {
            "start": 1382.2,
            "end": 1386.42,
            "transcript": "Qanellren tegg'ivkenaku."
        },
        "145": {
            "start": 1386.42,
            "end": 1398.92,
            "transcript": "Maqariluku qanerturauciiqan ayuqucia-llu man'a, kiituan' niicuitellra-ll' man'a qanrutkurluku."
        },
        "146": {
            "start": 1398.92,
            "end": 1402.9,
            "transcript": "Tuaten piarkaugarput man'a."
        },
        "147": {
            "start": 1402.9,
            "end": 1410.42,
            "transcript": "Ikani ata malruugugni [?] anagulluteni [?] niicuitessiyaallrek."
        },
        "148": {
            "start": 1410.42,
            "end": 1420.7,
            "transcript": "Mat'ukun-ll' taangakun pissiyaallrek, maaten-gguq [?] kiimeqautaqlukek qanerturautaqlukek."
        },
        "149": {
            "start": 1420.7,
            "end": 1428.1,
            "transcript": "Ika-i quyanaqlutek cakneq, tamana aturyuyuirulluku."
        },
        "150": {
            "start": 1428.1,
            "end": 1433.46,
            "transcript": "Tuaten piarkaugarput man'a."
        },
        "151": {
            "start": 1433.46,
            "end": 1439.86,
            "transcript": "Tuaten man'a niicuilnguq egelrutarkauguq wangkuta."
        },
        "152": {
            "start": 1439.86,
            "end": 1444.44,
            "transcript": "Assirlukek egesqumakumteggu [?] tuaten piarkaugarput."
        },
        "153": {
            "start": 1444.44,
            "end": 1450.02,
            "transcript": "Niiculugpiar', niiculugyugesqumakumteggu [?] tuaten."
        },
        "154": {
            "start": 1450.02,
            "end": 1461.02,
            "transcript": "Waten qanerturaulluku piarkaugarput uumikevkenaku qancurlagatevkenaku."
        },
        "155": {
            "start": 1461.02,
            "end": 1475.68,
            "transcript": "Tuaten egelrutarkaugarput irniaqenrilengramteggu tuaten una yuk tangerrluku wangkuta anglakevkenaku tuar imutun qunukluku."
        },
        "156": {
            "start": 1475.68,
            "end": 1478.56,
            "transcript": "Maaten qanruqu'urarkaugarput."
        },
        "157": {
            "start": 1478.56,
            "end": 1486.1,
            "transcript": "Cali ikani imkuni Yupiit apqaurtaitnek ekumaura [?] ekumalarturi-llu [?]."
        },
        "158": {
            "start": 1486.1,
            "end": 1492.18,
            "transcript": "Tamana cali Yupiit apqaurtait makut assiryaaqut."
        },
        "159": {
            "start": 1492.18,
            "end": 1504.62,
            "transcript": "Yug' una pinarqeluaqanrilengraan makut Kass'at teguqerluku tayim' ayakautlaraat."
        },
        "160": {
            "start": 1504.62,
            "end": 1510.6,
            "transcript": "Pinarqeqapiarlanricaaq' un' [?] yuk murilkellemni."
        },
        "161": {
            "start": 1510.6,
            "end": 1516.06,
            "transcript": "Teguqerluku ayautlaraat camun agtevkenata [?]."
        },
        "162": {
            "start": 1516.06,
            "end": 1522.24,
            "transcript": "Waten wani Yupiit ikani ilakngatnga wii apqaurtuq."
        },
        "163": {
            "start": 1522.24,
            "end": 1532.22,
            "transcript": "Tuar tamakut imkut pinarqa', wangkuta caliaqluki pilaraput."
        },
        "164": {
            "start": 1532.22,
            "end": 1541.82,
            "transcript": "Tuar imutun tuar Kass'amun tegullerkaa egmian aviyutlararput."
        },
        "165": {
            "start": 1541.82,
            "end": 1549.7,
            "transcript": "Nengkutaq'lekluku [?] Kass'amun teguvkararkauvkenaku wangkuta qanrraarpailemta."
        },
        "166": {
            "start": 1549.7,
            "end": 1556.26,
            "transcript": "Tuaten tamakunek caliangqerrami ikani kinguneput."
        },
        "167": {
            "start": 1556.26,
            "end": 1561.52,
            "transcript": "Tamakungqerquvci cali assirluku eglercartuci."
        },
        "168": {
            "start": 1561.52,
            "end": 1565.72,
            "transcript": "Yup'igni makunek apqaurtengqertuci."
        },
        "169": {
            "start": 1565.72,
            "end": 1570.64,
            "transcript": "Assirtuq, assiryaaquq tamana Yup'igni waten."
        },
        "170": {
            "start": 1570.64,
            "end": 1574.9,
            "transcript": "Tamakut Kass'anun ayagarta [?] ak'akika."
        },
        "171": {
            "start": 1574.9,
            "end": 1583.66,
            "transcript": "Qayutun allrakuni qel'karkaugaput tuaten wangkuta aulukluki."
        },
        "172": {
            "start": 1583.66,
            "end": 1593.5,
            "transcript": "Tau͡gken man'a anagulluni camek mat'umek navgissiyaalria quyilria, quyilria un' [?] navgissiyaakata."
        },
        "173": {
            "start": 1593.5,
            "end": 1600.98,
            "transcript": "Cali tua-i wangkuta qunukengramteggu tauna caliaqesciigatarkaugarput."
        },
        "174": {
            "start": 1600.98,
            "end": 1608.94,
            "transcript": "Man'a taum aciqvakun kanaggun navgingraan, wangkuta qel'karkaugarput."
        },
        "175": {
            "start": 1608.94,
            "end": 1615.76,
            "transcript": "Taumek Kass'at maa-i nallunritaci."
        },
        "176": {
            "start": 1615.76,
            "end": 1622.06,
            "transcript": "Pinarqenrilengraan ayakautlaraat."
        },
        "177": {
            "start": 1622.06,
            "end": 1624.02,
            "transcript": "Tuaten ayuqut."
        },
        "178": {
            "start": 1624.02,
            "end": 1637.74,
            "transcript": "Tamakungqerquvci imum [?] Yup'igni apqaurtengqerquvci [?] atam taun imna qel'kurciqerci Kass'anun teguvkarpek'naku."
        },
        "179": {
            "start": 1637.74,
            "end": 1645.8,
            "transcript": "Teguyungermi taum Kass'am tegunaitaa wangkuta pisqerraarpailemteggu."
        },
        "180": {
            "start": 1645.8,
            "end": 1651.44,
            "transcript": "Tuaten assiryaaquq nunani tamakurrangqerquvci."
        },
        "181": {
            "start": 1651.44,
            "end": 1671.68,
            "transcript": "Mat'umek Kass'at qanruyutiit call' pingqerrevkenani [?] wangkuta-gguq ciuliamta qanruyutait-llu tamakut qanruyutait-llu tamakunek ilaluku tauna caumaaqamteggu tuaten pituarput."
        },
        "182": {
            "start": 1671.68,
            "end": 1676.94,
            "transcript": "Tamakut ciuliamta qanruyutait ukisqaqluki."
        },
        "183": {
            "start": 1676.94,
            "end": 1687.9,
            "transcript": "Waten pikumta, waten yuukan, assirluni eglerciiqniluku. Tamakut ciuliamta qanruyukarrait ukisqaqluki."
        },
        "184": {
            "start": 1687.9,
            "end": 1692.68,
            "transcript": "Assiryaaquq tamana tuaten eglertellerkaq."
        },
        "185": {
            "start": 1692.68,
            "end": 1703.92,
            "transcript": "Ukisqaqu'urluta tuaten eglereskumta wangkuta Yup'igni tuss'araungaitukut."
        },
        "186": {
            "start": 1703.92,
            "end": 1715.1,
            "transcript": "Tuar imutun maa-i Kass'at nallunritanka, pektengramta tuar iliin tuss'araqtaqaitkut qanllerpetun piuvkarpek'naku."
        },
        "187": {
            "start": 1715.1,
            "end": 1717.6,
            "transcript": "Tuaten ayuqut."
        },
        "188": {
            "start": 1720.44,
            "end": 1733.46,
            "transcript": "Tua-i waniwa tamana paivartaqa makunek niicuit', makunek qanerciigalngurnek-wa piqtaarpakaata."
        },
        "189": {
            "start": 1733.46,
            "end": 1743.48,
            "transcript": "Tua-i tamana niicuilnguq-llu wangkuta waten, wangkuta tau͡gaam kitugtarkaqerput qanerturaulluku."
        },
        "190": {
            "start": 1743.48,
            "end": 1754.52,
            "transcript": "Tuaten, tuaten egelruskumteki assirluku egelrutarkaarput tuaten, aanii qaill' ayuqengraan."
        },
        "191": {
            "start": 1754.52,
            "end": 1757.5,
            "transcript": "Naw'un allakun egelrusngaitarput."
        },
        "192": {
            "start": 1757.5,
            "end": 1762.22,
            "transcript": "Wangkuta atam ulurramteggu egelruciiqerput. Tua-i tuaten taktauq."
        },
        "193": {
            "start": 1765.58,
            "end": 1770.34,
            "transcript": "Yaa, atauciq cali break-arpailemta 10 minutes."
        },
        "194": {
            "start": 1773.3,
            "end": 1779.4,
            "transcript": "Aren imna, amna qaneryullruuq."
        },
        "195": {
            "start": 1779.4,
            "end": 1784.02,
            "transcript": "Break-arraarluta piniartutek tungliqlutek."
        },
        "196": {
            "start": 1787.54,
            "end": 1802.98,
            "transcript": "Wiinga cali qaneryugtua, qaneryulartua ukut calistet akiliullua ayagavkaqatnga tamatumek tunrirlua tua-i elliingnaq pisqevkenaki."
        },
        "197": {
            "start": 1802.98,
            "end": 1811.54,
            "transcript": "Waniwa wiinga qaneryugtua cuqyutekluku."
        },
        "198": {
            "start": 1811.54,
            "end": 1823.12,
            "transcript": "Wiinga waniwa Paniguarluq. Paniguaq. Kass'am piciryaraa aturluku,"
        },
        "199": {
            "start": 1823.12,
            "end": 1836.56,
            "transcript": "una'urluq, qanrucunailnguq, qanermun atuunrilnguq pitekluku  Kass'at piciryaraat aturluku wii piyaaqaqa."
        },
        "200": {
            "start": 1836.56,
            "end": 1852.1,
            "transcript": "Una-wa tang nuli'urrluqa Uqviggluk, Uqvigglugmek pilaraat, cali ellii Yugtarkun umyuallgutkevkenanuk."
        },
        "201": {
            "start": 1852.1,
            "end": 1871.44,
            "transcript": "Wii Kass'atun piamku umyuallgutkenritukuk aipaqa-llu, una-llu pitekluku qanrucunailnguq arivlurutaarlunuk [?] qaillun ayusciigananuk [?]."
        },
        "202": {
            "start": 1871.44,
            "end": 1884.62,
            "transcript": "Una wii kituggnarqellria irniarlurpuk qaillun kitugtengnaqluku piurlullruyaaqerpuk."
        },
        "203": {
            "start": 1884.62,
            "end": 1900.0,
            "transcript": "Wii Kass'at piciryaraat aturluku una qanrucunailnguq imucetun waten negtaarluku piunrirluku pilallruaqa."
        },
        "204": {
            "start": 1900.0,
            "end": 1905.28,
            "transcript": "Iqlutnun qanertuq Kass'am piciryaraa maliggluku."
        },
        "205": {
            "start": 1905.28,
            "end": 1920.08,
            "transcript": "Uqviggluguam [?] Yugtarkun piaqamni qiau͡rlulartuq una qanrucunailnguq pitekluku."
        },
        "206": {
            "start": 1920.08,
            "end": 1935.1,
            "transcript": "Taqngami-llu qanerluni, \"Qetunramaa, kenkenrirngaitamken unguvama taktaciatun.\""
        },
        "207": {
            "start": 1938.14,
            "end": 1952.98,
            "transcript": "Qaillun-mi ukuk, una qanrucunailnguq, qaill' kitugteqatarta wangkuta Yupiit."
        },
        "208": {
            "start": 1952.98,
            "end": 1976.72,
            "transcript": "Waniwa man'a taringluku pikunegteggu ukut Calistarmiut tayima-llu apyutkeciqelliat court-akun Yugtarkun 18-aam aciani naspaaguryugluku."
        },
        "209": {
            "start": 1976.72,
            "end": 1979.24,
            "transcript": "Ellaita teguluku."
        },
        "210": {
            "start": 1979.24,
            "end": 1999.24,
            "transcript": "Nutaan piyunarquciq court-akun pikunegteggu nutaan umyugiurutekngairuciiqaa court-akun aangaarakun 18-aam acianelnguq tau͡gaam piyugngaciqerput."
        },
        "211": {
            "start": 1999.24,
            "end": 2018.84,
            "transcript": "Ukut una'urluq itertaugallruuq qanrucunaitaacini pitekluku 12-aarluni ayagluni itertauyartuq."
        },
        "212": {
            "start": 2018.84,
            "end": 2025.98,
            "transcript": "Nallunrituq, nallunrituq qaillun pilit [?]."
        },
        "213": {
            "start": 2025.98,
            "end": 2037.64,
            "transcript": "Taumek Tim Kaganaq [?] cingyaaqaqa nuniini uitiin kenekluku."
        },
        "214": {
            "start": 2037.64,
            "end": 2043.98,
            "transcript": "Qaillun piluku tuaten taringeqernayukluku."
        },
        "215": {
            "start": 2043.98,
            "end": 2053.46,
            "transcript": "Qaillun camek picirluni-llu wall'u-llu kenkenriryugluni wangkunun pillilria."
        },
        "216": {
            "start": 2053.46,
            "end": 2059.98,
            "transcript": "Qang'a-llu camek tayim' pitarluni pillilria."
        },
        "217": {
            "start": 2059.98,
            "end": 2072.14,
            "transcript": "Ayagyuararni camek akngirukarangqerquvci wangkutnun manikuvciu,"
        },
        "218": {
            "start": 2072.14,
            "end": 2089.58,
            "transcript": "ici-ci-ka [?] quyanarqeciqsaaqvagceci wangkuta angayuqrulriani apaulriani-llu nallukevceńek [?] qanruskuvcikut."
        },
        "219": {
            "start": 2089.58,
            "end": 2107.94,
            "transcript": "Uurluum inerciigacaraq qetunramegnuk nallunrilamiu waten Tim Kaganam [?] apeskani waten piciqliuq,"
        },
        "220": {
            "start": 2107.94,
            "end": 2116.32,
            "transcript": "\"Ata'urluma anagullua pivakaama waten piunga.\""
        },
        "221": {
            "start": 2116.32,
            "end": 2132.62,
            "transcript": "Qang'a-llu ellminek-llu tegliuryullmikun, ellminek-llu mer'ayullmikun, ellminek-llu aulukenritellra, niisnganritellra-llu."
        },
        "222": {
            "start": 2132.62,
            "end": 2140.7,
            "transcript": "Wii tayima-llu apeskaku wii aperciqlianga."
        },
        "223": {
            "start": 2140.7,
            "end": 2151.68,
            "transcript": "Uum nallunailngurkun Uqviggluum nuli'irrluma nallunailngurmek qanrutaa,"
        },
        "224": {
            "start": 2151.68,
            "end": 2159.06,
            "transcript": "\"Kenkenrirngaitamken unguvallma taktaciatun.\""
        },
        "225": {
            "start": 2159.06,
            "end": 2166.7,
            "transcript": "Taumek uum wii pinritaanga, aanani tau͡gaam."
        },
        "226": {
            "start": 2166.7,
            "end": 2179.98,
            "transcript": "Aaniin camek qanrutliaqani qanrut'laraanga pimek-gguq piqeryugyaaquq qanrutaa-gguq qanrutesqellua."
        },
        "227": {
            "start": 2179.98,
            "end": 2188.56,
            "transcript": "Ik'atak wii takarnarilua anglicaamku."
        },
        "228": {
            "start": 2188.56,
            "end": 2212.04,
            "transcript": "Maa-i man'a wiinga caknerpak taringekunegteggu ukut assikekunegteggu 18-aarpailgan court-amun nasvakunegteggu okay-qan piyugngariciqngataput tuaten."
        },
        "229": {
            "start": 2212.04,
            "end": 2227.2,
            "transcript": "Tau͡gken court-amun pivkenaku tumevkenaku [?] pikumteggu qunukaqtangamteńi [?] 18-aaqsailnguq teguciqngatait tamaa-i."
        },
        "230": {
            "start": 2227.2,
            "end": 2254.56,
            "transcript": "Aipaa-wa mat'um nalliini Moravian-aat agayulirtengqertut, allat-llu tayim' pillilriit, agayuyaryaqliurluata ik'it [?] pillranek anagulluku pitgaqussiyaagqatni."
        },
        "231": {
            "start": 2254.56,
            "end": 2260.88,
            "transcript": "Agayuyaqlirngaitaa [?] pissiyaagaanga."
        },
        "232": {
            "start": 2260.88,
            "end": 2284.68,
            "transcript": "Cam makut iqlutuuyulriit pissuutait agayulirteńgulriani cali deacon-aarulriani-llu qanrutkaat qaillun ayuqengraat ilaliurluku."
        },
        "233": {
            "start": 2284.68,
            "end": 2305.36,
            "transcript": "Taumek tau͡gaam ilaliullemta ikiuyulria qalmara'arciqaa, ungacara'arciqaa, hello good morning-aam-llu tagcira'arciqaa eq'ukevkenaku."
        },
        "234": {
            "start": 2305.36,
            "end": 2313.26,
            "transcript": "Tua-i wii man'a amllenrilengraan qanrutkeqa'arqa."
        },
        "235": {
            "start": 2313.26,
            "end": 2315.52,
            "transcript": "Quyana."
        },
        "236": {
            "start": 2317.18,
            "end": 2325.5,
            "transcript": "Quyana. Waniwa break-alput [?] tekituq."
        },
        "237": {
            "start": 2325.5,
            "end": 2338.98,
            "transcript": "[?]-qalriit arnamek-ll' wani nalaqutua nuliacungamnek tauna cali ilakluku piciqell'."
        },
        "238": {
            "start": 2338.98,
            "end": 2350.46,
            "transcript": "Wiinga Akiacuarmek pillruunga. Akiacuarmiungungacaaqellrianga-wa tau͡gaam Akiacuarmi nepingalriacetun ayuqlua."
        },
        "239": {
            "start": 2350.46,
            "end": 2354.98,
            "transcript": "James Peter-aaruunga Yugtun-llu Qukailngurmek aterlua."
        },
        "240": {
            "start": 2354.98,
            "end": 2371.5,
            "transcript": "Tau͡gaam qamani wiinga calrirlua cali [?] tua-i imutun elitnalriacetun [?] ayuqlua qamani Akiacuarmi."
        },
        "241": {
            "start": 2371.5,
            "end": 2392.58,
            "transcript": "Man'a wani yuum piciryaraa avani-ll' ayagluni qanruyutii, avani-ll' ayagluni inerquutii, maligtarkaulliniaput wangkuta Yupiani calikumta waten apqiitnek [?] court-ami."
        },
        "242": {
            "start": 2392.58,
            "end": 2398.72,
            "transcript": "Court-arilria wiinga qamani court-arilua man'a nallunritaqa."
        },
        "243": {
            "start": 2398.72,
            "end": 2407.12,
            "transcript": "Ayagniqarraallemni imutun takarnartarlua wall'u alingnartarlua ayagnillruyaaqua."
        },
        "244": {
            "start": 2407.12,
            "end": 2417.12,
            "transcript": "Maaten wangnek elpengua takarnartarlua alingnartarlua-llu upingaitellinilrianga."
        },
        "245": {
            "start": 2417.12,
            "end": 2430.4,
            "transcript": "Tau͡gaam una wani caliaqa, caliarkaqa una, kenekluku unganaqlua qalartarkaullinilua tauna yugmun."
        },
        "246": {
            "start": 2430.4,
            "end": 2448.38,
            "transcript": "Qaillun atutulalqa man'a nutaan taringarkarluku mat'ukun yuum piciryaraakun nutaan qalarutekluku tamana."
        },
        "247": {
            "start": 2448.38,
            "end": 2455.16,
            "transcript": "Waten-llu pingayuutagka [?] ciin atavet qalarucuitakek."
        },
        "248": {
            "start": 2455.16,
            "end": 2464.18,
            "transcript": "Taukuk caliaqngamku allamun tunevkenaku irniaqellrautgun [?] pitarrluki pilaranka."
        },
        "249": {
            "start": 2464.18,
            "end": 2473.12,
            "transcript": "Cali-llu una picurlaumalriim pia wangnun taitaqaagu qagkunun anucuitaqa."
        },
        "250": {
            "start": 2473.12,
            "end": 2486.66,
            "transcript": "Ilait pituut waten, \"Una-wa atulqa qanruteksungramku qanrutkesciigalkeka elpenun. Elpet-wa anuciiqngavgu qagkunun yugnun.\""
        },
        "251": {
            "start": 2486.66,
            "end": 2499.78,
            "transcript": "Tamana alingnarquq waten judge-aulriarulriani wavet qemaggluku yugnun nulirqeng'ermiu maantarkaqenritlinia [?]."
        },
        "252": {
            "start": 2499.78,
            "end": 2515.98,
            "transcript": "Aneskumku wii una ciuliaqa ciulirneret au͡gkut picirkiutiit qanruyutiit-llu wiinga elluarrluku atunrilkumku atucurlagarkaulliniaqa."
        },
        "253": {
            "start": 2515.98,
            "end": 2534.94,
            "transcript": "Ak'a avani uum qanellracetun ava-i qanrut'ngermi niicunrilnguq-gguq yuum tamakut ciuliamta antetullruat nunanek tuaken."
        },
        "254": {
            "start": 2534.94,
            "end": 2548.48,
            "transcript": "Qanrulluku-llu-gguq, \"Utercukuvet uterceciiqamteggen tau͡gaam man'a elpet wani nunanun avguuten [?] au͡g'allrukuvet."
        },
        "255": {
            "start": 2548.48,
            "end": 2557.98,
            "transcript": "Ataam utercukuvet uterceciiqamken.\" Tuacetun pitullrulliniut yuut ak'a tamaani."
        },
        "256": {
            "start": 2557.98,
            "end": 2566.76,
            "transcript": "Uum qanellra ava-i au͡gna wiinga-llu niicetullruaqa tamana niitenga'arqa."
        },
        "257": {
            "start": 2566.76,
            "end": 2577.98,
            "transcript": "Maa-i man'a court-aryaraq, Kass'am pianga, \"Wangkuta tang navgussiyaagngaitkut uum Kass'am piciryaraan.\""
        },
        "258": {
            "start": 2577.98,
            "end": 2584.72,
            "transcript": "Yuum piciryaraan navengaitaatkut atuqumteggu."
        },
        "259": {
            "start": 2584.72,
            "end": 2597.06,
            "transcript": "Aturluku inerquutai qanruyutai-llu wangkuta atuqumteki assirluta ayagciqlinilriakut."
        },
        "260": {
            "start": 2597.06,
            "end": 2606.56,
            "transcript": "Una-llu wani court-ariyaraq cali elluarrluku atuqumteki wangkuta Yugni nepairuciiqliukut."
        },
        "261": {
            "start": 2606.56,
            "end": 2614.28,
            "transcript": "Tau͡gaam umyuallguteksaraq cali-am una atuqumteggu ak'acetun."
        },
        "262": {
            "start": 2614.28,
            "end": 2626.34,
            "transcript": "Ak'a tang avani umyuallgutellrulliniameng nunacuarni-llu allakarmeng uitang'ermeng umyuallgtekngameng kenkutellrulriit."
        },
        "263": {
            "start": 2626.34,
            "end": 2634.14,
            "transcript": "Kenkucameng-llu makut elliraat aipailget-llu neqkaitnek payugquratullrullinikait."
        },
        "264": {
            "start": 2634.14,
            "end": 2643.9,
            "transcript": "Man'a qanruyun ak'a avaken ayagluku nalluyagucunaicaaqaput calillerkaat taringnaunaki [?]."
        },
        "265": {
            "start": 2643.9,
            "end": 2651.26,
            "transcript": "Wangnek cuqkekuma tamana cuqyutkaa taringengaitaci."
        },
        "266": {
            "start": 2651.26,
            "end": 2665.54,
            "transcript": "Tau͡gaam una yuum piciryaraa alerquutii-llu nalluvkayunaitaput makunun ciuliarramteńun."
        },
        "267": {
            "start": 2665.54,
            "end": 2671.74,
            "transcript": "Qanruyun atauciuguq yuum qanruyutii ellarpallermi tamakut."
        },
        "268": {
            "start": 2671.74,
            "end": 2678.5,
            "transcript": "Wangkuta Yugni taringetulriani qanruyuteput atauciuguq."
        },
        "269": {
            "start": 2678.5,
            "end": 2689.96,
            "transcript": "Kia inerqukakut nani nunani allani taum inerqutii inerqurciqaakut atauciungan qanruyun qaneryaraq man'a."
        },
        "270": {
            "start": 2689.96,
            "end": 2701.2,
            "transcript": "Tua-i au͡g'utun waten court-arinertua [?] qamani uum kass'am piciryaraa aturpek'naku tau͡gaam yuum piciryaraa aturluku."
        },
        "271": {
            "start": 2701.2,
            "end": 2705.02,
            "transcript": "Kenekluku unganaqluni."
        },
        "272": {
            "start": 2705.02,
            "end": 2711.96,
            "transcript": "Unganarqengnaqluni ukunun caliaminun."
        },
        "273": {
            "start": 2711.96,
            "end": 2720.7,
            "transcript": "Ellii mikliriluni pinarqelliniuq waten ukuni-llu mikellrurrluni caliaminun."
        },
        "274": {
            "start": 2720.7,
            "end": 2730.06,
            "transcript": "Kiani amllerrsaaqut calillgutenka tau͡gaam wiinga kiima kiani cucukuralaatnga court-aq yuu [?] atuumauq."
        },
        "275": {
            "start": 2730.06,
            "end": 2736.74,
            "transcript": "Amllerrsaaqut ilanka arnat tuaten tamakut cucukellrunritait, cucukessunait [?]."
        },
        "276": {
            "start": 2736.74,
            "end": 2740.7,
            "transcript": "Piqatarqata tuani caliqatarqa tangvayuunani."
        },
        "277": {
            "start": 2740.7,
            "end": 2751.22,
            "transcript": "Tua-i waten qancurlagaluni, wall'u qenerrluni, wall'u caturlagaluni, yuumta ciuqerratni piarkaunritliniuq."
        },
        "278": {
            "start": 2751.22,
            "end": 2757.32,
            "transcript": "Tau͡gaam assirluta unganaqluta-llu wangkuta caliarkaulliniukut."
        },
        "279": {
            "start": 2757.32,
            "end": 2763.46,
            "transcript": "Nutaan una qanruyun aturciqliniaput kenkeknguan."
        },
        "280": {
            "start": 2763.46,
            "end": 2766.48,
            "transcript": "Kenkekem allakun pisciiyatukut."
        },
        "281": {
            "start": 2766.48,
            "end": 2771.98,
            "transcript": "Kenkekun-llu umyuallgutkeciqliniluta."
        },
        "282": {
            "start": 2771.98,
            "end": 2778.88,
            "transcript": "Eq'ukput qanenrilnguagutetuaput [?] nalluvkenaku-ll' tamana."
        },
        "283": {
            "start": 2778.88,
            "end": 2781.66,
            "transcript": "Tua-i-wa amllerilria qanellqa."
        },
        "284": {
            "start": 2784.98,
            "end": 2788.28,
            "transcript": "Yaa, una-wa qanrutqernaluku."
        },
        "285": {
            "start": 2788.28,
            "end": 2790.72,
            "transcript": "Wangkuta tan'gurrarni, I mean."
        },
        "286": {
            "start": 2790.72,
            "end": 2800.18,
            "transcript": "Ciuqliim qanerpailegma, wiinga maku', Negtemi yuurtellruunga anglilua-llu yaani yaavet 1964-aamun."
        },
        "287": {
            "start": 2800.18,
            "end": 2806.84,
            "transcript": "Maavet-llu nugtarrlua 1965 yaavet 1978."
        },
        "288": {
            "start": 2806.84,
            "end": 2812.5,
            "transcript": "1978-aami-llu kassuullua nugtarrlua-llu Tununermun."
        },
        "289": {
            "start": 2812.5,
            "end": 2816.02,
            "transcript": "Tununermiungurrlua man'a tekilluku."
        },
        "290": {
            "start": 2816.02,
            "end": 2825.62,
            "transcript": "Atqa-llu Yugtun Anuralriaruyaaqlua tau͡gaam Pinruralriamek piuratuatnga Kass'atun-llu Paul Sonny."
        },
        "291": {
            "start": 2825.62,
            "end": 2829.86,
            "transcript": "Yaa, au͡g'umek wani qanrutqernaluku."
        },
        "292": {
            "start": 2829.86,
            "end": 2843.98,
            "transcript": "Wangkuta tan'gurrarni imumek waten tua-i qanruyutvut ataucirqumek taringyuitaput qanrutkaqatgu."
        },
        "293": {
            "start": 2845.86,
            "end": 2851.38,
            "transcript": "Tau͡gaam qavciliriluku qanrutkaqatgu taringurainatuaput."
        },
        "294": {
            "start": 2851.38,
            "end": 2856.88,
            "transcript": "Iliini waten, wiinga tan'gurrauyaaqngama,"
        },
        "295": {
            "start": 2856.88,
            "end": 2865.94,
            "transcript": "waten kinguqlimnek aptesciuraqama qanrutesqelluteng waten qanrutestaitniluteng,"
        },
        "296": {
            "start": 2865.94,
            "end": 2868.14,
            "transcript": "waten umyuarteq'lartua,"
        },
        "297": {
            "start": 2868.14,
            "end": 2874.76,
            "transcript": "\"Makusmi [?] ciuqliinka qanrutestekait wall'u qanrutestekaci.\""
        },
        "298": {
            "start": 2874.76,
            "end": 2876.78,
            "transcript": "Waten piaqatnga,"
        },
        "299": {
            "start": 2876.78,
            "end": 2883.08,
            "transcript": "\"Qanrutestailngua tang qanrutqernga ellangcaqaqernga.\""
        },
        "300": {
            "start": 2883.08,
            "end": 2895.68,
            "transcript": "Wiinga camek qanllerkamnek uunguciileng'e'rma puqialama-llu."
        },
        "301": {
            "start": 2895.68,
            "end": 2906.28,
            "transcript": "Tayima wiinga ellaita cucuklua qanrutesqelluteng piaqata caperrsutuyaaqua."
        },
        "302": {
            "start": 2906.28,
            "end": 2914.56,
            "transcript": "Tua-i-w' murilkeqallemnek tau͡gaam niitellemnek-llu qanrucetuanka."
        },
        "303": {
            "start": 2914.56,
            "end": 2915.64,
            "transcript": "Qanqautetuanka."
        },
        "304": {
            "start": 2915.64,
            "end": 2923.84,
            "transcript": "Taukugnek malrugnek tan'gurraagnek taringcauruciqerlua piciuqua atrek apertunrilengraagnek."
        },
        "305": {
            "start": 2923.84,
            "end": 2932.92,
            "transcript": "Ciumek makumiu tan'gurraam apteskiinga qanruskiinga,"
        },
        "306": {
            "start": 2932.92,
            "end": 2942.06,
            "transcript": "aanami qanellra au͡gna qanrutkellraniu waten piaqa,"
        },
        "307": {
            "start": 2942.06,
            "end": 2947.58,
            "transcript": "\"Aanavet kenekngamiten qanrutaaten.\""
        },
        "308": {
            "start": 2947.58,
            "end": 2951.26,
            "transcript": "Wiinga-ll' tua-i qanruqu'urluku,"
        },
        "309": {
            "start": 2951.26,
            "end": 2963.22,
            "transcript": "\"Wangkuta ilumun tan'gurrarni niicuilengramta ilaitni ciutput ciuluta inglua umegluku,"
        },
        "310": {
            "start": 2963.22,
            "end": 2972.16,
            "transcript": "wavet qamiqumteńun ellitullini', ilaita niicugngalriit tuatnatulliniut."
        },
        "311": {
            "start": 2972.16,
            "end": 2980.14,
            "transcript": "Tuamtellu aipaa niiciiquq ingluakun ciutmi uuggun-llu anluni."
        },
        "312": {
            "start": 2980.14,
            "end": 2983.06,
            "transcript": "Wiinga tuatnatuunga iliini.\""
        },
        "313": {
            "start": 2983.06,
            "end": 2990.8,
            "transcript": "Taumek wangkuta iliini quyalartua makunek ak'allanek qanaagakata."
        },
        "314": {
            "start": 2990.8,
            "end": 3002.82,
            "transcript": "Au͡g'um wani makumium qanrutesqellrani qanruqu'uraqallruaqa tua-i pinertutacirramtun."
        },
        "315": {
            "start": 3002.82,
            "end": 3009.7,
            "transcript": "Tua-i-llu qanenermek taqngami pianga, aanii niicugnistevkenaku qanaatellruamku."
        },
        "316": {
            "start": 3009.7,
            "end": 3019.32,
            "transcript": "Pianga, aanami-gguq cangalkenrilkiinek qanerturallranek qanerturtua."
        },
        "317": {
            "start": 3019.32,
            "end": 3021.22,
            "transcript": "Quyaluni cakneq."
        },
        "318": {
            "start": 3021.22,
            "end": 3031.18,
            "transcript": "Wangkuta waten yugmek ataucimek qanrutestengqerqumta wanirpak taringengaitelliniukut."
        },
        "319": {
            "start": 3031.18,
            "end": 3048.04,
            "transcript": "Tau͡gaam tauna qanerturallra tua-i-ll' allam, wall'u nunalgutkenritestiin, qanruskani nutaan taringeciqelliniuq carrarmek."
        },
        "320": {
            "start": 3048.04,
            "end": 3053.82,
            "transcript": "Tauna-ll' tua-i nataqluku akmani akukumiungurtama."
        },
        "321": {
            "start": 3053.82,
            "end": 3068.38,
            "transcript": "Taum-llam au͡g'um angayuqaagken au͡g'um aaniin qanrullua waten taisqellua."
        },
        "322": {
            "start": 3068.38,
            "end": 3073.22,
            "transcript": "Qetunraa-gguq tang au͡gna qanaateqerlaku."
        },
        "323": {
            "start": 3073.22,
            "end": 3076.78,
            "transcript": "Elliin-gguq qanaatesciigataa."
        },
        "324": {
            "start": 3076.78,
            "end": 3081.0,
            "transcript": "Wiinga-ll' capercillaglua cakneq."
        },
        "325": {
            "start": 3081.0,
            "end": 3089.86,
            "transcript": "Tauna aanii arnaurteńguq."
        },
        "326": {
            "start": 3089.86,
            "end": 3096.6,
            "transcript": "Kinguakun taum pillran tua-i pinertutacirramtun piqcaarallruaqa."
        },
        "327": {
            "start": 3096.6,
            "end": 3103.7,
            "transcript": "Taum-ll' kinguakun atiin taum-ll' pilua."
        },
        "328": {
            "start": 3103.7,
            "end": 3114.14,
            "transcript": "Atam au͡gna qetunraqa qanaateqaqiu, elliin-gguq qanrutesciigataa."
        },
        "329": {
            "start": 3114.14,
            "end": 3118.26,
            "transcript": "Taumek-ll' wiinga umyuaqa tuani calirpagtuq."
        },
        "330": {
            "start": 3118.26,
            "end": 3125.96,
            "transcript": "Wiinga puqialama qaillun qanrutlerkaanek."
        },
        "331": {
            "start": 3125.96,
            "end": 3132.12,
            "transcript": "Wangkuta qaneryarat makut ciuqlimta qanllrit ataucirqumek taringengaitua."
        },
        "332": {
            "start": 3132.12,
            "end": 3136.96,
            "transcript": "Qavciliriluta taum taringyugngalliniukut."
        },
        "333": {
            "start": 3136.96,
            "end": 3152.02,
            "transcript": "Taum wani qetunraan caqerlua piinanemni phone-aqa kallaggluni."
        },
        "334": {
            "start": 3152.02,
            "end": 3155.7,
            "transcript": "Pianga, maqiyugtua-gguq-qaa."
        },
        "335": {
            "start": 3155.7,
            "end": 3160.46,
            "transcript": "Wiinga-ll' tua-i angerluku tan'gurrauluni."
        },
        "336": {
            "start": 3160.46,
            "end": 3164.02,
            "transcript": "Ellii-gguq maqikiuqatartuq."
        },
        "337": {
            "start": 3166.22,
            "end": 3171.7,
            "transcript": "Tua-i-ll' kumarqaarluni pianga,"
        },
        "338": {
            "start": 3171.7,
            "end": 3176.48,
            "transcript": "kumartuq-gguq ama-i cuqluku agkilii."
        },
        "339": {
            "start": 3176.48,
            "end": 3180.88,
            "transcript": "Tua-i-ll' uitaurlua tua-i pinaringalan aglua."
        },
        "340": {
            "start": 3180.88,
            "end": 3185.16,
            "transcript": "Itertua maaten cataunani."
        },
        "341": {
            "start": 3185.16,
            "end": 3189.24,
            "transcript": "Tua-i-ll' aqumlua uitaurlua utaqaurluku."
        },
        "342": {
            "start": 3189.24,
            "end": 3194.64,
            "transcript": "Camek umyuartengengsaagpegnii."
        },
        "343": {
            "start": 3194.64,
            "end": 3204.54,
            "transcript": "Maaten itertuq kegginaa tangyunaunani assiinani anglanaunani."
        },
        "344": {
            "start": 3204.54,
            "end": 3211.88,
            "transcript": "Tua-i-ll' pianga, ellii-gguq tang qanrutqerlaku."
        },
        "345": {
            "start": 3211.88,
            "end": 3216.64,
            "transcript": "Qanaateqerlaku."
        },
        "346": {
            "start": 3216.64,
            "end": 3222.82,
            "transcript": "Kegginaa tangerrluku wiinga imkurlua asqialliqa'arrlua."
        },
        "347": {
            "start": 3222.82,
            "end": 3228.52,
            "transcript": "Elpeci iliini qetunrarseng tangrraqavci tuaten aliayullalartuci."
        },
        "348": {
            "start": 3228.52,
            "end": 3232.5,
            "transcript": "Ayuqluku wiinga-ll' pillruunga."
        },
        "349": {
            "start": 3232.5,
            "end": 3239.82,
            "transcript": "Tua-i-llu aqumlunuk waten akiqliqa'arrlunuk."
        },
        "350": {
            "start": 3239.82,
            "end": 3247.66,
            "transcript": "Ellii ika-i akimni aqumluni aqumgalunuk."
        },
        "351": {
            "start": 3247.66,
            "end": 3251.3,
            "transcript": "Wiinga-ll' tua-i pilua,"
        },
        "352": {
            "start": 3251.3,
            "end": 3256.2,
            "transcript": "qaillun wiinga men'ermek taqellrusia."
        },
        "353": {
            "start": 3256.2,
            "end": 3260.24,
            "transcript": "Wiinga-ll' tua-i qaillun kiucirkailamku tauna."
        },
        "354": {
            "start": 3260.24,
            "end": 3270.62,
            "transcript": "Wiinga-ll' maani anguyagteńi ikani quyurtellemteńi iluracungaqa una Kangrilnguq qanerturallrani aptellruaqa waten."
        },
        "355": {
            "start": 3270.62,
            "end": 3278.9,
            "transcript": "Elpet qaillun taqlerpenek wiinga maligcugyaaqluten."
        },
        "356": {
            "start": 3278.9,
            "end": 3287.58,
            "transcript": "Elliin qanellra uum ilu'urma umyuaqluku iqluvkenani qanellruan."
        },
        "357": {
            "start": 3287.58,
            "end": 3295.16,
            "transcript": "Tauna qanellra wiinga-llu, wiinga-ll' cangalkuvkenii mel'allruama."
        },
        "358": {
            "start": 3295.16,
            "end": 3301.72,
            "transcript": "Tau͡gaam-wa allrakut qavciurtut pinritengnaqu'urangelqa man'a."
        },
        "359": {
            "start": 3301.72,
            "end": 3306.54,
            "transcript": "Tamatumek qanruqu'urqilaku."
        },
        "360": {
            "start": 3306.54,
            "end": 3309.64,
            "transcript": "Qanruqu'urluku tua-i."
        },
        "361": {
            "start": 3309.64,
            "end": 3322.62,
            "transcript": "Ilait makut waten niicugninqegcaaratulit niicetulliniut kinguqliqengramteki ciuqliqengramteki."
        },
        "362": {
            "start": 3325.98,
            "end": 3331.24,
            "transcript": "Qanruqu'urqilaku tua-i pinertutacirramtun."
        },
        "363": {
            "start": 3331.24,
            "end": 3345.02,
            "transcript": "Wiinga wangnek qaneryaraq taiksailnguq makunek tau͡gaam elder-amnek qanlleq, qanellret qaneryarait aturluki antengnaqluku."
        },
        "364": {
            "start": 3345.02,
            "end": 3352.76,
            "transcript": "Wangkuta waten wangkutnek pitulliniukut."
        },
        "365": {
            "start": 3352.76,
            "end": 3365.94,
            "transcript": "Imumek waten wangkuta tua-i camek umyuarteqenrilnginanemteńi wangkutnek aulukngamta."
        },
        "366": {
            "start": 3365.94,
            "end": 3371.1,
            "transcript": "Una waniwa tangllemni."
        },
        "367": {
            "start": 3371.1,
            "end": 3379.46,
            "transcript": "Waniwa au͡gna taangaq naspaallruaqa pivakarlua."
        },
        "368": {
            "start": 3382.98,
            "end": 3394.18,
            "transcript": "Imumek waten patuakun kuvqaullua pillemni."
        },
        "369": {
            "start": 3394.18,
            "end": 3397.4,
            "transcript": "Tua-i-ll' espickarluku."
        },
        "370": {
            "start": 3397.4,
            "end": 3403.08,
            "transcript": "Espickaqemni wanirpaagaq ek'ullagluni."
        },
        "371": {
            "start": 3403.08,
            "end": 3409.22,
            "transcript": "Wiinga-ll' tua-i kinguknerakun kinguakun tamaa-i umyuarteqenglua."
        },
        "372": {
            "start": 3409.22,
            "end": 3413.96,
            "transcript": "Wangkutnek kenqutkiulallinilriakut."
        },
        "373": {
            "start": 3416.64,
            "end": 3421.42,
            "transcript": "Tua-i kenqutkiurluta tamatum taangam pilalliniakut."
        },
        "374": {
            "start": 3421.42,
            "end": 3426.84,
            "transcript": "Picurlautmek et'umek aqvalluta."
        },
        "375": {
            "start": 3428.58,
            "end": 3436.42,
            "transcript": "Tua-i-ll' taumek nalqiguqaarluku."
        },
        "376": {
            "start": 3436.42,
            "end": 3443.5,
            "transcript": "Yaa, time-aq apaan [up-aan?], iquklitenrilengraan quyaunga cakneq wani au͡g'um qanrutlemnek."
        },
        "377": {
            "start": 3443.5,
            "end": 3449.76,
            "transcript": "Waten tayima wangkuta ataucirqumek qaneryaraq taringyuilamteggu."
        },
        "378": {
            "start": 3449.76,
            "end": 3467.6,
            "transcript": "Tayima elpeci ak'allani tayima qanruskengaci waten qanrut'laraci kenekniluki ayuqluta wangkuta-ll' irniaput anglicavut [?] kenekluki."
        },
        "379": {
            "start": 3467.6,
            "end": 3471.64,
            "transcript": "Quyana cakneq qanertellua."
        },
        "380": {
            "start": 3471.64,
            "end": 3474.18,
            "transcript": "Quyana Sonny."
        }
    },
    "4qFx_P2CkKQ": {
        "1": {
            "start": 8.54,
            "end": 17.48,
            "transcript": "Tau͡gaam John Phillip-aaruunga. 52 [?]. Ayaginaraugua Kangirnarmiugulua-llu."
        },
        "2": {
            "start": 17.48,
            "end": 36.28,
            "transcript": "Cali aqumgallrenka, aqumllerenka ukut wani nunamni taisngalriit nine-aanek, taukunek wani aqumkan [?] tegumiangqelartua man'a-llu ilakluku quyurrvigput."
        },
        "3": {
            "start": 36.28,
            "end": 55.66,
            "transcript": "Tuacetun taukut pitangraata wani aqumlleret ayakevkenaki pisqumaciqa maliggluku taukunun wani ikayuutelartua-w' tua-i waten qanaata ciulirneput."
        },
        "4": {
            "start": 55.66,
            "end": 65.22,
            "transcript": "Yuk-gguq wani catngunrileng'e'rmi taarkengiarautellria [?] quyurtellrianun tauna-gguq amllellriaruuq."
        },
        "5": {
            "start": 65.22,
            "end": 77.58,
            "transcript": "Maa-i una wani tamana pitekluku au͡gkut apengllerenka makuni ayuqenrilengraata quyurtaalalriit quyurtaalriani tamakuni au͡gkut qanrutkanka."
        },
        "6": {
            "start": 77.58,
            "end": 89.7,
            "transcript": "Piyunartacirramtun wani man'a ciukluku qanrutka piyunartacirramtun ikayuutelaama taukunun."
        },
        "7": {
            "start": 89.7,
            "end": 102.66,
            "transcript": "Au͡gna wani ukut qanrutkellrat nallunritqapigtenrilengramki tau͡gaam wangnun cali atuulallruuq au͡gna wani neqlicaraq."
        },
        "8": {
            "start": 102.66,
            "end": 112.16,
            "transcript": "Avani wani miktellemni wii tamaten tuaten piaqatnga camek umyuarteqsuitellruunga wani tamakunek piluteng."
        },
        "9": {
            "start": 112.16,
            "end": 124.12,
            "transcript": "Maaten wani caqerluni iliita au͡gkut wani au͡gna neqlicaraq pillrani."
        },
        "10": {
            "start": 124.12,
            "end": 145.02,
            "transcript": "Caqerluni iliita au͡g'utun qanellratun wani ciutmun piluni taukut wani tuqulrianek niitaqameng, ciutmun-am piluni taukut wani piurarraarluki aperturluki atrit wangnun elliluki."
        },
        "11": {
            "start": 145.02,
            "end": 157.76,
            "transcript": "Tayima-ll' atrit ilait nalluyagutanka tau͡gaam kiingan una maa-i atulaqngat tauna kiingan nallunritaqa."
        },
        "12": {
            "start": 157.76,
            "end": 179.98,
            "transcript": "Tamakut wani umyuaqluki pilallinilriit yut'eng tua-i-llu ilaita, iliini wani uum ullagluku umyuaqellni, tauna wani umyuaqluku pitulliniut ayuqenritut ava-i qanrutkellri ayuqenritniluki neqlicarat uum wani."
        },
        "13": {
            "start": 179.98,
            "end": 194.42,
            "transcript": "Tauna wani yuum iliin ullagluku qantamek imirluku wani mermek-llu tua-i tapirluku cikilallruatnga ilaita tuaten."
        },
        "14": {
            "start": 194.42,
            "end": 206.8,
            "transcript": "Tauna cunaw' wani ava-i qanrutkuciatun wani umyuaqluku tauna wani ayalleq wani yun'i taumun elliluku pitullinilria."
        },
        "15": {
            "start": 206.8,
            "end": 218.98,
            "transcript": "Au͡gkut qanrutkellrit qanrutkenrilengraata, makut maa-i pinritqall'uki [?] qanrutekluki, tauna umyuaqluku pitullinilria."
        },
        "16": {
            "start": 218.98,
            "end": 229.5,
            "transcript": "Tamakut tamaa-i nangtequteteng ayallret ellmeggnek umyuaqluki au͡g'utun ilaita neqlicarat atulallrulliniat avani."
        },
        "17": {
            "start": 229.5,
            "end": 253.94,
            "transcript": "Cali-llu yuk wani, waten tamaaggun pirraarluni yuk assiirutaqami yuk naulluungaqan au͡g'utun, tauna umyuaqluku au͡g'utun piaqatni, qanruyuciicetun au͡g'utun, tauna umyuaqluku piaqatni, assiriaqluni naulluutii."
        },
        "18": {
            "start": 253.94,
            "end": 265.6,
            "transcript": "Tauna-gguq tua-i wani tamana umyuaqluku taum iliini kangingyugluni piaqami tuastun pilalliniuq."
        },
        "19": {
            "start": 265.6,
            "end": 276.96,
            "transcript": "Tama-i tamana wani au͡gkut wani nallunrilutacirramtun qanrutkaq au͡gna wani nallunritqapigtenrilriamku kangia."
        },
        "20": {
            "start": 276.96,
            "end": 293.26,
            "transcript": "Tau͡gaam wangkuta wani au͡gkut ciuliamta ava-i qanrutkelaraat wangkuta anaassait [?] atullerteng wangkutnun asvuavangnaqsaaqluku [?]."
        },
        "21": {
            "start": 293.26,
            "end": 299.76,
            "transcript": "Tua-llu tua-i wangkuta ilaitni ukveyuitukut qanruyutemteńek."
        },
        "22": {
            "start": 299.76,
            "end": 309.1,
            "transcript": "Wall'u tamakut ilait caunritkaqluki wiinga-llu maa-i tamakut ciutengavnun niitelaraanka caunritniluki ilait."
        },
        "23": {
            "start": 309.1,
            "end": 317.4,
            "transcript": "Tau͡gaam nallunritnaurput una."
        },
        "24": {
            "start": 317.4,
            "end": 328.32,
            "transcript": "Waten qaneryarartangqertuq qanrut'laraitkut maani wani agayuvingqertukut tamamta nani uitalriani kituungraata."
        },
        "25": {
            "start": 328.32,
            "end": 337.1,
            "transcript": "Tekiit' [?], qanertuq waten, Jesus-aaq nallunritarput [?] augna taperluku, waten qanelriartangqertuq."
        },
        "26": {
            "start": 337.1,
            "end": 349.98,
            "transcript": "Tekitenritua nunamun alerquutet caunrilcarturluki, piunrilkarturluki, tau͡gaam ilayarturluki."
        },
        "27": {
            "start": 349.98,
            "end": 354.96,
            "transcript": "Tauna wani umyuaqelaqeka."
        },
        "28": {
            "start": 354.96,
            "end": 373.88,
            "transcript": "Agayutem wani ilumun yug' atauciq piyurtellruamiu canek wani alerquutnek piinaku pingailamiu qanruyutnek-llu, ikayuutekainek-llu temii."
        },
        "29": {
            "start": 373.88,
            "end": 378.26,
            "transcript": "Tamakunek wani ciuqliput au͡gkut pilallrullinii."
        },
        "30": {
            "start": 378.26,
            "end": 383.18,
            "transcript": "Tamakut wani avani watuacetun ciuqliput ayuqenritut."
        },
        "31": {
            "start": 383.18,
            "end": 396.28,
            "transcript": "Iinriurtetaitellruuq, doctor-aartaitellruuq. Kina doctor-aamek makut ciuqliput tangyuitellruut, makut yuungcaucetnek tangyuitut."
        },
        "32": {
            "start": 396.28,
            "end": 401.18,
            "transcript": "Au͡g'unek tau͡gaam ava-i watua-llu tanglartuci tamakunek."
        },
        "33": {
            "start": 401.18,
            "end": 408.06,
            "transcript": "Tamakunek tau͡gaam tamaa-i au͡g'unek pingqetullruut."
        },
        "34": {
            "start": 408.06,
            "end": 417.7,
            "transcript": "Ukvekluki cat qanruyuciicetun atuamegteki wangkucicetun watua-am nalliicetun ayuqenritut."
        },
        "35": {
            "start": 417.7,
            "end": 423.94,
            "transcript": "Arnassaagarluteng angutessaagarluteng pektesciigaliluteng yuutullruut avani."
        },
        "36": {
            "start": 423.94,
            "end": 434.54,
            "transcript": "Ugaan pektesciigaliim teguluki-llu angukara'urluut qasgimek maqiqata'arqata anutelallruaput, wiinga-llu ilagautelallruunga tamakunek."
        },
        "37": {
            "start": 434.54,
            "end": 440.36,
            "transcript": "Upakata'arqata-llu atrautaqluki tegumiaqluki angyami iluani."
        },
        "38": {
            "start": 440.36,
            "end": 453.5,
            "transcript": "Ciulirneteng imutun caunrilngurtetun pikevkenaki cakneq kencikluki pitullruit, kenekluki cakneq qanruyucetekngamegteki-w' tua-i."
        },
        "39": {
            "start": 453.5,
            "end": 461.8,
            "transcript": "Mat'umek au͡gna ilaqerluku neqlicaraq, tamalkuan pinrilengramku au͡gkut ikayuqaranka."
        },
        "40": {
            "start": 461.8,
            "end": 463.48,
            "transcript": "Quyanaqvaa."
        },
        "41": {
            "start": 464.48,
            "end": 471.76,
            "transcript": "Tamaani nulirqelriik unguvayuitetulliniuk tamatum nalliini ak'a."
        },
        "42": {
            "start": 471.76,
            "end": 483.42,
            "transcript": "Unguvasciigataqagnek-llu wangkuk una'urluq-llu yuugukuk waten ataucirraurlunuk anelgutaunanuk ayuqukuk."
        },
        "43": {
            "start": 483.42,
            "end": 493.3,
            "transcript": "Tua-i tamaani atermek aciisqenritellrulliniagnga taukuk nulirqelriik."
        },
        "44": {
            "start": 493.3,
            "end": 497.1,
            "transcript": "Yuilqumi wiinga yuurtellrulliniunga un'gani."
        },
        "45": {
            "start": 497.1,
            "end": 500.36,
            "transcript": "Angayuqaagka Qinarmiungullruuk."
        },
        "46": {
            "start": 500.36,
            "end": 507.64,
            "transcript": "Qinarmiullret Tuntutuliarmun nugtarqullruut, angayuqaagma nunakek."
        },
        "47": {
            "start": 507.64,
            "end": 517.76,
            "transcript": "Un'gani-llu uksuiyaryarami pavavet yuurtellruunga tamaani kuigem iluani ellami uksuqatarluku."
        },
        "48": {
            "start": 517.76,
            "end": 522.92,
            "transcript": "October-aami maa-i anutiingqelartua 10-aami."
        },
        "49": {
            "start": 522.92,
            "end": 534.6,
            "transcript": "Tua-i tauqapiaraunricaaqlilria-llu upainanratni tuavet uksulirkameggnun ellami pelatekam iluani."
        },
        "50": {
            "start": 534.6,
            "end": 539.68,
            "transcript": "Yuurcama-gguq taukuk angayuqaagka irniangesciigalnguuk."
        },
        "51": {
            "start": 539.68,
            "end": 552.0,
            "transcript": "Taum angutem ayallrutiignek waten qanrutak, \"Taunau͡rluq nutaan unguvangaituq. Nengelmi maani yuurtuq.\""
        },
        "52": {
            "start": 552.0,
            "end": 559.14,
            "transcript": "Nem'i-llu pivkenani tua-i pelatekam iluani uksuryulria-wa cikuqaquluni."
        },
        "53": {
            "start": 559.14,
            "end": 563.22,
            "transcript": "Tamaani tua-i wiinga yuurtellrulliniunga."
        },
        "54": {
            "start": 563.22,
            "end": 576.92,
            "transcript": "Man'a aviukaqsaraq qanrutekvailemku qanrutkeqararkaqa carrauguq. Sass'am nekelkaqa [?] murilkekiu."
        },
        "55": {
            "start": 576.92,
            "end": 582.02,
            "transcript": "Yaa, carrauguq qanrutkeqararkaqa."
        },
        "56": {
            "start": 582.02,
            "end": 595.22,
            "transcript": "Avani yuullemteńi wangkuta laavkaamek tangellrunritukut, waten-llu enerpagmek tangellruvkenaku, kass'anek-llu tangellruvkenata."
        },
        "57": {
            "start": 595.22,
            "end": 606.52,
            "transcript": "Mat'um nalliini maa-i kallugkun yuugukut alingnarqelriakun eksulriakun ekuayulriakun."
        },
        "58": {
            "start": 606.52,
            "end": 616.26,
            "transcript": "Wangkuta-llu arnani enem nayurtaini man'a alerquuteksugqa [?] ayagyuanun. Yugyallerci quyakaqa."
        },
        "59": {
            "start": 616.26,
            "end": 628.06,
            "transcript": "Man'a tang kalluk, takumcuyuyuilnguq keneq. Yuum ilii enaitaqaa uksuungraan-llu takumcukevkenaku ellamun ellirluku."
        },
        "60": {
            "start": 628.06,
            "end": 636.02,
            "transcript": "Tamakut elpekngamki kinguqvani man'a kalluk piurtellruuq. Kallugtaitellruuq nallumni."
        },
        "61": {
            "start": 636.02,
            "end": 646.92,
            "transcript": "Nutaan-llu wiinga kallulegmek enengvaalullemni umyuarteq'lallruunga, qavamteńi-llam makut kalluut ekuaciqut."
        },
        "62": {
            "start": 646.92,
            "end": 650.46,
            "transcript": "Umyuaqa tua-i mat'umek umyuarluni."
        },
        "63": {
            "start": 650.46,
            "end": 661.34,
            "transcript": "Agayutmek tamaq'apiarpeci nallunrituci. Kia nallunguanritaa. Tamarmi yuum Agayun nallunritaa ikayurtekaq."
        },
        "64": {
            "start": 661.34,
            "end": 666.76,
            "transcript": "Arnar' enemini uitakuni piicatuciquq."
        },
        "65": {
            "start": 666.76,
            "end": 682.76,
            "transcript": "Man'a kalluk ekualria wangkuta-wa kallugglainarteggun calriakut kenirluta neqkiurluta cat-llu makut niitelput ciutegemteggun kallugglainarkun ayagluteng."
        },
        "66": {
            "start": 682.76,
            "end": 693.12,
            "transcript": "Man'a tang kaigateksunarqelalria kesianernek tamalkuan kalluum calillra enemek piunriresqevkenaku."
        },
        "67": {
            "start": 693.12,
            "end": 699.38,
            "transcript": "Cali-llu ilaci nunaukarangqerquni pingevkaqaitkut-llu maa-i."
        },
        "68": {
            "start": 699.38,
            "end": 716.28,
            "transcript": "Nunaukarani-w' tauna imartuumaan piicautarkaugaa Agayutmun ikayurtetaarluku iluanelnguut tamalkuita yugtuumaita enet mat'um kalluum piunrirenritlerkaanun."
        },
        "69": {
            "start": 716.28,
            "end": 727.48,
            "transcript": "Man'a umyuarqutellruamku ayagyuanun nutaan neng'ilrianun nutaat-llu yuungnaqilrianun ayagyualrianun man'a qanrutkaqa."
        },
        "70": {
            "start": 727.48,
            "end": 738.48,
            "transcript": "Cumigtellruunga qanrutkessugluku uum-llu au͡g'um qanrutkarkama aviukaqsaram ciungani waniwa qanrutkaqa."
        },
        "71": {
            "start": 738.48,
            "end": 744.44,
            "transcript": "Wangnek uum-llu pinritaanga. Wangnek tau͡gaam piyugqa man'a."
        },
        "72": {
            "start": 744.44,
            "end": 751.06,
            "transcript": "Una aviukaqsaraq maaten ellangua inutaturluku."
        },
        "73": {
            "start": 751.06,
            "end": 764.36,
            "transcript": "Imumi nuna pikliartaitellrani kass'anek, yuut neqelget tungiinun ayagatullruut neqelgem. Cali pissuqcaarluteng up'nerkami yuilqumun ayagluteng."
        },
        "74": {
            "start": 764.36,
            "end": 774.48,
            "transcript": "Iliini upalriani qungurtangqelallruuq ciuneput qungumek angenrilngurmek-llu mikelnguum pianek pitangqerraqluni."
        },
        "75": {
            "start": 774.48,
            "end": 783.34,
            "transcript": "Tamatum nalliini tuqulriit amllellrunritut. Ikgetellruut. Cayaqlirluni tuqulriartanglallruuq."
        },
        "76": {
            "start": 783.34,
            "end": 790.98,
            "transcript": "Enemek-llu nepiameng ekelriamek niitellrunritua. Waniwa ilumun niitellrunritua."
        },
        "77": {
            "start": 790.98,
            "end": 798.12,
            "transcript": "Mat'um nalliini enek'egtaaraat kenrem piunrilaraa yugnek-llu tapuciaqluni."
        },
        "78": {
            "start": 798.12,
            "end": 806.54,
            "transcript": "Man'a alerquuteksupiaraqa ayagyuanun nutaan enek'ameggnun itrarkanun cali mat'um kinguanun."
        },
        "79": {
            "start": 806.54,
            "end": 813.04,
            "transcript": "Unuakumi atakumi-llu Agayutmun qalarcaraulartuq."
        },
        "80": {
            "start": 813.04,
            "end": 817.94,
            "transcript": "Ca tamalkuan ikayungcautet qanrutkellua [?]."
        },
        "81": {
            "start": 817.94,
            "end": 824.0,
            "transcript": "Au͡gna tua-ll' tua-i imna aviukaqsaraq tekitaqa wani."
        },
        "82": {
            "start": 824.0,
            "end": 830.56,
            "transcript": "Sass'amek qungvagyugtua qaqiarrnayukluku."
        },
        "83": {
            "start": 830.56,
            "end": 836.54,
            "transcript": "Aviukaqsarak malruuguk."
        },
        "84": {
            "start": 836.54,
            "end": 848.06,
            "transcript": "Tamakut yuut yuilqumi tarritaqamta cavgura'urlurrlainarluta kesianek unateput-llu makut qerraraqluteng ukiluteng, ugaani-w' tua-i cavem."
        },
        "85": {
            "start": 848.06,
            "end": 856.82,
            "transcript": "Ayagyuarluta ikayuutelallruukut mikengramta cat teguyugngariaqamteggu angayuqamteńun."
        },
        "86": {
            "start": 856.82,
            "end": 863.92,
            "transcript": "Angayuqat takarnarqellriaruullruut qanellratnek nangurcugnaunani."
        },
        "87": {
            "start": 863.92,
            "end": 867.2,
            "transcript": "Mat'um nalliini irniarirtua."
        },
        "88": {
            "start": 867.2,
            "end": 875.16,
            "transcript": "Iliini qanelqa-llu maligtaqunripakarqatgu umyuaqa umyuarteq'lartuq waten."
        },
        "89": {
            "start": 875.16,
            "end": 883.84,
            "transcript": "Wangkuta-ggem imumi angayuqangqellemteńi aanangqellemteńi-llu, aanamta qanqallra nangurrsunaitellruuq."
        },
        "90": {
            "start": 883.84,
            "end": 894.84,
            "transcript": "Man'a qanrutkeqaraqa au͡gna aviukaqsaraq umyuaqutnguuq imkunun catairutlermun."
        },
        "91": {
            "start": 894.84,
            "end": 906.58,
            "transcript": "Waten tang aviukartullrulriit imkut yuut nunalleruarmun tekitaqameng qunguqartalegmun kituyuunaku, kiturluku ayayuunateng."
        },
        "92": {
            "start": 906.58,
            "end": 915.32,
            "transcript": "Tau͡gaam tauna arulairvikluku tuani inertullruut saanililuteng-llu neqkanek-llu tagulluteng."
        },
        "93": {
            "start": 915.32,
            "end": 931.1,
            "transcript": "Tua-i-ll' qungurraam taum ketiini nerqataameng tua-i pukeskanruarmek carraqunrayagarmek neqkateng tamakut ilangarqurluki nuna elakarluku waten."
        },
        "94": {
            "start": 931.1,
            "end": 939.06,
            "transcript": "Tuavet ek'arqaarluki neqkat qaqicata saayumek cali saaniigem imari kuvqerluku tuavet."
        },
        "95": {
            "start": 939.06,
            "end": 942.88,
            "transcript": "Tuaten-llu pirraarluku nutaan patuluku nerluteng."
        },
        "96": {
            "start": 942.88,
            "end": 944.62,
            "transcript": "Tamaa-i-gguq aviukaqluteng."
        },
        "97": {
            "start": 944.62,
            "end": 948.32,
            "transcript": "Ilii-wa cali aipaam aviukaqsaram."
        },
        "98": {
            "start": 948.32,
            "end": 959.46,
            "transcript": "Arnaq tegutaqami neqkamek carraquinrayagarmek cali teguqaulluni waten qulmun eg'artetullrua tua-i-llu-q' aviukaqluni."
        },
        "99": {
            "start": 959.46,
            "end": 962.98,
            "transcript": "Tang aviukaqsarat malruullrullinilriit."
        },
        "100": {
            "start": 962.98,
            "end": 967.5,
            "transcript": "Ava-i man'a nalluyagutelqa neq'angaqa."
        },
        "101": {
            "start": 967.5,
            "end": 976.84,
            "transcript": "Irr'ilallruama teguqaulluteng waten qulmun eg'artaqatgu aviukaqluteng-gguq tua-i."
        },
        "102": {
            "start": 976.84,
            "end": 984.9,
            "transcript": "Imumi tang yuut tarrinrullrulriit uitaurayuunateng."
        },
        "103": {
            "start": 984.9,
            "end": 992.82,
            "transcript": "Anguarturange'rmeng cavgurange'rmeng-llu uksuiyarrlainarluteng up'nerkiyarrlainarluteng-llu."
        },
        "104": {
            "start": 992.82,
            "end": 996.8,
            "transcript": "Tamana atutullruat au͡gkut imkut yuut."
        },
        "105": {
            "start": 996.8,
            "end": 1004.04,
            "transcript": "Nunat-llu ukut nunallrutellriatun yuiqapiarluki yuilqumun ayagaqluteng."
        },
        "106": {
            "start": 1004.04,
            "end": 1011.16,
            "transcript": "Tau͡gaam tua-i pisciigatqapigtellria aulukestekarluni tuavet unicetullruut."
        },
        "107": {
            "start": 1011.16,
            "end": 1022.02,
            "transcript": "Caqerluta upagtukut up'nerkami, aanaka tua-i ilakluku wangkuta alqaqa-llu, ilangqellruukut au͡g'umek arnassagarmek."
        },
        "108": {
            "start": 1022.02,
            "end": 1031.38,
            "transcript": "Piyuatung'e'rmi inglua nalamaluni, unatai-llu tamalkuuvkenateng, waten cetamanek unaterluni."
        },
        "109": {
            "start": 1031.38,
            "end": 1034.74,
            "transcript": "Tauna aanama auluk'lallrua."
        },
        "110": {
            "start": 1034.74,
            "end": 1048.52,
            "transcript": "Tauna aanama elitnaullruanga taumek mingeqluku, aklullrai mingeqluki kituggluki payuggnguarluku tuaten wangkuta neqkarramteńek ilarraitnek."
        },
        "111": {
            "start": 1048.52,
            "end": 1055.6,
            "transcript": "Tang man'a cali assilriarulria ikayuqularaq yugnek [?]."
        },
        "112": {
            "start": 1055.6,
            "end": 1067.22,
            "transcript": "Arnaulriani aanaulriani man'a irniamteńun cat tamalkuan nallunricetnarqerput [?], nallunricetnarqelliniarput."
        },
        "113": {
            "start": 1067.22,
            "end": 1073.98,
            "transcript": "Waniwa ukaqvanek au͡g'umek ciuqliliraqa kallugtangenrakun."
        },
        "114": {
            "start": 1073.98,
            "end": 1085.8,
            "transcript": "Kalluum mat'um amlleq navguraa, amta-llu wangkutni assiqapiarluni nep'ut-llu kaminiarput kumaluni kallugkun."
        },
        "115": {
            "start": 1085.8,
            "end": 1099.68,
            "transcript": "Tau͡gaam ikayurtekarput nallunritarput ellam iluani tamamta qanruqu'urrlainarnaqluni."
        },
        "116": {
            "start": 1099.68,
            "end": 1107.04,
            "transcript": "Mat'umek qaneryuglua qanertua pitsaqlua."
        },
        "117": {
            "start": 1107.04,
            "end": 1117.9,
            "transcript": "Irniama imkut tut'gararugama-llu takuatni makunek nerevkaraqamki qalartelartua, qalartelaryaaqua."
        },
        "118": {
            "start": 1117.9,
            "end": 1122.5,
            "transcript": "Qanruciyuitnilua ciutegemkun niitelartua."
        },
        "119": {
            "start": 1122.5,
            "end": 1125.38,
            "transcript": "Tua-i waten pitalliniuq."
        }
    },
    "tIpwFwFE3HU": {
        "1": {
            "start": 44.7,
            "end": 50.96,
            "transcript": "Una wani pikput can'giirnek angussaagyarauguq."
        },
        "2": {
            "start": 50.96,
            "end": 63.22,
            "transcript": "Pau͡gna wani nunapiim caranglluum-llu qainga tangellra ungvalriartangqerpakanrilngat'laryaaquq cavakalriartaunani-llu."
        },
        "3": {
            "start": 63.22,
            "end": 81.02,
            "transcript": "Tau͡gaam yuk murilkelluni piaqami nataqut'lartuq unguvalrianek tamaani uitalrianek unguvatkaminek tamatum nunapiim caranglluum-llu taitellranek."
        },
        "4": {
            "start": 81.02,
            "end": 102.06,
            "transcript": "Andrew Tsikoyak (Ciquyaq) una allrakunguq yuinarnek cetamaunrita'arnek (80) tamaani-llu unguvallruluni tua-i unguvarem taktaciatun elilluku nunam tamatum neqkangnaquteksarai."
        },
        "5": {
            "start": 102.06,
            "end": 118.32,
            "transcript": "Tua-i-ll' cali makut imkut luqruuyiit ayaggaarluteng utertaqata nutaan cangnairulluni."
        },
        "6": {
            "start": 118.32,
            "end": 126.04,
            "transcript": "Alingluteng can'giiret iirluteng tayima carangllugmi."
        },
        "7": {
            "start": 126.04,
            "end": 140.64,
            "transcript": "Luqruuyiit tau͡gaam piluteng cangyuirulluteng-llu ukut, tau͡gaam manatgun pituluteng."
        },
        "8": {
            "start": 140.64,
            "end": 146.7,
            "transcript": "Tua-i nutaan catairutetuut can'giiret kiagpak."
        },
        "9": {
            "start": 146.7,
            "end": 158.5,
            "transcript": "Maani tau͡gaam caarrlugni qalriaqaqutuluteng mecarrluteng caranglluut akuliitnek."
        },
        "10": {
            "start": 158.5,
            "end": 174.54,
            "transcript": "Nutaan-llu cali ava-i pinariameng catairucan alingenriameng atrarluteng atrarvingqerraqameng."
        },
        "11": {
            "start": 174.54,
            "end": 191.6,
            "transcript": "Waten-am meq uksuarmi ikgetaqan atrarciigatetulliniut imutun neq'ngevkenani man'a, ukut-llu neq'ngevkenani."
        },
        "12": {
            "start": 191.6,
            "end": 199.7,
            "transcript": "Puglirnerem tumaunaki tayima tamaanlluteng."
        },
        "13": {
            "start": 199.7,
            "end": 210.86,
            "transcript": "Uksuar, up'nerkami pugletulim nunam aciani carr'ilqurrini-llu uitaluteng."
        },
        "14": {
            "start": 210.86,
            "end": 221.14,
            "transcript": "Tamaa-i tamaaken neq'ngelartuq uksuarmi."
        },
        "15": {
            "start": 221.14,
            "end": 235.06,
            "transcript": "Alingluteng-wa tamakunek luqruuyagnek manignanek-llu qimalaameng neryuiceteng."
        },
        "16": {
            "start": 235.06,
            "end": 252.1,
            "transcript": "Tua-i-llu uksuarmi avaken anelrianek mengliinek caarrlugnek puglerneret akuliitnek anelrianek neqengqelartuq una."
        },
        "17": {
            "start": 252.1,
            "end": 256.76,
            "transcript": "Man'a maa-i ukatmun carvanirtuq."
        },
        "18": {
            "start": 256.76,
            "end": 266.3,
            "transcript": "Tua-i mumigcuunani ul'aqan tau͡gaam iliini ukatmun carvaniqaqluni."
        },
        "19": {
            "start": 266.3,
            "end": 283.14,
            "transcript": "Tua-i-llu imkut neqet cali can'giiret unegken caarrlugnek anellret kuicuarteggun asgurluteng maaggun."
        },
        "20": {
            "start": 283.14,
            "end": 290.1,
            "transcript": "Uum mengliikun iterluteng utercameng-llu wavet cangtauluteng."
        },
        "21": {
            "start": 290.1,
            "end": 294.66,
            "transcript": "Can'giiret makut cangtaulartut taluyatgun."
        },
        "22": {
            "start": 294.66,
            "end": 303.58,
            "transcript": "Taluyat-llu makut piliaqumaaqluteng ernerni malrugni wall'u-llu unugni-llu malrugni."
        },
        "23": {
            "start": 303.58,
            "end": 315.56,
            "transcript": "Taluyat makut pilimalartut unarcianek cali-llu kevraartut acilqurritnek."
        },
        "24": {
            "start": 315.56,
            "end": 335.8,
            "transcript": "Painga, una waniw', una iqtutacia waten, cuqluku iliini-ll' kiturluku angluki piyugaqameng."
        },
        "25": {
            "start": 335.8,
            "end": 346.76,
            "transcript": "Tua-i nutaan caliaqluki cikiqii nemrulluki."
        },
        "26": {
            "start": 346.76,
            "end": 358.6,
            "transcript": "Tamakunun unavet tua-i maa-i makut elliurluki ciumek."
        },
        "27": {
            "start": 358.6,
            "end": 370.56,
            "transcript": "Nutaan-llu qaqican man'a nutaan elliluku waken ayagluku."
        },
        "28": {
            "start": 370.56,
            "end": 377.06,
            "transcript": "Waniw' taktacia. Waken usguluku cali."
        },
        "29": {
            "start": 377.06,
            "end": 385.74,
            "transcript": "Alla-ll' cali wavet nangluni. Maa-i-ll' cali ayagluni waniwa-ll' nangluni."
        },
        "30": {
            "start": 385.74,
            "end": 397.08,
            "transcript": "Taktuaqapigmek piyuunateng pikiurturarraarluteng pituut."
        },
        "31": {
            "start": 397.08,
            "end": 409.32,
            "transcript": "Tua-i nutaan wii makut caliaqelaranka atakugni malrugni."
        },
        "32": {
            "start": 409.32,
            "end": 427.32,
            "transcript": "Tua-i makut-llu cali pinarian makut quutekaniirturluki makut nemrulluki."
        },
        "33": {
            "start": 427.32,
            "end": 435.62,
            "transcript": "Pingaqan malruuluki pirraarluki maa-i ayimtaqluku ilangarqurluki."
        },
        "34": {
            "start": 435.62,
            "end": 443.0,
            "transcript": "Pinarian-llu waniw' nemerluki uumek."
        },
        "35": {
            "start": 443.0,
            "end": 451.8,
            "transcript": "Tua-i-llu call' nemrraarluki murak canaluku cingigluku."
        },
        "36": {
            "start": 451.8,
            "end": 462.28,
            "transcript": "Qama-i alaunani murak gguun kapulluku waniwa una au͡g'aryairtelkucirluku."
        },
        "37": {
            "start": 462.28,
            "end": 465.28,
            "transcript": "Tua-i nutaan taqluteng."
        },
        "38": {
            "start": 465.28,
            "end": 472.42,
            "transcript": "Makut wani taluyat tumartellrit mulnganaqluteng, mulngakluteng pinarqut."
        },
        "39": {
            "start": 472.42,
            "end": 481.8,
            "transcript": "Qillertellrit-llu makut wani unarciat cali elisnganaqluni."
        },
        "40": {
            "start": 481.8,
            "end": 486.48,
            "transcript": "Epsalngutaunani-llu pinaqluni."
        },
        "41": {
            "start": 486.48,
            "end": 494.66,
            "transcript": "Waniw' una mat'um iqua."
        },
        "42": {
            "start": 494.66,
            "end": 505.44,
            "transcript": "Man'a tua-i waten nemiarun qupnengqertuq maaggun."
        },
        "43": {
            "start": 505.44,
            "end": 517.48,
            "transcript": "Tua-i-llu ingna iqua una imna, nauwa kassullra, cevvluku [?]."
        },
        "44": {
            "start": 517.48,
            "end": 521.74,
            "transcript": "Nutaan waten kegg'urluku."
        },
        "45": {
            "start": 521.74,
            "end": 535.4,
            "transcript": "Waten piurluku tua-i. Kegg'urluku."
        },
        "46": {
            "start": 535.4,
            "end": 548.64,
            "transcript": "Iquklican-llu tua-i wavet iqua elliluku gguun tegumiaqluku man'a, man'a petengmaaluni [?] avani."
        },
        "47": {
            "start": 548.64,
            "end": 556.22,
            "transcript": "Nutaan ayagnirluku waten tua-i uutun."
        },
        "48": {
            "start": 556.22,
            "end": 562.94,
            "transcript": "Waten tekermek cayugturluku."
        },
        "49": {
            "start": 562.94,
            "end": 578.24,
            "transcript": "Cali-ll' waten, waken pirraarluku, uuggun puggluku, nutaan wavet uuggun call' puggluku."
        },
        "50": {
            "start": 578.24,
            "end": 583.86,
            "transcript": "Gguun call' piluku, gguun puggluku ukatmurrluku."
        },
        "51": {
            "start": 583.86,
            "end": 592.92,
            "transcript": "Nutaan waten tua-i uumek teguurluki nemruqu'urluki."
        },
        "52": {
            "start": 592.92,
            "end": 597.86,
            "transcript": "Kiituan' tua-i imna nemiarun."
        },
        "53": {
            "start": 597.86,
            "end": 614.72,
            "transcript": "Waniw' nang'uq man'a, man'a nang'aqan maavet qupnermun aitararrluku kayimqerluku elliaqluku waten."
        },
        "54": {
            "start": 614.72,
            "end": 623.22,
            "transcript": "Nutaan-llu una iqua tapluku nemrulluku call' tapqulluku."
        },
        "55": {
            "start": 623.22,
            "end": 637.74,
            "transcript": "Tua-i waten ava-i kiituan' tungitellerkaatnun elliameng uumek call' cing'urluku uumek."
        },
        "56": {
            "start": 637.74,
            "end": 641.4,
            "transcript": "Waten tua-i nemruqu'urluku."
        },
        "57": {
            "start": 641.4,
            "end": 647.7,
            "transcript": "Taluyam yaani iquani quutellrani ukinerrartangqertuq."
        },
        "58": {
            "start": 647.7,
            "end": 656.18,
            "transcript": "Una wani ukinerraq muragmek cingigcimalriamek kevilaraat mingquterpagtun ayuqluni."
        },
        "59": {
            "start": 656.18,
            "end": 676.16,
            "transcript": "Taum wani, tauna wani mingquterpagngalnguq makut-llu allat cali taluyam aklui pilimalartut canarturluki makutgun pilissuutaitgun,"
        },
        "60": {
            "start": 676.16,
            "end": 681.64,
            "transcript": "taluyanek calissuutmegteggun."
        },
        "61": {
            "start": 681.64,
            "end": 688.88,
            "transcript": "Waniwa una makut taqsuutiit."
        },
        "62": {
            "start": 688.88,
            "end": 696.12,
            "transcript": "Tua-i una waniw' cavik una."
        },
        "63": {
            "start": 696.12,
            "end": 702.96,
            "transcript": "Forty-five-am nuniini piurtellruuq."
        },
        "64": {
            "start": 702.96,
            "end": 707.02,
            "transcript": "Waten iqtutaurallruyaaquq nuuga."
        },
        "65": {
            "start": 707.02,
            "end": 714.54,
            "transcript": "Waniw' nang'uq aturturluku."
        },
        "66": {
            "start": 714.54,
            "end": 721.5,
            "transcript": "Tua-i waten pitariluni nangluni maa-i atussiyaaksailan."
        },
        "67": {
            "start": 721.5,
            "end": 743.04,
            "transcript": "Una-llu epua imkut tuntut, nulirtem qunguturaullratni, nulirtem cirunra enqellria waniwa."
        },
        "68": {
            "start": 743.04,
            "end": 751.46,
            "transcript": "Nauw' cali, waniw' un' qupurcuutii."
        },
        "69": {
            "start": 751.46,
            "end": 765.24,
            "transcript": "Waniwa tua-i una waten piluku qupurluku man'a ukilluku. Una tua-i waten."
        },
        "70": {
            "start": 765.24,
            "end": 778.68,
            "transcript": "Nutaan-am cali taqngan, uumek waniw' cakilluku."
        },
        "71": {
            "start": 778.68,
            "end": 783.24,
            "transcript": "Waten muragmun piluku."
        },
        "72": {
            "start": 783.24,
            "end": 793.3,
            "transcript": "Waniw' tua-i taqsuutii cali cat. Makut-llu."
        },
        "73": {
            "start": 793.3,
            "end": 802.02,
            "transcript": "Tamakut makut qupurcuutait unarciat."
        },
        "74": {
            "start": 802.02,
            "end": 806.78,
            "transcript": "Maa-i tua-i calissuutait makut taluyat."
        },
        "75": {
            "start": 806.78,
            "end": 827.06,
            "transcript": "Tua-llu ava-i au͡gna cali ukuk waten makunek waten canauralleq."
        },
        "76": {
            "start": 827.06,
            "end": 831.8,
            "transcript": "Waten tua-i piurluki, quaguurluki [?]."
        },
        "77": {
            "start": 848.94,
            "end": 859.02,
            "transcript": "Maa-i makut waten piurluki pikiurallret makut, maa-i."
        },
        "78": {
            "start": 859.02,
            "end": 867.04,
            "transcript": "Tua-i-llu canaurallermini ukuk cali nanglutek."
        },
        "79": {
            "start": 867.04,
            "end": 882.96,
            "transcript": "Tua-i ukiqataagnek nutaan cali-am ukugnek allua, all'uteng waten atutuit."
        },
        "80": {
            "start": 882.96,
            "end": 894.78,
            "transcript": "Tua-i wavet qillerrluki waten."
        },
        "81": {
            "start": 894.78,
            "end": 910.56,
            "transcript": "Nutaan-llu waten canaluta. Nutaan akngirtevkenata canaluta assirluteng."
        },
        "82": {
            "start": 910.56,
            "end": 926.24,
            "transcript": "Tua-i nutaan cali makunek waten tamalkuuluni pillranek, kenimaluki tau͡gaam."
        },
        "83": {
            "start": 926.24,
            "end": 937.0,
            "transcript": "Waten uumek cetqerraarluki, keggluki qup'urluki tua-i munarcaar[luki] assircaarluki."
        },
        "84": {
            "start": 937.0,
            "end": 944.84,
            "transcript": "Ukuk tua-i waniw' nayumiqastek makulissuutek."
        },
        "85": {
            "start": 944.84,
            "end": 952.86,
            "transcript": "Tua-i waten iqlutmurtaqan ukatmurtaqan pilriani assiriaqluni."
        },
        "86": {
            "start": 952.86,
            "end": 965.0,
            "transcript": "Ukatmun-llu call' piami assiriluni qukarturluni tua-i qup'urluni waten tua-i ayuqluteng makutun."
        },
        "87": {
            "start": 965.0,
            "end": 972.4,
            "transcript": "Muraunge'rmek-llu cali elngulriit."
        },
        "88": {
            "start": 972.4,
            "end": 982.4,
            "transcript": "Tua-i una cataicunaituq waten piarkauluni, piliarkauluni."
        },
        "89": {
            "start": 982.4,
            "end": 1002.7,
            "transcript": "Cali-llu ayagniqarraallermini ciuqlikacaarmi tua-i caknernaqluni, tua-i waten-llu tungitellrat caknernaqluni pisciiganani."
        },
        "90": {
            "start": 1002.7,
            "end": 1010.24,
            "transcript": "Nutaan-llu elitellrian uumikuani qacignaqluteng piluteng."
        },
        "91": {
            "start": 1010.24,
            "end": 1018.4,
            "transcript": "Kiituani tua-i qacignariut caknernairulluteng."
        },
        "92": {
            "start": 1018.4,
            "end": 1022.56,
            "transcript": "Uum wani Andrew Tsikoyam taluyirvia una."
        },
        "93": {
            "start": 1022.56,
            "end": 1027.74,
            "transcript": "Angunaq'lalliniuq allrakuni au͡gkuni amllerni."
        },
        "94": {
            "start": 1027.74,
            "end": 1040.06,
            "transcript": "Waten taluyarvigkameggnek yuaraqameng, man'a wani elisngaluku taringumaluku-llu can'giiret piciryarait pinaqliniut."
        },
        "95": {
            "start": 1040.06,
            "end": 1048.38,
            "transcript": "Tamakut-llu kinguvarcimaluteng avaken ciuliameggnek ayagluteng."
        },
        "96": {
            "start": 1048.38,
            "end": 1055.68,
            "transcript": "Kuik man'a kautuaraqluku."
        },
        "97": {
            "start": 1055.68,
            "end": 1067.16,
            "transcript": "Taluyat nekaat muragmek kautuaraqluku qaill' et'utacia."
        },
        "98": {
            "start": 1067.16,
            "end": 1083.16,
            "transcript": "Tua-i tau͡gaam assirarkaugaqan tua-i yuvrirluku tuavet nutaan civvluki makut eniitnek yuvrirturluku."
        },
        "99": {
            "start": 1083.16,
            "end": 1105.34,
            "transcript": "Cali-llu kuigem ceńiinun nugtarteqataquniki cali kautuarluku assilria tua-i aciqvanun et'uluni waten pilartuq."
        },
        "100": {
            "start": 1105.34,
            "end": 1118.22,
            "transcript": "Waten ceńami tua-i qaillun waten aciqsigtaarkauluni two foot piciqsugnarquq."
        },
        "101": {
            "start": 1118.22,
            "end": 1124.06,
            "transcript": "Aipaa-ll' avguluku it'ganrem wall'u it'ganeq."
        },
        "102": {
            "start": 1124.06,
            "end": 1137.0,
            "transcript": "It'ganeq tau͡gaam avegluku pikuni cikucugluki nenglengkan man'a qenum nepucugluku."
        },
        "103": {
            "start": 1137.0,
            "end": 1150.9,
            "transcript": "Tua-i elakaniraqluku una nekaat, una keluat assiriluku qanikciurutkun carrirluku."
        },
        "104": {
            "start": 1150.9,
            "end": 1158.2,
            "transcript": "Civqaarluki-llu cikuliurutmek kautuarturluki."
        },
        "105": {
            "start": 1158.2,
            "end": 1166.76,
            "transcript": "Waten tua-i tusngataciat keluat-llu yuvrirturluku."
        },
        "106": {
            "start": 1166.76,
            "end": 1182.12,
            "transcript": "Tua-i-ll'-gguq qerratanrilkuni tua-i man'a keluat assirarkauluni tua-i neqengqerqan cangyugarkauluni."
        },
        "107": {
            "start": 1182.12,
            "end": 1193.8,
            "transcript": "Tua-i tau͡gken qerratacuayaarquni una waten cangyuillruluni."
        },
        "108": {
            "start": 1193.8,
            "end": 1201.32,
            "transcript": "Tau͡gaam tua-i kautuarturallerkun tua-i yuvrirturluki."
        },
        "109": {
            "start": 1201.32,
            "end": 1214.96,
            "transcript": "Makut nutem taluyat muragnek pilimalriit arcaqerluteng atulartut pavani Akulmi, Akulmiut yuitgun."
        },
        "110": {
            "start": 1214.96,
            "end": 1225.88,
            "transcript": "Makut wani caviyagaat atulaqait maa-i unairucugluteng allrakum ataucim kinguani."
        },
        "111": {
            "start": 1225.88,
            "end": 1233.58,
            "transcript": "Cali-llu cangyuvakarpek'nateng-wa muragcetun makucetun."
        },
        "112": {
            "start": 1233.58,
            "end": 1240.48,
            "transcript": "Can'giiret amlleqata makut taluyateng yuvrilarait unuaquaqan."
        },
        "113": {
            "start": 1240.48,
            "end": 1251.7,
            "transcript": "Amta-llu cangyuvakanripakarqata iliikun ernerni malrugni wall' pingayuni takuaqluki."
        },
        "114": {
            "start": 1251.7,
            "end": 1259.54,
            "transcript": "Assikaat tua-i tamarmeng yuut can'giiq."
        },
        "115": {
            "start": 1259.54,
            "end": 1269.36,
            "transcript": "Uksurqan tua-i pissurturluteng tamarmeng kuiget ceńaitnun."
        },
        "116": {
            "start": 1269.36,
            "end": 1289.52,
            "transcript": "Tamaa-i alerquatekellruaput-llu tan'gaurlurni ciuqlimteńek ayuqucirtuuteku'urluku tua-i elitnaurturluta qalarulluta qanerkut."
        }
    },
    "-Pc_Taab9Qo": {
        "1": {
            "start": 28.34,
            "end": 41.38,
            "transcript": "Urutaq yuurtellruuq Qaaritaarviim erenri qulngurtellratni 1914-aami uksuyallerrmeggnun ayallermeggni Nunapicuarmiut yaaqsinrilkiitni."
        },
        "2": {
            "start": 41.38,
            "end": 51.4,
            "transcript": "Anglillruuq Nunapicuarni nunakluku-llu up'nerkianritaqameng uksuiyanritaqameng-llu nasaurluullermini,"
        },
        "3": {
            "start": 51.4,
            "end": 57.28,
            "transcript": "uingellruuq George Beaver-aamek Yugcetun aterluni Anguksuarmek."
        },
        "4": {
            "start": 57.28,
            "end": 73.72,
            "transcript": "Anguksuaraam amauraa atamikun Mamterillermiut piurteqarraallratni ilakellruat ciuqliit yuut nunaksagutellratgu, taum-llu-gguq arnam enii ciuqliullruluni."
        },
        "5": {
            "start": 73.72,
            "end": 82.48,
            "transcript": "Anguksuaraankuk-gguq Urutaq-llu irniangqellruuk akimiarunrita'arnek, tau͡gaam-gguq malrunelgen yuunrillruut."
        },
        "6": {
            "start": 82.48,
            "end": 93.2,
            "transcript": "Tamalkuita irniani Urutam ikayuunani ellminek yuurtevkallrui, malruk tau͡gaam naulluuvigmi yuurtellrulutek."
        },
        "7": {
            "start": 93.2,
            "end": 102.84,
            "transcript": "Uinga Anguksuar yuunrillruuq ak'araurrluni ellup'illra [?], unilluki amlleret tutgarani iluperani-llu."
        },
        "8": {
            "start": 102.84,
            "end": 114.76,
            "transcript": "Taukut mikelnguut Urutam pililarai atu'urkaitnek matangqavkayuunaki, cali-llu irniari aipait-llu akluliaqluki."
        },
        "9": {
            "start": 114.76,
            "end": 123.76,
            "transcript": "Avatiitni mingqiilallmi kenilallran cali-llu aulukuralallminek ilaminek agayuyarturalartuq."
        },
        "10": {
            "start": 123.76,
            "end": 133.16,
            "transcript": "Moravian-aani agayuyalartuq kiimi-llu aturpagaqluni kalikanek tangvanrilnge'rmi umyuamikun tau͡gaam."
        },
        "11": {
            "start": 133.16,
            "end": 142.52,
            "transcript": "Agayun-gguq cacestuqutek'laraa [?] atungssaaraqluni-llu-gguq neqkiuraqami wall'u mingpaqami."
        },
        "12": {
            "start": 147.52,
            "end": 159.55,
            "transcript": "Nassaurluullemni qaillun tayim' angtalua pisia miklua? Im' iciw' museum-aani yaaruicetangqellria imkunek muragnek."
        },
        "13": {
            "start": 159.55,
            "end": 169.12,
            "transcript": "Taum [?] nallunritai imkut yaaruissuutet cali tua-i caliyaraq tamaa-i-ggun wiinga elitnaullrulliniaqa."
        },
        "14": {
            "start": 169.12,
            "end": 176.32,
            "transcript": "Yaaruyunqepiallruunga nasaurluullemni unuakumi tua-i aanama pilugaqanga."
        },
        "15": {
            "start": 176.32,
            "end": 183.91,
            "transcript": "Tua-i-ll atkuama imna yaaruitka waten curum aciani uitauralria atakum' itraqama."
        },
        "16": {
            "start": 183.91,
            "end": 193.52,
            "transcript": "Tuavet elliqatukeka tua-i-ll' unuakumi anqataama egmian piluganga yaaruitka imna teguqerluku anlua ellamun."
        },
        "17": {
            "start": 193.52,
            "end": 205.8,
            "transcript": "Qanikcanrrar qaninerraar manigpak iquanek ayaglua yaaruilua calingualalrianga pilugulinguarlua."
        },
        "18": {
            "start": 205.8,
            "end": 214.94,
            "transcript": "Atkulinguarlua tua-i cucukekemnek assikekenka elliluku yaaruigurlua."
        },
        "19": {
            "start": 214.95,
            "end": 227.3,
            "transcript": "Tamaa-i tang calinermek tamaaggun elitellrullrianga calingua, unatemkun calinguarturlua qanikcaam qaingani yaaruigurlua."
        },
        "20": {
            "start": 227.3,
            "end": 235.48,
            "transcript": "Tua-i caliyaurtua tamaaten imkut yaaruilua piliama ayuqait piliuryaurlua."
        },
        "21": {
            "start": 235.48,
            "end": 246.12,
            "transcript": "Tau͡gaam erenret amlleret aturluki mingquratung'e'rma Sunday-q tua-i kiingan uitayaraqluku."
        },
        "22": {
            "start": 246.12,
            "end": 257.4,
            "transcript": "Uitayaraqluku maqinermek atakumek ayaglua mingqa'arkanka tangerrsuumiirutaqluki tua-i-w' qessangllua, tua-i-w' taqsuqlua."
        },
        "23": {
            "start": 257.4,
            "end": 266.16,
            "transcript": "Taqsuqulluku week-ami mat'umi Monday-mek ayaglua yaavet Maqinermun mingqelalqa."
        },
        "24": {
            "start": 266.16,
            "end": 274.81,
            "transcript": "Pi, elitnauristengqellrulriaten-qaa mingqelallerpeni elitnauristengqelallruut?"
        },
        "25": {
            "start": 274.81,
            "end": 295.72,
            "transcript": "Elitnauristengqerpek'nii, tau͡gaam taum arnam (tangvagluki?), ii-i tangvagluki, arnam-llu taum ataucim waten nat'raliyaramek, kiingan elitnaullruanga, waten nat'raryaramek, teguaryaramek."
        },
        "26": {
            "start": 295.72,
            "end": 312.32,
            "transcript": "Ciuqlirmi assiinaki evungtaqluki [?], cali-llu tua-i wiinga aipangama aiparma calivkatullruanga,"
        },
        "27": {
            "start": 312.32,
            "end": 325.04,
            "transcript": "Wangnek tua-i canek calivkarlua, wiinga-llu nasaurluullruama tamaani, ellamcungqellruama-llu,"
        },
        "28": {
            "start": 325.04,
            "end": 334.33,
            "transcript": "Caliyuumiitetullruyaaqlua qiagaqlua-llu ugaani mingeqsuumiitun."
        },
        "29": {
            "start": 334.33,
            "end": 344.48,
            "transcript": "Mingqessaramek-qaa elitnaularilartuten maa-i, tua-i-w' kina mingqessaramek elitnaularan?"
        },
        "30": {
            "start": 344.48,
            "end": 359.41,
            "transcript": "Kina ayuqucirtularanka tau͡gaam elirqulluki-llu wangtun mingqessulriit caliyulriit yuut ayuqucirtuagaqluki tuaten pituniluki."
        },
        "31": {
            "start": 359.41,
            "end": 369.51,
            "transcript": "Kalikanek-llu elirqucirlua maa-i cali mat'um nalkengraaku qagaaken itellriit kalikaneglirqutnek [?] anulluteng anlartut."
        },
        "32": {
            "start": 373.15,
            "end": 381.3,
            "transcript": "Caliaqavet-qaa, tun'arkaten wall'u kitumun piliatun ayuqluki?"
        },
        "33": {
            "start": 381.3,
            "end": 400.19,
            "transcript": "Ayuqluki mingqetuanka qaill' umyuarteqsuitua canun tamaita, wangkutnun makunun-llu tun'arkamnun umyuarteqevkenii assinrungnaqluki-llu-gguq assiillrungnaqluki-ll' ukut piyuunii."
        },
        "34": {
            "start": 400.19,
            "end": 411.98,
            "transcript": "Tun'arkaqeng'? Tun'arkaqengqamki ayuqluki ilamell' [?] pikait ayuqluki calitun, qaill' umyuartequcuitanka allat pikait."
        },
        "35": {
            "start": 411.98,
            "end": 421.14,
            "transcript": "Naliit-mi piliarpet tua-i-w' tengrukenruluki pilarcit?"
        },
        "36": {
            "start": 421.14,
            "end": 436.22,
            "transcript": "Makut wani pilianka irugnun atkuk-llu ciumek tengrukenrularanka maqar', yuum watua temiini mat'um pengegnailutkai assirluni atullerkait."
        },
        "37": {
            "start": 436.22,
            "end": 439.98,
            "transcript": "Atuungata. Atuungata."
        },
        "38": {
            "start": 439.98,
            "end": 448.97,
            "transcript": "Tamaita makut, makut tengrukenrularanka maqarqutkait."
        },
        "39": {
            "start": 453.07,
            "end": 462.2,
            "transcript": "Mingqelallren-qaa aanavni mingqelallren ayuqenritlilria, aanavet mingqelallratun?"
        },
        "40": {
            "start": 462.2,
            "end": 468.99,
            "transcript": "Canek ellii allanek maa-i pililallrullill' wall'u-q', allanek-llu melqunek aturluni?"
        },
        "41": {
            "start": 468.99,
            "end": 483.2,
            "transcript": "Yaa, melqunek aturluni atkulitullruuq ayuqucirtuqaraqsaullrua-ll' wiinga piqarraallemni, atkuliyaurteqarraallemni-wa."
        },
        "42": {
            "start": 483.2,
            "end": 488.54,
            "transcript": "Qaralilirillrami maa-i atularan elliin pilallran?"
        },
        "43": {
            "start": 488.54,
            "end": 502.16,
            "transcript": "Pilallra tua-i atularaqa maa-i, (qaralilirai) qaralilirai ayuqluki tua-i qaralilirilartua, tau͡gaam assinrungataqluteng teguyararkalingruama."
        },
        "44": {
            "start": 502.16,
            "end": 508.09,
            "transcript": "Maa-i elpet? Ii-i. Amllenruluteng aturarkaten cat ayuqenrilnguut."
        },
        "45": {
            "start": 508.09,
            "end": 518.16,
            "transcript": "Cat-wa teguteguarqanka amllenruluteng ayuqenrilnguut. Aanavet pilallrini ayuq' amllenruluteng? Amllenruluteng."
        },
        "46": {
            "start": 520.12,
            "end": 528.74,
            "transcript": "Imna kitek' qanrutkeqaqerru iciw' ilait ilakellriit-llu qaralingqelallrullinilriit allakarmek?"
        },
        "47": {
            "start": 528.74,
            "end": 548.54,
            "transcript": "Yaa, nunat-wa tua-i. Atam nunat ilait atkungqetullruut-llu Qagkumiutarnek watua Kuigpagmiutarnek qantullrulriit atkunek, ava-i imkunek maaggun qaralilegnek."
        },
        "48": {
            "start": 548.54,
            "end": 561.24,
            "transcript": "Iciw' maa-i maaggun-am pingelriit tumaqcanek-llu qaralilirluki piaqluteng. Tamaa-i-gguq tamakut tumarcauyuitellrucet'raarautullruut [?] tau͡gaam Kuigpagmiutaat."
        },
        "49": {
            "start": 561.24,
            "end": 571.92,
            "transcript": "Waniwa-llu, waniwa-llu una wani agngirarkaqa [?] taqumalria, Ukurram un' atkuliaqa."
        },
        "50": {
            "start": 571.92,
            "end": 585.56,
            "transcript": "Peyalem [?] nulirranek makut-gguq maa-i Qagkumiutaat, Kuigpagmiutaat, waten nacalget ukirnek."
        },
        "51": {
            "start": 585.56,
            "end": 591.47,
            "transcript": "Tauna-qaa tua-i elpeci ilakellriani qaraliqenrilng'e'rpet?"
        },
        "52": {
            "start": 591.47,
            "end": 607.64,
            "transcript": "Qaraliqenrilngamku assikngamku waniw' una piaqa, ukunun ilamnun atkuliaqa man'a ayuqluki waten qaralilirluki."
        },
        "53": {
            "start": 607.68,
            "end": 631.64,
            "transcript": "Imkut ukurranka ukut atauciq tau͡gaam pamna au͡g'um nulirra uum aliimategyuagnek piliarkaugaqa cali piliksaitaqa, ukut ukurranka qaqitengyaaqanka maa-i una waniw' calim nulirram qak'um atkua, alngigarqanka una pegeskunun [?]"
        },
        "54": {
            "start": 631.64,
            "end": 643.54,
            "transcript": "Qaraliqenrilngerpet, qaraliqaqluki piyullerpeni? Assikekenka piaqluki. Yaa ayuqeliaqluki."
        },
        "55": {
            "start": 643.54,
            "end": 650.46,
            "transcript": "Nunat tau͡gaam maa-i call' ilait qaraliit ayuqenrit'laryugnarqut, qagaani wall' maani-qaa?"
        },
        "56": {
            "start": 650.46,
            "end": 659.16,
            "transcript": "Ayuqenritut. Qagkumiut-llu tua-i ayuqenritut atam tua-i cait akluit."
        },
        "57": {
            "start": 659.16,
            "end": 664.14,
            "transcript": "Angutet-mi angutet qaraliit, arnat-llu qaraliit ayuqevkenateng?"
        },
        "58": {
            "start": 664.14,
            "end": 670.48,
            "transcript": "Angutet qaraliit atkuit ayuqenritut angutet, arnartartun ayuqsuitut."
        },
        "59": {
            "start": 670.48,
            "end": 672.4,
            "transcript": "Qaillun ayuqevkenateng?"
        },
        "60": {
            "start": 672.4,
            "end": 687.18,
            "transcript": "Ayuqetuut atam waten angutet atkuita kenugngalrianek angutet atkungqerraqamek, kenugngalrianek angun atkungqerquni ayuqeciquq akurluni,"
        },
        "61": {
            "start": 687.18,
            "end": 701.86,
            "transcript": "Ukugnegun-llu waten ulviinarrarmek [?] kangiani-wa pukirrar imna tua-i uluva-ggaq qatertungelria [?]"
        },
        "62": {
            "start": 701.86,
            "end": 709.96,
            "transcript": "Tua-i-ll maaggun alngarluni pingayun ukuk-wa call' alngak, kan'a-wa kanani atauciq alngaq."
        },
        "63": {
            "start": 709.96,
            "end": 718.66,
            "transcript": "Pamani-llu akiani cali ukalirneq, tauna manulirneq ukaqliuluni, pam'a-ll' ukaqliuluni."
        },
        "64": {
            "start": 718.66,
            "end": 729.11,
            "transcript": "Tua-i-ll' tunua ayuqeqami ulviinam pamyua ukuk-wa alngak tunuani angutem tua-i kiingan tuaten alngarluki taukuk."
        },
        "65": {
            "start": 729.11,
            "end": 739.98,
            "transcript": "Waniwa-gguq una qaraliq imna tauna alngak wanelnguq nalkenrilkiini-llu ukalirnermi aipaa."
        },
        "66": {
            "start": 739.98,
            "end": 751.34,
            "transcript": "Au͡gkuk-gguq tua-i pitegcautnguak, pitegcautnguaq-gguq tua-i tauna pitgarluku yaaggun-llu anlluku."
        },
        "67": {
            "start": 751.34,
            "end": 760.98,
            "transcript": "Qaraliq-llu tua-i tauna kangingqetuq tuaten, pit'garuaranek pitukiitun alngaq."
        },
        "68": {
            "start": 760.98,
            "end": 773.92,
            "transcript": "Atam tua-i pingssaugut imkut yuut. Mikelngurtaasmi? Mikelngurtaat-ll' angutetaat tan'gaurlurrartayagaat tuaten ayuqiyagarluteng."
        },
        "69": {
            "start": 773.92,
            "end": 789.98,
            "transcript": "Angucetaayartun ayuqluteng? Yaa angucetaayartun ayuqluteng. Angutet imkut iciw' qanrutkeqallren akwaugaq, angutet cali allakarmeng, melqunek cali allakaumalrianek atutullrullinilriit-qaa? Yaa."
        },
        "70": {
            "start": 789.98,
            "end": 799.98,
            "transcript": "Angutet imkut tevyuuliit, caulriat ima, kanaqliit?"
        },
        "71": {
            "start": 799.98,
            "end": 810.13,
            "transcript": "Tua-i-wa una maa-i iciw' ava-i tevyulimek qanelriaten wangkuta kanaqlagnek pituaput, nunat atam ayuqenritut qaneryarait."
        },
        "72": {
            "start": 810.13,
            "end": 819.6,
            "transcript": "Ukut tevyulinek qanengtuluteng, ukut-llu kanaqlagnek."
        },
        "73": {
            "start": 819.6,
            "end": 833.98,
            "transcript": "Tunuitnek angutet atkuungqerraqluteng? Tunuitnek tevyulit angutet, tua-i angutet tunurrlainarnek atkungqerraqluteng, arnat-llu aqsarrlainarnek. Ii."
        },
        "74": {
            "start": 833.98,
            "end": 843.73,
            "transcript": "Tuar tang pit tau͡gaam qanganaat, arnat tau͡gaam atulaqait. Angutet-llu pituyaaqait."
        },
        "75": {
            "start": 845.98,
            "end": 854.98,
            "transcript": "Mingqellrit-wa makut wani amiit ayuqenritlallilrit, ilait cagniluki pinarqellilriit, ilait-llu cagni'?"
        },
        "76": {
            "start": 854.98,
            "end": 867.52,
            "transcript": "Atam amit makut mingqellrat assinrituq ilait, imkut atam raccoon-at keggaciqnarqut, qailiqnarqut, naulluutmek alairinarqut."
        },
        "77": {
            "start": 867.52,
            "end": 883.98,
            "transcript": "Ciin? Naam' elliin-wa tua-i qaill' ayuqngameng piat, kakiullrat-wa tua-i imkuami tevercilami, wiinga malrugqugnek raccoon-agnek atkuk pilillruunga."
        },
        "78": {
            "start": 883.98,
            "end": 894.98,
            "transcript": "Aipaqa unguvallrani piliaqluku, tuaten tang pillma kinguani mingqellma naullugaqlua qailiqerpaglua, ukuk-ll' akngirnaqluteng."
        },
        "79": {
            "start": 894.98,
            "end": 908.58,
            "transcript": "Tua-i tuaten piaqlua cali uuggun mernulaama una alairtaqluni tuaten raccoon-anek atkulellma kinguanek."
        },
        "80": {
            "start": 908.58,
            "end": 924.2,
            "transcript": "Ilait atam caliarkat qeciit makut imkut, naulluunaqelartut, kapullrit, nuqtallrit-llu."
        },
        "81": {
            "start": 924.2,
            "end": 935.2,
            "transcript": "Qacignaitut atam ilait cali makut unailicangnaqellrat irut makut, irut tua-i arcaqalartut tuntut iruit."
        },
        "82": {
            "start": 935.2,
            "end": 951.98,
            "transcript": "Cakviurluni makunek maa-i aturluta imkut tuntut iruit, reindeer-aat iruit caliaqelaraput cakviurluta tamalkuan kiiryugluta atauciin kaq'aqluta."
        },
        "83": {
            "start": 951.98,
            "end": 964.05,
            "transcript": "Taumek tua-i wiinga pilaqenka makut allat-llu-wa kipucuumitelaqait irut waten cakviurnarqellrat nallunrilamegteggun."
        },
        "84": {
            "start": 964.05,
            "end": 976.98,
            "transcript": "Wiinga tau͡gaam cakmiurnarqengraata ikayuutek'laamki caliaqelaranka makutgun, makutgun ellumerrluki."
        },
        "85": {
            "start": 980.12,
            "end": 983.57,
            "transcript": "Cakucinek-mi kelirluten pilarcit?"
        },
        "86": {
            "start": 983.57,
            "end": 1003.97,
            "transcript": "Kelilartua imkut tang yualukat nurnarillrulriit imumi, makut atam maa-i natranun, makut-wa tua-i maa-i natraliurcuutet waten qipluki, qipait, atam tamana yuvriqerr'u maa-i makut."
        },
        "87": {
            "start": 1003.98,
            "end": 1007.94,
            "transcript": "Naken man'a cauga Kass'artauguq?"
        },
        "88": {
            "start": 1007.94,
            "end": 1017.96,
            "transcript": "Tua-i-gguq tamaa-i ilngurliq [?] ak'allaq, ak'a imumi makurrlainarnek yualukautengqetullruut ilngurlinek [?]. Maa-i tang-am nurnariut."
        },
        "89": {
            "start": 1017.96,
            "end": 1034.98,
            "transcript": "Tuntut-llu uliutaitnek pau͡gkunek tunuita tuntut yualuitnek qip'iluta yualitullruukut, ukuk wavet-llu cali uumun amiliqertellranun nuvv'ikluki."
        },
        "90": {
            "start": 1034.98,
            "end": 1047.9,
            "transcript": "Amitqapiarluku qupqerraarluku tua-i-ll' mat'umun ilaulluku qipiurluku. Tua-i nucugciigacuunateng mingqulput amileng'e'rmeng."
        },
        "91": {
            "start": 1047.9,
            "end": 1060.29,
            "transcript": "Amuyularqellrianek? Amuyularqelrianek [?], atam ukullugnarqelartut amegciigalnguut."
        },
        "92": {
            "start": 1060.29,
            "end": 1064.96,
            "transcript": "Tuar tang imumi imumek, miilamek tungulriamek."
        },
        "93": {
            "start": 1064.98,
            "end": 1073.01,
            "transcript": "Aturluteng waten calaqait? Ii-i makut imkucituaput, tuaten."
        },
        "94": {
            "start": 1073.01,
            "end": 1079.58,
            "transcript": "Tua-i-q' tauna miilaq? Miilaq-wa tua-i waniwa."
        }
    },
    "KDMsKHYtx_U": {
        "1": {
            "start": 35.76,
            "end": 42.0,
            "transcript": "Nalluarci-qaa nertukut cuassaat maani naumalauciat?"
        },
        "2": {
            "start": 42.92,
            "end": 50.68,
            "transcript": "Amlleret aipaagni nunavciit canimelkiitni naulartut."
        },
        "3": {
            "start": 51.24,
            "end": 57.66,
            "transcript": "Makut amllernek tememun atuulrianek pinircautnek imangqertut."
        },
        "4": {
            "start": 57.74,
            "end": 63.42,
            "transcript": "Ciuliaput-llu pinircet'lallruluki [?]-aarugarni allrakuni."
        },
        "5": {
            "start": 65.12,
            "end": 71.84,
            "transcript": "Makunek allanek naunrarnek kipusvikarraat pingvailgata."
        },
        "6": {
            "start": 71.84,
            "end": 85.72,
            "transcript": "Amllertut nertutput naunraat wall'u maa-i paivngalriit akiinateng-llu aqvaqainauluteng."
        },
        "7": {
            "start": 86.0,
            "end": 99.52,
            "transcript": "Makussuquvet arvinlegnek allanek unangeciquten ciuqlikacaaq waniwa, ellacugniqegtaarmek yuuryiurluten."
        },
        "8": {
            "start": 99.52,
            "end": 105.2,
            "transcript": "Aipaa-wa temen pinircarluku."
        },
        "9": {
            "start": 105.2,
            "end": 112.72,
            "transcript": "Pingayuak, akiilngurnek atsanek cuassaanek-llu unangluten."
        },
        "10": {
            "start": 112.72,
            "end": 118.98,
            "transcript": "Cetamiit neryuumiitevkenak."
        },
        "11": {
            "start": 118.98,
            "end": 127.14,
            "transcript": "Tallimiit neqnek temevnun ikayuutnek unangluten."
        },
        "12": {
            "start": 127.14,
            "end": 132.4,
            "transcript": "Arvinelgat tau͡gaam arcaqalriamek."
        },
        "13": {
            "start": 135.68,
            "end": 143.2,
            "transcript": "Ilakucaramek tamana Yup'igni piciryaraqegtaaraqngamteggu."
        },
        "14": {
            "start": 144.68,
            "end": 152.1,
            "transcript": "Up'nerkami egmian ilaitnek cuassaat unatalartukut."
        },
        "15": {
            "start": 152.1,
            "end": 157.5,
            "transcript": "Una ciuqliq kapuukaraat."
        },
        "16": {
            "start": 159.8,
            "end": 169.82,
            "transcript": "Latin-aatun-wa atra Ranunculus pallasii Kass'atun-llu Pallas' buttercup."
        },
        "17": {
            "start": 169.82,
            "end": 185.42,
            "transcript": "Una mermi naumatuli kapuukarmek pilaraat maani nunamteńi, Kuigpagmi-llu kapuutnek, Kass'atun-llu ak'a atrapellrukek'a."
        },
        "18": {
            "start": 185.42,
            "end": 192.14,
            "transcript": "Nanvani uruni-llu nautuuq marami."
        },
        "19": {
            "start": 192.14,
            "end": 209.56,
            "transcript": "Kangraa mermi ugumalria tunguuq, iqua-llu cungagcenani camna-llu qaterluni mer'em acianelnguq."
        },
        "20": {
            "start": 209.56,
            "end": 214.78,
            "transcript": "Iliini qallerlirngataqluni acia."
        },
        "21": {
            "start": 214.78,
            "end": 221.62,
            "transcript": "Kangra cuyacuarangqertuq pingayupeggluni."
        },
        "22": {
            "start": 221.62,
            "end": 231.14,
            "transcript": "Naucetaangaqluni qaterrluteng, ilait-llu esirliuluteng."
        },
        "23": {
            "start": 231.14,
            "end": 243.82,
            "transcript": "Kapuukartelartukut nanvam terr'a cikuq anguarutmek keligluku wall'u agtaarluku."
        },
        "24": {
            "start": 243.82,
            "end": 252.78,
            "transcript": "Ayaruq, kapuukaraat-llu pugleqercata."
        },
        "25": {
            "start": 252.78,
            "end": 266.4,
            "transcript": "Atauciuqaqluki avurluki taugken urumi uitalriit nucugaarluki uru' pakigarraarluku."
        },
        "26": {
            "start": 266.4,
            "end": 279.3,
            "transcript": "Carrirluki qallaqaulluki cetyaarni tallimani imarkuamun."
        },
        "27": {
            "start": 279.3,
            "end": 288.44,
            "transcript": "Taqukiullermun yaquliullermun wall'u neq'liullermun suupamun-llu avuqluki."
        },
        "28": {
            "start": 290.16,
            "end": 297.6,
            "transcript": "Kesirrlainauluki-llu iliini nerluki uqumek ilaluki."
        },
        "29": {
            "start": 297.6,
            "end": 304.5,
            "transcript": "Kayangutullrem-llu qamanrani assipiartut cuassaaqluteng."
        },
        "30": {
            "start": 304.5,
            "end": 316.22,
            "transcript": "Yuurqaarauluteng-llu neqnirqut wall'u assaliqerluki Kass'artarnun kemegnun ilaksugngaut."
        },
        "31": {
            "start": 316.22,
            "end": 333.76,
            "transcript": "Qemagtellrit. Kapuukaraat puqlamek kuvqerraarluki wall'u qassauluki plastic-aamun ekluki cikutevkalaraput kumlivigmi."
        },
        "32": {
            "start": 333.76,
            "end": 345.38,
            "transcript": "Nitilim amatiikuani cepqerraartelluku kuik allat cuassaat naugaaralartut."
        },
        "33": {
            "start": 345.38,
            "end": 351.7,
            "transcript": "Angukaaq, Polygonum alaskanum, wild rhubarb."
        },
        "34": {
            "start": 351.7,
            "end": 365.04,
            "transcript": "Una cuassaaq kuiget ceńaitni wall'u nunami itumcimallermi nautuuq."
        },
        "35": {
            "start": 365.04,
            "end": 383.44,
            "transcript": "Angukaamek Kusquqvagmiut pilaraat, Kuigpagmiut-llu naucimek wall'u nak'amek, Kass'atun wild rhubarb-aaruuq."
        },
        "36": {
            "start": 383.44,
            "end": 389.68,
            "transcript": "Nalqigluni nautuuq cuyai uurtaagulluteng."
        },
        "37": {
            "start": 389.68,
            "end": 400.82,
            "transcript": "Cuyat qaingit manigceńateng, akmatait-llu melquyagangqerrnganateng."
        },
        "38": {
            "start": 400.82,
            "end": 413.76,
            "transcript": "Tamarmi cuyai temii-llu neqnguuq, Kass'artaam akucim cuyai neryuitait."
        },
        "39": {
            "start": 413.76,
            "end": 421.2,
            "transcript": "Angukaarculartukut cuyait waten amllertariqertaqata."
        },
        "40": {
            "start": 421.2,
            "end": 433.68,
            "transcript": "Kiagurtaqan naucetaangelartut qateryagcelngurnek, kangmegteggun quyungqalrianek."
        },
        "41": {
            "start": 433.68,
            "end": 448.08,
            "transcript": "Anipam iingatun qulait iqtunrulrianek angukaa tememun ikayuutnek vitamin A-aalirtut."
        },
        "42": {
            "start": 451.42,
            "end": 457.06,
            "transcript": "Vitamin C-aamek-llu cali imarluteng."
        },
        "43": {
            "start": 457.06,
            "end": 464.24,
            "transcript": "Ukuk ciissinek naulluunarqellrianek calugteńguuk."
        },
        "44": {
            "start": 464.24,
            "end": 474.2,
            "transcript": "Cali angukaa cuyait epuit-llu qassauluteng kenirluteng-llu neqnguut."
        },
        "45": {
            "start": 474.2,
            "end": 490.56,
            "transcript": "Akutaanun cakivqaarluki qiviqluki, wall'u uqumek avuluki caarraliqerluteng akutautuut."
        },
        "46": {
            "start": 490.56,
            "end": 498.6,
            "transcript": "Epuit-llu qeltairluki pie-auluteng cayunaitut."
        },
        "47": {
            "start": 498.6,
            "end": 504.96,
            "transcript": "Qassauluteng-llu epuit meciarluteng nernarqut."
        },
        "48": {
            "start": 504.96,
            "end": 524.2,
            "transcript": "Qemagtellrit. Ak'a tamaani kenirat angukaat puckanun ekraarluki talinermun elagyami iirluki piucitullruit."
        },
        "49": {
            "start": 524.2,
            "end": 528.92,
            "transcript": "Akertemek iirluki talilluki."
        },
        "50": {
            "start": 528.92,
            "end": 535.12,
            "transcript": "Maa-i tau͡gaam ekraarluki plastic-aanun."
        },
        "51": {
            "start": 535.12,
            "end": 543.22,
            "transcript": "Kumlivigmun qemagtelaraput atatakutaqluki."
        },
        "52": {
            "start": 543.22,
            "end": 557.16,
            "transcript": "Plastic-aanek tau͡gaam assigciraqavci elagyami uita'arkanek plastic-aanun qemarteksaunaki."
        },
        "53": {
            "start": 557.16,
            "end": 573.18,
            "transcript": "Imkunun tau͡gaam qaltautulinek menuilngurnek, unaitenrilngurnek assigcirluki."
        },
        "54": {
            "start": 573.18,
            "end": 587.88,
            "transcript": "Wall'u akercircetevkenaki talinermi uitavkarluki mamtulrianek plastic-aanek qaltautulinek assigcirluki."
        },
        "55": {
            "start": 587.88,
            "end": 601.82,
            "transcript": "Cuyaqsuut. Puukaryaqunaku tauna napa nalluarciqaa avaci tamarmi neqngucia."
        },
        "56": {
            "start": 601.82,
            "end": 616.36,
            "transcript": "Kuvyayaraqavci pissuryarluci wall'u angyarualriani wall'u piyuagurluci-llu yuilqumi kanga'arqavci."
        },
        "57": {
            "start": 616.36,
            "end": 623.98,
            "transcript": "Up'nerkaurtaqan kiagluni cuyaqsuut pugaaralartut."
        },
        "58": {
            "start": 623.98,
            "end": 634.86,
            "transcript": "Enrilnguam cuyaa, Salix alaxensis, felty willow leaf."
        },
        "59": {
            "start": 634.86,
            "end": 651.24,
            "transcript": "Ukut enrilnguam cuyaqai maani Alaska-m qaingani amllerrluteng naulartut cuyait, cungackegpek'nateng, qatevyaggluteng."
        },
        "60": {
            "start": 651.24,
            "end": 659.3,
            "transcript": "Uum felty willow leaf, taum cuyai tuaten ayuqut."
        },
        "61": {
            "start": 659.3,
            "end": 675.3,
            "transcript": "Waten pugaaralartut unataqraarluki uqumek mecirluki erenregni malrugni uitaqerceqaarluki iliini nerlaraput."
        },
        "62": {
            "start": 675.3,
            "end": 691.7,
            "transcript": "Wall'u amlleqvaarnek assigtanun cikunguanun ekiaqamta refrigerator-aam iluani uitayugngaut allrakurcarpiarluteng."
        },
        "63": {
            "start": 691.7,
            "end": 701.74,
            "transcript": "Tau͡gaam mumigtaarturluki uqumek kuv'allagpek'naki tau͡gaam mecirciucirluki."
        },
        "64": {
            "start": 701.74,
            "end": 711.56,
            "transcript": "Palurrluki wall'u cikunguaq uivvluku uitavkarraarluku iraluurtaqan mumigtaqluku."
        },
        "65": {
            "start": 711.56,
            "end": 717.04,
            "transcript": "Tamalkuita iluani cuyat meciisqelluki."
        },
        "66": {
            "start": 718.4,
            "end": 727.98,
            "transcript": "Tuatnarraarluki nerlaraput neqerrluarturraarluni assipiartut tapqellrat."
        },
        "67": {
            "start": 727.98,
            "end": 737.7,
            "transcript": "Ilaita suupamun avukelarait kinercirraarluki uqumek avunritaqamegteki."
        },
        "68": {
            "start": 737.7,
            "end": 749.58,
            "transcript": "Angliaqata amllerem neryuitai cuyat naurpangaqata cungagpagnirilaata."
        },
        "69": {
            "start": 749.58,
            "end": 763.04,
            "transcript": "Tau͡gaam August-aami taqtaqameng suupanun ingqiluteng ilakluteng cali assirmiut."
        },
        "70": {
            "start": 763.04,
            "end": 771.8,
            "transcript": "Uqvigaam cuyaa, salix pulchra, river willow leaf."
        },
        "71": {
            "start": 771.8,
            "end": 779.3,
            "transcript": "Una uqvigaat cuyaqaat au͡g'um ayuqevii."
        },
        "72": {
            "start": 779.3,
            "end": 789.64,
            "transcript": "June-ami unataqtuaput ilaita puckanun uqumek mecirluki piucituit."
        },
        "73": {
            "start": 789.64,
            "end": 797.8,
            "transcript": "Makut tamaita neqnun assirtut avukluteng kenirluki."
        },
        "74": {
            "start": 797.8,
            "end": 811.02,
            "transcript": "Ciuliamta eluciicetun cuyaqsugtulallruit napanek teguluki ner'aqluki."
        },
        "75": {
            "start": 811.02,
            "end": 824.22,
            "transcript": "Makut vitamin C-aalipiartut malrurqugnek amllenruluni saskam avgan imaa ataucimi orange-aami."
        },
        "76": {
            "start": 824.22,
            "end": 840.44,
            "transcript": "Cuassaat makut tamarmeng tememun ikayuutnek amllernek imangqerrameng ciuliaput palevkayuitellruit uksut tamaita ak'a imumi."
        },
        "77": {
            "start": 840.44,
            "end": 847.28,
            "transcript": "Quagciq, Rumex arcticus, sourdock."
        },
        "78": {
            "start": 847.28,
            "end": 849.8,
            "transcript": "Cauga una?"
        },
        "79": {
            "start": 853.26,
            "end": 859.42,
            "transcript": "Nall'artan Kass'atun sourdock-amek atengqertuq."
        },
        "80": {
            "start": 859.42,
            "end": 872.52,
            "transcript": "Qissunam avatiini-llu aatunamek pilaraat, Kuigpagmiut-llu kelugtaamek, wangkuta-llu quagcimek."
        },
        "81": {
            "start": 872.52,
            "end": 890.16,
            "transcript": "Tuar-qaa ciilqaaq? Ayuqsaaquk tau͡gaam quagcit cuyait epumeng caniatgun amllerrluteng naulartut."
        },
        "82": {
            "start": 890.16,
            "end": 897.84,
            "transcript": "Carraan-llu epuita qaingitni, wall' caniqerratni."
        },
        "83": {
            "start": 897.84,
            "end": 905.64,
            "transcript": "Kangrit-llu amllerrluteng qulmun nauluteng kavirceńateng."
        },
        "84": {
            "start": 905.64,
            "end": 918.16,
            "transcript": "Uruni kelugkaat can'get-llu akuliitni, kuiget, nanvat-llu cenaitni nautuut."
        },
        "85": {
            "start": 918.16,
            "end": 924.8,
            "transcript": "Naulartut nevumi qau͡gyaunrilngurmi."
        },
        "86": {
            "start": 924.8,
            "end": 937.04,
            "transcript": "Quagcit nernarqut kiagem taktaciatun enrirqameng tau͡gaam uungialiaqluteng."
        },
        "87": {
            "start": 937.04,
            "end": 947.64,
            "transcript": "Uungialiaqata tua-i qallarvalriamek iquarrluki kumlivillrat assirtuq."
        },
        "88": {
            "start": 947.64,
            "end": 958.96,
            "transcript": "Nutaan-llu uksumi anlluki cakivvluki yuurqaariluki wall'u akutaqluki."
        },
        "89": {
            "start": 958.96,
            "end": 969.68,
            "transcript": "Quagcit kenituit egatmun ekurluki mermek qallamalriamek mirluki."
        },
        "90": {
            "start": 969.68,
            "end": 982.1,
            "transcript": "Qallanguskaki-llu mumigtaaraqluki, tua-i-llu qallaulluki kenrikan-llu taggluku."
        },
        "91": {
            "start": 982.1,
            "end": 988.62,
            "transcript": "Akupallurluki quagcit nerlaraput, iliini-llu supamun teguqluki."
        },
        "92": {
            "start": 988.62,
            "end": 996.04,
            "transcript": "Tau͡gaam imumi qayussaalitullruit melugnek avuluki."
        },
        "93": {
            "start": 996.04,
            "end": 1006.36,
            "transcript": "Tau͡gaam ak'allaraat yuut nangellrat maliggluku qayussaliyaraq piunririinartuq."
        },
        "94": {
            "start": 1006.36,
            "end": 1018.02,
            "transcript": "Quagcit vitamin C-aamek, arvinlerkunek cipluki orange-aam ataucim imarkanranek caskam avgai imangqertuq."
        },
        "95": {
            "start": 1018.02,
            "end": 1028.74,
            "transcript": "Cali vitamin A-aalirluteng, uumek-llu mineral-aamek Kass'at aptukiitnek iron-aamek imarluteng."
        },
        "96": {
            "start": 1028.74,
            "end": 1041.82,
            "transcript": "Tamakut tememun egmianun naulluunailngurnek imangqertut, vitamin A C-yaaq, una-llu mineral-aaq, iron."
        },
        "97": {
            "start": 1041.82,
            "end": 1049.12,
            "transcript": "Ceturqaaraat, fiddlenecks or fiddleheads."
        },
        "98": {
            "start": 1049.12,
            "end": 1055.62,
            "transcript": "Ukut ceturqaaraugut wall' cetuguat naugaarallrit."
        },
        "99": {
            "start": 1055.62,
            "end": 1069.32,
            "transcript": "Caarilluut aciatni nautuut ceturtaqameng cuyait qulmun petenglartut it'ganret cetaman apurluki sugtutaaqluteng."
        },
        "100": {
            "start": 1069.32,
            "end": 1078.36,
            "transcript": "Allranitait nalanret marayarnganateng naugaaraat talisngaluki."
        },
        "101": {
            "start": 1078.36,
            "end": 1083.32,
            "transcript": "Aciit ayuqut banana-yagartun."
        },
        "102": {
            "start": 1083.32,
            "end": 1092.84,
            "transcript": "Kianerraarmi cetuguartelartukut petengvailgata kenirluki kelipiluki-llu masslamek uqirluki nertuaput."
        },
        "103": {
            "start": 1092.84,
            "end": 1102.0,
            "transcript": "Wall'u suupanun avukluki keniryaraugut. Cuassaaqluki-llu uqirluki nerluki."
        },
        "104": {
            "start": 1102.0,
            "end": 1111.6,
            "transcript": "Uutun ayuqluteng uungialata-llu sass'am aveksarpiarani qallarvautetuut."
        },
        "105": {
            "start": 1111.6,
            "end": 1115.88,
            "transcript": "Akutauluteng-llu assirtut."
        },
        "106": {
            "start": 1115.88,
            "end": 1126.8,
            "transcript": "Aciit banana-yagarngalnguut uksumi elagluki ingqirraarluki suupanun avukluteng assipiartut."
        },
        "107": {
            "start": 1126.8,
            "end": 1135.32,
            "transcript": "Wall'u uksuarmi cikuvailgan pitaqsugngaut."
        },
        "108": {
            "start": 1135.32,
            "end": 1140.32,
            "transcript": "Napalegni ukut nautuut."
        },
        "109": {
            "start": 1140.32,
            "end": 1149.6,
            "transcript": "Allngiguaq, Caltha palustris, cowslip-aamek Kass'atun aptuat."
        },
        "110": {
            "start": 1149.6,
            "end": 1163.06,
            "transcript": "Una allngiguaguuq mermi nautuuq allmaruamek Qissunam nuniinelnguut-llu aptuat."
        },
        "111": {
            "start": 1163.06,
            "end": 1179.38,
            "transcript": "Nat'ram allngiatun cuyaa ayuquq, cetrin cetaman tekilluki angtaluni."
        },
        "112": {
            "start": 1179.38,
            "end": 1199.36,
            "transcript": "Cet'ni qellupsaarluni manigcetevkenani, epua takluni angutii naucetaangaqluni esirlinek tallimauluteng petngai."
        },
        "113": {
            "start": 1199.36,
            "end": 1208.22,
            "transcript": "Kenengvailgata pitaqelaraput keniraqluki."
        },
        "114": {
            "start": 1208.22,
            "end": 1222.38,
            "transcript": "Miicirraarluki wall'u qallarvaaqaarluki cet'yaarni qulni taggluki mer'a pingayurqunek cimiraqluku qallarvautenqigtaqluki."
        },
        "115": {
            "start": 1222.38,
            "end": 1229.36,
            "transcript": "Qassauluku neryaqunaku iluliqnarquq uuvelaagluni."
        },
        "116": {
            "start": 1229.36,
            "end": 1237.16,
            "transcript": "Taumek qallarvautenqegcaararraarluku mer'a cimirluku qallarvautenqiggluku."
        },
        "117": {
            "start": 1237.16,
            "end": 1244.36,
            "transcript": "Cimirraarluku-llu nutaan pingayiriluku qallarvaaqaarluku neryugngaan."
        },
        "118": {
            "start": 1244.36,
            "end": 1253.8,
            "transcript": "Ikiituut, Angelica ludica, wild celery."
        },
        "119": {
            "start": 1253.8,
            "end": 1266.58,
            "transcript": "Kiagem qukaryartuani ikiituut pissurnarilartut temait elleggluteng, cuplurtuluteng."
        },
        "120": {
            "start": 1268.2,
            "end": 1276.46,
            "transcript": "Cungagcenateng qaskiit, cuyait uurtaagulluteng qulmun."
        },
        "121": {
            "start": 1276.46,
            "end": 1282.36,
            "transcript": "Epuita qecugmiaqluki temseng."
        },
        "122": {
            "start": 1282.36,
            "end": 1295.62,
            "transcript": "Cuyai ircaquruarceńateng pingayuuluteng wall' cetamauluteng nuungqerrluteng."
        },
        "123": {
            "start": 1296.48,
            "end": 1309.42,
            "transcript": "Naugaararqameng cuyat imeggluggluteng, taqmigcameng-llu manigiluteng ceńait."
        },
        "124": {
            "start": 1309.42,
            "end": 1322.36,
            "transcript": "Cingiketaarluteng kangrit-llu quyurmeng qulait iqtunruluteng qavyaggluteng."
        },
        "125": {
            "start": 1322.36,
            "end": 1330.6,
            "transcript": "Ilait-llu cungagceńateng qerrlerulluteng."
        },
        "126": {
            "start": 1330.96,
            "end": 1343.42,
            "transcript": "Una cuassaaq nevumi nautuuq, merrlugni, nanvani-llu pivkenani."
        },
        "127": {
            "start": 1344.88,
            "end": 1356.08,
            "transcript": "Nertuaput ciumek cuyairraarluku qeltairluku, tua-i-llu meciarluku uqumek nerluku."
        },
        "128": {
            "start": 1356.08,
            "end": 1362.88,
            "transcript": "Cuyait-llu suupamun avuksugngaut nutaraitnun."
        },
        "129": {
            "start": 1362.88,
            "end": 1375.68,
            "transcript": "Ikiituut nertuit allat uqumun mecirtelluki piucituit cikunguanun ekluki."
        },
        "130": {
            "start": 1375.68,
            "end": 1389.14,
            "transcript": "Kumlaskiinun-llu kinertellriamun wall'u maavet refrigerator-aamun ekluki, tuani piuciugngaut akaarnun."
        },
        "131": {
            "start": 1389.74,
            "end": 1396.6,
            "transcript": "Mecuqelugaq, sea lovage-aamek [?] Kass'atun pituarput."
        },
        "132": {
            "start": 1396.76,
            "end": 1413.74,
            "transcript": "Mecuqelugaat ikiituut tungelquqait cuyait pingayuuluteng, avgumaluteng, cungackeggluteng, naugaararqameng."
        },
        "133": {
            "start": 1413.74,
            "end": 1421.24,
            "transcript": "Cenliaruterluteng, kavirrlugcilngurnek uutuumarmeng."
        },
        "134": {
            "start": 1422.94,
            "end": 1433.62,
            "transcript": "Taqcameng-llu cuyangluteng tamarmeng wall'u cungagiluteng."
        },
        "135": {
            "start": 1433.62,
            "end": 1443.98,
            "transcript": "Mecuqelugaat ikiitugtun teggalquyagalegni wall'u nevumi nautuut."
        },
        "136": {
            "start": 1443.98,
            "end": 1451.36,
            "transcript": "Merrlugmi kuiget nanvat-llu ceńaitni pivkenateng."
        },
        "137": {
            "start": 1451.72,
            "end": 1458.42,
            "transcript": "Una vitamin A-aamek, C-aamek-llu imangqertuq."
        },
        "138": {
            "start": 1459.16,
            "end": 1475.22,
            "transcript": "Kiagmi mecuqelugartelartukut naugaaraat teguyunarillratnek ayagluki, July-ami nauginatkaatnun."
        },
        "139": {
            "start": 1475.72,
            "end": 1485.16,
            "transcript": "Cali ilaita naugingraata kenirluki assikelarait."
        },
        "140": {
            "start": 1485.16,
            "end": 1494.72,
            "transcript": "Kangrit naugyaaqut ikiituut kangricetun ayuqelrianek."
        },
        "141": {
            "start": 1494.76,
            "end": 1507.92,
            "transcript": "Nernarqut kenirluki cuassaaqluki, egamaarrlugnun-llu ilakluki suupanun tuaten."
        },
        "142": {
            "start": 1507.92,
            "end": 1512.96,
            "transcript": "Mecuqelugaat ilaita aptuit tukaayagnek."
        },
        "143": {
            "start": 1512.96,
            "end": 1521.96,
            "transcript": "Tukaayiit wall' mecuqelugaat kumlivigluki piucilarait plastic-aanun ekluki."
        },
        "144": {
            "start": 1521.96,
            "end": 1533.4,
            "transcript": "Wall'u cikunguamun, wall'u allamun assigtamun ekluki uqumek-llu mecirluki qungutelluki."
        },
        "145": {
            "start": 1533.4,
            "end": 1538.92,
            "transcript": "Tarnaq, cow parsnip."
        },
        "146": {
            "start": 1538.92,
            "end": 1550.08,
            "transcript": "Una ikiitun cali ilurii, Kass'atun cow parsnip-aamek ap'laraat Yugcetun-llu tarnamek."
        },
        "147": {
            "start": 1550.52,
            "end": 1566.56,
            "transcript": "Naucetaarkangtuliuguq epuit melquruarluteng iqtuluteng, sugtutaaqluni qulngunrita'araan it'ganret apurluki."
        },
        "148": {
            "start": 1568.8,
            "end": 1577.52,
            "transcript": "Cuyarpauluni kangrii cungagcenateng quyurmeng petenglurrluteng."
        },
        "149": {
            "start": 1577.52,
            "end": 1585.08,
            "transcript": "Qulait iqtunruluteng una cakneq tepsarquq cuassaaq."
        },
        "150": {
            "start": 1585.08,
            "end": 1590.8,
            "transcript": "Tau͡gaam eltairaqami utumaqaraqluni."
        },
        "151": {
            "start": 1591.36,
            "end": 1599.54,
            "transcript": "Qeltii ungilagnarquq puvqerrnaqluni-llu nerqerraalriani."
        },
        "152": {
            "start": 1599.54,
            "end": 1611.56,
            "transcript": "Tua-i avuan tuaten pivkalaraa taumek aigsaarluni wall'u yuaralegluni tarnarcunarquq."
        },
        "153": {
            "start": 1611.56,
            "end": 1617.5,
            "transcript": "Cali ciulirnermek nallunrilngurmek maligluni."
        },
        "154": {
            "start": 1617.52,
            "end": 1630.88,
            "transcript": "Qeltaiqerraarrlainarluku-llu neryarauluni una nevumi nautuuq qau͡gyami pivkenani."
        },
        "155": {
            "start": 1631.8,
            "end": 1638.54,
            "transcript": "Waten qeltii ciumek au͡g'arraarluku meciarluku neryarauguq."
        },
        "156": {
            "start": 1638.54,
            "end": 1655.12,
            "transcript": "Ikiituut mecuqelugaat, tarnat-llu nevumi nautuut mecagni merrlugni, kuiget nanvat-llu ceńaitni cenkacagaitni-llu pivkenateng."
        },
        "157": {
            "start": 1655.12,
            "end": 1667.0,
            "transcript": "Anguturluq, arnaurluq, Cicuta mackenzieana, poison water hemlock."
        },
        "158": {
            "start": 1667.0,
            "end": 1678.58,
            "transcript": "Tangrru una tuqunarquq naucetaaq anguturluq wall' arnaurluq ikiituum ayuqsaaqaa."
        },
        "159": {
            "start": 1678.58,
            "end": 1683.8,
            "transcript": "Tau͡gaam cuyai cingicekeggluteng."
        },
        "160": {
            "start": 1684.02,
            "end": 1690.5,
            "transcript": "Kangri-llu avlerrluteng qulmun quyungqayaaqeng'e'rmeng."
        },
        "161": {
            "start": 1690.5,
            "end": 1707.06,
            "transcript": "Nalaaqami-llu kaviryaggluteng mermi merrlugmi angayaani kuiget nanvat-llu cenkacagaitni nautuut."
        },
        "162": {
            "start": 1707.14,
            "end": 1716.56,
            "transcript": "Acia uquutvaguaq uivenqeggluni taqtelartuq."
        },
        "163": {
            "start": 1716.56,
            "end": 1726.72,
            "transcript": "Elatii nuyavyirluni, qupkuni ilua cupluryagluni capkutalegnek."
        },
        "164": {
            "start": 1726.72,
            "end": 1736.58,
            "transcript": "Una nallunairtunqegcaarluku pinarquq, tuqunarquq uquutvaguaraa arcaqerluni."
        },
        "165": {
            "start": 1736.8,
            "end": 1751.16,
            "transcript": "Ikiituut tau͡gken aciit qupellriani tumaumaut taksuriluteng, allaunruluteng uquutvaguani."
        },
        "166": {
            "start": 1751.16,
            "end": 1766.68,
            "transcript": "Tevyulit wall'u kanaqliit uquutvaguat nererraarluki nanvanun mermun unitelarait pugtavkarluki."
        },
        "167": {
            "start": 1766.8,
            "end": 1775.64,
            "transcript": "Agurrluk' uquutvaguanek teguteqeryaqunaci tuqunarqut."
        },
        "168": {
            "start": 1775.64,
            "end": 1780.16,
            "transcript": "It'garalget, beach greens."
        },
        "169": {
            "start": 1780.84,
            "end": 1788.48,
            "transcript": "It'garalget teggalquyagarni imarpiim ceńiini naulartut."
        },
        "170": {
            "start": 1788.48,
            "end": 1807.7,
            "transcript": "Kangrit qaterrlugluteng temii-llu cunagpauvkenani tau͡gaam cungagceńani cuyai puvngaluteng, mecurtuluteng iqtuyagarluteng."
        },
        "171": {
            "start": 1807.7,
            "end": 1819.32,
            "transcript": "Kiagpak malrurqugnek it'garalget nautuut May-aami July-ami-llu kangrit petengvailgata pitaqetuit."
        },
        "172": {
            "start": 1819.8,
            "end": 1832.54,
            "transcript": "Piciatun neqmun keniramun ilaulluteng akutanun, suupanun-llu assirtut, cuassaaruluteng-llu."
        },
        "173": {
            "start": 1832.54,
            "end": 1844.8,
            "transcript": "Plastic-aanun ekluki kumlivigmun qemaggluki piucituit, ilaita-llu kenirraarluki kumlivituit."
        },
        "174": {
            "start": 1845.8,
            "end": 1853.1,
            "transcript": "Quunarliar, sour grass."
        },
        "175": {
            "start": 1853.1,
            "end": 1860.72,
            "transcript": "Quunarliaraat nunami quyilriami naumatuut."
        },
        "176": {
            "start": 1860.8,
            "end": 1874.06,
            "transcript": "Carvat teggalqurrita qaingitni ingrit-llu ekviatni nunami mamkilngurmi."
        },
        "177": {
            "start": 1874.64,
            "end": 1888.66,
            "transcript": "Una tarenraq marayaarmiuni tarenrairauguq cuyait nertuit qassarluki."
        },
        "178": {
            "start": 1888.8,
            "end": 1905.66,
            "transcript": "Kangengan-llu July-am nalliini tamalkuan kenirluku saarraliqerluku nenglliqaqaku-llu juice-aqluni ayuqaituq."
        },
        "179": {
            "start": 1905.8,
            "end": 1911.54,
            "transcript": "Una cuassaaq vitamin C-aalirtuq."
        },
        "180": {
            "start": 1911.54,
            "end": 1918.84,
            "transcript": "Tayarut, mare's tail, wall' goose grass."
        },
        "181": {
            "start": 1918.84,
            "end": 1929.0,
            "transcript": "Kusquqviim paingani qagaatmun tayarut naulartut nanvarraarni iqtunrilngurni."
        },
        "182": {
            "start": 1929.0,
            "end": 1935.82,
            "transcript": "Tevurkanek pilaraput, mer'em aciani acingqertut."
        },
        "183": {
            "start": 1935.82,
            "end": 1947.16,
            "transcript": "It'ganrek-llu malruk apurlukek nautuut, cuyai epua uivqerrluku naulartut."
        },
        "184": {
            "start": 1947.8,
            "end": 1956.56,
            "transcript": "Cikuqami unataqtuaput keligarluki cikum qaingani."
        },
        "185": {
            "start": 1956.56,
            "end": 1970.74,
            "transcript": "Nunapiim-llu qainganun elliluki, ilaita missuullernun assigtalarait, wall'u ut'rutaqamegteki kumlivigluki."
        },
        "186": {
            "start": 1970.74,
            "end": 1986.4,
            "transcript": "Tememi qilut imaitnek carririlriaruut tayarut, ak'a avaken ciuliamteńek man'a tekilluku."
        },
        "187": {
            "start": 1986.8,
            "end": 2002.56,
            "transcript": "Kenituaput kepuqcaararraarluki yuurqaarmun tevuqluki, qallarvaulluki-llu tangviarrlugnek iquyucirluki."
        },
        "188": {
            "start": 2002.56,
            "end": 2014.82,
            "transcript": "Unailikata-llu taqluki, neqet kemget yaqulget-llu imarkuarit ciuneqluteng yuurqaarmun assirtut."
        },
        "189": {
            "start": 2014.82,
            "end": 2028.78,
            "transcript": "Tayarut akutauluteng kenirluki cali assirtut atsanek isuumayagarnek-llu ilayukuvki qiviqluki."
        },
        "190": {
            "start": 2028.8,
            "end": 2035.66,
            "transcript": "Utngungssaraat waten makut vesrayagaat angtaut."
        },
        "191": {
            "start": 2035.66,
            "end": 2043.4,
            "transcript": "Kangmegteggun naucetaarkayagarluteng yaqulget uksuarmi makut nertuit."
        },
        "192": {
            "start": 2043.4,
            "end": 2054.86,
            "transcript": "Uugnaraat wall'u avelngaat uksuqatarqan unatalarait tua-i-llu elagyameggnun elliluki."
        },
        "193": {
            "start": 2054.86,
            "end": 2063.28,
            "transcript": "Wangkuta-llu ak'a ciuliamta pilallruciicetun pakissaagluki."
        },
        "194": {
            "start": 2063.28,
            "end": 2075.38,
            "transcript": "Ancillrit tutmarluki, tua-i-llu muruqaamta pakigluku elagyat-llu imairluki."
        },
        "195": {
            "start": 2075.38,
            "end": 2080.7,
            "transcript": "Negaasget, wild sweet potato."
        },
        "196": {
            "start": 2080.8,
            "end": 2086.3,
            "transcript": "Negaasget cali uugnaraat neqkait."
        },
        "197": {
            "start": 2086.3,
            "end": 2098.58,
            "transcript": "Una kangraa qulutnguamek atengqertuq aciit taksuryuut qaterrlugluteng."
        },
        "198": {
            "start": 2098.58,
            "end": 2106.98,
            "transcript": "Iluit qatqapiarluteng. Utngungssartun unatatuit."
        },
        "199": {
            "start": 2106.98,
            "end": 2112.88,
            "transcript": "Iliini avuqluteng elagyami ataucimi uitalartut."
        },
        "200": {
            "start": 2112.88,
            "end": 2123.58,
            "transcript": "Anlleret, mouse nut, wall'u tall cottongrass underground root."
        },
        "201": {
            "start": 2123.8,
            "end": 2128.58,
            "transcript": "Anllernek makut atengqertut."
        },
        "202": {
            "start": 2128.58,
            "end": 2143.8,
            "transcript": "Iitaat acikait, camani nunami uitaluteng taksuriluteng tunguluteng qaingit melquyagangqerrnganateng iitaat iqukluki."
        },
        "203": {
            "start": 2143.8,
            "end": 2149.84,
            "transcript": "Uksuqata'arqan avelngaat wall'u uugnaraat unataqtuit."
        },
        "204": {
            "start": 2149.84,
            "end": 2160.32,
            "transcript": "Una kangraa tak'uq canegpauluni, kangraa petngaqami melquruangaqluni."
        },
        "205": {
            "start": 2160.32,
            "end": 2168.96,
            "transcript": "Anllerem ilua qaterrluni, qainga-llu keggagcenani tunguluni."
        },
        "206": {
            "start": 2168.96,
            "end": 2178.06,
            "transcript": "Anlleret unatallrit negaasegtun ayuqut elagyat pakigluki."
        },
        "207": {
            "start": 2178.06,
            "end": 2188.32,
            "transcript": "Anlleret akutauvallurluki nertuaput, kenirraarluki yuurqaaryaqluki-llu iliini."
        },
        "208": {
            "start": 2188.32,
            "end": 2195.36,
            "transcript": "Qassauluki-llu melugnek avuluki ner'aqluki."
        },
        "209": {
            "start": 2195.36,
            "end": 2210.64,
            "transcript": "Amlleret uugnaraat neqait, carrirluki, erurraarluki-llu caquluki kumlivilaraput uksumi neqkauteknaluki."
        },
        "210": {
            "start": 2211.26,
            "end": 2215.6,
            "transcript": "Elagaq, eskimo potato."
        },
        "211": {
            "start": 2215.6,
            "end": 2222.1,
            "transcript": "Elagaq wall'u agiyaaq Kusquqviim ceńiini nautuuq."
        },
        "212": {
            "start": 2222.2,
            "end": 2234.06,
            "transcript": "Una napayagauguq temii qavcinek puuluni qulmun nangerrluni, kangraa naugiaqluni."
        },
        "213": {
            "start": 2234.06,
            "end": 2242.2,
            "transcript": "Kavirrlugcilngurnek qulmun takellrianek."
        },
        "214": {
            "start": 2242.2,
            "end": 2253.18,
            "transcript": "Caniqliqluteng atauciq caumaluku naucetaarkangaqluni iqukluteng usgukellrianek."
        },
        "215": {
            "start": 2253.18,
            "end": 2261.66,
            "transcript": "Elagarcetuut cupraartelluku cikuqata'arqan-llu."
        },
        "216": {
            "start": 2261.66,
            "end": 2268.96,
            "transcript": "Nuna avatii itumqaarluku elagluku acia nucugaqluku."
        },
        "217": {
            "start": 2268.96,
            "end": 2279.74,
            "transcript": "Negaasegpagtun ayuqut qaterrluteng iluit, qaingit tau͡gaam manigceńateng qateryaggluteng."
        },
        "218": {
            "start": 2279.8,
            "end": 2287.32,
            "transcript": "Avelngaat wall'u uugnaraat cali makut unataqtuit."
        },
        "219": {
            "start": 2287.32,
            "end": 2300.76,
            "transcript": "Erurluki nernarqut kenirluki-llu akutauluteng, suupamun-llu avukluteng assirtut wall'u cuassaaruluteng."
        },
        "220": {
            "start": 2300.8,
            "end": 2311.74,
            "transcript": "Nasqupaguaq, uum Kass'artaa nalluamteggu vows head plant-amek [?] aciruaqallruaqa."
        },
        "221": {
            "start": 2311.74,
            "end": 2319.0,
            "transcript": "Una cuassaq kiingan ceńami Bering Sea-m ceńiini nautuuq."
        },
        "222": {
            "start": 2319.0,
            "end": 2327.92,
            "transcript": "Kass'atun atrinek nataquteksaitukut, tau͡gaam Yugcetun nasqupaguaruuq."
        },
        "223": {
            "start": 2327.92,
            "end": 2344.46,
            "transcript": "Ataucimek pungqertuq cuyai avatiikun naugaqluteng, kangrii kavivyaggluteng tungurrlugluteng, purple-aaruluteng."
        },
        "224": {
            "start": 2344.46,
            "end": 2355.2,
            "transcript": "Waten pitariaqata unataqtuit kenirraarluki uqirluki cuassaaqluki nertuit."
        },
        "225": {
            "start": 2355.2,
            "end": 2368.68,
            "transcript": "Egaamaarrlugnun avuqluki, qass'auluki-llu caqurraarluki kumlivigmun ekluki piuciaqluki."
        },
        "226": {
            "start": 2368.68,
            "end": 2376.68,
            "transcript": "Atsat, berries, atsat maani vitamin C-aalilriit nautuut."
        },
        "227": {
            "start": 2376.68,
            "end": 2389.54,
            "transcript": "Avukluki keserrlainaita-llu ner'aqluki saarraliqerluki makut tan'gerpiit."
        },
        "228": {
            "start": 2389.54,
            "end": 2393.0,
            "transcript": "Tumaglit."
        },
        "229": {
            "start": 2393.0,
            "end": 2395.76,
            "transcript": "Agautaat."
        },
        "230": {
            "start": 2395.76,
            "end": 2398.44,
            "transcript": "Surat."
        },
        "231": {
            "start": 2398.44,
            "end": 2401.22,
            "transcript": "Tuutaruat."
        },
        "232": {
            "start": 2401.22,
            "end": 2407.28,
            "transcript": "Atsalugpiat naunraat wall'u aqevyiit."
        },
        "233": {
            "start": 2407.28,
            "end": 2417.46,
            "transcript": "Atsalugpiat tuutaruat-llu vitamin C-aarit amllenqurraugut atsani maani nautulini."
        },
        "234": {
            "start": 2417.46,
            "end": 2422.72,
            "transcript": "Una-qaa cakartailngatuq?"
        },
        "235": {
            "start": 2422.72,
            "end": 2430.24,
            "transcript": "Kitak' neqnek apertuiqerci wani uitayugngalrianek."
        },
        "236": {
            "start": 2430.24,
            "end": 2443.36,
            "transcript": "Taumek avaceci murilkelluki nuna navguryaaqevkenaku, uqlaqsaunaki-llu yuilqumi uitaaqavci pilarniartuci."
        },
        "237": {
            "start": 2443.36,
            "end": 2452.46,
            "transcript": "Caarrluci-llu quyurrluki ut'rutaqluki, nuna man'a yuutekarci."
        }
    },
    "5WpK3B12bu4": {
        "1": {
            "start": 32.14,
            "end": 37.18,
            "transcript": "Una taryaqvauguq."
        },
        "2": {
            "start": 37.18,
            "end": 42.5,
            "transcript": "Cangtaqarraaqellratni qamiqutuumallruuq ukutuman aqsaqurtuumaluni-ll'."
        },
        "3": {
            "start": 42.5,
            "end": 52.64,
            "transcript": "Waten pivailemku qamiqurra kepluku ukuk-llu aug'arlukek uuggun-llu callarrluku ilua carrirluku."
        },
        "4": {
            "start": 52.64,
            "end": 58.58,
            "transcript": "Tua-ll' waniw' ulligteqatarluku."
        },
        "5": {
            "start": 58.58,
            "end": 65.0,
            "transcript": "Uuggun waten pirraarluku, waten-llu cali piluku."
        },
        "6": {
            "start": 69.06,
            "end": 75.16,
            "transcript": "Tua-ll' mumiggluku."
        },
        "7": {
            "start": 75.16,
            "end": 79.38,
            "transcript": "Maaggun-llu waten ceterluku."
        },
        "8": {
            "start": 79.38,
            "end": 82.26,
            "transcript": "Una wani strip-arkauguq."
        },
        "9": {
            "start": 89.72,
            "end": 93.66,
            "transcript": "Una-llam wani ipgiarucularta."
        },
        "10": {
            "start": 99.32,
            "end": 104.92,
            "transcript": "Tangavagarpecia-m tua-i neqliluliunrilngerma."
        },
        "11": {
            "start": 104.92,
            "end": 107.58,
            "transcript": "Tua-i-ll' waten piluku."
        },
        "12": {
            "start": 112.68,
            "end": 118.0,
            "transcript": "Kemga pitatekurangnaqluku."
        },
        "13": {
            "start": 121.76,
            "end": 123.94,
            "transcript": "Waten au͡g'arluku."
        },
        "14": {
            "start": 130.9,
            "end": 139.54,
            "transcript": "Waten-llu maaggun tevakarraarluku ilailaryaaqanka una tau͡gaam mik'uq. Waten tau͡gaam kiingan piqerrluku."
        },
        "15": {
            "start": 145.76,
            "end": 149.52,
            "transcript": "Tuamta-ll' mumiggluku ukatmun."
        },
        "16": {
            "start": 153.46,
            "end": 155.92,
            "transcript": "Waten piqerrluku."
        },
        "17": {
            "start": 155.92,
            "end": 166.62,
            "transcript": "Tuamta-ll' una cali, ukatmun piluku."
        },
        "18": {
            "start": 175.84,
            "end": 179.5,
            "transcript": "Kemgit pitatekengnaqu'urluki."
        },
        "19": {
            "start": 185.72,
            "end": 193.1,
            "transcript": "Ilairngaitaqa una mik'uq."
        },
        "20": {
            "start": 195.42,
            "end": 202.52,
            "transcript": "Uum tau͡gken ilairumakuni, ilaillra kiarneruluni."
        },
        "21": {
            "start": 204.3,
            "end": 207.74,
            "transcript": "Maa-i tang makut kiarneret."
        },
        "22": {
            "start": 215.24,
            "end": 217.58,
            "transcript": "Strip-arkauguq una."
        },
        "23": {
            "start": 219.74,
            "end": 227.0,
            "transcript": "Tua-ll' una wani enra, enra au͡g'arluku."
        },
        "24": {
            "start": 229.22,
            "end": 235.76,
            "transcript": "Waken ayagluku wavet au͡g'arluku aqsanra."
        },
        "25": {
            "start": 240.26,
            "end": 248.26,
            "transcript": "Nutaan-llu tua-i ik'utun strip-aliluku, slice-arluku."
        },
        "26": {
            "start": 268.32,
            "end": 272.6,
            "transcript": "Strip-arkaugut ik'utun ika-i ik'um caliaqai."
        },
        "27": {
            "start": 274.94,
            "end": 288.42,
            "transcript": "Makut-llu tua-i aqsanrit, aqsanrit waten piluki."
        },
        "28": {
            "start": 300.52,
            "end": 303.0,
            "transcript": "Waten piqcaarturluki."
        },
        "29": {
            "start": 313.48,
            "end": 318.96,
            "transcript": "Una cali mamtussiyalaan waten tevakarluku."
        },
        "30": {
            "start": 320.68,
            "end": 325.14,
            "transcript": "Waten-llu tua-i inikuni,"
        },
        "31": {
            "start": 325.14,
            "end": 332.6,
            "transcript": "una-llu mamtussiyaalaan waten qukaakun ikirrluku makluku."
        },
        "32": {
            "start": 332.6,
            "end": 343.9,
            "transcript": "Tua-i-ll' una-llu inglukegglutek agakunek una maktaluni."
        },
        "33": {
            "start": 343.9,
            "end": 346.4,
            "transcript": "Una call' piqernaurqa."
        },
        "34": {
            "start": 364.72,
            "end": 367.36,
            "transcript": "Waten piqcaarturluku."
        },
        "35": {
            "start": 377.26,
            "end": 380.24,
            "transcript": "Tua-ll' waten ayuqliriluni."
        },
        "36": {
            "start": 380.24,
            "end": 383.02,
            "transcript": "Tua-i-ll' agareskunek,"
        },
        "37": {
            "start": 385.42,
            "end": 392.56,
            "transcript": "mamtulriit, kan'a-ll' mamtulriik ukuk maktalutek."
        },
        "38": {
            "start": 400.0,
            "end": 405.98,
            "transcript": "Mikcuarmek cali piqernaurtua tuaken."
        },
        "39": {
            "start": 405.98,
            "end": 411.92,
            "transcript": "Kiik' eruriluten ataucimek mikcuarmek cikiqernga."
        },
        "40": {
            "start": 411.92,
            "end": 415.12,
            "transcript": "Nutaan pivkenak ang'uq tauna."
        },
        "41": {
            "start": 427.56,
            "end": 432.0,
            "transcript": "Yaa, tauna tua-i assirtuq."
        },
        "42": {
            "start": 437.2,
            "end": 441.0,
            "transcript": "Kitek taisgu. Assiriuq."
        },
        "43": {
            "start": 448.04,
            "end": 453.66,
            "transcript": "Nutaan. Mikvallagpaa-ll' uumi."
        },
        "44": {
            "start": 453.66,
            "end": 456.46,
            "transcript": "Una-wa cayagauga?"
        },
        "45": {
            "start": 490.14,
            "end": 492.86,
            "transcript": "Inglukegglukek uuggun."
        },
        "46": {
            "start": 526.4,
            "end": 531.04,
            "transcript": "Una-ll' call' waten makucit waten ulligtaqluki."
        },
        "47": {
            "start": 533.42,
            "end": 539.0,
            "transcript": "Taryaqvagcetun ayuqevkenateng."
        },
        "48": {
            "start": 555.5,
            "end": 568.54,
            "transcript": "Tua-ll' waten pirraarluku tulimain, tulimainek ayagluku."
        },
        "49": {
            "start": 580.7,
            "end": 586.8,
            "transcript": "Kemgit cali mamtussiyaanritengnaqluki, pitatekengnaqluki."
        },
        "50": {
            "start": 615.48,
            "end": 619.62,
            "transcript": "Makqurluku-ll' tua-i makut."
        },
        "51": {
            "start": 626.28,
            "end": 637.14,
            "transcript": "Tuamta-ll' mumiggluku, akmatii cali waten piluku."
        },
        "52": {
            "start": 656.8,
            "end": 668.32,
            "transcript": "Assircaarluki pitatekengnaqluki caliaqaqluki waten."
        },
        "53": {
            "start": 672.76,
            "end": 678.66,
            "transcript": "Tua-ll' akmatii cali waten, akmatiitun."
        },
        "54": {
            "start": 684.92,
            "end": 693.02,
            "transcript": "Una-ll' cali ukiarrluku air-angqerrniartuq agakuni."
        },
        "55": {
            "start": 704.44,
            "end": 713.02,
            "transcript": "Piciatun-am cali makucinek, makucinek wavet elliarkamek."
        },
        "56": {
            "start": 713.02,
            "end": 721.12,
            "transcript": "Makucinek napanek pingqelartut."
        },
        "57": {
            "start": 725.0,
            "end": 726.38,
            "transcript": "Ata."
        },
        "58": {
            "start": 735.28,
            "end": 740.58,
            "transcript": "Makut wani asmarrngilartut, asemńilartut,"
        },
        "59": {
            "start": 740.58,
            "end": 743.48,
            "transcript": "taumek makunek atulalriakut."
        },
        "60": {
            "start": 743.48,
            "end": 760.0,
            "transcript": "Tua-i-ll' wavet enermun akliartelluku ikna-ll' cuqluku, tua-i-ll' asemlluku. Tuamta-ll' elliluku."
        },
        "61": {
            "start": 760.0,
            "end": 768.58,
            "transcript": "Tua-ll' taqkuni, waniwa."
        },
        "62": {
            "start": 768.58,
            "end": 772.2,
            "transcript": "Taqkuni-ll' tua-i agarcugngariluni."
        },
        "63": {
            "start": 774.6,
            "end": 778.24,
            "transcript": "Boy, nanguteqatalliniukut."
        },
        "64": {
            "start": 783.9,
            "end": 793.72,
            "transcript": "Makut wani taqeltek, taqelket tuavet ek'aqluki mermek imalegni, inglukegqaarluki qillerqaarluki."
        },
        "65": {
            "start": 799.0,
            "end": 810.0,
            "transcript": "Tua-ll' qamiqurrit, qamiqurrit cali teq'erluki tepliluki."
        },
        "66": {
            "start": 813.02,
            "end": 824.78,
            "transcript": "Qamiqurrit-am' qanrutkelarait, temait-gguq aruirqata teq'augaqameng qamiqurrit makut. Neqet"
        },
        "67": {
            "start": 828.24,
            "end": 831.68,
            "transcript": "neryunarilartut uulartut."
        },
        "68": {
            "start": 837.5,
            "end": 845.62,
            "transcript": "Cali-llu enrit makut, taryaqviit enrit."
        },
        "69": {
            "start": 848.44,
            "end": 864.0,
            "transcript": "Meciarluteng cali uqumek avurluteng, nerellrat kinertauluteng, puyuqauluteng assirluteng, wall'u-llu egamaarrluuluteng neqnguyugngaluteng."
        },
        "70": {
            "start": 867.44,
            "end": 876.08,
            "transcript": "Meluit-llu cheese-aaliluki,"
        },
        "71": {
            "start": 876.08,
            "end": 884.66,
            "transcript": "ap'laqait 'eskimo cheese' meluit, uksumi cali ner'aqluki."
        },
        "72": {
            "start": 884.66,
            "end": 908.66,
            "transcript": "Meluucilriani kinertat meluit qemagtaqamteki kinrumalriit qassanek ekiirturluki qemagtelaraput."
        },
        "73": {
            "start": 911.0,
            "end": 918.76,
            "transcript": "Waniwa tang enerrluyagaq."
        },
        "74": {
            "start": 921.82,
            "end": 924.76,
            "transcript": "Cakneq-lli tangniqvaa."
        },
        "75": {
            "start": 938.48,
            "end": 954.7,
            "transcript": "Uksumi-ll' tua-i up'nerkami aren uksuarmi anllercuraqameng tua-i-ll' melugnek avuqerluki anlleret nernaurait."
        },
        "76": {
            "start": 955.76,
            "end": 973.64,
            "transcript": "Tua-ll' call' maa-i cali meluut piucingaqatki atsat nallaitni, atsat nalliitni mak'iluki akulluki aspiat."
        },
        "77": {
            "start": 976.08,
            "end": 983.22,
            "transcript": "Wall' neqerrluarnek canek uquilngurnek avuluki neryugngaluki meluut uksumi."
        },
        "78": {
            "start": 986.56,
            "end": 989.86,
            "transcript": "Qerrucuitnarqut-gguq meluut uksumi."
        },
        "79": {
            "start": 1004.42,
            "end": 1014.82,
            "transcript": "Cat tamarmi auluksarangqelliniuq assircaarluni aulukcurlarpek'naku, picuvvlarpek'nak."
        },
        "80": {
            "start": 1014.82,
            "end": 1027.0,
            "transcript": "Cat-llu cat qilukuallret cat neqallret neqlinriraqamta neqlivigput kenagtaqluku,"
        },
        "81": {
            "start": 1027.0,
            "end": 1039.36,
            "transcript": "neqallret enret-llu cat nerngailkeput, wall' qimugtet pingailkait. Nunamun elaulluki cekavtellerkaat umyuaqluku."
        },
        "82": {
            "start": 1039.36,
            "end": 1045.74,
            "transcript": "Cekavtenritevkangnaqluki neqa man'a..."
        },
        "83": {
            "start": 1063.98,
            "end": 1086.4,
            "transcript": "Imkut wani man'a neqlivigput, man'a makut-llu imkut scrap-alkut calqut makut, murilkelluki cekavcetevkarpek'naki neqlinermek-llu taq'aqamta neqlivigput kenagtaqluku erurluku."
        },
        "84": {
            "start": 1088.22,
            "end": 1105.58,
            "transcript": "Cat-llu nerngailkeput wall' qimugtet nerngailkait teq'allermun elagluki, teq'allermun kuvluki cailkamun pegetqapigtevkenaki."
        },
        "85": {
            "start": 1105.58,
            "end": 1112.56,
            "transcript": "Tuaten man'a neqa, neqem alerquutii, alerquutiin ilii ayuqelliniuq."
        },
        "86": {
            "start": 1118.28,
            "end": 1132.0,
            "transcript": "Cakneq tua-i time-arput tamalkuan aturluku neqa murilkenarqelliniuq, pinqegcaarluku, tua-i-wa wangkutnun cikiutngucia umyuaqluku."
        },
        "87": {
            "start": 1195.26,
            "end": 1202.02,
            "transcript": "Meluuciqatartua apqiitnek 'eskimo cheese'."
        },
        "88": {
            "start": 1202.02,
            "end": 1206.28,
            "transcript": "Waten una lumarrallruar sheet-allermek piliaqaqa."
        },
        "89": {
            "start": 1206.28,
            "end": 1214.2,
            "transcript": "Missuulirraarlua tua-i-ll' plastic-aamek tunglilirluk,"
        },
        "90": {
            "start": 1214.2,
            "end": 1225.5,
            "transcript": "plastic-aamek tunglilkuni ellngarciquq wall'u plastic-aaq, lumarrallermek elaqlilkuni, allegyugciquq."
        },
        "91": {
            "start": 1225.5,
            "end": 1227.94,
            "transcript": "Kanavet elliqer'."
        },
        "92": {
            "start": 1232.78,
            "end": 1234.0,
            "transcript": "Atata."
        },
        "93": {
            "start": 1240.34,
            "end": 1247.0,
            "transcript": "Wiinga waten aanama elitnaullguciatun, aanamnek elitellemnek."
        },
        "94": {
            "start": 1249.6,
            "end": 1255.98,
            "transcript": "Waten nutaranek melugnek..."
        }
    },
    "J8s8eMeTAtk": {
        "1": {
            "start": 2.91,
            "end": 6.3,
            "transcript": "Ekiiqaqluki kinertellriit meluut."
        },
        "2": {
            "start": 11.64,
            "end": 28.8,
            "transcript": "Meluucitulliniut. Nutaranek ekiiqaqluki, tua-i-ll' ek'aqameng, akulait-gguq callavkanritengnaqluki pilarait."
        },
        "3": {
            "start": 28.8,
            "end": 33.02,
            "transcript": "Akulait-gguq callaaqameng uqugglugyulartut."
        },
        "4": {
            "start": 33.02,
            "end": 41.46,
            "transcript": "Tua-i cam nek'enqegcaarturluki waten aanama wiinga elitnaullruanga meluuciyaramek."
        },
        "5": {
            "start": 41.46,
            "end": 50.46,
            "transcript": "Callrenka tamarmeng maa-i aanama elitnaurutaitgun elitellemnek piunga."
        },
        "6": {
            "start": 56.86,
            "end": 61.26,
            "transcript": "Pinqegcaarturluki akulait callavkaryaaqevkenaki."
        },
        "7": {
            "start": 65.4,
            "end": 70.68,
            "transcript": "Piciatun, piciatun ellilarpek'naki."
        },
        "8": {
            "start": 76.02,
            "end": 80.6,
            "transcript": "Nek'egcaarturluki, picuvvlagpek'naki."
        },
        "9": {
            "start": 80.6,
            "end": 87.16,
            "transcript": "Waten aanama elitnaullruanga pinqegcaarturluki cat picuvvlagpek'naki pilaasqelluki."
        },
        "10": {
            "start": 107.26,
            "end": 115.9,
            "transcript": "Tua-i-ll' kinertellriit cali qassanek nutaranek ekiirluki melugnek."
        },
        "11": {
            "start": 125.08,
            "end": 131.8,
            "transcript": "Akulait-gguq callaaqameng uqugglugyulartut."
        },
        "12": {
            "start": 136.48,
            "end": 148.16,
            "transcript": "Wiinga imkunayukluki, akulait callanengqerrnayukluki waten meluut pilaranka."
        },
        "13": {
            "start": 148.16,
            "end": 162.98,
            "transcript": "Tua-i-w' pinqegcaangnaqluki piyaaqem [?] pitacia, uquggluusqumavkenaki, tau͡gaam assirluku meluutngusqelluku."
        },
        "14": {
            "start": 166.96,
            "end": 174.48,
            "transcript": "Waten allat-wa yuut allacetun pitullikait. Wiinga tau͡gaam waten pilartua,"
        },
        "15": {
            "start": 177.12,
            "end": 180.8,
            "transcript": "meluutekegtaarmek meluutengqerrsuglua."
        },
        "16": {
            "start": 183.28,
            "end": 187.4,
            "transcript": "Qassat ekiiqaqluki kinertellrianek."
        },
        "17": {
            "start": 191.68,
            "end": 196.58,
            "transcript": "Meluun-llu tua-i una uksurpak-llu uitaluni."
        },
        "18": {
            "start": 201.5,
            "end": 207.58,
            "transcript": "Pacetellriami uitaurcelluku puqlanilriami uitavkarpek'naku."
        },
        "19": {
            "start": 207.58,
            "end": 212.48,
            "transcript": "Atam piyucingcaarniartut qer'at aciatni,"
        },
        "20": {
            "start": 212.48,
            "end": 223.12,
            "transcript": "tua-i-llu piyungkumteki, puyurcivigmun iterrluki natmun egkumun elliluki."
        },
        "21": {
            "start": 242.78,
            "end": 250.18,
            "transcript": "Acia qerratalriamek ellicestevkangnaqluki."
        },
        "22": {
            "start": 261.88,
            "end": 268.98,
            "transcript": "Uksumi nerellrat aspiartuq. Nenglem nalliini arcaqertuq."
        },
        "23": {
            "start": 268.98,
            "end": 274.72,
            "transcript": "Neqnek avuluku. Neqmek nerenrilkuvet meciarpek'nak."
        },
        "24": {
            "start": 274.72,
            "end": 281.1,
            "transcript": "Tua-i-ll' melugmek avuluten uquunguarrartelluku."
        },
        "25": {
            "start": 287.68,
            "end": 289.86,
            "transcript": "Nerluku."
        },
        "26": {
            "start": 290.8,
            "end": 292.02,
            "transcript": "Atata."
        },
        "27": {
            "start": 304.14,
            "end": 307.44,
            "transcript": "Avqurluki wiinga pilaranka."
        },
        "28": {
            "start": 310.68,
            "end": 317.44,
            "transcript": "Qerratainayukluku naliata acia."
        },
        "29": {
            "start": 325.14,
            "end": 328.86,
            "transcript": "Uksurpak-llu tua-i puyurcivigmi uitavkarluku."
        },
        "30": {
            "start": 328.86,
            "end": 336.38,
            "transcript": "Itrulluku-ll' tua-i nerqataquvet slice-arluku cheese-aatun."
        },
        "31": {
            "start": 336.38,
            "end": 347.04,
            "transcript": "Icugg' kipusvigmi pilalriit cheese-aanek. Tua-i-ll' ingqiluku."
        },
        "32": {
            "start": 347.04,
            "end": 352.72,
            "transcript": "Tuaten piluku aspiat."
        },
        "33": {
            "start": 352.92,
            "end": 359.14,
            "transcript": "Tua-i-ll' kainrillugaumamamamaluteng."
        },
        "34": {
            "start": 390.06,
            "end": 399.68,
            "transcript": "Kinertellriit tua-i waten ekiiqaqluki nutaranek melugnek."
        },
        "35": {
            "start": 414.62,
            "end": 430.82,
            "transcript": "Imumi, imumi melugnek tuniangarcetellratni, cat-llu cannery-t, cannery-t melugnek kiputengaartellratni."
        },
        "36": {
            "start": 432.28,
            "end": 445.28,
            "transcript": "Nanikuanarqerrlugayalallruuq meluutaitnayukluta, meluut tunia' allakaita kipucetullratki."
        },
        "37": {
            "start": 476.18,
            "end": 478.9,
            "transcript": "Assiirucuilameng-llu."
        },
        "38": {
            "start": 621.7,
            "end": 631.42,
            "transcript": "Uksurpak-llu tua-i makut wani nerluki, spoil-amek assiirutmek-llu nalluluteng."
        },
        "39": {
            "start": 663.2,
            "end": 669.64,
            "transcript": "Im'u, ciin iquyugta? Tuavet piqerrlii."
        },
        "40": {
            "start": 711.28,
            "end": 726.94,
            "transcript": "Cali-llu meluut makut maa-i mana'arqameng unani neqcaqnaurait canguratkaqluki."
        },
        "41": {
            "start": 726.94,
            "end": 731.46,
            "transcript": "Melugnek neqcirluteng manaryarnaurtut unavet."
        },
        "42": {
            "start": 731.46,
            "end": 738.44,
            "transcript": "Tuamta-ll' call makut meluut assirluteng suupiluki, kenirluki, soup-auluki."
        },
        "43": {
            "start": 738.44,
            "end": 747.28,
            "transcript": "Paraluruamek avuluki. Anianessiirluki wall' patitussaanek avuluku."
        },
        "44": {
            "start": 749.72,
            "end": 755.98,
            "transcript": "Taiqaa! Una tegumiaqeqerru. Iquyugtuq!"
        },
        "45": {
            "start": 755.98,
            "end": 758.12,
            "transcript": "Kanavet wavet piluki."
        },
        "46": {
            "start": 759.96,
            "end": 762.4,
            "transcript": "Tamaatmun iquyugtuq."
        },
        "47": {
            "start": 765.72,
            "end": 774.46,
            "transcript": "Suupirluki, paraluruarluki. Aspiat nerellrat."
        },
        "48": {
            "start": 783.74,
            "end": 786.3,
            "transcript": "Tamaatmun iquyugtuq."
        },
        "49": {
            "start": 786.3,
            "end": 795.96,
            "transcript": "Nangqatartut. Meluun taq'uq. Meluutek, meluuteput."
        },
        "50": {
            "start": 832.9,
            "end": 834.68,
            "transcript": "Aqumluten!"
        },
        "51": {
            "start": 884.24,
            "end": 885.64,
            "transcript": "Yaavet."
        },
        "52": {
            "start": 889.98,
            "end": 891.68,
            "transcript": "Taq'ukut."
        },
        "53": {
            "start": 926.92,
            "end": 940.38,
            "transcript": "Tua-ll' sulunarkiuqataraqameng tatangqurritnek waten kep'lalliniit."
        },
        "54": {
            "start": 946.26,
            "end": 950.8,
            "transcript": "Tatangquqainaitnek sulunarkiuraqameng."
        },
        "55": {
            "start": 959.16,
            "end": 964.22,
            "transcript": "Mulngakengqegcaarluni cali piyarauluni."
        },
        "56": {
            "start": 964.22,
            "end": 974.84,
            "transcript": "Qukaakun, qukaakun maaggun ikirteqatarqa. Man'a allenritengnaqluku."
        },
        "57": {
            "start": 977.48,
            "end": 986.2,
            "transcript": "Waniw' sulunarkiurlua-gguq tatangqunek, taryaqviit tatangqurritnek."
        },
        "58": {
            "start": 993.22,
            "end": 1003.9,
            "transcript": "Waten. Kepumavkenani man'a, tau͡gaam tevaumaluni tatangquq-llu qukamikun qup'arrluteng."
        },
        "59": {
            "start": 1005.56,
            "end": 1011.38,
            "transcript": "Waten ilaita keggutait au͡g'alarait, qaillun au͡g'alartatki?"
        },
        "60": {
            "start": 1011.38,
            "end": 1013.1,
            "transcript": "Pinguaqerrlii."
        },
        "61": {
            "start": 1013.1,
            "end": 1016.98,
            "transcript": "Yaa, waten au͡g'alalliniit keggutait."
        },
        "62": {
            "start": 1036.9,
            "end": 1044.72,
            "transcript": "Makucia-llu tua-i egamaarrlugkiurluku wall' qamiqurrlugkiurluku."
        },
        "63": {
            "start": 1060.88,
            "end": 1063.48,
            "transcript": "Ulluvii makluku."
        },
        "64": {
            "start": 1068.98,
            "end": 1071.82,
            "transcript": "Akia-llu."
        },
        "65": {
            "start": 1092.28,
            "end": 1097.44,
            "transcript": "Uuggun-llu waten pelacinagmek qillerrluku."
        },
        "66": {
            "start": 1097.44,
            "end": 1108.48,
            "transcript": "Ilai-llu waten ayuqurluki ukatmun waten pikuni, ulluvii makingarkauluni, iniluku kinercirluku."
        },
        "67": {
            "start": 1108.48,
            "end": 1113.92,
            "transcript": "Egamaarrlugkiurluki qamiqurrlugkiurluki."
        },
        "68": {
            "start": 1120.14,
            "end": 1129.12,
            "transcript": "Tuamta-ll' call makut sulunarkiuryugngaluteng kemegglainaungraata."
        },
        "69": {
            "start": 1130.82,
            "end": 1134.4,
            "transcript": "Sulunauluteng cali assirluteng."
        },
        "70": {
            "start": 1141.92,
            "end": 1144.92,
            "transcript": "Taryaqvayagauguq una."
        },
        "71": {
            "start": 1150.78,
            "end": 1156.96,
            "transcript": "Kemga mamtussiyaagan uqurian-llu."
        },
        "72": {
            "start": 1163.86,
            "end": 1169.1,
            "transcript": "Ilait una ayuqevkenaku."
        },
        "73": {
            "start": 1176.28,
            "end": 1179.28,
            "transcript": "Piqatarqa."
        },
        "74": {
            "start": 1211.8,
            "end": 1220.28,
            "transcript": "Uluaq ukatmun pirrluarluku. Inimakuni, makut wani maktaarkauluteng."
        },
        "75": {
            "start": 1231.3,
            "end": 1242.88,
            "transcript": "Una-llu cali aqsanrani mamtussiyaalaan mamkellicarluku."
        },
        "76": {
            "start": 1250.38,
            "end": 1261.58,
            "transcript": "Ilaita qukaitgun tevagpek'naki atauciuluki ulligtelarait wii, tau͡gaam tuaten pineq nalluaqa, tuaten piksailama."
        },
        "77": {
            "start": 1267.84,
            "end": 1276.04,
            "transcript": "Makut-llu-gguq cali neqet amiit, amirauluteng assirluteng."
        },
        "78": {
            "start": 1289.28,
            "end": 1291.28,
            "transcript": "Allayuuguq."
        },
        "79": {
            "start": 1292.64,
            "end": 1296.86,
            "transcript": "Tuar tang una uluaqa kass'amirtell'. Qaillun una pia?"
        },
        "80": {
            "start": 1296.86,
            "end": 1302.54,
            "transcript": "Nauw' imna uluaq assilria?"
        },
        "81": {
            "start": 1302.54,
            "end": 1304.2,
            "transcript": "Nutaan."
        },
        "82": {
            "start": 1327.3,
            "end": 1333.42,
            "transcript": "Kiarnelinritanka makut enrualuyaagaat mikngata."
        }
    },
    "Lljd7Yh0Bis": {
        "1": {
            "start": 88.14,
            "end": 94.56,
            "transcript": "Ciuqliuluku, ciuqliuluku nulirqutellriik ayuquciagnek qalartellerkarput."
        },
        "2": {
            "start": 94.56,
            "end": 103.12,
            "transcript": "Waniwa ellami watua wani neqlillerni piqataraput, nulirqutellriik ayagnilartuk ellmeggnun nallunriullutek."
        },
        "3": {
            "start": 103.2,
            "end": 110.28,
            "transcript": "Wall'u wangkuta avani, ciuqlirni wangkuta, waniwa-llu wii 73-aarlua."
        },
        "4": {
            "start": 110.28,
            "end": 120.96,
            "transcript": "Wangkuta tamatum nalliini uingyuitellruukut nulirtuyunateng-llu im'urraarluteng ellmegnun elisngarraarluteng [?]."
        },
        "5": {
            "start": 120.96,
            "end": 132.2,
            "transcript": "Tamatum nalliini nallungramteki angayuqamta ellaita tangerrluki pivkalallruit elluarrluteng tau͡gaam uitaarkat quyurtevkalallruit."
        },
        "6": {
            "start": 132.28,
            "end": 142.82,
            "transcript": "Nalluvkenaki-llu tangerrluki elluarrluteng uitangailnguut tan'gaurluq wall' nasaurluq piungraatgu pivkayuitellruat."
        },
        "7": {
            "start": 142.82,
            "end": 149.2,
            "transcript": "Angayuqurrita qalarulluki elluarrluku uitayukan angayuqait maligtaqusqelluki."
        },
        "8": {
            "start": 149.2,
            "end": 161.28,
            "transcript": "Tamana pitekluku ernerni makuni nuliqsagutellriit, ernerni makuni amllemni tayima uitacurlagalartut nangyuutaqluteng-llu."
        },
        "9": {
            "start": 161.36,
            "end": 167.72,
            "transcript": "Tamatum, tamatum angayuqameggnek narurcillrata pivkarluki."
        },
        "10": {
            "start": 167.72,
            "end": 177.36,
            "transcript": "Tau͡gaam angayuqameng pisqutiit maligtaqukunegteggu nepaunateng nulirqutarkaugut, maligtaqulluteng ellmegnek."
        },
        "11": {
            "start": 177.44,
            "end": 184.48,
            "transcript": "Nulirqucaraq, nulirqucarauguq atunem maligtaquuraulluni narurtaarutevkenani."
        },
        "12": {
            "start": 184.48,
            "end": 193.44,
            "transcript": "Tuaten pilria, tuaten pilriit atunem ellmeggnun maligtaquurautellriit qinuunateng uitalartut."
        },
        "13": {
            "start": 193.52,
            "end": 198.94,
            "transcript": "Tua-i-llu cali unguvainanermeggni irniangameng nutaan mulngakluteng."
        },
        "14": {
            "start": 198.94,
            "end": 213.52,
            "transcript": "Ellmegnun nutaan mulngakluteng kenkutlertek irniamek ciuqurrani [?] tangvagtellutek pillmegnun qancurlagatevkenatek pillagatevkenatek-llu tau͡gaam maligtaquuraullutek."
        },
        "15": {
            "start": 213.6,
            "end": 226.76,
            "transcript": "Man'a nallunritnarqaat ayagyualriit makuni ernerni nallunritnarqapiaryaaqaat, tau͡gaam arenqiatuq ernerni makuni ayagyualriit umyuarrateng atuamegteki."
        },
        "16": {
            "start": 226.76,
            "end": 234.14,
            "transcript": "Umyuarteng-llu aturluku tan'gaurluut aipaangnaqaqluteng, angayuqameng-llu pisqumanrilengraiceteng."
        },
        "17": {
            "start": 234.14,
            "end": 242.96,
            "transcript": "Tamana pitekluku maa-i kinguqvaarni kassuucimariluteng-llu uitacurlanglartut, kiituani aiparteng-llu unicungaat."
        },
        "18": {
            "start": 242.96,
            "end": 257.6,
            "transcript": "Tau͡gaam wangkuta waten ellilriani qanruquralaryaaqaput tuaten piyunaitniluku kassuusngalleq qigcigngaqngan kassuusngalria-llu kia avusngailaku yuum."
        },
        "19": {
            "start": 257.6,
            "end": 267.46,
            "transcript": "Taumek waniwa tamana pitekluku nallunaingengnaqluku-llu cali nausqumayaaqluku ataam elluarrluni uitayaraq."
        },
        "20": {
            "start": 267.46,
            "end": 282.82,
            "transcript": "Waten makutgun niicugnissuutetgun qalartevkalaraitkut tuaten-llu cali wiinga elluarrlua puqiglua pinrilnge'rma tau͡gaam ellaita piyullermeggnek maa-i qalartevkalaraitkut."
        },
        "21": {
            "start": 282.82,
            "end": 294.52,
            "transcript": "Taumek waniwa makut niicugniller', kia imum niicugnikuniki murilkeqapiarluki tua-i-llu cali umyuarteqluni ilumun tuaten pikuni."
        },
        "22": {
            "start": 294.52,
            "end": 308.86,
            "transcript": "Uitanqegcineq assilria atunem kenkut neq assilria atuqunegteggu elluarrluteng uitaarkaucirteng irniateng-llu qinuunaki anglivkararkaucia tangvagluku."
        },
        "23": {
            "start": 308.86,
            "end": 321.54,
            "transcript": "Ernerni makuni uitacurlagnek [?] amlleriata wangkuta imum ayagyuallemteńi makunek nunam piinek akusrarnarqellrianek pitaitellruuq watqapik."
        },
        "24": {
            "start": 321.54,
            "end": 330.94,
            "transcript": "Akusrarqurluteng-llu piyuunateng wall'u cali imkunek makunek tiiviinek pitailan."
        },
        "25": {
            "start": 330.94,
            "end": 341.54,
            "transcript": "Tuaten cali tiiviitgun arcaqerluteng maa-i mikelnguut makut elluarrlunri' pinritlerkameggnek elicungcaumaut."
        },
        "26": {
            "start": 341.54,
            "end": 353.58,
            "transcript": "Elicungcaumaciicetun-llu ak'a niitaqluki tiiviit ayuqeliluki tuaten piniluki wall'u cali ilateng akngirqaqluki ayuqeliluki tangvallerni."
        },
        "27": {
            "start": 353.58,
            "end": 366.6,
            "transcript": "Tamana pitekluku nulirqellriik qinuunakek tamakut-llu arcaqakevkenaki anglicarisqumalaryaaqeng'e'rmi arenqialnguq umyuarteng aturluki ellaita pilaamegteggu."
        },
        "28": {
            "start": 366.6,
            "end": 379.24,
            "transcript": "Cali-llu nulirtuquralriit ukuk ellmegnun cali ikayuutarkauguq, ikayuuqurluteng aipaqellriit qinuitut."
        },
        "29": {
            "start": 379.24,
            "end": 389.46,
            "transcript": "Angutem nuliani pinialan pisciigalkainek taqsurrniluni qaneqsaunani caliarkaulartuq."
        },
        "30": {
            "start": 389.46,
            "end": 400.9,
            "transcript": "Tuamta-llu cali arnam uini cali natmun-llu ayaumaaqan kinguani cat piqcaarallerminiki tekitarkaucia-llu nallunrilkuniu."
        },
        "31": {
            "start": 400.9,
            "end": 415.08,
            "transcript": "Yuilqumi-llu pektellrukan upingatarkaugaa, neqkaanek ena-llu cali unitaarpek'naku, nayurtuarluku upingalluku tekiskuni nerrlerkaa tamana upingalluku."
        },
        "32": {
            "start": 415.08,
            "end": 431.26,
            "transcript": "Tuaten pilriit, tuaten pilriit qinuunateng uitaarkaugut tau͡gken, tau͡gken imumek aipaan arnam aipaani ayaumaluku nenii unitaarturqani."
        },
        "33": {
            "start": 431.26,
            "end": 438.36,
            "transcript": "Nunaniqluku tekitenrilkuni nengelmun-llu itquni quyangaituq qusnginanermini."
        },
        "34": {
            "start": 438.36,
            "end": 451.36,
            "transcript": "Tamana pitekluku qanrucimalallruukut wangkuta waten ellilriani aipangkumta yugnun ullagatevkenata nerr'arput nayurtuaralaasqelluku."
        },
        "35": {
            "start": 451.36,
            "end": 471.1,
            "transcript": "Irniaput ilakluki tuaten pikumta elluarrluta uitaarkauniluta cali-llu aulukuralput neqkat-wa-llu akluput makut elluarrluki aulukurqumteki uitacurlagmek imangqerrnarqerkaunritniluki."
        },
        "36": {
            "start": 471.1,
            "end": 482.4,
            "transcript": "Cali-llu ernerni makuni maa-i cimirpagtuq au͡gna wangkuta-ll' ayuquciqlemta nalliini tangvaurallerput cimirpagtuq."
        },
        "37": {
            "start": 482.4,
            "end": 492.0,
            "transcript": "Tua-i-wa makut irniaput wangkuta ayagluteng-llu elitnauryaryaurcata elitnauryaryaurcameng."
        },
        "38": {
            "start": 492.0,
            "end": 502.56,
            "transcript": "Ilii-llu tayima utertenritaqluni tan'gaurluum wall' nasaurluum elliin umyuarani aturluku uingluni wall' nunulirturluni."
        },
        "39": {
            "start": 502.56,
            "end": 516.58,
            "transcript": "Tau͡gaam tuatnang'e'rmeng angayuqameggnek quyanarqeksaitut, quyanarqeksailucia iquat kinguqvaarni, kinguqvaarni avvutaaluugutkaa tamana."
        },
        "40": {
            "start": 516.58,
            "end": 530.94,
            "transcript": "Makuni Yup'ik-llu, Yup'ik-llu tau͡gaam aipangarkauyaaquq Yupiullgutminek wangkuta avani ciuqvani nasaurluullemteńi inerquusngallruukut."
        },
        "41": {
            "start": 531.12,
            "end": 545.48,
            "transcript": "Inerquusngallruukut akemkumiungung'e'rmeng-llu inerqulallruitkut yaaqvani yuurtellernek umyuar' pisqevkenata, akurturilarasqevkenata."
        },
        "42": {
            "start": 545.48,
            "end": 557.94,
            "transcript": "Taumek wangkuta maani ciuqvaarni yuullerni tuaten pillrunrilamta amlleq nuyangqenrituq kavirlinek avani ciuqvani."
        },
        "43": {
            "start": 557.94,
            "end": 566.66,
            "transcript": "Tau͡gaam ernerni makuni imkut tegganerullret tamatum nalliini angukara'urluut arnassagaat-llu."
        },
        "44": {
            "start": 566.66,
            "end": 578.7,
            "transcript": "Qalartellrat aturluku maa-i, maligtaqutengameng makunun aipaqenrilkemeggnun man'a nunarrarput man'a Alaska-q."
        },
        "45": {
            "start": 578.7,
            "end": 587.62,
            "transcript": "Maa-i yungluni nuyalegnek kavirlinek-llu amllenrurteqatangluteng maa-i tuaten ayuqelriit."
        },
        "46": {
            "start": 587.62,
            "end": 598.66,
            "transcript": "Tau͡gaam wangkurlumta Yupiani ayuqucirput qenarqenritarput [?] pingnatugallerput-llu piqcaarturallerput pegcunaitarput."
        },
        "47": {
            "start": 598.66,
            "end": 615.26,
            "transcript": "Tarrilkerrlainarluta wangkuta ilamteńun-llu cali piarkaugukut. Ilaput-llu tuaten cali wangkucicetun qalarutaqluki nepailutevkenaki ayagyuanrilriim waten ellilriim."
        },
        "48": {
            "start": 615.26,
            "end": 624.56,
            "transcript": "Ayagyuat nepailucunaitai, ellmeggnek umyuarteng aturluku piurquneng elluarrluteng pingailata."
        },
        "49": {
            "start": 624.56,
            "end": 641.08,
            "transcript": "Taumek ayuqucirtualuki, nerengnaqsaram-llu mat'um Yupiim nerengnaqsaraa nalluvkarpek'naku, cali-llu pingnatullerkaat, canek-llu pingnatugcuucillerkaat nalluvkayunaunani."
        },
        "50": {
            "start": 641.08,
            "end": 648.16,
            "transcript": "Tuaten pikuneng elluarrluteng, elluarrluteng pektarkaungata piituravkenateng-llu."
        },
        "51": {
            "start": 648.16,
            "end": 663.18,
            "transcript": "Amllemi-llu maa-i ernerni makuni tamatum maligtaqutenritellrata qanermek qalarucetmeggnek-llu narurcillrata piiturallerkaatnun tekiucetaqluki."
        },
        "52": {
            "start": 663.18,
            "end": 673.22,
            "transcript": "Taumek waniwa man'a ukut-am qalarcesqellrat imiisqellrat tua-i waniw' pitacirramtun cali imirluku."
        },
        "53": {
            "start": 673.22,
            "end": 687.18,
            "transcript": "Arcaqanruan una nulirqellriik, nulirqellriik teguterraanermeggnek kassuutellertek qigcikluku yuugarkaungagnek ellmegnun tau͡gaam maligtaquuraulluteng."
        },
        "54": {
            "start": 687.18,
            "end": 705.18,
            "transcript": "Maligtaquurauskut aipartek ataniravkenaku, tau͡gaam aipaani ataniqataquniu maqariluku atunarput cali-llu aperturluku qanrutekluku tuaten pikuni tamana tau͡gaam elluaturqenruarkauluni."
        },
        "55": {
            "start": 705.18,
            "end": 724.18,
            "transcript": "Cali makut ayagyuaput tuatelliarpek'naki angliringraata taqnerurtengraata irniangengraata cali taqeksaunaki maa-i taqeksaunaki tua-i uumek wani atunarquralriamek elpengcarrlainarluki."
        },
        "56": {
            "start": 724.18,
            "end": 738.92,
            "transcript": "Ernerni makuni qalaruqurarilleq tau͡gaam wangkutngulriani caliarurcaaquq, nallumavkarpek'naki elpekumavkarluku qaillun, qaillun aulukillerkaat."
        },
        "57": {
            "start": 738.92,
            "end": 752.52,
            "transcript": "Arcaqerluni-llu waniwa una wangkuta Yupiarulriani qalarutkumalartuq wangkutnun makut maa-i-am kiagullrani neqet akiinateng kuimalriit."
        },
        "58": {
            "start": 752.52,
            "end": 767.38,
            "transcript": "Kia im'um tegukaki, angutem tegukaki elliin ulligtaarluki kinyunarcarciigatai ak'a caperrnarqellriamek unaken atrarluni kuigmek aqvallruamiki."
        },
        "59": {
            "start": 767.38,
            "end": 781.8,
            "transcript": "Tau͡gaam nulirrulriim, irniani-llu piyugngarikata ilagarluki tamakut tau͡gaam tamaa-i ikayurrluteng kineryugnarikunegteki cali elluarrluki kinercetengnaqluki."
        },
        "60": {
            "start": 781.8,
            "end": 790.6,
            "transcript": "Apqemteńek-llu makunun paralunun pivkarpek'naki, naanguarutqevkarpek'naki wall' ciivagnun."
        },
        "61": {
            "start": 790.6,
            "end": 798.66,
            "transcript": "Tua-i kesianek cali carrirturyarauluteng kinertenrilnguut-llu cali kinllerkaatgun aulukluki."
        },
        "62": {
            "start": 798.66,
            "end": 811.18,
            "transcript": "Nutaan-llu puyurtellerkaatnun itqata aruliaruteksaunaki, qavarput arcaqakevkenaku neqka tau͡gaam kitugillerkaat kiaguaqan tarilkelaraput."
        },
        "63": {
            "start": 811.18,
            "end": 819.52,
            "transcript": "Irniaput wall'u tutgaraput wangkuta tutgaralingelriani aqsaqucuayagii pitekluku."
        },
        "64": {
            "start": 819.52,
            "end": 828.68,
            "transcript": "Waniwa amllemi maa-i elicamta wangkuta Yupiarulriani ner'a kinertellria cataicunailan."
        },
        "65": {
            "start": 828.68,
            "end": 848.92,
            "transcript": "Elitnaullermeggnek-llu utertaqameng ilait, nerlaryaaqeng'e'rmeng elitnaurvigmi tau͡gaam camiqenrilamegteki tuani nerellrat nutem neqnek home-ameggni neqkenrilamegteki egmianun ilii it'lartuq kinertaamek neqmek neryugluni."
        },
        "66": {
            "start": 848.92,
            "end": 863.22,
            "transcript": "Tamana pitekluku piyuumiutek'laraput waten-llu wangkuta ellilriani calirpagciigalingramta qanemteggun tau͡gaam tua-i caliluta, ca-qaa nerput kesianek caliurtelluku."
        },
        "67": {
            "start": 863.22,
            "end": 874.5,
            "transcript": "Kia imum maligtaqukuniu tamana maligtaquluku piqtarturquni auluklerminek quyaarkaulartuq quyaqapiaralararkaulartuq."
        },
        "68": {
            "start": 874.5,
            "end": 887.02,
            "transcript": "Waniwa cali ernerni makuni amlleret ayagyuanun nasvaumanrit'lartut kaillerkaat neqkaitellerkaat pitekluku."
        },
        "69": {
            "start": 887.02,
            "end": 902.9,
            "transcript": "Yupiat imkut nallunge'rmeng qatellrianek qalarustestenqenrileng'e'rmeng waten qanlallruata elluarrluku neqa aulukuralaasqelluku, cipnirluku, cipnirluku."
        },
        "70": {
            "start": 902.9,
            "end": 912.5,
            "transcript": "Waten qanerluteng, allrakut-gguq ayuqsuitut, ilii-gguq allrakum uksuumallerminek kiagnacialartut."
        },
        "71": {
            "start": 912.5,
            "end": 925.22,
            "transcript": "Tua-i-gguq tamaa-i elluarrluteng neqkanek aulukinritellret, wall'u angutet aqvaqurrinritellret neqkanek neqnek kuimalrianek nurilmun [?] aulukellret."
        },
        "72": {
            "start": 925.22,
            "end": 934.88,
            "transcript": "Tamaa-i-gguq tamakut nurutaqameng nasperturluteng-llu qaillukuanglartut pikenrilnge'rmegteki-llu tegutaangluteng."
        },
        "73": {
            "start": 934.88,
            "end": 944.34,
            "transcript": "Tau͡gaam tamana pitekluku maaten wangkuta murilkukut avani mikelnguullemteńi waten ellilriarulriani wangkuta."
        },
        "74": {
            "start": 944.34,
            "end": 957.6,
            "transcript": "Tamana kesianek qalarutek'laraat unangellerteng amrukevkenaku, unangtateng elluarrluki aulukesqelluki, cali-llu elluarrluki qemaggluki."
        },
        "75": {
            "start": 957.6,
            "end": 975.66,
            "transcript": "Qanrucimalaameng waten ilaci nuruskata elpeci avegvingqerquvci nurutellrit piilnguut wall'u imkut aipainrulriit kevgailnguut tan'gaurlurmek angusagtekamegnek."
        },
        "76": {
            "start": 975.66,
            "end": 994.88,
            "transcript": "Irniarilnguut tamakut cali cikiqaqullerkaat pitekluku amlleringraan neqa man'a nugtesqumalaraat wii avani au͡gkut imkut maurlullramta-llu ap'amta-llu qalartelallrit maa-i qalarutek'laraput."
        },
        "77": {
            "start": 994.88,
            "end": 1006.14,
            "transcript": "Tuaten pikuneng elluarrluteng piarkaungata, takumcutaucirteng-llu nasvagluku piilnguut pikaitnek cikiumaaqluki."
        },
        "78": {
            "start": 1006.14,
            "end": 1020.28,
            "transcript": "Nurucuunateng tuaten piuralriit pikailngurnun imkunun elliraulrianun avani ciuqvani elliraulriit aulukumallrunrilata canek nalluluteng yuullruata."
        },
        "79": {
            "start": 1020.28,
            "end": 1038.32,
            "transcript": "Tamakut cali neqkaitgun aulukiurallret uumiani neqkanek-llu pingnatugaqameng apqiitnek makut Kass'acetun qanelriit lucky-rluteng pilartut piluaqaquluteng Yugcetun aperluku."
        },
        "80": {
            "start": 1038.32,
            "end": 1048.12,
            "transcript": "Pingnatugaqameng piluaqaquluteng yuilqum neqkautainek unungssiarnek unanguuqaqluteng."
        },
        "81": {
            "start": 1048.12,
            "end": 1066.94,
            "transcript": "Ellaita nall'aramegteggun atuyuitellruut atuyuilucimegcetun tau͡gaam imkunun takumcunarqellrianun piyuumilrianun nerqeryuumilrianun-llu tamakunek ilangarquralaamegteki."
        },
        "82": {
            "start": 1066.94,
            "end": 1086.5,
            "transcript": "Waten qanrucimalallruameng ilangartaarturluki tamakunun neqkaten neqkat aulukelput pilaqumteki amllenermeggnek-gguq atam, amllenermeggnek-gguq atam cimingelarniartut."
        },
        "83": {
            "start": 1086.5,
            "end": 1097.44,
            "transcript": "Tamana-llu piciuguq maa-i wiinga tangvaurallemni ca ikgelngaqaarluni, tua-i mat'umun-llu uksumun engelqeruaqluni."
        },
        "84": {
            "start": 1097.44,
            "end": 1112.1,
            "transcript": "Umyugailkarulluki-llu aulukevkenaki, maa-i ellangamta, elpengamta, agayumacirkamteńek, piicagyaraq tegumiaqluku."
        },
        "85": {
            "start": 1112.24,
            "end": 1135.28,
            "transcript": "Waniwa neqaraput makut qemagtaqamteki, qemagterraarluki ilkartenqegcaararraarluki, umyugailkarutevkenaki cali piicautelaamteki, waten-llu wangkuta arnaulriani nall'aramteggun teguliaralaamteki qemagcisteńguamta arnaulriani wangkuta."
        },
        "86": {
            "start": 1135.28,
            "end": 1150.74,
            "transcript": "Qaqitenqegcaararqata tau͡gaam natmun qemagviatnun engelkarcimariaqata, kaigat'laamteki uksurpall'e'rmi kaigarkami aturarkaukumteki engelqerruluki aturyuumirluki."
        },
        "87": {
            "start": 1150.74,
            "end": 1163.74,
            "transcript": "Tang elliinginaq' kaigavkariyuilami aulukesteput au͡gkut ciuqlimta nallungermegteggu ap'lallrulliniluku ellam yuanek nallungermegteggu cunaw'."
        },
        "88": {
            "start": 1163.74,
            "end": 1180.2,
            "transcript": "Tua-i tuaten tamana qigcikngamegteggu tuaten cali amllemek unangellrunrilngermeng uksumun engelqerrulluki iliini-llu cipluteng amllermek."
        },
        "89": {
            "start": 1180.2,
            "end": 1192.98,
            "transcript": "Tamana cakneq quyanarqeqapiaralartuq alaitaqami wangkutnun man'a kia imum niiskuniu arnaulkutma-llu ayagyualriim ayagyuanrilngermi."
        },
        "90": {
            "start": 1192.98,
            "end": 1207.0,
            "transcript": "Umyuaqluku auluk'larnaurai aulukestengulriim auluk'larnaurai qinuilutevkenaki qalartevkenani-llu tuaten pillrungraaki."
        },
        "91": {
            "start": 1207.0,
            "end": 1222.46,
            "transcript": "Waniwa man'a neqkam piitellra angnirnarqenrituq. Nulirqellriignun-llu angnirnarqengaunani irnialegnun. Irniatek piinatek neqmek qemagtaarunatek."
        },
        "92": {
            "start": 1222.46,
            "end": 1229.5,
            "transcript": "Kaigakata, kiituani kaigem ugaani qiangut-llu mikelnguut qiangelartut kaigaqameng."
        },
        "93": {
            "start": 1229.5,
            "end": 1242.02,
            "transcript": "Tua-llu-qaa tamana agalkarrlutek neqnek qemagcillrunrilkunek elluarrluku-qaa tamana angnirnaqluku aturciqaak aturngaitaak."
        },
        "94": {
            "start": 1242.04,
            "end": 1261.92,
            "transcript": "Kiituani nasperturlutek naken, nalluatni-llu tegutaangarkauguq. Tamana pitekluku qalarucimalallruukut neqkaq elluarrluku aulukesqelluku qemaggluku-llu elluarrluku."
        },
        "95": {
            "start": 1261.92,
            "end": 1270.98,
            "transcript": "Makunek maa-i watua wii qalaruteksuumilallemnek man'a ukut imiisqellrat imiiraqa."
        },
        "96": {
            "start": 1270.98,
            "end": 1284.98,
            "transcript": "Cali-llu mikelnguut makut angliyugallratni tatamqevkenaki, inerquusngaaqluteng qasturalluki qalarutesqevkenaki."
        }
    },
    "GfqAsQzt9iQ": {
        "1": {
            "start": 137.24,
            "end": 139.24,
            "transcript": "(Ayagniryukuvet-gguq.)"
        },
        "2": {
            "start": 139.24,
            "end": 142.71,
            "transcript": "Yaa."
        },
        "3": {
            "start": 142.71,
            "end": 150.59,
            "transcript": "(Nacatek tau͡gaam avaqeryugatek? Nacatek.)"
        },
        "4": {
            "start": 150.59,
            "end": 152.24,
            "transcript": "Tua-i-qaa?"
        },
        "5": {
            "start": 152.24,
            "end": 153.42,
            "transcript": "Ayagniqaa."
        },
        "6": {
            "start": 153.42,
            "end": 161.82,
            "transcript": "Wiinga Marie Meyers-aaruunga. Yugcetun atrenka amllerrsaaqut. Luqipatamek [?] pilaraatnga."
        },
        "7": {
            "start": 161.82,
            "end": 168.7,
            "transcript": "Au͡gkut-wa acama. From Pilot Station."
        },
        "8": {
            "start": 168.7,
            "end": 175.96,
            "transcript": "Akaurtuq ak'a maurluni uitauratullruunga, miklua maamaka catairutellrani."
        },
        "9": {
            "start": 175.96,
            "end": 190.025,
            "transcript": "Maurluqa imkunek piaqan murilkelallruaqa king salmon-at amiitnek kiagmi."
        },
        "10": {
            "start": 190.025,
            "end": 197.975,
            "transcript": "Seggaarluni, amiirluni, kinercirluku-ll' amiq."
        },
        "11": {
            "start": 197.975,
            "end": 210.12,
            "transcript": "Kinercirraarluku-llu, iterciami cali itrulluku puyurqelluku. Fish-anun ilakluku mamterami."
        },
        "12": {
            "start": 210.15,
            "end": 222.59,
            "transcript": "Amllernek-ll' puyurkarcuunateng, qagkenka ma [?] uqirluni unaken atertlernek muragnek ellminek puyiraqluku mamteraq."
        },
        "13": {
            "start": 222.59,
            "end": 228.175,
            "transcript": "Tangvaurlallruaqa wii murilkelluku ikayungnaqluku."
        },
        "14": {
            "start": 228.175,
            "end": 239.03,
            "transcript": "Quyaklaanga-ll' ikayuqa'arqamni, umyuaqa piniriqertaqluni nanrarqanga."
        },
        "15": {
            "start": 239.03,
            "end": 252.538,
            "transcript": "Tua-i amiirraarluki tamakut. Itrutaitenrit [?] pingqerrsaaqua amiirumalrianek neq'akenritaqa tamakunek pingaicukluki."
        },
        "16": {
            "start": 252.538,
            "end": 265.83,
            "transcript": "Atrarrluki tamakucit aqsaita au͡g'arluki amirpall'er mingqeńaurai tapluki."
        },
        "17": {
            "start": 265.89,
            "end": 271.5,
            "transcript": "Mingqerraarluku-ll' acia cali allungalirluku."
        },
        "18": {
            "start": 271.5,
            "end": 279.24,
            "transcript": "King salmon-at tau͡g' eggs-ait katurrluki mamterami uitaurcelluki."
        },
        "19": {
            "start": 279.24,
            "end": 287.082,
            "transcript": "Egnenga'arcata-ll' nutaan tauna mingqerraarluku tamakunek imirluku."
        },
        "20": {
            "start": 287.082,
            "end": 294.06,
            "transcript": "Kinerciqerraarluki ernerpak unuakumi anlluki muriim qaingani, akertemun pivkenaki."
        },
        "21": {
            "start": 294.06,
            "end": 300.6,
            "transcript": "Apiatam kinguani-ll' mumiggluki qaingit kinqercelluki."
        },
        "22": {
            "start": 300.6,
            "end": 310.575,
            "transcript": "Atakuan-ll' tua-i tuavet mingqellminun qemaggluki. Makunek maa-i mingqutnek aturlallruut."
        },
        "23": {
            "start": 317.7,
            "end": 325.91,
            "transcript": "Wiinga imkunun mingqessuutek'larqa taperrnat waniwa."
        },
        "24": {
            "start": 325.91,
            "end": 335.95,
            "transcript": "Tua-ll' akertemun cali pivkenaku cellametevkarpek'naku-ll' mam' kenillrem [?] mengliini keluqvagmi uitaurcetnauraa."
        },
        "25": {
            "start": 335.95,
            "end": 342.91,
            "transcript": "Air-anglallian cami tayima elcetaqluku."
        },
        "26": {
            "start": 343.11,
            "end": 355.275,
            "transcript": "Tua-llu pinariata qemarqingameng nutaan upaglallruamta pavaken Curartalegmek."
        },
        "27": {
            "start": 355.275,
            "end": 360.24,
            "transcript": "Qemarqingami nutaan tauna-ll' qemaggluku."
        },
        "28": {
            "start": 360.24,
            "end": 366.99,
            "transcript": "Tuam kellulluku kumlamun pivkarpek'naku cellametevkarpek'naku."
        },
        "29": {
            "start": 366.99,
            "end": 375.24,
            "transcript": "Uksumi tua-i arucetaartuuman pilagturluku nernauraat."
        },
        "30": {
            "start": 375.24,
            "end": 381.0,
            "transcript": "Wiinga tua-i tangvaglallemtun cali maa-i tuaten pililartua."
        },
        "31": {
            "start": 381.0,
            "end": 386.98,
            "transcript": "Eggs-at quyurqaarluki amiirraarlua."
        },
        "32": {
            "start": 386.98,
            "end": 392.05,
            "transcript": "(Qemaggvigkiurluki-qaa tamakut amiit?) Yaa."
        },
        "33": {
            "start": 392.05,
            "end": 398.038,
            "transcript": "Cali pilugulillruaqa un' ataucirqumek irnianka mikluki."
        },
        "34": {
            "start": 398.038,
            "end": 404.07,
            "transcript": "Tangvallruamku tuaten pilugugkanek pillrani tuaten elliicetun."
        },
        "35": {
            "start": 404.07,
            "end": 412.99,
            "transcript": "Teq'umun tau͡gaam akurtevkenaki wii, iqairrassuutmun kenilluki iqairraarluki, cellamun-llu agarrluki."
        },
        "36": {
            "start": 413.02,
            "end": 420.17,
            "transcript": "(Taivluki-llu-qaa? [?]) Kinerngata-ll' qeltait makucikun au͡g'arluki."
        },
        "37": {
            "start": 420.21,
            "end": 429.05,
            "transcript": "Au͡g'arraarluki-ll' nutaan assiriata ulukcaararraarluki mingeqluki piluguliluki."
        },
        "38": {
            "start": 429.05,
            "end": 440.13,
            "transcript": "Una ataucirqumek pilillruaqa. Au͡gna-ll' qetunracuarpuk mikluku kinguqlikacaaraat imkut."
        },
        "39": {
            "start": 440.13,
            "end": 444.67,
            "transcript": "King salmon-aunrilnguut, teggmaarrluut, canek pilarceciki maani. (Kangiqneret.)"
        },
        "40": {
            "start": 444.67,
            "end": 449.24,
            "transcript": "Yaa, tamakut piitnek pililallruaqa mikellrianek amiirraarlua."
        },
        "41": {
            "start": 449.24,
            "end": 458.13,
            "transcript": "(Piluguliaqavki tamakut neqet amiit canek nat'rilarcecitki?)"
        },
        "42": {
            "start": 458.13,
            "end": 460.83,
            "transcript": "Imkunek au͡gkunek nat'ranek. (Oh, nat'raq?)"
        },
        "43": {
            "start": 460.83,
            "end": 464.24,
            "transcript": "Yaa, yualukaitnek-ll' yualukalirluki."
        },
        "44": {
            "start": 464.24,
            "end": 475.24,
            "transcript": "Tau͡gaam kellutnarqut tamakut. Matnermek pikuneng mecungkan egmian uutulriit. Kelluqerluki tua-i makaarnun aturlarait."
        },
        "45": {
            "start": 475.24,
            "end": 480.24,
            "transcript": "Tuaten pia tangvallemtun pilillruunga wii, una-ll' pililuku."
        },
        "46": {
            "start": 480.24,
            "end": 483.15,
            "transcript": "Maa-i tau͡gaam cali pililartua tamakunek."
        },
        "47": {
            "start": 483.15,
            "end": 487.24,
            "transcript": "Fish eggs-at caquliluki qemaggluki."
        },
        "48": {
            "start": 487.24,
            "end": 491.77,
            "transcript": "Kiagpak tau͡gaam pinritua. Amiillruyaaqua."
        },
        "49": {
            "start": 491.77,
            "end": 497.62,
            "transcript": "(Metuyuitelartut-qaa mecungnami?) Ai? (Metuyuitelartut-qaa mecungnarqaqan?)"
        },
        "50": {
            "start": 497.62,
            "end": 501.24,
            "transcript": "Naamell'. Mecunglallrulilriik uum pilug', mecunglall'."
        },
        "51": {
            "start": 501.24,
            "end": 510.46,
            "transcript": "Mecungtuyaaquk tau͡gaam kinqatuuk atunge'rmeng, kinqengir' [?]. Uqiggetqapigtell' ellamun aturturallrit."
        },
        "52": {
            "start": 510.46,
            "end": 517.13,
            "transcript": "Metuyuitellrit apcugnarquten. (Yaa.) Metuyuitut allganengvailegmeng."
        },
        "53": {
            "start": 517.13,
            "end": 527.75,
            "transcript": "Arillukuratullruaput-llu anguarunani imarpigmi. Anguarcuutekluki."
        },
        "54": {
            "start": 527.75,
            "end": 532.1,
            "transcript": "Maa-i tau͡gaam cali makunek piyaurtukut."
        },
        "55": {
            "start": 532.1,
            "end": 539.11,
            "transcript": "Ukuk kiistenka [?] taitellruanka. Cakaill' imkut tayim' paivnganrilata malikevkenaki taillruunga."
        },
        "56": {
            "start": 544.21,
            "end": 550.24,
            "transcript": "Tua-i taumek tuaten pitullruuq taun' maurluqa."
        },
        "57": {
            "start": 550.24,
            "end": 556.68,
            "transcript": "Daddy-qa pilitullrukii iqtunrani-w' ukut."
        },
        "58": {
            "start": 556.68,
            "end": 563.07,
            "transcript": "Wiinga tua-i amllermek qanemcikaitua watua."
        },
        "59": {
            "start": 563.07,
            "end": 566.3,
            "transcript": "Taumek tang tua-i tuaten pilallemnek."
        },
        "60": {
            "start": 566.3,
            "end": 575.55,
            "transcript": "(Kakiviik taukuk malikellregken, canek imangqelallritnek apertuuteqerkut.) (Anlluki.)"
        },
        "61": {
            "start": 575.55,
            "end": 579.24,
            "transcript": "Maa-i-w' makunek imangqerlalriit."
        },
        "62": {
            "start": 579.24,
            "end": 587.7,
            "transcript": "Yualukautenka cali unitellinianka."
        },
        "63": {
            "start": 587.7,
            "end": 596.77,
            "transcript": "Makunek-wa tua-i yualirlartua wii."
        },
        "64": {
            "start": 596.77,
            "end": 601.14,
            "transcript": "Ukunek-ll' cet'rissuucirlua."
        },
        "65": {
            "start": 601.14,
            "end": 604.99,
            "transcript": "Ipgiarutaqan uukun aturlartua uluaqa."
        },
        "66": {
            "start": 604.99,
            "end": 608.28,
            "transcript": "Tua-i taukut aturcuutait."
        },
        "67": {
            "start": 608.28,
            "end": 613.61,
            "transcript": "Taum [?] nat'rarcuutek'larqa makunek-llu mingqessuutekluku."
        },
        "68": {
            "start": 620.16,
            "end": 631.01,
            "transcript": "Tua-i-qaa? (Tauna kum', thimble-aam aipaa, yaa, camek pilimaa?)"
        },
        "69": {
            "start": 631.04,
            "end": 634.81,
            "transcript": "Leather-auguq. (Leather-auguq.) Yaa."
        },
        "70": {
            "start": 634.81,
            "end": 639.24,
            "transcript": "Taperrnanek pissuutek'larqa una."
        },
        "71": {
            "start": 646.2,
            "end": 654.78,
            "transcript": "Makut maa-i kangrita kep'arteqerrit [?] ingkut piit."
        },
        "72": {
            "start": 654.78,
            "end": 661.0,
            "transcript": "Kangrita parteraq'larait makut."
        },
        "73": {
            "start": 661.0,
            "end": 664.72,
            "transcript": "Tua-i taukut atuut', aturlallrenka."
        },
        "74": {
            "start": 665.65,
            "end": 668.75,
            "transcript": "Ca-llu?"
        },
        "75": {
            "start": 673.55,
            "end": 684.87,
            "transcript": "(Pililartuten-qaa tamakunek kakivignek ayuqenrilngurnek?)"
        },
        "76": {
            "start": 684.87,
            "end": 693.24,
            "transcript": "Yaa, ukut catuirutellrem ukut anaaniita pilialqai."
        },
        "77": {
            "start": 693.24,
            "end": 705.24,
            "transcript": "Piliyuumayaaqua wii-llu. Assirtut makut ayagaluni. Katagiyuitut."
        },
        "78": {
            "start": 705.24,
            "end": 711.24,
            "transcript": "Tua-i-qaa? Ca-llu?"
        },
        "79": {
            "start": 712.36,
            "end": 719.24,
            "transcript": "(Taukuk pilugucuaraak cam qecianek, cakuciugak taukuk?)"
        },
        "80": {
            "start": 719.24,
            "end": 721.81,
            "transcript": "Calf skin-auguk ukuk."
        },
        "81": {
            "start": 726.99,
            "end": 739.48,
            "transcript": "(Tua-i-qaa ayagnirlukek mingqellerpekek natiik tayim' ellirta, ca-llu taq'arkauga?)"
        },
        "82": {
            "start": 739.48,
            "end": 746.0,
            "transcript": "Man'a kanglirluku beaver-aamek ataam-llu makucimek."
        },
        "83": {
            "start": 746.0,
            "end": 761.05,
            "transcript": "Man'a-ll' makucilirlaraput kavirlinek imkunek seal skin, caulriit ima, nayirnek maagun pililaraput."
        },
        "84": {
            "start": 761.05,
            "end": 766.06,
            "transcript": "Ataam-ll' nutaan nat'rarluki allamek, naterkamek."
        },
        "85": {
            "start": 766.06,
            "end": 771.09,
            "transcript": "(Murnirluki wangkuta pililaraput, murnirluki.)"
        },
        "86": {
            "start": 771.09,
            "end": 775.24,
            "transcript": "Aterit ayuqsuilameng qaneryaraput."
        },
        "87": {
            "start": 775.24,
            "end": 778.24,
            "transcript": "Cingilerluki (Ilulirnerak-mi cagnek?)"
        },
        "88": {
            "start": 778.24,
            "end": 784.9,
            "transcript": "Waten makut angvalriit pililaranka ilupelirpek'naki. (Ilupelirpek'naki?)"
        },
        "89": {
            "start": 784.9,
            "end": 789.03,
            "transcript": "Caqerpek'naki."
        },
        "90": {
            "start": 789.03,
            "end": 799.688,
            "transcript": "Cali ca? Tua-i? Apyutkairututen. Tua-i-w' quyana."
        },
        "91": {
            "start": 799.688,
            "end": 806.65,
            "transcript": "(Qemagpalegpeki.) (Qemagtenrilki.)"
        },
        "92": {
            "start": 806.65,
            "end": 811.27,
            "transcript": "Elpet makut."
        },
        "93": {
            "start": 811.27,
            "end": 816.24,
            "transcript": "(Piluguum kangranun elliniaran.) Yaa."
        },
        "94": {
            "start": 816.24,
            "end": 823.39,
            "transcript": "Acama alerquallruanga iquciyaramek makucit. Maavet makut ellilaraput."
        },
        "95": {
            "start": 823.39,
            "end": 830.24,
            "transcript": "Man'a mecungterraarluku culunat egenratnek ciumek."
        },
        "96": {
            "start": 830.81,
            "end": 831.92,
            "transcript": "(Taryulegmek.)"
        },
        "97": {
            "start": 831.94,
            "end": 841.588,
            "transcript": "Yaa. Qeturian-llu waten imegluku, man'a-llu umcigtenqegcaarluku pipiarkauvkenani."
        },
        "98": {
            "start": 841.588,
            "end": 844.48,
            "transcript": "Imegturluku tamalkuan."
        },
        "99": {
            "start": 844.48,
            "end": 850.24,
            "transcript": "Culvaamun-llu [?] imgulluku unugpak uitavkarluku."
        },
        "100": {
            "start": 850.24,
            "end": 860.24,
            "transcript": "Unuaqu-ll' pinariam piyungamku anlluku makucikun mer' au͡g'arluku tamalkuan."
        },
        "101": {
            "start": 860.24,
            "end": 865.088,
            "transcript": "Mer'irluku, mer'inqegcaarluku."
        },
        "102": {
            "start": 865.088,
            "end": 870.91,
            "transcript": "Mer'inqegcaararraarluku-ll' nutaan uqurrluku."
        },
        "103": {
            "start": 870.91,
            "end": 872.88,
            "transcript": "(Cam uquanek atularcit?)"
        },
        "104": {
            "start": 872.88,
            "end": 880.94,
            "transcript": "Piciatun. Iqucilallemni nenemraq [?] uquitnek pilallruunga."
        },
        "105": {
            "start": 880.94,
            "end": 883.57,
            "transcript": "Saalaungraan-llu, Wesson oil-aungraan."
        },
        "106": {
            "start": 883.57,
            "end": 896.24,
            "transcript": "Ataam tuaten mingugaarluku kenitellemtun assircaarluku ataam man'a piluku, imqegcaarluku-llu."
        },
        "107": {
            "start": 896.24,
            "end": 902.0,
            "transcript": "Ataam caquluku unugpak uitaurcelluku."
        },
        "108": {
            "start": 902.0,
            "end": 906.35,
            "transcript": "Ataam unuaquani nutaan anlluku."
        },
        "109": {
            "start": 906.35,
            "end": 911.03,
            "transcript": "Petengtevkenaku waten maaggun ulugturluku."
        },
        "110": {
            "start": 911.03,
            "end": 914.6,
            "transcript": "Tamalkuan ulunqegcaarluku."
        },
        "111": {
            "start": 914.6,
            "end": 920.03,
            "transcript": "Ulugturarraarluku waten petenglluku."
        },
        "112": {
            "start": 920.03,
            "end": 931.04,
            "transcript": "Ernerpak calinge'rma qelunge'rma-llu piyungaqamku ullagluku tuaten ulugaqluku."
        },
        "113": {
            "start": 931.04,
            "end": 938.47,
            "transcript": "Kiituani uquq tayim' tamanguq, waten nengingaurcelluku."
        },
        "114": {
            "start": 938.47,
            "end": 948.57,
            "transcript": "Nutaan tamangengan taqengnaqluku, tamalkuan ulugturluku ak'anun, ak'aarnek kinercelluku."
        },
        "115": {
            "start": 948.57,
            "end": 953.425,
            "transcript": "Kinerlartuq ulugturalriani uquq pulaluni."
        },
        "116": {
            "start": 953.425,
            "end": 962.63,
            "transcript": "Nutaan kinrami waten ayuqluni, teggevkenani nengulraluni-llu."
        },
        "117": {
            "start": 962.63,
            "end": 970.76,
            "transcript": "(Canek-llu pililartat malagg'aayarnek, aliimatnek, atkugnun-llu-qaa?)"
        },
        "118": {
            "start": 970.76,
            "end": 982.913,
            "transcript": "Yaa, piciatun aturlaraat malagg'aayamun, atkuut-ll' negilit iluqliq, iluqlikacaaqluku, negilit tungliitnun."
        },
        "119": {
            "start": 982.913,
            "end": 990.69,
            "transcript": "Ciumek man'a, wolverine, wolf-aq-ll' elaqliuluku. Man'a iluqliuluku."
        },
        "120": {
            "start": 990.69,
            "end": 993.57,
            "transcript": "([?]) Ai? Yaa."
        },
        "121": {
            "start": 993.57,
            "end": 1002.82,
            "transcript": "Yaa, maavet-ll' aliimun. Unavet-ll' atkumnun wii iliit ceńek'larqa."
        },
        "122": {
            "start": 1002.82,
            "end": 1006.525,
            "transcript": "Piciatun atutuut makut."
        },
        "123": {
            "start": 1006.525,
            "end": 1013.65,
            "transcript": "Tuaten tua-i pitullruaqa. Kin' pinqegcaarluku murilkelluku pilriani."
        },
        "124": {
            "start": 1013.65,
            "end": 1019.6,
            "transcript": "Kintuut waten nengulralutung-llu, waten tua-i."
        },
        "125": {
            "start": 1019.6,
            "end": 1025.73,
            "transcript": "Watua tau͡gaam pisciigatua naveggaanranek [?] una."
        },
        "126": {
            "start": 1025.73,
            "end": 1032.24,
            "transcript": "Tua-i cali ca?"
        },
        "127": {
            "start": 1032.24,
            "end": 1035.24,
            "transcript": "Tua-i?"
        },
        "128": {
            "start": 1035.24,
            "end": 1041.24,
            "transcript": "Yaa, quyana."
        },
        "129": {
            "start": 1041.24,
            "end": 1044.07,
            "transcript": "(And what else did you guys want her saying?)"
        },
        "130": {
            "start": 1044.07,
            "end": 1047.79,
            "transcript": "(Maybe she could just explain, you know, the tools, your, your...)"
        },
        "131": {
            "start": 1047.79,
            "end": 1053.36,
            "transcript": "(Anturluki.) (Canun atutukait?) (Yaa, nutaan.)"
        },
        "132": {
            "start": 1053.36,
            "end": 1062.1,
            "transcript": "Ukuk waniwa ciumek aturlartut. Elirqissuutekluki."
        },
        "133": {
            "start": 1062.1,
            "end": 1063.65,
            "transcript": "(Camek aterluteng? [?])"
        },
        "134": {
            "start": 1063.65,
            "end": 1072.24,
            "transcript": "Mangautek. Wangkuta Yugcetun mangautek pilaraput. Elirqissuutekluki aturlaraput."
        },
        "135": {
            "start": 1074.4,
            "end": 1088.76,
            "transcript": "Uukun wiinga alngarluki ciumek pirraarluki, uukun-ll' nutaan mangagturluki."
        },
        "136": {
            "start": 1088.76,
            "end": 1098.425,
            "transcript": "Una-llu cali naterkanun elirqissuutekluku. Makut nat'raitnun aturluku."
        },
        "137": {
            "start": 1098.425,
            "end": 1107.24,
            "transcript": "Mangagqurarraarluki naterkat makutgun nat'rarlaraput."
        },
        "138": {
            "start": 1107.57,
            "end": 1112.24,
            "transcript": "Waniwa-llu mingqun. (Ask her to do that again.)"
        },
        "139": {
            "start": 1112.24,
            "end": 1116.86,
            "transcript": "(Okay.) Tua-i-qaa? (Cali uluaq.)"
        },
        "140": {
            "start": 1116.86,
            "end": 1123.6,
            "transcript": "Una waniw' elirqissuutek'lararput nat'ranun, makut piluguut nat'raitnun."
        },
        "141": {
            "start": 1123.6,
            "end": 1134.44,
            "transcript": "Elirqirraarluki mangagqaarluki-llu makutgun nat'rarlartukut makucikun."
        },
        "142": {
            "start": 1134.44,
            "end": 1145.938,
            "transcript": "Makunek aturluta, una, mingqun-llu nat'rarcuutekluku."
        },
        "143": {
            "start": 1145.938,
            "end": 1154.4,
            "transcript": "Una wani taperrnanun mingqessuutekaqa."
        },
        "144": {
            "start": 1154.4,
            "end": 1170.15,
            "transcript": "Waniwa-ll' ukuk. Cali ukugnegun elirqerraarluki, uukun-ll' elirqissuucirluta piluki. Mangagluki."
        },
        "145": {
            "start": 1170.15,
            "end": 1178.488,
            "transcript": "Piqainarcata-ll' nutaan uukun, uukun-llu mingeqluki."
        },
        "146": {
            "start": 1178.488,
            "end": 1185.663,
            "transcript": "Taqngamteki-llu makucimek maaggun pirraarluki, makucimek-llu."
        },
        "147": {
            "start": 1185.663,
            "end": 1195.24,
            "transcript": "Nutaan una call' kangranun aturluku, nugluku, qillrutaqluku."
        },
        "148": {
            "start": 1197.53,
            "end": 1205.563,
            "transcript": "Ipgiarutaqan wii un' uukun ipegcarlallruaqa, apyutkaar, ca ugna, cellissuun."
        },
        "149": {
            "start": 1205.563,
            "end": 1214.675,
            "transcript": "(Qaillun pilartuq cellissuun?) Waten. (Yaa.) Waten aturlallruaqa."
        },
        "150": {
            "start": 1214.675,
            "end": 1217.24,
            "transcript": "Yaa, tua-i-qaa?"
        },
        "151": {
            "start": 1319.82,
            "end": 1326.82,
            "transcript": "(Okay, she can put them away.) (Qemageski-gguq.) Okay."
        },
        "152": {
            "start": 1359.79,
            "end": 1362.63,
            "transcript": "(Tauna-ll' imegyukuvgu.)"
        },
        "153": {
            "start": 1369.21,
            "end": 1374.0,
            "transcript": "Tua-i? (Quyana.) (Quyana.)"
        },
        "154": {
            "start": 1392.65,
            "end": 1395.67,
            "transcript": "(Qantassia, aren.)"
        },
        "155": {
            "start": 1403.23,
            "end": 1405.77,
            "transcript": "(Okay.) Yaa."
        },
        "156": {
            "start": 1406.06,
            "end": 1413.688,
            "transcript": "Wangkuta makut ceńarmiuni maa-i mat'um atra issurit-gguq."
        },
        "157": {
            "start": 1413.688,
            "end": 1417.55,
            "transcript": "Waten ayuqelria issuriq angluni."
        },
        "158": {
            "start": 1417.55,
            "end": 1422.53,
            "transcript": "Cali-ll' mikellrit useqnagnek pituluki waten ayuqluteng."
        },
        "159": {
            "start": 1422.53,
            "end": 1426.425,
            "transcript": "Mikellrit useqnagnek pituluki."
        },
        "160": {
            "start": 1426.425,
            "end": 1435.77,
            "transcript": "Ayuqmeggnek-llu irniangluteng issuriyagarnek-am tamakut mikellrit piaqluki."
        },
        "161": {
            "start": 1435.77,
            "end": 1446.52,
            "transcript": "Makut mikellrit avani canek plastic-aanek, five gallon-aanek canek assigtarkaitetullemteńi."
        },
        "162": {
            "start": 1446.52,
            "end": 1453.89,
            "transcript": "Makut mikellrit qerrurluki allegqapiarraarluki."
        },
        "163": {
            "start": 1453.89,
            "end": 1458.838,
            "transcript": "Ervigluki allganengqerqata-ll' tua-i mingeqluki au͡g'utun."
        },
        "164": {
            "start": 1458.838,
            "end": 1467.77,
            "transcript": "Taperrnarmek-llam au͡g'u' taperrnaq imna akwaugaq, tamakunek call' ilulicirluki nanrutekluku."
        },
        "165": {
            "start": 1467.77,
            "end": 1473.52,
            "transcript": "Qerrurluku tua-i-llu pinarikan uqumek imirluku."
        },
        "166": {
            "start": 1473.52,
            "end": 1479.0,
            "transcript": "Waten qecialaatekluku qamaggun uqunek imirturluku."
        },
        "167": {
            "start": 1479.0,
            "end": 1490.7,
            "transcript": "Tua-i-llu nayiit call' assigtallrit ervigluki, ivrucirkiurluku egcuuna' egqaqiyuitellratni."
        },
        "168": {
            "start": 1490.7,
            "end": 1497.2,
            "transcript": "Ivrucirkiurluki melqurrit eritarturluki."
        },
        "169": {
            "start": 1497.2,
            "end": 1504.24,
            "transcript": "Erviggaarluki melqurrit au͡g'arturluki ivrucirkiurluki."
        },
        "170": {
            "start": 1504.24,
            "end": 1507.66,
            "transcript": "(Theresa, kitugtelaakegg'laku.)"
        },
        "171": {
            "start": 1517.24,
            "end": 1526.24,
            "transcript": "(It didn't sound, it was, I heard just a little crackle but I didn't hear much. It didn't sound like clothes rattling, it's crumpling.)"
        },
        "172": {
            "start": 1526.24,
            "end": 1528.99,
            "transcript": "Is it the battery?"
        },
        "173": {
            "start": 1528.99,
            "end": 1530.46,
            "transcript": "Assirtuq?"
        },
        "174": {
            "start": 1530.46,
            "end": 1532.13,
            "transcript": "(Sounds better now.)"
        },
        "175": {
            "start": 1532.13,
            "end": 1538.66,
            "transcript": "(Assirikanirtuq.) Aa? (Assirikaniuq.) Yaa."
        },
        "176": {
            "start": 1538.66,
            "end": 1546.24,
            "transcript": "Tua-i-llu tamakut ervigluki teq'umun caqutellret."
        },
        "177": {
            "start": 1546.24,
            "end": 1559.24,
            "transcript": "Cali-am una it'gait egtevkenaki arillulikuneng, arillugmun tumakluki."
        },
        "178": {
            "start": 1559.24,
            "end": 1573.22,
            "transcript": "Wangkuta canek caskuit anglanillrunrilamta, canek wii taqukanek-llu ilaitni maani anglanillrunrilamta ella,"
        },
        "179": {
            "start": 1573.24,
            "end": 1580.325,
            "transcript": "iciw' paivngaliqurayuunaki angya', qayatgun piuratullermeggni."
        },
        "180": {
            "start": 1580.325,
            "end": 1586.563,
            "transcript": "Wiinga-llam makut it'gait ellegcuunaki makut."
        },
        "181": {
            "start": 1586.563,
            "end": 1594.59,
            "transcript": "Qavcirqunek-am wii makut-llu it'gaitnek nat'ratullruunga wangnek makut it'gaitnek."
        },
        "182": {
            "start": 1594.59,
            "end": 1603.56,
            "transcript": "Kelugkautullruyaaqlilriit-llu tayima, taqullua an'aqama ivrang'e'rma imangyuunii."
        },
        "183": {
            "start": 1603.56,
            "end": 1613.96,
            "transcript": "Tua-i-ll' kinngengateng iciw' kelugpaulli amat [?] imangqeryukaarangluteng, wagg'uq tua-i aivkangluki."
        },
        "184": {
            "start": 1613.96,
            "end": 1629.51,
            "transcript": "Mermun-llu pikuneng imangesciigaliluteng kenikuneng tamaa-i mingqellret keningan umcigiluteng."
        },
        "185": {
            "start": 1629.51,
            "end": 1640.02,
            "transcript": "Tuamtellu call' mikellrit ervigluki, iciw' makut useqniit, useqnagnek pitukait."
        },
        "186": {
            "start": 1640.02,
            "end": 1649.84,
            "transcript": "Meqcirluki meqkata-llu ilavkugkiurluki pinevkarluku allga' uivluku tua-i ayagaqluni taum."
        },
        "187": {
            "start": 1649.84,
            "end": 1655.76,
            "transcript": "Wangkuta-llu nenguggluku waten uivvaarturcelluku."
        },
        "188": {
            "start": 1655.76,
            "end": 1660.45,
            "transcript": "Uivetmun tua-i tamana ilavkugkiuraqluku."
        },
        "189": {
            "start": 1660.45,
            "end": 1668.825,
            "transcript": "Elleggsukuniu ellegturluku aminaku piyukuniu amililuku."
        },
        "190": {
            "start": 1668.825,
            "end": 1673.24,
            "transcript": "Makut maa-i atuutullruut."
        },
        "191": {
            "start": 1676.24,
            "end": 1687.5,
            "transcript": "Egqaqsuitellratni pilugukluki qerrullikluki au͡gkut."
        },
        "192": {
            "start": 1687.5,
            "end": 1699.83,
            "transcript": "Ciuliamta qerrullikluki pilugukluki pitullruit makut maa-i mikellrit."
        },
        "193": {
            "start": 1699.89,
            "end": 1707.596,
            "transcript": "Irniaritnek-llu pilugungqerraqluteng cap'akirtuyuicetullratni kiagmi angutet kamila'."
        },
        "194": {
            "start": 1707.596,
            "end": 1716.95,
            "transcript": "Wangkuta kamilangqauratullemteńi anguteput-llu pilu'ugtu'rluteng [?], pilu'ugtutullruut [?]."
        },
        "195": {
            "start": 1718.41,
            "end": 1736.28,
            "transcript": "Makut maa-i cait tua-i uquneki', uqut piarkiuraqameng assigtarkiuraqameng unatait-ll' amiirluki, it'gait-llu pamyuuyagait-ll' ingkut call' amiirluki."
        },
        "196": {
            "start": 1736.28,
            "end": 1741.783,
            "transcript": "Assirluki tua-i qerr'urluki ellell'uki."
        },
        "197": {
            "start": 1741.783,
            "end": 1752.62,
            "transcript": "Uqumek imiqataquneng kenilluki keniluaqanrilengraan uquit waten au͡g'arturluki."
        },
        "198": {
            "start": 1752.62,
            "end": 1759.24,
            "transcript": "Ayallamek maakun piluki assirluku call' uquirluku."
        },
        "199": {
            "start": 1763.09,
            "end": 1770.515,
            "transcript": "Tua-i-llu uqunek tamaa-i uqut assigtarkiuqunegteki tuaten."
        },
        "200": {
            "start": 1770.515,
            "end": 1786.33,
            "transcript": "Makut-llu keluit elcutulriit augmek mingukuneng call' keluit imiqaquneng assiriqerrluteng augitnek makut, avani egqaqsuitellruitki."
        },
        "201": {
            "start": 1786.33,
            "end": 1793.557,
            "transcript": "Tua-i makut maa-i avani tayim' ciuliamta qerrulliktullruit."
        },
        "202": {
            "start": 1793.557,
            "end": 1800.804,
            "transcript": "Iciw' allat au͡gkut qerrulliktukait alla yuut, yuut allacetun qantulit."
        },
        "203": {
            "start": 1800.804,
            "end": 1807.24,
            "transcript": "Tamaani-llu tamaa-i ciuliamta makut qerrullikluki pitullruit."
        },
        "204": {
            "start": 1810.52,
            "end": 1815.39,
            "transcript": "(Naliit taqukat nat'raqluk'?)"
        },
        "205": {
            "start": 1815.39,
            "end": 1825.206,
            "transcript": "Amirkat tungunqut imkut qilut aanaita irniaritnek nat'ratuut."
        },
        "206": {
            "start": 1825.206,
            "end": 1839.35,
            "transcript": "Tau͡g' makut qaitnek-llu [?] call' maklassuugarnek, makut ilait p ikaitu͡rlulriani nat'rautuut, makuunge'rmeng-llu nat'ra tau͡gaam makut qungagayuluteng."
        },
        "207": {
            "start": 1839.35,
            "end": 1850.65,
            "transcript": "Tamakuni qungagayunqurrauluteng nayirni, taqukaullgutmeggni makut qungagayuluteng mikliyugluteng."
        },
        "208": {
            "start": 1850.65,
            "end": 1861.24,
            "transcript": "Tua-llu call' tua-i pilu'ugkiuqumteki una kangrit cakneq tua-i cuqluku pilu'ugkiurluku."
        },
        "209": {
            "start": 1863.52,
            "end": 1868.124,
            "transcript": "Ukunek waniw' cuqyutnek waten piluku."
        },
        "210": {
            "start": 1868.124,
            "end": 1873.887,
            "transcript": "Ingna waten ukumek-llu cip'arrluku."
        },
        "211": {
            "start": 1873.887,
            "end": 1879.763,
            "transcript": "Wagg'uq tua-i imangekata-llu uksuarmi ayakata,"
        },
        "212": {
            "start": 1879.763,
            "end": 1893.66,
            "transcript": "pitsaqa'artevkenateng murukat egmian-llu tua-i kangrangiarrluku acitmun ull'areskan mer' angqerrluni qamavet iterpek'nani."
        },
        "213": {
            "start": 1893.66,
            "end": 1898.68,
            "transcript": "Wangkuta tamaa-i alerquatekellruaput tamakut."
        },
        "214": {
            "start": 1898.68,
            "end": 1908.94,
            "transcript": "Aanaka-ll' wii tuqullruan quyatuunga qialua piyutullemnek amllenrilengraata."
        },
        "215": {
            "start": 1908.94,
            "end": 1917.23,
            "transcript": "Cuculuki qialua piyutullruunga tangerkenganka piliquaqata."
        },
        "216": {
            "start": 1917.23,
            "end": 1923.093,
            "transcript": "Tamaa-i aanama-ll' kinguani tuqullran kinguani,"
        },
        "217": {
            "start": 1923.093,
            "end": 1935.18,
            "transcript": "kinguqliqa-llu uksuarmi calingetuut mat'um nalliini teq'umek atkuut-llu call' iqurqelluki."
        },
        "218": {
            "start": 1935.19,
            "end": 1941.47,
            "transcript": "Pilu'ugkiurluteng ivrucirkiurluteng tamaa-i pituut."
        },
        "219": {
            "start": 1944.14,
            "end": 1951.23,
            "transcript": "(Naliit taqukat qayanun amikluki assinrulartat?) Caluki? (Qayanun.)"
        }
    },
    "35X11kzux70": {
        "1": {
            "start": 0.0,
            "end": 4.62,
            "transcript": "(Okay. Ii-i, nutaan, nutaan.)"
        },
        "2": {
            "start": 4.62,
            "end": 13.32,
            "transcript": "Qasgim, qasgim egaleqkakutki makulinrilengraan waten mingqurluku,"
        },
        "3": {
            "start": 13.32,
            "end": 22.42,
            "transcript": "tua-i-ll' taqkan call' avacirluku elliluku. Enet-llu pikaggun egalungqetullratni."
        },
        "4": {
            "start": 22.42,
            "end": 30.75,
            "transcript": "Anuqlirqan, (Qaillun canegmek-qaa waten asuirucinrilengraata?)"
        },
        "5": {
            "start": 30.75,
            "end": 40.56,
            "transcript": "Waten tua-ll' elli', anglanaqluni kanavet qanikcaq-llu ilutii kaimallagaa."
        },
        "6": {
            "start": 40.56,
            "end": 51.07,
            "transcript": "Yukluku, yuk-llu niicuileng'e'rmi egalerkun yaquleyagaat pikuni elliuqaqan [?] yaquleyagaucukluku."
        },
        "7": {
            "start": 57.8,
            "end": 65.58,
            "transcript": "Aliit-llu call' paingit call' mingqekuneng makulirluku."
        },
        "8": {
            "start": 65.58,
            "end": 79.9,
            "transcript": "Canun tua-i call man'a aturmiluni, umcigingnaqluku, taqukanek-llu allgumalrianek mingqekumta tua-i iluliukan mat'umek call' nanerluku, mingqulluku."
        },
        "9": {
            "start": 79.9,
            "end": 87.7,
            "transcript": "(Asuirutkiuraqameng taperrnat-qaa qamna, teggellria qamna au͡g'arraarluku?)"
        },
        "10": {
            "start": 87.7,
            "end": 94.24,
            "transcript": "Teggelriarit pivkenaki qetullriitnek avataitnek."
        },
        "11": {
            "start": 94.24,
            "end": 97.79,
            "transcript": "(Elaqliitnek-qaa?)"
        },
        "12": {
            "start": 97.79,
            "end": 104.77,
            "transcript": "Maa-i man'a akian pikaa, ukaqlian-wa pikaa."
        },
        "13": {
            "start": 104.77,
            "end": 109.42,
            "transcript": "Qetra-wa-gguq man'a pivkenaku."
        },
        "14": {
            "start": 109.42,
            "end": 127.02,
            "transcript": "(Tua-ll'-qaa taukuk, calaqait? Nupullukek? (Usgullukek?) Usgullukek.)"
        },
        "15": {
            "start": 127.02,
            "end": 137.44,
            "transcript": "(Tua-i-ll' tua-i assuirutkaaqluni-llu waten mingqekuniu naniliaqan-qaa call' allamek tuaten...)"
        },
        "16": {
            "start": 137.44,
            "end": 142.91,
            "transcript": "Iquklitaqan allamek cimirluku."
        },
        "17": {
            "start": 142.91,
            "end": 147.26,
            "transcript": "Parrluki tua-i iterrluku una wani."
        },
        "18": {
            "start": 147.26,
            "end": 151.68,
            "transcript": "Maa-i man'a tuaten pimalria."
        },
        "19": {
            "start": 155.95,
            "end": 166.91,
            "transcript": "Nanillruluni tan'gaurluum pikaqellrulliniani una-w' angelriim pikaqellrulliniani takenruurlu'."
        },
        "20": {
            "start": 166.91,
            "end": 170.02,
            "transcript": "Mat'um kelutestai,"
        },
        "21": {
            "start": 170.02,
            "end": 177.29,
            "transcript": "Paul John-am anaanakluku aaniin kinguqliqluku yualuk kelukai makut."
        },
        "22": {
            "start": 177.29,
            "end": 191.49,
            "transcript": "Assiirupailegmi tayima tunuarkiurani, una mikelngu' mikellran pikaqelliniani qaill' pitalriamek nanillruurluni."
        },
        "23": {
            "start": 196.33,
            "end": 212.72,
            "transcript": "Imarpigmelnguut imarpigmetla', piicunaunateng-ll' angutet tamaa-i imarpigmi pilriit, piitellerkaq kasngunaqsaaqluni tamakunek, angun ayagasteńi piilkata."
        },
        "24": {
            "start": 216.57,
            "end": 221.6,
            "transcript": "Waniw' un' angelriim pikaqa, una-ll' mikellruluni."
        },
        "25": {
            "start": 221.6,
            "end": 228.74,
            "transcript": "(Kinertaqateng-llu apailegmegteki kenicirraarluki pitungata'...)"
        },
        "26": {
            "start": 228.75,
            "end": 235.99,
            "transcript": "Nutaraugaqameng-wa angkayalalriit tau͡gaam atuqetaarqameng qungangetuut."
        },
        "27": {
            "start": 235.99,
            "end": 241.52,
            "transcript": "Tua-i mermun waten pirraarluku at'aqkait."
        },
        "28": {
            "start": 241.52,
            "end": 246.17,
            "transcript": "Ukucirraarluku qaingit."
        },
        "29": {
            "start": 246.17,
            "end": 250.61,
            "transcript": "(Qaillun-mi mecungekan kinerciqarraarluku-qaa call' piyugnauq.)"
        },
        "30": {
            "start": 250.61,
            "end": 258.0,
            "transcript": "Imegluku ayuqucillranun, qelketalriim ak'anun pikumaaqluki makut."
        },
        "31": {
            "start": 265.34,
            "end": 279.23,
            "transcript": "Uksumi-ll' cali uksuungraan ayaulluki ella qerruskateng tamaa-i all'uki, qaspeteng-wa iluatgun pitullikait wall'u-q' elataitgun wall'u."
        },
        "32": {
            "start": 279.23,
            "end": 281.49,
            "transcript": "(Elataitgun.)"
        },
        "33": {
            "start": 281.49,
            "end": 289.13,
            "transcript": "Makut maa-i-am puqlaq umciameng assirluteng."
        },
        "34": {
            "start": 289.13,
            "end": 298.23,
            "transcript": "(Apqiitnek-llu ekiaqaqamegteki qaspemta iluatnun at'aqluki nengelmi anuqmi-llu.)"
        },
        "35": {
            "start": 298.23,
            "end": 308.9,
            "transcript": "(Tua-i nallunailqerpak tua-i at'ellriani qai uqerrsulingartaqluni cupuguciirrluni nengllirqan wall'u anuqir'.)"
        },
        "36": {
            "start": 308.9,
            "end": 318.1,
            "transcript": "Au͡gkut-wa ciuliaput tayima makunek-llu yualunek waten mingqessuucilallrullilriit."
        },
        "37": {
            "start": 318.1,
            "end": 330.9,
            "transcript": "Maa-i maani assinruluni tuntum yualua wagg'uq uliutii man'a."
        },
        "38": {
            "start": 330.9,
            "end": 341.06,
            "transcript": "Una-wa tua-i tayima au͡g'um-llu ava-i John aturyug' nemrulluni iquagkuk kuvarpacuar [?]."
        },
        "39": {
            "start": 341.06,
            "end": 346.7,
            "transcript": "(Yualukiurqameng-qaa qipiurluteng ciumek pituut?)"
        },
        "40": {
            "start": 346.7,
            "end": 351.38,
            "transcript": "Ciumek qipiurluteng nat'rautektullruluki-llu."
        },
        "41": {
            "start": 351.38,
            "end": 363.38,
            "transcript": "Cali tua-i kiingan keluk yualukluku-gguq tamaa-i piluguliaqameng atkuliaqameng-llu yualukluku nurnarqellrani yualukaq."
        },
        "42": {
            "start": 363.38,
            "end": 372.87,
            "transcript": "(Qip'ikuni-qaa yualukamek malruulukek pilukek? Una ukatmun aipaa-llu.)"
        },
        "43": {
            "start": 372.87,
            "end": 378.86,
            "transcript": "(Qaillun qip'it', aanaka qip'itullruuq yualukiurqami tuaten.)"
        },
        "44": {
            "start": 378.86,
            "end": 390.14,
            "transcript": "Eglirluki-gguq tamaa-i wiinga qialua piyutullru', anir' quyalartua, aanaka tuqullrani anirta qialua piyutullrulliniunga."
        },
        "45": {
            "start": 390.14,
            "end": 396.25,
            "transcript": "Pikaitningraatnga qialua unangengnaqlua piyutullruunga."
        },
        "46": {
            "start": 396.25,
            "end": 403.52,
            "transcript": "Wagg'uq waniw' eglirluku mingqum tua-i imkucirarkaurcelluku."
        },
        "47": {
            "start": 403.52,
            "end": 405.1,
            "transcript": "Man'a maa-i tuncinraq,"
        },
        "48": {
            "start": 405.1,
            "end": 409.22,
            "transcript": "(Qaillun imkucirluni?)"
        },
        "49": {
            "start": 409.22,
            "end": 412.23,
            "transcript": "Eglirluku."
        },
        "50": {
            "start": 412.23,
            "end": 423.99,
            "transcript": "Tua-i-llu cali neviunarqellra pikna aturluku una-llu acia qup'arrluku qip'iluku nutaan nat'rautekiurluni."
        },
        "51": {
            "start": 423.99,
            "end": 433.74,
            "transcript": "Makunun-ll' atutullrullikait tayima pilugugnun, nat'ranun-llu, man'a yualuq."
        },
        "52": {
            "start": 433.74,
            "end": 439.44,
            "transcript": "Man'a tau͡gaam mecunglluku kenilluku yukutarrluku qupurrsunaqluni."
        },
        "53": {
            "start": 451.66,
            "end": 464.92,
            "transcript": "Makut cali yukutar', mingqelriani yukutarcesqumaarluku mecungqurluku akuruterluni mecunglluku mingquryarauluteng."
        },
        "54": {
            "start": 464.92,
            "end": 472.14,
            "transcript": "Mecungqurluki, inglua-llu umcingnaqluteng merignerit'laatekluki,"
        },
        "55": {
            "start": 472.14,
            "end": 479.89,
            "transcript": "ilua ilukluku nallunayunani maa-i man' iluan caarrlua."
        },
        "56": {
            "start": 479.89,
            "end": 493.9,
            "transcript": "Elatiin-w' au͡g'um man'a maa-i ilulirnermelngermi alaiterpagluni una, pivlaakaumallra, qam'um uum kelikavlaagumaqallra."
        },
        "57": {
            "start": 496.46,
            "end": 507.41,
            "transcript": "(Up'nerkaryugnaunaku-qaa teq'iciritullruut allakaan akurrvigkameggnek?)"
        },
        "58": {
            "start": 507.41,
            "end": 518.21,
            "transcript": "Erviginarqetuuq wagg'uq ciilrirluki teq'umun akurrluku ivrucit arillugkait neqet."
        },
        "59": {
            "start": 518.21,
            "end": 528.29,
            "transcript": "Igliit-llu, taqukat iglait, qaraliqercurcelluki qerr'urluki, teq'umun kenitevkarluki."
        },
        "60": {
            "start": 528.29,
            "end": 533.69,
            "transcript": "Teq'uq call' kenug', kitugutngullruuq."
        },
        "61": {
            "start": 533.69,
            "end": 549.47,
            "transcript": "Cam tamaa-i call' ivrucinun-gguq ciilriutekluku kitugutekluku cali kinqaku qerrurluki [?] ivrucit keluita-ll' nallait imangengaunateng call' tamaa-i."
        },
        "62": {
            "start": 549.9,
            "end": 556.87,
            "transcript": "(Teq'iciramun akurtaqamegteki tamakut qiluit, qaillun pitalriamek akunqavkalartat?)"
        },
        "63": {
            "start": 556.87,
            "end": 565.26,
            "transcript": "Teq'iciramun pinrilngermeng tua-i teq'umun nengllikaku akurrluku wagg'uq augirluku [?]."
        },
        "64": {
            "start": 565.26,
            "end": 566.85,
            "transcript": "(Teq'iciraunrilengraan?)"
        },
        "65": {
            "start": 566.85,
            "end": 581.21,
            "transcript": "Teq'iciraunrilengraan auga-ll' tua-i pikan au͡g'aqan kat' teq'um teguaku mermun cat yuuluku akungqaluku call' tangerrluku mermek mel'inqiggluku."
        },
        "66": {
            "start": 581.21,
            "end": 585.51,
            "transcript": "Tua-ll' tangerrluku ella assiqan qerrurluku."
        },
        "67": {
            "start": 585.51,
            "end": 597.26,
            "transcript": "Cali-am irniarita qiluyagait amirkat pitullruit avani qilut, makut irniarita qiluit."
        },
        "68": {
            "start": 597.26,
            "end": 606.4,
            "transcript": "Tapluku qerruqata'arqamegteki melugluku tapqurluku piuraraqluku."
        },
        "69": {
            "start": 606.4,
            "end": 608.54,
            "transcript": "(Qasperrluku-gguq.)"
        },
        "70": {
            "start": 608.54,
            "end": 611.37,
            "transcript": "Qasperrluku-gguq tua-i."
        },
        "71": {
            "start": 611.37,
            "end": 618.15,
            "transcript": "Keggnaq aqvallurluku amilamek makut, makuqluku."
        },
        "72": {
            "start": 622.12,
            "end": 628.96,
            "transcript": "(Qerrurluki-ll' kinerciraqamegteki, qaillun pitalriamek inimavkalartat?)"
        },
        "73": {
            "start": 628.96,
            "end": 640.5,
            "transcript": "Atakukan talilluku itrulluku tua-i-ll' apeqmegnek yukutaciqerluku waten ciilertelaata."
        },
        "74": {
            "start": 640.5,
            "end": 647.78,
            "transcript": "Maaggun-am, maaggun-am ullirtevkenaku qukaakun mat'ukun."
        },
        "75": {
            "start": 647.78,
            "end": 655.81,
            "transcript": "Mat'ukun ullirtevkenaku tau͡gaam mat'ukun."
        },
        "76": {
            "start": 658.57,
            "end": 662.23,
            "transcript": "Mat'ukun ullirrluku."
        },
        "77": {
            "start": 662.23,
            "end": 665.39,
            "transcript": "Man'a maaggun pivkenaku."
        },
        "78": {
            "start": 665.39,
            "end": 669.53,
            "transcript": "Mingeqsunaiciiquq man'a aturluku pikuni."
        },
        "79": {
            "start": 669.53,
            "end": 678.98,
            "transcript": "Man'a-llu mingeqsunanruluni cillarqurciqngami uiveskuni anglirikanirluni."
        },
        "80": {
            "start": 678.98,
            "end": 687.26,
            "transcript": "Uiveskuni anglirikanir' tuaten uivvaaquni."
        },
        "81": {
            "start": 689.92,
            "end": 701.26,
            "transcript": "(Maa-i-llu ilaitni mingqaaraat tanglalrianga qaraliqluki tamakut, ilait mingqaaraat.)"
        },
        "82": {
            "start": 701.26,
            "end": 715.39,
            "transcript": "Avani-wa apeqmegnek caakciakenrilkurrluku pi' qaraliqesciiganaku tau͡gaam qasperullerkaa egalrullerkaa qelkumallruuq."
        },
        "83": {
            "start": 715.39,
            "end": 719.62,
            "transcript": "(Ukaqvaggun-qaa tau͡gaam tuaten qaraliqsaurtellruut?)"
        },
        "84": {
            "start": 719.62,
            "end": 731.13,
            "transcript": "Ii-i ukaqvagun wii tangerrsaurtellruunga unaken kingunerpet nuniinek ayagnillruut, Caninermek waten qilut qaraliullrat."
        },
        "85": {
            "start": 731.13,
            "end": 735.98,
            "transcript": "(Kepluki dye-arraarluki-ll' ayuqenrilngurnun.)"
        },
        "86": {
            "start": 739.51,
            "end": 750.63,
            "transcript": "Up'nerkaryartumi, up'nerkami atutukait pingtuit, qayalillrat maliggluku."
        },
        "87": {
            "start": 750.63,
            "end": 763.13,
            "transcript": "Tupigluteng makut-gguq ikaraliiciluteng qayalikata tupigluki arilluliluteng neqem au͡gkut qeltaitnek."
        },
        "88": {
            "start": 763.13,
            "end": 770.06,
            "transcript": "Makut-llu call' imarnit' wagg'uq unlirluku call' neqem qeltiinek allauluni."
        },
        "89": {
            "start": 770.06,
            "end": 773.27,
            "transcript": "Ukua call' nequtungnaqluku."
        },
        "90": {
            "start": 774.67,
            "end": 779.03,
            "transcript": "Makut maa-i nequtungnaquluki, angengnaqu'urluki pilitullruut."
        },
        "91": {
            "start": 779.03,
            "end": 789.8,
            "transcript": "Akuit arcaqerluki qayam painga patuga-gguq [?] ket'rayunariluku."
        },
        "92": {
            "start": 789.8,
            "end": 804.05,
            "transcript": "Ellaqerruskan anuqem cayukauskateng patagturluteng, all'uku tua-ll' tamana as'arulluku, call' nuqi', au͡g'arrngairulluku"
        },
        "93": {
            "start": 804.05,
            "end": 811.28,
            "transcript": "piluk' qayaq-llu ciq'ngermi qayamun iterngaunan' tua-i wavet tau͡gaam anumun tull'uni."
        },
        "94": {
            "start": 811.28,
            "end": 823.26,
            "transcript": "Umcigluni qavavet-ll' iterngaunani teguarkani-gguq irugmi akunliignun paivqaarluku tua-i waten pikuni qaneni-ll' pikuniu mecungengarrluku."
        },
        "95": {
            "start": 826.36,
            "end": 833.07,
            "transcript": "(Makut-mi canek wani aturluteng string-alitullruitki?)"
        },
        "96": {
            "start": 833.07,
            "end": 838.24,
            "transcript": "Makunek-wa pilitullrullilriit ak'a wall'u-q' yualunek."
        },
        "97": {
            "start": 838.24,
            "end": 841.8,
            "transcript": "Wiinga tau͡gaam makucinek."
        },
        "98": {
            "start": 841.8,
            "end": 846.44,
            "transcript": "Makut-ll' neraitnek pilituaput."
        },
        "99": {
            "start": 849.26,
            "end": 864.54,
            "transcript": "(Tamakut-wa makut pivailgata imkucetun imkunek nauw' tanglut yaani tut'nengqelalriit, tamakut tua-i pinevluki-llu maavet pilallikait.)"
        },
        "100": {
            "start": 865.07,
            "end": 878.37,
            "transcript": "Cat tamarmi pilallruami naken pilerciiganani tua-i cat makut elngunraarait yuarluki pilallemni nurnallruut."
        },
        "101": {
            "start": 878.37,
            "end": 892.06,
            "transcript": "Tuamta-llu cali ava-i makut kelugkaat apqait qipumayanerrluteng, nani canek pilartatki maa-i, qipumanrilnguut."
        },
        "102": {
            "start": 892.59,
            "end": 909.96,
            "transcript": "Cali-am kelukaqamegteki makunek uliutnek, tuntut uliutaitnek, iqulirluki qipuurluki imkut nuvvsuutaita kepulaata, kepulaitki."
        },
        "103": {
            "start": 909.96,
            "end": 927.75,
            "transcript": "Tamakut-gguq yualut nuvv'ililriit kepsuillruata asvaillruata tamakunek enuliqerluki ilaqerluki aminek piaqameng nat'rarqameng-llu pilallikiit arnat."
        },
        "104": {
            "start": 927.76,
            "end": 936.33,
            "transcript": "Tuaten Qurray'am [?] nuvv'igkaqluku qemagarcilrianek niitelaameng."
        },
        "105": {
            "start": 936.33,
            "end": 939.73,
            "transcript": "Tua-i una tuaten ikayuqa'arqa."
        },
        "106": {
            "start": 950.31,
            "end": 959.67,
            "transcript": "Makut maa-i pirpakenqurrauluki piicetenritengnaqluki qayatullratni pitullruaput."
        },
        "107": {
            "start": 959.67,
            "end": 966.77,
            "transcript": "(Au͡gkut-llu imkut urut qayanun at'ulriaruyaaqelriit.)"
        },
        "108": {
            "start": 966.77,
            "end": 976.34,
            "transcript": "Makut-llu call' qayanun kelugkarnek wall'u makucinek wagg'uq ikaraliuciluki."
        },
        "109": {
            "start": 981.02,
            "end": 989.21,
            "transcript": "Ukut-llu cali kinercirluki waniwa-gguq urut."
        },
        "110": {
            "start": 989.21,
            "end": 996.36,
            "transcript": "Kinercirluki call' kinqata taqukaliuquneng tua-i piaqluki."
        },
        "111": {
            "start": 996.36,
            "end": 1007.34,
            "transcript": "Maaten tua-i piciqut tua-i qumlut qumulluku puyalruluteng nepcagnaqluteng cakneq."
        },
        "112": {
            "start": 1007.34,
            "end": 1015.2,
            "transcript": "Qayameggnun tua-i makut imkuciqluku, umcigutekaqluki."
        },
        "113": {
            "start": 1015.2,
            "end": 1018.31,
            "transcript": "Cali-ll' makut-llu call' aturluteng."
        },
        "114": {
            "start": 1018.31,
            "end": 1026.93,
            "transcript": "Kilinernun-llu cali tamakut tamaa-i patgulluku nemraqluki puyalertellriit."
        },
        "115": {
            "start": 1028.69,
            "end": 1032.02,
            "transcript": "Tape-anek piyuicetullermeggni."
        },
        "116": {
            "start": 1033.26,
            "end": 1040.62,
            "transcript": "(Puyaliaqameng canun ekluki pitullruitki tamana?)"
        },
        "117": {
            "start": 1040.62,
            "end": 1045.26,
            "transcript": "Up'nerkami tau͡gaam kiingan nutarinrarnek puyalituut."
        },
        "118": {
            "start": 1045.26,
            "end": 1053.0,
            "transcript": "Iciw' up'nerkami taqukiurqameng capuyalqerriunqegkii tuaten ayuqngata."
        },
        "119": {
            "start": 1053.0,
            "end": 1065.51,
            "transcript": "Qapiarraarluteng-llu uqurrluanek call' kuv'itekluku, qantamun muragamun camun tua-ll' ek'arrluki."
        },
        "120": {
            "start": 1066.32,
            "end": 1080.57,
            "transcript": "Piciqut tua-i qaill' tua-i cayunanateng angtacirkatun avaq'aulluteng [?] una piaqluku taun'-ll' passiluku akutaturluku."
        },
        "121": {
            "start": 1080.57,
            "end": 1083.53,
            "transcript": "Tau͡gaam patagturnaqluteng."
        },
        "122": {
            "start": 1083.53,
            "end": 1092.79,
            "transcript": "Qayagaurqakut puyaput-gguq tengqatartut, ukverluta aqevluta neryartulaagaqluta."
        },
        "123": {
            "start": 1095.44,
            "end": 1103.63,
            "transcript": "(Uksumi-qaa kiingan qanikcartangqellran nalliini puyamek akutaqluteng?)"
        },
        "124": {
            "start": 1103.63,
            "end": 1108.58,
            "transcript": "Ak'anivkenak tan'gerpiit nalliitni puyalituut."
        },
        "125": {
            "start": 1108.58,
            "end": 1114.35,
            "transcript": "Wiinga tamatum nalliini tan'gerpiit maa-i cumertelal'."
        },
        "126": {
            "start": 1114.35,
            "end": 1125.64,
            "transcript": "Tamakut tamatum nuniini nerevkatullruitkut puyaput. Qayagaurciqakut puyaput ukverlua-ll' tua-i wii tengnayukluki uterrlua tua-i nerlaagaqluki."
        },
        "127": {
            "start": 1126.26,
            "end": 1130.76,
            "transcript": "Puyaput tamakut ilumun tengtuyukluki."
        },
        "128": {
            "start": 1134.04,
            "end": 1137.04,
            "transcript": "(Assigtaitnek ava-i apcaaqsugnarquten.)"
        },
        "129": {
            "start": 1137.04,
            "end": 1145.43,
            "transcript": "(Yaa, canun qemaggluki puyalriit tamakut urut puyat canun qemangqalartatki?)"
        },
        "130": {
            "start": 1145.43,
            "end": 1156.59,
            "transcript": "(Ellngaarngailngurmun uqungruquq [?] icugg' maa-i temaitnek nayirnek wall'u useqnaarnek caqucilalriit uquuciaqameng.)"
        },
        "131": {
            "start": 1156.59,
            "end": 1164.05,
            "transcript": "It'gaitnun wall' anrutarnun ekluki puyaliaqluteng."
        },
        "132": {
            "start": 1164.05,
            "end": 1166.54,
            "transcript": "Qemangqaluki tua-i."
        },
        "133": {
            "start": 1166.54,
            "end": 1172.26,
            "transcript": "(Qangvarpak qemangqarungermegteki [?] assilartat?) Kiagpak. (Assiirucuitut-qaa?)"
        },
        "134": {
            "start": 1172.26,
            "end": 1184.26,
            "transcript": "Kiagmek ayagluteng puyaliaqamegteki uksurluni-ll' uksurpak up'nerkaqan-llu apeqmeggnek qayiuqungkuneng qayateng uptengkunegteki."
        },
        "135": {
            "start": 1184.26,
            "end": 1189.62,
            "transcript": "Matarrluki apqeqmeggnek qayat amiit kituggluki."
        },
        "136": {
            "start": 1189.62,
            "end": 1206.28,
            "transcript": "Tua-i-llu keluit umcigeskunegteki wagg'uq puyalluki makunek maa-i uum qanemcillratun tuntut tunuicetun umcigutekluki puyat makut qayat keluitnun."
        },
        "137": {
            "start": 1206.28,
            "end": 1221.44,
            "transcript": "Tua-i tuaten pirraarluki call' pikalget apeqmeggnek qayateng urasqerrluki kelliyarrluki qat'riqertelluki, nunam taunun nakmiin kelliyaanek."
        },
        "138": {
            "start": 1221.44,
            "end": 1224.62,
            "transcript": "Urasqamek at'legmek."
        },
        "139": {
            "start": 1224.62,
            "end": 1233.11,
            "transcript": "Tua-i tuaten qayat amiit kitugtaqamegteki puyat-llu makut umcigutekluki aturaqluki."
        },
        "140": {
            "start": 1233.11,
            "end": 1239.73,
            "transcript": "Aturluteng arnat-llu aunrarcuutekluki caquqerluki tau͡gaam."
        },
        "141": {
            "start": 1239.73,
            "end": 1250.52,
            "transcript": "Tua-i-llu mecingekaki yuuluki allanek call' cimirluki, kinercirluki kinrumalrianek."
        },
        "142": {
            "start": 1250.52,
            "end": 1259.96,
            "transcript": "Tamana-w' tamaa-i pitekluku urunek atengqeluugtelallilriit arnat aunrarcuutekluki pilalriit."
        },
        "143": {
            "start": 1263.0,
            "end": 1273.02,
            "transcript": "Tua-i-am call' makunek maa-i piitenrilkurcetullruut yullret imkut, makunek maa-i."
        },
        "144": {
            "start": 1277.26,
            "end": 1285.26,
            "transcript": "Maani uitatungerpet nalluken Urucaraq [Orutsararmiut] Native Council-am atra nallunrilngerpegu."
        },
        "145": {
            "start": 1285.26,
            "end": 1295.59,
            "transcript": "Tua-i kanaa-i Urucararmiungutiitnek pitalqanka wii ukut Urucaramek kanaken."
        },
        "146": {
            "start": 1295.59,
            "end": 1300.69,
            "transcript": "Urucaram nantellra maani amllerem nallua."
        },
        "147": {
            "start": 1300.69,
            "end": 1304.66,
            "transcript": "Tua-i kanaa-i kan' Urucaraq ateqluku."
        },
        "148": {
            "start": 1304.66,
            "end": 1309.75,
            "transcript": "Mamterillrem Yugtun Urucaraq."
        },
        "149": {
            "start": 1309.75,
            "end": 1320.46,
            "transcript": "Nalluyarqa Urucararmiungucia imumek Keggukaralegmek pitullrata ak'a kass'aqarraat maani ilallrata,"
        },
        "150": {
            "start": 1320.46,
            "end": 1327.35,
            "transcript": "pairta unani ceńami missuuk kanevnerpagluni equgluku."
        },
        "151": {
            "start": 1327.35,
            "end": 1337.82,
            "transcript": "Billy [?], au͡g'um im' tengssuuciurtem aanallra, Billy [?] kituuyaaquq-am. Kassalitiitamek [?] pinaurtellra."
        },
        "152": {
            "start": 1337.82,
            "end": 1349.55,
            "transcript": "Pianga, ellii-gguq waniwa Urucaramek urulluni ukunek aqvatuq enirtuullua yaaken Urucaraq."
        },
        "153": {
            "start": 1349.55,
            "end": 1352.04,
            "transcript": "Tuani-llu nallunrilqaaqa."
        },
        "154": {
            "start": 1352.04,
            "end": 1365.82,
            "transcript": "Billy Eatly [?] maani, iciw' imna ... [?] Billy Eatly [?] taum aanallra. Ii-i."
        },
        "155": {
            "start": 1372.26,
            "end": 1380.53,
            "transcript": "(Imarnit', imarniciyaram-qaa pianek yurauteltangqertuq?)"
        },
        "156": {
            "start": 1380.53,
            "end": 1387.98,
            "transcript": "Iciw' ava-i iciw' (Au͡gna qiluliuryaram pianek.)"
        },
        "157": {
            "start": 1387.98,
            "end": 1400.61,
            "transcript": "Wii elitaqkacagatuluku yuratullratni yuraryuqaarluni imarniciluni mingquarraarluni uivkaniqaqlukek mingqaqluni."
        },
        "158": {
            "start": 1400.61,
            "end": 1407.26,
            "transcript": "Qiluliullra elitaqkacagatullruluku arulaciqluku yurartii."
        },
        "159": {
            "start": 1411.84,
            "end": 1415.82,
            "transcript": "(Theresa, maniicugngaarpekut-qaa tamatumek.)"
        },
        "160": {
            "start": 1415.82,
            "end": 1425.86,
            "transcript": "Inerqullruanga [?] akmani elitesqumanrilkumku-gguq wii qemangqakilaku pikaqa."
        },
        "161": {
            "start": 1427.85,
            "end": 1441.26,
            "transcript": "Tua-i-am maani-am mat'um maa-i iluani up'nerkaq Washington, D.C.-mek tagelriim tuaten tua-i yuraarcellua makucikun tegullruanga."
        },
        "162": {
            "start": 1441.26,
            "end": 1446.38,
            "transcript": "Tua-i-llu pilua imarnitegnek taqucugngakuma pisqell'."
        },
        "163": {
            "start": 1446.38,
            "end": 1451.68,
            "transcript": "Tua-i-ll' taqellrulukek tayima ayagcetellrulukek."
        },
        "164": {
            "start": 1451.68,
            "end": 1465.64,
            "transcript": "Tauna tua-i museum-aam iluani agaarkauluni. Wii tauna-gguq can' yuraaralqa imarnitek-wa caniagni qanemciku'urlukek taukuk."
        },
        "165": {
            "start": 1468.99,
            "end": 1478.83,
            "transcript": "Taukuk tua-i ukuk imarnitek call' qanerturlua tua-i waten piurallruunga tunuarkaanek yagutnguarkaanek."
        },
        "166": {
            "start": 1478.83,
            "end": 1490.34,
            "transcript": "Tua-ll' uivvaarnilukek taqkumkek-llu-gguq waten tua-i piuk all'ukek. All'ukek-gguq waniw' qayaqa-ll' atrarrluku anguarlua-ll'."
        },
        "167": {
            "start": 1490.34,
            "end": 1498.04,
            "transcript": "Maa-i mat'um iqua. Muragiurlua-llu, taluyilua."
        },
        "168": {
            "start": 1498.08,
            "end": 1501.83,
            "transcript": "Taqkumki-ll' atmagluki kuigmun civcarturluki."
        },
        "169": {
            "start": 1504.46,
            "end": 1515.25,
            "transcript": "Tua-llu uterrlua call' qanemcillua, qanemcilua ak'a pitniluki taluyanka taukut aruqutekluki qasgim iluanun iterlua."
        },
        "170": {
            "start": 1517.26,
            "end": 1530.98,
            "transcript": "Tauna tayima museum-aam iluani agaciquq imarnitek taukuk-wa tua-i piliagka canimni. Wiinga-wa yuruaralrianga qanerturlua makumek."
        },
        "171": {
            "start": 1530.98,
            "end": 1533.97,
            "transcript": "Nalqiguteku'urluku."
        },
        "172": {
            "start": 1533.97,
            "end": 1540.33,
            "transcript": "Taukuk-wa tua-i piliagka agalriik canimni uitalutek."
        },
        "173": {
            "start": 1543.9,
            "end": 1547.2,
            "transcript": "Waten-am tegullruatnga up'nerkaq maani."
        },
        "174": {
            "start": 1547.2,
            "end": 1550.24,
            "transcript": "(Qanemci cauyaquciararqa.)"
        },
        "175": {
            "start": 1550.77,
            "end": 1560.07,
            "transcript": "(Qang'a. Ciuliami elliin arulaciqluku ciuliami arulaciatgun naugimnek.)"
        },
        "176": {
            "start": 1562.5,
            "end": 1577.73,
            "transcript": "Una tua-ll' apqii call' nangenrullrani elitessiyaallrunritaqa qununimek mumigcissaagualria."
        },
        "177": {
            "start": 1577.73,
            "end": 1582.57,
            "transcript": "Yuarutminek yuarulluku aminek cikiruaraqluku."
        },
        "178": {
            "start": 1582.96,
            "end": 1587.52,
            "transcript": "Mumigcisciigalliqnguarlua."
        },
        "179": {
            "start": 1587.52,
            "end": 1595.06,
            "transcript": "Wagg'uq taumek qununimek mumigcissaaguarlua pitaqnguallemnek."
        },
        "180": {
            "start": 1597.05,
            "end": 1599.71,
            "transcript": "(Taringenritliken-wa.)"
        },
        "181": {
            "start": 1603.0,
            "end": 1605.44,
            "transcript": "(Yuuluni tamarmi.)"
        },
        "182": {
            "start": 1605.44,
            "end": 1614.31,
            "transcript": "(Tau͡gaam caskuyarraarluku imarnitegken un' caskuyaqani-ll' unkuni mermun anglluquni.)"
        },
        "183": {
            "start": 1614.31,
            "end": 1623.13,
            "transcript": "(Tua-i mumigtarkauluni. Talliman-gguq ukut angllunret qaneryaraqelaqait.)"
        },
        "184": {
            "start": 1623.13,
            "end": 1629.22,
            "transcript": "(Tallimiitni tua-i qaqilluni, maklat kuigmi tua-i pugtuluni.)"
        },
        "185": {
            "start": 1629.22,
            "end": 1633.26,
            "transcript": "([?] iqtutalek.)"
        },
        "186": {
            "start": 1633.31,
            "end": 1643.68,
            "transcript": "Tua-i-am tamaa-i unaggun narulkarluku qununissuquneng imarnitiin engeliikun akuakun."
        },
        "187": {
            "start": 1649.93,
            "end": 1659.11,
            "transcript": "(Kumarutnek atutullermeggni, urunek cakucinek atutullruut?) Canek? (Kumarissuutet.)"
        },
        "188": {
            "start": 1659.11,
            "end": 1668.6,
            "transcript": "Canek tua-i maani uitalriit kumarulluut yuilqumi. (Taukut-qaa,) Uruugut. (Uruugut taukut.)"
        },
        "189": {
            "start": 1668.6,
            "end": 1671.78,
            "transcript": "Kumarqulluut-w' imkut."
        },
        "190": {
            "start": 1671.78,
            "end": 1684.55,
            "transcript": "Tua-i piyugtacimitun agaulluku wall'u cali angneranek au͡g'aqaulluni, kenerciluteng-gguq uqumun aku'uqluku."
        },
        "191": {
            "start": 1684.55,
            "end": 1689.12,
            "transcript": "Wall'u elagyarqekuneng kenurqutaqluku tuaten tua-i."
        },
        "192": {
            "start": 1691.84,
            "end": 1693.96,
            "transcript": "(Candle-aaqluku.)"
        },
        "193": {
            "start": 1693.96,
            "end": 1699.33,
            "transcript": "(Qaillun-gguq waten taktavallalriit tamakut kumarulluut.)"
        },
        "194": {
            "start": 1699.33,
            "end": 1703.72,
            "transcript": "(Tua-i quyurmeng waten naumalartut nunapigmi.)"
        },
        "195": {
            "start": 1703.72,
            "end": 1709.35,
            "transcript": "(Maa-i pitangqerrsaaquq nani tayima maani kiarrluni pilriani tangerrnaqluni.)"
        },
        "196": {
            "start": 1709.35,
            "end": 1721.78,
            "transcript": "Elpet-llu ellangellruyaaqellilriaten Kuigilngurmi piit' urutalegmi tamaa-i kumarqullugtalegmi yuilqumi ungagaat tamakut tamaa-i."
        },
        "197": {
            "start": 1721.79,
            "end": 1727.4,
            "transcript": "(Au͡gkut ungagaat, canun atulillruitki?)"
        },
        "198": {
            "start": 1727.4,
            "end": 1731.54,
            "transcript": "(Malruunikait, tungulriit qatellriit-llu.)"
        },
        "199": {
            "start": 1731.54,
            "end": 1738.67,
            "transcript": "Yuurqarauluteng neqnirqelriit soup-ii [?] tayaruqluki."
        },
        "200": {
            "start": 1738.67,
            "end": 1743.09,
            "transcript": "(Alungeliaqameng-llu qimugtemeng neqkaitnek call' ilaketuluki.) (Ii-i.)"
        },
        "201": {
            "start": 1743.09,
            "end": 1752.29,
            "transcript": "(Enuryugciaqameng qimugcitkameggnek uqurrluarmek avuluki alungeliaqluki qimugteńun.)"
        },
        "202": {
            "start": 1752.29,
            "end": 1755.38,
            "transcript": "Tua-i neqnguata."
        },
        "203": {
            "start": 1755.38,
            "end": 1764.86,
            "transcript": "Tamakut-am yuurqaaratnek negeqlimtaungekut [?], Scammon, Hooper, Chevak, uuqnanek pituit."
        },
        "204": {
            "start": 1764.86,
            "end": 1769.18,
            "transcript": "Wangkuta tau͡gken yuurqaarnek piaqluki."
        },
        "205": {
            "start": 1769.22,
            "end": 1771.83,
            "transcript": "Qagaani Kuigpagmi canek uuqnanek."
        },
        "206": {
            "start": 1771.83,
            "end": 1778.38,
            "transcript": "Urunek pituit, wiinga [?] urunek piaqluki tamakut yuurqaaraat."
        },
        "207": {
            "start": 1778.38,
            "end": 1782.07,
            "transcript": "Uuqnanek neqciuratuut."
        },
        "208": {
            "start": 1782.07,
            "end": 1794.57,
            "transcript": "Tua-i ava-i qanrutkan qimugtet iluviggnun [?] urugciaqata tamakunek alungeliluki tamakunek inerqetullruut. (Ii-i.)"
        },
        "209": {
            "start": 1794.57,
            "end": 1801.26,
            "transcript": "Ava-i elitaqevkaran qanrutekluku [?]."
        },
        "210": {
            "start": 1801.26,
            "end": 1811.74,
            "transcript": "(Wiinga-llu-w' maurluirutka cavailgan qavcirqunek tayima yuurqaarrluku-ll' pilrianga tamakut ungalamek [?].)"
        },
        "211": {
            "start": 1811.74,
            "end": 1813.66,
            "transcript": "(Mmm, yaa.)"
        },
        "212": {
            "start": 1813.66,
            "end": 1816.44,
            "transcript": "(Imkut neqaitnek.)"
        },
        "213": {
            "start": 1816.44,
            "end": 1822.55,
            "transcript": "Tungulriarurraarluteng qat'riluteng-llu keningquq [?] neqniqtutkacagarluteng [?]."
        },
        "214": {
            "start": 1822.55,
            "end": 1826.54,
            "transcript": "(Ungagaat.)"
        },
        "215": {
            "start": 1826.54,
            "end": 1832.56,
            "transcript": "Aptellruyaaqatnga [?] nunapigmi camp-arluta pillemni."
        },
        "216": {
            "start": 1832.56,
            "end": 1838.92,
            "transcript": "Makut tuntut neqait, caugat atrit Yugtun?"
        },
        "217": {
            "start": 1838.92,
            "end": 1845.26,
            "transcript": "Ungagaat. Yaa, atrit tua-i [?]-lraranka."
        },
        "218": {
            "start": 1845.26,
            "end": 1855.73,
            "transcript": "(Qagaani tua-i nunamteńi tamakut ilaitni amllerrsartut cakneq. Amllerlartut cakneq.)"
        },
        "219": {
            "start": 1855.73,
            "end": 1865.22,
            "transcript": "Au͡gkut qatyaarluteng, qaill' [?], pikegkut tua-i kangrit qaterrluteng tau͡gken."
        },
        "220": {
            "start": 1865.23,
            "end": 1870.26,
            "transcript": "Tuaten ayuqngat'lalliniut."
        },
        "221": {
            "start": 1870.26,
            "end": 1874.44,
            "transcript": "Aiparluteng-am cali tegulriani [?]-narqut."
        },
        "222": {
            "start": 1874.44,
            "end": 1879.87,
            "transcript": "Ii-i. Paluqutanek pilit [?]."
        },
        "223": {
            "start": 1884.99,
            "end": 1896.0,
            "transcript": "(Yuurqaaraliaqameng-llu tayarunek pitukait-llu, melugnek-llu canek avuluki.)"
        },
        "224": {
            "start": 1897.49,
            "end": 1913.0,
            "transcript": "Tua-i makut-llu maa-i neqet meluit, meluit neqet, manignat, cuukviit, tua-i-wa meluit tamarmeng pituluki."
        }
    },
    "THoVlwnV44g": {
        "1": {
            "start": 16.94,
            "end": 18.41,
            "transcript": "Tua-i-qaa?"
        },
        "2": {
            "start": 20.23,
            "end": 36.18,
            "transcript": "Man'a maa-i qetutessiyaagngan lumarraarmek piliaqestiin pillrukii ilaita taquk', mikelngurtaungan mat'umek pilirluku."
        },
        "3": {
            "start": 36.18,
            "end": 50.84,
            "transcript": "Tau͡gken angelriim pikekakut taqukamek au͡g'umek mani issurimek wall'u nayirmek melquralaatekluku man'a mingeqvikirluku qam'umun qecia."
        },
        "4": {
            "start": 54.81,
            "end": 58.56,
            "transcript": "Taqukamek-am acirluku qecigmek."
        },
        "5": {
            "start": 64.8,
            "end": 69.04,
            "transcript": "Nunavci-qaa nuniini arrnanek picetuut?"
        },
        "6": {
            "start": 69.04,
            "end": 82.4,
            "transcript": "Caaqameng maa-i malruk takumni niitellemni makuciignek pitellrurtuk ataucimek imarpiim cuignilnguanek."
        },
        "7": {
            "start": 82.4,
            "end": 87.92,
            "transcript": "Tua-i-w' piurayuilnguut nunameggni tau͡gaam makut pivimeggni pitullilriit."
        },
        "8": {
            "start": 92.4,
            "end": 97.48,
            "transcript": "Cat-llu allat melqurritnek atkulilartat?"
        },
        "9": {
            "start": 97.48,
            "end": 103.9,
            "transcript": "Piciatun tuntunek-llu atkulitullruut."
        },
        "10": {
            "start": 103.9,
            "end": 122.08,
            "transcript": "Atkulitullermeggni atkunek tau͡gaam piuratullermeggni tuntunek qanganarnek tua-i piciatun qecingqellria tamalkuan atkuuluni kaviarnek uliirnek imkunek qatellriarrlainaat."
        },
        "11": {
            "start": 122.08,
            "end": 138.586,
            "transcript": "Rabbit-aanek u͡gasegnek wangkuta pituaput maani-llu qayuqegglinek tamakunek tua-i atkuuyugngalria tamalkuan atauciunivkenaku qelepluku kiituan amllerriuq."
        },
        "12": {
            "start": 138.586,
            "end": 150.64,
            "transcript": "Tua-i-llu piyugngakan allanek ilangraan melqurra ilukeqataqan allanek ilangqengraan atkuk-llu tuaten pitullruukut."
        },
        "13": {
            "start": 155.72,
            "end": 181.08,
            "transcript": "Una manua ilutmun caumakan kaviarnek yaqulegnek una melqilria-wa-gguq una-am callugyarcauratuat [?] pamna taumi pinrillrungraan pisqellu', una-gguq callugyar' manu pituut."
        },
        "14": {
            "start": 187.07,
            "end": 209.87,
            "transcript": "Una wani imarmiutat ukut tayim' piliaqestiin qavciullrat nallunritaa, arvinelgunrilkuneng malrunelgen, eight-aat, seven-aat, seven-aat wall'u cipingaluku, ten-aarunrilkuneng makut imarmiutat."
        },
        "15": {
            "start": 221.63,
            "end": 231.64,
            "transcript": "Tua-i waniw' cam tamarmi waten cat tamalkuan atkuureskuni wall' paltuugnek maa-i piurangelriit atuuciquq."
        },
        "16": {
            "start": 231.64,
            "end": 243.08,
            "transcript": "Pikiunrilkumteggu tau͡gken piuvkenani qemangqaaruluni tayim' cataunani, pingnatukumteńi tau͡gken waten alaunani assirluni."
        },
        "17": {
            "start": 259.08,
            "end": 262.08,
            "transcript": "Yaa, atkunek piliarput [?], yaa."
        },
        "18": {
            "start": 268.08,
            "end": 285.92,
            "transcript": "Una-wa waniwa au͡g'umi qecigkillruluni issuriyagaq mikelnguq, tau͡gaam allrakungeksailnguq."
        },
        "19": {
            "start": 285.92,
            "end": 292.62,
            "transcript": "Una-wa waniwa wangkuta malagg'aayat ukuit puukaryaranek pituaput."
        },
        "20": {
            "start": 295.43,
            "end": 314.37,
            "transcript": "Tamakuciuguq, ukuk-wa una-wa-gguq ciutailitaa, ciutairyailkutii malagg'aayaq nacaq."
        },
        "21": {
            "start": 317.7,
            "end": 321.51,
            "transcript": "Qaillun cuqtaalartatki malagg'aayat?"
        },
        "22": {
            "start": 322.64,
            "end": 332.61,
            "transcript": "Qaill'-wa cuqtelartatki malagg'aayat, wiinga tangrruarluki pilitullemni pililallruunga."
        },
        "23": {
            "start": 336.81,
            "end": 342.21,
            "transcript": "Caat [?] angyaaqevkenaki, mikliqercaaqevkenaki."
        },
        "24": {
            "start": 342.98,
            "end": 353.08,
            "transcript": "Waten inerquutullruitkut, mikteqalria-gguq tau͡gaam assiitelartuq angliriqerteng'e'rmi-gguq tau͡gken cavkenani."
        },
        "25": {
            "start": 358.08,
            "end": 375.08,
            "transcript": "Makut maa-i arcaqerluku atkuut imarnitet-llu, piluguut ivrucit-llu, iqertiit-llu, piluguit-llu angutet angkengraitki pisqelluki, piuraasqelluki."
        },
        "26": {
            "start": 378.95,
            "end": 388.04,
            "transcript": "Anguteteng avani arcaqekluki piuratullermeggni, angussaagtekngam', tua-i-gguq angussaagtekngamteki."
        },
        "27": {
            "start": 388.08,
            "end": 401.88,
            "transcript": "Angutelqurraq-gguq ikiungermi, niitetullruunga waten, angutelqurraq-gguq ikiungermi arnaq anakluku mer'em akuliinek neqnek tegucugngauq."
        },
        "28": {
            "start": 401.88,
            "end": 406.08,
            "transcript": "Wangkut yagarrluni-gguq camek tegutnaituq."
        },
        "29": {
            "start": 408.16,
            "end": 418.32,
            "transcript": "Makugtaqarraarpek'nani-gguq camek tegusngaituq, uitainanrani-gguq camek tekisngaitaa pitarkaat."
        },
        "30": {
            "start": 418.32,
            "end": 431.08,
            "transcript": "Tau͡gaam-gguq makugtaqa tuaten tamana pitekluku alerqutullruitkut unangkengarait assircaarrluku piuraasqelluki."
        },
        "31": {
            "start": 435.34,
            "end": 447.76,
            "transcript": "Kesianek nepailuutevkenata apqan pitullruitkut wangkuta aanaka-ll' wii tuqullrungraan kenkesteḿa tayima arnam,"
        },
        "32": {
            "start": 447.76,
            "end": 457.08,
            "transcript": "Qanrucetetukiinga tuaten, cam iliini angutem alarrvikekaanga tuaten piuraasqelluku."
        },
        "33": {
            "start": 461.86,
            "end": 467.77,
            "transcript": "Atkuliaqameng-llu-qaa qaralimeggnek ellait pimeggnek call' qaralirtaqluku?"
        },
        "34": {
            "start": 467.77,
            "end": 482.05,
            "transcript": "Ii-i atkulikuneng alngalegmek wagg'uq cetqunegteki-llu ellaita ellang' alerquutmegteggun ellaita pimeggnek ceterluki."
        },
        "35": {
            "start": 482.08,
            "end": 496.59,
            "transcript": "Maa-i-gguq makut cetret ellaita pimeggnek qaralirrluki imkut wanelnguut qalirnek piluki, maanelnguut-llu qulitaarnek piluki."
        },
        "36": {
            "start": 496.59,
            "end": 503.85,
            "transcript": "Elleggurluteng imkut pukit maavet ayatulriit kankut-llu caqerluteng."
        },
        "37": {
            "start": 503.85,
            "end": 512.04,
            "transcript": "Maa-i allat aminaki pilartut tamakunek."
        },
        "38": {
            "start": 512.08,
            "end": 523.22,
            "transcript": "Una alarrvikekaten naaq [?] taringan qanellra? Nuu. Angutem elluarrluku arnauyukluku nulirrniaqaku."
        },
        "39": {
            "start": 523.4,
            "end": 529.08,
            "transcript": "Tua-i tuaten kangilitullruat au͡gkut angutem alarrvikekaten."
        },
        "40": {
            "start": 529.08,
            "end": 539.35,
            "transcript": "Assiryukluten arnam nulirrniaqaten taunguuq tuaten tua-i meaning-angqertuq."
        },
        "41": {
            "start": 539.35,
            "end": 552.14,
            "transcript": "Angun-gguq caunrilkeqeryaqunaku, ikiungraan tangnerrlugnarqengraan, iingan inglua catailengraan, tussilluni pektetungraan."
        },
        "42": {
            "start": 552.14,
            "end": 567.15,
            "transcript": "Anaggluta-gguq mer'em akuliinek cikum acianek tegucugngaut neqnek neqa avani pitekluku pitullruameng man'a aturaq ca."
        },
        "43": {
            "start": 567.15,
            "end": 572.483,
            "transcript": "Pivkenaku tau͡gaam arcaqanruluni neqa."
        },
        "44": {
            "start": 576.07,
            "end": 588.4,
            "transcript": "Tua-i-ll' wii waniwa tuaten niiquratullruama tutgaraanka-ll' watqapik cam iliini tau͡gaam qanrusngualukaqluki."
        },
        "45": {
            "start": 588.4,
            "end": 598.64,
            "transcript": "Tamamta-w' tuaten ayuqelriakut qanruyutekaput nallunritengramteki qanerturciiganaki."
        },
        "46": {
            "start": 598.64,
            "end": 600.69,
            "transcript": "Qemangqaluki."
        },
        "47": {
            "start": 600.69,
            "end": 605.08,
            "transcript": "Qunutungariluta, qunukengluki apqiitnek."
        },
        "48": {
            "start": 607.08,
            "end": 630.46,
            "transcript": "Neryuuminriamta ayuqluta, una anrutaq kanavirutngullrani ayuqniarutngullruuq, maa-i-ll' mat'um nalliini ayuqliulluteng yuut food stamp-am usviirutevkalriateng ellirluki yuut, wii tuaten tua-i tangvagli mat'um nalliini."
        },
        "49": {
            "start": 631.08,
            "end": 641.25,
            "transcript": "Qavaryaurrluta-ll' umyuarput engelkarrluku, makut tua-i tutgaraput irniaput ayagneruluteng."
        },
        "50": {
            "start": 641.55,
            "end": 648.01,
            "transcript": "Qavanqerrurrluteng, camek tua-i kepqutaunateng ellrameggni, ca tauna."
        },
        "51": {
            "start": 650.08,
            "end": 662.79,
            "transcript": "Tua-ll' qemangqangramki tamakut niitetullrenka cam iliini tunqalang'e'rmeng tunqatungraamki tuaten pisciiganaki waniw' uitalluki."
        },
        "52": {
            "start": 666.27,
            "end": 678.45,
            "transcript": "Alerquutekuratullrenka wiinga angutngungraata, wiinga piciukellruaqa aipaqa tayim' ak'a tuqullruluni tua-i-llu."
        },
        "53": {
            "start": 678.45,
            "end": 690.62,
            "transcript": "Au͡gna au͡gkut cingilegmek tangellrulriaci taqukassuutnek, taumek tua-i cingilganek cavegmek atengqerrluni tauna."
        },
        "54": {
            "start": 691.93,
            "end": 706.84,
            "transcript": "Avani ak'a itrullua qasgimun tua-i yagarluteng qayililuteng una tua-i uivurqenka tangssuararaqluku, uumek calilun' wavet nangerrlua tangssuararaqluku,"
        },
        "55": {
            "start": 706.84,
            "end": 713.82,
            "transcript": "wangni-ll' tua-i ikanelnguq cauluku tangssuarluku qamigaucingatelliniluni."
        },
        "56": {
            "start": 714.39,
            "end": 730.29,
            "transcript": "Qaillun-llu tayim' angtallrusia, pianga, \"Ukut qayamkun [?] malruk palungqalriik natermi ac'eciissaakata, aminerramek tamaa-i ac'etqatallinilluku.\""
        },
        "57": {
            "start": 730.29,
            "end": 741.08,
            "transcript": "Qanrutaanga, \"Kiikii-gguq tuaten angutngungraata caliuralriit murilkelluki tangssuaratulliniki ilakiit."
        },
        "58": {
            "start": 741.08,
            "end": 753.08,
            "transcript": "Avaniku tayima tua-i au͡g'utun angutem alarrvikekaanga irniangekumegnuk tan'gurrarnek wall'u arnanek."
        },
        "59": {
            "start": 753.08,
            "end": 770.78,
            "transcript": "Tan'gurraam-gguq taum qetunrarma apeskanga qaill' makut angucetaat calillrat, waten pitullratnek alerquat, pilissaakuni-gguq cauciqaanga qaill' makut pitullranek."
        },
        "60": {
            "start": 770.78,
            "end": 779.74,
            "transcript": "Tua-i tayima wiinga-ll' nalluyagulluki, tua-i-ll' aatiit tuqullruluni tayim' au͡gkucimek, pianga, \"Mom, qaill' makut pituat?\""
        },
        "61": {
            "start": 779.74,
            "end": 800.01,
            "transcript": "Arnaulua tau͡gken tangerqa au͡gkuci q ava-i tegutem cingilga, camek-gguq una, waten piluku, tua-i waten pituniluki, tangvagaqamki waten pituniluki tua-i ulurluku-ll'."
        },
        "62": {
            "start": 800.01,
            "end": 815.08,
            "transcript": "Maniqa tua-llu pia qalarcuartukuk kitek calitulit ullagluki maniyarturru, tayim' anellrani imna au͡gna anguulluam taum qanellranek [?]."
        },
        "63": {
            "start": 815.08,
            "end": 825.65,
            "transcript": "Wani imuulliniluni tauna tua-i qanellrat tekitelliniluku itqertuq quuyuarluni alartenritukuk-gguq."
        },
        "64": {
            "start": 825.65,
            "end": 839.08,
            "transcript": "Tauna im' na-lluuyagucaaqelqa tua-i tayim' cacuayagaulua taitellra wangnun tauna imna tua-i ilumun tekitetullinillrat,"
        },
        "65": {
            "start": 840.3,
            "end": 855.08,
            "transcript": "Wiinga-ll' tua-i umyuaqa [?] ellmikun tuar wani qanellrull' wangni tuaten tua-i murilkellruaqa, kiiki-gguq tuaten calilriit cauralriit tangssuaratulaki."
        },
        "66": {
            "start": 855.08,
            "end": 874.08,
            "transcript": "Avaniku-gguq tayima angutem alarrvikekanga, irniangekumegnuk angutnek arnartaat-llu cali alerquateksugngaluki panimnun, qetunraaqa-ll' tauna tua-i tuaten pilissaakan apeskanga apertuutetuniaqa."
        },
        "67": {
            "start": 874.08,
            "end": 888.01,
            "transcript": "Tua-i tuani tauna tua-i neq'aqallruaqa tayima tua-i nalluyagutellruluku-ll' taum-llu tua-i qanrutesqellma qaillun imumi tayim' aciqsigtaarillrua."
        },
        "68": {
            "start": 888.01,
            "end": 898.08,
            "transcript": "Tauna tua-i neq'aqa ilumun man'a qanruyun aturngaiqaarluku tekitetulliniluku pitullinillra yuum."
        },
        "69": {
            "start": 898.08,
            "end": 907.92,
            "transcript": "Nallunrirluku tamarngaitellinilqa qanruyukar tauna kalika'armun igausnganrileng'e'rmi."
        },
        "70": {
            "start": 909.47,
            "end": 918.61,
            "transcript": "Niicugnipiaqerluku niicugnillra tua-i kalikami ellimanrilengraan tauna tekicugngalliniluk'."
        },
        "71": {
            "start": 918.61,
            "end": 929.08,
            "transcript": "Tauna tua-i' naaqiyuileng'erman qanrutellra taum wangteqertuq tua-i ilumun piulliniluni, piciulliniluni."
        },
        "72": {
            "start": 929.08,
            "end": 934.6,
            "transcript": "Tua-ll' taum kinguakun aptenqivtevkenii calissaallminek."
        },
        "73": {
            "start": 938.08,
            "end": 948.46,
            "transcript": "Tau͡gaam enuqaalissaalqanek [?] qanrutengraanga nallunillruaqa, waten ellangellemni"
        },
        "74": {
            "start": 948.46,
            "end": 955.95,
            "transcript": "ayuqelrianek pitullruyaaqniluki, Qerrulligmiumek nuliangqerrami taumek."
        },
        "75": {
            "start": 955.95,
            "end": 969.38,
            "transcript": "Tua-i Qerrulligmiu taumek nuqamek maniillua makuliyugyaaquq-gguq ellmi piliaminek makumiutarmek."
        },
        "76": {
            "start": 969.38,
            "end": 972.08,
            "transcript": "Nalluamku apertuutellrunritaqa."
        },
        "77": {
            "start": 978.08,
            "end": 982.08,
            "transcript": "Tua-i-w' nallunrirtuci. Yaa."
        },
        "78": {
            "start": 985.91,
            "end": 991.44,
            "transcript": "Cunawa-qaa uivet alarrvikellrukiiten [?]"
        },
        "79": {
            "start": 995.8,
            "end": 1003.08,
            "transcript": "Tauna tua-i wiinga qessakengramku uiksagutellrukeka aatama pivkallruakut."
        },
        "80": {
            "start": 1006.55,
            "end": 1018.41,
            "transcript": "Aataput takaqellruamteki angayuqaput qessakengramku aatama pivkallruluk', aanaka tayim' tuqullruluni."
        },
        "81": {
            "start": 1018.41,
            "end": 1025.78,
            "transcript": "Una-q' Iquyuilnguum atkukaa? Al'ama-q' pikaa."
        },
        "82": {
            "start": 1028.08,
            "end": 1052.08,
            "transcript": "Tua-llu tua-i wiinga umyuamkun cuqingalaarqa ellangellruama enuqlitenqurrarmi canun tamaitni Alaska-m iluani agayulirteńun elitnaurvigmi ellangvilqa tuaten ayuquq kinguqlikat [?]."
        },
        "83": {
            "start": 1053.06,
            "end": 1066.25,
            "transcript": "Tua-i yuum ava-i qanerturallri niitaqluki angutnek arnaungraata-llu arulairuteksaitelliniat ukut ellangvima tamana."
        },
        "84": {
            "start": 1066.25,
            "end": 1084.08,
            "transcript": "Ukut tau͡gken avaqlimta agayulirtellrit elitnaurvilget pivakani [?] tamaani maligutaqama Tununertellrianun pitatemnek tangerrnaurtua."
        },
        "85": {
            "start": 1084.08,
            "end": 1106.08,
            "transcript": "Aling qigcikek'ngaitelarpaa-ll' ciulirnemeggnek cakngermegteki tuamtell' Qipnermun maligutnaurtua pitatemnek tangerrnaurtua Tununermiucetun qigcigyuutaunateng pitateput ciulirnemeggnek."
        },
        "86": {
            "start": 1106.08,
            "end": 1122.08,
            "transcript": "Cunaw' tamaa-i waten agayuvigmun tunelriatun ayagyuatun elitnaurvigmun tunelriatun pimiimeng qigcikenritlinilriit."
        },
        "87": {
            "start": 1122.08,
            "end": 1134.08,
            "transcript": "Tua-i-ll' maa-i neq'akaqamku ayuqliucameng tua-i nunat tamarmeng tuaten ellilliniluteng maa-i."
        },
        "88": {
            "start": 1134.08,
            "end": 1149.33,
            "transcript": "Wangkuta tua-i maa-i waten pitarilriani engelngullrulliniluta au͡gkut ciuliamta piciryarallrat ullangartellerput cat makut murilkeqalput."
        },
        "89": {
            "start": 1149.33,
            "end": 1163.35,
            "transcript": "Engelngullrulliniluta kinguqlimta tau͡gken makut niicuirucamegteki tua-i elicugngang'e'rmegteki nallunricugyaaqeng'e'rmegteki-llu."
        },
        "90": {
            "start": 1163.35,
            "end": 1182.08,
            "transcript": "Wangkutnek apertuacetairucameng tua-i nallulriatun ellirluki ava-i yuum cali qanrutkurqii una waniwa ngel'ngucimcetun [?] aiparma piliallrau paltuuk."
        },
        "91": {
            "start": 1182.08,
            "end": 1199.87,
            "transcript": "Tutgarmegnun ug'um paniani tua-i asqiallugutaunaku ellangellermini uum apqiinek piaqurrirturluku ellangviin anglicallruatni."
        },
        "92": {
            "start": 1199.87,
            "end": 1210.24,
            "transcript": "Ava-i-ll' wii taikanillruluku college-aarluku, graduate-aumaluku caliyaramek anglicallruatni."
        },
        "93": {
            "start": 1210.24,
            "end": 1233.08,
            "transcript": "Uumek waniw' tutgarpuk pilillruluku arenqianaunaku atuyunarqerkaurrluku elliin tua-i ciulirneminek elitnaurumallni aturluku ingna-ll' yaa-i aipaagni nacaqellikii au͡g'um atiin-qaa [?]."
        },
        "94": {
            "start": 1234.92,
            "end": 1258.4,
            "transcript": "Tua-i waten wangkutaungramta maa-i waten au͡gkut anguvilqerluki elitelput egmirrluki pikumteki wangkuta waten waniw' kinguqlimteńun elpeceńun elitevkaryuumayaaqluki."
        },
        "95": {
            "start": 1258.4,
            "end": 1276.73,
            "transcript": "Cali man'a atkuk aturaq wangkutnun nulirtullerkaq tekiskumteggu nulirput atkugkaitullerkaa."
        },
        "96": {
            "start": 1276.73,
            "end": 1293.069,
            "transcript": "Irniamta cakaitullerkaa umyuamteńun imiusngatullruuq-llu kasngunarqerkauluta tuaten nulirput atu'urkaiturtelluku."
        },
        "97": {
            "start": 1293.08,
            "end": 1303.52,
            "transcript": "Irniaput atkugkaiturtelluki kasngunarqellerkaput taringumaluku anglillruluta,"
        },
        "98": {
            "start": 1303.52,
            "end": 1316.08,
            "transcript": "nulirput neqkaitularcetlerkaa taringumaluku kasngunarqerkauluta aiparput neqkaiturcet'laqumteggu irniaput-llu."
        },
        "99": {
            "start": 1316.08,
            "end": 1340.08,
            "transcript": "Tamaa-i tamakunek umyuamteggun imiumaluta ellangvimta pillruitkut tua-i ellangpertellerkamek kesianek imangqerrnarqellrunrituq arcaqerluku neqkaaq man'a tua-i kiingan kanavirutengellra [?] taringumallruamteggu."
        },
        "100": {
            "start": 1340.08,
            "end": 1368.08,
            "transcript": "Tua-i-ll' mat'um nalliini ikayuun pugngami welfare-aq food stamp-aq neryuumilriartairucami ayagyuamek tua-i ellangpengelriatun ellangpengenrilnge'rmeng umyugait kanavirutairucami tua-i ayuqliulluteng."
        },
        "101": {
            "start": 1368.08,
            "end": 1383.86,
            "transcript": "Tamaani ellangartellemni-wa wii kumlivigtaitellruami imumi cataunani tua-i ikayuucetaunani-llu kenirkalget-llu tangnertunaqluteng."
        },
        "102": {
            "start": 1383.86,
            "end": 1397.08,
            "transcript": "Neqmek kenirarkamek avalilget tangnertunaqluteng, ayuqnianaqluteng tamaa-i."
        },
        "103": {
            "start": 1397.08,
            "end": 1405.08,
            "transcript": "Tua-i makut maa-i kinguqlimteńun niicecuirucamteki nallulriatun ellirluki."
        },
        "104": {
            "start": 1405.08,
            "end": 1420.08,
            "transcript": "Cali maa-i wiinga umyuama imaqerpalriatun ayuqetukii wangkuta qanrutesciutullruamta, nengaugiteu͡rluqumta,"
        },
        "105": {
            "start": 1420.08,
            "end": 1435.069,
            "transcript": "cangnaqsuilkumta uum nuliqliuskengamta angayuqaarita [?] neqkaaraitaa neqkaaraitnun cukaciartullerkarput."
        },
        "106": {
            "start": 1435.08,
            "end": 1446.09,
            "transcript": "Pingnatuyuilkuvet tua-i neqkaarait cukacarturluki [?] nengaugisnguarluqumta ilumun."
        },
        "107": {
            "start": 1446.09,
            "end": 1464.08,
            "transcript": "Tua-i tuaten qanrucimallemteggun uitauryuumiitnaqluni piyuumaluni ayuqellrulliniluni neqmek pingnaquranritlerkaq kasngunaqluni, unangengnaquranritlerkaq."
        },
        "108": {
            "start": 1464.08,
            "end": 1474.55,
            "transcript": "Wa-kir' [?] maa-i nukalpiarem man'a tangrruungeciquq nunani pim-gguq boyfriend-aqaa."
        },
        "109": {
            "start": 1474.55,
            "end": 1491.328,
            "transcript": "Taukut girlfriend-ami neqautaitnek nanguluugutnguyarturaqluteng mat'um nalliini, kasguyullerkaunateng-llu tamakut niicuilamegteng [?]."
        },
        "110": {
            "start": 1491.328,
            "end": 1507.26,
            "transcript": "Tuamta-llam waten qavarpiiqnak ata pisqerraqaitkut qavamek makugtengramta tupagluta tamaa unuakumi."
        },
        "111": {
            "start": 1507.26,
            "end": 1524.05,
            "transcript": "Tua-i waten pitsaqaartevkenak wiinga pitullruatnga aipangqatallemni cunaw' [?] apa'urluma pillruanka waten cakaarpenga aipangniartut palucirarkarpenek tau͡gaam aipangciqellriaten [?]."
        },
        "112": {
            "start": 1524.05,
            "end": 1538.6,
            "transcript": "Cakneq kasgunaqluni tuaten piscilleq maa-i qavamek tuaten qavanertunilua qessanqurrunilua tuaten pitullrukiit,"
        },
        "113": {
            "start": 1538.6,
            "end": 1555.71,
            "transcript": "tamana neq'akluku, neq'akluku uumek aipangrraanemnek, ilii peggluku, peggluku pingnaqurallruunga wangnek [?]."
        },
        "114": {
            "start": 1555.71,
            "end": 1564.08,
            "transcript": "Cangatenritliama taum tayima qanyuirulluteng tuaten."
        },
        "115": {
            "start": 1564.08,
            "end": 1586.08,
            "transcript": "Wiinga-llu ataurluma ayuqucir' [?] aipaqa tua-i waniw' unuaq kassuulluku uumek qanqallerminek tua-i avaunritarkamnek qanqallrulria wangnun."
        },
        "116": {
            "start": 1586.08,
            "end": 1601.06,
            "transcript": "Kasngunarqeqataryaaqvaa-lli aipan tungelqurtulria nernariaqan qancunguar imiqassaagalallerkaa neqkaaraminek [?]."
        },
        "117": {
            "start": 1601.06,
            "end": 1615.88,
            "transcript": "Tua-i taumek tua-i qanrucuilngermia arcaqakngami tayima tua-i anrutaan imai ilallerkaa tuaten qanrutellrukiinga."
        },
        "118": {
            "start": 1615.89,
            "end": 1633.01,
            "transcript": "Cali maa-i wangkutnek iliini ellakelriatun waten pitatemteńi umyuarteqtuumek food stamp-artangvailngan ava-i irniaput angunaqngellruut [?]."
        },
        "119": {
            "start": 1633.01,
            "end": 1646.27,
            "transcript": "Ciin-kiq camek caliamek-llu piilengramta food stamp-artaunani-llu paluivkenata irniamek ellaitnek anangnaqlerkaat."
        },
        "120": {
            "start": 1646.27,
            "end": 1664.08,
            "transcript": "Qaill' tekitesqellruceta tamana cali umyuaqetukeka iillakelriacetun paluyukapigcupailemteki ellaitnek pingnaqlerkaat tekitevkalput."
        },
        "121": {
            "start": 1665.08,
            "end": 1673.42,
            "transcript": "Yaa, wangkuta tang avani ayagyuallemteńi caliaq-llu piitellruuq."
        },
        "122": {
            "start": 1673.42,
            "end": 1696.13,
            "transcript": "Naken-ll' akikam caliluta naken kipusvigmek, tangvakilirluta kipusvigmun itqumta camek irniamta-ll' neqaitnek unangeciqceta caliarkartaitellruuq tamatum nalliini man'a tau͡gaam melqulek akikengnaqu'urluku."
        },
        "123": {
            "start": 1696.13,
            "end": 1706.04,
            "transcript": "Kass'aq amllellrunrilami tamatum nalliini ayuqngun tayim' pillilria maani-llu avani nunamteńek Kass'aq amllellrunrituq akingnarqellria."
        },
        "124": {
            "start": 1706.04,
            "end": 1721.08,
            "transcript": "Pitullruukut cali una equk akikengnaqluku equgglainarnun murangqetullratni imumi makut-llu kipusviit."
        },
        "125": {
            "start": 1721.08,
            "end": 1736.75,
            "transcript": "Tua-i cat navruqurangnaqu'urluku pingnaquratullruukut, camun neqkalkut Anchorage-at navrutengnaqu'urluku."
        },
        "126": {
            "start": 1736.75,
            "end": 1753.3,
            "transcript": "Wiinga cirilua anglillrunritua, iliini-llu Kass'artam, Kass'am neqiinek iliini piiteqaqluta, piicimaaqput ak'anun."
        },
        "127": {
            "start": 1753.3,
            "end": 1764.08,
            "transcript": "Mat'umek neqpigmek, neqpigmek mat'umek mer'em iluanelngurnek can'giirnek-llu anagulluta pissiyaallrunricaaqukut."
        },
        "128": {
            "start": 1764.08,
            "end": 1778.08,
            "transcript": "Tau͡gaam Kass'artarmek maaken tamatum cakviuqerluni angayuqaagka pitullruyugnarquk tamatum nalliini."
        },
        "129": {
            "start": 1778.08,
            "end": 1794.58,
            "transcript": "Wiinga-ll' tua-i piyaurcama maa-i cakviurulua pingnaqellruunga irniamnek aipamnek muraicetenritengnaqluku nenglliullerkat pitekluku."
        },
        "130": {
            "start": 1794.58,
            "end": 1807.08,
            "transcript": "Cali-llu qavamek, qavamek arcaqayussiyaangengnaqlua irnianka nulirqa-llu ayuqniallerkak ilaitnek pitekluku."
        },
        "131": {
            "start": 1807.08,
            "end": 1829.08,
            "transcript": "Taumek qanrutescitullruunga waten, \"Cakarpenek-kiq [?] nulirturniarcit? Paluarkamek tau͡gaam nulirturciquq. Cakneq atawauvkenani kasngunaqluni tamana niitelqa cakneq assirpek'nani piyuumirnaqluni tau͡gaam."
        },
        "132": {
            "start": 1829.08,
            "end": 1846.08,
            "transcript": "Qavaq-llu peg'arrluku ilii, qessam ilii peg'a yuk qessainanrani angun cak'an tekisngaitaa, neqkaan-llu tekisngaunaku, aturarkain-llu tekisngaunaku."
        },
        "133": {
            "start": 1846.08,
            "end": 1861.84,
            "transcript": "Qessaluni uitanginanrani camek, camek pingnaqevkenani qanruyun amllellruyaaquq imumi wangkuta waten maa-i ilumun qanertuq."
        },
        "134": {
            "start": 1861.84,
            "end": 1876.24,
            "transcript": "Maa-i kinguliaput, elpeci maa-i kinguliamteńi ca nalluarci, qaillun-llu anglingnaqlerci nalluarci."
        },
        "135": {
            "start": 1876.24,
            "end": 1890.39,
            "transcript": "Angayuqaamta makgutekluta nengelmek tuaten, ilumteńek tuaten makgutekluta qavaq-llu peggluku anglivkangnaqellruitkut."
        },
        "136": {
            "start": 1890.39,
            "end": 1905.06,
            "transcript": "Tua-i waten aipangllerkarput tekitellranun pivkangnaqtullruitkut, cunaw' pivkangnaq' tuaten aulukengnaqtullrulliniut."
        },
        "137": {
            "start": 1905.06,
            "end": 1918.81,
            "transcript": "Camek piungaqamta laavkaamek kipusvigmek itqerrluta pisciigatektullruamta tamaani ca akiinani pisciiganani."
        },
        "138": {
            "start": 1918.81,
            "end": 1933.04,
            "transcript": "Apqemteńek-ll' akiilngirluteng pitullruyaaqluteng, imumi ilait, tua-i-ll' akiilnguteng patutukait pillilriit tayima."
        },
        "139": {
            "start": 1933.04,
            "end": 1947.08,
            "transcript": "Maa-i-ll' arcariluteng, watua makut kinguliaput, tua-i ava-i qanellratun neqkaircarautnguciiquten tau͡gaam arnaunge'rpet angutngung'e'rpet"
        },
        "140": {
            "start": 1947.08,
            "end": 1968.08,
            "transcript": "Ukurriskuvet qang'a-ll' tuavet nengaugiskuvet neqkaircarautnguciiquten tau͡gaam, tua-i-ll' wiinga tuaten niitetullruanka piaqatnga wii."
        }
    },
    "hsTpLPFlVFI": {
        "1": {
            "start": 0.0,
            "end": 12.96,
            "transcript": "Naumastai vesraaraurtut, wagg'uq vesraaraat imkut unaunateng naumalriayagaat unaunateng."
        },
        "2": {
            "start": 14.45,
            "end": 26.58,
            "transcript": "Tua-i-llu (Can'guluteng-qaa?) Ii-i, can'guyaaqluteng tau͡gaam takevkenateng unaunateng canegni allakaunruluteng aminateng-llu."
        },
        "3": {
            "start": 26.58,
            "end": 32.59,
            "transcript": "Naninateng? Ii-i. Maqarcenateng-llu. Ii-i. Canyagaat."
        },
        "4": {
            "start": 32.59,
            "end": 40.38,
            "transcript": "Mararmiutaat-gguq tamaa-i vesraaraat maram can'gi."
        },
        "5": {
            "start": 40.38,
            "end": 47.44,
            "transcript": "Tua-i ayuquciilkumta tua-i nunapigmek tangyuilkumta,"
        },
        "6": {
            "start": 47.6,
            "end": 75.22,
            "transcript": "natetmun-ll' ayauciicugngarikumta elagluku piciqukut vesraaraullinilriit makut. Maaten tua-i carrirluki elagluki tekiskumteki piciqaput acilqurrit, acilqurrit wantellinilriit waniwa ukatmun-llu elivingaluteng maa-i qanikcautellrulliniluki."
        },
        "7": {
            "start": 75.22,
            "end": 99.58,
            "transcript": "Tua-i taringutnguluteng nunam tungiinun elivingaluteng. Uksuarmi ulerpagmi mer'em qaingitukiini uitiimeng ulerpiim qaingillrani nunam tungiinun elivtellrulliniluki nunam tungiit taringluku."
        },
        "8": {
            "start": 99.58,
            "end": 120.91,
            "transcript": "Tua-i nutaan tamakutgun cali imarpiim nunam-llu tungiit taringyarauluni. Tuaten tua-i ayuqucirtuutektullruluku wangkutnun tan'gurraarluut tamakut vesraaraat."
        },
        "9": {
            "start": 123.96,
            "end": 138.74,
            "transcript": "Tuamta-ll' tua-i imkut mecungluni patugglirluni apqemteńek cikuluku tuaten ellalluk wall' ivsuk pillrukan."
        },
        "10": {
            "start": 138.74,
            "end": 153.62,
            "transcript": "Asgulirnerit imkut cikursalaqait cat uqvigaat wall' can'get wall' ikiituut tamaa-i cali tamakut taringumasqekngait."
        },
        "11": {
            "start": 153.62,
            "end": 175.49,
            "transcript": "Cikur' ingluit cikurlakan naliagnek cikursagtaki keluvaramek wall' kanaknermek wall' ungalamek tuatun mecungniryaran tungiinun naliatnek cikurlallruaki."
        },
        "12": {
            "start": 175.49,
            "end": 196.9,
            "transcript": "Taringumallra cali tuaken cikursallruluki ikiituut ingluit uqvigaat ingluit tamaa-i call' tamakut qagkut imkut kavirlit Kass'atun ima canek pilaqaat uqvigaat willow, yaa, tamakut."
        },
        "13": {
            "start": 196.9,
            "end": 213.22,
            "transcript": "Tamakutgun cali tamaa-i natetmun caull' kingunermi tungiit taringnaqluni cumikluni-w' tua-i yuk pilria tuaten ayuqeciqelliniluni."
        },
        "14": {
            "start": 213.22,
            "end": 227.3,
            "transcript": "Kuiniuyulitun, kuinrua nalluvkenaku uilratulitun [?] cangallruvkenaku. Tua-i-qaa?"
        },
        "15": {
            "start": 243.22,
            "end": 244.9,
            "transcript": "Cali-q'?"
        },
        "16": {
            "start": 251.28,
            "end": 255.78,
            "transcript": "Atrit-ata apertualuki piniaci tamakut."
        },
        "17": {
            "start": 260.5,
            "end": 270.26,
            "transcript": "Pingayunek-wa wii atengqerrluki makut niitelaqenka. Pingayunek aterluki ayuqenrilngurnek niitelaranka."
        },
        "18": {
            "start": 288.59,
            "end": 303.14,
            "transcript": "Aterpagcesciigalkanka aterpagciiqanka, yaa. [?] caigglugnek makut pitukait maa-i waniwa-am caiggluum arnii, arnak."
        },
        "19": {
            "start": 303.8,
            "end": 317.75,
            "transcript": "Angutait-am tayima makuyaangqertut qagaa-i, makut maa-i arnauluku. Makuunateng pagkuunateng waniw' caiggluum nulirra."
        },
        "20": {
            "start": 320.51,
            "end": 333.8,
            "transcript": "Angutait-wa tayim' call' tamakut teggenruluteng, arnait-gguq maa-i makuunateng imkuyagaunateng, arnait."
        },
        "21": {
            "start": 339.68,
            "end": 365.79,
            "transcript": "Wiinga ellangellrunritua makunek iinruuvkarluki. Imum' wani wankuta uicungalleramteńek pitukvut elpeci-llu ilaraupaallerpet [?] nengaukaim [?] tuqu [?]. Uksuarmi elliin pelurkarcetuuq kelegkartarcetuuq makucinek wagg'uq makunek qaltaruanek aipalirluki."
        },
        "22": {
            "start": 368.58,
            "end": 389.22,
            "transcript": "Pelurkarcetuuq makunek uksuarmi kikika tua-i iliini piliqluni tekitaqluni qillertaaruaqluteng. Iqmituami pelurkaminek cumercetuluni makucinek, alqalqa iqmiyuitellrulria nulirr'."
        },
        "23": {
            "start": 390.74,
            "end": 405.7,
            "transcript": "Canek-gguq makunek qaltaruanek call' ilaluki legtaqluki. Maa-i qangvarpak ayagluk' niitelaranka iinruulliniluteng, iinrukniluki."
        },
        "24": {
            "start": 405.78,
            "end": 435.03,
            "transcript": "Wiinga ellangellemni iinruuluki niicuitellruanka tau͡gaam cam iliini murilkeqalallemni waten, waten ayuqluteng aanama qengak wani kevingqerturalartuk uksumi keviumauranglartuq. Caqerluku apluku, waten piluku ciin tamakunek qengagken keviumangyugcikek."
        },
        "25": {
            "start": 435.03,
            "end": 456.58,
            "transcript": "Qamiqulnguurangaqami-gguq pilarak, tua-ll' piaqa \"Caugat?\". Teptukuyaugut-gguq, teptukuyauniluku, tau͡gaam tua-i qivrulartua ciin taum nallunringnaqellrunritlinillemnek tamakut teptukuyiit."
        },
        "26": {
            "start": 456.58,
            "end": 473.02,
            "transcript": "Qamiqulnguurangaqami-gguq tua-i kevirtuuranglarak qamiqulnguyuirut'lartuq-gguq tamakunek qengagni kevirlukek tepait narumaurluki."
        },
        "27": {
            "start": 473.06,
            "end": 486.3,
            "transcript": "Caullrit qaill' naumallrit nallunringnaqellrunritanka tamakut, makut tau͡gaam nalluvkenaki maa-i iinruugurluki niicuicetullruanka."
        },
        "28": {
            "start": 486.3,
            "end": 500.7,
            "transcript": "Tau͡gaam kiingan ayut, ayunek tua-i canek allanek iinrunek niicuitellruunga maa-i, tua-ll' ellangellruunga tuaten ayuqlua, canek allanek iinrunek nallulua."
        },
        "29": {
            "start": 500.7,
            "end": 524.74,
            "transcript": "Tau͡gaam ayut, ayunek tua-i puyuit-llu naru'urluki, wagg'uq tarvarluteng-llu nevuit piqerluki caayuqluki tuaten tamakut, makut ayut, caayutairutaqameng tamakunek yuurqangaqluteng imkut yullret anguqallrenka."
        },
        "30": {
            "start": 524.74,
            "end": 544.74,
            "transcript": "Caayuq-llu paivngaurayuitellrulliniami nangutaqluteng tua-i kipusvigmek caniqliicetullruameng, ingna-ll' canimaar store-aullrunrit'laami yaaqsigluni tau͡gaam nani tayima tua-i tamakunek imalleq."
        },
        "31": {
            "start": 544.74,
            "end": 563.98,
            "transcript": "Nanguturluraqluteng pivakarluteng tua-i caayunek, tuall' au͡gkunek ava-i yuurqaarangluteng ayunek. Makunek iinruuluki niiteqayuitetullruunga wiinga."
        },
        "32": {
            "start": 563.98,
            "end": 585.98,
            "transcript": "Tau͡gaam maa-i watua iinrukengluki. Cali au͡g'um elliraam angutem au͡g'um iliini tekitaqami makurrlainarnek ciki'irqanga ulugaqamki tuar imna cotton-aatun elliraqluteng makuit, cotton-aatun tua-i ayuqluteng."
        },
        "33": {
            "start": 585.98,
            "end": 602.46,
            "transcript": "Callanernun pategtekiurqamki tutgaranka tuaten piaqata. Ulugaqamteng tua-i cotton-aatun ayuqliriaqluteng, makuit kiingita."
        },
        "34": {
            "start": 602.46,
            "end": 623.25,
            "transcript": "Ciilqavkarluki tua-i yulugluki [?] qeturivkarluki, cotton-aatun-llu ellirluteng. Patukluku, patuvkaraqluki callanret tamakucinek. Assiraqluteng tua-i."
        },
        "35": {
            "start": 623.26,
            "end": 642.06,
            "transcript": "Cali-llu tua-i ilaita kitugutekluki merturluki unuakumi neraunateng, met'uluki cali-ll' ilii tua-i iinrutun erenrem-llu qukallrani atakumi-llu."
        },
        "36": {
            "start": 642.06,
            "end": 648.93,
            "transcript": "Tua-i kitugutkaqluku ilaita kememeggnun nangtequtmeggnun makut."
        },
        "37": {
            "start": 648.93,
            "end": 663.48,
            "transcript": "Iciw' yungcaristet iinruukit'laqaitki tuaten cuqlirluki atusqelluki tuaten piaqami pillermegteggun ikayuuteknilarait wiinga iinrukqaqsaitanka makut."
        },
        "38": {
            "start": 663.48,
            "end": 677.68,
            "transcript": "Tau͡gaam meq'atuungam neqnialkaqatki nunukcaggaarluki irnianka tutgaranka-llu merkiurraarluki."
        },
        "39": {
            "start": 677.68,
            "end": 686.07,
            "transcript": "Merkiugaqamegteki-qaa qallangulluki pituut wall' mermek kumlamek kuvluku."
        },
        "40": {
            "start": 686.07,
            "end": 692.44,
            "transcript": "Uuqnarqelriamek wiinga pilaranka qallangellermek patuluki-ll' tua-i uitalluki."
        },
        "41": {
            "start": 692.44,
            "end": 699.55,
            "transcript": "Au͡g'arciqaqa ecurilliniluni tamana."
        },
        "42": {
            "start": 699.55,
            "end": 718.94,
            "transcript": "Ilait-am tutgarama irniama-w' tua-i aanateng niilluk' qetunrait atait-wa piyuill', neqnialkelluki. Nunukcagga'arluki tua-i qanevluuguqa'arluki pivkaraqluki."
        },
        "43": {
            "start": 718.94,
            "end": 741.26,
            "transcript": "Makut maa-i elliin tua-i nallunritellrukeka tauna nengaulqa tunucuk-gguq una. Makunek maa-i uksuarmi angutaitnek-llu tapirluni pelurkartetullruuq iqmituami tuquvailgan."
        },
        "44": {
            "start": 741.26,
            "end": 751.02,
            "transcript": "Tauna cali. Cali ilayukuvgu uum caiggluum atuullra."
        },
        "45": {
            "start": 751.02,
            "end": 761.62,
            "transcript": "Yuurqaqsunarqut-ll' atam caayuqsunarqut wiinga-ll' ayuni neqnikenruluki yuurqaqellrit."
        },
        "46": {
            "start": 761.62,
            "end": 770.66,
            "transcript": "Atrit-qaa? Atrit makut nallunrilkuvni cauluki nallunriciqut. Nunamteńi caiggluugut."
        },
        "47": {
            "start": 770.66,
            "end": 777.3,
            "transcript": "Unani-ll' call' Qipnermiut nuniitni qanganartangqerran call' caiggluuluteng."
        },
        "48": {
            "start": 777.3,
            "end": 781.94,
            "transcript": "Iigmi-llu caigglugtangqerran naunerrluuluteng."
        },
        "49": {
            "start": 781.94,
            "end": 790.42,
            "transcript": "Kuinerrami-ll' call' naunerrlugnek ilaita pilarait caigglugtangqerran tamana."
        },
        "50": {
            "start": 790.42,
            "end": 798.02,
            "transcript": "Maani-ll' maa-i qanganaruarullilriit qanganartailan. Taukuuluku tua-i niitelaranka."
        },
        "51": {
            "start": 798.02,
            "end": 805.74,
            "transcript": "Au͡gna-llu wii niitela'arqa caigglugmek atengqerran Tuntutuliarmi naunrakayagnek-gguq piaqluki."
        },
        "52": {
            "start": 805.74,
            "end": 808.74,
            "transcript": "Ii-i, naunerrlugnek-llu-w' tua-i pilaqait."
        },
        "53": {
            "start": 808.74,
            "end": 822.19,
            "transcript": "Tua-i-ll' ayut, I mean, maani qanganaruanek niitelaranka pivkarluki. Kingunemni tau͡gken tua-i caigglugnek."
        },
        "54": {
            "start": 822.19,
            "end": 838.34,
            "transcript": "Waten green-aaruaqata naumaaqata pit'elarait ilaita wall'u-q' ilait cali avuraqluki uksuarurtaqan tunguriaqata."
        },
        "55": {
            "start": 838.34,
            "end": 851.94,
            "transcript": "Tua-i-w' tamaa-i mecuit-llu iinruklerkait pitekluki, waten ayucetun mermun piluki meq'aqu'urallrit ilaita assikait."
        },
        "56": {
            "start": 851.94,
            "end": 859.46,
            "transcript": "Ukveqestemeggni-llam tua-i nallrusngaaqluteng tua-i ikayuugaqluteng."
        },
        "57": {
            "start": 859.46,
            "end": 871.38,
            "transcript": "Usguniqluni-ll' atam assirtut. Mecungluki tua-i waten usgunminun ellirraarluni nemerluki qavarluni-llu."
        },
        "58": {
            "start": 871.38,
            "end": 875.62,
            "transcript": "Ilugka wii pilallragni pitullruunga waten."
        },
        "59": {
            "start": 875.62,
            "end": 889.7,
            "transcript": "Ciisqugka ellivikraarluni nutaranek lumarrayagamek-llu nemerlukek qavarlua ikayuugaqluteng."
        },
        "60": {
            "start": 889.7,
            "end": 906.96,
            "transcript": "Taukut caiggluut atullrat amllerrsugnarqut. Wangkuta caigglugnek pit'uaput nem' pavani. Cali [?] cali naurrlugaqata imkut."
        },
        "61": {
            "start": 906.96,
            "end": 925.39,
            "transcript": "Makut kinercirraarluki, nasqurrit cat naurrluut naugaqata, naugaqata autullratni. Kinercirraarluku ululriani waten cotton-aatun ayuqliqertut un' qanrutkellratun [?] kinerciqerraarluku."
        },
        "62": {
            "start": 925.39,
            "end": 954.58,
            "transcript": "Tua-llu tua-i naurrluun elliluki piciatun qai' elliluki. Unuaqan paqciiqaten im'utet [?]  camek pinga'ar' nucuutelliut naurrluun tamatum pianek [?]. Tua-i-ll' ataam ellivikekuvgu tamakunek patuluku. Tua-i unuaq, uumikuan paqciiqan imkut naurrluut ak'a tamallrulliut."
        },
        "63": {
            "start": 955.45,
            "end": 984.26,
            "transcript": "Tuamta-llu maa-i pilartut nunamni makut caiggluut maa-i steam-atgun maqiyurcameng [?] imumun qaltaanun mer'anun qelluki [?], qallaucelluki. Tuanelengraata tau͡gaam ciqiluni, assiqapiarluni cali. Seq-llu cali pukniriqernganani [?] piqerrluni."
        },
        "64": {
            "start": 984.26,
            "end": 998.24,
            "transcript": "Caullrat makut amllertut, waten ayuqluni, nauviullratni [?] neru'urluki mecuit ig'aqluki, cali piaraugut makut."
        },
        "65": {
            "start": 998.24,
            "end": 1013.54,
            "transcript": "Nalangraata-ll' up'nerkami-ll' ataam pilaraat [?]. Puqlam kuvluki tua-i uucetun patuluki nalamangermeng-ll' atuugut."
        },
        "66": {
            "start": 1014.05,
            "end": 1029.03,
            "transcript": "Au͡gna avauqalliniaqa ing'utun aipama-ll' tua-i maqiaqamegnek iliini ermigcuun uuqnaq'laami imirraarluku mer'atnek tua-i ciqiaqluku."
        },
        "67": {
            "start": 1032.45,
            "end": 1038.0,
            "transcript": "Maqiqatalriani maqivililriani makut watua makut steam-atgun piyaurciqut."
        },
        "68": {
            "start": 1038.0,
            "end": 1056.69,
            "transcript": "Cali-llu taarritekluki patguurcuutekluku tememun tua-i. Atuullrat amllertuq. Ukveq'laamegteki ilait ikayuutekaqluku. Wagg'uq taarriluteng. Tua-i, tua-i, ii-i."
        },
        "69": {
            "start": 1056.73,
            "end": 1063.24,
            "transcript": "Taarissuutekluku tuaten maqiaqama."
        },
        "70": {
            "start": 1063.24,
            "end": 1086.9,
            "transcript": "Maa-i makut man'a-wa nunam qainga Ellam Yuanek taqumiimi cat makut nunam qaingani ellmeggnek nauyuitut. Uum tau͡gaam ellamek pilillrem nauvkalarai."
        },
        "71": {
            "start": 1086.9,
            "end": 1115.03,
            "transcript": "Tua-i-llam maa-i nalakuneng qaki [?] up'nerkaqerran-llu [?] tua-i urukan urukarraaqan una tua-i tuar cakartaunani nunam qainga, tua-i tuqumalriatun ayuqluni tuar naunqiggngailnguut makut-llu cali napat, tuar qakinret makut-llu qagkut caassit [?] pilriit cat tamarmi man'a nunam qainga,"
        },
        "72": {
            "start": 1117.38,
            "end": 1145.9,
            "transcript": "Agayutem-am Ellam Yuanek taqellrullinia unguvaluku, unguviimi-llu canek atsairuqaarluni-llu tuaten taqellruani, atsairuqaar' [?] atsat makut, atsalugpiat-llu maa-i makut tangrrurraarluteng igtelalriit tua-i puyunrilkarteng [?]."
        },
        "73": {
            "start": 1146.9,
            "end": 1176.29,
            "transcript": "Limit-aarteng tekitaqan. Cali-am pinarikuneng cat allat nunapiim qaingani naugiluteng leaves-aarit naugiarkat cali-am tua-i tuaten naugivkarluki, Ellam uum Yuan naugivkarluki, cat tamana pitekluku ellmeggnek naunrit'laata. (Ingkut cali pivkarki,)"
        },
        "74": {
            "start": 1176.29,
            "end": 1178.9,
            "transcript": "Time-airutqatartuci."
        },
        "75": {
            "start": 1178.9,
            "end": 1180.9,
            "transcript": "Yaa, ayunek."
        },
        "76": {
            "start": 1180.9,
            "end": 1183.9,
            "transcript": "Tamalkuita taukut."
        },
        "77": {
            "start": 1183.9,
            "end": 1192.89,
            "transcript": "(We could do this one or) (Una-llu)"
        },
        "78": {
            "start": 1192.89,
            "end": 1201.9,
            "transcript": "Makut-llu niicuitellruanka maa-i wangkuta pituaput pellukutait tumagliit uitaviit."
        },
        "79": {
            "start": 1206.22,
            "end": 1215.62,
            "transcript": "Ilaita anerniqernaitniluki pilarait, ikayuuniluki anernemeggnun."
        },
        "80": {
            "start": 1215.62,
            "end": 1240.76,
            "transcript": "Wiinga anernemnek pitullemni iinruyuitellruunga tua-i cat iinruaqtuutet nalluluki, kiingan man'a. Cali qasgimun kuvuurutiinun ilakluki qallangutevkarluki kuvelriani tuar ilumun vicks man'a-llu-q' vicks-aacetun qanremcen̄i [?] ayuqluni."
        },
        "81": {
            "start": 1240.76,
            "end": 1250.14,
            "transcript": "Yuuriillra-llu [?] call' qamna pivigturiqerrnganani makut vicks-aacetun ayuqluteng."
        },
        "82": {
            "start": 1250.14,
            "end": 1259.9,
            "transcript": "Avani tua-i ak'a ayaulluta-llu makunek maa-i kangritnek, angutaita kangritnek nerevkarluta."
        },
        "83": {
            "start": 1259.9,
            "end": 1261.73,
            "transcript": "(Tamakut-qaa waten...)"
        },
        "84": {
            "start": 1261.73,
            "end": 1271.9,
            "transcript": "Ii-i, (...qanqacuaralget [?] tang maa-i angutait?) makut, yaa, makut. Makut maa-i au͡g'arluki nerevkatullruitkut."
        },
        "85": {
            "start": 1271.9,
            "end": 1279.21,
            "transcript": "(Tamuagurluki-qaa ig'aqluki?) Wangkutnek tamualuki ig'aqluki."
        },
        "86": {
            "start": 1279.21,
            "end": 1283.9,
            "transcript": "Tua-i caayuutairutaqameng-llu makut maa-i yuurqaqtullrit."
        },
        "87": {
            "start": 1286.52,
            "end": 1306.25,
            "transcript": "Cali tua-i makut atuu', makut maa-i tarvauluteng. Ayuurutniaqluteng apqucirrlugteng  tarvarniluku. Iquit-wa leg' puyiallagalriit tua-i-ll' wavet call' narumaurluku."
        },
        "88": {
            "start": 1306.25,
            "end": 1315.17,
            "transcript": "Qumigtuquneng-llu call' tamaa-i avukluku una pakigluku kanavet elli' [?] puyuram,"
        },
        "89": {
            "start": 1315.17,
            "end": 1326.38,
            "transcript": "waten nangerrluni quun-llu [?] puyur' anevkarluki, tua-i-gguq qumigturluni, yaa, qamavet iterluni una tua-i pakigluku quun-llu [?] anluni."
        },
        "90": {
            "start": 1326.38,
            "end": 1329.43,
            "transcript": "Naulluutni anevkarluku."
        },
        "91": {
            "start": 1329.43,
            "end": 1346.9,
            "transcript": "Anesqumaluku anteńiluku [?] caiggluk makucimun. Leggluku. Quun tua-i anluni anutevkarluku tua-i nangtequtni makucimun. Tua-i-gguq qumigturluni."
        },
        "92": {
            "start": 1346.9,
            "end": 1361.63,
            "transcript": "Tuaten cumiksugallemni pitullruut. Cali qamigaqatalriit cumikeqallemni iillayulqata ayagareskilik ciuneniingnakumarqaarluki [?] cat tua-i ingkut."
        },
        "93": {
            "start": 1361.63,
            "end": 1371.59,
            "transcript": "Tua-i-llu-qaa qamigautegnun qayami qainganun elliqar', cukangnaqluni tang kumartellni qaingirluku ayagarluni."
        },
        "94": {
            "start": 1371.59,
            "end": 1392.75,
            "transcript": "Tua-i-llu alqairutkaptellrungnarqa [?], ciin-gguq au͡gna waten pia, ava-i-gguq qayani cani qamigaqataami caarrluirai tarvarai."
        },
        "95": {
            "start": 1392.75,
            "end": 1407.77,
            "transcript": "Tua-i makut tuaten avaken ayagluteng makut iinruugut. Tarvauluteng, qumigturluki tuaten tuaggun anevv', tukninganateng cali."
        },
        "96": {
            "start": 1407.89,
            "end": 1418.57,
            "transcript": "(He's almost ready.) (Okay, we're back on.) Calriatun utaqavkarnaurtut."
        },
        "97": {
            "start": 1418.57,
            "end": 1424.46,
            "transcript": "Uum waniwa ukvekpiarutii yuarun."
        },
        "98": {
            "start": 1424.46,
            "end": 1434.92,
            "transcript": "Tarvarnauramken"
        },
        "99": {
            "start": 1434.92,
            "end": 1444.8,
            "transcript": "Tarvarnauramken"
        },
        "100": {
            "start": 1444.8,
            "end": 1462.28,
            "transcript": "Ellugarnauramken pikaniraniartuten"
        },
        "101": {
            "start": 1462.28,
            "end": 1472.05,
            "transcript": "Yugiyamaa tarvarnauramken"
        },
        "102": {
            "start": 1472.05,
            "end": 1481.49,
            "transcript": "Akuluram-qaa kat'um tarvartainek-qaa"
        },
        "103": {
            "start": 1481.49,
            "end": 1498.36,
            "transcript": "Elluarlluten-qaa qamigaquniar"
        },
        "104": {
            "start": 1498.36,
            "end": 1507.76,
            "transcript": "Tarvarnauramken"
        },
        "105": {
            "start": 1507.76,
            "end": 1525.37,
            "transcript": "Ellugarnauramken pikaniraniartuten"
        },
        "106": {
            "start": 1525.45,
            "end": 1544.49,
            "transcript": "Yugiyamaa tarvarnauramken, kinuqat-gguq qamkut tarvartaitnek-qaa"
        },
        "107": {
            "start": 1544.49,
            "end": 1561.23,
            "transcript": "Elluarlluten-qaa makiraquniar tuta-aniar"
        },
        "108": {
            "start": 1561.23,
            "end": 1574.57,
            "transcript": "Tua-llu cam yugmek tuaken ca uum au͡g'aryugngacian cali tangrruarutii ukvernarqutekluku-llu."
        },
        "109": {
            "start": 1574.64,
            "end": 1582.95,
            "transcript": "Uinguallinilria arnat iliit uinguatullratni nulirruarluteng-llu."
        },
        "110": {
            "start": 1582.95,
            "end": 1596.11,
            "transcript": "Tamakut tang angun nulirruaquni ilami tangyuilengraatgu elliin nallmikun [?] tauna arnaq angutngukuni nulirrualria,"
        },
        "111": {
            "start": 1596.11,
            "end": 1613.12,
            "transcript": "arnaq tauna tangerrngaksagutetulliniluku. Tua-i-am tauna arnat iliit uingualliniluni. Uingaura-ll' tauna tapiararluni [?] tua-i arnani ullatulliniluku."
        },
        "112": {
            "start": 1613.12,
            "end": 1635.19,
            "transcript": "Tua-i-am taum arnam uinguani tauna waniw' tua-i wanirpak ak'aurteksailnguq taiqataan makucit maa-i ayut leggluki tepkegcalliniuq tua-i ayutun neriluni [?]."
        },
        "113": {
            "start": 1635.19,
            "end": 1659.52,
            "transcript": "Tuaken kevall' [?] qaniusqelluni taumun uinguaminun. Taqkan agluinguarat [?] taun igvalliniuq. Ikirucaaqluku uinguara taun nang'ertelliniuq. Nang'errluni tangvaggaarluku ye-rluni [?] tunulluku niitellinia ye-i [?]."
        },
        "114": {
            "start": 1659.52,
            "end": 1676.4,
            "transcript": "Ayum ayuurutaanga. Tua-i-gguq cunaw' uingauni taun inerqurrluku alaitenqigg'. Tua-i. (Quyana) Ayum ayagtelluku."
        },
        "115": {
            "start": 1676.4,
            "end": 1686.64,
            "transcript": "(Ii-i, ayuuruuyulluku.) Ayuurutanga'arluni ayalliniluni, tainqiggngairulluni."
        },
        "116": {
            "start": 1686.64,
            "end": 1708.15,
            "transcript": "Tua-i-qaa? (Tua-i-wa [?] freezer) Unkunuaqu cali meeting-atartukut apqauryugamken yaqulget, qaillun yaagneq, measurements."
        },
        "117": {
            "start": 1708.15,
            "end": 1733.9,
            "transcript": "Yaqulget pivkenateng yagneq. (No, yaqulget-llu, birds) Yaqulegnek taitellruami, yaqulegnek call' apqaurciquq. (Tua-llu yagneq, tua-llu if we have time, we might try to talk about more about survival skills like he was talking about with grass, yugtun.) Unaqu-gguq quyureskumta..."
        }
    },
    "u1uo02UBFoQ": {
        "1": {
            "start": 21.76,
            "end": 36.72,
            "transcript": "Qamani-wa wiinga nunamni Akiarmi, imkut makut maa-i cikukan taluyat-llu ceńarcuutet."
        },
        "2": {
            "start": 36.72,
            "end": 48.26,
            "transcript": "Enekaitnek-am ciumek ciku ukiqaarluku carvanermek yualalliniut ak'a avaken ayagluteng."
        },
        "3": {
            "start": 48.26,
            "end": 60.54,
            "transcript": "Ciuliatnek ciuliat piciryaraqeqngamegteggu man'a, taluyam pissuutii alerquutii ayuqucirtuutii maliggluku."
        },
        "4": {
            "start": 60.54,
            "end": 77.02,
            "transcript": "Maligtenrilkunegteggu umyuateng-ll' aturluku ping'e'rmeng elluatuqngailameng tua-i ellait tau͡gaam imkut ca man'a pissuukarteng,"
        },
        "5": {
            "start": 77.02,
            "end": 96.9,
            "transcript": "Aipal'ggarmek una angllerkaa pitekluku tua-i tuaten ceńarcuutngung'e'rmeng-llam makut taluyarpiit maa-i-wa ceńarcuutet nunamni muraulrirtut."
        },
        "6": {
            "start": 96.9,
            "end": 112.76,
            "transcript": "Imkut tau͡gaam caviit, caviit nurnairutnitekluki, chicken wire-aat makut wall' imkut yaassiigtangqellriit."
        },
        "7": {
            "start": 112.76,
            "end": 122.54,
            "transcript": "Ilait tua-i waten tamakut tak'urluteng, ukugnek-am cali waten cuqyuterluteng two inch."
        },
        "8": {
            "start": 122.54,
            "end": 139.24,
            "transcript": "Tamakut tamaa-i waten ayuqellriit tau͡gaam tegg'utan kelucaluteng, weld-aungarluteng-am tamakunek qaillun tayima, waten akultutalalliut, tamakut taluyaglallriit chicken wire-at."
        },
        "9": {
            "start": 139.24,
            "end": 152.98,
            "transcript": "Tau͡gaam pilingnaqleq-am keggsuutegenkun, pliers-aagnegun, wangkuta-wa Yugcetun tamakut pliers-at acilarput keggsuutnek."
        },
        "10": {
            "start": 152.98,
            "end": 165.38,
            "transcript": "Tua-i cavik una kepraarluku-llu pereqluku tua-i tuaten, tuam' unatellugnarquq atam tamakunek taluyinek, tau͡gaam caputait."
        },
        "11": {
            "start": 166.82,
            "end": 184.32,
            "transcript": "Caputaita waniwa akultutaciit, ukuk pingayun, tua-i tamana una-am aturluku ceńaq kelua muragnek kapurqirraarluteng."
        },
        "12": {
            "start": 184.32,
            "end": 198.5,
            "transcript": "Caputellem cali kalvaguterluteng, imkunek nalleryaagalrianek, enrilnguanek, maqaruat nertukaitnek amiit nertuut maqaruat."
        },
        "13": {
            "start": 198.5,
            "end": 213.1,
            "transcript": "Tamakunek tua-i amilnguurnek taktakengraata kalvagteqatarqameggni ciumek cim'irraarluki, tamakut imkut piliateng napayagaat waten piluki."
        },
        "14": {
            "start": 213.1,
            "end": 226.78,
            "transcript": "Waniw' una cuqyutekurluni [?] akulkicessiyaakuni-am kiaceńi [?], au͡gna iliini waten pilaami, Kusquqviim maani ceniini."
        },
        "15": {
            "start": 226.78,
            "end": 240.0,
            "transcript": "Merigluni-gguq, uksungraan ca una cikumeng'e'rmi tauna tua-i nayugluni, merigluni-gguq tua-i."
        },
        "16": {
            "start": 240.0,
            "end": 257.6,
            "transcript": "Qamana, qamana eneliluni tamatum-am uatiini yaa-i ingna tuaten userqekan uksungraan ciulia [?] imkut igqaqellret nunam au͡gkut taqyagaat,"
        },
        "17": {
            "start": 257.6,
            "end": 272.44,
            "transcript": "Uqviinrarngayagaralriit wall'u imkut urugnganateng, nunam piit taumi im'ullerqellra [?] aterrluku ciulavik-gguq,"
        },
        "18": {
            "start": 272.44,
            "end": 286.08,
            "transcript": "Carangllungluteng tua-i, tamana pitekluku tua-i uumek cuqyutengqelaryugnarqut, ilait kevirluteng tua-i kevi'irqata."
        },
        "19": {
            "start": 286.08,
            "end": 301.1,
            "transcript": "Qau͡gyaukata nayugyugngaluku, tua-i-gguq nerurrluku carvanrem, cali-am nekait carvanertua waten elliurturalria assirluni, imkunek-am pi',"
        },
        "20": {
            "start": 301.1,
            "end": 311.66,
            "transcript": "Imkut kass'artarnek aptenritaaten muragnek pilianeng nemiarneng [?] qaillun akultutaciit cigiit."
        },
        "21": {
            "start": 311.66,
            "end": 328.96,
            "transcript": "Tua-i-wa enrilnguat napayagaat imkut, naugaarnek pilartut caputekanek, napanek, cauyat, [imkut pilit] tua-i waten, [waten] akultutaciit maa-i."
        },
        "22": {
            "start": 328.96,
            "end": 340.22,
            "transcript": "Taluyarpagnek pilianek nemiaranek pikuvet, qayutun makut cigiit akultutaluki pillerkaatnek caucirkaitnek aptaaten."
        },
        "23": {
            "start": 340.22,
            "end": 351.62,
            "transcript": "Tua-i-w' ava-i caputet enemta taluyarpilriatun ayuqut cavutetullrat kingunemni waten tua-i waniw' ukunek pingayugngek,"
        },
        "24": {
            "start": 351.62,
            "end": 361.18,
            "transcript": "Tuaten tua-i waten tamana murayaggaak enrilnguarraat waten."
        },
        "25": {
            "start": 361.18,
            "end": 372.9,
            "transcript": "Waniwa waten one two pingayukuneng waten akultutaciqliniluteng qukaatni menglii una-llu cali waten."
        },
        "26": {
            "start": 372.9,
            "end": 394.64,
            "transcript": "Una-wa waniwa pingayunek-gguq yuaranek, tamakut cuqyutengqertut tau͡gna pitekluku, caluku ciulavik, carangllugnarqellria,"
        },
        "27": {
            "start": 394.64,
            "end": 412.22,
            "transcript": "Kuvyat-llu cali kuvyaunge'rmeng cali tuaten tua-i, caranglluut tamatum piaqateng pugtayuitut kit'etuut tua-i neggluku-llu carvanrem pugtaqutaqengraan piyugngaa."
        },
        "28": {
            "start": 412.22,
            "end": 431.98,
            "transcript": "Tamana pitekluku tua-i akultuteng uumek cuqerluteng manignat makut ciutmun anyuitut pamyumegteńun pamyuteng anqaarluki pektaarluteng kingutmun antuut."
        },
        "29": {
            "start": 431.98,
            "end": 441.24,
            "transcript": "Tamana pitekluku tua-i ceńarcuutet-llu ukut wani kegginaquruarit."
        },
        "30": {
            "start": 443.52,
            "end": 459.3,
            "transcript": "Tuaten pillerkaa tamakut piluku pilartut, pat'gutkengnaqu'urluku-w' tua-i elluarrluku assirluku pingnaq'larait."
        },
        "31": {
            "start": 463.68,
            "end": 475.32,
            "transcript": "Tuamta-llu cali qaillun imkut teggutait, teggutaita ilaita."
        },
        "32": {
            "start": 475.32,
            "end": 487.88,
            "transcript": "Tamakut una una [?] tau͡gaam nuugit waten-am cali tamakut waten nemiarluki un' aciqliq teggutii."
        },
        "33": {
            "start": 487.88,
            "end": 498.02,
            "transcript": "Imkut uiva' taluyat can'giirtut uivaarluki pilaqait, tua-i tuaten waten tau͡gaam cingigluki tamakut."
        },
        "34": {
            "start": 498.02,
            "end": 502.52,
            "transcript": "Una paltuun wani uumun agtui'."
        },
        "35": {
            "start": 510.82,
            "end": 513.74,
            "transcript": "Tua-i-qaa nutaan?"
        },
        "36": {
            "start": 516.6,
            "end": 521.44,
            "transcript": "Qanerkaqa-wa imna nauwa tayim arulaircatni tamaq'."
        },
        "37": {
            "start": 521.44,
            "end": 536.54,
            "transcript": "Teggutait. Yaa, tegg'utait cali-am imkunek qapugcetellrianek peryugngalrianek pairtekluki tau͡gaam."
        },
        "38": {
            "start": 536.6,
            "end": 548.92,
            "transcript": "Assilqurra tamatum nayumiqastekaata assilqura yaaqsiuluku, im'um-llu cali kepellra, kepellra."
        },
        "39": {
            "start": 548.92,
            "end": 567.18,
            "transcript": "Kangkek tau͡gken wani usgullukek cali nemrullukek-am cali tuaten piyaraut tau͡gaam pitatekengnaqu'urluki-am imkut man'a elliqerraallerteng ayuqut, perraanritengnaqluku, nalqingnaqluku,"
        },
        "40": {
            "start": 567.18,
            "end": 581.68,
            "transcript": "Arcaqerluki makut qugnilngurnun au͡g'umun avgulek, waten elligtalriamun, usukcaulluku tua-i pilaamegteggu."
        },
        "41": {
            "start": 581.68,
            "end": 594.86,
            "transcript": "Nalqingnaqluki tamakut kelliit ceńarcuutet pilalliniut, tua-i-llu cali pingna nurutengraan cali napat."
        },
        "42": {
            "start": 594.86,
            "end": 607.24,
            "transcript": "Taqagkucit qagaa-i napayagaat muriik kapuqaarlukek muracuaraak tamakuk piyunarqellriikek wall'u pingayunek."
        },
        "43": {
            "start": 607.24,
            "end": 624.68,
            "transcript": "Tamakut tua-i taukut muriit pau͡gna pinrilkan inarrluki-am imkut qagkut quunarliyagaat, kipullgutaarluki acilqurrit tuantaqluteng, wantaqluteng."
        },
        "44": {
            "start": 624.68,
            "end": 635.28,
            "transcript": "Tua-i-llu cali negucirluki neggluki kelua capluki pilartut."
        },
        "45": {
            "start": 636.48,
            "end": 656.88,
            "transcript": "Callanritengnaqluki tamakut manignat pitekluki, tuamta-llu cali kiagmi, makunek nauw' manalaqait imkut unani Kusquqvagmi neqcuaraat white fish-ayagaat."
        },
        "46": {
            "start": 656.88,
            "end": 668.64,
            "transcript": "Cali-am tamakut tuacetun ceńarcuucilriatun kiagcuuciluteng-gguq, taluyilallruut pikartuyirnerutellermeggni [?],"
        },
        "47": {
            "start": 668.64,
            "end": 682.44,
            "transcript": "Tuamta-llu cali tuaten tua-i ceńarcuutnun capluki pilalliniut keluit capqerluki kanavet caputet ellillermegni iquakun,"
        },
        "48": {
            "start": 682.44,
            "end": 702.36,
            "transcript": "Tau͡gaam matarrluteng, kuima' nauw' kuimarqameng maa-i matarrluteng tua-i caarluni tamakut kapurqelallikait, kapurqelallrullikait elluatun [?] angayamek piitlermeggni."
        },
        "49": {
            "start": 702.36,
            "end": 707.64,
            "transcript": "Tuntuviit wall'u-q' tuntut-llu-qaa enritnek atutullruut?"
        },
        "50": {
            "start": 707.64,
            "end": 709.36,
            "transcript": "Aturpek'nateng."
        },
        "51": {
            "start": 709.36,
            "end": 713.02,
            "transcript": "Tau͡gaam. (Canun allanun pissurcuutmeggni?)"
        },
        "52": {
            "start": 713.02,
            "end": 721.72,
            "transcript": "Imkut tau͡gaam avani ciuqvapiani, ciuqvapiani."
        },
        "53": {
            "start": 721.72,
            "end": 723.1,
            "transcript": "Uitaqaqa."
        },
        "54": {
            "start": 728.64,
            "end": 742.24,
            "transcript": "Aling' catlim"
        },
        "55": {
            "start": 742.3,
            "end": 757.58,
            "transcript": "Tua-i-llu avani Kass'at nurnallratni makut tua-i tuntut cirunrit tau͡gaam teggelriit kepluki cikuliurutkengnarqenglallallrulliniut."
        },
        "56": {
            "start": 757.62,
            "end": 773.04,
            "transcript": "Cavik nurnallrani au͡gkut ciuliapiat Kass'artaunani, tamatum nalliini tua-i ca aklukengnaqluku pilallermeggni tua-i tuaten pilallrullinia."
        },
        "57": {
            "start": 773.06,
            "end": 790.42,
            "transcript": "Cirunernek teggelrianek tau͡gaam imkunek cikuliuruteng'e'rmeng pingailngurmi navegngailngurnek-wa tua-i."
        },
        "58": {
            "start": 790.42,
            "end": 795.58,
            "transcript": "Terqimalrianek [?] pilallilriit cikuliurutengqelallrulliniit tua-i tamaani."
        },
        "59": {
            "start": 795.58,
            "end": 800.4,
            "transcript": "Keggutait-llu atutullruit?"
        },
        "60": {
            "start": 800.4,
            "end": 809.12,
            "transcript": "Keggutait tuaten tang keggutnek unani-w' tau͡gaam."
        },
        "61": {
            "start": 809.12,
            "end": 825.3,
            "transcript": "Ava-i atulallrit au͡g'umun-llu kapuarrlukek-gguq keggutngukagnek calissuutaitell' atullrunritut-llu caliaqumayarauluteng."
        },
        "62": {
            "start": 825.3,
            "end": 838.58,
            "transcript": "Tuamta-llu cali avani makunek maani Kass'artaitellrani cali-am teggalqut umililuki."
        },
        "63": {
            "start": 839.8,
            "end": 854.4,
            "transcript": "Pagaani ingrini iliini teggalqut mamkunateng qupuumalartut tamaa-i-gguq cimilegka tua-i tamakut caliaqluki piaqluki."
        },
        "64": {
            "start": 854.4,
            "end": 861.86,
            "transcript": "Nateqvani tamakut teggalqut piaqluki, ingrini-q' uitalrianek?"
        },
        "65": {
            "start": 861.86,
            "end": 876.2,
            "transcript": "Ingrini, ingrini uitalrianek. Imkut nallitmun qupulriit, caulleralriit ima tanem."
        },
        "66": {
            "start": 876.2,
            "end": 884.52,
            "transcript": "Atengqertut cat tamarmeng teggalqurrungermeng ayuqenrilameng atrit atengqertut."
        },
        "67": {
            "start": 884.52,
            "end": 896.94,
            "transcript": "Canek-am au͡gkut quputulit tamakut, qiurut, qiurunek."
        },
        "68": {
            "start": 896.94,
            "end": 905.02,
            "transcript": "Tua-i tamaa-i tamakut cingilektukait qiurut-gguq, imkut nallitmun. (Yaa.)"
        },
        "69": {
            "start": 905.04,
            "end": 923.3,
            "transcript": "Makunun-wa tau͡gaam arcaq'urluki pavani urluvegnun [?] im' pitegcautaitnun cingilek, ungituq [?] waten ayuqliriqerrluki ilait cingilek atullrukiit."
        },
        "70": {
            "start": 924.3,
            "end": 941.12,
            "transcript": "Unani-llu ca unani imarpigmi-am cali imkunek, cali pililallrullinikait pitegcautet tuaten, imkut-llu ava-i qalamcikek'a au͡g'um ciuqlirma."
        },
        "71": {
            "start": 941.12,
            "end": 954.4,
            "transcript": "Pingayun pingayun im' cingilek tamakut maani nuusaarpagnek pilarait tamaani-llu au͡g'um qanrutellra nuusaat."
        },
        "72": {
            "start": 954.4,
            "end": 970.2,
            "transcript": "Cali-am pissuuterluteng au͡g'utun maani enernek pivkenaku una tau͡gaam ayaun tua-i, ukut-llu naltegussuutait tua-i waten."
        },
        "73": {
            "start": 970.2,
            "end": 983.3,
            "transcript": "Nayukaumaluteng tua-i una tamana-am imna narulkarcuun uumek neg'arrluku tua-i waten."
        },
        "74": {
            "start": 983.42,
            "end": 1002.88,
            "transcript": "Piinanermek una-ll' neng'arrluku, kiimi tua-i una au͡gna nurauq narullkarcuun uumek piqerluku, ukugnek tegumiaqluku tauna."
        },
        "75": {
            "start": 1002.88,
            "end": 1016.54,
            "transcript": "Uum tau͡gaam tua-i elliluku ellinginanermini tua-i una-llu tua-i pikavet ellir', una wani cuqluku-am cali pillra."
        },
        "76": {
            "start": 1016.54,
            "end": 1027.96,
            "transcript": "Napa'arteqatallra tua-i pitaciq neggluku, napa'arteqataqan peg'arrluku, ukugnek tau͡gaam tegumiaqluku taun' nuqaq."
        },
        "77": {
            "start": 1027.96,
            "end": 1044.22,
            "transcript": "Uum alularluku cali tauna pingraan, nuraam au͡g'um, maani-llu ukuk wani ayuqluki pilarngat'lallruut, tuamta-llu cali anguyiit nalliitni."
        },
        "78": {
            "start": 1044.3,
            "end": 1059.58,
            "transcript": "Tamakut tua-i ungit cingilget imkunek-am makunek taryaqviit ulligtat."
        },
        "79": {
            "start": 1059.58,
            "end": 1073.28,
            "transcript": "King salmon-aat ulligtat ingkut pamyuit, assilriani nauw' imkut qiirnganateng aminateng tua-i-w' qiiret."
        },
        "80": {
            "start": 1073.28,
            "end": 1088.16,
            "transcript": "Un'gartelalriit maani-llu piluteng, tamakut-gguq tamakut-am tegularluki qip'aliluki ak'a-llu pitegcautmun taumun nemeqluku."
        },
        "81": {
            "start": 1088.16,
            "end": 1094.78,
            "transcript": "Pelassinagtaitellrani, wire-aartaitellrani."
        },
        "82": {
            "start": 1094.78,
            "end": 1115.44,
            "transcript": "Tamakunek, wagg'uq tua-i tamakut kiillugnaqngata-gguq tamakunek taryaqviit nuyayarngalngurnek qiirnganateng tau͡gaam tamakunek qip'aliiluki nemlallruit, kiillugnarqut-gguq."
        },
        "83": {
            "start": 1115.44,
            "end": 1130.64,
            "transcript": "Tuamta-llu cali arnaq-am cali aamarciluku una qaillun ayuqaqan, mikelnguq wall'u qainga callartaqan [?] angut tamakunun neryaqunak aamarciutemta [?]."
        },
        "84": {
            "start": 1130.64,
            "end": 1140.3,
            "transcript": "Evsaigpenek aamarcuutet tamakunek nernerrluugut neryaqunak."
        },
        "85": {
            "start": 1140.3,
            "end": 1154.16,
            "transcript": "Tamaa-i aamarcilriamun-llu cat makut, tuamta-llu cali irniarit pitekluki."
        },
        "86": {
            "start": 1154.16,
            "end": 1163.08,
            "transcript": "Bottle-aaq milegmek kuvluku qatellriamek piyuitellruut, uumek tau͡gaam tua-i arnam [?] aamarciilallrulliniut."
        },
        "87": {
            "start": 1163.08,
            "end": 1176.58,
            "transcript": "Imkut-gguq-am aamarciinanermeggni-llu, piciatun nerlallret maani aripanilarput qassarluteng wall'."
        },
        "88": {
            "start": 1176.58,
            "end": 1189.28,
            "transcript": "Tua-i-gguq-qaa imkut-llu kilinri wall'u mamesciigatetuut, tau͡gken-am imkut murilkelluki pillret mikelnguut aamarciaqameng."
        },
        "89": {
            "start": 1189.28,
            "end": 1201.78,
            "transcript": "Tamakut-gguq kilinrit mamellrit cukaut, ca man'a pissuutengqerrami."
        },
        "90": {
            "start": 1201.78,
            "end": 1220.74,
            "transcript": "Maani-wa naamell' im'-wa un'gani qaill' ayuqelartat tamana, wangkuta maani neqnek aripalrianek neresqessuitellrulliniut tamakut muggcilriit evsiameggnek."
        },
        "91": {
            "start": 1220.74,
            "end": 1230.98,
            "transcript": "Tuamta-llu cali imkut kuvyat, assirtuq."
        },
        "92": {
            "start": 1231.1,
            "end": 1245.1,
            "transcript": "Kuvyat cali imkut maani ava-i au͡g'um ciuqlirmek qanqallrukii imkut iqallugcuutet."
        },
        "93": {
            "start": 1245.1,
            "end": 1265.46,
            "transcript": "Ukut wani angtateksugngaut iqalluk, sayak, tua-i taukuk kuvyata angtateksugngait tau͡gaam-am imkut, iqtutacia kuvyam."
        },
        "94": {
            "start": 1265.46,
            "end": 1278.0,
            "transcript": "Akimiarmek-gguq neganek pikaken ayagluku tua-i 15 mesh akimiaruluni."
        },
        "95": {
            "start": 1278.0,
            "end": 1296.82,
            "transcript": "Tamakunek tua-i qillerkirraarluku [?] atratmun cali tamakut pirraarluki nutaan tua-i elliurturluku taun ayagnirraarluku piyugngaluni."
        },
        "96": {
            "start": 1296.82,
            "end": 1316.54,
            "transcript": "Iqtutacia ciumek pirraarluku tua-i-llu cali avani aguutetgun maani-llu pilallrulliniut, angyaitellermeggni, angyaitellermeggni."
        },
        "97": {
            "start": 1316.54,
            "end": 1332.58,
            "transcript": "Cali-am taktacia tua-i-gguq kuvyat taqkapiaq, ellaitni-wa tua-i one cycle-aarulallilriat tayima yagenret akimiaq."
        },
        "98": {
            "start": 1332.58,
            "end": 1350.54,
            "transcript": "Atauciim, aipaak, pingayuak, cetamiik, tallimiik, tua-i tuaten-llu yagqerrluki tua-i fifteen-aarurrluta-llu taqluku, taktaciit."
        },
        "99": {
            "start": 1350.54,
            "end": 1370.2,
            "transcript": "Tua-i-llu cali tuaten ayuqngata-am imkut mesh-ait akimiarnek taryaqvagcuutet-wa makut angenrutuameng uyatunrulallilriit tayim' mikcuayaaq iqtutacia negarkilami piqkiciiquq."
        },
        "100": {
            "start": 1370.2,
            "end": 1379.44,
            "transcript": "Angliriina-lli-llu [?] maliggluku una wani negaq, takliriinaraami."
        },
        "101": {
            "start": 1379.44,
            "end": 1389.96,
            "transcript": "Taukuk imkuk negelgaq waniwa iqallukcuutngukuni wall'u waniw' una waten taktayartuq tang negaq."
        },
        "102": {
            "start": 1389.96,
            "end": 1397.74,
            "transcript": "Tua-i-llu waten piyugngaluni malrunek waten piami."
        },
        "103": {
            "start": 1397.74,
            "end": 1401.16,
            "transcript": "Unatmegnek-qaa cuqyucirluteng piaqluteng?"
        },
        "104": {
            "start": 1413.68,
            "end": 1421.12,
            "transcript": "Tua-i tuaten pilartut pilallrulliniut maani Kusquqvagmi pissuutekameggnek."
        },
        "105": {
            "start": 1421.12,
            "end": 1432.06,
            "transcript": "Aguutekun-llu qantaq murak kuvyaliateng tamana tua-i akimiarmek yagnelek."
        },
        "106": {
            "start": 1432.06,
            "end": 1445.22,
            "transcript": "Qantamnek [?] nek'arrluku cali-am imkunek puuvilirluki [?] ipuutngutulinek kevraartut imernaitnek cakilluki tau͡gaam."
        },
        "107": {
            "start": 1445.3,
            "end": 1455.94,
            "transcript": "Canek-am engelaitun qillrutevkenaki, neqem camani kuimallra cuqnguaqerluku."
        },
        "108": {
            "start": 1455.94,
            "end": 1470.72,
            "transcript": "Iliini-llu neqet waniwa tua-i atercetaqameng qaillukuarluki taklirikanirluki-llu piyugngaluki, atraqaniryugngaluki tamakut imkut."
        },
        "109": {
            "start": 1470.72,
            "end": 1488.26,
            "transcript": "Taum muriim pugtaqulia' pugtaquciameng uyatuqanirluki tau͡gaam ukirrluki tuaten tua-i aciqvaqanirayugngaluku."
        },
        "110": {
            "start": 1488.26,
            "end": 1504.08,
            "transcript": "Atercetameng-llu-gguq tua-i tuaten qemia puuvim tamakut imkut qillrusngalriit ilavkuat."
        },
        "111": {
            "start": 1504.08,
            "end": 1518.24,
            "transcript": "Cali-wa-am piliaqngamegteggu tua-i qerqerluku iquklican kegqerluku nengumavkangnaqu'urluku anguartura keggluku."
        },
        "112": {
            "start": 1518.24,
            "end": 1540.26,
            "transcript": "Tua-i-llu-gguq cam-am am'um neqem qimullagallni pian elliurameng, nutaan piluku tekiteqataamegteggu au͡g'arcetenritengnaqluku mulngakluku kaugturian kaugturluku tua-i nuqluku."
        },
        "113": {
            "start": 1543.38,
            "end": 1558.92,
            "transcript": "Tua-i au͡g'umek kuvyaramek ava-i cuqyutiinek maani Kusquqvagmi qanqertua."
        },
        "114": {
            "start": 1558.94,
            "end": 1578.56,
            "transcript": "Makut-llu cali, Akulmi-llu cali ava-i Akulmi cali neqengqerrami umkucetun imarpigtartun luqruuyiit imarpinrarngalnguut akakiiget."
        },
        "115": {
            "start": 1578.56,
            "end": 1585.84,
            "transcript": "Tamaa-i tamakut-amta cuqluki kuvyalilallruutelliniut pavani Akulmi."
        },
        "116": {
            "start": 1585.84,
            "end": 1592.28,
            "transcript": "Tau͡gaam kuvya'."
        },
        "117": {
            "start": 1592.28,
            "end": 1610.14,
            "transcript": "Ilait-wa tua-i kuvyaryuumiitaqameng kuik capluku taluyarpaliluteng, taluyarpateng civvluki pilalliniut, tau͡gaam carvanek caumaluku up'nerkami neqet makut tamarmeng mayutuut, kamitetuut."
        },
        "118": {
            "start": 1610.14,
            "end": 1618.8,
            "transcript": "Maa-i-ll' uksuarmi mat'um nalliini uterrluteng tua-i."
        },
        "119": {
            "start": 1618.8,
            "end": 1628.3,
            "transcript": "Aren maa-i-gguq pau͡gna neqairutevsiallikiit-llu makut too many beaver kuiget capuqtarluki."
        },
        "120": {
            "start": 1628.36,
            "end": 1638.3,
            "transcript": "Yaa makut can'giircurviit pau͡gani-ll' nunamteni amllerrsaaqut tua-i nernarkaqluteng imum',"
        },
        "121": {
            "start": 1638.3,
            "end": 1650.5,
            "transcript": "Watua paluqtaq amllerissiyaagami neqairait paluqtaat can'giirnek tuaten kuik capurluku, paluqtaq amllessiyaagngami."
        },
        "122": {
            "start": 1650.5,
            "end": 1661.56,
            "transcript": "Kiituan [?] Kuigpak ilii una [?] nequtungraan ilii paluqtaam eniinek pitangqerrsaaqut kuigpiit ceńiini paluqtaq amllessiyaagtuq."
        },
        "123": {
            "start": 1661.56,
            "end": 1674.06,
            "transcript": "Kiituan unani-llu imarpiim ceńiini paluqtarnek qinuciaramun nayiyuitnun wii malirqaqluki imarpigmi unani."
        },
        "124": {
            "start": 1674.06,
            "end": 1680.12,
            "transcript": "Amllessiyaak paluqtaat makut niitetullruanka pitarkat nangtuniluki."
        },
        "125": {
            "start": 1680.12,
            "end": 1685.06,
            "transcript": "Ciin makut paluqtaat nangyuipakartat amlleriinarluteng tua-i?"
        },
        "126": {
            "start": 1685.06,
            "end": 1702.22,
            "transcript": "Nunani-llu Kuigpagmi nunamteńi Kuiggayagartangqellra unavet pavavet, qavcinek tayima paluqtaat enaitnek pitangqerrluni tamaaggun Kuiggayaggun itlernek enet akuliitnun uitaaqluteng."
        },
        "127": {
            "start": 1703.3,
            "end": 1710.74,
            "transcript": "Paluqtaq amlleriami cat maa-i pissuyuirulluki-ll' tamakut."
        },
        "128": {
            "start": 1710.74,
            "end": 1720.96,
            "transcript": "Uumek ikayuqerqacuaqaqataramken imernarrlainarnek kuvyat pugtaqutangqetullrunritut imumi."
        },
        "129": {
            "start": 1720.96,
            "end": 1734.56,
            "transcript": "Waten-llu quuyaaq waten quuyaaq kepurraarluku, una-llu ukucia ak'a pingaitua [?]."
        },
        "130": {
            "start": 1739.4,
            "end": 1749.3,
            "transcript": "Kingunun Kuigpagmi. ([?] imernat kinraqameng uqrililallrata [?] aturpallungat'lallrukait.)"
        },
        "131": {
            "start": 1749.3,
            "end": 1761.14,
            "transcript": "Yaa, uqriitut. Tua-i tau͡gken waten quuyaaq-llu waten cellegtangraan kepurraarluki taktataltak' ah shit, taktataskeggiluki [?]."
        },
        "132": {
            "start": 1761.14,
            "end": 1771.3,
            "transcript": "Ukut-am iquit iqertuarluki ciikarluku waten ayuqliriqercelluki."
        },
        "133": {
            "start": 1771.3,
            "end": 1772.98,
            "transcript": "Cakuciit muriit?"
        },
        "134": {
            "start": 1772.98,
            "end": 1786.5,
            "transcript": "Muriit piciatun quuyaganek, muracuaraat waten cellegtangraata, cellegturengraata, uum-llu anguranqengraaki."
        },
        "135": {
            "start": 1786.5,
            "end": 1792.3,
            "transcript": "Piqertuaqerluku wani waten ayuqliriqerrluku acia."
        },
        "136": {
            "start": 1792.3,
            "end": 1805.3,
            "transcript": "Nutaan-llu ukilluku una ukicissuutengqetullermeggni canek ilait ak'a tamakunek pingvailegmek canek qaill' piluku ukitetullruitki tamakut."
        },
        "137": {
            "start": 1805.3,
            "end": 1819.58,
            "transcript": "Nutaan-llu uskurirluki ilait makut-llu qeltait amiitnek pagkut pelacinagnurnatullrani."
        },
        "138": {
            "start": 1819.58,
            "end": 1834.08,
            "transcript": "Tamakut qaill' piluki-ll' pilallikait tuskurirluki. Piitlermeggni qayarrlainartun aguutegglainartemun [?] piuratullermeggni."
        },
        "139": {
            "start": 1834.08,
            "end": 1845.9,
            "transcript": "Kuvyan iliit teggat'lartuq et'ulriamek pilriit neqcunrutullruut, tauna neqiqaqluteng."
        },
        "140": {
            "start": 1845.9,
            "end": 1859.96,
            "transcript": "Tamakut makut pugtaqutait uskurirraarluki kuvyameggnun petuungraata-ll' peturluki ping'e'rmeng atercetaunrilnge'rmeng."
        },
        "141": {
            "start": 1859.96,
            "end": 1875.3,
            "transcript": "Cuqyukaangqertut-am qaillun tayim' ilait qaiqsiglartut, ilait aciq pingiinarluku tua-i-ll' tauna assiriqertellra tekican tuaten taqluku uskurait."
        },
        "142": {
            "start": 1875.3,
            "end": 1886.38,
            "transcript": "Qayarrlainarteggun pitullermeggni takellrianek et'ulrianek-llu pingqessuitellruut."
        },
        "143": {
            "start": 1886.38,
            "end": 1901.32,
            "transcript": "Tuamta-llam tamatum alngarcuun taiteqerr'u kalikaq, una tau͡gaam."
        },
        "144": {
            "start": 1901.32,
            "end": 1915.88,
            "transcript": "Tuamta-llu taryarqvagnek kaugturrlainayuitellruit pavani kinguni, kaugturrlainayuitut au͡gkunek anernek-llu pililuteng."
        },
        "145": {
            "start": 1915.88,
            "end": 1925.3,
            "transcript": "Camek enranek? Piciatun enernek amililuki waten amililuki pilirraarluteng."
        },
        "146": {
            "start": 1925.3,
            "end": 1943.74,
            "transcript": "Kaugturrlainarluki aaryugturluteng. Angyaituullermeggni imumi Kuigpagmi maani angyaituullermeggni angkarkat-llu nurnatullruameng makut cat ungungssiit unani amiit."
        },
        "147": {
            "start": 1943.74,
            "end": 1961.04,
            "transcript": "Makunek tang wii maani ungungssimteńek wangkuta kelumi angyauluki tangerqaqsaitellruunga. Maa-i qanemcit'lagyaaqaci angyaqaciaqavci tamakunek pililuteng piqaqsaitetullruut wii takumni."
        },
        "148": {
            "start": 1961.04,
            "end": 1979.9,
            "transcript": "Tau͡gaam imkunek qagkunek elngut (kemegyun) elngut qeltaitnek tamakunek imkunek angritnek-llu weld-arluki pitukait tamakunek pingqetullermeggni-gguq."
        },
        "149": {
            "start": 1979.9,
            "end": 1995.82,
            "transcript": "Taryaqvagem man'a pit'aqameng kuvyameggni atercitalriit arcaqerluteng, waten atercetarturluteng piuralriit et'ulriamek kuvyangqerciigatetullruut."
        }
    },
    "hLaTPSc53fI": {
        "1": {
            "start": 13.941,
            "end": 37.431,
            "transcript": "Tuamta-llu cali una waniwa una murak makucinek door knob, steambath door knob, that's smokehouse door knob,"
        },
        "2": {
            "start": 41.784,
            "end": 60.608,
            "transcript": "Qasgimun-llu amiignun-llu aturyugngalugni waten per'uralria uutun, ussukcaulluku tau͡gaam, ak'a tua-i door knob-auryugng[aluni]."
        },
        "3": {
            "start": 61.0,
            "end": 65.84,
            "transcript": "(Piciatun atuulrilriim [?] piyurcivignun tuaten [?]) Atutuuluni tua-i."
        },
        "4": {
            "start": 65.84,
            "end": 90.412,
            "transcript": "Ii-i makut muriit tua-i tamarmeng ak'a au͡gku'urluut murak arcaqerluku aklukengnaq'lallrulliniamegteggu. Tua-i murak-llu kiingan tua-i keniutek'lallrulliniamegteggu."
        },
        "5": {
            "start": 90.843,
            "end": 111.84,
            "transcript": "Peligurtaitellrani, stove oil-artaitellrani, makut-llu maa-i murakelallrit, nenun kaminiamun tua-i murakluku."
        },
        "6": {
            "start": 112.882,
            "end": 130.28,
            "transcript": "Atupia' ava-i qanllemtun atawaqerlit napat piciatun naukuneng Agayun tuaten qanerluni nauluteng-ll' atuugarkaungameng aturyugtemeggni, ata."
        },
        "7": {
            "start": 131.706,
            "end": 163.275,
            "transcript": "(Ava-i call' qanqallrulriaten up'nerkami pissungaqameng qanganarnek wall'u-q' uksuarmi tuntunek, wall' caribou-nek, tau͡gaam au͡gna wani qanrutkeqaaqerru, uksuarmi iqamrarluci natmun tuavet ayagluci, tua-i-llu tamaani muriit tamakut aturyugarkaci angyaqatagnun.)"
        },
        "8": {
            "start": 163.51,
            "end": 184.314,
            "transcript": "Tua-i tuaten uksumi cat pituut. (Up'nerkarmi, up'nerkiavigpecenun [?] ayagluci tuani.) Tua-i quyurcarauguq-am cali tamana tau͡gaam napat, napat tua-i pagna nallunrilamegteggu ciunerkarteng."
        },
        "9": {
            "start": 184.686,
            "end": 205.882,
            "transcript": "Tamaani napat ngeliitni pellukata'arqamegteki ingrit iliini napamun, nothing, tree, pitaitetuuq, teggalqurrlainaq tau͡gaam. Tuaten ayuqut taman' pitekluku, algacalartut tua-i-llu,"
        },
        "10": {
            "start": 207.667,
            "end": 230.726,
            "transcript": "Tamakunek angyaqatiim aklukai cali pikarrluki yuaraluteng napat kepurluki tuavet tua-i, qangillerkameggnun-llu unilluki nutaan angyaqataameng caluki aulukluki tua-i atu'urtengnarqluki."
        },
        "11": {
            "start": 230.726,
            "end": 244.745,
            "transcript": "(Tamakut-mi qeciit atu'urarkait qaillun kinercirraarluki-qaa atutuut?) Nuu. (Wall'u-qaa?)"
        },
        "12": {
            "start": 244.745,
            "end": 260.74,
            "transcript": "Qayat, qayat makliit amiitnek piqatarqamegteki kinerrluki piyuitait, akurluki, maa-i akurngaluki kenilluki."
        },
        "13": {
            "start": 260.74,
            "end": 272.44,
            "transcript": "(Una tang apcaaqelalria pissuryam nalliinek tau͡gaam, mayurluteng pissuryarluteng angyaq aciaraatnek aptelaryaaqaaten.)"
        },
        "14": {
            "start": 272.44,
            "end": 305.471,
            "transcript": "(Angyaqatamek pililallrat tamana.) Waten kia-i kiaggun Akiarmek avatiitni Kiillaraliit, tua-i wall'u piami cali, ua-i cali Kuiggluum ekvik au͡gna, tuaggun-gguq nugluteng, taquateng qaniililuki atmaga'arluteng."
        },
        "15": {
            "start": 306.431,
            "end": 332.34,
            "transcript": "Tuavet-llu qaniirraarluki unilluki uterrluteng. Tua-i-llu taquat atu'urkateng neqkat, neqerrluaraat, neqerrluaraulit caulit, naligkaulit-llu,"
        },
        "16": {
            "start": 332.804,
            "end": 362.098,
            "transcript": "qavartaquneng pikait. Tua-i tuaggun piyualuteng ayalalliniut, atmagluteng uksuarmi, maa-i mat'um nalliini tuntuvagculalriit August-aami, kiagurluku pilarngat'lartut tuaten atkukarculriit qanganernek."
        },
        "17": {
            "start": 363.765,
            "end": 388.863,
            "transcript": "Makug' cali-am tua-i, yuk pinaqluni pingelria pituuq, tua-i tuaken-am kiituan pagaa-i capenruitelliniuq-am kiaggun taum Kiillaraliim paingan uatiikun piyuagurluni mayuneq pagaavet tuamta-llu cali kia-i Cauneq."
        },
        "18": {
            "start": 389.726,
            "end": 412.02,
            "transcript": "Tauna Caunermek Akiarmek kiatiitnek qanlalriit niitelalliken. Tua-i-am tuaggun cali nugluteng cali piyualuteng imkut qemit maligqurluki ingrinun tekicarauguq, qavarciigataarpek'nani tua-i."
        },
        "19": {
            "start": 412.72,
            "end": 440.02,
            "transcript": "Tuamta-llu cali tuaggun cali tua-i piyualuteng iruteng aturluki qaniigaqluki qavarraarluteng, tua-i-llu ayiimeng ayagluteng cali imkut taukut qaniigateng kiturluki quliitnun tan'geriateng tau͡gaam arulairluteng, tuani tua-i ak'a avaniukan nalililuteng,"
        },
        "20": {
            "start": 442.0,
            "end": 473.176,
            "transcript": "pelatekirpek'nateng nalililuteng. Tua-i-llu tuaken qavarraarluteng imkut qaniilteng, waken-am call' kingutmun aqvaluki taukut-llu pirraarluki upqaarluki atmagluki cali ayaulluki tuavet, wall'u kituryugngakuniu tauna pelatekaq, I mean pelataq, nalik quliinun kiturluku cali piluku."
        },
        "21": {
            "start": 473.176,
            "end": 500.02,
            "transcript": "Tua-i tuaten ayauquqcaarluki iruteng aturluki. (Tuaten ikamraulluki up'nerkami ayaggaarluteng, maani-llu-qaa tua-i up'nerkiluteng tuaten piinanermeggni-llu angyaqataliluteng, waten tua-i nutaan tamaaggun merkun uterrluteng.) Yaa, waten-am pilartut qimugtetgun."
        },
        "22": {
            "start": 500.726,
            "end": 532.02,
            "transcript": "Cali-am qaniiluteng canek pilartut. Cat makut neqkat nangtuameng, ca tua-i yug' neryuunani piyuunani tamakut tua-i tuaten piluki, ciumek qaniirraarluki ikamrarluteng qimugteggun pilallermeggni up'nerkami, tua-i-llu,"
        },
        "23": {
            "start": 533.02,
            "end": 560.373,
            "transcript": "Tamaani camp-arkameggnun tekicameng umyuarrlermeggnun tekicameng tuaken tua-i nutaan qanganarcuutet makikcagnek, caskurluteng-gguq makikcagnek, yaqulget, yaqu͡rritnek makikcaat."
        },
        "24": {
            "start": 561.412,
            "end": 586.863,
            "transcript": "Tuaten ava-i pilallrulliniameng maa-i pikegcingelriit kapkaanacuayaarnek, nuirluki tua-i. Imkut-llu makut tua-i jackrabbit snares maqaruarcuutet negat, tamakut tamaita tamakutgun qanganarculalriit maa-i."
        },
        "25": {
            "start": 587.902,
            "end": 619.431,
            "transcript": "Tuamta-llu cali kapkaanacuarnek number 1-aanek piameng tuaken tua-i waken. Waniw' una uitauq camp-aq. Ayagluni tua-i ingrit aturluki tua-i-llu kapkaanaci, kapkaanat tamakut number 1-at nangkata uterrluni tua-i atmak kalngam iluani cumerqurluki qanganaat igtaitni."
        },
        "26": {
            "start": 621.588,
            "end": 648.157,
            "transcript": "Tua-i-llu unuakumi makcameng-am kapkaanani imkut civtellni qanganarcuutet paqluki, tua-i-llu iquklicameki nangneq kapkaanagni nangenrak tekicamiki yaatiinun cali aqumluni imkut pitani,"
        },
        "27": {
            "start": 648.902,
            "end": 678.863,
            "transcript": "qanganaat kalngamek kuvluki. Suggait tevagluki it'giluki, it'gait qupurluki, suggait tua-i qamiqucuaraita pellugarrluki uugak [?] qengak qengagmeng kangiagnegun ceterluku tua-i, tua-i-ll' nuusimek elliuqcaarluki."
        },
        "28": {
            "start": 679.392,
            "end": 705.18,
            "transcript": "Allaqaq, tuaten pitaraqan, qemaggluku allamek piaqluku it'giluku. Tua-llu taukut imkut unuakumi pitani qaqicata sugg'illni, it'gillni-llu nang'ata qasgarmun atmagcuutmun ekurraarluki, atmagluki uterrluni,"
        },
        "29": {
            "start": 705.275,
            "end": 737.961,
            "transcript": "imkut tuaten takuillret, takuilli tumkurluki. Piqu'urluteng pilarkangqerrameng cali. Tua-i-llu arnaq amiirarkat sugg'ivkenateng teguluki qanganarnek amiirluteng tamakunek tuaten pimalrianek wangkuta tuaten qanganarcurraarluta sugg'illemteńek. Taugaam imkut sugg'imanrilnguut utetmun pilput sugg'iyuitaput ciumeggnun tau͡gaam"
        },
        "30": {
            "start": 738.471,
            "end": 749.765,
            "transcript": "cangllerkait pitekluki, im' tuani aqumluta erneq nalluluki sugg'iluta, it'gait tuaten qupuyaarluki sugg'iluki."
        },
        "31": {
            "start": 750.608,
            "end": 780.157,
            "transcript": "Qamiqurrit uyaqu' pellugartaqata nungulluki allamun piaqluta. Tua-i-gguq sugg'iluni, arnat-llu tua-i piameng nutaan sugg'ivkenateng teguluki, tua-i-llu taqngamegteki tamakut qiluiyaarluki, up'nerkam uquriyagatuut qanganaat sugg'irraarluki, i mean, amiirraarluki qiluirraarluki qemilluki agarrluki."
        },
        "32": {
            "start": 781.157,
            "end": 796.843,
            "transcript": "Cali-am muragnek qikilirluki agarrvilirluki, agartessuutekaitnek caliyarauguqama qanganarcunaq' cali."
        },
        "33": {
            "start": 798.686,
            "end": 812.0,
            "transcript": "Im' tua-i iniurluki agarrvigkiuraqluki. (Sug'irraarluki-llu kuingiraralallelriaci.)"
        },
        "34": {
            "start": 819.235,
            "end": 840.18,
            "transcript": "Tamakut-am unuakumi kuuvviarrarluta tua-i takuluki ayagluki iquklitamta tuaten pilartukut qanganartulriani tua-i-llam cangllerkait pitekluki tuavet aqumluta kuingiraq[luta]."
        },
        "35": {
            "start": 851.333,
            "end": 860.059,
            "transcript": "(Iici allayuqertellran kuingiraraqluci.)"
        },
        "36": {
            "start": 860.059,
            "end": 871.588,
            "transcript": "Tua-i-wa Kuigglugmiut-llu kia-i mayurturalartut maa-i mat'um nalliini tau͡gaam pissiyaayuirutengyugnarqut."
        },
        "37": {
            "start": 872.784,
            "end": 899.18,
            "transcript": "Imkut-llu avani tamatum nalliini qanganarculallemteńi, Nunivaarmiut tagluteng qanganarkanek imkut nayiit qerruinarkat, qerruinarkat una imalget uqumek,"
        },
        "38": {
            "start": 899.569,
            "end": 929.412,
            "transcript": "qanganarkanek wankuut [?] naverrluki taumek piaqluki. Tuaten pilallruut. Tuamta-llu cali imkut nayiit aqsaqurrit ciriirniarutngulutek-gguq. Cauga-kiq ciriiq? (Ii-i wii nallunritaqa.) Un'gani-am maqarualegtangqerran tauna pitekluku ciriirnek unegkumiut pilarait."
        },
        "39": {
            "start": 934.824,
            "end": 945.18,
            "transcript": "Iqlunricugnarqua."
        },
        "40": {
            "start": 945.18,
            "end": 972.588,
            "transcript": "Avani tuamta-llu cali mikelnguq imkut au͡gkut ciriiret apellrenka anqiitayaarnun imkunek. Qamiqurra imkut tauna mingqeqerluki ak'a-llu umcuutaqluki-gguq mikellratni tamakunek,"
        },
        "41": {
            "start": 974.118,
            "end": 994.784,
            "transcript": "kameksacuarirluki, lumarrat, [?]-aayaguat-llu, plastic-aaq-llu, shoes-aq pitaitellra-lli [?]."
        },
        "42": {
            "start": 997.18,
            "end": 1005.18,
            "transcript": "(Cakucinek tamakunek ilaiqerluki, cat-qaa amiitnek?)"
        },
        "43": {
            "start": 1005.18,
            "end": 1027.608,
            "transcript": "Mikelngurnun. (Cat amiit?) (Imkut-wa [?] maqaruat.) Maqaruat rabbit. Mingeqluki iquqaarluki, iquqaarluki-am cali tamakunun mikelngurnun ulikluki."
        },
        "44": {
            "start": 1029.941,
            "end": 1059.18,
            "transcript": "Tuamta-llu makucirtaitellrulliniami, nauwa, maqucinek pitaitellrani-am cali anqiiyaaq tamakut amiitnek ungsuucirluki atkucuarirluki una tau͡gaam mingqevkenaku inglua-llu."
        },
        "45": {
            "start": 1061.706,
            "end": 1062.941,
            "transcript": "(Ciin-gguq?)"
        },
        "46": {
            "start": 1065.784,
            "end": 1094.745,
            "transcript": "Unerni', mingequmalriit-gguq-am ukut unerninarituut angyayagaat tepaitnek tepsaqluteng. Tua-i tuaten-am pilallrulliniit avani. Angyayagarnek tepsaqnganateng unerninaqluteng."
        },
        "47": {
            "start": 1094.745,
            "end": 1125.431,
            "transcript": "Angyayagaat tepaitnek. Avelngacuaraat au͡gkut cingickellriani sugg'et. (Anirtima. Anirrlugnani [?] maani cauga'arqata [?] nani wii maligutaqama, arnat aguarqa [?], ingluliutaqama unerningnaqengnaq'. Ii-i angyagaq.) Tua-i-w' tamana pitekluku mingeqsuitellruit tamakut maqaruat amicuaraitnek."
        },
        "48": {
            "start": 1125.824,
            "end": 1151.667,
            "transcript": "T-shirt-ayagartaitellrani tuaten pilallruut, tuamta-llu cali makut yaqulget amiit melqurrit au͡g'arluki tua-i tuaten tamakuyugngaluni maqaruarailkan un'gani-llu tuaten pilallrullikait. Makut-llu call' qugyuut. Ingtaat-llu-w' nalliitni tua-i,"
        },
        "49": {
            "start": 1152.235,
            "end": 1169.549,
            "transcript": "cat yaqulgungraata tuaten aturangengnaq'lallrulliniamegteki pikartuyuqerulriit terullermeng [?] nalliini. Tua-i-ngullilria-wa ukut-wa qalaryunglliut."
        },
        "50": {
            "start": 1169.569,
            "end": 1171.843,
            "transcript": "(Ii-i, ukut-wa atam ellirtut.)"
        },
        "51": {
            "start": 1171.843,
            "end": 1176.902,
            "transcript": "Apqauranayunaitua wii, kiima yuunrilama."
        },
        "52": {
            "start": 1176.941,
            "end": 1178.765,
            "transcript": "(Uitaqaqartukut-gguq.)"
        },
        "53": {
            "start": 1178.784,
            "end": 1185.177,
            "transcript": "Aa-a, ukut-wa tua-i wiinga-w' taqlilrianga, taqlilria."
        },
        "54": {
            "start": 1185.177,
            "end": 1187.49,
            "transcript": "(Tarenrairngaitait-qaa qayuw'?)"
        },
        "55": {
            "start": 1187.49,
            "end": 1194.961,
            "transcript": "Ak'a-w' tarenrairallruk' yaaggun. Allamek piviitut."
        },
        "56": {
            "start": 1237.333,
            "end": 1247.608,
            "transcript": "Tua' ak'a qayalitullermeggni man'a maa-i yualuq, cetuam-gguq yualua, teraan yualua."
        },
        "57": {
            "start": 1247.608,
            "end": 1255.961,
            "transcript": "Mecunglluku taluluku, taluluku-gguq amlleriluku waten pililuku."
        },
        "58": {
            "start": 1255.98,
            "end": 1272.18,
            "transcript": "Man'a maa-i tuntum yualukua uliun-gguq maa-i man'a ak'allauguq wii man' aryuqngaaqamku mingqaqama qecigmek tegulua, teguqaullua iliitnek yualulirlua mingqeqatuanka."
        },
        "59": {
            "start": 1272.843,
            "end": 1289.18,
            "transcript": "Tuntum maa-i man'a tunuan pam'um yualua, wagg'uq uliun. Makut-wa cetuam teraan-gguq yualui. Qupurrluki piirriluki qayanun yualukiitullruit."
        },
        "60": {
            "start": 1289.18,
            "end": 1306.18,
            "transcript": "Tuamtellu iluit qamku call' qipiurluteng au͡g'utun ming' mat'umek call' nanerluku mingqluku ilua qamna qayam, wagg'uq iluliluku."
        },
        "61": {
            "start": 1306.18,
            "end": 1324.18,
            "transcript": "Tuamtellu tua-i makulikumta qayatullratni, un'a au͡gkua qayam painganun engelqaqerkaurcetengnaqluku pitullruut mingeqluku tua-i-ll' cillartengnaqluku man'a."
        },
        "62": {
            "start": 1325.51,
            "end": 1336.471,
            "transcript": "Qayam painganun aturyugngariluku. Anuqenguskateng-llu-gguq tua-i taukunek all'uteng."
        },
        "63": {
            "start": 1336.588,
            "end": 1355.726,
            "transcript": "Akuaman qayam painganun ac'elluku wagg'uq ket'garluteng arillugluteng-llu, una-ll' ava-i qanrutkekeka angengnaqluku pitullruameng wavet teguarkateng paivvluki, tua-i waken tegulluteng qanteng-llu kinqatam mecunguartarkauluku [?]-llu."
        },
        "64": {
            "start": 1357.18,
            "end": 1364.0,
            "transcript": "Qairem pingraan iterngaunani qayam iluanun tuagg' umciagnek."
        },
        "65": {
            "start": 1364.0,
            "end": 1372.18,
            "transcript": "Wiinga-ll' imarnitertullemni [?] meqsungaqamta taryuulaan nanvat ilait."
        },
        "66": {
            "start": 1372.18,
            "end": 1383.569,
            "transcript": "Taryuunrilqengurmek kiarrluteng kenirmigluteng meq-llu ellngayuunan mequuvkarluta ilakuaput-llu eggluki."
        },
        "67": {
            "start": 1384.314,
            "end": 1389.922,
            "transcript": "Theresa, au͡g' itelliniuq tauna [?]."
        },
        "68": {
            "start": 1389.922,
            "end": 1395.196,
            "transcript": "Akaurcaaquq apqiitnek maa-i cinquggluni [?]."
        },
        "69": {
            "start": 1395.196,
            "end": 1424.177,
            "transcript": "Uginam qilua. Nauwa au͡gna nagiiquyaq. Makunek-gguq piyagarluni kukgarqacuar wani nevuani [?] imumek waten pissuutiita aturluku, aipalqa-llu imna-llu yualunek-am museum-aam kuvyamek pilisqellrani kanani-wa agalallilria museum-aami."
        },
        "70": {
            "start": 1425.745,
            "end": 1439.961,
            "transcript": "Makut wii qipiurallruunga maa-i-ll' man'a qemian call' ilakuara, man'a-w' maa-i qaill' pilriim waten mamcarmi kinqallrulartau."
        },
        "71": {
            "start": 1439.961,
            "end": 1465.18,
            "transcript": "Uginaman qilukluku. Ca ak'a avani, cat makut maa-i uginam qilua waten atuyuitellruuq tau͡gaam kinercirluku, wagg'uq kuvyamun-llu qemirkiurluku tamakunun-llu au͡g'umun narulkacuarmun atuuluni."
        },
        "72": {
            "start": 1465.18,
            "end": 1488.628,
            "transcript": "(Qerruinam.) Ak'allauyaaquq man' peqlirrluku maa-i mat'um una-gguq waniwa imkuluni tuqullruuq mat'um kelukestiini kamat [?] Nick-am aniin kelukai makut irniaran taitellrai."
        },
        "73": {
            "start": 1492.118,
            "end": 1520.804,
            "transcript": "Tua-i maa-i ciissit, yuvriranka ciissit, ciissillrulliniluku, una-llu call' waniw' ciissim pillrulliniluku, una-ll' call' ciissim piluku. Waniw' una angelriim imarnitem pikliniluku, wavet waniw' cuqluku tuamtellu au͡gna ava-i uumi iqugkaat wagg'uq yagutnguaq."
        },
        "74": {
            "start": 1523.0,
            "end": 1554.804,
            "transcript": "Angutet akluit pinertutacirramcetun pingnatutullruamteki waniw' una wavet cuqluku, cuqluku kepluku, amllertatekluku, tua-ll' au͡gna im' waten pimalria, pimalria wavet mingqulluku, nutaan uumun call' ukatmun mingqulluku."
        },
        "75": {
            "start": 1554.882,
            "end": 1585.843,
            "transcript": "Una-am cilingqalria waten maanteqerluni waten. Waniwa-gguq tunuarai yagutnguara-wa. Man'a-gguq maa-i yagutnguaqluku. Elluarrlutek tua-i taukuk cuqinga', tua-i-llu maavet mingquqaarluku cali iqua qilum,"
        },
        "76": {
            "start": 1585.843,
            "end": 1613.58,
            "transcript": "waken call' ayagluku mingqulluku pikavet, ikavet akianun. (Ii-i.) Tuamtellu aipirluku, ilukilkan mat'umek call' aipirluku, allamek-llu wagg'uq kegginarirluku, tapluku call' qiluq elliluku, qiluqliikuni makunek aipirturluku."
        },
        "77": {
            "start": 1616.079,
            "end": 1642.902,
            "transcript": "Waniw' una ava-i pinguallemni yualukiu esuirutkiuraqa. Mat'umek ai teguyarirturluku piurluku ukugtun. Man'a caranglluk wangkuta taqsuitaput, wiinga-llu mingqelluku akikiurluku,"
        },
        "78": {
            "start": 1643.843,
            "end": 1666.74,
            "transcript": "piirritekluku neqnun, curuqluku, neqnun assigtarkiurluku, patuuluni, neqnun patuuluku patukiurluki ikiungraata, mecungengaunani-llu acia patuukuni."
        },
        "79": {
            "start": 1667.275,
            "end": 1686.4,
            "transcript": "Issratet-llu mikelngermeng callarvaggaarcelluku, nalluyagulluku ellamun itrutlerkaa piqall', teguluku, anlluku, agarrluku kinerciqatarluku tegulriani, acia kinerrluku wall' tua-i yukulqerruuq."
        },
        "80": {
            "start": 1688.9,
            "end": 1718.52,
            "transcript": "Maa-i aturluku wangkuta arulairucuunaku nunamteńi uani. Mat'um nalliini cumertaqluteng uksuarmi piirritkanek. Makunek-llu mingqutkanek tupigluki, allat-wa nanvat ceńaitni, wagg'uq makut kelugkaat kuiget-llu ceńaitni, allat-wa cali iitarnek imkut pitukait, qup'arrluki nutaraguaqata,"
        },
        "81": {
            "start": 1718.52,
            "end": 1727.7,
            "transcript": "nertulput uugnaraat neqait tamakut. Alliqsituluki tamakut pagkuit naumalriit."
        },
        "82": {
            "start": 1729.765,
            "end": 1747.04,
            "transcript": "Arillugnun tuaten keviqluki anguarcuutnun makut. Anngallma nakmiktullrui tamakut tupigat kevit, mecungengermeng-gguq qaqingqerteng'e'rmeng kivyuyuilata."
        },
        "83": {
            "start": 1747.04,
            "end": 1771.98,
            "transcript": "Tegutekluki makut arilluum mecungengermi qamkut. Maa-i makut umcilriit, qaillun-llu tua-i melugangermi mecungarrluku pingermi imkuluni, (umcigluni), umcigluni."
        },
        "84": {
            "start": 1773.451,
            "end": 1800.824,
            "transcript": "Angliringnaqluki anguteput pilitullruaput qayatuata, miktenritengnaqluk' tua-i-ll' ava-i uum call' tegucugngarivkarluku. Keggatai call' angevkarluku, angengnaqluku akuit-llu tua-i imkut yagqurluki, akua call' yakluku cip'arrluku qayam, qayam tua-i engelqaqsugngarivkarluku."
        },
        "85": {
            "start": 1803.216,
            "end": 1813.54,
            "transcript": "(Qaillun tamakut qilut uptelarkatki itqerraallratnek ayagluteng?)"
        },
        "86": {
            "start": 1813.54,
            "end": 1823.4,
            "transcript": "Uin, uin waten qanqata, umpi-gguq maklagtuq wall'u-qaa tungunqutuq."
        },
        "87": {
            "start": 1824.784,
            "end": 1853.08,
            "transcript": "Tua-ll' tekiuskaku-gguq qiluq imna waten tua-i ayuqluni. Imkucianek au͡g'arturluku, iqukliskan-llu taum-ll' nerai au͡g'arluki erurluku, tua-ll' call' qantamun ekluki, ciumek qeltait au͡g'arturluki, tua-llu cali taqreskan kelikan qamna iluata,"
        },
        "88": {
            "start": 1853.08,
            "end": 1876.72,
            "transcript": "uqlallra qeltairluku ayallakun waten kelikaarluku, tua-ll' nutaan. Taqkan teq'umun ekluku augirluku, tua-ll' kinguakun cali mermek piurluku waten-llu ellirareskan ella assiqan qerrurluku."
        },
        "89": {
            "start": 1883.275,
            "end": 1888.843,
            "transcript": "Wiinga-ll' waniw' yurauciqluku makuliuruarturlua."
        },
        "90": {
            "start": 1897.902,
            "end": 1904.706,
            "transcript": "Maa-i makut piicun', ceńami anguatullratnek piicunailnguut."
        },
        "91": {
            "start": 1906.843,
            "end": 1914.549,
            "transcript": "Cakneq piitesqumavkenaku pingnatutullret, pingnatutullret."
        },
        "92": {
            "start": 1916.941,
            "end": 1925.16,
            "transcript": "Una waniwa, waniwa-gguq tunuarkiurluku."
        },
        "93": {
            "start": 1926.686,
            "end": 1930.4,
            "transcript": "(Nanciiqluni imarnitet piani.)"
        },
        "94": {
            "start": 1930.4,
            "end": 1933.84,
            "transcript": "Tuar ciumek ayagnitukait ugkuit."
        },
        "95": {
            "start": 1933.84,
            "end": 1940.64,
            "transcript": "(Nateqvaciiqa [?] tunuani.) Waniw' wanlluni, waniw' tang waten ayuqluni."
        },
        "96": {
            "start": 1940.64,
            "end": 1950.882,
            "transcript": "Ava-i-ll' ellinguarturallrukeka una ciligneq pagaanlluni una-llu kapulluni wavet ciligneq-wa"
        },
        "97": {
            "start": 1950.882,
            "end": 1960.02,
            "transcript": "tua-i talliurrluni, akia-llu elliluku, yaaken-ll' ayagluku mingeqluku ikavet tuamtell' aipirluku."
        },
        "98": {
            "start": 1960.53,
            "end": 1966.6,
            "transcript": "Tuamtell' ukua piluku tua-ll' unlirraarluku tuamtell' uivvaarturluku."
        },
        "99": {
            "start": 1970.745,
            "end": 1982.53,
            "transcript": "(Tua-i-llu-qaa kegginarirnacian cali kegginarirluku murilcarirluku.)"
        },
        "100": {
            "start": 1982.53,
            "end": 1996.314,
            "transcript": "Ukuam cali camek allegciqngan una call' mak'arluku ukilluku-llu mingeqluku nutaan-llu nungircaraa elliluku."
        },
        "101": {
            "start": 1998.157,
            "end": 2006.353,
            "transcript": "Tua-i-am ellikuni cali makunek maa-i wagg'uq asuirucirluku qup'arrluku mingeqluku."
        },
        "102": {
            "start": 2010.02,
            "end": 2013.36,
            "transcript": "Makunek aryuqnarqait..."
        }
    },
    "nR9p3SGBN8Y": {
        "1": {
            "start": 0.74,
            "end": 12.21,
            "transcript": "Canitmun tua-i tau͡gken imkut murak man'a naulra atu'urrluku waten makucit cuukvaguat."
        },
        "2": {
            "start": 12.21,
            "end": 14.83,
            "transcript": "Ii-i. Tua-i tamaa-i."
        },
        "3": {
            "start": 14.83,
            "end": 29.66,
            "transcript": "Aren imumi-ll' pavani tua-i uksumi stove-ailaq nurnallrani amllernek tua-i muragnek quyurtelalriit waten naparqurluki."
        },
        "4": {
            "start": 29.66,
            "end": 44.16,
            "transcript": "Tuamta-llu cali un'gani pilalliut qanikcangvailgan imkut qemit iquut tamakunek cuukvaguanek pingqerlallruat nau', makut cuukvaguat qemit iquitni nauyunqegtut."
        },
        "5": {
            "start": 44.16,
            "end": 57.84,
            "transcript": "Tamakut call' tua-i pilallikci niitellrat tua-i un'gani-llu qanikcilallrani capun-am au͡g'ukun murangengnaqaqameng-gguq waten yuatullruut."
        },
        "6": {
            "start": 57.84,
            "end": 78.85,
            "transcript": "Qanikcaq, qanikcingraan tua-i kapun tua-i-llu camna nuna allareskan anuluku tua-i tuaten piqerluteng makuciq inangqerralria murak qaingakun nangeskuvet nep'areskat tang cam ca maa-i [?]."
        },
        "7": {
            "start": 78.85,
            "end": 88.78,
            "transcript": "Aren qanikciurluku-gguq-wa murangengnaq' tuaten tua-i niirqelaranka wii."
        },
        "8": {
            "start": 88.82,
            "end": 104.5,
            "transcript": "Ciutek makuk niitellrek elitnaurustenguuk ukugnek aipaa tunglirluteng, ciuqlirlutek ukugnek una-w' kitugg'ik."
        },
        "9": {
            "start": 104.5,
            "end": 119.05,
            "transcript": "Pitullruyaaqut [?] nunavut qagna qanikcangaqangaraakut tepaat piyuirut ellameng [?] kevraartut qakineq amllerrlainaq."
        },
        "10": {
            "start": 119.05,
            "end": 131.8,
            "transcript": "Tamakunek aqvauqurrlua (un'gani uum nuniini kevraartutaituq) [?] tekit'larqaa."
        },
        "11": {
            "start": 131.8,
            "end": 144.58,
            "transcript": "Makut tau͡gaam imkut uqviaraat-llu pavani-ll' akulmi qanikcaq amllenrillrani kangritnek tua-i kepurluki muraggluteng."
        },
        "12": {
            "start": 144.58,
            "end": 157.5,
            "transcript": "Tekicameng-llu tua-i taptaarluki, taptaarrarluki murakelallruut, murakelallruut kangqerruuget-gguq [?]."
        },
        "13": {
            "start": 157.5,
            "end": 168.94,
            "transcript": "Wiinga-ll' tamakucinek tangtullruunga waten kangernek kangritnek cuukvaruat kanritnek qillerrluki taptaarraaluki."
        },
        "14": {
            "start": 168.94,
            "end": 183.62,
            "transcript": "Uqviaraat-gguq, wii waniw' nerluki tuaten, iqmilqa tamalkuan uqviarturlua araitni uqviaraat tua-i aturtaciit [?]."
        },
        "15": {
            "start": 183.62,
            "end": 199.21,
            "transcript": "Araqluki peluqluki ilaita tua-i akikangllagatekluki, peluqiuralriit, maa-i-wa tua-i,"
        },
        "16": {
            "start": 199.21,
            "end": 212.21,
            "transcript": "Imna tua-i kaa [?] kuuvviarni, one pound-aq, three pound, hundred fifty or sixty muirluku nangluku."
        },
        "17": {
            "start": 212.21,
            "end": 228.54,
            "transcript": "Tamakucini caqerluni nauw' cuvaungnavet [?] ayakatartuq cuvaungnaq hooper bay, tua-i-ll' tamakut aratarrluku [?]"
        },
        "18": {
            "start": 228.54,
            "end": 244.17,
            "transcript": "Tua-i-llu tekicava [?] nerrluki kuv'aqluki waten imkunun can, can-autellragnun-llu waten angkayar', imkunun-llu kuuvviarutellren one pound."
        },
        "19": {
            "start": 244.17,
            "end": 255.62,
            "transcript": "Tua-i akikiurturluki piaqluki, tua-llu camani suuvami iliita kipusvigmi, kipusvigmi pillillemni iliit."
        },
        "20": {
            "start": 255.62,
            "end": 270.54,
            "transcript": "Kuuvviarutlermektaituq, one pound-autellrarmek imumek, paumnaqellrakapiaq [?] tua-i taitaa atam [?] pakteqerlaki."
        },
        "21": {
            "start": 270.54,
            "end": 289.68,
            "transcript": "Negtarrauluni ima carrarmek-wa negtaullrulliniut, akanglu', negtaallra [?] piama, una-wa akingqellruuq, 350 dollars, tauna one pound-acuayaaq."
        },
        "22": {
            "start": 289.68,
            "end": 306.04,
            "transcript": "Tua-llu wii [?] akitunritut caumautellra curat imkut pikluteng thirty five dollars piaqluki, muralriit-llu forty dollars tua-i piugaqluki."
        },
        "23": {
            "start": 306.04,
            "end": 326.42,
            "transcript": "Tua-ll taum kinguakun pinqigteqataama kuuvviarutellranek quyurciigatuq maa-i... Uitasgu!"
        },
        "24": {
            "start": 329.54,
            "end": 351.47,
            "transcript": "Avani-wa waten agaavet ingrinun ayalalriit up'nerkami iliini una wani paaskaam tua-i paaskaaq-ll' atanqevkenaku Easter-aaq."
        },
        "25": {
            "start": 351.47,
            "end": 370.49,
            "transcript": "Agaavet qangarnartuqatarqameng atanqevkenaku ayatullruut, tua-i-llu ciumek qaniiluteng atu'urkameggnek ciumek ayauqurluki, ayauqaarluki,"
        },
        "26": {
            "start": 370.49,
            "end": 380.52,
            "transcript": "Tuavet tua-i engell'itngatkameggnun [?] cali-am ernerem qanikcilallruami avani,"
        },
        "27": {
            "start": 380.52,
            "end": 393.26,
            "transcript": "Pilallruut paluqtartuurluteng tuaten pilallrulliniut ciumek, paluqtaq ukaqvaggun Kass'at pitekluki paluqtartula'angellruut."
        },
        "28": {
            "start": 393.26,
            "end": 408.36,
            "transcript": "Avani ciuqvani waten pilallrulliniut maa-i mat'um nalliini tuntuvak ikirtaqan nani allami piyuitut, pissuyuitut."
        },
        "29": {
            "start": 408.36,
            "end": 419.77,
            "transcript": "Tua-i-llu cali avani cali uksuarmi, uksuarniararqan maani August-aami wall'u,"
        },
        "30": {
            "start": 419.77,
            "end": 433.59,
            "transcript": "Piyualuteng egmianun tekitesciigalameng cateng atpagluki ayauqurluki yuilqumun tuavet, uniqaarluki ataam utertaqluteng tua-i."
        },
        "31": {
            "start": 433.59,
            "end": 453.31,
            "transcript": "Tua-i-llu cali imkut taukut atmagluki ayaulteng piata maa-i mat'um nalliini tuntuvagcuqermeng ayagalalriit, tuntuvagnek pissurluteng, cali tuntupianek tuntunek-llu pilallrulliniut."
        },
        "32": {
            "start": 453.31,
            "end": 468.68,
            "transcript": "Makut-llu cali pitateng yuilqumi, yuilqurmiutaat tuntut agarrluki kemgit, amiit-llu cali qelekluki."
        },
        "33": {
            "start": 468.68,
            "end": 481.68,
            "transcript": "Nauw' imna im' qalartellria qalartellrulria avani ciuqvani cat tua-i yaqulek, yaqulgem-ll' amirraqengraakut, tua-i qeleklarniluki atuutarkaungan."
        },
        "34": {
            "start": 481.68,
            "end": 497.14,
            "transcript": "Wall'u angutem yuilqurrakuni qerrutenricuutekaqngaku, tamaa-i tuaten carrateng murilkelluki pilallrulliniut."
        },
        "35": {
            "start": 497.14,
            "end": 515.26,
            "transcript": "Cat tau͡gaam-am murak tua-i cassuutekluku, tuaten tua-i pirraarluteng cali-am ukut angyaqatak au͡gna avngulek muragtakengraan cali,"
        },
        "36": {
            "start": 515.26,
            "end": 525.84,
            "transcript": "Ikamrarnun cali quyurrluteng-am call' pitarqaarluteng cali taukut ayaulluki tua-i napat napailermun tekitaqameng."
        },
        "37": {
            "start": 525.84,
            "end": 537.04,
            "transcript": "Ciunerteng tamakunek napanek pitangqerrngaitaqan, tuaken tua-i napat nuniitnek, napat nang'arkaurtaqata,"
        },
        "38": {
            "start": 537.04,
            "end": 553.92,
            "transcript": "Imkunek piciatun tua-i perelrianek waten, waten angyaqatiim ellissuutekai waten, tamakut ciumek tamakunek, tua-i-llu cali saagarnerkaitek cali imkut."
        },
        "39": {
            "start": 553.92,
            "end": 567.14,
            "transcript": "Qugniilnguut wall'u cali nalqilriit muriit, au͡gkut-llu qanrutkellrenka enrilnguut piyugngaluki tau͡gaam manigarrluki cakiarrluki."
        },
        "40": {
            "start": 567.14,
            "end": 583.93,
            "transcript": "Tua-i imkut tamakut ellilarraarluki muriit perelriit qillerqerraarluki wall'u ussukcartangqerr'an ussukcanek tamakut qerrarutiin napa perallra waten pillra."
        },
        "41": {
            "start": 583.93,
            "end": 597.75,
            "transcript": "Waniw' una cuukvaguaq napak perelriik waten, ii-i perelriik tua-i waten piyugngaluki qukalirluku cali,"
        },
        "42": {
            "start": 597.75,
            "end": 611.1,
            "transcript": "Qaillun tayim' iqtutat tuaggun piluku tua-i tamana ciumek ellilarraarluku naangarikata nutaan qukamek unaken ayagmluku."
        },
        "43": {
            "start": 613.33,
            "end": 628.21,
            "transcript": "Barrow-mi imkunek mangtagnek pissuraqameng tamakucitun amilegmek ayautelalriit ikamranun ekluku."
        },
        "44": {
            "start": 628.21,
            "end": 641.0,
            "transcript": "Tua-i tuaten ciumek enrit pikiurluki napanek piciatun tua-i atuuyugngalrianek, tua-i-llu taktacirkaa."
        },
        "45": {
            "start": 641.0,
            "end": 649.4,
            "transcript": "Taukut imkut pugtatulirkat amit."
        },
        "46": {
            "start": 649.4,
            "end": 667.2,
            "transcript": "Engelcuqunguaqerluki [?] (Cakuciit amiitnek?) Tuntut, wall'u taqukat tua-i makut piciatun angyaq-llu angyaurcugngaut."
        },
        "47": {
            "start": 667.2,
            "end": 679.19,
            "transcript": "Tuntuviit-llu cali maa-i avani-am ciuqlermi ciuqvani avani, tuntut makut tuntuit nurnallruyaaqelliniut."
        },
        "48": {
            "start": 679.19,
            "end": 692.3,
            "transcript": "Cali maa-i pingata tamakut tuntuviit amiit cali yuilqumun pegtevkenaki pitaqameng ut'rulluki tamana umyuaqluku."
        },
        "49": {
            "start": 692.3,
            "end": 710.08,
            "transcript": "Atuuciqngan pagaam ingrinun mayuquneng angyaqatakluki, assigtaqluki canun pitameggnun aklullrameggnun wall'u cali imku ikamrak acik ikamralugpiaq tempialgek."
        },
        "50": {
            "start": 710.08,
            "end": 727.0,
            "transcript": "Uum nallunritqapiaraquralria [?] qanllemni tempialgek ikamralugpiak, tamakut imkut cateng unicuitellruamegteki peggluki erenret pikingnaqu'urluki pilallruameng."
        },
        "51": {
            "start": 727.0,
            "end": 743.52,
            "transcript": "Tamakut-am au͡g'arluki ilakluki-llu tuavet imumun angyaqatagmun ilakluki tegg'utaq, imkut au͡gkut itegpiit tamakunek pilirluki tua-i qaqican nutaan mingeqluteng"
        },
        "52": {
            "start": 743.52,
            "end": 760.12,
            "transcript": "Cuqluki tuntut amiit usgutaqluki tau͡gaam qeciit, melqurengraata-llu piyugngaluki tua-i, mingeqsugngaluki."
        },
        "53": {
            "start": 760.12,
            "end": 775.38,
            "transcript": "Qaqicat-llu tua-i qeciitelatekluki cali tuavet elliluki angyaqatarmeng cali-am makliit nillaraqamegteki makut."
        },
        "54": {
            "start": 775.38,
            "end": 785.2,
            "transcript": "Pilagaluki ukiqluki nuqsugtessuutekait, nillaqan makliim amia tuaten nengenqessugngaluku."
        },
        "55": {
            "start": 785.2,
            "end": 799.21,
            "transcript": "Pilaan tua-i tuaten qemi', nunamun piluki tuaten-llu tua-i, tuntuviim wall'u [?] taqukam brown bear-am, wall'u black bear-am pii tamakut."
        },
        "56": {
            "start": 799.21,
            "end": 815.1,
            "transcript": "Usgulluki waten mingeqluki, mingeqsararluteng-am cali tamakut, usgutellrit nauw' imna una wani,"
        },
        "57": {
            "start": 815.1,
            "end": 828.16,
            "transcript": "Ava-i qalartellrulriit akwaugaq canek keluut tamakut iinruaqturkaitnek, tuamta-llu cali makut cat."
        },
        "58": {
            "start": 828.16,
            "end": 846.8,
            "transcript": "Maa-i-llu mat'um nalliini wall'u lumarraq mingugmek mingukuni maa-i-ll' man'a aguutnguyugngauq waten ayuqeng'erni mingugmek mingukuni imangingairulluni."
        },
        "59": {
            "start": 846.8,
            "end": 864.12,
            "transcript": "Tamakut-am cali tuaten angyaqatiit keluit piluteng camek auqerluki tau͡ga tuntut uquitnek wall'u tuntuviit wall'u taqukam."
        },
        "60": {
            "start": 864.12,
            "end": 875.64,
            "transcript": "Man'a uquq yuurqami wall'u kumlataqami tegg'iqertelaami"
        },
        "61": {
            "start": 875.64,
            "end": 886.74,
            "transcript": "Camek auqerluni tua-i, mer'em tamakut keluutiuni piyugngaluki,"
        },
        "62": {
            "start": 886.74,
            "end": 906.2,
            "transcript": "Wall'u cali amllermek-ll' auluki pikuneng tua-i au͡g'ayuitut kinertellriamun cat uquq man'a au͡g'ayuituq ciumek, tau͡gken mecungekan tauna ciunani, nevngaituq mecuman-gguq."
        },
        "63": {
            "start": 906.2,
            "end": 915.24,
            "transcript": "Kinqeqata tua-i tamakunek mingugluki asruaqturluki meq iterngairulluku."
        },
        "64": {
            "start": 915.24,
            "end": 936.1,
            "transcript": "Ava-i parcilriatun cali maavet imumun angyaqatiim pianun qainganun ceńiinun teveqluku unavet enrinun nuvuurulluku maklagcetun ukirqerraarluku."
        },
        "65": {
            "start": 936.1,
            "end": 952.98,
            "transcript": "Tamakut tua-i aturluki nutaan-llu kingumek ciunga-llu ingna mingeqluku cali aminragmek amilriatun qagkumiut un'gani-llu pilallrukait tamakut."
        },
        "66": {
            "start": 952.98,
            "end": 968.65,
            "transcript": "Inerkiurluki tua-i tuaten tamakut imkut maklagnek amilget enrunateng piyugtesciigatut muragmek tegg'utaunata."
        },
        "67": {
            "start": 968.65,
            "end": 979.7,
            "transcript": "Tamakut taqerra'arluki tuaten pagaani yuilqumi amirluki tua-i tau͡gaam alingnarquq cetulleq."
        },
        "68": {
            "start": 979.7,
            "end": 990.03,
            "transcript": "Pagkut iliini carvanilami alingnaqluni wall'u cali imkut muraggluut cali tamakut tua-i cali murilkessa'arauluteng."
        },
        "69": {
            "start": 990.03,
            "end": 1003.83,
            "transcript": "Tuamta-llu tua-i cetulriani kuigkun anyarakun Kiillaraliitkun, Kuigglukun."
        },
        "70": {
            "start": 1003.83,
            "end": 1023.83,
            "transcript": "Tamaa-i tamakut qaralarcuryarallrit, wall'u cali paluqtarcuryaurtet up'nerkami-am tuaten angyaqaciluteng pitameggnek tamakut tau͡gaam imkut tuntut amiit cali caaruarevkarpek'naki [?] iniaqluki wall'u pinevluki kinertalliluki."
        },
        "71": {
            "start": 1023.83,
            "end": 1039.17,
            "transcript": "Kinquneng cang'ermeng tepengvailegmeng kinquneng piunrirnaunateng, yuum nerngermiki-llu ak'anun uitamangraata kinercata uqumek meciarluki neryugngaluki."
        },
        "72": {
            "start": 1039.17,
            "end": 1053.11,
            "transcript": "Tuamtellu cali un'gani issurit amiit cali tulimait kinercilaqait au͡g'arluki nerlartut, tuaten-llu pagaani tuntut tamakut pilarait kineng'iluki."
        },
        "73": {
            "start": 1053.38,
            "end": 1070.46,
            "transcript": "Tuaten ca man'a pitayuilqurmiutarraq cailkamun pegcuitellruat, cat-llu wall'u enret, enri ungungssiaraam enri cat atuuyugngalriit qalekluki cali."
        },
        "74": {
            "start": 1070.46,
            "end": 1086.76,
            "transcript": "Avani ciuliani tuaten pilallrulliniut, atuugarkaungata-wa tua-i nallunrilameng murak-llu tangerrluku cauciataa, tamana tua-i pitekluku muragnek tamatum ner'."
        },
        "75": {
            "start": 1088.57,
            "end": 1097.94,
            "transcript": "Uitavig' amim tusnganerkaanek pilartut tau͡gaam iqtukayagtuq tua-i qukaa."
        },
        "76": {
            "start": 1097.94,
            "end": 1107.89,
            "transcript": "Waten angyaqatak ayuqsugngaluni una ciunga tua-i cillarrluni tua-i waten akagtangqerrsugngaluni."
        },
        "77": {
            "start": 1107.89,
            "end": 1124.61,
            "transcript": "Tau͡gaam-am kuigkun cetulraat, tamatumek alulartuut ciuyagtem-gguq kuikun man'a carvanem murilkelluku pitua."
        },
        "78": {
            "start": 1124.61,
            "end": 1141.47,
            "transcript": "Una-gguq tau͡gaam kinguyagtem uum, alularluku tua-i ingna tangvagluku ciuqliq tuaten piaqan aviqerqan ukatmun perelriani kuigni ak'a au͡gna."
        },
        "79": {
            "start": 1141.47,
            "end": 1157.86,
            "transcript": "Napat iliini waten pilaata tamakut cali unuryakluki tangerrluki tuaten tua-i carvanem qipngani-llu waten elliurluni ing'um-llu cali ikayuqluni tuamta-llu cali."
        },
        "80": {
            "start": 1157.86,
            "end": 1171.3,
            "transcript": "Arnat cali, cali-am ellegturalrianek mimernanek-llu murak."
        },
        "81": {
            "start": 1171.3,
            "end": 1186.05,
            "transcript": "Piluku nemerluku anguarucilalriit, tua-i tamakut cali pikanek atura'arqateng nallunritait tamakut tuaten kuigkun cetuarqet."
        },
        "82": {
            "start": 1186.05,
            "end": 1195.79,
            "transcript": "Tuulkessaaq, Anyaraq, Tuulkessaaq, Kiillarraliin, Kuiggluk."
        },
        "83": {
            "start": 1195.79,
            "end": 1215.94,
            "transcript": "Taukut nallunrilameng waten murak-llu piluku tau͡gaam anguarutnguluni allamek puulirarkauluku, aviqerluki nauw' imkut maa-i-llu tanglalriaci TV-ni, imkut."
        },
        "84": {
            "start": 1215.94,
            "end": 1230.52,
            "transcript": "Rub-at qerrurluki tua-i tuaten angyaraitagceńun tamakut ayuqsaqut, tau͡gaam waten makut cillartut, waten ellingavkenateng qacarnek, ellingatuut angyaqateng."
        },
        "85": {
            "start": 1230.52,
            "end": 1247.91,
            "transcript": "Kuiliulriani carvaneq carugpangraan tanglalriaci imkunek tiiviit iliitni pivakarlua-ll' wii tanglalrianga, tua-i tuaten umyuaqaqluki-ll' angyaqatiit tamakut umyuamnun tut'aqluteng tamakunek tangrraqa."
        },
        "86": {
            "start": 1247.91,
            "end": 1259.11,
            "transcript": "Qerruvaqer', rub-anek qerrutulinek, angyaqatagtun [?] ayuqluteng, tua-i tegg'utaileng'e'rmeng, rub-aumeng, tegg'ilaameng, tau͡gken tamakut."
        },
        "87": {
            "start": 1259.11,
            "end": 1281.7,
            "transcript": "Aguutet canoo-t enrunateng wall'u qagaani angyapiat imkut amimek, imarpigmiut amiitnek amilek enrunani pugtangailan, tamakut cetut tuaten angyaqatarqat, murait ayaut quyurrluki atu'urkat pilartut."
        },
        "88": {
            "start": 1281.7,
            "end": 1289.07,
            "transcript": "Cat tua-i ucinertut atam tamakut angyaqatiit."
        },
        "89": {
            "start": 1289.07,
            "end": 1311.48,
            "transcript": "Taqngameng-llu tua-i cali-am kelugarciaqameng tua-i canek tamaani piinanermeggni canek makunek kevyungalrianek kelugarcillerkaq cali muriit."
        },
        "90": {
            "start": 1311.48,
            "end": 1323.61,
            "transcript": "Angyaqatak camun wall'u nasqunalegmun kevraartumun, kuiget tua-i tamaa-i carvanilriani."
        },
        "91": {
            "start": 1323.61,
            "end": 1333.67,
            "transcript": "Ukut wani acilqurrit uaqliuyuitut, kiaqliurrlainauluteng carvanrem tungiini imkut mimernait."
        },
        "92": {
            "start": 1333.67,
            "end": 1348.22,
            "transcript": "Ipuucitukait acim [?] tamaa-i tamakut wall' iliit teggalqisngaluni kapusngaluni alingnarqut tamakunun agtuuskuni angyaqata piyuituq."
        },
        "93": {
            "start": 1348.22,
            "end": 1365.94,
            "transcript": "Carvanrem melugluku asgulirnerakun imitua angllurrluku-llu tangrrungaunani-ll' angyaunge'rmi-llu muraunge'rmi tuaten tamakunun."
        },
        "94": {
            "start": 1365.94,
            "end": 1378.72,
            "transcript": "Man'a kuiget carvanirluni tamakucimun agtuuskuni quka'arrluni egmianun pugterenqerrau' luvqerciiquq [?]."
        },
        "95": {
            "start": 1378.72,
            "end": 1394.27,
            "transcript": "Carvanrem melugluku nasgulirneq, tuaggun nasgulirnerkun imirluku cairyugngaluku yuk, kinguqliirutka imumek ply wood-aamek manaryartut."
        },
        "96": {
            "start": 1394.27,
            "end": 1408.75,
            "transcript": "Tuaten tua-i neggluku imirluku pugler', cali tua-i naringavigi [?] camna tua-i kuigem terr'a piluku."
        },
        "97": {
            "start": 1408.75,
            "end": 1428.75,
            "transcript": "Au͡gna-llu tua-i narivikellra piyualuteng tua-i atralliniluteng, massiinaq tau͡gaam tauna au͡g'angnaqliniluku atullerteng 25-aarulliuq, caulria tua-i tuavet ellili' [?]."
        },
        "98": {
            "start": 1428.75,
            "end": 1440.29,
            "transcript": "Qerrayunaqngan tua-i qikertakun qaillukuarluteng-am call' qerrangnaqluteng qerrarluteng pengerturluki-llu tua-i tekicunrilata."
        },
        "99": {
            "start": 1440.29,
            "end": 1465.88,
            "transcript": "Tua-i tamana angyaqaa ca maantelliniluni. Paqluku-llu tua-i pillemteńi kiugna Frank DeMantle-aaq wiinga kinkunek cali ilaluta tamana aqvaluku mermi iluanelnguq, apqiitnek nagtarrlugmun angllulleq."
        },
        "100": {
            "start": 1465.88,
            "end": 1478.41,
            "transcript": "Makut-llu cali maa-i cali manaryat-am iliitni ukaqvaggun allrakut, wall'u-q' allrakuurtuq tangrruyuitut."
        },
        "101": {
            "start": 1478.41,
            "end": 1487.74,
            "transcript": "Mer'em iluantetuut camun pilriit asgutmun carvenrem negingalaateng."
        },
        "102": {
            "start": 1487.74,
            "end": 1500.67,
            "transcript": "Au͡gna-ll'-am cali Kaali Kawagley [?] unguvaluni imkunek 1 by 6 angyapiaq tuskaq number boat, 1 inch."
        },
        "103": {
            "start": 1500.67,
            "end": 1511.17,
            "transcript": "Tamana-am tamakucimun kiani Akiarmi elitnauristengqellruukut."
        },
        "104": {
            "start": 1511.17,
            "end": 1517.93,
            "transcript": "Camek-am atengqellruyaaquq Kaali Kawagley [?] unguvaluni tamaani Akiarem taqluni."
        },
        "105": {
            "start": 1517.93,
            "end": 1531.99,
            "transcript": "Tuntuvagtullermeggni-am tamatum atami angyaakun tuskanek tamakunek 1 by 6 amirluni muriit tamaani pilallratni."
        },
        "106": {
            "start": 1531.99,
            "end": 1539.77,
            "transcript": "Tua-i maakucimun tua-i-m kaassalinaq arulairtellrani tamakucimun piluku."
        },
        "107": {
            "start": 1539.77,
            "end": 1551.89,
            "transcript": "Tuani-am Kaali Kawagley-m [?] qanrutlinia tauna elitnaurista maligi, maani kuigmi asgutuut murilkelluki murilkelluteng."
        },
        "108": {
            "start": 1551.89,
            "end": 1572.37,
            "transcript": "Ca tua-i qaillun man'a kaassalinaq arulaireskan ca teguqerluku wall' asiarutmek [?] muragmek cikuliurun puukartellaitnek algacagluteng pituut tanguarut cali makut murilkelluki."
        },
        "109": {
            "start": 1572.37,
            "end": 1579.59,
            "transcript": "Tua-i paivngaluki tua-i murilkelluki qaill' pikuneng tegulerluku tua-i caleryagarkaugut."
        },
        "110": {
            "start": 1579.68,
            "end": 1600.64,
            "transcript": "Tua-i-am tauna massiinaq arulairtellrani avaniim massiinani makut camun lagtuutaqameng wall' it'gallritaqameng apqaitnek serve pin tamakut au͡g'ar' kep'arrarlallruut."
        },
        "111": {
            "start": 1600.68,
            "end": 1619.88,
            "transcript": "Au͡gkut massiinaqaaraat serve pin-anek aterluteng tamakut kep'a camna kaassalinaq ayainermun tamakut kep'artaq' tuaten tua-i pilaqluni."
        },
        "112": {
            "start": 1619.88,
            "end": 1629.8,
            "transcript": "Tuani tua-i tauna-llu alingnaqniluku qanrutellrulliniluku murilkelluku pisqelluku tua-i-llu tauna elitnaurita qanlliniuq."
        },
        "113": {
            "start": 1629.8,
            "end": 1641.68,
            "transcript": "Ellii-gguq-wa mat'umun Kiillaraliitmun teguvkarngailkuk. Tua-i tuaten qanrutellrani qanlluku."
        },
        "114": {
            "start": 1642.68,
            "end": 1651.29,
            "transcript": "Tua-i tuani tamakucimun massiinaq tauna ussukcairtelliuq-llu wall'u-qaa au͡g'altuq asgenra [?]."
        },
        "115": {
            "start": 1651.29,
            "end": 1671.68,
            "transcript": "Tua-i tuavet muragmun acilqumun piami carvaniami mer'em piniami tuavet tua-i nasqunamun piqrucami asgutmun imilerluni."
        },
        "116": {
            "start": 1671.71,
            "end": 1687.93,
            "transcript": "Asmarrluni atqerrluku tua-i tauna imna qinrutaunani manarcuutairulluni nutgiulluni tua-i tauna qanngualleq."
        },
        "117": {
            "start": 1687.93,
            "end": 1703.59,
            "transcript": "Tua-i ingna angyam ilua carringqekapiaralalliniuq tua-i tauna murak nagingatii switch-aakun kegglarluku au͡gna imna kinguqliqa."
        },
        "118": {
            "start": 1703.68,
            "end": 1715.48,
            "transcript": "Akacagyaaqlermeggni ava-i massiinaq au͡g'alaagniluku pillruuq tauna tua-i naringuvia murak kegglarluku switch-aakun igcani."
        },
        "119": {
            "start": 1715.48,
            "end": 1734.89,
            "transcript": "Tamana uatmun caumalliniami angyaq tau͡gaam aluluni tuskanek 1 by number, man'a tau͡gken qacarnera plywood, plywood-auruluni tauna imna naringavini."
        },
        "120": {
            "start": 1734.89,
            "end": 1753.39,
            "transcript": "Kep'arcan angyaq-llu tamana mer'em iluani kingua ciumek pugleqertuq imna tauna nagingavini kep'artellran pugleq, wiinga-llu tua-i tangvagluku wani."
        },
        "121": {
            "start": 1753.39,
            "end": 1762.39,
            "transcript": "Kep'arcan tauna camani nagigarracuayaruatni angyam kinguan puglerrluni."
        },
        "122": {
            "start": 1762.39,
            "end": 1772.68,
            "transcript": "Tua-i-llu tamana ciunga-llu imna ciungan ingna ilakut au͡g'alliniaku carvanrem cali."
        },
        "123": {
            "start": 1773.08,
            "end": 1794.9,
            "transcript": "Can-aqercami [?] tua-i kingua puglerrluni napa'arrluni waten carvanrem ingna nallugarrluku tuar cingqerraq ciumikun-llu yaaggun perrlermikun meq anqerrluni ingna-llu naparrluni tua-i."
        },
        "124": {
            "start": 1794.9,
            "end": 1817.74,
            "transcript": "Aren mermek imiarcami pugleqertuq imkut enret two by six-aat qukamegteggun qupumiimeng, tamakut-llu aciatni tamakut imaunani ciumikun maq'errluni."
        },
        "125": {
            "start": 1817.74,
            "end": 1831.43,
            "transcript": "Wiinga-llu tua-i pilua tegulerluki egmian atqercan ceńamelan, atraqerrlua tegulerluki."
        },
        "126": {
            "start": 1831.43,
            "end": 1845.06,
            "transcript": "Mer'em iluanqaarluni carracuayaarmek imaq-im [?] tua-i-ggem kuvrami tuaten kingua ciumek piami naparrluni meq qerrurrluq pagaa-i carvallalria tuar' [?]."
        },
        "127": {
            "start": 1845.06,
            "end": 1863.88,
            "transcript": "Au͡gna tua-i tamana pitekluku cali murilkela' cetulriit murilkelalliniut, akerta uatmun ayagturalami [?] imumek meq, akertem, akerta wavet elli'irqan arulailallrulliniuq."
        },
        "128": {
            "start": 1863.88,
            "end": 1875.31,
            "transcript": "Ciqinernariqerrluni-gguq tangerciiganani, ciqineq-wa tua-i nallunritliken."
        },
        "129": {
            "start": 1875.31,
            "end": 1886.39,
            "transcript": "Mer'em qainga akertem tangerciigalan qevleriluku, cikutun ayuq' tua-i tuaten ellirnera [?] arulairluteng pilallrulliniut."
        },
        "130": {
            "start": 1886.39,
            "end": 1899.75,
            "transcript": "Unuakumi tau͡gaam tua-i piaqluteni iliini-llu, piaqluteng tua-i tuaten arulairaqluteng."
        },
        "131": {
            "start": 1899.75,
            "end": 1921.32,
            "transcript": "Cali meq waten au͡gna kuik tamana canek muragnek keviumaaqan, ava-i-llu waten muriit amllelalliniut ciissaalriatun kuik kuik teggalquq waten kanevluni pilalliniuq."
        },
        "132": {
            "start": 1921.32,
            "end": 1937.67,
            "transcript": "Kanevluni tua-i ciissaalriatun imkut qugniilnguut kevraartut tuar ciissaukun kepurtur' kepurturqai tamakut aciit qerra'artaqama, iquaqama kuik-wa man'a carugpak [?]."
        },
        "133": {
            "start": 1937.67,
            "end": 1953.8,
            "transcript": "Tua-i tuaten ciissaalriatun cukanruluni-llu pitulliniuq, kuilinqigcivaqami mer'em elagluku teggalqungraan, alingnarquq tamana, acutaayuunani-llu."
        },
        "134": {
            "start": 1953.8,
            "end": 1963.68,
            "transcript": "Tua-i tauna cairluku nutgiulluni, angyam iluani tamermeng aterrluteng..."
        }
    },
    "H_nE-ZMAmI8": {
        "1": {
            "start": 4.707,
            "end": 25.552,
            "transcript": "Paltuugem aaniin atkua paltuuk. Man'a maa-i au͡gna lumarrarmek pingqerrami man'a-llu, una-llu aanaungami nayiim melquqcianek pingqerrluni. Man'a nayiuguq, nayiim melqurranek."
        },
        "2": {
            "start": 26.707,
            "end": 42.96,
            "transcript": "Allaunruuq maa-i man'a nayiim qecia. Au͡g'um paltuugema aaniin pikaa una. Ing'um, Matina-m pilialqai makut, caliaqaa."
        },
        "3": {
            "start": 49.103,
            "end": 59.207,
            "transcript": "Au͡gkutun pikuni imektuunani imekcuruyakaryugluni, mat'umek tau͡gken pingqerrami assirluni."
        },
        "4": {
            "start": 64.845,
            "end": 83.224,
            "transcript": "Nacaquni ella anuqem [?] iciw' imkussiyaagpek'naku, taiga'rtevkarpek'naku. Apqiitnek aqumeqautmini makucilineq-llu taqutnaituq aqumqerluni."
        },
        "5": {
            "start": 84.931,
            "end": 88.897,
            "transcript": "Makut tamaa-i qakutii-gguq maa-i man' keglunrem."
        },
        "6": {
            "start": 91.259,
            "end": 105.96,
            "transcript": "Usguqu'urluku au͡g'arturarraarluku elliluku mat'umun negilvakayallrem, taqliqluku, malrugnek-llu iluqlilirluku cali allagnek."
        },
        "7": {
            "start": 106.586,
            "end": 116.638,
            "transcript": "Tua-i-llu man'a aqsii maa-i ukalirneranun elliluku ukatmun caulluku aqsakaa man'a keglunrem."
        },
        "8": {
            "start": 120.655,
            "end": 128.155,
            "transcript": "Waten negililituukut. Maa-i-gguq ulpegyailkutii."
        },
        "9": {
            "start": 135.5,
            "end": 142.379,
            "transcript": "Tua-i-am au͡gkut yuratullratni iliini yuralrianek tangssutullruunga,"
        },
        "10": {
            "start": 142.759,
            "end": 152.397,
            "transcript": "ca tamalkuan qanemcikaunegteki, waniwa-gguq pitami makucianek waten cuqnguarluku acetutacia."
        },
        "11": {
            "start": 152.828,
            "end": 163.96,
            "transcript": "Waniwa-gguq qakutii waten tua-i yurallermini waten piluni, tua-i-gguq mat'um qakutiinek cuqciluni."
        },
        "12": {
            "start": 163.96,
            "end": 172.138,
            "transcript": "Canek-im igcetaanek acirluku pissuquvgu, camun anyuumaluni [?], canek ima pit'."
        },
        "13": {
            "start": 172.224,
            "end": 188.586,
            "transcript": "Tamakussurluteng pitamek, pisnguarluni-am tauna yuralria tua-i-llu qakutii-gguq una, piani im' qakutii acetuqallra tunuani,"
        },
        "14": {
            "start": 190.0,
            "end": 206.897,
            "transcript": "cuqnguarluku, qanemci' call' tamana waten elliurturluni yuraryaraq qanemci' ciuliameng piitnek kinguvavkatuyaaqluku. Wiinga ava-i yurangqertua imarnicinguarturalriamek."
        },
        "15": {
            "start": 209.328,
            "end": 222.707,
            "transcript": "Tua-i-am cat tamalkuan arulaciqngamegteki yugni ayuqenril' iciw' allacetun qantulriit allaceteng-llu qaill' caperluku."
        },
        "16": {
            "start": 223.052,
            "end": 234.0,
            "transcript": "Tamaa-i ellaita pimeggnek yagiraluteng call' qanemciurluteng yuratuut. Piumiarpek'nateng apqiitnek qavaruarluni-gguq."
        },
        "17": {
            "start": 236.759,
            "end": 242.276,
            "transcript": "Maa-i makut Kass'at imkuit piutait iqutait."
        },
        "18": {
            "start": 244.96,
            "end": 249.414,
            "transcript": "(Cakuciurat tamana melqurra?)"
        },
        "19": {
            "start": 249.828,
            "end": 264.483,
            "transcript": "Imkut rabbit-aanek pitukait makut Kass'at piutait. Tua-i wangkuta mingqetuaput ukat' qeciakun pivkenaku maaggun tau͡gaam."
        },
        "20": {
            "start": 264.517,
            "end": 279.103,
            "transcript": "Melqurritgun piuq, mingqerluki maaggun piyaaqekumteki iciw' tua-ll' amkut melqut nucungluteng, alaingluteng maaggun tangniirulluteng."
        },
        "21": {
            "start": 279.103,
            "end": 293.0,
            "transcript": "Tau͡gken maaggun makuatgun mingqengermi anyuunateng. Mingquq ngelqingraan-llu ayuqluku tua-i waten mingqerluku, melqurrakun maaggun."
        },
        "22": {
            "start": 294.81,
            "end": 307.897,
            "transcript": "Yaqulgungraata-llu call' tuaten makuitgun melqurritgun mingqurluki, kiingan tua-i melqurritgun mingeqluki."
        },
        "23": {
            "start": 309.241,
            "end": 339.569,
            "transcript": "Waniwa-am una call' angkayagluni iciw' alianek qanellrulrianga. Paatakun [?], ii-i waniwa call' un' angkayagluni. Aling kangia. Angengnaqu'urluki aliita kapusngallrit, ukut-llu call' nanitellerkait, ukut-llu cali ilukitlerkait angutet wani keserrlainarnek makucinek negilingqelalriit."
        },
        "24": {
            "start": 342.776,
            "end": 360.0,
            "transcript": "Cali tua-i tuaten pilartut. Keserrlainarnek angutet pingqetuut, iliini-ll' makurpagmek ulpekyailkucirluku. Maa-i man'a-am paluqtaq."
        },
        "25": {
            "start": 360.862,
            "end": 374.448,
            "transcript": "Terikaniaq-wa. Man'a-am au͡gkut ava-i paluqtat nacauluteng makuuluteng, alim-llu nuukluki, mat'um-llu cali ceńevkaryailutekluku [?]."
        },
        "26": {
            "start": 375.362,
            "end": 390.379,
            "transcript": "Maa-i man'a pimalria aqsaitnek. Iciw' merigyugciqngata man'a mat'umek maa-i waten elliluki uluarturaqluki."
        },
        "27": {
            "start": 392.637,
            "end": 398.258,
            "transcript": "([?]-gguq tamaa-i tamakut. [?] maani Kusquqvagmi pituaput.)"
        },
        "28": {
            "start": 399.793,
            "end": 419.172,
            "transcript": "Piilkuneng merigyugciqngata akua. Yaqulgungraata-llu yaqurritnek allgiaraat pitukaitnek, yaqurrita natkuuyugaitnek makucingqetullruut tumarngaluteng."
        },
        "29": {
            "start": 422.845,
            "end": 432.966,
            "transcript": "(Uluarumavkenateng, cet'rumavkenateng.) Ca imkut yaqurrita nataitni qaill' angtaluteng uitalriit tamakunek."
        },
        "30": {
            "start": 436.603,
            "end": 453.672,
            "transcript": "Qanganat alngalget cali waten call' ilait pingqelartut takuit ungkut. Pikailnguut-am piilengraata atkugtukait."
        },
        "31": {
            "start": 456.724,
            "end": 468.96,
            "transcript": "Tua-i-am un' waniw' Mark-am nulirran atkuk wani yugpaungan, angkayagluku un' nulirran paltiuliaraa."
        },
        "32": {
            "start": 472.121,
            "end": 488.103,
            "transcript": "Tang maa-i waten, ngelqiit ussanricaaqluku qamna, alian kangia. Cali imkut waten."
        },
        "33": {
            "start": 497.379,
            "end": 510.569,
            "transcript": "Tua-llu taqumarinrakun nequkitarallinian-am elliin call' maa-i mat'umek nequtucarluku, taqumaringraan-am wavet ullirrluku."
        },
        "34": {
            "start": 511.569,
            "end": 531.345,
            "transcript": "Mat'umek elliin ellivikluku. Amavet tua-i. Waten-am makut maa-i mingqerraarluki keviqatuut, waniw' unran kat'um kevia waniw'."
        },
        "35": {
            "start": 534.741,
            "end": 564.879,
            "transcript": "Uum waniw' pia. Miknayukluku. Waten pikuni mikelkuni allegyugluni pisciiganani ukua allegyugluni, wall' una allegyugluni ukatmun. Waten tau͡gken pingqerquni assirpak. Angengnaqu'urluki pitullruut. Atkuut nat' aliit nequkitlerkai cali imkukluki."
        },
        "36": {
            "start": 567.724,
            "end": 590.138,
            "transcript": "Imegnaingnaqluki pituit. Tua-i-w' waniw' una angengermi assian natii-ll' imkunek qercugpek'nani, allegyugpek'nani. Nacaa-ll' call' wani angtacia."
        },
        "37": {
            "start": 603.69,
            "end": 617.155,
            "transcript": "Tang waniwa nacaa. Piktevkenani cali, ilii."
        },
        "38": {
            "start": 625.017,
            "end": 631.19,
            "transcript": "Wagg'uq waten nacangermi qunerrngairulluni, qaciggluni tau͡gaam."
        },
        "39": {
            "start": 634.414,
            "end": 648.741,
            "transcript": "Wiinga mingeqsugallemni yaqulegnek elliraat, elliraanek pingayunek call' alqairutma irniariin pingayun tan'gurraat taukut tua-i atkuliyaramek elissautelpuk kinguqliqa-llu."
        },
        "40": {
            "start": 649.069,
            "end": 668.172,
            "transcript": "Nacalinek tau͡gaam elitnaciarluku cunaw' tang nalluluku, patgulluki amllertatekluku una-llu pitullini'. At'engualriani tua-i man'a puverpagngatuq man'a cagnilria. Waten pimanga' [?] wall'u-q' ukatmun."
        },
        "41": {
            "start": 669.81,
            "end": 679.155,
            "transcript": "Cunaw' tang tuaten ingluit nanillruluku pitullrullit', kiingan tauna elitesciigatqeryaaqellruaqa nacalinek."
        },
        "42": {
            "start": 684.052,
            "end": 692.96,
            "transcript": "Iluteqraarlunuk engel'angaqlunuk nangteqngallagngataqluteng at'enguarcetaqamegnek yatkuut [?]."
        },
        "43": {
            "start": 696.96,
            "end": 715.241,
            "transcript": "Cam mitkenritengnaqluku, man'a-ll'-am maa-i call' nanitenritengnaqluku piliaqluku assillerkaakun tau͡g', nacaunani-ll' uitakuni cali assiami misngaluni man'a tamarmi."
        },
        "44": {
            "start": 715.879,
            "end": 730.534,
            "transcript": "Natiim naca' caam cagnikuni una-llu ukatmun nerigyugluni, wall'u-q' ukatmun nerigyukluni. Tua-i waten piami assirluni-llu una-llu ukatmungqaluni."
        },
        "45": {
            "start": 733.345,
            "end": 735.569,
            "transcript": "Maa-i-gguq man'a asguruaq."
        },
        "46": {
            "start": 736.31,
            "end": 737.724,
            "transcript": "(Negilia.)"
        },
        "47": {
            "start": 737.724,
            "end": 748.017,
            "transcript": "Negilia. Tau͡gken tua-i waten wii-ll' negilianek qaner', negilia au͡gkut. (Ca piilkan?)"
        },
        "48": {
            "start": 748.707,
            "end": 763.103,
            "transcript": "Makuilkan angutet tua-i negili', angutem piani waten keserrlainarmek waten ayuqevkenaku negililirluku. Kegluneq tarvirrluku nanilkan usguqerluku tua-ll' nacamun ellilluku."
        },
        "49": {
            "start": 764.483,
            "end": 766.017,
            "transcript": "(Negiliuluni.)"
        },
        "50": {
            "start": 766.172,
            "end": 783.672,
            "transcript": "Negililuni. Makut tau͡gken arnat waten apqiitnek asguruangqelaameng, iciw' man'a elalirnera cillartengnaqu'urluku, waten elalirnera au͡gna. Cillartengnaqu'urluku uucetun."
        },
        "51": {
            "start": 787.586,
            "end": 790.96,
            "transcript": "Maa-i man'a nayiuguq cik."
        },
        "52": {
            "start": 792.121,
            "end": 794.96,
            "transcript": "(Issurinek-llu-qaa pituut?)"
        },
        "53": {
            "start": 795.96,
            "end": 803.276,
            "transcript": "Tua-i-ll' cigkilngurnek useqnagnek issuryagarnek-llu pitullilriit aqsaitnek-llu."
        },
        "54": {
            "start": 815.621,
            "end": 834.96,
            "transcript": "Makut-llu call' tua-i pilugugnun aturluteng paluqtat, alinun, nacauluteng, atkuuluteng, qaraliluteng waten. Tua-i-llu call' maa-i pikluku paluqtarma."
        },
        "55": {
            "start": 837.759,
            "end": 843.96,
            "transcript": "Uyaqurran un' aqviit [?] man'a maa-i."
        },
        "56": {
            "start": 848.19,
            "end": 860.086,
            "transcript": "Tua-i-am taqraarluki-llu pulengtaq makut qaill' ayuqekata umlluki angtucarluki pinarqetuluni."
        },
        "57": {
            "start": 862.086,
            "end": 867.983,
            "transcript": "Tau͡gken tua-i angvallangermi cavkenani mikteqanrilami."
        },
        "58": {
            "start": 876.431,
            "end": 888.96,
            "transcript": "Maa-i ayuqluteng atkuli' pingnatugciiganateng-llu paniput wangkucicetun canek atkugnek pingnatugciiganata."
        },
        "59": {
            "start": 891.345,
            "end": 903.586,
            "transcript": "Wangkuta canek paltuuget-llu nurnarqellratni atkulingnaqu'urluta callruarnek pitullruut yaqulegnek, ngelqaqestiinun atkukevkaraqluki."
        },
        "60": {
            "start": 904.828,
            "end": 906.96,
            "transcript": "Angutet arcaqakluki."
        },
        "61": {
            "start": 910.621,
            "end": 915.069,
            "transcript": "(Atkuliaqameng natii ciumek mingqelartatgu.)"
        },
        "62": {
            "start": 915.672,
            "end": 924.603,
            "transcript": "Akuit piyuumiilkunegteki ukuam ciumek akulperaat, tunuara-gguq akulperaat."
        },
        "63": {
            "start": 924.655,
            "end": 950.172,
            "transcript": "Tunua angenruluku piluku waniw' una. Uum akunlii angenruluku watuacetun. Tua-i-llu kingua call' una call' pam'umi mikellruluni call' pamna cagningairucelluku tunuaratun akulperanek wangkuta pituaput."
        },
        "64": {
            "start": 953.96,
            "end": 981.293,
            "transcript": "Tua-i-llu apremnek munalriim cali yulriim kat'um akulperam usguanek iqukluku ukua nacaqevkarluku. Usguvkenaku tau͡gaam naken mayurluni nacaqevkarluku. Tuaten pituluteng."
        },
        "65": {
            "start": 984.328,
            "end": 1006.69,
            "transcript": "Assiraqlun' una-ll' wani pinganani cali. Waniw' una pik'um usguaran kepenrilani amna. Waniw' usgucuarii. Pamna kepumavkenani."
        },
        "66": {
            "start": 1009.741,
            "end": 1016.345,
            "transcript": "Una kepumavkenani. Keluunani assirluni tau͡gken waniw' cavkenani."
        },
        "67": {
            "start": 1026.586,
            "end": 1044.966,
            "transcript": "Atkuut miktengnaqevkenaku angengnaqa'urluki tau͡gaam pitull' pituit. Ukuit-llu call' ava-i makuit call' uum ilait qerruarluki pitullruut atkuulartut ukuitgun."
        },
        "68": {
            "start": 1053.414,
            "end": 1073.103,
            "transcript": "Ayuqerrlainalrianek atkulisciigatellruamta wangkuta pikartu', apqiitnek pikat nurnaqngata. Tumarrluki-llu una wani natiin navgurpek'naku ilakangengnaqluku tunuara."
        },
        "69": {
            "start": 1074.448,
            "end": 1079.017,
            "transcript": "Iciw' tumaqsaaqerluku piyarauluni manua-llu."
        },
        "70": {
            "start": 1089.535,
            "end": 1115.96,
            "transcript": "Martha-m aaniin maa-i makut piliarugai. Tutgarani panini-llu qetunrai-ll' makut paltuungqerrsaaqluteng tamarmeng, ellaita tau͡gaam atuyuitait. Piluguitevkenateng-llu tamarmeng. Pilistiit-wa atauciq."
        },
        "71": {
            "start": 1122.155,
            "end": 1140.96,
            "transcript": "Makut maa-i Kass'at iqutaqkai. Qessananarqelrianek zip-alirluki tuaten. Wiinga-am qessanaktuyaaqekenka makut zip-at navgaqata-llu cimiriyuumiicaaqaqluki."
        },
        "72": {
            "start": 1147.414,
            "end": 1173.155,
            "transcript": "Tua-i-am waniwa elirqungiimi, waten pimangermi assirlu', waten tau͡gken pimakuni, waten ayak', tau͡gken waten pikuni assirluni natii iqlukevkenani, zip-angermi-llu ayuqluni iquklilluni. Assirpak cali qaill' pivkenani tua-i waten, waten pinqeggluni."
        },
        "73": {
            "start": 1176.569,
            "end": 1198.707,
            "transcript": "Ukua nanitevkenaku piami. Wagg'uq waniw' cillartengnaqluku man'a. Tua-i waniw' assiami iqu', nangluku-llu zip-autengermi man'a waten ayuqsugngaluku."
        },
        "74": {
            "start": 1204.759,
            "end": 1226.397,
            "transcript": "Catgu aqum', apqiitnek caqungqerrluni wanirpak taqngailami. Iryaqerraarpek'nani umyuarteqluni una, umyuarteqkuni uqilua-llu [?] wall'u-q' ukatmun."
        },
        "75": {
            "start": 1233.96,
            "end": 1245.96,
            "transcript": "Apqiitnek maa-i aqumqerrluni, massiinarluni-ll' qaspingermi aqumqautmini taqutngaicetuut [?]. Tua-i ayuqluni."
        },
        "76": {
            "start": 1246.96,
            "end": 1258.207,
            "transcript": "Tegulaarluki wangkuta tegulapiarturluki mingqetuamteki, una-llu qaill' pilria uluarluku arvirluku elirqetua [?]."
        },
        "77": {
            "start": 1264.96,
            "end": 1292.96,
            "transcript": "Tua-i-q' taringuci? Avani tua-i yaqulegnek tau͡gaam pingnatutullruut kaviaret uliirnek-llu, rabbit-aanek-llu makurmiutarnek. Cali tua-i quulluki assivkangnaqluki. Qetutevkangnaqluku, qessavkenani tua-i ulugturluki."
        },
        "78": {
            "start": 1298.535,
            "end": 1307.96,
            "transcript": "Maa-i yuut qacigtengelriit cak, akimun tau͡gaam kiingan cak piyugturluteng, arnaungermeng."
        },
        "79": {
            "start": 1313.069,
            "end": 1318.96,
            "transcript": "Maa-i call' ak'acetun piyaraq Kass'at cucukaqluki."
        },
        "80": {
            "start": 1321.96,
            "end": 1335.431,
            "transcript": "Tua-i-am waniw' uum paltuugem, atkuum paltuuguluni, natiin canganarqevkenani, piliaqestiin ukurrani angeng'an waniw' angkayagluni."
        },
        "81": {
            "start": 1336.603,
            "end": 1344.259,
            "transcript": "Calturpek'naku-llu angengermi arnaq. Natiima asqiatevkenani."
        },
        "82": {
            "start": 1355.517,
            "end": 1359.552,
            "transcript": "(Man'a-wa uum una waniwa negiliq.)"
        },
        "83": {
            "start": 1361.845,
            "end": 1376.759,
            "transcript": "Ikamralallermeggni anuqa pairrluku-llu ping' piaqameng ak'a tua-i atuuluteng waten elliluteng qimugtet ayaulluku una yugteng, anuqa', taumek,"
        },
        "84": {
            "start": 1378.121,
            "end": 1410.621,
            "transcript": "Ac'etengnaturluku tua-i asgurcuutet anuqekun anuqa, ak'a tauna ellilequni anuqlingraan kegginairyugnaunani kegginaq uqilluku uum. Anuqekun-ll' asgung'e'rmi tua-i waten elliqaquni, ak'aki kegginaq urugarcugngaluni. Taumek atengqellriit anuqekun asgulriani elliluteng,"
        },
        "85": {
            "start": 1411.138,
            "end": 1440.96,
            "transcript": "ac'eteng aturluku anuqekun asgung'e'rmeng ak'a iliini anuqa neng', uksumi nengllirqan tua-i kegginaller-llu pakemna anuqa wall'u canirulluku pilriani, anuqa tua-i tunglirnera ak'a tua-i qerriata akekataki tua-i kegginama, kegginallrama inglua, tau͡gaam makucit,"
        },
        "86": {
            "start": 1441.741,
            "end": 1465.5,
            "transcript": "waten elliqaquni ayakuni ak'a tua-i uqrutauluni. Anuqa-llu caniruteng'e'rmi taumek anuqekun asgulriatun ac'eteng aturluku asguruat asgung'e'rmi-ll' anuqa assirluni, assirluni, kegginaq patuguqisngaarkauluku [?]. Tua-i, au͡g'um ikayuqa'arqa."
        },
        "87": {
            "start": 1468.397,
            "end": 1485.448,
            "transcript": "Boy-am [?] akaarcaaqelriamek, qamaggun mingqumiimeng melqurrakun, kel'u' maa-i-ll' anevkenateng melqurruit. Tau͡gken maaggun elatekun waten mingqekuni ak'a tua-i melqurri anluteng."
        },
        "88": {
            "start": 1486.897,
            "end": 1500.96,
            "transcript": "Kenluqsagngaunateng tau͡gken maaggun melqurrakun mingqurluku pikuni, ak'allaurtengermeng-llu waten ayuqumaluteng, melqut pugesciiganateng maaggun."
        },
        "89": {
            "start": 1510.776,
            "end": 1512.293,
            "transcript": "Tua-i-qaa?"
        },
        "90": {
            "start": 1545.466,
            "end": 1554.68,
            "transcript": "Taum kituusqaqerturru [?] tauna. (Mic-an.) Una wani nugtarrluku tungiinun."
        },
        "91": {
            "start": 1560.914,
            "end": 1588.328,
            "transcript": "Uum wani atuullra amllertuq waten-am waniw' ayuqeng'e'rmi imkunun, qalartellrulria una canek taluyaruanek imarmiutarcuutnek piqataquni wall'u imkunek kanaqlagnek, camiuni-llu ilegvagnek pilartatki, kani' [?] tua-i (Ii-i)"
        },
        "92": {
            "start": 1588.569,
            "end": 1595.966,
            "transcript": "Ii-i. Keggani kegga kaulimek kainaatamek aipaag' ayagnirluteng qelivagnek piurat [?]."
        },
        "93": {
            "start": 1595.966,
            "end": 1615.155,
            "transcript": "Yaa, waten-am tamakut imkut tuani atertangqerraqan, aullu tauna apaangaitaat. Tuaten atengqellria. Tua-i-ll'-am cali ava-i qanellrulrianga un'gani,"
        },
        "94": {
            "start": 1617.0,
            "end": 1636.19,
            "transcript": "maqarualegtangqerran maqarualek-am tua-i qulautekluku apenrilkurrluku, ciriirnek pilallinikait maqaruat. Ii-i, tua-ll' cat tuaten ayuqut. Tuamta-llu cali una waniwa una piciatun aturtuq."
        },
        "95": {
            "start": 1636.207,
            "end": 1660.552,
            "transcript": "Taluyat wall' au͡gkut nemiarat tamakunun umyuaqulluku cimiskunikii [?] makucimeg'-am makut kuicuaraat kiagumatulit-llu nuniit makut imarmiutaat wangkucicetun-am cali can'giirnek neqengqertut."
        },
        "96": {
            "start": 1661.569,
            "end": 1690.603,
            "transcript": "Canek tua-i neqnek nerluteng imarmiutaat neqekluku. Tamakut-am taluyanun itraqameng can'giircuutet-llu wall'u taluyaruat, makucimek imaitaqameng, imna tua-i naggun tungitellratgun-llu yaaggun perellratgun, qangquulluteng kanaqlayagaunii,"
        },
        "97": {
            "start": 1691.017,
            "end": 1718.724,
            "transcript": "wall'u imarmiutauli taluyaqegtaar nutaraungraan qangqurluki keggmarluki ukikata-llu tuaggun anuni. Tau͡gken makucimek-am imangqerquneng, tamakut pivkenaki maani taluyat iluatni nanitaaquni kuimarluni maku', aviraucata makut, keggmarluki tua-i ukisngaunaki-llu taluyaruat."
        },
        "98": {
            "start": 1719.259,
            "end": 1749.655,
            "transcript": "Tuaten pilartut. Tuamta-llu cali kanaqlayagaat makut keggutengqeng'e'rmeng, malruurqa'arnek ipegtut nutaan paluqtartun kepyulitun ayuqut [?]. Tua-i makuciq cali keggmarluku kepsugngaluteng tua-i. Tuaten makut piciatun aturtut. Tuamta-llu cali imkut nalqilriit."
        },
        "99": {
            "start": 1751.534,
            "end": 1779.828,
            "transcript": "Kingunemni nunamni uksuarqurniararqan imkut ceńarcuutetulriit, cali makunek nalqilrianek quyurrluteng. Tua-i-llu cali makunek-am cali nalqiyagalrianek, napacuarnek nalqiyagalrianek cali avurluteng pikarrluteng tua-i, tau͡gaam,"
        },
        "100": {
            "start": 1780.897,
            "end": 1810.328,
            "transcript": "ellmeggnek tua-i cucukekmeggnek imkut perelriit uitaqu'urluki. Tau͡gaam imkut waten nemiarat pitateku'urluteng pilaameng, tamakut-am cali nemiarluki, caputekiurluki imkut makut atgiarcuutet wall'u-qaa manignarcuutet ceńarcuutet."
        },
        "101": {
            "start": 1811.293,
            "end": 1840.172,
            "transcript": "Makut-llu tua-i cali piata qaqicata-am qillrulluki ceń'irraarluteng [?] tamakut muriit nalqilriit makut enrilnguat, uqvigpignek-wa pilallikci. (Unani pitait makucit kingunemteńi.) Makut-am qagkut imkut Kusquqvagmi,"
        },
        "102": {
            "start": 1840.431,
            "end": 1870.552,
            "transcript": "uaken ayagluni tua-i Naparyarrarnek tamakut apqait ciriiret neqaitnek-llu piaqluteng, neqetuit [?] amiit tamakut. Makut ukut-am nertulliniut ungungssiaraat makut amiitnek, paluqtaat, tua-i maqaruat, tuntuviit kangritnek,"
        },
        "103": {
            "start": 1871.259,
            "end": 1898.897,
            "transcript": "nerluteng qanikcalingraan, elngut kangritnek nerluteng tuntuviit. Tuaten ayuqut makut tuntuviit issaluurat-llu cali imkut, elngut qeltait piurluki kepurluki paluqtartun nerlarait. Neqngamegteki tua-i, aren-wa uum wani-am Ellam Yuan,"
        },
        "104": {
            "start": 1899.759,
            "end": 1928.828,
            "transcript": "ca neqirluku neqkartuumaan taitelaameng canun-llu ungungssairnun tamiinun, tamakut tuaten nertuluteng, tuntut-llu nunapigmek neqkait [?] neqkailngaunateng, ungungssairaat wangkuta cali piyukumteki pissurluki, iliini nangtequalaramta. Tua-i-llu tua-i waniwa ava-i,"
        },
        "105": {
            "start": 1932.914,
            "end": 1962.19,
            "transcript": "taluyat tamakut, tuamta-llu cali imkut kiagmi. Una waniwa neqliarnek pamani qassallrulria tua-i, cali-am capluku nemiaranek tau͡gaam, civvluki-llu tua-i carvaneq tunulluku. (Asgurcuucirluku mermi.) Manatukaitnek neqcuaraat, whitefish-ayagaat."
        },
        "106": {
            "start": 1962.397,
            "end": 1992.155,
            "transcript": "Cali-am tua-i tuaten tamakussurluteng aturluki tua-i. Tuamta-llu cali au͡gkut ava-i cat perelriit-llu muriit cuukvaguat, wall'u makut perelria cali tamakuyugngaluteng, ikamranun asvairquyutnguluteng, piciatun tua-i murak aturaat makut."
        },
        "107": {
            "start": 1992.759,
            "end": 2011.56,
            "transcript": "Ciuliarlumta can'get, grass, aturait, piciatun cat call' caurturngaluku. Tuamta-llu cali maa-i makut neqsuutnun cali atuuyugngaluteng."
        }
    },
    "HzGl6zYmZW4": {
        "1": {
            "start": 3.36,
            "end": 23.84,
            "transcript": "Una-wa, ataki qeltii, makut, makut-llam makuunge'rmeng qagkut kegga-i keggani alailngurmi tangvakemteńi napat ayuqenritut."
        },
        "2": {
            "start": 23.84,
            "end": 39.68,
            "transcript": "Quunarlit, kaviqsuyagaat nunapiim qainganek nautulit, kaviqsugnek piaqluki, tamakut tua-i aciitnek-llu nemiaruteksugngaluki cali nemiaryugngaluteng."
        },
        "3": {
            "start": 39.68,
            "end": 59.4,
            "transcript": "Tuamta-llu cali maa-i yuut makut iqairiyu'urangameng [?], enem-llu iluani makuciungraan ak'a muragmek nalqilria ak'a clothesline, tua-i atuuyug' [?] nalqiami."
        },
        "4": {
            "start": 59.4,
            "end": 79.44,
            "transcript": "Avani cat makut atutullret, cat tua-i wall'u cali, wall'u cali imkunek qikilirluki keniq kumarrluki keni'irqameng cali,"
        },
        "5": {
            "start": 79.44,
            "end": 89.86,
            "transcript": "perelriit imkut agarucirluki, camek-wa tua-i elngurturalriamek agarucirluku [?]."
        },
        "6": {
            "start": 89.86,
            "end": 103.68,
            "transcript": "Makut aturtut maa-i, una wani enrilnguarungatuq qagaaken pillrukunek."
        },
        "7": {
            "start": 103.68,
            "end": 110.08,
            "transcript": "Qagkut cali enrilnguarunritut. Kaviqsuungatut."
        },
        "8": {
            "start": 110.08,
            "end": 133.9,
            "transcript": "Makut-llu cali napat ayuqenritut: enrilnguat, angvallurlit, kaviqsuut, cuukvaguat, auguqsulit."
        },
        "9": {
            "start": 133.9,
            "end": 141.54,
            "transcript": "Au͡gkut angvallurlinek pilallret, makuciit cuyait."
        },
        "10": {
            "start": 141.54,
            "end": 149.08,
            "transcript": "Akagtangqerrsarpia' iqtuyararluteng, akagtanqerrluteng."
        },
        "11": {
            "start": 149.08,
            "end": 160.78,
            "transcript": "Piit, makut-llu qagaani ayuqngalngermeng atrit ayuqevkenateng."
        },
        "12": {
            "start": 160.78,
            "end": 169.5,
            "transcript": "- Yaa-i man' elitaqciqaqa caucia. - Ak'a wii elitaqaqa."
        },
        "13": {
            "start": 169.5,
            "end": 181.44,
            "transcript": "Auguqsulit. Cuukvaguam ayuqsaaqaa tau͡gaam makungqerrami-am maa-i kepelmun."
        },
        "14": {
            "start": 181.44,
            "end": 190.62,
            "transcript": "Waten makut qaraliyagait waten canitmun usgukurayagarluteng pilaameng auguqsulit."
        },
        "15": {
            "start": 190.62,
            "end": 195.64,
            "transcript": "Cuukvagua' amta-llu tangellrat tua-i waniw' cuukvaguaruluni."
        },
        "16": {
            "start": 195.64,
            "end": 200.6,
            "transcript": "Cuukvaguapiat-llu makuciit."
        },
        "17": {
            "start": 200.6,
            "end": 215.46,
            "transcript": "Qemini-llu tua-i tamakut naurpallulartut qemit imkut pucigallritni cuukvaguat makuit qulmun."
        },
        "18": {
            "start": 215.46,
            "end": 234.5,
            "transcript": "Makut-llu maa-i au͡gkunun imkunun ing'um maniullrinun qatengraata makut amiita kaviriyugngait, color-aliyugngait cungagarrluki-gguq."
        },
        "19": {
            "start": 234.5,
            "end": 240.94,
            "transcript": "Atrit tua-i tamatum color-aliyaram cungagarrluki."
        },
        "20": {
            "start": 240.94,
            "end": 247.1,
            "transcript": "Calia tuam iqua [?] kaviriqerreskuni cungagaringai-gguq [?] man'."
        },
        "21": {
            "start": 247.1,
            "end": 250.06,
            "transcript": "Atak-gguq man'a cungagarqaaqaat [?]."
        },
        "22": {
            "start": 250.06,
            "end": 256.62,
            "transcript": "Tuamta-llu cali arnat makut caliyarait ayuqenrilameng. (Qeltaitnek-qaa aturluteng?) Ai? (Qeltaitnek-qaa?)"
        },
        "23": {
            "start": 256.62,
            "end": 262.66,
            "transcript": "Yaa, qeltait canaluki tuai au͡g'arluki camun quyurrluki."
        },
        "24": {
            "start": 262.66,
            "end": 273.36,
            "transcript": "Tua-i-ll' mermek miiqerraarluki, tua-i-llu imna tua-i uruq."
        },
        "25": {
            "start": 273.36,
            "end": 284.66,
            "transcript": "Avani-w' urunek kiingan teguyarangqelallrulriit tua-i tuaten pirraarluki tuavet urumun akurqaarluku, imna tauna amiq,"
        },
        "26": {
            "start": 284.66,
            "end": 289.96,
            "transcript": "qatengraan tamatumek mingugaqluku."
        },
        "27": {
            "start": 289.96,
            "end": 303.46,
            "transcript": "Wall'u cali makut qeltait minguggaarluku mer'atnek, makut qeltait ellilarluki, tua-i palurqurluki ak'a kaviriyugngariluteng au͡g'um,"
        },
        "28": {
            "start": 303.46,
            "end": 311.14,
            "transcript": "kameksiim, kameksiim au͡g'umek kavircecarpialriim mengliarutem color-aa."
        },
        "29": {
            "start": 311.14,
            "end": 318.9,
            "transcript": "Makungai [?] tuaten. (Kenirluku-qaa pituat wall'u kenirpek'naku?) Kenirpek', keninrilengraan."
        },
        "30": {
            "start": 318.9,
            "end": 339.68,
            "transcript": "Tuamta-llu cali cuukvaguat cali wall'u makucit imumi kiingan melqulek akikengnaquralallermeggni caliaq nurnallrani, kaviaret."
        },
        "31": {
            "start": 339.68,
            "end": 351.88,
            "transcript": "Waten camek tua-i February-mek ayagluni akerta apeqmeggnek caumaurayunariqerreskan."
        },
        "32": {
            "start": 351.88,
            "end": 361.16,
            "transcript": "Tua-i tamaa-i ayagluteng kaviaret makut qat'riinatuut, uiluki-gguq akertem."
        },
        "33": {
            "start": 361.16,
            "end": 372.8,
            "transcript": "Tau͡gken wangkuta yugni palirtengluta, Kass'at apqiitnek sunburn."
        },
        "34": {
            "start": 372.8,
            "end": 378.46,
            "transcript": "Tua-i palir' tunguriluta qalikcangqerrakan."
        },
        "35": {
            "start": 378.46,
            "end": 383.88,
            "transcript": "Tuaten tua-i."
        },
        "36": {
            "start": 383.88,
            "end": 389.76,
            "transcript": "Tuamta-llu cali makut imkut quunarlit."
        },
        "37": {
            "start": 389.76,
            "end": 403.0,
            "transcript": "Pertaangermeng, pertaangermeng quunarlit-gguq makut, elngurtut-llu tamakut, imkunun tuaten nuv'anun qus'urnun [?],"
        },
        "38": {
            "start": 403.0,
            "end": 409.74,
            "transcript": "nuutekluki agartengermeng, mulngakevkenaki teverqeng'ermeng kevkar'."
        },
        "39": {
            "start": 409.74,
            "end": 415.24,
            "transcript": "Enrilnguat-am tau͡gken makut kevkar', iliini kep'arcetuluteng."
        },
        "40": {
            "start": 415.24,
            "end": 432.68,
            "transcript": "Tamakunek-am cali nuutekanek can'giiret wall' can'giirnek nuv'iyukuni, can'giirnek pingqerquni nunamini cali nuutnguyugngaluteng tamakut."
        },
        "41": {
            "start": 432.68,
            "end": 434.88,
            "transcript": "Aa."
        },
        "42": {
            "start": 434.88,
            "end": 450.48,
            "transcript": "Quunarlit makut tuamta-llu cali qanritaqata, mikelnguq qanrircan tamakut tua-i qeltai cali piluki cali mikelngurmun taumun qanranun pikluki."
        },
        "43": {
            "start": 450.48,
            "end": 458.2,
            "transcript": "Mamevkangnaqkuniki mikelnguum callakayalaameng iliini makut mikelnguut."
        },
        "44": {
            "start": 458.2,
            "end": 463.58,
            "transcript": "Iliini-wa tayima iqmiullrit-llu cat."
        },
        "45": {
            "start": 463.58,
            "end": 480.9,
            "transcript": "Makut-llu maa-i elpeci arnani panici, qanrut'laqiciki makut battery-llret-llu wall' imkut battery-cuayaallret iliini maqtuut."
        },
        "46": {
            "start": 480.9,
            "end": 483.64,
            "transcript": "Assiituut tamakut."
        },
        "47": {
            "start": 483.64,
            "end": 492.38,
            "transcript": "Imaitnek poison-qapiarauluteng. Tamatumek-llu maqvikekuni lumarraungermi waten."
        },
        "48": {
            "start": 492.38,
            "end": 496.0,
            "transcript": "Catun tua-i arucugngaluku."
        },
        "49": {
            "start": 496.0,
            "end": 506.3,
            "transcript": "Tamakut iliini mikelngumi iqmiuquniki, tamakut tamatum-ll' iliini qanri wii-am tuaten umyuarteq'lartua,"
        },
        "50": {
            "start": 506.3,
            "end": 519.48,
            "transcript": "battery-q maqerrlullrukuni iqmiullrukuniu, qanra tua-i call'aqerlaryukluku iliini pilaranka."
        },
        "51": {
            "start": 519.48,
            "end": 523.24,
            "transcript": "Mmm."
        },
        "52": {
            "start": 523.24,
            "end": 539.44,
            "transcript": "Makut maani aturtut makut piciatun neq', imkut-llu enrilnguat, uqvigpagnek-wa pilaqait, neqnun-llu initauyugngaluteng."
        },
        "53": {
            "start": 539.44,
            "end": 553.16,
            "transcript": "Tau͡gaam imkut cali-am assilriit tang kiarrluki kepugluki tamakut neq', qer'at imkut neqet inivigkaitnek yuarluni nalqinraraitnek,"
        },
        "54": {
            "start": 553.16,
            "end": 561.2,
            "transcript": "engelqing', iqtukata-llu tua-i tuaten tamakut napat neqnek kinercirissuutekat."
        },
        "55": {
            "start": 561.2,
            "end": 567.86,
            "transcript": "Tuamta-llu cali puyurcivigmi qukakun algungqelaami cali menglii-llu."
        },
        "56": {
            "start": 567.86,
            "end": 577.48,
            "transcript": "Tua-i itertat teveqsugngaluteng tamakut nalqilriit tau͡gaam enrilnguat."
        },
        "57": {
            "start": 577.48,
            "end": 582.54,
            "transcript": "Nani, makut-llu avguliyagaat [?] pilai assillilriit."
        },
        "58": {
            "start": 582.54,
            "end": 587.88,
            "transcript": "Qeltairluki-llu atam avguliyagaat imkut, qeltairluki."
        },
        "59": {
            "start": 587.88,
            "end": 596.96,
            "transcript": "Kingqenrirtut. Qeltair' kingqan uqiggerpak piaq', uqiggenrateng piaqluteng qeltairluki kinerciqerluki."
        },
        "60": {
            "start": 596.96,
            "end": 603.2,
            "transcript": "Puyurcivigmun pagaani neqnun pikluki agarcissuutekluki."
        },
        "61": {
            "start": 603.2,
            "end": 618.86,
            "transcript": "Kingqerigyaaqut tau͡gaam arungaut, makut-am avguliyagaat apeqput makutgun equgniluta arungigtut. Neng'uluteng-llu ping'ermeng arungigtut. Arunginqait makut tamaa-i. Arungigtut."
        },
        "62": {
            "start": 618.86,
            "end": 626.36,
            "transcript": "Tau͡gaam-wa camun aturluki kinqengigtut. Kinqengigtut."
        },
        "63": {
            "start": 626.36,
            "end": 633.24,
            "transcript": "Qetulameng. Qetulameng cali caliaqessiryarluteng."
        },
        "64": {
            "start": 633.44,
            "end": 647.88,
            "transcript": "Tuamta-llu cali makut maa-i napat cali qer'at-llu waten piyugngaluki tua-i patuqerluki wall'u aruvarqiqataquni imkut."
        },
        "65": {
            "start": 647.88,
            "end": 652.04,
            "transcript": "Muriit cali kapuqluki."
        },
        "66": {
            "start": 652.04,
            "end": 661.4,
            "transcript": "Makut-llu tua-i inarqurluki kipullgutaarluki, neqet aruviryugngaluteng."
        },
        "67": {
            "start": 661.4,
            "end": 679.62,
            "transcript": "Wall'u pikailkuni, tamakunek kapurqirraarluni qacarneriskan, maa-i kalikallret wall'u plastic-aanek piqerluku qacarnirluku, smokehouse, ateceteng aturluku aruvarqiyugngalriit."
        },
        "68": {
            "start": 679.62,
            "end": 685.52,
            "transcript": "Tua-i uumun tun'aqa. Cali kankut pivsiaqisiki piyukuniki."
        },
        "69": {
            "start": 685.52,
            "end": 691.3,
            "transcript": "Makut-am una-wa quunarlitun ayuqen', quunarliunrituq."
        },
        "70": {
            "start": 691.3,
            "end": 706.64,
            "transcript": "Quunarlit tau͡gaam wangkuta avani Kuigpagmi uksurqan cap'ilaameng cap'itullermeggni, maa-i-w' call' cap'italriit Kuigpagmi manignarcuutnek."
        },
        "71": {
            "start": 706.64,
            "end": 709.42,
            "transcript": "Aa."
        },
        "72": {
            "start": 709.42,
            "end": 718.96,
            "transcript": "Ca. Waten Kuigpagmi cen'irraarlu' taluyat nunakaitni cikumariaqata qaill' pitariaqan tayim' ciku."
        },
        "73": {
            "start": 718.96,
            "end": 722.86,
            "transcript": "Caputet. (Tutmayumariaqan. Tutmaryuumaqia.) Ii-i. Yaa."
        },
        "74": {
            "start": 722.86,
            "end": 738.98,
            "transcript": "Tua-i cen'ilartut piaken ayagluteng. Qayutun iqtutara' tua-i-w' cikur' mamturingraan taluyat tamaani cikum aciani uitarkaurrluki manignarcuutet."
        },
        "75": {
            "start": 738.98,
            "end": 745.4,
            "transcript": "Una wiinga-w' kingumni waten et'utacia tua-i taluyat uitallerkaat."
        },
        "76": {
            "start": 745.4,
            "end": 751.12,
            "transcript": "Yagneq wavet."
        },
        "77": {
            "start": 751.12,
            "end": 770.12,
            "transcript": "Tau͡gken tamakut tua-i enaayuitait cali-llu imna waten ayuqellriarun'-am cap'ngermi manignat makut picia carrarkun antuut tua-i qerratauralriakun cap'ngermeng."
        },
        "78": {
            "start": 770.12,
            "end": 776.34,
            "transcript": "Tau͡g' manilria yuarluku-am cali ceńarcuuciryarauguq."
        },
        "79": {
            "start": 776.34,
            "end": 787.08,
            "transcript": "Maa-i nemiaranek piyuirucameng chicken wire-aanek wall'u cali imkunek yaassiistengqeyagarluteng taluyat."
        },
        "80": {
            "start": 787.08,
            "end": 795.9,
            "transcript": "Unatellugnarqut tau͡gaam keggsuutegen'gun perequrluki [?] tua-i tuani taluyarpilriani."
        },
        "81": {
            "start": 795.9,
            "end": 798.44,
            "transcript": "Tua-i keggaterrlainauluteng."
        },
        "82": {
            "start": 798.44,
            "end": 804.86,
            "transcript": "Imkut-am cali kiagcuutet taluyatun muriit."
        },
        "83": {
            "start": 804.86,
            "end": 809.62,
            "transcript": "Cali-am ceńarcuutlernek keggacirraarluki."
        },
        "84": {
            "start": 809.62,
            "end": 823.52,
            "transcript": "Tua-i-llu cali qamuit-gguq cali muriit taluyat taukut tungillratun iterrluki."
        },
        "85": {
            "start": 823.52,
            "end": 843.16,
            "transcript": "Tuaggun taluyanek iluliricilriatun qilleqluki. Takuingameng-llu naluamegteki tamakut taluyat kev'ggaarluki amuluki cali angyamun ekluki cayuurluki neqet."
        },
        "86": {
            "start": 843.16,
            "end": 852.82,
            "transcript": "Ingna-llu cali paugluni ilavkungqerran, cali ilavkuneng mayurrluku nutaan neqait tamakut."
        },
        "87": {
            "start": 852.82,
            "end": 854.92,
            "transcript": "Piciatun cali tamakut cangtuut."
        },
        "88": {
            "start": 854.92,
            "end": 857.1,
            "transcript": "Yaa, piciatun pituyaaqut."
        },
        "89": {
            "start": 857.1,
            "end": 867.64,
            "transcript": "Tau͡gaam qagaani wangkuta kuimteńi keggnarnun avuut [?] waten-llu ulqetaam tekicuitellaani kiagungraan-llu."
        },
        "90": {
            "start": 867.64,
            "end": 874.7,
            "transcript": "Tuaten camna waten ayuqlaryaaquq aciatni ilii, ilii terr'a."
        },
        "91": {
            "start": 874.7,
            "end": 881.92,
            "transcript": "Tau͡gaam-am tamakut waten ayuqellriit ayuqeliluki pilarait."
        },
        "92": {
            "start": 881.92,
            "end": 885.74,
            "transcript": "Wall' iliini agiyaurluki maniggluki."
        },
        "93": {
            "start": 885.74,
            "end": 888.64,
            "transcript": "Manigtevkenaki."
        },
        "94": {
            "start": 888.64,
            "end": 890.16,
            "transcript": "- Caputet kep'aqluki. - Waten equgnek."
        },
        "95": {
            "start": 890.16,
            "end": 897.58,
            "transcript": "Equgnek. Tauna waten ayuqellria, waten ayuqliqeskan, taum ngeliinun quk' kapulluku."
        },
        "96": {
            "start": 897.58,
            "end": 902.38,
            "transcript": "Ataam tau͡gken tuaten ayuqngan, ataam tuaten ayuqercan, tua-i cali kapulluku."
        },
        "97": {
            "start": 902.4,
            "end": 909.38,
            "transcript": "Iliit tau͡gken waten manigpak. Manigpak piaqluni."
        },
        "98": {
            "start": 909.38,
            "end": 918.34,
            "transcript": "Carvanirturalriamun tau͡gaam carvanqegturalriamun manignarcuucituut Kuigpagmi."
        },
        "99": {
            "start": 918.34,
            "end": 919.38,
            "transcript": "Carvaneq yuarluku."
        },
        "100": {
            "start": 919.38,
            "end": 923.2,
            "transcript": "Carvanra yua', tukniuralriamun carvanermun."
        },
        "101": {
            "start": 923.2,
            "end": 926.58,
            "transcript": "Tuknailkan neqcurkiciiqut."
        },
        "102": {
            "start": 926.58,
            "end": 933.8,
            "transcript": "Tuknilriamun tau͡gken civveskuvki taluyaten, apeqput wangkuta taluyarpiit."
        },
        "103": {
            "start": 933.8,
            "end": 951.92,
            "transcript": "Una waten ukatmun caumallrat nallaringakan nutaan una kan'a-llu talut kanani civingaqan enluaratni wani allamek equgmek pitangqellartuq."
        },
        "104": {
            "start": 951.92,
            "end": 959.74,
            "transcript": "Tauna cali kitugtaarluku waten nateqvaqaniqaaqluku makekani'iqluku-llu [?]."
        },
        "105": {
            "start": 959.74,
            "end": 969.1,
            "transcript": "Nall'areskuvgu nutaan neqtengareskata tuaten taqluki. Taqluki."
        },
        "106": {
            "start": 969.1,
            "end": 983.3,
            "transcript": "Cali-ll' cikuq iliim mamtulartuq Kuigpagmi, iliini five foot-llu [?] mamtutaaqluni. Allrakut ilaitneng, una-w' nenglan tayim' nasperturluku pilallilriit."
        },
        "107": {
            "start": 983.3,
            "end": 997.44,
            "transcript": "Makut wani tamakut kapurqerraarluki nutaan makunek imkunek uqvigpiagarnek nakercetellrianek cali waten."
        },
        "108": {
            "start": 997.44,
            "end": 1011.48,
            "transcript": "Aqvaqu'urluta aqvataarluteng nutaan-am cali imkunek quunarlinek pitukemteńek, unuamek qanrutkellren, nutaan tamakunek aqvalluteng."
        },
        "109": {
            "start": 1011.48,
            "end": 1027.5,
            "transcript": "Tamakut makut wani uqvigpiyagaat cikum qainganun man'a tamana cuqluku waten ayuqetaallra, cuqluku taktaciluku piliaqluteng."
        },
        "110": {
            "start": 1027.5,
            "end": 1035.76,
            "transcript": "- Una-qaa aturyugan? - No, tauna. - Qanerturaa. - Aturyunritaqa."
        },
        "111": {
            "start": 1035.76,
            "end": 1042.5,
            "transcript": "Tamakut waten piqtaalriit ayuqeliluki piliaqluteng."
        },
        "112": {
            "start": 1042.5,
            "end": 1044.76,
            "transcript": "Taun' taktaciluku."
        },
        "113": {
            "start": 1044.76,
            "end": 1057.46,
            "transcript": "Tamakunek enrilnguanek pirraarluteng, nutaan quunarlinek waten, quunarlinek inarqurluki waten."
        },
        "114": {
            "start": 1057.5,
            "end": 1067.76,
            "transcript": "Ilait-llu naparqurluki pirraarluki aciqliit inarqurluki piaqluki, et'utacia cali cuqeqaarluku."
        },
        "115": {
            "start": 1067.76,
            "end": 1074.76,
            "transcript": "Tua-i tuaten usguqurturluki allanek pilaqluteng kanavet taluyat nunakaatni."
        },
        "116": {
            "start": 1074.76,
            "end": 1079.02,
            "transcript": "Tuaten elliungan, waten ilii waten elliurturatuuq."
        },
        "117": {
            "start": 1079.02,
            "end": 1086.96,
            "transcript": "Ilii-llu waten tua-i ceńamek ayagluni, tua-i-ll' ayuqluni tua-i ak'aki taqluni unavet."
        },
        "118": {
            "start": 1086.96,
            "end": 1094.46,
            "transcript": "- Kunlugem. - Ilii qaguum Kuigpiim marayarrlainaunrituq. Ilii teggalqurrlainauluni pilartuq."
        },
        "119": {
            "start": 1094.46,
            "end": 1102.64,
            "transcript": "Ilii-am kingunemni waten, iliini caputet makut taktuanek pilget cangyuillruut."
        },
        "120": {
            "start": 1102.64,
            "end": 1114.2,
            "transcript": "Imkut tau͡gken taksaaganrilnguum waten-llu uutun cetuluteng pitalalriit ceńamek tua-i kanavet cangyunrungaataqluteng wangni."
        },
        "121": {
            "start": 1114.2,
            "end": 1120.62,
            "transcript": "Carvanra cuqequrluku qagaani pituut nunami."
        },
        "122": {
            "start": 1120.62,
            "end": 1135.8,
            "transcript": "Taluyat wangkuta kingunemteńi kiani Akiarmi taluyat nek'arcuagaqamegteki au͡gna enrilnguayaarraq ukiqaarluku carvanermek yuatuut."
        },
        "123": {
            "start": 1135.8,
            "end": 1146.5,
            "transcript": "Tua-i-llu iliini carvanirciqngalngermi tauna imna kaputellrani tua-i uitaluni."
        },
        "124": {
            "start": 1146.5,
            "end": 1148.48,
            "transcript": "Quunirluni tua-i."
        },
        "125": {
            "start": 1148.48,
            "end": 1158.12,
            "transcript": "Tua-i-llu imna-am kaputellra tamana carvanengqerqan kapulluku pikuni peggluku."
        },
        "126": {
            "start": 1158.12,
            "end": 1169.52,
            "transcript": "Tua-i-llu camani carvanrem tekiskani una, ellii, carvanrem camna, carvanrem cinguulriatun qiivvluku."
        },
        "127": {
            "start": 1169.52,
            "end": 1175.24,
            "transcript": "Iliini qiivyatarrarnek [?] qacuurtugu [?], tua-i waten elliurturalria tamaa-i assirtuq."
        },
        "128": {
            "start": 1175.24,
            "end": 1183.74,
            "transcript": "Yaa, assiryaquq. Tau͡gaam-am carvanra kayututatekenrituq. (Kayussiyaagtuq.) Maancetun ayuqenrituq Kuigpak."
        },
        "129": {
            "start": 1183.74,
            "end": 1194.28,
            "transcript": "Ilii caputem tamakut caputet ilait ellingermeng carvanem nerurrluku. (Nerurrluku.) Camna cat qerratarrluku."
        },
        "130": {
            "start": 1194.28,
            "end": 1205.26,
            "transcript": "Cali caliaqsaraugut tamakut waten nerurtaq ak'a [?] allanek piliqerluteng tauna capluku."
        },
        "131": {
            "start": 1205.26,
            "end": 1211.3,
            "transcript": "Manignaat makut arcaqerqata qagaani Kuigpagmi ceńakun pituyaaqut."
        },
        "132": {
            "start": 1211.3,
            "end": 1215.16,
            "transcript": "Ceńaliuryunqessiyaagtut."
        },
        "133": {
            "start": 1215.16,
            "end": 1220.74,
            "transcript": "Pingna tua-i keluseng qelpaqayunaunaku [?] pilartut."
        },
        "134": {
            "start": 1220.74,
            "end": 1229.54,
            "transcript": "Tua-i qelpacuaqerqan carvanrem ayuarcaku [?] tua-i tumyaraqluku tauna."
        },
        "135": {
            "start": 1229.54,
            "end": 1243.36,
            "transcript": "Tamakut quunarlit tamakunek qillerqurluki watua, ilait watua, qemkunrunarcianek [?] piyaurtut. Piyaurtut."
        },
        "136": {
            "start": 1243.36,
            "end": 1250.1,
            "transcript": "Man'a apqen chicken wire-aq Kuigpagmi piksunaituq."
        },
        "137": {
            "start": 1250.1,
            "end": 1256.64,
            "transcript": "Neqesngaituten tamakucimek capucirluteng taluya' manignarcuuciquten."
        },
        "138": {
            "start": 1256.64,
            "end": 1260.76,
            "transcript": "- Umyuan ngelkarrluku [?] neqesngaituten. - Assiitut."
        },
        "139": {
            "start": 1260.76,
            "end": 1272.84,
            "transcript": "Neqesngaituten. Neptuut-gguq. Neptuut. Neptuut tamakut chicken wire-aat caputekluki Kuigpagmi. Neptuut-gguq."
        },
        "140": {
            "start": 1272.84,
            "end": 1279.78,
            "transcript": "Nepiit niilluku manignat neqem pisciigatut."
        },
        "141": {
            "start": 1279.78,
            "end": 1283.7,
            "transcript": "Waten ayuquq qag' [?] Kuigpak."
        },
        "142": {
            "start": 1283.7,
            "end": 1289.04,
            "transcript": "Wangkuta-wa qaillun iq'lin."
        },
        "143": {
            "start": 1289.04,
            "end": 1298.76,
            "transcript": "Tamakunek makucinek nalqilrianek enrilnguanek nemiarraarluta qaill' tayim' tua-i takluki wall'u yagenreg' malruugaqragnek."
        },
        "144": {
            "start": 1298.76,
            "end": 1310.78,
            "transcript": "Imkunek au͡gkunek enrilnguayaarnek nalqilrianek-am cali qilleqluki tamakut imkut makut nemiarat caputet."
        },
        "145": {
            "start": 1310.78,
            "end": 1326.86,
            "transcript": "Kanaggun qillerrluku wall'u imkutgun nemiarutetgun nallaitgun qillertaqluki ilii-llu cetamaugaqluteng qillrutat tamakut kalvagutet."
        },
        "146": {
            "start": 1326.86,
            "end": 1344.52,
            "transcript": "Cali-am takyaarluteng tamakut caputet ceń'ermun tuavet. Imkut-am cali nayumiqastekait muriit, qaillun ellegtelriit, tua-i asvailngalnguaraat kapurqerraarluki ciumek."
        },
        "147": {
            "start": 1344.52,
            "end": 1354.58,
            "transcript": "Nutaan-llu tua-i tamakut imkut kalvagutet qillrulluki tuavet pilarait."
        },
        "148": {
            "start": 1354.58,
            "end": 1360.44,
            "transcript": "Amitessiyaalrianek pingqessunaitut qagaa-i Kuigpagmi."
        },
        "149": {
            "start": 1360.44,
            "end": 1362.96,
            "transcript": "Asvarutengqessunaunateng. [?]"
        },
        "150": {
            "start": 1362.96,
            "end": 1374.24,
            "transcript": "- Imkut. - Carvaneq waten up'nerkaryarneret [?] takliriaqata carvaneq kayungturiaqan pilartut."
        },
        "151": {
            "start": 1374.26,
            "end": 1387.58,
            "transcript": "Qamani kingunemni imna-am cali qau͡gyaq. Nerurcugtut tamaani qau͡gyaq camna tau͡gaam imna qiku."
        },
        "152": {
            "start": 1387.58,
            "end": 1389.84,
            "transcript": "Nepsaqellria marayaq."
        },
        "153": {
            "start": 1389.84,
            "end": 1393.88,
            "transcript": "Tua-i tamaa-i tamakut taluyat ceńarcuutet nekaat."
        },
        "154": {
            "start": 1393.88,
            "end": 1402.98,
            "transcript": "Tua-i pituyaaqut qagaani ilii Kuigpiim tamakunek marayamek piitelartuq ceńarcuucirquneng ilait."
        },
        "155": {
            "start": 1402.98,
            "end": 1404.92,
            "transcript": "Piitelartuq ilii teggalqum."
        },
        "156": {
            "start": 1404.92,
            "end": 1409.22,
            "transcript": "Kayurtukayiimi-wa. [?]"
        },
        "157": {
            "start": 1409.22,
            "end": 1417.28,
            "transcript": "Ak'a cuptullermini Kuigpak alingnarqetullruuq up'nerkami cikur' ayagaqami."
        },
        "158": {
            "start": 1417.28,
            "end": 1419.78,
            "transcript": "Qanikcam-wa mer'em. Mel'ir'."
        },
        "159": {
            "start": 1419.78,
            "end": 1432.64,
            "transcript": "Tua-ll' ingrikun cikuq mayurqainauluni tuskuni, ingrikun mayurkauluni, mayurpakar' una-ll' quigiqerluni nayimlluni iggluni nunamun."
        },
        "160": {
            "start": 1432.64,
            "end": 1437.82,
            "transcript": "Ingrim qainganun iggluni. Ingriq qertungraan mayuryuungaa ciku."
        },
        "161": {
            "start": 1437.82,
            "end": 1443.1,
            "transcript": "Qayutun mamtutang' una, four, five foot-llu mamtutangermi mayuryuungaa."
        },
        "162": {
            "start": 1443.1,
            "end": 1448.7,
            "transcript": "Cik' Kuigpak tugeskuni cikum cupnginanrani."
        },
        "163": {
            "start": 1448.7,
            "end": 1452.92,
            "transcript": "Watua tau͡gaam tuaten piyuiruq. Piyuirutuq."
        },
        "164": {
            "start": 1452.92,
            "end": 1454.92,
            "transcript": "Qanikcangqerrsuirucan."
        },
        "165": {
            "start": 1454.92,
            "end": 1460.92,
            "transcript": "Imucetun ayuqenran [?] qanikcarpagaluni piyuirucan."
        },
        "166": {
            "start": 1460.92,
            "end": 1466.92,
            "transcript": "Cup'aqami-llu up'nerkaq-llam cup', urug', cupenrituq, urugluni Kuigpak nangluni."
        },
        "167": {
            "start": 1466.92,
            "end": 1469.86,
            "transcript": "- Cikuirluni. - Kusquqvagmi-llu tuaten pillruuq."
        },
        "168": {
            "start": 1469.86,
            "end": 1473.74,
            "transcript": "Atqaniraluni kiituan nang'uq cupuciinani."
        },
        "169": {
            "start": 1473.74,
            "end": 1480.56,
            "transcript": "Cupevkenani. Equgmek-llu pivv' [?] cikut aprunateng, aprunateng [?]."
        },
        "170": {
            "start": 1480.56,
            "end": 1486.62,
            "transcript": "Imaicimallruuq cikuirutngermi ak'anun, ak'anun."
        },
        "171": {
            "start": 1486.62,
            "end": 1493.34,
            "transcript": "Tua-i makut tuaten caputektuut qagaani Kuigpagmi. Caputeklarait."
        },
        "172": {
            "start": 1493.34,
            "end": 1500.92,
            "transcript": "Maa-i-am tau͡gken ataam alakngamegteki makunek enrilnguayaagngekumki [?] takellriatun [?] nakercetellrianek."
        },
        "173": {
            "start": 1500.92,
            "end": 1506.92,
            "transcript": "- Ussuk'. Kass'at pingata ussukcanek tau͡gaam. - Nemiaruarpek'naki."
        },
        "174": {
            "start": 1506.92,
            "end": 1510.0,
            "transcript": "Ii-i, ussukcat nurnairucata."
        },
        "175": {
            "start": 1510.0,
            "end": 1515.98,
            "transcript": "Tamakunek piluteng akultuvkenaki piaqluteng."
        },
        "176": {
            "start": 1515.98,
            "end": 1518.62,
            "transcript": "Waten akulkutaluki, uumek."
        },
        "177": {
            "start": 1518.62,
            "end": 1528.9,
            "transcript": "Tua-i ussukcauqurluki tau͡gaam makunek quunarlinek cali amllenrilengraata aciqvar' man'a alla avuqaqluku."
        },
        "178": {
            "start": 1528.9,
            "end": 1535.26,
            "transcript": "Avuqaqluku waten amllenrilengraata. Avuqaqluki."
        },
        "179": {
            "start": 1535.26,
            "end": 1539.72,
            "transcript": "Enaiyuitait au͡gkut waten yagneq wavet."
        },
        "180": {
            "start": 1539.72,
            "end": 1544.06,
            "transcript": "Enaissiyaayuitai entengraan Kusquqvak."
        },
        "181": {
            "start": 1544.06,
            "end": 1548.28,
            "transcript": "- Kuigpak-llu-wa, qaillun Kuigpagmi-wa-am malrugnek. - Kuigpagmi."
        },
        "182": {
            "start": 1548.28,
            "end": 1552.76,
            "transcript": "Iliini pingayunek-llu yagnernek et'utalartuq."
        },
        "183": {
            "start": 1552.76,
            "end": 1562.18,
            "transcript": "Tau͡gaam waten taum qagaani manignarcuutet aciqliuluki elliyugngaluki."
        },
        "184": {
            "start": 1562.18,
            "end": 1573.04,
            "transcript": "Tua-i-llu imkut makut neqait piciatun luqruuyiit neqyagaat cangtauyugngaluteng qaingitni."
        },
        "185": {
            "start": 1573.04,
            "end": 1579.7,
            "transcript": "Tuaten pilalleq. Niigartelartan tuaten-qaa tamakut pilarait?"
        },
        "186": {
            "start": 1579.7,
            "end": 1581.14,
            "transcript": "Qalliqellrialirluku."
        },
        "187": {
            "start": 1581.14,
            "end": 1587.64,
            "transcript": "Qalliqellriit qalliqellrianek pitullruyaaqut ak'a."
        },
        "188": {
            "start": 1587.64,
            "end": 1598.8,
            "transcript": "Tua-i neqtaqluteng manignarnek, makunek-llu apqemteńek cii, ciissuuciqatarqameng malruinek qalliqellrianek pitullruut."
        },
        "189": {
            "start": 1598.8,
            "end": 1606.98,
            "transcript": "Capluki, takrarluki [?]."
        },
        "190": {
            "start": 1606.98,
            "end": 1611.08,
            "transcript": "Ciissuuciinek neqsugaqameng manignarnek auluki."
        },
        "191": {
            "start": 1611.08,
            "end": 1617.6,
            "transcript": "Tamakucinek qalliqellriat pairteqluki waten."
        },
        "192": {
            "start": 1617.6,
            "end": 1623.48,
            "transcript": "Ukut wani asguqliit uatmun caulluki carvaneq tunulluku."
        },
        "193": {
            "start": 1623.48,
            "end": 1628.8,
            "transcript": "Ukut-llu aipait pairtait asgutmun caulluku, carvaneq caulluku."
        },
        "194": {
            "start": 1628.8,
            "end": 1635.7,
            "transcript": "Qalliqellrani-llu ilait cetamainek-llu, cetamainek-llu pingqetullruut."
        },
        "195": {
            "start": 1635.7,
            "end": 1642.92,
            "transcript": "Tua-i luqruuyiit nunamteńi pissiyaaglanritut. Pissiyaayuitut."
        },
        "196": {
            "start": 1642.92,
            "end": 1650.14,
            "transcript": "Uksuarmi tang uksuakackami [?] kuvyakun piqcuaqerluteng [?] tayima ataam tamatuut."
        },
        "197": {
            "start": 1650.14,
            "end": 1657.48,
            "transcript": "Tau͡gaam makut manignaat ciit-llu cingqetullrani qalliqellrianek taluyarcirluki pituut."
        },
        "198": {
            "start": 1657.48,
            "end": 1666.8,
            "transcript": "Taumek iliini tut'ulriamun piluki qalliqell' anglartut taluyait qagaani Kuigpagmi. Anglartut."
        },
        "199": {
            "start": 1666.8,
            "end": 1673.48,
            "transcript": "Nemiarat-wa nemiarluki pitullermeggni au͡gkut makut-llu can'giircuutet."
        },
        "200": {
            "start": 1673.48,
            "end": 1679.14,
            "transcript": "Taum ilulirait angluki waten yaassiinqepagluki."
        },
        "201": {
            "start": 1679.14,
            "end": 1687.3,
            "transcript": "Up'nerkami tugnerrilriani-am cali calirpagyarauguq, ciklakun, ciklakun."
        },
        "202": {
            "start": 1687.3,
            "end": 1694.36,
            "transcript": "Qaliraggluku tua-i iliini-llu tua-i waten mamtutaaqluni ciku."
        },
        "203": {
            "start": 1694.36,
            "end": 1697.38,
            "transcript": "Ukiluni-llu wavet."
        },
        "204": {
            "start": 1697.38,
            "end": 1707.82,
            "transcript": "Atam Kuigpagmi iliini cikuliurutem, pu' [?] iliini taklartuq ilii three fathom-llu pit'aqluni."
        },
        "205": {
            "start": 1707.82,
            "end": 1717.7,
            "transcript": "Mamtuaqan ciku five foot cipluku pitaaqan kangrakun teguluku ukitengnaqu'urlaraat camna."
        },
        "206": {
            "start": 1717.7,
            "end": 1722.36,
            "transcript": "Uk'iqercan-llu tua-i tuaggun ayuqurluku."
        },
        "207": {
            "start": 1722.36,
            "end": 1730.92,
            "transcript": "Imkutgun-llu kass'artarteggun, (Pick?), pick yaa, ceń'ar' man'a caliaqluku."
        },
        "208": {
            "start": 1730.92,
            "end": 1740.78,
            "transcript": "Uk'iqercaaqevkenaku mamkellicarturluku im' keputetun ayuqut. Keputetun ayuquq cikuliur' una."
        },
        "209": {
            "start": 1740.78,
            "end": 1746.92,
            "transcript": "Maa-i watua Kass'at pingata chainsaw-tgun piyaurtellriit mamtuaqan."
        },
        "210": {
            "start": 1746.92,
            "end": 1760.82,
            "transcript": "Aissuq [?] man'a, 20 foot I mean 20 inches pitaaqan taktaciluku blade-aa, cikur' atam kegglarciryartuq man'a luku cikuq."
        },
        "211": {
            "start": 1760.82,
            "end": 1764.0,
            "transcript": "Kegglarluku au͡g'aqluku."
        },
        "212": {
            "start": 1764.0,
            "end": 1766.3,
            "transcript": "- Chainsaw. - Tevagluku ciumek."
        },
        "213": {
            "start": 1766.3,
            "end": 1770.3,
            "transcript": "Chainsaw-m blade-aa taktaciluku."
        },
        "214": {
            "start": 1770.3,
            "end": 1772.58,
            "transcript": "- Man'a piaqluku. - Cikum-qaa [?] ayagtelluku."
        },
        "215": {
            "start": 1772.58,
            "end": 1776.6,
            "transcript": "Ataam-llu atam yassiinrem [?] cali inglukaat piluku."
        },
        "216": {
            "start": 1776.6,
            "end": 1780.16,
            "transcript": "Nutaan tamakut pirraarluku cikuliurutgun."
        },
        "217": {
            "start": 1780.16,
            "end": 1782.16,
            "transcript": "Usserqelluku."
        },
        "218": {
            "start": 1782.16,
            "end": 1787.36,
            "transcript": "Angluki-llu piaqluki tamakut mamtuaqan."
        },
        "219": {
            "start": 1787.36,
            "end": 1799.34,
            "transcript": "Mamkilan tau͡gken imkut makut 18 inch-arraat mamturivailgan nalqerruqapiartut [?] tamakut mermun tekitellranun."
        },
        "220": {
            "start": 1799.34,
            "end": 1804.22,
            "transcript": "Cukanrartut atam chainsaw-t makut cikussuutekluki."
        },
        "221": {
            "start": 1804.22,
            "end": 1809.6,
            "transcript": "Ekuliuruteksaurtait watua tamakut tua-i maa-i Kuigpagmi."
        },
        "222": {
            "start": 1809.6,
            "end": 1814.32,
            "transcript": "Kuvyilriit-llu tua-i aturluku icugg' eniaqluteng."
        },
        "223": {
            "start": 1814.32,
            "end": 1822.24,
            "transcript": "Maa-i-am cali tanglangua imkunek can'giirissuutnek massiinalegnek pikaggun."
        },
        "224": {
            "start": 1822.24,
            "end": 1833.2,
            "transcript": "Ayagceqaarluki tua-i-llu cikum qainganun massiinaq una ayagluni qipuuryaraq."
        },
        "225": {
            "start": 1833.2,
            "end": 1840.12,
            "transcript": "Ayagarceqaarluku tua-i elliluku atrarrluku."
        },
        "226": {
            "start": 1840.12,
            "end": 1843.68,
            "transcript": "Qagaani-am manarcuteklarait tamakut man'a."
        },
        "227": {
            "start": 1843.68,
            "end": 1844.9,
            "transcript": "Manarcuuteki?"
        },
        "228": {
            "start": 1844.9,
            "end": 1848.74,
            "transcript": "Cukicissuutet cikunek."
        },
        "229": {
            "start": 1848.74,
            "end": 1852.92,
            "transcript": "Manaryarcuuteklarait-gguq qagaa-i tamakut."
        },
        "230": {
            "start": 1852.92,
            "end": 1856.42,
            "transcript": "Aren cat tamarmi qacignariami ilii."
        },
        "231": {
            "start": 1856.42,
            "end": 1863.2,
            "transcript": "Tamakut massiinaq ayagarrluku cikum qainganun cikumun kapulluki anluiluteng tua-i."
        },
        "232": {
            "start": 1863.2,
            "end": 1871.92,
            "transcript": "Ekian-llu allamun tua-i allam aturyar' [?] tunluku tua-i-llu manarluteng tuani."
        },
        "233": {
            "start": 1871.92,
            "end": 1874.4,
            "transcript": "Tua-i-gguq yuuk qanerkairutellrianga."
        },
        "234": {
            "start": 1874.4,
            "end": 1880.92,
            "transcript": "Wiinga-llu tua-i-am caciryarait amllerrsaaqut makut wani. Ilait nalluanka."
        },
        "235": {
            "start": 1880.92,
            "end": 1890.66,
            "transcript": "Nalluanka makut ilait qanruteksungramki. Wii atuqaqsaitellrenka tangerqaqsaitellrenka-ll' qanrutkesciigatenka."
        },
        "236": {
            "start": 1890.66,
            "end": 1897.06,
            "transcript": "Wiinga au͡gkut kaviqsugnek pilalten naumalartut nunani."
        },
        "237": {
            "start": 1897.06,
            "end": 1899.92,
            "transcript": "Uqviagnek piaqluki."
        },
        "238": {
            "start": 1899.92,
            "end": 1904.84,
            "transcript": "Atuuqallit kiingita apertuqa'aqerlaki kanani. (Ii-i.)"
        },
        "239": {
            "start": 1904.84,
            "end": 1918.24,
            "transcript": "Man'a maa-i uqvigaukuni, nauwa avani kanaqlagcutullemteńi apqiitnek anyuullingraan [?] eglertengnaqaqamta."
        },
        "240": {
            "start": 1918.24,
            "end": 1932.06,
            "transcript": "Makucit maqvigaat kangrit kipulketaaruarrluki, iquit-wa qillerrluki tangluqengnaqlallruaput muruyailkutengnaq-llu aniullugmi."
        },
        "241": {
            "start": 1932.06,
            "end": 1934.34,
            "transcript": "- Qanikcaq-wa. - Qetuliaqan."
        },
        "242": {
            "start": 1934.34,
            "end": 1936.82,
            "transcript": "Yaa, qetungartaqan."
        },
        "243": {
            "start": 1936.82,
            "end": 1939.8,
            "transcript": "Tuaten tua-i apenrit qavtegengu [?] au͡gna."
        },
        "244": {
            "start": 1939.8,
            "end": 1952.8,
            "transcript": "Cali-llu caputekaitaqamta-w' tua-i can'giircuutet-llu kapuqluki waten kipullegtaulluki amlletulriani piaqamta."
        },
        "245": {
            "start": 1952.8,
            "end": 1954.98,
            "transcript": "Paluqtaat im' nurnallrat."
        },
        "246": {
            "start": 1954.98,
            "end": 1958.04,
            "transcript": "Maa-i tua-i paluqtaq tangenrakun [?]."
        },
        "247": {
            "start": 1958.04,
            "end": 1965.92,
            "transcript": "Nuniitni paluqtat tuatnaumal' uitasciigatelliniut. (Uitangait'.) Au͡g'ar' nerluki. Eniit au͡g'arluki."
        },
        "248": {
            "start": 1965.92,
            "end": 1969.04,
            "transcript": "Nerciqait nangluki."
        },
        "249": {
            "start": 1969.04,
            "end": 1975.125,
            "transcript": "Au͡gkut ava-i uqvigaata cuyaqsuit tuaten unani atuuqalartut."
        }
    },
    "5IgeHRWZ2dw": {
        "1": {
            "start": 15.48,
            "end": 24.8,
            "transcript": "Tua-llu tua-i nutaan uumun kuvyacuamun apqiitnun piqatartua, kuvyacuamun."
        },
        "2": {
            "start": 25.88,
            "end": 36.15,
            "transcript": "Neqet angtatkenrilata unani kingunemni ellangvimni imarpinrarcuuciaqameng-gguq"
        },
        "3": {
            "start": 36.15,
            "end": 48.65,
            "transcript": "uumek waniwa taktacililaraat negaqeggutii uum cuqminek uumek imarpinrarcuucikuni."
        },
        "4": {
            "start": 48.65,
            "end": 62.013,
            "transcript": "Tua-i-llu negaa qaill' angtaqaquni, tua-i-gguq ang'urangermi ukunun ag'arrluni pitauyugngaciqngan mikellra"
        },
        "5": {
            "start": 62.013,
            "end": 72.938,
            "transcript": "anyugngarinrilkurrluku imarpinrarcuun tuaten tua-i negaqeggutekiularaat apeqmeggnek."
        },
        "6": {
            "start": 74.43,
            "end": 76.338,
            "transcript": "Tua-i-llu cali,"
        },
        "7": {
            "start": 76.338,
            "end": 88.66,
            "transcript": "(Tamatum-qaa imarpinrarcuutem kuvyam qaillun taktacirkaanek-llu pituut, negaa, iciw' waten taktacirkaanek.)"
        },
        "8": {
            "start": 88.66,
            "end": 92.863,
            "transcript": "Taktacirkaanek cuqtaituq qanemciugaqami."
        },
        "9": {
            "start": 92.863,
            "end": 106.988,
            "transcript": "Yuum, yuum pikangqerrutacirrani aturluku, yagenret-llu-gguq pingayun tua-i amllertut imarpinrarcuutem wall'u talliman yagenret."
        },
        "10": {
            "start": 107.5,
            "end": 122.29,
            "transcript": "Iciw' tua-i maa-i ca qemangqaaqekvut amllertatkevkenaku amlleriluku piyungramteggu nuqlitellriani amllerisciiganani taun' qemangqaarput amllerciiganani."
        },
        "11": {
            "start": 122.3,
            "end": 136.475,
            "transcript": "Taumek tamaa-i kuvyam tuaten taktacirkaanek cuqnguluku qanelriamek niicuitua. Waten tau͡gaam tua-i pikangqerrutacirrani cuqluku."
        },
        "12": {
            "start": 136.475,
            "end": 149.7,
            "transcript": "Yagneruaraat-llu-gguq ukut pingayun amllertut. Ilumun amllertut. Neq'legmi civingakuni yagenret pingayuungermeng, family-q neqkangyugngauq."
        },
        "13": {
            "start": 150.1,
            "end": 165.013,
            "transcript": "Tua-i-gguq takelrianek kuvyang' tamaa-i qilagturluteng piaqameng takellriamek kuvyalget talliman-gguq ukut yangenret cipepakayuitai."
        },
        "14": {
            "start": 165.013,
            "end": 177.475,
            "transcript": "Cali-llu imkut mesh-ait, negait, akimiarmek-gguq tua-i una arvitmun iqtutacia negalek,"
        },
        "15": {
            "start": 178.05,
            "end": 189.638,
            "transcript": "tua-i-gguq tauna fifteen mesh. Tua-i-gguq tauna tuar' angraan ayuqluku picugngauq."
        },
        "16": {
            "start": 189.638,
            "end": 201.413,
            "transcript": "Tua-i taumek tang au͡gkut anguqallrenka kuvyayarraarluteng apeqmeggnek kuvyacuameggnek iniiqa'u͡rluraqameng,"
        },
        "17": {
            "start": 201.413,
            "end": 208.46,
            "transcript": "tamakut tamaa-i fifteen mesh-aulalliut, qaillun iqtutaurluteng tapingayagarluteng,"
        },
        "18": {
            "start": 208.56,
            "end": 218.8,
            "transcript": "qalirnerita qemiita aciita-llu waten tap'arrluku piaqaceteng kuvyarrait qaill' iqtutauryaaqnaurtut."
        },
        "19": {
            "start": 218.8,
            "end": 228.75,
            "transcript": "Amta-llu tua-i iliini apqemeggnek anguluaqerluteng tekitaqluteng, neqluteng."
        },
        "20": {
            "start": 228.75,
            "end": 237.013,
            "transcript": "Ellait-llu cipcugngakuneng payuguteksugngaluki cipnguteng keniryuumilrianun."
        },
        "21": {
            "start": 239.06,
            "end": 255.613,
            "transcript": "Tua-i tamaa-i tua-llu cali taryarvagcuutmek pikuneng kana-i kan'a imegglugneq cuq'liluteng waten."
        },
        "22": {
            "start": 255.613,
            "end": 267.425,
            "transcript": "Ellaita cali pililriit cuqmeggnek. Tua-i tauna waken ayagluku pikuni, negaq qaill' taktaarkauluni, taryaqvak napcugngaarkauluni."
        },
        "23": {
            "start": 268.125,
            "end": 281.613,
            "transcript": "Makut maa-i imegglugnerrateng aturluki, tuarpiaq ingcissaqluki measurer-aqluki calituluteng."
        },
        "24": {
            "start": 281.613,
            "end": 290.388,
            "transcript": "Tua-i-am qilagluteng piut, taryarvagcuun tamana tua-i taryaqviim napcugngavikluku."
        },
        "25": {
            "start": 291.7,
            "end": 300.588,
            "transcript": "Wiinga taum yualuarnek pilriit kingu'urtellruanka ataucimek yualuarmek qilalriamek tangellruyaaqua kuvyiluni."
        },
        "26": {
            "start": 300.588,
            "end": 313.863,
            "transcript": "Tau͡gaam wiinga au͡gkut tangerqenganka pelacinagtangenrakun piameng pelacinagnek taum qilalallruut imkunek tamakunek ilaita yualukanek pitukaitnek."
        },
        "27": {
            "start": 313.863,
            "end": 320.725,
            "transcript": "Tua-llu cali taqukassuucilriamek makunun,"
        },
        "28": {
            "start": 321.413,
            "end": 335.338,
            "transcript": "taqukanun apqemteńun imarpigmiutarnun, cetuanun, maklagnun, canun maklaarnun pikiurcuucilriit qanemciaqameng."
        },
        "29": {
            "start": 335.338,
            "end": 344.696,
            "transcript": "Una waniwa cali, elliin tua-i yuum cuqni. Wavet tua-i-gguq taqukassuutem negaqeggutiin cuqii."
        },
        "30": {
            "start": 344.696,
            "end": 353.063,
            "transcript": "Tua-i-am amllertatminek ilakuni, ak'akika qamirvaurrangermi cali taqukaq napcugngalliniluni."
        },
        "31": {
            "start": 353.763,
            "end": 371.863,
            "transcript": "Tua-i-am cali makut uksumi tamaa-i nutgitlermeggni taqukassuuciateng civteqatarqamegteki waken tua-i mer'em ngeliinek,"
        },
        "32": {
            "start": 373.563,
            "end": 389.838,
            "transcript": "anerneteng nucuggaarluku aneryaaqsaunateng kelutmurtetulliniut piyualuteng epsalnguqeskuneng-llu arulaiquneng nutaan tugerluteng, kuvyaseng tamana civivigkiurluku."
        },
        "33": {
            "start": 389.838,
            "end": 407.763,
            "transcript": "Tua-i-gguq anernerteng cuqyutekluku ellaita. Taqukaq cikum acianun itqan tagnguartelluku utercungllerkaa tamaaken tayim' cuqluku civcilallilriit."
        },
        "34": {
            "start": 408.213,
            "end": 417.978,
            "transcript": "Tuaten-am cali tua-i taqukassuutnek wagg'uq tuami uksuuluku civciaqameng,"
        },
        "35": {
            "start": 417.978,
            "end": 430.261,
            "transcript": "tua-i anernerteng cuqekluku temetmurtellininaurtut tua-i-llu-gguq epsalnguqeskuneng, tugerluteng taukuviateng civivigkiurluki."
        },
        "36": {
            "start": 430.543,
            "end": 442.12,
            "transcript": "Nutaan tau͡gken cali kiaguluku civciqataquneng, apqiitnek makut agtuinret."
        },
        "37": {
            "start": 443.609,
            "end": 454.511,
            "transcript": "Mat'um nunamek kanarluni kuigmun unavet ketvanun etgatenrilnguut, agtuinernek pituit."
        },
        "38": {
            "start": 454.511,
            "end": 462.9,
            "transcript": "Mat'um kuinran mallgeskiinek ceńaq, agtuinermek tua-i. Tuavet call' tua-i tamana kuvya,"
        },
        "39": {
            "start": 463.838,
            "end": 469.283,
            "transcript": "civtetulliniluku agtuinernun tamakunun."
        },
        "40": {
            "start": 469.283,
            "end": 482.359,
            "transcript": "Tua-i pikangqerraqami maklaungermi, cetuarung'ermi, nayiungermi, amirkaungermi pit'ulliniluteng."
        },
        "41": {
            "start": 482.359,
            "end": 488.675,
            "transcript": "Makut-am issurinek pitukait napqurayuitut-gguq kuvyanun."
        },
        "42": {
            "start": 489.688,
            "end": 501.098,
            "transcript": "Tua-i-w' tua-i mecikumiimegteki pilallikait. Tamakut-am napqurayuitniluki pinaurait issurit."
        },
        "43": {
            "start": 501.098,
            "end": 512.022,
            "transcript": "Wii waniwa yuucimni kuvyakngellruunga issuri', uinagnek malrugnek, cetuaq-wa, amirkaq-wa."
        },
        "44": {
            "start": 512.022,
            "end": 519.288,
            "transcript": "Kuvyamkun tamaa-i taukunek yuuqallemni pitellruunga wii ukanirpak."
        },
        "45": {
            "start": 520.513,
            "end": 527.467,
            "transcript": "Tua-i quyanaqnaurtuq kuvyamun nap'artellria."
        },
        "46": {
            "start": 527.467,
            "end": 532.457,
            "transcript": "Tua-i ava-i au͡gna kuvyam tungiinun qaqicugnarqaqa."
        },
        "47": {
            "start": 532.457,
            "end": 543.038,
            "transcript": "Cali tau͡gaam makut-wa kuvyat avani murilkenarqellruut nylon-aurpailegmeng."
        },
        "48": {
            "start": 543.7,
            "end": 563.543,
            "transcript": "Kuvyat tua-i aturraarluku kinenqegcaararqan tau͡gaam qemagcaraullruuq, mecungcetenrilkurrluku aturnarivailgan arutullruameng imkut nylon-aarunrilnguut pelaciniit ciuqliit."
        },
        "49": {
            "start": 563.543,
            "end": 573.975,
            "transcript": "Au͡gkut-llu cali elngurlinek apqaitnek, elngulriit au͡gkut elngung'ermeng nylon-aarunrilnguut kuvyaqarraqelallrit."
        },
        "50": {
            "start": 574.175,
            "end": 589.087,
            "transcript": "Nylon-aaruvkenateng elngurlinek tau͡gaam aprumaluteng arutumillruameng tamakuungermeng cali atuqatanrilngurni kinerterrlainaasqumalriaruluteng,"
        },
        "51": {
            "start": 589.087,
            "end": 598.663,
            "transcript": "aturpek'nateng-am mecungura'arqameng elnguirucetetulliniameng tamakut nylon-aarunrilnguut wagg'uq makut elngurlit."
        },
        "52": {
            "start": 599.963,
            "end": 601.5,
            "transcript": "Tua-i-wa-qaa?"
        },
        "53": {
            "start": 605.6,
            "end": 607.075,
            "transcript": "(Oh, nuqaq.)"
        },
        "54": {
            "start": 609.663,
            "end": 618.707,
            "transcript": "Wiinga nuqamek piliqaqsaicaaqua, tau͡gaam pililriit tangvatullruanka."
        },
        "55": {
            "start": 618.707,
            "end": 631.113,
            "transcript": "Wangkuta-llu tang piumanaitellemta nalliini pistekamta-gguq makut. Calicuumirluta pitullrulliniamegtekut ikayuryuumirlua."
        },
        "56": {
            "start": 632.538,
            "end": 642.054,
            "transcript": "Wiinga tua-i iliini tuatnastengqetullruunga ikayuryuumirterlua caliqataryaaqaqama."
        },
        "57": {
            "start": 642.054,
            "end": 652.2,
            "transcript": "Wagg'uq tauna ikayuryuumiq'ngelria kangingqerrluni neqkar' tau͡gaam man'a kiimi qagrulriatun ayuqellrani."
        },
        "58": {
            "start": 652.2,
            "end": 667.163,
            "transcript": "Tua-i-gguq tauna pistekarani piskan ellii nerqallerkaarani pitekluku ikayungnaquratullrullinikait ayagyuateng tamaani,"
        },
        "59": {
            "start": 667.163,
            "end": 682.213,
            "transcript": "arnaungermeng angutngung'ermeng tamaa-i tuaten tuvqakqerciuqallerkarteng pitekluku ikayurarkateng ikayungnaquratullrullinikait."
        },
        "60": {
            "start": 682.22,
            "end": 695.402,
            "transcript": "Neqkaar' tau͡gaam man'a kiimi cailkamek unangkengaq neruciullrani. Makunek kipusvillarnek pitaitellrani tamaani."
        },
        "61": {
            "start": 695.402,
            "end": 711.063,
            "transcript": "Wagg'uq tua-i tuvqaqesciuqallerkani pitekluku, taumun ikayuacuumirturluteng pitullruameng. Tuamta-llu neqnertuuralria una,"
        },
        "62": {
            "start": 711.275,
            "end": 730.688,
            "transcript": "angun tekiskan nallunrilkunegteggu nulirra neqlikan ullagluku ikayurluku, kitumek ellimertaileng'ermeng, tua-w' nernirikata taukut tuvqakqallerkani taumun neqautekestiitnun pitekluku."
        },
        "63": {
            "start": 731.313,
            "end": 750.478,
            "transcript": "Neqet-llu makut ayuqenrilameng, meluit makut ilaita neqnguluteng Kass'at whitefish-anek pitukaita, wall'u makut ceturnat."
        },
        "64": {
            "start": 750.478,
            "end": 756.957,
            "transcript": "Amlleriqerluku yuum unakaqaki wagg'uq tenguggait pitekluki"
        },
        "65": {
            "start": 757.9,
            "end": 772.196,
            "transcript": "ikayuucarturnaurtut neqliarinun taum temait pikarkaungraaki. Tenguggii wani elliin pikarkauluku wagg'uq tenguliyarturluni."
        },
        "66": {
            "start": 772.196,
            "end": 788.063,
            "transcript": "Tamaa-i tamakut ikayuutek'luugtaqluki. Tuamta-llu makunek qaurtunek wall'u qassayaarnek amlleriqerluku pitellriartangqerqan wagg'uq meluit pitekluki,"
        },
        "67": {
            "start": 788.788,
            "end": 792.989,
            "transcript": "ullagluku qanruciiqa meliyarturtua."
        },
        "68": {
            "start": 792.989,
            "end": 807.263,
            "transcript": "Tua-i-llu neqlilluku ceg'ulluku meluit elliin cali pikarkauluki. Agluni eneminun ut'rulluki akulluki neqkaqerkauluki."
        },
        "69": {
            "start": 807.938,
            "end": 824.163,
            "transcript": "Tamaa-i tamakutgun ikayuryartuluugtaqluki ikayurnarqelriit, neqkaarateng wall'u tuvqakqerciullerkarteng pitekluku."
        },
        "70": {
            "start": 824.4,
            "end": 831.717,
            "transcript": "Tua-llam waniw' una apertuqataq'ngaqa nuqaq."
        },
        "71": {
            "start": 831.717,
            "end": 839.538,
            "transcript": "Ilaita nuqarrlugnek nunalgutellget egutnek pituluki. Egun-gguq."
        },
        "72": {
            "start": 840.6,
            "end": 851.641,
            "transcript": "Nakertatkenritliniameng-am tamakut nuqat, egutet. Ilii-gguq uyaqsunarquq nuqam."
        },
        "73": {
            "start": 851.641,
            "end": 860.313,
            "transcript": "Imumek tua-i uyaqaa una kangingqertuq nall'arcunaqluni, uyaqsunaqluni nall'arcunaqluni."
        },
        "74": {
            "start": 861.263,
            "end": 871.304,
            "transcript": "Tua-i tamakut-am tamaa-i cuqait mat'um-llu tevagnerem qaill' qaviyagtenritellran."
        },
        "75": {
            "start": 871.304,
            "end": 883.763,
            "transcript": "Aturluku waten narulkautaqaten, tallian uum elucilillra tua-i ciuneqluku ayatuluni tauna tua-i egun uyaqsunarqelria."
        },
        "76": {
            "start": 884.913,
            "end": 891.913,
            "transcript": "Tua-i-llu kia angutem elitaqciqaa nuqam tuaten egcaraa."
        },
        "77": {
            "start": 891.913,
            "end": 903.813,
            "transcript": "Piqertuutat ilaita epuit qiperrluaralriit. Tangvakngamun kanavet piqerrut'ngermi inglutruarcuut' tua-i piqertuutaungermi."
        },
        "78": {
            "start": 904.1,
            "end": 917.088,
            "transcript": "Cunaw' tang man'a qiperrluartura'arqami. Imna tau͡gken epua nak'renqekapiarquni piqertuutaam tangvallermun tuavet piqruskuni tulluni."
        },
        "79": {
            "start": 917.35,
            "end": 921.217,
            "transcript": "Tuaten-llu egutet makut nuqat ayuqut."
        },
        "80": {
            "start": 921.217,
            "end": 940.467,
            "transcript": "Mat'um tevagnerem qavirnganritaqami cali-ll' uum teguyaraan, teguyaraa una qaill' qipe', uivngallrunritaqami tua-i, tallim umyuaqek'ngaanun tuavet tutmatuliugaqami."
        },
        "81": {
            "start": 940.467,
            "end": 943.313,
            "transcript": "Tua-i-gguq tauna uyaqsunarqelria."
        },
        "82": {
            "start": 943.925,
            "end": 951.674,
            "transcript": "Tua-ll' kumluit waten tangvak'nganka ukiyucimayuitut unani."
        },
        "83": {
            "start": 951.674,
            "end": 958.963,
            "transcript": "Kuigpagmiutarnek tau͡gaam ukiyucimalrianek maa-i ayalangama tangerrsaurtua."
        },
        "84": {
            "start": 959.675,
            "end": 972.543,
            "transcript": "Una nayuumatuuq tau͡gaam waken nayun waten tuput'uuvkenani uum akitmigcaraa."
        },
        "85": {
            "start": 972.543,
            "end": 984.775,
            "transcript": "Tua-llu cali akia ikna tegqerraagnek pinrilkuni tulurraagnek, una kepumayuami naaqutnguyunaitelartuq."
        },
        "86": {
            "start": 985.338,
            "end": 997.337,
            "transcript": "Ukuk waniwa akuliigni tegqerraak tekauralriik wall' tulurraulutek, tulurnek pikalget."
        },
        "87": {
            "start": 997.337,
            "end": 1006.088,
            "transcript": "Tua-i tuaten pikuni nagingassuutnguyugngaluteng, tauna-ll' cali nagingassuutnguyugngaluni."
        },
        "88": {
            "start": 1006.388,
            "end": 1020.076,
            "transcript": "Tua-llu ingna mat'um teviim taktacirkaa. Una waniw' ngel'ekaa."
        },
        "89": {
            "start": 1020.076,
            "end": 1035.5,
            "transcript": "Waniw' uumek cali ingna veg'illra-gguq, nuqam veg'illra [?]. Enrrauluni [?] unani kingunemni, enrrauluni tua-i."
        },
        "90": {
            "start": 1036.22,
            "end": 1052.13,
            "transcript": "Enernek pilingnaurtullruit waten patak'arluteng alqunaqerluteng ping'e'rmeng tauna tua-i-w' asvaiciiqngan muragtun urivkenani."
        },
        "91": {
            "start": 1052.13,
            "end": 1055.163,
            "transcript": "Enrrarnek pingnaquratullruit."
        },
        "92": {
            "start": 1055.438,
            "end": 1068.975,
            "transcript": "Asveret keggutaitnek wall'u natiini tua-i wall' tulupiarrarnek tua-i tamakunek tamaa-i kakitessuutiit tauna pilingnaquratullruat."
        },
        "93": {
            "start": 1071.725,
            "end": 1088.348,
            "transcript": "Cali una, wagg'uq pupsugyaraa, nemerluku tua-i una qurrasqitarngairulluku."
        },
        "94": {
            "start": 1088.348,
            "end": 1096.6,
            "transcript": "Wavet uum qaqum qainganun epua pikan pupeskaquniu qurrayiryugngairulluku."
        },
        "95": {
            "start": 1097.188,
            "end": 1107.738,
            "transcript": "Cali-am tua-i nunurvianek piaqluku tauna. Nanerpiim-gguq nunurvian, nagiiquyam-gguq nunurvia, nunurluku waten pilaami."
        },
        "96": {
            "start": 1107.888,
            "end": 1119.424,
            "transcript": "Tua-i-am cali tauna nuusaarpiit pingqessuilameng. Nuusaarpagnek atulrianun mecungaqameng-llu qurrasqiarteqeryarpiarayuluteng."
        },
        "97": {
            "start": 1119.424,
            "end": 1133.8,
            "transcript": "Nuusaarpiit tamakut amllermun cal' aturluteng. Ingtaugaqata maliqluki pug'aqata nuusaarpak narulkarluki nall'artellriani pitaqaqluki."
        },
        "98": {
            "start": 1134.913,
            "end": 1148.294,
            "transcript": "Cali cikuqami tunrilngurmi canun neqnun carvat qavani nuniitni wangkuta kuigput carvatangqertuq."
        },
        "99": {
            "start": 1148.294,
            "end": 1160.638,
            "transcript": "Nanvarnaitni manignaq kana-i cikuqami alailkata callarrluku, wagg'uq nuusaarpagnek kakiluku kanavet nuggluku pitaqaqluku."
        },
        "100": {
            "start": 1161.113,
            "end": 1176.22,
            "transcript": "Kakilrianek-am tamakut tuatnalriit tukiartaqluku kapluku nuusaarpagnek pissu'urqameng, kakilriit-gguq tamaa-i, kakiluki pissulriit."
        },
        "101": {
            "start": 1176.25,
            "end": 1196.275,
            "transcript": "Cali ukuk aipaagnek qanrutkellragnek, up'nerkami wall'u up'nerkaunrilengraan kiagungraan cuukviit, luqruuyiit, keggsulit, macilriit, tamakunek cali tua-i kapqerluki pitaqnaqluni."
        },
        "102": {
            "start": 1197.1,
            "end": 1201.13,
            "transcript": "Tua-i tamakut nuusaarpiit pitait ayuqevkenateng."
        },
        "103": {
            "start": 1201.13,
            "end": 1212.75,
            "transcript": "Tengaungraata tua-i-ll' canimelkan cali yaqulek, narulkalriim pitaqekuniu tua-i tengaungraan nuusaarpagteggun pitaqekani iggluni."
        },
        "104": {
            "start": 1213.6,
            "end": 1223.087,
            "transcript": "Tamakut nuusaurpiit tua-i kuvyaunrilngermeng pitamegteggun nerutngullrat amllellriaruluni."
        },
        "105": {
            "start": 1223.087,
            "end": 1237.22,
            "transcript": "Nagiiquyat tau͡gken tua-i makunun taqukanek pitukemteńun, seal-anun, Kass'at seal-anek pitukaitnun atuulriaruaqluteng."
        },
        "106": {
            "start": 1238.963,
            "end": 1244.272,
            "transcript": "Tua-llu atauciq una apertuumaqaqsaituq. Una-gguq asaaquq."
        },
        "107": {
            "start": 1244.272,
            "end": 1254.488,
            "transcript": "Waniwa au͡gkunek imkunek tegutnek nagiiquyanek-llu au͡gna maniillermini apertullrunritaa."
        },
        "108": {
            "start": 1255.838,
            "end": 1275.025,
            "transcript": "Asaaquq tamana, usiiryaraq apqiitnek, au͡gkut avani waten muriik pikunek, waniwa qantam paikngalkii muriik qaingagni."
        },
        "109": {
            "start": 1276.638,
            "end": 1292.598,
            "transcript": "Wagg'uq tuaten acaluq. Qayami mat'um kinguqliim uum taprartaam aciagnun tamakuk muriik waten tusngaviik qerrlukek."
        },
        "110": {
            "start": 1292.598,
            "end": 1299.525,
            "transcript": "Tauna-ll' tua-i asaaqum usaartaa wavet imiulluku."
        },
        "111": {
            "start": 1301.05,
            "end": 1308.565,
            "transcript": "Tamana tamaani asaaquq nak'rutaituq, culuituq apqiitnek."
        },
        "112": {
            "start": 1308.565,
            "end": 1324.588,
            "transcript": "Tau͡gaam inglua man'a manigg', waten tua-i allirenqeggluni tulum inglua. Inglua-ll' amaggluni, inglua allirenqeggluni. Taum-ll' allirenqellran iqua qaluggluni."
        },
        "113": {
            "start": 1325.8,
            "end": 1344.325,
            "transcript": "Tua-i tamaa-i nutgunateng pissuagaqameng unani seal-anek, maklagmek ugtamek tangrraqameng tua-ll' agturatulliniat tua-i narulkaqainaurtengnaqluku."
        },
        "114": {
            "start": 1345.413,
            "end": 1353.725,
            "transcript": "Narulkaquneng tekicugngarillran uum, usaameng enurngairutellranun mallengnaqluku."
        },
        "115": {
            "start": 1354.538,
            "end": 1365.063,
            "transcript": "Tua-i tamana tamaa-i asaaquni nutaan nak'rutailnguq culuilnguq nuqirluni cali aturyarauluni wagg'uq egucirluku."
        },
        "116": {
            "start": 1366.45,
            "end": 1384.125,
            "transcript": "Tua-i uum enurngairutaqaku narulkaquniu nurrluku taum asaaqum tucaaqeng'e'rmi ingluni manigcilan waten allirinqegngan, ingna-ll' iqua qaluggluni,"
        },
        "117": {
            "start": 1384.513,
            "end": 1394.7,
            "transcript": "nurrluku tucaaqeng'e'rmi, qanikcarmun tuskuni, kat'agluni qanikcam qaingakun tekiskuni tua-i kukgari kapulluni."
        },
        "118": {
            "start": 1395.025,
            "end": 1402.163,
            "transcript": "Tua-i tuaten ugtarcurcuutekluki, asaaqut tamakut."
        },
        "119": {
            "start": 1402.163,
            "end": 1411.475,
            "transcript": "Tua-i narulkaryarat iliit aprumaksailnguq asaaquq apertuqa'arqa tua-i-nguyugnarquq nutaan."
        },
        "120": {
            "start": 1412.688,
            "end": 1417.261,
            "transcript": "Apyutailkuvci camek tayima."
        },
        "121": {
            "start": 1421.38,
            "end": 1424.272,
            "transcript": "Ii-i, aren."
        },
        "122": {
            "start": 1424.272,
            "end": 1434.304,
            "transcript": "Tua-i-llu asaaquq cali au͡gna iqua tegucetun ayuqluni, tegutet atutukiicetun qerruinaq yaani nayiq."
        },
        "123": {
            "start": 1434.304,
            "end": 1445.538,
            "transcript": "Qerruumalria pamatum asaaqum uskuraan usaaranun agumaluni qillrusngaluni yaani iquani."
        },
        "124": {
            "start": 1445.988,
            "end": 1451.424,
            "transcript": "Cali-am qillrutpiaryarauvkenani tauna."
        },
        "125": {
            "start": 1451.424,
            "end": 1467.88,
            "transcript": "Qerruinam imum, wani taprartarriini tuluq, nugusngaluni taum imum waten piani."
        },
        "126": {
            "start": 1467.88,
            "end": 1476.772,
            "transcript": "Ukinerkun taukunun nugusngalutek, uterrluni ataam call' wavet qerruinarmun qillrusngalu'."
        },
        "127": {
            "start": 1476.772,
            "end": 1490.565,
            "transcript": "Nutaan waten taukuk ukinrek nalliigni, tamana usaam iqua kaucugngaqaami, nayukaumalutek call' taukuk."
        },
        "128": {
            "start": 1490.565,
            "end": 1501.625,
            "transcript": "Tua-i tauna iqua putuq as'uqaarluku taukugnun nek'areskuni qillrusnganrilngermi imkuk kanani,"
        },
        "129": {
            "start": 1502.525,
            "end": 1512.761,
            "transcript": "waten pimalriignek [?], qillrusnganrilngermi au͡g'arngaunani usgutsuuterluni."
        },
        "130": {
            "start": 1512.761,
            "end": 1527.674,
            "transcript": "Tua-i tamaa-i cakviut tuan' tauna qerruinaq pitarkam kuimaulluku ayagataqani, qamesciigalngurmek-am taumek usgutsuucilalliniluku."
        },
        "131": {
            "start": 1527.674,
            "end": 1533.575,
            "transcript": "Cakviullrunrilngurteng tua-i an'artetaaqerluku tauk' avaqeryarautuluni [?]."
        },
        "132": {
            "start": 1535.188,
            "end": 1539.87,
            "transcript": "Qerruinam tauna usgutsuutii."
        },
        "133": {
            "start": 1539.87,
            "end": 1554.326,
            "transcript": "Pinirpaa-ll' tamakuni angutni qanemciugaqameng ilait pivilget narulkarraarluku tua-i yuugarrluteng."
        },
        "134": {
            "start": 1554.326,
            "end": 1565.978,
            "transcript": "Qayateng tua-i mayurqualuki usaaq tamaa-i nuqluku, angaqengraata nuqingatullrullinikait."
        },
        "135": {
            "start": 1565.978,
            "end": 1574.837,
            "transcript": "Taqsuqengkata-ll' tua-i aangruyameggnek tuqulluki aangruyagaluki."
        },
        "136": {
            "start": 1574.837,
            "end": 1590.7,
            "transcript": "Wiinga tua-i pinikelaranka tamakut, apqiitnek nucecurlakngamnek maklagmek nuqtellemni cikum qainganek cakviullruama."
        },
        "137": {
            "start": 1591.438,
            "end": 1599.544,
            "transcript": "Tua-i caknaq pinirtacimtun tua-i qelluqpagallrani nuqingallruamku."
        },
        "138": {
            "start": 1599.544,
            "end": 1609.525,
            "transcript": "Tamakut tua-lli-wa nutkarraarpailegmegteki nuqcitullret atag' nutaan pinillrularyaaqut."
        },
        "139": {
            "start": 1610.313,
            "end": 1621.294,
            "transcript": "Wiinga nucecurlaumaluku maklag' nuqtellemni cakviullruama qayatullemteńi cikum qainganek."
        },
        "140": {
            "start": 1621.294,
            "end": 1631.707,
            "transcript": "Tua-i au͡g'um caki'irma malikngamegnuk pulenglluku upugngan nutaan nalalluku."
        },
        "141": {
            "start": 1631.707,
            "end": 1639.513,
            "transcript": "Nunamek cikumek wii narulkarluku qimullrani tua-i cakviullruunga."
        },
        "142": {
            "start": 1640.425,
            "end": 1645.0,
            "transcript": "Uqamailameng-wa tunertullinilrit."
        },
        "143": {
            "start": 1645.0,
            "end": 1649.95,
            "transcript": "Ii-i nutaan-wa tua-i-qaa?"
        },
        "144": {
            "start": 1650.275,
            "end": 1654.638,
            "transcript": "(Urluvret-mi cuqyutait caugat?)"
        },
        "145": {
            "start": 1656.238,
            "end": 1664.141,
            "transcript": "Yuk-wa tua-i elliin cuqyinek call' cuqerluteng taktateksuitellrulriit taumek."
        },
        "146": {
            "start": 1664.141,
            "end": 1667.825,
            "transcript": "Cali-llu mamtutateksuunani urluveq."
        },
        "147": {
            "start": 1669.175,
            "end": 1675.815,
            "transcript": "Wii tua-i waniw' pinialama mamkitekacagarmek urluvengqerrsuumaunga."
        },
        "148": {
            "start": 1675.815,
            "end": 1680.978,
            "transcript": "Pinilria tau͡gken mamtulriamek."
        },
        "149": {
            "start": 1680.978,
            "end": 1693.475,
            "transcript": "Tua-i pinirtacini yuum aturluku tamakut cagnitacirkaat pitullrulliniat."
        },
        "150": {
            "start": 1695.388,
            "end": 1709.707,
            "transcript": "Ilait-llu tamana murak mamtungraan tunuitgun cali yualunek wagg'uq cagniqrucirluki pitullrulliniluki."
        },
        "151": {
            "start": 1709.707,
            "end": 1724.325,
            "transcript": "Tamakut-gguq pinilriit qeluitullruut yugmek qaimeggni qetluteng maaggun, yuk tauna amaqluku. Urluteng qelutullruut pinilriit tamaa-i."
        },
        "152": {
            "start": 1725.8,
            "end": 1738.902,
            "transcript": "Urluvret [?] tua-i taktatkenritut. Ilii yagneq nuringai, iliin-llu yagneq naamaluku. Cuqseng tamaa-i aturluku piaqameng."
        },
        "153": {
            "start": 1738.902,
            "end": 1751.738,
            "transcript": "Tamakut-am iliin ayimcilliniaqluteng waten pitgaqatarluteng piaqameng urluvmeggnek. Ilaita ayimcitulliniluteng."
        },
        "154": {
            "start": 1752.0,
            "end": 1763.424,
            "transcript": "Iliit-am tauna malirqellruugni [?] tua-i tuaten pitgaqataryaaqellermini ayimcurlulliniuq."
        },
        "155": {
            "start": 1763.424,
            "end": 1774.076,
            "transcript": "Arenqiapaalliniuq, \"Arenqiapaa! Urluvqa-ll' ayimlluni. Kina-qaa imna aipalegmek urluvrituq?\""
        },
        "156": {
            "start": 1774.076,
            "end": 1781.738,
            "transcript": "Taum-gguq mallgetestiin kiugaa, \"Urluvqa-wa aipangqerrsaaqelria tau͡gaam elpet pakigngailken.\""
        },
        "157": {
            "start": 1781.913,
            "end": 1787.109,
            "transcript": "Tua-i piniami ellminek nallunrilami."
        },
        "158": {
            "start": 1787.109,
            "end": 1798.9,
            "transcript": "Pinilriarunrilriim taum artuaku pakigngaitniluku aipangqengraan elliinun kiulliniluni."
        },
        "159": {
            "start": 1801.413,
            "end": 1807.794,
            "transcript": "(Pitegcautait-mi cali-qaa cuqyutengqertut?)"
        },
        "160": {
            "start": 1807.794,
            "end": 1813.5,
            "transcript": "II-i, tua-i cali taklivallallerkaat una,"
        },
        "161": {
            "start": 1814.975,
            "end": 1822.707,
            "transcript": "malrurqugnek tua-i una, amllermek uniurpakaumanritaat."
        },
        "162": {
            "start": 1822.707,
            "end": 1826.685,
            "transcript": "Uum-wa tua-i pakillerkaa cuqluku."
        },
        "163": {
            "start": 1826.685,
            "end": 1838.137,
            "transcript": "Cali-am eputeng tak'aqata tuaten yaaqvanun pitgautellriani aguranritliniameng tamakut pitegcautet."
        },
        "164": {
            "start": 1838.338,
            "end": 1852.913,
            "transcript": "Cali tua-i pitegcaucilriani manigcetengnaqluku man'a qainga canauryarauluteng tamakut pitegcautet."
        },
        "165": {
            "start": 1852.913,
            "end": 1863.435,
            "transcript": "Ukut-llu qelutiinun kautellerkait mamcarterrluarluki terirvigkait."
        },
        "166": {
            "start": 1863.435,
            "end": 1868.163,
            "transcript": "Cingilget-wa cali ayuqenrilnguut."
        },
        "167": {
            "start": 1868.163,
            "end": 1885.663,
            "transcript": "Urugnaq, tua-i [?] urugnar' una au͡guulartuq enernek cingilengqerraqameng, luvingaluni [?] avatmikun nakerluni."
        },
        "168": {
            "start": 1885.663,
            "end": 1891.063,
            "transcript": "Iliit tau͡gken inglua nall'aramikun nakerluni."
        },
        "169": {
            "start": 1892.113,
            "end": 1905.348,
            "transcript": "Tau͡gken cali nuusaangqerrluteng, pingayunek waten pilegnek ilait-llu malrurraagnek."
        },
        "170": {
            "start": 1905.348,
            "end": 1909.196,
            "transcript": "Nuusaanek tamakut apraqluki."
        },
        "171": {
            "start": 1909.196,
            "end": 1914.902,
            "transcript": "Tua-i-llu cali pingayuag' una akitnaq-gguq."
        },
        "172": {
            "start": 1918.489,
            "end": 1930.022,
            "transcript": "Tegg'uralriamek cingiligkiuquneng, nuuga waten ayuqluku, kangia-llu tua-i amililuku waten piluku."
        },
        "173": {
            "start": 1930.022,
            "end": 1938.175,
            "transcript": "Tua-i-llu apeqmeggnek call' caniryarluni taun' akitnaq."
        },
        "174": {
            "start": 1941.263,
            "end": 1952.075,
            "transcript": "Waten taqutmun pingqerrluni. Ilait-llu cetam', malrugnek pingqerquneng four-aat tua-i caniryauluteng waten nalleqliqelriit."
        },
        "175": {
            "start": 1953.0,
            "end": 1964.815,
            "transcript": "Tamaani makuungraata mermi kuimatulit imaqcaaraat, augtaaraat, ayungnaaraat,"
        },
        "176": {
            "start": 1964.815,
            "end": 1980.375,
            "transcript": "wall'u tuk'naayagaat, piyagaat neqkaiturluteng piaqameng, tamakucikun tamaa-i akitnakun pitgaquneng, malkalteng imkut caniryameggnek allgu'urluki,"
        },
        "177": {
            "start": 1980.913,
            "end": 1988.283,
            "transcript": "yaqurrircugngaluki wall'u yaqurrit akngirrluki tuqucugngaluki."
        },
        "178": {
            "start": 1988.283,
            "end": 2002.95,
            "transcript": "Tamaa-i akitnat tamakut tamakuyaganun angenrilnguarnun atutuluki ayungnaarnun, imaqcaarnun, canun tua-i tuk'laayaarnun-llu."
        }
    },
    "sYUY5OT5Ag4": {
        "1": {
            "start": 0.0,
            "end": 16.12,
            "transcript": "Imkunek-llu atrit ayuqenritsiyaalaameng cuukvak keggsuunii luqruuyak maciaqata-llu [?] mulngakurluni anguarturluni tamakut tua-i."
        },
        "2": {
            "start": 16.12,
            "end": 33.82,
            "transcript": "Tang mermi massituameng makut luqruyiit, tua-i assilria narulkagaqluku nall'artaqami tua-i arrsaput [?] pingyatuutek'lallrulliniamegteggu au͡gkut,"
        },
        "3": {
            "start": 33.82,
            "end": 46.34,
            "transcript": "Piciatun makut nuuliarput [?] au͡gkut pilalten avani atulallrulliniut cali-llu urluvegpallug' [?] yaaqvani."
        },
        "4": {
            "start": 46.34,
            "end": 52.58,
            "transcript": "Maa-i uurluut nutget amllerinitekluki uurluut-llu tangeqsairullerkait [?]."
        },
        "5": {
            "start": 52.58,
            "end": 62.92,
            "transcript": "Tangerrnairutut watpik tamakut nuusaarpik piyuirucaiceteng maa-i tangrruyuirutut nunamteńi."
        },
        "6": {
            "start": 62.92,
            "end": 71.36,
            "transcript": "Tangrruutullruyaaqut tangrruguratullruyaaqut (mikelngullraallerpet), ii-i (wiinga-llu)."
        },
        "7": {
            "start": 71.4,
            "end": 83.08,
            "transcript": "Neqsuutekluku tua-i-ll' mer'em iluani uitangraata narulkarluku tua-i aqsaqurkenka imiliqluku."
        },
        "8": {
            "start": 83.5,
            "end": 97.76,
            "transcript": "Au͡gkucan pitegcautet tua-i cassuutekluki ilait pitarpauluta, qaillun tua-i piaq pitarpaunarput ilait [?]."
        },
        "9": {
            "start": 97.76,
            "end": 116.36,
            "transcript": "Makut nuusaarpak tangtullruukut pingqetullruut, qayarrsuutengqetullruut avani Kuigpagmi keluqvani [?] mingqetullruut [?] atungluki tua-i."
        },
        "10": {
            "start": 116.36,
            "end": 138.18,
            "transcript": "Makut-llu maa-i maani kangiqvani uksuarmi-llu nuugluki piyuarrlainarluteng pilallermeggni tua-i ciku-llu man'a makuciq nuuggarluni tau͡gaam tua-i."
        },
        "11": {
            "start": 138.18,
            "end": 153.3,
            "transcript": "Piciatun tua-i cali camek nuulirluku ava-i-llu cau' [?] nugnallrani cikuliurutnguyugnganun ima-i man'a makut kevraartuyagaq."
        },
        "12": {
            "start": 153.3,
            "end": 168.3,
            "transcript": "Wall'u quarnaq, wall'u elnguq, tua-i tamaa-i tamakut cikuliurutnguyugnga' puksurnaluki [?]."
        },
        "13": {
            "start": 168.3,
            "end": 183.24,
            "transcript": "Piciatun wall'u cali imkuni qaluni makut tamakut au͡gkut pillrenka puuyugngaluteng cali."
        },
        "14": {
            "start": 183.24,
            "end": 200.24,
            "transcript": "Tamatumek-llu piilkuneng im' unarciaq tua-i murak qugcilria tallitmun quptuli-am cali kituggluku qupraarluku canaluku cali."
        },
        "15": {
            "start": 200.24,
            "end": 202.36,
            "transcript": "Tangtullruunga wii."
        },
        "16": {
            "start": 202.36,
            "end": 223.32,
            "transcript": "Piciatun wall'u qenairutnun imkut-llu qenairutet cikussuutet qupraarluku tua-i tamakunek-llu qenuirutet aterluteng cali perperuingaluteng."
        },
        "17": {
            "start": 223.32,
            "end": 231.44,
            "transcript": "Tamakunek-llu ava-i akwaugaq qanaarallrulriit elngut ayuqenritniluki."
        },
        "18": {
            "start": 231.44,
            "end": 243.6,
            "transcript": "Elnguq ilait muraungameng [?] man'a makut, taumek-llu makut qalqapiit wall'u-qaa piqertuutait."
        },
        "19": {
            "start": 243.6,
            "end": 257.76,
            "transcript": "Puukarcaaqamteki waten wangkuta una-llu wiinga elput-llu tua-i imkut waten, waten murilkessaraugut-am (murilkessaraugut makut)."
        },
        "20": {
            "start": 257.76,
            "end": 274.44,
            "transcript": "Tua-i-llu imna piqertuutama qalqapiit piqertuutama-llu puukaqengraani waten imkut tua-i kepelmun makut-gguq pilget."
        },
        "21": {
            "start": 274.44,
            "end": 279.84,
            "transcript": "Piqertuuskuni-llu nutaraugem [?]."
        },
        "22": {
            "start": 279.84,
            "end": 293.22,
            "transcript": "Piqpagacunaitut makut waten makuciq nutaraungermeng  wani taqluku elliluku aturluku piqpagacunaitut ayucutun [?]."
        },
        "23": {
            "start": 293.22,
            "end": 312.78,
            "transcript": "Kep'artetuit, tamakut tua-i tamaa-i, tuamta-llu cali makut ava-i mimernat, kevraartut, maani-wa pilaqait Kusquqvagmi nunamni-wa wiinga nasqunat."
        },
        "24": {
            "start": 312.78,
            "end": 322.98,
            "transcript": "Nasqunat mimernat, tuaten nunamni-wa aprumatuit."
        },
        "25": {
            "start": 322.98,
            "end": 342.98,
            "transcript": "Tamakut tamaa-i qantaliluki tua-llu, cakilluki qantauyugngaluteng yuum, qantalikuni tua-i tamatumek mimernamek."
        },
        "26": {
            "start": 342.98,
            "end": 357.48,
            "transcript": "Acia cam qantam, alumiirluku-llu [?] qantaq. Pilitullruut wall' piciatun waten, elngunek pitullruut perqaarluki."
        },
        "27": {
            "start": 357.48,
            "end": 376.32,
            "transcript": "Qantaliluki tuaten, waten-am mimernanek-llu cam naciata assuumiit [?] pililuku, qaltaliluki, qantat-llu tuaten ayuqluteng, qagaani nunamni pilituut, pilitullruut."
        },
        "28": {
            "start": 376.32,
            "end": 393.58,
            "transcript": "Avani cat tamalkuan tuamta-llu cali pivailgan niitellra qalamcimek niitelartua, una kuigem mat'unun kuimcenun ayuqenrilami imarpik."
        },
        "29": {
            "start": 393.58,
            "end": 413.24,
            "transcript": "Tamaaken meqsung'e'rmi piluni pingaituq, mercuulilartut-gguq-am imkut, unguvalriit-wa tua-i nakacuut-llu mermek imirluki tua-i mercuutekluki-llu cat nurnallratni."
        },
        "30": {
            "start": 413.24,
            "end": 420.1,
            "transcript": "Tua-i tamaa-i tuaten-am niitelallruunga (pingqerrluteng qeciqutanek)."
        },
        "31": {
            "start": 420.1,
            "end": 434.32,
            "transcript": "Tuamta-llu cali imkut nayiit aqsaqurrit anrutait cali, cali tamakut mercuutek'lallrullikait mermek imirluki."
        },
        "32": {
            "start": 434.32,
            "end": 455.18,
            "transcript": "Imarpigmi unani maa-i mat'um nalliini qamigaqatarniaqameng ikamrani yuarluteng wall'u tua-i man'a aluminum-aaq [?] ekluku kaassalilamek kaassalilartuunga mat'umek."
        },
        "33": {
            "start": 455.18,
            "end": 468.16,
            "transcript": "Snuukuumek ayagarrluni ernerpak tua-i yaaqsigliurutellriit maa-i, tuani. Pikegcingameng tamakut."
        },
        "34": {
            "start": 474.2,
            "end": 496.68,
            "transcript": "Makut wiinga-ll' imarpiliuqsaicaaqua waniwa tau͡gaam ciutegem-wa niitellemni, au͡gkut-qaa qanrutkellren elitaqugarait [?] imarpigmiunguavet? Tua-i. Waten qanruyutet makut ayuqut."
        },
        "35": {
            "start": 496.68,
            "end": 518.86,
            "transcript": "Atullermeggnek qalartetuut wall'u canek atuuyugngalrianek assirluki piarkait tuamta-llu cali makut maa-i, yuk qalaruyutem tau͡gaam kitugcugngauq."
        },
        "36": {
            "start": 518.86,
            "end": 533.56,
            "transcript": "Qanruyutni maligtaqukuniu, wall'u cali qalarciqaarluku kina imna nalluyagulluku tua-i-llu piinanermini-am [?] iliitni piciquq aren."
        },
        "37": {
            "start": 533.56,
            "end": 554.42,
            "transcript": "Tua-i-llu tauna imna qanrutkellra tekicamiu aren ima-tanem man'a tuaten pikuni elluatuqngaitnillrukiinga' [?] qalarutet tua-i tuaten ayuqut."
        },
        "38": {
            "start": 554.42,
            "end": 582.18,
            "transcript": "Au͡gkut tamana pitekluku-llu tan'gurraacuarauluki qasgim iluani unuakumi atakumi-ll' inarteqata'arqata qalarut'lallrullinikait ciunerkait apertualuki qessanqerrukata-llu wall'u-q' qessalteng maligtaqukatgu neqkaitularciqniluki."
        },
        "39": {
            "start": 582.18,
            "end": 593.72,
            "transcript": "Tau͡gaam imkut qessaniyunqellriit-gguq, qessange'rmeng qessateng ayemqelluku natmun yuilqumun ayangengnaqellriit."
        },
        "40": {
            "start": 593.72,
            "end": 608.84,
            "transcript": "Wall'u makunek can'giircuun can'giirnek, cali tua-i tamakut piyugngaluni cat."
        },
        "41": {
            "start": 608.84,
            "end": 626.18,
            "transcript": "Tuamta-llu cali pissuutekaitnek yuk pingnaqenrilkuni tamakut amllerrsaaqeciqut tamakussuutnek taluyanek-llu piilkuni pikaiciur'."
        },
        "42": {
            "start": 626.18,
            "end": 646.12,
            "transcript": "Tau͡gaam imkut taluyanek piilkuni pugelriit cali qaluni uugnek [?] can'giirnek imangai atra tua-i cali tavaken tamaa-i tuaten pilalriit."
        },
        "43": {
            "start": 646.12,
            "end": 664.08,
            "transcript": "Canek cat tamarmeng pissuutengqertut, makunek-llu pavani cat pilallruyaaqellriit maa-i cali makut akakiiget nunacevvni qaurtunek pilallilriit."
        },
        "44": {
            "start": 664.08,
            "end": 673.96,
            "transcript": "Maani Kusquqvak akakiiget qagaani-llu qaurtut kiani avani-llu Kalskag-mi pilaqait."
        },
        "45": {
            "start": 673.96,
            "end": 689.68,
            "transcript": "Tamakut cali, cali-am tamakussuutekanek pilallermeggni imkunek aminek-am ciuqlemni pilallruut kuvyiinaq'lallruyaaqelliniut."
        },
        "46": {
            "start": 689.68,
            "end": 699.72,
            "transcript": "Keniaqameng-gguq qiller'enritua imkut inglua naivqetaarayuitut [?]."
        },
        "47": {
            "start": 699.72,
            "end": 718.08,
            "transcript": "Tau͡gaam-am imkut cali makut qaillukuarluteng Kass'artaitellrani avani pilingnaqluteng, imkunek-am makunek [?] enrilnguat allgit [?]."
        },
        "48": {
            "start": 718.08,
            "end": 736.28,
            "transcript": "Up'nerkami tau͡gaam, waten maa-i mat'um nalliini neptuut, qeltait amiit pelatait qeltait amiit neputut, ava-i-llu pinrilngumek uumi piyaaqlemni nepesngallruuq [?]"
        },
        "49": {
            "start": 736.28,
            "end": 753.5,
            "transcript": "Nepesngaluni tua-i maniarkamnek cama-i-am unitellruaqa talirrukek'a [?] pinritnayukluki cali alingenrilamku."
        },
        "50": {
            "start": 770.06,
            "end": 772.06,
            "transcript": "Piqataquma pinial' [?]."
        },
        "51": {
            "start": 772.06,
            "end": 780.62,
            "transcript": "Wiinga-llu tua-i [?] yaassiicuararraagka nanluciurutagka maavet ut'rutellruyaaqaqa tua-i maatmun ukatmun."
        },
        "52": {
            "start": 790.0,
            "end": 807.76,
            "transcript": "Yuilngurnek tau͡gaam makucituut makut perelteng aturluki nalqigglainalrianek makunek pitu' (kinraqameng ilait tuaten) imkut-am makut-am muriit tegg'ralget."
        },
        "53": {
            "start": 807.76,
            "end": 817.64,
            "transcript": "Teggelriit muriit, murak teggelrianek auluk, perrngetuuq tua-i. (Yaa pituut)."
        },
        "54": {
            "start": 817.64,
            "end": 827.58,
            "transcript": "Muriit makut muraungermeng mayuqeqapiaranrituq, wangkucitun umyuaput-llu wangkuta ayuqut."
        },
        "55": {
            "start": 837.02,
            "end": 854.68,
            "transcript": "Una-wa makut nuqat pililriani una talliq cuqyutekluku pilalriit waten, tegumiallerkaa tauna aturluku una wani cuqyutet tua-i-llu."
        },
        "56": {
            "start": 885.58,
            "end": 901.72,
            "transcript": "Una-wa cuqtellriani nuqaq una taqtacirkaa una tallimek teguluku iqua una wani iqukaa cuqyutngulria tegumiaqellriani tuani tuaten taktarkauguq."
        },
        "57": {
            "start": 901.72,
            "end": 919.88,
            "transcript": "Tua-llu una nanerpak, ukunek wani piliaqameng-wa una cuqyutekluku pilartut. Amllenrani wani waten pingayuluki yaavet wani engel'ekaanun pililaryaaqut."
        },
        "58": {
            "start": 919.88,
            "end": 937.0,
            "transcript": "Tua-llu una wani nanerpak wani nuqaq. Uum taktacianek pingayunleganek taktaarkauluni tuaten."
        },
        "59": {
            "start": 937.0,
            "end": 948.68,
            "transcript": "Tuaten pilriit assinrulartut. Pegtellrit-wa nalqigcetenruluni. Makut maani cavget qaillun taktang'e'rmeng cangatenritut."
        },
        "60": {
            "start": 948.68,
            "end": 957.66,
            "transcript": "Ilait takluteng pilartut, ilait-llu nanillrulluteng, tua-im cuqyutaileng'e'rmeng cangatenritut yaaqvanun egucuilata."
        },
        "61": {
            "start": 957.66,
            "end": 969.2,
            "transcript": "Makut tau͡gaam yaaqvanun egucetuut, canimun qang'a-ll' yaaqvanun. Uum nuqam ikayurluku yaaqvanun egutekavkarlaraa."
        },
        "62": {
            "start": 978.46,
            "end": 997.7,
            "transcript": "Makuni-wa nanerpagni una nuuga aqliga una wani tut'aqami tuavet maklagmun qang'a-ll' issurimun, nayirmun qanga-ll' cetuamun tut'aqami una au͡gaarrluni pilartuq waten."
        },
        "63": {
            "start": 997.7,
            "end": 1009.6,
            "transcript": "Tuavet unilluni man'a-llu saggluni, tamaaggun-llu tua-i nalluvkenaku tauna natmun ayallraat ungungssiim."
        },
        "64": {
            "start": 1009.6,
            "end": 1030.4,
            "transcript": "Tua-llu, maklaukuni qang'a-llu issuriq nayiq cetuaq-llu tuaten maligterraarluku nutaan uumek cavegmek aturluteng."
        },
        "65": {
            "start": 1030.58,
            "end": 1042.2,
            "transcript": "Tau͡ga una wani engeluvkaayarmek [?] qang'a-llu cukayulria maklamek usaangqerrlartuq, rope-angqerrluni."
        },
        "66": {
            "start": 1042.2,
            "end": 1058.36,
            "transcript": "Tua-llu una wani una nail-auguq, ilait-llu pugitalget [?] pililarait makut-llu nuugit cagvet una patagaluku pillraamku, una amllenrit' wani ugg'un nuuqlaryaaqut waten."
        },
        "67": {
            "start": 1058.58,
            "end": 1072.58,
            "transcript": "Tau͡gaam wani uumek wani nunangqellartuq ekluku-llu tuavet, ellilriani [?] una wani takenra akilirnerani uitaluku, man'a-llu wani ukalirnerani."
        },
        "68": {
            "start": 1072.58,
            "end": 1080.58,
            "transcript": "Tuaten tut'aqameng wani an'aqan una wani nuqtaqan una cani'irrluni ukatmun pilartuq."
        },
        "69": {
            "start": 1080.74,
            "end": 1095.58,
            "transcript": "Tua-llu us'arakun nutaan nuqluku tauna pilteng piyuumaluku, una wani ukinra miklaami waten caniirtaqami anesciigat'lartuq."
        },
        "70": {
            "start": 1366.22,
            "end": 1372.58,
            "transcript": "Dennis tuavet-llu aqumyukuvet, tuavet-ll' cali aqumgauryukuvet."
        },
        "71": {
            "start": 1378.9,
            "end": 1380.94,
            "transcript": "Piyukuvet."
        },
        "72": {
            "start": 1393.58,
            "end": 1396.2,
            "transcript": "Tuai-qaa?"
        },
        "73": {
            "start": 1396.2,
            "end": 1401.46,
            "transcript": "Wiinga, una-qaa apertuuluku ciumek atqa-llu?"
        },
        "74": {
            "start": 1401.46,
            "end": 1412.58,
            "transcript": "Yaa, wiinga Pilot Station-armiunguunga Kass'atun Timothy Myers-aaruunga Pilot Station-aarmiu."
        },
        "75": {
            "start": 1414.48,
            "end": 1417.98,
            "transcript": "Unaken imarpigmek ceńiini taillruuq."
        },
        "76": {
            "start": 1419.54,
            "end": 1426.38,
            "transcript": "Yugtun-llu Uparqumek pituatnga. Uparqumek. Ii-i. Uparqumek."
        },
        "77": {
            "start": 1429.24,
            "end": 1440.86,
            "transcript": "Tua-i wiinga makunek calituliunricaaqua makut ukut wani niigarcauma makut egtarkaqanka."
        },
        "78": {
            "start": 1440.86,
            "end": 1452.58,
            "transcript": "Ut'rulluki kinguani egtarkautekanka. Pililanka pililaqcaqerlua [?] makunek pillruunga."
        },
        "79": {
            "start": 1452.58,
            "end": 1465.96,
            "transcript": "Calituliunricaaqua taqeksaunata-ll' makut. Makucimek-llu piliksaunii ciungag' waniw' taqungenrilengraan nasvakarkamnek makunek piqallruunga."
        },
        "80": {
            "start": 1465.96,
            "end": 1471.58,
            "transcript": "Nunavceńi-llu-qaa tamakut angallanek aptuaci wall' ipuutnek?"
        },
        "81": {
            "start": 1471.58,
            "end": 1479.58,
            "transcript": "Ipuut piciatengqertut amllernek makut nunat qaneryarait ayuqenrilameng."
        },
        "82": {
            "start": 1479.58,
            "end": 1487.58,
            "transcript": "Qaneryarait ayuqenrilameng atrit amlleriut cali makut."
        },
        "83": {
            "start": 1487.58,
            "end": 1494.58,
            "transcript": "Qantuya'aqlua tau͡ga tamamta tau͡gaam cat atrit allauruluteng pituameng."
        },
        "84": {
            "start": 1494.58,
            "end": 1499.04,
            "transcript": "Cakucinek muragnek aturluten tamakut caliaqellrusiki?"
        },
        "85": {
            "start": 1499.04,
            "end": 1505.08,
            "transcript": "Atata. Makut maa-i muriit makut temait."
        },
        "86": {
            "start": 1505.08,
            "end": 1512.76,
            "transcript": "Quugnek muragnek quugnek-llu unarcianek pituukut makunek."
        },
        "87": {
            "start": 1516.56,
            "end": 1532.42,
            "transcript": "Wiinga calituliunricaaqua tau͡gaam makut ut'ruskumegtaqkaqngamki ukut assinritnek patagalua pinrilkuma piliyugngaunga."
        },
        "88": {
            "start": 1532.42,
            "end": 1552.58,
            "transcript": "Ukut taluyat can'giircuutnguut. Apqemteńi imangarcuutnguluteng makut, ukut makut makucililartukut waten unarciamek qupurrirraarluta, unarcianek yuarumarraarluta."
        },
        "89": {
            "start": 1552.58,
            "end": 1561.58,
            "transcript": "Tua-i-ll' cali ataam makunek cali yuarumaluta makukaitnek apqemteńek nemiarutkanek."
        },
        "90": {
            "start": 1561.58,
            "end": 1563.2,
            "transcript": "Tamakut qapercetulit?"
        },
        "91": {
            "start": 1563.2,
            "end": 1568.58,
            "transcript": "Per'et keggmalriani waten per'etuut waten ayuqliriluteng."
        },
        "92": {
            "start": 1568.58,
            "end": 1577.58,
            "transcript": "Ilait, ilait-am tau͡gaam tegqerrailguut waten makut tegqerpallurnek pilget assinrulartut, tuumanrulartut."
        },
        "93": {
            "start": 1577.58,
            "end": 1593.78,
            "transcript": "Cali-llu makunek wangkuta apqemteńek napanek kevraartegnek makucirkartelartukut, makut tepaat."
        },
        "94": {
            "start": 1593.78,
            "end": 1603.76,
            "transcript": "Kuigpagmi tepaat, ilait elnguitut makut makuungerma ellnguitlartut ayemcurluteng."
        },
        "95": {
            "start": 1603.76,
            "end": 1610.28,
            "transcript": "Tau͡gken makut imkut kevraarrlunek pitukeput assinruluteng makuni. (Naumalriit.)"
        },
        "96": {
            "start": 1610.28,
            "end": 1631.74,
            "transcript": "Ii-i, naumalriit. Naumalriit kevraartut assinruluteng makuni makut Kuigpagkun aterqaqellret up'nerkami ilait elnguitut ilait. Assirluteng-gguq pituyaaqut waten assirluteng ilait."
        },
        "97": {
            "start": 1631.74,
            "end": 1646.84,
            "transcript": "Ilait-am taumek cali assirluteng qupsuitut waten qup'uralriani kellgarput [?] pilrianek caqiurluteng ayagaqer' waten eliurluteng piaqluteng ilaita waten akerpak, akerpak piaqluteng."
        },
        "98": {
            "start": 1646.84,
            "end": 1658.68,
            "transcript": "Makut can'giit, wiinga tang au͡gkutgun atamkun-llu atallemkun apa'urlukun."
        },
        "99": {
            "start": 1658.68,
            "end": 1670.4,
            "transcript": "Apa'urluqa au͡gna calitullruami, wangkuta tuqlutuaqa muriim qetunraanek."
        },
        "100": {
            "start": 1670.4,
            "end": 1681.76,
            "transcript": "Muriim [?] apa'urluqa calitullruuq piciatun. Canek makut caliarat amllertuq."
        },
        "101": {
            "start": 1681.76,
            "end": 1693.98,
            "transcript": "Maa-i cali makut wani yualut makut cali nekevraartut pikait wangkuta aterpagtaqluki."
        },
        "102": {
            "start": 1693.98,
            "end": 1704.58,
            "transcript": "Nekevraartut imkut naumalriit unguvalriit aciit maa-i tua-i camaken. (Acilquitnek-qaa?) Ii-i."
        },
        "103": {
            "start": 1704.58,
            "end": 1711.22,
            "transcript": "Maa-i makut qupurrluki qeltairraarluki qupurrluki-llu."
        },
        "104": {
            "start": 1711.22,
            "end": 1713.58,
            "transcript": "Canek calissuutnek aturluci (tamakut)?"
        },
        "105": {
            "start": 1713.58,
            "end": 1719.9,
            "transcript": "Calissuutaitnek makut aturluta wiinga calissuutaitnek."
        },
        "106": {
            "start": 1719.9,
            "end": 1740.42,
            "transcript": "Pelkaraallugmek perelrianek waten nuulget puungqerrluteng piciatun puulituaput wangkuta qagaani nunamteni cirunernek piciatun tugkarnek piciatun puulirluki makucilissuutek'laraput."
        },
        "107": {
            "start": 1740.42,
            "end": 1764.96,
            "transcript": "Ava-i au͡gkut niitetullruut watua-llem qanerlallrulriaten cikuliurutni imkut. Ak'allaq yuut reindeer, piciatun reindeer horn, tamakunek aturluteng cikumamturiaqan [?] cikuliuteng, tamakunek enulirraarluki-llu."
        },
        "108": {
            "start": 1764.96,
            "end": 1776.8,
            "transcript": "Qaill' piaqata tayima iqmiaqurluku urugcira'arlarait qaill' ataam aturluki tuaten makut."
        },
        "109": {
            "start": 1776.8,
            "end": 1779.98,
            "transcript": "Cam nalliini muragnek cumertenglarceci?"
        },
        "110": {
            "start": 1779.98,
            "end": 1787.8,
            "transcript": "Piciatun wii cumertetuunga uksungraan-lli piugaqama kiagungraan-llu piciatun."
        },
        "111": {
            "start": 1789.58,
            "end": 1798.8,
            "transcript": "Calissuutenka makunun egtarkaurluutenka, taqkuma."
        },
        "112": {
            "start": 1798.8,
            "end": 1807.66,
            "transcript": "Natait tuaten-qaa piurarraarluki qaillun cuqluki tamaqulituat taluyacuarnek?"
        },
        "113": {
            "start": 1807.66,
            "end": 1822.36,
            "transcript": "Makut cuqyutaitut makut, wiinga cuqyutaitua makunun, angelriamek-llu piliyulriamek pinarquq waten taktaqellrianek piliyulrianek pinaq', ayuqenritut makut."
        },
        "114": {
            "start": 1828.42,
            "end": 1841.48,
            "transcript": "Makut can'giirrlainarluni atuuluteng qagaani Kuigpagmi, kiagmi-llu neqsuutekluki."
        },
        "115": {
            "start": 1841.48,
            "end": 1851.1,
            "transcript": "Waten cap'iluteng kanani-ll' iquani assigurrluki waten."
        },
        "116": {
            "start": 1851.1,
            "end": 1861.86,
            "transcript": "Caputet takliriluki wangkuta aqpemteńek asgurcuutnek pitullruit kiagmi neqsuuteng makut taryaqvagcuutnek kangiqnercuuteteng."
        },
        "117": {
            "start": 1861.86,
            "end": 1876.82,
            "transcript": "Piciatun neqa makucit tegutuat, piciatun neqa. Ayuqenrilnguq neqa tegutullruat kuvyanek pingvailegmeng."
        },
        "118": {
            "start": 1876.82,
            "end": 1888.6,
            "transcript": "Taluyanek-am atengqerrluteng taluyaq waten taluyaungyaqluteng caputnguluteng."
        },
        "119": {
            "start": 1888.6,
            "end": 1909.34,
            "transcript": "Taum taluyam caullrit apertuqerki natiinqellriit [?], tauna au͡g'atukan-llu aperturluku, qaillun-llu ciptellrit wall'u-q' cip' qaillun ima?"
        },
        "120": {
            "start": 1910.5,
            "end": 1918.42,
            "transcript": "Au͡gkut makut neqsuutet kiagmissuutet."
        },
        "121": {
            "start": 1927.42,
            "end": 1936.46,
            "transcript": "Takuigaqavci qaillun piluki pilarceci, wall' (atata) civcivailegpeci qaillun piluki pilartat?"
        },
        "122": {
            "start": 1936.46,
            "end": 1947.42,
            "transcript": "Kepuqerraqerlaki makut cali kepuusqeciqai, egtarkautnguut ukut, wall'u-q' cauluki."
        },
        "123": {
            "start": 1952.6,
            "end": 1961.72,
            "transcript": "Anelga caaksugtai [?] aptenqegcaurarraarlua pikina. [?]"
        },
        "124": {
            "start": 1961.72,
            "end": 1974.54,
            "transcript": "Ukut piciatun elligyarait tatngameng nanilngurnek piliarkaullruyaaqua ukut egtarkautnguata [?] waten."
        },
        "125": {
            "start": 1974.54,
            "end": 1978.8,
            "transcript": "Caullrit camek aterpagtelallrit tamakut?"
        },
        "126": {
            "start": 1978.8,
            "end": 1994.24,
            "transcript": "Makut cali taluyiit, makut-ll' Kuigpagmi amkut iluliraitni, iluqliungata waten can'giircuutet piciatun taluyat neqsuutet cali neqsuun..."
        }
    },
    "0CDj4LvHnOU": {
        "1": {
            "start": 3.21,
            "end": 7.99,
            "transcript": "Una waniwa-gguq agya man'a."
        },
        "2": {
            "start": 7.99,
            "end": 22.75,
            "transcript": "Ima, ima wiinga Umkumiuni tayima allgumanrilngurmek ziplock-am iluani waten ayuqluni allgumavkenani ek'illruunga."
        },
        "3": {
            "start": 22.75,
            "end": 36.548,
            "transcript": "Ziplock-am iluanun inerquulluku allgisqevkenaku tayim' uitauq. Qangvaq imumi amllellruut makut agyanun anaqelarnikait."
        },
        "4": {
            "start": 36.548,
            "end": 39.583,
            "transcript": "Tuar maa-i cuyauluni-ll' man'a."
        },
        "5": {
            "start": 39.583,
            "end": 52.82,
            "transcript": "Tutgarqa kassuuteqatallrani Napaskiarmun ayallemteńi alqaan irniara callarrluni qanra qiangyugluni."
        },
        "6": {
            "start": 52.82,
            "end": 67.34,
            "transcript": "Tua-ll' au͡g'um ciuniumavimta tutgarma taum panian aanii. Tauna tua-i pania tutgaramnek kassuuteqatar[tuq]."
        },
        "7": {
            "start": 67.34,
            "end": 80.821,
            "transcript": "Angutni pia, \"Imna nauwa kacuuq kiag' imumi nalaqutallren agya man'a, natmun ellillrusiu?\" aperturluku."
        },
        "8": {
            "start": 80.821,
            "end": 91.42,
            "transcript": "Apertuaku pia, \"Kitak tua-i tauna aitarrluku qanra kaimiu'.\" Kaimesqelluku. Kaimluku."
        },
        "9": {
            "start": 91.42,
            "end": 101.583,
            "transcript": "Tua-i tang egmian tuar tang assiriqertell' qanra calkacagalleq. Uumi imanek waniwa kaimvikluku."
        },
        "10": {
            "start": 101.583,
            "end": 111.85,
            "transcript": "Tangerqerrallem[ni] tuar tang iqmigkiuraq cuyaq man'a qai'. Im' tangvagaqamteki tau͡gken pagaani qaterluteng ayagartaqlu[teng]."
        },
        "11": {
            "start": 111.85,
            "end": 125.5,
            "transcript": "Tua-i-am makut maa-i agyanun anaqnilaqaat. Cami imumi amllellruut anaqullratni pingatut tamaa-i."
        },
        "12": {
            "start": 125.5,
            "end": 135.12,
            "transcript": "Tangssugaqamteki tau͡gken kenruurluteng ayagarrluteng."
        },
        "13": {
            "start": 135.12,
            "end": 142.45,
            "transcript": "Tua-i tungiinun uum waniwa kiingan ava-i qanerkaqa maniaqa."
        },
        "14": {
            "start": 142.45,
            "end": 151.536,
            "transcript": "(Taum-qaa qanret eyalriim [?] qanret callarturalriim tamakucimek [?]?) Yaa, taum tua-i."
        },
        "15": {
            "start": 151.536,
            "end": 162.1,
            "transcript": "Qam'um iluanek urraarmek qam'umek. ([?]) Amllenrilengraan kanevluku."
        },
        "16": {
            "start": 162.1,
            "end": 166.393,
            "transcript": "Nutaan-llu tua-i tuani iinruullrat nallunrillrukeka."
        },
        "17": {
            "start": 166.393,
            "end": 183.73,
            "transcript": "Taum tua-i Napaskiarmium angutni tua-i piluku kiag' imumiirluni [?] iqvallermeggni nalaqutallra. Natmun ellillranek apqesqelluku."
        },
        "18": {
            "start": 183.73,
            "end": 187.012,
            "transcript": "Tuaken tua-i qanra kaimesqelluku."
        },
        "19": {
            "start": 189.833,
            "end": 201.73,
            "transcript": "Cami imumi amllerrluteng tua-ll' iliit allgumanrilnguq tan'gurraata makut mikelnguut itrutaqlua caullritnek aptaqlua."
        },
        "20": {
            "start": 201.73,
            "end": 212.667,
            "transcript": "Allgumanrilnguq ziplock-amun ekluku-ll' Umkumiuni tayima uitaviktullemta iluani uitauq."
        },
        "21": {
            "start": 212.667,
            "end": 217.68,
            "transcript": "Allgumavkenani waten ayuqluni."
        },
        "22": {
            "start": 217.68,
            "end": 225.12,
            "transcript": "Tuar maa-i man' cuyaulalria arau-w' [?] qamna call' iluani."
        },
        "23": {
            "start": 225.12,
            "end": 235.7,
            "transcript": "(Imait-wa tamakut ayuqelalriit. Tuar imna piyuggai [?] color-ait mallguulaqait tamakut imaita.)"
        },
        "24": {
            "start": 235.7,
            "end": 237.02,
            "transcript": "Imaita."
        },
        "25": {
            "start": 237.02,
            "end": 238.78,
            "transcript": "(Ii-i, imaita, yaa.)"
        },
        "26": {
            "start": 238.78,
            "end": 249.58,
            "transcript": "(Aruvaar imna agturyartullrulrianun aruvaarqelallrit taum tuaten taum mallguuqapigtaa.)"
        },
        "27": {
            "start": 249.58,
            "end": 255.631,
            "transcript": "Tuani tua-i nutaan iinruullinillra nallunrirluku."
        },
        "28": {
            "start": 255.631,
            "end": 262.94,
            "transcript": "Tua-i kinguakun kina-im' iinrunqigteksaunani. Wiinga-am utrucaaqellruunga malrugnek."
        },
        "29": {
            "start": 262.94,
            "end": 279.06,
            "transcript": "Tua-ll'-am irniama, wiinga-ll' nutaan tamaani iinruullran ayallemni nallunrillruamku qelkesqumanrilatku tua-i eggluku."
        },
        "30": {
            "start": 279.06,
            "end": 289.988,
            "transcript": "Tauna tau͡gaam tamaa-i allgumanrilnguq Umkumiuni uitauq. Uitavikelallemteńi iluani ziplock-am iluani ekumaluni."
        },
        "31": {
            "start": 300.35,
            "end": 310.86,
            "transcript": "Iillakellruanka iinruullinillrat. Imkut pagkut [?] tangssugaqamteki imumirpakenruluteng. (Qaamleqtaalriit [?]) Ii-i."
        },
        "32": {
            "start": 310.86,
            "end": 322.917,
            "transcript": "Ayagarcetullrat umyuaqluku tungullinillratnek. Tuar ilumun iqmigkiuraq cuyaunganan' man' qainga."
        },
        "33": {
            "start": 327.16,
            "end": 345.94,
            "transcript": "(Tamakut-wa tangrrulalriit tangrruyungaqameng, tua-i-ll' kinercameng, agtuq'ameng-llu puyillagluteng, aruvillagluteng tamatumek aruva' kanenarluni [?] piyuggairten [?].)"
        },
        "34": {
            "start": 345.94,
            "end": 355.714,
            "transcript": "(Tamakut-wa unailngatqapiggluni imutun tua-i dust-atun ayuqluni taum tamakut imait pircillakaryuguapiggluni pilartut.)"
        },
        "35": {
            "start": 358.58,
            "end": 368.345,
            "transcript": "Ing'um-am yaa-i naken-kiq taitau? Naken tegulqau? (Anchorage.)"
        },
        "36": {
            "start": 368.345,
            "end": 377.976,
            "transcript": "(Tauna-qaa [?] teguluku cangaituq.) Cangaituq. Cayuitut. (Kiik taiteqerru [?].)"
        },
        "37": {
            "start": 377.976,
            "end": 386.42,
            "transcript": "Makut waten ayuqellriamek ak'a tangellruyaaqua nunam qaingani."
        },
        "38": {
            "start": 386.42,
            "end": 397.774,
            "transcript": "Tua-i waten uutun ayuquq, ak'a. Tau͡gaam cauciinaku agturpek'naku-llu unitellruaqa, ak'a."
        },
        "39": {
            "start": 397.774,
            "end": 407.4,
            "transcript": "Taum kinguakun tangenqigteksait'. Waten uucetun angtataluni, waten callguungaluni [?], uitaurluni."
        },
        "40": {
            "start": 407.4,
            "end": 422.35,
            "transcript": "Cauciilamku, makucimek-llu tangeqsailama ciungaku unitellruaqa tuaten nuniinun agturpek'naku teguvkenaku-llu."
        },
        "41": {
            "start": 422.35,
            "end": 431.726,
            "transcript": "Tua-i-wa-wa elitaqevkarna [?] ugna tangellruyaaqua nunapiim qaingani makucinek, ak'arraq tayima."
        },
        "42": {
            "start": 431.726,
            "end": 440.56,
            "transcript": "Qavciurtutallrakut [?] tayima, akimaiaq-llu yuinaq-llu tayima pimangengataqa."
        },
        "43": {
            "start": 440.56,
            "end": 447.107,
            "transcript": "Tau͡gaam agturpek'naku waten unitellruaqa, [?]-rraarluku."
        },
        "44": {
            "start": 447.107,
            "end": 459.26,
            "transcript": "Waten callgumaluni waten angtata' uutun cuyatun ayuqut qaingit. Cuyatun ayuqngalliniut. Cauciitellruaqata tua-i wii."
        },
        "45": {
            "start": 459.26,
            "end": 472.87,
            "transcript": "Wiinga-ll' nutaan tuani iinruutullinillrat nallunrillruaqa, tutgarqa kassuuteqatarluni alqaan qetunracuarii callarrluni cakneq qanrat."
        },
        "46": {
            "start": 472.87,
            "end": 481.81,
            "transcript": "Tua-i taum cakirkaan uini apluku, kiag' imumi iqvallermegni nalaqutallran natmun ellillranek."
        },
        "47": {
            "start": 481.81,
            "end": 489.14,
            "transcript": "Tua-i tangssugpek'naku qanrakun kaimesqelluku qanrulluku."
        },
        "48": {
            "start": 489.14,
            "end": 503.774,
            "transcript": "Tua-i egmian assiriqernganani tauna. Tua-i-ll' kinguakun tuani tua-i qeleknaluku piyaaqluku malrugnek ut'rucaaqlua."
        },
        "49": {
            "start": 503.774,
            "end": 514.43,
            "transcript": "Pingayuak tauna tayima alkumavkenani Umkumiuni uitavikelallemta iluani ziplock-am iluani uitauq."
        },
        "50": {
            "start": 514.43,
            "end": 528.87,
            "transcript": "Irniama-am qelkesqumanrilatgu canaqnayukluku, taumek-llu qanemcinge'rma egtesqengatgu-am tua-i egglukek malruk taukuk."
        },
        "51": {
            "start": 528.87,
            "end": 535.191,
            "transcript": "(Makut-am angtatenritut cali. Tua-i angtuarulliniuq.)"
        },
        "52": {
            "start": 535.191,
            "end": 545.107,
            "transcript": "Wiinga-llu pulengtaq tanglartua. Ilait tua-i mikluteng piaqluteng, ilait-llu angliriinarluteng."
        },
        "53": {
            "start": 545.107,
            "end": 555.49,
            "transcript": "Angtatkenritut-am tamakut tangrruaqameng maani nunam qaingani tangrruyugaqameng-wa tua-i tangrrulallrit."
        },
        "54": {
            "start": 555.49,
            "end": 571.19,
            "transcript": "Wiinga-llu camun iinruuciit-llu nallulaamki tangvaggaarluki, ciuqlirmi tangerqarraallemni, agtullerkaa ancurtukluku poison-aarnayukluku."
        },
        "55": {
            "start": 571.19,
            "end": 580.71,
            "transcript": "Wiinga-ll' tau-i nutaan taum nalliini nallunrirluki, tuaten ayuqellinillrat."
        },
        "56": {
            "start": 580.71,
            "end": 589.845,
            "transcript": "Wangkuta maa-i ciuliaput ilaita ap'larait [?] agayumanritellratni-gguq yuut."
        },
        "57": {
            "start": 589.845,
            "end": 597.536,
            "transcript": "Ilaita-llu ciuliaput-gguq au͡gkut caitellruut."
        },
        "58": {
            "start": 597.536,
            "end": 610.54,
            "transcript": "Tau͡gken wiinga ciuliaput tangrruarturarqamteng nutaan agayumapialriarullrulalliniut ciuliaput."
        },
        "59": {
            "start": 611.51,
            "end": 618.345,
            "transcript": "Uumek tau͡gaam kiingan tua-i anglluucimek qaneryarait qallruluteng [?]."
        },
        "60": {
            "start": 618.345,
            "end": 629.012,
            "transcript": "Maa-i-llu yuut qantuluteng ciuliat-gguq qanruyutait Bible-aani uitaut, yuut ilait qantuluteng."
        },
        "61": {
            "start": 629.012,
            "end": 639.94,
            "transcript": "Ak'a tang tamakut ciuliaput ayagmek Agayutem aulukellrullinikai tua-i pikiumaluki."
        },
        "62": {
            "start": 641.79,
            "end": 657.381,
            "transcript": "Anglluumanrilnge'rmeng ak'a Tanqilriim Anernerem umyugait imiumallratgun alerquutait, qanruyutait, Bible-aat imaitni cangalkuvkenateng."
        },
        "63": {
            "start": 657.381,
            "end": 667.048,
            "transcript": "Tua-i-llu maa-i tuaten Agayutem aulukngamiki, makutgun maa-i naunrarteggun wall' naunraunrilngurteggun,"
        },
        "64": {
            "start": 667.048,
            "end": 675.512,
            "transcript": "cali ellaita tememeggnun atuuyungalriit taringumaluki pillrulliniluteng."
        },
        "65": {
            "start": 675.512,
            "end": 685.012,
            "transcript": "Cat ikayurkateng tememeggnun yuucimeggnun-llu tua-i nalluvkenaki."
        },
        "66": {
            "start": 685.012,
            "end": 696.79,
            "transcript": "Tamaa-i qanruyun maligtaquluku yuulriit ak'a anirtuumarilriarurcullrulliniluteng."
        },
        "67": {
            "start": 696.79,
            "end": 707.214,
            "transcript": "Tangertengqetulliniluteng-llu ak'a uyaqumegteggun alimeng nuugitgun akumegteggun-llu tanqigmek anlluggluteng."
        },
        "68": {
            "start": 707.214,
            "end": 723.3,
            "transcript": "Amta-llu maa-i ilait agayumallrunrilngurnek apraqluki. Wii tang umyuamkun tangrruartura'arqamki nutaan-lli agayumapialriarullrullinivaa au͡gkuni."
        },
        "69": {
            "start": 723.3,
            "end": 741.39,
            "transcript": "Waken unuakuarmek maktaqata ayagyuateng tan'gurraat nasaurluut-llu ernerpak piicagturallerkaatnek alerqualalliniluki tua-i maktellratnek ayagluki yaavet erenrem iquklitellranek."
        },
        "70": {
            "start": 741.39,
            "end": 757.22,
            "transcript": "Umyuarteqlerkait apertuagurallermeggni atu'urkait apertuagurallermegteggun tuarpiaq ernerpak piicagturaasqelluki qalarut'lallrullinikait."
        },
        "71": {
            "start": 757.22,
            "end": 767.607,
            "transcript": "Maa-i tau͡gken wangkuta nallemteńi agayumalrianek apngengaceteng yuut, wiinga-qaa kiima pilartua."
        },
        "72": {
            "start": 767.607,
            "end": 774.214,
            "transcript": "Unuakumi makcaurrlua ernerpak umyuarteqlerkanka neq'akevkenaki."
        },
        "73": {
            "start": 774.214,
            "end": 785.63,
            "transcript": "Avani maktetullruyaaqlua apertuagitullratni ernerpak waten piurciqua yaavet erenrem iquklitellranun."
        },
        "74": {
            "start": 785.63,
            "end": 798.274,
            "transcript": "Alerquutait cali uniurteqaqsiyaallerkait pitsaqutmek qigcignaqluteng ernikumta ernerpak tangvagtailengramta qalarcetulinek."
        },
        "75": {
            "start": 798.274,
            "end": 804.87,
            "transcript": "Alerquatait imkut uniurtassiyaagnek pillerkait qigcignaqluteng."
        },
        "76": {
            "start": 804.98,
            "end": 822.56,
            "transcript": "Tamaa-i tuaten ayuqngan Agayutem ayagmek ciuliaput aulukellrulliniceteng atu'urkiumaluteng nerrlermegteggun, maaggun caurallermegteggun."
        },
        "77": {
            "start": 822.56,
            "end": 834.92,
            "transcript": "Tua-i man'a maani nutem ciuliamta piciryaraat umyuaqelriani ayagmek pikiumaluki ciuliaput,"
        },
        "78": {
            "start": 835.49,
            "end": 847.036,
            "transcript": "makunek kallugnek canek calissuullugpagnek piilengraata ellaita tegularluki piyugngak'ngaitnek piiturarkauvkarpek'naki."
        },
        "79": {
            "start": 847.036,
            "end": 863.56,
            "transcript": "Maa-i tua-i man'a nutem piciryararput ilumun ellam piunrillrani tau͡gaam atunriarkauyaaqellerput wangkutnek pivkenata tau͡gaam imutun,"
        },
        "80": {
            "start": 864.38,
            "end": 869.143,
            "transcript": "alarutestellegtun ayuqngamta katagyaaqellruarput."
        },
        "81": {
            "start": 869.143,
            "end": 878.667,
            "transcript": "Ataam tau͡gaam maa-i Agayutem umyuamteggun cali makut ciuliqagteput umyugaitgun,"
        },
        "82": {
            "start": 878.667,
            "end": 892.12,
            "transcript": "au͡g'umek ataam taringengevkaateng maa-i wangkutnun utelmun pingnaqlerkaat taringengaarluku-ll' maa-i wangkuta piyaaqluta."
        },
        "83": {
            "start": 893.4,
            "end": 902.786,
            "transcript": "Tua-i tamaa-i anglluucimek piicugngermeng anglluucingqellrulliniluteng call' ciuliaput."
        },
        "84": {
            "start": 902.786,
            "end": 913.869,
            "transcript": "Yug' una tan'gurraq wall' nasaurluq wall' yuk arenqilenripakarqan, tagcimek wall' merqemek aperyarirluku."
        },
        "85": {
            "start": 913.869,
            "end": 923.714,
            "transcript": "Merkun qalarulluku merqelluku-llu waten ayuqesqevkenaku arenqialliqutii tauna"
        },
        "86": {
            "start": 923.72,
            "end": 934.012,
            "transcript": "catairutesqelluku pillermegteggun angllurcetetullrulliniat tamaaggun tamaa-i ciuliamta ilateng."
        },
        "87": {
            "start": 934.012,
            "end": 945.0,
            "transcript": "Tamaa-i taumek qanruyutnek maligtaquluteng qanruyun maligtaqulurnaurtaarpek'nak [?] atungnaqestai."
        },
        "88": {
            "start": 945.0,
            "end": 955.37,
            "transcript": "Ak'a anirtuumariameng tamaa-i tangertengqetuluteng ilait anlluggluteng tanqigmek uyaqumegteggun aliimeng nuugitgun nakumegteggun-llu."
        },
        "89": {
            "start": 956.45,
            "end": 974.86,
            "transcript": "Qaill' agayumallrunritniluteng apernarqevkenateng ciuliaput agayumiimeng Bible-aat-ll' imaitnek qanruyuterluteng atuusqutait atuusqenrilutait nalluvkenaki."
        },
        "90": {
            "start": 974.86,
            "end": 991.38,
            "transcript": "Makuni-ll' agayulirtet apertuatukaitni kayunruluteng ayagyuameggnun aturluki. Ayagyuateng taringumavkarluki picurlallerkaat elluarrluteng-llu pillerkaat."
        },
        "91": {
            "start": 991.38,
            "end": 1001.536,
            "transcript": "Taumek atunem tan'gurraat nasaurluut-llu taringusngaluteng pillruameng atunem naanguaqutellrunrilnguut."
        },
        "92": {
            "start": 1001.536,
            "end": 1008.68,
            "transcript": "Pinariaqateng tau͡gaam uingaqluteng pinariaqateng nulirturaqluteng."
        },
        "93": {
            "start": 1008.68,
            "end": 1012.726,
            "transcript": "Naanguaqutevkenateng atunem."
        },
        "94": {
            "start": 1012.726,
            "end": 1028.34,
            "transcript": "Ciuliameng elucirqaullrat aturluki piamun assilriacetun egelrulluku taman' yuucirteng arenqiallugtaarpakalriartaunani-llu."
        },
        "95": {
            "start": 1028.34,
            "end": 1039.631,
            "transcript": "Tamakut-wa tamaani ak'allat qangarrutestait tuarpiaq angayulirtet. Agayulirtetun ayuqluteng."
        },
        "96": {
            "start": 1039.631,
            "end": 1052.405,
            "transcript": "Arenqilinrilnguq ellangcarluku ellangevkaraqluku. Elluarrluku pillerkaat taringevkarluku, elluarrluun [?] pinritlerkaat taringevkarluku."
        },
        "97": {
            "start": 1052.405,
            "end": 1061.833,
            "transcript": "Agayulirtetun tamakut ayuqellrulliniluteng apqait qalarucitulit qanaacitulit."
        },
        "98": {
            "start": 1061.833,
            "end": 1079.238,
            "transcript": "Wiinga tua-i nutaan agayumapialriaruluki ciuliaput tanglangan', umyuamkun tanglaranka, tuarpiaq wangkuta maa-i kinguliarluitni, ellam tau͡gaam tanqigcetellra paqingalriatun ellirluta tamamta."
        },
        "99": {
            "start": 1079.238,
            "end": 1084.98,
            "transcript": "Qaillun ellam tanqigtacia. Taringumanrilngurtem tua-i yuucirlirluta."
        },
        "100": {
            "start": 1086.02,
            "end": 1096.798,
            "transcript": "Apqiitnek au͡gkut paallallerkarput tau͡gaam kiingan ellaksagutellriatun ayuqluta tamamta ellirluta."
        },
        "101": {
            "start": 1096.798,
            "end": 1106.27,
            "transcript": "Ciuliat au͡gkut taringumanrilkiaralqaat wagg'uq paallallerkarput tau͡gaam kiingan ellakluku."
        },
        "102": {
            "start": 1106.63,
            "end": 1114.75,
            "transcript": "Ellailngurmun ayuqekulluta wall'u uriimta [?] tau͡gaam qagertellerkaat ellakluku."
        },
        "103": {
            "start": 1114.75,
            "end": 1136.88,
            "transcript": "Camek nallunrilkengaitelkelluta ayagyuameggni tuaten piaqamegtekut kenektacirmeggni tamana taringevkangnaqtullrullinikiit elluarrluni yuum pillerkaa, pinerrlugluni pillerkaa."
        },
        "104": {
            "start": 1137.27,
            "end": 1158.4,
            "transcript": "Tamaa-i tua-i makucetun maa-i yuum tememitun apqemteńek iinruaqetutengqellerkaatun, yuucirput-llu man'a qanruyutmek iinrutellriatun ayuqellrulliniluku ayagmek."
        },
        "105": {
            "start": 1158.4,
            "end": 1175.12,
            "transcript": "Maa-i wangkuta doctor-am wall' nurse-am pilissarrarmek cikiraqakut waten atuusqelluku ukveqluku atu'urqamteggu nall'arulluni tememteńun ikayuulartuq."
        },
        "106": {
            "start": 1175.12,
            "end": 1191.369,
            "transcript": "Tamaa-i-ll' cali qanruyun man'a ciuliat au͡gkut qalarutkelallrat ayagyuam ukveqluku niicugniluku atungnaqluku piaqami, yuuluaqautektulliniluku."
        },
        "107": {
            "start": 1191.369,
            "end": 1200.369,
            "transcript": "Temii-ll' man'a apqiitnek caqamlugtevkenani naulluutem pivakanrilngurtun eglerrluni tauna."
        },
        "108": {
            "start": 1200.369,
            "end": 1217.274,
            "transcript": "Tuarpiaq qanruyun iinruulriatun ayuqngan ukveqluku aturtai maligtaqustai temiit man'a calrilngurtun piuralriarutulliniluni."
        },
        "109": {
            "start": 1217.274,
            "end": 1231.55,
            "transcript": "Au͡gkut-llu Yupiit kangilitulliniluku maligtaqutellria, ernerraq-gguq aipirluku nangerngaciiquq. Tua-i nall'arusngaluteng tamakut."
        },
        "110": {
            "start": 1231.55,
            "end": 1245.107,
            "transcript": "Tuarpiaq tailalaan [?] ukveqluku wii mel'arqa iliini arenqilinritaqama, kinguani-llu ayuquciqa-am arenqianaqerrlullra nallunariluni."
        },
        "111": {
            "start": 1245.107,
            "end": 1260.09,
            "transcript": "Tua-i tuaten-llu au͡gkut ciuliat ayagyuameggnun qanruyun qalarutkaqamegtegu tuarpiaq ayagyuatun mercetellriatun yuuciat."
        },
        "112": {
            "start": 1260.09,
            "end": 1272.37,
            "transcript": "Elluarrluteng yuutekaatnek ayuqetullrulliniluki. Au͡g'umek ava-i umyuaqelallemnek qanqertua."
        },
        "113": {
            "start": 1272.37,
            "end": 1280.905,
            "transcript": "Wiinga-ll' cali nauwa au͡gkut ciuliaput nunat ikgelngermeng qasgingqelalriit."
        },
        "114": {
            "start": 1280.905,
            "end": 1291.095,
            "transcript": "Cali-ll' maa-i, watua maa-i nunat ikgelngermeng agayuvigluteng ayuqenrilngurnek."
        },
        "115": {
            "start": 1291.095,
            "end": 1295.58,
            "transcript": "Cali-ll' au͡gkut ciuliaput qasgirluteng."
        },
        "116": {
            "start": 1295.58,
            "end": 1302.881,
            "transcript": "Maa-i tua-i umyuaqelaranka tamakut qasgit agayuviullrulliniluteng."
        },
        "117": {
            "start": 1302.881,
            "end": 1311.11,
            "transcript": "Arnaq-ll' iterluni quuskegciryarturciiganani tamatum qasgim iluani."
        },
        "118": {
            "start": 1311.11,
            "end": 1319.22,
            "transcript": "Tamakut tamaa-i agayulirtet angulluat anyuunateng qasgim iluani uitaluteng."
        },
        "119": {
            "start": 1319.22,
            "end": 1332.405,
            "transcript": "Elissariluteng tan'gurrarnek ayagyuanek qanruciurluteng Bible-at, tuarpiaq Bible-aileng'e'rmeng, Bible-am imaa aturluku."
        },
        "120": {
            "start": 1332.405,
            "end": 1335.69,
            "transcript": "Kalikamek nallullrung'e'rmeng."
        },
        "121": {
            "start": 1335.69,
            "end": 1346.89,
            "transcript": "Man'a tua-i arniurner' arcaqerluku inerquutekluku wangkutnun-llu call' arnanun, teglek-llu inerquutaqellruluku."
        },
        "122": {
            "start": 1346.89,
            "end": 1354.84,
            "transcript": "Arcaqalriit Bible-at imait wangkutnun nepliuteku'urluki tan'gurarnun-llu."
        },
        "123": {
            "start": 1354.84,
            "end": 1364.24,
            "transcript": "Taumek wangkuta maa-i tan'gurraq-llu qaill' pisciigacetullrukput alikluku nangyaqluku."
        },
        "124": {
            "start": 1364.24,
            "end": 1375.04,
            "transcript": "Cali inerquumatullruluta angayuqamta, tan'gaurluq qimugkauyartun ayuqniluku ungaqercukaarniluku."
        },
        "125": {
            "start": 1375.04,
            "end": 1381.53,
            "transcript": "Avalitngusqevkenata tallurnaqciqniluta tuaten ayuqekumta."
        },
        "126": {
            "start": 1381.53,
            "end": 1386.99,
            "transcript": "Umyuamteńek tua-i au͡g'ararkaunrilngurmek qanrulluta pitullruitkut."
        },
        "127": {
            "start": 1386.99,
            "end": 1396.1,
            "transcript": "Cali una kiutekangqengramta uitauraasqelluta qanrucetullrukiikut."
        },
        "128": {
            "start": 1396.1,
            "end": 1402.6,
            "transcript": "Tua-i ca tamalkuan taumek wiinga maa-i umyuaqtukeka tamana qasgiq."
        },
        "129": {
            "start": 1402.6,
            "end": 1411.738,
            "transcript": "Agayuviullrulliniluni kiingan tan'gurrarnek yugluni agayulirtet-wa angulluat. Anyuunateng tamaa-i uitaluteng ilait."
        },
        "130": {
            "start": 1411.738,
            "end": 1417.09,
            "transcript": "Agayuviullrulliniluni kiingan tan'gurrarnek yugluni agayulirtet-wa angulluat. Anyuunateng tamaa-i uitaluteng ilait."
        },
        "131": {
            "start": 1417.09,
            "end": 1424.322,
            "transcript": "Ilumun tua-i piciularyarauluni tamana umyuaqtullrat tuaten."
        },
        "132": {
            "start": 1424.322,
            "end": 1437.429,
            "transcript": "Maa-i tau͡gken agayuvingqeng'ermeng-llu ayuqluta imangqesciigaliluni imutun imangqetullermikun pitullermitun."
        },
        "133": {
            "start": 1437.429,
            "end": 1444.39,
            "transcript": "Imaicugpagluni iliini imangqetunge'rmi."
        },
        "134": {
            "start": 1444.46,
            "end": 1454.18,
            "transcript": "Ayuqluta tuani unani tuaten maa-i ellilriakut agayuvigput ilaitni wangkuta maani arcaqakenrirluku."
        },
        "135": {
            "start": 1454.18,
            "end": 1461.21,
            "transcript": "Ciuliamta tau͡gken arcaqakellruluku tamaa-i piitellerkarteng qasgimek."
        },
        "136": {
            "start": 1461.21,
            "end": 1466.345,
            "transcript": "Tua-i una agya man'a taq'uq."
        },
        "137": {
            "start": 1466.345,
            "end": 1475.78,
            "transcript": "Pikestiinun tuniu. Tamarkenka."
        },
        "138": {
            "start": 1491.37,
            "end": 1506.86,
            "transcript": "Nauwa akwaugaq qanellrulrianga caranglluunge'rmeng ca tamiini angutengqerrniluku."
        },
        "139": {
            "start": 1506.86,
            "end": 1516.929,
            "transcript": "Ilumun cat tamarmi angutengqerrami, una waniwa qengalleq-gguq, wangkuta qengallegnek pituaput."
        },
        "140": {
            "start": 1516.929,
            "end": 1521.42,
            "transcript": "Una waniw' uum arniin angutekluku."
        },
        "141": {
            "start": 1521.42,
            "end": 1532.54,
            "transcript": "Makut maa-i arnauluteng kayangunek irniyugngaluteng, makut-ll' angutnguameng irnisciiganateng kayangunek."
        },
        "142": {
            "start": 1532.54,
            "end": 1538.881,
            "transcript": "Maa-i makut arnakluki. Una-wa angutii."
        },
        "143": {
            "start": 1538.881,
            "end": 1555.78,
            "transcript": "Avani ak'a anglanillrunrilameng ilii tua-i piyung'e'rmi tengmiarcuutnek-llu cakaunani tamaa-i pitullrulria."
        },
        "144": {
            "start": 1555.78,
            "end": 1564.5,
            "transcript": "Tua-i-am tamarkenka ukuk wani atkuutulik amiirumalutek waniwa."
        },
        "145": {
            "start": 1564.5,
            "end": 1572.512,
            "transcript": "Atam tau͡gaam uqurissiyaalriit amiit camlaillrulartut makut ayuqluteng. Makut elngunruluteng qeciit angutnguameng."
        },
        "146": {
            "start": 1572.512,
            "end": 1582.62,
            "transcript": "Makut-llu elnguillruluteng qeciit arnaungameng."
        },
        "147": {
            "start": 1582.62,
            "end": 1593.0,
            "transcript": "Tuaten tua-i makut ayuquk. Uuvlekatulukek-llu kemgek ayuqlutek. Waniwa un' uuvlekatuli."
        },
        "148": {
            "start": 1593.0,
            "end": 1603.738,
            "transcript": "Una-wa angutii call' ayuqlukek. Iliini angutait uquillruluteng makut-llu arnait uqurinriluteng."
        },
        "149": {
            "start": 1603.738,
            "end": 1615.46,
            "transcript": "Avani-am cumiksugallemni angucet keligyugaqameng arnamek keligkameggnek cikiisqelartut makucimek."
        },
        "150": {
            "start": 1615.92,
            "end": 1621.0,
            "transcript": "Arnaitnek nakmiluteng makunek pivkenaki."
        },
        "151": {
            "start": 1621.0,
            "end": 1632.667,
            "transcript": "Atkuutuluteng-llu call' maa-i makut atkuutullruluteng au͡gna iluralqa keserrlainarnek angun atkungqetullrulria."
        },
        "152": {
            "start": 1632.667,
            "end": 1638.47,
            "transcript": "Melqurrit ilumun au͡g'arngiallruluteng allami."
        },
        "153": {
            "start": 1638.98,
            "end": 1644.51,
            "transcript": "Makut-wa cali aipait wangkuta pituluki qau͡gernek."
        },
        "154": {
            "start": 1645.03,
            "end": 1651.976,
            "transcript": "Metraat-wa-gguq call' makuni angenruluteng."
        },
        "155": {
            "start": 1651.976,
            "end": 1660.905,
            "transcript": "Aipait waten ayuqluteng wangkuta qau͡gernek pituluki angutait-wa call' waten ayuqsaaqluteng."
        },
        "156": {
            "start": 1660.905,
            "end": 1671.02,
            "transcript": "Ilaita-llam maa-i tan'gurraat apertuuteng'e'rmeng ackiilegnek pilaqait makut arnait iingit qaraliarangqerrata."
        },
        "157": {
            "start": 1673.62,
            "end": 1680.441,
            "transcript": "Makut maa-i una wani waten arnekluku yaqulgem."
        },
        "158": {
            "start": 1680.441,
            "end": 1687.0,
            "transcript": "Waten call' ayuqsaaqelriameng qau͡gret, arnait-llu call' ayuqluteng."
        },
        "159": {
            "start": 1687.0,
            "end": 1698.81,
            "transcript": "Metraat-wa cali makuni angenruluteng ayuqsaaqluteng waten, tau͡gaam angenruluteng makuni. (Qengallegglainauguk.)"
        },
        "160": {
            "start": 1698.81,
            "end": 1708.012,
            "transcript": "Waniw' ukuk, (Qengallegglainauguk.) qengallrek angutii kiingan ukungqellruuq, arnii-llu tua-i waten ayuqluni."
        },
        "161": {
            "start": 1708.012,
            "end": 1719.583,
            "transcript": "Una call' qengarluni, uquuluni qengaa, una-llu piinani nulirra."
        },
        "162": {
            "start": 1719.583,
            "end": 1729.52,
            "transcript": "Cat tamarmi caranglluunge'rmi angutengqerrami, waniw' tua-i un' angutii uum, una-w' arnii."
        },
        "163": {
            "start": 1731.21,
            "end": 1734.0,
            "transcript": "(Cam nalliini pissutullruitki tamakut?)"
        },
        "164": {
            "start": 1734.25,
            "end": 1741.56,
            "transcript": "Up'nerkami, watua maa-i ayuqluteng up'nerkami tekicetuut makut yaqulget."
        },
        "165": {
            "start": 1741.56,
            "end": 1752.738,
            "transcript": "Ciuqliita makut uquillrulartut tekiteqarraalriit tua-ll' kinguqliit makut tekiskuneng uqurikayag', uquriluteng tamarmeng."
        },
        "166": {
            "start": 1752.738,
            "end": 1763.39,
            "transcript": "Egcuunaki-ll' au͡gkut ciuliamta kelingnaqu'urluki atkugkiurturluku amilek tamalkuan mik'lengraan."
        },
        "167": {
            "start": 1763.48,
            "end": 1779.714,
            "transcript": "Tuaten ayuqluteng. Cat tamalkuan amilek amiituli atkukengnaqtullruamegteki allgurluku caunrilkelluku pisciigacetuluku tau͡gaam pirpaku'urluku."
        },
        "168": {
            "start": 1779.714,
            "end": 1789.03,
            "transcript": "Wangkuta maa-i alerquutkellruluku-ll' wiinga ataucirraungraan qelkuraasqelluku."
        },
        "169": {
            "start": 1789.33,
            "end": 1797.702,
            "transcript": "Atam-gguq atauciuyaaqerraarluni amllerikuni atkugkanrurniartuq."
        },
        "170": {
            "start": 1800.07,
            "end": 1810.52,
            "transcript": "Ayuqluteng tua-i maa-i makut qeciit camlaillruluteng, makut-llu qeciit amiitelngunruluteng."
        },
        "171": {
            "start": 1812.56,
            "end": 1821.35,
            "transcript": "(Atkuliaqamegteki-qaa melqurrit) Caluki?(Atkuliaqamegteki melqurrit-qaa elatekluki piaqluki?)"
        },
        "172": {
            "start": 1821.97,
            "end": 1827.52,
            "transcript": "Angucet elatekvallutuit, arnat-llu qeciit elatekluki."
        },
        "173": {
            "start": 1827.52,
            "end": 1832.8,
            "transcript": "Melqurritgun-am call' makut maa-i mingqetuluki wangkuta."
        },
        "174": {
            "start": 1834.82,
            "end": 1848.82,
            "transcript": "Melqurritgun kiingan mingqetuluki. Nalluvkenaki tua-i qeciitgun mingqellerkaita ik'ikenruluki. Melqurritgun tau͡gaam."
        },
        "175": {
            "start": 1849.22,
            "end": 1855.429,
            "transcript": "Melqissiyaalriit apqiitnek tamarqelluki melqurrit."
        },
        "176": {
            "start": 1855.429,
            "end": 1863.04,
            "transcript": "Makut-llu melqurpiit au͡g'arluki pitullruaput. Makut maa-i melqurpait."
        },
        "177": {
            "start": 1864.35,
            "end": 1868.35,
            "transcript": "(Ellallinraan-llu-qaa metuyuunateng?)"
        },
        "178": {
            "start": 1868.87,
            "end": 1886.11,
            "transcript": "Melqurrit-wa tua-i mecungtenrilkurrluki pitull', ellarvassiyaagaqan tau͡gaam imarnitailkumta mecungluteng, qeciit-llu, amiit makut-llu elatekekuneng utumanruluteng."
        },
        "179": {
            "start": 1887.38,
            "end": 1896.98,
            "transcript": "Tua-i mecungeskata ciilqavkanrilkurrluki ulugturluki amiit kinevkatuluki."
        },
        "180": {
            "start": 1897.3,
            "end": 1914.429,
            "transcript": "Tua-i quyurrluki makut tua-i-llu uksuaryartuqan, tamakut tamaa-i makut qelkellerteng teq'iciriluteng, teq'umun atauci', ilaita amllellriit akurrluki."
        },
        "181": {
            "start": 1914.429,
            "end": 1923.73,
            "transcript": "Tua-i kenikata uquit, uquit call' au͡g'avsiarluki."
        },
        "182": {
            "start": 1923.73,
            "end": 1938.238,
            "transcript": "Au͡g'a', cali-am tamaani makut maa-i wagg'uq angularluku kinraumallratni, uquivlaagumalriit ciki'irqekikut angulaasqelluku alkaryaaqevkenaku."
        },
        "183": {
            "start": 1938.238,
            "end": 1947.69,
            "transcript": "(Keggmarluku?) Keggmarluku, mekeggluku [?] uqua au͡g'araqluku."
        },
        "184": {
            "start": 1947.69,
            "end": 1954.893,
            "transcript": "Tuaten tua-i pivkatullruit wangkutnun."
        },
        "185": {
            "start": 1954.893,
            "end": 1962.13,
            "transcript": "Cakneq tua-i cakaitellruameng makut maa-i amilget pikluki."
        }
    },
    "3s5DRwacMNI": {
        "1": {
            "start": 0.5,
            "end": 6.06,
            "transcript": "Una taqumanrituq cali. Taqumanritut makut."
        },
        "2": {
            "start": 6.06,
            "end": 10.56,
            "transcript": "Ak'a wii pillruaqa. Tamarkenka-qaa?"
        },
        "3": {
            "start": 10.56,
            "end": 18.08,
            "transcript": "Ukut-qaa tamalkuita pillruaten? Ukut-llu-qaa? Yaa canrituq. (Piyugngaunga.)"
        },
        "4": {
            "start": 18.08,
            "end": 26.8,
            "transcript": "Kitak aperturqerki caullrit natait tamakut waten-llu qipumalriit."
        },
        "5": {
            "start": 26.8,
            "end": 35.6,
            "transcript": "Makut maa-i cigyarnek pituaput makut. Maa-i makut makucit, unarciat."
        },
        "6": {
            "start": 35.6,
            "end": 48.98,
            "transcript": "Kuigpiim una-am [?] up'nerkami cup'aqami tapeqluki atertetuut maa-i maani-ll' tayim Kusquqvak pitullruuq pituuq muragnek."
        },
        "7": {
            "start": 48.98,
            "end": 62.04,
            "transcript": "Tua-i tamakunek yuarluta waten yuarluki. Illiini tang muriit tequut [?] amllenruluni [?] makucit nurnaklartut iliini."
        },
        "8": {
            "start": 62.04,
            "end": 68.64,
            "transcript": "Kiaget ilaitni pavani Kuigpagmi, yuaryaraugut."
        },
        "9": {
            "start": 68.64,
            "end": 81.22,
            "transcript": "Makut cali maa-i wangkuta napapianek pilaraput qau͡gkut napanek pitungerpeciki makut uqvialuk [?] wangkuta pituaput."
        },
        "10": {
            "start": 81.22,
            "end": 88.74,
            "transcript": "Ciin-gguq tauna ciungani uitalria umgutaa waten ayuqa?"
        },
        "11": {
            "start": 88.74,
            "end": 102.36,
            "transcript": "Una igyaraat una igyaraatnek taluyat pila' tapkut ukut carrauluteng piat (yaa tapkut) tapkutaksiak [?] wiinga takliqertengraata atagiima [?] pillruanka nanicaaqlartut."
        },
        "12": {
            "start": 102.36,
            "end": 106.7,
            "transcript": "Iveskuneng-qaa neqet itquneng anenritlerkait pingeqluki?"
        },
        "13": {
            "start": 106.7,
            "end": 118.4,
            "transcript": "Anngaunateng ugguut itquneng tua-i uitaarkaugut cali-llu neqerrlainarluni atalriarunritut."
        },
        "14": {
            "start": 118.4,
            "end": 128.82,
            "transcript": "Imumi ayatullemteńi ak'a wiinga-llu ellangellemni pissutullemteńi imumi melqulek man'a akitengnaquratullemteńi."
        },
        "15": {
            "start": 128.82,
            "end": 141.16,
            "transcript": "Makut maa-i imarmiutarcuutekluki pilitullruut, au͡gkunek-ll' aipairluku elpeci cavigni uumek pilaraci, Kuigpagmi-ll' wangkuta cinkarnek piaqluki."
        },
        "16": {
            "start": 141.16,
            "end": 154.8,
            "transcript": "Yaa tamakut angliriluki makut tamakussuutet pilarpiit tegpagnek wangkuta, yaa imarmiutarcuut tangevkenaki taluyacuaraat waten,"
        },
        "17": {
            "start": 154.8,
            "end": 172.58,
            "transcript": "Cavignek watua taluyagyuarcameng. Cavigglainarni ilulirait-llu makuit, ilulirait cavignek piliyaurrluku, muragnek pingnatutullruut ak'a."
        },
        "18": {
            "start": 172.58,
            "end": 185.02,
            "transcript": "Wiinga-llu makucinek aturlua pissuryaurteqerraallemni wii piliamni aturlua pitullruunga pikarquaten [?] kiagmi."
        },
        "19": {
            "start": 185.02,
            "end": 194.34,
            "transcript": "Wiinga cam iliini piciatun ernermi uksungraan-ll' iliini pitaitaqaama yuarlua makunek."
        },
        "20": {
            "start": 194.34,
            "end": 213.2,
            "transcript": "Apqemteńek wangkuta napanek Kuigpagmiunun nekevraarturnek pilallerpeceńek uksumi pilartut tamakunek Kuigpak qanikcangaqan, yuarluki napat wangkuta napanek pituaput."
        },
        "21": {
            "start": 213.2,
            "end": 228.76,
            "transcript": "Taqumalriit tamakut taluyaliaci nateqvani civingalartat? Canek iircuqataquvci [?] natmun civtelarcecitki?"
        },
        "22": {
            "start": 228.76,
            "end": 231.88,
            "transcript": "Imkuni kuicuarni."
        },
        "23": {
            "start": 231.88,
            "end": 241.12,
            "transcript": "Melqulegnek pissuqata'arqamta kuicuaraat amllerlartut maani-llu ilait nanvat-llu kuicuarengqerraqluteng."
        },
        "24": {
            "start": 241.12,
            "end": 254.92,
            "transcript": "Kuicaaq kuigni-llu maani kuigit apeqsartut [?] waten ilait kuicuarangqerraqluteng tamakunun iqkilngurnun civeqlaraput makut melqulegcuutekluki piaten [?] qagaani nunamteńi."
        },
        "25": {
            "start": 254.92,
            "end": 261.34,
            "transcript": "Neqnun-mi can'giircuqataquvci nani?"
        },
        "26": {
            "start": 261.34,
            "end": 270.82,
            "transcript": "Can'giiret cali makut maani-llu tayima pilartut nanvat uksuarmi anyuglartut ilait nanvat kuilget [?]."
        },
        "27": {
            "start": 270.82,
            "end": 276.28,
            "transcript": "Qaillun caulluku civtelartat? Carvaren-qaa cauluku wall' waten tunulluku?"
        },
        "28": {
            "start": 277.2,
            "end": 288.62,
            "transcript": "Ayuqenritut. Qagaani ayuqenritut ilait uksuarmi nanvarnek kuilget anyuglartut. Carvanrem maliggluki cetuluteng."
        },
        "29": {
            "start": 288.62,
            "end": 299.48,
            "transcript": "Ilait-llu up'nerkami wangkuta apqemteńek mayur' asuurluteng [?] carvanrem cauluku civtaqluki."
        },
        "30": {
            "start": 299.48,
            "end": 311.98,
            "transcript": "Mayurturalriik can'giiret qang'a-llu neqet cuukviit pike fish keggsulit-llu tamakut-llu tamaa-i."
        },
        "31": {
            "start": 311.98,
            "end": 324.02,
            "transcript": "Piciatun makut neqkat piciatun. Kiagmi-llu taryaqvagnek qavlunanek."
        },
        "32": {
            "start": 324.02,
            "end": 338.12,
            "transcript": "Piciatun neqa nutaan amlleret teguluku makut kiagmi capuciluteng waten nunarcianek nunamteńi waten pilirluni makunek yualulirluki. (Uksumi-ll' manignat.)"
        },
        "33": {
            "start": 338.12,
            "end": 345.56,
            "transcript": "Uksumi-llu manignamek. Waten-am cap'iqatarqameng."
        },
        "34": {
            "start": 353.82,
            "end": 364.0,
            "transcript": "Waten-am makultuvkenaki ekivikluki, iqtutaciatun man'a meq ekivikluki."
        },
        "35": {
            "start": 364.0,
            "end": 379.64,
            "transcript": "Tamalkuan takengraata waten, takliriluki pingraata, kanani-llu kituquurluki waten ussukcaitellermeggni waten makunek tau͡gaam pingqetullemegnun waten makucetun killerquurluki."
        },
        "36": {
            "start": 379.64,
            "end": 389.96,
            "transcript": "Nutaan-llu kanani iquat yaassiigurrluteng waten temait, temait amiingqer' makucinek pilirluki."
        },
        "37": {
            "start": 389.96,
            "end": 404.72,
            "transcript": "Tuaggun caputgun atrarqamegnun puukaquurluku tuaggun-ll' amiigat tua-i tekicami wani amiingata allanek tuaggun-am kiigatgun piciatun qaiterluni."
        },
        "38": {
            "start": 404.72,
            "end": 422.02,
            "transcript": "Ukunun-am taluyanun cali ataam iterluteng wani nutaan anenqigngaunateng, yuitat tau͡gaam yuitat takukanigtegu [?] nutaan una au͡g'arluku angyangqerquni angyamun kuvluki [?]."
        },
        "39": {
            "start": 422.02,
            "end": 430.64,
            "transcript": "Ernerni qavcini (piciatun unugpak-llu) civingalarta taluyat unuaquaqan-qaa paqcetuit (unuaquaqan) wall'u-qaa ?"
        },
        "40": {
            "start": 430.64,
            "end": 440.72,
            "transcript": "Kiagmi, kiagmi unuaquaqan qagaani pitullruit waten neqsuutekluku piaqamegteki."
        },
        "41": {
            "start": 440.72,
            "end": 459.08,
            "transcript": "Kuvyailnguut, kuvyamek, kuvyamek civciyumiluteng atak, yuunaki uqiyvik [?] cikuyungellranun piktullrit imumi ak'a makut neqsuutekluki kiagmi."
        },
        "42": {
            "start": 459.3,
            "end": 460.5,
            "transcript": "Tua-i neqa neqet..."
        },
        "43": {
            "start": 460.5,
            "end": 469.72,
            "transcript": "... waten qaterrlainarniluteng pilriit, tepaat Kuigpagmun atertellret nekevraartuularyaaquq."
        },
        "44": {
            "start": 469.72,
            "end": 479.4,
            "transcript": "Tau͡gaam waten tegg'armek aviitaqameng im' [?] (maqikellrat-llu?) Ii-i."
        },
        "45": {
            "start": 479.5,
            "end": 494.06,
            "transcript": "Tua-llam neq'akenritqapiararqa makucimek unarciamek makucituut makuguciutullrat neq'aqa'arqa tau͡gaam maani tekicimariuq imkun."
        },
        "46": {
            "start": 494.06,
            "end": 509.9,
            "transcript": "Wangkuta apqemteńun nemercinek piaqluki unavciaq, waten qeluk-wa (qeluk niitellerrmeggnek) yaa waten melkarkun [?] piq'erraarluku waten mamtutaarcelluki."
        },
        "47": {
            "start": 509.9,
            "end": 522.52,
            "transcript": "Piuralria [?] tuaten ayagturnaurtua nallullruyaaqanka nutaan allragni nallunrirluki, tamakuull' [?]."
        },
        "48": {
            "start": 522.52,
            "end": 531.54,
            "transcript": "Ataatamnek taumek waten ekiaq aptellria [?] nalqigluni pituli."
        },
        "49": {
            "start": 531.54,
            "end": 546.74,
            "transcript": "Tua-i waten makuciurr' [?] mulngaku'urluku qup'aqluku, makuuluni wall'u nemiarurteńguluni (Yaa wall'u makuciuluni). Keluk ilakluku ellminek kelukluni."
        },
        "50": {
            "start": 546.74,
            "end": 564.9,
            "transcript": "Tau͡gaam makuciq. (Imarcuun [?]). Makucit makunun pikellrat waten, waten-ll' taktat' nang'aqata allanrusrutaqam ilait, wiinga qillerqurluki piyuitau makut, nemiarut makut qupumalameng cali, qupumalameng, qusngalriit-ll' makut.)."
        },
        "51": {
            "start": 564.9,
            "end": 581.52,
            "transcript": "Wiinga qillerquurluki piyuitua makut, nemiarut makut qupumalaameng cali, qupumalaameng, tamaavet qup'ellrem iluani ikuusgutqataar' [?] tauna allat cat tua-i nuniinun elliqerluki iliit."
        },
        "52": {
            "start": 581.52,
            "end": 593.26,
            "transcript": "Qillrucuumitaqamki pitniaranka [?], makucit makut ilait teqkut nemercinek pilallrit."
        },
        "53": {
            "start": 593.26,
            "end": 609.96,
            "transcript": "Petqinga'artaqami iliit makut yualut iliit tua-i petngetuut angillermek angiluteng ilulir' imkut ellimluteng [?] waten taluyat."
        },
        "54": {
            "start": 609.96,
            "end": 619.48,
            "transcript": "Ataam tau͡gaam teguluki nutaan allanek-llu nekevraartut piitnek nutaan yualulirluki ataam caliaqenqiggluki."
        },
        "55": {
            "start": 619.48,
            "end": 631.7,
            "transcript": "Pet'ngang'iqertaqama angituat tauna angllurmeggnun yaavet, taluyaunrillermeggnun, nutaraat atuqsaileng'e'rmeng."
        },
        "56": {
            "start": 631.7,
            "end": 647.82,
            "transcript": "Cali makut aipaingqerrluteng yualukait maani ekvigni, uqviinrarnek pituaput wangkuta tamakut tamaa-i, makut uqvigait amaarit, amaarunek pituaput makut."
        },
        "57": {
            "start": 647.82,
            "end": 659.86,
            "transcript": "Tau͡gaam arungigtut, makuni arunginruut (makuni-llu-qaa?) makut arungiallruut nekevraarcinraat."
        },
        "58": {
            "start": 660.04,
            "end": 669.74,
            "transcript": "Ekviim mat'um uqvigata pit imkut ekvigmi arungillrat cukanruut cukanrulartuq."
        },
        "59": {
            "start": 669.74,
            "end": 685.08,
            "transcript": "Akulmi-llu tua-i pilallrulriit imkunek uqviaraat, tau͡gaam imu, imu, im' can'gilngurem uqu' [?] uumi."
        },
        "60": {
            "start": 685.08,
            "end": 700.42,
            "transcript": "Uqugglaarauluni tua-i elagarluki, makucimek-llu uqvigaam acianek tangrramiu [?] kapluku, nuqluku, ayaulluku tuaten makunek cali kelunallruut Akulmi."
        },
        "61": {
            "start": 700.42,
            "end": 718.02,
            "transcript": "Maani pitullruut pavani-llu, tau͡gaam arungiillrat, arullrat cukanrulriit (qakinruqercetuameng), ii-i qakinruqercullrat canimecuan makuni nekevraarcinrarrlainarnek piyaurtellruut."
        },
        "62": {
            "start": 718.02,
            "end": 729.92,
            "transcript": "Cali makuunge'rmeng pavani ingrini, ingrini makut yualukarcunaituq nekevraarrluku aciitnek makucinek assiitut."
        },
        "63": {
            "start": 729.92,
            "end": 745.58,
            "transcript": "Uruat mamtuaqami assiituq, mamkilngurmek urulget assiqapiartut, kangiit-llu kepqaarluku nuq'ertellrianek tamarmeng kiigarrnaurtut tayima taktacimeg' [?]."
        },
        "64": {
            "start": 745.58,
            "end": 756.08,
            "transcript": "Cali imkut kevraartut imkut waten ava-i, imkut tau͡gken meraaluteng avaluteng [?] piciatun."
        },
        "65": {
            "start": 756.08,
            "end": 766.76,
            "transcript": "Makuciit camani nunam iluani ayuqeliluki peraa' (yaa pituut.) ayagyugluteng-llu, tau͡gken imkut avayalget waten."
        },
        "66": {
            "start": 770.06,
            "end": 774.88,
            "transcript": "Yagingalrianek wangkuta [?] tamakunek."
        },
        "67": {
            "start": 774.88,
            "end": 781.6,
            "transcript": "Tamaa-i yuaryaraugut [?] cali tamakut kevraarcinrait (yuarturnaqluni)."
        },
        "68": {
            "start": 781.6,
            "end": 789.26,
            "transcript": "Cat tamarmeng makuungermeng-llu yuarnarqut."
        },
        "69": {
            "start": 789.26,
            "end": 800.72,
            "transcript": "Tua-ll' makut neqerrlainarnun atuunrilameng uumi imumi pingayagyaurteqerraallemni [?] maligucaurteqerraallemni nunistemnun-llu."
        },
        "70": {
            "start": 800.72,
            "end": 812.38,
            "transcript": "Makucirrlainarnek Kass'artanek aturpek'nata pitull', melqulegcuraqamta makucirrlainarnek atutullruukut."
        },
        "71": {
            "start": 812.38,
            "end": 832.84,
            "transcript": "Nurlallrulriit-llu tamaani pissiyaayuitellruut kiingan makut chicken apqait, chicken wire-aat tua-i, makut imkut wire-aat piyuitellruut nurnallruut, maa-i tang ukaqvaggun-am tamakut blackfish-anun atularait ii-i."
        },
        "72": {
            "start": 832.84,
            "end": 844.44,
            "transcript": "Ukaqvaggun tamakunek taluyiryaurtut maa-i piciatun nunanun ayangerma Kass'artarrlainanek tau͡gaam taluyanek tangerrsaurrlua waten neqsuutnek can'giircuutnek-llu."
        },
        "73": {
            "start": 845.44,
            "end": 852.74,
            "transcript": "Piciatun nunanun tekitngapik [?] ukut melqulegcuutngulliniluteng-llu ukut, ukut-ll' neqsuutngulliniluteng can'giircuutnek."
        },
        "74": {
            "start": 852.74,
            "end": 854.78,
            "transcript": "Uksumi-llu-qaa atutuit cali?"
        },
        "75": {
            "start": 854.78,
            "end": 865.02,
            "transcript": "Atutuut pugelrianek can'giirnun atutuut cali uksumi makut pugengsuutnguluteng can'giircuutnguluteng."
        },
        "76": {
            "start": 865.02,
            "end": 878.7,
            "transcript": "(... tau͡gaam) Waten naparrluki aturluki naparterrlainaq. (Blackfish-at mayurraarluteng [?] ataam ek'arrluteng makunun.)"
        },
        "77": {
            "start": 878.7,
            "end": 899.02,
            "transcript": "Uumi waniwa calillemteńi watnalria tau͡gaam anerturyuumayaaquq. Tua-i-wa kinguliamteńun pikakun manimalriaruarkaungani pikiutii [?] makut watnalria tau͡gaam anerturyuumayaaquq."
        },
        "78": {
            "start": 899.02,
            "end": 912.02,
            "transcript": "Yaa makut wiinga cellangeqerraallemni makucirrlainarnek atutullruit au͡gkut teggvakluki au͡gkut angelriit."
        },
        "79": {
            "start": 912.02,
            "end": 921.76,
            "transcript": "Wangkuta apqemteńek Kass'atun otter-aanek pitukait tamakut wangkuta-llu pavani cinkarnek piaqluki."
        },
        "80": {
            "start": 921.76,
            "end": 932.44,
            "transcript": "Maani-llu maani nunavceńi tayim' cavignilngurnek pituaci. Otter cuignilngurnek maani pituut wangkuta-ll' unani cinkamek."
        },
        "81": {
            "start": 932.44,
            "end": 940.82,
            "transcript": "Yaa, tua-i pavani cinkarnek pituaput. Ayuqut wangkuk qaneryarapuk."
        },
        "82": {
            "start": 940.82,
            "end": 955.2,
            "transcript": "Qaillun-mi atunritaqamegteki qemagtelartatki tamakut atunritellmeng nalliini qaillun maqaalartat kineklitlerkait piluki."
        },
        "83": {
            "start": 955.2,
            "end": 973.74,
            "transcript": "Makut wani melqulegcuuteklemteńi, tamaa-i angussaagcuuteklemteńi tuaten uungnaqsaqumteńi yuugaqamteki uqvaarnun agartelaraput petugluki anuqemun tengrailteng agaarkauluteng."
        },
        "84": {
            "start": 973.74,
            "end": 986.32,
            "transcript": "Tua-i im' tua-i ataam-ll' allamikuan tekicamteki teguqerluki tau͡gaam ataam civvluki, aruata-ll' nutaan arungengatai paqtarraarluki ayimcuriata allanek civirkiurluki."
        },
        "85": {
            "start": 989.7,
            "end": 999.02,
            "transcript": "Uumek piliksaitua wii ciungakun, waniwa waniw' ayuqliqerqaarluku takellruut makuciliqaqsaitua."
        },
        "86": {
            "start": 999.02,
            "end": 1012.02,
            "transcript": "Cakucinek muragnek aturluteng angallalilartat? (Cauga?) Angallanek piliaqameng ipuutnek tamakunek cakucinek muragnek atulartat?"
        },
        "87": {
            "start": 1012.02,
            "end": 1030.02,
            "transcript": "Makut imkuugut wangkuta pilallemteńi mimernanek, mimernanek pituukut pilituut makucit. Wiinga-ll' wani uumek wii-ll' naspaaqallruyaaqua tau͡gaam taqevkenaku."
        },
        "88": {
            "start": 1030.02,
            "end": 1043.66,
            "transcript": "Mimernanek pituut maa-i muragglainarnek cangqetullruamni imumi muragglainarnek."
        },
        "89": {
            "start": 1043.66,
            "end": 1055.76,
            "transcript": "Man'a angnaqucirteng cali muragnek saskulirluteng angulluucirluteng pitullruami."
        },
        "90": {
            "start": 1055.76,
            "end": 1073.4,
            "transcript": "Ilait tua-i makut wani piqamegna taqnaq' [?] iliini makucinek, pau͡gani-wa nunamteńi muragnek piuratuyaaquq pau͡gkut Kuigpak kia up'nerkan [?] tamalkuan."
        },
        "91": {
            "start": 1073.4,
            "end": 1092.58,
            "transcript": "Tau͡gaam iliini piiteqerlartuq, tua-i-llu-am[?] wiinga nunama avatii, piitaqan nauw' makunek wangkuta apqemteńek napapianek, kevraartunek, tamakunek pikartelartukut uksumi-llu uksurmi-llu."
        },
        "92": {
            "start": 1096.28,
            "end": 1109.96,
            "transcript": "Yuarluki, yuarniluki-am cali piaq yuarnaqniluteng-am cali, caliaraa mat'um muriim amllertuq, avani."
        },
        "93": {
            "start": 1109.96,
            "end": 1118.78,
            "transcript": "Qagkut-llu makut elngunek pitukengait cali makut-llu cuukvagvuat ayuqenritut caliaraa."
        },
        "94": {
            "start": 1118.78,
            "end": 1138.02,
            "transcript": "Pavani wiinga tua-i wiinga murilkengrraanemnek apa'urluqa muriim qetunraa calingssaullruuq piciatun, qayiluni aguuciluni tangluniluni piciatun caliaqluku."
        },
        "95": {
            "start": 1138.02,
            "end": 1155.02,
            "transcript": "Elerpalluanek [?] tangvaurluku wiinga, tangvaurluku camek caliqata'arqan apqaurluku, camek caliqatarcit, taumek caliqatarniaqan ayutullruaqa tangvagluku."
        },
        "96": {
            "start": 1155.02,
            "end": 1168.54,
            "transcript": "Ilait cuqyutengqertut makut tanglut qayat-llu [?], ilait cuqyutengqertut makut wii cuqyutaitnek makut qanemciklallrunritaanga cuqyutailriit."
        },
        "97": {
            "start": 1168.54,
            "end": 1183.74,
            "transcript": "Maa-i tau͡gaam makut au͡g'um-llu au͡g'um pillri cuqyutengqertut, cuqyutengqertut, maa'i cat cuqtaurluku waten piaqluteng, uumek-llu piaqluku."
        },
        "98": {
            "start": 1183.74,
            "end": 1197.88,
            "transcript": "Cat tamarmi qayiaqameng, ilututacirqaallem qayam, qayapigmek piliaqameng, cuqyutengqertut ellaita cuqyutmeggnek."
        },
        "99": {
            "start": 1197.88,
            "end": 1206.02,
            "transcript": "Tangluliaqameng-llu cali ellaita cuqyut' apa'urluqa ellminek cuqcissuutengqertuq."
        },
        "100": {
            "start": 1206.02,
            "end": 1216.72,
            "transcript": "Au͡gkut napat muriit qanrutkelten nekevraarcinraat cuukvaguat-llu naliit taukuk muriik elngunrua?"
        },
        "101": {
            "start": 1216.72,
            "end": 1228.92,
            "transcript": "Au͡gkut elngut, elngunek pilallrit elngelngunruut, elngurtut, elngurtut makut cuukvaguat, makut-llu-q' uqvigpiit elngunritut."
        },
        "102": {
            "start": 1228.92,
            "end": 1239.32,
            "transcript": "Cuukvaguaq tau͡gaam kinerqami elnguq-llu, imkut, akwaugaq qangvaq-ggem ak'allrat, maantellilriit-ll' tayima."
        },
        "103": {
            "start": 1239.32,
            "end": 1251.56,
            "transcript": "(Camantut aqvanirnek atata [?]) Kin'erqameng murak, uqvaaq-llu kinerqam elngurituuq, elngurituuq."
        },
        "104": {
            "start": 1251.56,
            "end": 1262.74,
            "transcript": "Murartaqavci, atertellerrlainarnek-qaa tau͡gaam pituut piliarqameggnek, wall'u-qaa napalrianek kepurluki?"
        },
        "105": {
            "start": 1262.74,
            "end": 1273.4,
            "transcript": "Kepulria kepurluki waten makucirkanek piaqameng napanek kevraartut yuarraarluki tau͡gaam cali yuarraarluki."
        },
        "106": {
            "start": 1273.4,
            "end": 1288.76,
            "transcript": "Kepluku tauna taum makucirkanek pilartut nemiarutekluku, qupurrluku waten makuciqluki? (Kelukluki.) Kelukluki tuaten cigyakluki nemiarutekluki, au͡gkut piyaraugut."
        },
        "107": {
            "start": 1288.76,
            "end": 1295.28,
            "transcript": "Qaillun piluki tamakut waten pertelartatki?"
        },
        "108": {
            "start": 1295.28,
            "end": 1308.56,
            "transcript": "Murak maa-i man'a qupkuni qavciurrluni pingayuurrluni-llu qupsuumauq, tua-ll' qupraarluku nemiaq, ataam cali qupcuarluku qamna ilukaa."
        },
        "109": {
            "start": 1308.56,
            "end": 1318.26,
            "transcript": "Tua-llu taqngan nutaan keggmarluki pereqluki waten ayuqliriluki, uivenqelliluki-llu."
        },
        "110": {
            "start": 1318.26,
            "end": 1329.0,
            "transcript": "Picuqcaarluki pilriani makut assirtut, aluyaqegtaaraat, aluyacungaqegtaaraat tangellripiaqluteng waten picuqcarpek'nak."
        },
        "111": {
            "start": 1329.0,
            "end": 1343.1,
            "transcript": "Nanitetuyaaqut wiinga taqliqertengraa-llu patagaqallemni pillruunga egtarkauluki (Eggngaitut). Waniwa uum teguciqkai."
        },
        "112": {
            "start": 1343.1,
            "end": 1360.46,
            "transcript": "Qaillun tamakut yaaqsigtaluki pilartatki canek-qaa cuqyutengqenritut ukingrit apiit? (Akultutaciit.) Akultutaciit tamakut waten."
        },
        "113": {
            "start": 1360.46,
            "end": 1377.7,
            "transcript": "Makut-qaa? Makut can'giirrsuutet akultuyuitut, makut tau͡gken  melqulirnek pissuutet imarmiutaat-ll' pit akultunritut, makuni atam akultunruluteng."
        },
        "114": {
            "start": 1377.7,
            "end": 1385.22,
            "transcript": "Tua-llam cali au͡gkut can'giiyaraat, can'giiyarnek tangtuuci tayima."
        },
        "115": {
            "start": 1385.22,
            "end": 1396.12,
            "transcript": "Wangkuta apqemteńek alungyarmek, neqtaq can'giicuayaarmek, tunguqtaat can'giicuayaaqtaraat."
        },
        "116": {
            "start": 1396.12,
            "end": 1409.38,
            "transcript": "Makut, makuciliaqameng makut mamkillritnek pililartut taluyiqatarqameng, tamakussuutekanek taluyiqatarqameng au͡gna apa'urluqa."
        },
        "117": {
            "start": 1409.38,
            "end": 1417.52,
            "transcript": "Akulaitqapiarluki tau͡gken waten taqluteng caliaqluki."
        },
        "118": {
            "start": 1417.52,
            "end": 1431.14,
            "transcript": "Makut-llu nemiarutai cali akulaitqapiarluki piluki, taluyacungaqegtaarataqluteng, alungyaarnek alungyaarcuutnek pituit tamakut can'gicuarcuut imkut."
        },
        "119": {
            "start": 1431.14,
            "end": 1438.98,
            "transcript": "Tamakut makuciliaqamegteng akulaitqapiarluteng, waten akultutayugnarqut tau' [?]."
        },
        "120": {
            "start": 1438.98,
            "end": 1448.7,
            "transcript": "Calilngunarqut, pessalngunarqut caliaqellret, akulaitsiiyaagameng akulaitsiiyaagluni."
        },
        "121": {
            "start": 1448.7,
            "end": 1468.76,
            "transcript": "Atuuguq man'a murak tamarmeng, canun tamarmi atuuguq murakluku tuaten, qalcilriani-llu makunek makucinek terr'it camek tallungait pililuki mimernanek aciit qalcitulit qancililriit."
        },
        "122": {
            "start": 1468.76,
            "end": 1478.78,
            "transcript": "Au͡gkunek-llu wangkuta apqemteńek Kass'artaung'e'rmeng miiskaanek pitukeput, tamakuciurrluki tuaten ilait pilituut."
        },
        "123": {
            "start": 1478.78,
            "end": 1488.7,
            "transcript": "Tau͡gaam qaltaliaqameng asgarluki imkunek."
        },
        "124": {
            "start": 1488.7,
            "end": 1494.42,
            "transcript": "Tungnanek, yaa, tungnanek-llu pituut, au͡gkunek."
        },
        "125": {
            "start": 1498.18,
            "end": 1507.62,
            "transcript": "Kaugpiit ca [?] imkut tugkaraitnek alngarturluku qanciaqameng."
        },
        "126": {
            "start": 1507.62,
            "end": 1523.36,
            "transcript": "Tamakunek qanciaqameng temait makut waten murak tem'it alngaqegtaarturluki, maa-i ayuqenrilngurnek piliurnaurait kassutmun kassurrluku."
        },
        "127": {
            "start": 1523.36,
            "end": 1532.54,
            "transcript": "Tamakunek what you call them walrus, tamakuciitni imkut."
        },
        "128": {
            "start": 1532.54,
            "end": 1541.82,
            "transcript": "Tamakucinek elngarturluki pitullruut au͡gkut ciuliaput."
        },
        "129": {
            "start": 1541.82,
            "end": 1553.78,
            "transcript": "Wii tau͡gaam pisciigatua tamakunek, kia ellimerciqsaaqnga, tamakucini pilisciigatleqertua tamakucinek."
        },
        "130": {
            "start": 1555.66,
            "end": 1568.34,
            "transcript": "Ilait cat wiinga-wa wiinga makunek muragnek caliyaurcama calissuutelliqluni piyunaitut makut, wangni."
        },
        "131": {
            "start": 1568.34,
            "end": 1579.06,
            "transcript": "Elkarrlainartun piyunaitut tayima cakum' au͡gkut ciuliat tua-i pilagyaaqait qalciaqameng qantaliaqameng."
        },
        "132": {
            "start": 1581.66,
            "end": 1594.58,
            "transcript": "Wiinga tamakut calingssaunritua tang wii ayagmek calingssaunritua, calingssaunricaaqua."
        },
        "133": {
            "start": 1594.58,
            "end": 1605.2,
            "transcript": "Tau͡gaam elitellemkun aatallma tangvaurluku iliini alerquqerlaryaaqaanga."
        },
        "134": {
            "start": 1605.2,
            "end": 1623.58,
            "transcript": "Tau͡gaam ilii alerquutii nauw' im' piyaurcama ak'a catairutellranun, makluni nunurngailanga, wii piyugtaciyaurtellruunga [?], makluni nunurngailucami-wa."
        },
        "135": {
            "start": 1623.68,
            "end": 1639.58,
            "transcript": "Wii piyugtacimnun maa-i caliyaurtellruunga, wii aliklemnek, wii capinritarallemnek, capillemnek pisciigatua, pisciigatua capillemnek."
        },
        "136": {
            "start": 1642.36,
            "end": 1650.02,
            "transcript": "Ilait caperrnaqlartut ilait caliarit, caliaci-wa ilaitni caperrnaqlartut."
        },
        "137": {
            "start": 1650.02,
            "end": 1659.9,
            "transcript": "Makut-llu [?] qaillun piluki piuralriaci assiriluki-llu pinaurait."
        },
        "138": {
            "start": 1659.9,
            "end": 1673.38,
            "transcript": "Wiinga tamakucinek caliyuilama nalluanka, tau͡gaam pulengtaq tangvatuunga. Tangvatuyaaqua tau͡gaam elitellrunritanka tamakut."
        },
        "139": {
            "start": 1677.32,
            "end": 1683.22,
            "transcript": "Ii-i. Tua-i-qaa?"
        },
        "140": {
            "start": 1683.22,
            "end": 1690.22,
            "transcript": "Camek allamek ilayunrilkuvgu tuaten pitangerpet upingauq [?]?"
        },
        "141": {
            "start": 1690.22,
            "end": 1707.4,
            "transcript": "Camek wii, wii taqlemnek camek caliamek tangvagpek'naku wii elisciigataqa, tangvagpek'naku wii caliaqengramku. Tangvagpek'naku pisciigataqa."
        },
        "142": {
            "start": 1707.4,
            "end": 1715.96,
            "transcript": "Tua-i waten taktaqangermi canrilngatuq. Makut maa-i piyugtain kia teguluki [?]."
        },
        "143": {
            "start": 1716.1,
            "end": 1733.28,
            "transcript": "Wiinga kingunemnek tainrilama [?] tuyurtequaqallruunga ukunun waniwa atalriaruut au͡gkut maningqerraarkanek [?] waniw' ukut wantelluki wii pikuma quyayartua."
        },
        "144": {
            "start": 1734.78,
            "end": 1747.32,
            "transcript": "Kingunemnek watua taillrunrilama tuyurteqallerlua taumek qetunramkun nemnek teguluki teguqesqelluku piqallruama."
        },
        "145": {
            "start": 1747.32,
            "end": 1763.58,
            "transcript": "Ayaalqa-am nunamnun ak'aurcan month-aurtenglliuq-llu. Ii-i wii-qaa?"
        }
    },
    "3P8jR6veulc": {
        "1": {
            "start": 7.67,
            "end": 22.53,
            "transcript": "Tuamta-llu cali una cuukvaguaq perelra qaillun uumi-llu ellenrulria [?] waten ellegtakugnek iqtutakunek makucinek."
        },
        "2": {
            "start": 22.53,
            "end": 35.57,
            "transcript": "Una mik'engraan pillruaqa tuaten nalqiggnaluku angyaqatagnun menglekluku alla waten ayuqekunek ukuk tua-i waten ayuqsartuk tang."
        },
        "3": {
            "start": 35.57,
            "end": 43.05,
            "transcript": "Waten ayuqsartuk waniw' ukuk angyayugagucetun [?] qacarnertun ayuqluni."
        },
        "4": {
            "start": 45.87,
            "end": 63.5,
            "transcript": "Tamakut tua-i pingnatulallermeggni makunek cuukvaguanek wall'u tua-i cat wall'u ikamriqataquneng cali allamun,"
        },
        "5": {
            "start": 63.5,
            "end": 73.83,
            "transcript": "wall'u ava-i au͡gna qup'illrani tangellrukeka, tangvallruksi una au͡g'umek,"
        },
        "6": {
            "start": 73.83,
            "end": 89.02,
            "transcript": "two by four-aamek qup'ellrani tua-i qupluki cali man'a piyugngaluku tau͡gaam una-am waten piluku, ak'a-llu tua-i tamatumek two by four-aanriltutalriamek piluku,"
        },
        "7": {
            "start": 89.02,
            "end": 96.21,
            "transcript": "una-llu tua-i asvaiqerr'arrluku napaqutarirluni-ll' ikamraulugngaluni."
        },
        "8": {
            "start": 100.16,
            "end": 115.92,
            "transcript": "Tuamta-llu cali maa-i makut ilaita avani-w' tua-i tamalkuan murak aklukengnaq'lallrulliniamegteggu."
        },
        "9": {
            "start": 115.92,
            "end": 130.39,
            "transcript": "Cali akulmi pavani qagkut uqviaret [?], caneg im' pilaqait, kaviqsuyaraat imkut, kavirituli cuyait leaves-aarit nalaaquma [?], kaviqsuyagaat, ii-i,"
        },
        "10": {
            "start": 130.39,
            "end": 141.15,
            "transcript": "atsiitnek cali makucirrluteng cap'itkevkenaku nemiarutkaita [?] piluki taluyat."
        },
        "11": {
            "start": 144.32,
            "end": 157.39,
            "transcript": "Mani-w' una uum qanrutkeqallrutkii kevraarcinraat pileryagciigalamek yuaryaraugata [?] waten kevraarcinraat waten ayuqut,"
        },
        "12": {
            "start": 157.39,
            "end": 166.92,
            "transcript": "au͡gkut ava-i aminaki tangelci makukait kevraartut atsiit."
        },
        "13": {
            "start": 166.92,
            "end": 182.37,
            "transcript": "Maa-i makut kevraarcinraarteng ayuqut taluyiit taluyanun, tuamta-llu tua-i una cali atuuuguq piciatun wall'u perelra, wall'u una cali waten ayuqellra,"
        },
        "14": {
            "start": 182.37,
            "end": 195.26,
            "transcript": "camun imumi iqucissuutmun-llu puksugngaluku uum-llu au͡gna kepun, cakin, malrugnek atengqertuq kepun, cakin."
        },
        "15": {
            "start": 195.26,
            "end": 211.26,
            "transcript": "Tua-i una-llu perngami cali-am iqu' arnat aturiqataquneng qeciit caluggluki, iqulluki-gguq."
        },
        "16": {
            "start": 211.26,
            "end": 234.76,
            "transcript": "Puuyugngaluni una perelra una-llu maa-i makut una waniwa qamigautegnun ikamracuaraagnun tau͡gaam una pulalluku, wavet elliluku,"
        },
        "17": {
            "start": 234.76,
            "end": 252.36,
            "transcript": "Waten tua-i pul'arrluku ak'a-llu qaqican piluku, allamek-llu cali akiakun inglua cali piluku, nutaan-llu murak elliluku tua-i nutaan ussukcaitellermeggni-wa nemerluki pilallrukait."
        },
        "18": {
            "start": 252.36,
            "end": 264.47,
            "transcript": "Tuamta-llu cali makut imna tua-i atertaq kevraartuq tep'aq cali cakilluku ikamralugpialiyugngaluteng,"
        },
        "19": {
            "start": 264.47,
            "end": 283.69,
            "transcript": "tau͡gaam kenriiruirluku-gguq, kenriiruat [?] iluq? Iluq'am-wa ikamraarit tanglallrullikii, tua-i tuaten, cali-am qukait ukilluki, tamakut kenriirualget,"
        },
        "20": {
            "start": 283.69,
            "end": 295.35,
            "transcript": "tua-i-llu cali-am quliriqataqunegteki-am cali pissuuterluteng tamakut taq'lallrulliniut,"
        },
        "21": {
            "start": 295.35,
            "end": 313.76,
            "transcript": "aterluteng, ikamralugpiat, tua-i picaitun aturyugngaluteng, aciurrlugngaluteng pagkut au͡g'arluteng pikuneng,"
        },
        "22": {
            "start": 313.76,
            "end": 333.39,
            "transcript": "tuamta-llu cali pirlaarit assingait enret imarpiim ungungssiin enrit assingarrluki qamigautnun, ikamrat tamakunun-llu tempialegnun [?],"
        },
        "23": {
            "start": 333.39,
            "end": 352.67,
            "transcript": "maa-i mat'um nalliini ayuqek'laqait makut plastic slide-alek acirner' [?] assirit, tua-i tuaten tamakut assingata cali-am caliaqellrat amllerrsugnarquq,"
        },
        "24": {
            "start": 359.86,
            "end": 374.87,
            "transcript": "enret au͡gkut cali-am muragnek ukirqiagumaluteng muragnek, ussukcanek, nekait cali tevagturluki tamakunun ikamralugpianun."
        },
        "25": {
            "start": 374.87,
            "end": 387.28,
            "transcript": "Avamiqatmek tamaa-i ukut tunut kapusngavaita elalirneri tamakunek tamaa-i pilallret."
        },
        "26": {
            "start": 387.28,
            "end": 401.41,
            "transcript": "Tuamta-llu cali nunapiim qaingani tamakut imkut qanikcailengraan piirakapiggluteng enret imarpiim enret, ingungssiim enrit ayagnaurtut tua-i enritevkenatek."
        },
        "27": {
            "start": 401.41,
            "end": 416.1,
            "transcript": "Tau͡gaam wiinga iluq'ameg-am ugna ataataka kiputellruuq aturluki-llu pagaavet qanganartullruluku ingrini up'nerkami,"
        },
        "28": {
            "start": 416.1,
            "end": 430.72,
            "transcript": "aren tamakunek imkut tunurnek qaninerraq nutaraq, catun tua-i qau͡gyatun ayuqelliniuq ellaitni."
        },
        "29": {
            "start": 430.72,
            "end": 446.05,
            "transcript": "Nutaraulunek kenercenani [?] tua-i, tau͡gken mecungekuni tua-i assingata makut tua-i ellmegnek cingqaquni-ll' [?] ayagluni tua-i mecungaqami tua-i piingaqapigcugngaluni."
        },
        "30": {
            "start": 447.73,
            "end": 465.03,
            "transcript": "Tuamta-llu cali tamakut assingat maa-i imkut hickory-t maa-i hickory-t cali ukaqvakun pillruut imkutlilriit [?] brown-aaruluteng assingaq'lallrit,"
        },
        "31": {
            "start": 465.03,
            "end": 476.13,
            "transcript": "tamakut pivailgata au͡gkut imkut kevraartut Christmas tree-t tegg'eraitnek assingirluteng pilallrulliniut."
        },
        "32": {
            "start": 476.13,
            "end": 487.72,
            "transcript": "Makut-am unailnguut assingaugaqameng egmian anglalliniameng, nangqertulalliniameng.  Tua-i-llu tua-i una cali,"
        },
        "33": {
            "start": 489.72,
            "end": 503.51,
            "transcript": "Aguutektukait-gguq maa-i makut avani makut piciatun atuugut nunam-ll' iluani, nunam-ll' iluanun,"
        },
        "34": {
            "start": 503.51,
            "end": 519.62,
            "transcript": "meluk kinercirraarluku wall'u kinercinrilengraan una laaggaarluku, makucimek-llu tua-i piluku meluk, piluku,"
        },
        "35": {
            "start": 519.72,
            "end": 536.87,
            "transcript": "Piyugngaluni, avani-wa ca tamalkuan neryaraq tua-i, arcaqakegglainalallrulliniamegteggu cali-llu imna kaigyaraq."
        },
        "36": {
            "start": 536.87,
            "end": 548.47,
            "transcript": "Aren ilait-llu neryuniaruitleq [?] pinanermeggni tua-i nunamun tayima aturpailegmegteki tamanek pitekluku aqsaqrituryaraq [?]."
        },
        "37": {
            "start": 548.47,
            "end": 567.72,
            "transcript": "Tau͡gaam maa-i mat'um nalliini kaigyaraq piniaralliuq, tuallitua una-am cali waniwa piciatun atuuguq ava-i iqvarcuutnguyugngaluni."
        },
        "38": {
            "start": 568.72,
            "end": 579.46,
            "transcript": "Aguutem canoe-maa mingeqsugngaluku tau͡gaam makucinek, makucinek kenirluki ukirquarraarluki waten usgutellrit."
        },
        "39": {
            "start": 581.72,
            "end": 602.72,
            "transcript": "Tua-i-llu cali tamakut imkut qaqicata mingqerraarluki, tang waniw' una Christmas tree-m angiyaa, una-am cali angiyaq-qaa, camek au͡gna [?] navegyugtuq, tegg'ituameng angiyat."
        },
        "40": {
            "start": 603.72,
            "end": 619.72,
            "transcript": "Kaugtuqaquni-llu uqurluni tua-i teggalput, tau͡gaam tamatum uqumek piciatun uqumek neqem uquanek unegkumiutagmek auqerluku tua-i nepcariluku."
        },
        "41": {
            "start": 620.04,
            "end": 629.9,
            "transcript": "Mermun akurtaqameng tuaten nepcaqerraarluteng tegg'iqertetuut makut, cang'ermi-llu [?] perrirang'ermi,"
        },
        "42": {
            "start": 629.9,
            "end": 649.88,
            "transcript": "Tua-i kenerkun cali uruggluku, aguutengqelallemteńi kanarrlagtulallemteńi wii qalugyarqama-llu canvas-aanek imkunek plastic-autulinek aguutet amingellratni, qalugyarqama tua-i mingqerraarluku makucimek,"
        },
        "43": {
            "start": 649.88,
            "end": 661.91,
            "transcript": "Tau͡gaam qakineruarnek cali aurraarlua [?] makucimek cupu'urcaarluku, kuciqtara'artelluku, kuci',"
        },
        "44": {
            "start": 661.91,
            "end": 678.72,
            "transcript": "Tamana-llu tua-i mingqerraarluku lumarrarqa allgartelleq piluguk, una-llu cali, ak'a avani waniw' una, waniwa-gguq una,"
        },
        "45": {
            "start": 679.72,
            "end": 695.38,
            "transcript": "Una-am cali paluqtartangqellruan nunalgutainai canek kepiulinek acilallriit ilaita,"
        },
        "46": {
            "start": 695.38,
            "end": 711.38,
            "transcript": "makut tuani aternek niitaqameng tua-i qula- [?] tapailritengnaqluki [?] tuaten nallunrilengramegteki allanek aciqernek, qulautekluku-gguq yuum taum atra tua-i,"
        },
        "47": {
            "start": 711.38,
            "end": 729.37,
            "transcript": "Una wani aluqatkaq waniwa, maa-i makut avani iinruartuq'lallrullinikait au͡gna-ll'-am,"
        },
        "48": {
            "start": 729.37,
            "end": 737.61,
            "transcript": "aluqatkaq una, atulaqait canun,"
        },
        "49": {
            "start": 737.61,
            "end": 751.24,
            "transcript": "Cacaqameng alangruaqameng makunek cali wani wall'u ircenrrarnek tangell' tangrraqameng cali makunegmi uglutek [?] unateteng tua-i piaqluki,"
        },
        "50": {
            "start": 756.2,
            "end": 767.21,
            "transcript": "Makut maa-i muriit ayuqai au͡gkut ciuliarluut, aklut kiingan tua-i aklutengnaq'lallrulliniamegteggu,"
        },
        "51": {
            "start": 767.21,
            "end": 779.21,
            "transcript": "imkunek-llu cali, cauyaralegnek aguullem [?] perrluki cali imkunek quarnanek,"
        },
        "52": {
            "start": 779.21,
            "end": 793.24,
            "transcript": "kevraartut aipaitnek mingqutait amilnguarnek quarnanek tua-i aqevkenaki perqelallikait, [?] cali tamakut quarnek, tamakunek cauyaralget,"
        },
        "53": {
            "start": 799.72,
            "end": 808.51,
            "transcript": "Cauyaralegnek-wa tangerqaqulallrulrianga pavaken elpet tuar' ataka [?] cali tamakut tangrruluaqallrunritut,"
        },
        "54": {
            "start": 808.51,
            "end": 825.5,
            "transcript": "Makut cat angyat pingatat tua-i tangrrunrillrut, tua-i-wa makut,"
        },
        "55": {
            "start": 825.5,
            "end": 841.97,
            "transcript": "Tuamta-llu cali yuilqumi cali pelatekat cat canvas-aat-llu nurnallrulliniameng,"
        },
        "56": {
            "start": 841.97,
            "end": 856.85,
            "transcript": "Cali-am qagkut napayagaat tuanelngulriit nunapigmun kapulluki, perrluki qavartalallrulliniut, atam,"
        },
        "57": {
            "start": 856.85,
            "end": 867.44,
            "transcript": "Maaken Kusquqvagmek kiakem Akiarmiut kiatiitgun piyuagurluteng mayulallinilriit qanganaat pitekluki wall'u cat,"
        },
        "58": {
            "start": 867.44,
            "end": 882.32,
            "transcript": "Tua-i uksuarmi-llu maa-i tuntut, maa-i tuntuvagcualalriit caribou-nek tuaten pingkait maa-i tamakut pitekluki ingrinun mayuraqluteng,"
        },
        "59": {
            "start": 882.32,
            "end": 902.63,
            "transcript": "Tamaani tuntupiat pilallrulliniat tua-i tamaani, angyaqaciluteng amiitnek makunek cuukvaguat perelriaritnek cali aurluteng tua-i assigtarkiurluteng,"
        },
        "60": {
            "start": 902.63,
            "end": 919.54,
            "transcript": "Tuntuviim amian angyaqatangmi eksurngangatelaraa [?] kemni tamalkuani yugmek tapirrluki pitaqestiin"
        },
        "61": {
            "start": 923.7,
            "end": 933.8,
            "transcript": "Angyaqatiit au͡gkut tua-i, tua-i wiinga-wa."
        },
        "62": {
            "start": 933.8,
            "end": 939.4,
            "transcript": "Tauna-qaa taq'an, taiteqerr'u."
        },
        "63": {
            "start": 939.4,
            "end": 949.08,
            "transcript": "Wiinga maurluma makucit caktullrui iinrukluki tuaten,"
        },
        "64": {
            "start": 949.08,
            "end": 960.07,
            "transcript": "Makut imait qamkut aciat [?] waten ivguarrsinga'artun [?] angertun ayuquq, angertuarluki tuaten [?] aturtullruit [?]. (Angrutait-llu.)"
        },
        "65": {
            "start": 960.07,
            "end": 976.25,
            "transcript": "Tua-llu uksuarpak cikumarraarluni kiagaqan makut neqet asgurunglartut [?] qang'a-ll' Kuigpagkun cupellran kinguani."
        },
        "66": {
            "start": 976.25,
            "end": 989.84,
            "transcript": "Taryaqvagteqerraarqan yuk wii takumni maurluma nallunritan muicimaller anngairutii ellikcaumek [?] piaqluku apa'urluma,"
        },
        "67": {
            "start": 989.84,
            "end": 1007.64,
            "transcript": "Apa'urlugka-wa tau͡kuk. Nulirra maurluqa taum anngairutiin uicimaller-am anngairutiin. Anngaqaa Ellekcaaq Ellekcaamek pitullrat."
        },
        "68": {
            "start": 1007.64,
            "end": 1016.25,
            "transcript": "Taryaqvagteqerraarqan kuvyartengqerraarqan waten taryaqviit tut'aqata [?] yuk piciatun nunalgutni,"
        },
        "69": {
            "start": 1016.25,
            "end": 1032.35,
            "transcript": "Nallunrirqamiu makucimek tegut'lartuq. Tua-ll imna taryaqvagtellria ullagluku makuciq itumlluku, pirraarluku, tamuarraarluku, unatmun minguuqaarluku,"
        },
        "70": {
            "start": 1032.35,
            "end": 1042.72,
            "transcript": "Taryaqvagmi qaingani uglaraa. Piken pitaqenrilngenguagu-llu [?] uimi ingurluku ingugturluku makucinek."
        },
        "71": {
            "start": 1043.03,
            "end": 1048.16,
            "transcript": "Puaterrlainaq [?] piuratuluni maaten-llu tangeqsaurtaqa."
        },
        "72": {
            "start": 1048.16,
            "end": 1058.72,
            "transcript": "Qaill'-kiq tanem tayim' [?] ayuqngan. Tua-i iinrukluku tuaten makuciq pituat. Naulluugaqameng iinrukaqluku."
        },
        "73": {
            "start": 1059.72,
            "end": 1063.87,
            "transcript": "Pitullruut makucat."
        },
        "74": {
            "start": 1063.87,
            "end": 1084.72,
            "transcript": "Makut atam iluit peqlirtepiartut. Angrit-llu cali tua-i tukniut makut imait. Peqlirrluteng tuaten."
        },
        "75": {
            "start": 1084.72,
            "end": 1099.72,
            "transcript": "Makut-gguq makut-wa nerellrit napat ayuqenrilnguut uum iluanun ayalalliameng tuaten ayuqelalriat alurratkat."
        },
        "76": {
            "start": 1102.85,
            "end": 1124.09,
            "transcript": "Mecuita nauw' maa-i cat, cat-llu makut qaill' piaqata tuamta-llu cali, cat piaqata tua-i, makut aturaqluki,"
        },
        "77": {
            "start": 1124.09,
            "end": 1141.54,
            "transcript": "Wall'u kineryulria makunek maa-i. Iinrut makut pingata ilaita-qaa cungakluku [?] nallunrilngermegteggu atuyuirut'lalliniut,"
        },
        "78": {
            "start": 1141.54,
            "end": 1156.08,
            "transcript": "Tuamta-llu cali makut nunam qaingani, cat iinruuyugngalriit."
        },
        "79": {
            "start": 1157.72,
            "end": 1173.97,
            "transcript": "Ellmeggnek naullrunrilata ellam yua umyuaqerraarluku tuavet iinrukestekaanun,"
        },
        "80": {
            "start": 1173.97,
            "end": 1186.72,
            "transcript": "umyugailkarutevkenaku-am cali makut ellmeggnek piurtellrunritut cat tua-i can'gung'e'rmeng ellmeggnek piurtellrunritut."
        },
        "81": {
            "start": 1186.72,
            "end": 1202.72,
            "transcript": "Ellam yua qanerturallermikun makunek taqutellrulliniuq, napat naulit, atsat naulit atawaqerliit naugaqluteng tua-i."
        },
        "82": {
            "start": 1202.72,
            "end": 1215.12,
            "transcript": "Ayuqelliniut tamana pitekluku tua-i nunam qaingani iin, iin yugmun naulluulriamun-ll' atuqata'arqama una wani,"
        },
        "83": {
            "start": 1215.12,
            "end": 1229.98,
            "transcript": "piliaqestiit umyuaqerrluku tuaten-gguq calinruciquq, cat cam man'a umyugailkarukurluku piyunaitelalliniuq, piyunaitelaryaaqellrulliniuq."
        },
        "84": {
            "start": 1229.98,
            "end": 1250.91,
            "transcript": "Tua-i ukut cali iliit arnat qaneryugngall', qaneryugngall', cali arnartarnek aturyaranek-llu piyugciqliut tua-i waten pitalii amlleriuq au͡gna qalartelqa tua-i piurci tua-i, qaqiutua tua-llu."
        },
        "85": {
            "start": 1250.91,
            "end": 1253.77,
            "transcript": "Tarenrairyugciqsugnarqut. Aa."
        },
        "86": {
            "start": 1258.54,
            "end": 1272.72,
            "transcript": "Au͡gkut wani angyaqatiit qaillun pilimatullritnek apertuiqaqaa, canek-llu qecilirluki ava-i ilii piqallruken."
        },
        "87": {
            "start": 1272.72,
            "end": 1283.77,
            "transcript": "Makut-wa maa-i qagaani, makut-ll'-am cali yuaryaraa, cat tamalkuan ullagluku teguluku, kepluku piyuitut,"
        },
        "88": {
            "start": 1283.77,
            "end": 1301.72,
            "transcript": "yuarluku napali pulaarluni qaqiuteksaitelallilriit-llu one day wall'u ernerni pingayuni-llu, cat makut teguqerluteng pisciigatut, uum-llu nallunritai."
        },
        "89": {
            "start": 1305.33,
            "end": 1317.44,
            "transcript": "Yuaryarai cat tamalkuan yuaryaraa au͡gkut-llu cali ipuutet cali ipuutekarcaulriani nurnarngal'arem [?] ilartat-llu tua-i"
        },
        "90": {
            "start": 1317.48,
            "end": 1331.69,
            "transcript": "Nunamni wii napat tuaten pulaagarluki una mimernaq ullagluku yuvriarraarluku unitaqluku alla imna ullagluki tangerrluku yuvriaraqluku."
        },
        "91": {
            "start": 1331.72,
            "end": 1343.72,
            "transcript": "Au͡gkut-llu cali mimernat kuvyanun maa-i mat'um nalliini waten ayuqellrianek pugtaqutaqengqelalriit."
        },
        "92": {
            "start": 1343.72,
            "end": 1363.51,
            "transcript": "Cali tamakut tamaa-i kuvyailiameggnun ipuutngutulit puuviqluki uskurirluki tau͡gaam ukiqaarluki canek qip'aliameggnek pilallikait,"
        },
        "93": {
            "start": 1363.51,
            "end": 1372.72,
            "transcript": "tuamta-llu cali imkut tuntut cirunritnek lead [?] nurnallrullian."
        },
        "94": {
            "start": 1372.72,
            "end": 1391.25,
            "transcript": "Cali tuntut cirunrit qupluki ukilluki ak'a-llu tamatumun kuvyam parteraanun qilleqcaaraulluku lead line [?]."
        },
        "95": {
            "start": 1398.32,
            "end": 1415.72,
            "transcript": "Tamakut tua-i-llu cakikurluki murak qaill' ayuqengraan wall'-qaa imkut kuigpagmi qavani-llu Yukon Kalskag avgulek."
        },
        "96": {
            "start": 1415.72,
            "end": 1436.31,
            "transcript": "Cotton wood tamakunek makut perelriit qaqitaqatat tamakunek aurluteng nerkiularait qayacetun."
        },
        "97": {
            "start": 1436.31,
            "end": 1450.54,
            "transcript": "Qayanek tanglartuten angyanek-llu tuaten tua-i, cat tegg'utaunani, cat nayumiqastaunani piurtesciigatuq piurcugngaung'e'rmi,"
        },
        "98": {
            "start": 1450.54,
            "end": 1461.72,
            "transcript": "ukutgun tau͡gaam caliaqsarauluni tua-i caliaqenrilkuni yuut tangvagluni ellminek pingait unatgun tau͡gaam."
        },
        "99": {
            "start": 1462.32,
            "end": 1477.95,
            "transcript": "Ataucimek-qaa muragmek, wall' ayuqenrilngurnek muragnek ataucimelngurmek ayuqenrilngurnek napanek aturluteng angyaqatali'?"
        },
        "100": {
            "start": 1477.95,
            "end": 1491.34,
            "transcript": "Makugnek yuaraqameng cukvaguarunrilengraata qagkut-ll' imkut perelrianek tua-i tau͡gaam ayemngailngurnek,"
        },
        "101": {
            "start": 1491.34,
            "end": 1509.42,
            "transcript": "cat-llu imkut cali waten ayemngulget qugniilnguut, wangtun qugniilnguut qupraarluki allamek cali waniw' una qupkuni waten taktaluni, atam waten taktaluni una waniw' iqua."
        },
        "102": {
            "start": 1509.42,
            "end": 1524.26,
            "transcript": "Tua-i-llu nanilami qupkuni, tua-i-llu cali waken ukatmun pikuni nanileng'e'rmi amun [?], aling tatkayag' uumi,"
        },
        "103": {
            "start": 1524.26,
            "end": 1536.24,
            "transcript": "kan'a tungrukaa tegg'uciqerluku cali nemerluku allamek muragmek pategcirluku, qukaakun nemerluku, ak'a tua-i."
        },
        "104": {
            "start": 1536.24,
            "end": 1542.44,
            "transcript": "Cakucinek-mi aminek nalait piluki?"
        },
        "105": {
            "start": 1542.44,
            "end": 1554.51,
            "transcript": "Piciatun tuntuit amiit mingeqluki tau͡gaam, tuamta-llu cali mingeqsaraat waten angyaqacilriit,"
        },
        "106": {
            "start": 1554.51,
            "end": 1570.72,
            "transcript": "waniwa waten mingqetuut, atam tangvakaraa paqnayulria, waten una yaaggun pirraarluku qerarrluku,"
        },
        "107": {
            "start": 1570.72,
            "end": 1584.21,
            "transcript": "aa, waken yaatmun pirraarluku, qerrarluku cali ikavet, tuamta-llu cali wavet piluku kapulluku yaatmun,"
        },
        "108": {
            "start": 1584.21,
            "end": 1602.87,
            "transcript": "tua-i-llu taukut imkut nuqeskuneng eqluteng [?] tua-i-llu qaqiskan-am cali canek keluit, tunurtangqerqan tunurmek, tamakut imkut pillrit mingugluki,"
        },
        "109": {
            "start": 1605.94,
            "end": 1615.9,
            "transcript": "Minguilkuneng qassumakuneng-llu imangeciqngateng [?],"
        },
        "110": {
            "start": 1615.9,
            "end": 1628.24,
            "transcript": "Man'a meq it'rayuqapiartuq, tuamta-llu cali nengla neliiyaaqciiquq waten yuk umcikapiarluku tua-i elliini [?] ellminek,"
        },
        "111": {
            "start": 1628.24,
            "end": 1641.88,
            "transcript": "Ak'a nengla it'rayuami iralullrua man'a uksum qillertellra it'rayuni-gguq iralurput pit'uq,"
        },
        "112": {
            "start": 1641.88,
            "end": 1651.91,
            "transcript": "Amiit ikir' yurneq [?] tuarenruuluni [?] itqerrluni, tua-i tamaa-i"
        },
        "113": {
            "start": 1651.91,
            "end": 1664.72,
            "transcript": "Tamakut tua-i tamatumek tunurmek wall'u camek, iinruarturyugngauq-qaa tamakut keluut?"
        },
        "114": {
            "start": 1664.72,
            "end": 1671.72,
            "transcript": "Cakucit-mi muriit angeryungqelartat qayimegteggun maaggun?"
        },
        "115": {
            "start": 1671.72,
            "end": 1680.98,
            "transcript": "Christmas tree allat piyuit, allanek-qaa napanek tanglartuten anglegnek,"
        },
        "116": {
            "start": 1680.98,
            "end": 1691.07,
            "transcript": "Napaneg'em im'un kevraartut tau͡gaam makut angengqerrluki tangtukenka, tua-i kiingan,"
        },
        "117": {
            "start": 1691.07,
            "end": 1706.55,
            "transcript": "Makuung'e'rmeng atertaat kevraartuugut [?], kinrurtaqameng, muraurtelartut [?] atercugngariluteng,"
        },
        "118": {
            "start": 1706.55,
            "end": 1719.58,
            "transcript": "Kevraartut ilaksaaqait tamakut, tamakumiumeng-llu ilii ilua qamna muriim ilaa angertangqerrlartuq ilii mur'im,"
        },
        "119": {
            "start": 1719.58,
            "end": 1730.55,
            "transcript": "kevraartucestun waten angertangqerrluni qamani mur'iim iluani nepcanaqluni cakneq, nepcugluni, angrangruluta catun,"
        },
        "120": {
            "start": 1730.55,
            "end": 1745.28,
            "transcript": "caulriit-kiq imkut, cat imkut qupneruaraat [?], yaa, tua-i tamaa-i, au͡gkut-llu bumble bee-t imku uqlalriit,"
        },
        "121": {
            "start": 1745.28,
            "end": 1762.25,
            "transcript": "honey just like honey, honey-tun ayuqluteng, ayuqluteng iliitni qupneruaraat ilait, nekevraartuyaakut makut Christmas three-at, tau͡gaam qakinrurtaqameng muraurrluut,"
        },
        "122": {
            "start": 1762.25,
            "end": 1773.98,
            "transcript": "Tua-i-llu ussucat ullulluteng atercata cupngameng, cupngan, ukut kuigaipak [?] cupngan,"
        },
        "123": {
            "start": 1773.98,
            "end": 1789.67,
            "transcript": "Cikum avayairulluki assiriluki manigiluki, avayartairulluku qainga cikut, cikut avayarpangrata-ll' avayat assiriluki waten manigiluki taq'aqluki. Aa."
        },
        "124": {
            "start": 1789.72,
            "end": 1792.17,
            "transcript": "Ii-i, qaqiskuvet, ii-i."
        },
        "125": {
            "start": 1792.17,
            "end": 1809.68,
            "transcript": "Tua-i cup'aqa wii cikum caliaqluki avayairulluki, muraurrluki tep'arnek pituaput wangkuta tamakut eq'ut maani, Kusquqvagmek-llu cetullret qavaken kiatem,"
        },
        "126": {
            "start": 1809.68,
            "end": 1822.37,
            "transcript": "Tua-i wii Christmas tree-ruyaaqut, tamakut makut, makut cuukvaguaq, kinerqameng waten ayuqngilartut."
        },
        "127": {
            "start": 1822.37,
            "end": 1827.34,
            "transcript": "Taq'uten-qaa tua-i? Yaa, tuaten taq' [?]."
        },
        "128": {
            "start": 1827.34,
            "end": 1839.35,
            "transcript": "Una waniwa aterluni amun [?] cali waten ayuqngami cat makut atengqer'"
        },
        "129": {
            "start": 1839.35,
            "end": 1856.28,
            "transcript": "Una perngami ikamranun itegkauyugngaluni, ciunguyugngaluni una-llu waten ayuqngami ikamranun"
        },
        "130": {
            "start": 1856.28,
            "end": 1876.0,
            "transcript": "Maa-i, wall'u cali kapetaat qulqitet menglemun una elliluku akia-llu inglua pikuni cali-am atuuluni tua-i una aturyugngaluni,"
        },
        "131": {
            "start": 1876.0,
            "end": 1886.02,
            "transcript": "Ava-i-llu uumgutmun [?] una calugcissuutmun, kanavet cali elliirraarluni calugciquni ak'a tuuyugngaluni,"
        },
        "132": {
            "start": 1886.02,
            "end": 1903.22,
            "transcript": "Una-wa uum wani atra, napu, waniwa napu, camun ikamranun-llu ingnaqertellregnun [?]"
        }
    },
    "U_q4jkp8UJU": {
        "1": {
            "start": 0.0,
            "end": 1.683,
            "transcript": "(Kiingita. [?])"
        },
        "2": {
            "start": 4.673,
            "end": 6.44,
            "transcript": "(Kingumek ancugaten?)"
        },
        "3": {
            "start": 6.7,
            "end": 12.923,
            "transcript": "Kingu qanerturainanem [?] antaqluki piciqanka. Tua-i-qaa pinariuriuq? Ready?"
        },
        "4": {
            "start": 12.923,
            "end": 14.4,
            "transcript": "(Yaa. Ii-i. Yup. Ii-i.)"
        },
        "5": {
            "start": 14.4,
            "end": 24.481,
            "transcript": "Wiinga-wa Yugcetun Kangrilngurmek pilaqiitnga, cali-llu kinguneqa Yugcetun Nunakauyauluni."
        },
        "6": {
            "start": 24.481,
            "end": 32.317,
            "transcript": "Cali-am nunarraqa tuaten atengqengraan kankut kingunrenka ingrit Qaluyaanek pituit."
        },
        "7": {
            "start": 32.317,
            "end": 35.375,
            "transcript": "Kass'acetun-llu Paul John-amek pilaraatnga."
        },
        "8": {
            "start": 35.375,
            "end": 45.0,
            "transcript": "Wiinga tau͡g' waniwa kingunemnek akaurturtuq ayalqa. Tayima unugcuun tayim' kingleggngataa."
        },
        "9": {
            "start": 45.0,
            "end": 55.8,
            "transcript": "Tua-llu Anchorage-amek taiqatallemni waten piqatalliniata, qetunraurluqa camna kingunemni uitalria call-arluku."
        },
        "10": {
            "start": 55.925,
            "end": 66.613,
            "transcript": "Tua-i ukut kiingita taicanricaaqengramki, ukunek tua-i piqayunarqelrianek arcaqanqurrarnek,"
        },
        "11": {
            "start": 66.613,
            "end": 75.529,
            "transcript": "yuuciatnun au͡gkut ciuliamta atuupialrianek callermeggni tamaitni,"
        },
        "12": {
            "start": 75.529,
            "end": 84.2,
            "transcript": "tua-i teguqayunarquraat uuggun nuliacungamkun tuyuqesqelluki call-allruaqa."
        },
        "13": {
            "start": 84.2,
            "end": 87.75,
            "transcript": "Tua-llu waniw' ukut maniarkanka ikgetut."
        },
        "14": {
            "start": 89.425,
            "end": 95.35,
            "transcript": "Waniwa ukut arcaqalriarut."
        },
        "15": {
            "start": 95.35,
            "end": 102.75,
            "transcript": "Cali-llu una tua-i waniw' arcaqalriaqapiarauluni. (Malikelqa.)"
        },
        "16": {
            "start": 102.75,
            "end": 107.96,
            "transcript": "Una call' waniw' cali arcaqalriaqapiarauluni."
        },
        "17": {
            "start": 107.96,
            "end": 122.692,
            "transcript": "Ukut waniwa waten amllertang'ermeng, au͡gkut ciucimta yuucillrata ellmeggnek egelrulluteng pillermeggni caskullrit angtuat."
        },
        "18": {
            "start": 122.692,
            "end": 128.713,
            "transcript": "Waten angtaurluteng alaileng'ermeng. Angtuat waniwa."
        },
        "19": {
            "start": 128.713,
            "end": 134.596,
            "transcript": "Callermeggni tamaitni caskullrit."
        },
        "20": {
            "start": 134.596,
            "end": 137.88,
            "transcript": "Waniwa una arcaqerluku."
        },
        "21": {
            "start": 137.96,
            "end": 147.538,
            "transcript": "Calissuun angtuaq pingraan una-ll' cali arcaqerluni calissuun angtuaq pingraan."
        },
        "22": {
            "start": 147.538,
            "end": 160.394,
            "transcript": "Ukut waniwa arcaqaqapiaraat muriim caurcugngarivkartai qupurrluki murak."
        },
        "23": {
            "start": 160.394,
            "end": 170.837,
            "transcript": "Qaillun tua-i ellegtallrungraan waten ellircecugngarivkartai ukut muriim."
        },
        "24": {
            "start": 172.106,
            "end": 174.913,
            "transcript": "Ukut waniwa."
        },
        "25": {
            "start": 174.913,
            "end": 185.327,
            "transcript": "Tuamta-llu waniw' muragiuquni, makunek calikuni yuk, waten makulikuni,"
        },
        "26": {
            "start": 185.327,
            "end": 193.64,
            "transcript": "uuggun tau͡gaam waniwa waten makuurcecugngaluki."
        },
        "27": {
            "start": 193.64,
            "end": 204.394,
            "transcript": "Cali-llu cananaqluteng pikataa uum [?] tau͡gaam canaluku tua-i ca piurcecugngaluku."
        },
        "28": {
            "start": 204.394,
            "end": 213.904,
            "transcript": "Tua-llu cali ipgiaruskan makuciq wall' makuciq makucimeg' maa-i nutaan nuagarrluku,"
        },
        "29": {
            "start": 213.904,
            "end": 221.98,
            "transcript": "ipegcarluku, wagg'uq elliluku piyugngaluku."
        },
        "30": {
            "start": 221.98,
            "end": 236.125,
            "transcript": "Tua-llu tua-i tuaten piameng murak tamalkuq, tayima piqertuutacuarmek taicallrungatua-ll' kingunemnek pikuma,"
        },
        "31": {
            "start": 236.125,
            "end": 246.54,
            "transcript": "piqertarluku, kepraarluku, taktacirkaa cuqeqaarluku murak waten cakiuqataquniu."
        },
        "32": {
            "start": 246.54,
            "end": 258.865,
            "transcript": "Makucimek tua-i ciumek iquakun, ukut waniw' waten angtatkenricaaqut tau͡gaam tangrruarutnguut."
        },
        "33": {
            "start": 258.865,
            "end": 264.865,
            "transcript": "Angtuarutuyaaqut muragnun angtuanun atulriarulriit."
        },
        "34": {
            "start": 264.865,
            "end": 273.163,
            "transcript": "Muriim iquanun piluku, cali tua-i kaugtuutarkamek taicallruunga kingunemnek taillrukuma."
        },
        "35": {
            "start": 273.55,
            "end": 281.837,
            "transcript": "Waten acitmun murak qavcinek pingayunek wall' cetamanek ellekan pirraarluku,"
        },
        "36": {
            "start": 281.837,
            "end": 291.125,
            "transcript": "kaugtuqtaarturluku waten pikuneng it'riinaquneng, ayagnirciqaat murak quplerkaa."
        },
        "37": {
            "start": 291.125,
            "end": 304.7,
            "transcript": "Cali tua-i ayagnengkan allanek waten kapusvikaqluku iqutmun murak ayuqevkenaku caurcugngaluku makuciurcugngaluku."
        },
        "38": {
            "start": 305.025,
            "end": 318.615,
            "transcript": "Ukuk waniwa waten calissuutek muraliurcuutek angtaurang'ermek yuut cangnaqellermeggni tamiignun atulriaqellruagket."
        },
        "39": {
            "start": 318.615,
            "end": 332.74,
            "transcript": "Uumek ca cananarqerkaq, apeqmeggnek qanilqerluku, qayikuneng, angyikuneng, piciatun ikamrarkiuquneng,"
        },
        "40": {
            "start": 332.74,
            "end": 340.577,
            "transcript": "uuggun keputekun tau͡gaam tua-i qanilqerluku pikarnirillratun pitariluku."
        },
        "41": {
            "start": 341.029,
            "end": 350.721,
            "transcript": "Tua-i-ll' nutaan canayaqliyukan [?] call' waten waniwa makucikun canaluku,"
        },
        "42": {
            "start": 350.721,
            "end": 367.113,
            "transcript": "tua-i caurtellerkaatun canaluku, makuciugarkaukan canaluku, qantaugarkaukan canaluku, uum tua-i akluliumaluki yuut."
        },
        "43": {
            "start": 367.588,
            "end": 382.904,
            "transcript": "Pitegcautekiuquneng canaluku, nagiiquyarkiuquneng canaluku, apeqmeggnek tegutekiuquneng canaluku, urluverkiuquneng canaluku,"
        },
        "44": {
            "start": 382.904,
            "end": 388.08,
            "transcript": "uuggun tau͡gaam ciumek qanilqerraarluku keputekun."
        },
        "45": {
            "start": 388.55,
            "end": 396.48,
            "transcript": "Keputek uksuaraqararkamnek-am cali yaani itrutellruyaaqua yaavet yaa-i elliqallruaqa."
        },
        "46": {
            "start": 404.48,
            "end": 418.712,
            "transcript": "Una waniwa kepun qaillun murak ayuqengraan cauqataqan makucikun maa-i waten qanilqatuluku, keputequluku."
        },
        "47": {
            "start": 418.712,
            "end": 426.875,
            "transcript": "Tua-i waten yaaken ayagluku, wall' iqua cingigluku ayuqluku tua-i,"
        },
        "48": {
            "start": 426.875,
            "end": 440.663,
            "transcript": "makuliqataquneng-llu maa-i cali waten cali pirraarluku waten canassuutekun cali, assircarluku, assircalriacetun piluku."
        },
        "49": {
            "start": 441.613,
            "end": 450.125,
            "transcript": "Cali-llu ava-i kaugtuutarkamnek taicallrulliungaallruunga."
        },
        "50": {
            "start": 450.125,
            "end": 462.475,
            "transcript": "Man'a maa-i uum murak qupsugngallra manikumku cayanricugnarquq, man'a qup'eng'e'rmi cangaituq."
        },
        "51": {
            "start": 481.925,
            "end": 487.375,
            "transcript": "Estuuluq navngaciqelliuq."
        },
        "52": {
            "start": 491.963,
            "end": 494.4,
            "transcript": "Tang at [?] waniw' tua-i qupkii."
        },
        "53": {
            "start": 494.913,
            "end": 503.25,
            "transcript": "Waten waniw' murak qaillun ellegtangraan makucirrarteggun maa-i, anglartut tau͡gaam."
        },
        "54": {
            "start": 503.25,
            "end": 512.596,
            "transcript": "Murak qaill' ellegtangraan miklirivkaryugngaluku makutgun waten piluku."
        },
        "55": {
            "start": 512.596,
            "end": 521.675,
            "transcript": "Tua-i-ll' qupluni. Tua-i maa-i makut calissuullugpakutpallraat angtuat makut maa-i,"
        },
        "56": {
            "start": 522.475,
            "end": 538.558,
            "transcript": "kallugyaraitellermeggni muragmun tua-i yuucirkameng cassuutekaanun makulissuutekluku tuaten aturluki."
        },
        "57": {
            "start": 538.558,
            "end": 551.588,
            "transcript": "Tua-llu man'a maa-i uum apertuallra, malruuluni atuuyungalria nemiarutnguluni, nemirciuluni elnguami."
        },
        "58": {
            "start": 551.813,
            "end": 556.654,
            "transcript": "Cali-am waten waniwa makukiuqatalriani."
        },
        "59": {
            "start": 556.654,
            "end": 560.962,
            "transcript": "Waten ayagniryarauluni makucimek atulriani."
        },
        "60": {
            "start": 560.962,
            "end": 569.538,
            "transcript": "Cali-am qupellra waten pinginayu', pinginarciiganani alularyarauluni."
        },
        "61": {
            "start": 569.538,
            "end": 576.231,
            "transcript": "Wavet cali tusngavkenani qupesciigatuq elluarrluni."
        },
        "62": {
            "start": 576.231,
            "end": 586.827,
            "transcript": "Wavet tau͡gaam tua-i ciisqumun elliluku tangvagluku alularayunaqluni qupellra muriim."
        },
        "63": {
            "start": 590.0,
            "end": 593.048,
            "transcript": "Munarulluku."
        },
        "64": {
            "start": 593.048,
            "end": 599.413,
            "transcript": "Tua-i-am maa-i qupsarauniurtessiyaanrilamni malruugtuq."
        },
        "65": {
            "start": 599.413,
            "end": 603.24,
            "transcript": "Uuggurraq [?] tau͡gaam waniwa."
        },
        "66": {
            "start": 603.24,
            "end": 611.163,
            "transcript": "Tua-i makucir' maa-i yuucimeng callermeggni angutem cayaraani."
        },
        "67": {
            "start": 611.163,
            "end": 614.875,
            "transcript": "Una waniw' piicunailquqapiaralleq."
        },
        "68": {
            "start": 615.38,
            "end": 617.971,
            "transcript": "Tua-i atullra amllerrami."
        },
        "69": {
            "start": 617.971,
            "end": 626.688,
            "transcript": "Tuamtell' waniwa una-am qupsukuniu cali qupenqigcugngaluku."
        },
        "70": {
            "start": 632.15,
            "end": 638.202,
            "transcript": "(We can't see it. We can't see it.) (Tangesciigataa.)"
        },
        "71": {
            "start": 638.202,
            "end": 645.038,
            "transcript": "Qupenqegquq-wa [?]. Qupengnaqellma assiitsiyaagpek'naku iptevkaraa."
        },
        "72": {
            "start": 650.413,
            "end": 661.558,
            "transcript": "Tua-i maa-i. Tua-llu waniwa apqiitnek nemirciksukuniu, cali-am piciatun qupsunainani,"
        },
        "73": {
            "start": 661.558,
            "end": 668.988,
            "transcript": "ukatmun qupsunaunani, ukatmun tau͡gaam qupneqluni nemirciuyukuni."
        },
        "74": {
            "start": 674.875,
            "end": 680.45,
            "transcript": "Mamtuami makucikun tau͡gaam call' qupnarqaa."
        },
        "75": {
            "start": 689.325,
            "end": 698.529,
            "transcript": "Iit amllerpakaata tangvagtenka piyuumanaicarpiaraqa."
        },
        "76": {
            "start": 698.529,
            "end": 706.442,
            "transcript": "Ulunengqerrmilliniuq-am una. Waniwa-ll' apqiitnek ulunani tekican kep'uq."
        },
        "77": {
            "start": 706.442,
            "end": 710.588,
            "transcript": "Tua-llu waniw' ciilerngelliniluku tuaten man'a."
        },
        "78": {
            "start": 710.838,
            "end": 712.18,
            "transcript": "Ciilnguakuaqca [?]."
        },
        "79": {
            "start": 712.18,
            "end": 722.18,
            "transcript": "Ii-i. Waniwa-gguq nemircilikuneng waten piyarauluni."
        },
        "80": {
            "start": 724.075,
            "end": 736.51,
            "transcript": "Ciilerterrlullra man'a waniw' makucikauluku waten nemircikauluku piaqamegteggu quptuluteng."
        },
        "81": {
            "start": 736.51,
            "end": 739.35,
            "transcript": "Tua-i tang ciilertellinikii."
        },
        "82": {
            "start": 739.388,
            "end": 749.558,
            "transcript": "Ciilrem man'a kep'arcungevkallinia. Waniw' ciilertevkenak pikumku ukuk imutun,"
        },
        "83": {
            "start": 749.558,
            "end": 758.838,
            "transcript": "car-aami drive-alriim una, drive-ayullni tua-i pissuutekaa."
        },
        "84": {
            "start": 759.113,
            "end": 773.308,
            "transcript": "Makuciliaqameng ukuk waniwa drive-arcuutek keggluku ayagteskuniu ukugnegun tau͡gaam kepevkarpek'naku iquklilluku qupevkararkauluku iquk'."
        },
        "85": {
            "start": 773.308,
            "end": 783.827,
            "transcript": "Waten-llu makuciurtelluku nemircililria apqiitnek ukuk tau͡gaam talularluku [?]."
        },
        "86": {
            "start": 783.827,
            "end": 798.08,
            "transcript": "Tuamta-ll' ava-i tangvakevcia murak quplemni uum tau͡gaam tegumiaqellma iquklitevkarluku kepevkarpek'naku."
        },
        "87": {
            "start": 798.413,
            "end": 811.38,
            "transcript": "Tuamta-ll' ava-i tangvakvut ukuyagaagnegun 2x4 qupelria caurcugngariluni."
        },
        "88": {
            "start": 811.875,
            "end": 826.587,
            "transcript": "Tua-i-llu tuaten ayuqngamiu au͡gkut-ll' imkut unuaq maniullri au͡g'um au͡gkut, nanerpiit, nagiiquyat, tegutet, nuqat."
        },
        "89": {
            "start": 826.587,
            "end": 837.888,
            "transcript": "Uuggun tau͡gaam cali qupraarluki cali tua-i qanilqerluku cakarniriyugngariluku."
        },
        "90": {
            "start": 838.95,
            "end": 848.885,
            "transcript": "Wani-w' ukuk piqertuutarmek pingayurlutek avani ciuliamta,"
        },
        "91": {
            "start": 848.885,
            "end": 859.1,
            "transcript": "Kass'at makut cassuutait igvarpailgata tua-i ilumun piicunaitqapiarallgek [?] angutngulriani."
        },
        "92": {
            "start": 859.238,
            "end": 873.12,
            "transcript": "Neqsuutmun, ikamranun, angyanun, qayanun, tua-i canun tamarmeng atulriarullrulutek ukuk."
        },
        "93": {
            "start": 874.688,
            "end": 886.56,
            "transcript": "Una-wa cakiirutma pia angssiyaagluni una tuaten navellruluni cakillma una pilqa, una tau͡gaam wii pilialqaqa."
        },
        "94": {
            "start": 886.95,
            "end": 891.963,
            "transcript": "(Camek tauna atengqerta? Tugumian. Camek atengqerta?)"
        },
        "95": {
            "start": 892.2,
            "end": 895.096,
            "transcript": "Malrugnek acilaraat."
        },
        "96": {
            "start": 895.096,
            "end": 902.885,
            "transcript": "Nunat Mellgarmek nunalgutellget at'legmek canassuutmek pituat."
        },
        "97": {
            "start": 902.885,
            "end": 909.279,
            "transcript": "Mellgarmek-llu nunalgutailnguut mellgarmek."
        },
        "98": {
            "start": 909.279,
            "end": 918.346,
            "transcript": "Una-w' cali man'a eneq, akaartapiaq cali arunritlinilria."
        },
        "99": {
            "start": 918.538,
            "end": 928.588,
            "transcript": "Kankut kanani nunamta avatiini wagg'uq ukut nunallret, Engelumiunek atpiangqerrnilarait."
        },
        "100": {
            "start": 930.4,
            "end": 940.885,
            "transcript": "Taum-gguq Apanuugpiim anguyiurcuutnguluni qanemciutullrem yuurrvillri, nunat ak'allat."
        },
        "101": {
            "start": 940.885,
            "end": 948.529,
            "transcript": "Pivakarlua-am tekitanka ustellrullinilria."
        },
        "102": {
            "start": 948.529,
            "end": 962.048,
            "transcript": "Man'a-w' tang asverem tulimaa, man'a-w' nunam qaill' mamtutacia qaill' tayim' pugumalria tuaken ussingalriamek nunamek una."
        },
        "103": {
            "start": 964.048,
            "end": 967.673,
            "transcript": "Piunga, \"Aling ak'allar' una eneq alaunani.\""
        },
        "104": {
            "start": 967.673,
            "end": 971.76,
            "transcript": "Maaten tang elaglua antaqa arumavkenani."
        },
        "105": {
            "start": 971.76,
            "end": 980.327,
            "transcript": "Tua-i-ll' una waniw' piliaqngamku epuliulluku, ak'allapiaq tuar una eneq."
        },
        "106": {
            "start": 980.327,
            "end": 987.225,
            "transcript": "Narulkaqurrlainarluteng tau͡gaam pissutullermeggni au͡gkut ciuliamta nerkuallrat."
        },
        "107": {
            "start": 987.6,
            "end": 991.115,
            "transcript": "(Apanuugpiim nerkuallra.) Ii-i. (Ii-i.)"
        },
        "108": {
            "start": 991.115,
            "end": 998.808,
            "transcript": "Tua-i waniw' arumavkenani iillanaqluni nunam akuliinteng'ermi."
        },
        "109": {
            "start": 998.808,
            "end": 1015.452,
            "transcript": "Tua-i ukut amllenricaaqut manillrenka tau͡gaam ciuliamta yuucirmeggni arcaqalriaqapiaqluki atuqengalqengatki,"
        },
        "110": {
            "start": 1015.452,
            "end": 1021.615,
            "transcript": "qetunramnun tuyurtequaluki taitesqelluki piluki."
        },
        "111": {
            "start": 1021.615,
            "end": 1028.288,
            "transcript": "Maniarkaitqapigcalqa ukunek waniw' maniarkangqerqertua."
        },
        "112": {
            "start": 1028.288,
            "end": 1035.32,
            "transcript": "Apyutengqerquvci tayima. Elpeci-w' tau͡gaam ayagyuanun."
        },
        "113": {
            "start": 1035.32,
            "end": 1046.08,
            "transcript": "(Tauna keputmek pilaqiit. Aterpagtenrilavkek ava-i caullritnek, taukut-llu qupsuutekelten.)"
        },
        "114": {
            "start": 1046.08,
            "end": 1054.51,
            "transcript": "Una Equgcuutmek nunalgutellret aivagutmek pituat."
        },
        "115": {
            "start": 1054.51,
            "end": 1062.4,
            "transcript": "Equgcuutetailnguut tau͡gken equgcuutmek ekiarqitmek-llu."
        },
        "116": {
            "start": 1062.4,
            "end": 1078.481,
            "transcript": "Makut-gguq mikcuaraat ekiarqitnek pitukait waten taluyarkiuraqameng apeqmeggnek cigyagkiuraqameng ekialmun qupqata'arqamegteki ava-i ayagnillemtun kaugtuarluki."
        },
        "117": {
            "start": 1078.481,
            "end": 1083.038,
            "transcript": "(Muraugut-qaa? Muragnek-qaa pilituut?)"
        },
        "118": {
            "start": 1083.038,
            "end": 1091.663,
            "transcript": "Kass'at imkut tegqautait, qanikciurutet epullrit wall' piqertuutaat."
        },
        "119": {
            "start": 1091.663,
            "end": 1101.913,
            "transcript": "Nutaan tau͡gken avani Kass'at waten cautait igvarpailgata tegg'eranek imkunek (Makunek.),"
        },
        "120": {
            "start": 1101.913,
            "end": 1111.115,
            "transcript": "ii-i, tegg'eranek pikartaqlu', pikartetullrulliniluteng makukarrlu'."
        },
        "121": {
            "start": 1111.115,
            "end": 1113.635,
            "transcript": "(Angtatkevkenaki-llu-qaa piliaqluki?)"
        },
        "122": {
            "start": 1113.635,
            "end": 1126.635,
            "transcript": "Ii-i, angtuanun pikateng, qaillun-llu taktaluki piliaqaqluki angtuanun qupurrissuutekaat."
        },
        "123": {
            "start": 1126.635,
            "end": 1133.0,
            "transcript": "Tua-i angtatkevkenaki tua-i yuum piullmitun makungqerrarkauluni yuk."
        },
        "124": {
            "start": 1137.625,
            "end": 1144.183,
            "transcript": "Aivagutet, equgcuutet, ekiarqitet. Pingayunek waniw' una aterluni."
        },
        "125": {
            "start": 1144.183,
            "end": 1155.221,
            "transcript": "Una-wa cakitessuun, cakitessnamegnun [?] nunalgutellget keputmek piyugngallikiit."
        },
        "126": {
            "start": 1155.221,
            "end": 1160.394,
            "transcript": "Tua-i keputmek wangkuta kingunemteńi pilaraat."
        },
        "127": {
            "start": 1160.394,
            "end": 1166.0,
            "transcript": "Una-llu tua-i ataatangqellruunga Mellgarmek."
        },
        "128": {
            "start": 1166.452,
            "end": 1172.837,
            "transcript": "Nunamteńi canassuutmek pituluki, ilaita-llu mellgarnek pituluki."
        },
        "129": {
            "start": 1172.837,
            "end": 1186.144,
            "transcript": "(Makut-am au͡gkut atruaqanun [?] nunalgutmeggni qulautekluku-am tuaten ava-i tuaten pilaraat.)"
        },
        "130": {
            "start": 1186.144,
            "end": 1194.0,
            "transcript": "Aling aruksaitekai calliurman' [?]. (Mamtungraan unani, mamturingraan.) Ii-i, ii-i."
        },
        "131": {
            "start": 1194.725,
            "end": 1199.99,
            "transcript": "(Kaugpiita tulimait arumaitelliniat.)"
        },
        "132": {
            "start": 1199.99,
            "end": 1204.88,
            "transcript": "Arutuyaaqeng'ermeng-wa caami una enritqallrullinia."
        },
        "133": {
            "start": 1204.88,
            "end": 1208.94,
            "transcript": "(Elpenun-gguq tua-i atuusqelluni taumun.) Ii-i."
        },
        "134": {
            "start": 1208.94,
            "end": 1213.96,
            "transcript": "(Elpenun-am maniuresqelluku, aturluku.) Ii-i."
        },
        "135": {
            "start": 1213.96,
            "end": 1223.52,
            "transcript": "(Uum wani Ellam Yuan taumek-am paivutellrullinikii.) Ii-i."
        },
        "136": {
            "start": 1223.988,
            "end": 1231.74,
            "transcript": "Imkut-wa elpeci maniciqngavci unaken pitallrenka pinrilkenka."
        },
        "137": {
            "start": 1231.74,
            "end": 1235.52,
            "transcript": "Tua-ll' makut maa-i Kass'allaulria una."
        },
        "138": {
            "start": 1236.263,
            "end": 1238.894,
            "transcript": "Electric-am cingik."
        },
        "139": {
            "start": 1238.894,
            "end": 1254.394,
            "transcript": "Wii-am ikamrillemni iluturiqerrinayuklua waten iterpallagyailkucirluku drill-aqullemni ussukcar' pivigkait [?] ekumallinian-am un' malikellinikeka."
        },
        "140": {
            "start": 1254.638,
            "end": 1262.635,
            "transcript": "Una-w' cali munailama manialngurnun manigcissuutem drill-am cingilga Kass'alleq."
        },
        "141": {
            "start": 1262.635,
            "end": 1264.563,
            "transcript": "(Kass'artauluni.)"
        },
        "142": {
            "start": 1265.375,
            "end": 1276.115,
            "transcript": "(Makucimek yuarkaullruyaaqua maani kipusvigni. Waten angtaunga') (Camek?) (Au͡gkucimek maniqallru')"
        },
        "143": {
            "start": 1276.115,
            "end": 1279.654,
            "transcript": "Swanson-aami pitangqelartuq."
        },
        "144": {
            "start": 1279.654,
            "end": 1286.24,
            "transcript": "Yaani kelliani caviliurviani."
        },
        "145": {
            "start": 1286.24,
            "end": 1290.183,
            "transcript": "([?])"
        },
        "146": {
            "start": 1290.183,
            "end": 1294.15,
            "transcript": "Qaillun? Tua-i-qaa taqua? (Yaa.)"
        },
        "147": {
            "start": 1363.02,
            "end": 1368.481,
            "transcript": "(Antarssuutekua-qaa?) Ii-i."
        },
        "148": {
            "start": 1368.481,
            "end": 1372.231,
            "transcript": "(Popscicle?)"
        },
        "149": {
            "start": 1372.231,
            "end": 1379.08,
            "transcript": "Pikuneng-wa piciqlill'."
        },
        "150": {
            "start": 1394.788,
            "end": 1399.975,
            "transcript": "Ayagnirnariuq-qaa au͡gna wall'u-qaa? (Ikegkuk-gguq utaqalukek.)"
        },
        "151": {
            "start": 1403.188,
            "end": 1409.279,
            "transcript": "Ayagnirnariuq-qaa? Tauna-wa atanrulria, qaa?"
        },
        "152": {
            "start": 1409.279,
            "end": 1414.02,
            "transcript": "(Makut-wa tau͡gaam kalikarnek calialget atanrulriit.)"
        },
        "153": {
            "start": 1432.125,
            "end": 1436.683,
            "transcript": "(Dean, are you ready? Yeah.)"
        },
        "154": {
            "start": 1436.683,
            "end": 1439.02,
            "transcript": "(Ayagniryukuvet.)"
        },
        "155": {
            "start": 1439.25,
            "end": 1451.221,
            "transcript": "Wiinga-w' waniwa nutem, nutem Akiarmiungunricaaqua."
        },
        "156": {
            "start": 1451.221,
            "end": 1459.163,
            "transcript": "Uani uakarpeceńi Mamterillermiut Urucararmiut uatiitni yuurtellruunga Napaskiarmi."
        },
        "157": {
            "start": 1460.438,
            "end": 1472.365,
            "transcript": "Tua-i-llu unisteka tauna ataka up'nerkami yuut nuna taqluku,"
        },
        "158": {
            "start": 1472.365,
            "end": 1486.488,
            "transcript": "tut'enrilamegteggu-am pillerkani pian up'nerkillermi tayima apa'urluurutma Quteraam Qucillgaam, up'nerkillrani qemagngaluni tua-i ellimaluni."
        },
        "159": {
            "start": 1486.813,
            "end": 1500.26,
            "transcript": "Wiinga-w' waniwa atqa, wiinga-wa nunakarte' pavani tuaten Akulmi, Napaskiarni yuurqaarlua Akulmun pavavet pillrulrianga."
        },
        "160": {
            "start": 1500.26,
            "end": 1510.863,
            "transcript": "Cali aanaka angutmek algacakesciullrani."
        },
        "161": {
            "start": 1510.975,
            "end": 1515.462,
            "transcript": "Tua-i pavani anglillruunga."
        },
        "162": {
            "start": 1515.462,
            "end": 1526.952,
            "transcript": "Pavani-llu angliama pau͡gkumiu pavani pau͡gkut piluki."
        },
        "163": {
            "start": 1526.952,
            "end": 1535.452,
            "transcript": "Aren, aren wiinga waniwa unisteka Yugtun ateqluku atra."
        },
        "164": {
            "start": 1535.452,
            "end": 1543.048,
            "transcript": "Middle name-aa ateqluku Misngalriamek piaqlua Kass'atun-llu Wassilie."
        },
        "165": {
            "start": 1543.048,
            "end": 1553.9,
            "transcript": "Una-wa aanaka aptelaryaaqaqa canritellrani,"
        },
        "166": {
            "start": 1553.9,
            "end": 1558.933,
            "transcript": "\"Unistemqa-qaa, atama-qaa atra nallunritan?\""
        },
        "167": {
            "start": 1558.933,
            "end": 1568.263,
            "transcript": "\"Naamell' elliin-wa takaqellruamku-w', takaqellruamku-wa apteksaitellruamku nallukeka.\" Tuaten tua-i qanellruuq."
        },
        "168": {
            "start": 1568.263,
            "end": 1580.692,
            "transcript": "Una-w' wani kinguqliurutma Paul Evon-am, last name-aanun wii join-arlua pillruunga tua-i tuaten ayuquq."
        },
        "169": {
            "start": 1580.692,
            "end": 1586.975,
            "transcript": "Cali-ll' pavani Akulmi, ukuk waniwa qalartellrulriik,"
        },
        "170": {
            "start": 1587.863,
            "end": 1591.442,
            "transcript": "kuik tuaten capluku imkunek qagkunek napanek."
        },
        "171": {
            "start": 1591.442,
            "end": 1600.74,
            "transcript": "Napat qagkut iqtungraan tua-i niraraucirluku [?]."
        },
        "172": {
            "start": 1600.74,
            "end": 1611.02,
            "transcript": "Cali taluyilallruut unatetgun caviyaarnek pivkenateng munarciatgun uum waniwa qalartellrukii."
        },
        "173": {
            "start": 1611.688,
            "end": 1616.152,
            "transcript": "Munarciat makut pilallruut."
        },
        "174": {
            "start": 1616.152,
            "end": 1634.471,
            "transcript": "Tuamta-llu cali kuigmi pavani Akulmi uitallemni imkunek makunek can'giirnek taluyiqatarqameng,"
        },
        "175": {
            "start": 1634.471,
            "end": 1642.6,
            "transcript": "kuik tua-i waten kuig' maa-i kuigukuni kelutmun ceńaq cauluku."
        },
        "176": {
            "start": 1642.6,
            "end": 1655.529,
            "transcript": "Imkut maa-i tanglaqput kanaqliit, kanaqliit tevyulit, ilegviit. Atrit amllertut tau͡gaam. Tagnengqelalriit."
        },
        "177": {
            "start": 1655.538,
            "end": 1674.0,
            "transcript": "Tua-i tuaten can'giircuutet kelutmun caulluki ceńaq cauluku tau͡gaam camna qanikciurutkun caluku muragkun-llu elagiyaurluku waten manigyaaqerraarluni waten elliluku."
        },
        "178": {
            "start": 1674.0,
            "end": 1678.02,
            "transcript": "Ceńakun pektelalliniameng imkut can'giiret."
        },
        "179": {
            "start": 1678.106,
            "end": 1688.087,
            "transcript": "Tamaavet ek'artaqameng taluyat kelutmun caumang'e'rmeng tua-i neq' anguaqluteng pilallrulriit."
        },
        "180": {
            "start": 1688.087,
            "end": 1694.808,
            "transcript": "Tua-i au͡g'um anglicartema tuaten piaqan, kuik aturvikluku tua-i."
        },
        "181": {
            "start": 1695.692,
            "end": 1702.712,
            "transcript": "Tuaten tagneruirluki-gguq taluyirluni can'giiliqaqluni can'giirnek."
        },
        "182": {
            "start": 1702.712,
            "end": 1717.154,
            "transcript": "Cali-ll' murag' man'a avani cat, pillerma', cat waten nurnallratni cat piurtengnaqluki pilallrulliniluteng."
        },
        "183": {
            "start": 1718.365,
            "end": 1731.471,
            "transcript": "Tuamta-llu cali kuvyalingnaq'lallruyaaqellrullinilriit imkunek nauw' tanglut yaani tutnerit ciungini, ciungani."
        },
        "184": {
            "start": 1731.471,
            "end": 1735.923,
            "transcript": "Tuaten tua-i pinevluku-gguq."
        },
        "185": {
            "start": 1735.923,
            "end": 1742.25,
            "transcript": "Pinvanek tuntut amiitek-llu pinevluki kuvyaling' qilagaqluteng kuvyaliluteng."
        },
        "186": {
            "start": 1742.25,
            "end": 1749.298,
            "transcript": "Tau͡gaam-gguq-am keniaqameng aqelquqtaarluteng tua-i keniaqameng."
        },
        "187": {
            "start": 1749.298,
            "end": 1764.529,
            "transcript": "Amit makut mecungaqameng tuaten ellilaameng tau͡gaam imkut enrilnguat amiit waten makucetun waniw' una elngum amia."
        },
        "188": {
            "start": 1764.529,
            "end": 1785.817,
            "transcript": "Waten allegluku tua-i-llu kinerciqarraarluki, kinerpailegata imkut issurit qiluit, irnerrluliuqata'arqavegteki tailarait keligarluki."
        },
        "189": {
            "start": 1785.817,
            "end": 1794.788,
            "transcript": "Tua-i-am tuaten au͡gkut keligarluki elatait au͡g'arluki pilallrulliniit."
        },
        "190": {
            "start": 1794.788,
            "end": 1802.02,
            "transcript": "Qagkut imkut uqviaraat amiit. Kinerciqarraarluki tua-i."
        },
        "191": {
            "start": 1802.02,
            "end": 1816.394,
            "transcript": "Tua-i-llu cali kinrata cali qipluki aklukengnaqngamegteki-w' tua-i."
        },
        "192": {
            "start": 1816.394,
            "end": 1826.163,
            "transcript": "Aqsaqurteng kiingan tua-i allamek piinateng. Nerrsuukaraat [?] tau͡gaam makut arcaqakellrulliniamegteki."
        },
        "193": {
            "start": 1830.538,
            "end": 1841.837,
            "transcript": "Cat muriit tua-i aklukluki. Maa-i-llu makut, tuamta-llu cali waniw' una cuukvaguaq."
        },
        "194": {
            "start": 1841.837,
            "end": 1848.51,
            "transcript": "Una-am wani perelria piciatun atuuguq."
        },
        "195": {
            "start": 1848.51,
            "end": 1862.529,
            "transcript": "Wall'u imkunek ava-i tuntut amiitnek angya' pagaavet qanganarrculallrulliniameng ingrini up'nerkami ayagluteng."
        },
        "196": {
            "start": 1862.856,
            "end": 1868.49,
            "transcript": "Tua-i-llu cali-am cuukvaguanek makunek."
        },
        "197": {
            "start": 1868.49,
            "end": 1874.317,
            "transcript": "Makut-am muriit cuukvaguarungaleng'ermeng malruugut atrit."
        },
        "198": {
            "start": 1876.02,
            "end": 1886.135,
            "transcript": "Waniw' ukuk, tang waniw' una cuukvaguam... una auguqsuliulliniuq."
        },
        "199": {
            "start": 1886.135,
            "end": 1893.279,
            "transcript": "Una-llu cali auguqsuliu', makungertuq atam, ukuk auguqsuliulliniuk."
        },
        "200": {
            "start": 1893.279,
            "end": 1903.481,
            "transcript": "Waten-am makut qaaryait, utnguit, qaillun nallunaitut makumegteggun. Malruugut."
        },
        "201": {
            "start": 1903.779,
            "end": 1913.971,
            "transcript": "Maa-i makut-ll' amiit, aminun waten, kavirutekluki pilallruit. Color-irluki imkut qatengraata."
        },
        "202": {
            "start": 1913.971,
            "end": 1929.586,
            "transcript": "Atkuliameng-llu arnat imkut alngat, pukit, tuntut melqurrit qatellriit, kangiitnun elliarkarceteng makut."
        },
        "203": {
            "start": 1929.586,
            "end": 1934.02,
            "transcript": "Qeltait au͡g'arraarluki tamakunek kavirrluki."
        },
        "204": {
            "start": 1934.346,
            "end": 1951.163,
            "transcript": "Tuamta-llu cali cat ipuutet tuaten makut camek tau͡gaam auqerluki, uqumek auluki pilallrullikait."
        },
        "205": {
            "start": 1951.163,
            "end": 1962.26,
            "transcript": "Tua-i-llu cali makut maa-i algacagluteng-am cali pagaani ingrini, ingrit napaitelaameng iliini tua-i."
        },
        "206": {
            "start": 1962.481,
            "end": 1965.942,
            "transcript": "Tua-i ingrirrlain' teggalqut tua-i napataunani."
        },
        "207": {
            "start": 1965.942,
            "end": 1975.961,
            "transcript": "Makunek-am cali napanun aqvalluteng imkunek perelrianek cuukvaguanek."
        },
        "208": {
            "start": 1975.961,
            "end": 1984.933,
            "transcript": "Angyanun makut tua-i akia-llu piluku ayuqii uum."
        },
        "209": {
            "start": 1984.933,
            "end": 1989.654,
            "transcript": "Tua-i-llu tuaten elliurluku aguutetun makut."
        },
        "210": {
            "start": 1990.183,
            "end": 1996.086,
            "transcript": "Perelriit angyiluteng mingeqluki-llu cali imkut tuntut amiitnek."
        },
        "211": {
            "start": 1996.086,
            "end": 2000.51,
            "transcript": "Nauwa, Barrow-mi imkut angyat tanglaqci."
        },
        "212": {
            "start": 2000.51,
            "end": 2012.058,
            "transcript": "Tuaten tua-i mingeqluki pugtayugngarilalliniut makut tuntut, taqukat, tan'gerlit, wall'u tuntuviit."
        },
        "213": {
            "start": 2012.058,
            "end": 2014.02,
            "transcript": "Angyauyugngariluteng."
        }
    },
    "63IWdhSwF8w": {
        "1": {
            "start": 36.05,
            "end": 38.32,
            "transcript": "Ayagniryukuvet."
        },
        "2": {
            "start": 38.32,
            "end": 55.75,
            "transcript": "Tua-i-llu tua-i imna tekicameng tuavet kingunermeggnun nutaan angyaqatak amiirluku ciirraarluku imegluku tua-ll' qemaggluku,"
        },
        "3": {
            "start": 55.75,
            "end": 68.21,
            "transcript": "Tua-i-llu cali uumiku cali tamana angyaqatak imegluku tua-i kinssiiyaagpailgan [?] imegluku qemaggluku."
        },
        "4": {
            "start": 68.21,
            "end": 83.13,
            "transcript": "Tua-i-llam aturarkaukuniu cali ayaulluku ciumek imgumaluku mermun kenicirraarluku tamakut angyaraatiit ataam elliyugngaat."
        },
        "5": {
            "start": 84.48,
            "end": 102.29,
            "transcript": "Amir'em man'a mermun akungqerraarluni tau͡gaam atuurtelaami, mer'em maa-i kitugtelaraat man'a amiirluku tua-i qemaggluku-llu tamana pilaraat."
        },
        "6": {
            "start": 104.36,
            "end": 125.47,
            "transcript": "Enri-llu tua-i tamakut caksugngaluki wall' muraksugngaluki camun atuunqigngailuta tua-i allamek cimirluki angyaqatiyugngiimek cat qagkunek naparpallernek tamakunek quyurqaarluteng ayautelallruut."
        },
        "7": {
            "start": 125.47,
            "end": 138.15,
            "transcript": "Tua-i tau͡gani tuaten ayuquq ii-i tua-i-qaa nutaan taqua, angyaqatii maa-i qemaggtellrem aturraarluku qemagciraa. Ii-i tua-i."
        },
        "8": {
            "start": 138.15,
            "end": 141.04,
            "transcript": "Quyanaqvaa."
        },
        "9": {
            "start": 144.45,
            "end": 153.49,
            "transcript": "Un'gaani nunamni taper' waten kepliarluki maaggun uluarluki,"
        },
        "10": {
            "start": 153.49,
            "end": 167.1,
            "transcript": "Waten napallratnek teguluki uluarraarluki elliaqluki neqnun neqet umyuaqluki piirritkait."
        },
        "11": {
            "start": 167.1,
            "end": 179.78,
            "transcript": "Cali-llu makunek maa-i tupitullruut acillqurrit acilkellritnek [?] ilaqerluki unegkumiut pikartellret."
        },
        "12": {
            "start": 179.78,
            "end": 191.22,
            "transcript": "Cau͡gken [?] nunani caninermi kelugkarnek, iitarnek-llu assiqsarkanek pitullruluteng maa-i picuirutut,"
        },
        "13": {
            "start": 191.22,
            "end": 209.68,
            "transcript": "Tau͡gaam nunamni makut arulairucuitaput neqnun atutuit piirritekluki caqukluki patukluki, curuqluki neqnun, neqnun patukluki piirritekluki."
        },
        "14": {
            "start": 210.78,
            "end": 221.5,
            "transcript": "Cali maa-i aturpatuut, tupigluki-llu tupingqullugluki patukiurluki pagaavet pimimalrianun."
        },
        "15": {
            "start": 222.71,
            "end": 235.22,
            "transcript": "Makut-wa cali maa-i-gguq can'get makut, makut maa-i angutekait uaterpalluk-llu [?] ayuqelriit arnait."
        },
        "16": {
            "start": 237.62,
            "end": 250.63,
            "transcript": "Maa-i-gguq makut tang angutait, makut-llu call' anguterluteng tegkayalrianek makut-wa arnait."
        },
        "17": {
            "start": 250.63,
            "end": 261.74,
            "transcript": "Cat tamarmeng anguterluteng, cailkaungermeng, naucetaarungermeng, ciissiungermeng, naugyaqameng irniaqluteng."
        },
        "18": {
            "start": 263.94,
            "end": 287.94,
            "transcript": "Makut maa-i wangkuta cuukiingsagaunata piineqtulput, cali kevegtarluki acilqurrit-llu ulugluki, kepluku wall' kepliarluku uluakun cuukiingsagaunata piineqtulput, angutet-llu cat carraungraata ayaulluki, ayautarkaitnek pivkarluki."
        },
        "19": {
            "start": 290.3,
            "end": 301.59,
            "transcript": "Angutngung'e'rmeng-llu ayaka'ata'arqameng piiskaunriit makunek piicuumiinateng qayatullratni,"
        },
        "20": {
            "start": 301.59,
            "end": 322.22,
            "transcript": "Aturtut call' [?] makut atullruaput makunek tuamelcung' [?] nevunegnengqetullratni kepliarluki, wagg'uq uviutarkiurluki, nel'ikata tupingqullugluki, tua-i-w' nevumun pagaavet kaingailkucii-llu."
        },
        "21": {
            "start": 323.26,
            "end": 337.1,
            "transcript": "Cali-llu nevum iluani uitaatullermeggni ilaita-wa-gguq kangciraqluki kelumun, ilait-llu makunek saltupigluki kangciraqluki curuqluki,"
        },
        "22": {
            "start": 337.1,
            "end": 353.78,
            "transcript": "Avani-llu kelugkarnek aipaitnek, kuiget ceńiitni naumalalriit kelugkat, imkut pitaqellret waten ayuqluteng tau͡gaam makuit kilirnaqluteng, kelugkaci naumalriit kilirnaqluteng avata."
        },
        "23": {
            "start": 356.06,
            "end": 378.62,
            "transcript": "Maa-i makut call' atuuluteng piicunaunateng, wiinga alerqutullruatnga qimagyunritaaralrianek makunek patuvailgaki qanikcaam piutaitesqevkenii, makuutaitellerkaq-am call' uksumi tallurnaqluni."
        },
        "24": {
            "start": 380.52,
            "end": 395.88,
            "transcript": "Tua-i-llu allaneq tekiskuni piinani cimiryukaki egmian tua-i cim' pivkarluku, can'get tunluki cucukellminek tua-i avurluku tegulaulluni tuceńi piinirluni,"
        },
        "25": {
            "start": 395.88,
            "end": 412.92,
            "transcript": "Makut maa-i ellangutkellruanka-ll' wii cukiirunii pilutullruunga makucinek, tau͡gaam putukuq iliini anyugluni waten nemerluki tua-ll' acetunran [?] nemerluki piluguk all'uku."
        },
        "26": {
            "start": 414.03,
            "end": 433.22,
            "transcript": "Cali-am neqet qeltaitnek pilugurtulriani kankut cingillret patungnaqu'urluki tungailkuneng-gguq puqem ciungekuneng ar'uqerciiqut, tunglingnaqu'urluki call' makucinek pitullruukut."
        },
        "27": {
            "start": 438.5,
            "end": 461.74,
            "transcript": "Nevum iluani uitautullemteńi, makut tua-i cali-llu alqairutka tuquqatallrani aklurugaitellemteńi makut maa-i can'get akitnguyugngaluteng akagyailkutnguluteng-llu qillertat tuaten alqairutka pillruuq."
        },
        "28": {
            "start": 463.34,
            "end": 476.28,
            "transcript": "Tukuun ilua caucirlua ellangellrunikum iqluquci [?].  Ayuquciq'apiarullemtun wii ellangellemtun qanemcituunga."
        },
        "29": {
            "start": 476.28,
            "end": 493.53,
            "transcript": "Aturanek amlernek piinata, atkuput ataucivalluut, aipait allranek cimingenrilkuneng yaaliagnillauluteng alkaryugluteng, atunrirluku nutaranek tau͡gaam atungluteng."
        },
        "30": {
            "start": 493.78,
            "end": 505.57,
            "transcript": "Makut maa-i call' alerquutelput piyugngaurluut apat'availgaki makunek piitesqevkenata,"
        },
        "31": {
            "start": 505.57,
            "end": 515.17,
            "transcript": "Maa-i tua-i egmiulluku-ll' ikgelengraata pingqengnaq'lartua makucinek atuumayuirutengraata."
        },
        "32": {
            "start": 518.14,
            "end": 536.37,
            "transcript": "Atuumayuiruteng'e'rmeng piitengqellriani qanikcami cagvi [?] kevirluku agarcunarqelria makut taqsuunaki-ll' call' makut keviulluki aturluki agarrluteng mamcangqavkenateng."
        },
        "33": {
            "start": 539.14,
            "end": 558.55,
            "transcript": "Makut call' maa-i neqet curuqluki, tau͡gaam wii ak'a avani cungagpauluku nuqliartellriit piirritektullruit neqnun makut makunek maa-i aturluteng, cungagpaungraata arnanqurrarnek-wa makunek pitullrullilriit."
        },
        "34": {
            "start": 559.34,
            "end": 573.28,
            "transcript": "Maa-i makut nauwa arnara tegumialqa, una waniwa arnii makut-wa angutait."
        },
        "35": {
            "start": 577.44,
            "end": 590.32,
            "transcript": "Arnait-wa tua-i maa-i cat tamarmeng-ll' arnarluteng, pagkut-llu tua-i arnangqetullilriit, naumalriit tamarmeng arnarluteng, anguterluteng."
        },
        "36": {
            "start": 590.34,
            "end": 604.0,
            "transcript": "Au͡gkut-wa angutait tegkayalriit call' waten pingqerrluteng makuciyagarnek, tau͡gaam elleggluteng piksunaunateng, qaillun makut angutait."
        },
        "37": {
            "start": 604.0,
            "end": 620.56,
            "transcript": "Makut mayarnait, angutait piksunaunateng, makunek maa-i pitetuukut wangkuta, maa-i pitaqsunarilliniluteng makut qagait tayima."
        },
        "38": {
            "start": 622.11,
            "end": 636.05,
            "transcript": "Wiinga mingqaarkartaqama makuitgun qecugluki pissutuunga ayagmek kepaartellrit pitaqsuunaki, tau͡gaam kepeksailnguut makuitgun waten cayugturluki."
        },
        "39": {
            "start": 636.05,
            "end": 647.38,
            "transcript": "Tau͡gken tua-i neqnun-wa tua-i canun atu'urkiuquneng uluarturluki pitaqluki, tua-ll' tupingqullugluki call' ellamun agavkarluki."
        },
        "40": {
            "start": 647.54,
            "end": 656.49,
            "transcript": "Qaqikata-llu itrulluki neqivigmun ellilaki amun [?] elliluki."
        },
        "41": {
            "start": 656.49,
            "end": 670.98,
            "transcript": "Tua-ll' aturnarikan cali kepqutkevkenaku neqet'uskata teguluki cali kenilluki pirritekluki, patukluki-llu ilait."
        },
        "42": {
            "start": 670.98,
            "end": 683.12,
            "transcript": "Wangkuta makut taqsuitaput, makut maa-i taperrnat. Makut-wa can'get piinrutullret."
        },
        "43": {
            "start": 683.88,
            "end": 696.59,
            "transcript": "Makut-wa, makut-am call' teggnemeggnek aiparluteng wangkuta pitukeput pitaqsunaunateng tuklugpiit, tugglugpagnek piluki."
        },
        "44": {
            "start": 703.06,
            "end": 710.37,
            "transcript": "Wangkuta piaqluki tugglugpagnek caksunaunateng tegkayagluteng can'get."
        },
        "45": {
            "start": 713.68,
            "end": 722.82,
            "transcript": "Tua-i kinguneqa nalluyagutekluku, nalluyagucuilamku tuaten wiinga atutullemnek qantuunga."
        },
        "46": {
            "start": 723.41,
            "end": 732.06,
            "transcript": "Cali tua-i kiitaicukumta putuskarugarnek piitetullruamta angayuqamta-ll atkullraitnek umigluta inarrluta."
        },
        "47": {
            "start": 732.37,
            "end": 746.42,
            "transcript": "Tupigat-wa makucit curuput, makut qaingatni aciit-wa call' makuni can'get wagg'uq curuluut tupigat-wa qaingani curut."
        },
        "48": {
            "start": 747.04,
            "end": 760.35,
            "transcript": "Makut wagg'uq maa-i curuluut.  Cangatevkenateng aturaqluki tua-i cavkenateng, kumlacuunateng puqerrvagluteng."
        },
        "49": {
            "start": 760.35,
            "end": 775.29,
            "transcript": "Iciwa kit'ellria-llu uksuarmi makunek maa-i paivngalikuni qecugluni kemni tunairluku keviqaani maqauluteng assirluteng."
        },
        "50": {
            "start": 775.29,
            "end": 785.06,
            "transcript": "Qerrutnaunateng alerquutkellruit makut tan'gurraat makut-llu ikayuuluteng."
        },
        "51": {
            "start": 799.7,
            "end": 812.06,
            "transcript": "Makut maa-i caranglluut nanvam-llu ceńiini naumalriit kelugkaat, kuigem-llu ceńiini kelugkaat naungatuuq."
        },
        "52": {
            "start": 813.21,
            "end": 830.53,
            "transcript": "Makut-llu cali, makut-gguq nautuut-wa ak'a-gguq tamaani anguyatullermeggni tallimegteggun tamaa-i makulget taperrnarrluni nuniini uitalriit tut'esnaateng-gguq cimillrit."
        },
        "53": {
            "start": 830.53,
            "end": 844.06,
            "transcript": "Taperrnarrlugnek-gguq maa-i taperrnarrlugnek piluki nanilnguut-wa caliarkat cali tua-i issratkartetullruluteng acetussiyaanrilnguq."
        },
        "54": {
            "start": 845.08,
            "end": 860.06,
            "transcript": "Tut'esninqigtellriit-gguq naatuut, taum makut taperrnarrluit yuullritnun keluqsing'e'rmeng-gguq nautuut makuuluteng cal."
        },
        "55": {
            "start": 863.87,
            "end": 873.53,
            "transcript": "Makut maa-i caunrilkessuunauteng atuungameng."
        },
        "56": {
            "start": 873.53,
            "end": 890.06,
            "transcript": "Tan'gurraat maa-i alerquut tekiskan uksuarmi ciurraarluki makunek keviqan assinruciqniluku kecukculaagluku [?] atam ing'um pivsiaqataraa."
        },
        "57": {
            "start": 895.27,
            "end": 906.26,
            "transcript": "Tua-i? Qanrutem atullrui amllertut makut can'get angutnguluni aturyarait amllertut."
        },
        "58": {
            "start": 906.26,
            "end": 923.92,
            "transcript": "Waten uksurluku ikamrarluni pilriani tua-i-llu nani arulairmigkailnguni canlirturalriamun arulaikuni ikamrarluni pikuni."
        },
        "59": {
            "start": 924.06,
            "end": 940.88,
            "transcript": "Qecuktarluki tua-i ikamragni unkuk inarpigkaani atlirtiurluku qavaquni qerrutnaunateng makut ikamragnun iluagnun caggluki."
        },
        "60": {
            "start": 942.06,
            "end": 948.65,
            "transcript": "Qerrutnaunateng tua-i nengllirrlengraan tua-i uumanaqluteng."
        },
        "61": {
            "start": 948.65,
            "end": 971.46,
            "transcript": "Tuamta-ll' tua-i aliumatek imkut nengelmi unatairnarqelalria nuqlirluni nengllirluni-ll' piaqami qetullritnek pulurluki aliumatet imiqerluki atullritnengelmi unatairnaunateng tua-i."
        },
        "62": {
            "start": 972.06,
            "end": 992.06,
            "transcript": "Angutnguluni uksumi. Tuamta-ll'-wa pitsaqevkenani aarnairupailgani ikamrarluni wall'u pekqurluni pikuni pitsaqevkenani kitngarqelriamun tekiarrluni alqunaq pikuni nuugku'"
        },
        "63": {
            "start": 1008.6,
            "end": 1019.14,
            "transcript": "Kitngarqelriamun tekiarrluni pikuni nunaqvani makucinek tangerrnaqkan canegnek."
        },
        "64": {
            "start": 1019.14,
            "end": 1036.099,
            "transcript": "Egmian tauna [?] apqiitnek vegtalaagluni nutaan tua-i pikanruskata aturani egmian cali piluguugni yuulukek mermek imangqerrsaraulaameng kit'ellriani."
        },
        "65": {
            "start": 1036.13,
            "end": 1047.06,
            "transcript": "Mermek imairraarlukek aturan-ll' piyugngakuni tua-i ellminek cuqluni ciulaakarraarluki."
        },
        "66": {
            "start": 1049.06,
            "end": 1061.3,
            "transcript": "Piinirluni makunek piluguugni all'ukek qaillun angtangraagnek tua-i tau͡gaam piyugtutaciagtun-i piiningnaqluni, piiniqangnaqluni."
        },
        "67": {
            "start": 1061.3,
            "end": 1069.51,
            "transcript": "Qerrulliigni call' kanaken ayaglukek ekiirlukek canegnek, apqiitnek ekiirlukek."
        },
        "68": {
            "start": 1069.51,
            "end": 1087.02,
            "transcript": "Tua-i keggatminun, keggatni uum pikuniu ciumek pamkut tununi pirraarluku atkumi-ll' man'a pikuniu cali kingumek man' manulirnaur' talligni-ll' makuk."
        },
        "69": {
            "start": 1087.02,
            "end": 1100.28,
            "transcript": "Qerrusngaitelliniluku yuk tuaten tua-i pikan aturai makut qalqaingit mecungengraata, wii tua-i atullruaqa [?] qimugtetgun kicaaqellruyaaq'."
        },
        "70": {
            "start": 1100.28,
            "end": 1118.56,
            "transcript": "Tua-i avaunrilamku tuaten alerquutengqellra maaten atu'urqa. Tua-i ilumun qerrutnaunani aturanek maa-i makut qaingit kumlacaaqluki qerrutnaitepigtelliniluni."
        },
        "71": {
            "start": 1118.56,
            "end": 1129.72,
            "transcript": "Makut maa-i angutngung'e'rmeng alerquutaitgun aturnaqliniluteng can'get waten anqaillugtellriamek."
        },
        "72": {
            "start": 1129.72,
            "end": 1140.97,
            "transcript": "Cali maa-i watua wii atunriqsaitanka makut can'get apqaitnek uksurcuutek cap'akirtunge'rma."
        },
        "73": {
            "start": 1140.97,
            "end": 1156.17,
            "transcript": "Ca maavet tut'esniqautekluki amllenrilengraata imkut iciw' insulation-aarit aturturaqalriani uksurcuutet piluguut mecungyukutarculaqai."
        },
        "74": {
            "start": 1156.17,
            "end": 1172.97,
            "transcript": "Tuaten tua-i tut'esnaarralget yukutarcuillrugpagluki it'gairnaringaqvakarciigatliniluteng uksumi Kass'artaangraata uksurcuucet'vut ceńiiqallret [?] makunek maa-i."
        },
        "75": {
            "start": 1172.97,
            "end": 1182.21,
            "transcript": "Etuulliniluteng cali maa-i apertualaryaaqekenka qarinak-llu ilait atuyuit'laryunarqekait."
        },
        "76": {
            "start": 1182.21,
            "end": 1198.31,
            "transcript": "Cali tua-i waten maa-i snuukuulangengramta angutni, mecungnaqluku ilerteqataqumta vegtarluta qecuktaraqateng, vegtaasqelaraitkut."
        },
        "77": {
            "start": 1198.31,
            "end": 1212.59,
            "transcript": "Vegtarluta qillerrluki wavet aqumyaramun qalliliulluki pikumta nullumta mecungllerpagluki makut."
        },
        "78": {
            "start": 1212.59,
            "end": 1221.846,
            "transcript": "Mecungyailkullugpakluki aqumgallrem cam'un au͡gkut cali uqvigaat cuyaqsuit."
        },
        "79": {
            "start": 1221.846,
            "end": 1238.79,
            "transcript": "Makunek pikailkumta call' kepuriqerluta, tamakunek call' cuyiqerluta nullumta cali mecungengailutekliniluki uqvigaa cuyaqsuit ski-doo-m man'a aqumlleq-am mecungeng'e'rmi."
        },
        "80": {
            "start": 1238.79,
            "end": 1250.82,
            "transcript": "Makut maani nallunritevkarluki tua-i pinaqsaaqek'ngaput nallerquateksunrilamteki maa-i"
        },
        "81": {
            "start": 1250.82,
            "end": 1266.209,
            "transcript": "Tau͡gaam makut quyanarquci wall' elpeci waten ikayurluta kangiitungluci makunek tuarpiaq imutun nallunrilkengaraput qanelriatun ayuqluci."
        },
        "82": {
            "start": 1266.209,
            "end": 1281.31,
            "transcript": "Amci nallunrilkengaci qemangqaviiqnaciki wangkutnun apertuangqerciki quyanaqluci maa-i tuatnaluci makutgun-llu maa-i tape-atgun, makutgun-llu video-tgun."
        },
        "83": {
            "start": 1281.31,
            "end": 1304.22,
            "transcript": "Catairutengramta maa-i calissuutekaci kangiitungluci quyanaqluci. Catairutengramta aturluki wangkucicetun apa'urluureskuvci grandma-ureskuvci elitnaurutkaci maa-i quyanaqluci kaigatkengelriatun ayuqliriluki wangkutnek."
        },
        "84": {
            "start": 1304.22,
            "end": 1323.95,
            "transcript": "Tua-i qaneryaraungami ciulirneq-gguq kangiituumakuni nallunrilkeminek naamikikaarngaituq, egmian-gguq tuaten piyarauniluku nalqigtarkaugaa."
        },
        "85": {
            "start": 1323.95,
            "end": 1339.93,
            "transcript": "Cunaw' tua-i-w' waten ilumun nallustiin ca kangiikaqaku aperturyuumirluku aperturnaqtullinian waten kingumiyuanun [?]."
        },
        "86": {
            "start": 1339.93,
            "end": 1362.64,
            "transcript": "Tua-i tuaten makut maa-i can'get angutem aturyaraanek ava-i qanrutkeqaaranka cali tua-i qemangqaarraqellrat, uum qanellratun angutngungraata ava-i qemangqaarrangqelarniluki piqallrulria."
        },
        "87": {
            "start": 1362.64,
            "end": 1382.78,
            "transcript": "Tua-i tuaten amllenrilengraata yuilqurrluni ucikataarrangqellra assinrurpalliniluni atullrit amlleraameng perriutarkailkuni, perriutaqsuumaluki unatminun-llu."
        },
        "88": {
            "start": 1382.78,
            "end": 1396.14,
            "transcript": "Inaruskuni-llu pitsaqevkenani yuilqumi qavartaquni atlirmeng, atlirneng, atlirnelnguyailkutek-llu wall' akitekluki."
        },
        "89": {
            "start": 1396.14,
            "end": 1412.06,
            "transcript": "Tua-i atullrit amllerrluteng qilqucumiirraangermeng can'get anengnaqurallrit apqiitnek can'get-llu-gguq uqgetut [?] avaliqluki-gguq agyulraqurallrat canatenrituq."
        },
        "90": {
            "start": 1412.06,
            "end": 1421.06,
            "transcript": "Tuaten-am cali alerquutektullrukait angutngung'e'rmi atullrat can'gem amllepigtellinian tua-i."
        },
        "91": {
            "start": 1421.06,
            "end": 1436.36,
            "transcript": "Anerneminek-llu pitulim kumla tuknikek'uniu cali taplaaqerluki [?] apqiitnek maqilriaceteng qanermiaqluki."
        },
        "92": {
            "start": 1436.36,
            "end": 1451.76,
            "transcript": "Anerneran cali ikayuqsuumaluki imumek tua-i asem'amek [?] apqucingqeng'e'rmi anertevkallra ikayuqsuumaluki nengelmi pektaukuni."
        },
        "93": {
            "start": 1453.83,
            "end": 1461.06,
            "transcript": "Tua-i ava-i au͡gna wii nallunritetun nacirram tungiitni ikayuqaatua can'get tungiitnun."
        },
        "94": {
            "start": 1461.06,
            "end": 1474.06,
            "transcript": "Niitela'arqa-llu ellaagaqameng yuilqumi can'get elivumallritgun apertuuyugnganiluki can'get."
        },
        "95": {
            "start": 1474.06,
            "end": 1484.76,
            "transcript": "Ii-i. Wiinga tamaa-i taman' ayagmek taringumallruaqa waten yuilqurcaramek alerquagilaata."
        },
        "96": {
            "start": 1484.76,
            "end": 1498.06,
            "transcript": "Waniw' tua-i ellam anuqii atauciunrituq Kass'at una north-amek pitukit yugtun wangkuta negermek pilaraput."
        },
        "97": {
            "start": 1498.06,
            "end": 1514.06,
            "transcript": "Una-llu ilaita nuna kiugkenermek pitukiit wall' calaramek wangkuta nunamteńi kelugaramek aptuarput kelugaramek."
        },
        "98": {
            "start": 1514.06,
            "end": 1523.06,
            "transcript": "Ilaita calaramek piaqluku ilaita-ll' kiugkenermek wangkuta tau͡gken kingunemteńi kelugaramek."
        },
        "99": {
            "start": 1523.06,
            "end": 1540.97,
            "transcript": "Makut cali maa-i aperyarallgutkenritut nunani anuqat, una-llu Kass'at apqiit east-aq wangkuta Yugtun ungalamek pituluku Nunivaarmiut-ll' arnin'ermek."
        },
        "100": {
            "start": 1540.97,
            "end": 1555.49,
            "transcript": "Tua-llu cali una south east-aq wangkuta aptuluku kanaknernek ungalaq-ll' akuliignek kingunemni unani."
        },
        "101": {
            "start": 1555.49,
            "end": 1564.06,
            "transcript": "Cali-am ava-i iliit nunat allamun aperyarangqerrluku qanrutkellrua."
        },
        "102": {
            "start": 1564.06,
            "end": 1575.82,
            "transcript": "Una-llu south kanaknermek piaqluku wangkuta Nunivaarmiut-llu negqigteḿek."
        },
        "103": {
            "start": 1575.82,
            "end": 1596.26,
            "transcript": "Una-llu west-aq wangkuta keggaknermek pituluku Nunivaarmiut-llu kass'atuklak uassiaramek, uassiaramek."
        },
        "104": {
            "start": 1596.26,
            "end": 1610.08,
            "transcript": "Tua-llu una cali west-ankuk north-aq-ll' akuliik keggaknerenkuk negeqvak-ll' akuliignek wangkuta aterpagtetuluku."
        },
        "105": {
            "start": 1610.08,
            "end": 1619.28,
            "transcript": "Tua-i-ll' nutaan ava-i au͡gna apyuten anuqetgun taikanirraarluku apertuqatarqa."
        },
        "106": {
            "start": 1619.28,
            "end": 1632.06,
            "transcript": "Taringumaciqerput nakek'nermek anuqliqan natquigucia, wall'u-q' nakek'nermek anuqliucia."
        },
        "107": {
            "start": 1632.06,
            "end": 1645.29,
            "transcript": "Alerquamatukuneng ayagyuaput tamakunek [?] nakek'nirniluku tegganrem qanrutkellrukakut wall' ciulirnerem,"
        },
        "108": {
            "start": 1645.29,
            "end": 1654.1,
            "transcript": "Ayagyuam taringumaciqai im'um-wa qanrutkellrukii akwaugaq ella ayallrani nakek'nirniluku."
        },
        "109": {
            "start": 1654.1,
            "end": 1671.06,
            "transcript": "Ayakuni nunanek tuaken ca umyuaqluku ayakuni nunat yaaqsigivailgata kingyarciquq, nunat yaa-i tua-i ciunerkaan-wa nalliini amna."
        },
        "110": {
            "start": 1671.06,
            "end": 1692.06,
            "transcript": "Tua-i-ll' piciquq imumi akwaugaq ella ayallermini can'get livtellinikai [?] taumi anuqmi can'get imkut qanikcamun tapqarulluki tua-i tuatmun pillinikaa."
        },
        "111": {
            "start": 1692.06,
            "end": 1707.4,
            "transcript": "Tua-i nunat tangerrluku amna-llu ciunerkani tangrraarluki can'get tangerquniki ayagciqliniunga makut can'get ukatmun makut iqalluguat apqulluku livterrlugngait."
        },
        "112": {
            "start": 1707.4,
            "end": 1713.14,
            "transcript": "Kiarniartengraan-llu kingunek qanelnguciinelngaitelliniluku."
        },
        "113": {
            "start": 1713.14,
            "end": 1734.79,
            "transcript": "Tua-i-ll' tamaani piinanrani pitsaqevkenani ella ayautengareskani kingutmun caukuni tamakut imkut can'get wall' iqalluguat ayallermini nunat tangerrluku ciunerkani ella imna tangerrluku cuqtellruamiki."
        },
        "114": {
            "start": 1734.79,
            "end": 1750.06,
            "transcript": "Iqalluguat can'get-llu tamakut cuqyutekluki ayagluni cimirngailata-ll' anuqni uivtengraaku taringumaluku anuqiim uivtellinia ayagluni."
        },
        "115": {
            "start": 1750.06,
            "end": 1770.06,
            "transcript": "Iliini pircissiyaakan uniurucalkang'e'rmi nunat ayaaqsunrilkiitni [?] cali taq'ekumniu nuna cauluki tua-i imna CBS Kass'at aptukiit number-at aperluki CBS-aakun ayatuut."
        },
        "116": {
            "start": 1770.06,
            "end": 1783.06,
            "transcript": "Tua-i-llu uniurtevkenak tuarpiaq taringumaluki tamakut cuqtapaallrit tuarpiaq CBS-aakun ayalriatun pellaavkenani tekilluku."
        },
        "117": {
            "start": 1783.06,
            "end": 1796.06,
            "transcript": "Tuaten tua-i pitullruunga agayunirtaltallmini ikamrayuirucan pellaacuilamni-llu. Aren agayulirtem tua-i."
        },
        "118": {
            "start": 1796.06,
            "end": 1812.06,
            "transcript": "Kamaknauraanga angalkuularyugnarqua tumet-gguq atumangraaki kiaranailengraan pellaayuitua tumtailengraan ayagnaurtua \"aa\" ciulisteka-gguq allerqua \"ci\"."
        },
        "119": {
            "start": 1812.06,
            "end": 1819.31,
            "transcript": "Ava-i-gguq tekitelartua nunat nall'aq [?] angalkularyugnarquanga."
        },
        "120": {
            "start": 1819.31,
            "end": 1831.14,
            "transcript": "Tua-i tang maa-i tuqullrunrilkan iliini cauluki qanaatelaryaaqeka [?]."
        },
        "121": {
            "start": 1831.14,
            "end": 1842.39,
            "transcript": "Tua-i tamakut ayuqucirtuutet nunam qaingani can'get makut alerquutmek qanruyutmeggni,"
        },
        "122": {
            "start": 1842.39,
            "end": 1856.53,
            "transcript": "Tua-i uksurpak caumacirkamegcetun ungalam cungullrugki [?] uksuarmi livtaqamiki cimirngairulluki uksurpak tauna tua-i caumallra tua-i taqluni."
        },
        "123": {
            "start": 1856.53,
            "end": 1870.06,
            "transcript": "Tua-i pellaalriim pellaakuni canengqetuli nallunrilkuniu elagaqerluku piciquq can'get makut maa-i uksuar imkut livtellri."
        },
        "124": {
            "start": 1870.61,
            "end": 1886.67,
            "transcript": "Tua-i tamaaggun cali nunami tungiinun ayuquciirucaaqerraarluni tamakutgun nunami tungiinun caukanillerkami taringaqluku can'get livingallrat."
        },
        "125": {
            "start": 1886.67,
            "end": 1902.59,
            "transcript": "Natquigtellrukan-llu unugpak nakeknillra-ll' nalluvkenaku cali tamakutgun iqalluguatgun kingunermi tungiin nallumaunaku natmun ayangermi."
        },
        "126": {
            "start": 1902.59,
            "end": 1913.66,
            "transcript": "Cuqtellruami-w' tua-i ak'a nakek'nermek iqalluguat tamakut taqumallrat."
        },
        "127": {
            "start": 1913.66,
            "end": 1923.94,
            "transcript": "Tuamta-ll' wangkuta unani mararmiuni ayuqucirturaqluta nuna qerkellikanillengqertuq."
        },
        "128": {
            "start": 1923.94,
            "end": 1940.66,
            "transcript": "Tua-i man'a nunapik apqiit ayagluni qerkellillran-llu melii tekiskuniu, wagg'uq ingigutngurrluni, ingigutngurrluni. Ingigutmek niitelallulriaten. Tua-i-ll' tamatum."
        }
    },
    "Vt_5bI5GmyU": {
        "1": {
            "start": 9.69,
            "end": 28.22,
            "transcript": "Yaa taq'uten? Tua-i-am makut tekiteqarraarqata-llu angutet ilait qassatukait qiluit-llu call' qamkut qassarluki tenguit-llu,"
        },
        "2": {
            "start": 28.22,
            "end": 39.5,
            "transcript": "Kenirarkaunrilkata qassarluki tenguit qiluit-llu call' kiingan tua-i imkut neqnialnguit cungait kiingan au͡g'aqerluki."
        },
        "3": {
            "start": 39.5,
            "end": 52.0,
            "transcript": "Tua-i pinrilqerrunaku nerluku. Qassarluku wall'u uuvelekarluku, wall'u tua-i uunqegssukuni uunqeggluku."
        },
        "4": {
            "start": 52.0,
            "end": 71.28,
            "transcript": "Tuaten ayuqluteng qassangermeng-llu makut miryalngunaitetuluteng tua-i-w' uuvelekaungameng qassangermeng-llu qassauluki amiirluki nerngermeng imkut-llu alkiarnek pitukait mikcuayagaat,"
        },
        "5": {
            "start": 71.28,
            "end": 90.84,
            "transcript": "Call' tuaten makucetun ayuqluteng. Uuvelekatuluki qassangermeng-llu miryalngunaunateng. Tamakut au͡gkut tua-i apeqtullrenka melqurrit ayuqevialriit qau͡gret, metraat-llu tamaa-i uuvelekatulit."
        },
        "6": {
            "start": 90.84,
            "end": 101.31,
            "transcript": "Makut tau͡gken uqsuqanek pitukait uuvelekarcelluki niicuunaki, tuutangayiit-llu neqleret-llu."
        },
        "7": {
            "start": 101.31,
            "end": 110.02,
            "transcript": "Tau͡gaam-am imkut [?] ukuit qatellriit nacaullegnek pitugngaput. Call' tua-i makut uuvelekatuluki."
        },
        "8": {
            "start": 112.4,
            "end": 122.63,
            "transcript": "Tekiteqarraarqata tamaa-i ataucirraungraan-llu kenirluku uuvelekarluku, wall' tua-i yuunqeggluku."
        },
        "9": {
            "start": 122.63,
            "end": 135.29,
            "transcript": "Tayarunek amlleq-wa-gguq-mi amllerucirluku mer'a tayarunek. Tuar piar rice-irluku tayarunek tamaa-i pingqer'"
        },
        "10": {
            "start": 135.29,
            "end": 143.79,
            "transcript": "Wall'u utngungssarnek wall' anllernek."
        },
        "11": {
            "start": 143.79,
            "end": 157.3,
            "transcript": "Kenerkarqan-am tamakutnek-llu wangkuta uugnaqata neqellritnek [?] qanikcam qainganun pissuraqluta."
        },
        "12": {
            "start": 157.3,
            "end": 163.07,
            "transcript": "Canek aturluteng pissurcuutnek pissutullruitki pissuraqluteng?"
        },
        "13": {
            "start": 163.07,
            "end": 182.68,
            "transcript": "Tua-i-ll' nutegnek nutget call' tamaa-i imameggnek anglaninrilnguut tangtullruunga wagg'uq camek ima tanem imaliluteng, nut'guqaarluki imalteng."
        },
        "14": {
            "start": 182.68,
            "end": 195.7,
            "transcript": "Cali tua-i ut'reskuneng tuaten pikiurluteng cingilegkiurluki-llu urutulimek au͡g'umek anumilutun ayuqsaaqelriim."
        },
        "15": {
            "start": 195.7,
            "end": 214.06,
            "transcript": "Tau͡gaam urugluku kuv'aqluku pilissuucirluteng-am tamaa-i kuvuurluku kenirraarluku qallarvakan, cingilegkiurluteng puyurkamnek-llu-gguq pilirluki."
        },
        "16": {
            "start": 214.06,
            "end": 229.03,
            "transcript": "Tamaa-i piluteng tuaten pitullruut anglanillrunritukut tau͡gani qanlartukut maa-i anglaningut nut'get-wa ayuqenrilnguut."
        },
        "17": {
            "start": 229.03,
            "end": 242.12,
            "transcript": "Yuum tua-i nut'gi ayuqevkenateng watua maa-i pilalriit yaqulegcuutait, canun nut'gassuutait, canun-wa nut'gassuutait."
        },
        "18": {
            "start": 242.12,
            "end": 252.74,
            "transcript": "Ataucirrarnek avani pingqengnatuguq, tua-i-w' cam ilii piitaqluni, ilii pingqerraqluni."
        },
        "19": {
            "start": 252.74,
            "end": 269.09,
            "transcript": "Au͡gna piuten nut'gitellrat neq'ak-llu piyugnarquten, nuinek apeqmeggnek, nuinek, tua-i nagiiquyatun ayuqsaaqluteng, tau͡gaam ellenruluteng nuqirluteng egtaqluki."
        },
        "20": {
            "start": 269.09,
            "end": 280.23,
            "transcript": "Mikurluteng makut elpengqerraallemni angyayuitellratni, nut'gaurrlainayuitellratni, nut'galaange'rmeng yaaqsingraata nut'gayuitellratni."
        },
        "21": {
            "start": 280.23,
            "end": 298.26,
            "transcript": "Mikurluteng tengautullruut quigpek'nateng-llu, quyurmek, ii-i quyurmek, tamaa-i tua-i makussuutengqetullrulliniut elleggiurluki ipuit nernek equamalkucirluki [?] nuugit."
        },
        "22": {
            "start": 298.26,
            "end": 316.34,
            "transcript": "Tua-i-gguq tau͡gken tekiskaceteng tua-i akuliitnun nuiteng narupauskatki, nuirem tuaten tamakut puukaqustayiskata, aqvaqualuteng tau͡ga-i nalavsialaagluki avulaagluki [?]."
        },
        "23": {
            "start": 316.34,
            "end": 335.35,
            "transcript": "Tamaa-i tuaten pitaqluteng caskutgun watua pitegcautetgun nuusaarpagteggun tua-i-llu apqiitnek ingeskata aipaagneng pitegcautetgun nuusaarpagteggun-llu nauskaqu'urluki [?]."
        },
        "24": {
            "start": 335.35,
            "end": 354.7,
            "transcript": "Wall'u ungularqekata unguluki kuvyamek. Apeqmeggnek qasgingualiqerluteng wall' kangiqiqerluteng alarqelluki atkuk, atkugkanglaqluteng."
        },
        "25": {
            "start": 357.41,
            "end": 369.65,
            "transcript": "Tua-i-am makut kenirluki tua-i-llu angutet ilait tau͡gnariqerrniluki uuvallagniluki qanernaurtua,"
        },
        "26": {
            "start": 369.65,
            "end": 383.97,
            "transcript": "Ilait tuar tang tua-i puqlamun akurqaarluki tuaten nertulriit, tuaten-am wii tangsuugaqama elisngallritnek, umyuarteqlua tangssuitullruanka."
        },
        "27": {
            "start": 383.97,
            "end": 401.35,
            "transcript": "Makut maa-i qassarluki au͡g'utun ava-i qanllemtun, piyussiyagaqameng tua-i arnat waten aulukluku, yaqurit-llu ciumek au͡g'arluki pikatki."
        },
        "28": {
            "start": 401.53,
            "end": 409.07,
            "transcript": "Piussiyaalriim tua-i teguluku pukugluku qassaangraan nerluku."
        },
        "29": {
            "start": 409.07,
            "end": 415.86,
            "transcript": "Amiiraqamegteki apertuuteqerkut qaillun natait au͡g'arluteng?"
        },
        "30": {
            "start": 415.86,
            "end": 426.36,
            "transcript": "Ukut wani qamiqurrit waniw' uum qengartuullra, maa-i man'a qengaan tayima uqum ilii."
        },
        "31": {
            "start": 426.36,
            "end": 437.98,
            "transcript": "Una waniwa qengangqellruuq waten uqumek, ing'utun-wa ciugugalaunatek [?]."
        },
        "32": {
            "start": 437.98,
            "end": 456.1,
            "transcript": "Amiirraarluku tua-i-llu yaquk, call' tua-llu yaaqevkenaki piluki tua-i-llu yaqurra neng'arrluku, una uum nalliikun aaryugenraakun [?] kegqerluku ayagnirluku."
        },
        "33": {
            "start": 456.1,
            "end": 467.18,
            "transcript": "Tua-i-llu ayaggluku uum nallii, qam una ayagniqluku, uivneq allgumaangaunani."
        },
        "34": {
            "start": 467.46,
            "end": 478.23,
            "transcript": "Uum waniw' unangllekluku, kumlum, kumlumteńek piurluku tua-i man'a tekilluku."
        },
        "35": {
            "start": 478.23,
            "end": 490.61,
            "transcript": "Tua-i-llu anteqataaqan call' wani pilakarluku anlluku, assirluku tua-llu yaaqevkenaku anqurluku."
        },
        "36": {
            "start": 490.61,
            "end": 502.49,
            "transcript": "Tua-ll' keliliku-gguq [?] una tapqernarmek yualulirluta keligluku uum yaqurra aipaakun una iterrluku."
        },
        "37": {
            "start": 502.49,
            "end": 514.86,
            "transcript": "Tua-i uum yaqurra aipaakun iterteng'ermi pugyugngaluni tamarmeng."
        },
        "38": {
            "start": 514.86,
            "end": 529.4,
            "transcript": "Qaillun-mi qemagtelallrucecitki iciw' ikgetaqata atkugkanrurpailgata, qaillun qemangqalartatki natmun elliluku?"
        },
        "39": {
            "start": 529.4,
            "end": 542.23,
            "transcript": "Canek ilaqcarluku ayuqenrilengraata amiilegnek tauna tua-i atauciq ilaluku atkulituut, kelerrlainarnek pivkenaku."
        },
        "40": {
            "start": 542.23,
            "end": 560.06,
            "transcript": "Tau͡gaam nataicukan cali kiimelengraan natkeqerluku, wall'u-q' akulperaqluku, wall'u-q' aliknun nuggluku [?] tuaten ayuqluni. Ayuqenrilengraata atkugkan atkulingnaqtullruut."
        },
        "41": {
            "start": 560.06,
            "end": 571.35,
            "transcript": "Qaillun camun ekluki wall'u-q' nemgulluki-qaa mecungevkarpek'naki-llu qemangqatullruit?"
        },
        "42": {
            "start": 571.35,
            "end": 580.54,
            "transcript": "Tuaten tua-i alerquutnun [?] carugaitetullruameng-wa tua-i agakata tamaa-i angularluki piyunarcarluki."
        },
        "43": {
            "start": 580.54,
            "end": 586.24,
            "transcript": "Aptelaraaten kinqaki natmun qemaggluki tupigat kiimeng issrat..."
        },
        "44": {
            "start": 586.24,
            "end": 604.62,
            "transcript": "Tua-i-llu, tua-i-llu (qemaggviullruut) kinqata iciw' agavallagcetevkenaki tua-i assirluku pikata imkarluki issraatmun wall' uqlarvimeggnun ek'arrluki tua-llu-qaa?"
        },
        "45": {
            "start": 604.62,
            "end": 617.27,
            "transcript": "Au͡g'umek-am kinercirpek'naki pilaryukluki pilliniamken amiiltengqata una kinerciqarraarluku nutaan qemaggluku?"
        },
        "46": {
            "start": 617.27,
            "end": 634.41,
            "transcript": "Tua-i ava-i qanrutamken kinqaki uquivlaallrukan taiciiqait angulaasqelluku. Tua-i maligulluta angularluku keggaqluku."
        },
        "47": {
            "start": 634.41,
            "end": 654.34,
            "transcript": "Tua-i pii au͡g'anqellria ulugluku pivkaraqluku. Tau͡gaam uquivlaagumalria atauciunrilengraan canek ayuqainek ilaluku amingqellrianek qerrulliluteng teq'umun tamaa-i."
        },
        "48": {
            "start": 654.34,
            "end": 666.1,
            "transcript": "Uquit puyalerteng'e'rmeng ululriani au͡g'araqluteng, iliini-ll' tua-i kilikaaraqerluki natait imkut piqerluki."
        },
        "49": {
            "start": 666.1,
            "end": 685.2,
            "transcript": "Mermun-llu erurturluki teq'urpagninaqngacuunateng tamaa-i teq'umun-am pirraarluki mermun wagg'uq erurturluki. Teq'urrniirulluteng-llu."
        },
        "50": {
            "start": 685.2,
            "end": 698.29,
            "transcript": "Imumek iciw' rinse-arnilialriit qulit'ani rinse-araqameng-llu pairtellriatnun ayuqaqluteng."
        },
        "51": {
            "start": 698.29,
            "end": 714.6,
            "transcript": "Tuaten tua-i miilamek nalluluteng pitullruut, teq'uq tukniani enruuluni tuaten piciatun capruunani teq'uq elluatuuluni pirpakluku wangkuta."
        },
        "52": {
            "start": 714.6,
            "end": 725.4,
            "transcript": "Ca tua-i au͡g'asciigalkan teq'umun akureskuni caperqevkenaku tua-i tamalkuan au͡g'arluku."
        },
        "53": {
            "start": 725.4,
            "end": 735.24,
            "transcript": "Erurturluku-llu mermun tuaten kinengraani teq'urpagninarqevkenaki."
        },
        "54": {
            "start": 735.24,
            "end": 739.56,
            "transcript": "Qugyuut-llu-qaa atkulitullruit?"
        },
        "55": {
            "start": 739.56,
            "end": 762.07,
            "transcript": "Qugyuut tua-i tamaa-i amiitulit makut-llu aipait qucilgaarmek pitukait nacauyunqeggluteng cali megcuunaki melqurrit ikgelengraata nacauyunqeggluteng tamaa-i qucilgaat wall'u curmauluteng cuyanek imirluki."
        },
        "56": {
            "start": 762.07,
            "end": 770.37,
            "transcript": "Melqurrit ikgellruata wiinga nacangqelgullruunga tamaa-i qucilgarnek-gguq tamakunek."
        },
        "57": {
            "start": 770.54,
            "end": 780.88,
            "transcript": "Qugyuut nutaan quyatekluki angengaat allegngiagata-llu atkuksugngitullruit."
        },
        "58": {
            "start": 780.88,
            "end": 793.09,
            "transcript": "Tan'gurraat-llu cali tunutellegnek wall'u-qaa qaqanek [?] tamaa-i melqurrit cali tamakut elngurluteng."
        },
        "59": {
            "start": 793.09,
            "end": 805.84,
            "transcript": "Tunutellget qaqat-wa mikellruluteng tamakut tunutellget angenruluteng ayuqait-wa call' makut tuullget-gguq makut angkayagluteng yaqulget."
        },
        "60": {
            "start": 805.84,
            "end": 813.6,
            "transcript": "Tamakunek tau͡gaam pitulinegni [?] niiteqayuitellruunga tuulleggnek."
        },
        "61": {
            "start": 813.6,
            "end": 830.49,
            "transcript": "Tamakucimek [?] maurluma maqiyaurtellemni maqissuucillrui assiqapiarluni kacak pikumallrua akaurtuq [?]."
        },
        "62": {
            "start": 830.56,
            "end": 840.9,
            "transcript": "Maurluma pilia maqissuu' maqituviama [?]"
        },
        "63": {
            "start": 840.9,
            "end": 848.16,
            "transcript": "Tekitaqameng cakneq tua-i irniyarturluteng maani pitulriit."
        },
        "64": {
            "start": 848.16,
            "end": 859.68,
            "transcript": "Tua-i wangkuta nut'gasciigalngurni qaill' tua-i nanilengraan-llu nanvam waten piqall' akulnguyaanek acirluku."
        },
        "65": {
            "start": 859.68,
            "end": 879.8,
            "transcript": "Tuavet tua-i kuvyaq civeskuni picimitun pilluni, wagg'uq nulirtaqameng tamaa-i picimegcetun pituata piliqerraqluni kuvyaq tuaten tua-i nanvam waten ayuqellranun akulnguyaanun civvluku."
        },
        "66": {
            "start": 879.8,
            "end": 895.08,
            "transcript": "Makut ellamiilget [?] cali kayanguiteguvkenaki tamalkuitaan atuumaita pitaqsukuniki call' tauna kuvyamek elliqervikluku wall'u negamek pilirluku."
        },
        "67": {
            "start": 896.92,
            "end": 912.74,
            "transcript": "Tua-i umyugata aturluku tamaa-i pitaqluteng tua-i, cat tamalkuan arnaunge'rmeng pissuqcaarturatullruamegteggu kiagmi arulainqavkenateng."
        },
        "68": {
            "start": 912.74,
            "end": 938.82,
            "transcript": "Makut maa-i tengviitnun taq'aqluki kayangut mikcuayagaungraata ut'rulluku piyuna' inerqutuakut tau͡gaam imkut caunrilnge'rmeng, Kassaunrilnge'rmeng, piksunailnguq tua-i pissunrilengraan ilangcivkenaku uitatesqelluku."
        },
        "69": {
            "start": 941.36,
            "end": 951.77,
            "transcript": "Niilluki tua-i tau͡gaam piksunarqelriit qelekluki tuqulluki."
        },
        "70": {
            "start": 951.77,
            "end": 966.75,
            "transcript": "Tengvailegmeng qaillun tua-i pisciigat'lartut qimange'rmeng wangkuta malirqerluki piksunarqelriit tamakut tuqutaqluki."
        },
        "71": {
            "start": 968.04,
            "end": 988.04,
            "transcript": "Wagg'uq ingtaqata tamaa-i-llu tuaten aanait piyagateng angliriluteng-llu piyagait tau͡gaam tengeksaunateng tengvailgata maligqerluki pitaqaqluki."
        },
        "72": {
            "start": 988.04,
            "end": 999.82,
            "transcript": "Tuaten-llu call' tua-i tekiskaata nanvam-gguq uuma akulnguyaanun, akulnguyaitnek-am tamakut nanvaq tua-i waten ayagluni una-ll' tuaten piqerluni."
        },
        "73": {
            "start": 999.82,
            "end": 1009.76,
            "transcript": "Tuavet tua-i kuvyaq civvluku yaqulek. Piliqaqluni qavciluni tallimalluni pingayulluni."
        },
        "74": {
            "start": 1009.76,
            "end": 1018.04,
            "transcript": "Tamaa-i amilegnek tamaa-i atkugkanek pissutuluta-llu tuaten kuvyirluki."
        },
        "75": {
            "start": 1018.04,
            "end": 1039.04,
            "transcript": "Ayuqenrilngurnek navtaqluteng tamaa-i-ll' ellakevkenateng nulirrluteng piaqameng tua-i cat tamarmi angutengqerrami ciknaluteng-llu tamaa-i tauna nuliateng tamaa-i calluutekaqluku."
        },
        "76": {
            "start": 1039.04,
            "end": 1056.55,
            "transcript": "Tuaten tua-i kuvyaq civeskuni ayuqenrilngurnek pitarkauluni tua-i-am ilait qanlartut kepaalget-gguq napngiatut kuvyanun tamatumun."
        },
        "77": {
            "start": 1056.55,
            "end": 1068.04,
            "transcript": "Ilumun piqurayuunateng tamakut kepaalget cat atrit-llu arivkurluki cauciitevkenaki pitullriit."
        },
        "78": {
            "start": 1070.04,
            "end": 1078.04,
            "transcript": "Pingcimalriit-qaa yaqulget assinruut atkuuluteng?"
        },
        "79": {
            "start": 1078.04,
            "end": 1085.04,
            "transcript": "Angutait arnaita aqsaitukut."
        },
        "80": {
            "start": 1085.04,
            "end": 1097.74,
            "transcript": "Evaacillengqerrluteng melqerrunateng tamakut pituut tuaten ayuqetuut angutait tau͡gken tua-i callugnerunateng tekuyugngaluteng tau͡gaam."
        },
        "81": {
            "start": 1097.74,
            "end": 1118.04,
            "transcript": "Tuaten ayuqengraata aqsait melqurrilengraata tua-i-w' piluki makut keggatait mingqelriani camun keviqautekaqluki tuaten pitullruut. Una tua-i camun keviqautaqluku."
        },
        "82": {
            "start": 1119.04,
            "end": 1130.04,
            "transcript": "Yaqulget-mi enrit caktullruitki, like mingqut'litullrukait wall'u-q' meluskarcuutekluki?"
        },
        "83": {
            "start": 1130.04,
            "end": 1138.57,
            "transcript": "Tamakunek-wa wii mingqutngutulinek nallullrulrianga mingqutnek aturluteng mingqetullruut."
        },
        "84": {
            "start": 1138.57,
            "end": 1160.04,
            "transcript": "Tau͡gaam yaqurra maaten nallenra [?] qullia tangtullruunga iliini meluskautaqluku, iciw' tuaten tamakussutekluku, meluskautaqluku, meluskassuutekluku."
        },
        "85": {
            "start": 1162.04,
            "end": 1168.04,
            "transcript": "Piciatun-qaa yaqulgem yaqurran enranek wall'u-q'?"
        },
        "86": {
            "start": 1168.04,
            "end": 1176.84,
            "transcript": "Ellenranek qullianek pag'umek, wall'u uum kangianek kangilquranek taum uum."
        },
        "87": {
            "start": 1176.84,
            "end": 1190.04,
            "transcript": "Ilii-llu tua-i mat'umek qullianek, tua-i-llu call' kangianek ukut ellenrutuata, iquk tua-i kep'arrluku meluskassuutengqerraqluku."
        },
        "88": {
            "start": 1190.04,
            "end": 1200.04,
            "transcript": "Qanraaqama tua-i-am qanqapak makinkacagaanga, pikna cikum pingangqellruyaaquq [?]"
        },
        "89": {
            "start": 1214.04,
            "end": 1220.04,
            "transcript": "Cali qaneryukuvci yaqulget tungiitnun ayuqenrilnguut?"
        },
        "90": {
            "start": 1220.04,
            "end": 1222.91,
            "transcript": "Qanerluci."
        },
        "91": {
            "start": 1222.91,
            "end": 1235.39,
            "transcript": "Maani-wa akulmi-llu tamaa-i nut'gitlermeggni negarirluteng-gguq."
        },
        "92": {
            "start": 1235.39,
            "end": 1245.04,
            "transcript": "Nauw' maa-i maqaruat-llu tumyarait negirqameng maqaruartelalriit tuaten."
        },
        "93": {
            "start": 1245.04,
            "end": 1254.09,
            "transcript": "Maqaruarcuutetun makut piciatun uqiaraat-ll' aciit."
        },
        "94": {
            "start": 1254.09,
            "end": 1262.99,
            "transcript": "Tau͡gaam agartessuutekait waten muriik kapullukek."
        },
        "95": {
            "start": 1262.99,
            "end": 1278.81,
            "transcript": "Yaavet-llu calinglua tua-i-llu tamana imna imkut napat aciit kevraarcinrait camkut qillruku'urluki."
        },
        "96": {
            "start": 1278.81,
            "end": 1294.25,
            "transcript": "Nanvani-llu tua-i iliini-llu uum qanellratun tua-i waten nanvaq ayuqelalriit ilii [?] tuavet-llu qukaanun tua-i nenglluku ilallrullinilriit."
        },
        "97": {
            "start": 1294.25,
            "end": 1315.04,
            "transcript": "Nega'arturluteng-gguq au͡gna ca nengqarluku wall'u nengpailegmiu, nenglluku tua-i aturpailegmiu tamakut-llu tua-i kevraarcinraat qamyarirluki tau͡gaam."
        },
        "98": {
            "start": 1315.04,
            "end": 1336.04,
            "transcript": "Negaraq [?] tamakut tua-i yaqulget tamakut mer'em taum quliinun qaillun tayim' pitaluki tamakut tua-i wall'u imkuni nauw' nanvat ilait maa-i carangllulililriit tamakut nuniit."
        },
        "99": {
            "start": 1339.45,
            "end": 1357.04,
            "transcript": "Tamakut tua-i napat aciit uqviaraat camkut naulluutait qeltairluki tau͡gaam wall'u tuaten piyukuni kevraarcinraat cali piyugngaluteng akagenqellriit tau͡gaam."
        },
        "100": {
            "start": 1359.99,
            "end": 1366.42,
            "transcript": "Imkut tua-i igartuarluteng [?] pilallrullinilriit."
        },
        "101": {
            "start": 1376.04,
            "end": 1391.43,
            "transcript": "Ing'um-am imarni pulengtaq apertutuyaaqaqa ukunun cali eliteksailamiu-am cupumangami cali qanrutkesqa."
        },
        "102": {
            "start": 1391.43,
            "end": 1405.04,
            "transcript": "Tua-i tau͡g' perturturatuyaaqluki waten pituniluki imarniit ataucirquunrilngurmek, uumun-llu waniw' apertutuyaaqluki amllerqunek."
        },
        "103": {
            "start": 1405.04,
            "end": 1416.89,
            "transcript": "Tua-i pituyaaqluku waten imarniciqata'arqameng tang ciumek tunuit nacaitnek ayagnitulriit."
        },
        "104": {
            "start": 1416.89,
            "end": 1434.04,
            "transcript": "Nalqigutetuyaaqluku amllerqunek. Tua-i ciumek pamkut tunuaritnek acirluki, nacait ciumek tua-i wavet cuqluku."
        },
        "105": {
            "start": 1434.04,
            "end": 1450.04,
            "transcript": "Tua-i cuqluku mingqerraarluku tuamtellu-gguq yagutnguirluku taukuk au͡gkuk qiluk wantarkaulutek yagutnguamek pilukek cilignek maanlluteng."
        },
        "106": {
            "start": 1450.04,
            "end": 1462.49,
            "transcript": "Wavet-am tua-i kituqangraan cuqluku pisqetukait. Tua-i tuaken ayagluku pituut."
        },
        "107": {
            "start": 1462.49,
            "end": 1475.04,
            "transcript": "Tua-i-llu qayatullratni tamaa-i qaill' pitarikan cillatmun tua-i ayagcelluku qayam painga tangrruarluku."
        },
        "108": {
            "start": 1475.04,
            "end": 1485.04,
            "transcript": "Yaglluku tua-i iliini yaglluku cip'areskuni tua-i qayam painga at'arkauluni."
        },
        "109": {
            "start": 1488.04,
            "end": 1506.69,
            "transcript": "Nauwa call' tua-i akwaugaq qanellrulrianga angutet angengnaq' angkayangnaqluki pilivkatullruniluki patagturturluki calaallerkait, murullerkait mermun."
        },
        "110": {
            "start": 1506.69,
            "end": 1515.04,
            "transcript": "Tuaten tua-i aliilaagluteng calaallerkaat, alilaagluteng qaill' pilaallerkait."
        },
        "111": {
            "start": 1515.04,
            "end": 1529.52,
            "transcript": "Angengnaqu'urluki piuratullruit tua-i tamaa-i alerquutekluku mikcuayaarmek pilisqumanritniluku ukunek waniwa cuqluku."
        },
        "112": {
            "start": 1529.52,
            "end": 1546.67,
            "transcript": "Unat qaill' pitalrianek-llu piluguan kangraa cipluku, kan'a cali qaill' call' pitalrianek at'elaagluku kamilartelaallerkaa tauna."
        },
        "113": {
            "start": 1546.67,
            "end": 1556.77,
            "transcript": "Maa-i-am tuaten pinanriata piluguut wii kangrit waten cuq'errluki pilituunga angutet nequtunruurluki."
        },
        "114": {
            "start": 1558.04,
            "end": 1568.8,
            "transcript": "Tuaten ayuqluni, nat'rait-llu tua-i call' angutet, angengnaqluki wiinga yuaranka mik'lata waten angutet naterkiitullruat."
        },
        "115": {
            "start": 1568.8,
            "end": 1586.47,
            "transcript": "Angengnaqu'urluki angutet aklulitullruut, arnat-llu mik'ellruataan ayayuilata natmun caltunritlerkaitgun tau͡gaam pilituluki."
        },
        "116": {
            "start": 1586.47,
            "end": 1601.43,
            "transcript": "Tau͡gaam atkuliaqameng angliyugngalriit angengnaqu'urluki cali tua-i tau͡gken calitungramta iliini tuaten angengnaqengramteki mikliqercugpagluki iliini."
        },
        "117": {
            "start": 1601.43,
            "end": 1615.37,
            "transcript": "Ayuqerrlainarluki piyuitetuamta iliini tua-i mikteqariluta, iliini tua-i angliriqerrluki, tuamtell' cavkenateng angliriqerringalriit."
        },
        "118": {
            "start": 1615.37,
            "end": 1625.32,
            "transcript": "Mikliyuilnguut tau͡gaam kituggluki miklicarluki wall'u angtucaqerluki tuaten piyarauluni."
        },
        "119": {
            "start": 1625.32,
            "end": 1639.04,
            "transcript": "Ilanka call' ukut camek cuqcetullermeggnek qanerciqut angutet ellaita pivimeggnek qayam natainek painganek."
        },
        "120": {
            "start": 1653.05,
            "end": 1664.23,
            "transcript": "Wiinga-wa kuvyat tau͡gaam negaqerutaitnek qanqaquma cangail' neqet angtatkenrilata."
        },
        "121": {
            "start": 1664.23,
            "end": 1684.36,
            "transcript": "Tua-i au͡gku'urluut cat cuqtaarturallermegteggun pitulliniameng cat qilagturluki tau͡gaam kiagmi caskukarateng pitullruameng neqet angtatkenrilata."
        },
        "122": {
            "start": 1684.36,
            "end": 1699.94,
            "transcript": "Quarruugcuutet tua-i arnat tangerrnilarluki tau͡gaam negitullruut quarruugcuuciaqameng qalunek."
        },
        "123": {
            "start": 1699.94,
            "end": 1715.98,
            "transcript": "Nuna man'a ayuqenrilngurteggun neqetgun nunautengqetulliniami unaunai wii anglivilqa uksumi quarruuget arcaqerluki."
        },
        "124": {
            "start": 1715.98,
            "end": 1734.04,
            "transcript": "Tua-i caskuitenritengnaqtullruut imkut pingnaqsuuteteng qimugtet kiingita pingnaqsuutektullruamegteki qimugcitekluki kiingita uksurpak quarruuget pitullruameng."
        },
        "125": {
            "start": 1734.04,
            "end": 1755.48,
            "transcript": "Tangvakanka tua-i au͡gkut cuqaunateng pupeskumciarrlainarluku tua-i quarruugcuun im' qilalaraat negaayukut [?] quarruuk tua-i ermirngairulluku wavet apqiinun quunguallranun, quunguamum engeliinun."
        },
        "126": {
            "start": 1755.48,
            "end": 1761.36,
            "transcript": "Tua-i-ll' qalut imkut quarruugcuutet waten ayuqluki qilatullruamegteki."
        },
        "127": {
            "start": 1761.36,
            "end": 1782.04,
            "transcript": "Tauna tua-i nutaan quunguaraq pellukan nutaan tua-i piyullermitun cali negartutaluki quarruganiungangraan man'a qilagcuutekani yaareskaninrem umyaaqluku negartucarluku tua-i uii [?] man'a."
        },
        "128": {
            "start": 1782.04,
            "end": 1793.8,
            "transcript": "Tua-i tau͡gken tauna qalu atuqatalriani pailirluk waten agtaarucirluki-ll' muragmek apeqmeggnek pitullruamegteki."
        },
        "129": {
            "start": 1793.8,
            "end": 1801.53,
            "transcript": "Kevelriani qalu imna waten quarruugcuun ayuqaqluni."
        },
        "130": {
            "start": 1801.53,
            "end": 1817.79,
            "transcript": "Tua-i carvanrem neqet quarruuget atertelaaki itquneng tua-i taum negarkitellrani iluanelkuneng anngaunateng carvanrem-wa tua-i piateng."
        },
        "131": {
            "start": 1817.79,
            "end": 1826.28,
            "transcript": "Tua-i wangkuuramta-llu neryutuamteki nertuluki."
        },
        "132": {
            "start": 1826.28,
            "end": 1840.69,
            "transcript": "Wii waniwa kasngukevkenaki quarruuget avani ciuqvani neqa nurnangraan man'a kuigmiutaq."
        },
        "133": {
            "start": 1840.69,
            "end": 1853.36,
            "transcript": "Quarruuget tau͡gaam kiimeng alaitetullrulliniameng yuk amlleq tamaani apqiitnek anagcetetullruat quarruuget."
        },
        "134": {
            "start": 1853.36,
            "end": 1867.1,
            "transcript": "Taumek-llu tamaa-i kinertayagauluki miklengraata iqukvangaqan neqkiutullrukait nertustaita."
        },
        "135": {
            "start": 1867.1,
            "end": 1873.9,
            "transcript": "Ilaita enrussiyaagpagtat makut pituyaaqait."
        },
        "136": {
            "start": 1873.9,
            "end": 1886.94,
            "transcript": "Tau͡gaam wangkutni angtuaruut tamakut quarruuget neqet elluatuuluteng neryutuluku-ll' wii caknerpak."
        },
        "137": {
            "start": 1886.94,
            "end": 1902.12,
            "transcript": "Tua-i tamakut pivakarluteng-am quarruuk aterpagceciullrulliniuq ak'apiaq neqa nurnatullrani quarruuk quarruugara'urluuq usuuq nukalpiigaqegglii."
        },
        "138": {
            "start": 1902.12,
            "end": 1913.23,
            "transcript": "Tua-i tamaa-i palutekevkenaki kanautektuamegteki kiagmi neq'ngellranun."
        },
        "139": {
            "start": 1913.23,
            "end": 1929.5,
            "transcript": "Taumek-am tua-i palutekevkenaki kanautektulteng pitekluki iliit-am aterpagtellrullinikai au͡g'utun quarruuk quarruugara'urluq usuuq nukalpiigaqegglii."
        },
        "140": {
            "start": 1929.5,
            "end": 1940.76,
            "transcript": "Tua-i quarruuget makut enlirngalngermeng enrit navguutngunritut yuum temiinun."
        },
        "141": {
            "start": 1940.76,
            "end": 1949.63,
            "transcript": "Imkuugut tau͡gaam tamakut enrit qam'um aqsaqum wall' anrutam caarrluan ancestai."
        },
        "142": {
            "start": 1949.63,
            "end": 1961.14,
            "transcript": "Enyagait imkut anrutam caarrluanek carririluteng anaurtaqameng pilriaruluteng."
        },
        "143": {
            "start": 1961.14,
            "end": 1972.1,
            "transcript": "Cali tamakut quarruuget vitamin-aarpauluteng neqngullrutmeggni vitamin-aangqenruluteng amlleq."
        },
        "144": {
            "start": 1972.1,
            "end": 1982.43,
            "transcript": "Taumek-llu alungililriani qimugtet uqumek pugtaqangetulria mer'at tua-i tamakut-llu cali..."
        }
    },
    "LRiZgAzKLbI": {
        "1": {
            "start": 7.72,
            "end": 10.67,
            "transcript": "Canek-im' aptellriaten? Qayat amiit'"
        },
        "2": {
            "start": 10.67,
            "end": 16.4,
            "transcript": "Naliit taqukat [?] qayat amiiqellriit assinruat?"
        },
        "3": {
            "start": 16.4,
            "end": 24.64,
            "transcript": "Amirkat. Uum amirkanek pilallikait."
        },
        "4": {
            "start": 25.48,
            "end": 29.6,
            "transcript": "Ava-i iciw' kiuyugluku taman' wii piqallrukek'a."
        },
        "5": {
            "start": 29.6,
            "end": 40.24,
            "transcript": "Kingunerpeni tamakut qayanun amiqsunarqelriit maklaarnek pituit. Piagaat."
        },
        "6": {
            "start": 40.24,
            "end": 48.8,
            "transcript": "Maklaarnek tua-i piaqluku aanait atait-llu maklagnek pituamegteki kingunerpeni."
        },
        "7": {
            "start": 48.8,
            "end": 54.2,
            "transcript": "Wii wangkuta tau͡gken nunani Qaluyaanek kingunelegni."
        },
        "8": {
            "start": 54.2,
            "end": 58.72,
            "transcript": "Tungunqunek pituamteki angayuqrit."
        },
        "9": {
            "start": 58.72,
            "end": 66.44,
            "transcript": "Irniari tamakut amirkanek pituluki qayanun amiqsunarqelriit."
        },
        "10": {
            "start": 66.44,
            "end": 81.84,
            "transcript": "Tua-i-llu tamakut-am paivngarrlainayuilameng maklaaraat amirkat makucinek maa-i paqnernek issurinek pikangqellriit qayiaqluki."
        },
        "11": {
            "start": 81.84,
            "end": 100.82,
            "transcript": "Tua-i cavkenateng cali piunerkillrung'e'rmeng tamakuni maklaaraat maklaarnek aptukaitnek kingunerpeni issurirrlainarnek amingqeng'e'rmi qayaq pikalek [?] tua-i qayaungaqluteng."
        },
        "12": {
            "start": 100.82,
            "end": 111.76,
            "transcript": "Tau͡gaam piunerkillruluteng tamakuni maklaarnek aptukaitnek kingunerpeni qecigkillruameng."
        },
        "13": {
            "start": 114.74,
            "end": 118.99,
            "transcript": "Tua-i-qaa ava-i taringaci?"
        },
        "14": {
            "start": 119.77,
            "end": 140.76,
            "transcript": "Cat-wa tamarmeng makut taqneret makut-llu cali maa-i paluqtaat au͡gkut uum anellrii paluqtaat maani-llu cali tamakut nurnaqata paluqtaat amiitnek, ucinglluut angtuat."
        },
        "15": {
            "start": 140.76,
            "end": 153.44,
            "transcript": "Cali-am makut unani natra'arqaqamegteki imkut angtuat makliit taqneret,"
        },
        "16": {
            "start": 153.44,
            "end": 172.69,
            "transcript": "Cali-am una wani mingqutem pillerkaa elirqerraarluku qaingam man'a ilulirnera, kemgan tunglirnera mamkellicarturluku uluamek naterkiulallruut."
        },
        "17": {
            "start": 172.69,
            "end": 187.76,
            "transcript": "Ukingiallruata-llu tamakunek ernerpak piyuagura'ange'rmi ukingaunani, up'nerkami-llu cali imna cikum,"
        },
        "18": {
            "start": 187.76,
            "end": 199.34,
            "transcript": "Keggaliqertaqami tua-i tamaani-llu nataarrlugnarqut [?]. Tuamta-llu cali pagaani ingrini teggalqut cali nat'rait nat'rat nertuit,"
        },
        "19": {
            "start": 199.34,
            "end": 209.75,
            "transcript": "Muriit-llu nauw' maani tutmarturalriani, muraunge'rmeng plywood-aat-llu camek qalliitaqameng [?] piyuangurallrata nanglaqait tua-i,"
        },
        "20": {
            "start": 209.75,
            "end": 226.3,
            "transcript": "Tuaten-llu nat'rat avani kameksalilallermeggni pilallruit pinraaraitnek piyunarqelrianek ak'anun piyuraarkanek nangyallitni [?] pilartut"
        },
        "21": {
            "start": 226.3,
            "end": 246.56,
            "transcript": "Cali makut maani Kusquqvagmi wall'u Akulmiut pavani ava-i malagg'aayaalartut-llu paluqtaat, tuamta-llu cali imarmiutaat mink cuignilnguq otter cali tungunquciungaqluteng [?] tamakut, kameksagnek,"
        },
        "22": {
            "start": 246.56,
            "end": 257.58,
            "transcript": "Atkuuyugngaat uliaqluki tuaten im' makut cuignilnguut maa-i imarmiutaat-llu kanaqlayagaat-llu muskrat-at,"
        },
        "23": {
            "start": 257.58,
            "end": 274.62,
            "transcript": "Tuamta-llu cali pikarturaqluteng ava-i akwaugaq-im qalamcilrianga elpet-ll' aptaqluten canek uterteqatarqata piliat angyiluteng tuaten [?] utertelartut tamakut elluurraarluteng [?]"
        },
        "24": {
            "start": 274.62,
            "end": 283.64,
            "transcript": "Yuilqumek kiingan, yuilqumek kiingan aklukaangnaq'lallrulliniut au͡gkut ciuliat,"
        },
        "25": {
            "start": 283.64,
            "end": 298.72,
            "transcript": "Umyugiurluteng tau͡gaam makut-am cat qinganartaqata taqtuluki tua-i pissunrirluki,"
        },
        "26": {
            "start": 298.72,
            "end": 312.83,
            "transcript": "Tuamta-llu cali makut cali kayangut, yaqulget kayanguit yung'artaqata taq'aqluki,"
        },
        "27": {
            "start": 313.94,
            "end": 332.06,
            "transcript": "Makut yuilquq kiimenguatenaaleng'e'rmeng [?] ellmeggnek makut ungungssiaraat nunam qaingani fish-anek kiimaileng'ermeng ellmeggnek tamana assillrakun piingnaqu'urluku,"
        },
        "28": {
            "start": 334.51,
            "end": 355.18,
            "transcript": "Iqlunritua-qaa? Tua-i tuaten ayuqut, tuamta-llu cali kanaqlayagaat makut qinganartaqata next year-aq up'nerkanek tekiskan cali tamakut kiingan-wa akingnaq'lallruamegteki,"
        },
        "29": {
            "start": 355.18,
            "end": 367.64,
            "transcript": "kanaqlayagaat, muskrat-at, imarmiutaat, kaviaret, nani-llu cali qavcicualegni, qavcicua cali piaqluki."
        },
        "30": {
            "start": 367.64,
            "end": 391.32,
            "transcript": "Kaviaret-llu tua-i unani piciatun maani yuilqumun akikeng' navrutengnaqaqluki akikengnaqluki caliarkaq nurnapiapiallrani, Kass'artaitellrani tamakut imkunek makunun melqulek im' uum apqemteńun tun'aqluki."
        },
        "31": {
            "start": 391.32,
            "end": 407.1,
            "transcript": "Wall'u kipusvigmi cali kupcaani makuni cali tamakunek akingengnaq' tau͡gaam ciuqlermi cat akiitellrulliniameng, imarmiutam waniw' akia navrutii,"
        },
        "32": {
            "start": 407.1,
            "end": 421.39,
            "transcript": "Yaassiik saayuq qalutaaryaq, tua-i qanulluku saskam imaanek au͡gna caqukaq only one cup tea, tua-i taqluku."
        },
        "33": {
            "start": 427.86,
            "end": 447.59,
            "transcript": "Tuaten pilallrulliniut maani piqarraallermeggni-llu Kassaunge'rmeng tua-i, kaviarem-llu akia navrutii kaviarem-llu tun'ikuni yuurqerkaq pitekluku, one, two, taqluku, kaviarem [?] amia,"
        },
        "34": {
            "start": 448.86,
            "end": 462.1,
            "transcript": "Tuaten qanrutek'lallrukait avani piqarraaller' maani Kass'at, Kass'alugpiat-wa maani piqarraarngatellrulriit niitellra,"
        },
        "35": {
            "start": 464.46,
            "end": 482.18,
            "transcript": "Tamaa-i tuaten pilallruut cat tamalkuan tua-i pitengnaqluku aturaqengnaqluku, makut-llu cali ava-i qalartellrukek'a [?] makut fish-at amiit, neqcugninar'"
        },
        "36": {
            "start": 482.3,
            "end": 495.29,
            "transcript": "Avani-llu qimugtet ciinaitelallrulliniameng [?] kalevnerkaunateng [?], tamakut pitekluki tua-i cali teq'umun akurrluki,"
        },
        "37": {
            "start": 495.29,
            "end": 512.7,
            "transcript": "Nertuata makut piciatun qimugtet, tuntut maa-i-llu tanglallilriaci tarrapaga'arrarluci [?], camek amimek maaken piameng, paivngaqan, qimugtem keggluku, nerluku, neryugngaluku nangluku."
        },
        "38": {
            "start": 512.7,
            "end": 533.32,
            "transcript": "Tamana pitekluku teq'umun akurtelarait neqcugniirluki. Neqcugnilallrat makut qimugtet neqcugninrilkata tua-i makut-llu maa-i neqerrluaraat tuknilalriit."
        },
        "39": {
            "start": 533.32,
            "end": 545.44,
            "transcript": "Kaigluni tau͡gken tua-i nerqatarluni tepait umiqsikeng'anateng tua-i-ll' piqerluni nernermek taqluni piami uitaqaameng,"
        },
        "40": {
            "start": 545.44,
            "end": 558.23,
            "transcript": "Aren taukut imkut yaaqsing'ermeng narungut [?] tua-i ak'a kainrilameng, wiinga-w tua-i kiima pilallilrianga."
        },
        "41": {
            "start": 564.32,
            "end": 580.37,
            "transcript": "Una cali waten skin-aq, waten waniw' ayuqelria ava-i qanelria ilavkurkiurluki, apuqermek [?] pinevkarluki pitullrullratnek atuullra amllerrluni,"
        },
        "42": {
            "start": 580.37,
            "end": 598.7,
            "transcript": "Makut cat piaciniit, rope-acuaraat piitellratnek atuullra amllerrluni ikamriaqameng tupiqluku qamigauciaqameng tupiqluku, qayiaqameng tupiqluku,"
        },
        "43": {
            "start": 598.7,
            "end": 612.0,
            "transcript": "Tua-i cassuucillermeggnun tamalkuan aturluki. Tanglunikuneng-llu cali tua-i tutneqluki tupiqluki tuaten."
        },
        "44": {
            "start": 612.0,
            "end": 630.92,
            "transcript": "Skin-am mat'um atullra amllepiallruuq avani atutullratni yuut kiingan man'a cam nunam qaingani ungungssiaraat."
        },
        "45": {
            "start": 633.57,
            "end": 651.41,
            "transcript": "Maani-llu cali pagaani ingrini tuntupiat makliit uum ava-i qanellratun pinevkarluki negilallrullinikait umyaraitnun."
        },
        "46": {
            "start": 651.41,
            "end": 666.8,
            "transcript": "Ava-i ca tamalkuan piqarraallermeggni au͡gkurluut pingnatupiarluteng pingnatullrulliniut ciuliat."
        },
        "47": {
            "start": 667.66,
            "end": 680.05,
            "transcript": "Piciatun wall' imkut makut makliit makunun caulriit [?] nurniarutata cali cikuliurutmun nem'eqerrluki piaqluki,"
        },
        "48": {
            "start": 680.05,
            "end": 693.02,
            "transcript": "Tau͡gaam waten au͡g'utun nuussikun piluku, tuamta-llu cali tuntut maani meqcirluki amiit."
        },
        "49": {
            "start": 693.02,
            "end": 708.69,
            "transcript": "Meqngata-llu tua-i kinercirluki kinrata-llu cali tuntu waten taktuanek piyukun uunrunrilngurnek uivaarturluku tua-i"
        },
        "50": {
            "start": 708.69,
            "end": 724.95,
            "transcript": "Angkuni-llu tuntut tuaten anglunun ingkunun ciungatnun piciuquni tuntum amia uivaarturluku tua-i waten usgunritengnaqluku pikuni tuaten piyugngaluni,"
        },
        "51": {
            "start": 724.95,
            "end": 740.93,
            "transcript": "Kiituan taun' amiq angrraarluni mikliriuq, elatii waten maaggun mengliikun pilagtuarturluku tua-i kiituan uivaarrluku tua-i waten."
        },
        "52": {
            "start": 740.93,
            "end": 755.4,
            "transcript": "Tuaten una-llu ava-i qanertuq makut amiit pilarniluki tuaten, takengnaqaqamegteki, kenait-llu [?] uivaarluki pilallruit pilallrulliniut."
        },
        "53": {
            "start": 758.98,
            "end": 782.34,
            "transcript": "Au͡gna apau͡rlurka wiinga-ll' tamakut cali tuami apqek' [?] au͡gna muriim ketunraa [?], tua-i makucinek pingvurluki pilitullruut, nunamteńi kuigpagmi cakluki tau͡gken tua-i tamalkuan aturluki."
        },
        "54": {
            "start": 782.34,
            "end": 792.16,
            "transcript": "Tamana tamalkuan aturluki, aturluki, waten ukcitnguutullruamallri [?] tamakuciliaqan nallunritaaqa."
        },
        "55": {
            "start": 792.16,
            "end": 803.72,
            "transcript": "Una-am cali pilriani-gguq, una-am, una qalamcillrulria nalia [?], una uuggun murak uplarniluku uum alularluku,"
        },
        "56": {
            "start": 803.72,
            "end": 816.07,
            "transcript": "Cali-am nuussiq-gguq-wa tuaten uivaarturluku pilria tua-i elliluku tua-i uuggun cali,"
        },
        "57": {
            "start": 816.07,
            "end": 829.3,
            "transcript": "Tau͡gaam una caviggaq tua-i cuq', waten-llu pikuni kepciquq tau͡gken nalqingnaqerrlainarluku uivaarluku pilallrulliniuq,"
        },
        "58": {
            "start": 832.02,
            "end": 839.25,
            "transcript": "Anglanarquq makucinek [?]"
        },
        "59": {
            "start": 839.25,
            "end": 851.18,
            "transcript": "Cali ava-i una qanertuq nuqtestaunani-am cali piyuunani, cukanrulallian-am cali nuqingaurluku,"
        },
        "60": {
            "start": 851.18,
            "end": 865.0,
            "transcript": "Una waniwa tuatenakuni [?] pilakarraarluku, tua-i-llu avavet pikan teguyunarikan una amit tegumiaqluku,"
        },
        "61": {
            "start": 865.0,
            "end": 880.88,
            "transcript": "Au͡gna-llu imna au͡g'arturallra cali nuqingaurluku tua-i tuaten, au͡gkutun cali mulngaku'urluku takluku piyukuni, kepeksaunaku, tamerkiukun [?]."
        },
        "62": {
            "start": 880.88,
            "end": 896.77,
            "transcript": "Taklartut tua-i naurarqamek [?] kep'artarluteng pinritaqameng, nuqingastemegnun-gguq tau͡gaam ataut atalartut. Tua-i ilii-gguq nuqingasteńgunermi kep'arciurnerkarrluku [?]."
        },
        "63": {
            "start": 896.77,
            "end": 910.37,
            "transcript": "Qac'uqerteqa'arqan aipaak tua-i imumek tua-i pitatekengnaqluku wiinga-ll' nuqtestengulngullruama tua-i una qacinruqaquni [?]"
        },
        "64": {
            "start": 910.37,
            "end": 924.75,
            "transcript": "Ak'a tua-i kepengyaaq', kepsuumiileng'e'rmi kep'arrluku, taumek-am pingualallrukait, nuqcetaaggurrluku [?] pinevkartuq, una caviggaamek tegumiaqestii pivkenani,"
        },
        "65": {
            "start": 924.75,
            "end": 931.7,
            "transcript": "Nuqculi pinevkayunaqluni. Tuaten qanrutek'lallruut."
        },
        "66": {
            "start": 931.7,
            "end": 949.47,
            "transcript": "Tuamta-llu cali yuum qaingakun kap', yuum akngirtellrukan kapnarqan tua-i cali-am ukuk yuum qaingkengraani nuqluku [?]"
        },
        "67": {
            "start": 949.47,
            "end": 960.38,
            "transcript": "Imkut-am inglua pupsumyaakuni kapkuni tua-i [?] tamana assiirutarkaq [?],"
        },
        "68": {
            "start": 960.38,
            "end": 966.87,
            "transcript": "Pisqaa-am tuaten tuakun pinevkaruaresqaat, ii-i,"
        },
        "69": {
            "start": 966.87,
            "end": 983.88,
            "transcript": "Uluanek pikalget uluanek atungnaquratuut neng'enqellrianek (putgaryaranek) makunek wangkuta pitukumteki caviggaq makut neng'enqellrit piksunarqut tua-i waten."
        },
        "70": {
            "start": 983.88,
            "end": 997.92,
            "transcript": "Ing'um nuqtestem nuqeskaku, uum-llu wani tua-i waten, (uluaq?) qang'a makuciq (aturyuitut-wa),"
        },
        "71": {
            "start": 997.92,
            "end": 1015.72,
            "transcript": "Tua-i-llu uum nuqtellriim nugtarrluku teguluku ataam cayugaqluku, makucignek-wa tegumialriim ing'um cayullrani pilaki,"
        },
        "72": {
            "start": 1015.72,
            "end": 1034.58,
            "transcript": "Una nuqetellriaruliaraqan arulairaqami teguluku ataam cayugaqaku uum tegumiaqestiin string-aurtaqluku, (tapraq) ii-i tapruaq,"
        },
        "73": {
            "start": 1034.58,
            "end": 1053.89,
            "transcript": "Au͡gkutun nauw imna ingna naliak ukuk, qulilam [?] qiluinek tangellrulriakut, tua-i tuaten makut-llu au͡g'um pinevkara tuaten ayuqliritulliniut amiungermeng."
        },
        "74": {
            "start": 1053.89,
            "end": 1072.34,
            "transcript": "Mik'elnge'rmiu caviggaq assirtuq wangkuta-ll' apqemteńek pupsuyagengqerrami. Ii-i, pupsucuaraat, nuussicuacuaraat. Imani kiaqvani."
        },
        "75": {
            "start": 1080.41,
            "end": 1100.92,
            "transcript": "Taqukat-mi uquit canun atutullruit caulallrit qayat-llu amirqai kinerciqaqamegteki uqumek-llu mecircet'laqaat? Uqua taqukam?"
        },
        "76": {
            "start": 1100.92,
            "end": 1117.87,
            "transcript": "Qayaq nutaraq uqumek aturpakayuitellruut nutaramun nutaan tau͡gaam allragni ellaurtaqan [?] qayaq uqurrluku qaingaa pitullruat."
        },
        "77": {
            "start": 1117.87,
            "end": 1132.12,
            "transcript": "Uqum atullra amllertuq. Puyalikuneng puyanun temeciulluku puyaurtelluku [?]. Uqunek? Ii-i."
        },
        "78": {
            "start": 1132.12,
            "end": 1147.66,
            "transcript": "Tuamta-llu kenurraqluku kiingan unuum tamalkuitaa imkunek Kass'artanek pingvailegmeng unuut tamalkuita kenurraqluku."
        },
        "79": {
            "start": 1147.66,
            "end": 1164.55,
            "transcript": "Nerkuneng tuamtell' tua-i umkurmiut pikangqerquneng nertellermek tamiini nerluku. Kumlanertung'e'rmeng kinernertuquneng arcaqerluku neryugpallaarluku."
        },
        "80": {
            "start": 1164.55,
            "end": 1172.6,
            "transcript": "Keniratunge'rmeng-llu cali uqirluku naniqseng [?] tua-i uquq kesianek aturluku."
        },
        "81": {
            "start": 1172.6,
            "end": 1192.9,
            "transcript": "Tuamta-llu yuk naulluungekuni uqumek merluni. Amna iluni caarrluirluku-gguq caarrluk anaraluni anlluku naulluullra-llu nall'arulluni amllerem assiriluni."
        },
        "82": {
            "start": 1193.95,
            "end": 1204.16,
            "transcript": "Tuamta-ll' ilii qamiqulnguniluni uqumek unatni pirraarluku man'a cungu'uni mingugluku."
        },
        "83": {
            "start": 1204.16,
            "end": 1219.84,
            "transcript": "Tua-i qamiqiqsuuteqluku tuaten, tuai uqum atullra amllepiarluni.  Qerruskuni tuamta-llu yuilqumi uuqlagnaqsuitellruami."
        },
        "84": {
            "start": 1221.37,
            "end": 1239.29,
            "transcript": "Qerrutetaacin [?] niilluku qaneni imirluku uqumek pikangqerquni igkuni qerrutellra cali utumaqerluni uqum tua-i atullra amllepiarluni."
        },
        "85": {
            "start": 1239.29,
            "end": 1256.99,
            "transcript": "Cali-llu waten makunek Kass'at calugtaitnek aminek calugciyuitellermeggni qetulcautektuluku aminun. Uqurrluku iquciaqameng qetulcautekluku."
        },
        "86": {
            "start": 1256.99,
            "end": 1264.558,
            "transcript": "Tuai uqum qaill' atullra amllepiarluni."
        },
        "87": {
            "start": 1264.558,
            "end": 1273.62,
            "transcript": "Arcaqerluni ivrulliniut. Up'nerkami qanikcaragyunga'artaqan."
        },
        "88": {
            "start": 1273.62,
            "end": 1282.93,
            "transcript": "Tua-i neqekluku kenurraqluku cassuutekluku inrukluku tuaten tamiini."
        },
        "89": {
            "start": 1282.93,
            "end": 1296.15,
            "transcript": "Tauna maa-i ciuliaput qantullrulriit. Uquq-gguq man'a camek nerlerrluutaituq-llu camek tua-i."
        },
        "90": {
            "start": 1296.15,
            "end": 1309.84,
            "transcript": "Yuk-gguq uquq tung'ermi puyilqapiarqinek tua-i ilussaqrutek tauna akulluku ayagmek neqngamegteggu au͡gkut."
        },
        "91": {
            "start": 1310.84,
            "end": 1328.22,
            "transcript": "Tua-i-am uqum-ll' ilii tam' [?] calriit kaassarninarqelartat [?] kemgit-llu uquit-llu. Taum wangkuta pituluki tamakut tegauniluku."
        },
        "92": {
            "start": 1328.22,
            "end": 1347.03,
            "transcript": "Tua-ll' tamaani angitullratni uqunek cali angrurcelluku uquq kenirluku ekuavkarluku tua-ll' pinarikan qanikcaam qainganun kuvluku nengllikakut tuangerturluku cavkenani assirluni pimakuni."
        },
        "93": {
            "start": 1347.03,
            "end": 1357.84,
            "transcript": "Iliin-llam nepcagnariqerrniluku qanlallruut. Uqum tua-i cat tamalkuan call' aturaat tamatum uqum."
        },
        "94": {
            "start": 1357.84,
            "end": 1374.6,
            "transcript": "Ayuqucirturilriit-am iliitnek caqerluni tua-i, tua-i-gguq-am maa-i yugni tegaulria yuk, aptuarput tunerninaqniluku."
        },
        "95": {
            "start": 1374.6,
            "end": 1381.54,
            "transcript": "Tamaa-i-gguq tamakut ciugut taqukat tamakut tegiit. Unerninarqeller' ii-i."
        },
        "96": {
            "start": 1385.38,
            "end": 1393.8,
            "transcript": "Cali-llu-gguq tua-i yugni maa-i tegaput tunerninaqniluki aptuluki wangkuta."
        },
        "97": {
            "start": 1393.8,
            "end": 1411.56,
            "transcript": "Cali tanem makut tua-i neqnialkaqluku wangkuta kaassarninarqelriit iliit tukniluni, iliit tukniallruluni. Wagg'uq wangkuta piaqluki tegauniluki tegagninaq'."
        },
        "98": {
            "start": 1411.56,
            "end": 1416.91,
            "transcript": "Narellra-ll' iliit tukniluni cali kaassarninaqnganani."
        },
        "99": {
            "start": 1416.91,
            "end": 1425.23,
            "transcript": "Neryunaunani-ll' arcaqalriat atam piineryuunaitut."
        },
        "100": {
            "start": 1425.23,
            "end": 1435.7,
            "transcript": "Cali-llu makucit arcaqerluteng tua-i-w' kiimeng piklagmek piluteng angucaluit tepsaqtuluteng."
        },
        "101": {
            "start": 1435.7,
            "end": 1450.09,
            "transcript": "Issuriit-qaa? Ii-i. Issurvagnimek-gguq wagg'uq yugni ayuqenritliniamta iliin-am tamana tepiit nall [?] elpekumavkenaku,"
        },
        "102": {
            "start": 1450.09,
            "end": 1468.01,
            "transcript": "Iliin tau͡gken tua-i tepiit [?] elpekumaluku issurvagnek. Yuum tau͡gken iliin elpekumavkenaku, ava-i wii aipaqa tuaten ayuquq makucimek pili-ll' elpekumavkenaku,"
        },
        "103": {
            "start": 1468.01,
            "end": 1481.19,
            "transcript": "Wiinga-ll' tepiinek qanen'erma [?] elliin uuguciitaa [?] tepiit tuanguciitaa tuaten yug'un ayuqelliniluta."
        },
        "104": {
            "start": 1481.19,
            "end": 1489.16,
            "transcript": "Nalliit-mi taqukat uuvikauluki nertuitki wall' naliit uunqegcaarluki nertuit?"
        },
        "105": {
            "start": 1489.16,
            "end": 1505.84,
            "transcript": "Makut maa-i issurit uuvikauluki tangerqaqsaitanka, niiteqaqsaunii-llu issurinek uuvikarniluni, tau͡gken makut maklaraat amirkat."
        },
        "106": {
            "start": 1505.84,
            "end": 1517.88,
            "transcript": "Tua-i [?] allagluki neryuumiinaki kesianek tua-i uuvikarrlainauluki neryugnaqluteng, aanait-llu makliit,"
        },
        "107": {
            "start": 1517.88,
            "end": 1526.84,
            "transcript": "Makut cali nayiit uuvikaunge'rmeng cangatevkenateng [?] nayiit."
        },
        "108": {
            "start": 1526.84,
            "end": 1541.84,
            "transcript": "Tuamta-ll' tua-i makut yaqulget uuvikaunuteng nertukait uuvallegluku call' nerellrat assirpek'nani tuaten tua-i tau͡gaam neryugnaqluteng."
        },
        "109": {
            "start": 1541.84,
            "end": 1560.75,
            "transcript": "Ukaqvakun makut qugyuut uuvikauluki nerellrit nutaan elpekellruanka assinqurraullinilriit uuvikaryarani makuni uuvikauluteng, wangkuta apqemteńek uuvikauluteng."
        },
        "110": {
            "start": 1567.84,
            "end": 1581.84,
            "transcript": "Makut wani negilinun asguruanun tuaten inguqaqluki, iciw' negilim elaqliani."
        },
        "111": {
            "start": 1581.84,
            "end": 1597.14,
            "transcript": "Keglunrem-qaa melqurrui amian melqurran nayumirastekluku, kegginaranek pilartelarait [?] tamakut asguruaqluki."
        },
        "112": {
            "start": 1597.14,
            "end": 1614.84,
            "transcript": "Arnat negiliitat, arnat tua-i atutuit asguq wagg'uq asguruaq-llu, atuyuunaqluni-am keviqcaarnaunani assilliniluni atullra usguq makut piqcaarnaunateng."
        },
        "113": {
            "start": 1614.9,
            "end": 1634.38,
            "transcript": "Ava-i cali nat'rakunallemteni nat'rautulillermeng ilii aprumanritut tuntum qamiqurrit kegginaurluta iliit tamaa-i naspaaqtullruit [?] tuntut reindeer-at qamiqurrit kegginait."
        },
        "114": {
            "start": 1634.38,
            "end": 1647.84,
            "transcript": "Nat'raqaqluki ilait uksumi, tau͡gaam melqurriimanrilnguut, [?]-irnaqnitullruut, melqurriiqaumanrilnguut."
        },
        "115": {
            "start": 1656.84,
            "end": 1670.84,
            "transcript": "Cali-ll' au͡gkut neqerrliuten nat'raqetuluki pilugukluki, wiinga-am tua-i pingqellruunga iliinek nat'rarluteng ilamteńek."
        },
        "116": {
            "start": 1670.84,
            "end": 1680.04,
            "transcript": "Inerqurnauraatnga ankuma qimugtem-gguq anaanun tusuucaaqunakek natragka,"
        },
        "117": {
            "start": 1680.04,
            "end": 1691.39,
            "transcript": "Tua-i umyuaqaumta paqnayungluni tamatumek ciin inerqutullratnek qimugtem anaanun tusuutesqevkenaku."
        },
        "118": {
            "start": 1691.39,
            "end": 1700.87,
            "transcript": "Taum paqpiqcaqlua qimugtem anaanun tull'uku, murilkevkenii ellami qanikcami aquiluteng,"
        },
        "119": {
            "start": 1700.87,
            "end": 1712.21,
            "transcript": "Tua-i-ll' itrama piatnga tua-i-am tus'utelliniagken natrarpet aipaat, tangraqa taun' tus'uutelqa nangllini-ll',"
        },
        "120": {
            "start": 1712.21,
            "end": 1720.84,
            "transcript": "Wagg'uq tua-i qimugtem anaanun tus'uutellraini ar'uqertetuut tamakut."
        },
        "121": {
            "start": 1720.84,
            "end": 1737.66,
            "transcript": "Tua-i nallunrirluku-am wiinga, makut maa-i makuuluteng meqluki [?] cingiqluki, makut, yualukaqluku ukuk waniwa pinevkarnillrulriik,"
        },
        "122": {
            "start": 1737.66,
            "end": 1747.84,
            "transcript": "Waten call' tua-i cingiqluki, cali-llu makuciqluki, uiteramek tau͡gaam qaralirrluki."
        },
        "123": {
            "start": 1747.84,
            "end": 1757.3,
            "transcript": "Camek-qaa acilartatkut tamana?  Murneq-gguq maa-i, wangkuta murnernek pituaput, makut."
        },
        "124": {
            "start": 1757.3,
            "end": 1768.84,
            "transcript": "Ikgetqaqan piluguk call' waten usguluku, tumkitqaqan cangatevkenaku, wagg'uq tua-i murnirluku."
        },
        "125": {
            "start": 1768.84,
            "end": 1775.24,
            "transcript": "Ngelairutait' [?]"
        },
        "126": {
            "start": 1775.24,
            "end": 1790.5,
            "transcript": "Makut, makualaatekluku qamna melqutungraan tau͡gaam man'a menglii mingeqvigka melqurriqerluku,"
        },
        "127": {
            "start": 1790.5,
            "end": 1803.53,
            "transcript": "Maa-i-w' man'a amirkaq wall'uq maklassiuguq im' makliim irniaraa."
        },
        "128": {
            "start": 1803.53,
            "end": 1820.84,
            "transcript": "Maklassuugaat-llu natrauyugngaut qecigtuu', maklagni qecigkillruameng tau͡gaam makaa avani canek anglaninritellermeggni ayagassuutait maklaagni nat'ritullruit, nat'rangqetullruut."
        },
        "129": {
            "start": 1823.19,
            "end": 1836.77,
            "transcript": "Wagg'uq iqertait ayagassuutait uksumi piluguit angutet, iliin-am tua-i man'a kangeqluku piluguugken,"
        },
        "130": {
            "start": 1836.77,
            "end": 1852.26,
            "transcript": "Makua qaitelluku melqutungraan kananelluni, mat'umek-llu kanglirluku melqurrat ayuqengraan cali iliini tamaa-i ciisqurrilitaqluku-gguq."
        },
        "131": {
            "start": 1854.01,
            "end": 1862.54,
            "transcript": "Qaliruanek atuyuitetutellermeggni ciisqurrilitaqluku-gguq piluguugni nanilkagnek,"
        },
        "132": {
            "start": 1862.54,
            "end": 1871.84,
            "transcript": "Man'a tua-i allagnek aturluni, ukuk-llu tua-i ciisqurrilitagni all'ukek."
        },
        "133": {
            "start": 1871.84,
            "end": 1877.85,
            "transcript": "Tuar ilumun pilu'ugtulalria kanaggun maaggun nusgurluni."
        },
        "134": {
            "start": 1878.84,
            "end": 1886.53,
            "transcript": "Tua-ll' kamilaareskuni ukuk-llu yuuvkenani wall' tua-i au͡g'arlukek uqlanissiyaakagnek."
        },
        "135": {
            "start": 1886.53,
            "end": 1898.26,
            "transcript": "Makut maa-i tuaten pitullruut, kangeqluki pilugugnun, kankut-ll' aciit,"
        },
        "136": {
            "start": 1898.26,
            "end": 1909.76,
            "transcript": "Makuitelatekluki, makuitnek qeciitnek elatelirluki kan'a, kan'a nat'ram tunglirnera pilugugluni."
        },
        "137": {
            "start": 1909.84,
            "end": 1913.84,
            "transcript": "Angingnaqu'urluki angucetaat pitullruaput."
        },
        "138": {
            "start": 1913.84,
            "end": 1926.84,
            "transcript": "Tau͡gaam tuaten melqurrailukluku aciugaqata irutevkenaki, tua-i kinguamallruciatun tua-i."
        },
        "139": {
            "start": 1926.84,
            "end": 1935.3,
            "transcript": "Eluciatun, calugtevkenaki."
        },
        "140": {
            "start": 1935.3,
            "end": 1938.95,
            "transcript": "Cimirilaakatartukut call'"
        }
    },
    "hpDEodHWvZM": {
        "1": {
            "start": 0.0,
            "end": 9.08,
            "transcript": "Maa-i [?]. Pugcuunani. [?]"
        },
        "2": {
            "start": 13.75,
            "end": 31.46,
            "transcript": "Piyagarnek pissuriyagarnek ciuqlirmek waten-llu tua-i issuriurtellrianek [?]. (Au͡gkut-qaa.) [?]"
        },
        "3": {
            "start": 31.46,
            "end": 43.27,
            "transcript": "Au͡gna qalarutqerquvgu qalarutkeqakuvgu cali au͡gna nat'rarkiugaqameng?"
        },
        "4": {
            "start": 43.27,
            "end": 55.4,
            "transcript": "Cat makut-qaa? Meqcirluki meq'kata-ll' tua-i melqurrirraarluki nilla'aqataqunegteki cali wavet kelikarluki."
        },
        "5": {
            "start": 55.4,
            "end": 62.52,
            "transcript": "Uqurrluk qamani au͡g'anqegcarluku makuani."
        },
        "6": {
            "start": 62.52,
            "end": 79.0,
            "transcript": "Keliuqerluku-gguq tua-i tua-ll' nutaan tamana uqurrluku nangkan imkutgun muragatgun pitullermeggni tua-i nillarluku nat'rarkiurluku waten ilii ayuqaqluki."
        },
        "7": {
            "start": 79.0,
            "end": 82.66,
            "transcript": "Nunamun kapu', ii-i muragat."
        },
        "8": {
            "start": 82.66,
            "end": 87.62,
            "transcript": "Kapu'urqelluki uivenqell' waten ayuqliriaqlu'."
        },
        "9": {
            "start": 87.62,
            "end": 97.43,
            "transcript": "[???] Qemiraggluku. Qemiraggsiarauguq. (Catnaq-gguq niillagrluku-gguq tamana qemiraglliyarauguk tuaten avuk.)  Wangkuta-ll' nunamteńi."
        },
        "10": {
            "start": 97.43,
            "end": 116.44,
            "transcript": "Nillarrluku tua-i nat'raqsunariluni. Kinercirluku. Kinqaku tua-i imugluku tuaten nat'raqataquni nenglluku naterkaq tua-i cuqluku kepulluni nat'rarluni."
        },
        "11": {
            "start": 116.44,
            "end": 135.0,
            "transcript": "Angutet cat mikcuayaarnek engelqikusualrianek [?] pilivkayuitetullruit avani, tau͡gaam angengnaqu'urluki. Piluguit nat'raik-ll' angengnaqu'urluki."
        },
        "12": {
            "start": 135.0,
            "end": 145.85,
            "transcript": "(Man'a-wa) Ayagassuutait arcaqerluki, pengegnaingnaqu'urluki [?] pitullruit."
        },
        "13": {
            "start": 145.85,
            "end": 161.0,
            "transcript": "Ava-i call' qanemcikek'a man'a caluumavkenaku aciqliuluni. Qaill' waten taktaluni, waten-llu cali tak' makucimek usguluni maaggun."
        },
        "14": {
            "start": 161.0,
            "end": 169.0,
            "transcript": "Wagg'uq nuqyucirluku cali kan'a makungqerrluni."
        },
        "15": {
            "start": 169.0,
            "end": 183.63,
            "transcript": "Tua-i askuni nanilngu' [?], tamakucignek mingqungengraan tua-ll' uum nallii, uum nallii call' makucinek qanqillrulluku, nuqyucirluku-llu-gguq."
        },
        "16": {
            "start": 183.63,
            "end": 192.09,
            "transcript": "Pengegnairluki pingnatullruit angucetayagaatulruit piluguit, akluit."
        },
        "17": {
            "start": 192.09,
            "end": 200.45,
            "transcript": "Tua-i angengnaqu'urluki tau͡gaam engelqikussavkanrilkurrluki."
        },
        "18": {
            "start": 206.0,
            "end": 212.9,
            "transcript": "Taprualuunkuk-gguq tapraq-llu qaillun ayuqenritak, taprualuk, tapraq?"
        },
        "19": {
            "start": 212.9,
            "end": 224.04,
            "transcript": "Taprualuk kevkarcainaqumaluni ellegtuq [?]. (Taprualuk) Ii-i tapraq tau͡gken amillruluni."
        },
        "20": {
            "start": 224.04,
            "end": 234.58,
            "transcript": "Taprualuk canun nuqtaarutnguyugngaluni, ikamrat-llu qamuutaqsugngaluku."
        },
        "21": {
            "start": 234.58,
            "end": 243.88,
            "transcript": "Tua-i kevkarten' kevkautenritengnaqluni piyutminun atuugarkauluni taprualuk."
        },
        "22": {
            "start": 243.88,
            "end": 248.29,
            "transcript": "Uginaat-llu-qaa irnerrluitnek tamakulitut?"
        },
        "23": {
            "start": 248.29,
            "end": 268.0,
            "transcript": "Ava-i iciw' maniitellrukiikut aminani, tamaa-i qayat caaganritnun, camkut camani caaganernek pituit, cauyaraitnun qillruquraumatuluteng tua-i."
        },
        "24": {
            "start": 268.0,
            "end": 284.35,
            "transcript": "Tamakuksuumituluki keniaqameng amim pasgerqateng nucuilata, wagg'uq nangurqucuilata tamakuksuumirturatuluki."
        },
        "25": {
            "start": 284.35,
            "end": 293.95,
            "transcript": "Tau͡gken tua-i paivngarrlainarciigalameng-am makut ungungssit."
        },
        "26": {
            "start": 293.95,
            "end": 306.0,
            "transcript": "Nutaan pinevkarluteng, tamakukiurrameng [?] amililuku tua-i imutun yualu' pelacinagnek pitukemcetun."
        },
        "27": {
            "start": 306.0,
            "end": 318.36,
            "transcript": "Ellegtaarkaungengnaqevkarluku tua-i munarcarluteng cat pinevkarluteng, wagg'uq nemerkiurluni."
        },
        "28": {
            "start": 318.36,
            "end": 323.72,
            "transcript": "Qecigem man'a cak-llu ayuqenrilngurteggun atupiallruat tau͡gkut."
        },
        "29": {
            "start": 323.72,
            "end": 327.0,
            "transcript": "Kuvyalitullruit-llu-qaa?"
        },
        "30": {
            "start": 327.0,
            "end": 342.25,
            "transcript": "Yualunek, ii-i tau͡gken nutaan taqukassuucikuneng cali-ll' tamakunek pinevkaranek taqukanek kuvyakiurluni nutaan pinevkaranek kuvyakiuruit [?]."
        },
        "31": {
            "start": 342.25,
            "end": 352.0,
            "transcript": "Cuqcarangqerrluteng-llu cali qanemcikurarqaiceteng [?] negartutaciit, cuqcarangqerrluteng."
        },
        "32": {
            "start": 352.0,
            "end": 360.17,
            "transcript": "Cassuutet waten negaqeggun taktaarkauniaqluku, waten taktaarkauniaqluku."
        },
        "33": {
            "start": 360.17,
            "end": 375.0,
            "transcript": "Makut tamaa-i imegglugneruarait unatet cuqnguluteng, imegglugneruarait makut maa-i, tua-i yaaqgutnun [?]."
        },
        "34": {
            "start": 375.0,
            "end": 391.0,
            "transcript": "Pavani-am Kuigpagmi, wang' wiinga ilait makunek apqemteńek pelacilagnek piitellratni, makut-llu uqviigaat qeltaitnek kuvyitullratni."
        },
        "35": {
            "start": 391.0,
            "end": 413.4,
            "transcript": "Ilait-am waten yualunek cat yualitnek tua-i pilartat tauna-ll' reindeer, arnait qip'iluteng, kuvyakia qip'iluta angutaitamta taqngaita [?] kuvyait, qilagturluteng pitullrat, apqemteńek wangkuta qilagqu'urluteng kuvyitullratni."
        },
        "36": {
            "start": 413.4,
            "end": 433.0,
            "transcript": "Tua-i kuvyakiutullruit wiinga tangellruunga tamakucinek cali-llu makut qagkut, napayagat qagkut, qeltaitnek kuvyanek taryaqvagcuutnek."
        },
        "37": {
            "start": 433.0,
            "end": 445.0,
            "transcript": "Tamakut yualut qaillun ayuq' ayuqat tayim keniaqameng tayim tuaten qanrutkellerpeten piqtaatullilriit tayima."
        },
        "38": {
            "start": 445.0,
            "end": 456.88,
            "transcript": "Cangrraarluni una qillernera inglu' yaatmuqerrluni pian, napingalleq anqerrluni ayagluni puukaraa."
        },
        "39": {
            "start": 456.88,
            "end": 465.28,
            "transcript": "Makut [?] qagkut apeqevet wangkuta Kuigpagmi uqviigaat qeltait kuvyaglua qeltaitnek kuvyaq'"
        },
        "40": {
            "start": 465.28,
            "end": 471.97,
            "transcript": "Wiinga-llu qeltaitnek, cam kicautaqellruunkuk [?]."
        },
        "41": {
            "start": 471.97,
            "end": 479.48,
            "transcript": "Tau͡gaam mer'em et'aqercerrlainarluni [?] kinqerqameng ayemcuulartut [?] mermi uitanritaa'"
        },
        "42": {
            "start": 479.48,
            "end": 485.81,
            "transcript": "Tamarmi mer'em elngurcalallinik'in [?]."
        },
        "43": {
            "start": 485.81,
            "end": 499.18,
            "transcript": "Makut-llu cali arnat cali imkunek goose foot [?] neqet anguugnga can'giiret-llu caqukiuqamegteki mecung'"
        },
        "44": {
            "start": 499.18,
            "end": 515.0,
            "transcript": "Mermun akurqaarluki tua-i tupigluki, ak'a-llu tua-i plastic-at nurnallratni tua-i can'get makut cali atupiarluki atullruit."
        },
        "45": {
            "start": 515.0,
            "end": 532.06,
            "transcript": "Tua-i kiingan aklukluki maqarqutekluki, cakluki, imiutaqluki-llu mud house-am iluani, qasgim-llu cali ilua cali tamakunek seam insulation"
        },
        "46": {
            "start": 533.64,
            "end": 543.65,
            "transcript": "Tamakut tamaa-i-am nunamun mud house-anun kanevyaiskutekluki."
        },
        "47": {
            "start": 543.65,
            "end": 555.42,
            "transcript": "Tuamta-llu cali waten qalliqluki amlleriluki pikuneng, ellarvagyaaq [?] imkut tamakut canek ellurciquq [?], tamavet-llu piyugnaunani."
        },
        "48": {
            "start": 555.42,
            "end": 567.19,
            "transcript": "Tamakut tua-i makut-llu cali pivakarluteng-am ilait avani qaillukuarluteng pilaameng makut-llu."
        },
        "49": {
            "start": 567.19,
            "end": 584.0,
            "transcript": "Roofing paper-aartaitellrani napat cali kelaaciiritnek roofing paper-aatun saggluki piaqluki kucirngaunateng tua-i same roofing paper."
        },
        "50": {
            "start": 584.0,
            "end": 604.63,
            "transcript": "Au͡gkut atam wangkuta qagaani pavani Kuigpagmi avngulegnek pituaput matqugniilngurnek [?] qelkait imkut puyurcivim [?] qilakluki-llu kuciyuitqapiartut watpik."
        },
        "51": {
            "start": 604.63,
            "end": 613.01,
            "transcript": "Tua-i ellarvangraan kucirngaunateng assirluteng cakneq."
        },
        "52": {
            "start": 613.01,
            "end": 629.0,
            "transcript": "Tamakuni-llam iliit pavani piterrnarqut puyurciviteng pilirluki, qilait-llu pau͡gkut tamakucinek pitullruit, anuqlingaalriit [?]."
        },
        "53": {
            "start": 631.48,
            "end": 641.23,
            "transcript": "Aren, cat tamalkuan au͡gkurluut seviinritleng' [?] nalliini tua-i."
        },
        "54": {
            "start": 641.23,
            "end": 652.64,
            "transcript": "Tua-i murak-llu tangrraqamegteggu tangvagluku una atak umyuarterluni una tuar' taunguciqellria wall'u cakauluni."
        },
        "55": {
            "start": 652.64,
            "end": 665.28,
            "transcript": "Tua-i tuaten tua-i umyuartuqulluku tua-i teguluku tua-i piluku, tekicameng-llu tua-i pinaraan uum."
        },
        "56": {
            "start": 665.28,
            "end": 680.9,
            "transcript": "Au͡gna tangellrakut tua-i waten elliluku tua-i, tua-i-llu umyuarteqellrukuneng taungur' taunguluku piyukunegteggu taunguluku taqluku."
        },
        "57": {
            "start": 680.9,
            "end": 689.76,
            "transcript": "Tua-i-w' cali tua-i man'a akluullilliniut."
        },
        "58": {
            "start": 693.13,
            "end": 701.0,
            "transcript": "Apteqaryugamken ciin aturalartuq uiteraq maani, maani-llu?"
        },
        "59": {
            "start": 701.0,
            "end": 713.55,
            "transcript": "Nutem-wa tua-i alngani makuilnguut tangvallrit assirpek'nateng makuilnguut-llu."
        },
        "60": {
            "start": 715.57,
            "end": 729.74,
            "transcript": "Iliin imkut assiriqerrutekluku, patagmek-llu keniyailkutnguvkenani."
        },
        "61": {
            "start": 729.74,
            "end": 742.02,
            "transcript": "Tau͡gaam makut tua-i canun tamiitnun call' uiteraq man'a aturluku."
        },
        "62": {
            "start": 742.02,
            "end": 760.0,
            "transcript": "Alnganun negilinun makunun-llu, qayanun-llu caitnun tamalkuan uitaraq cat man' qaraliqluku, pitegcautnun urlumegnun qantani."
        },
        "63": {
            "start": 761.26,
            "end": 773.46,
            "transcript": "Qipuutnun-llu tua-i aturluku man' call' qaraliqluku uiteraq, uiteramek pitukiit man'a."
        },
        "64": {
            "start": 773.46,
            "end": 782.56,
            "transcript": "Tangnircautnguluni minguuluni, muraganun-llu, qecignun-llu."
        },
        "65": {
            "start": 782.56,
            "end": 789.93,
            "transcript": "Piilngurni-am qenaqluni cakneq makucimek piitaitelleq."
        },
        "66": {
            "start": 793.0,
            "end": 808.65,
            "transcript": "(Pavani-am makuci'...) Elpet-qaa unangellruuten makucimek?"
        },
        "67": {
            "start": 808.65,
            "end": 823.0,
            "transcript": "Uiteramek-qaa uiterarcuullerpeni unangell' nalaqutellruuten Rose-aq-llu? Tununermiut. Pitellruuten-qaa?"
        },
        "68": {
            "start": 823.0,
            "end": 828.0,
            "transcript": "[?] tau͡gaam..."
        },
        "69": {
            "start": 829.9,
            "end": 831.54,
            "transcript": "Usuuq."
        },
        "70": {
            "start": 834.0,
            "end": 840.76,
            "transcript": "Kuigpagmiut-llu uiteraq aturlartuq, Kuigpagmiut-llu?"
        },
        "71": {
            "start": 840.76,
            "end": 846.27,
            "transcript": "Uiteraq-gguq-qaa makuciq Kuigpagmiuni atutuaci qaraliqluku-llu?"
        },
        "72": {
            "start": 846.27,
            "end": 859.0,
            "transcript": "Qaraliqlaraat tau͡gaam tamakucililartut cuukvagvuat, cuukvaguat, tamakuciurrluki."
        },
        "73": {
            "start": 859.0,
            "end": 874.0,
            "transcript": "Kuigpagmiut pavani makem' [?] kanani navcavatiin [?] uiterat uiterang' uiterartaqertuq [?] Tununermi-llu, tamaaken Tununermek wiinga uiteranek pituut kavirimek."
        },
        "74": {
            "start": 874.0,
            "end": 885.0,
            "transcript": "Pavani Kuigpagmi makucinek uiteranek, uiteraliaqameng cukvagvuat qagkut pilartut."
        },
        "75": {
            "start": 886.0,
            "end": 898.32,
            "transcript": "Tua-i tang waten tangnircautekluki canun, pilu' waten pilugugnun makunun avirrluki piluguliaram."
        },
        "76": {
            "start": 898.32,
            "end": 908.98,
            "transcript": "Tamakut cuukvagvuat pi' amiitnek. Qaill' pilugumegmun [?] pilutait pilallikait."
        },
        "77": {
            "start": 908.98,
            "end": 919.89,
            "transcript": "Tua-i tamakucinek pirraar' waten ayuqlirituut, ayuqlirituut makucetun."
        },
        "78": {
            "start": 919.89,
            "end": 928.0,
            "transcript": "Tangnircaut', tangnirqutnguut tau͡gaam makut uiterat waten canun makunun piluku [?]."
        },
        "79": {
            "start": 928.0,
            "end": 940.23,
            "transcript": "Imumi-wa wiinga niitelallrulrianga tuntunek-llu tamakunek canaluki qeltaitnek akurrluki avuluki wagg'uq peqlicarluki."
        },
        "80": {
            "start": 940.23,
            "end": 951.52,
            "transcript": "Tua-i tau͡gken waten kaviriqerluteng kepluki. (Yaa.)  Wagg'uq tua-i peqlicarluki keningyallruluteng tamakut."
        },
        "81": {
            "start": 951.52,
            "end": 954.55,
            "transcript": "Ii-i, qeltait."
        },
        "82": {
            "start": 954.55,
            "end": 965.0,
            "transcript": "Aunraryungellrata nalliini iquk', iqukvaryarturqan pitullruut, pinitullruut."
        },
        "83": {
            "start": 965.0,
            "end": 979.6,
            "transcript": "Iciw' makut cuukvaguat ayuqenrit', aipaingqertut [?] cali allamek. (Auk.)  Aipaingqertut qanrutkellruken-im cuukvaguat [?] malruinun malruuguk."
        },
        "84": {
            "start": 979.6,
            "end": 994.75,
            "transcript": "Makut-llu cali qavarnacetun, qavar' I mean kevraartut-llu makut ayuqsaaqut tau͡gaam allauluteng tua-i ava-i tamakunek imkunek ap' [?]."
        },
        "85": {
            "start": 994.75,
            "end": 998.65,
            "transcript": "Yaa, wangkuta apqemteńi [?] Kuigpagmi mingqutnguanka pingqer'."
        },
        "86": {
            "start": 998.65,
            "end": 1001.41,
            "transcript": "Ii-i, mingqutnguangqertut. (Ii-i.)"
        },
        "87": {
            "start": 1001.41,
            "end": 1020.6,
            "transcript": "Tau͡gaam tamakut cali ava-i qanrutkellruken cauyaralegnek angyayallermeggni neqluki, I mean [?] tulimaqluki, tulimaqellriakut tua-i"
        },
        "88": {
            "start": 1021.41,
            "end": 1029.03,
            "transcript": "Tamakut pilallruit pertaraa [?] aaqevkenakun perqelallikiit elngurtun."
        },
        "89": {
            "start": 1029.03,
            "end": 1044.76,
            "transcript": "Tamakut taum qau͡gkumiut cauyaralegglainarnek [?] muragnek pililallrulriit Kuigpak-llu [?] pilallrullriit."
        },
        "90": {
            "start": 1044.76,
            "end": 1066.0,
            "transcript": "[?] tua-i angyaungermeng ayagluteng tamakut cauyaralget tau͡gaam muruit au͡gkut tuskayagartun ayuqliriluteng kelucirluteng [?] pilallrulliniut [?]."
        },
        "91": {
            "start": 1068.69,
            "end": 1078.59,
            "transcript": "Break-atartukut. Break-aqaqatar'. Quyana."
        },
        "92": {
            "start": 1280.0,
            "end": 1295.33,
            "transcript": "Yaa, atkuliaqameng-am atkupianek, atkupianek atkuliaqameng una waniwa-gguq una man'a kepumakuni akulperaa."
        },
        "93": {
            "start": 1295.33,
            "end": 1299.0,
            "transcript": "Man'a nengnarrluku [?]."
        },
        "94": {
            "start": 1299.0,
            "end": 1312.54,
            "transcript": "Akulperaa angengnaqluku tua-i manuani angengrungnaqluku una waten pillra atungnaqluku."
        },
        "95": {
            "start": 1312.54,
            "end": 1327.83,
            "transcript": "Cali-llu ukuit call' angeng' waten miktevkenaku angengnaqluku tau͡gaam uum nallii alissaallerkaa pitekluku aliiquni-ll' call' cukamek ayagluni."
        },
        "96": {
            "start": 1327.83,
            "end": 1333.0,
            "transcript": "Mikelkuni tau͡gken pissaluki tua-i nallertuq una."
        },
        "97": {
            "start": 1333.0,
            "end": 1344.92,
            "transcript": "Ukuit angengnaqluki, ukuit-llu atkuukuneng, angluki waten pamna elliullra."
        },
        "98": {
            "start": 1344.92,
            "end": 1360.77,
            "transcript": "Cali uum call' una waten piqtaanruamta. Takenruluku takluku."
        },
        "99": {
            "start": 1361.16,
            "end": 1371.44,
            "transcript": "Tuamtell' call' una wani call' manua mikellruluku pam'umi nengugtaayuilan."
        },
        "100": {
            "start": 1371.44,
            "end": 1381.0,
            "transcript": "Nanillruluku manuungan mikellruluni pam'umi."
        },
        "101": {
            "start": 1381.0,
            "end": 1386.81,
            "transcript": "Una-ll' call' tuan' nayugluku nacaliluku nacaa elliluku."
        },
        "102": {
            "start": 1386.81,
            "end": 1399.0,
            "transcript": "Nayuumanrilkuni-am waten imumek pissaagluni, maancugluni waten elliung'e'rmi mayuryugluni."
        },
        "103": {
            "start": 1399.0,
            "end": 1410.88,
            "transcript": "Ukuit-am call' tua-i angengnaqu'urluki, tamana aliryaaqellerkaa pitekluku mikelkuniu una ellegyugtuq."
        },
        "104": {
            "start": 1410.88,
            "end": 1426.73,
            "transcript": "Cali-llu ukuit, ukuit nayungnaqluki waten piluki, cali im' qaillun ayuqsugluteng pimanrilnguut mik'enqegpek'nateng."
        },
        "105": {
            "start": 1426.73,
            "end": 1433.72,
            "transcript": "Una maa-i yunruluni wall'u negiliq man'a waten piyunruluni."
        },
        "106": {
            "start": 1436.0,
            "end": 1445.66,
            "transcript": "Wangkuta tua-i piliaqamta ukui cakneq nayunrungnaqluki atkuungraata pituaput."
        },
        "107": {
            "start": 1445.66,
            "end": 1454.0,
            "transcript": "Tunuit-llu nayugpek'nateng tunuungatan nacatuat."
        },
        "108": {
            "start": 1454.0,
            "end": 1465.26,
            "transcript": "Cali alii taukut ukut kangiit nequtungnaqluku, una-am waniw' mikelngurtaunge'rmi angluni."
        },
        "109": {
            "start": 1465.26,
            "end": 1477.17,
            "transcript": "Alerqutullruitkut wangkuta irniangkumta-gguq pilikumteki angkengraitki anguvigkirluki."
        },
        "110": {
            "start": 1477.17,
            "end": 1492.06,
            "transcript": "Tua-ll' piqerluteng ak'a mikelkessaguareskatki, nequtukata alii tau͡gaam taktucaqerluki wall'u akurtucaqerluki tuaten pilartukut."
        },
        "111": {
            "start": 1495.36,
            "end": 1512.0,
            "transcript": "Atkunek piciatun atkuuyugngauq mik'leng'er'mi angeng'e'rmi, yaqulngung'e'rmi qecilek atkuuyugngaluni."
        },
        "112": {
            "start": 1513.12,
            "end": 1531.0,
            "transcript": "Waten pitullruitkut, uingkumta-gguq ikgelengraan amilgatkuutuli, yaqulngungraan atauciungraan pegtevkenaku assirluku pikilaput."
        },
        "113": {
            "start": 1531.35,
            "end": 1546.0,
            "transcript": "Atam-gguq tuaten piurqumta ilangurluni, kiituan-gguq atkuvkanrurtuq ayuqenrileng'e'rmeng tamaunge'rmeng pitullruitkut tuaten."
        },
        "114": {
            "start": 1546.0,
            "end": 1559.11,
            "transcript": "Uiput-gguq picuicaaqsartut, tamakut-gguq pitai atauciungraan iciw' egmian auluku'urluku."
        },
        "115": {
            "start": 1559.11,
            "end": 1567.65,
            "transcript": "Una-wa-gguq aipaa piculuni, nulirran pitai egmian piyuunaki."
        },
        "116": {
            "start": 1567.65,
            "end": 1576.14,
            "transcript": "Tuar-gguq una egmian picuileng'er'mi piuratulria picuilengraan uimi pitai."
        },
        "117": {
            "start": 1576.14,
            "end": 1590.0,
            "transcript": "Egmian atauciunivkenaku kepumangraan atuuyugngalria qelekluku assirluku."
        },
        "118": {
            "start": 1590.0,
            "end": 1599.0,
            "transcript": "Camun-gguq ata mikteqangraan assikluku pikumteki keviqautnguniartuq."
        },
        "119": {
            "start": 1599.0,
            "end": 1606.64,
            "transcript": "Tuaten qanrutet'ullruitkut tau͡gani wiinga nalluyaguteksaitanka tamakut."
        },
        "120": {
            "start": 1606.64,
            "end": 1616.56,
            "transcript": "Tuamtellu pinauraitkut piyugngaurallemteńi uimta pitait egmian pingnaquraasqelluki."
        },
        "121": {
            "start": 1616.56,
            "end": 1625.0,
            "transcript": "Atam-gguq pisciigalikumta pisciigalillininiartukut."
        },
        "122": {
            "start": 1625.62,
            "end": 1639.0,
            "transcript": "Qialuta-llu imucetun piyungraamta pisciiganata, tuai-wa qelluqitngaqan kemegput ilumun pisciigaliaqamta piyungraamta pisciigatetukut."
        },
        "123": {
            "start": 1639.0,
            "end": 1648.3,
            "transcript": "Tua-i ava-i au͡g'um tuaten qanrutetullruitkut wangkuta Kass'allat paivngarivailgata."
        },
        "124": {
            "start": 1648.3,
            "end": 1659.81,
            "transcript": "Tau͡gaam tamakut tamaa-i qecilget taqukat-llu massuungraata mequmanrilkata assirluki aulukesqelluki."
        },
        "125": {
            "start": 1664.22,
            "end": 1676.0,
            "transcript": "Uiput-gguq pissuyuitut tegtarkanek, ilii-gguq egpakaqata pissuryuumiiruciiquq."
        },
        "126": {
            "start": 1678.4,
            "end": 1691.0,
            "transcript": "Piner' tuarpiaq au͡gkut yuullret wangkuta pinerrluirturluta pitullrukaitkut tua-i piciuluni, piciulliniluni."
        },
        "127": {
            "start": 1691.36,
            "end": 1709.0,
            "transcript": "Una pinerrluirtuq taringenrurqerkarpeciicetun tuarpiaq college-aarluki ayagmek college tuaten pinerlluirturluki college-aarluki tuarpiaq."
        },
        "128": {
            "start": 1710.79,
            "end": 1717.34,
            "transcript": "Taum atkuum cakuciullrit apertuqerki melquit cangellrit?"
        },
        "129": {
            "start": 1717.34,
            "end": 1730.45,
            "transcript": "Waniw' un' imarmiutauguq imarmiutaq man'a-wa au͡gna ava-i piluguk melqurricaraq man'a qatellria."
        },
        "130": {
            "start": 1730.45,
            "end": 1738.4,
            "transcript": "Pukiuguq-qaa pukiuluni Kass'at caliallrat man'a."
        },
        "131": {
            "start": 1738.4,
            "end": 1750.14,
            "transcript": "Makut-wa yuum caliallri man'a-w' cali cuignilnguuvkenani otter-auluni man'a imarpiim cuignilngua."
        },
        "132": {
            "start": 1751.87,
            "end": 1760.96,
            "transcript": "Man'a. Yugcetun atlek arrnamek. Arrnak, arrnak man'a."
        },
        "133": {
            "start": 1760.96,
            "end": 1774.28,
            "transcript": "Cuignilngurtun ayuqsarpiarluni melqurra imarpiim tau͡gken pikluku cuignilngua imarpiim arrnak."
        },
        "134": {
            "start": 1774.28,
            "end": 1782.71,
            "transcript": "Ca tamalkuan iqucaraungami iquciimanrilkuni qaill' piliyung'e'rmi."
        },
        "135": {
            "start": 1782.71,
            "end": 1796.09,
            "transcript": "Makuungraata-llu alinun pikaiturlurqameng alinun qaraliqtullruit makuit wall'u akuitnun makuungrata."
        },
        "136": {
            "start": 1799.96,
            "end": 1815.28,
            "transcript": "Imarmiutaungraata pikaiturlulriani wangkuta angayuqamta tuaten pilitullruitkut cukanraraluteng ayayuitellratni."
        },
        "137": {
            "start": 1815.28,
            "end": 1826.93,
            "transcript": "Man'a-wa negilia terikaniaq ilaita qavcignek pituit, wii ellangellemni terikanianek pitullruit."
        },
        "138": {
            "start": 1826.93,
            "end": 1842.62,
            "transcript": "Tua-i-llu nunalinqigcama qavcignek makut pituluki terikaniaq man'a, man'a-wa ava-i paluqtaq man'a au͡g'um aqsii."
        },
        "139": {
            "start": 1842.62,
            "end": 1848.89,
            "transcript": "Aqsakaa man' paluqtam, man'a-wa kegluneq."
        },
        "140": {
            "start": 1848.89,
            "end": 1864.7,
            "transcript": "Ukuk-wa cali alngak kapusngallrak taqukarraq una, taqukauluni, au͡gna ava-i useqnaunrilkuni nayiuluni una."
        },
        "141": {
            "start": 1865.0,
            "end": 1881.01,
            "transcript": "Uum petugvia, tau͡gken alngalget atkut waten alngiqunegteki makucirrarnek, alngatlukaa puuyuterluteng makucirrarnek."
        },
        "142": {
            "start": 1881.01,
            "end": 1884.87,
            "transcript": "Pukinek. Pukirnek."
        },
        "143": {
            "start": 1884.87,
            "end": 1894.32,
            "transcript": "Alngat ingkut alngat maani, makurrarnek uitavigluteng."
        },
        "144": {
            "start": 1894.34,
            "end": 1901.87,
            "transcript": "Waten allakarmeng agalriit makunek maa-i tusngallerluteng."
        },
        "145": {
            "start": 1901.87,
            "end": 1911.79,
            "transcript": "Tau͡gken waten tegglit makut, taqukarrarnek kapusngallerluteng."
        },
        "146": {
            "start": 1911.79,
            "end": 1933.06,
            "transcript": "Waniwa-gguq ukuk manumiik, tayima-w' atkuukuni qukaani, manumigmek piaqeka ukua manumigmek piluku pamkuk-wa cali una-wa-gguq kakauyaq."
        },
        "147": {
            "start": 1933.06,
            "end": 1940.13,
            "transcript": "Tua-i maa-i makut maa-i taqukarrarnek kapusngallerluteng."
        },
        "148": {
            "start": 1941.69,
            "end": 1949.24,
            "transcript": "Au͡gkucim melqurrai ikeglicaaqerluku."
        },
        "149": {
            "start": 1949.24,
            "end": 1959.31,
            "transcript": "Wangkuta cali tua-i pikailngurni piqcarlu' pingnatugluteng pitutullruut."
        },
        "150": {
            "start": 1964.06,
            "end": 1977.79,
            "transcript": "Atkuut-llu cali elitengnaqevkarluki tua-i ava-i qanrutkellrukeka, uingkumta cai keggatnivkenaku, atauciunivkenaku qelkuraasqelluku."
        },
        "151": {
            "start": 1977.79,
            "end": 1992.65,
            "transcript": "Tuamtell tua-i atkulikumta, ukut waniwa pingegnairluki pisqelluki pamkut-llu waten elliullrat."
        },
        "152": {
            "start": 1992.65,
            "end": 2006.03,
            "transcript": "Ali'irtequni cukangnaqluni imarnicetun, patakarluni alingnaq, qaringaunani wani egmian ali'irtarkauluni."
        },
        "153": {
            "start": 2006.03,
            "end": 2017.0,
            "transcript": "Imarnicetun au͡g'utun, kangyaa una wani nequtungnaqluku, angutet pii..."
        }
    },
    "989WUAw4Ve0": {
        "1": {
            "start": 107.96,
            "end": 115.98,
            "transcript": "Mikelnguut akusraruteqeryularait elitnaurumalata niisngalaasqelluki."
        },
        "2": {
            "start": 115.98,
            "end": 123.46,
            "transcript": "Tua-i-llu mikelnguq ak'anun akusrarutekungallrung'e'rmi qanerngaunani."
        },
        "3": {
            "start": 123.46,
            "end": 129.74,
            "transcript": "Tuatenamallret assinrituq qanrutkumayungaluni-llu."
        },
        "4": {
            "start": 129.74,
            "end": 133.42,
            "transcript": "Arcaqerluku pistii angayuqaukan."
        },
        "5": {
            "start": 133.42,
            "end": 141.66,
            "transcript": "Angayuqerrulriim ukvercecugngaa mikelnguq canritniluku akusrarutekumallra."
        },
        "6": {
            "start": 141.66,
            "end": 146.38,
            "transcript": "Taumek qanyuilnguut alingqeryulaameng."
        },
        "7": {
            "start": 156.12,
            "end": 160.86,
            "transcript": "Mikelnguut akusrarutekumalartut pinialameng."
        },
        "8": {
            "start": 160.86,
            "end": 169.6,
            "transcript": "Taqneret ukveq'larait qanrucestekngamegteki. Taqnerem-llu tua-i akusrarutekekagu mikelnguq."
        },
        "9": {
            "start": 169.6,
            "end": 177.68,
            "transcript": "Qanrulluku-llu watqapiar kina qanrucaqunaku mikelnguum niiciiqaa."
        },
        "10": {
            "start": 177.68,
            "end": 184.88,
            "transcript": "Kina-llu qanrusngaunaku aassaqurallerkaa tau͡gaam arcaqakluku."
        },
        "11": {
            "start": 184.88,
            "end": 192.9,
            "transcript": "Umyuarteqellemni yuk aipailkuni allamun cauciquq maligtaqucugngalriamun."
        },
        "12": {
            "start": 192.9,
            "end": 201.28,
            "transcript": "Mikelngurmek-llu akusrarutekilleq qacignarqenruuq taqnermi."
        },
        "13": {
            "start": 201.28,
            "end": 210.34,
            "transcript": "Allrakuni pellullerni wangkuta Alaska-rmiuni aptenglartukut assirtacianek yuullemta, tau͡gaam allani apyutni arcaqanrulria uunguuq."
        },
        "14": {
            "start": 210.34,
            "end": 214.12,
            "transcript": "Ciin irniaput agkengumavtelarceta?"
        },
        "15": {
            "start": 214.12,
            "end": 224.46,
            "transcript": "Atam au͡gna apyun umyuangcaarautekqerru, wangkuta maani umyualinqigtenrilkumta mikelnguut agkengumalallratnek, wall' akusrarutekumalallrat."
        },
        "16": {
            "start": 224.46,
            "end": 230.4,
            "transcript": "Atauciq nasaurluq cetamanek, akusrarutekumaciquq eighteen-aarpailegmi."
        },
        "17": {
            "start": 230.42,
            "end": 242.02,
            "transcript": "Ava-i au͡gkut naaqutait atauciq cetamanek nasaurlurnek, atauciq-llu tan'gaurluq tallimanek akusrarutekumaciquq taqupailegmi high school-amek."
        },
        "18": {
            "start": 243.14,
            "end": 259.3,
            "transcript": "Assinrituq man'a mikelngurnun pisteńi amllermi nallunrit'laagu ayuqluku angani, amaqlini wall' kinguqlini, paistii, elitnauristii, agayulirtii, wall' angayuqurra."
        },
        "19": {
            "start": 259.3,
            "end": 268.3,
            "transcript": "Anchorage-aami iliit cat cat ayuqutkellruat man'a arenqiallugutvut qagercetaamun utaqauralria qagglerkaminek."
        },
        "20": {
            "start": 268.98,
            "end": 277.58,
            "transcript": "Calilriit nunameggni wall' state-amun elpekngaat man'a arenqiallugun caliaqluku-llu caliaqumaarkauciacetun."
        },
        "21": {
            "start": 277.58,
            "end": 285.84,
            "transcript": "Nutaranek alerquutengellruut Alaska-mi ilakluku yuum alla akusraruciyukekuniu qanrutkellerkaa."
        },
        "22": {
            "start": 285.84,
            "end": 295.36,
            "transcript": "Cali anucimirqecetaarutai akusrarucillrem ilamaluni elitnaurutkaqluku tuaten elpengcaarluki mikelnguut mat'umek."
        },
        "23": {
            "start": 295.36,
            "end": 302.1,
            "transcript": "Tau͡gaam umyuarniurutkengengraatgu ellarpamteńi, state-amteńi, nunacuarni-llu."
        },
        "24": {
            "start": 302.1,
            "end": 312.22,
            "transcript": "Akusrarucilallratni elitnaulartuq yuullemteńi United States-aami Alaska-mi cali kuigpiim Kusquqviim-llu avategkeggni."
        },
        "25": {
            "start": 315.0,
            "end": 326.98,
            "transcript": "Trooper-aat iliit Susan Bell-aq calillrurtuq Mamterillermi cetamani allrakuni, caliaran akusrarutekumallernek ayautelaraa akimairnun nunacuarnun."
        },
        "26": {
            "start": 329.28,
            "end": 337.42,
            "transcript": "Police-ani caliyaurqaanemnek qulngurtuut allrakut niicuitellruluta-llu mikelngurnek akusrarutekilrianek."
        },
        "27": {
            "start": 337.42,
            "end": 346.56,
            "transcript": "Kia qanruciiqellruakut wangkuta-llu niicuitellruluta ilakutngermeng akusrarutekilrianek. tuaten pilauciat nallullruaput."
        },
        "28": {
            "start": 349.0,
            "end": 361.84,
            "transcript": "Maa-i-rpak tau͡gaam mikelngurnek akusrarutekilriit amllerilliniut state-amteńi cellarpamcetun mikelnguut akusrarutekellrit maa-i anenglliniut alaitengluteng."
        },
        "29": {
            "start": 362.0,
            "end": 369.78,
            "transcript": "Amllenrem nallunriraa yuum-llu assiilucia nallunrirluku iterciyaurciameng-llu."
        },
        "30": {
            "start": 369.78,
            "end": 375.14,
            "transcript": "Nallunrirngameng tuaten pilauciatnek amllerem qanruteksaurtua."
        },
        "31": {
            "start": 375.14,
            "end": 383.8,
            "transcript": "Mamterillermi pingayurqunek amllerikanillrulliniuq man'a mikelnguum akusrarutii 1981-aarraanranek."
        },
        "32": {
            "start": 384.0,
            "end": 396.14,
            "transcript": "Yuum tau͡gaam maa-i-rpak qanruteksugngaa uum tungiinun Division of Family and Youth Services wall'u trooper-aanun, wall'u-qaa city police-anun."
        },
        "33": {
            "start": 397.0,
            "end": 408.96,
            "transcript": "Iliit cali uitatunrulaqiit asian uunguuq. Alaska-m piurtellra alerquun qanelria yuk kituungermi kamakikuni qanrutkarkaullra."
        },
        "34": {
            "start": 408.96,
            "end": 415.06,
            "transcript": "Yuut Alaska-mi qanrutkiarkat mikelnguq akusrarutekumallrukan ukuugut."
        },
        "35": {
            "start": 415.06,
            "end": 424.26,
            "transcript": "Yungcaristet, health aide-at, iinriurtet, elitnauristet, elitnaurviit atanrit, elitnaurvigni calistet."
        },
        "36": {
            "start": 424.26,
            "end": 438.46,
            "transcript": "Ikayurtet, tegustet, nayurtet itercivigni, calilriit state-am calivini, erenrani paigestet day care-ani, cali allam yuinek anglicarilriit wall' aulukilriit."
        },
        "37": {
            "start": 438.62,
            "end": 446.92,
            "transcript": "Ukut yuut pinarqut'liumayugngaut qanrutkenrilkatki nallunrilketeng mikelnguut akusrarucimalriit."
        },
        "38": {
            "start": 446.92,
            "end": 462.42,
            "transcript": "Calisteńguluni kamakumalrianek, Kuigpiim Kusquqviim-ll' avategkeggni Mamterillermi anangnaquucista Bryan Schuler-aam tangenrungata elpenguciat elitellrit-llu qanrutkillerkaq alerquun aturluku."
        },
        "39": {
            "start": 465.08,
            "end": 471.22,
            "transcript": "Agkengumalrianek qanrutkelallrit akusrarutekilalriit amllerivkanritait."
        },
        "40": {
            "start": 471.22,
            "end": 482.96,
            "transcript": "Tau͡gaam assinruuq maa-i qanrucilallrit, health aide-at, yungcaristet, social worker-at, ilakellriit, nunacuarni-llu tegustait."
        },
        "41": {
            "start": 482.96,
            "end": 490.26,
            "transcript": "Yuut elpekngaat akusrarucilria. Narugcilriaruuq uitacimangaunani-llu."
        },
        "42": {
            "start": 490.26,
            "end": 495.58,
            "transcript": "Unakumarirraarluki qanellrit, kangiitullrit cukanrulartut."
        },
        "43": {
            "start": 495.58,
            "end": 502.74,
            "transcript": "Ayuqestassiigutekluku Yuut apqaularait suuliluki."
        },
        "44": {
            "start": 502.74,
            "end": 510.7,
            "transcript": "Atullrit irniaruat ikayularaitkut. Malkanirluki Yupiit mikelnguit qitevtessiyaayuilnguut."
        },
        "45": {
            "start": 510.7,
            "end": 517.3,
            "transcript": "Cukanrulartuq mikelnguq nasvagyugngaaqatki qaillun piqapiaraumalteng."
        },
        "46": {
            "start": 517.3,
            "end": 524.3,
            "transcript": "Ukaqvaggun tau͡gaam cat cimingellruut, allrakuni pellullerni nutaranek kangiituriyaranek ayagnillruut."
        },
        "47": {
            "start": 524.3,
            "end": 530.34,
            "transcript": "Apqaurillrit kitugtellruit cingumanruarkauluki agkengumallret pistaitni."
        },
        "48": {
            "start": 530.34,
            "end": 535.94,
            "transcript": "Atullrit makunek irniaruanek ikayularait mikelnguut apervikuallratni."
        },
        "49": {
            "start": 535.94,
            "end": 544.26,
            "transcript": "Cali ikayularait tegustet qanercetaarviit-llu kangiitullratki mikelnguum qaillun piqapiaraumallranek."
        },
        "50": {
            "start": 544.26,
            "end": 558.42,
            "transcript": "Ukut wani irniaruut aturlaranka iciw' mikelnguaraat iliini qallatecuaralartut, iliini-llu qanemcilteng takliriinarlartuq."
        },
        "51": {
            "start": 558.42,
            "end": 564.72,
            "transcript": "Tau͡gaam ukut atuqumku mikelnguaraat qanrut'laranka, ukut wii pikniluki."
        },
        "52": {
            "start": 564.72,
            "end": 575.16,
            "transcript": "Tau͡gaam ukut irniaruat qanruciiqaatnga, ikayurciqaatnga tauna mikelnguar."
        },
        "53": {
            "start": 575.16,
            "end": 586.54,
            "transcript": "Iciw' qanemcinauraanga, kia yuum pillrukagu, agtullrukagu qaillun-llu, qaillun-llu pillrucianun taum yuum pistiin."
        },
        "54": {
            "start": 586.54,
            "end": 595.34,
            "transcript": "Tua-ll' mikelnguaraam mikelnguq apciiqaqa iciw' tem'im, yuum tem'im, cai cat unatait uqsuit it'gait."
        },
        "55": {
            "start": 595.34,
            "end": 600.22,
            "transcript": "Tua-ll' ellii iliini matarqiyagaciqam una irniaruaq."
        },
        "56": {
            "start": 600.22,
            "end": 605.86,
            "transcript": "Tua-ll' apciiqaqa kituucia una irniaq, una irniaruaq."
        },
        "57": {
            "start": 605.86,
            "end": 617.06,
            "transcript": "Tua-ll' yuum, tua-ll' taum yucuayaagam piciqaanga tauna pistiin, iciw' pistiin aperturciqai kia agtullrukagu."
        },
        "58": {
            "start": 617.06,
            "end": 627.82,
            "transcript": "Tua-ll' wii apciiqaqa, qaill' pillruaten? Tua-ll' iliini, tua-i matarrluku, iliini matarqiyiganauraat una irniaruaq."
        },
        "59": {
            "start": 627.82,
            "end": 631.94,
            "transcript": "Una-llu angun irniaruaq matarciiqaanga."
        },
        "60": {
            "start": 631.94,
            "end": 640.34,
            "transcript": "Tua-ll' qainganun elliciqaa, wall' nangengqaurluni piciqaa, wall' una, angun aciani uitamaluni."
        },
        "61": {
            "start": 640.34,
            "end": 646.86,
            "transcript": "Tua-ll' taum una yuk asriutekestiin qaill' piciqaa."
        },
        "62": {
            "start": 646.86,
            "end": 653.4,
            "transcript": "Tua-i-ll' qaill' piqapiarallra qanrutekciqaa."
        },
        "63": {
            "start": 655.46,
            "end": 662.64,
            "transcript": "Iliini-llu waten, video camera-kun atungnaqlartukuk, tau͡gaam iliini piitelartukuk."
        },
        "64": {
            "start": 662.64,
            "end": 672.54,
            "transcript": "Makut recorder-aakun pikumku recorder-ami recorder-aq qanruciiqaqa waten."
        },
        "65": {
            "start": 672.54,
            "end": 679.86,
            "transcript": "Una yuk arnam, arnaq inangqaurluni waten pilinuni, qerrullicuaraat atrarcimaluni."
        },
        "66": {
            "start": 679.86,
            "end": 687.34,
            "transcript": "Tua-ll' una-ll' angun irniaruaq, aturai, iciw' qerrulliik atrarcimaluteng."
        },
        "67": {
            "start": 688.3,
            "end": 694.74,
            "transcript": "Tua-ll' qaill' piqapiarallni, inangqaurallni qanruciiqaqa record-aamun."
        },
        "68": {
            "start": 694.74,
            "end": 710.38,
            "transcript": "Tua-ll' taqluta una maavet taiskumteggu, Mamterillermun taiskumteggu, wangkuk mumigtenrilkumteggu state trooper-at iliit mumigciiqaat, mumigcistengqerrluteng-llu."
        },
        "69": {
            "start": 710.38,
            "end": 718.2,
            "transcript": "Tauna mumiggluku tua-ll' district attorney-mun tunciqaat, tua-ll' taum yuum niicugniqagu."
        },
        "70": {
            "start": 718.2,
            "end": 732.26,
            "transcript": "Wall' naaqikagu, qaill' apqaullrenka pikatgu ellii tua-ll' tauna yuk caqatallni piniaraa, caqataqapiarallni."
        },
        "71": {
            "start": 732.26,
            "end": 745.4,
            "transcript": "Iciw' iliini itertelaraat egmian, wall' iliini uitavkarluku, iciw' eighteen-aqsailnguut ilait iterceciigataa tamaa-i."
        },
        "72": {
            "start": 745.4,
            "end": 751.16,
            "transcript": "Uumikuani pikuni tau͡gaam itercugngaat."
        },
        "73": {
            "start": 751.16,
            "end": 760.52,
            "transcript": "Maa-i waten iciw' asriutekegcimallrit itercivigmun pilarait."
        },
        "74": {
            "start": 760.52,
            "end": 767.94,
            "transcript": "Tau͡gaam itercirvigmun uitaciitaat, tua-i uitaqapirluku uitaceciitaat."
        },
        "75": {
            "start": 767.94,
            "end": 774.48,
            "transcript": "Iciw' ikayurcetaarluteng pituit maa-i iciw'."
        },
        "76": {
            "start": 774.48,
            "end": 793.04,
            "transcript": "Yuum-qaa allauteksailkagu callni mikellrani qanruteksailkagu kitumun yuum asriutekegcimallrani anglikuni ataam ellii tauna yuk piciqai iciw'-qaa qallautellrulrianga ava-i tua-i."
        },
        "77": {
            "start": 793.04,
            "end": 800.26,
            "transcript": "Tamana-qaa allauteksailkagu elluarrluni uitangaituq mikelngurnun cauyugciquq."
        },
        "78": {
            "start": 801.46,
            "end": 816.4,
            "transcript": "Im' high school-ami-llu uitangraan tauna mikelnguarnek piciquq ikayurcetaanrilkuni, iciw' qanruteksailkagu."
        },
        "79": {
            "start": 818.84,
            "end": 827.68,
            "transcript": "Cimillrit apqauriyarait qanecetaarvigmi calilriit caliarit qacignariqercetait tau͡gaam tuaten ayuqellrunrituq."
        },
        "80": {
            "start": 827.68,
            "end": 835.86,
            "transcript": "Allrakuni kitullerni qanercetaarvigni calilriit cukaingqallruut pinarqutillerkaitnek tamakumalriit."
        },
        "81": {
            "start": 838.5,
            "end": 849.34,
            "transcript": "Arenqiallugutngullruuq kemyukillerkaq, qanercetaarviit apcimalallruut cucukliisqelluki ukverumallerkaa mikelnguum wall' pistellran."
        },
        "82": {
            "start": 849.34,
            "end": 855.96,
            "transcript": "Tau͡gaam apqaurilallrit assiriata taringeng'arput kemyukillerkaq piunrilucianek."
        },
        "83": {
            "start": 855.96,
            "end": 861.42,
            "transcript": "Mikelnguut iqluquteksuitait akusrarutekumalteng."
        },
        "84": {
            "start": 864.34,
            "end": 874.06,
            "transcript": "Elisngalriit qanrut'laraitkut mikcuaraat iqluqusciigat'larniluki akusrarutekumallrukuneng."
        },
        "85": {
            "start": 874.06,
            "end": 883.7,
            "transcript": "Ciumek, ayagyuassiyaagata nalluluteng qaill' qanllerkameggnek qanruciikuneng."
        },
        "86": {
            "start": 883.7,
            "end": 891.96,
            "transcript": "Nalluut akusrarutekiyaram ayuqucia, tau͡gaam tuaten pimallrukuneng."
        },
        "87": {
            "start": 891.96,
            "end": 906.7,
            "transcript": "Tunglia, mikngameng tuknilrianek iqluqusciigatut tegustemun wall' allamun umyuarteqeksaunateng-llu tuaten iqluqunaluteng."
        },
        "88": {
            "start": 906.7,
            "end": 917.8,
            "transcript": "Mikelnguaraat qanruskaten waten yuum agtullruniluku qurrsuutiyagamikun ukverarkaugapuk."
        },
        "89": {
            "start": 917.8,
            "end": 933.7,
            "transcript": "Tauna mikelnguaq iqlusciigatuq qanrusngaitaaten qaill' taum ellii yuk, ellii yucuayaaq yugpallermun-llu qaill' pillrinek iqlungaituq."
        },
        "90": {
            "start": 933.7,
            "end": 947.08,
            "transcript": "Apertullni yuum, yuum apertullni mikelnguarmun-llu tamakut ilait apertullni mikelnguaram elitesciigataa angayuqaminek."
        },
        "91": {
            "start": 947.08,
            "end": 954.64,
            "transcript": "Iciw' waten angayuqaulriani waten qanrucuitapuk irniaput."
        },
        "92": {
            "start": 954.64,
            "end": 961.7,
            "transcript": "Aatan-llu, aatan wiinga-llu aipaqellruukuk waten irniaput piyuitapuk."
        },
        "93": {
            "start": 961.7,
            "end": 971.04,
            "transcript": "Tauna yucuar allamek tau͡gaam yugmun eliciiquq tauna yuk asriutekellrukagu."
        },
        "94": {
            "start": 971.04,
            "end": 983.7,
            "transcript": "Mikelnguaq iqlusciigatuq tuaten, tuaten iciw' asriutekellrukuni qaill'-llu ayuqucia qaill' callni iqluqutekesciigataa."
        },
        "95": {
            "start": 983.7,
            "end": 994.84,
            "transcript": "Apertullni aperciryarai nallui, yuum pillrukagu tau͡gaam, qanrutkellrukagu tau͡gaam."
        },
        "96": {
            "start": 994.84,
            "end": 1003.7,
            "transcript": "Tau͡gaam maa-i nalkucuartukut iciw' mikelnguaraat qallaucaurtagu, wangkut-ll' ukveksaurrluki."
        },
        "97": {
            "start": 1003.7,
            "end": 1010.0,
            "transcript": "Tauna mikelnguaram qanruski, uum ataatama waten pikiinga."
        },
        "98": {
            "start": 1010.0,
            "end": 1018.7,
            "transcript": "Waten ca maaggun qurrsuutiyagamkun agtuqiinga, wiinga-llu agturceskiinga ellii pia."
        },
        "99": {
            "start": 1018.7,
            "end": 1024.7,
            "transcript": "Tuaten atam maa-i ukveryaurtapuk mikelnguaraat iqluyuilata."
        },
        "100": {
            "start": 1024.7,
            "end": 1032.38,
            "transcript": "Atullrat irniaruanek, suunek, allanek-llu apqaurillrit ikayularait qanercetaarviit caliaritni."
        },
        "101": {
            "start": 1032.38,
            "end": 1039.7,
            "transcript": "Tau͡gaam qanercetaarviit Alaska-mi kiimetenritut ingluliullratgu mikelnguut akusrarutekumallrat."
        },
        "102": {
            "start": 1039.7,
            "end": 1049.98,
            "transcript": "Ingluliurtait ilangqertuq Clara Kelly-mek arulacestii Southwestern Alaska Council for Prevention of Child Sexual abuse-am calivian."
        },
        "103": {
            "start": 1049.98,
            "end": 1054.7,
            "transcript": "Mikelnguut elitellerkait umyuarniurutain ilakaat."
        },
        "104": {
            "start": 1054.7,
            "end": 1062.02,
            "transcript": "Taringevkangnaq'larai mikelnguut ayuqenriluciagnek assirluni assiinani-llu agtuumanrek."
        },
        "105": {
            "start": 1062.02,
            "end": 1070.7,
            "transcript": "Pilarait canritniluki qanllerkait assiinateng agtuumallrukata iiqumcuarauteknarqenritniluku-llu."
        },
        "106": {
            "start": 1070.7,
            "end": 1078.7,
            "transcript": "Cali Clara Kelly ikayurilartuq piciurrluki iqluqumallrit, allat-llu qannguat yuut ukveqtukait."
        },
        "107": {
            "start": 1078.7,
            "end": 1085.88,
            "transcript": "Ilait taqneret wani umyuarteqlartut wani mikelngurmek agtuq'ngellra akusraruciq'ngelleq-llu cangatenricukluku."
        },
        "108": {
            "start": 1085.88,
            "end": 1092.7,
            "transcript": "Tau͡gaam cangatuuq assinrituq iciw', assilriamek calinrituut mikelnguarnek tuaten agturayulriit."
        },
        "109": {
            "start": 1092.7,
            "end": 1103.7,
            "transcript": "Iliit qannguat wall' piciunrilnguut niicimalalria piuq mikelnguut angliaqameng nalluyagutestuniluku akusrarutekumalteng."
        },
        "110": {
            "start": 1103.7,
            "end": 1112.14,
            "transcript": "Mikelnguaraat waten iciw' akusrarutekescillret wall'u-qaa kia imum agturallrit tuaten iciw' mikelnguaraat temirteńgunritut."
        },
        "111": {
            "start": 1112.14,
            "end": 1117.78,
            "transcript": "Kemyagait-llu makut wani pinariksaunateng, umyuayagait-llu makut pinariksaunateng."
        },
        "112": {
            "start": 1117.78,
            "end": 1126.58,
            "transcript": "Tau͡gaam ilait umyuarteqlartut mikuuq una mikelnguaq canrituq agturaramni akngirrngaituq anglikuni-ll' nalluyaguciiqaa."
        },
        "113": {
            "start": 1126.58,
            "end": 1136.92,
            "transcript": "Tau͡gaam tamana piciunrituq qaillun mitaangarmi mikelnguar wani nalluyagucuitelliniuq, umyugayagaa-llu assiriyunani ikayurcirraarpailegmi."
        },
        "114": {
            "start": 1138.1,
            "end": 1151.94,
            "transcript": "Tamarmeng mikelnguut ayuqsuitut ayuquciit akusrarutekumallruaqameng ayuqenritut allrakuit qaillun akusrarutekumallrat ilakuciat-llu mikelnguq pistellra-llu."
        },
        "115": {
            "start": 1151.94,
            "end": 1158.46,
            "transcript": "Tamarmeng au͡gkut ikayuutngulartut paqtaqatki mikelnguum tem'i umyuara-llu."
        },
        "116": {
            "start": 1158.46,
            "end": 1167.56,
            "transcript": "Tau͡gaam nallunaituq ak'anun akusrarutekumalleq mamyuilngurtun ayuqlituuq Anchorage-aami qalarucista Pamela Kirk."
        },
        "117": {
            "start": 1167.56,
            "end": 1177.94,
            "transcript": "Iqakelartut ellmeggnek atuumallertun, umyuarteq'lartut nunamun ellimallruyukluteng agumallerkarteng kiingan pitekluku."
        },
        "118": {
            "start": 1177.94,
            "end": 1187.04,
            "transcript": "Ellmeggnek catkevkenateng, assikevkenateng, tangniilkelluteng, cali uqumcaraqluteng, tangniqsuumiinateng."
        },
        "119": {
            "start": 1187.04,
            "end": 1198.24,
            "transcript": "Ilait aanaunguangelartut aulukaqluki mikelnguut mikelngurngatevkenateng tua-i aanayagartun ayuqaqluteng."
        },
        "120": {
            "start": 1198.24,
            "end": 1210.62,
            "transcript": "Sagmalarait mikelnguucirteng, teglegumalriatun ayuqluni mikelnguucia cali murilketaitarkauyaaqellra allatun mikelngurtun."
        },
        "121": {
            "start": 1210.62,
            "end": 1224.44,
            "transcript": "Qacignarqenrituq ataam utertevkangnaqellra mikelnguullranun, man'a piciuguq mikelngurnun taqnecuartun ayuqellernun five-aarraanermeggnek."
        },
        "122": {
            "start": 1224.44,
            "end": 1234.68,
            "transcript": "Tau͡gaam amllermi umyuakun aknirtelleq mamngailngat'lartut caunrilkellra-llu tekilluni taqnerurtellranun."
        },
        "123": {
            "start": 1236.52,
            "end": 1245.32,
            "transcript": "Atqa Leanne-auguq. Allrakungqertua yuinaq qula qulngunrita'arnek cipluku."
        },
        "124": {
            "start": 1245.32,
            "end": 1257.66,
            "transcript": "Wii akusrarutekumalqa ayagnillruuq six-aallemni, nallunritlemni, tekilluku akimiarunrita'arnek allrakungqelqa."
        },
        "125": {
            "start": 1257.66,
            "end": 1264.92,
            "transcript": "Kiimi aanama uingan pivkenii, tau͡gaam aangkama-llu."
        },
        "126": {
            "start": 1264.92,
            "end": 1271.2,
            "transcript": "Uika nallunrituq qavcin friend-anka qanrutellruanka."
        },
        "127": {
            "start": 1271.2,
            "end": 1281.66,
            "transcript": "Qanrutnaluki-llu brother-aanka umyuarteqellruunga, tau͡gaam qanruteksaitanka upinganrilama."
        },
        "128": {
            "start": 1281.66,
            "end": 1293.92,
            "transcript": "Mecirauteklerkaanek-llu, wall' iqluquniciiqaatnga taringenrilquneng qaill' piqapiallra."
        },
        "129": {
            "start": 1293.92,
            "end": 1299.14,
            "transcript": "Tuar wii iqluqumalleq cakneq."
        },
        "130": {
            "start": 1299.14,
            "end": 1308.62,
            "transcript": "Amllerni allrakuni taumun angutmun atanirciurumalrianga."
        },
        "131": {
            "start": 1308.62,
            "end": 1314.66,
            "transcript": "Tamana malikellruaqa kassuucimallemnun."
        },
        "132": {
            "start": 1314.66,
            "end": 1321.22,
            "transcript": "Allrakuni cali maa-i assilisciigat'lartua uimnek."
        },
        "133": {
            "start": 1321.22,
            "end": 1329.54,
            "transcript": "Ilagaarlaranka allat arnat wangtun pimallret qalarutekesciigataqluku-llu tau͡gaam."
        },
        "134": {
            "start": 1329.54,
            "end": 1338.1,
            "transcript": "Assiilkaqa waten ayuqevkaanga camek uqamailkutkaileng'e'rma."
        },
        "135": {
            "start": 1338.1,
            "end": 1345.42,
            "transcript": "Elliin iqluqullruanga arvinlegnek allrakungqellemni."
        },
        "136": {
            "start": 1345.76,
            "end": 1356.82,
            "transcript": "Umyuarteqleq mikelnguut aknircimayuicukluki wall' assirinayukluki akusrarutekumavkarraarluki piciunritut amllenritnun mikelngurnun."
        },
        "137": {
            "start": 1356.82,
            "end": 1365.26,
            "transcript": "Tangllemcetun-llu kingukuunrakun agtuumallran mikelnguum assiicugngaut ak'anun-llu uitayugngaluni."
        },
        "138": {
            "start": 1365.26,
            "end": 1371.86,
            "transcript": "Cakneq assiilliqsugngauq kemyuksaaqellra piciunrilkan pistellni ilakekuniu."
        },
        "139": {
            "start": 1373.8,
            "end": 1382.34,
            "transcript": "Canrituq qanlleq mikelnguut akusrarutekumallruniluki, allanerteggun tuavet tekitellruukut."
        },
        "140": {
            "start": 1382.34,
            "end": 1394.22,
            "transcript": "Tau͡gaam canritenrituq qanlleq amllerugaat akusrarutekumalriit ilakelartut umyuamegteggun pistelteng-llu."
        },
        "141": {
            "start": 1395.48,
            "end": 1405.18,
            "transcript": "Yuuciuniuryuumiitelarait mikelnguut akusrarutek'larniluki nallunrilkengaita kenkekngait-llu."
        },
        "142": {
            "start": 1411.78,
            "end": 1424.84,
            "transcript": "Tamatum navgularaa kemyukellrat kegguciurtet yungcaristet elitnaurista elaqlit angait-llu imkut kemyukqapiaratukvut."
        },
        "143": {
            "start": 1424.84,
            "end": 1430.72,
            "transcript": "Tamatum-llu tungiinun aptellria apyutkaa assirtacia yuullemta."
        },
        "144": {
            "start": 1432.22,
            "end": 1437.68,
            "transcript": "Umyuarteq'lallran piunriumallra kiimi mikelngurmi piunrituq."
        },
        "145": {
            "start": 1440.52,
            "end": 1448.72,
            "transcript": "Malrugnek ayuqenrilnguugnek nallunairucetaangqertuq mikelnguq akusrarutekumakuni."
        },
        "146": {
            "start": 1448.72,
            "end": 1457.96,
            "transcript": "Ciuqlia, temem nallunairutai. Arcaqanra-llu mikelnguum ayuqucia cimiqan."
        },
        "147": {
            "start": 1457.96,
            "end": 1467.52,
            "transcript": "Mikelnguq ellanqelarraarluni uitaurayunqeggikan aipaagni akusrarutekumallran pivkaraa."
        },
        "148": {
            "start": 1467.52,
            "end": 1478.22,
            "transcript": "Wall'u mikelnguq nepaitelarraarluni anagutengkan cali tauna qaillukuarucimallruyugnarquq."
        },
        "149": {
            "start": 1478.22,
            "end": 1489.34,
            "transcript": "Temem nallunairutai alaiterpatuut au͡gllirluteng wall'u uqlarluteng aklut inglernun qurrsugiluni."
        },
        "150": {
            "start": 1489.76,
            "end": 1504.64,
            "transcript": "Qiayugturluni, qiyunerluni, ucaa nunii pivluni, wall'u kanaggun apqucingluni mikelnguum naulluutekenrilkiinek VD-nek."
        },
        "151": {
            "start": 1504.64,
            "end": 1513.6,
            "transcript": "Yuut amlleriinarluteng elpekengraatgu allat qanngualallrit akusrarutekumalrianek ukveqenrirait."
        },
        "152": {
            "start": 1513.6,
            "end": 1519.58,
            "transcript": "Amllerni allrakuni ukvetullruut akusrarucitulit nallunaitelaryukluki."
        },
        "153": {
            "start": 1523.08,
            "end": 1533.18,
            "transcript": "Akaarnun Kass'at qulirangqellruut ilakeng'ermeng akusrarucilarniluki nunacuarni ayuqluteng Appalachia-mi."
        },
        "154": {
            "start": 1533.18,
            "end": 1545.22,
            "transcript": "Yuut pivakarluteng ukvengellruut man'a piciunritniluku, quliraqainauniluku, man'a piciuyaaquq, tau͡gaam tuaten ayuqenrituq."
        },
        "155": {
            "start": 1545.22,
            "end": 1552.42,
            "transcript": "Waten pitulit yuut ayuqengssaaranritut. Tamaita tangrrumariaput."
        },
        "156": {
            "start": 1552.42,
            "end": 1564.54,
            "transcript": "Itercillrurtukut agayulirteńek ayuqenrilngurnek cakegtaunrilngurnek yugnek pinarqellrianek-llu yullgutkenrilkemeggnek agturallernek."
        },
        "157": {
            "start": 1564.54,
            "end": 1569.22,
            "transcript": "Tua-i nallunaituq yuut ayuqenritut maani."
        },
        "158": {
            "start": 1570.02,
            "end": 1575.24,
            "transcript": "Malrugnek ayuqenrilnguugnek agkengyulriartangqertuq."
        },
        "159": {
            "start": 1575.24,
            "end": 1581.08,
            "transcript": "Ciuqlian nallunritarput yuc'iller mikelnguut nallukiit."
        },
        "160": {
            "start": 1581.08,
            "end": 1593.68,
            "transcript": "Tau͡gaam tauna mikelnguryunqeggluni ata aipaagni allrakulegnek eleven to thirteen tan'gaurlurnek wall'u nasaurlurnek."
        },
        "161": {
            "start": 1593.68,
            "end": 1598.5,
            "transcript": "Agkengtulit aipait yuguut assirnganateng."
        },
        "162": {
            "start": 1598.5,
            "end": 1611.74,
            "transcript": "Tau͡gaam-am qaill' piameng arenqiayugluteng ellmeggnek caunrilkelluteng wall'u taangiqsugluteng akusraruteki Yugtut mikelngurnek."
        },
        "163": {
            "start": 1612.9,
            "end": 1620.92,
            "transcript": "Amllerrmi inerciigacet'ulini nallunairutuq amllelartut mikelnguut avataitni."
        },
        "164": {
            "start": 1620.92,
            "end": 1632.46,
            "transcript": "Allrakuni kitullerni itercilartukut yugnek state-am iluani. Ilakluki ciuliqagtait boy scout-at agayuviliurteńek-llu."
        },
        "165": {
            "start": 1632.46,
            "end": 1642.04,
            "transcript": "Wanirpak qanercetaarunmi caliangqertukut uumek agayugmi calitulimek mikelnguut ayautaqluki kiagivigmun."
        },
        "166": {
            "start": 1642.04,
            "end": 1655.34,
            "transcript": "Tamaani-llu agturarluki. Nallunriumallermini-llu agayumacini cimirluku. Tuamta-llu ataam agturatullni ayagnirluku."
        },
        "167": {
            "start": 1655.34,
            "end": 1669.22,
            "transcript": "Yuut akmani umyuarteq'laata waten, arenqiallugutengqerrsukluki kiingan Appalachia-mi Alaska-mi-llu, nunacuaraat piciliumalartut piciryaraqniluku mikelngurnek agturiyaraq."
        },
        "168": {
            "start": 1669.52,
            "end": 1682.88,
            "transcript": "Usuuq atam qau͡vaken Lime Village maavet tekillua un'gavet Tuntutuliaq tekilluku ayagalallruunga."
        },
        "169": {
            "start": 1682.88,
            "end": 1689.98,
            "transcript": "Tua-ll' qau͡vaken Kuigpagmi from Holy Cross tua-ll' Qerruulligmun."
        },
        "170": {
            "start": 1689.98,
            "end": 1699.06,
            "transcript": "Takneret ak'allat yuut apqarlauranka waten, tatamtevkenaku pingnaqlaragka."
        },
        "171": {
            "start": 1699.06,
            "end": 1705.76,
            "transcript": "Pilaranka, \"Waten-qaa yuut-qaa piciyaraqait iciw' waten mikelnguarnek asriutekiluteng?\""
        },
        "172": {
            "start": 1705.76,
            "end": 1715.1,
            "transcript": "Waten pingnauriatnga, \"Tuaten-gguq piyuitut yuut irniateng mikelnguar naanguarutngunrituq.\""
        },
        "173": {
            "start": 1715.1,
            "end": 1726.8,
            "transcript": "Naanguaryukuni-gguq yuk aipangluni pili tauna aipani piliuq mikelnguaq pivkenaku piciryaraqenritapuk, kiam-llu yuum."
        },
        "174": {
            "start": 1726.8,
            "end": 1733.46,
            "transcript": "Piikaanga kia-llu yuum qanruskanga tuaten wii iliini qenqertelartua."
        },
        "175": {
            "start": 1733.46,
            "end": 1743.14,
            "transcript": "Waten Yupiit piciryaraqenritaat irniaten mikelnguaraat ellaita anglikuneng."
        },
        "176": {
            "start": 1743.14,
            "end": 1755.22,
            "transcript": "Wangkuk, ak'allauruskumta ellaita wangkugnun eliciiquk."
        },
        "177": {
            "start": 1755.86,
            "end": 1765.18,
            "transcript": "Elluarrluteng-llu elitenrilkuneng anglikuneng tua-i usuuq, imkuciquq, akusrarngarciquq mer'aluteng, mer'ayugluteng cakneq."
        },
        "178": {
            "start": 1765.18,
            "end": 1772.64,
            "transcript": "Taangiqluteng, aipameggneng callugluteng, elluarrluteng-llu yuvpek'nateng, yuvkenateng."
        },
        "179": {
            "start": 1775.18,
            "end": 1786.52,
            "transcript": "Caliamni qanercetaarvigmi elitellruaqa yuut assikenritellrat mikelngurnek akusrarucilallrat mikelnguut qununarqut allacetun ellarpamteńi."
        },
        "180": {
            "start": 1786.52,
            "end": 1797.22,
            "transcript": "Yuut umyuarteqellriit mikelnguut temait takarnarqenricukluki alartut, tamana nallunrillruaput qanercetaarvigmi."
        },
        "181": {
            "start": 1797.22,
            "end": 1809.22,
            "transcript": "Nallunricuk'lallemcetun amllerni allrakuni akusrarucitulit allakaumasciigatut kemgitgun, allrakuitgun, arnaullrakun, wall' angutngullrakun."
        },
        "182": {
            "start": 1809.22,
            "end": 1816.66,
            "transcript": "Niitelartukut yuut ayuqenrilnguut akusrarutekilarniluki wall' agkengilarniluki mikelngurnek."
        },
        "183": {
            "start": 1816.66,
            "end": 1823.48,
            "transcript": "Cali niitelartukut mikelngurnek akusrarutekilallrat kiingan maani piksaitelarniluku."
        },
        "184": {
            "start": 1823.48,
            "end": 1832.04,
            "transcript": "Makut ikayurciqaitkut taringevsiartelluku, aipaagni-llu ikayurluta mikelnguut watngamanritlerkaitnun."
        },
        "185": {
            "start": 1832.04,
            "end": 1836.0,
            "transcript": "Tau͡gaam nallunritellra taringellra-llu amllenrituk."
        },
        "186": {
            "start": 1836.0,
            "end": 1850.78,
            "transcript": "Qanercetaarviit allat-llu caliaqelangraitki mikelnguut akusrarutek'laqait wall' agkengluki maani avatemteni ayuqluku Anchorage-aaq, Seattle, Chicago, Washington D.C.-q-llu."
        },
        "187": {
            "start": 1850.78,
            "end": 1859.1,
            "transcript": "Nanleng'e'rmi man'a arenqiallugutnguluni. Tau͡gaam allakun arulaircecugngaaput man'a arenqiallugutvut."
        },
        "188": {
            "start": 1859.1,
            "end": 1869.22,
            "transcript": "Qacignaqluni akiinani cali assinruluni allani imuuguq angayuqerrulriit niicugnillerkait irniateng."
        },
        "189": {
            "start": 1870.76,
            "end": 1886.22,
            "transcript": "Irniavet ullagluten qanruskaten yugmun agturamallruniluni ukveqiu elpenek elpengcaaraluten caurallratnek nev'et avatiini."
        },
        "190": {
            "start": 1886.22,
            "end": 1897.22,
            "transcript": "Cali elpengcaarluki irniaten qaill' pimayugngallratnek tau͡gaam canritniluku qanllerkait."
        },
        "191": {
            "start": 1897.22,
            "end": 1907.38,
            "transcript": "Tamatum assircet'laraa canrituq qanlleq kia waten qanruteksaitaanga."
        },
        "192": {
            "start": 1907.38,
            "end": 1921.22,
            "transcript": "Irumcaurautngullruuq. Tau͡gaam assirilriaruvkenani. Ayuqenrituq assilriit assiilnguut-llu irumcautet."
        },
        "193": {
            "start": 2068.32,
            "end": 2080.34,
            "transcript": "Pilarrait waniwa ukut ikayurtekat. Mamterillermi, Southwest Alaska Council for Prevention of Child Sexual Abuse, Box 1948, Bethel, Alaska 99559."
        },
        "194": {
            "start": 2080.34,
            "end": 2085.24,
            "transcript": "Calivaita number-aara waniwa, 543-3994."
        },
        "195": {
            "start": 2085.24,
            "end": 2092.14,
            "transcript": "Cali Tundra Women's Coalition, Box 1537, maani Mamterillermi 99559."
        },
        "196": {
            "start": 2092.14,
            "end": 2106.22,
            "transcript": "Calivaita office-aarat number-aara, 543-3424, arenqiallugtellrianun ikayurnarqellrianun-llu una qayagauryugngaaci collect-arluku, 543-3456."
        },
        "197": {
            "start": 2106.22,
            "end": 2116.02,
            "transcript": "Curuygmi wall' Dillingham-ami Safe & Fear Free Environment, Box 94, Dillingham, Alaska 99576."
        },
        "198": {
            "start": 2116.02,
            "end": 2127.6,
            "transcript": "Office-aarata number-aara 842-2320, arenqiallugtellriit-llu collect-aryugluteng call-aryugngaut wavet, 842-2316."
        },
        "199": {
            "start": 2127.6,
            "end": 2134.16,
            "transcript": "Imangarmi-llu Emmonak Women's Center, General Delivery, Emmonak, Alaska 99581."
        },
        "200": {
            "start": 2134.16,
            "end": 2138.98,
            "transcript": "Office-aarata number-aara, 949-1434."
        },
        "201": {
            "start": 2138.98,
            "end": 2151.12,
            "transcript": "Cali-ll' nunacuarni qayagauryugngaaci wall' ullagyugngaaci village public safety officer-aat, tegustet, healthy aide-at, village safe home-at wall'u magistrate-at."
        },
        "202": {
            "start": 2151.12,
            "end": 2160.36,
            "transcript": "State-amta iluani arenqaillugtellriit qayagauryugngaaci Alaska State Trooper-aat wall' qillerqistet caliviit maani regional center-aani."
        },
        "203": {
            "start": 2160.36,
            "end": 2165.6,
            "transcript": "Cali Division of Family and Youth Services-aat cali caliviit maani region-aani."
        },
        "204": {
            "start": 2165.6,
            "end": 2175.78,
            "transcript": "Cali-llu Alaska Council on Domestic Violence and Sexual Assault, Department of Public Safety, Pouch N, Juneau, Alaska 99811."
        },
        "205": {
            "start": 2175.78,
            "end": 2185.62,
            "transcript": "Waqaa quyana ataku ilagaqatarluta ava-i suuq tangvagput, mat'um mikelnguut akusrarutekumallrit tungiitnun qaillun-llu pilallritnek."
        },
        "206": {
            "start": 2185.62,
            "end": 2191.14,
            "transcript": "Wiinga Atmaugua ataku-llu malrunek allanengqertua mat'um tungiinun calitulignek."
        },
        "207": {
            "start": 2191.14,
            "end": 2197.7,
            "transcript": "Ciuqlia, Clara Kelly arulaitestii Child Sexual Abuse Project-aam maani Mamterillermi."
        },
        "208": {
            "start": 2197.7,
            "end": 2201.96,
            "transcript": "Mary Abruska-llu social worker-aam ikayua ADFYS-aami."
        },
        "209": {
            "start": 2201.96,
            "end": 2206.2,
            "transcript": "Ciumek Mary man'a reporting-laamek pilaqiit."
        },
        "210": {
            "start": 2206.2,
            "end": 2211.26,
            "transcript": "Yuut kinkunun report-ararkaugat nallunrilkengangqerquni?"
        },
        "211": {
            "start": 2211.26,
            "end": 2217.84,
            "transcript": "Nunacuarni police iterciviatni, itercistiitni piarkauyaaqut."
        },
        "212": {
            "start": 2217.84,
            "end": 2225.82,
            "transcript": "Tua-llam, healthy aide-anun, taukuk-llu wangkugnun report-ararkauguq Family and Youth Service-aani."
        },
        "213": {
            "start": 2225.82,
            "end": 2233.72,
            "transcript": "Collect-arluteng call-aryugngauk, number-aq tunlaku, waten five, four, three, three, one, four, one."
        },
        "214": {
            "start": 2233.72,
            "end": 2242.1,
            "transcript": "Tua-ll' qanruulluut imkut-ll' arnat-ll' kiustiita qanrulluki iciw' calistiitnun ilainun pisqellukek."
        },
        "215": {
            "start": 2242.1,
            "end": 2253.58,
            "transcript": "Tua-ll' kina kiulria qan' tauna yuut qanemcitnauraak qaill' kituucia tauna mikelnguar asriutekcimalleq."
        },
        "216": {
            "start": 2253.58,
            "end": 2261.14,
            "transcript": "Tegustet ilakluki kinkut qanrucugngaitki? Health aide-aita."
        },
        "217": {
            "start": 2261.14,
            "end": 2269.54,
            "transcript": "Clara, qaill' mat'um alerquutem agtuumalartaki makut case-at caliaqela'arci makut mikelnguut akusrarutekumalriit."
        },
        "218": {
            "start": 2269.54,
            "end": 2276.82,
            "transcript": "Maa-i-qaa amllessiyaagluki-qaa man' tua-i-w' man'a reporting-larat atuyaurcatgu."
        },
        "219": {
            "start": 2276.82,
            "end": 2281.9,
            "transcript": "Tamatum-qaa qanrucillerkaita caliarkaci amlleriqercetait?"
        },
        "220": {
            "start": 2281.9,
            "end": 2291.36,
            "transcript": "Tamana alerquun iciw' anguq'apiar nallunriskengangqerqumta qanrutkesqelluku mikelnguarnek akusrarucimalrianek."
        },
        "221": {
            "start": 2291.36,
            "end": 2297.54,
            "transcript": "Tamana tua-i-wa akaurcaaqellria tamana alerquun naungucianek."
        },
        "222": {
            "start": 2297.54,
            "end": 2309.7,
            "transcript": "Tau͡gaam wangkuta piurqaanamteńek, wangkuta-llu tua-i ilakluta piciatun mikelnguarnek elicariyaurcamta wall' makunek, mit'engungraata-llu tegustet iinriurtet tamatum tungiinek."
        },
        "223": {
            "start": 2309.7,
            "end": 2318.22,
            "transcript": "Alerquayaurcamteki iciw' anguqapiar qanrutkesqelluki amlleringiinartut wani iciw' qanrutkumalriit."
        },
        "224": {
            "start": 2318.22,
            "end": 2326.7,
            "transcript": "Naspaaluta, wiinga-gguq ata nunacuarmi uitaunga, nallunrilkengqerrlua-ll' mikcuarmek tuaten akusrarutekumalriamek."
        },
        "225": {
            "start": 2326.7,
            "end": 2334.22,
            "transcript": "Qaillun caliaqelarcecitki? Tamarpetek aipatek ciumek piyukuni, aipaa-ll' kinguakun piyukan."
        },
        "226": {
            "start": 2334.22,
            "end": 2342.22,
            "transcript": "Elpeni, elpet-qaa nunacuarmi uitalriaten? Yaa. Qaillun elpet ayagnirluku caliaqeciqsiu?"
        },
        "227": {
            "start": 2342.22,
            "end": 2349.98,
            "transcript": "Wangkuk call-angkumta egmian pingayut erenret nauvailgata tamaavet nunanun piarkauyaaqukuk."
        },
        "228": {
            "start": 2349.98,
            "end": 2353.86,
            "transcript": "Kiimta wall' itercistet malikluku piarkauyaaqapuk."
        },
        "229": {
            "start": 2353.86,
            "end": 2359.58,
            "transcript": "Tua-ll' tauna mikelnguar apqaurraarluku yuvrivkarraarluku tuaten apqaurluku."
        },
        "230": {
            "start": 2359.58,
            "end": 2367.22,
            "transcript": "Tauna-ll' pistiita itercistet ellaita caliaqciqapuk tauna-ll' yucuayagaaq asriutekcimalria."
        },
        "231": {
            "start": 2367.22,
            "end": 2375.72,
            "transcript": "Angayuqaan elluarrluku qanqesciigalkatgu wangkuk teguciiqapuk, wall' ilainun elliluku."
        },
        "232": {
            "start": 2375.72,
            "end": 2383.22,
            "transcript": "Ilain assiinaku pikatgu wangkuk teguciiqapuk nunacuarmek, Mamterillermun-llu tailluku."
        },
        "233": {
            "start": 2383.42,
            "end": 2393.52,
            "transcript": "Tua-ll' foster parent-aanun iciw' aulukilrianun pituapuk, makut-llu aulukilriit assirtut, foster parent-anun pilaraat."
        },
        "234": {
            "start": 2393.52,
            "end": 2398.22,
            "transcript": "Assirtut iciw' mikelnguarnek aulukilartut."
        },
        "235": {
            "start": 2398.22,
            "end": 2404.64,
            "transcript": "Tua-ll' tamaavet pirraarluku iliini, iliini pamavet yungcarvigmun pilaraput."
        },
        "236": {
            "start": 2404.64,
            "end": 2411.1,
            "transcript": "Ciuqlimi tekiteqarraalriani, yungcaristem-llu ellii yuvripiarluku pilarait mikelnguaq."
        },
        "237": {
            "start": 2411.1,
            "end": 2419.28,
            "transcript": "Arnaungraan, wall' arnaukan, wall' tan'gaurlukan, yungcaristet piarkaugaat, yuvrirarkaugaat."
        },
        "238": {
            "start": 2419.28,
            "end": 2432.16,
            "transcript": "Imkucimeng-llu ciissingcuarankuneng tua-ll' ellaita qanrulluta piniaraat, iciw' yuvrirraarluku ciissingqerkuni iinrukiitarkauyaaqaat egmian."
        },
        "239": {
            "start": 2432.16,
            "end": 2445.14,
            "transcript": "Taqnercetun-qaa pitarrluku iinruvkarluku? Naam. Wall'u-qaa? Tua-i ayuq' iciw' tamakut ciissit wani venereal disease-anek pilaqait, ayuqaitnek pilarait."
        },
        "240": {
            "start": 2445.14,
            "end": 2455.62,
            "transcript": "Taqnerulriacetun-qaa iinruvkarluku? Ii-i, tua-i-w' iinruvkaralria wall' kapluku wall' iinrucuarnek piluku."
        },
        "241": {
            "start": 2456.18,
            "end": 2466.9,
            "transcript": "Maa-i atam mikelnguar, qavcirqugem [?] maa-i niitelartua, ataucirmek qangvarem niitellrulrianga."
        },
        "242": {
            "start": 2466.9,
            "end": 2477.24,
            "transcript": "Yungcaristem-gguq waten qaill' piniluku, VD-ngqerrniluku, yuqertellermikun. Tauna piciunrituq mikelnguaq."
        },
        "243": {
            "start": 2477.24,
            "end": 2485.96,
            "transcript": "VD-ngesciigatuq yuk agturcirraarpailegmini."
        },
        "244": {
            "start": 2485.96,
            "end": 2494.22,
            "transcript": "Yuum tau͡gaam agtuqagu tua-i tau͡gaam piciquq, allanun pisciiganani."
        },
        "245": {
            "start": 2494.22,
            "end": 2504.94,
            "transcript": "Qerrutnek pingesciigatuq, qerrutnek wall'u canek aturallernek iqailrianek tamaggun pisciigatuq, tauna piciunrituq atam."
        },
        "246": {
            "start": 2504.94,
            "end": 2508.36,
            "transcript": "Qaill' taktalriamek foster home-ani uitalartat?"
        },
        "247": {
            "start": 2508.36,
            "end": 2521.44,
            "transcript": "Iliini, iliini maybe arvinleggluku, iralurrluku, iliini-ll' malrugnek allrakurrluku."
        },
        "248": {
            "start": 2521.44,
            "end": 2532.2,
            "transcript": "Angayuqaat-wa tangvagluku, angayuqaat iciw' ikayuqatgu ukveqatgu eniitni tua-i ellaitnun uniciiqapuk."
        },
        "249": {
            "start": 2532.2,
            "end": 2540.76,
            "transcript": "Pisciigat' ellaita ukvesciigat', ukvenrilkatgu wangkuk tua-i tegupiggluku malrugnek allrakurrluku pingnaqlarapuk."
        },
        "250": {
            "start": 2540.76,
            "end": 2553.64,
            "transcript": "Tauna yucuayagaq niitelartukuk waten mikelnguaraat-ggem mikaaqameng nalluyaguutelartut. Nalluyaguciyuitut. Nalluyaguciyuitut."
        },
        "251": {
            "start": 2553.64,
            "end": 2557.94,
            "transcript": "Qakuani qanercetaavigkun caliaqelartatki?"
        },
        "252": {
            "start": 2562.94,
            "end": 2571.0,
            "transcript": "Egminaq pingnaqlaryaaqait tau͡gaam yaa, egminaq pingnaqlarait akaurtessiyaagpailgan."
        },
        "253": {
            "start": 2571.0,
            "end": 2577.34,
            "transcript": "Iciw' mikelnguyagaat iciw' iqluluteng qanyuitut. Cali-llu mikelnguyagaat picetaarluteng pivkayuitut tuaten."
        },
        "254": {
            "start": 2577.34,
            "end": 2586.38,
            "transcript": "Cali-llu camek iciw' mikelnguyagaat akwaugamek qanyuitut akwaugaq unuaqu wall' miksiyaagaqameng."
        },
        "255": {
            "start": 2586.38,
            "end": 2595.98,
            "transcript": "Tamana pitekluku nalluyagupailgatki iciw' ukaqsignginanrani qanercetaarvigmun pingnaqlarait."
        },
        "256": {
            "start": 2595.98,
            "end": 2602.22,
            "transcript": "Elpet-qaa calivigpet allarrauluku Mary-m caliviani aulukelaraci man'a?"
        },
        "257": {
            "start": 2602.22,
            "end": 2609.4,
            "transcript": "Ikayuqu'urluta aulukarkauyaaqeput iciw' ikayuq, wiinga caliaqa iciw' elitnaurilriatun pilartua."
        },
        "258": {
            "start": 2609.4,
            "end": 2620.22,
            "transcript": "Mikelngu', waten elitnaurvignun, iinrivignun, tegusteńun, piciatun ayagaluta wangkuta calivimni elitnaurilartukut mat'um tungiinun."
        },
        "259": {
            "start": 2620.22,
            "end": 2630.44,
            "transcript": "Cali elitnaurvinun iterluta mikelnguaraat iciw' cali elitnaurluki mat'um qaill' ellaita kemegteng kitumun agturarkaunritellerkaat."
        },
        "260": {
            "start": 2630.44,
            "end": 2641.34,
            "transcript": "Makut temirtet wani nallunritelarkauyaaqut mikelnguarnek caumakilleq wani inerquutnguqapiartuq alingnaqluni iciw' tuaten piarkaunricaaqut."
        },
        "261": {
            "start": 2641.34,
            "end": 2648.72,
            "transcript": "Cali tuaten mikelnguarnek pilriit akngirtengelriit-wa caanguaqiluteng-llu iciw' itertaugarkauluteng."
        },
        "262": {
            "start": 2649.22,
            "end": 2654.72,
            "transcript": "Im'ucetun Mary-m-qaa caliviacetun enaitnek ayaulluki pilaraci?"
        },
        "263": {
            "start": 2654.72,
            "end": 2661.54,
            "transcript": "Wangkuta iciw' social worker-aunritukut tuaten picuitukut tau͡gaam elitnaurnginarluki yuut qanrusnginarluki."
        },
        "264": {
            "start": 2661.54,
            "end": 2670.62,
            "transcript": "Mat'um tungiinun iciw' nallunringevkaq', tua-i-w' nallunritesqelluki, excuse me."
        },
        "265": {
            "start": 2670.62,
            "end": 2677.26,
            "transcript": "Waten elluatmun calinritniluki mikelnguarnek wani tuaten ayulriit."
        },
        "266": {
            "start": 2677.26,
            "end": 2681.04,
            "transcript": "Tegustenguut social worker-aunrilamta wangkuta tuaten."
        },
        "267": {
            "start": 2681.04,
            "end": 2688.76,
            "transcript": "Qanrut'laraput tau͡gaam kiameng tuqlurluta qanruskeput qanrucimanrilkata ukut wangkuta qanruciiqaput."
        },
        "268": {
            "start": 2688.76,
            "end": 2691.52,
            "transcript": "Qaill' angtaluteng mikcuaraat elicugngaat mat'umek?"
        },
        "269": {
            "start": 2691.52,
            "end": 2702.58,
            "transcript": "Egmian taringyaurtaqameng taringyaurtellriit iciw' il'ikun allrakuq cip'arrluku qaneryaurtelalriit egmiinaq wani iciw'."
        },
        "270": {
            "start": 2702.58,
            "end": 2713.38,
            "transcript": "Tua-i-wa tamaqapiaraan mat'um anguciuryaram arniuryaram-ll' tungiinek pinrilengramteki iciw' waten una waniw' irniacuar' [?] iciw'."
        },
        "271": {
            "start": 2713.38,
            "end": 2719.1,
            "transcript": "Yuqertessuutevun, wall' anarcuutevun, wall' tamakunek evsaivvet avatiiggun iciw'."
        },
        "272": {
            "start": 2719.1,
            "end": 2725.44,
            "transcript": "Wall'u-q' kalikanek waten kiarturarkaunritait, tua-i-w' carraungraan qanrulluki."
        },
        "273": {
            "start": 2725.44,
            "end": 2732.22,
            "transcript": "Tua-i-ll' agtuqaten kia uum egmian kina, aanan wall' elitnauristen kina-am qanrulluku."
        },
        "274": {
            "start": 2733.28,
            "end": 2740.22,
            "transcript": "Maa-i-qaa waten mikelngurnek pilallrit amlleriut wall' carraurtut?"
        },
        "275": {
            "start": 2740.22,
            "end": 2747.92,
            "transcript": "Tuar amlleriinalriit iciw' qanruteksaurcatgen-wa tua-i amlleriqernganateng."
        },
        "276": {
            "start": 2747.92,
            "end": 2750.22,
            "transcript": "Ciungani-mi qaill' amllertalallruat?"
        },
        "277": {
            "start": 2750.66,
            "end": 2758.76,
            "transcript": "Imumi-wani iciw' 1981-ami piqarraallemteńi seventeen allrakum iluani qanrutkumalriit."
        },
        "278": {
            "start": 2758.76,
            "end": 2771.7,
            "transcript": "Tuai-ll' 1982-ami, 27-aat qanrutkumaluteng, tuai-ll' 1983-ami, 87, tuai-ll' 1984-ami, 134, 134."
        },
        "279": {
            "start": 2771.7,
            "end": 2777.08,
            "transcript": "Iciw' maa-i tang, amlleriinarluni. Waken-qaa alerquutmek pingaunani?"
        },
        "280": {
            "start": 2777.08,
            "end": 2786.18,
            "transcript": "Tuai-wa iciw' yuut nallunriqameng, iciw' wangkuta-llu yugni iciw' tegustet wani waten pivkenaki angurrluk tuaten qanaalanriluni iciw'."
        },
        "281": {
            "start": 2786.18,
            "end": 2792.12,
            "transcript": "Inerquyuirucamteki mikelnguut, iciw' mikelnguut iqluyuitut canek."
        },
        "282": {
            "start": 2792.12,
            "end": 2799.0,
            "transcript": "Cali-llu mat'um tungiinun wani elicuitut umyuarteqsartut waten iliikun aanaulriit."
        },
        "283": {
            "start": 2799.0,
            "end": 2804.9,
            "transcript": "Tuai-w' TV-mek tangvagpakarluni waten elitengllilria. TV-mek tangvagpakarluni elitengyuitut."
        },
        "284": {
            "start": 2804.9,
            "end": 2813.08,
            "transcript": "Tau͡gaam eliciiqut, nallunriciiqut, kia imum, agturraarpailatgen kia imum elisngaitelliniut."
        },
        "285": {
            "start": 2813.08,
            "end": 2819.0,
            "transcript": "Qaillun makut cali uit elpet ikayuqenrilngurni calilalriat? Qaillun calillgutek'larceci?"
        },
        "286": {
            "start": 2820.04,
            "end": 2827.22,
            "transcript": "Allat-llu qanercetaarviit qillerqistet tegustet, qaillun calillgutek'larceci? Kia cat caliaqelartatki?"
        },
        "287": {
            "start": 2827.4,
            "end": 2835.1,
            "transcript": "Tua-i-w' katurrluta ikayuqu'urluta, iciw' watua qanellrulriakut ikayuqu'urluta mat'um tungiinun calingnaqlartukut mikelnguaraat tungiitnun."
        },
        "288": {
            "start": 2835.1,
            "end": 2844.22,
            "transcript": "Cali-llu meeting-aaraqluta case group-amek acirlaqput iciw' tegustet, qillerqistet, iinriurtet, umyuanek calituli ukut."
        },
        "289": {
            "start": 2844.22,
            "end": 2853.0,
            "transcript": "Wangkuta-llu every two weeks katurrluta makut wani qanrutkumalriit qaillun, nanluciitnek."
        },
        "290": {
            "start": 2853.0,
            "end": 2864.36,
            "transcript": "Qaill', tua-i-w' ciunerkiurluki, wall'u aulukumanrilnguut qaill' auluklerqaat elluarluki pillerqaitgun pilartukut tuaten."
        },
        "291": {
            "start": 2864.36,
            "end": 2870.0,
            "transcript": "Mary, amlleret umyuarteq'lartut kiingita nasaurlucuaraat pituyukluki waten."
        },
        "292": {
            "start": 2870.0,
            "end": 2879.22,
            "transcript": "Qaillun, qaillun, allaunruuq-qaa tan'gaurlucuarnun-llu, wall' qaill' ayuquk wall' qaill' ayuqenrituk?"
        },
        "293": {
            "start": 2879.22,
            "end": 2888.32,
            "transcript": "Tan'gaurluut-llu atam kiirmeng tuar, kiimeng tuar nunam qaingani agtuumalalriik kiirmeng."
        },
        "294": {
            "start": 2888.32,
            "end": 2898.22,
            "transcript": "Yuum tau͡gaam qanruskaa qallauskakek tan'gaurluut amllessiyaalriit piqaqsaitanka, tau͡gaam qavcirraat maybe tallimarraak."
        },
        "295": {
            "start": 2898.22,
            "end": 2903.0,
            "transcript": "Maa-i makunun caliyaurcama."
        },
        "296": {
            "start": 2903.0,
            "end": 2913.18,
            "transcript": "Qanernaur' tuar kiimi pilalria, tuar kiimi agtuumalalria. Ciin-llu-gguq tau͡gaam pianga?"
        },
        "297": {
            "start": 2913.18,
            "end": 2926.22,
            "transcript": "Caurrnayukluteng, iciw' angutnun kiingan caunayukluteng pilartut caperrsugluteng."
        },
        "298": {
            "start": 2926.22,
            "end": 2931.02,
            "transcript": "Im', im', nepaillruluteng-qaa arnani?"
        },
        "299": {
            "start": 2931.02,
            "end": 2943.0,
            "transcript": "Iliini, tua-i qaill' yuut ayuqenrilameng ilait ilateng callugyugluki wall' iliini nepaitenruluni."
        },
        "300": {
            "start": 2943.0,
            "end": 2956.1,
            "transcript": "Wall' tua-i piciatun ayuqluteng. Tau͡gaam qenqercugluteng. Qenqertaqameng tua-i qenqertepiggnaurtut. Tua-i cakneq umyuarit-w' navegngameng."
        },
        "301": {
            "start": 2956.1,
            "end": 2962.22,
            "transcript": "Caliaqellrit-qaa? Caliaqellrit-qaa nasaurluut tan'gaurluut-llu ikayuqsuitut?"
        },
        "302": {
            "start": 2962.84,
            "end": 2974.26,
            "transcript": "Ayuqsuitut tau͡gaam maa-i elitengua tan'gaurluut angutnun tau͡gaam iliini qallaciiquq."
        },
        "303": {
            "start": 2974.26,
            "end": 2980.9,
            "transcript": "Arnamun qallautellerkat caperrsugluku, caperrsugnauraa waten."
        },
        "304": {
            "start": 2980.9,
            "end": 2990.92,
            "transcript": "Wiinga-ll' wang'ung'e'rma au͡g'um, im'um iciw' wani una yuk caliaqekegka, uum, taum qanrusngaitaanga waten angutnun tan'gaurluku."
        },
        "305": {
            "start": 2990.92,
            "end": 2999.18,
            "transcript": "Uum wani angutem agtullruanga, angutem tau͡gaam apeskaku ciuqlirmi qenqerrarraarluni."
        },
        "306": {
            "start": 2999.18,
            "end": 3009.44,
            "transcript": "Tuaten-gguq piqaqsaitniluni pinaurtuq. Tua-ll' kinguakun im' iciw' uitaviani taukut qanrutniarai."
        },
        "307": {
            "start": 3011.18,
            "end": 3027.78,
            "transcript": "Qaillun, caliaqellrit-qaa qaillun-mi cukaircet'laraiceciqa qaneryuumitaqameng? Wall' qaill' qanercet'larcecitki?"
        },
        "308": {
            "start": 3027.78,
            "end": 3042.34,
            "transcript": "Tua-i-wa apqaurluki, wall' iliini apqaunrilengramki qanrutekluku, alla yuk aterpagtevkenaku tau͡gaam qanemciurluku uum yugmeng angutngukuni wall' tan'gaurlukuni."
        },
        "309": {
            "start": 3042.34,
            "end": 3047.18,
            "transcript": "Waten ayuqellriamek ak'a caliaqellruniluku tauna."
        },
        "310": {
            "start": 3047.18,
            "end": 3054.38,
            "transcript": "Tua-ll' ellii ciuqlirmi tua-i qanrusngaitaanga, umikuani tau͡gaam paqeskumku cali piniarai."
        },
        "311": {
            "start": 3054.38,
            "end": 3058.58,
            "transcript": "Wii tuaten pillrunilua, taum yuum pillruanga."
        },
        "312": {
            "start": 3058.58,
            "end": 3073.9,
            "transcript": "Wall' waten au͡g'um yuum pillruanga ak'a imumi yuucuaraallrani boarding home-ami wall' uitaviani uitellermini."
        },
        "313": {
            "start": 3073.9,
            "end": 3087.5,
            "transcript": "Taum nem'i angutem imum arnam uingan tauna-gguq asriutekellrua, waten pinaur' wiinga angutem asriutekellruanga umyuaqa-ll' aknirrluku."
        },
        "314": {
            "start": 3087.5,
            "end": 3094.8,
            "transcript": "Maa-i umyuaqa assiit'lartuq cukaarlua qenqertaqama iliini tuar nalluyagutelalrianga."
        },
        "315": {
            "start": 3095.22,
            "end": 3109.58,
            "transcript": "Clara qaillun pilaqait-wa short-term, long-term, egmianun akaarnun-llu qaill' agtuumalartutki mikelnguut tuaten pimaaqata?"
        },
        "316": {
            "start": 3109.58,
            "end": 3112.24,
            "transcript": "Temirtet-qaa mikelnguaraliuraqameng?"
        },
        "317": {
            "start": 3112.24,
            "end": 3119.56,
            "transcript": "Iliikun-wa qanrutekenrilkuneng egmian tua-i taqeksaunateng piuratulliniut iciw'."
        },
        "318": {
            "start": 3119.56,
            "end": 3131.22,
            "transcript": "Qanrutkekaten tau͡gaam alakumarikuneng tua-i taqluteng. Iliikun mikelnguaraat iciw' taum angutem caumakekunegteki inerqualarait iciw' qanqaasqevkenaki."
        },
        "319": {
            "start": 3131.22,
            "end": 3135.7,
            "transcript": "Tua-i ellaita avalitkuciqniluki qanqata."
        },
        "320": {
            "start": 3135.7,
            "end": 3146.8,
            "transcript": "Tau͡gaam maa-i-wa nallunringameng mikelnguaraat iciw' tamana, tua-i-w' mikelnguaraat nallunritlartut tuaten piscilriit tamana assinritellranek iciw'."
        },
        "321": {
            "start": 3146.8,
            "end": 3153.26,
            "transcript": "Maa-i qanrut' ukveksaurcamteki-w' qanraqata egminaq ilait qanerlartut."
        },
        "322": {
            "start": 3153.26,
            "end": 3164.46,
            "transcript": "Ilait tau͡gaam tuaten iciw' angayuqaateng niitellaqait qanenritaqata tua-i taqsuitelliniit."
        },
        "323": {
            "start": 3165.56,
            "end": 3172.22,
            "transcript": "Tamakut temirtet nallunrileng'e'rmeng inerquutngungraan."
        },
        "324": {
            "start": 3172.22,
            "end": 3178.66,
            "transcript": "Qaill'-mi mat'um mikelnguut cimiryugngaitki ayuqucait, cimilarait? Cam?"
        },
        "325": {
            "start": 3178.66,
            "end": 3183.44,
            "transcript": "Mikelnguum ayuqucia-qaa? Agturcillret? Yaa, pimarraarluni."
        },
        "326": {
            "start": 3183.44,
            "end": 3190.22,
            "transcript": "Cimiqapigtetulliniuq umyugayagai iciw' qaingit akngirteng'e'rmeng, umyugayagait tau͡gaam akngirtenrulalliniut."
        },
        "327": {
            "start": 3190.22,
            "end": 3197.86,
            "transcript": "Tua-i-ll' iciw' wangkuta temirteńi umyugaput kia uum akngirtaqatki wall' navegluki ak'anun umyuarrlugtelalriakut."
        },
        "328": {
            "start": 3197.86,
            "end": 3206.76,
            "transcript": "Tuaten-llu ukut mikelnguyagaungermeng wani ak'anun umyugait-wa navgaqameng egminaq assiriyuitut."
        },
        "329": {
            "start": 3206.76,
            "end": 3218.22,
            "transcript": "Ilait temirtengurteng'e'rmeng-llu tua-i usvillugtellriateng piluteng wall' taangatuuriluteng melugayuuriluteng iciw' tua-i assinrilngurmek tua-i caliarluteng, ayagarluteng."
        },
        "330": {
            "start": 3218.22,
            "end": 3225.86,
            "transcript": "Wall' piciatun aipangluteng, piciatun iciw' kassuupailgata wall' piciatun aipangluteng."
        },
        "331": {
            "start": 3225.86,
            "end": 3230.9,
            "transcript": "Cimiqetaarluteng. Ii-i cimiqetaarluteng. Pelleryuksaunateng. Ii-i."
        },
        "332": {
            "start": 3232.08,
            "end": 3235.56,
            "transcript": "Tua-i taanganun, taanganun piyugluteng."
        },
        "333": {
            "start": 3235.56,
            "end": 3242.82,
            "transcript": "Taangaq-qaa arcaqalartuq waten pitulimi? Piscillerni? Yaa, pituuq."
        },
        "334": {
            "start": 3242.82,
            "end": 3257.24,
            "transcript": "Taum yuum qallauteksungraagu caperrsugluteng uumun, ukverumangangait, uumun ukveng', ukverumangaitniluteng piyugluteng. Ukvekngaicukluteng."
        },
        "335": {
            "start": 3257.24,
            "end": 3263.18,
            "transcript": "Wall' assikngairucukluteng pituut."
        },
        "336": {
            "start": 3263.18,
            "end": 3274.7,
            "transcript": "Tua-ll' taanganun piaqameng ak'a-ll' qallautekluku. Taum-llu melguciitii iciw' tatamluni, iliini tatameqluteng."
        },
        "337": {
            "start": 3274.7,
            "end": 3282.62,
            "transcript": "Wiinga-mi panicuarlua qaillun wii piyugngasia irniarkaa tuaten pimanritlerkaagnegni?"
        },
        "338": {
            "start": 3282.62,
            "end": 3294.36,
            "transcript": "Tua-i-wa ayuqucirturluku kia yuum agturarkaunritaa iciw' qaiminun, qurrsuutiyagakun ulluakun [?], evyait avatiitni."
        },
        "339": {
            "start": 3296.32,
            "end": 3302.86,
            "transcript": "Qanrulluku egmian yuum pikaten tuaten qanrutesqelluten."
        },
        "340": {
            "start": 3302.86,
            "end": 3317.14,
            "transcript": "Ellii-gguq tuaten qanrulluku taum pan'im elpenun tusnganricaaquq assirtuten taum yuum iciw' pistevet tuaten piarkaunricaaquq."
        },
        "341": {
            "start": 3317.14,
            "end": 3328.24,
            "transcript": "Nunurngaitniluku qanrutaqluku. Cali-llu cali kenekniluku pikiun, atam tuaten mikelnguaraat pituut, atam."
        },
        "342": {
            "start": 3328.24,
            "end": 3335.98,
            "transcript": "Allameng-qaa yugmun qanellrit assinruut wall'u angayuqerrulriamun ciumek ullakuni assinruciquq?"
        },
        "343": {
            "start": 3335.98,
            "end": 3347.5,
            "transcript": "Wangni-w' mikelnguar aanani wall' aatani qanruskagu aanii aatii-ll' alikluku tamana qallautellerkaa."
        },
        "344": {
            "start": 3347.5,
            "end": 3360.52,
            "transcript": "Elpet waten qanruskuvgu man'a qallautekqatalqa wii caperrsugyaaqaqa tau͡gaam ayuqucirturyugyaaqamken waten yugmun akngirtesqevkenak."
        },
        "345": {
            "start": 3360.52,
            "end": 3371.8,
            "transcript": "Piciatun kituungraan maani nunam qaingani piarkaunricaaqaaten, agturarkaunricaaqaaten qaivnun, akngireskaten egmian wii wall' aatan qanrulluku piarkaugan."
        },
        "346": {
            "start": 3371.8,
            "end": 3382.5,
            "transcript": "Atam wii malrugni allrakulegnek irniangqerrsaaqua ava-i elicungcaraqa waten qanrulluku, Yugtun Kass'atun-llu pila'arqa."
        },
        "347": {
            "start": 3384.12,
            "end": 3397.58,
            "transcript": "Quyanaqvaa-ll' ilagarluta au͡gna-ll' ata ava-i tangellruciu mikelnguut qaillun-wa waten pimanritengnaqlerkaatnek, quyana-ll' ukuuk ikayu' ilagarlua."
        },
        "348": {
            "start": 3467.8,
            "end": 3484.7,
            "transcript": "Elpet tau͡gaam akusrarutekumallrukuvet qayagauqiki iliit ukut number-aat, 543-3141, wall' 543-3994, cali-ll' una, 543-3456."
        }
    },
    "PYBMB-e5zyk": {
        "1": {
            "start": 73.4,
            "end": 84.46,
            "transcript": "Ukut makunek qalerteqatalriakut neqnek ukunek kiik' [?] waniw' igausngaluteng pikani."
        },
        "2": {
            "start": 84.46,
            "end": 94.96,
            "transcript": "Ava-i mat'um neqem assiiruyutek'lallrinek ukuni wani igausngalrianek pika-i."
        },
        "3": {
            "start": 97.3,
            "end": 106.58,
            "transcript": "Ukut ciuqlikacaar pika-i  Bacterial Decomposition wall'u Spoilage of Fish by Bacteria."
        },
        "4": {
            "start": 106.6,
            "end": 120.98,
            "transcript": "Ukut-wa makut assiiruyutek'lallriit neqem elluarrluni aulukumanritaqani."
        },
        "5": {
            "start": 132.44,
            "end": 150.04,
            "transcript": "Makut-llu maani au͡g'um makut-wa tua-i bacteria-m-gguq neqa assiirucet'laraat imumek-wa tua-i nerelriacetun nangluku."
        },
        "6": {
            "start": 172.6,
            "end": 185.88,
            "transcript": "Tauna-gguq tuani waten cam-wa mat'um ukut waniw' pika-i qanelria, taukut imkut neqet assiiruyutek'lallrit-gguq."
        },
        "7": {
            "start": 185.88,
            "end": 198.12,
            "transcript": "Qaillun tua-i saarralam kanevneruayaraicetun angtaluni tangerciiganaku ava-i qanrutkeqallrani wangkuta."
        },
        "8": {
            "start": 198.12,
            "end": 215.94,
            "transcript": "Tauna-gguq tuani waten amllertalartuq 400 million, 400 million amllertaluni tua-i tauna aquinrayagaq [?] assiiruyutek'lallra neqem."
        },
        "9": {
            "start": 256.42,
            "end": 265.32,
            "transcript": "Au͡gkut-llu ava-i neqem assiiruyutek'lallri au͡gkut pikna pika-i qullik'acaraq atauciuluni."
        },
        "10": {
            "start": 265.32,
            "end": 272.26,
            "transcript": "Tua-ll' piuraqerluni ava-i waten avegluni malruurrluni."
        },
        "11": {
            "start": 272.26,
            "end": 285.9,
            "transcript": "Una tua-i ingna yaa-i assirluni tuaten pikuni tauna uumi sass'am avgani waten piarkauluni malruuluni."
        },
        "12": {
            "start": 285.9,
            "end": 297.6,
            "transcript": "Tua-i-llu-gguq ingkut una wani sass'am avga avqukcaarluku uumun sass'anun qulnun."
        },
        "13": {
            "start": 297.6,
            "end": 311.66,
            "transcript": "Atauciq tua-i tauna pikna ciissiyagaq waten 1 million amllertariarkauluni 10 hours, 10 hours."
        },
        "14": {
            "start": 336.02,
            "end": 346.54,
            "transcript": "Neqet-llu makut wangkuta-w' tua-i neqkaput waten tun'arkauluki wall'u tua-i arcaqerluki makut tun'arkat."
        },
        "15": {
            "start": 346.54,
            "end": 355.34,
            "transcript": "Waten camun-wa tua-i uqlalriamun pinritengnaqluki cali-ll' tua-i."
        },
        "16": {
            "start": 355.34,
            "end": 364.88,
            "transcript": "Tua-i-w' canun uqlalrianun pinritengnaqluki maaken assircetengnaqluki aulukluki."
        },
        "17": {
            "start": 400.16,
            "end": 415.04,
            "transcript": "Kiugna-ll' kia-i waniw' una, una tarenraq ukut wani neq'liulriit ukut waniw' caquluki makut patuluki-ll' qanteng."
        },
        "18": {
            "start": 415.04,
            "end": 422.02,
            "transcript": "Nuyateng-llu patuluki qava-i naulluuvigmicetun neqet ukut caliaqluki."
        },
        "19": {
            "start": 422.02,
            "end": 431.92,
            "transcript": "Tamatumun au͡g'umun qanrutellranun assiiruyutek'lallra-wa neqem pinritengnaqevkarluki."
        },
        "20": {
            "start": 431.92,
            "end": 441.7,
            "transcript": "Assirluteng tua-i waniw' ukut au͡gkut Yugtun nalluanek pollack-aanek pillrit neqet-wa tua-i imarpigmiutaat."
        },
        "21": {
            "start": 441.7,
            "end": 453.18,
            "transcript": "Tamakut tamaani caliaq una wani avani Korea-mi pillrullinia, tarenraq kiugna."
        },
        "22": {
            "start": 463.92,
            "end": 475.18,
            "transcript": "Kiugna-ll' kia-i cali waten makunek atulallruut ikugcuutnek neqet tua-i piciatun kapurluki ikugaqluteng qagkunek aturluteng."
        },
        "23": {
            "start": 485.76,
            "end": 495.18,
            "transcript": "Au͡gna-ll' ava-i ciuqlirmi au͡gkut neqnun atuusqumanritut mat'um maa-i nalliini tun'arkanun."
        },
        "24": {
            "start": 495.18,
            "end": 507.18,
            "transcript": "Kiugkuk-llu kia-i neqek una wani alailnguq imna neq au͡g'ukun ikugcuutekun kapumalriik neqa."
        },
        "25": {
            "start": 519.36,
            "end": 532.16,
            "transcript": "Ukuk-gguq wani pacific perch-auguk Yugtun wii nalluagka kia-i-gguq pingnaqullia."
        },
        "26": {
            "start": 532.16,
            "end": 545.2,
            "transcript": "Au͡g'ukun ikugcuutnun pillra unguvaluku atlia-llu kiugna tuqumariluku."
        },
        "27": {
            "start": 562.9,
            "end": 576.12,
            "transcript": "Ukuk-llu waniw' ava-i au͡gkuk ciuqlirmi tangelput waniw' kemgak au͡g'arluku qava-i alaunani kiugna qulliq."
        },
        "28": {
            "start": 576.18,
            "end": 591.18,
            "transcript": "Unguvaluku ikugcuutmek kapluku, atlia-llu kan'a, kana-i cali tuqumariluku au͡g'um ciuqlim tangvallemta ayuqii."
        },
        "29": {
            "start": 615.56,
            "end": 628.0,
            "transcript": "Qullik'acagaq-llu kia-i imna au͡gna unguvaluku ikugcuutmek kapleq kia-i aunraqallrek alaunatek."
        },
        "30": {
            "start": 628.0,
            "end": 642.02,
            "transcript": "Atlia-ll' kanani au͡gna imna tuqumaluku pillra alaitessiiyaagpek'nani qama-i iniumayaaqellra alaitevkenani."
        },
        "31": {
            "start": 673.88,
            "end": 686.48,
            "transcript": "Pika-i-ll' pikegkuk ukuk wani au͡gkut assiiruyutek'lallrit qullik'acagiini kapumalria pingna."
        },
        "32": {
            "start": 686.48,
            "end": 688.44,
            "transcript": "Avaggun ikugcuutkun."
        },
        "33": {
            "start": 689.18,
            "end": 703.1,
            "transcript": "800 million amllertalriit tuani qullik'acagiini, au͡gkut imkut assiiruyutek'lallrit."
        },
        "34": {
            "start": 703.1,
            "end": 718.94,
            "transcript": "Tua-i-ll' yaani maani pimanrilngurmi 300 thousand, 300."
        },
        "35": {
            "start": 718.94,
            "end": 723.18,
            "transcript": "Ikgellruluni 300-aami avani."
        },
        "36": {
            "start": 741.92,
            "end": 749.08,
            "transcript": "Ukuk-llu ava-i cali waten unguvangraan tuqumangraan-llu."
        },
        "37": {
            "start": 749.08,
            "end": 755.28,
            "transcript": "Au͡gkut imkut ikugcuutet atuusqumanritut waten."
        },
        "38": {
            "start": 755.28,
            "end": 768.18,
            "transcript": "Waten catailngermi kanani au͡gna aunrallra kana-i tau͡gaam imkut assiiruyutek'lallria amllertateklutek ukuk ayuqellinilutek waniwa."
        },
        "39": {
            "start": 768.18,
            "end": 779.82,
            "transcript": "Kan'a aunrallra alaitenrilngermi makut-gguq ikugcuutet maa-i mat'um nalliini inerquutngurtut."
        },
        "40": {
            "start": 798.34,
            "end": 812.12,
            "transcript": "Makut-llu maani neqet wangkuta mat'um assiirutellratnun cukaircaryugngalliniarput waten kumlaqu'urtelluki akertemun pivkaqsaunaki."
        },
        "41": {
            "start": 812.12,
            "end": 821.22,
            "transcript": "Tamaaggun tua-i assiirutngermi assiirutellra cukaiqanirpagciqliniuq."
        },
        "42": {
            "start": 821.22,
            "end": 826.18,
            "transcript": "Tamaaggun kumlacet-llu, kumlaqu'urtelluku neqa pikan."
        },
        "43": {
            "start": 849.72,
            "end": 860.48,
            "transcript": "Au͡gkut-llu ava-i waten qanrutek' wangkuta-w' tua-i maani amllerni neqauteput patuitelaata."
        },
        "44": {
            "start": 860.48,
            "end": 873.18,
            "transcript": "Wangkutnun elitnaurutekluki makut piit ilait au͡gkut waten neqet ciuqlikacagauluku-gguq neqa man'a elluarrluku aulukumarkauguq."
        },
        "45": {
            "start": 873.18,
            "end": 885.2,
            "transcript": "Tungiini-llu au͡gkut ikugcuutet aturpek'naki, nangneqlikacaar-llu neqa kumlaqu'urtelluku."
        },
        "46": {
            "start": 919.26,
            "end": 932.86,
            "transcript": "Au͡gkut-ll' avani ukut wani qalarutkai imkut-wa tua-i qamani iluani neqem aqsaqurrni."
        },
        "47": {
            "start": 932.86,
            "end": 942.24,
            "transcript": "Au͡gna imna ner'aqameng neqem nerellrita qam'um pilallra."
        },
        "48": {
            "start": 942.24,
            "end": 950.82,
            "transcript": "Tua-i-w' neqet makut anaurcet'laqai iluani tamatumek."
        },
        "49": {
            "start": 965.5,
            "end": 976.98,
            "transcript": "Tamana-llu-gguq tamaani iluatni qamani aqsaqatni-wa uitalartuq."
        },
        "50": {
            "start": 1008.5,
            "end": 1018.52,
            "transcript": "Ukuk-llu waniw' tarenrami neqek tamatum tua-i au͡g'um."
        },
        "51": {
            "start": 1018.52,
            "end": 1028.3,
            "transcript": "Yuvgertun ayuqluku aqsaqurrani qamani iluani tamatum tua-i assiirutevkarluki qava-i kiugkut."
        },
        "52": {
            "start": 1028.3,
            "end": 1037.6,
            "transcript": "Kiugna atauciq iqsulirnermi uitalria utumaluni-w' qukaqliq-llu cali."
        },
        "53": {
            "start": 1037.6,
            "end": 1047.68,
            "transcript": "Tau͡gaam una tallirpilirnerani uitalria assiitqapiarluni imkuit-llu."
        },
        "54": {
            "start": 1047.68,
            "end": 1055.18,
            "transcript": "Melui-llu assiinateng waten makut maa-i tamatum assiirutevkallri."
        },
        "55": {
            "start": 1067.28,
            "end": 1075.62,
            "transcript": "Au͡gna-ll' ava-i aqsaqurra makut kiingan pivkenak tamatum tua-i au͡g'um assiirutevkallri."
        },
        "56": {
            "start": 1075.62,
            "end": 1083.14,
            "transcript": "Kiingan tua-i pivkenaku man'a-ll' kemga qava-i qagkut tulimai-llu kiirarkaqliniluteng."
        },
        "57": {
            "start": 1083.14,
            "end": 1088.48,
            "transcript": "Ugaani assiirutem uum ilua neqem."
        },
        "58": {
            "start": 1104.08,
            "end": 1111.5,
            "transcript": "Una-ll' waniw' tua-i unani pillrat imarpigmek waten."
        },
        "59": {
            "start": 1111.5,
            "end": 1120.66,
            "transcript": "Kiugna tua-i aqsaqurra assiinani meluut-llu makut assiitqapiarlutent kia-i."
        },
        "60": {
            "start": 1120.66,
            "end": 1130.74,
            "transcript": "Makut-gguq wavet Japan-inun pilaamegteki meluit, meluit makut waten ayuqellriit Japan-it piyuumiitelarait."
        },
        "61": {
            "start": 1145.68,
            "end": 1156.84,
            "transcript": "Au͡gkut-llu tua-i ava-i au͡g'um waten-wa iliini Yugtun yuut ilait pilarait."
        },
        "62": {
            "start": 1156.84,
            "end": 1167.96,
            "transcript": "Aqsaqurra-wa qilunglliqerniluku qilunglliqellran waten assiirulluku qava-i qagkut-llu imkucirluki."
        },
        "63": {
            "start": 1167.96,
            "end": 1176.08,
            "transcript": "Tulimayagaat ceverqusngaluteng [?] qavani imumi amicaariini."
        },
        "64": {
            "start": 1176.08,
            "end": 1181.68,
            "transcript": "Assiinateng tua-i qilunglliqallra assiirutevkarluni."
        },
        "65": {
            "start": 1197.72,
            "end": 1213.4,
            "transcript": "Au͡gkut-llu avani ava-i-gguq waten nerlut arcaqerluteng aqsaqurrit assiirutellrit cukauq, cukanruuq makuni nerailngurni."
        },
        "66": {
            "start": 1213.4,
            "end": 1220.74,
            "transcript": "Ner'arluteng tua-i aqsaqurrat imaq cukamek assiirutelarkauluni aqsaqurrat."
        },
        "67": {
            "start": 1236.32,
            "end": 1244.78,
            "transcript": "Makut-llu-am maani tuaten tamaaggun tamana qilunglliqallra-wa."
        },
        "68": {
            "start": 1244.78,
            "end": 1257.48,
            "transcript": "Waten assinrulliniuq cukaillruluni-ll' assiirutellra neqem egmianun tua-i aqsaqurrirluku tuani aqsaqut ilua-llu carrirluku."
        },
        "69": {
            "start": 1273.5,
            "end": 1282.72,
            "transcript": "Tamakut-llu aqsaqurrilriani au͡gkut waten imkut aqsaqurrani qamani pilakaquluki."
        },
        "70": {
            "start": 1282.72,
            "end": 1292.18,
            "transcript": "Tamakut pilriani tamakut anlalliniut maavet aqsaqurran elatiinun tamana, qamavet iluatnun cekavvluni."
        },
        "71": {
            "start": 1315.64,
            "end": 1330.02,
            "transcript": "Makut-llu maani cali neqet maa-i, makut-wa tua-i kipucetet waten makut meliit piu tunyulaamegteki ellmeggnek akituata-llu."
        },
        "72": {
            "start": 1330.02,
            "end": 1337.58,
            "transcript": "Maani makut kipucetet aqsaqurtuumaita piularait aqsaqurrirpek'naki."
        },
        "73": {
            "start": 1337.58,
            "end": 1353.12,
            "transcript": "Tamaaggun tua-i waten tau͡gaam assinrulliniuq wangkutnun tuaten pisciigalamteki, aqsaqurrirluki pisciigalamteki kumlatengnaqluki tua-i egmianun pivkararkauluki."
        },
        "74": {
            "start": 1377.54,
            "end": 1385.66,
            "transcript": "Au͡gkuk avani tuaten assiirutesqumavkenaku qilunglliqaasqumanrilkumteggu-llu."
        },
        "75": {
            "start": 1385.66,
            "end": 1393.9,
            "transcript": "Aqsaqurrirluku egmianun wall'u aipaani aqsaqurrim anelkiin [?]."
        },
        "76": {
            "start": 1393.9,
            "end": 1406.18,
            "transcript": "Egmianun tua-i-wa puqlamun pivkarpek'naku patumaluku maani wangkuta kumliviilamta."
        },
        "77": {
            "start": 1427.16,
            "end": 1440.2,
            "transcript": "Uumek-wa wani qalarteqatartukuk neqet qaillun piluteng assiirut'lallrat wall'u."
        },
        "78": {
            "start": 1440.2,
            "end": 1453.86,
            "transcript": "Qaillun-wa tua-i piluteng aulukcurlaamaaqameng-llu assiirut'lallrat tamatumek qalarteqatartua neqet."
        },
        "79": {
            "start": 1453.86,
            "end": 1457.18,
            "transcript": "Tangrruluteng-wa tua-i tarenrairitnun piciqai."
        },
        "80": {
            "start": 1474.0,
            "end": 1486.12,
            "transcript": "Makut-llu waniw' ukut wani alailnguug slide-ami."
        },
        "81": {
            "start": 1486.12,
            "end": 1503.08,
            "transcript": "Ukut waniw' neqet puyuqat-wa makut assirluki pingnaq'lalliniut assilriarrlainarnek tamakunek pingnaq'lalliniut waten puyuqiqatarqamek akmani."
        },
        "82": {
            "start": 1527.58,
            "end": 1535.5,
            "transcript": "Waten-llu makut kia kiugna caqumaluni plastic-aamek pilria."
        },
        "83": {
            "start": 1535.5,
            "end": 1544.72,
            "transcript": "Neqa aciani unani atlirnerani qagkut augyarneret ayuqellria kia."
        },
        "84": {
            "start": 1544.72,
            "end": 1552.6,
            "transcript": "Waten-gguq pilriit tua-i-wa piyuksaitelarait waten ayuqellriit neqet."
        },
        "85": {
            "start": 1561.36,
            "end": 1570.2,
            "transcript": "Makut-llu cali tua-i-w' kiputellriit piyuksaitelalliniut waten ayuqai."
        },
        "86": {
            "start": 1570.2,
            "end": 1581.38,
            "transcript": "Qamaggun iliitgun pingraata wall'u qaingitgun waten callar' tua-i-ll' allguumaluni man'a kemgat ikirqumaluni."
        },
        "87": {
            "start": 1597.44,
            "end": 1609.46,
            "transcript": "Kiugna-ll' kia kiugna cali kia-i uuggun uyaquminun nuniitnun [?] amia-wa ukirqumaluni."
        },
        "88": {
            "start": 1609.5,
            "end": 1618.4,
            "transcript": "Tuaten-gguq waten pimalriit allguumalria man'a amiat assiiruyutek'laraat kemgat."
        },
        "89": {
            "start": 1618.4,
            "end": 1628.9,
            "transcript": "Taumek-gguq ava-i inerquuskait makut ikugcuutet imkut, kapurluki ikugcuutet."
        },
        "90": {
            "start": 1641.62,
            "end": 1655.1,
            "transcript": "Makut-llu waten alqai amiit-wa allguumalriit wall'u augyarnelget augyarneret-gguq amlleq au͡g'alaraat kemgatni tuaten."
        },
        "91": {
            "start": 1655.1,
            "end": 1663.18,
            "transcript": "Tua-i-wa kemgat mat'umek assilriamek pingnaqaqameng neq'liurtet."
        },
        "92": {
            "start": 1675.3,
            "end": 1687.66,
            "transcript": "Kiugna-ll' kia-i cali una wani neqa qupumalria qava-i teqsuqaminun nuniikun augyanerluni."
        },
        "93": {
            "start": 1687.66,
            "end": 1699.54,
            "transcript": "Qainga-gguq tua-i asqapiarluni qamaggun tau͡gaam enran tulican uivain nuniitgun."
        },
        "94": {
            "start": 1699.54,
            "end": 1705.52,
            "transcript": "Tamaaggun taqeq kep'arciman, au͡gna augyanerluni."
        },
        "95": {
            "start": 1729.38,
            "end": 1738.24,
            "transcript": "Kiugna-ll' cali kia-i waten neqa assiryaaqellriim watua kiani augna-ll' augyarneruluni."
        },
        "96": {
            "start": 1738.24,
            "end": 1746.12,
            "transcript": "Waten tegulacurlallermikun qau͡gna kemga itumumaluni."
        },
        "97": {
            "start": 1746.12,
            "end": 1752.88,
            "transcript": "Qava-i alaunateng kiugumi atlirmi kemga qau͡gna qupuumaluni nallunaunani."
        },
        "98": {
            "start": 1752.88,
            "end": 1764.3,
            "transcript": "Qaingani tau͡gken callarpailegmi assillruluni assiryaaqluni, tau͡gaam qaugna qava-i cali itumumalriit waten piyuksaitelalliniut."
        },
        "99": {
            "start": 1784.1,
            "end": 1796.04,
            "transcript": "Au͡gkut-llu avani ava-i malruk kinguqliik slide-ak-wa tarenrak au͡gkuk alaiteqallra kinguqlikacagaak."
        },
        "100": {
            "start": 1796.04,
            "end": 1811.84,
            "transcript": "Maaken pillrulliniuk tegulacurlaumallermun wall'u tayima egqaqumallermegnegu  wall'u teqsuqurritmun tegulallragnek."
        },
        "101": {
            "start": 1822.18,
            "end": 1836.64,
            "transcript": "Neqet-gguq makut tegulacurlayunaitut wall'u egqaqluteng wall'u milqaulluki-w' tua-i piyunaitut waten tun'arkat."
        },
        "102": {
            "start": 1857.64,
            "end": 1870.48,
            "transcript": "Au͡gkuk-llu ava-i waten au͡gkunek malrugnek pilalliniuq au͡gkuk-wa tarenrak malruk."
        },
        "103": {
            "start": 1870.48,
            "end": 1881.78,
            "transcript": "Waten mat'umek tegulacurlallerminek wall'u teqsuqvakun teguluki kevguurluku wall' egqaqellranek."
        },
        "104": {
            "start": 1902.56,
            "end": 1913.46,
            "transcript": "Au͡gkut-llu-gguq cal' ava-i waten ava-i qanrutkuralpuk au͡gkut ava-i waten pinritet'"
        },
        "105": {
            "start": 1913.46,
            "end": 1931.9,
            "transcript": "Waten-wa tua-i neqautput assiisqumakumteki au͡gkut waten tegulacurlagpek'naki wall'u egqaqevkenaki wall'u ikugcuucetgun kapurpek'naki assiisqumakumteki neqet."
        },
        "106": {
            "start": 1952.18,
            "end": 1962.18,
            "transcript": "Au͡gkut-llu maa-i qalarutkarkai au͡gkut ukut wani iqaluteng uqlarluteng neqet."
        },
        "107": {
            "start": 1962.18,
            "end": 1976.6,
            "transcript": "Tamana-llu-gguq qanernairutaunani iqallrat neqet waten iqaluteng pikuneng qanernairutarkait, qanernairutaitarkauluteng."
        },
        "108": {
            "start": 1995.5,
            "end": 2006.98,
            "transcript": "Ukut-llu waniw' tarenrami kiani slide-ami uitalriit iqa' uqlarluteng uqlaqapiarluteng tayima iliit."
        },
        "109": {
            "start": 2006.98,
            "end": 2019.88,
            "transcript": "Ukut neqet waten nutarayaaqeng'e'rmeng uqlaquneng cukameng assiirutellrat egmianun ilii makunek egmian cukaqapiamek assiirutarkauluteng."
        },
        "110": {
            "start": 2029.08,
            "end": 2036.32,
            "transcript": "Makut-llu cali maa-i waten imumek qau͡gyamek patusqumanritliniut."
        },
        "111": {
            "start": 2036.32,
            "end": 2049.12,
            "transcript": "Patukuneng tua-i waten qau͡gyarrliquneng-wa tua-i qaingat assiirutellrat imumek tua-i assiirutellra cukacararkauluki qakia patukuniki."
        },
        "112": {
            "start": 2067.72,
            "end": 2074.26,
            "transcript": "Una-ll' kiugna-ll' tua-i kia-i nunakuarcuutem kinguani neqnek pilria."
        },
        "113": {
            "start": 2074.26,
            "end": 2083.44,
            "transcript": "Man'a tua-i ava-i qanrutekii iqaluteng qaingit makut marayirluteng uqlarluteng."
        },
        "114": {
            "start": 2083.44,
            "end": 2093.82,
            "transcript": "Waten imumek ikugcuutmek kapurluki qaingitgun tamana tua-i arcaqerluni cali assiirutellrat."
        },
        "115": {
            "start": 2093.82,
            "end": 2099.1,
            "transcript": "Neqet waten cukaq'apiarrarkauluni."
        },
        "116": {
            "start": 2114.2,
            "end": 2123.98,
            "transcript": "Makut-llu maa-i kiugna kia-i tarenraq ciivagnek imarluni plastic-aaq qau͡gna."
        },
        "117": {
            "start": 2123.98,
            "end": 2135.72,
            "transcript": "Plastic-aamek waten patu' unaitelliniut akercirluku egmianek akertem uuciiqai. Ilua qamna man'a qainga elalirnera anuqling'e'rmi."
        },
        "118": {
            "start": 2135.72,
            "end": 2141.36,
            "transcript": "Ilua qamna patumakuneng uuqnarqapiararkaulliniuq."
        },
        "119": {
            "start": 2153.8,
            "end": 2161.38,
            "transcript": "Kiugna-ll' tua-i kia-i plastic-aamek patumaluteng kiugkut neqet."
        },
        "120": {
            "start": 2161.38,
            "end": 2168.84,
            "transcript": "Au͡gkut-wa ciiviit iluani pilriit tamana puqlinrinrat'em [?] acia."
        },
        "121": {
            "start": 2180.88,
            "end": 2194.36,
            "transcript": "Man'a-ll' kia kiugna cali kiugna anaqaitnek wangkuta pilaqeput ciiviita anaqiit kiugna neqa."
        },
        "122": {
            "start": 2194.36,
            "end": 2210.96,
            "transcript": "Tamakut cali imkut waten ayuqellriit au͡gkut FDA-nek pilallrit Food and Drug Administration-aata tamana inerquuteksulriit waten man'a waten."
        },
        "123": {
            "start": 2210.96,
            "end": 2215.44,
            "transcript": "Ciivagnun neqet tun'arkat pisqevkenaki."
        },
        "124": {
            "start": 2231.26,
            "end": 2239.26,
            "transcript": "Una-ll' cali kana-i kan'a angyam ilua tarenrairumalria-ggua tarenrairumalria."
        },
        "125": {
            "start": 2239.26,
            "end": 2246.12,
            "transcript": "Un'a tua-i una-i uqurrlirluni kaassarrlirluni tayima."
        },
        "126": {
            "start": 2246.12,
            "end": 2256.64,
            "transcript": "Tamana-gguq neqet makut maani mat'umun tua-i-wa assiirutessiiyaagngaicaaqlilriit."
        },
        "127": {
            "start": 2256.64,
            "end": 2264.9,
            "transcript": "Tau͡gaam tepiit au͡gna assirngaunani au͡g'aqayuilaminek kaassarninarqellria neqa."
        },
        "128": {
            "start": 2278.5,
            "end": 2289.5,
            "transcript": "Kiugna-ll' kia-i imna imegcuutnek-wa pilaqait drum-at salmon drums."
        },
        "129": {
            "start": 2289.5,
            "end": 2298.34,
            "transcript": "Tauna tua-i iluanun imna imegturluku akagturluki kiugna avani pitukait."
        },
        "130": {
            "start": 2298.34,
            "end": 2307.68,
            "transcript": "Tauna-gguq kia kiugna grease-amek kiugna imilalliniami aciani kucirluku."
        },
        "131": {
            "start": 2320.22,
            "end": 2334.36,
            "transcript": "Waten-gguq tau͡gaam waten neqet caqumaluteng assinruut kiugum kia-i tub-at iluatni neqet ekumaciicetun."
        },
        "132": {
            "start": 2334.36,
            "end": 2340.02,
            "transcript": "Assirniluku-ll' kiugna waten piluni tau͡gaam patumavkenateng."
        },
        "133": {
            "start": 2357.18,
            "end": 2366.36,
            "transcript": "Au͡gkunek tua-i elluarrluteng avani waten aulukumakuneng wall'u elluarrluteng caquliumaluteng pikuneng."
        },
        "134": {
            "start": 2366.36,
            "end": 2379.16,
            "transcript": "Ava-i pillratun waten kaassaq wall'u uqulkuk neqem pianun pimaaqami."
        },
        "135": {
            "start": 2379.16,
            "end": 2386.76,
            "transcript": "Tepii au͡g'artesciigat'lartuq egmian au͡g'arciiganani-llu kaassarninarqellria."
        },
        "136": {
            "start": 2386.76,
            "end": 2395.12,
            "transcript": "Tamana tamaa-i piluku caqukegcarluki neqet pinarqai."
        }
    },
    "5RFXaM2ty1E": {
        "1": {
            "start": 244.66,
            "end": 251.94,
            "transcript": "Qanganaruanek naunrarnek-wa tua-i iinrutullrulriit yuut imumi."
        },
        "2": {
            "start": 251.94,
            "end": 271.2,
            "transcript": "Iinrut hospital-aartangvailgan, Kass'artangvailgan yuut iinruktullruit nunamiutaat maani nunam qaingani cat naumalriit-llu iinruktullruit ukvekluki-wa pitullruit."
        },
        "3": {
            "start": 271.2,
            "end": 284.4,
            "transcript": "Tuaten-llu assirivkarkauciit nalluvkenaki asgurakevkenaki calluvkelrianek piciurtetuami [?]. Asgurakevkenaki assiritngungaicukluku-llu umyuaqevkenaki."
        },
        "4": {
            "start": 284.4,
            "end": 293.0,
            "transcript": "Tau͡gaam assirillnguarkauciatnek neryuniurutet-llu atutullruit imumi cat makut iinrutet."
        },
        "5": {
            "start": 296.32,
            "end": 309.38,
            "transcript": "Tamakut-mi qanganaurat qaillun atulallruatki [?]."
        },
        "6": {
            "start": 309.38,
            "end": 323.12,
            "transcript": "Tua-i-wa meqluki meq'aquurluki igqaquurluki pitukait makut-ca tua-i kevraartut-llu cuyait qanganaruat-llu atsaruat-llu. Atsaruat-wa tua-i nallullikci tayima."
        },
        "7": {
            "start": 323.12,
            "end": 335.42,
            "transcript": "Naumalriit naulallret nunat yuut tutmallritni nunallerruartalegni tamakut nautuut. Makut-llu qanganaruat yulliaguralriami tau͡gaam nautuut."
        },
        "8": {
            "start": 335.42,
            "end": 344.14,
            "transcript": "Makut-llu atsaruat cali yuut nunakellruaraitni cali nautuut, naunqegtuut."
        },
        "9": {
            "start": 344.14,
            "end": 360.64,
            "transcript": "Allami piciatun nauyuunateng tau͡gaam yullialriami tutmallret yuut tarritellratni nunallritni nauyunqelartut qanganaruat atsaruat-llu. Iinrut tua-i-w' tamakut tamaa-i iinruktullrit imumi."
        },
        "10": {
            "start": 360.64,
            "end": 378.92,
            "transcript": "Ukvekluki-w' tua-i pitullrukait assirit' iinrumek nuuqitellermeggni yuut. Iinrukaqluki canun, tamakunun-llu tamaa-i qamaggun pugtautemegteggun apqucingelrianun imkunek ukinernek."
        },
        "11": {
            "start": 378.92,
            "end": 394.14,
            "transcript": "Tamaa-i atutullruit-llu carraururluku erneq tamalkuan meq'aquurluku kenirraarluku qallarvautelluku mer'a allakarluku mer'irluki."
        },
        "12": {
            "start": 394.14,
            "end": 401.14,
            "transcript": "Merrlainauluku aturaqluku. Temai tamakut uitalluki. Mer'it tau͡gaam."
        },
        "13": {
            "start": 401.14,
            "end": 408.14,
            "transcript": "Ilaita tua-i assiritketuut. Tua-i-wa ukvestaita assiritketullikait."
        },
        "14": {
            "start": 408.14,
            "end": 423.96,
            "transcript": "Mat'um-llu-wa maa-i ellamta nalliini uitang'e'rmeng iinrut makunek Kass'anek iinrunek aruqestemeggnek yuut iinrututuli pimangermeng asgurakekunegteggu ikayuutekngailkiit."
        },
        "15": {
            "start": 423.96,
            "end": 437.14,
            "transcript": "Tau͡gaam ukvekluku pikunegteggu iinruq assiritkarkaucia nalluvkenaku tangvalriatun ciunrem pikunekteggu assiritkeciqekiit."
        },
        "16": {
            "start": 437.14,
            "end": 447.66,
            "transcript": "Takliriuq. Kitak tua-i-am pii qitevten. Tauna waten."
        },
        "17": {
            "start": 528.54,
            "end": 534.76,
            "transcript": "Qavcini yugtun taringetutuut?"
        },
        "18": {
            "start": 534.76,
            "end": 536.12,
            "transcript": "Ikgetut."
        },
        "19": {
            "start": 546.78,
            "end": 558.36,
            "transcript": "Tua-i-w' au͡gkut qanrutkellrenka kiimeng iinrugtullrunrilkait, tau͡gaam amllertut atam Yupiit iinruktullrit."
        },
        "20": {
            "start": 558.36,
            "end": 570.04,
            "transcript": "Atsat-llu imkut kavirlit kenirluki, tua-i-ll' massarralicuarluki carrarmek kenirraarluki."
        },
        "21": {
            "start": 570.04,
            "end": 578.2,
            "transcript": "Tuaten tua-i mertuumaita saskaq tua-i qukarpek'naku [?] carrarmek imiqerluku."
        },
        "22": {
            "start": 578.2,
            "end": 592.52,
            "transcript": "Tauna tua-i yuum igyariqelriim-llu man'a qat'gani assiilkan quserluni cakneq pikuni kineryugluku-llu qamna igyaraq."
        },
        "23": {
            "start": 592.52,
            "end": 602.84,
            "transcript": "Tamakut atam tamaa-i kavirlit assiqapiartut, wiinga-llu atutullruanka. Maa-i-llu call' mat'um nalliini wii atutuanek."
        },
        "24": {
            "start": 633.7,
            "end": 645.26,
            "transcript": "Waten-llu-ggem niitelartua au͡gkut ava-i caiggluut."
        },
        "25": {
            "start": 656.02,
            "end": 661.1,
            "transcript": "Tamaana wii atuqsailamku nalluaqa. Tuaten piqaqsailama."
        },
        "26": {
            "start": 661.1,
            "end": 672.72,
            "transcript": "Nallukemnek wii qalarteksaitua uumirpak, maani qalartengrraanemnek. Tamana atuqaqsailamku ayuquciatun qanrutkesciigataqa."
        },
        "27": {
            "start": 672.72,
            "end": 684.54,
            "transcript": "Tuaten qallarvautelluki puqlamek anllugtelluki usgunernun pillra atuqaqsailamku qanrutkesciigataqa elisnganritaqa."
        },
        "28": {
            "start": 684.54,
            "end": 693.06,
            "transcript": "Tau͡gaam elisngakemnek atullemnek-llu wiinga uumirpak piurtua qalartellemnek."
        },
        "29": {
            "start": 693.06,
            "end": 702.82,
            "transcript": "Piciulriamek-wa tua-i pillemteńek pingnaqlua nallukemnek pivkenii nallunrilkemnek tau͡gaam."
        },
        "30": {
            "start": 702.82,
            "end": 717.94,
            "transcript": "Ca tua-i iinrungssiit iinrungssakevkatullrit imkut ciuliamta ilaita atullrenka nallunritanka maa-i. Maa-i nallunrilkemnek qanlartua."
        },
        "31": {
            "start": 800.3,
            "end": 813.26,
            "transcript": "Una-w' tua-i waniw' au͡gkunek tua-i iinrurrlainarnek pillilrianga, una pillertaqa iinruurtellriarrlainarnek-qaa waniw' wani iluani uum qanerkangqertua?"
        },
        "32": {
            "start": 813.26,
            "end": 834.9,
            "transcript": "Tauna wani qanganaruanun, napat, cuyaitnek, cuyamek, napat qeltaitnek, uquq, teq'uq, kangivvlu [?], atsat, ukut qanrutellruatnek, angeryuk, qimugkauyarat-llu anait."
        },
        "33": {
            "start": 834.9,
            "end": 848.54,
            "transcript": "Yaa, nallukeka-w' tua-i ilait-wa tua-i nallukenka makut atuqsailama, tua-i-w' tau͡gaam atullemnek qalartellrianga tua-i canek iinrumssakcetut'ullruitkut iimumi."
        },
        "34": {
            "start": 848.54,
            "end": 856.12,
            "transcript": "Canek tua-i ilaita im' wani uitanritut uumi kalikarmi, nalluamegteki-w' tua-i pillikait."
        },
        "35": {
            "start": 856.12,
            "end": 866.98,
            "transcript": "Cat imkut, imkunek-llu tuaten kineryugluta igyariqaqamta canek iinruarturcetektullruitkut."
        },
        "36": {
            "start": 866.98,
            "end": 882.06,
            "transcript": "Au͡gkunek-llu imkut paluqtaat iguukelarait imkut elalirnermi kanani kupelriani, kanani ellami uitaluteng amimek tau͡gaam qallirluteng iguukelalliit."
        },
        "37": {
            "start": 882.06,
            "end": 896.1,
            "transcript": "Tamakut tua-i qagercaaqevkenaki amiilaqeput, agturyaaqevkenak tepsaqpiarluteng cakneq, atam iinrurninaq'ngat'lartut tamaa-i tamakut, tamakut-llu tamaa-i kinercirluki."
        },
        "38": {
            "start": 896.1,
            "end": 906.38,
            "transcript": "Tua-i-llu kinraki quselriamun carraquineq, tua-i tangrrunritluku carraquineq tuaken tuknipiartut."
        },
        "39": {
            "start": 906.38,
            "end": 922.74,
            "transcript": "Carraquineq qanermun elliluku, tua-i-ll' iqmigluku meq tua-i ig'aqluku, tauna kuinrayagaq [?] tuknipiartuq, iinrurninaq'ngatetuut atam, tuar-llu kegguciqsuucecugninaq'ngat'lalriit."
        },
        "40": {
            "start": 922.74,
            "end": 932.0,
            "transcript": "Atutullruanka-llu wii tamakut aanama aturcetullranek. Tua-i assiritngutuut mat'umun-llu."
        },
        "41": {
            "start": 932.0,
            "end": 949.34,
            "transcript": "Tamaa-i cali nallunrilkemnek cali atsaruat, au͡gkut naucetaat tamakut tua-i au͡gkut qanrutkellrenka kangrit yellow-aarrauluteng waten, green-aayaarnek waten ava-i arluteng [?]."
        },
        "42": {
            "start": 949.34,
            "end": 965.76,
            "transcript": "Tamakut tamaa-i nauyunqegtut yuut nunallritni, nauyunqellriit uum makut qanganaruat apqaita makut camiut qagkumiut caiggllugnek pitukaita ayuqait tamakut."
        },
        "43": {
            "start": 966.42,
            "end": 979.44,
            "transcript": "Pekcarani yuum tutmallrani tarritellrani nauyunqellriit, naumayunqellriit. Tamakut cali tamaa-i kepluki aciit pivkenaki."
        },
        "44": {
            "start": 979.44,
            "end": 994.04,
            "transcript": "Qulvaarkun kepluki kenirluki qallarvautelluki, mer'at-llu cali teguluku, tamakut-llu tua-i atullruamki nallunrila'atqapiggluki waniw' qanrutek'eqataranka."
        },
        "45": {
            "start": 994.04,
            "end": 1009.08,
            "transcript": "Tamakut atullruanka panimnun naulluutengellrani imumi amlleret yuut nallunritaat aumikun, augani uitaluni apqucia, yuungcaristem-llu."
        },
        "46": {
            "start": 1009.08,
            "end": 1025.1,
            "transcript": "Tua-i six-aaniiraluni temiini uitaarkaunritniluku qanrullua, elliin-llu yuungcaristem qanrullua una wani panika ikayurviitniluku."
        },
        "47": {
            "start": 1025.1,
            "end": 1039.78,
            "transcript": "Six-aaniiraluni tamana augani apqucia uitalria, quverpangluni-ll' kegginaa, nuyai-llu meqluteng, iinrut-wa tua-i Kass'artaat pingalkait meqevkarngalget [?]."
        },
        "48": {
            "start": 1039.78,
            "end": 1050.78,
            "transcript": "Wiinga tua-i nanikuallruunga, kinguqlikacagauluku irniaqngamku nangenruluku nasaurluq."
        },
        "49": {
            "start": 1050.78,
            "end": 1066.48,
            "transcript": "Tua-i-llu nanikuallemni waten umyuarteqellruunga, wiinga wangnek nangerrllua ikayuutekaanek temiin piyugtua."
        },
        "50": {
            "start": 1066.48,
            "end": 1083.48,
            "transcript": "Tuaten-llu pirraarlua atullemnek waniw' qanemcitamci, piicallruunga tau͡gaam agayutmun ikayuusqellua, elliin uum ellarpak piliaqellruniluku naunrartuumaat."
        },
        "51": {
            "start": 1083.48,
            "end": 1089.92,
            "transcript": "Wiinga tamaaken tegullua una temii uum ikayuryugluku."
        },
        "52": {
            "start": 1089.92,
            "end": 1106.2,
            "transcript": "Umyuarteqngama-llu calivimni calissuutemni nuussicuagka tegullruagka arenqialama qiangama qunuama, qunulua."
        },
        "53": {
            "start": 1106.2,
            "end": 1117.76,
            "transcript": "Tegulukek yuungcarista annganemnek at'agesciigalingan [?] piavet atrarluni tau͡gaam wii qalarut'larturlua."
        },
        "54": {
            "start": 1117.76,
            "end": 1135.24,
            "transcript": "Tua-i-llu tuaten piama nuussicuak tegulukek anlua, anngama-llu anua enem yaani keluani kuinacuaraat [?] tamakut atsaruat, yellow-arrarnek kangelgit naumalriit."
        },
        "55": {
            "start": 1135.24,
            "end": 1144.18,
            "transcript": "Ullagluki-llu egmianun taukut saaniicuarmek patuirluku mikcuarmek tegumiarlua."
        },
        "56": {
            "start": 1144.18,
            "end": 1154.96,
            "transcript": "Tekicamki-llu elliluku caniatnun ciugglua qanerlua ikayuusqellua makut-gguq."
        },
        "57": {
            "start": 1154.96,
            "end": 1168.34,
            "transcript": "Tua-i-llu-w' taukut kangrit kepluki nuussicuarluki, assikluki cali kepraarluki, ek'aqluki tua-i qanerturlua, ekraarluki itrama kuvluku puqlamek."
        },
        "58": {
            "start": 1168.34,
            "end": 1180.38,
            "transcript": "Qallarvagturtelluku atsaruat kangrit, atsaruat-wa tua-i temeqvaarkun maaggun iquit yurangqaluteng, maaggun temeqvaarkun kep'aqluki."
        },
        "59": {
            "start": 1180.38,
            "end": 1189.82,
            "transcript": "Tua-i-llu glass-agnun malrugnun saaniicuaraami maa-i mer'irluku."
        },
        "60": {
            "start": 1189.82,
            "end": 1197.82,
            "transcript": "Mer'irraarluku-ll' taukunun elaturramun elliluku, nengllacirluku, nenglliaku-llu."
        },
        "61": {
            "start": 1197.82,
            "end": 1215.18,
            "transcript": "Tauna nasaurluq piaqa uuggun ikayuqaat ikayungnaqeq'ata'arqa temen asguraksaqunaku umyuarteqkina waten assiriarkaullerpenek canrirarkaullerpenek."
        },
        "62": {
            "start": 1215.18,
            "end": 1229.78,
            "transcript": "Tua-i-llu saskaq qalliq au͡gna saskaq qukarpek'naku neqnialan, qukarpek'naku imiqerluku amllerarmek."
        },
        "63": {
            "start": 1229.78,
            "end": 1239.56,
            "transcript": "Nerellran kinguani tuaken igevkaqataamku qanrutaqa ukvekesqelluki elliinun tem'inun ikayuutnguarkauciat."
        },
        "64": {
            "start": 1239.56,
            "end": 1251.84,
            "transcript": "Ava-i qalartellrani yuungcaristii elliin qitevtetuami niiqngaku tuaten ikayurciigalicia."
        },
        "65": {
            "start": 1251.84,
            "end": 1273.48,
            "transcript": "Tua-i-llu pivkarluku, tuamtellu atatakuani cali pivkaqataamku piaqa tua-i ata asguraksaqunaku, asgurakevkenaki wangkuta iinrut atutullruaput ukvekluki assiritkarkauciit-llu ciunemteńi tangvalriatun piluki."
        },
        "66": {
            "start": 1273.48,
            "end": 1275.5,
            "transcript": "Tua-llu-q' takliriuq?"
        },
        "67": {
            "start": 1279.3,
            "end": 1293.52,
            "transcript": "Tua-i-llu aturluku tang waten pingayurqunek unuakumi, apiatami, atakumi, ernerpak pingayurqumek waten pivkarluku tamatumek."
        },
        "68": {
            "start": 1386.42,
            "end": 1393.54,
            "transcript": "Atralria assirluni, assilriaruluni, pellutua-gguq tua-i tamatum."
        },
        "69": {
            "start": 1393.54,
            "end": 1407.84,
            "transcript": "Tamaa-i tuaten ellillrani wiinga quyallruunga cakneq apqucia tamana atrarluni, irugkenun ellirluni, pugengluteng-llu it'gai [?] tua-i tuaten ava-i..."
        }
    },
    "Ckj8X5vkJH0": {
        "1": {
            "start": 88.82,
            "end": 96.48,
            "transcript": "Uum-gguq nepii anirturiyugngauq. Tau͡gaam-gguq ikayuutngungaituq amiigem nunii ekuakan."
        },
        "2": {
            "start": 96.48,
            "end": 103.98,
            "transcript": "Taumek enet malrugnek amiingqerresqumalriit pitsaqevkenani nakekan anyugngallra piluku."
        },
        "3": {
            "start": 103.98,
            "end": 110.98,
            "transcript": "Smoke detector-aat-gguq qalrialartut nak'aqan anirtuumaaqluteng-llu yuut makutgun."
        },
        "4": {
            "start": 110.98,
            "end": 118.76,
            "transcript": "Enem yuit elitnaurusqumayaaqut pitsaqevkenani nakekan qaillun pillerkaan nallunritesqelluku."
        },
        "5": {
            "start": 147.8,
            "end": 155.74,
            "transcript": "Uum-gguq nepi anirturiyugngauq. Qaillun-gguq tau͡gaam irnian piciqa amiigem nunii ekuakan anviinani?"
        },
        "6": {
            "start": 155.74,
            "end": 165.1,
            "transcript": "Assirluku nem'ek anllerkaa nallunritevkarluku, elitnaurutkaqluku pitsaqevkenani nakekan anllerkaanek."
        },
        "7": {
            "start": 199.22,
            "end": 206.48,
            "transcript": "Ena-gguq kek'an ken'eq anviiryugngaaten taumek malrugnek anvingqesqumalria amiigegnek."
        },
        "8": {
            "start": 206.48,
            "end": 212.0,
            "transcript": "Elitnarutekluku-llu pitsaqevkenani nakekan nallunritesqelluku."
        },
        "9": {
            "start": 252.5,
            "end": 258.68,
            "transcript": "Ukut mikelnguut elitellruut qaillun pillerkameggnek pitsaqevkenateng akluteng ekuakata."
        },
        "10": {
            "start": 258.68,
            "end": 265.0,
            "transcript": "Arulairluni, iquluni, akagluni. Irniarpet-qaa ukut nallunritai?"
        },
        "11": {
            "start": 293.18,
            "end": 296.9,
            "transcript": "Uum nepii anirturillruuq amllernek yugnek."
        },
        "12": {
            "start": 296.9,
            "end": 303.62,
            "transcript": "1983-mi-gguq twenty two-aat maani Alaska-mi yuunrillruut enen'i ekellriani."
        },
        "13": {
            "start": 303.62,
            "end": 307.9,
            "transcript": "Tamarmeng-llu yuut ekellret smoke detector-aarunateng."
        },
        "14": {
            "start": 307.9,
            "end": 315.02,
            "transcript": "Amlleret tau͡gaam-gguq maa-i council-aat nunacuarni ellillruut smoke detector-aanek nen'un."
        },
        "15": {
            "start": 315.02,
            "end": 320.12,
            "transcript": "Cali kenrit yuvrirnarqut ellirraarluki nalluyagutevkenaki."
        },
        "16": {
            "start": 320.12,
            "end": 324.42,
            "transcript": "Kenra tuqumaluni ikayuutngungaituq nakek'an."
        },
        "17": {
            "start": 353.84,
            "end": 362.5,
            "transcript": "Kaminiat kiircautet kenret ukulkuut-llu atutukput kevkalarait nep'ut."
        },
        "18": {
            "start": 362.5,
            "end": 367.64,
            "transcript": "Kenerteggun pilriit nen'i murikelluki pinarqaput."
        },
        "19": {
            "start": 367.64,
            "end": 373.32,
            "transcript": "Wangkuta-llu cat tamalkuita murilkenarqaput assirluki pillerkaatgun."
        },
        "20": {
            "start": 415.0,
            "end": 424.02,
            "transcript": "Piqatarraarpek'nani ek'a ayagnilartuq ayuqeltassiigluku man'a nunaput Alaska qakmavet."
        },
        "21": {
            "start": 424.02,
            "end": 429.02,
            "transcript": "Nunamteńi maani Alaska-mi quyinrulliniuq enet ekellriit."
        },
        "22": {
            "start": 429.02,
            "end": 434.34,
            "transcript": "Waniwa-qaa umyuarteqngelta kevkarinricaram tungiinun?"
        },
        "23": {
            "start": 464.88,
            "end": 473.6,
            "transcript": "Cali mer'aluteng nallusngaluteng-llu natermi iliita-llu kuingini aqumllermun igtelluku."
        },
        "24": {
            "start": 473.6,
            "end": 481.12,
            "transcript": "Smoke detector-aam ikayurngaitaaten nallusngaluten qalriangraan niitenrilkuvgu."
        },
        "25": {
            "start": 481.12,
            "end": 487.92,
            "transcript": "Cikiumaukut ikayuutekamteńek arenqiallugeskumta aturkamteńek."
        },
        "26": {
            "start": 487.92,
            "end": 495.6,
            "transcript": "Tau͡gaam atuungaitut taangiqellriamun. Yuucin-qaa nallunritan?"
        },
        "27": {
            "start": 527.4,
            "end": 532.36,
            "transcript": "Kuingit-gguq ekutngulalriani ciuqliuluteng igaumaut."
        },
        "28": {
            "start": 532.36,
            "end": 538.3,
            "transcript": "National Fire Protection Association-aami-llu cali ciuqliuluni igausngaluni."
        },
        "29": {
            "start": 538.3,
            "end": 545.22,
            "transcript": "Unguvakan elpet yuuciqluku-llu tau͡gaam yuunrillerkavgit [?] maagun eketgun mikelnguugut."
        },
        "30": {
            "start": 545.22,
            "end": 549.8,
            "transcript": "Arenqiallugcesqumanritan-qaa irniarpet iliit?"
        },
        "31": {
            "start": 584.36,
            "end": 590.08,
            "transcript": "Maani ellarpiim iluani Alaska-mi enet ekellriatun amllinrulartut."
        },
        "32": {
            "start": 590.08,
            "end": 595.06,
            "transcript": "Kiingan United States-aam pivkenani tau͡gaam ellarpamta iluani."
        },
        "33": {
            "start": 595.06,
            "end": 600.72,
            "transcript": "Nasvaumalartuq igatgun tau͡gaam qaillun man'a arenqiallugun pisciigataat?"
        },
        "34": {
            "start": 600.72,
            "end": 609.06,
            "transcript": "Wangkuta tau͡gaam elitnaurutkaqluku piyugngaaput pitsaqevkenani nakekan pillerkamteńek."
        },
        "35": {
            "start": 637.0,
            "end": 646.4,
            "transcript": "Elitnaurumanrilnguq qaillun pillerkanek nakekan iliit itengnaqciquq ekuangraan anirturingnaqkuni ilaminek."
        },
        "36": {
            "start": 646.4,
            "end": 650.36,
            "transcript": "Ena ekluku ankuvet itenqigtengnaqsaqunak."
        },
        "37": {
            "start": 650.36,
            "end": 656.0,
            "transcript": "Elitnauruteknarqellriaruuq ilavet anirtuumallerkaat pitekluku."
        },
        "38": {
            "start": 685.0,
            "end": 693.08,
            "transcript": "Kaminian-gguq-qaa tangerrsugngaan waniwa aqumgallerpenek? Tangerrsugngakuvgu-gguq tangvaugaqaqerru."
        },
        "39": {
            "start": 693.08,
            "end": 699.84,
            "transcript": "1983-mi-gguq twelve-aat yuut yuunrillruut eketgun kaminianek ayagniumaluteng."
        },
        "40": {
            "start": 699.84,
            "end": 706.86,
            "transcript": "Kaminiatgun ekutngulallrat yuunrilriit nunarpamteńi ciuqliurluni igaumauq."
        },
        "41": {
            "start": 706.86,
            "end": 713.72,
            "transcript": "Kaminian ellimanrilkuni ayuqucirtuutmikun aarnarquq, tau͡gaam elpenun atauq."
        },
        "42": {
            "start": 713.72,
            "end": 721.6,
            "transcript": "Uunret kilinruut uutellrem-llu nalluyagusngaitai yuullmi tangtaciatun, umyuarniararput man'a."
        }
    },
    "pOeLyo1_P10": {
        "1": {
            "start": 43.88,
            "end": 61.98,
            "transcript": "Au͡gkut-wa ciuliaput, wangkuta tangvaqalput, wiinga-wa tangvaqallrenka, akusrartesciigatellrulriakut, cat tamalkurmi qanertarluni."
        },
        "2": {
            "start": 61.98,
            "end": 72.16,
            "transcript": "Cali-llu-wa waten kaingramta tegulruulluta neresciiganata, aanamteńun cikiumavkenata."
        },
        "3": {
            "start": 75.6,
            "end": 84.68,
            "transcript": "Tuamta-llu meqsugaqamta apa'urlumta ciuqvani yuurtellret qecircetaqluteng tumamteńun."
        },
        "4": {
            "start": 86.34,
            "end": 105.46,
            "transcript": "Tua-i-ll' qapuuluni. Maaten piciquten mer'uluni man'a, pinauraitkut meq, meqsuneqsaitut [?], neqerqengan elluarrluni temevnun pulateksaitelliniuq."
        },
        "5": {
            "start": 110.52,
            "end": 121.96,
            "transcript": "Nutaan tua-i qapuurtaqan, qapurrlainaurtaqan mequinermek cikituitkut. Anglanivkarpek'nata cal' aqsiluta merciiganata."
        },
        "6": {
            "start": 126.56,
            "end": 140.24,
            "transcript": "Qasgimi tua-i ellaita tau͡gken nep'agaluteng [?] angukaraallraat ayarinaqluteng. Qaltaq imairutniaqan quyakalalriaput tua-i."
        },
        "7": {
            "start": 140.24,
            "end": 151.26,
            "transcript": "Makut cali maa-i kevraartut mimernaitnek pilaraput acilqurrit ilait angluteng waten ayuqelartut mimernait."
        },
        "8": {
            "start": 151.26,
            "end": 165.5,
            "transcript": "Tua-i-llu makut maa-i iinruugut cali yuk igyaraa callareskan neresciigaliluni-llu."
        },
        "9": {
            "start": 165.5,
            "end": 173.12,
            "transcript": "Tua-i-llu makucinek aqvalluni kepluki maaggun, man'a-llu kemgat."
        },
        "10": {
            "start": 173.12,
            "end": 180.3,
            "transcript": "Waten aug'arluku urukan, canaluku maa-i kemga, kemgat man'a."
        },
        "11": {
            "start": 181.8,
            "end": 191.74,
            "transcript": "Man'a kenirluku kemgat nutaan cali merturluku."
        },
        "12": {
            "start": 191.74,
            "end": 201.22,
            "transcript": "Akultutacirrlugmi tayima every three hours merturquniu qeckaqsaunateng."
        },
        "13": {
            "start": 201.22,
            "end": 206.9,
            "transcript": "Imna angellrung'e'rmi igyaraani callamalria."
        },
        "14": {
            "start": 206.9,
            "end": 223.64,
            "transcript": "One week kitugtarkaugat assiriluku makut, mamlluku tuaten makut maa-i kevraartut mimernaita-gguq kemgit, kevraarcinraat-llu cali kemgit cangallrungaitut makunek."
        },
        "15": {
            "start": 225.0,
            "end": 238.0,
            "transcript": "Now tua-i akngikutalriakut caaqamta tua-i-llu qimugtem anaa [?] teguluku minguuluku eggluku-llu. Akertem tevellran tungiinun."
        },
        "16": {
            "start": 238.0,
            "end": 242.96,
            "transcript": "Unuaqan assiriaqluta. (Assirian-llu-qaa erurluku?)"
        },
        "17": {
            "start": 242.96,
            "end": 245.68,
            "transcript": "Eruraqluku assiriaqan?"
        },
        "18": {
            "start": 245.68,
            "end": 253.2,
            "transcript": "Assi' eruqsai' eruriksaitellrulriakut-wa wangkuta Kassiyaagaunrilamta."
        },
        "19": {
            "start": 253.2,
            "end": 262.56,
            "transcript": "Maligtaquluki tua-i aulukesteput pillrulriakut ermigpakayuunata-llu."
        },
        "20": {
            "start": 266.94,
            "end": 270.74,
            "transcript": "Ukuk waniw' angucaluk, angucaluk-gguq waniw'."
        },
        "21": {
            "start": 270.74,
            "end": 278.74,
            "transcript": "Tua-i-llu una waniw' tegumiaqaqan ataluni [?] makut makuyagaat maa-i kangerpailnguut pit'larait."
        },
        "22": {
            "start": 278.74,
            "end": 287.52,
            "transcript": "Tua-i ayuqengacaaqengraata-am assinrularniluki makunek kangerpailngurnek pit'lallruuq."
        },
        "23": {
            "start": 288.66,
            "end": 300.64,
            "transcript": "Makut wangkuta ciuqliput murilketalaameng, murilketalliniameng akusrarqurpek'nateng wangkucicetun pilallrulliniameng."
        },
        "24": {
            "start": 302.14,
            "end": 314.16,
            "transcript": "Wangkuta murilkenritukut, ilumun-wa tua-i murilketait wiinga-w' tua-i pilallilrianga."
        },
        "25": {
            "start": 314.16,
            "end": 327.76,
            "transcript": "Tau͡gaam tua-i tangvagluki pitenka nalluyagutenrit' nalluyagusngatauyaaqua, tau͡gaam assilriamek iqugkangqerciqngelnguut [?] nallunritengnaq'laranka tua-i nalluyagutenritengnaqluki."
        },
        "26": {
            "start": 341.52,
            "end": 358.4,
            "transcript": "Tamaa-i tuaten atuusqelluku alerquutek'larait canun-wa tua-i imkunun minguulluki lumarrarmun camun piciatun iciw' caqukanek pilaqait imkut ciantiit [?]."
        },
        "27": {
            "start": 358.66,
            "end": 372.42,
            "transcript": "Ciantiit [?] cam-llu pianun imumun lumarrayagarmun minguulluki atulallruuq tau͡gaam imkunek caqukapianek lumarrarrlainarmek camek im' piilngurnek."
        },
        "28": {
            "start": 372.42,
            "end": 384.08,
            "transcript": "Tau͡gaam tamakun ang'aqata uunra-wa tauna angellrani nemerkamek caqukamek tamakucinek pilaqait, pilaqait tamakut."
        },
        "29": {
            "start": 384.08,
            "end": 404.52,
            "transcript": "Tuaten call' makutetun au͡gkut pitui imkut wani pit au͡gkut enrilnguanek-ggem amani nunamteni pilaqait au͡gkut willow-t'."
        },
        "30": {
            "start": 404.52,
            "end": 415.52,
            "transcript": "Makut enrilnguat waten pilaraput man'a qeltuit au͡g'arluku."
        },
        "31": {
            "start": 415.52,
            "end": 426.52,
            "transcript": "Au͡g'arraarluku nutaan qeltiit man'a qamna iluat man'a waten keligarluku."
        },
        "32": {
            "start": 426.52,
            "end": 445.86,
            "transcript": "Keligarraarluku-ll' tua-i una callakayalriim nuniini maanelkan, callakayalriim nuniinun wavet elliluku uitauraqertelluku ak'aarluni  Aknginarqeqapigqaarluni aknginairuciiquq."
        },
        "33": {
            "start": 447.46,
            "end": 454.86,
            "transcript": "Tua-i-ll' aknginairuskan egmian una au͡g'arluku anluku, nernge'rmi-ll' akngirrngaunani."
        },
        "34": {
            "start": 454.86,
            "end": 463.52,
            "transcript": "Kakegglugmek-wa tangeqsaileng' iinrulriamek, naspaaqa akwaugaq nangkeliin [?] pakikaruq [?] kakegglugmek."
        },
        "35": {
            "start": 475.82,
            "end": 484.9,
            "transcript": "Qukairneq. Waniwa kaplerkaqa."
        },
        "36": {
            "start": 489.76,
            "end": 492.04,
            "transcript": "Tua-i-ll' qaill' pisiu?"
        },
        "37": {
            "start": 492.04,
            "end": 498.48,
            "transcript": "Waniw' ciissiirqa (Ciissiirluku-qaa?). Ii-i. [?]"
        },
        "38": {
            "start": 498.48,
            "end": 509.72,
            "transcript": "Niitellruut waten aqumlllitanek aqumllit [?] kilirciqluku (kilirngaituq) assirtuq-qaa?"
        },
        "39": {
            "start": 509.72,
            "end": 519.42,
            "transcript": "Ii-i, inunrilngapagcit [?]. Unguggluk [?] cakneq. Piqatarqa."
        }
    },
    "7fuT2DeOQiE": {
        "1": {
            "start": 833.98,
            "end": 848.06,
            "transcript": "Ukut ONC-rmiut quyurciiqut January 11, ukut tau͡gaam ciulirneput January 4-ami quyurciiqut atakumi seven-ak'laagmi."
        },
        "2": {
            "start": 848.06,
            "end": 850.96,
            "transcript": "Nani quyurciiqceci?"
        },
        "3": {
            "start": 850.96,
            "end": 855.26,
            "transcript": "Piani urucararmiut quyurrviatni."
        },
        "4": {
            "start": 855.26,
            "end": 866.4,
            "transcript": "Urucararmiut quyureskata cauciqa qalarutkarkaci ciumek, agenda-rpeci, agenda-tni-wa?"
        },
        "5": {
            "start": 866.4,
            "end": 881.92,
            "transcript": "Elkarciiqerput ciumek icivaq caliallerput ukut ciulirneret quyurtellermeggni ciulirneqsuglua cucukellruatnga."
        },
        "6": {
            "start": 881.92,
            "end": 899.4,
            "transcript": "Tauna ciukluku caliaqeciqerput, ukut-llu urucararmiut council-aarit tamatumek nalqigulluki qaill' ayuqucirkaanek, qaillun-llu ilertellerkamteńek."
        },
        "7": {
            "start": 899.4,
            "end": 908.12,
            "transcript": "Cali-qaa allanek caliarkarpeceńek pillruuci?"
        },
        "8": {
            "start": 908.12,
            "end": 919.4,
            "transcript": "Uumi quyurtellemteńi una yugni tamamteńi maa-i nallunritarci arenqiallugutngulartuq."
        },
        "9": {
            "start": 919.4,
            "end": 935.12,
            "transcript": "Ayagyuan una, ayagyuanrilengramta-llu tamamta arenqiallugutekluku una waniw' taangaq tunglia-w' cali una tuneniaruilriit makunek yuum navguutiinek tememeggnun."
        },
        "10": {
            "start": 935.12,
            "end": 949.76,
            "transcript": "Tauna tua-i ciuqliuluku caliaqeciqerput qailluqapiar tau͡gaam caliaqumallerkaa uunguciituq tau͡gaam quyureskumta qaillun caliaqumallerkaa taringeciqerput."
        },
        "11": {
            "start": 1033.4,
            "end": 1042.72,
            "transcript": "Inerquqtarturangramceteng-wa elicungcangram elicungcarluki pilaraput elicung' iciw' tua-i."
        },
        "12": {
            "start": 1042.72,
            "end": 1050.34,
            "transcript": "Alerqurluki iciw' inerqurluki ellaitnek murilkesqelluki, ellaitnek aulukesqelluki."
        },
        "13": {
            "start": 1050.34,
            "end": 1056.16,
            "transcript": "Nani-ll' piyuakata malruuluki wall' pingayuuluki."
        },
        "14": {
            "start": 1059.4,
            "end": 1068.48,
            "transcript": "Mer'alriit-llu iciw' tua-i mer'alrianun-llu ilagautesqevkenaki, kiingita ellami tarritesqevkenaki."
        },
        "15": {
            "start": 1068.48,
            "end": 1081.34,
            "transcript": "Kitumek tau͡gaam ilangqerrlainarrluki, umyuamni uitauralria qanruteksupiaraqa atauciq yuk arnaq qalarutlemku waten qanrutellruanga."
        },
        "16": {
            "start": 1081.34,
            "end": 1090.54,
            "transcript": "Elpeci tang uingi qenlalriaci, avvucetaarilartuci. Wangkuta TWC-mi tuaten piyuitukut."
        },
        "17": {
            "start": 1090.54,
            "end": 1101.86,
            "transcript": "Arnaq tailuni ikayungcarqan elliin piyullra maligtaquurluku wangkuta pilaraput, waten-llu piyuunaku unisgu uin pegesgu."
        },
        "18": {
            "start": 1101.86,
            "end": 1111.58,
            "transcript": "Waten tau͡gaam anagulluni nangtaussiyaagaqan, nangtaullritell' iciw' yuut maani nalluit."
        },
        "19": {
            "start": 1111.58,
            "end": 1120.14,
            "transcript": "Hospital-aamek qavangteng-llu nangterpaumaluteng wangkutnun tailartut tuquyarpiarraarluteng nangtaum ugaan."
        },
        "20": {
            "start": 1120.14,
            "end": 1126.56,
            "transcript": "Tua-i-ll' wangkuta imkuci alingucilluku waten piqalaraput."
        },
        "21": {
            "start": 1126.56,
            "end": 1132.56,
            "transcript": "Unisngaqaqerru ikayungcaumarikan tau͡gaam ullagniaran."
        },
        "22": {
            "start": 1132.56,
            "end": 1145.4,
            "transcript": "Waten-llu pivkenaku unisgu pegesgu divorce-arru unilluku, piyugngakagnek-llu piyukagnek tamarkenka qalarulluku unicetaariyuunata-llu."
        },
        "23": {
            "start": 1145.4,
            "end": 1159.88,
            "transcript": "Arnam-llu taum piyullra wangkuta maligtaquurluku waten-llu tua-i piyukan uterteqatartua wangkuta nuqtesciiganaku elliin umyuani aturluku utertelartuq wangkuta."
        },
        "24": {
            "start": 1159.88,
            "end": 1170.78,
            "transcript": "Umyuamteggun qunugpiangramteggu uitastengramteggu elliin umyuani aturluku utertelartuq."
        },
        "25": {
            "start": 1170.78,
            "end": 1180.4,
            "transcript": "Tamana yugnun taringesqumaaqa avv'ucetaariyuilamta unicetaariyuunata-ll' aipaignek."
        },
        "26": {
            "start": 1200.98,
            "end": 1215.38,
            "transcript": "Arcaqerluki man'a maani asbestos-aaq taringumallemni matuunrilengraan qat'gamikun cancer-aangnarqellinian."
        },
        "27": {
            "start": 1215.38,
            "end": 1226.28,
            "transcript": "Cali-llu watuangunrilnguq pivkenani tau͡gaam twenty years kinguatni agturyugngaluku yuk cancer-aarcecugngaluku-llu."
        },
        "28": {
            "start": 1226.28,
            "end": 1235.3,
            "transcript": "Tamana pitekluku makut elitnauruit maa-i qaqitqapiarluki ullagtaarumaarkaugut yuvrirluki."
        },
        "29": {
            "start": 1235.3,
            "end": 1242.96,
            "transcript": "Yuvrirluki sample-aarluki-llu tamakut-llu sample-aarit ayagcecimaarkauluteng."
        },
        "30": {
            "start": 1242.96,
            "end": 1252.86,
            "transcript": "Akmavet nutaan-llu ut'reskata nutaan tamaggun nallunairarkauluni cat asbestos-aangqellrit."
        },
        "31": {
            "start": 1252.86,
            "end": 1263.84,
            "transcript": "Atam man'a asbestos-aaq amllerianun pimaliniuq una wani friable-aamek pilallrat imna tengyukaaralria."
        },
        "32": {
            "start": 1264.08,
            "end": 1272.4,
            "transcript": "Asbestos-aaq tengyukaaralria maani-llu tangerrnarqevkenani pillemteńi piarkauluni."
        },
        "33": {
            "start": 1272.4,
            "end": 1280.2,
            "transcript": "Una-llu cali non-friable-aaq makuni natercuutni, sheet rock-ani-llu imkuni makuni."
        },
        "34": {
            "start": 1280.2,
            "end": 1292.24,
            "transcript": "Uitayugngaluni wall'u-wa hard board-ani, wall'u-wa qaliqerkani-ll' piciatun tua-i uitayugngaluni tamaani piliaqelallermeggni-wa."
        },
        "35": {
            "start": 1292.24,
            "end": 1299.82,
            "transcript": "Man'a asbestos-aaq ayagniutekellrulliniamegteggu makunun enenun piluku."
        },
        "36": {
            "start": 1299.82,
            "end": 1306.54,
            "transcript": "Taumek tamana piluku arcaqerluki maa-i makut elitnaurviit ak'allaat."
        },
        "37": {
            "start": 1306.54,
            "end": 1313.0,
            "transcript": "Arcaqerluki tamakut tamaa-i nallunailngurmek asbestos-aangertut."
        },
        "38": {
            "start": 1313.0,
            "end": 1324.7,
            "transcript": "Qaillun-mi tamakut wani yuvrirciiq' quyuqa'artelluki taqkata, qaill' piciqceci?"
        },
        "39": {
            "start": 1324.7,
            "end": 1333.0,
            "transcript": "Caliaqengciqait tamakut tua-i arcaqerluki makut elitnaurviit tamakucilget."
        },
        "40": {
            "start": 1333.0,
            "end": 1342.78,
            "transcript": "Tayima kalikartanek ellivikurarait tua-i-w' yuum iteqtararkaqenrilkii nallunailkuciungaluni."
        },
        "41": {
            "start": 1342.78,
            "end": 1349.24,
            "transcript": "Calilriarung'e'rmi waten elitnaurvigmi calilriarung'e'rmi mulngakarkauluni."
        },
        "42": {
            "start": 1349.24,
            "end": 1356.4,
            "transcript": "Cali-llu ukut wani calilriit elitnaurvigmi tuani elitnauristeńgungraata-llu taumun."
        },
        "43": {
            "start": 1356.4,
            "end": 1364.7,
            "transcript": "Pitangqerqan asbestos-aangqerqan imumek tengyulriamek, friable-amek pikiitnek iteqtaarcetarkauvkenateng."
        },
        "44": {
            "start": 1364.7,
            "end": 1379.02,
            "transcript": "Tamaa-i tamana piluku arcaqerluku caliaqluki elitnaurat makut elluarrluteng-wa tamatumun-llu expose-anritlerkaat piluku wangkuta caliukut."
        },
        "45": {
            "start": 1379.02,
            "end": 1393.12,
            "transcript": "Makut-wa tua-i pilriit arcaqerluku man'a caliarput pimalria qakemkunun ullaumalrianun alerquumakata alerquutet maligtesqelluki."
        },
        "46": {
            "start": 1393.12,
            "end": 1410.9,
            "transcript": "Tamatumek tau͡gaam kiingan pitkangqertua arcaqerluku makunun tusngiin elitnauranun elitnaulrianun aarcirtutngukuni tuaten inerquusngalria qakemkunun maligtaqusqumaluku piaqa."
        }
    },
    "50iQDFMRQpg": {
        "1": {
            "start": 51.14,
            "end": 55.58,
            "transcript": "Quyana ilagaqatarluta arcaqalriamek qalartellemteni."
        },
        "2": {
            "start": 55.58,
            "end": 58.02,
            "transcript": "Mer'em Pinerrlugutii."
        },
        "3": {
            "start": 58.02,
            "end": 61.52,
            "transcript": "Waniwa Kakianerem nallunrivsiarcetqataraakut."
        },
        "4": {
            "start": 66.58,
            "end": 77.36,
            "transcript": "Maa-i up'nerkarqan, up'nerkaraqan yuut quyalartut waten cikutairutaqan merkun-llu kuigkun-wa ayagalriit amlleriaqluteng."
        },
        "5": {
            "start": 77.36,
            "end": 86.94,
            "transcript": "Maa-i waten tau͡gaam elliraqan yuut ilairutellret kuigkun umyuaqelarait ilateng."
        },
        "6": {
            "start": 86.94,
            "end": 98.8,
            "transcript": "Makut wani tegustet, tegustet cali up'nerkamek, up'nerkaq, up'nerkam-wa tekitellerkaanek pissiyaaksaitelartut."
        },
        "7": {
            "start": 98.8,
            "end": 106.4,
            "transcript": "Waten week-at iluatni cupqerraaraqan unani kuigkun temnek yuaranglaameng."
        },
        "8": {
            "start": 106.4,
            "end": 115.0,
            "transcript": "Makut wani yungcaristet qanertut kiagmi allrakuaqan yuut qulnguluteng catairut'larniluki."
        },
        "9": {
            "start": 115.0,
            "end": 128.2,
            "transcript": "Cali allrakut qulen maa-i pellullruut, quyurmeng-llu yugnek cagmarillruluteng 150 yuinaat malrunlegen qulnek cipluku."
        },
        "10": {
            "start": 128.2,
            "end": 140.26,
            "transcript": "Iliini waten nunat ilait yugtutalartut. Amlleret piyuutengqellruut maa-i 1990-ni tamana cimiryugyaaqluku maani Kuigpiim Kusquqviim-llu avatiini."
        },
        "11": {
            "start": 140.26,
            "end": 153.12,
            "transcript": "Allragni akimiaq malrunek cipluku cuuqitellriartangqellruuq maaken Kuigpiim Kusquqviim-llu avatiinek maa-i-llu unarneq [?] tekilluku maa-i mat'umi allrakumi pingayunek tamarillrurrluta."
        },
        "12": {
            "start": 153.12,
            "end": 163.28,
            "transcript": "Mat'um iralum ciungani John Waska-m Mamterillermiu qerruluni yuunrillruuq tuani-llu cikukun navguulluni kiqaaluni snuukullermini."
        },
        "13": {
            "start": 163.28,
            "end": 173.98,
            "transcript": "Cali kinguaraakun ukuk Gerald Tom una-llu Walter Overton Anyararmiuk cali kit'ellrulutek Curarpalegmiut Anyararmiut-llu akunlegkeni."
        },
        "14": {
            "start": 173.98,
            "end": 178.62,
            "transcript": "Tuani wani party-lriani mer'alriani-wa uitarraarlutek."
        },
        "15": {
            "start": 178.62,
            "end": 189.42,
            "transcript": "Taukuk wani kamakait tamaa egmillruyuklukek aipaa cali snuukuumun, snuukuumun-wa tegumiaqusngallruluni."
        },
        "16": {
            "start": 189.42,
            "end": 197.52,
            "transcript": "Mat'ua [?] taukuk wani arenqiallugtellriak arcaqerluni assiitellriaruuq uum Gerald Tom-am aaniinun."
        },
        "17": {
            "start": 197.52,
            "end": 202.98,
            "transcript": "Tauna wani irniaminek cetamanek merkun tamarillruuq."
        },
        "18": {
            "start": 202.98,
            "end": 212.1,
            "transcript": "Maa-i mat'umi kiagmi atuqengamteńi tamana allauluku atuusqumayaaqluku allani allrakuni pellullerni."
        },
        "19": {
            "start": 212.1,
            "end": 219.28,
            "transcript": "Tau͡gaam waten nallunritukut tayima ataucimek cali catairutellriartangqerciquq."
        },
        "20": {
            "start": 219.28,
            "end": 233.48,
            "transcript": "Tau͡gaam mat'um waten qanrutkuurluku pillranun waten aipaagni tayima ataucimek unguvamek anirturikumta watnalput waniwa canrituq."
        },
        "21": {
            "start": 233.48,
            "end": 245.48,
            "transcript": "Wangkuta yugni, yugni yupiulriani tegganeput wall'u ciuliaput ciuliamta qanruyutait arcaqalriaruluki niitelaraput."
        },
        "22": {
            "start": 245.48,
            "end": 256.0,
            "transcript": "Waniwa ayagnirluku atakurpak wani watnalput niicugniqernauput Aaryuk Joseph Evan Napaskiarmiu mat'umek up'nerkamek qalartellrani."
        },
        "23": {
            "start": 259.66,
            "end": 267.28,
            "transcript": "Aarnarqelria man'a kiak maa-i-am tua-i alairtuq."
        },
        "24": {
            "start": 267.28,
            "end": 272.54,
            "transcript": "Merkun-llu cali maa-i tarratengluta cali."
        },
        "25": {
            "start": 272.54,
            "end": 276.98,
            "transcript": "Mat'um taangam."
        },
        "26": {
            "start": 276.98,
            "end": 290.18,
            "transcript": "Waniwa picurlagatngucia cali-llu yuum wani navguutngucia."
        },
        "27": {
            "start": 290.18,
            "end": 301.0,
            "transcript": "Tua-i elpek'nariyaaqelria tayima, aturtek'lallmini-llu tayima cali elpek'nariyaaquq."
        },
        "28": {
            "start": 301.36,
            "end": 311.22,
            "transcript": "Arenqiatuq tau͡gaam tua-i aturyugtain atulaamegteggu atuusqumanricaaqeng'e'rmi."
        },
        "29": {
            "start": 311.22,
            "end": 319.16,
            "transcript": "Tua-i ellaita arcaqakekteng atularaat."
        },
        "30": {
            "start": 321.0,
            "end": 326.6,
            "transcript": "Maa-i mat'um nalliini yuk wani waten ayuquq."
        },
        "31": {
            "start": 326.6,
            "end": 337.96,
            "transcript": "Watua waniwa qalaruqaarluku nangerngaluni cavkenani waniwa qalaruqaarluku."
        },
        "32": {
            "start": 337.96,
            "end": 343.96,
            "transcript": "Tua-i-llu ayiimi taangiq mer'aluni."
        },
        "33": {
            "start": 345.0,
            "end": 354.72,
            "transcript": "Tayima-llu cat caq cali navailgan cali ilii pivakarluni angyaminek atalartuq."
        },
        "34": {
            "start": 354.72,
            "end": 363.62,
            "transcript": "Angyam-llu unilluku, qaillun-llu anirtuasciiganani tauna."
        },
        "35": {
            "start": 363.62,
            "end": 369.82,
            "transcript": "Tua-i ellminek tuqutelartuq tauna cakneq-lli nallunaipaa."
        },
        "36": {
            "start": 371.0,
            "end": 382.76,
            "transcript": "Ellminek tuqu' tuqulluni tua-i tuarpiaq imutun cangallruvkenani ellminek nutellriami."
        },
        "37": {
            "start": 382.76,
            "end": 390.16,
            "transcript": "Wall'u nuussimek ellminek kapellriami, wall'u qemitellriami-llu."
        },
        "38": {
            "start": 390.16,
            "end": 403.22,
            "transcript": "Tua-i cangallruvkenani mermun igtaqami tua-i ellminek tuqutelartuq."
        },
        "39": {
            "start": 403.22,
            "end": 414.22,
            "transcript": "Man'a taringesqumangyaaqaqa wiinga. Tua-i wiinga carrluuyaaqeng'e'rma wangnek tunullua."
        },
        "40": {
            "start": 414.22,
            "end": 426.2,
            "transcript": "Tunullua wangnek umyuaqesqumangyaaqaqa makunun taringesqumangyaaqluku-llu makunun ayagyuaqegtaarnun."
        },
        "41": {
            "start": 426.2,
            "end": 432.4,
            "transcript": "Ellaita ayuqucirteng ellmeggnek navguassiyaakaitnun."
        },
        "42": {
            "start": 434.52,
            "end": 442.06,
            "transcript": "Atakurpak kelgillruukut maaken yugnigkek'ngamta ilaitnek mat'um wani mat'umun qalartesqelluki."
        },
        "43": {
            "start": 442.06,
            "end": 457.22,
            "transcript": "Ayagnirluki ukut wani qalartarkat waniwa una Daniel Bill waken YKHC-ni umyuam tungiinun, umyuat tungiitnun ikayuristeńguuq mental health specialist-aaruluni."
        },
        "44": {
            "start": 457.22,
            "end": 469.88,
            "transcript": "Cali Peter Isaac maaken Mamterillermek tegganeq cali ilakluku ayagnircetellrat ukut Bethel Search and Rescue team maani yuaritulit."
        },
        "45": {
            "start": 469.88,
            "end": 478.7,
            "transcript": "Ciumek wani Daniel-aaq apluku apyutmek maani, maani wani maa-i avatemteni."
        },
        "46": {
            "start": 478.7,
            "end": 483.4,
            "transcript": "Tuar taqsuunateng yuut tungmagteliyarturalriit."
        },
        "47": {
            "start": 483.4,
            "end": 489.42,
            "transcript": "Iliini-llu pinarqenricaaqengraan waten ciuliamta qanruyucicetun."
        },
        "48": {
            "start": 489.42,
            "end": 495.18,
            "transcript": "Una-gguq-wa tua-i tuaten piarkaunricaaqellrung'e'rmi tau͡gaam tua-i tuaten pilria."
        },
        "49": {
            "start": 495.18,
            "end": 507.0,
            "transcript": "Qaillun makut wani tungmagcuurallemta man'a Yupiulput yuuyararput wall'u ilakluta yuullemteńun agtuumalartakut?"
        },
        "50": {
            "start": 507.0,
            "end": 518.84,
            "transcript": "Pii, ilumuuq-qaa kina yuk waten piunriryaaqamta [?] tamalkumta agtetuakut, yaaqvani-llu uitangraan waten niitaqluku."
        },
        "51": {
            "start": 518.84,
            "end": 527.8,
            "transcript": "Pit, ilait-llu tamakut tamarillruut waten ilait tang naklekluki piaqluki."
        },
        "52": {
            "start": 527.8,
            "end": 532.88,
            "transcript": "Ilaita-llu waten ikayurluki piurturluki."
        },
        "53": {
            "start": 532.88,
            "end": 547.28,
            "transcript": "Makut-llu taum piunrillrem aipaq naarit [?] nuliangni-llu ilait makut iluteqluteng piaqluteng."
        },
        "54": {
            "start": 547.66,
            "end": 554.86,
            "transcript": "Pit, tauna pellugpialngan alla ataam pinqigtaqluni."
        },
        "55": {
            "start": 554.86,
            "end": 568.24,
            "transcript": "Ilait-llu alla yuk tua-i maani kuigpiit akuliitni meq man'a aturturluku piuratuamteggu waten picurlagaqluteng piaqluteng."
        },
        "56": {
            "start": 568.24,
            "end": 578.92,
            "transcript": "Picurlaqtalriit naum amlleriinarluteng. Kiitavani waten piunrillret amlleriinartut"
        },
        "57": {
            "start": 578.92,
            "end": 585.62,
            "transcript": "Tua-i tauna pellugpialrian alla akngirtaqluni, cuuqitaqluni."
        },
        "58": {
            "start": 585.62,
            "end": 599.16,
            "transcript": "Kiitavani tau͡gaten aturturluni piuralriani waten tamana pellugpailgan, allrakuq man'a pellugpailgan allapiaqluni."
        },
        "59": {
            "start": 599.16,
            "end": 608.26,
            "transcript": "Umyuaq waten assiirutkaniraqluni piurturluni, tau͡gaten pinarqetuuq."
        },
        "60": {
            "start": 608.26,
            "end": 616.36,
            "transcript": "Maa-i man'a wani wangkuta Yugni Kass'anun aprumalria grieving process."
        },
        "61": {
            "start": 616.36,
            "end": 623.74,
            "transcript": "Mat'um caliaqelqa wangkutni Yupiaruluta nutaraulriatun ayuquq."
        },
        "62": {
            "start": 623.74,
            "end": 631.74,
            "transcript": "Maa-i-llu yuut qaqiteksailngataqluku tamana wani ellmeggnek wani ikayulteng."
        },
        "63": {
            "start": 631.74,
            "end": 638.22,
            "transcript": "Qaillun mat'um qaqimaksaitellran arenqiallugun ilalqautek'lartau?"
        },
        "64": {
            "start": 638.22,
            "end": 650.44,
            "transcript": "Pii civuqlikacaameng qaneryugtua man'a aprumalria Kass'atun grieving process-aaq, pii atra tau͡gaam kiirrarmi nutarauguq."
        },
        "65": {
            "start": 650.44,
            "end": 659.88,
            "transcript": "Wangkutni Yup'igni piciryarangqellruukut-llu cali pit qaneryarangqerrluta-llu cali tamatum tungiinun."
        },
        "66": {
            "start": 659.88,
            "end": 667.96,
            "transcript": "Pii ukut wanigg' ilait umyugarniurutput antaqluki aassaqutevkenaki."
        },
        "67": {
            "start": 668.36,
            "end": 676.28,
            "transcript": "Taum ilakai waten yugmeng tamarilriani waten aassaqutevkenaku qanemcikaqluki."
        },
        "68": {
            "start": 676.28,
            "end": 686.74,
            "transcript": "Cali-llu cali qanrucimaluta waten iluteqaqamta-llu cali antaqluku-llu cali piaqluku tau͡gaten pisqelluku."
        },
        "69": {
            "start": 687.0,
            "end": 695.86,
            "transcript": "Iliini waten yuk kit'ung'e'rmi nunaniryugaqami nenglallermikun tau͡gaam qanrucetua."
        },
        "70": {
            "start": 695.86,
            "end": 705.0,
            "transcript": "Yug'em-llu iliini waten iluteqaqami qiallermikun tau͡gaam iluteqellni tau͡gaten qanrucetua."
        },
        "71": {
            "start": 705.6,
            "end": 719.2,
            "transcript": "Pii tau͡gaten piurturluni nuqtevkenaku aassaqutekevkenaku ayuqucini yug'em piuraquni assiriciquq."
        },
        "72": {
            "start": 719.2,
            "end": 731.24,
            "transcript": "Cali-llu cali qanrucimaluta waten calingnaqu'urturluta piurasqelluta, una'atput [?] atungnaqu'urturluki piurasqelluta."
        },
        "73": {
            "start": 731.24,
            "end": 748.6,
            "transcript": "Tau͡gaten cali pisqumaluta-llu cali, arcaqerluni-llu cali waten qayutuni ernerni ilaput tauna pinriqarraarcelluki uitaurasqelluta, tamana-llu cali ilakaat."
        },
        "74": {
            "start": 748.8,
            "end": 757.28,
            "transcript": "Civuliamta tamana Yup'igni grieving process-aput nallunritait."
        },
        "75": {
            "start": 757.28,
            "end": 763.1,
            "transcript": "Nunacuarni-llu cali maa-i-rpak atutuluki-llu cali tamana."
        },
        "76": {
            "start": 763.1,
            "end": 769.54,
            "transcript": "Waten elluarrluki atulriani tamana, elluarrluku tamana qaqitnarquq."
        },
        "77": {
            "start": 769.54,
            "end": 774.96,
            "transcript": "Tau͡gaam mat'umi allrakum iluani arcaqanrutuuq."
        },
        "78": {
            "start": 775.0,
            "end": 785.52,
            "transcript": "Waten man'a piciryaraq tekitaqan tauna aiparnaaqetulput umyugaqluku."
        },
        "79": {
            "start": 785.52,
            "end": 792.82,
            "transcript": "Iliini waten aliayugaqluta waten neqet tekitaqata, tengmiat tekitaqata."
        },
        "80": {
            "start": 792.82,
            "end": 804.14,
            "transcript": "Makut-llu pitukiit holiday-t tekitaqata-llu cali tamakut nalliitni arcaqanruluta tut'aqluta."
        },
        "81": {
            "start": 804.14,
            "end": 815.78,
            "transcript": "Kitak' Peter, Peter-aaq una wani ava-i qanrutellrucimcetun ilakaat ukut nautellrat Bethel's Search and Rescue team-at."
        },
        "82": {
            "start": 815.78,
            "end": 823.36,
            "transcript": "Ciuqliqa apyutka wangkuta Yup'igni tayima avaken ciuliamtenek ayagluta."
        },
        "83": {
            "start": 823.36,
            "end": 831.84,
            "transcript": "Ella qaillun ayuqengraan nengelvagli qaillun tua-i ayuqengraan una tua-i tekitaqluku uum yuum."
        },
        "84": {
            "start": 831.88,
            "end": 843.0,
            "transcript": "Maa-i-llu alqunaqalriatun ilangartaangluta qaillun wangkuta Yugni ciin tuatnaceta?"
        },
        "85": {
            "start": 843.64,
            "end": 857.6,
            "transcript": "Tamana-wa avani ciuqvani atulallrat makut ciulirnemta waten tua-i ellmeggnek murilkelluteng pilallruameng."
        },
        "86": {
            "start": 857.6,
            "end": 865.0,
            "transcript": "Cali canek-wa tua-i arenqiallugtarkaunrirluteng ayagatullruameng."
        },
        "87": {
            "start": 865.6,
            "end": 874.3,
            "transcript": "Ayagassuutai cali makut makucetun nutaratun ayagassuuteksaguskengamcetun ayuqevkenateng."
        },
        "88": {
            "start": 874.3,
            "end": 884.96,
            "transcript": "Tua-i amlleq tamaa-i ukut-llu atuqengain kingunrinun ayautaqluku ayuquciilengraan."
        },
        "89": {
            "start": 884.96,
            "end": 893.5,
            "transcript": "Tua-i cali qanrucimaaqluta wiinga-llu tuaten pimalallruunga ayuquciireskuma."
        },
        "90": {
            "start": 893.5,
            "end": 904.5,
            "transcript": "Qimugtenka tua-i naspaarraarluki ciulistema picimitun ayauskanga arulairlua ella assirinerciisqelluku."
        },
        "91": {
            "start": 904.5,
            "end": 919.42,
            "transcript": "Tau͡gaam tua-i camek-wa tua-i nuqitevkenateng nuqairluteng upingaluteng tua-i ayatullruameng neqkaitevkenateng."
        },
        "92": {
            "start": 919.42,
            "end": 933.22,
            "transcript": "Makut-llu wangkuta aturyaureskeput urumassuutekateng cali ucikluki canimelengraan ayallerteng arenqialluggngairulluteng."
        },
        "93": {
            "start": 933.22,
            "end": 941.92,
            "transcript": "Tua-i-llu maa-i mat'um nalliini tamaanicetun ayagayuirutukut."
        },
        "94": {
            "start": 941.92,
            "end": 948.58,
            "transcript": "Tua-i taukut nunat iliini-llu qanrut'laryaaqekaitkut."
        },
        "95": {
            "start": 948.58,
            "end": 959.96,
            "transcript": "Taquarluta pisqelluta arcaqerluku qanikciurun cikuliurun-llu tauna ucikesqelluku."
        },
        "96": {
            "start": 960.0,
            "end": 972.76,
            "transcript": "Tua-i tuaten pingraitkut maa-i mat'um nalliini inerciigatlemteggun tau͡gaam ayuqucirtuutput-wa tua-i maligtaqunritlemteggun arenqiallugtelartut."
        },
        "97": {
            "start": 972.76,
            "end": 979.9,
            "transcript": "Yuum ilii tuaten pilaquni yaaqvaarnun."
        },
        "98": {
            "start": 979.9,
            "end": 991.92,
            "transcript": "Tua-i-wa yaaqvaagnun ella assiiquaqengraan tua-i upingakuni arenqialluggngaituq."
        },
        "99": {
            "start": 991.92,
            "end": 1000.94,
            "transcript": "Wall'u ayuquciireskuni tua-i arulainqaciquq tuantarkauluni tua-i camek nuuqitevkenani."
        },
        "100": {
            "start": 1000.94,
            "end": 1008.4,
            "transcript": "Tau͡gaam wangkuta maligtaqutenritlemteggun arenqiallugtaalartukut."
        },
        "101": {
            "start": 1008.4,
            "end": 1017.72,
            "transcript": "Nallunritaput-llu makut ayagassuuteput cukamek ayalameng tua-i camek umyuarteqnarqevkenani ayakatalleq."
        },
        "102": {
            "start": 1020.0,
            "end": 1033.52,
            "transcript": "Maa-i wani allragni, allragni qanertut murilkilriit akimiaq malrugnek cipluku cuuqitellriartangqellruniluki, avgit-llu taukut taangakun wani picurlaumaluteng."
        },
        "103": {
            "start": 1033.52,
            "end": 1044.74,
            "transcript": "Taangam avatiini cat wani cali cat atuqengaput wangkuta ilalqautnguat katagissiyaallemteńun ilamteńek."
        },
        "104": {
            "start": 1045.0,
            "end": 1050.84,
            "transcript": "Tua-i-w' ava-i qanrutkekek'a inerciigatlemteggun tau͡gaam."
        },
        "105": {
            "start": 1050.84,
            "end": 1059.18,
            "transcript": "Inerqungraitkut makut ciulirnemteńek inerqumangramta ayuqucirtuumangramta-llu."
        },
        "106": {
            "start": 1061.06,
            "end": 1066.86,
            "transcript": "Tamaaggun maligtaqutenritlemteggun arenqiallugtaalartukut."
        },
        "107": {
            "start": 1067.0,
            "end": 1076.28,
            "transcript": "Kiituani-llu tua-i yuum ilii mat'ukun wangkuta apqemteggun taangamek atunrilnge'rmi."
        },
        "108": {
            "start": 1076.28,
            "end": 1084.34,
            "transcript": "Tua-i tamaaggun cali ayuqucirtuutmikun, alerquutmikun angayuqaagminek."
        },
        "109": {
            "start": 1084.34,
            "end": 1094.38,
            "transcript": "Tamana narurrluku pikuni tua-i matuunrilengraan atunrilnge'rmiu man'a arenqiallugeskuni tua-i piunriryarkauluni."
        },
        "110": {
            "start": 1094.64,
            "end": 1103.54,
            "transcript": "Tau͡gaam arenqiallugingaluni pinrilkuni tua-i cali unguvaluni nataqumaarkauluni."
        },
        "111": {
            "start": 1103.8,
            "end": 1109.48,
            "transcript": "Maa-i wani elpet ukuni search and rescue team-ani Mamterillermi uitauten."
        },
        "112": {
            "start": 1109.48,
            "end": 1118.8,
            "transcript": "Tayima-llu ataucirqunrilngurmek ilagautelalliuten temnek yuaraqata unani kuigmi drag-arluteng."
        },
        "113": {
            "start": 1118.8,
            "end": 1124.36,
            "transcript": "Qaillun wangkuta ilagauteksaitukut tamaavet amlleret ilagaucuitut."
        },
        "114": {
            "start": 1124.36,
            "end": 1132.46,
            "transcript": "Qaillun umyuarteq'larcit ayainanerpeni waten tem'ek yuarinanerpeni?"
        },
        "115": {
            "start": 1133.98,
            "end": 1141.48,
            "transcript": "Tuatenalleq imkunrituq qacignarqenrituq."
        },
        "116": {
            "start": 1141.48,
            "end": 1155.44,
            "transcript": "Cali tuatenauralriani ukut wani kingunri angayuqaak-llu makut-llu ilai yugnikek'ngai-llu tamakut umyuaqnarqut."
        },
        "117": {
            "start": 1155.54,
            "end": 1167.1,
            "transcript": "Qaillun tauna yuk ayuqluku tangrruarturcelluku yuaranarqelartuq, mermek aciani."
        },
        "118": {
            "start": 1167.1,
            "end": 1172.52,
            "transcript": "Tua-i camek umyuarteqnarqevkenani ilainek tau͡gaam."
        },
        "119": {
            "start": 1172.64,
            "end": 1180.94,
            "transcript": "Qaillun tua-i tangrruarturalrianek unguvaluku, tuqumaluku-llu nataqumallerkaa."
        },
        "120": {
            "start": 1180.94,
            "end": 1187.9,
            "transcript": "Tua-i takumcunaqluni, tau͡gaam tua-i mat'um nalliini ikayuqegcingukut."
        },
        "121": {
            "start": 1188.0,
            "end": 1198.4,
            "transcript": "Tua-i-wa waten mermun wiiinga-wa atulaqek'a mermun ekvailegma agayulartua."
        },
        "122": {
            "start": 1198.4,
            "end": 1206.86,
            "transcript": "Tua-i nataqsuumirluku tauna tua-i tau͡gaam tuaten pingraan nataqumaarkaunrilnguq nataqumaksaitelartuq."
        },
        "123": {
            "start": 1206.86,
            "end": 1213.64,
            "transcript": "Nataqumaarkaq-llu pistekaminun cali nall'arulluni nataqumaluni."
        },
        "124": {
            "start": 1214.0,
            "end": 1220.42,
            "transcript": "Maa-i cali una aipaa apyutma."
        },
        "125": {
            "start": 1220.42,
            "end": 1232.52,
            "transcript": "Tayima una yuaqek'ngarci nall'arulluni camun manarpagmun nall'arulluni ug'aqami mermek."
        },
        "126": {
            "start": 1232.52,
            "end": 1241.42,
            "transcript": "Cali wangkuta ugqerraalria mermek tangeqsaitaput, qaillun cali tamana wani tuaten ayuqellriit ayuqat?"
        },
        "127": {
            "start": 1243.0,
            "end": 1254.5,
            "transcript": "Tua-i wii tuaten nugciksaicaaqua yugmek, tau͡gaam tua-i qanrutkelarait, tua-i-w' quyanaqluni cakneq nataqumaaqami."
        },
        "128": {
            "start": 1254.5,
            "end": 1271.02,
            "transcript": "Cali piciatun uumun negcigmek, negcigmun pistekellrunrilkiinun pisqevkenaku inerquutengqertuq."
        },
        "129": {
            "start": 1271.02,
            "end": 1279.16,
            "transcript": "Tau͡gaam taumek mayurcestiin nutaan tegukaku nutaan ikayuusqelluku. (Ii-i.)"
        },
        "130": {
            "start": 1279.16,
            "end": 1292.28,
            "transcript": "Ilait-gguq tua-i taum negcigtellran nugteng'e'rmi allam teguaqani pitsaqa'artevkenani-gguq ataam kit'elartuq."
        },
        "131": {
            "start": 1292.28,
            "end": 1304.1,
            "transcript": "Tua-i tau͡gaam taum pistiin pistellran nutaan tegumarikaku nutaan ikayurarkauluku tauna pistiin."
        },
        "132": {
            "start": 1304.1,
            "end": 1317.4,
            "transcript": "Ii-i, maa-i wani wangkuta waten mat'um arenqiallugutem maani Kuigpiim Kusquqviim-llu avatiini piarkaunrituq."
        },
        "133": {
            "start": 1317.4,
            "end": 1332.5,
            "transcript": "Tau͡gaam cali waten, waten ayuqluni man'a ellarpamteńi piuralput tua-i-w' caknernaqluni."
        },
        "134": {
            "start": 1332.5,
            "end": 1339.04,
            "transcript": "Una cali Daniel-aaq ataucirqumek uterqikluku cali."
        },
        "135": {
            "start": 1339.04,
            "end": 1347.62,
            "transcript": "Qaillun maa-i kiaku, kiagpak man'a wani kiak ullakengarput maa-i."
        },
        "136": {
            "start": 1347.62,
            "end": 1356.0,
            "transcript": "Allauvkaryugngaceta ciunganimi makut waten picurlagalriit ikgenritenritlerkaat umyuaqluku?"
        },
        "137": {
            "start": 1357.0,
            "end": 1363.78,
            "transcript": "Wii, pii ilumuyaaquq man'a yuuyararput cimillra."
        },
        "138": {
            "start": 1363.78,
            "end": 1375.18,
            "transcript": "Pii merkun ayagalriani angyatgun ayagaqluta, cukanraarluuta-llu ayagaqluta."
        },
        "139": {
            "start": 1375.18,
            "end": 1385.52,
            "transcript": "Tau͡gaam meq man'a cimiqsaituq, cimissiy'aksaituq. Pii nuna-llu cali man'a cimissiy'aksaunani-llu cali."
        },
        "140": {
            "start": 1387.76,
            "end": 1401.26,
            "transcript": "Tamana tamakut aturaqluki waten civuliamcetun nerengnaqu'urturluta atu'urturluki, kuiget aturturluku-llu man'a nunam qainga."
        },
        "141": {
            "start": 1402.0,
            "end": 1410.2,
            "transcript": "Ellait atullrit makut qaneryaraat-llu aturnarqut cali waten meq atulriani."
        },
        "142": {
            "start": 1410.2,
            "end": 1415.72,
            "transcript": "Nuna-q'-llu man'a atulriani cali qaneryaraq-llu cali aturnaqluni."
        },
        "143": {
            "start": 1415.72,
            "end": 1428.78,
            "transcript": "Waten wangkutnun murilkelluta pisqelluta qanrucimaukut, ilaput-llu cali murilkelluki, murilkesqelluki cali qanrucimaukut."
        },
        "144": {
            "start": 1428.78,
            "end": 1432.32,
            "transcript": "Elluarrluta waten murilkuulluta piuraqumta."
        },
        "145": {
            "start": 1432.4,
            "end": 1448.36,
            "transcript": "Ilaput-llu cali qanirturaqluki waten pugtautessuutet atusqelluki piaqluki piuraqumta waten assirluta piuryartukut."
        },
        "146": {
            "start": 1448.36,
            "end": 1462.08,
            "transcript": "Waten-llu nunaniryungnaqelriani-llu cali tamana cangatevkenani, canricaqluni, Yupiit tamalkurmeng nunaniryugluteng uitayutuut."
        },
        "147": {
            "start": 1463.84,
            "end": 1478.74,
            "transcript": "Waten mer'avkenani, cameng-llu umyugamta tamarillem tungiinun aturpegnani pilriani nunaniryulleq waten assinrutuuq."
        },
        "148": {
            "start": 1478.74,
            "end": 1491.08,
            "transcript": "Tamakut aturturluki piuraqumta, pii qaneryaraat aturturluki piuraqumta nallairpegnaki, avatairpegnaki."
        },
        "149": {
            "start": 1491.08,
            "end": 1497.52,
            "transcript": "Tau͡gaten piuraqumta ikeggliikanirciqut picurlalriit."
        },
        "150": {
            "start": 1497.52,
            "end": 1508.14,
            "transcript": "Ii-i, nutaan wani maa-i atauciq, ataucirmek tayima waten atakurpak niitelput."
        },
        "151": {
            "start": 1508.14,
            "end": 1520.0,
            "transcript": "Tangerrluku, wall'u tua-i niitelput piluku ataucimek unguvamek anirturikumta tamana wani ikayuutnguciiquq, makut-llu cali arcaqerluteng maa-i."
        },
        "152": {
            "start": 1520.06,
            "end": 1532.42,
            "transcript": "Wangkutni cali yuuyaramteńi maani-wa Yup'igni kit'essuutet nutaraulriatun ayuqluteng cali eliteksaunaki atullrit."
        },
        "153": {
            "start": 1532.42,
            "end": 1539.82,
            "transcript": "Una wani Chuck Hunt-aq allragni ilaminek tamarillruuq cali cuuqilluni."
        },
        "154": {
            "start": 1539.82,
            "end": 1547.04,
            "transcript": "Kotlik-aami ellii qanertuq makunek wani kit'essuutnek atulria kina imna."
        },
        "155": {
            "start": 1547.04,
            "end": 1561.0,
            "transcript": "Elicugnganiluku piksagulluku makucetun maa-i akmani nunarpagni, nunakuarcuutekun, nunakuarcuucetgun ayalriit picirkiutengqertut naqugtarkauluteng."
        },
        "156": {
            "start": 1561.0,
            "end": 1571.2,
            "transcript": "Maa-i cali wangkuta maani avatemteńi kuiget unkut tumyaraqellriatun ayagassuutekellriatun ayuqut"
        },
        "157": {
            "start": 1571.2,
            "end": 1582.1,
            "transcript": "Makut-llu kit'essuutet wangkutnun nepcugngaluteng taangaq wangkutnun cali tememteńun neptelauciatun."
        },
        "158": {
            "start": 1582.1,
            "end": 1593.8,
            "transcript": "Tamatum wani kit'essuun una wani tememteńun piureskan cimirciqliuq man'a wani assiirutellriatun waniwa Chuck Hunt-aq niicugniqernauput."
        },
        "159": {
            "start": 1597.34,
            "end": 1603.62,
            "transcript": "Cat piciatun nutarat at'aqamteki aviranaqlartut."
        },
        "160": {
            "start": 1603.62,
            "end": 1612.36,
            "transcript": "Ackiit at'ellrianek ciuqlirmek aviranaqlartut, au͡g'arluki-llu wangkuta elliluki atuqsaunata."
        },
        "161": {
            "start": 1612.36,
            "end": 1620.74,
            "transcript": "Cali iliikun umyugarteqluta kegginarput waten tangniacukluku ackiignek aturngamta."
        },
        "162": {
            "start": 1620.74,
            "end": 1626.96,
            "transcript": "Wall'u cass'anek atu'urqamta ciuqlirmi aviranaqlartut."
        },
        "163": {
            "start": 1626.96,
            "end": 1634.74,
            "transcript": "Wall'u sap'akinek nataranek pingaqamta aviranaqlartut."
        },
        "164": {
            "start": 1634.74,
            "end": 1644.06,
            "transcript": "Cali-llu tuaten makut maani piciatun atlerput qaimteńun ciuqlirmi atulriani aviranaqlartut."
        },
        "165": {
            "start": 1644.06,
            "end": 1661.22,
            "transcript": "Tau͡gaam aturtaartulriani, aturtaarluki aturaqluki pilriani assiriluteng qaimteńun neptellriatun ayuqluteng. Tuaten cali makut maani pugtassuutet ayuqut."
        },
        "166": {
            "start": 1661.22,
            "end": 1673.7,
            "transcript": "Tuaten aturturalriani cat piciatun qaimteńun tuaten piksagullaraa qaimta."
        },
        "167": {
            "start": 1673.7,
            "end": 1680.14,
            "transcript": "Au͡g'alriani-llu tuarpiaq-llu ilii qaimta au͡g'alria."
        },
        "168": {
            "start": 1680.14,
            "end": 1691.82,
            "transcript": "Tuaten tau͡gaam wangkuta elitnarquukut maa-i-rpak aturtalriani nutaan avaiviirulluku [?]."
        },
        "169": {
            "start": 1694.64,
            "end": 1706.46,
            "transcript": "Quyana wani ilagarluta atakurpak uumek wani special program-aamek. Tayima au͡gkut Peter Isaac-aam wall'u Daniel Bill-am qalartellri."
        },
        "170": {
            "start": 1706.46,
            "end": 1714.28,
            "transcript": "Au͡g'um-llu cali qalartellri niilluki umyuaqekumteki tamatumun cali ikayuutnguciquq ciunerkamteńi."
        },
        "171": {
            "start": 1714.28,
            "end": 1718.96,
            "transcript": "Umyuaqluku waten aknirtenritlerkan."
        },
        "172": {
            "start": 1718.96,
            "end": 1730.24,
            "transcript": "Cali tua-i-wa umyuaqengnaqluta unaggun kuigkun ayaganiartut cali kuik takaqellriatun ayuqulluku. Quyana cakneq."
        }
    },
    "mVCyBKHIsa4": {
        "1": {
            "start": 108.52,
            "end": 113.62,
            "transcript": "Cama-i! Quyana ilagaqatarluta Qanrutkumaarkanun Avatemteńi."
        },
        "2": {
            "start": 113.62,
            "end": 131.46,
            "transcript": "Ayagnirluteng am'um Agayunrem tailriim nalliini April 22nd, tekilluku April 25-aaq, ukut Yukon Kuskokwim Health Corporation-aat arulaciqatalliniut uumek aterluni waten \"Quyumta Piniringluta\"."
        },
        "3": {
            "start": 131.46,
            "end": 139.74,
            "transcript": "Ukut YKHC-t man'a arulataat cali ikayurluteng allanek calistemeggnek tamaani allanek tuaten."
        },
        "4": {
            "start": 139.74,
            "end": 156.0,
            "transcript": "Tayima-llu neryuniurtut cip'arrluku 300-aat cipluki amlletarnayukluki ilagauteqatalriit nunarrarnek tailuteng maaken YKHC-m ikayuqngait nunaitnek."
        },
        "5": {
            "start": 156.0,
            "end": 162.04,
            "transcript": "Waniwa allanregka alqaqellriik ukuuguk."
        },
        "6": {
            "start": 162.04,
            "end": 171.12,
            "transcript": "Una ciumek Pupsuc'ngaq Elizabeth Sonnyboy, kanani YKHC-ni calituluni."
        },
        "7": {
            "start": 171.12,
            "end": 185.56,
            "transcript": "Una-llu cali alqaan aipaa Mary Stachelrodt Uyuruciar, cali mat'umek ikayuulluni arulacistenguluni."
        },
        "8": {
            "start": 185.56,
            "end": 189.06,
            "transcript": "Quyana tailutek."
        },
        "9": {
            "start": 189.06,
            "end": 204.86,
            "transcript": "Kitak pitaarlutek qanruarteqerkut makunek ayuqenrilnguut, ayuqenrilngurnek-wa caqtaaqatallritnek quyurvakata ukut am'um Agayunrem tailriin nalliini."
        },
        "10": {
            "start": 204.86,
            "end": 213.14,
            "transcript": "Ciumek Pupsuc'ngaq, aren Uyuruciar. Pitsaqenritamken."
        },
        "11": {
            "start": 213.14,
            "end": 225.52,
            "transcript": "Man'a tribal unity-q cali-llu traditional medicine-aam meaning-aara caularta ketvarteqerru tamana."
        },
        "12": {
            "start": 225.52,
            "end": 237.12,
            "transcript": "Tua-i quyureskumta makut qalarutekciqaput. Una-llu yuut-wa tua-i quyurmeng quyurutellerkaat."
        },
        "13": {
            "start": 237.12,
            "end": 246.7,
            "transcript": "Cali-llu yuut, tua-i-w'. (Yuut piciryaraitgun.) Iinruit."
        },
        "14": {
            "start": 246.7,
            "end": 250.08,
            "transcript": "Yuut-wa piciryaraitgun iinruit."
        },
        "15": {
            "start": 252.0,
            "end": 258.44,
            "transcript": "Man'a tribe-anek niitelartukut. Tribal unity-q cauga?"
        },
        "16": {
            "start": 258.44,
            "end": 264.1,
            "transcript": "Tua-i-w' quyumta-gguq Yugni, quyurrluta waten."
        },
        "17": {
            "start": 264.1,
            "end": 270.78,
            "transcript": "Una-llu cali quyurtellriit amllertut, una-llu atauciuluni."
        },
        "18": {
            "start": 270.78,
            "end": 277.58,
            "transcript": "Maani tau͡gaam ciungani piut waten, quyurrluteng, yuut tamalkurmi."
        },
        "19": {
            "start": 278.32,
            "end": 282.14,
            "transcript": "Man'a-mi tribal medicine cauga tamana?"
        },
        "20": {
            "start": 282.14,
            "end": 289.28,
            "transcript": "Medicine-aamek qitevqurluteng qanaagaqata iinrumek umyuaqertelartua."
        },
        "21": {
            "start": 289.28,
            "end": 291.0,
            "transcript": "Tuaten-qaa tamana ayuquq?"
        },
        "22": {
            "start": 291.0,
            "end": 303.08,
            "transcript": "Tua-i-w' qalaruteknaluki tamakut yuut calallrit cali-llu maani nunarpamteńi cali yuut atularyaaqut."
        },
        "23": {
            "start": 303.08,
            "end": 306.6,
            "transcript": "Tamakunek qalarutesqelluku-w' yuut."
        },
        "24": {
            "start": 306.6,
            "end": 314.76,
            "transcript": "Ilait tekilluteng maani nunarramteńek tamana qalarutekciqaat. Mam'illerkaat-wa tuut."
        },
        "25": {
            "start": 314.76,
            "end": 317.92,
            "transcript": "Ii-i. Ak'allaat piciryarait aturluki?"
        },
        "26": {
            "start": 317.92,
            "end": 318.74,
            "transcript": "Ii-i."
        },
        "27": {
            "start": 318.74,
            "end": 320.12,
            "transcript": "Oh. Ii-i."
        },
        "28": {
            "start": 320.12,
            "end": 332.06,
            "transcript": "Kitek Pupsuc'ngaq, nutaan man'a iliit quyurutkarkaat common vision-aamek at'lek."
        },
        "29": {
            "start": 332.06,
            "end": 342.68,
            "transcript": "Tunglia-wa ilagalluteng naparcillerkaat, tua-i-w' tuaten wii mumigeskeka."
        },
        "30": {
            "start": 342.68,
            "end": 344.1,
            "transcript": "Cauga tamakut, taukuk?"
        },
        "31": {
            "start": 345.94,
            "end": 351.36,
            "transcript": "Waniwa ukuk malruk wani cali yuvrirarkaput wani common vision."
        },
        "32": {
            "start": 351.36,
            "end": 359.96,
            "transcript": "Quyurramta-gguq tangrruararkaput wani kitugutput wani yuvriqumteki."
        },
        "33": {
            "start": 359.96,
            "end": 366.66,
            "transcript": "Tangrruarturluki wani tuaten kitugutput paivtarkauluki."
        },
        "34": {
            "start": 366.66,
            "end": 370.02,
            "transcript": "Cali una proactive partnership building."
        },
        "35": {
            "start": 370.02,
            "end": 379.82,
            "transcript": "Ikayuqu'urluta-gguq tangelput wani tangrruarturluki, arenqiallugutet qaillun kitugteqatarceta."
        },
        "36": {
            "start": 379.82,
            "end": 392.58,
            "transcript": "Tamakut tangrruarturluki cuqyutekluki-llu tamamta ikayuqu'urluta calillerkamteńun taukut tungiitnun."
        },
        "37": {
            "start": 392.58,
            "end": 398.66,
            "transcript": "Iciw' uitavkenata qaillun caliyaurteqatarceta ikayuqu'urluta."
        },
        "38": {
            "start": 398.66,
            "end": 409.64,
            "transcript": "Taukuk cali taringyukuvciki, wavet quyureskumta tainiartuci niicugniyarturluci."
        },
        "39": {
            "start": 409.64,
            "end": 413.6,
            "transcript": "Ii-i, Uyuruciar."
        },
        "40": {
            "start": 413.6,
            "end": 428.9,
            "transcript": "Akmani ilaput, Ingqilinek pitukeput, quyurvagaqata cali ellait wagg'uq powwow-aquluteng wall'u-q' allanek Ingqilit piciryarait aturluki."
        },
        "41": {
            "start": 428.9,
            "end": 434.06,
            "transcript": "Niitelartua mat'umek talking circle-aamek, cauga tamana?"
        },
        "42": {
            "start": 434.06,
            "end": 441.8,
            "transcript": "Wangkuta-llu-gguq Yugni pilallruukut tuaten, waten quyumta aqumluta qalartaqluta."
        },
        "43": {
            "start": 441.8,
            "end": 448.52,
            "transcript": "Camek tua-i anciyukumta, waten una-gguq talking circle-aaq aturluku."
        },
        "44": {
            "start": 448.52,
            "end": 456.06,
            "transcript": "Ak'a-llu-gguq tuaten pilallruut arnat waten monthly-raqameng."
        },
        "45": {
            "start": 456.06,
            "end": 463.98,
            "transcript": "Iciw' tuaten quyurrluteng qalartaqluteng, ca-gguq anciyugngaluku tuani talking circle-aami."
        },
        "46": {
            "start": 463.98,
            "end": 466.72,
            "transcript": "Tuaten-llu piciqukut quyureskumta."
        },
        "47": {
            "start": 466.72,
            "end": 477.16,
            "transcript": "Ii-i. Piciatun-qaa yuut qalarculriit qalarcugngaluteng tuani?"
        },
        "48": {
            "start": 477.16,
            "end": 486.72,
            "transcript": "Tuani-wa waten pitaarturluteng, yuut waten quyurrarmeng aqumluteng uivvaarluteng waten qalartaqluteng."
        },
        "49": {
            "start": 486.72,
            "end": 498.16,
            "transcript": "Ataucimek-llu waten tegumiarluteng iliini teggalqurraq wall'u-q' ca apallircuutnek iciw' pilallrukait au͡gkut, talking stick, tuaten."
        },
        "50": {
            "start": 498.16,
            "end": 508.26,
            "transcript": "Tua-llu yuk qanquni anciluni wall'u-q' piicagluni, tua-i-ll' taqkuni allamun tunluku waten."
        },
        "51": {
            "start": 508.26,
            "end": 514.3,
            "transcript": "Qaqiskunek tau͡gaam cali-llu piyukuneng cali piaqluteng."
        },
        "52": {
            "start": 514.3,
            "end": 516.46,
            "transcript": "Tamana aturluku."
        },
        "53": {
            "start": 516.46,
            "end": 529.0,
            "transcript": "Tuani-llu call' uivenqellriami tamana aturaqamteggu, kina quigpek'nani, kina-ll' aciqvantevkenani, tamamta wani ayuqurluta tuani."
        },
        "54": {
            "start": 529.0,
            "end": 540.02,
            "transcript": "Iliita-llu wani qanrutkellrukii, ircaqumteggun-gguq taringuqu'urluta, tuani uivenqellriani tamana aturaqamteggu."
        },
        "55": {
            "start": 540.02,
            "end": 544.7,
            "transcript": "Cunawa-am yuut tuatnalallrulriit maani ak'a tamaani."
        },
        "56": {
            "start": 544.7,
            "end": 557.36,
            "transcript": "Kitak, man'a-mi preventive health care? Man'a-qaa imuuguq-qaa naulluunritengnaqsaram tungiinun caliaruuq?"
        },
        "57": {
            "start": 557.36,
            "end": 568.54,
            "transcript": "Ii-i. Cat wani arenqiallugutet pugvailgata caliaqellerkait yuvrillerkait-llu tamatuuguq."
        },
        "58": {
            "start": 568.54,
            "end": 577.24,
            "transcript": "Camek maa-irpak wani arenqiallugutet pug'aqata ullagarut'lalriakut tua-i-ll' caliaqluki."
        },
        "59": {
            "start": 577.24,
            "end": 593.7,
            "transcript": "Tamakut-gguq pugengvailgata assinruciqngan wani yuvrirturluki arenqiallugutet wani pugvailgata caliaqengnaqlerkait wall'u kitugtengnaqlerkait."
        },
        "60": {
            "start": 593.7,
            "end": 598.0,
            "transcript": "Tuaten yuvrirarkauluki tuani quyureskumta."
        },
        "61": {
            "start": 598.0,
            "end": 601.82,
            "transcript": "Ii-i. Man'a-mi community development?"
        },
        "62": {
            "start": 601.82,
            "end": 609.3,
            "transcript": "Nunarraat-qaa aturyuk'ngait ayagniutekaat qaillun-llu tamana ayuqa?"
        },
        "63": {
            "start": 609.3,
            "end": 622.16,
            "transcript": "Yaa. Tuani wani quyurtaaraqamta nunacuarni, tamakut nunacuaraam wani yui ikayuqluki."
        },
        "64": {
            "start": 622.16,
            "end": 637.46,
            "transcript": "Ikayuqu'urluteng tuani mat'umek wani pugcingnaqellriit ikayuulluteng qaillun tamarmeng yuut ikayuqu'urluteng pillerkameggnek tamana yuvrituat."
        },
        "65": {
            "start": 637.46,
            "end": 649.7,
            "transcript": "Ii-i, Uyuruciar. Man'a-mi pinircallerkaa yuum ilakuralriit-llu nunat tuaten caugat?"
        },
        "66": {
            "start": 649.7,
            "end": 653.28,
            "transcript": "Strengthening individual family community, cauga tamana?"
        },
        "67": {
            "start": 653.28,
            "end": 669.78,
            "transcript": "Tua-i-gguq nakmiin waten yuk pinircangnaqluni ilani-llu ilakluki waten cali-llu nunacuarneng piniringnaqluteng-wa."
        },
        "68": {
            "start": 669.78,
            "end": 675.04,
            "transcript": "Tamakunek workshop-acuarluteng piciqsugnarqut."
        },
        "69": {
            "start": 675.04,
            "end": 685.14,
            "transcript": "Tamana-llu qalarutek'larciqaat, nakmiin-wa piniriyungluta, mam'ingiyungluta-w' waken."
        },
        "70": {
            "start": 685.14,
            "end": 695.46,
            "transcript": "Waten mam'ikumta wangkutnek ilaput ikayuryugngangluki, nunarraput-llu, ilaput-llu tamalkuita."
        },
        "71": {
            "start": 695.46,
            "end": 700.34,
            "transcript": "Yuk tua-i mam'ikuni allamek agturciquq tuaten."
        },
        "72": {
            "start": 703.74,
            "end": 716.36,
            "transcript": "Pupsuc'ngaq, man'a caqtaaqatallrat caliurluni pingaicugnarquq, allanek-llu-qaa irr'inarqellrianek caqtaarciqut tua-i?"
        },
        "73": {
            "start": 716.36,
            "end": 731.02,
            "transcript": "Ii-i. Ap'ama call' alerqullruanga-wa tamana qanrutkesqelluku cali callerkamteńek waten calirrlainarluta yuunritniluta."
        },
        "74": {
            "start": 731.02,
            "end": 735.04,
            "transcript": "Tau͡gaam iliikun-llu anglaniqaqluta pilaasqelluta."
        },
        "75": {
            "start": 735.04,
            "end": 738.46,
            "transcript": "Assiriyukumta tamalkurrluta."
        },
        "76": {
            "start": 738.46,
            "end": 743.12,
            "transcript": "Anglanitekat-llu ilait wani cayaraput-llu puggluki."
        },
        "77": {
            "start": 743.12,
            "end": 753.1,
            "transcript": "Yurarciqut tamaani, atualuteng, wall'u qanemciluteng, wall' cali agnguarluteng-llu call'."
        },
        "78": {
            "start": 753.1,
            "end": 759.1,
            "transcript": "Tamakut tamalkuita pugqurluki aturturluki-ll' tuani quyurvakumta piciqaput."
        },
        "79": {
            "start": 759.1,
            "end": 765.56,
            "transcript": "Tua-i-gguq tamalkurrluta assirillerkaput tangvagluku."
        },
        "80": {
            "start": 765.56,
            "end": 771.6,
            "transcript": "Calirrlainarpek'nata iliikun anglaniqaqluta ngel'arceciaqluta-llu."
        },
        "81": {
            "start": 771.6,
            "end": 780.0,
            "transcript": "Tamakutgun-gguq ikayuqu'urluta assiriyukumta mamyukumta-llu, tamakut-llu aturarkauluki."
        },
        "82": {
            "start": 781.48,
            "end": 798.52,
            "transcript": "Tua-ll', Uyuruciar. Nutaan-qaa waten piqatartut maani quyurvagluteng waten tua-llu-qaa kinguani allrakutaalriit iluitni watnaaqluteng pilarciqut?"
        },
        "83": {
            "start": 798.52,
            "end": 804.72,
            "transcript": "Tua-i-wa una ciungani waten quyurteksailameng."
        },
        "84": {
            "start": 804.72,
            "end": 817.54,
            "transcript": "Cali-llu qangvaq-wa maani quyurtellrulriakut, iciw' pathway to wholeness-aami, 88-89 right around there pillrulriakut, quyurrluta waten."
        },
        "85": {
            "start": 817.54,
            "end": 828.04,
            "transcript": "Tau͡gaam waten anglriamek quyurvagmek waten piniringnaqluta piqaqsaitukut maani Mamterillermi waten ayuqellriamek."
        },
        "86": {
            "start": 828.04,
            "end": 836.54,
            "transcript": "Ak'a-gguq tau͡gaam quyurtelallruut kalukarluteng, allanek-llu nunacuarnek kelgiluteng."
        },
        "87": {
            "start": 836.54,
            "end": 844.64,
            "transcript": "Quyurrluteng tua-i-w' anglaniluteng, yurarluteng, nerluteng, cikiraqluteng-llu canek."
        },
        "88": {
            "start": 844.64,
            "end": 848.96,
            "transcript": "Tua-i tuaten tamana umyuaqluku quyurtut."
        },
        "89": {
            "start": 848.96,
            "end": 860.82,
            "transcript": "Allat-llu cali maani Alaska-m nuniini nunarpamteńi quyurtelartut waten tua-i-w' ayuqluku una."
        },
        "90": {
            "start": 860.82,
            "end": 868.56,
            "transcript": "Iliini-llu qavcini tallimani ernerni quyurtelartut."
        },
        "91": {
            "start": 868.56,
            "end": 880.48,
            "transcript": "Cali-llu quyurciiqut. Cali last year August-aami quyurtellruut. Cali-ll' quyurteqatarluteng Tanacross-ami waten ayuqellriat."
        },
        "92": {
            "start": 880.48,
            "end": 883.5,
            "transcript": "Allat-llu nunat. Cali pilituut."
        },
        "93": {
            "start": 883.5,
            "end": 894.24,
            "transcript": "Cali ciungani waten piksailamta-llu akimianek nunacuarnek kelgiukut."
        },
        "94": {
            "start": 894.24,
            "end": 900.0,
            "transcript": "Cetamaqtaarluki tuaken wani nunacuarmek kelgiluta."
        },
        "95": {
            "start": 900.0,
            "end": 904.24,
            "transcript": "Tuatelluni [?] yugyapiartuq maani."
        },
        "96": {
            "start": 904.24,
            "end": 916.4,
            "transcript": "Yugyakataan-llu ikayuucukata yuut, enekanek-llu yuaryaaqukut, ikayuqaasqelluta tamaaggun."
        },
        "97": {
            "start": 916.4,
            "end": 925.72,
            "transcript": "Yuut ilait wani enenek nekaiciiqngata taikuneng ikayuqaasqelluta-llu tamaaggun kaigayaaqukut."
        },
        "98": {
            "start": 925.72,
            "end": 937.58,
            "transcript": "Nek'anek, nek'angqerqata yuut qayagauresqelluki iciw' yugmek wani allanenqerrsukata ikayuusqelluta."
        },
        "99": {
            "start": 937.58,
            "end": 940.24,
            "transcript": "Kinkut qayagaurluki?"
        },
        "100": {
            "start": 940.24,
            "end": 946.82,
            "transcript": "Darlene Wright-aq YKHC-mi, Nellie Kiunya-q-llu call'."
        },
        "101": {
            "start": 946.82,
            "end": 953.36,
            "transcript": "Taukuk wani arcaqerlukek wani qayagaurlukek, 543-3321."
        },
        "102": {
            "start": 953.36,
            "end": 967.0,
            "transcript": "Nek'anek, nevcenek wani enetgun-wa tua-i ikayuucukata allanengqerrsukata taukuk qayagauresqellukek."
        },
        "103": {
            "start": 967.0,
            "end": 984.56,
            "transcript": "Tarenriurteput una Dean Swope-aq watua kanavet YKHC-nun ukut tarenrat piliat mingullrit tarenriaqeryartullrui."
        },
        "104": {
            "start": 984.56,
            "end": 994.5,
            "transcript": "Pupsuc'ngaq, kitek ukutgun TV-tgun pugqertaqata qanrutkeqerki."
        },
        "105": {
            "start": 994.5,
            "end": 998.2,
            "transcript": "Kia makut tarenraliat piliaqellruaki?"
        },
        "106": {
            "start": 998.2,
            "end": 1016.66,
            "transcript": "Earl Atchak, James Angaiak-llu wani, taukuk wani ikayuutuk cakneq wani wavet wani ukunun wani iciw' draw-rlutek makunek-llu caanguanek wani pilutek."
        },
        "107": {
            "start": 1016.66,
            "end": 1036.62,
            "transcript": "Una wani paivtellria imuuguq wani man'a wani nunaput, nunaput wani piciatun wani Alaska-mi nunaput caliaqellratgu, Alaska lands claim tuani tutellrani."
        },
        "108": {
            "start": 1036.62,
            "end": 1046.4,
            "transcript": "Tauna una atuullruuq."
        },
        "109": {
            "start": 1046.4,
            "end": 1054.12,
            "transcript": "Makut-wa tarenrat nasvaumaciqellilriit tuani quyurrviatni piani."
        },
        "110": {
            "start": 1054.12,
            "end": 1055.78,
            "transcript": "Nani-ima quyurteqatalriit?"
        },
        "111": {
            "start": 1055.78,
            "end": 1061.76,
            "transcript": "High school-ami pamani tuana quyurvalput aturciqaput."
        },
        "112": {
            "start": 1061.76,
            "end": 1066.04,
            "transcript": "Tua-i-ll' ukuni tarenrani cetamaugut ava-i."
        },
        "113": {
            "start": 1066.04,
            "end": 1075.28,
            "transcript": "Una wani land claim-at wani, au͡gna ciuqlia piqallra wani land claim-at pikaat."
        },
        "114": {
            "start": 1075.28,
            "end": 1086.08,
            "transcript": "Una-llu wani YKHC-mi caliaput wani nunacuaraat wani ullagtaarturluki wani."
        },
        "115": {
            "start": 1086.08,
            "end": 1093.34,
            "transcript": "Quyurtellalriakut ullagtaarturluki ikayuayarturluki wani."
        },
        "116": {
            "start": 1093.34,
            "end": 1098.02,
            "transcript": "Camek kaigaaqata wani ikayungcarluteng YKHC-m."
        },
        "117": {
            "start": 1098.02,
            "end": 1117.16,
            "transcript": "Ukut hospital-armiut ikayuqluki wall'u yungcaristait ikayuqluki wall'u quyurulluki council-aat arenqiallugutaitnek-llu tangvagcelluta paivvluteng, qaillun-ll' ikayullerkaitnek paivvluki."
        },
        "118": {
            "start": 1117.16,
            "end": 1128.16,
            "transcript": "Cali wani calivigmi wani YKHC-mi piciatun wani ikayurteńek pitangqertuq."
        },
        "119": {
            "start": 1128.16,
            "end": 1140.26,
            "transcript": "Taanganriryulriit ikayuayugngaluki wall'u wani kegguciuryulriit ikayuryugngaluki, ackiingyulriit ikayuryugngaluki."
        },
        "120": {
            "start": 1140.26,
            "end": 1146.82,
            "transcript": "Tamakunek wani ikayurtengqertut YKHC-mek kaigayugngaluteng."
        },
        "121": {
            "start": 1146.82,
            "end": 1152.78,
            "transcript": "Tua-i-llu wani, wani au͡gumi cauyaq qukaami uitalria."
        },
        "122": {
            "start": 1152.78,
            "end": 1167.44,
            "transcript": "Taum cauyam yuut tamalkuita kelelriacetun pilaaki qukaani wani YKHC-m wani ikayurtain qukaani wani cauyaq uitauq."
        },
        "123": {
            "start": 1167.44,
            "end": 1179.36,
            "transcript": "Tua-i-wa waten assiritmun yuut ilakliutellerkaitnun cingumalaaku mat'um wani YKHC-m."
        },
        "124": {
            "start": 1179.36,
            "end": 1193.3,
            "transcript": "Tua-i-ll' cali yuvriqerluku wani qaillun yuk, Yupiit-llu makut nerangnaqsarait wani ukunek paivarrluteng."
        },
        "125": {
            "start": 1193.3,
            "end": 1203.2,
            "transcript": "Assirpaa! Tua-i-ll' cali yuungcaristait wall'u nunacuarni wani health aide-angqellriit ikayurtengqerrluteng tamakunek."
        },
        "126": {
            "start": 1203.2,
            "end": 1211.58,
            "transcript": "Tuaten tamamta quyurramta ikayuqu'urluta nunacuarni calilaamta."
        },
        "127": {
            "start": 1211.58,
            "end": 1229.06,
            "transcript": "Tamakut yuut tangerrsukatki-wa tua-i makut tarenraliat pianciiqelliniut ukut YKHC-t quyurvakata \"Quyumta Piniringnaqluta\" quyurvakata tamatumek."
        },
        "128": {
            "start": 1229.06,
            "end": 1238.5,
            "transcript": "Yaa, agangqaciqut wani yuut tangerrlarniarait pamani apcukuneng-llu caullritnek ap'artaqluta piniaraitkut."
        },
        "129": {
            "start": 1238.5,
            "end": 1250.1,
            "transcript": "Tua-i-ll' una wani tarenraq wani tangvalput, ak'a avani atullrit qaillun-llu cimingellra yuut wall' Yupiit maa-i."
        },
        "130": {
            "start": 1250.1,
            "end": 1257.64,
            "transcript": "Iciw' tuar aturait cimingluteng wall' cayarait cimingluteng tauna nasvaumauq."
        },
        "131": {
            "start": 1257.64,
            "end": 1268.84,
            "transcript": "Neryaraput-ll' man'a cimingluni, elitnaungluta ayagcuuteput-llu cimingluteng."
        },
        "132": {
            "start": 1268.84,
            "end": 1280.1,
            "transcript": "Wall'u caliyaraput agayulirtet-llu tekitellruluteng elitnaurvingluta tuaten yuungcaristet-llu tekirqelluteng."
        },
        "133": {
            "start": 1280.1,
            "end": 1288.86,
            "transcript": "Qaillun wani piciryaraput wall' yuuyaraput-llu man'a cimingellranek taukut wani tekirqellratni."
        },
        "134": {
            "start": 1288.86,
            "end": 1295.42,
            "transcript": "Tauna taunguluni nasvicimaluni."
        },
        "135": {
            "start": 1295.42,
            "end": 1306.4,
            "transcript": "Yuut piciryarait ak'a tamaakenirnek man'a ngelkarrluku una tarenraq nasvaigilliniuq yugnun."
        },
        "136": {
            "start": 1306.4,
            "end": 1311.1,
            "transcript": "Cimingellrit wani yuut cayarait."
        },
        "137": {
            "start": 1311.1,
            "end": 1316.32,
            "transcript": "Ii-i, yaa."
        },
        "138": {
            "start": 1316.32,
            "end": 1322.1,
            "transcript": "Ukuk piliaqestek makut tarenrat kanani-qaa YKHC-ni calituuk?"
        },
        "139": {
            "start": 1322.1,
            "end": 1332.24,
            "transcript": "Nuu, ukuk wani imkuuguq wani piyugteqlutek taillruuk ellmeggnek maniitellruuk wani waten pilarnilutek."
        },
        "140": {
            "start": 1332.24,
            "end": 1341.84,
            "transcript": "Tua-i-llu quyaqerluta wangkuta ikayuqluki. Maa-i ikayuucagnek quyaviklukek Earl Atchak, James Angaiak-llu."
        },
        "141": {
            "start": 1341.84,
            "end": 1344.02,
            "transcript": "Quyanarquk."
        },
        "142": {
            "start": 1344.02,
            "end": 1352.96,
            "transcript": "Tua-i-ll' cali una wani imuuguq tarenraq waniwa, \"ak'a imumi atulalput\"."
        },
        "143": {
            "start": 1352.96,
            "end": 1363.0,
            "transcript": "Ciuliamta wani atulallrit, yurarluteng, pissuryarluteng, calinguaraqluteng piciatun."
        },
        "144": {
            "start": 1363.0,
            "end": 1370.24,
            "transcript": "Atullrit wani ak'a cimingvailgata ayuquciput."
        },
        "145": {
            "start": 1370.24,
            "end": 1381.04,
            "transcript": "Elitnaurvingvailgata-llu ayuqucillrat wani makut ak'a imumi."
        },
        "146": {
            "start": 1381.04,
            "end": 1390.62,
            "transcript": "Qayarluteng-llu pissuryaraqluteng wall' neqsurluteng, neqkameggnek tua-i kiagmi-llu segluteng."
        },
        "147": {
            "start": 1390.62,
            "end": 1400.3,
            "transcript": "Wall'u uksuarmi yaqulegnek-llu pissuraqluteng qayarluteng wall' atsassurluteng."
        },
        "148": {
            "start": 1400.3,
            "end": 1408.1,
            "transcript": "Tua-i cayarallrit wani ak'a ciuliamta piciryarait."
        },
        "149": {
            "start": 1408.1,
            "end": 1415.24,
            "transcript": "Atsassurluni tauna qemagtarkaminek kiagmi."
        },
        "150": {
            "start": 1415.24,
            "end": 1428.28,
            "transcript": "Tayima tang ayagyuat elitnaurat-llu eliciiqsugnarqellriit makunek tarenranek ak'a tamaani yuut piciryarallrit nasvaumaluteng tarenrakun."
        },
        "151": {
            "start": 1428.28,
            "end": 1438.98,
            "transcript": "Yaa, tua-i-ll' tauna wani piklermegnek nunamun wani teq'aciluteng."
        },
        "152": {
            "start": 1438.98,
            "end": 1442.82,
            "transcript": "Canek aturkameggnek uksumi manaraluteng."
        },
        "153": {
            "start": 1442.82,
            "end": 1452.34,
            "transcript": "Tua-i tamakut wani teq'araqluki tua-i-ll' calirpaggaarluteng uksumi kiagpak-llu nutaan-llu tua-i uksumi."
        },
        "154": {
            "start": 1452.34,
            "end": 1459.0,
            "transcript": "Imutun mernuiqalriatun kalukarluteng kelgiluteng yurarluteng anglaniluteng."
        },
        "155": {
            "start": 1459.0,
            "end": 1467.02,
            "transcript": "Tua-i atulallrit tamakut wani uum wani tarenram nasvitaakut tamakunek."
        },
        "156": {
            "start": 1467.02,
            "end": 1477.9,
            "transcript": "Anglill' ukuni quyurvakatalriani anglanarqeqatallinivaa! Uyuruciar."
        },
        "157": {
            "start": 1477.9,
            "end": 1485.22,
            "transcript": "Tamakut ukut tarenrat tangerrsukuvceciki, pianciiqut high school-ani quyurvakata nasvaumaluteng."
        },
        "158": {
            "start": 1485.22,
            "end": 1491.54,
            "transcript": "Uyuruciar, amllerciqut yuut allanret maavirtellriit?"
        },
        "159": {
            "start": 1491.54,
            "end": 1497.0,
            "transcript": "Qaillun kainritlerkam tungniinun pekceci?"
        },
        "160": {
            "start": 1497.0,
            "end": 1511.26,
            "transcript": "Tua-i-wa nerevkarilarciqut tua-i-w' lunch time-ami, apiatami cali-llu atakutami-llu. Atakutalarciqut-llu tua-i piani high school-ami."
        },
        "161": {
            "start": 1511.26,
            "end": 1528.78,
            "transcript": "Tau͡gaam waten 22nd-23rd working group tamakut tekiteqatalriit. Tekiteqatalriit imkut quyurteqatarluteng kiimeng."
        },
        "162": {
            "start": 1528.78,
            "end": 1538.42,
            "transcript": "Cetamiritmi Tallimiritmi-llu kelgumalriit nunacuarnek wani tauna wani ellait erneqait."
        },
        "163": {
            "start": 1538.42,
            "end": 1546.76,
            "transcript": "Tuani wani caliarkauluteng arenqiallugutnek yuvrirluteng, qaillun-llu kitugtellerkaitnek yuvrirluteng."
        },
        "164": {
            "start": 1546.76,
            "end": 1558.72,
            "transcript": "Paivtarkameggnek wavet YKHC-mun, nasvagiarkauluteng tamakunek YKHC-mun."
        },
        "165": {
            "start": 1558.72,
            "end": 1569.18,
            "transcript": "Taukuk erenrek wani ellaita quyurtaqluteng-wa tua-i ikayuulluteng kelgumalriit taukut."
        },
        "166": {
            "start": 1569.18,
            "end": 1578.52,
            "transcript": "Tua-i-ll' Tallimiritem atakuani nutaan yuut piciatun kelgumaluteng taisqumaluteng-llu."
        },
        "167": {
            "start": 1578.52,
            "end": 1593.4,
            "transcript": "Tuani wani ikirciiqukut wani makut ciuliaput wall'u tegganret imkuluki pirpakluki tuani atakumi piqatartukut."
        },
        "168": {
            "start": 1593.4,
            "end": 1608.68,
            "transcript": "Tua-i wani imutun qigcikellriatun ciuliaput tegganerput-llu tuani atakumi ellait, ellait wani imkuluki."
        },
        "169": {
            "start": 1608.68,
            "end": 1620.04,
            "transcript": "Kelgumaluteng tua-i taukut arcaqakluki tauna ayagniutekciqluku ellaitnun atakuani Tallimiritem."
        },
        "170": {
            "start": 1620.04,
            "end": 1632.26,
            "transcript": "Tua-i-ll' Maqinermi Agayutmi-llu call' piciatun yuut, makumiut piciatun-ll' nunanek wani nutaan kelgumaluteng."
        },
        "171": {
            "start": 1632.26,
            "end": 1647.42,
            "transcript": "Waten-llu wani nunacuarnek wani akimianek kelgumayaaqellriit yuut quyurtarkauluteng tua-i-ll' Cetamiritmi Tallimiritmi-llu caliarkauluteng."
        },
        "172": {
            "start": 1647.42,
            "end": 1663.42,
            "transcript": "Tau͡gaam wani Maqinermi Agayunermi-llu piciatun yuut taigarkauluteng, niitaqluta-llu, qayagauraqluta-llu, nunarpamteńek Alaska-mek taiyulriit amllerrniluki."
        },
        "173": {
            "start": 1663.42,
            "end": 1672.7,
            "transcript": "Qessakevkenaki tua-i kelgumaluteng-llu tamakut piciatun yuut taiyulriit paqnayugluteng mat'umek."
        },
        "174": {
            "start": 1672.7,
            "end": 1675.56,
            "transcript": "Ellmeggnek tailuteng."
        },
        "175": {
            "start": 1675.56,
            "end": 1686.52,
            "transcript": "Yaa, quyanarqeqatallinivaa tanem ukut YKHC-t mat'umek arulaciqatalliniluteng \"Quyumta Piniringluta\"."
        },
        "176": {
            "start": 1686.52,
            "end": 1696.06,
            "transcript": "Cali ilagauculriani nalluyagutevkenaci piani high school-ani Tallimiritmi Maqinermi Agayunermi-llu yuut piciatun kelgumaut."
        },
        "177": {
            "start": 1696.06,
            "end": 1702.28,
            "transcript": "Tau͡gaam taum ciuqliani makut calistait elitnaulriacetun piqataryugnarqait."
        },
        "178": {
            "start": 1702.28,
            "end": 1705.42,
            "transcript": "Tua-i-wa waten sass'arput amllertalria."
        },
        "179": {
            "start": 1705.42,
            "end": 1714.22,
            "transcript": "Quyana Pupsuc'ngaq cali-llu Uyuruciar tailutek, alqaqellriik waniwa."
        },
        "180": {
            "start": 1714.22,
            "end": 1721.8,
            "transcript": "Cali pinarikumta uumiku, Aqum'allraugua, quyana tangvagluci, piurci."
        }
    },
    "5lyhdh7pgOI": {
        "1": {
            "start": 7.13,
            "end": 18.7,
            "transcript": "Aipaagni elitaqenritaci waniw' uum iluancaaqut cali imkut ridge-at [?] cali tumyariit atrit-ll'ellimaluteng waniwa."
        },
        "2": {
            "start": 19.87,
            "end": 30.55,
            "transcript": "Tua-i-ll' una wani, una waniwa aipaagni office-arpenek tauna tangeqsaitan."
        },
        "3": {
            "start": 31.33,
            "end": 40.28,
            "transcript": "Una waniwa tangrrarci, waniwa tang Mamterillrem nunautii nangtacia."
        },
        "4": {
            "start": 42.77,
            "end": 62.11,
            "transcript": "Tua-lli-wa una wani, una waniw' atulararput, au͡gna-wa man'a-wa maa-i yaalirneq, au͡gna Qaluyaat tunglirneret, man'a-wa ukatii qau͡gna cali Kusqviim avatii pau͡gna-llu ilakluku."
        },
        "5": {
            "start": 62.11,
            "end": 85.9,
            "transcript": "Waniwa ukut tangerquvciki uum wani tegumiaqeqataraa, waniw' una tegumiaq', waken Mamterillernek ankuni nanglengraan, wall' avani Qaluyaani uitangraan, wall' un'gani uitangraan, wall'u pavani uitangraan."
        },
        "6": {
            "start": 85.9,
            "end": 100.09,
            "transcript": "Tua-i kaigatkatkut nunat taukut maavet ayagciqukut, waten-llu qanerpek'nata, \"Tamana nalluaqa pingaitaqa.\" Tuaten ayuqut makut maa-i yuartet."
        },
        "7": {
            "start": 103.42,
            "end": 122.5,
            "transcript": "Taumek tua-i umyuaq kaigavikamci nallunritaqavciki piicallerpeciukun tau͡gaam ikayurluki cavkenaki tauna-llu yuaqengrat nataqesqumaluku,"
        },
        "8": {
            "start": 122.5,
            "end": 131.62,
            "transcript": "Wall'u kinguliamteńun cali assirluki ataam tekitesqumaluki, yaa una waniw' arcaqerluni,"
        },
        "9": {
            "start": 135.96,
            "end": 154.84,
            "transcript": "Yaaqvanun una wani ayagayarauguq, maa-i-llu nanvarraarayagaat makut amavet Qaluyaat nuniitun tekilluki, man'a call' kiatgun, eliteqainalriit erinaunritut makut,"
        },
        "10": {
            "start": 154.84,
            "end": 176.14,
            "transcript": "Una waniwa nuna elitengnaqemkun ilagautnatertua [?] makunek. Tau͡gaam uum wani, uumun waniwa una-wa au͡gkut tunciqanka wiinga atuvailemcianka [?],"
        },
        "11": {
            "start": 178.37,
            "end": 192.8,
            "transcript": "Una arcaqerluni tamayunaituq nanlengraan kiugkut tamaqengan wall'u Kuigpami, wall'u nani avani-llu Qaluyaani pitsaqevkenateng taigaciqut,"
        },
        "12": {
            "start": 192.8,
            "end": 208.32,
            "transcript": "Ikayuusqumaauteng Mamterillermi yuartaitnek, wall'u allanek nunanek, tua-i ullagciqaat waten-llu qalerciiganateng nalluaqa tamana wiinga ayagngaitua."
        },
        "13": {
            "start": 209.07,
            "end": 222.66,
            "transcript": "Cali-llu ava-i qanellrucimtun ella pirretpagyaaqeciquq qanugpagluni pircigluni cakneq tumyarat-llu tangerciinganaki erenrani waten,"
        },
        "14": {
            "start": 222.66,
            "end": 237.64,
            "transcript": "Tau͡gaam pingraan kina imna erenrani aipaagni ancuqsunarqerrluartuq tamana, arcaqerluni tuaten ayuqaqan tan'gerinercilallruaqa wiinga."
        },
        "15": {
            "start": 237.64,
            "end": 253.36,
            "transcript": "Tan'geriaqan tau͡gaam ingna ciunemni qertulria [?] tangercugngariaqamku nutaan ayagaqlua, unayaqlirayiaqerraarlua-llu ilakagenritaqama kiirrarem [?] ayagaqlua."
        },
        "16": {
            "start": 253.36,
            "end": 267.82,
            "transcript": "Tau͡gaam cali utertaqama uniurutevkenii tekitaqlua kingunek wall'u tuavet nunanun allanun elitaqaaqama tuavet nunanun allanun ayagluni, assinruluni tuaten,"
        },
        "17": {
            "start": 267.82,
            "end": 274.12,
            "transcript": "Nutaan-llu tuaken cingunemnun call-arlua."
        },
        "18": {
            "start": 274.12,
            "end": 289.84,
            "transcript": "Maa-i cali man'a petekngamku pic'aqaartevkenateng arenqiallugartaqata ukut uterpailgata kingunemtenun inarcuutegu aipaqa-llu aipama-ll' ikayualarai."
        },
        "19": {
            "start": 289.84,
            "end": 307.04,
            "transcript": "Ca tau͡gaam tamana quyatekluku maa-i tamana cavkenii pellulriatun ayakngamku una tua-i waten amlleriuq au͡gna takliriinartuq qanelqa,"
        },
        "20": {
            "start": 307.04,
            "end": 325.15,
            "transcript": "Waten pitangraan cali au͡g'um qanelqatun nangenrunrituq una cali piinanermeggni igvarciqut waten ca-ll' piluteng.  Cali ciulirnerrarni tamana neryuniurutek'larniartut quyana."
        },
        "21": {
            "start": 537.82,
            "end": 554.77,
            "transcript": "Ii-i. Yaa quyaunga wani ava-i maavet ak'alla'arluni uumirpak taigurtua maavet kiaqaanemnek."
        },
        "22": {
            "start": 554.77,
            "end": 570.41,
            "transcript": "Una wani tek'eqa nuuga kep'artellruuq, tua-i yuum calistuit uitasquciacetun [?] uitaurlua uumun maksiumun uitanqegcillerkamun tailua ernilartua,"
        },
        "23": {
            "start": 570.41,
            "end": 584.65,
            "transcript": "Tua-i waniw' man'a-ll' qanllerkarci umyuaqsugnaicaaqerka, quyaunga cakneq waten qanerturallinillratnek,"
        },
        "24": {
            "start": 584.65,
            "end": 602.0,
            "transcript": "Waniwa wii qanqeryuglua waten man'a qaneryaraq Yup'igni atauciulliniuq, nani-llu uitang'e'rmi tangnerranarqelua qanerngaitelliniluni,"
        },
        "25": {
            "start": 605.12,
            "end": 625.26,
            "transcript": "Tuaten tua-i ayuqelliniuq, mat'um Yup'igurluum alerquutii inerquutii-llu cangallrunritliniuq, nani yaaqvani uitang'e'rmi qanquni ak'allaar, tua-i tuani nunamini niitellminek niiciiqelliniuq, tangnerrarngaunani-llu."
        },
        "26": {
            "start": 627.73,
            "end": 641.25,
            "transcript": "Tuaten kalikaitqapigteng'e'rmeng au͡gkut ciuliarluput imutun [?] qamiqumegteggun tuar kalikarugarnek qemangqaangqelalriit tangrraullemni,"
        },
        "27": {
            "start": 641.25,
            "end": 650.73,
            "transcript": "Tuamtellu-am maa-i computer-aanek nallun' puqilrianek nalkulluteng aipaiput."
        },
        "28": {
            "start": 650.73,
            "end": 666.28,
            "transcript": "Ak'a ciumetni umyuartequrallemni ak'allaraat tamakucingqelliniluteng, ciunerkaq-llu nalluvkenaku qanrutkaqluku, tuaten tua-i ayuqelliniluteng."
        },
        "29": {
            "start": 666.28,
            "end": 689.62,
            "transcript": "Waniwa nutaramek qanerngaitua, qanerngaicaaqua nutaramek, tau͡gaam niitellruaqa-am [?] avaken aatamnek angutngurrluni aataka aanaka-llu tuaten angayuqangqellruunga, ukut-llu anelgutenka allakarmeng yuurtengluteng,"
        },
        "30": {
            "start": 689.62,
            "end": 707.42,
            "transcript": "Tamaa-i tua-i qanruyukarait makut ciuliamta piciulliniluteng, maaten waten ellirtua, piciulriamek imna qanerturatullinilua ataka elitaqu'urluki maa-i elitaqengluki,"
        },
        "31": {
            "start": 707.42,
            "end": 728.56,
            "transcript": "Cali-llu una tuvqayulria ayagyuaq, waten ak'allaarmun cakneq quyatulliniluni, quyapiatulliniluni cakneq, anirta ima tanem imkuk angayuqaagka, waten tuvqakessiurqamek waten ayagyuameng cakneq amatngulallruuk"
        },
        "32": {
            "start": 729.04,
            "end": 739.12,
            "transcript": "Quyalutek cakneq neqkaurakegnek-llu carraularyaaqengraan cakneq quyapialallruuk."
        },
        "33": {
            "start": 739.12,
            "end": 754.62,
            "transcript": "Maaten tamaa-i waten ellirtua, ukut irniama-llu irniaqsaaqluki panima payugartaqakuk neqkamegnek irniaqengraamegnegu quyaqapiarnaurtukuk,"
        },
        "34": {
            "start": 754.62,
            "end": 768.57,
            "transcript": "Waten ellirnartetulliniuq, taumek makut mumilkenarqaci kilgarmun ak'allaraat unguvalriit ikayuungnaqu'urluki pilaquvciki"
        },
        "35": {
            "start": 768.57,
            "end": 783.03,
            "transcript": "Ikayuarnaku'urluki naklekluki makut pisciigalilriit kalivqinangetulliniut, waten umyuarramegteggun tau͡gaam kiingan calingetulliniliut,"
        },
        "36": {
            "start": 783.03,
            "end": 796.05,
            "transcript": "Umyuarramegteggun tau͡gaam kiimeng tua-i caliluteng, tau͡gken tua-i man'a kemtengarturyaguskunegtekut cassiigaliilriatun ayuqluteng,"
        },
        "37": {
            "start": 796.05,
            "end": 809.3,
            "transcript": "Tua-i tamana umyuaqluku, waniw' umyuarkarpeceńek cikingnaqsaaqamci ayagyuani makunek ak'allarpeceńek,"
        },
        "38": {
            "start": 809.3,
            "end": 818.21,
            "transcript": "Qanruyukarait-llu cali murilkelluki inerquutait alerquutait-llu cali atungnaqluki,"
        },
        "39": {
            "start": 818.21,
            "end": 833.16,
            "transcript": "Tauna-gguq tua-i qanruyutminek, waten ciulirneminek qanruyutminek tauna atuqunii tua-i-gguq elluarrluni ciunrait kiungalengraan,"
        },
        "40": {
            "start": 833.16,
            "end": 845.79,
            "transcript": "Tekitellriani asqililuni, tau͡gken-gguq im' ayagyuam umyuani aturluku egilrakuni iquani yaani asqialliqsugngaarkaulliniluni,"
        },
        "41": {
            "start": 845.79,
            "end": 859.85,
            "transcript": "Tamana pitekluku waniwa mat'umek qanqernalua, waniwa-ll' ukut ak'allaraat niicugnilriit tangnerranritut mat'umek qankengamnek,"
        },
        "42": {
            "start": 859.85,
            "end": 874.83,
            "transcript": "Qasgimi imkut ellii-llu qanerturalriim atullgunrilngermiu niitellminek elliin-llu piliaqevkenaku tamana qanruyutni,"
        },
        "43": {
            "start": 875.61,
            "end": 885.57,
            "transcript": "Elliin atulgunrilngermiu yuk tauna cingumailria ayagyuaminek qanrutkarqaulliniu,"
        },
        "44": {
            "start": 885.57,
            "end": 902.01,
            "transcript": "Cali-llu niisngalkunrilngermi tauna kinguni niiqsainakek'uniu ayagyuaminun cali atuusqumavkenaku qanrutkarkaulliniu,"
        },
        "45": {
            "start": 902.01,
            "end": 910.0,
            "transcript": "Tua-i-gguq tauna yuk ayagyuaminek cingumailriim tau͡gaam yuk qanrutetua,"
        },
        "46": {
            "start": 910.0,
            "end": 927.92,
            "transcript": "Tau͡gken-gguq imna nepaunani qanrucuunaki-llu ayagyuani pikuni tua-i imucetun tamakut qunukelriacetun ayuqluki cingumaivkenani yugmek,"
        },
        "47": {
            "start": 927.92,
            "end": 942.98,
            "transcript": "Picurlallerkait-llu yuilqumi-llu nunalluallerkait qanruyutekluki tamakut qaillun yuilqumi anirtungnaqlarkaa elliini,"
        },
        "48": {
            "start": 942.98,
            "end": 960.0,
            "transcript": "Tamaa-i tamakut qanruyutait yuilqumi waten ayagyuaranguten elluirrlainarluni pingaitelliniami, iliini yuilqumi ayagpakarluni arenqiallugciiqelliniameng."
        },
        "49": {
            "start": 960.0,
            "end": 973.06,
            "transcript": "Tamana tamaa-i qanruyutekluku pilallrulliniat, pilallrukiit-wa anguvilqallemni,"
        },
        "50": {
            "start": 973.06,
            "end": 988.9,
            "transcript": "Tamakut tamaa-i qasgingqerrluki-llu cali cumigyagutellruunga, un'gaani nulamni Qaluyaani cam Kass'am tekitnaciaqallrullinikai, wiinga-llu anguluki,"
        },
        "51": {
            "start": 990.36,
            "end": 1006.83,
            "transcript": "Massiinartaunani angyaunateng, tua-i qinuunani, nuna imna neqlilriamek camek niitnaunani,"
        },
        "52": {
            "start": 1006.83,
            "end": 1018.2,
            "transcript": "Qayatgun tau͡gaam makut-wa qeciit angyait, ang'upaggsuutait tua-i angyarluteng qecignek,"
        },
        "53": {
            "start": 1018.2,
            "end": 1030.25,
            "transcript": "Tamakunek tamaa-i, pingqevkarluki tamarmeng-ll' angutet piqenrilnguut ilait piqevkarluki angullruanka,"
        },
        "54": {
            "start": 1030.25,
            "end": 1044.74,
            "transcript": "Tamaa-i umyuamkun tau͡gaam umyuaqelaranka tua-i neq'akluki, carugaat makut tangvagamki aling aren elluiqapiggluteng maa-i,"
        },
        "55": {
            "start": 1044.74,
            "end": 1064.58,
            "transcript": "Watua maa-i elluiqapiggluteng pilillrat tua-i tamakut kingunrenka anguviilqalqenka tangssuullruamki arenqiapaa-ll' tua-i cakneq man'a ciuliamta ayuquciurlullrat peggetqapigtellriacetun ayuqluku,"
        },
        "56": {
            "start": 1066.7,
            "end": 1080.58,
            "transcript": "Wall'u-q' man'a kenurraq arulaiqan tua-i kalivqilirluta cauniniqerciiganata-llu piyugngaluta, tua-i maa-i piciuluni"
        },
        "57": {
            "start": 1080.58,
            "end": 1093.3,
            "transcript": "Qaillun pisciiganata callerkaunata kenurrarnek nipkan piarkaulliniluta, unuakumi-ll' yuurqeryugamta yuurqassiiganata."
        },
        "58": {
            "start": 1093.3,
            "end": 1107.85,
            "transcript": "Tauna-ll' kaminiaq enem kiircautii kaminiaq uquireskun aren callerkaunani uitaqerluteng qerrulluta nenglliurluta arenqiapakar."
        },
        "59": {
            "start": 1107.85,
            "end": 1119.99,
            "transcript": "Tua-i imkut yug'urluut cait wangkuta kingunritni Yup'igni peggetqapiggluki, peggetqapiggluki"
        },
        "60": {
            "start": 1119.99,
            "end": 1139.14,
            "transcript": "Imkut angaviilqallrenka [?] aanaurluqa-llu ata'urluqa-llu ukuk waten uksuarrarmi aren caller' tua-i calutek yaquleguar', qecileguar' piuqcarluku, piuqcarluku, atkuliluku."
        },
        "61": {
            "start": 1139.8,
            "end": 1155.04,
            "transcript": "Unuk cali ata'urluqa muragnek caliarluni unugmi qavarlua tupagnaurtua cali maktalutek caliuralriik,"
        },
        "62": {
            "start": 1155.04,
            "end": 1164.5,
            "transcript": "Kenurraak-gguq uurraq [?] aren tanqigcetenricaaqlinivakar."
        },
        "63": {
            "start": 1164.5,
            "end": 1184.94,
            "transcript": "[?] kumassuun maani kumakuni enem qacarnerani kapuarcimalria kumassuun kenurracuayaar, lamp-acuayaar tamakut-llu tanqigcetliniut, tanqigcetqapiaralliniut."
        },
        "64": {
            "start": 1184.94,
            "end": 1195.49,
            "transcript": "Tamakut nalluyagucuitaqanka wii angullruamki tangvallruamki-llu, Yupiigurluut au͡gkut."
        },
        "65": {
            "start": 1195.49,
            "end": 1211.07,
            "transcript": "Naklegnaqsaaqeng'e'rmengi atullermeggni-llu tamaani naklegnarqellrunritut ellmegni nunaniryugluteng tau͡gaam yuullruut, camek umyuaq-llu qerrutaunateng."
        },
        "66": {
            "start": 1211.07,
            "end": 1233.43,
            "transcript": "Yuullrulliniut nunaniryugluteng kinguneqa una angayuqaagka-ll' kiimek pivkenatek ayuqluteng nunaniryupialallrulliniut camek umyuarniurutaunateng aren watua maa-i"
        },
        "67": {
            "start": 1233.43,
            "end": 1251.65,
            "transcript": "Asqilingramta aliayulangluta kingunritni wangkuta, tua-i maa-i callerkaq amlleritqapiarluni mat'um ernemta nalliini ernerpak"
        },
        "68": {
            "start": 1251.65,
            "end": 1268.7,
            "transcript": "Caqatarcit? Suuliaqatartua. Caqatarcit? Dance-aliyaqatartua, tua-i maakut tuani atullrunritait ciuliamta. Tua-i atullrunritait."
        },
        "69": {
            "start": 1268.7,
            "end": 1285.69,
            "transcript": "Waniwa ak'allarraurtellriani, tamalkurrarmek-llu piilkuni kalivqinaryugngaluteng. Wangkuta kass'aurtengamta qemangqaarrailkumta kalivqinakalriacetun-llu ayuqsugngaluteng."
        },
        "70": {
            "start": 1285.69,
            "end": 1301.14,
            "transcript": "Avani ciuliaput one cent-arraungraan-llu nallunritucia ak'allarni one cent-arraungraan umyuaqumayuitellruut tamakut, umyuaqumayuitellruut."
        },
        "71": {
            "start": 1301.14,
            "end": 1314.52,
            "transcript": "Quyanaq-wa taklirinrilengraan waten qanqertua au͡g'umek carraungaan, carraungermi man'a qaneryararraq taklirissiyaagpek'naku-llu pillra."
        },
        "72": {
            "start": 1314.52,
            "end": 1325.49,
            "transcript": "Amllerugaulartuq, wiinga-w' umyuaqenrularka waten qanqerqama amllermek qanenrilerma,"
        },
        "73": {
            "start": 1325.49,
            "end": 1339.34,
            "transcript": "Tau͡gaam qanengnaqa'artetuunga quyaqapiartua-ll' ava-i waten qanerturalrianek itlemni umyuaqenricaa umyuaqluki pinricaaqua quyanaq-wa cakneq."
        },
        "74": {
            "start": 1339.34,
            "end": 1343.76,
            "transcript": "Yaa, quyana tailuten au͡g'aqernaurka."
        }
    },
    "T2cDE8ruHis": {
        "1": {
            "start": 0.0,
            "end": 7214.84,
            "transcript": "Ak'allaurtenrilengma nallunritarpecia akaurtuq makumiunguuruciq tau͡gaam-am ava-i qaneryaaqua makumiunguurtenrilma makumiunguurtellrunilua,"
        },
        "2": {
            "start": 7214.99,
            "end": 7225.03,
            "transcript": "Makumiungunricaaqua avani tau͡gaam Qaluyaat nuniitni tamaani yuurtellruunga."
        },
        "3": {
            "start": 7225.03,
            "end": 7246.51,
            "transcript": "Tamaaken-llu tua-i Akulmiut pavavet nunaninqigglua. Tuaten-llu nunaninqigutemnek ataam cali maavet Mamterillernun atrarlua caliqataama. Tauna tua-i Mamterillermi narutekaqa caliaqa, calingelqa."
        },
        "4": {
            "start": 7246.51,
            "end": 7264.03,
            "transcript": "Tau͡gaam au͡gna pingraan una wani umyuaqniarci una wani-gguq Peter Atchak-aaq nallunritarci caliaqa tegullrua."
        },
        "5": {
            "start": 7264.03,
            "end": 7275.33,
            "transcript": "Wiinga-llu quyalua tegullrua caliama nunamtun au͡g'utun yuurvillemtun ayuqelriamek nunangqerran."
        },
        "6": {
            "start": 7275.33,
            "end": 7295.16,
            "transcript": "Catailngurmek, napatailngurmek muragtaunani-llu. Uksumi waten qanikcangaqan catairutevsiaraqluni imkut tau͡gaam nalluyugnarqaci wangkuta nakaarnek avanek pilaraput."
        },
        "7": {
            "start": 7295.16,
            "end": 7312.39,
            "transcript": "Quagcit au͡gkut akuliitni naumalalriit tamakut napaluteng takluteng. Tua-i tamaa-i tamakut waten qanikcangaqan wangkuta atulalput nallunailkutaqluki."
        },
        "8": {
            "start": 7312.39,
            "end": 7327.29,
            "transcript": "Tau͡gaam teguvkenaki tua-i tauna nakaa pucikcaunararput [?] yuvrilallruaput cakneq waten arenqialluga'artellerkarput umyuaqluku."
        },
        "9": {
            "start": 7327.29,
            "end": 7339.86,
            "transcript": "Tuamta-llu cali ayainanemteńi canegnek quyungqalrianek qertuuralriami tamakunek, tamakucinek tekitelartukut."
        },
        "10": {
            "start": 7339.86,
            "end": 7363.49,
            "transcript": "Tua-i cali tauna yuvrilararput ella assingraan. Assingraan tauna yuvrilararput pitsaqartevkenata arenqiallugutellemta nalliini wall'u pellaakun taum tauna tekiskumteggu elitaqerkauqluku."
        },
        "11": {
            "start": 7363.49,
            "end": 7383.75,
            "transcript": "Au͡gna-ll' cali ava-i ciuqlia quagcit angutait tak'lartut tauna cali tua-i avatiini maani amllenrraata taukut cali tua-i yuvrilaraput waten cali au͡g'utun arenqialluga'artellerkarput umyuaqluku."
        },
        "12": {
            "start": 7383.75,
            "end": 7403.05,
            "transcript": "Au͡gkut tua-i ava-i nallunritniaci. Tua-llu una wani ukut wani kingumek nalqigarciiqenka amllermek pingaitua."
        },
        "13": {
            "start": 7403.05,
            "end": 7416.46,
            "transcript": "Maani Mamterillerni ciuqlikacaarmi makunek yuartenek pingqerraallratni wiinga tua-i cucukellruatnga."
        },
        "14": {
            "start": 7416.46,
            "end": 7436.15,
            "transcript": "Man'a wii nunakenricaaqengramku, tau͡gaam nunakenrilengramku cucukuciiqaa tunrikluku, cali-llu quyakenrilengramku quyakelriatun pitarrluku ciuniullruaqa."
        },
        "15": {
            "start": 7436.15,
            "end": 7446.04,
            "transcript": "Uum-llu waniwa cali canimniaqumgalriim tayima cali tamana aturaa wangtun makumiungunrituq."
        },
        "16": {
            "start": 7446.04,
            "end": 7459.34,
            "transcript": "Ava-i qanellrucimtun quyallrunilua uum wani caliaqa man'a teguaku nunama ayuqiinek nunangqerrat."
        },
        "17": {
            "start": 7460.06,
            "end": 7470.35,
            "transcript": "Tua-i tamaani nanikuaraqulallruyaaqua uksugmi-llu waten wall'u kiagmi,"
        },
        "18": {
            "start": 7470.35,
            "end": 7482.34,
            "transcript": "Tau͡gaam tamakut atullrungramki tua-i pillerkaq [?] tekiteksailan tamakut pellullrullinianka quyanaqluni."
        },
        "19": {
            "start": 7482.34,
            "end": 7492.03,
            "transcript": "Tayima-ll' una tuaten ayuqellruuq avani nunamini uitallermini."
        },
        "20": {
            "start": 7492.03,
            "end": 7514.41,
            "transcript": "Mat'um enungqelliatnga [?] snuukuungqerrama-llu, snuukuungellma-llu nalliini piatnga tua-i quyakellruaqa tamana, tauna-llu ayagassuutekaqa wii murilkelluku cakneq, aturaqluku."
        },
        "21": {
            "start": 7514.41,
            "end": 7526.49,
            "transcript": "Tayima tua-i avani nunamni cingunemni pircirqami uksumi camek tangerrnaitelartuq."
        },
        "22": {
            "start": 7526.49,
            "end": 7541.33,
            "transcript": "Cali-llu ca qanirqami anuqlirluni-llu, amirluluni-llu cali tuma man'a cailkaq camek tangerrnaitaqluki,"
        },
        "23": {
            "start": 7541.33,
            "end": 7552.07,
            "transcript": "Tua-lli-wa tua-i pingraan tamaani atularput wangkutnek anangnaqluta, kingunitengnaqluta-llu,"
        },
        "24": {
            "start": 7552.07,
            "end": 7566.34,
            "transcript": "Tua-i-llu man'a teguamku wii yuarteng aterlua ellimalqa pitekluku tua-i wangnek kevingallruunga tuani tamaani,"
        },
        "25": {
            "start": 7566.34,
            "end": 7575.65,
            "transcript": "Qavamnek-llu maklua qayagaurciurqama egmianun tua-i qanrutaqatnga uptaqlua."
        },
        "26": {
            "start": 7575.65,
            "end": 7591.65,
            "transcript": "Upqaarlua-llu nutaan ilakamnek yuaralua maligkamnek-llu iliini unangeksaitellruunga. Tua-i kiimleng'e'rma ayagaqlua ella assiilengraan."
        },
        "27": {
            "start": 7591.65,
            "end": 7608.15,
            "transcript": "Ilaitni-llu tan'gaurlugnek malingqerraqlua caqapigtaqama, tamana kiimetellra nagutekevkenaku ayagaqama wangnek tua-i ayagaqlua."
        },
        "28": {
            "start": 7608.15,
            "end": 7616.06,
            "transcript": "Qaku-llu utertellerkaqa, qaku-llu nunamnun tekitellerkaqa, nalluluku."
        },
        "29": {
            "start": 7616.06,
            "end": 7625.45,
            "transcript": "Wall'u ciunemni tamaani yuk tauna tamalria cali nataqellerkaa au͡gtaugtaqu'urluku [?],"
        },
        "30": {
            "start": 7625.45,
            "end": 7641.14,
            "transcript": "Tau͡gaam imutun kaigaqu'urluku ayagaqlua pillemni tamaani iliini pivakarlua alangaqalartua tekiartaqemku tauna arenqiallugingalria."
        },
        "31": {
            "start": 7641.14,
            "end": 7652.74,
            "transcript": "Ilii tamarluni piksaicaaquq, tau͡gaam snuukurturrluku [?], maa-i man'a tamana tayarayaraat elitellrua tamaaggun."
        },
        "32": {
            "start": 7652.74,
            "end": 7669.46,
            "transcript": "Ilait snuukuugnek arenqiallukteksaicaaqut, tau͡gaam tuavet kingunermeggnun tekiteqataruarturluteng ayagiinarqameng yuarnarilartut, yuararkaurrnarilartut."
        },
        "33": {
            "start": 7669.46,
            "end": 7682.22,
            "transcript": "Snuukuut makut carra [?] Kuinrayagarmi minute-ani qavcirrarni yaaqvanun ayalartut, ayalalliniut,"
        },
        "34": {
            "start": 7682.22,
            "end": 7695.51,
            "transcript": "Tamaani-llu pii ayagaqama ciuneqa tangvagciigat'lallruaqa snuukuumi, kenurrama-llu ciuneqa imkuvkenaku, ciqinqaumavkenaku."
        },
        "35": {
            "start": 7695.51,
            "end": 7716.77,
            "transcript": "Tau͡gaam ukuk wani eskiigma menglekek snuukuum talirneruamini, tuaggun tau͡gaam tumka man'a tangvagluku makut-llu imkut pit wani iqalluguayagaat tamakut tamaa-i tamakutgun ayagaqlua."
        },
        "36": {
            "start": 7717.7,
            "end": 7734.59,
            "transcript": "Nauwa-wa tua-i tayima ciuneqa natmun-llu ayauciini ayagaqama, imumirpak-llu qanrut'lallruatnga-llu au͡gkut ellakurtaqluni assiiruciutuq."
        },
        "37": {
            "start": 7734.76,
            "end": 7748.31,
            "transcript": "Tua-i-gguq ayagiinarpek'nii arulaiquma tuaken-llu uitallemnek kinguneqa tangerrsugngaciquq. Tua-i tamaana umyuaqluku tau͡gaam."
        },
        "38": {
            "start": 7748.31,
            "end": 7759.59,
            "transcript": "Tau͡gaam waten yuarqamta yuarqama tamana imutun narurtellriatun pilallruaqa wangnek pevvlua."
        },
        "39": {
            "start": 7759.59,
            "end": 7778.45,
            "transcript": "Wagg'uq umyuarteqaqama, tua-i-gguq tauna ciunemni uitanguartequ'urluku ayakuma, pitsaqevkenaku-llu, unguvaluku wall'u anirtevkarluku nall'ara'arteq [?] tau͡gaam yuaqluku, tua-i tamana aturaqluku."
        },
        "40": {
            "start": 7778.68,
            "end": 7805.2,
            "transcript": "Maa-i tua-i waten teggumalriamek [?] nall'artengvailegma man'a arulairutellruaqa. Cali naulluutem pillrunrilkanga maa-i cali atuqcaarturyartua, tau͡gaam pingraan tamana pegtellrungramku ukut wani qalarucimarillruanka tamana perrngaitniluku."
        },
        "41": {
            "start": 7805.2,
            "end": 7817.29,
            "transcript": "Au͡gna tua-i takliriuq. Tua-llu ukuunek nasviarrnaumci, ukut waniwa igarugaat ukut."
        },
        "42": {
            "start": 7817.29,
            "end": 7835.28,
            "transcript": "Mamterillermiut tumyaraita atrit, igarugaat ukut amllerrluteng. Tua-llu waniwa nunat Mamterillermiut ayagnerit."
        },
        "43": {
            "start": 7835.28,
            "end": 7849.01,
            "transcript": "Waniwa ukut tumyarait piunarqellerkaitgun waten pillruanka. Tuaten Mamterillermiunek wani ukut waniw' tang housing-aat."
        },
        "44": {
            "start": 7849.01,
            "end": 7862.1,
            "transcript": "Pitsaqevkenii wani nunani ellimerumakuma ukut-gguq ukut akuliitni tarracugngalua, ella assiilengraan."
        },
        "45": {
            "start": 7862.1,
            "end": 7870.72,
            "transcript": "Tuamta-llu ukut-wa niptessuata [?] unavet, unavet atrarluni."
        },
        "46": {
            "start": 7873.31,
            "end": 7882.19,
            "transcript": "Maa-i taum makut nunarraat highway-rrluut ellimaluni, pau͡gkut-llu nunat ellimaluteng tumyarait-llu maanlluteng."
        }
    },
    "QJVdoVFixd8": {
        "1": {
            "start": 2.37,
            "end": 5.38,
            "transcript": "Unguvangnaqsaramek qalarteqatartut."
        },
        "2": {
            "start": 7.74,
            "end": 12.72,
            "transcript": "Tangnerraqatar' waten piqallemni elitan, ayallran'."
        },
        "3": {
            "start": 17.23,
            "end": 18.81,
            "transcript": "Qenaqvakar'."
        },
        "4": {
            "start": 29.34,
            "end": 34.29,
            "transcript": "Waten-kiq audio-ra piyugngaaqa? Uum tang work-arciigalnguq."
        },
        "5": {
            "start": 332.2,
            "end": 341.4,
            "transcript": "Kaakgaraugaat [?] ukut Mamterillermiut ivartiit angayuqaqatnga."
        },
        "6": {
            "start": 343.78,
            "end": 356.96,
            "transcript": "Wangkuta waten qayagaugaqakut kina imna tayim' tekiteksaitniluku wall'u-qaa tamaryukuarluku piaqatki wangkuta."
        },
        "7": {
            "start": 358.96,
            "end": 367.22,
            "transcript": "Uplutayaatuukut ivaryarturluki tuavet kingkut tayim' tekiteksailnguut wall'u-qaa tamalriit."
        },
        "8": {
            "start": 368.64,
            "end": 385.64,
            "transcript": "Wangkuta akingyuunata calituukut makut ilaput maani ilagautelriit ukuni ellmeggneng piluteng tau͡ga ilagautetuut."
        },
        "9": {
            "start": 391.66,
            "end": 411.64,
            "transcript": "Au͡gkut ivalput mat'um-wa tua-i civuani ivatetullruut tamakut ilait upingallrukuneng tayima ivarnerqenritenruyaartut tayim' ilait."
        },
        "10": {
            "start": 411.66,
            "end": 431.2,
            "transcript": "Waten-am aarnartetulria tua-i ayagalriani pegnerrarluteng-llu ilait, ayalriani snow go-rkun wall'u-q' angyakun ilait upingavkenateng maa-i ayagyugaat arcaqerluteng ayagatuut."
        },
        "11": {
            "start": 431.2,
            "end": 449.28,
            "transcript": "Waten-ll' maa-i ayagalriit arcaqerluku uksumi kitumek allameng aiparrangqerkuneng snow machine-ameng allameng [?] pegnaqsiyaagpek'nateng tua-i piarkauluteng."
        },
        "12": {
            "start": 449.28,
            "end": 468.34,
            "transcript": "Cali tuumellerni tumet maligtengnaqluki tamakut tua-i assinruarkauluteng ayakatalriani-ll' cali aklukat makut ilakelriani assinruciqluni."
        },
        "13": {
            "start": 468.34,
            "end": 481.4,
            "transcript": "Qanikciurutmeng qalpapagmeng cingyaameng cepitskaneng [?] neqkaarneng."
        },
        "14": {
            "start": 481.4,
            "end": 497.34,
            "transcript": "Cali aipaagni au͡gkunek tarenriurrsuucecuarneng wall'u-qaa au͡gkut quletmun nutgutulriit, pagaani-llu qagraqameng tanqigaratulriit."
        },
        "15": {
            "start": 500.64,
            "end": 512.66,
            "transcript": "Ayakatalriani cali kina imna aipan wall'u-qaa kina yugnikaran nallunarcelluku natmun ayakatallerpecinun."
        },
        "16": {
            "start": 512.66,
            "end": 518.76,
            "transcript": "Cal' qaku qipciqngatellerpecineng nallunritevkarluki."
        },
        "17": {
            "start": 518.76,
            "end": 528.82,
            "transcript": "Cal' au͡gkut una cali ilakenritliniaqama au͡gna au͡gkunun."
        },
        "18": {
            "start": 528.82,
            "end": 540.38,
            "transcript": "Una cal' malikelriani pingqerquvet VHF radio-meng qanerrsuutmeng maliqerquucat tauna ikayuutkarkauluku arenqaillertulriani."
        },
        "19": {
            "start": 540.64,
            "end": 554.3,
            "transcript": "Ayagpailegput cal' man'a cellam qaill ayuquciqngatlerka, tamana radio-tgun wall'u-qaa pamkut cellalirtet qayagaulriani."
        },
        "20": {
            "start": 557.72,
            "end": 566.82,
            "transcript": "Cellam maa-i qaill' ayuqucirrngatellerkaaneng nallunailkuvet tau͡ga ikayutnguarkauluni."
        },
        "21": {
            "start": 566.82,
            "end": 579.2,
            "transcript": "Im' tayim' aipagni cellarvak cellalluk taiqatalria nallunriciiqan cal' upinganruurciqnganeng tayim' aipagni piciqulriaten."
        },
        "22": {
            "start": 579.32,
            "end": 591.46,
            "transcript": "Aturaten-llu tamakut cal' arcaqatuut nengllirqan maqarquralriatnun maligirluten ayakuvet assinruarkauluni."
        },
        "23": {
            "start": 591.46,
            "end": 606.08,
            "transcript": "Wall'u-qaa cellallirarkaungalkan ivyurciqngalkan tau͡ga au͡gkuneng ivyiurrsuutneng maliliquvet cal' assinruarkauluten."
        },
        "24": {
            "start": 606.64,
            "end": 616.58,
            "transcript": "Cal' nutaan cal' navgikuvet wall'u-qaa nani, nani nanluciurkuvet cuilqumi."
        },
        "25": {
            "start": 616.58,
            "end": 624.64,
            "transcript": "Ayagiinarpegnak pikuvet inerquutaugaqalria maa-i ayagiinarpegnak pisqumalliniluten."
        },
        "26": {
            "start": 624.82,
            "end": 633.9,
            "transcript": "Tau͡ga arulirluten anuqliqan-llu cingyangqerquvet cingyan mayurrluku."
        },
        "27": {
            "start": 641.9,
            "end": 657.32,
            "transcript": "Muragartangerkan-llu kumarciluten muragneng tuagneng ellingnaqevkenak piniartuten cal' radio-rkuut una-llu ilaten niicuumalriit aipagni nallunaitevkengnaqluki tuavet."
        },
        "28": {
            "start": 657.32,
            "end": 669.96,
            "transcript": "Tau͡ga uitaniluten nanluciurutavet tauna cellalluk kitunercirluku aqumgakina tamaani ayagiinarpegnak."
        },
        "29": {
            "start": 676.12,
            "end": 692.14,
            "transcript": "Im' ukut wan' tegganret cal' qanercetugyaqluki tungiinun mat'um qaillun-wa tua-i upingayaram wall'u-qaa cellami cuilqum iga'."
        },
        "30": {
            "start": 692.14,
            "end": 698.36,
            "transcript": "Nanluciurutelriani qaillun qiptengnaqler' tamatum tungiinun."
        },
        "31": {
            "start": 701.12,
            "end": 710.02,
            "transcript": "Ilaqercellugyaqluki makut qanellrenka ayagnirluta Max-aq taiyukuvet."
        },
        "32": {
            "start": 710.02,
            "end": 718.44,
            "transcript": "Mat'um tungiinun qaneryullikuvet cingumamteggen taiqerluten qanqasqelluten."
        },
        "33": {
            "start": 734.64,
            "end": 750.5,
            "transcript": "Tua-i-llu nunam yuini ukanirpak elitnaurutemteńeng mat'umek elitetuukut tua-i aturarkaput."
        },
        "34": {
            "start": 750.5,
            "end": 763.44,
            "transcript": "Elitetuluki cali-llu aturarkaqenricaaqerrngaput elitetuluki elitnaurutekngamteki tua-i ukanirpak."
        },
        "35": {
            "start": 763.44,
            "end": 773.26,
            "transcript": "Cali-llu wangkuta alairyugnaunata tamatumek elitnaurutemteńek."
        },
        "36": {
            "start": 773.26,
            "end": 788.56,
            "transcript": "Au͡gkut ciuqliput elitetuluteng maa-i-llu wangkuta tamatumek paitangqerrluta ellaita atullritnek."
        },
        "37": {
            "start": 839.88,
            "end": 851.32,
            "transcript": "Cali-llu maani yuilqumi tamatum elilluatum."
        },
        "38": {
            "start": 851.32,
            "end": 864.7,
            "transcript": "Alerquatekluki yuilqumi makut atellrit nanvat kuiget qemit tamakut nallunritarkauluki."
        },
        "39": {
            "start": 864.7,
            "end": 878.02,
            "transcript": "Ellaita cali-llu nallukengateng kinkunun nallunritestaitnun apqaugutekluki atrit tamakut elitetuluki."
        },
        "40": {
            "start": 905.52,
            "end": 921.58,
            "transcript": "Cali-llu man'a arcaqerluku man'a neqa kencikpiarluku, nunam-llu qaingan ugungssiim makut atutukput."
        },
        "41": {
            "start": 921.58,
            "end": 932.76,
            "transcript": "Yuuteput makut kencikpiarluki alerquutiit aturluku yuutulliniluteng ukanirpak tua-i."
        },
        "42": {
            "start": 932.86,
            "end": 947.58,
            "transcript": "Man'a-llu nunamta atulaucia qaillun kencikluku, tamana-llu aturluku."
        },
        "43": {
            "start": 947.58,
            "end": 962.84,
            "transcript": "Takarnarqutii-llu tuaten ayuqluni takarnairucuunani, tau͡gaam tuaten ayuqluni takarnarqutii, takarnarqerrlainarluni."
        },
        "44": {
            "start": 989.0,
            "end": 1008.38,
            "transcript": "Tuaten-llu cali tamakunek alerquutmeggnek nallunrilameng tua-i tamana aturarkarteng elitnaurusteng kencikerrlainarluku yuuluteng."
        },
        "45": {
            "start": 1008.38,
            "end": 1018.48,
            "transcript": "Tua-i aturarkaqngamegteggu, tau͡gken cali tua-i imkut cirliqelriit tamana aturyung'e'rmegteggu."
        },
        "46": {
            "start": 1018.48,
            "end": 1032.66,
            "transcript": "Cali tua-i cirliqutektuluku, tau͡gaam tamakut ilaurluita atunem ikayuulluteng man'a yuuyaraq."
        },
        "47": {
            "start": 1032.66,
            "end": 1043.3,
            "transcript": "Nunam-llu-qaa, nunam-wa tua-i qaingani yuuyaraq atunem ikayuulluteng yuutulliniluteng tua-i."
        },
        "48": {
            "start": 1043.3,
            "end": 1056.16,
            "transcript": "Maa-i wangkuta kinguneruaraitni tuaten tamatumek pingqerrluta."
        },
        "49": {
            "start": 1056.16,
            "end": 1067.06,
            "transcript": "Pivut tamana kencikluku yuugarkaulliniluta tua-i atunem ikayuulluta yuuluta."
        },
        "50": {
            "start": 1067.06,
            "end": 1075.38,
            "transcript": "Man'a-llu arenqiallugtaarucit ayuqenrilnguut, nunam qaingani."
        },
        "51": {
            "start": 1075.38,
            "end": 1091.66,
            "transcript": "Tamakutgun tamaa-i alerqurataitgun aturarkaulliniluki yuum uum tauna tekilluku aturaqami nutaan taungurcipigarluku."
        },
        "52": {
            "start": 1091.66,
            "end": 1107.28,
            "transcript": "Yuum atutulliniluku, atuamiu-llu tua-i elliin taungurciluku, atuamiu nutaan taringluku elliin atullmikun."
        },
        "53": {
            "start": 1107.28,
            "end": 1119.1,
            "transcript": "Cali-llu umyuarteqluni, cali-llu qanaaluni makunun ilaurluminun ilumun tauna tuaten ayuqelria."
        },
        "54": {
            "start": 1119.8,
            "end": 1133.64,
            "transcript": "Piciuluni alerquutngulliniuq, anirtima ilaurlumta pellayairtugluta makunek qanruyutnek qanaatetulliniarkut."
        },
        "55": {
            "start": 1203.64,
            "end": 1212.72,
            "transcript": "Cali-llu tua-i waten yuum uksumi, kiagmi-llu tuaten cali."
        },
        "56": {
            "start": 1212.72,
            "end": 1228.56,
            "transcript": "Ukut wani qelgaarkani tua-i nallunriraput makut qelgaarkaput ukut qanikciurun, cikuliurun piqertuutaq ilavkuk-llu."
        },
        "57": {
            "start": 1228.56,
            "end": 1243.18,
            "transcript": "Ilavkuk una ilumun cacetukutguqapigtelliniuq [?] tegusciigalngurmun-llu tegussuutngutulliniami."
        },
        "58": {
            "start": 1243.18,
            "end": 1253.68,
            "transcript": "Cali-llu mayurciigalngurmun camun nau͡gg'un mayurcuutnguluni cali atrarcuutnguluni."
        },
        "59": {
            "start": 1253.68,
            "end": 1266.34,
            "transcript": "Cali-llu uumun ilavkuk una tegussuutngutulliniluni."
        },
        "60": {
            "start": 1266.34,
            "end": 1275.74,
            "transcript": "Camun ungungssimun-llu tegusciiganaku pikuni cali tegussuutnguluni."
        },
        "61": {
            "start": 1275.74,
            "end": 1289.84,
            "transcript": "Imumi tuntut amllerivailgata tamakunun ilagauqurlaut pitullemni tua-i alerquutngulliniuq una."
        },
        "62": {
            "start": 1289.84,
            "end": 1304.22,
            "transcript": "Ilavkuk una miluqun caviggaq-llu. Taukuk yugmun ang'aqurrlainarluku pitulliniluni."
        },
        "63": {
            "start": 1304.22,
            "end": 1319.36,
            "transcript": "Alerquutekliniluku tua-i arenqiallugeskuni-llu tun' camek pingqerquni tamatum-wa nalliini wangkuta alerquutput."
        },
        "64": {
            "start": 1319.36,
            "end": 1328.14,
            "transcript": "Tuntut iliit milqerluku, tuqulluku maqaunkutekluku tamaani yuilqumi uitasqelluku."
        }
    },
    "lueW8hDOHgE": {
        "1": {
            "start": 114.5,
            "end": 120.4,
            "transcript": "Wangkuta nunacuarmiuni ciqicilrianek tanglartukut. Amllerni allrakuni waten yuulartukut nunamteńi."
        },
        "2": {
            "start": 120.4,
            "end": 133.38,
            "transcript": "Maa-i state-am anguyagtem-llu elluaringnaqait calillgutekluki Native Association-aat cali nunacuaraat paivvluki akitussiyaanrilngurnek tau͡gaam pengegnailngurnek mer'em qurrutet-llu ikayuutekaitnek nunani."
        },
        "3": {
            "start": 138.0,
            "end": 143.24,
            "transcript": "Ilait nunacuaraat nauciyugngaciqut cuplunek mer'em qurrucet-llu ayagcuutekaitnek."
        },
        "4": {
            "start": 143.24,
            "end": 148.32,
            "transcript": "Ilaitnun tau͡gaam cuplulillrat akitussiyaagtuq wall' ellillra qacignarvkenani."
        },
        "5": {
            "start": 148.32,
            "end": 151.0,
            "transcript": "Camek-mi tamakut nunat aturyugngaat?"
        },
        "6": {
            "start": 151.0,
            "end": 156.18,
            "transcript": "Wani tangrrarkarpeceńi paqciiqaput cetaman nunat ayuqenrilngurnek yuqerrvilget."
        },
        "7": {
            "start": 156.18,
            "end": 162.68,
            "transcript": "Anarvik, mound-aq, composting toilet-aaq, legcitulit-llu yuqerrviit auluk'larait nakmiin pikestait."
        },
        "8": {
            "start": 162.68,
            "end": 168.52,
            "transcript": "Anarviit cavignek acilget, flush tank haul-am-llu nuna tamalkuan ikayularait."
        },
        "9": {
            "start": 168.52,
            "end": 171.92,
            "transcript": "Ayagnirciqukut Shageluk-mi Innoko River-aami."
        },
        "10": {
            "start": 171.92,
            "end": 177.02,
            "transcript": "Tamaani ak'allatun qacignarqellriamek-llu yuqerrvingqertut anarvigmek."
        },
        "11": {
            "start": 177.02,
            "end": 184.42,
            "transcript": "Nunacuarni tanglartukut makunek anarvignek. Nuna elaumalartuq et'uluni tua-i-llu anarvik qainganun ellimaluni."
        },
        "12": {
            "start": 184.42,
            "end": 190.32,
            "transcript": "Elaneq muiraqan allamek elalartut anarvik nugtarrluku, tua-i-llu uitavillra nunamek patuluku."
        },
        "13": {
            "start": 190.34,
            "end": 196.12,
            "transcript": "Anarviit ellimanarqut yaaqsigluki mertarviit wall' mer'et ciissinritlerkait pitekluki."
        },
        "14": {
            "start": 196.12,
            "end": 199.96,
            "transcript": "Anarviit akitunritut pilillret cali auluksaraunateng."
        },
        "15": {
            "start": 199.96,
            "end": 204.22,
            "transcript": "Qurrutet imait ataucimi uitalartut ciissiit sagtevkenateng."
        },
        "16": {
            "start": 204.22,
            "end": 211.06,
            "transcript": "Tau͡gaam anarviit ellisciigatut mecagglilrianun wall' qau͡gyilrianun cali ulem tekicugngakiini."
        },
        "17": {
            "start": 211.06,
            "end": 218.4,
            "transcript": "Anarviit enem iluantenritut meq aturyugngalria utercuunani cali nugtarrnaqluteng elanret muiraqata."
        },
        "18": {
            "start": 218.4,
            "end": 226.52,
            "transcript": "Makut nautellratki Shageluk-mi qulni allrakuni kitullerni anarvilillruat cavignek acilegnek Public Health Service-aami calistet."
        },
        "19": {
            "start": 226.52,
            "end": 235.4,
            "transcript": "Caviit tank-at muiraqata calistem maqtelarai allamun-llu imiuqaarluki ciqicivigmun wall' sewage lagoon-amun ayaulluku."
        },
        "20": {
            "start": 235.4,
            "end": 241.48,
            "transcript": "Anarviit tank-ait ayuquciit-llu ak'anun atuuyugngavkalarait tau͡gaam akilirarkarluteng."
        },
        "21": {
            "start": 241.48,
            "end": 244.52,
            "transcript": "Anarviit akingqertut qulnek tiissitsaanek."
        },
        "22": {
            "start": 244.52,
            "end": 250.76,
            "transcript": "Nunam yui kiputarkaugait pump-aq, naivissuun tank-aq, cali nunakurcuutekaa."
        },
        "23": {
            "start": 250.76,
            "end": 255.32,
            "transcript": "Calistekamek cali piyarauluteng muiraqata pistekaitnek."
        },
        "24": {
            "start": 255.32,
            "end": 260.84,
            "transcript": "Nunami tumyarat auluknarqut assirluteng ciqitarkat ayautnaqngata."
        },
        "25": {
            "start": 260.84,
            "end": 265.84,
            "transcript": "Yuut anarvilget cavignek acilegnek cali akilirilartut ikayuumalteng."
        },
        "26": {
            "start": 265.84,
            "end": 271.6,
            "transcript": "Anarviit qacignarqut cali auluksaraunateng tau͡gaam alla qacignaillra atengqertuq mound-amek."
        },
        "27": {
            "start": 271.6,
            "end": 274.94,
            "transcript": "Paqteqerlaut aturyaraa Iliamna-mi wall' Tevyarami."
        },
        "28": {
            "start": 274.94,
            "end": 281.18,
            "transcript": "Makut apqiit mound-at ayagnillruit 1947-aami cali pilarait Wisconsin toilet-aanek."
        },
        "29": {
            "start": 281.18,
            "end": 284.98,
            "transcript": "Makucit mound-at arulat'larait aulukluki-llu pikestait."
        },
        "30": {
            "start": 284.98,
            "end": 288.82,
            "transcript": "Johnny Johnson-aam pini pikaa 1986-aarraanranek."
        },
        "31": {
            "start": 294.3,
            "end": 298.62,
            "transcript": "Man'a ciqitarkaq wavet uitavigkaminun pilartuq."
        },
        "32": {
            "start": 298.62,
            "end": 311.9,
            "transcript": "Tua-llu tauna imirturaraqluni meq mayurturluni piaqami pugtassuun tekitaqamiu kalluum ayagcet'laraa pump-aq."
        },
        "33": {
            "start": 311.9,
            "end": 327.36,
            "transcript": "Tua-llu meq tamana taun tekiskaku ayagarrluni tua-llu tamana ciqitarkaq mat'umun cuplumun ayagluni tuaken wavet nunam qaingan iluanun piluni."
        },
        "34": {
            "start": 327.36,
            "end": 335.7,
            "transcript": "Una wani qulliani uitalartut makut cuplut taktaciacetun taum nunam."
        },
        "35": {
            "start": 335.7,
            "end": 348.54,
            "transcript": "Cetaman it'ganeq naagaqata cuplumun allamun pilartuq, tua-llu tayima tamana waten avquqcaarnganaku piuralartuq."
        },
        "36": {
            "start": 348.54,
            "end": 360.24,
            "transcript": "Man'a ciqitarkaq tamaaggun kucirturalartuq cuplutgun tuaken quliitnun, tua-llu tuaken acitmun ellminek piurluni."
        },
        "37": {
            "start": 360.24,
            "end": 367.0,
            "transcript": "Ciuqlirmi allrakumi cikullruyaaquq 36 below zero tekitellrani."
        },
        "38": {
            "start": 367.0,
            "end": 377.66,
            "transcript": "Tua-llu up'nerkami kitugtestait tekilluteng man'a maqarqucillruat cetamanek cetyaarnek mamtutaluteng maqarqutet."
        },
        "39": {
            "start": 377.66,
            "end": 384.0,
            "transcript": "Waniwa pingayunek it'ganerluteng aciani uitauq mat'um nunam."
        },
        "40": {
            "start": 384.0,
            "end": 391.66,
            "transcript": "Tuakenirnek assirluni caksaunani caliurtuq pingayunelget allrakut iluatni."
        },
        "41": {
            "start": 391.66,
            "end": 403.78,
            "transcript": "Wani-llu 1988-aami 89-aam akunliigni uksumi tayima 50 below zero tekitengraan cikullruvkenani."
        },
        "42": {
            "start": 403.78,
            "end": 406.52,
            "transcript": "Maa-i cali tauna caliurtuq."
        },
        "43": {
            "start": 406.52,
            "end": 416.54,
            "transcript": "Tau͡gken caliaqnaqluni elliin pikestiin malruk allrakuk naagaqan caliaqarkauluku."
        },
        "44": {
            "start": 471.92,
            "end": 478.58,
            "transcript": "Mound-aq ellimariaqami auluksaraitelartuq. Atuuyugngaluni-llu yuinat allrakut tekilluki."
        },
        "45": {
            "start": 478.58,
            "end": 488.82,
            "transcript": "Ena atulria mound-amek yuqerrvingertuq enem iluani, tau͡gaam cali well-angqerrnaqluni, holding tank-amek, cali pump-amek ayautessuutekaitnek ciqitat mound-amun."
        },
        "46": {
            "start": 488.82,
            "end": 495.68,
            "transcript": "Mound-am ellillra akituyugngauq arcaqerluku qikuq, qau͡gyaq, teggalquyagaat-llu nurnaqata."
        },
        "47": {
            "start": 495.68,
            "end": 500.48,
            "transcript": "Mound-am ayuqellerkaa taqnerqa [?] elisngalriim assirluni caliarkaukan."
        },
        "48": {
            "start": 500.48,
            "end": 506.04,
            "transcript": "Mound-am ellillra calirpaagarnarquq qallia unatekun ellimaarkaungami."
        },
        "49": {
            "start": 506.04,
            "end": 514.26,
            "transcript": "Qurrutem imai pikalqeggluteng sagtescaaraugut [?] mound-am acia ellngarnayukluku wall' mermun aukuyutnayukluku."
        },
        "50": {
            "start": 514.26,
            "end": 520.16,
            "transcript": "Cali tank-aa, cupluq, mound-aq-llu maqarqucirnarqut cikunayukluki uksumi."
        },
        "51": {
            "start": 520.16,
            "end": 525.34,
            "transcript": "Tank-am pump-aa murilkenarquq assirluni caliarkaukan mound-aq."
        },
        "52": {
            "start": 525.34,
            "end": 530.48,
            "transcript": "Qau͡gyaq, qikuq, teggalquyagaat-llu mound-ani allakalarait ciqitat ciissiit."
        },
        "53": {
            "start": 530.48,
            "end": 536.24,
            "transcript": "Cali alla qurrun composting toilet-aaq elucimitun calituuq allakarturluki ciissit."
        },
        "54": {
            "start": 536.24,
            "end": 540.94,
            "transcript": "Nakneq, ungalalirnerani Iilgayam kinguneqaa John Knutson-aam."
        },
        "55": {
            "start": 540.94,
            "end": 548.9,
            "transcript": "Anguyagtem yaquleyagiurtaini calista cali neqsurta composting toilet-aani pikaa aturluku-llu qulni allrakuni."
        },
        "56": {
            "start": 548.9,
            "end": 552.96,
            "transcript": "Qavciugut ayuqenrilnguut composting toilet-aat tuniaqetukait."
        },
        "57": {
            "start": 552.96,
            "end": 555.82,
            "transcript": "Ilait tank-ait angengata ellamun ellimalartut."
        },
        "58": {
            "start": 555.82,
            "end": 558.82,
            "transcript": "Ilait tau͡gaam mikngameng enem iluanun elliyugngaut."
        },
        "59": {
            "start": 558.82,
            "end": 563.78,
            "transcript": "Makut amllermek mermek atuyuitut, tepaitaqluteng-llu elluarrluteng ellimaaqameng."
        },
        "60": {
            "start": 563.78,
            "end": 566.6,
            "transcript": "Paqteqerlaut Knutson-aankut yuqerrviat."
        },
        "61": {
            "start": 576.9,
            "end": 580.9,
            "transcript": "Una wani ciqiciurluni qurrun uitauq."
        },
        "62": {
            "start": 580.9,
            "end": 587.1,
            "transcript": "Cali-llu cuplungqerrluni acitmun enem acianun."
        },
        "63": {
            "start": 587.1,
            "end": 596.24,
            "transcript": "Waten fan-angqerturluni-wa kesianek man'a wani tepsaqevkarpek'naku piuralartuq."
        },
        "64": {
            "start": 596.24,
            "end": 604.84,
            "transcript": "Cali-llu qurrutngung'e'rmi tepsaqsuunani man'a ella tayim' assirturluni."
        },
        "65": {
            "start": 604.84,
            "end": 615.42,
            "transcript": "Ciuqlirmi umyuarteqlemni assiicukluku waten elatemkun ciqicivingqellriaten wall' qurrutengqatalriaten ayuqellruyukaqa."
        },
        "66": {
            "start": 615.42,
            "end": 621.14,
            "transcript": "Tau͡gaam atuamku waniwa assiucia nallunrirqa."
        },
        "67": {
            "start": 621.14,
            "end": 630.38,
            "transcript": "Cali-llu assirluni maa-i waten nunam qaingani ping'e'rmi wall'u teggalquungraan atuuyugngaluni."
        },
        "68": {
            "start": 630.38,
            "end": 641.08,
            "transcript": "Tau͡gken waten allamek mermek aturarkauluni, cali-llu makut wani mermek atuyuitut."
        },
        "69": {
            "start": 641.08,
            "end": 647.38,
            "transcript": "Man'a wani cupluq, mat'um qacarnerem keluani uitauq."
        },
        "70": {
            "start": 647.38,
            "end": 668.48,
            "transcript": "Cali-llu kenirvimteńi makut wani neqkaunrilnguut qeciit, kuuvviallret, saayuutellret, naunrat qeciit, wavet ek'lartut camavet-llu iggluteng."
        },
        "71": {
            "start": 668.48,
            "end": 674.64,
            "transcript": "Una wani ciqiciviunganani piuguq enem aciani."
        },
        "72": {
            "start": 674.64,
            "end": 688.36,
            "transcript": "Atauciq pakmaken qurrutmek pilartuq, cali-llu una wani kenirvimteńek caliaqsagauguq iliini."
        },
        "73": {
            "start": 688.36,
            "end": 701.0,
            "transcript": "Cali-llu ikirteng'e'rmi una wani amiiga, man'a wani igteksailnguq mat'um acianun tamana caliaqerkauluku."
        },
        "74": {
            "start": 701.0,
            "end": 707.7,
            "transcript": "Cali ikirteng'e'rmi waten camek narnaunani."
        },
        "75": {
            "start": 707.7,
            "end": 715.0,
            "transcript": "Cali-llu ataucirqumek tayima allrakum iluani man'a caliaqnaqluni."
        },
        "76": {
            "start": 715.0,
            "end": 736.3,
            "transcript": "Waten-llu man'a wani nunaurtellriatun ayuqliriluni, cali-llu anteńaqluku alingnaunani-llu, cali-llu naucetaanun wall'u naunrarvignun aturyugngaluni, atunrilkuni-llu tamana ciqicugngaluku."
        },
        "77": {
            "start": 792.36,
            "end": 799.76,
            "transcript": "Amlleret composting toilet-aat atulartut kallugmek. Ilait-llu angengameng amllermek pivigmek aturaqluteng."
        },
        "78": {
            "start": 799.76,
            "end": 803.12,
            "transcript": "Tamarmeng assirluteng aulukenqegcaarnarqut."
        },
        "79": {
            "start": 803.12,
            "end": 813.0,
            "transcript": "Ilii yuqerrviim aulukcurlaumakuni ayuqluku kiirmek wall' anuqsaaryaraa arulaiqan urugngalnguliurallra arulairciquq."
        },
        "80": {
            "start": 813.0,
            "end": 817.02,
            "transcript": "Tuaten-llu pikuni ataam ayagninqigtengnaqsarauluni."
        },
        "81": {
            "start": 817.02,
            "end": 824.0,
            "transcript": "Makut qurrutet piliaqumaut atuumaarkauvkenateng cetaman cipluku una yungqerqan."
        },
        "82": {
            "start": 827.82,
            "end": 835.6,
            "transcript": "Composting toilet-aat ukut pikuciat mermek amllermek atuyuitut, tau͡gaam puqlam aurnaqluteng [?] assirluteng caliarkaukuneng."
        },
        "83": {
            "start": 835.6,
            "end": 842.18,
            "transcript": "Cali allamek yuqerrvigtangqertuq mermek atuyuilngurmek tau͡gaam legtaqluki qurrutem imai."
        },
        "84": {
            "start": 842.18,
            "end": 847.8,
            "transcript": "Legcitulit yuqerviit aturyarait paqteqerlaut Kuinerrarmi Kusquqviim paingani."
        },
        "85": {
            "start": 847.8,
            "end": 854.3,
            "transcript": "Legcitulit yuqerrviit naspaallruit Alaska-mi National Guard-at, Public Health Service-aam, cali qavcin elitnaurviit."
        },
        "86": {
            "start": 854.3,
            "end": 858.22,
            "transcript": "Maani Kuinerrarmi incinerator toilet-aangqertuq Fuzz LePage-aq."
        },
        "87": {
            "start": 871.16,
            "end": 876.62,
            "transcript": "Una wani kallugtun aturluni qurrutnguuq."
        },
        "88": {
            "start": 876.62,
            "end": 885.56,
            "transcript": "Cali-llu aturpailegmi mat'umek qalliliqarraarluku atuurarkauluni."
        },
        "89": {
            "start": 885.56,
            "end": 896.4,
            "transcript": "Kina tayima yuqerqaarluni una-wa it'gavkun neg'arrluku tauna-ll' iggluni taum acianun."
        },
        "90": {
            "start": 896.4,
            "end": 908.0,
            "transcript": "Tuani uitaluni uum it'gam agturaqatni kumangarcet'laraa tua-llu leggluku."
        },
        "91": {
            "start": 908.0,
            "end": 922.34,
            "transcript": "Caknek uuqnarqelartuq tayima-llu tiissitsaaq aipaa avegyarpiarluku degrees-at tekitaqluteng tau͡gken elatiini kumlaqu'urluni."
        },
        "92": {
            "start": 922.34,
            "end": 928.38,
            "transcript": "Tamana legtelaraa akimiarit cetyagaat iluatni."
        },
        "93": {
            "start": 928.38,
            "end": 935.92,
            "transcript": "Tuatnarraarluni kumlacilaraa sass'am avgan iluani."
        },
        "94": {
            "start": 935.92,
            "end": 948.76,
            "transcript": "Cali-llu qavcin erenret atuqerluki taum aciani assigtaa anlluku waten legcimalria tangerciqan."
        },
        "95": {
            "start": 948.76,
            "end": 959.48,
            "transcript": "Tamana legtellra alingnaituq Yugnun ak'a leg'umiimi makut-llu ciissit tuqulluki."
        },
        "96": {
            "start": 959.48,
            "end": 967.1,
            "transcript": "Cali-llu tamana aturyugngaluku-wa naucetaarvignun wall'u ciqilluku."
        },
        "97": {
            "start": 967.1,
            "end": 972.18,
            "transcript": "Teptaunani cali-llu wall' allamek ciqitarkaunani."
        },
        "98": {
            "start": 972.18,
            "end": 980.9,
            "transcript": "Una cali piliumaluni-wa aruyuilngurmek wall'u qallyuilngurmek."
        },
        "99": {
            "start": 980.9,
            "end": 989.36,
            "transcript": "Qacignaqluni atullra cali-llu camek iqairinaunani."
        },
        "100": {
            "start": 989.36,
            "end": 994.62,
            "transcript": "Tamarmeng caviyagai iluantut alingnaunani-llu."
        },
        "101": {
            "start": 994.62,
            "end": 1001.0,
            "transcript": "Tau͡gaam akia malrugnek tiissitsaanek akikangqerrluni."
        },
        "102": {
            "start": 1001.0,
            "end": 1006.0,
            "transcript": "Cali-llu amllermek kallugmek aturnaqluni."
        },
        "103": {
            "start": 1058.52,
            "end": 1065.62,
            "transcript": "Ayuqluku anarvik, mound-aq, composting toilet-aaq-llu, legcitulit yuqerrviit kiingan auluk'larait qurrutet imait."
        },
        "104": {
            "start": 1065.62,
            "end": 1069.18,
            "transcript": "Ataam uterceciyuitut aturyugngalriamek mermek enenun."
        },
        "105": {
            "start": 1069.18,
            "end": 1074.7,
            "transcript": "Tau͡gaam allamek yuqerrvigtangqertuq tuaten piyugngalriamek, cuplui tuaten akituvkenateng."
        },
        "106": {
            "start": 1079.2,
            "end": 1088.26,
            "transcript": "Kuinerrami makut wani flush tank-at aturyarait ayagnillruuq 1994-aami."
        },
        "107": {
            "start": 1088.26,
            "end": 1102.14,
            "transcript": "City-q Kuinerrami calillgutekluki State-aq mat'um nunarraat makut wani assirillerkait tungiitnun elliigillruuq tallimanek makucinek."
        },
        "108": {
            "start": 1102.14,
            "end": 1111.18,
            "transcript": "Cali-llu ak'a ataucirqumek uksumi atullrurrluku camek arenqiallugutaunani."
        },
        "109": {
            "start": 1111.18,
            "end": 1122.26,
            "transcript": "Maa-i tamana cingumaaput cali-llu ataam elliiciqluta makut enet tamaitni maani nunani elliiyugluki."
        },
        "110": {
            "start": 1122.26,
            "end": 1138.74,
            "transcript": "Ukut wani IRA Council-aat calillgutekluki City-q makunek imirillruuq unangengnaqluki akikait, cali-llu Indian Community Block Grant-at mat'um tungiinun caliaqsugluku."
        },
        "111": {
            "start": 1138.74,
            "end": 1146.78,
            "transcript": "Flush tank haul-amek atulriit malrugnek tank-agnek atulartut, aipaa me'rmek imangqerrarkauluni, aipaa-llu qurrutet imaitnek."
        },
        "112": {
            "start": 1146.78,
            "end": 1153.0,
            "transcript": "Mervik tank-aq enem iluantelartuq, imiryugngaluku-llu pikestiin wall' nunami calistet."
        },
        "113": {
            "start": 1153.92,
            "end": 1157.9,
            "transcript": "Qamularait mer'em tank-ait imirluki-llu nunam well-aanek."
        },
        "114": {
            "start": 1157.9,
            "end": 1161.76,
            "transcript": "Eneni calistem kallugkun nucugcet'laraa meq tank-amun."
        },
        "115": {
            "start": 1161.76,
            "end": 1169.84,
            "transcript": "Ciqitat tank-ait ellamet'lartut enem acani. Elucimitun ellngautaqluki qurrutet imait cali meq atuumalria tank-amun."
        },
        "116": {
            "start": 1169.84,
            "end": 1175.62,
            "transcript": "Tamarmek cupluq tank-aq-llu maqarquciumalutek cikunritlerkaak piteklukek."
        },
        "117": {
            "start": 1175.62,
            "end": 1181.48,
            "transcript": "Cali cupluq heat tape-aumaluni, tank-aq-llu kallugcuutmek ircarissuutecuarluni."
        },
        "118": {
            "start": 1181.48,
            "end": 1189.0,
            "transcript": "Nunami calistem tank-akun maqtelaraa tank-am imaa allamun tank-amun, tua-i-llu ayaulluku ciqicivigmun."
        },
        "119": {
            "start": 1189.0,
            "end": 1195.7,
            "transcript": "Enet qerkitsiyaalriit aturciigalnguut ellmeggnek maqtulinek tank-anek, aturyaraugut transfer tank-anek."
        },
        "120": {
            "start": 1195.7,
            "end": 1202.3,
            "transcript": "Yuqerrvik ellimalartuq qulliini transfer tank-am, cali erurivik tuaten tank-amun ellngaraqluni."
        },
        "121": {
            "start": 1202.3,
            "end": 1207.02,
            "transcript": "Yuqerrvik quyigluni ellimanarquq ellngararkaukuni tank-amun."
        },
        "122": {
            "start": 1207.02,
            "end": 1212.7,
            "transcript": "Qurrutet imait meq-llu aturngailnguq ciumek transfer tank-amun quyurtelarqelluni."
        },
        "123": {
            "start": 1212.7,
            "end": 1222.24,
            "transcript": "Tauna tank-aq muiraqan imai nugtartelartut angenranun holding tank-amun pump-akun, tua-i-llu angenra tank-aq imairluku calistem."
        },
        "124": {
            "start": 1222.24,
            "end": 1233.52,
            "transcript": "Flush tank haul-aryarat sagcecuitait ciqitat ciissiit, yuut nunami calisteńgunge'rmeng agtuyuilatki ciqitat, elluarlluni tau͡gaam aulukumakuni."
        },
        "125": {
            "start": 1233.52,
            "end": 1240.02,
            "transcript": "Flush tank haul-aryaram ikayulaitki tamalkuan nuna, enem yui akilirilartut iraluaqan."
        },
        "126": {
            "start": 1240.02,
            "end": 1246.18,
            "transcript": "Akiliutait ayalartut calistenun cali aulukumallerkaitnun yuqerrviit aklukait."
        },
        "127": {
            "start": 1248.58,
            "end": 1258.0,
            "transcript": "Waniwa 1996-aami yuinaq tallimanek cipluku (25) amllertalrianek waten elliiyugtukut maani Kuinerrami."
        },
        "128": {
            "start": 1258.0,
            "end": 1273.28,
            "transcript": "Cali-llu caliaqaqamegteggu wall'u tamana ciqiteqataqamegteggu akimarnek (15) akikanek aturaqluteng-llu [?] cali akimiarnek (15) akiliqerluteng imiraqluki mer'it."
        },
        "129": {
            "start": 1273.28,
            "end": 1283.02,
            "transcript": "Wall'u yuut ellmeggnek waten pump-arluki tamakut piyugngait, wall'u cali ellmeggnek mertarluteng."
        },
        "130": {
            "start": 1283.02,
            "end": 1287.64,
            "transcript": "Tamana ellmeggnek pikatki akiinani."
        },
        "131": {
            "start": 1292.44,
            "end": 1305.24,
            "transcript": "Kitugcukuvgu elpet qurruteten wall' mer'em ayagyaraa enevni wall'u ilagausngaluten nunavet mat'umun calillra, ayuqenrilngurnek ikayuutnek pitangqerrucia kiingan ayagneruuq, cali ayuqenritut umyuaqerkat."
        },
        "132": {
            "start": 1305.24,
            "end": 1310.62,
            "transcript": "Naliit mer'em qurrutet-llu ikayuitait assirluni caliciqa nunavceńi?"
        },
        "133": {
            "start": 1310.62,
            "end": 1314.94,
            "transcript": "Qaillun akingqerciqa ellillra aulukellra-llu?"
        },
        "134": {
            "start": 1314.94,
            "end": 1319.08,
            "transcript": "Naken akikaa unakciqa?"
        },
        "135": {
            "start": 1319.08,
            "end": 1328.12,
            "transcript": "Allat akikait ayuqluku auluklerkaa atu'urkai-llu wall'u tumyarillerkaa ilaknarqut-qaa?"
        },
        "136": {
            "start": 1328.12,
            "end": 1332.46,
            "transcript": "Nunam-qaa akilicugngaciqaa aturtain akiliutaitgun?"
        },
        "137": {
            "start": 1332.46,
            "end": 1345.34,
            "transcript": "Caliaqellerkaa, ellillerkaa, auluklerkaa-llu mer'em qerrutet-llu taqevkenateng ikayuulluteng-llu caliaqnarqaat nunam yuin, ciuliqagtait, state-am, anguyagtem, allat-llu."
        },
        "138": {
            "start": 1345.34,
            "end": 1349.3,
            "transcript": "Iquani cat iqaillrukata tamamteńun assinruciquq."
        },
        "139": {
            "start": 1349.3,
            "end": 1354.0,
            "transcript": "Calillgutkellemteggun qurrutet aturnanriryugngaut."
        }
    },
    "Z1fIb5_GfhE": {
        "1": {
            "start": 2.5,
            "end": 12.18,
            "transcript": "...assinrunilarait uksuungrani merturluni aipaqa ava-i tamakunek."
        },
        "2": {
            "start": 12.18,
            "end": 23.16,
            "transcript": "Tua-i-llu ukut waten ayuqut qanganaruat atuullrat."
        },
        "3": {
            "start": 23.16,
            "end": 42.44,
            "transcript": "Tamatumun tamaa-i cancer-aamun [?] merturluku atuuluteng. Makut ava-i cancel-aata [?] tua-i-llu cali."
        },
        "4": {
            "start": 42.44,
            "end": 56.58,
            "transcript": "Iluni quulereskan, quulerrluni imga apqemteńek keliurciluteng elciarluteng quunarqeqapiarmek yuk pikuni."
        },
        "5": {
            "start": 56.58,
            "end": 65.82,
            "transcript": "Tua-i-llu tamakut juice-aatnek meq'uni egmiaqapiar tua-i nipciquq quulertellrat cataunani."
        },
        "6": {
            "start": 65.82,
            "end": 69.06,
            "transcript": "Keniramek-qaa? Keniramek."
        },
        "7": {
            "start": 69.06,
            "end": 74.72,
            "transcript": "Keniram mecuanek meq'uni egmianun nipciquq quulertenrirluni."
        },
        "8": {
            "start": 75.76,
            "end": 82.22,
            "transcript": "Nerluki tuaten cuyatuumaita can'get uqua up'nerkami waten naullrat."
        },
        "9": {
            "start": 83.0,
            "end": 86.7,
            "transcript": "Naugaraaten nertuit kenerluki."
        },
        "10": {
            "start": 86.7,
            "end": 95.58,
            "transcript": "Tua-i tuaten ayuqluni. Tamakunun-llu wii atullruaqa tuaten. Allragni quulertunga'artellruunga."
        },
        "11": {
            "start": 95.58,
            "end": 106.58,
            "transcript": "Tua-i-llu tamatumek qanganaruam mecuanek mer'aqa egmiaqapiar tua-i catairutnaurtuq mer'ucimtun quulertenrirlua."
        },
        "12": {
            "start": 109.48,
            "end": 125.32,
            "transcript": "Tuamta-llu yuk kilirpakuni, wall'u it'gamikun kilirpakuni, imuuni [?] waten uquryagluku cakneq."
        },
        "13": {
            "start": 125.32,
            "end": 141.0,
            "transcript": "Imkut qanganaruat cuyait kinercirraarluku ulugluki. Tua-i-llu uluka'arluki uqumek mecirluki wall'u saalamek aipaagnek tua-i ayuqlutek taukuk."
        },
        "14": {
            "start": 141.0,
            "end": 148.4,
            "transcript": "Tuavet imumek kilinerpaminun patgulluku nemegluku uitaluni unugpak."
        },
        "15": {
            "start": 148.4,
            "end": 158.56,
            "transcript": "Unuaquani au͡g'arluku ikirciiqaa imna uquryak tamarmi tuavet taum tegullinikii."
        },
        "16": {
            "start": 158.56,
            "end": 167.6,
            "transcript": "Carrinqekapiarluni-ll' kilinra uquryagartairulluni patagmek mam'arkauluni tuatnakuni."
        },
        "17": {
            "start": 167.6,
            "end": 177.76,
            "transcript": "Cayugissuutnguluni cayugcetaaruluni assiitellriamek kemgem iluanek tukniluteng cali tamakut."
        },
        "18": {
            "start": 181.06,
            "end": 195.38,
            "transcript": "Au͡gkut pulengtaq wii tangautullruunga tamakunun kilinerpamek-llu iinrukluku uquryanqessuunateng kilinrit tamakunek."
        },
        "19": {
            "start": 195.38,
            "end": 203.22,
            "transcript": "Tua-llu cali kilineq kilirpagaqameng aunratuut."
        }
    },
    "H_PWsD75rcg": {
        "1": {
            "start": 70.42,
            "end": 74.66,
            "transcript": "Waqaa, Aqum'augua. Quyana ilagaqatarlua qanemcikanun."
        },
        "2": {
            "start": 74.66,
            "end": 86.58,
            "transcript": "Atakuliciiqukut ukut LKSD-t Yugcetun qaneryaramek wall'u-qaa qalarcaramek elitnaurilallratnek nalluyagutenritlerkaa-wa tua-i man'a qaneryaraput qalarcaraput Yugcetun."
        },
        "3": {
            "start": 86.58,
            "end": 93.8,
            "transcript": "Cali-llu tangvagciqukut uumek tangercetaaliyaratnek ava-i Maqinermi Mink Festival-aam nalliini caqtaallritnek."
        },
        "4": {
            "start": 93.8,
            "end": 102.92,
            "transcript": "Cali-llu eliciiqluta ukut TWC-t ikayuutiitnek uumek Napayaarmek ayagallratnek maani Mamterillermi cikiutet tungiitnun pilria."
        },
        "5": {
            "start": 102.92,
            "end": 108.58,
            "transcript": "Makut ciumek tau͡gaam arcaralriit qanemcit ava-i Agayunermi piurtellret."
        },
        "6": {
            "start": 108.58,
            "end": 115.24,
            "transcript": "Ukut state-at piyungarrluteng uumek nutaramek Bethel recieving home-amek naparciyungartelliniut."
        },
        "7": {
            "start": 115.24,
            "end": 118.5,
            "transcript": "Una qaneq ava-i Tallimiritmi niitellruaput."
        },
        "8": {
            "start": 118.5,
            "end": 128.88,
            "transcript": "Tayima ellait state-at navgucullegni [?] niitukut city-t nunamek piani housing-aat nuniitni taun' nutaram receiving home-am pikaanek nunakaanek."
        },
        "9": {
            "start": 128.88,
            "end": 136.08,
            "transcript": "Cali cimiqataraat una ak'allaq ena makut ayagyuat uitaviat muirumalria."
        },
        "10": {
            "start": 136.08,
            "end": 144.64,
            "transcript": "Makunek ayagyuanek tuani uitavingqelartut tekilluku akimiaq pingayun cip'arrluku (18) allrakungelrianun."
        },
        "11": {
            "start": 144.64,
            "end": 156.78,
            "transcript": "Tauna tau͡gaam piurpailgan ukut city planning commision-aara canrilkarkauluku January 6-aami quyureskuneng tua-ll' nutaan ukut council-aat canrilkarkauluku naparpailgatgu."
        },
        "12": {
            "start": 156.78,
            "end": 169.02,
            "transcript": "Elkek taukuk ava-i canrilkekatgu ayagnirciqaat Kanruyaucim iraluani caliaqengluku napartengluku kiagumainanrani-llu ikirrluni makunun ayagyuanun."
        },
        "13": {
            "start": 169.02,
            "end": 179.48,
            "transcript": "Tua-ll' ukut Qerrulligmiut council-aarit ikayullrulliniit ukut state-at tegustait tegutellratni uumek taangamek tuniaryukellratnek tamaani Qerrulligmi."
        },
        "14": {
            "start": 179.48,
            "end": 187.14,
            "transcript": "Ukut council-aat teguvkallruat una yuinaq akimiaq pingayunek cip'arrluku (38) allrakulek Isaac Seaton-aaq."
        },
        "15": {
            "start": 187.14,
            "end": 198.88,
            "transcript": "Ukut council-aat qanrutellruit taukut tegustet kamakniluku taanganek tuneniaryukluku taum Seaton-aam elliin eniinek $100 pitaarluki tamakut putiil'kaat."
        },
        "16": {
            "start": 198.88,
            "end": 207.96,
            "transcript": "Ukut tegustet yuallermegteggu Seaten-aam enii nataqutellruut malrugnek putiil'kaagnek tiissitsaaruyarpialrianek-llu akirugarugarnek."
        },
        "17": {
            "start": 207.96,
            "end": 218.66,
            "transcript": "Tayima Qerrulligmiut aprumalartut kinrumaniluku tua-i-wa taanganek taitesciigataqluteng yuut tamaavet nuniitnun cali-llu tuneniarciiganateng."
        },
        "18": {
            "start": 218.66,
            "end": 229.54,
            "transcript": "Tua-ll' Mamterillermiut nutaramek uumek cacetuqutenglliniut cacetuqutekameggnek cucuklillruut alerquistekamek traditional chief-amek."
        },
        "19": {
            "start": 229.54,
            "end": 248.32,
            "transcript": "Una Qugcuun cali-llu Allran'aq au͡gkuk elkeka ukut Uiviim iraluani tegganret piani Eddie Hoffman Senior Center-aami cucukellruagket ilii cucukesqelluku ukutgun ONC-tgun ciuliqagtekesqelluku."
        },
        "20": {
            "start": 248.32,
            "end": 252.66,
            "transcript": "Elkek taukuk atrek tunumallruuk ukunun ONC-nun."
        },
        "21": {
            "start": 252.66,
            "end": 261.72,
            "transcript": "Ellait-llu tua-i nutaan ONC-t board-aari cucukluku una Qugcuun traditional chief-aqesqelluku maani Mamterillermi."
        },
        "22": {
            "start": 261.72,
            "end": 274.6,
            "transcript": "Tayima ellii tauna Anvil-aaq Qugcuun board-ani ONC-ni uitallruyaaquq tau͡gaam au͡g'araat traditional chief-aurcan allamek yugmek aqumlleranun yuaruciiqaat."
        },
        "23": {
            "start": 274.6,
            "end": 290.36,
            "transcript": "Tau͡gaam qanrutkaat ellii tauna Qugcuun traditional chief-aaruluni maani Mamterillermi ONC-t caqtaaraqata kesianek ellii cacetuqutek'larciqaat alerquistekluku tuaten caqtaaraqameng maani Mamterillermi."
        },
        "24": {
            "start": 290.36,
            "end": 309.32,
            "transcript": "Tua-llu unuaqu Tallimiritmi December, aren, unuaqu-wa tua-i Tallimiritmi ukut yugngalnguaraat maani makumiungurtellret, Mamterillermiungurtellret, nerevkariqatalliniut makunek tegganernek piani Eddie Hoffman Senior Center-aami."
        },
        "25": {
            "start": 309.32,
            "end": 320.26,
            "transcript": "Cali makut ellait yugngalnguaraat neqkameggnek-wa nerevkariciqliniut ayagnirluteng 11:30-mi 1:30 tekilluku."
        },
        "26": {
            "start": 320.26,
            "end": 334.5,
            "transcript": "Nall'arcetaarciqliniut-llu uumek TV-mek cali-llu tangercetaarcuutmek VCR-amek, allanek tuaten makunek cikiutnek ellait yugngalnguaraat taitellritnek aruqiarkauluteng tamakunun tegganernun."
        },
        "27": {
            "start": 334.5,
            "end": 344.0,
            "transcript": "Cali ukut tegganret ellait Alussistuarciqut cikiuteteng aruqarkauluki December 21-aami taum kinguani."
        },
        "28": {
            "start": 344.86,
            "end": 366.88,
            "transcript": "Tua-ll' makut erenret nalliitni tangvalartukut niitaqluta-llu makunek mikelngull'ernek ayagyuanek qalartaqameng qitevtenruaqluteng, qitevcunruaqluteng, Yugcetun tau͡gken tua-i-wa qanssiyaayuirulluteng."
        },
        "29": {
            "start": 366.88,
            "end": 382.0,
            "transcript": "Una Charles Kass'atuq (Kashatok) ukuni LKSD-ni Yugtarnek elitnauristet arulatestii cali-llu Iigmiut elitnaurviat principle-aarat Mark John-aq maantellruuk uumi."
        },
        "30": {
            "start": 382.0,
            "end": 391.28,
            "transcript": "Uum-llu Upay'am apqangssaglukek mat'umek nalluyagutenritlerkaa wangkuta Yugni qalarcaraput."
        },
        "31": {
            "start": 391.28,
            "end": 394.32,
            "transcript": "Waniwa Upay'am apqangssallra."
        },
        "32": {
            "start": 395.78,
            "end": 410.8,
            "transcript": "Ciuqliuluku una wani makut-wa elitnaurvimteńi yuvriumalriit allrakuni maa-i pingayuurtellriit record-aani imkunek qelkelluki qaneryaraitnek pillret."
        },
        "33": {
            "start": 410.8,
            "end": 431.04,
            "transcript": "Yuvrillemegniki watua avani allrakuni malrug' ciuqligni yuut-wa qantulit Yugcetun amllenrullruut ikgelikanirluteng-llu Yugtun pitulriit allrakuni pingayuni."
        },
        "34": {
            "start": 432.78,
            "end": 443.88,
            "transcript": "Tangrruaqallerpeni information-aarituten qaillun amllertaciat Yugtun qalarutkellrat nunacaurat enaitni."
        },
        "35": {
            "start": 444.44,
            "end": 458.74,
            "transcript": "Amllenritut ukut tau͡gaam imkut makut-wa tua-i qantulit Yugtun angayuqameggnun atatulria tamana waten tayim' umyuartekumta kingunerput umyuaqluku."
        },
        "36": {
            "start": 458.74,
            "end": 472.72,
            "transcript": "Miktellemteńi angayuqaput-wa tua-i camek qanqata kina-llu imna assikluku pikuneng wangkuta-ll' tua-i mikcuarni umyuarteqluta taum tungiinun tua-i assirluni umyuarput."
        },
        "37": {
            "start": 472.72,
            "end": 481.9,
            "transcript": "Wall'u ca tua-i imna pivakluku angayuqamta piaqatgu wangkuta-ll' tauna, wangkuta-ll' mikengramta tauna tuaten umyuarteqtuluta."
        },
        "38": {
            "start": 481.9,
            "end": 489.44,
            "transcript": "Ukverat-llu cali, ukveraqata camek tauna-ll' tua-i ukvek'ngaat [?] wangkuta-ll' cali ukveqluku."
        },
        "39": {
            "start": 489.44,
            "end": 497.06,
            "transcript": "Tayima tua-i qaneryaraq-llu man'a Yugtun angayuqanun ataluni."
        },
        "40": {
            "start": 497.06,
            "end": 508.5,
            "transcript": "Ukunun-llu call' aanaulrianun-wa arcaqerluni, aanaulriit maa-i qaneryaraat tauna tua-i aanaulriim irniarinun."
        },
        "41": {
            "start": 508.5,
            "end": 513.86,
            "transcript": "Irniarit tua-i aanameng qaneryaraacetun qaneryugngaluteng."
        },
        "42": {
            "start": 516.54,
            "end": 524.8,
            "transcript": "Qaillun-mi maa-i unuamek tangerrluku allrakuni qulni kitullerni qaillun ayuqa tamana?"
        },
        "43": {
            "start": 527.34,
            "end": 535.12,
            "transcript": "Ukut wani statistics-aat yuvrillmegneki..."
        },
        "44": {
            "start": 540.96,
            "end": 543.18,
            "transcript": "Takut tuani."
        },
        "45": {
            "start": 545.04,
            "end": 558.34,
            "transcript": "Two years tau͡gaam iluani amllertalriamek tamana iciw' ayuqestassiigutengqertuq."
        },
        "46": {
            "start": 558.34,
            "end": 568.62,
            "transcript": "1990-mi Yugcetun qantulit amllertat 41%-wa pillrulliniut."
        },
        "47": {
            "start": 568.62,
            "end": 575.02,
            "transcript": "Tau͡gken maa-i 1993-aami 33%."
        },
        "48": {
            "start": 575.02,
            "end": 583.82,
            "transcript": "Tuar Kass'acetun wani qanturilriit amlleriinarluteng."
        },
        "49": {
            "start": 586.28,
            "end": 599.0,
            "transcript": "Nunacuarni-mi waten Chefornak-aaq, wall' allani nunacuarni waten Cevv'arnermi, Chefornak-aami, wall'u Asaucaryarmi Mountain Village-aami?"
        },
        "50": {
            "start": 599.0,
            "end": 612.88,
            "transcript": "Ii-i, maani school district-aamteńi ukut wani nunat Yugtarmiut amllenqurraugut elitnaurait Yugturrlainaq pitulit."
        },
        "51": {
            "start": 614.46,
            "end": 628.0,
            "transcript": "Ukuni-llu cali Mamterillermi, Goodnews Bay, Platinum, Mikuryami-llu, taukuni tua-i cali Kass'aturrlainaq elitnaurituluteng iliini pilange'rmeng."
        },
        "52": {
            "start": 628.52,
            "end": 641.84,
            "transcript": "Cali ukut wani Cevv'anermiut im' yuut cali Yugtun pilallrat qantullrat-wa elitnaurat ikgeliinarluni."
        },
        "53": {
            "start": 641.84,
            "end": 660.22,
            "transcript": "Uumi qayagaullemni Asaucaryarmiut Kass'aturrlainaq, Kass'aturpallarrlainaq elitnaularniluteng pillruut, makut-llu elitnaurat Kass'atun tau͡gaam qantuluteng, Yugtun piyuunateng."
        },
        "54": {
            "start": 660.22,
            "end": 675.78,
            "transcript": "Tayima qavciugut ukut wani: A, B, C, D, E, F, taukuuluteng LAO [?] category-nek pitukait cuqtaqamegteki tauggun Yugtun-wa qantullrit."
        },
        "55": {
            "start": 675.78,
            "end": 683.78,
            "transcript": "Ukut wani E-aat F-aat-llu Kass'aturrlainaq pituluteng. A-aaq-llu una wani Yugturrlainaq pituluni."
        },
        "56": {
            "start": 683.78,
            "end": 691.36,
            "transcript": "Tua-i qanrutkellruut taukut Asaucaryarmiut E-aat amllerrniluki F-aanek avuluteng."
        },
        "57": {
            "start": 691.36,
            "end": 699.0,
            "transcript": "Qaillun-mi angayuqrulriit piyugngaut cingumaluki Yugtun mikelnguut qalartellerkaatnek?"
        },
        "58": {
            "start": 701.68,
            "end": 712.1,
            "transcript": "Cali qanqallracetun-wa tua-i mikelnguut makut elitellrat kingunermeggni tau͡gaam ayagnirtuq angayuqameggneng."
        },
        "59": {
            "start": 712.1,
            "end": 720.68,
            "transcript": "Angayuqaita qaneryaraakun naukuneng tua-i taumek qaneryarangqerciquq."
        },
        "60": {
            "start": 720.68,
            "end": 734.4,
            "transcript": "Angayuqaa Yugtun qalareskan Yugtun qalarcetuluni nauciquq, wall' qitveskan qitevcetuluni nauluni, wall' tamarkenka atutukuni tamarkenka nauluni."
        },
        "61": {
            "start": 734.4,
            "end": 755.68,
            "transcript": "Tau͡gaam una wani mikelnguq Yugcetun wall' allakun naukuni tuani enemeggni atutukmikun nauciquq."
        },
        "62": {
            "start": 755.68,
            "end": 766.08,
            "transcript": "Tua-i-ll' tauna qaneryaraq wani taringyugngaluku qalaruteksugngaluku-llu nauciquq."
        },
        "63": {
            "start": 766.08,
            "end": 780.52,
            "transcript": "Tua-i-ll' tuaggun cali taringyaraakun qaneryaraakun elitnaurumakuni cali elitellra man'a cukamek nauciqluni."
        },
        "64": {
            "start": 780.52,
            "end": 792.22,
            "transcript": "Tau͡gken cali elitellra man'a iciw' aakulagtellriacetun piciquq qaneryaraq tauna mikellranek ayagluku aturturanrilkuni."
        },
        "65": {
            "start": 792.22,
            "end": 799.16,
            "transcript": "Amllertut-llu makut atunrivkallerkaa mat'um qaneryaram."
        },
        "66": {
            "start": 799.16,
            "end": 802.0,
            "transcript": "Cali qalarutekciqaput tamana."
        },
        "67": {
            "start": 802.74,
            "end": 816.18,
            "transcript": "Wangkutni-qaa Yugni qanelput wall' calput agtuumalartut mikelnguut tua-i-w' murilkurallermeggni tua-i-w' Yugtun qalarcaraq wall'-llu-q' Kass'atun."
        },
        "68": {
            "start": 816.9,
            "end": 834.1,
            "transcript": "Amllertut makut wani cayaraput, enemteńi-llu imkut pitulit. TV-q-llu man'a TV-nek makunek tangvalriani, tangvagturalriani-w' tua-i caarcallerkiarulluteng Yugtun-llu."
        },
        "69": {
            "start": 834.1,
            "end": 851.18,
            "transcript": "Wangkuta tayim' wiinga anglillemni miknii-llu niitelallruunga qanemcinek quliranek apa'urlunka-ll' [?] imkut qanemcituluteng ak'a pitullermeggnek ayuqucirturiluteng tuaten."
        },
        "70": {
            "start": 851.18,
            "end": 863.86,
            "transcript": "Maa-i TV-ngamta TV-mek tau͡gaam tua-i kiingan aqumgaurluta tangvag' ayuqucirturilriamek wall' qanemcilalriamek niiqurayuirulluta."
        },
        "71": {
            "start": 863.86,
            "end": 872.46,
            "transcript": "Man'a tua-i cayararput wangkuta imutun unitellriatun piluku unicetevkarluku tamakut TV-m."
        },
        "72": {
            "start": 872.46,
            "end": 876.12,
            "transcript": "Cali ilaqaqerlaku au͡gna."
        },
        "73": {
            "start": 876.12,
            "end": 894.82,
            "transcript": "Mikelnguq una wani qaneryaramcetun elitnaurumanrilkuni taringyuilkuni-llu au͡gkut piciryaraput wall' qanruyutet qanrutkellerkaa taumun taringyuilngurmun assirngaituq."
        },
        "74": {
            "start": 894.82,
            "end": 908.42,
            "transcript": "Amllertut wangkuta Yugni qanruyuteput, amllermi-llu yuum elluarrluni atu'urkaqluki tamakut qanruyutet."
        },
        "75": {
            "start": 908.42,
            "end": 920.12,
            "transcript": "Tua-i-ll' mikelnguq wani qaneryaramcetun elisnganrilkuni taringengaitait tamakut qanruyutet."
        },
        "76": {
            "start": 920.12,
            "end": 933.0,
            "transcript": "Taumek arcaqertuq wangkuta mikelnguut-wa makut taringellerkaitgun qalarut'laqumteki."
        },
        "77": {
            "start": 934.26,
            "end": 942.8,
            "transcript": "Ciin-gguq man'a arcaqertaa mikelngunun qelkellerkaanek qalarciarait wall'u-qaa Yugtun piciryaraitnun?"
        },
        "78": {
            "start": 942.8,
            "end": 957.5,
            "transcript": "Kinguqvaarni avani pingkumta makut-wa irniaput qalarcuilkuneng Yugtun, ilangqertukut tayima Ungalaqlirmiunek-llu Yugtun qanyuunateng."
        },
        "79": {
            "start": 957.5,
            "end": 962.4,
            "transcript": "Amta-ll' tamakurmiunguluteng unani-llu yuurtellruyaaqluteng."
        },
        "80": {
            "start": 963.06,
            "end": 968.82,
            "transcript": "Ayuqniarartut tamakut wangkucetun waten Yugtun qantuyugyaaqluteng."
        },
        "81": {
            "start": 968.82,
            "end": 972.6,
            "transcript": "Yup'igtun ellmegcicetun qalarcugyaaqluteng."
        },
        "82": {
            "start": 972.6,
            "end": 982.52,
            "transcript": "Tayima wangkuta miklemteńi makut angayuqaput wall'u ilaput amllerpek'nateng Kass'atun pitulit."
        },
        "83": {
            "start": 982.52,
            "end": 991.58,
            "transcript": "Tayima wangkuta imutun naspaalalriatun umigciluta qaneryarakun Yugtun Kass'atun-llu pituluta."
        },
        "84": {
            "start": 991.58,
            "end": 998.28,
            "transcript": "Tamana tua-i maa-i amllenriameng Yugturrlainaq pitulit."
        },
        "85": {
            "start": 998.28,
            "end": 1010.78,
            "transcript": "Wangkuta makut irniaput imutun pinrilget mumigciyuirulluteng-llu qanerciyuirulluku makut wani angayuqateng wall'u ilateng."
        },
        "86": {
            "start": 1010.78,
            "end": 1020.14,
            "transcript": "Tamatuyuirucameng-llu [?] tayima imutun tua-i cam imna atuyuitaqamteggu nalluyagutetukvut."
        },
        "87": {
            "start": 1020.14,
            "end": 1028.58,
            "transcript": "Makut-llu word-at imkut qaneryarat ilait aperyarat atuyuitaqamteki nalluyagutenglaraput."
        },
        "88": {
            "start": 1029.82,
            "end": 1040.0,
            "transcript": "Kitak' qanrutqerkut ilait program-aanek school district-aam paivciallratnek Yugtun-wa tamatum tungiinun."
        },
        "89": {
            "start": 1040.58,
            "end": 1047.62,
            "transcript": "Pingayuulartut au͡gkut maani LKSD district-aamteńi atuqengaput model-aat."
        },
        "90": {
            "start": 1047.62,
            "end": 1061.4,
            "transcript": "Ciuqliat Yup'ik First Language model, tua-i-ll' tunglia Bilingual Bicultural model, pingayuat-llu una English First Language model."
        },
        "91": {
            "start": 1061.4,
            "end": 1066.12,
            "transcript": "Kiik' tauna English First Language-aaq cam tamana cauga?"
        },
        "92": {
            "start": 1066.12,
            "end": 1072.32,
            "transcript": "Una wani English First Language program-aq imuuguq waten wani."
        },
        "93": {
            "start": 1072.32,
            "end": 1075.74,
            "transcript": "Maa-i 26-aanek school-anek pitangqertuq maa-i."
        },
        "94": {
            "start": 1075.74,
            "end": 1083.5,
            "transcript": "Taukut-llu tua-i iliitni 16-aaruluteng ukut elitnaurviit taumek First Language-aamek atulriit."
        },
        "95": {
            "start": 1083.5,
            "end": 1098.8,
            "transcript": "Waten pituluteng ayagniraqameng tua-i yaaken kindergarten-aamek, first grade, second grade, and also third grade, taukut tua-i ilakluki Yugturrlainaq, Yugtun-llu naaqiyaranek elitnaurluteng."
        },
        "96": {
            "start": 1098.8,
            "end": 1103.18,
            "transcript": "Tau͡gaam sass'am avgani Kass'atun pituluteng."
        },
        "97": {
            "start": 1103.18,
            "end": 1119.88,
            "transcript": "Tua-i-ll' yaani fourth grade-amun tekicameng Kass'atun pituriluki, Yugtun-llu sass'ami ataucimi ernermi piaqluki yaavet twelfth grade-amun high school-amek-wa taqviatnun."
        },
        "98": {
            "start": 1122.0,
            "end": 1138.0,
            "transcript": "Ava-i au͡gna Charles Kass'atuq (Kashatok) LKSD-ni Yugcetun elitnauriyaram arulatestiit cali-llu una John Mark-aq principal-aarat Igmiut elitnaurviatnek kingunerluni, Upay'am apqangssallruagket."
        },
        "99": {
            "start": 1138.0,
            "end": 1148.98,
            "transcript": "Tua-ll' ava-i Maqinermi maani Mamterillermi makut imkut melqulget imarmiutat umyuaqluki caqtaallruut yugyakapiarluteng."
        },
        "100": {
            "start": 1148.98,
            "end": 1153.16,
            "transcript": "Tiissitsaaq aipaa avegluku (500) yuut ilagautellruluteng tuani."
        },
        "101": {
            "start": 1153.16,
            "end": 1167.46,
            "transcript": "Cali KYUK-m tarenrairistait ukut Mike March, Richard Trotter, cali-llu Uquviaq Ollie Andrew, mat'umek tarenrairillermeggnek waniwa nasvakataraatkut."
        },
        "102": {
            "start": 1351.86,
            "end": 1360.24,
            "transcript": "Uksurnaciaran makut-llu kapkaanartet pissurvimegteńun tekitesciigatellruat egmianun."
        },
        "103": {
            "start": 1360.24,
            "end": 1369.42,
            "transcript": "Assirtassiillrunritait makut melqulget tau͡gaam taicugngaaceci December 18-aaq tekilluku kanavet Cutting Edge-aamun."
        },
        "104": {
            "start": 1369.42,
            "end": 1377.72,
            "transcript": "Nutaan tuani December 18-aami assirtassiirciqait nunuliutait cali amllerrartut tayima cikiutekait."
        },
        "105": {
            "start": 1377.72,
            "end": 1390.44,
            "transcript": "Tua-ll' ukut TWC-t arulaciit aipiriluteng allrakumek aturluteng makut umyuaqluki arnat mikelnguut-llu qimalalriit enemeggnek alingluteng."
        },
        "106": {
            "start": 1390.44,
            "end": 1396.12,
            "transcript": "Uumek Napayaarmek ayagaciut. Uum waniwa Upay'am man'a ketvarteqataraa."
        },
        "107": {
            "start": 1406.26,
            "end": 1410.44,
            "transcript": "TWC-m cikiutnek program-aa ayagnillruuq allragni."
        },
        "108": {
            "start": 1410.44,
            "end": 1418.38,
            "transcript": "Qimallret enellgutmeggnek nangtaumallret aanaulrianun mikelngunun Alussistuaqegcisqelluki."
        },
        "109": {
            "start": 1418.38,
            "end": 1423.06,
            "transcript": "Makut cikiutait kingunengqertuq Mamterillermiunek."
        },
        "110": {
            "start": 1423.06,
            "end": 1432.1,
            "transcript": "State trooper-aat tegustet-llu taicillruut nutaranek naanguanek kingunerluteng anguyagtet iliit Marine Corps-anek."
        },
        "111": {
            "start": 1432.1,
            "end": 1445.14,
            "transcript": "Una napayaaq tangnircautengqertuq kalikanek pilinguanek tamarmeng-llu taukut tunuitni qalarutkaqluteng mikelngurnek nasaurlunek wall' tan'gaurlunek."
        },
        "112": {
            "start": 1445.14,
            "end": 1448.98,
            "transcript": "Allrakuitnek camek-llu Alussistuaryullratnek."
        },
        "113": {
            "start": 1448.98,
            "end": 1458.26,
            "transcript": "Wiinga aptellruaqa TWC-m ilii calista Uiyaq Joan Hawk-aq uumek napayaamek qanrutkevsiarqelluta."
        },
        "114": {
            "start": 1458.26,
            "end": 1459.92,
            "transcript": "Waniwa kiutii."
        },
        "115": {
            "start": 1459.92,
            "end": 1475.52,
            "transcript": "Una wani napa maantellret ciungani maantellriit waniwa maantellriit, maantellret-llu ciungani aanat mikelnguut-llu napautekaat."
        },
        "116": {
            "start": 1475.52,
            "end": 1488.98,
            "transcript": "Ingkut yaani ornament-aat atengqertut mikelnguut aanat-llu atritnek, how old qavciuciitnek-llu, canek-llu piyullritnek igaqaumaluteng."
        },
        "117": {
            "start": 1488.98,
            "end": 1504.4,
            "transcript": "Tua-i-ll' wangkuta ayagalluku napa, napacuar tau͡gaam alla ayagalluku, calisteńun pamani yuungcarvigmi wall' allani calisteńun ayagalluku."
        },
        "118": {
            "start": 1504.4,
            "end": 1510.88,
            "transcript": "Ellait-llu tua-i atermek teguqaarluteng cikiutekaanek tauna aanaq wall'u mikelnguq piluku."
        },
        "119": {
            "start": 1510.88,
            "end": 1517.52,
            "transcript": "Kia makut piliaqaki napami uitalriit ornament-aanek pilaqiit?"
        },
        "120": {
            "start": 1517.52,
            "end": 1526.54,
            "transcript": "Maani calistet cetaman piliaqait JV volunteer-at tamarmeng piliaqait."
        },
        "121": {
            "start": 1526.54,
            "end": 1533.76,
            "transcript": "Cikiutengciqluteng piciatun ayuqenrilngurnek mikelnguut arnat-llu cali cikiutengciqluteng."
        },
        "122": {
            "start": 1533.76,
            "end": 1536.04,
            "transcript": "Mamterillermek Upay'augua."
        },
        "123": {
            "start": 1545.26,
            "end": 1549.58,
            "transcript": "Waten-wa tua-i qanemcikaput amllertalriit."
        },
        "124": {
            "start": 1549.58,
            "end": 1551.86,
            "transcript": "Quyana ilagarluta."
        },
        "125": {
            "start": 1551.86,
            "end": 1563.3,
            "transcript": "Uumiku cali, uumiku qanemcinqigeskumta Cetamiritmi, Tallimi' aren, Agayunrutiini Alussistuarciqut."
        },
        "126": {
            "start": 1563.3,
            "end": 1571.7,
            "transcript": "Cali Alussistuartaarluku uumiku qanemciciqukut piciatun makunek Alussistuarturalrianek maani Mamterillermi."
        },
        "127": {
            "start": 1571.7,
            "end": 1573.8,
            "transcript": "Quyana ilagarluta, piurci."
        }
    },
    "Hy8w_2qn0as": {
        "1": {
            "start": 1.18,
            "end": 15.82,
            "transcript": "Maa-i wani una Peter Thompson-aaq pillri qaqiutellrulliniat Aipiritmi maa-i Bethel City Council-aat qanellruut, uumek nunamek 9,000 square feet cikillrulliniat Thompson-aamun."
        },
        "2": {
            "start": 15.82,
            "end": 27.7,
            "transcript": "Una-ll' qaqiulluku nunai Thompson-aam pillri. Assiitellrulliniuq nalluluteng qaill' nunamek ayuqucianek qavcinek allrakunek Thompson-aaq."
        },
        "3": {
            "start": 27.7,
            "end": 38.1,
            "transcript": "Tauna case-aq ayagnillrua enii ekuallrani ukut-llu maani nutaan, I mean, nutaramek nem'ek piliqatullruyaaqaat."
        },
        "4": {
            "start": 38.1,
            "end": 45.28,
            "transcript": "Tau͡gaam elilluteng nunai-gguq tuani uitallra city-m pikellrulliniat."
        },
        "5": {
            "start": 45.28,
            "end": 54.5,
            "transcript": "Tau͡gaam Thompson-aam ilai qanellruut ellait-gguq ciumek tuantellruut, uumek-llu traditional claim-angqerrluteng nunamek."
        },
        "6": {
            "start": 54.5,
            "end": 64.78,
            "transcript": "Cali-llu Council-aata qaqiutellrulliniat una lawsuit-aq, Senator Johnny Binkley-m pillri qanerluteng-llu ataam quyurciiqut June-ami."
        },
        "7": {
            "start": 64.78,
            "end": 81.5,
            "transcript": "Ukut-llu allat Native group-at maani Alaska-mi qalarutengnaqaat interior department-aaq apluki ellait-gguq atengruyugluteng ungungssiitnek uumi federal-aam nunaitni."
        },
        "8": {
            "start": 82.06,
            "end": 92.04,
            "transcript": "Una Tanana Chiefs Conference AVCP-q-llu maani Mamterillermi aptait qalarutut apluki-llu ukut interior department-aat."
        },
        "9": {
            "start": 92.04,
            "end": 98.54,
            "transcript": "Ellaita-wa atengruyugluteng nunaitnek federal land-ani."
        },
        "10": {
            "start": 98.54,
            "end": 111.72,
            "transcript": "una-llu Tanana Chiefs Conference-aamek Fairbanks-aami qanellruuq, makut-gguq Yupiit maani Alaska-mi right-angqerrsaaqut ellait-gguq atengruyugngauluteng."
        },
        "11": {
            "start": 111.72,
            "end": 117.8,
            "transcript": "Uumi 1975-aam Indian Self-Discrimination Act-ami tuaten-gguq qanertuq."
        },
        "12": {
            "start": 117.8,
            "end": 126.9,
            "transcript": "Ukut-llu federal government-aat qanerluteng una fish and wildlife management-aat-gguq ellaita atengrungciqut taumek."
        },
        "13": {
            "start": 126.9,
            "end": 134.5,
            "transcript": "Tauna-llu amlleq una 60% nunam maani Alaska-mi ellaita atengrungluteng."
        },
        "14": {
            "start": 134.5,
            "end": 143.7,
            "transcript": "Maani Yupiit-wa uumek neryaqsaram picirkaitnek piilkata July 1st-aarpailgani."
        },
        "15": {
            "start": 143.7,
            "end": 152.8,
            "transcript": "Una Alaska Supreme Court-at December-aami qanellruut, neryaqsaram-gguq alerquutii assiitellruniluku unconstitutional-aaruluni."
        },
        "16": {
            "start": 152.8,
            "end": 165.98,
            "transcript": "Ukut-llu wani state legislature-aat qaqiutellruut tauna neryaqsaram piarkait piuvailgatgu taumek taum neryaqsaram piarkait piciurteksaituq."
        },
        "17": {
            "start": 165.98,
            "end": 175.64,
            "transcript": "Amllellrulliniut nerangnaqsaram caliaqellerqait uum state legislature-aat maa-i tau͡gaam nallunrilkegput wani piciurteksaitellrai."
        },
        "18": {
            "start": 175.64,
            "end": 192.02,
            "transcript": "Maa-i-llu uunguciitelliniut qaill' ayuq' pillerkait uum subsistence nerangnaqsaram-wa tua-i tungiinun amllerluteng-llu ukut yuut qacuvallamalriit mat'um waniw' legislature-aam pegtellratni caliaqellerkait nerangnaqsaram tungiini."
        },
        "19": {
            "start": 194.42,
            "end": 204.14,
            "transcript": "Egmian-wa tua-i pilaagngailkiit tayima ayuqevkenateng-llu qanaalalriit-am."
        },
        "20": {
            "start": 204.14,
            "end": 214.88,
            "transcript": "Tau͡gaam amllenrukata qanelriit arenqigiluku nerangnaqsaram tungiinun assillerkaa tuaten qaqiuciiquq."
        },
        "21": {
            "start": 214.88,
            "end": 221.84,
            "transcript": "Usviitut wani makut Kass'at wangkuta piciryararput ataniungnaqluku."
        },
        "22": {
            "start": 221.84,
            "end": 237.6,
            "transcript": "Tau͡gaam wangkutnek pingnaqurallerput ataniungnaqevkenaku pikuneng atawaunruciquq wangkuta piciryaraqngamteggu ellaita aipamta makut piciryaraqellrunrilamegteggu ataniungnaqaat."
        },
        "23": {
            "start": 238.22,
            "end": 248.72,
            "transcript": "Fish and Game tau͡ga operate-aarallermegcetun pikassni tayima assirciqsugnarquq."
        },
        "24": {
            "start": 251.68,
            "end": 261.58,
            "transcript": "Ataku-llu qaneryarakegtaani niiciiqliniaput una Ulric Nayamin, allrakunek pingayunek wanigg' unguvanritellrulliniuq wani."
        },
        "25": {
            "start": 261.58,
            "end": 270.34,
            "transcript": "Nayamin-aaq una allrakurtellruuq 78-aarluni tuqu' unguvanrillermini qalarciquq nerangnaqsaram pillratnek."
        },
        "26": {
            "start": 273.8,
            "end": 281.26,
            "transcript": "Waten imkut qaneryaraat imkut tegganret maa-i aturtuq."
        },
        "27": {
            "start": 281.26,
            "end": 291.8,
            "transcript": "Waten kiagmi neqem nalliini neqkameng unangnaqurasqaqkiikut qanrulluta imkut civuliamta."
        },
        "28": {
            "start": 291.8,
            "end": 300.4,
            "transcript": "Qavaryugpegnata neqkameng unangnaqurasqelluta. Imarpik-gguq cacetuqutngunrituq."
        },
        "29": {
            "start": 300.4,
            "end": 316.2,
            "transcript": "Tau͡ga ava-i [?] cacetuqutngunritluni imarpiim tau͡ga elpecinun maa-i mania waten tau͡ga umgucimayumkunikut pissurciiganata umgucimarkaugukut, umgucimarkaugaakut imarpiim."
        },
        "30": {
            "start": 316.56,
            "end": 329.3,
            "transcript": "Cali tau͡ga waten umyugarturallemni imkut cam iliini up'nerkaut kiagucim iliini neqet nurnarqetuut."
        },
        "31": {
            "start": 329.3,
            "end": 337.14,
            "transcript": "Cali tau͡ga imkut taqukaq cali nurnaqluteng cam up'nerkaucim iliini."
        },
        "32": {
            "start": 337.32,
            "end": 344.94,
            "transcript": "Cali imkut tengmiat makut ikgenateng up'nerkaucim iliini tekitnaurtut."
        },
        "33": {
            "start": 344.94,
            "end": 354.04,
            "transcript": "Waten qanyuunateng nangniluni imkut, nangniluki qanyuitellruut kitumeng."
        },
        "34": {
            "start": 354.56,
            "end": 368.96,
            "transcript": "Tau͡gaam iliini taum allrakucim-ll' iliini imkut nurnaunateng pituut neqet-ll' amllerrluteng, qang'a-ll' taqukat amllerrluteng, qang'a-llu tengmiat cali amllerraqluteng."
        },
        "35": {
            "start": 368.96,
            "end": 377.12,
            "transcript": "Tau͡gaten imumi ayuqellruut nangniluki tau͡gaten qanruteksuitelqait."
        },
        "36": {
            "start": 379.24,
            "end": 390.4,
            "transcript": "Nayamin-aaq arvinlegnek mikelngungqellrulliniuq qula estaman tutgararluni malrunek-llu iluperrarluni unguvanrillermini."
        },
        "37": {
            "start": 390.56,
            "end": 398.08,
            "transcript": "Una wani Dallas Sur-aaq [?] one hundred dollars pingellrulliniuq maani Kilbuck School-ami unuamek."
        },
        "38": {
            "start": 398.08,
            "end": 410.1,
            "transcript": "Amlleret-gguq mikelngut maani Alaska-mi una poster essay contest-aamek pillrulliniut una United States Department of Immigration and Naturalization."
        },
        "39": {
            "start": 410.1,
            "end": 421.56,
            "transcript": "Taukut aptellrui mikelnguut igasqelluki qaill' ellaita ayuqellriit maani America-mi qaill'-llu assikellrit America-m pillritnek."
        },
        "40": {
            "start": 421.58,
            "end": 429.76,
            "transcript": "Sur-aq [?] wani 6th grade-aaruuq [?]-aaq elitnauristenguuq taumek Sur-amek."
        },
        "41": {
            "start": 429.76,
            "end": 443.56,
            "transcript": "50,000-aat mikelnguut tuani maaken region-aatnek America-mi tuavet pillrulliniut una-llu Sur-aq akimiarurtelluni qaqiutellrani."
        },
        "42": {
            "start": 447.36,
            "end": 462.48,
            "transcript": "Ukut waniw' tua-i whaling captain-aat, wanigg' whaling captain Burton-aaq wanigg' Barrow-mi whale-aatulit agutellrulliniat nunacuaraat ciuqlirmek tuqucilqemnek makunek whale-anek maa-i."
        },
        "43": {
            "start": 462.48,
            "end": 471.3,
            "transcript": "Alaska Eskimo Whaling Commission-aaq qanlliniut ukut-gguq whale-at akwaugaq tegurciullrulliniut yaaqsigtaluteng five miles."
        },
        "44": {
            "start": 471.32,
            "end": 480.56,
            "transcript": "Ukut-wa Barrow-q fifteen-anek-wa tua-i pillrullinilriit wall'u-q' pillerqaitnek pingqellrulliniut makunek whale-anek tegucillerqaitnek."
        },
        "45": {
            "start": 480.56,
            "end": 491.88,
            "transcript": "Wainwright-aq maa-i-wa malrugnek whale-anek tegutellrulliniut, ukut-llu nunacuarat Point Hope-ami arvinlegnek-wa tua-i strike-angqellrulliniut wall'u-qaa chance-assaarluteng."
        },
        "46": {
            "start": 491.88,
            "end": 497.14,
            "transcript": "Tau͡gaam ataucirraarmek wani commissions reserve account-amek pingellrulliniut."
        },
        "47": {
            "start": 497.24,
            "end": 511.04,
            "transcript": "VPSO-mi McGrath-amek ukut qanrutellrulliniat maani Alaska-m state trooper-aat maani Mamterillermi una arnaq, Martha Gregory seventy one allrakungqellria tuqullrulliniuq."
        },
        "48": {
            "start": 511.04,
            "end": 527.64,
            "transcript": "Tau͡gaam tuqullri nalluit tuar tau͡gaam kia tuqutellrunritluku temaa Anchorage-aamun ayautellruat iinrivigmun tangesqelluku qaill' tuqellrinek pillri."
        },
        "49": {
            "start": 533.76,
            "end": 543.8,
            "transcript": "Una wanigg' cetuqupak wanigg', 35-aam tua-i-wa 35 foot cetuqupak wanigg'."
        },
        "50": {
            "start": 543.8,
            "end": 552.96,
            "transcript": "Wavet tidal channel-aami kiatmun mayallrulliniut 25 miles, Naknek River-aami King Salmon-aaq-gguq caniani."
        },
        "51": {
            "start": 552.96,
            "end": 564.08,
            "transcript": "State wildlife biologist Dick Sellers qanellruuq tamakut-gguq cetuqupat alarrluteng-gguq caqirtellrulliniut maaggun agyiirtellermeng."
        },
        "52": {
            "start": 564.08,
            "end": 571.72,
            "transcript": "Ukut calitulit wanigg' cetuqupak alingutliniat wanigg' ataam tuavet imarpigmun pingaitnayukluki."
        },
        "53": {
            "start": 571.72,
            "end": 582.56,
            "transcript": "Ukut wanigg' calistet cali qanertut cetuqupak ciuqlimek-gguq maqinermi pugellrulliniuq kiatmurceciigaliluni-llu."
        },
        "54": {
            "start": 582.68,
            "end": 595.34,
            "transcript": "Sellers-aat cali ilait wanigg' official-aat umyuarteqengnaqut qaillun una cetuqupak augutelleraitni imarpigmun Sellers-aaq cali qanerluni una cetuqupak wanigg'."
        },
        "55": {
            "start": 595.34,
            "end": 604.08,
            "transcript": "Tua-i-gga ulellermini wanigg' piugmallrullinikii tau͡gaam uitauraciqliniuq, uitaurartuq."
        },
        "56": {
            "start": 604.08,
            "end": 607.56,
            "transcript": "Quyana ilagarlunuk atakurpak. Piurci."
        }
    },
    "akTuEB0w1aY": {
        "1": {
            "start": 2.3,
            "end": 8.99,
            "transcript": "Piuresqelluta qaillun-kiq piat wanirpak? Amlleret upingaut apyuteten kiuyugngaluki."
        },
        "2": {
            "start": 8.99,
            "end": 15.81,
            "transcript": "Ayuqeltalliugutkiciki cucukeltessallermeggni akqutait kalikaitnun."
        },
        "3": {
            "start": 15.81,
            "end": 20.23,
            "transcript": "Cali elliitulit ellaitnun allat-llu cali amlleret."
        },
        "4": {
            "start": 20.23,
            "end": 23.51,
            "transcript": "Ikayurcetaarnariut akiituut."
        }
    },
    "W018Whbyq0w": {
        "1": {
            "start": 62.24,
            "end": 70.84,
            "transcript": "Uumi agayuviit Juneau-mi apervikuallruit yut'eng tamakurmiut."
        },
        "2": {
            "start": 70.84,
            "end": 80.0,
            "transcript": "Taqevkallrit pitekluki tamakurmiut yuut piciryarait qaneryarait-llu."
        },
        "3": {
            "start": 80.02,
            "end": 95.08,
            "transcript": "Maani cali Kuigpiim Kusquqviim iluani apyutngukut [?], makut-gguq agayuviit apervikualitki yuut cali cagmarcetellrit piciryarait pitekluki."
        },
        "4": {
            "start": 95.08,
            "end": 101.0,
            "transcript": "Man'a qalarutkeqataraput atakurpak."
        },
        "5": {
            "start": 132.0,
            "end": 135.9,
            "transcript": "Waqaa, Aqum'augua. Quyana ilagaqatarlua atakurpak."
        },
        "6": {
            "start": 135.9,
            "end": 140.96,
            "transcript": "Man'a ketvarteqataraput kangingnaurluku-llu apyun."
        },
        "7": {
            "start": 140.96,
            "end": 155.18,
            "transcript": "Makut-gguq-qaa agayuviit apervikualitki yuut ak'a tamaani piciryarait qanrutkelallrit pitekluki, arulaircetellrit-llu pitekluki."
        },
        "8": {
            "start": 155.18,
            "end": 163.7,
            "transcript": "Ciumek tau͡gaam qaillun ayagnillruat ak'a tamaani makut agayuviit."
        },
        "9": {
            "start": 163.7,
            "end": 176.14,
            "transcript": "1800-aat iquatni agayumaciik malruk, Moravian-aat Kass'alugpiat-llu, agayumaciteng ayagnillruit avatemteńi."
        },
        "10": {
            "start": 176.14,
            "end": 192.42,
            "transcript": "Kass'alugpiat agayumaciat Nushagak-em avatiini piurtellruuq, Moravian-aat-llu Kusquqviim avatiini Mamterillermi."
        },
        "11": {
            "start": 192.42,
            "end": 200.5,
            "transcript": "Kinguatgun allat agayumaciteng allat-llu allanret tekitengellruut."
        },
        "12": {
            "start": 200.5,
            "end": 207.96,
            "transcript": "Allanret ilait piciryarateng cayarateng-llu yugnun nasvallruit."
        },
        "13": {
            "start": 207.96,
            "end": 213.82,
            "transcript": "Ilait nutarat piciryarat ikayuutngullruut yugnun."
        },
        "14": {
            "start": 213.82,
            "end": 222.16,
            "transcript": "Cukacarluku tau͡gaam cagmallrat yuut piciryarait cayarait-llu."
        },
        "15": {
            "start": 222.16,
            "end": 228.78,
            "transcript": "Iirutengqurturaraqelriit cayarameggneng tua-ll' tau͡gaam umyuarteqenglua,"
        },
        "16": {
            "start": 228.78,
            "end": 238.72,
            "transcript": "caneng iiqumtuarluta piaqamta kitumun tangesqevkenata piaqamta, tauna calput assiituq."
        },
        "17": {
            "start": 238.72,
            "end": 246.22,
            "transcript": "Tua-ll' umyuarteqenglua al'rrakuni cayaraput wangkuta qaneryaraput-llu assiicukluku."
        },
        "18": {
            "start": 246.22,
            "end": 256.84,
            "transcript": "Assiicukliaqamteki wangkuta iciw' cayaraput cakneq amaggun assiilliqtuuq."
        },
        "19": {
            "start": 256.84,
            "end": 269.44,
            "transcript": "Alaska-q iluarrluku agayuviit ayuqenrilnguut amlleret yuut cagmarcetellruit piciryarait, cayarait, ukverit-llu."
        },
        "20": {
            "start": 269.44,
            "end": 276.94,
            "transcript": "Tau͡gaam Kurt Vit-aq [?] qanertuq Moravian-aat watnallrunritniluki."
        },
        "21": {
            "start": 280.66,
            "end": 293.56,
            "transcript": "Doctor Kurt Vit-aq piuq, \"Qanrucugngaamci watqapik igaucimanrituq naliit Moravian-aat agayulirtait, ilakluku John Kilbuk-aaq, qanellrunritut,"
        },
        "22": {
            "start": 293.56,
            "end": 303.02,
            "transcript": "'Wangkutni agayumayukuvci yuuyaraci wall'u yuraryaraci ciumek pegciiqaci.'\""
        },
        "23": {
            "start": 303.02,
            "end": 309.62,
            "transcript": "Iliit qanemyugutiit amlleret yuut agayuvignun ellimalria uunguuq,"
        },
        "24": {
            "start": 309.62,
            "end": 316.54,
            "transcript": "\"Arulaircetellruit yuraryarait yuut amllerni nunani.\""
        },
        "25": {
            "start": 316.54,
            "end": 335.24,
            "transcript": "Ciuqliq agayuvik au͡g'aricetaalleq yugnek negeqlirmi up'nerkaq Kaatulit allgiliyaat Michael Kenny-m arulatellrua cali Juneau-mi arulatellruluku."
        },
        "26": {
            "start": 335.24,
            "end": 343.88,
            "transcript": "Tuakenirnek allat cali ayuqenrilnguut agayuviit au͡g'aricetaangellruut."
        },
        "27": {
            "start": 343.88,
            "end": 351.54,
            "transcript": "Cagmarcetellrit yuut ayuqenrilnguut piciryarait pitekluku."
        },
        "28": {
            "start": 351.54,
            "end": 362.5,
            "transcript": "Wangni-wa agayumaciq, agayumacim piciryararput navegyugnganritaa."
        },
        "29": {
            "start": 362.5,
            "end": 367.88,
            "transcript": "Mat'um ukveryaram Agayutmun nutaram navegyugnganritaa."
        },
        "30": {
            "start": 367.88,
            "end": 384.0,
            "transcript": "Tau͡gaam imkut cayaraput piciryaraput, man'a kenkucaraq, ilakucaraq, allat-llu im'utun pinirtellriatun pia."
        },
        "31": {
            "start": 384.0,
            "end": 392.92,
            "transcript": "Cali-llu akaurtellria maa-i agayumacim waten mat'um tekitellra."
        },
        "32": {
            "start": 392.92,
            "end": 406.02,
            "transcript": "Aipaagni akaurcan maa-i tua-i piciryaraqengamegteggu-llu ukveryaraq man'a Agayutmun, piciryaraqengamegteggu ellaita teguluku yuut."
        },
        "33": {
            "start": 406.02,
            "end": 415.7,
            "transcript": "Apervikuakata agayuviit, camek piciiciiqsugnarqut."
        },
        "34": {
            "start": 415.7,
            "end": 421.84,
            "transcript": "Kaatulit agayulirtiit tunglia It'gaq Bob Aloysius piuq,"
        },
        "35": {
            "start": 421.84,
            "end": 438.42,
            "transcript": "\"Qaillun umyuartuqengraata yuut mat'um tungiinun, qalarutkesqelluku ilameggnun yugnikek'ngameggnun-llu umyuateng mat'um tungiinun nallunaircelluku.\""
        },
        "36": {
            "start": 445.24,
            "end": 449.14,
            "transcript": "Quyana ataam ilagarluta, Aqum'augua."
        },
        "37": {
            "start": 449.14,
            "end": 454.8,
            "transcript": "Waniwa ayagniqatartukut apyutput-llu ava-i taringellruluku."
        },
        "38": {
            "start": 454.8,
            "end": 463.3,
            "transcript": "Ciumek ukut waniwa ilagaqput ellmeggnek kituuciteng apqataraat."
        },
        "39": {
            "start": 463.3,
            "end": 468.62,
            "transcript": "Ciumek, Bob. Yugcetuqapiar."
        },
        "40": {
            "start": 468.62,
            "end": 472.64,
            "transcript": "Wiinga-wa ciuqliq atqa Sliksuuyaulria."
        },
        "41": {
            "start": 472.64,
            "end": 477.68,
            "transcript": "Uum maurlum Aqum'am anglicallruanga."
        },
        "42": {
            "start": 477.68,
            "end": 490.72,
            "transcript": "Aanaka-wa Taitauraulria Paimek kingunengqerrluni. Apa'urluqa-llu aatii Tengluilnguq."
        },
        "43": {
            "start": 490.72,
            "end": 498.86,
            "transcript": "Yaa, wiinga Angalgamek pilaraatnga maani, cali Kuigpagmiungulrianga."
        },
        "44": {
            "start": 498.86,
            "end": 503.56,
            "transcript": "Ataka Aiggailnguullruuq, aanaka-llu Nurauq."
        },
        "45": {
            "start": 503.56,
            "end": 512.46,
            "transcript": "Aiggailnguq una Kuigpagmiungullruuq Neqlercurvigmek kingunerluni, aanaka-llu unaken Askinamek kingunerluni."
        },
        "46": {
            "start": 513.48,
            "end": 521.66,
            "transcript": "Wii Tacuk'augua Ulruan Pania. Cev'armiunguunga."
        },
        "47": {
            "start": 521.66,
            "end": 524.58,
            "transcript": "Wiinga-llu Kumangulria."
        },
        "48": {
            "start": 524.58,
            "end": 539.9,
            "transcript": "Ukuk aanaka, kituulria, aataka-llu Augutaq."
        },
        "49": {
            "start": 539.9,
            "end": 550.08,
            "transcript": "Aanaka-llu, atra tua-i nalluyagutelliniaqa."
        },
        "50": {
            "start": 550.08,
            "end": 554.36,
            "transcript": "Wiinga Tuunralguunga."
        },
        "51": {
            "start": 554.36,
            "end": 570.58,
            "transcript": "Apa'urluirutengqertua. Apa'urluirutema [?] Ten'garull', Ten'gaumek [?] pilallruat, ataka Anguturluq, aanaka-wa Aanamek-wa pilaqiit Yugcetun aterkaitellrian."
        },
        "52": {
            "start": 570.58,
            "end": 579.94,
            "transcript": "Wiinga Caninermiunguunga. Angayuqaagka-wa Uliggaq Atak'iller [?] tayim' ak'a catairutellruuk."
        },
        "53": {
            "start": 579.94,
            "end": 586.88,
            "transcript": "Tua-ll' cimek ayagniulluku man'a atakurpak qalarutqatarput."
        },
        "54": {
            "start": 586.88,
            "end": 594.72,
            "transcript": "Ciumek Sliksuuyaq, qaillun umyuarteqsit mat'um tungiinun apyutem?"
        },
        "55": {
            "start": 594.72,
            "end": 606.76,
            "transcript": "Agayuviit-qaa yuut maani Kuigpiim Kusquqviim-llu iluani apervikualitki wall'u-qaa au͡g'arillitki, apervikualitki?"
        },
        "56": {
            "start": 606.76,
            "end": 620.14,
            "transcript": "Wiinga-wa umyuarteqlemkun waten Seattle-ami wall'u Juneau-mi ukut agayuviit apervikuangermeng yugnun,"
        },
        "57": {
            "start": 620.14,
            "end": 632.38,
            "transcript": "tuarpiaq wangkuta maani Kuigpagmi Kusquqvagmi-llu ceńami-llu ilakevkenata tuaten pilriit."
        },
        "58": {
            "start": 632.38,
            "end": 659.4,
            "transcript": "Taumek wiinga umyuamkun waten ellaita tamakut agayuviit elluarrluteng apervikuayukuneng yum'eggnek taivkariluteng makunun nunacuarnun nutaan apervikuakuneng nutaan tamana apervikualteng nutaan piciuciquq."
        },
        "59": {
            "start": 659.4,
            "end": 664.6,
            "transcript": "Wiinga-ll' kiimetenritua waten umyuarteqlemni."
        },
        "60": {
            "start": 664.6,
            "end": 669.12,
            "transcript": "Angalgaq, qaillun-mi umyuarteqsit mat'um apyutem tungiinun?"
        },
        "61": {
            "start": 669.12,
            "end": 684.98,
            "transcript": "Yaa, wiinga-wa umyuamni tamana arcaqalria uum Bob-am qanellra tungaunaki tua-i yuut wani maani nunacuarni ullagluki wall'u quyurvakata qanrutnaqsaaqai tungaunateng."
        },
        "62": {
            "start": 684.98,
            "end": 692.1,
            "transcript": "Tuaten yaaqvanek ping'e'rmeng wani tau͡gaam piciulriatun ayuqenrituq."
        },
        "63": {
            "start": 692.1,
            "end": 697.76,
            "transcript": "Tua-i tangvallruamku tamaani miklua qaillun auluk'lallrit."
        },
        "64": {
            "start": 697.76,
            "end": 705.94,
            "transcript": "Tua-i-wa assilriamek amllermek cikingermegtekut wani tau͡gaam yuucirput amllermek wani ilangarterpagluku."
        },
        "65": {
            "start": 705.94,
            "end": 713.9,
            "transcript": "Akngirrluki yuuciput pillruata tua-i tungaunaki qanresqumayaaqluki yugnun wiinga umyuartequa."
        },
        "66": {
            "start": 713.9,
            "end": 717.18,
            "transcript": "Ii-i, Tacuk'aq?"
        },
        "67": {
            "start": 717.18,
            "end": 721.96,
            "transcript": "Wii-ll' cali ukuk civuqlima cali qanellritun umyuaqa ayuquq."
        },
        "68": {
            "start": 721.96,
            "end": 731.36,
            "transcript": "Cal' agayuviit makut tungaunateng cali nunarnun agluteng pinqigcuumirauteteng paivcilluki."
        },
        "69": {
            "start": 731.36,
            "end": 746.58,
            "transcript": "Tawa-ll' tawaten pinginarpegnateng tau͡gaam ikayurluta au͡gkut cayaraqegtaaraput pugcilluki agayuvignun-ll' piciatun ilaksagulluki."
        },
        "70": {
            "start": 746.58,
            "end": 749.6,
            "transcript": "Kumangulria, qaillun-mi elpet umyuaqsit?"
        },
        "71": {
            "start": 749.6,
            "end": 760.7,
            "transcript": "Avani ciuqliit agayulirtet tekiteqarrallermeggni taringvailegmeng man'a piciryararput caunrilkellrulliniat."
        },
        "72": {
            "start": 760.7,
            "end": 766.14,
            "transcript": "Amta-llu cangallruvkenateng maa-irpak taringnaulriani."
        },
        "73": {
            "start": 766.14,
            "end": 775.42,
            "transcript": "Makut-llu apqat [?] aperlallrit Agayun [?] wangkuta ciuliamta ungalegmek pitullrullinia."
        },
        "74": {
            "start": 775.42,
            "end": 777.5,
            "transcript": "Man'a cali angalkuq."
        },
        "75": {
            "start": 777.5,
            "end": 781.58,
            "transcript": "Imkucicetun prophet-aacetun ayuqellriarullrulliniuq."
        },
        "76": {
            "start": 781.58,
            "end": 785.34,
            "transcript": "Tau͡gken una tuunralek assinrilnguuvkenani."
        },
        "77": {
            "start": 785.34,
            "end": 793.9,
            "transcript": "Angalkuq una yugnek tau͡gaam ikayuringnaqellriaruyaaqellrulliniuq tau͡gaam assiilluku aprumaluku."
        },
        "78": {
            "start": 793.9,
            "end": 796.0,
            "transcript": "Ii-i, Tuunralek."
        },
        "79": {
            "start": 797.76,
            "end": 801.42,
            "transcript": "Nuu, ak'alliilkekinga [?]."
        },
        "80": {
            "start": 801.42,
            "end": 814.28,
            "transcript": "Tau͡gaam wiinga-w' tua-i ukutgun elitnaurumacimteggun wall'u-llu seminary-mi elitnaulartukut."
        },
        "81": {
            "start": 814.28,
            "end": 836.18,
            "transcript": "Cali-llu kiingan tuani pivkenaku tau͡gaam wangkuta agayumacimteńi yuvriararaqamku wall'u-llu naaqellemku elitnaurvimteggun elitnaullemteńun taringua, tauna tarinelqa aturluku."
        },
        "82": {
            "start": 836.18,
            "end": 851.38,
            "transcript": "Tayima una wani agayuvigput wall'u-llu ciuliat au͡gkut taillret maavet agayuviim mat'um ukvermek taiciluteng, qaneryaramek taiciluteng."
        },
        "83": {
            "start": 851.38,
            "end": 857.14,
            "transcript": "Taukut wangni tangvallemni."
        },
        "84": {
            "start": 857.14,
            "end": 867.92,
            "transcript": "Mat'umek tua-i apqemteńek apologize-aryaramek apologize-anarqellriamek wangni pitalngat'lartuq."
        },
        "85": {
            "start": 867.92,
            "end": 873.7,
            "transcript": "Ellait-wa tua-i tekicameng maavet Yugcetun qaneryaurtengnaqellruut."
        },
        "86": {
            "start": 873.7,
            "end": 877.76,
            "transcript": "Qanturiameng tau͡gaam nutaan qaneryaraq qalarutekluku."
        },
        "87": {
            "start": 877.76,
            "end": 890.1,
            "transcript": "Cali-llu kitumek, kitumek-wa tua-i nunuqengellrat nalluaqa tau͡gaam ellait nangteqluteng qaneryariulallruut."
        },
        "88": {
            "start": 890.1,
            "end": 896.94,
            "transcript": "Callerkuaq, elpet-mi qaillun umyuaqsit mat'um apyutem tungiinun?"
        },
        "89": {
            "start": 896.94,
            "end": 901.1,
            "transcript": "Au͡g'aricetaarluteng-qaa agayuviit pillerkaat?"
        },
        "90": {
            "start": 901.1,
            "end": 914.72,
            "transcript": "Wiinga umyuarteqlemni taringumassiyaanritaqa ciin wani au͡g'aricetaararkaullrat tamakut agayuviit yugnun."
        },
        "91": {
            "start": 914.72,
            "end": 933.94,
            "transcript": "Ukanirpak-wa wiinga mik'nii [?] un'gani Caninermi agayulirtet ilakluki angllillruyaaqngama niiteqaqsaunii-llu canek tamakunek agayulirteńek waten makut piciryaraput taqesqelluki."
        },
        "92": {
            "start": 933.94,
            "end": 940.7,
            "transcript": "Cali apqalaryaaqluki ilait tegganret camek."
        },
        "93": {
            "start": 940.7,
            "end": 948.5,
            "transcript": "Arenqiallugutnek au͡g'aricetaallerkaatnek-llu tamatum tungiinun niiteksaitua."
        },
        "94": {
            "start": 948.5,
            "end": 956.92,
            "transcript": "Cali wangni wiinga umyuaqellemni tuar tang tua-i-w' pinarqenrilnguq."
        },
        "95": {
            "start": 956.92,
            "end": 965.28,
            "transcript": "Au͡g'aricetaarnarqenrilnguut tua-i-w' agayulirtet yugnun."
        },
        "96": {
            "start": 965.28,
            "end": 971.5,
            "transcript": "Ii-i, Sliksuuyaq."
        },
        "97": {
            "start": 971.5,
            "end": 982.68,
            "transcript": "Au͡g'um-qaa qanqallra ava-i kiuqeryuumitan ciin yuut au͡g'aritnarqat?"
        },
        "98": {
            "start": 982.68,
            "end": 998.34,
            "transcript": "Au͡g'aritnarqellriit-wa wangni umyuamku waten tangvallruamki-llu ayuqucillrit makut ciuqliit maavet taillret agayuvignek kingunelget."
        },
        "99": {
            "start": 998.34,
            "end": 1017.2,
            "transcript": "Taringenrilameng man'a wangkuta elluarrluni man'a yuuyaraput taringenrilamegteggu qaillun-llu kangia ayuqucianek taringenrilameng caunrilkellruat alikluku-llu."
        },
        "100": {
            "start": 1017.2,
            "end": 1042.9,
            "transcript": "Cali waten makut angalkukegtaarat, yuut ikayurtait, umyuamegteggun, ircaqumegteggun, qaimegteggun, anernemegteggun-llu yuut waten arenqiallugtaqata waten makut angalkuut ikayulallrukait."
        },
        "101": {
            "start": 1042.9,
            "end": 1048.22,
            "transcript": "Waten tamana-ll' tua-i taringenrilamegteggu caunrilkellruat."
        },
        "102": {
            "start": 1048.22,
            "end": 1053.28,
            "transcript": "Amta-llu wangkuta yup'ut yuk'egtauraqapiarluteng."
        },
        "103": {
            "start": 1053.28,
            "end": 1070.62,
            "transcript": "Alerquutait atam yuvriquvciki waken qaneryaramek, qaneryaraq kingunengqellria Agayutmek, qaneryaram-ll' iluani waten yuuyaramek ilangqerrluni."
        },
        "104": {
            "start": 1070.62,
            "end": 1077.84,
            "transcript": "Tamalkuita tua-i yuuyarat elluarrluki atulallruit wangkuta yup'ut."
        },
        "105": {
            "start": 1077.84,
            "end": 1101.94,
            "transcript": "Man'a tau͡gken nutaan waten akmaken tailriit agayuvigmek agayuyaramek-llu taicilriit taringenrilamegteggu tua-i egmian arulaingnaqellruat man'a wangkuta elluarrluku yuuyaraput."
        },
        "106": {
            "start": 1101.94,
            "end": 1113.72,
            "transcript": "Cali waten angliurallemni [?] mikelnguulua ukut maurluma ilain kenkepiarallruatnga."
        },
        "107": {
            "start": 1113.72,
            "end": 1116.8,
            "transcript": "Nallunritqapiaraqa tamana."
        },
        "108": {
            "start": 1116.8,
            "end": 1123.86,
            "transcript": "Wiinga aataileng'e'rma aanaileng'e'rma-llu, tamana cakellrunritaat."
        },
        "109": {
            "start": 1123.86,
            "end": 1130.38,
            "transcript": "Yuuciqa tau͡gaam atqa-llu tauna tua-i pirpak'lallruat."
        },
        "110": {
            "start": 1130.38,
            "end": 1135.06,
            "transcript": "Tamana pitekluku elluarrlua tua-i anglivkangnaqellruatnga."
        },
        "111": {
            "start": 1135.06,
            "end": 1145.74,
            "transcript": "Wani tau͡gken nutaan tuarpiaq qecuumalrianga waten uitallemnek, yaavet-llu mission-aanun eklua."
        },
        "112": {
            "start": 1145.74,
            "end": 1152.74,
            "transcript": "Tuani tuar nutaan ayuquciqa man'a nunaka-llu ulpiarrluni ayuqellrulria."
        },
        "113": {
            "start": 1152.74,
            "end": 1156.06,
            "transcript": "Cangayuutenka tua-i amlleqapiartut."
        },
        "114": {
            "start": 1156.06,
            "end": 1161.46,
            "transcript": "Tamaani tua-i elitellruulrianga watua kasnguyugnermek."
        },
        "115": {
            "start": 1161.46,
            "end": 1167.42,
            "transcript": "Man'a-llu umyuaqegtaaralalqa tua-i caunrirluni."
        },
        "116": {
            "start": 1167.42,
            "end": 1176.8,
            "transcript": "Alarcuirullrua tau͡gaam iquklingqellriamek tuarpiaq niitengelrianga tau͡gaam."
        },
        "117": {
            "start": 1176.8,
            "end": 1190.44,
            "transcript": "Cali qenertem̄ek, umyuarniurnermek, iluteqlermek, cangayugmek-llu tua-i elitellrulrianga tamaani uitallemni."
        },
        "118": {
            "start": 1190.44,
            "end": 1195.06,
            "transcript": "Elluarrlua taukut aulukellrunrilaatnga."
        },
        "119": {
            "start": 1195.06,
            "end": 1202.86,
            "transcript": "Amlleret-llu mikelnguut, wangni-llu mikenrulriit, tua-i elluarrluki aulukellrunritait."
        },
        "120": {
            "start": 1202.86,
            "end": 1218.0,
            "transcript": "Amta-llu ukut waten mission-aani qanaanaurtut, wall' agayulirtet manassenkaat -llu, kenkem̄ek mat'umek tua-i cingumarrlainarluteng, amta-llu ayuquciit tuaten ayuqevkenani."
        },
        "121": {
            "start": 1218.0,
            "end": 1227.52,
            "transcript": "Taumek wiinga kiimetenritua tuaten waten ayuquciqa."
        },
        "122": {
            "start": 1227.52,
            "end": 1233.56,
            "transcript": "Kiimetellrunritua-llu waten ilangqellruunga amllernek."
        },
        "123": {
            "start": 1233.56,
            "end": 1239.88,
            "transcript": "Maa-i cali nagutekaat cakneq, arenqaillugutekluku-ll' tamana."
        },
        "124": {
            "start": 1239.88,
            "end": 1245.82,
            "transcript": "Angalgaq-qaa, elpet-mi qaillun tamana qanruteksarciu?"
        },
        "125": {
            "start": 1245.82,
            "end": 1266.46,
            "transcript": "Tua-i-wa wiinga-llu tangvallruama angliyugallemni makunek temirteńek nunalgutemnek wani waten makut agayulirtet wani aulukellratki qanaataqluki canek makunek piciryaraitnek yuut assiilngurmun tau͡gaam ayaumaniluki."
        },
        "126": {
            "start": 1266.46,
            "end": 1269.92,
            "transcript": "Amta-llu taringumavkenaki ellaita."
        },
        "127": {
            "start": 1269.92,
            "end": 1279.22,
            "transcript": "Umyuameggnek umyuartequrallermeggnek kamakurallermeggnek iqulirluki yugnun niicetnaurait yuut piciryaraat."
        },
        "128": {
            "start": 1279.22,
            "end": 1290.8,
            "transcript": "Tau͡gaam tamakut tegganret yuut wani ukverumapiggluteng ukverumallruut camun [?] imumun pinilriamun tua-i-wa-llam pikestiinun."
        },
        "129": {
            "start": 1290.8,
            "end": 1297.62,
            "transcript": "Tua-i makut-llu ungungssit tamalkuita ella-llu meq-llu tamalkuan pikluku."
        },
        "130": {
            "start": 1297.62,
            "end": 1314.68,
            "transcript": "Tua-i qigcikpiarluku epsuqluki-llu [?] makut cikiutai ungungssit tamaa-i tua-i imarpigmiutaat nunamiutaat-llu tuaten tuvqakaqluki-llu allanruaqata waten pitauluteng allaneqellriacetun aulukaqluki."
        },
        "131": {
            "start": 1314.68,
            "end": 1326.44,
            "transcript": "Tua-i real spirituality, waten man'a wani qamaggun ircaqukun Agayutem mallga [?] wani tua-i malkapiaraumallruyaaqaat."
        },
        "132": {
            "start": 1326.44,
            "end": 1337.64,
            "transcript": "Tau͡gaam cali maa-i tamana wani yuut amlleq wani avaliqsaaqaat mallgucaraq yugnun ellamegteńun-llu tamiinun."
        },
        "133": {
            "start": 1337.64,
            "end": 1350.4,
            "transcript": "Tau͡gaam nutaqsilriit amlleret wani tamana nalluyagutaat makut ciuqliit agayulirtet wani tua-i-wa caunrilkevakaitki."
        },
        "134": {
            "start": 1350.4,
            "end": 1368.9,
            "transcript": "Tua-i tamakut wani ak'allaat qanaatekvakayuirutait maa-i ilakellriani waten elicauteksuunaki-llu mikcuarnun makunun wani qigcikumasqelluki makut wani ungungssit avataitni ellarpak man'a avatemteńi."
        },
        "135": {
            "start": 1368.9,
            "end": 1374.68,
            "transcript": "Cali makut elicarateng wani quyungqallriit ataucim piani."
        },
        "136": {
            "start": 1374.68,
            "end": 1381.74,
            "transcript": "Tua-i cakneq wani kellut'lallrukait qaneryarait aturcetenritengnaqluku."
        },
        "137": {
            "start": 1381.74,
            "end": 1389.24,
            "transcript": "Cali Kass'aturrlainaq qanaasqelluki, nunurciraqluteng Yugtun qanaarluteng piaqameng."
        },
        "138": {
            "start": 1389.24,
            "end": 1398.7,
            "transcript": "Wall'u cali arnat wall'u tan'gaurluut wani waten mallguuruceteksaunaki [?] cali."
        },
        "139": {
            "start": 1398.7,
            "end": 1410.74,
            "transcript": "Anagulluki-wa tua-i yuut ilaliurutengqengraata ayagmek wani avvucimavkarluki nallulriacetun tua-i ilaliuruceteksaunaki-llu."
        },
        "140": {
            "start": 1410.74,
            "end": 1423.78,
            "transcript": "Agayunerni tau͡gaam tua-i ceńingqacuaqautestaqluki [?] unuakumi tamaani qulni kaugaqan tua-i tamaavet apiatarneriqatallranun."
        },
        "141": {
            "start": 1423.78,
            "end": 1434.22,
            "transcript": "Tua-i waten quyurautaqata-llu iliini wani nunurciqluteng tamakut nasaurluut pilallrulriit anagutniluki."
        },
        "142": {
            "start": 1434.22,
            "end": 1447.7,
            "transcript": "Waten iluliurucaraq wall'u nuliacungaliurucaraq tamana yuuciqngamegteggu waten kenkulluteng mallgulluteng yuuyaraat wani tamana navgurmillruat qaneryaraa."
        },
        "143": {
            "start": 1447.7,
            "end": 1450.94,
            "transcript": "Cali makut wani quyurtaaryarat."
        },
        "144": {
            "start": 1450.94,
            "end": 1458.34,
            "transcript": "Allanek nunanek wani invite-ariluteng taivkaryluteng quyalalriit Thanksgiving-alriacetun."
        },
        "145": {
            "start": 1458.34,
            "end": 1475.4,
            "transcript": "Aruqluteng neqkanek canek Christmas-aarluteng tuaten, tuaten ayuq'lallruut Thanksgiving tamakut wani waten makut agayunerpiit ayuquciit maliggluki wani tuaten piurlallruyaaqait."
        },
        "146": {
            "start": 1475.4,
            "end": 1481.7,
            "transcript": "Tau͡gaam tamana tuunrangayagmun-llu ayaumaniluku taqevkallrukiit."
        },
        "147": {
            "start": 1481.7,
            "end": 1491.44,
            "transcript": "Maa-i nunalget-llu tanglaranka unani ceńami yurarciiganateng tamakunek piciryarallermeggnek aturciiganateng."
        },
        "148": {
            "start": 1491.44,
            "end": 1496.32,
            "transcript": "Tua-i piciryarateng tamana tamaqapiarluku."
        },
        "149": {
            "start": 1496.32,
            "end": 1507.9,
            "transcript": "Tua-i tamana assirluni yuuyaraq mikelnguut-llu waten camek pitqarraarqata wall' nasaurluurteqarraarqata celebrate-arluteng tua-i."
        },
        "150": {
            "start": 1507.9,
            "end": 1520.0,
            "transcript": "Quyurvagluteng anglaniluteng pilallruut celebrate-arluku tauna angliyualria assilivkarluku ilakliulluku."
        },
        "151": {
            "start": 1520.0,
            "end": 1537.4,
            "transcript": "Tacuk', angliriurallerpeni taringellruan-qaa agayuviim ayuqucia, qaillun-llu agtuumallrua elpenun yug'ulriami?"
        },
        "152": {
            "start": 1537.4,
            "end": 1550.8,
            "transcript": "Tamaani wii miktellemni qayutun im' al'rrakungqellrulua, maybe tallimaneng al'rrakungqellrulua, kinguqlikacarmeng kingunemni kalukallruut."
        },
        "153": {
            "start": 1550.8,
            "end": 1559.14,
            "transcript": "Tawa-ll' tamana ataucirrar' kalukaq, amllerrsaaqluteng kalukatvut tang civuani."
        },
        "154": {
            "start": 1559.14,
            "end": 1565.64,
            "transcript": "Tau͡gaam wii ataucirrar' kalukaq anguvilqerluku."
        },
        "155": {
            "start": 1565.64,
            "end": 1575.02,
            "transcript": "Cunaw' civuqliani au͡gkut ayuqenrilnguut kalukarugaput agayulirtet taqevkallrulliniluki."
        },
        "156": {
            "start": 1575.02,
            "end": 1586.72,
            "transcript": "Cali qayutuneng nunamteńi angalkungqellrulliniluta assilrianeng ikayurteng ilait tau͡gken assiinateng, ilait-ll' assirluteng."
        },
        "157": {
            "start": 1586.72,
            "end": 1601.64,
            "transcript": "Tamakut cunaw' agayulirtet iciw' piunrilkelluki assiilkelluki caliarit taqevkalliniluki."
        },
        "158": {
            "start": 1601.64,
            "end": 1612.48,
            "transcript": "Cali wii waniw' Catholic-aulua assiilngiryarameng elitellrulua Cugturrlainaq tawa-ll'."
        },
        "159": {
            "start": 1612.48,
            "end": 1618.78,
            "transcript": "Ataucim agayulirtem nunup'aglua Kass'aturrlainaq tau͡gaam assiilngusqellua."
        },
        "160": {
            "start": 1618.78,
            "end": 1627.48,
            "transcript": "Wii-ll' assiikevkenaku ciin agayuviim tungiinun qaneryararput man' pisqessuitellratgu."
        },
        "161": {
            "start": 1627.48,
            "end": 1639.54,
            "transcript": "Cali tamaani apqauraqamki makut teggneret cayarallemteńeng naum [?] tawa iiqumtuarluteng iirturluki qanaateksuunaki-ll'."
        },
        "162": {
            "start": 1639.54,
            "end": 1646.5,
            "transcript": "Wagg'uq tawani uivegciluteng agayuviim tungiinun pinricukluteng."
        },
        "163": {
            "start": 1648.26,
            "end": 1664.0,
            "transcript": "Kumangulria, wangkuta-qaa ak'allarni ak'allaat imkut ciuqlirput tegganret, teggneret yuuciat-qaa assiitellruukuq?"
        },
        "164": {
            "start": 1664.0,
            "end": 1669.8,
            "transcript": "Maa-i-tun [?] cuqtaalriani assiqapigtellrulliniukut tamaani."
        },
        "165": {
            "start": 1669.8,
            "end": 1677.64,
            "transcript": "Man'a-llu taangaryaraq iiqumta yugnun tangaavkenateng piluteng."
        },
        "166": {
            "start": 1677.64,
            "end": 1682.96,
            "transcript": "Cali anuraksaunateng mer'alliniaqameng."
        },
        "167": {
            "start": 1682.96,
            "end": 1689.42,
            "transcript": "Cali tamaani tan'gurraulua Ingirraallermun [?] ayagcetellruatnga."
        },
        "168": {
            "start": 1689.42,
            "end": 1705.36,
            "transcript": "Tamaani cali elitnaullemteńi makut Moravian-at Bible-ait Yugtun mumigngalriit anguq'apiar agtuusqevkenaki tamakut kenerpagmun ayagciqniluta."
        },
        "169": {
            "start": 1705.36,
            "end": 1708.74,
            "transcript": "Aarcirtuutait tamaa-i."
        },
        "170": {
            "start": 1708.74,
            "end": 1721.26,
            "transcript": "Cali maani Yugtun qanraqamta kangirami aqumgavkarluta atakurpak angliksailmilriakut-wa."
        },
        "171": {
            "start": 1721.26,
            "end": 1730.34,
            "transcript": "Umyuamteggun aknirtelalput tamakut amlleqapigtelliniluteng puqigivailemta."
        },
        "172": {
            "start": 1730.34,
            "end": 1734.3,
            "transcript": "Tamaa-i amllerqunek tamakunek umyuarteq'lartua,"
        },
        "173": {
            "start": 1734.3,
            "end": 1745.32,
            "transcript": "ciin makut ciuqliit agayulirteput tuaten calilallritnek wall'u-qaa wangkuta caunrilkelluta tuaten auluklaraitkut?"
        },
        "174": {
            "start": 1745.32,
            "end": 1755.48,
            "transcript": "Maa-i allakakucaramek maa-i cali taqeksaitut makut qatellriaput."
        },
        "175": {
            "start": 1755.48,
            "end": 1765.6,
            "transcript": "Amta-ll' imkut ciuliamta tangenrrangramteki ilaliuqaasqelluki."
        },
        "176": {
            "start": 1765.6,
            "end": 1775.14,
            "transcript": "Tua-llu camek neqkailkan ilaliuqernginaquni amlleqapigciiqniluku."
        },
        "177": {
            "start": 1775.14,
            "end": 1781.32,
            "transcript": "Maa-i tavaq-qaa makut ayagyuaput tuaten umyuarteq'lalriit."
        },
        "178": {
            "start": 1781.32,
            "end": 1787.66,
            "transcript": "Amta-llu kailriit maani nakirneqluki ikayurcetaalriit-ll' nakirneqluki."
        },
        "179": {
            "start": 1787.66,
            "end": 1791.62,
            "transcript": "Kiuqernaurtut ilait, \"Qayutun akilirciqsia?\""
        },
        "180": {
            "start": 1791.62,
            "end": 1801.14,
            "transcript": "Wangkuta tamaani aki umyuaqluku anglicallrunritukut."
        },
        "181": {
            "start": 1801.14,
            "end": 1808.64,
            "transcript": "Tamaani ayagyuallemteńi quyaqallerkaa tau͡gaam ukut ilamta pitekluku."
        },
        "182": {
            "start": 1808.64,
            "end": 1816.0,
            "transcript": "Tuaten tau͡gaam quya-gguq una angelriamek akinaungqertuq."
        },
        "183": {
            "start": 1818.56,
            "end": 1829.14,
            "transcript": "Maa-i cali watua iliikun ayagniararqamta qavatmun piciryaraqluku uksuarmi."
        },
        "184": {
            "start": 1829.14,
            "end": 1842.44,
            "transcript": "Yullraurluunka pilaranka, \"Atam atercetarluci neqpiggarmek makut piqerlaki, piqerlaqilaput.\""
        },
        "185": {
            "start": 1842.44,
            "end": 1851.06,
            "transcript": "Akinaurutii tangrrumanrilnguum akituqapigtelliniuq."
        },
        "186": {
            "start": 1853.82,
            "end": 1858.0,
            "transcript": "Yuum ilii ayuqsuitut quyallrit."
        },
        "187": {
            "start": 1858.0,
            "end": 1868.24,
            "transcript": "Quyalriit ak'anivkenateng akinaurilalliniut tuaten camek imumek piyullemteńek."
        },
        "188": {
            "start": 1868.24,
            "end": 1869.88,
            "transcript": "Tua-i."
        },
        "189": {
            "start": 1869.88,
            "end": 1873.7,
            "transcript": "Tuunralek."
        },
        "190": {
            "start": 1873.7,
            "end": 1885.2,
            "transcript": "Umyuavet-qaa maligartenritai ukut qanerturallratni ava-i yuut ak'a tamaani tegganret teggneret-llu assiryaaqellruniluki?"
        },
        "191": {
            "start": 1885.2,
            "end": 1892.42,
            "transcript": "Tamakut wangkuta ciuliaput..."
        },
        "192": {
            "start": 1892.42,
            "end": 1907.04,
            "transcript": "Wiinga qanqatartua history book-anka aturluki Moravian-aat igautellrit avalingqerrama-llu ama-i tamakut igaitnek waten qanrumalrianek."
        },
        "193": {
            "start": 1907.04,
            "end": 1918.32,
            "transcript": "Ellait tekitelliniut akmaken 1884-aami ayagnirluteng, 1885-aami nutaan piurrluni una Mamterilleq."
        },
        "194": {
            "start": 1918.32,
            "end": 1922.28,
            "transcript": "Maavet-llu ciungani missionary-t tekiteqaqsaunateng."
        },
        "195": {
            "start": 1924.24,
            "end": 1939.88,
            "transcript": "Wiinga tua-i-wa una qanrutkarkaqa tayima ukut pillracetun ayuqeqapiarngaicaaqellria."
        },
        "196": {
            "start": 1939.88,
            "end": 1951.3,
            "transcript": "Tau͡gaam quyaunga-wa quyatengqertua unuamek qaneryaramek mat'umek taicimallemteńek."
        },
        "197": {
            "start": 1951.3,
            "end": 1966.0,
            "transcript": "Taicetput-llu [?] tamakut missionary-t caknerluteng taicillruut, tuqualuteng maani akulemteńi qaneryaramek pingnaqnginanermeggni qalarucingnaqnginanermeggni."
        },
        "198": {
            "start": 1966.0,
            "end": 1975.18,
            "transcript": "Cali-llu taukut taicilriit piciryaraput wangkuta cakaallrunritait maani Kusquqvagmi."
        },
        "199": {
            "start": 1975.18,
            "end": 1984.22,
            "transcript": "Cali-llu qanrucimaluteng igausngaluteng document-aumaluteng history book-amteńi."
        },
        "200": {
            "start": 1984.22,
            "end": 1996.72,
            "transcript": "Taukut missionary-t qanlliniut malrugnek anernertangqerran Agayutem pianek, Agayutnguluni-llu tauna."
        },
        "201": {
            "start": 1996.72,
            "end": 2000.7,
            "transcript": "Cali-llu allamek pitarluni anernerrlugmek."
        },
        "202": {
            "start": 2000.7,
            "end": 2007.48,
            "transcript": "Taukuk-llu cikiqengtulutek yugmun piyulriamun, wall'u-llu..."
        },
        "203": {
            "start": 2007.48,
            "end": 2016.54,
            "transcript": "Ciumek waten qanrutkekumku, Anerneq Tanqilria, Agayutem anernera, cikiqengtuuq yugnun piyullmitun."
        },
        "204": {
            "start": 2016.54,
            "end": 2020.96,
            "transcript": "Wiinga-llu tauna qanrutesciiganaku taumek cikiisqellua."
        },
        "205": {
            "start": 2020.96,
            "end": 2033.64,
            "transcript": "Elliin tau͡gaam piyullminek cikirciqlua qanrutkumaluni tauna Corinthians-aani, Ephesians-aani, Galatians-aani, qaillun ayuqellrianek cikiqenglaucia."
        },
        "206": {
            "start": 2033.64,
            "end": 2043.82,
            "transcript": "Tua-llu taukut tekicameng tekitelliniut Kass'at maavet nunamteńun, maaten-gguq tekitut yuut makut angalkurtarluteng."
        },
        "207": {
            "start": 2043.82,
            "end": 2052.32,
            "transcript": "Tau͡gaam angalkut malruugut, aipait assilriaruluteng, aipait-llu assiitellriaruluteng."
        },
        "208": {
            "start": 2052.32,
            "end": 2054.8,
            "transcript": "Tamarmi tua-i tuaten ayuqellriartangqerran."
        },
        "209": {
            "start": 2054.8,
            "end": 2073.96,
            "transcript": "Tau͡gaam man'a cali atauciq tau͡gaam yuut piat wangkuta maani atulallrit yuraryaraq man'a agayumacim mat'um arulaircetellruyaaqaa."
        },
        "210": {
            "start": 2073.96,
            "end": 2084.44,
            "transcript": "Tau͡gaam yuut Yupiit qaneryaraq nallunriamegteggu tamakut cukaircetellruat kiituan arulairtuq."
        },
        "211": {
            "start": 2084.44,
            "end": 2091.66,
            "transcript": "Kass'at arulaircetellrunricaaqaat Moravian missionary-t."
        },
        "212": {
            "start": 2091.66,
            "end": 2098.2,
            "transcript": "Tau͡gaam cali qaneryaraput man'a tamarcetellrunritaa taukut."
        },
        "213": {
            "start": 2098.2,
            "end": 2105.64,
            "transcript": "Ukut tau͡gaam federal government-aam elitnauristain education department, taukut tau͡gaam tua-i."
        },
        "214": {
            "start": 2105.64,
            "end": 2115.34,
            "transcript": "Wiinga wang'ulua-llu qacarceciulallruunga amllerqunek qaneryunqeggama wall'u-llu puqialama Kass'atun tamatum nalliini."
        },
        "215": {
            "start": 2115.34,
            "end": 2129.34,
            "transcript": "Anaanama-llu elitnauristem, Miararmek [?] pilallruarput, tungaunani qacartelallruanga wall'u-llu ruler-aamek kaugturaqlua Kass'atun qalarrnilua."
        },
        "216": {
            "start": 2129.34,
            "end": 2141.32,
            "transcript": "Tau͡gaam missionary-t tuacetun pillrunritaatnga, qaillun-llu qancurlautellruvkenii tau͡gaam alarucimteńek apertuut'lallruitkut."
        },
        "217": {
            "start": 2141.32,
            "end": 2157.46,
            "transcript": "Tayima wiinga umyuarteqlemni au͡g'utun tua-i ukut inglulilriacetun piyaaqanka tau͡gaam inglulirpek'naki. Qaneryugngaunga waten,"
        },
        "218": {
            "start": 2157.46,
            "end": 2169.16,
            "transcript": "Moravian Church-am tungiinun apologize-arngaicugnarqua wall'u-llu apologize-asqumanricugnarqanka wangnun tau͡gaam quyakluki elicecatnga nalluyaaqellemnek."
        },
        "219": {
            "start": 2169.16,
            "end": 2179.44,
            "transcript": "Heathen-aaruyaaqellemnek Agayun wall'u-llu Christian-aarunricaaqellemnek tamakuurcugngarillemnek. Quyana."
        },
        "220": {
            "start": 2179.44,
            "end": 2185.82,
            "transcript": "Callerkuaq, au͡g'um-qaa qanellra Tuunralgem ilaqeryuumiitan piciatun?"
        },
        "221": {
            "start": 2185.82,
            "end": 2196.3,
            "transcript": "Ii-i, wiinga-wa elitnauqallemni im'umi waten wani taringellrukeka."
        },
        "222": {
            "start": 2196.3,
            "end": 2211.74,
            "transcript": "Ellarpiim iluani yuut ayuqenrilnguut piciryaralget man'a Agayumacim Christianity-m Gospel-aam-wa tua-i tekitaqateng amlleret piciryararteng ilait pegtelaryaaqait."
        },
        "223": {
            "start": 2211.74,
            "end": 2220.72,
            "transcript": "Tau͡gaam man'a elluarrluni yuuyararteng pegtevkenaku pilartut, ilait tua-i pegtelaryaaqeng'e'rmegteki."
        },
        "224": {
            "start": 2220.72,
            "end": 2233.78,
            "transcript": "Maa-i-llu cali yuut unuamek alerquuteteng aturluki yuuluteng. Amlleq alerquun elluarrluni yuullerkaq tamana cimirpek'nani."
        },
        "225": {
            "start": 2233.78,
            "end": 2243.74,
            "transcript": "Cali tegganret qalarutellemni-w' imumi 10 years-aurteqatalria maa-i pillruut,"
        },
        "226": {
            "start": 2243.74,
            "end": 2256.82,
            "transcript": "au͡gna-gguq yuut yuuyarallrat alerquutait picirkiutait yuuluteng cangallrunritliniuq mat'um Agayumacim alerquutaini."
        },
        "227": {
            "start": 2256.82,
            "end": 2265.42,
            "transcript": "Cali-llu qanerluni iliit, Agayutmek-gguq imumi qanyuitellruyaaqut, Ellam tau͡gaam Iinganek qanraqluteng."
        },
        "228": {
            "start": 2265.42,
            "end": 2271.3,
            "transcript": "Waten-gguq maa-i tauna ayuqelliniuq, tua-i-wa allauvkenani."
        },
        "229": {
            "start": 2271.3,
            "end": 2279.32,
            "transcript": "Cali, au͡gna Walter-aam qanellra wiinga cali ilaqeryugaqa."
        },
        "230": {
            "start": 2279.32,
            "end": 2288.32,
            "transcript": "Makut wani Moravian Church-aq una apeqerluku elitnauristeńgullruut ilait."
        },
        "231": {
            "start": 2288.32,
            "end": 2298.12,
            "transcript": "Tua-i-llu avaken Department of Education, iciw' taumek tua-i ilait amller' kingunengqellruameng."
        },
        "232": {
            "start": 2298.12,
            "end": 2307.44,
            "transcript": "Alerquumallruut Kass'atun qaneryaraq aturluku elitnaurisqelluki, elitnaurluki mikelnguut Kass'atun qaneryaramek."
        },
        "233": {
            "start": 2307.44,
            "end": 2311.78,
            "transcript": "Tua-i tamana alerquuteteng maliggluku pillruut."
        },
        "234": {
            "start": 2311.78,
            "end": 2324.58,
            "transcript": "Ellaita agayuvimeggni tamana Kass'atun aturluku elitnauryaraq alerquutekellrunritaat."
        },
        "235": {
            "start": 2324.58,
            "end": 2328.48,
            "transcript": "Moravian-aat maa-i ellarpamteńi amllertut."
        },
        "236": {
            "start": 2328.48,
            "end": 2344.02,
            "transcript": "Cali-llu ayagaqameng yugnun man'a qaneryaraq ayaulluku piaqameng, yuut qaneryarait atungnaqurluki pilartut taumek mumigcilalriit-llu Bible-aanek yuarutnek-llu."
        },
        "237": {
            "start": 2344.02,
            "end": 2347.28,
            "transcript": "Cali waten qaneryugtua."
        },
        "238": {
            "start": 2349.8,
            "end": 2366.46,
            "transcript": "Iaitnek maa-i niitelartua makunun Moravian-aanun wall'u allanun agayulirteńun qaneryaramek ayagcecilrianun man'a yuucirput piunrirrniluku, yuuyararput piunrirrniluku."
        },
        "239": {
            "start": 2366.46,
            "end": 2377.04,
            "transcript": "Cali-llu agturluku man'a elluarrluta-w' tua-i yuunritlerput wall'u taangiqsulallrat, tua-i-w' yurrluurrluteng, imutun aakulagtellriatun pivkarluki."
        },
        "240": {
            "start": 2377.04,
            "end": 2386.24,
            "transcript": "Tua-i tauna agayumaciq amllerem piluku piaqluteng tamatumek kangingqerrniluku."
        },
        "241": {
            "start": 2386.24,
            "end": 2400.64,
            "transcript": "Umyuartequa wangni Kass'at-wa tua-i ilaita, arcaqerluteng Kass'at, waten mikelngurtun-wa tua-i umyugailngurtun iliini pissiyaagaitkut umyuarteqsuicukluta."
        },
        "242": {
            "start": 2400.64,
            "end": 2417.28,
            "transcript": "Canek picarkiraqluta cat qaill' pisqelluku, wangkuta umyuangqertukut assilria wall'u assiitellria, umyuartequ'utelaraput, umyuartequcugngaaput."
        },
        "243": {
            "start": 2417.28,
            "end": 2427.42,
            "transcript": "Cali mikelngurtun-wa umyuarteqenrilngurtun pinarqevkenata, tua-w' anglicalriatun pinarqevkenata."
        },
        "244": {
            "start": 2427.42,
            "end": 2436.12,
            "transcript": "Cali au͡gna ilaqerluku, ilumun angalkut assirrlainallrunrituq wani tua-i man'a yuuyararput."
        },
        "245": {
            "start": 2436.12,
            "end": 2441.1,
            "transcript": "Ellarpiim iluani yugmek assirrlainalriamek pitaituq."
        },
        "246": {
            "start": 2441.1,
            "end": 2453.24,
            "transcript": "Iciw' anguyalallrulriit-llu maani. Cali-llu aturnarqenrilnguq amlleq yuut avani agayumaciq-llu tekipaligan atulallruluku."
        },
        "247": {
            "start": 2453.24,
            "end": 2460.32,
            "transcript": "Inerquutelirluteng, inerquuteliqapiarluteng assiitellriim atunritlerkaan tungiinun."
        },
        "248": {
            "start": 2460.32,
            "end": 2467.92,
            "transcript": "Nallunritellruameng tua-i yuum assirluni yuullerkaanek wall'u yurrluuniluni [?] yuullerkaanek."
        },
        "249": {
            "start": 2467.92,
            "end": 2477.76,
            "transcript": "Taumek alerquutelillrulriit nallunrilamegteggu yuum tamarmi assiilnguq atullerkaa wall'u assilria."
        },
        "250": {
            "start": 2477.76,
            "end": 2492.38,
            "transcript": "Qaneryaram mat'um nutaram assiilnguq allakauluku aperluku pilaryaaqellrukiit tau͡gaam yuut au͡gkut avani cali nallunritellrulriit cam assiitellriim atulallra wall'u assilriim."
        },
        "251": {
            "start": 2492.38,
            "end": 2497.92,
            "transcript": "Wangni qanyuunaunata assiqapiarallruniluki yuut tamaani."
        },
        "252": {
            "start": 2497.92,
            "end": 2503.98,
            "transcript": "Tau͡gaam ilumun assilrianek amllernek inerquutengqellruut."
        },
        "253": {
            "start": 2505.76,
            "end": 2511.56,
            "transcript": "Cali peng'gartua waten apervikuakata agayuviit."
        },
        "254": {
            "start": 2513.24,
            "end": 2525.58,
            "transcript": "Peng'gartua-wa makunek ayagyuanek man'a agayumacirput-wa tua-i iciw' pinayukluku, ingluarnayukluteng."
        },
        "255": {
            "start": 2525.58,
            "end": 2537.24,
            "transcript": "Tua-i-w' ukveqevkenaku-llu... ap'luaqanricugnarqaqa... umyugait caunrilkelriatgun-llu tua-i pinga'arcesqumanricaaqluki."
        },
        "256": {
            "start": 2537.24,
            "end": 2543.44,
            "transcript": "Au͡g'utun ava-i qanqallruama, makut tegganret-llu qanellruata."
        },
        "257": {
            "start": 2543.44,
            "end": 2556.2,
            "transcript": "Alerquuteput tuar imutun yuuyaraq elluarrluta alerquuteput imutun pinirikanilriatun ukverem ilakii. Tua-i tamakunek..."
        },
        "258": {
            "start": 2558.6,
            "end": 2568.08,
            "transcript": "Sliksuuyaq, ava-i niiqurtukut ak'a tamaanillarnek yuut ayuquciq'lallritnek."
        },
        "259": {
            "start": 2568.08,
            "end": 2586.58,
            "transcript": "Ilait tayima ava-i qanellricetun agayuviit makut ilait apervikuangaicugnarqut umyuameggni-wa pinarqenrilameng."
        },
        "260": {
            "start": 2589.06,
            "end": 2604.22,
            "transcript": "Aipaagni pillikiit, tua-i-w' aipaagni pikata ilait, tua-i-ll' allat cali agayuviit ilagaulluteng apervikuamek pingluteng."
        },
        "261": {
            "start": 2604.22,
            "end": 2618.66,
            "transcript": "Wangkuta yug'ulriani tuaken apervikuatem nuniinek, qaillun ayagciqceta, apervikuamek akurturraarluta?"
        },
        "262": {
            "start": 2618.66,
            "end": 2621.2,
            "transcript": "Natmurciiqceta tuaken?"
        },
        "263": {
            "start": 2623.28,
            "end": 2638.32,
            "transcript": "Apervikuakata-wa wangkutnun yugnun nunacuarni nutaan tuarpiaq wangni nutaan man'a yuuyaraput nutaan kasngukevkenaku atungciqaput."
        },
        "264": {
            "start": 2638.32,
            "end": 2646.04,
            "transcript": "Allakaunrilan waten makut taitellracetun. Allakauqapiaranrituq. Ayuqeqapiartuq."
        },
        "265": {
            "start": 2646.88,
            "end": 2657.0,
            "transcript": "Yuviquvciu-wa tang man'a wangkuta yuuyaraput, allayuunrituq waten ukut missionary-t taitellracetun."
        },
        "266": {
            "start": 2657.0,
            "end": 2667.76,
            "transcript": "Waten man'a wangkuta yuuyaraput una-ll' ukvemta ayuquciat ayuq'apiartuk waten."
        },
        "267": {
            "start": 2667.76,
            "end": 2670.16,
            "transcript": "Aliimacetun ayuquk."
        },
        "268": {
            "start": 2670.16,
            "end": 2677.12,
            "transcript": "Nutaan wangkuta yuuyaraput aturluki kasngukevkenaki nutaan nalletmun ayagyunarqukut."
        },
        "269": {
            "start": 2677.12,
            "end": 2681.38,
            "transcript": "Man'a-llu tunluku ayagyuamteńun."
        },
        "270": {
            "start": 2681.38,
            "end": 2694.22,
            "transcript": "Qanrulluki, \"Wangkuta yuuyaraput allayuunritut ukunun watua makut agayuviit elitnauraicetun. Ayuqeqapigtut.\""
        },
        "271": {
            "start": 2694.22,
            "end": 2698.22,
            "transcript": "Ilumun waten yuut ayuqenritut."
        },
        "272": {
            "start": 2698.22,
            "end": 2706.84,
            "transcript": "Amlleret yuut elluarrluteng yuungnaqu'urlartut, ilait-llu tua-i alartaqameng nutaan iqlutmun ayalalriit."
        },
        "273": {
            "start": 2706.84,
            "end": 2709.64,
            "transcript": "Tamana nallunritaput."
        },
        "274": {
            "start": 2709.64,
            "end": 2716.48,
            "transcript": "Man'a ava-i ak'a tamana kingunellruuq."
        },
        "275": {
            "start": 2716.48,
            "end": 2725.1,
            "transcript": "Maa-i tang ernerpak-wa tua-i nutaan, qaillun wangkuta, wangkutnek ikayungnaqerqatarceta?"
        },
        "276": {
            "start": 2725.1,
            "end": 2738.28,
            "transcript": "Iliit man'a wangkuta nutaan yuuyaramteńek ilaluku aturluku ikayuqsunarqaput man'a wangkuta elluatmun ayangnaqellriani."
        },
        "277": {
            "start": 2741.34,
            "end": 2749.06,
            "transcript": "Angalgaq, ellpet-mi qaillun umyuarteqsit apervikuakata natmun naken waken ayagciqceta?"
        },
        "278": {
            "start": 2749.06,
            "end": 2764.5,
            "transcript": "Ii-i, tua-i-wa apervikuakata wangkutnun yugnun quyamek tua-i cikirciqkiikut utumaqercelluku qamna akngirniurpaka' [?] umyuarniurpakallerput qangvarpak."
        },
        "279": {
            "start": 2764.5,
            "end": 2771.82,
            "transcript": "Tua-i salve-alriacetun iciw' minguutamek mingulriacetun akngirtelput utumaqalalria."
        },
        "280": {
            "start": 2771.82,
            "end": 2775.38,
            "transcript": "Tuaten ayuqeciqsunarquq wiinga umyuarteqlemni."
        },
        "281": {
            "start": 2775.38,
            "end": 2793.12,
            "transcript": "Tamana wani amlleq wani akngirutekellrat yuut umyuamegteggun arcaqerluteng kasngukluku man'a yuuyaraq elluarrluni piciryaralteng pegtellrat ataam yuut atungeqainauraat wani kasngukevkenaku."
        },
        "282": {
            "start": 2793.12,
            "end": 2809.84,
            "transcript": "Tua-i man'a-llu yuraryaraq cali utercarngatuq cali amllernun nunanun waten ilaliurutpiarluni wani allanun nunanun tua-i ilakeqapiaralriacetun Agayutem alerquutiicetun, \"love your neighbor as yourself\"."
        },
        "283": {
            "start": 2809.84,
            "end": 2821.62,
            "transcript": "Tua-i tamana wani Yupiit wani atuqiit qangvarpak tayima tamakut agayulirtet amlleq tekicata wani tua-i tamana cimirpalriacetun ayuqellria."
        },
        "284": {
            "start": 2821.62,
            "end": 2839.32,
            "transcript": "Cali makut elitnaurai cali eliteluarpailegmeng tamaani taqellruameng ak'a tua-i elitnaurniluki irniateng wani allanun tua-i ellaita elitnaunrillrukait piciryarameggnek."
        },
        "285": {
            "start": 2839.32,
            "end": 2846.22,
            "transcript": "Tua-i tamana wani aulukarkarteng ellaita responsibility-rteng peggluku."
        },
        "286": {
            "start": 2846.22,
            "end": 2868.98,
            "transcript": "Tua-i tamana wani akngirutekmiluku cali amlleq wani makut ayagyuat tamakut-llu umyuarniulriit iqlutmurrluteng taangamun tuaten cauluteng drug-anun tuaten irniateng tuaten assirluki aulukevkenaki naucirpek'naki imumicetun qanruqu'urluki qaruqurluki-llu."
        },
        "287": {
            "start": 2868.98,
            "end": 2884.56,
            "transcript": "Tua-i tamana wani atunrirpakiit tua-i piciryaraq man'a wani wiinga heathen-amek wall'u pagan-aamek apermallra wani allanun yugnun wani umyuama assikenritaa."
        },
        "288": {
            "start": 2884.56,
            "end": 2891.88,
            "transcript": "Tua-i Agayutem piliaqellruamiki makut yuut tamalkuita ayuqenrilnguut elluarrluki."
        },
        "289": {
            "start": 2891.88,
            "end": 2900.92,
            "transcript": "Assirtacirkiurluki assilriamek aturkiurluki ellminun ayaumalrianek."
        },
        "290": {
            "start": 2900.92,
            "end": 2911.46,
            "transcript": "Tuaten nallunge'rmeng makunek wani allat yuut ukveritnek tua-i tungiinun egleqcarararkauluteng taqumalriit."
        },
        "291": {
            "start": 2911.46,
            "end": 2921.28,
            "transcript": "Tua-i waten kiimetleq wani Agayutaunani camek ikayurtekaunani uitalleq wani umyuarniurnarquq akngirnarquq."
        },
        "292": {
            "start": 2921.28,
            "end": 2938.76,
            "transcript": "Tua-i ak'a tamana wani nallunrilamegteggu yuut Ellam Yuanek ak'a qanemcilalriit Tulukaruk-llu una cali iuliarput taitellra cali maa-i ayagneriluni Kuigpagmiunek unani Ceńarmiunek-llu."
        },
        "293": {
            "start": 2938.76,
            "end": 2947.52,
            "transcript": "Cali waniwa uum-am Bob-am qanellratun tau͡gaam [?] combine-arlukek."
        },
        "294": {
            "start": 2947.52,
            "end": 2963.72,
            "transcript": "Yup'igtaat makut-llu nutarat assilriit avaliqluki yuk wani pikuni assinruurciqluku una [?] improve-arpautnguciqngatuq tayim' agiirtellrianun yugnun nutaranun."
        },
        "295": {
            "start": 2963.72,
            "end": 2967.5,
            "transcript": "Tacuk'aq, elpet-mi qallun umyuarcit mat'um tungiinun?"
        },
        "296": {
            "start": 2967.5,
            "end": 2969.76,
            "transcript": "Sass'arput cukarinartuq."
        },
        "297": {
            "start": 2969.76,
            "end": 2971.96,
            "transcript": "Yaa, tangvagaqa."
        },
        "298": {
            "start": 2971.96,
            "end": 2979.28,
            "transcript": "Maa-i-rpak iciw' ayagnirturtukut tua-i maa-i cayaraput paivqurluku."
        },
        "299": {
            "start": 2979.28,
            "end": 2991.54,
            "transcript": "Agayuviit cal' yuucuumaut apologize-anrilengraata umyugamni ayagturciquq taqngaitukut iciw' ayagnilriani maa-i."
        },
        "300": {
            "start": 2991.54,
            "end": 3002.98,
            "transcript": "Tau͡gaam agayuviit ikayuucuumaut agayuvigni puggluku man'a cayaraqegtaaraput ilaksagulluku agayuvigni."
        },
        "301": {
            "start": 3002.98,
            "end": 3012.36,
            "transcript": "Cali yurat makut kalukat-ll' tamakut cali pugngiinartut."
        },
        "302": {
            "start": 3012.36,
            "end": 3023.4,
            "transcript": "Pugngiinartut apologize-anrilengraata tua-i yuut cayarait pug'urciquq tau͡gaam agayuvik ikayuuskuni nutaan assirciquq."
        },
        "303": {
            "start": 3023.4,
            "end": 3030.04,
            "transcript": "Kumangulria, elpet-mi qaillun tamatum tungiinun umyuarteqsit?"
        },
        "304": {
            "start": 3030.04,
            "end": 3044.44,
            "transcript": "Makut-wa yuarutet Kass'artaat taringumanrilngurni ayuqsukluki wangkuta umyuarteq'lartut wangkucit' qitevpakayuilnguut-llu."
        },
        "305": {
            "start": 3044.44,
            "end": 3054.18,
            "transcript": "Tua-i wangkuta yuarutput tayima ellaita assirrlainarluki niirqellanritait."
        },
        "306": {
            "start": 3054.18,
            "end": 3062.2,
            "transcript": "Ilait assirluteng quyaluteng-llu qaneryarangqerrsaaqut."
        },
        "307": {
            "start": 3062.2,
            "end": 3069.04,
            "transcript": "Amta-llu cangallruvkenateng, tuunralget imkut aturlallrit cangallruvkenateng."
        },
        "308": {
            "start": 3069.04,
            "end": 3076.42,
            "transcript": "Qayuwa wangkuta ilamta Kass'alugpianek-ll' tailuteng."
        },
        "309": {
            "start": 3076.42,
            "end": 3089.28,
            "transcript": "Nallungaitatki tamakut elluatun qaneryarat apertuurluki tuunralegtaat-llu amta-ll' erinait ayuqluteng."
        },
        "310": {
            "start": 3089.28,
            "end": 3093.58,
            "transcript": "Ellaicetun taringumangaitaput."
        },
        "311": {
            "start": 3093.58,
            "end": 3101.1,
            "transcript": "Ellaita agayuyarait wall'u-qaa waten agnguarluteng tuaten piyarait."
        },
        "312": {
            "start": 3102.88,
            "end": 3110.68,
            "transcript": "Tuunralek, naken waken ayagciqceta pillikata?"
        },
        "313": {
            "start": 3112.98,
            "end": 3117.78,
            "transcript": "Wangkuta-wa maa-i caliarkaput amllertut."
        },
        "314": {
            "start": 3117.78,
            "end": 3128.08,
            "transcript": "Maaggun agayuvigkun inglukutevkenata wall'u-llu inglucitevkenata ayakcaarqumta aulukarkaput amllertut."
        },
        "315": {
            "start": 3128.08,
            "end": 3143.54,
            "transcript": "Aipainret, elliraat, cali-llu makut mat'umek pillugutengqelalriakut taangamek wall'u-llu apqemteńek iinrukayagnek, drugs, cali-llu puyurtukayagnek allanek."
        },
        "316": {
            "start": 3143.54,
            "end": 3149.0,
            "transcript": "Tamakut caliarkaput amllertut, uumek tau͡gaam wiinga nangnermek qaneqeryugtua."
        },
        "317": {
            "start": 3149.0,
            "end": 3158.66,
            "transcript": "Quyatengqertua missionary-t taillruata, imkut kiimeng pivkenateng mainuut [?], miner-aat kiimeng pivkenateng."
        },
        "318": {
            "start": 3158.66,
            "end": 3177.54,
            "transcript": "Taangauceteng, taukut missionary-t taillrunrilkata, maa-i nutaan arcaqalriamek miner-aat, mine-at makut piciryaraatnek wall'u-llu trader-aat piciryaraitnek arcaqerluku tamana atularyararput agayumacimek pivkenata."
        },
        "319": {
            "start": 3177.54,
            "end": 3190.64,
            "transcript": "Ellait taukut imkut kipusvilget, laavkaalget tailallruut, tunyugngaluteng aklunek aturanek atu'urkaitnek-wa tua-i cali makunek ilangqerrluteng taanganek."
        },
        "320": {
            "start": 3191.3,
            "end": 3205.04,
            "transcript": "Quyatengqertua missionary-t taitellratnek qaneryaramek tamana arcaqerpallaarluku aturyallerput offset-alriatun ayuqngatgu assilriamek tapengqerrluni."
        },
        "321": {
            "start": 3208.22,
            "end": 3214.22,
            "transcript": "Callerkuaq, elpet-mi qaillun tamatum ava-i tungiinun qanerkangqercit?"
        },
        "322": {
            "start": 3216.06,
            "end": 3228.56,
            "transcript": "Wiinga-w' ciumuucugyaaqluku man'a inglukutenritlerkarput Kass'anun, Kass'at-wa tua-i iliini pilriatun."
        },
        "323": {
            "start": 3228.56,
            "end": 3236.36,
            "transcript": "Inglukellriatun pilaraput qanraqluta, \"Yuucirput, tailuteng yuucirput piunrirrniluku\"."
        },
        "324": {
            "start": 3236.36,
            "end": 3250.12,
            "transcript": "Tau͡gaam tamamta yuut ellait-llu Kass'at tua-i taringengnaqellriatun-wa tua-i pillgutkenricaaqengramta."
        },
        "325": {
            "start": 3250.12,
            "end": 3262.16,
            "transcript": "Tau͡gaam nallunringnaqellriatun ayuquciput ellaita-llu wangkuta ayuquciit inglukutenritlerkarput-wa tua-i ciumurutesqumayaaqluki."
        },
        "326": {
            "start": 3262.16,
            "end": 3276.04,
            "transcript": "Cali-llu ilumun uum qanqallratun agayuvimteńi-wa makut yuut alerquutait, elluarrluni yuuluni alerquutait, tamakut egmirtelaasqumayaaqluki."
        },
        "327": {
            "start": 3276.04,
            "end": 3287.78,
            "transcript": "Maa-i seminary-mi wiinga piqallruyaaqua tamakunek tau͡gaam ak'anek waniw' piksaitua tau͡gaam cali tamakut agayulirtekat qalarut'larayugyaaqluki-w' tua-i."
        },
        "328": {
            "start": 3287.78,
            "end": 3296.9,
            "transcript": "Mat'um kinguani arcaqerlua nallunrilkengarramnek-wa tua-i yuut alerquutaitnek assilrianek tamakut-llu atulaasqelluki."
        },
        "329": {
            "start": 3296.9,
            "end": 3310.3,
            "transcript": "Message-aarat man'a agayuvik, agayuviim tua-i-w' agayumacim massage-aara gospel-aaq im'u' pinirtellriatun pilaatgu, ilaaqatgu, yuucimta alerquutainek."
        },
        "330": {
            "start": 3310.3,
            "end": 3322.3,
            "transcript": "Cali quyayugtua cali tekitellraanek. Wangkuta-w' tua-i makut ciuqliit agayulirtet-llu qaneryaramek elluarteng amlleret tekiutellret."
        },
        "331": {
            "start": 3322.3,
            "end": 3332.42,
            "transcript": "Ilait tua-i picurlagluteng-am pillruyaaqellriit yuucirput-llu cakneq cirlaksulriatun pillruat ilaita."
        },
        "332": {
            "start": 3332.42,
            "end": 3340.34,
            "transcript": "Tau͡gaam amlleret tua-i-w' man'a Qaneryaraqegtaar wangkutnun taitellruluku."
        },
        "333": {
            "start": 3340.34,
            "end": 3352.32,
            "transcript": "Iliini alingelartua imkut makut-wa tua-i Kass'at qaneryaramek taitenrilnguut au͡gkut-llu uum qanrutkeqallri kipusviliurtet pillrukata,"
        },
        "334": {
            "start": 3352.32,
            "end": 3365.22,
            "transcript": "wangkuta qaneryaramek mat'umek tusngavingqenritellrukumta tamaani qaillun-kiq maa-i ayuqsarceta?"
        },
        "335": {
            "start": 3365.22,
            "end": 3376.26,
            "transcript": "Quyana Callerkuaq, Tuunralek, Kumangulria, Tacuk'aq, Angalgaq, Sliksuuyaq-llu."
        },
        "336": {
            "start": 3376.26,
            "end": 3379.14,
            "transcript": "Quyanaqvaa ilagarluta atakurpak."
        },
        "337": {
            "start": 3379.14,
            "end": 3383.12,
            "transcript": "Cali-llu elpeci tangvallerni, quyana tangvagluci."
        },
        "338": {
            "start": 3383.12,
            "end": 3399.22,
            "transcript": "Ava-i au͡gna ketvartellriatun qalarutkaput cali-llu elpeci umyuaci aturluki qaillun au͡g'um nalqigtellerkaa tau͡gaam tusngaciquq yugnun."
        },
        "339": {
            "start": 3399.22,
            "end": 3404.38,
            "transcript": "Cali quyana ilagarluta atakurpak. Pinarikumta uumiku cali piniartut."
        },
        "340": {
            "start": 3404.38,
            "end": 3405.56,
            "transcript": "Piurci."
        }
    },
    "p0XAmQwenEI": {
        "1": {
            "start": 3.01,
            "end": 15.0,
            "transcript": "Yaglutek ceterluku-llu, ukut-llu mill'uteng, tull'utek-llu, itqerrlutek nunameggnun."
        },
        "2": {
            "start": 15.0,
            "end": 29.0,
            "transcript": "Arenqianatek tua-i alingkacagarlutek tamaa-i tua-i qanemcillinilutek taumek tua-i Qam'uralriim [?] tua-i-ll waniw unugluni qasgimi uitallratni."
        },
        "3": {
            "start": 30.0,
            "end": 44.0,
            "transcript": "Tamaa-i uitainanratni tua-i-llu-gguq cakemna ikna-wa-gguq inglertangqetullruut-gguq qasgit waten pagg'un tua-i uivetmun."
        },
        "4": {
            "start": 49.23,
            "end": 69.01,
            "transcript": "Tua-i-ll' aqumgauraqtalria-gguq tauna kina kitumek ima tanem arivtellrukii tauna angalkullruar tua-i."
        },
        "5": {
            "start": 70.33,
            "end": 92.0,
            "transcript": "Tua-i-llu-gguq pugluni ava-i amiigkun ayaperyarangqetullruut-gguq qasgit amiit ayaperyaqaqami-gguq pinru' [?] unatai atraraqluki."
        },
        "6": {
            "start": 92.0,
            "end": 103.0,
            "transcript": "Tuaten im' piurluni mayurturalliniuq, kiaqvaq itqerrutmini qanlluniluni Qam'uralriim atiin nauwa."
        },
        "7": {
            "start": 103.0,
            "end": 116.0,
            "transcript": "Tua-ll' iliita kiullinia ayallruuq unuaq, iqluuci ayaksaituq."
        },
        "8": {
            "start": 116.0,
            "end": 128.0,
            "transcript": "Tua-i-llu-gguq-wa unatminek elqiirluni yuut-gguq taukut atlirneqluku nillruat alingameng tua-i."
        },
        "9": {
            "start": 128.0,
            "end": 140.0,
            "transcript": "Tamaa-i-gguq tuatenallrani angalkut imkut atrarluteng tuunriyaaqerraarluteng igyariyuksuarluteng tagqertaqluteng."
        },
        "10": {
            "start": 141.0,
            "end": 165.0,
            "transcript": "Aren tua-i tuatenauq tuaten tua-i piaqluteng angalkut tamakut piniryukluteng piaqameng caluteng tuunralek tauna tua-i carayak tamarcetaarluku tuaten ayaaqaqameng tuaten igyariyuksuarluteng tagqertellininaukut maavet."
        },
        "11": {
            "start": 165.75,
            "end": 185.0,
            "transcript": "Ai-gguq Qam'uralriim atiin-im nauwa elqiirluni-gguq waten tua-i kiarrluni tua-i-ll ayallruuq, ayallruuq kinakucirmiunun tayima."
        },
        "12": {
            "start": 185.0,
            "end": 194.0,
            "transcript": "Tua-llu-gguq iqluuci yuut taukut niillinii tang yaa-i."
        },
        "13": {
            "start": 194.0,
            "end": 215.0,
            "transcript": "Tua-i-w' catailnguq alartuten ayuqiinek piiten ayuqaituq, tegungnaqsaaq'-llu tauna angutni tua-llu tua-i iliita-am tua-i angalkumirrluni tua-i piyaaqeqtalliniluni."
        },
        "14": {
            "start": 215.0,
            "end": 233.0,
            "transcript": "Igyarani nucumrruaksualek [?] tagqertelliniluni, tagqercami iliit qanlliniluni caulriaten iksuuq angalkuulartuten-ggem qaill' pilriaten uitavakarcit."
        },
        "15": {
            "start": 233.0,
            "end": 263.49,
            "transcript": "Tua-i-llam tua-i piqerluni up'engaartelliniluni, imarniitegnek-llu cikiisqelluni aliumacirluni-llu [?] iluperluni, naquggluni-llu qanermiirluni-llu maqissuutmek [?] tua-i-llu natraaranga'artelliniuq."
        },
        "16": {
            "start": 263.49,
            "end": 276.0,
            "transcript": "Kialirnerakun maaggun atraaraanga'artelliniuq tauna angalk' [?] tua-i qaill' ayuqelria tauna angalkullruarmek [?]."
        },
        "17": {
            "start": 276.0,
            "end": 300.06,
            "transcript": "Atraaraanga'artelliniuq-gguq qariuqerluki [?] uitekani kinguqvaqanirnaurtuq uaqvaqaniqa'aqluni. Tua-i-gguq tuatnaurluku iqluki aqvaqaniryaaqekan-gguq [?] pinauraa, iqluten piuten uaqvaqaniqa'aqluku."
        },
        "18": {
            "start": 300.06,
            "end": 324.45,
            "transcript": "Tua-i-gguq tuatnaurlutek, tuatnauraqapiarlutek aviteka niisqaqluni, niisqaniqaqlutek, kiaqvaq maaggun menglemikun itraqaniratarqan narukanirluku pillininauraa, iqlutun piuten avitekaniqerrluni uaqvaqanirnaurtuq."
        },
        "19": {
            "start": 324.45,
            "end": 346.32,
            "transcript": "Kiituani-gguq waniw' amiik tekitaa, tua-i-llu-gguq tekicamegnegu cakma. Qasgit igcangertullruata kanavet, igtet tua-i tayim' atrallinilutek cakma tua-i qanaaqurluku."
        },
        "20": {
            "start": 346.32,
            "end": 358.86,
            "transcript": "Tua-i ak'a-ll' tamaani angalkut tamakut kevgaraitevkenateng waten agayulirceteng kevgarirturluteng pitullrulriit."
        },
        "21": {
            "start": 358.86,
            "end": 382.34,
            "transcript": "Tayima kevgarraak-llu taukuk akiqliqu'urlutek call' waten tua-i piluku, tua-ll' tua-i piinanragni kana-i tua-i kevgagken [?] taukuk tangvallrani qumilliniluni tauna carayak imarnitekmiku."
        },
        "22": {
            "start": 382.34,
            "end": 393.88,
            "transcript": "Tua-ll tua-i taum angalkum pillinia atam kiivet alingnaqsukelriaten."
        },
        "23": {
            "start": 393.88,
            "end": 414.44,
            "transcript": "Atam ciunerkan au͡gna tangerqerru arenqianguteraranga'artelliniuq tauna carayak iivkanritqaasqelluni pinqigngaitniluni, iqluuten pinqigngaitenrituten piciquten."
        },
        "24": {
            "start": 414.44,
            "end": 424.0,
            "transcript": "Tua-i cakma tua-i umingurtellinilutek nangyaruk'acagarluni tauna tua-i carayak."
        },
        "25": {
            "start": 424.04,
            "end": 434.04,
            "transcript": "Tua-i-ll' tayim' uminguqertelliniluki tua-i-ll taukut kingumni uitaqalliniluteng tua-i."
        },
        "26": {
            "start": 434.04,
            "end": 454.0,
            "transcript": "Tua-i-ll tua-i uitaqainanrani, uitaqainanratni migpallarteq [?] qakmani, iterluni-llu, itertuq-gguq qanermiarilgumaluteng. Taiski."
        },
        "27": {
            "start": 458.76,
            "end": 473.95,
            "transcript": "Qanermiari wani leg'umaluteng elluaqautelliniluki maqi naqugutailriim-llu."
        },
        "28": {
            "start": 473.95,
            "end": 489.02,
            "transcript": "Iciw' kangiplugnek, kaingluni, aliimategni-ll' pecuglukek cali kangiggluuluteng legumarrlainarluteng maqissuutni-ll' yuulukek cuk'aqii [?] purr'amek [?] puyirluni."
        },
        "29": {
            "start": 489.02,
            "end": 503.25,
            "transcript": "Cuk'arqateng aturait taukut urr'amek puyiraqluteng. Tua-i-ll tua-i aqumgami tuavet uitavillminun."
        },
        "30": {
            "start": 503.25,
            "end": 513.0,
            "transcript": "Ilani taukut qanrutlinii atam man'a qasgici tangerqerci, maktanqigciu."
        },
        "31": {
            "start": 514.0,
            "end": 541.84,
            "transcript": "Maaten-gguq tanglliniat im' tauna qasgirteng, qacarnerrlainarkun egalerluni. Pikanqaarluni-gguq yaavet ellilliniluni egallra. Tua-i-gguq tegucarpiarluki taum teguskateng tua-i yuuyarpek'nateng aren ik'ikik-gguq angalkut."
        },
        "32": {
            "start": 541.84,
            "end": 562.15,
            "transcript": "Tuunrimallinilriit unugpak qasgiteng maktanqeggluku qasgiat-gguq im' maktanqeggikili pikaggun-llu egalengluni. Tua-i-gguq tauna alangru akalleq."
        },
        "33": {
            "start": 562.15,
            "end": 575.14,
            "transcript": "Tua-i taqellruuq iivkaumariani kenerpagmun pikilria tayima. Tua-i-gguq iivkarluku. Nangyarnartacia."
        },
        "34": {
            "start": 575.14,
            "end": 593.27,
            "transcript": "Tamaa-i nangyarnarqetaciani carayaunge'rmi-llu tauna ciunerkani nangyaqluku. Inerquurluryaaqelliniluku-llu pinritqaasqelluni, ciin pinritqaasqelluni."
        },
        "35": {
            "start": 593.27,
            "end": 606.38,
            "transcript": "Nangyarnartaciani-gguq ciunerkani keneq tauna iivkaqaasqumallrunricaaquq. Akqiyaaqluni-llu-gguq pinqigngaitniluni."
        },
        "36": {
            "start": 606.38,
            "end": 621.39,
            "transcript": "Angalkum taum ukveqevkenaku iivkalliniluku tua-i taqluni alangrunqigtevkenani tua-i tayima, carayak taun' carayayagamek amarluni."
        },
        "37": {
            "start": 621.91,
            "end": 636.4,
            "transcript": "Tauna-gguq carayaullermini alingnarqellruuq, tuamtellu waniw' waten pitariluku quliriurarraarlua taq'urlullruuq [?] im' aataput."
        },
        "38": {
            "start": 636.4,
            "end": 659.83,
            "transcript": "Tuamtellam qanemcitaanga carayagtuli-gguq tauna nuna. Tua-i-gguq tua-i carayagtuli tauna tua-i carayauguq tua-i carayaunguarluteng tua-i taun' una taukut carayagnek imarrluteng."
        },
        "39": {
            "start": 659.83,
            "end": 673.0,
            "transcript": "Tua-llam tua-i yun'errat iliitni waten tua-i unugmi ikamrarluni tekicamiki taukut allauguq man'a au͡g'umi tuakenritaat [?]."
        },
        "40": {
            "start": 673.0,
            "end": 690.12,
            "transcript": "Tekicamiki tua-i nani qavarvigtailami tamaa-i qasgimun itliniluni qimugteḿinek ilaluni, tua-i nuna qavarvigtailami."
        },
        "41": {
            "start": 690.12,
            "end": 703.0,
            "transcript": "Itertuq-gguq maaten unugcuullugpaungami-ll' itqellermi kiugna qanikcaq waten-gguq tua-i qanikcaq."
        },
        "42": {
            "start": 703.0,
            "end": 713.36,
            "transcript": "Qanikcaq elliini qanikcaq itrugaraat, imumek tua-i kaimurarallermun ellii ayuqekulluki tauna."
        },
        "43": {
            "start": 713.36,
            "end": 729.4,
            "transcript": "Tua-i-ll' tua-i-am caniqaarmun aqumqerluni qimugteminek tua-i avacia ilaluni aqumelliniluni qavaqatarluni."
        },
        "44": {
            "start": 729.47,
            "end": 746.36,
            "transcript": "Tua-i kiugna kiani paqnakqaqluku piinanrani tua-i-ll' kiugna pek'artelliniuk aren alingallagyaaqekili-gguq tua-i alingallak'acagarluni."
        },
        "45": {
            "start": 746.36,
            "end": 762.0,
            "transcript": "Qimugteńi tau͡gaam tegumiaqluki pilliniluki. Tua-i-ll' tua-i pinginanrani kiugna qanlliniuq."
        },
        "46": {
            "start": 763.0,
            "end": 778.77,
            "transcript": "Carayagmun pinayukluteng maa-i-w' mayurtuarqatarameng [?]. Aling tua-i-ll' tua-i piinanrani tua-llu-gguq qakemna agviirteńgaartuq."
        },
        "47": {
            "start": 778.77,
            "end": 795.41,
            "transcript": "Qaillun tua-i neperlurrluni qaillur ayak [?] tua-i nepii man'a ayuqluni alingnaqluni qimugtai-llu-gguq ukut tua-i qengatgia qaquluteng ugaan alingem [?]."
        },
        "48": {
            "start": 795.41,
            "end": 822.0,
            "transcript": "Tua-llu-gguq piinanermini agna kiugna inerquangartelliniuq qagaa-i qasgim akiakun qagaa-i tua-i angelraralliniluni tauna it'rugarallernga [?], kan'urarrallerngalngut [?]. Amiik tua-i tekican niitaa maa-i."
        },
        "49": {
            "start": 823.0,
            "end": 844.75,
            "transcript": "Cakma tua-i calullinilutek tua-i cakma tua-i arenqianek [?] carayak tauna tua-i taum carayaurrlu' [?] piluku tua-i tayima."
        },
        "50": {
            "start": 844.75,
            "end": 857.0,
            "transcript": "Maa-i tayima iterluki tua-i-llu yugtaituq-qaa?"
        },
        "51": {
            "start": 857.0,
            "end": 871.13,
            "transcript": "Tua-i cakma tua-i amiigmi calluglutek, callullinilutek temya [?] angruyagluni tua-i cakma tayima-ll' tuamtellu-gguq."
        },
        "52": {
            "start": 871.13,
            "end": 884.26,
            "transcript": "Tua-i-ll' tua-i piqerluni tauna-am imna ayuqucirramitun itliniuq."
        },
        "53": {
            "start": 884.26,
            "end": 891.26,
            "transcript": "Cali-am kallagciiqell' tegumiaqluku-llam itenrituq [?]."
        },
        "54": {
            "start": 891.26,
            "end": 916.88,
            "transcript": "Kitelliniuq ayuqucirramitun tuamtell' maa-i itralliniluni qava-i ellminun-llu tuavet tua-i tekicami arulairngami tuklulliniuq kitaki tutgar-llu nutaan carayiim piciqenritaaten camek pivkenak qavangcaar."
        },
        "55": {
            "start": 916.88,
            "end": 931.02,
            "transcript": "Qavarniipagta-wa alingurlullermini aren tua-i unuakuani tauna-im uptelliniuq."
        },
        "56": {
            "start": 931.02,
            "end": 942.0,
            "transcript": "Qimugteńi tua-i assircarluki tua-i-am tamaa-i pinqigngaitnirraarcelluni carayagmun."
        },
        "57": {
            "start": 942.0,
            "end": 950.0,
            "transcript": "Ek'arrluni ikamragmi qimugtait taukut ayakpalliniluteng tua-i cukangkacagarluteng."
        },
        "58": {
            "start": 950.0,
            "end": 958.62,
            "transcript": "Aling kitnguyuitelarpaa-lli ikamraitni aling aren tua-i."
        },
        "59": {
            "start": 958.62,
            "end": 971.7,
            "transcript": "Tua-i-gguq tauna nuna nani-ll' tamaani carayagtulimek atengqertuq tauna, tua-i niitellruaramnek qanemcit'laramci."
        },
        "60": {
            "start": 971.7,
            "end": 986.88,
            "transcript": "Mat'umek maa-i qanemcit'laqemci qanemcitamci wangnek qanemcitenritamci tangvallrunritaqa."
        },
        "61": {
            "start": 986.88,
            "end": 1003.0,
            "transcript": "Tua-lli tua-i ava-i-am tua-i iquklilluni iquklitenricaaqlilria tayima, tamaa-i kingunermini tekicami tua-i qanemcillrulria tua-i taumek carayagtulimek."
        },
        "62": {
            "start": 1003.0,
            "end": 1029.0,
            "transcript": "Tua-llam tua-i taumek kassauluni-gguq iliarullilria-wa [?] tekicami tua-i kingunermini au͡gna-ll' tang tayima qanerkaqa nalluyaguartelliniluni. Tua-i waniw' unimqerqa atam waniw' qangengataqa."
        },
        "63": {
            "start": 1029.0,
            "end": 1042.1,
            "transcript": "Kaaruskan [?] tau͡gaam qanemciiqaqa. Ak'a tang qanemciurarqata waten atakumi alingnaqkacagatullrulria."
        },
        "64": {
            "start": 1042.1,
            "end": 1059.73,
            "transcript": "Atakumi-llu anllerkaq alingnarqetullruluni qanemciuralriami niicugniaqamta, waten-llu uitaurluteng, au͡gna-qaa qanelqa niicugnia."
        },
        "65": {
            "start": 1059.73,
            "end": 1066.6,
            "transcript": "Camek ava-i qanercit?"
        },
        "66": {
            "start": 1066.6,
            "end": 1088.0,
            "transcript": "Waten qanemcilriamek niitaqamta alingkacagatuluta qasgimi-llu iterluta. Waten qanemcilrianek niicugniurarqamta ala-i ik'acagamta-ll' anesciigataqluta yuk tau͡gaam maligarrluku anqercugngaluta, maligarcugngaluku."
        },
        "67": {
            "start": 1088.49,
            "end": 1108.0,
            "transcript": "Alingkacagayarnaurtukut qasgimi waten qanengssaararqata imkut payugkengluteng-llu payugtellrianiu ellam wii [?] maliksugtatullruama [?] qanemci, qanemcimek-gguq niicarturlua tamaa-i carayagtullratni."
        },
        "68": {
            "start": 1108.36,
            "end": 1129.0,
            "transcript": "Tua-i-ll' tua-i ingna nallunrilkengaqa ingna'urluq ap'aci Kayungyaar, Cyril Alexie, takuk'acagamni waten qanemcillrulria elliin pillminek, ellii pilqapiaraminek."
        },
        "69": {
            "start": 1129.04,
            "end": 1140.56,
            "transcript": "Waten qanemcillruuq qasgimek, enemeggnek-gguq anluni, anngami-gguq-am qasgimun ag'uq."
        },
        "70": {
            "start": 1140.56,
            "end": 1148.96,
            "transcript": "Tua-i atam ingkayungyaar qavaitkacagatullruuq-llu tua-i tupagyara'arluni tuamtell'."
        },
        "71": {
            "start": 1149.0,
            "end": 1161.0,
            "transcript": "Inangqaurayuunani-llu tua-i inangqaurluku-ll' waniw' tangellrunritaqa."
        },
        "72": {
            "start": 1163.73,
            "end": 1181.6,
            "transcript": "Tua-i-ll' tua-i-am enemeggnek anngaami qanemcilliniuq aggliniuq, maaten-gguq qasgim una amiigan yaaqsikaqii piqalliniuq yugyangni nanerngalria [?] ciungani."
        },
        "73": {
            "start": 1181.6,
            "end": 1193.4,
            "transcript": "Tua-i-ll' tekicamiu waniw' nangerrluni. Nangercami-gguq igvaqussaagyaaqekini una-gguq uivkaniiq'."
        },
        "74": {
            "start": 1193.4,
            "end": 1215.9,
            "transcript": "Ataam-gguq narukanirluku ukatmun pikaniryaraq uivkaniraqluku. Tua-i-gguq tuaten narugaluku alqunamek-llu uivkanirterluni igvaarcaaqaqani, angtua pitacirturluku uivkaniraqluni."
        },
        "75": {
            "start": 1217.0,
            "end": 1239.34,
            "transcript": "Tua-i umyuani pingan yaaqvaqanirluni waniw' tua-i aturait tangvallinii maaten tua-i elitaqluku waniwa tauna tuqullret iliit canek ima tanem atkungqerrnillruut."
        },
        "76": {
            "start": 1240.0,
            "end": 1262.33,
            "transcript": "Ak'a-ll' imkut tuqullret kegginait patuluki qungitetullrukai. Nalirneq tamana patuan inglua iigiingaluki tamaa-i atkuit taukut tua-i elitaqluki tua-i."
        },
        "77": {
            "start": 1262.33,
            "end": 1272.39,
            "transcript": "Tua-i cacirkailami tua-i kingupiarturluni tangvaagarluku yaa-i."
        },
        "78": {
            "start": 1272.39,
            "end": 1284.22,
            "transcript": "Maaten-gguq tang im' yaaqsigngan [?] yaavet tangrraa nunamun maavet tusnganritlinilria carayakaacaq."
        },
        "79": {
            "start": 1284.22,
            "end": 1302.44,
            "transcript": "Tusngavkenani tua-i ilirqurluni maligquryaaqluku. Yaaqsian-gguq tua-i amigteng taun' pekicami piciqiarraangcar' pecillini' [?]."
        },
        "80": {
            "start": 1302.44,
            "end": 1311.77,
            "transcript": "Qerruciatun-gguq taum aulukesturlullran-am pilliniararluni. Qaill' pisit?"
        },
        "81": {
            "start": 1311.77,
            "end": 1329.0,
            "transcript": "Tua-i-gguq qanrutkenricaaqerraaluku qanrutekluku. Elitaqluku tua-i aterpaggluku taukut atkui-llu tangellni taukut apertualuki pillra."
        },
        "82": {
            "start": 1329.0,
            "end": 1341.47,
            "transcript": "Tua-i-llu elitaqluku Uyarrlugaam uum atra [?] atam ingkayungiar alangrukumi alangrukuyaullrulria."
        },
        "83": {
            "start": 1341.47,
            "end": 1361.67,
            "transcript": "Tuamtell'-am yaani avani iciw' Uqsuggaam ceńiini muraganek-am quyurqilliniuq tua-i arenqianani piyugteqluni, tamaa-i-ll' tua-i atmiuqatarluni qayamitulirnera kanavet tangerqalliniuq yugnarngall' [?]."
        },
        "84": {
            "start": 1361.67,
            "end": 1376.98,
            "transcript": "Tua-i cacet aviqerpall'aarluni [?] atmiulliniluni tua-i atmani taukut muragat tegumiaqluki tua-i atrautelliniluki qayami."
        },
        "85": {
            "start": 1376.98,
            "end": 1389.5,
            "transcript": "Imna-gguq tang murilkenriqaarluku taun' yuk imna nangernalleq piyaaqata ima cataunani, una-llu urnellrat tekitengraani tua-i im' callrunani tua-i."
        },
        "86": {
            "start": 1389.74,
            "end": 1411.0,
            "transcript": "Tua-i qayaminun waniw' tekicami muragat taukut ekurraarluki ayalliniluni aren ayakarluni-gguq waniw' Cevv'arnermun iterluni ayuquciaman uqamaitkacaganglliniluni tua-i uqamaitkacagangluni."
        },
        "87": {
            "start": 1411.0,
            "end": 1434.0,
            "transcript": "Waniwa-ll' nunanun tekilluni, uatiitnun-llu tua-i tagluni, allani paqumangnaqluku miryarallruuq miryarallruniyugnarquq camek, camek wall' tua-i cungaglimek."
        },
        "88": {
            "start": 1434.0,
            "end": 1440.23,
            "transcript": "Tua-i waniw' unisqurluan-gguq tekilluku waniw' qaill' pisiaraluku [?]."
        },
        "89": {
            "start": 1440.47,
            "end": 1456.24,
            "transcript": "Tua-i-gguq alangrupiggluni alangruyaaqellinilria, kituuga-gguq tayima tauna alangruq kiagmi avani Uyarrlugaam ceńiini."
        }
    },
    "GDRR8mgHBTk": {
        "1": {
            "start": 64.92,
            "end": 67.16,
            "transcript": "Waqaa."
        },
        "2": {
            "start": 67.16,
            "end": 72.0,
            "transcript": "Cangaceci atakurpak Qaariitaarviim nalliini."
        },
        "3": {
            "start": 72.0,
            "end": 81.0,
            "transcript": "Qaariitaarvik atuqiit alanruut, ircenraat, cali-llu makut angalkullraat"
        },
        "4": {
            "start": 81.0,
            "end": 84.1,
            "transcript": "atakurpak Qaaritaarviim nalliini."
        },
        "5": {
            "start": 84.12,
            "end": 97.84,
            "transcript": "Maani KYUK-tgun nasvagceciqatartukut makunek qalamciqatalrianek makunek alangrunek alingnaqellrianek piciatun maaken nunamta iluanek avatemnek."
        },
        "6": {
            "start": 97.84,
            "end": 101.66,
            "transcript": "Quyanaqvaa tangvakatarluci."
        },
        "7": {
            "start": 101.96,
            "end": 104.9,
            "transcript": "Anglanikici."
        },
        "8": {
            "start": 120.82,
            "end": 132.0,
            "transcript": "Tua-i-llu qanemcit makut ayuqsuitelaameng tua-i niitellrucimtun una ayagniqatarqa."
        },
        "9": {
            "start": 132.18,
            "end": 146.56,
            "transcript": "Qagaani Qaluyaat Askinrat [?] neglegenratni [?] kuigtangqellria atengqerrluni Qip'ngayagmek."
        },
        "10": {
            "start": 146.56,
            "end": 160.08,
            "transcript": "Ak'a tamaani yugtangqellrullinilria taumek yuungnaqelriamek aipangqerrluni."
        },
        "11": {
            "start": 161.38,
            "end": 172.62,
            "transcript": "Tua-i-llu aipaa tauna nulirra irninerrluggluni yuunrilliniluni."
        },
        "12": {
            "start": 172.62,
            "end": 181.98,
            "transcript": "Yuunrian-llu tua-i taumek irniaranek malilirluku qungulliniluku."
        },
        "13": {
            "start": 182.0,
            "end": 196.7,
            "transcript": "Tauna-llu atiik qungurraarluku atraami tamaani canek saskunek"
        },
        "14": {
            "start": 200.26,
            "end": 211.4,
            "transcript": "inerquumaluki pitullratni saskumek pilliniluni, ellii-llu tuquluni maligucugyaaqluni umyuarteqluni."
        },
        "15": {
            "start": 211.5,
            "end": 225.3,
            "transcript": "Tua-i-llu tauna imna irniara tauna qalervanglliniluni tuani qunguumallrani."
        },
        "16": {
            "start": 226.78,
            "end": 234.28,
            "transcript": "Tua-i-llu tuaten pinga'arcan alangrulangluni pinga'arcan,"
        },
        "17": {
            "start": 234.28,
            "end": 249.64,
            "transcript": "taum taukut-wa nunat yuirutenglliniluteng pakmavet uksiyarameggnun upagangluteng."
        },
        "18": {
            "start": 249.68,
            "end": 268.0,
            "transcript": "Cali tau͡gken tuaken taukurmiut iliitnek amavet Qissunamun nengaugitamek tan'gurrarmek pitangqelliniluni."
        },
        "19": {
            "start": 269.24,
            "end": 280.34,
            "transcript": "Tua-i-llu tauna nengaugitaq tuani tua-i cakimini uitalliniuq."
        },
        "20": {
            "start": 280.34,
            "end": 293.46,
            "transcript": "Taukut-llu tua-i yuirulluteng, yuirutengluteng taukut kiagillret, neqlillret taukut."
        },
        "21": {
            "start": 293.46,
            "end": 304.02,
            "transcript": "Maa-i-llu uksuqu elriqatalliniluteng taukut nunat."
        },
        "22": {
            "start": 304.02,
            "end": 319.64,
            "transcript": "Tua-i-llu pinarian tua-i uksuumainanrani yuut imkut quyurtenglliniluteng tauvet Amigtulimun."
        },
        "23": {
            "start": 319.64,
            "end": 325.72,
            "transcript": "Amigtulirmiunek taukut atengqelliniameng uksillrit."
        },
        "24": {
            "start": 327.66,
            "end": 332.16,
            "transcript": "Quyurtengluteng yugyangluteng."
        },
        "25": {
            "start": 334.52,
            "end": 348.52,
            "transcript": "Tua-i-llu taukuk tauna Qissunamiunun nengaugitaq pisqengatni tua-i"
        },
        "26": {
            "start": 348.52,
            "end": 360.52,
            "transcript": "upiqalliniluni ullautnaluni tauvet ilaminun nunalgutminun."
        },
        "27": {
            "start": 360.52,
            "end": 373.6,
            "transcript": "Uptellrani-am taum tan'gurraaraam taum cakiriin maligcugluku-wa pilliniluku."
        },
        "28": {
            "start": 373.6,
            "end": 387.32,
            "transcript": "Tua-i-am qinuyaaqellinia taum nengaungan qaillun pikan alingurnarqeciqniluku."
        },
        "29": {
            "start": 387.32,
            "end": 396.5,
            "transcript": "Tua-i-llu pingraani tua-i aguaggluni maligcullinia."
        },
        "30": {
            "start": 396.5,
            "end": 406.56,
            "transcript": "Taukuk tua-i angayuqaagken pilliniak tua-i malikesqelluku."
        },
        "31": {
            "start": 406.56,
            "end": 414.76,
            "transcript": "Tua-llu taum nengaungan piyaaqellinia tangerrluku,"
        },
        "32": {
            "start": 414.76,
            "end": 425.64,
            "transcript": "\"Qaillun pikuvet alingurnarqellerkan pitekluku tua-i maliksuumiicaaqekemken.\""
        },
        "33": {
            "start": 425.64,
            "end": 440.0,
            "transcript": "Taum tan'gurraam pillinia, \"Tua-i-wa elpet tau͡gaam alingurnarqellerkan pitekluku waniwa maligcugamken.\""
        },
        "34": {
            "start": 440.0,
            "end": 442.18,
            "transcript": "Tua-i malikellinia."
        },
        "35": {
            "start": 442.18,
            "end": 453.72,
            "transcript": "Maliklutek tuavet Amigtulimun ullautelliniuk."
        },
        "36": {
            "start": 453.72,
            "end": 476.0,
            "transcript": "Tua-llu tuaken Amigtulimek kinernissaalriik tuavet Qip'ngayagmiunun taum tuquvillranun irniaminek maligluni tua-llu aqvailliniuk."
        },
        "37": {
            "start": 479.18,
            "end": 491.32,
            "transcript": "Tekicartulliniuk ingkut nunat taukut yugmek au͡g'umek pektesterluteng."
        },
        "38": {
            "start": 491.32,
            "end": 504.56,
            "transcript": "Maaten tua-i mallgutliniuk tuavet nunanun arnaq au͡gna pektellria amarluni mikelngurmek."
        },
        "39": {
            "start": 504.56,
            "end": 514.06,
            "transcript": "Nem'un uumun itraqami tayimnguluni tua-i muluqalalliniuq."
        },
        "40": {
            "start": 514.06,
            "end": 530.36,
            "transcript": "Akaarnun tua-i tayimnguqerluni kiaggun egkuakun anluni, an'aqami allamun uumun itraqluni."
        },
        "41": {
            "start": 530.36,
            "end": 543.64,
            "transcript": "Tua-i taukuk imkuk tuavet neqsaugimegnun [?] ciunirlutek mayurrvigmun qimugtetek tua-i"
        },
        "42": {
            "start": 543.64,
            "end": 562.68,
            "transcript": "maavet naparyainun petukturluki, petukturraarluki-llu mayurlutek tua-i muragamek mayurautengqetullratni ak'lirturluku."
        },
        "43": {
            "start": 562.68,
            "end": 580.94,
            "transcript": "Qaqiucamek mayurlutek tamana-llu mayurautsek [?] maavet manulqerranun mayurrluku uitallinilutek tua-i, uitaqerlutek tua-i neramcilliuk tuani."
        },
        "44": {
            "start": 580.94,
            "end": 593.54,
            "transcript": "Tua-i-llu neramciinanragni neraksugglutek tayima piinanragni camna aciagnek qanlliniuq,"
        },
        "45": {
            "start": 593.54,
            "end": 600.72,
            "transcript": "\"Ataki una mikelnguq neqkaaraanek piqertuu.\""
        },
        "46": {
            "start": 600.72,
            "end": 611.48,
            "transcript": "Maaten tua-i maaggun akulqucugteggun qinqerlutek acitmun tanglliniak."
        },
        "47": {
            "start": 611.48,
            "end": 619.1,
            "transcript": "Kan'a arnaq imna kana-i mikelngurmek amarluni."
        },
        "48": {
            "start": 619.1,
            "end": 630.06,
            "transcript": "Tua-i tamaaken kinernequinermek pipeskaullutek akulqucugkun ig'arcecillinilutek."
        },
        "49": {
            "start": 630.06,
            "end": 633.5,
            "transcript": "Camna-i [?] migpallartelliniuq."
        },
        "50": {
            "start": 633.5,
            "end": 643.3,
            "transcript": "Maaten tanglliniak taqa'aqva [?] kan'a nerrluminek iluqlilirluni tegukii."
        },
        "51": {
            "start": 643.3,
            "end": 650.52,
            "transcript": "Arenqianani tua-i quyaluni."
        },
        "52": {
            "start": 650.52,
            "end": 658.5,
            "transcript": "Tua-i taggliniluni tuavet qunguumavimi tungiinun."
        },
        "53": {
            "start": 658.5,
            "end": 663.74,
            "transcript": "Quyaqapiggluni tua-i tuani-gguq qanaallruuq,"
        },
        "54": {
            "start": 663.74,
            "end": 679.18,
            "transcript": "tua-i makut ukut wani nunat enet-wa ceńilarniluki camek neqkuinermek uumi mikelnguum neqkaaraanek yuaqcaarturlutek pilarnilutek."
        },
        "55": {
            "start": 679.18,
            "end": 684.64,
            "transcript": "Quyaqapiggluni tua-i taggliniuq."
        },
        "56": {
            "start": 684.64,
            "end": 690.26,
            "transcript": "Taukuk tua-i unugpak tuani uitallinilutek."
        },
        "57": {
            "start": 690.26,
            "end": 707.82,
            "transcript": "Tanqigyarangarcan uplutek ikamratek tamakut taukuk kinernernek neqnek ucilirlukek ayalliniuk."
        },
        "58": {
            "start": 707.82,
            "end": 718.08,
            "transcript": "Tua-i-llu ayagturaqerlukek cingunragni uka-i agiirtelliniluni."
        },
        "59": {
            "start": 718.08,
            "end": 729.94,
            "transcript": "Tua-i canimelliaqan man'a kingunertek camek ceterluku cetraarluku ayagaqlutek."
        },
        "60": {
            "start": 729.94,
            "end": 750.06,
            "transcript": "Tamaavet tua-i cetellragnun tekitaqami tua-i tayima muluuraqerluni tua-i akaarnun tua-i tayima mululnguqerluni  ataam alarutaqluni maligglukek."
        },
        "61": {
            "start": 750.06,
            "end": 755.8,
            "transcript": "Tuatnaaqlutek tua-i mallgingaqan."
        },
        "62": {
            "start": 755.8,
            "end": 769.4,
            "transcript": "Tua-i-llu tuavet tua-i uksillernun Qip'ngayagmun tekicamek atakuarmi tua-i."
        },
        "63": {
            "start": 769.4,
            "end": 787.52,
            "transcript": "Pinarian qasgimun, qasgi nek'uratullermeggni tamaani angutet, qasgimun tua-i ciunirlutek payugqaqliniluteng arnat anguteteng neqkalirluki."
        },
        "64": {
            "start": 787.52,
            "end": 795.58,
            "transcript": "Camek-llu tua-i qaneqsaunatek. Tauna iqukluku qanqaqsaunatek."
        },
        "65": {
            "start": 795.58,
            "end": 812.12,
            "transcript": "Tua-i tamakut payugqaqelriit nangvailgata qanlliniut tumellragnegun cam'umek yugmek agiirtellriamek."
        },
        "66": {
            "start": 812.12,
            "end": 824.34,
            "transcript": "Taukuk tua-i qanlliniut, nutaan unugpak pektainrilengraata pisqelluki."
        },
        "67": {
            "start": 824.34,
            "end": 833.3,
            "transcript": "Tua-i payugqaqelriit tamakut. Cunawa-gguq tua-i waniwa nangneq payuggluni."
        },
        "68": {
            "start": 833.3,
            "end": 846.52,
            "transcript": "Nangenrullinilria anluni-llu ak'anun-llu pivkenani."
        },
        "69": {
            "start": 846.52,
            "end": 859.6,
            "transcript": "Camna ukut wani qanlliniut, una wani amigteng una aurnermek elciarniluku."
        },
        "70": {
            "start": 859.6,
            "end": 875.7,
            "transcript": "Maaten tua-i uyanglluku amigteng pilliniut, ak'a tua-i ua-i amigmun keviutellrullinilria tauna maligtestiik."
        },
        "71": {
            "start": 875.7,
            "end": 898.44,
            "transcript": "Ugna-wa-gguq uani amiigem quliini tauna tua-i tan'gurraar kelutmun caumaluni, tauna Qissunamiuyaaq kelutmun caumaluni uitaaqell'."
        },
        "72": {
            "start": 898.44,
            "end": 911.24,
            "transcript": "Tua-i arenqianateng ukut angalkut-llu tuunrangayiit tamakut tuunriqutulit amlletullratni tamaani."
        },
        "73": {
            "start": 911.24,
            "end": 921.2,
            "transcript": "Tua-i cayaaqelliniut tamakut angalkuteng atrarcetaqluki."
        },
        "74": {
            "start": 921.2,
            "end": 930.1,
            "transcript": "Tua-i-llu tamakut angalkut amllerpakarluteng, uumek-am ilangqelliniut angalkumek."
        },
        "75": {
            "start": 930.1,
            "end": 941.72,
            "transcript": "Tua-i avalillukluku yuut tamakut pitukiitnek avalilluutulimek [?]."
        },
        "76": {
            "start": 941.72,
            "end": 953.06,
            "transcript": "Tua-ll' tua-i tauna caqerluku-am atrartelliniuq tauna avalilluutuli qanaalluku,"
        },
        "77": {
            "start": 953.06,
            "end": 961.48,
            "transcript": "\"Nutaan nat [?] kitaki waniwa pisqumalria, pisqumakvut ugna nutaan caliaqiu.\""
        },
        "78": {
            "start": 961.48,
            "end": 973.64,
            "transcript": "Aren piyaaqekiitni tua-i cumiktagaluni tagqertelliniuq arenqianani tua-i."
        },
        "79": {
            "start": 973.64,
            "end": 986.62,
            "transcript": "Tua-i-llu piqerluni amigmun kan'a puggliniuq tauna tua-i itellria alangrukayak tauna."
        },
        "80": {
            "start": 986.62,
            "end": 993.56,
            "transcript": "Arenqiapaa-ll' yugugaat imkut qasgimiurugaat."
        },
        "81": {
            "start": 993.56,
            "end": 1002.84,
            "transcript": "Nasperturluteng tua-i quy'uqtaangelliniut maavet tua-i kapiangellermeggni."
        },
        "82": {
            "start": 1002.84,
            "end": 1016.86,
            "transcript": "Qasgi-llu man'a qilii man'a atraqtaarluni kan'a qaillun piqa'arqan atrartaqluni qilii pagna."
        },
        "83": {
            "start": 1016.86,
            "end": 1027.02,
            "transcript": "Maaggun-llu menglekun maaggun cupungluni nenglengluni man' qasgiq."
        },
        "84": {
            "start": 1027.02,
            "end": 1040.26,
            "transcript": "Tua-i-ll' tua-i tuaten tua-i kapiangluteng alingem ugaan' piinanermeggni."
        },
        "85": {
            "start": 1040.26,
            "end": 1054.5,
            "transcript": "Tauna-llu nengaugaq tauna Qissunamun nengaugitleq tauna-llu cakirani-llu tangerqautelliniu atunem."
        },
        "86": {
            "start": 1054.5,
            "end": 1065.48,
            "transcript": "Tangerqaucamek taum im' nengaugan pilinia tangerrluku,"
        },
        "87": {
            "start": 1065.48,
            "end": 1070.22,
            "transcript": "\"Maliksuumiinak pillruyaaqekemken."
        },
        "88": {
            "start": 1070.22,
            "end": 1085.9,
            "transcript": "Tua-i waten picirkan pitekluku, waniwa-llu alingurnarqeqataryaaqluten qaillun waniwa pikumta.\""
        },
        "89": {
            "start": 1085.9,
            "end": 1093.58,
            "transcript": "Atam tauna tan'gurrar tauna maktellinilria."
        },
        "90": {
            "start": 1093.58,
            "end": 1105.02,
            "transcript": "Makcami kan'a-wa-gguq ketiini waniwa amik tauna."
        },
        "91": {
            "start": 1105.02,
            "end": 1111.1,
            "transcript": "Makcami qanlliniuq,"
        },
        "92": {
            "start": 1111.1,
            "end": 1124.62,
            "transcript": "\"Man'a-qaa maqissuutmek pitangqerqan qimugtegnek-llu aliimalluugnek pitangqerqan piqerci.\""
        },
        "93": {
            "start": 1124.62,
            "end": 1132.84,
            "transcript": "Maqissuutmek cikilliniat qimugtegnek-llu aliimallugpiignek."
        },
        "94": {
            "start": 1132.84,
            "end": 1148.9,
            "transcript": "Tauna maqissuun teguamiu taukuk-llu maaken qulminek aglumek maaken puyuqnermek unatni tanukaulluki."
        },
        "95": {
            "start": 1148.9,
            "end": 1158.0,
            "transcript": "Maavet tua-i qauraminun minguutelliniluku tamana puyuqnek."
        },
        "96": {
            "start": 1158.0,
            "end": 1167.88,
            "transcript": "Minguuterraarluku-llu nacaq tauna maqissuun at'elliniluku."
        },
        "97": {
            "start": 1167.88,
            "end": 1175.38,
            "transcript": "Ac'amiu cali qimugtek taukuk aliimalluuk all'ukek."
        },
        "98": {
            "start": 1175.38,
            "end": 1188.84,
            "transcript": "Atraarlukek kanavet tua-i aciminun taum alangrumta tunuanun irugni kanevvlukek."
        },
        "99": {
            "start": 1188.84,
            "end": 1206.84,
            "transcript": "Nikialuni [?] tua-i murugtelliniluni ualirneranun qanaalluku tuaten, Qissunarmiunguami Qissunarmiucetun qanaalluku tangerrluku,"
        },
        "100": {
            "start": 1206.84,
            "end": 1213.86,
            "transcript": "\"Qissunarmiut maavet qasgiatnun alartellriaten."
        },
        "101": {
            "start": 1213.86,
            "end": 1220.5,
            "transcript": "Ikayurturaqernaamken avitkaniqernga.\""
        },
        "102": {
            "start": 1220.5,
            "end": 1235.36,
            "transcript": "\"Qang'a.\" Taum ciunran pillinia, \"Qang'a, alartenritua maavet au͡gkuk kinernissaalriim maligglukek taillruunga.\""
        },
        "103": {
            "start": 1235.36,
            "end": 1252.94,
            "transcript": "Tuani ima-tanem yuut tamakut quy'uqtaangellermeggni qasgimun unatminek-gguq elqiirlini yuut tamakut kiartelaqai uivaqluni."
        },
        "104": {
            "start": 1252.94,
            "end": 1266.34,
            "transcript": "Tauna-ll' imna yuut pamani keluatni uitangraan tauna atasek qanrutekluku tua-i taunguniluku."
        },
        "105": {
            "start": 1266.34,
            "end": 1273.76,
            "transcript": "Taitesqelluku tua-i taitenrilkatgu waniwa tamalkuita piunrirciiqniluki."
        },
        "106": {
            "start": 1276.62,
            "end": 1280.3,
            "transcript": "Arenqiapaa-lli!"
        },
        "107": {
            "start": 1280.3,
            "end": 1288.66,
            "transcript": "Tauna imna taum qanaalluku tuaten tua-i irugni cu [?] piqtaarluku murugtelliniluni."
        },
        "108": {
            "start": 1288.66,
            "end": 1298.88,
            "transcript": "Murugcami, murugcingariami camavet qanlliniuq tauna tan'gurrar."
        },
        "109": {
            "start": 1299.38,
            "end": 1315.72,
            "transcript": "\"Atam kiivet alingnaqsukelriaten. Atam pistekagpet ak'a avatairumarillruagken. Atam cumikeqaa.\""
        },
        "110": {
            "start": 1316.78,
            "end": 1319.8,
            "transcript": "Arenqiapaa-lli!"
        },
        "111": {
            "start": 1319.8,
            "end": 1331.9,
            "transcript": "Camna uitaqerluni kapiangartelliniuq arenqianani tua-i pistekagni tamakuk tanglliamikek pillilria."
        },
        "112": {
            "start": 1331.9,
            "end": 1351.26,
            "transcript": "Tua-i-llu tua-i tayima murugcami tuaten-wa tua-i qanaaquraqerluku tua-i qanerturallra kumingurtelliniluni."
        },
        "113": {
            "start": 1351.26,
            "end": 1371.06,
            "transcript": "Kiatmun tayima qasgim egkuan tungiinun camaggun tua-i tayim nunam akuliikun qanerturallrak tayim' tayima umingurtelliniluni."
        },
        "114": {
            "start": 1371.06,
            "end": 1382.7,
            "transcript": "Tua-i tayim' umingurcan qanaanraagnek tua-i uitalliniluteng unugpak."
        },
        "115": {
            "start": 1382.7,
            "end": 1399.22,
            "transcript": "Atam tua-i unuumainanrani camaken amigmek tauna tua-i tan'gurrar egtellinilria tua-i kiavet egkumun tull'uni."
        },
        "116": {
            "start": 1399.22,
            "end": 1408.36,
            "transcript": "Tuc'ami urramek puyiallalliniluni."
        },
        "117": {
            "start": 1408.36,
            "end": 1421.82,
            "transcript": "Tauna tua-i maqissuun aliimalluuk-llu taukuk yuulukek tua-i nevumaluni evcilliniluni tua-i tuavet nangerrluni."
        },
        "118": {
            "start": 1421.82,
            "end": 1430.84,
            "transcript": "Pekcuggaarluni tua-i anlaagluni uavet eneminun."
        },
        "119": {
            "start": 1430.84,
            "end": 1436.5,
            "transcript": "Ugcami qanlliniuq,"
        },
        "120": {
            "start": 1436.5,
            "end": 1454.04,
            "transcript": "\"Ataki man'a qasgisi waten ayuqluni qasgiukaunrituq. Angalkuni amllertuci. Kiik' piluku kituggluku piciu.\""
        },
        "121": {
            "start": 1454.04,
            "end": 1465.12,
            "transcript": "Maaten tua-i yugugaat imkut cumikelliniut tamakut-llu angalkurugaat cumikluteng pilliniut."
        },
        "122": {
            "start": 1465.12,
            "end": 1475.4,
            "transcript": "Aren, qasgiat man'a talucianani tua-i pagna qilii ayuqellinilria."
        },
        "123": {
            "start": 1475.4,
            "end": 1477.56,
            "transcript": "Arenqiapaa-lli!"
        },
        "124": {
            "start": 1477.56,
            "end": 1493.1,
            "transcript": "Nutaan tua-i angalkut imkut qavcit-llu tayima piat atrarluteng nep'ngelliniluteng unani qasgim natrani tuunriluteng."
        },
        "125": {
            "start": 1493.1,
            "end": 1507.56,
            "transcript": "Atam tua-i tauna imna cungimcialuni tagqertelleq tauna avalilluutuli angalkut iliita qanlliniuq,"
        },
        "126": {
            "start": 1507.56,
            "end": 1516.52,
            "transcript": "\"Ciin tanem waniwa pilqa man'a piyugcaliqerpakarta?\""
        },
        "127": {
            "start": 1516.52,
            "end": 1533.18,
            "transcript": "Aren, tua-i tuaten qasgiseng tamana kitugtellia tua-i tuaten pillermeggni, nep'ngellermeggni tamakut angalkut."
        },
        "128": {
            "start": 1533.18,
            "end": 1540.52,
            "transcript": "Waten pitaluku man'a niitellrucimtun tua-i qanemcikqerqa."
        },
        "129": {
            "start": 1540.52,
            "end": 1547.04,
            "transcript": "Tua-i waten pitaluku taq'uq."
        },
        "130": {
            "start": 1553.54,
            "end": 1559.82,
            "transcript": "Ila-i! Tua-ll' wii qanemcitqernaumci."
        },
        "131": {
            "start": 1559.82,
            "end": 1566.68,
            "transcript": "Tauna-gguq ak'a imumi akimiarnek allrakurluni nasaurluquq."
        },
        "132": {
            "start": 1567.44,
            "end": 1581.48,
            "transcript": "Tamaani-llu uingnaluni umyuarteqeksaitellmi nalliini imumi tua-i aquimqeggiqerluni pilria."
        },
        "133": {
            "start": 1581.48,
            "end": 1590.56,
            "transcript": "Cami tayima nayurinanrani mikelngurnek angayuqaak taukuk mikelnguq calillinilutek."
        },
        "134": {
            "start": 1590.56,
            "end": 1599.96,
            "transcript": "Tua-i-ll' tauna nasaurluq nayurinanrani cam-gguq uum tan'gaurluum itqii ciungani-llu-gguq tangeqsaunaku atakumi."
        },
        "135": {
            "start": 1599.96,
            "end": 1608.56,
            "transcript": "Tua-i-llu-gguq tang itrami uum tan'gaurluum tauna nasaurluq tua-i caumaluku arenqialkii ellii nallunritniluku."
        },
        "136": {
            "start": 1608.56,
            "end": 1614.8,
            "transcript": "Tua-i-llu-gguq atakurpak tua-i qanengssaarautaqlutek piqerlutek-gguq."
        },
        "137": {
            "start": 1614.8,
            "end": 1620.0,
            "transcript": "Taum wani tan'gaurluum nasaurluq tauna apeskilliu,"
        },
        "138": {
            "start": 1620.0,
            "end": 1623.82,
            "transcript": "\"Waqaa, uiksunritarpenga?\""
        },
        "139": {
            "start": 1623.82,
            "end": 1627.94,
            "transcript": "Nasaurluq tauna takuyaarrluni tauna angun pillinia,"
        },
        "140": {
            "start": 1627.94,
            "end": 1632.18,
            "transcript": "\"Usuurluuq, tuaten qalarteksaunak."
        },
        "141": {
            "start": 1632.18,
            "end": 1637.02,
            "transcript": "Uingnalua wii umyuarteqeksaitua. Uingengaitua.\""
        },
        "142": {
            "start": 1637.02,
            "end": 1641.56,
            "transcript": "Aren-gguq tauna tan'gaurluum tauna nasaurluq pikii,"
        },
        "143": {
            "start": 1641.56,
            "end": 1646.72,
            "transcript": "\"Aren, nallunritamken. Ciunerkan tangvagaqa."
        },
        "144": {
            "start": 1646.72,
            "end": 1649.98,
            "transcript": "Uingeciquten irnialingluten-llu.\""
        },
        "145": {
            "start": 1649.98,
            "end": 1651.74,
            "transcript": "Aren, nasaurluq tauna piuq,"
        },
        "146": {
            "start": 1651.74,
            "end": 1659.16,
            "transcript": "\"Aling, kaggagtenrilu. Tamakunek qalartenrilu. Tuaten pingaitua.\""
        },
        "147": {
            "start": 1659.16,
            "end": 1665.2,
            "transcript": "Aren-gguq tan'gaurluq tauna qenertellria niitenritniluni waten-gguq qanertuq,"
        },
        "148": {
            "start": 1665.2,
            "end": 1674.08,
            "transcript": "\"Usuurluuq, kingunemnun utreskuma aanaka angalkuuguq. Aanaka qanrutarkaugaqa.\""
        },
        "149": {
            "start": 1674.08,
            "end": 1685.54,
            "transcript": "Tua-i-llu-gguq uksuarluni, tuani tua-i up'nerkami nulirrniallruluku, kiagluni-llu-gguq uksuarluni-llu-gguq."
        },
        "150": {
            "start": 1685.54,
            "end": 1692.1,
            "transcript": "Nasaurluum-llu-gguq tauna nulirrniarciullni nalluyagulluku umyuaqenrirluku."
        },
        "151": {
            "start": 1692.1,
            "end": 1706.78,
            "transcript": "Caqerluni atam atakumi tua-i inarteqatarluteng uptellinilriit imumi iralvagyaurrluni."
        },
        "152": {
            "start": 1706.78,
            "end": 1709.9,
            "transcript": "Inarteqatarluteng-gguq upluteng."
        },
        "153": {
            "start": 1709.9,
            "end": 1716.9,
            "transcript": "Tua-i-gguq tauna nasaurluq ca piciinaku alingyuicaaqellria."
        },
        "154": {
            "start": 1716.9,
            "end": 1729.56,
            "transcript": "Alingqernaurtuq tatamqeryugluni-llu, cat-llu-gguq kallagartaqata wall' cat pivallaka'arqata tatamqeryugluni."
        },
        "155": {
            "start": 1729.56,
            "end": 1737.54,
            "transcript": "Tua-i-ll' tamana tuaten tatamqeryugturangermi ellminek waten aptaqluni,"
        },
        "156": {
            "start": 1737.54,
            "end": 1742.86,
            "transcript": "\"Qaill' piama ciin wii alingyugpakarcia? Alingyuitua-ggem.\""
        },
        "157": {
            "start": 1742.86,
            "end": 1748.14,
            "transcript": "Tua-i-llu inarrnarian inarrluni camek tua-i umyuarteqevkenani."
        },
        "158": {
            "start": 1748.14,
            "end": 1754.4,
            "transcript": "Tan'geqapiarmi-ll' inartelalliniami kengurrat nipluki kengurrailngurmi."
        },
        "159": {
            "start": 1755.88,
            "end": 1763.48,
            "transcript": "Inarrluni qavaqalliniluni-gguq egmianun akitni agtuamiu."
        },
        "160": {
            "start": 1763.48,
            "end": 1769.62,
            "transcript": "Aren, unuumiananrani-gguq ircaqurran kaugtualriim tuparqaa."
        },
        "161": {
            "start": 1769.62,
            "end": 1773.54,
            "transcript": "Maaten-gguq uituq alingqapiarluni."
        },
        "162": {
            "start": 1773.54,
            "end": 1779.72,
            "transcript": "Ircaqurr-allu nutengvagluni qanra-llu igyaraa tekiluku kinerrluni."
        },
        "163": {
            "start": 1779.72,
            "end": 1792.64,
            "transcript": "Alingluni-gguq tua-i camek makluni-llu-gguq aqumluni avatni man'a kiaraluku tan'germi camek tangerrnailengraan."
        },
        "164": {
            "start": 1792.64,
            "end": 1798.14,
            "transcript": "Tua-i-gguq elpekluku ellii tua-i cam piqataqii."
        },
        "165": {
            "start": 1798.14,
            "end": 1808.76,
            "transcript": "Arenqialami qaneni kinercan ingleminek atrarluni uavalliniluni meqsarturluni."
        },
        "166": {
            "start": 1808.76,
            "end": 1812.82,
            "transcript": "Merraarluni-llu-gguq ilait-llu-gguq qavarluteng."
        },
        "167": {
            "start": 1812.82,
            "end": 1817.18,
            "transcript": "Merraarluni-llu-gguq tua-i ataam uterrluni."
        },
        "168": {
            "start": 1817.18,
            "end": 1825.7,
            "transcript": "Ingleminun inarrluni kelutmun cauluni inangqayaaquq-gguq qavarciiganani alingluni."
        },
        "169": {
            "start": 1825.7,
            "end": 1832.88,
            "transcript": "Tan'germek-ll' alingyuicaaqellria tan'geqitellerminek-llu-gguq alingluni tamaa-i."
        },
        "170": {
            "start": 1832.88,
            "end": 1841.78,
            "transcript": "Egaleni-ll' tua-i ukut wani egalerpallraat ciuqamini inglemi tunuatni uitalriit ikirtelliniluki, aren iralvagluni-gguq."
        },
        "171": {
            "start": 1841.78,
            "end": 1847.64,
            "transcript": "Tua-i maaten-llu-gguq kiartuq ca tamalkuan tangerrsugngaluku iralian."
        },
        "172": {
            "start": 1847.64,
            "end": 1851.64,
            "transcript": "Iraluq itqerrluni egalerteggun."
        },
        "173": {
            "start": 1851.64,
            "end": 1856.66,
            "transcript": "Tua-llu-gguq ataam inarrluni ellminek-gguq qanrutuq,"
        },
        "174": {
            "start": 1856.66,
            "end": 1865.16,
            "transcript": "\"Aren, tua-i tanqigpagluku alingessiyaagngaitelliunga. Ataam naspaalua inarteqerlii.\""
        },
        "175": {
            "start": 1865.16,
            "end": 1869.5,
            "transcript": "Tua-i-ll' qacarneq caugarrluku kelutmun cauluni inarrluni."
        },
        "176": {
            "start": 1869.5,
            "end": 1881.34,
            "transcript": "Tua-i iigni uisngalukek uitauraqanrakun-gguq kia-gguq tang ingelrii aaluuyaarteskai qulmun negtaarluki pekluni-llu-gguq tamarmi."
        },
        "177": {
            "start": 1881.34,
            "end": 1884.2,
            "transcript": "Nutaan-gguq atam alingallalria."
        },
        "178": {
            "start": 1884.2,
            "end": 1891.84,
            "transcript": "Tua-i-ll'-am umyuarteqliniuq mumigcugluni ketmun."
        },
        "179": {
            "start": 1891.84,
            "end": 1901.17,
            "transcript": "Tua-i-llu tuaten tua-i kelutmun caumaluni inangqayaaqellermek cukailcaarturluni umyuarteqluni,"
        },
        "180": {
            "start": 1901.17,
            "end": 1907.36,
            "transcript": "\"Cam-kiq waniwa ingelrenka pektaarcetaki.\""
        },
        "181": {
            "start": 1907.36,
            "end": 1912.02,
            "transcript": "Tua-i-llu-gguq tuigteqatarluni qetermi inglemini arulairluni."
        },
        "182": {
            "start": 1912.02,
            "end": 1920.94,
            "transcript": "Pektesciigatqapiarluni-gguq ilani-llu-gguq qavalriit qayagpagangnaqsaaqekai erinii anesciiganani."
        },
        "183": {
            "start": 1920.94,
            "end": 1930.66,
            "transcript": "Qigciminek-gguq ukalirnermek tangerrluni qamiqumek iralum itqertellriim mecignarqevkarluku."
        },
        "184": {
            "start": 1930.66,
            "end": 1937.02,
            "transcript": "Alingallalria-gguq tua-i-llu-gguq umyuartequq, \"Aling cauga-kiq wani.\""
        },
        "185": {
            "start": 1937.02,
            "end": 1947.6,
            "transcript": "Maaten-gguq ukatmun qamiquni caqirteqata'arluku-gguq tangrraa arnacilleq."
        },
        "186": {
            "start": 1947.6,
            "end": 1950.26,
            "transcript": "Qasperluni-gguq."
        },
        "187": {
            "start": 1950.26,
            "end": 1953.6,
            "transcript": "Waken-gguq ayagluni wavet tekiarrluni."
        },
        "188": {
            "start": 1953.6,
            "end": 1961.62,
            "transcript": "Ukugnegun taqurluni. Nuyai-gguq elleggluteng taqui-llu-gguq ellekayagluteng."
        },
        "189": {
            "start": 1961.62,
            "end": 1974.18,
            "transcript": "Maaten-gguq tang wavet meciknaurluku pia aciminun tusngavkenani arnall'er tauna qumicpaumaluni [?] taquminun ilarqusngaluni."
        },
        "190": {
            "start": 1974.18,
            "end": 1986.22,
            "transcript": "Uitavkenani-gguq qasperluni qiuglimek kavirlinek qaralilegmek kameksagluni-llu."
        },
        "191": {
            "start": 1986.22,
            "end": 1994.5,
            "transcript": "Iirpallraak-wa-gguq tua-i-gguq qakipiarluni unatminek-gguq qaneni patumaurqii."
        },
        "192": {
            "start": 1994.5,
            "end": 1998.21,
            "transcript": "Unatai-llu-gguq tua-i amimek caqumaluteng."
        },
        "193": {
            "start": 1998.21,
            "end": 2001.22,
            "transcript": "Cetugpallrai-wa-gguq."
        },
        "194": {
            "start": 2001.22,
            "end": 2008.62,
            "transcript": "Tua-i-gguq tauna tangellra augilnganani [?] cauciinani, yuuguq-gguq-qaa wall'u-gguq-qaa yuunrituq?"
        },
        "195": {
            "start": 2008.62,
            "end": 2012.34,
            "transcript": "Iirpallraak makuk wavet tangvakii."
        },
        "196": {
            "start": 2012.34,
            "end": 2025.68,
            "transcript": "Tua-ll' ulungnaqluku ulu'urcamiu ilani qayagpagangnaqlinikai, kiituan'-gguq taqsuqnguq."
        },
        "197": {
            "start": 2025.68,
            "end": 2037.16,
            "transcript": "Imkuk-llu-gguq mikelnguuk malruk unugmi uiteqicugtetulik aamalisqaqamek tupagyugpek'natek-gguq."
        },
        "198": {
            "start": 2037.16,
            "end": 2042.5,
            "transcript": "Ellii-wa-gguq callulria."
        },
        "199": {
            "start": 2042.5,
            "end": 2054.5,
            "transcript": "Tua-i-llu tuaten pingnaqsaaqerraarluni erinakegcaraqami-llu tau͡gken erinii assirluni anqertaqluni."
        },
        "200": {
            "start": 2054.5,
            "end": 2064.54,
            "transcript": "Qasturingnaqluni erinakegcaraqluni pingraan kitumek-gguq yugmek tuparqiyugpek'nani."
        },
        "201": {
            "start": 2064.54,
            "end": 2070.6,
            "transcript": "Tua-i-llu naspaalliniuq , \"Qaill'.\" Ellminek-gguq qanrutuq,"
        },
        "202": {
            "start": 2070.6,
            "end": 2078.9,
            "transcript": "Qaill' waniwa-qaa wiinga makngaitua, pekngaitua? Qangvarpak waten ayuqeqatarcia?\""
        },
        "203": {
            "start": 2078.9,
            "end": 2092.36,
            "transcript": "Tua-i-llu-gguq tang naspaaluni unatni pekcetaaqai-gguq, pektengelriit-gguq waten, elliupagaluki pekluteng."
        },
        "204": {
            "start": 2092.36,
            "end": 2097.42,
            "transcript": "Maaten-gguq ayuqucini man'a temni pia tamarmi pekluni."
        },
        "205": {
            "start": 2097.42,
            "end": 2103.04,
            "transcript": "Tua-i-ll' umyuarteqliniuq, \"Qaillun-kiq makeskuma piyartanga?\""
        },
        "206": {
            "start": 2103.04,
            "end": 2107.79,
            "transcript": "Tua-i-ll' talligni pamavet pilukek cingutegminek ayagnirluni."
        },
        "207": {
            "start": 2107.79,
            "end": 2112.54,
            "transcript": "Makteqtararalliniuq cukaunani cingluni ellminek."
        },
        "208": {
            "start": 2112.54,
            "end": 2116.72,
            "transcript": "Naggluni-llu-gguq arulairluni aqumeqerluni."
        },
        "209": {
            "start": 2116.72,
            "end": 2121.08,
            "transcript": "Atraqataryaaqellria ingleminek."
        },
        "210": {
            "start": 2121.08,
            "end": 2131.34,
            "transcript": "Naggluni-gguq ayasciiganani maaten-gguq-am maani uni [?] tangraa camek maani elpekngamiuq qukamini."
        },
        "211": {
            "start": 2131.34,
            "end": 2136.4,
            "transcript": "Pia-gguq-am man'a enerrlainaq talliq."
        },
        "212": {
            "start": 2136.4,
            "end": 2149.7,
            "transcript": "Cunawa-gguq-am taulkuum tua-i qaneni patumaurangermi ingluanek tallimi waten ellillinikii."
        },
        "213": {
            "start": 2149.7,
            "end": 2156.92,
            "transcript": "Tangrramiu-gguq-am tamana talliq unaqseqertellria ellminek-llu-gguq eggluni inglernun taklaqerluni."
        },
        "214": {
            "start": 2156.92,
            "end": 2159.98,
            "transcript": "Nutaan-gguq pektesciiganani."
        },
        "215": {
            "start": 2159.98,
            "end": 2164.5,
            "transcript": "Tua-ll' tuani calluktaumallinilria."
        },
        "216": {
            "start": 2164.5,
            "end": 2179.2,
            "transcript": "Kiituani-gguq tang takuyarluni tauna calkuk tauna call'er tangrraqamium pegnem, pegnem uluryaurtaa."
        },
        "217": {
            "start": 2179.2,
            "end": 2188.66,
            "transcript": "Kiingan-gguq tua-i qamiqurra pektaqluni taucillrem cam tangerqengami tungiinun-gguq qamiqurra qessaunani."
        },
        "218": {
            "start": 2188.66,
            "end": 2193.16,
            "transcript": "Tua-i-llu callulliniuq aaraangnaqluni."
        },
        "219": {
            "start": 2193.16,
            "end": 2204.08,
            "transcript": "Maaten-gguq tang elpenguq ellminek murilkuq ugaan taqsuqellmi-w' tua-i cakviullmi pitacian pillilria."
        },
        "220": {
            "start": 2204.08,
            "end": 2212.98,
            "transcript": "Kiiryungqapiaralliniluni-llu-gguq mer'et ser'a maaggun qurrlura'arluni."
        },
        "221": {
            "start": 2212.98,
            "end": 2220.0,
            "transcript": "Erinani antengnaqumaluku-gguq-am cikempagluni-llu-gguq aarangnaqaqluni."
        },
        "222": {
            "start": 2220.0,
            "end": 2225.36,
            "transcript": "Caqerluni-gguq cikempagluni erinani anenerturinaryaaqellrani."
        },
        "223": {
            "start": 2225.36,
            "end": 2231.66,
            "transcript": "Cikempagluni-gguq aarangnaqellria taqsuq'ngami-llu-gguq [?] iigni-gguq uitak."
        },
        "224": {
            "start": 2231.66,
            "end": 2242.36,
            "transcript": "Ukut-gguq-am enerrlainaat unatelkuut kegginaan quliini qanra patuqatarluku ukaqsigillrulliniluni-llu-gguq ak'a unatai."
        },
        "225": {
            "start": 2242.36,
            "end": 2254.78,
            "transcript": "Aaranritengnaq'ngarcan-gguq taum qacigarrluni uitaqaa, taulkuum cam tangerqengaan unatni cayukai."
        },
        "226": {
            "start": 2254.78,
            "end": 2265.96,
            "transcript": "Tua-llu-gguq cayuamiki taum wani takuyarluni wavet tangrramiu taum-gguq tangerqengaan pikii waten,"
        },
        "227": {
            "start": 2265.96,
            "end": 2274.5,
            "transcript": "\"Usuuq, ciin qetunrama nulirrniallraten niitellrunritciu."
        },
        "228": {
            "start": 2274.5,
            "end": 2278.84,
            "transcript": "Waniwa ullagamken tamana pitekluku.\""
        },
        "229": {
            "start": 2278.88,
            "end": 2284.76,
            "transcript": "Ala-i! Elliin-gguq kiuvkenaku camek tua-i tuaten qanrraartelluku tangerr'."
        },
        "230": {
            "start": 2284.76,
            "end": 2301.12,
            "transcript": "Ulungnaqngamiu ulungnaqluku tua-i-llu-gguq ulu'urcamiu ataam cali aarangnaqliniuq erinani tuaten kitugtaqluku erinaqegcaraluni."
        },
        "231": {
            "start": 2301.12,
            "end": 2309.7,
            "transcript": "Quspangnaqaqluni-llu-gguq tua-i cakviurluni pitaciremtun [?] cali pektesciiganani."
        },
        "232": {
            "start": 2309.7,
            "end": 2320.3,
            "transcript": "Qaillun-llu-gguq-llu tanem piami-llu tuani piicallerkaminek-llu umyuarteqenritlinia tuatnallermini."
        },
        "233": {
            "start": 2320.3,
            "end": 2331.56,
            "transcript": "Arenqiatellria-gguq pektengnaqluni, pektengnaqvakarluni-gguq pivakarluni neq'aqaraa unatmi pektellri."
        },
        "234": {
            "start": 2331.56,
            "end": 2339.68,
            "transcript": "Ataam-llu-gguq tua-i unatni pekcetaarluki, kiituan-gguq pektengut kiimeng-gguq waten elliurluteng."
        },
        "235": {
            "start": 2339.68,
            "end": 2343.96,
            "transcript": "Tua-ll' cali umyuarteqliniuq, \"Kaa [?] it'ganka pingaitut.\""
        },
        "236": {
            "start": 2343.96,
            "end": 2351.2,
            "transcript": "It'gani-gguq naspaaluki pekcetevkangnaqkai, kiituan-gguq waten unataicetun elliuryaurtuq."
        },
        "237": {
            "start": 2351.2,
            "end": 2356.46,
            "transcript": "Ataucikun-gguq pileryagaluni it'gani unatni-llu pekcetaaqai."
        },
        "238": {
            "start": 2356.46,
            "end": 2362.34,
            "transcript": "Ellminek-llu-gguq ingleni pekcetaqluki pileryagaluni piani."
        },
        "239": {
            "start": 2362.34,
            "end": 2367.28,
            "transcript": "Tuaten pingami umyuarteqliniuq,"
        },
        "240": {
            "start": 2367.28,
            "end": 2373.2,
            "transcript": "\"Unacilleq wani canaluni wani qeńarqa.\""
        },
        "241": {
            "start": 2373.2,
            "end": 2381.6,
            "transcript": "Tauna tua-i tuani alangrulria taumek qen'ngelliniluni taqsuq'ngellermini."
        },
        "242": {
            "start": 2381.6,
            "end": 2388.4,
            "transcript": "Tua-ll' piuq, \"Qaillun-kiq waniwa piniarta alqunaq mak'areskuma.\""
        },
        "243": {
            "start": 2388.4,
            "end": 2396.26,
            "transcript": "Tua-ll' tuaten uptelliniluni umyuartequ'urluni mak'arcugluni alqunaq piqataarpek'nani."
        },
        "244": {
            "start": 2396.26,
            "end": 2411.96,
            "transcript": "It'gani-am tua-i unatni-llu elliulliniut upluki umyuamikun tuaten una ca wani tangerqengani yulkuk ca arnacilleq arivqurluku."
        },
        "245": {
            "start": 2411.96,
            "end": 2422.7,
            "transcript": "Tua-llu-gguq tuaten tua-i piyugngariami cikempagluni alqunaq piqatarraarpek'nani mak'artelliniuq."
        },
        "246": {
            "start": 2422.7,
            "end": 2430.0,
            "transcript": "Kiingan-gguq tua-i niiskengangqertuq sugg'agtellriamek cingqullagluni-llu-gguq man'a ayuqucia."
        },
        "247": {
            "start": 2430.0,
            "end": 2439.42,
            "transcript": "Tanqigpallartellriamek-llu-gguq imutun kallugcuutet kenurrat burnout-araqameng pilalriit."
        },
        "248": {
            "start": 2439.42,
            "end": 2445.4,
            "transcript": "Tuaten-gguq tanqigpallarrluni, tuarpiaq-llu-gguq tarenrairisuutem kenurraa."
        },
        "249": {
            "start": 2445.4,
            "end": 2452.0,
            "transcript": "Tuaten tua-i mak'artellermini ayuqucia-ll' man'a cingqullagluni."
        },
        "250": {
            "start": 2452.0,
            "end": 2463.5,
            "transcript": "Mak'areskili-gguq tua-llu-wa-gguq tang ingleminek mak'arcami ayalria-gguq cukavkenani-gguq aciminun tut'eksaunani."
        },
        "251": {
            "start": 2463.5,
            "end": 2471.12,
            "transcript": "Atrarluni-llu-gguq atra', qulvaarkun-gguq ayalria cukavkenani."
        },
        "252": {
            "start": 2471.12,
            "end": 2478.64,
            "transcript": "Kaminiamun-llu-gguq, kaminiaq-llu-gguq nallairamiu atrarluni, atraryarturluni cukavkenani."
        },
        "253": {
            "start": 2478.64,
            "end": 2485.34,
            "transcript": "Atrallermini-llu-gguq nuyai nangerrluteng naparrluteng."
        },
        "254": {
            "start": 2485.34,
            "end": 2493.88,
            "transcript": "Migpallaguarpek'nani-llu-gguq natermun tut'ellria putukuk ciumek waten maqarpak."
        },
        "255": {
            "start": 2493.88,
            "end": 2497.82,
            "transcript": "Qainga-llu agtuutevkenani kaminiamun."
        },
        "256": {
            "start": 2497.82,
            "end": 2503.86,
            "transcript": "Kingutmun-gguq inglemi tungiitnun caumaluni tut'ellria kaminiam canianun."
        },
        "257": {
            "start": 2503.86,
            "end": 2508.08,
            "transcript": "Tua-ll' tuani nangengqaurluni ingleni-gguq tangvagai."
        },
        "258": {
            "start": 2508.08,
            "end": 2517.48,
            "transcript": "Imna-llu-gguq yuc'illeq arnacilleq tuani tangerqengallni piyaaqaa-gguq cataunani."
        },
        "259": {
            "start": 2517.48,
            "end": 2524.18,
            "transcript": "Tau͡gaam-gguq man'a ayuqucia qaillun ayuqluni kenertessnganani-llu-gguq [?]."
        },
        "260": {
            "start": 2524.18,
            "end": 2533.34,
            "transcript": "Tua-llu-gguq piyualuni agluni ataam ingleminun uterrluni inarcaaqellria."
        },
        "261": {
            "start": 2533.34,
            "end": 2541.16,
            "transcript": "Cikmirciiganani-gguq. Ala-i, cikmiryaraqami-gguq taumek imumek tangellminek tangrraqluni."
        },
        "262": {
            "start": 2541.16,
            "end": 2549.1,
            "transcript": "Arenqialami-ll' tua-i qavarngailami cikmirluni-gguq tua-i uitauraqeryaaqaqan tauna alairaqluni."
        },
        "263": {
            "start": 2549.1,
            "end": 2554.74,
            "transcript": "Naken-gguq maaken avatiinek sugg'illagaurluni."
        },
        "264": {
            "start": 2554.74,
            "end": 2567.44,
            "transcript": "Umyuarteqliniuq taumun cali alairviknayukluni  alingluni taum alairvikenrikeskani aipiriluni qaillun picirkani nalluamiu."
        },
        "265": {
            "start": 2567.44,
            "end": 2582.64,
            "transcript": "Ingleminek makluni ulillerani, putuskani-llu, curuni-llu, tamalkuita tua-i imegluki teguluki nugtartelliniuq yaavet allam inglerin ketiitnun."
        },
        "266": {
            "start": 2582.64,
            "end": 2591.22,
            "transcript": "Ketiitnun tua-i curiurluni tuavet aqumluni maktaluni aqumluni uitauralria-gguq."
        },
        "267": {
            "start": 2591.22,
            "end": 2600.02,
            "transcript": "Tuani-llu-gguq tang maktellermini umyuarteqengsaaranrilnguq kitumek ilaminek tuparqinayuk[luku], tuparqillerkaminek."
        },
        "268": {
            "start": 2600.02,
            "end": 2607.06,
            "transcript": "Camek-gguq umyuarteqengssaarpek'nani nepailcaarluni-llu-gguq taum tua-i piluni."
        },
        "269": {
            "start": 2607.06,
            "end": 2613.1,
            "transcript": "Curuminun-llu-gguq tua-i natermun allam ingleran canianun curuliurraarluni."
        },
        "270": {
            "start": 2613.1,
            "end": 2620.36,
            "transcript": "Irugni kipullguarrlukek natermun aqumluni uitauralliniuq."
        },
        "271": {
            "start": 2620.36,
            "end": 2629.28,
            "transcript": "Neq'aqamiu imna ataam cali alairviknayuqluku agluni egalret patullinii."
        },
        "272": {
            "start": 2629.28,
            "end": 2633.94,
            "transcript": "Paturraarluki-llu-gguq nutaan candle-aq kumarrluku."
        },
        "273": {
            "start": 2633.94,
            "end": 2640.98,
            "transcript": "Candle-aq kumarterraarluku ataam agluni aqumluni irugni navgullukek natermi."
        },
        "274": {
            "start": 2640.98,
            "end": 2649.24,
            "transcript": "Tua-i imumek irr'iluni, \"Calkugmek, calkuk tanem au͡gna, calkugmek tanem tangercia?\""
        },
        "275": {
            "start": 2649.24,
            "end": 2656.46,
            "transcript": "Uitaqanrakun-gguq amiigem tungli', amiigem kingunengqerrnganani."
        },
        "276": {
            "start": 2656.46,
            "end": 2660.18,
            "transcript": "Makut-gguq tang paraluruat akangelriit."
        },
        "277": {
            "start": 2660.18,
            "end": 2671.22,
            "transcript": "Tua-i-gguq cam imum naken egqaqkai paraluruat nateq, natermun-gguq tut'aqameng, elliin-gguq tungiinun akagnaurtut, curuan-llu-gguq acianun iterluteng."
        },
        "278": {
            "start": 2671.22,
            "end": 2677.7,
            "transcript": "Ellii-gguq tamakunek irr'ill', \"Naken imkut, naken kia, naken?\""
        },
        "279": {
            "start": 2677.7,
            "end": 2686.34,
            "transcript": "Amta-llu-gguq tangerkengaa-ll' ugna amiigem, amiigem cania cataunani yugtaunani."
        },
        "280": {
            "start": 2686.34,
            "end": 2694.36,
            "transcript": "Umyuarteqengsaarpek'nani-llu-gguq-am tua-i una wani tunumini inglerni qavalria tuparqellerkaanek."
        },
        "281": {
            "start": 2694.36,
            "end": 2701.84,
            "transcript": "Yuut-gguq tua-i tamarmeng tamaani qavalriit qavaryugluteng, ellii-gguq kiimi maktaluni."
        },
        "282": {
            "start": 2701.84,
            "end": 2709.64,
            "transcript": "Tua-i-ll' umyuarteqliniuq waten, \"Unuaqu wani egmianun uiskuma."
        },
        "283": {
            "start": 2709.64,
            "end": 2715.68,
            "transcript": "Curuma aciatnun camek itqellret paqtarkauganka.\""
        },
        "284": {
            "start": 2715.68,
            "end": 2719.6,
            "transcript": "Qaillun-llu-gguq camek umyuarteqevkenani."
        },
        "285": {
            "start": 2719.6,
            "end": 2730.6,
            "transcript": "Akitni tauna kitugterraarluku inarrliurluni qamiqurran-llu-gguq putuskaq tauna agtuani."
        },
        "286": {
            "start": 2730.6,
            "end": 2734.98,
            "transcript": "Uitaqarraarpek'nani-gguq egmian qavalliniluni tayim'."
        },
        "287": {
            "start": 2734.98,
            "end": 2740.56,
            "transcript": "Qayagpagal', aren, qavainanermini-llu-gguq tang tua-i qavanguqluku tauna."
        },
        "288": {
            "start": 2740.56,
            "end": 2751.84,
            "transcript": "Qavangurtulria-gguq tupallinillermini tuani tupaguarluni-gguq ilani-gguq qanemciskai qavanguminek taumek."
        },
        "289": {
            "start": 2751.84,
            "end": 2755.54,
            "transcript": "Taumek tua-i tangellruniluni alangrullruniluni."
        },
        "290": {
            "start": 2755.54,
            "end": 2765.98,
            "transcript": "Aren, piuraqerluni-gguq tua-i anguyagtet it'ngengameng eniit itngelriit [?] nutegluteng, taumek-gguq alangruanek yuaruarluteng."
        },
        "291": {
            "start": 2765.98,
            "end": 2772.36,
            "transcript": "Piinanermini tamaani tua-i qayagpagangelriamek kitumek niitenglliniluni."
        },
        "292": {
            "start": 2772.36,
            "end": 2781.28,
            "transcript": "Maaten-gguq uigartuq mikelngullraat iliita qayagpagakii-gguq ampi aamalisqelluteng."
        },
        "293": {
            "start": 2781.28,
            "end": 2792.34,
            "transcript": "Maaten-gguq makcami, maaten-gguq tang imna ellii tauna maktuq ayuqucia-gguq uqamaunani pamrianani-llu."
        },
        "294": {
            "start": 2792.34,
            "end": 2798.14,
            "transcript": "Taqsuqerpagnganani-gguq ayuqucirrluggluni-gguq cakneq."
        },
        "295": {
            "start": 2798.14,
            "end": 2806.44,
            "transcript": "Tua-i makcami tauna aamaliyulleq ullagluku, camek-llu-gguq umyuarteqengssaaranrituq."
        },
        "296": {
            "start": 2806.44,
            "end": 2810.9,
            "transcript": "Unuk-llu-gguq qaillun imna pillni nalluyagutqapiarluku."
        },
        "297": {
            "start": 2810.9,
            "end": 2818.28,
            "transcript": "Ayuqucirrluggluni-gguq tau͡gaam ayuqucia uqamaunani pamrianani-llu."
        },
        "298": {
            "start": 2818.28,
            "end": 2826.58,
            "transcript": "Aamalicetalria tauna aamarcuutni ullagluku, teguluku amalilliniuq [?], amalirraarluku tunrraarluku."
        },
        "299": {
            "start": 2826.58,
            "end": 2832.0,
            "transcript": "Piqanrakun-gguq [?] taukut wani mikelnguut aaniit uilluni."
        },
        "300": {
            "start": 2832.0,
            "end": 2836.5,
            "transcript": "Maktellinluni, makcami tua-i saanililuni."
        },
        "301": {
            "start": 2836.5,
            "end": 2853.2,
            "transcript": "Tua-i-gguq tang ellii tauna nasaurluq allayuulria imucet', imutuuvkenani qessaitelaryaaqellria-llu unuakumi egmianun cat piarkat calaalaryaaqekai."
        },
        "302": {
            "start": 2853.2,
            "end": 2859.3,
            "transcript": "Umyuaqevkenaki-gguq tang cavkenani aqumgarrarmi uitaurall'."
        },
        "303": {
            "start": 2859.3,
            "end": 2862.84,
            "transcript": "Taukut-gguq mikelnguut aaniita aptaa,"
        },
        "304": {
            "start": 2862.84,
            "end": 2866.26,
            "transcript": "\"Qaillurluq usuuq pilriaten qakivakarciq?"
        },
        "305": {
            "start": 2866.26,
            "end": 2870.06,
            "transcript": "Qaill' pisit?"
        },
        "306": {
            "start": 2870.06,
            "end": 2875.1,
            "transcript": "Ciin uitanguluarpakarciq? Naulluuguten-qaa?"
        },
        "307": {
            "start": 2875.1,
            "end": 2882.54,
            "transcript": "Alingellrulliuten unuk qavallerpeni? Camek-qaa qavangurtullruuten?\""
        },
        "308": {
            "start": 2882.54,
            "end": 2885.34,
            "transcript": "Taum wani qanruteksaunaku."
        },
        "309": {
            "start": 2885.34,
            "end": 2896.66,
            "transcript": "Tuaten tau͡gaam waten qanellrani, \"Alingellrulliuten camek unuk?\", neq'aqeryaaqellinikii unuk tua-i alangrullni."
        },
        "310": {
            "start": 2896.66,
            "end": 2907.84,
            "transcript": "Umyuarteqluni alingallagnayukluku qanrutenritliniat canrilnguarluni tau͡gaam pillinia, nuu canritniluni."
        },
        "311": {
            "start": 2907.84,
            "end": 2914.24,
            "transcript": "Taum-gguq tua-i taum arnam mikelnguut taukut aaniita piurqii,"
        },
        "312": {
            "start": 2914.24,
            "end": 2920.1,
            "transcript": "\"Atak usuuq maktavkenak inarrluten. Inangqan naulluuyugnarqellriaten tang.\""
        },
        "313": {
            "start": 2920.1,
            "end": 2924.92,
            "transcript": "Ullagarrluku-gguq qamiqurra cavtaa puqervagluni."
        },
        "314": {
            "start": 2924.92,
            "end": 2933.98,
            "transcript": "Aren-gguq tua-i tauna nasaurluq, aren, allayuurtellria taum kinguakun."
        },
        "315": {
            "start": 2933.98,
            "end": 2938.8,
            "transcript": "Apqaungnauraa-llu-gguq taum wani arnam,"
        },
        "316": {
            "start": 2938.8,
            "end": 2945.2,
            "transcript": "\"Qaillun usuuq pilriaten cassanqerriarupakarcit?"
        },
        "317": {
            "start": 2945.2,
            "end": 2950.86,
            "transcript": "Ciin-llu ilaten aquingraata-ll' aquyayuirupakarcit? Qaill' pisit?\""
        },
        "318": {
            "start": 2950.86,
            "end": 2958.5,
            "transcript": "Qanemciyuunani-gguq qanruteksaunaku imna alangrullni."
        },
        "319": {
            "start": 2958.5,
            "end": 2970.54,
            "transcript": "Erenret-gguq [?] tua-i iliitni taqsuqerpassiyaangaqami ellmikun waten inglernun-llu taklara'artaqami."
        },
        "320": {
            "start": 2970.54,
            "end": 2980.08,
            "transcript": "Taklara'artaqami qavaqerrnaurtuq-gguq qavarniciilnganani tau͡gken-gguq tupagciigaterrlainarluni."
        },
        "321": {
            "start": 2980.08,
            "end": 2984.42,
            "transcript": "Kiituan'-gguq tang ancurtunguq qavallerkaminek."
        },
        "322": {
            "start": 2984.42,
            "end": 2991.2,
            "transcript": "Caqerluni tua-i arnassagaat iliita apqaullinikii,"
        },
        "323": {
            "start": 2991.2,
            "end": 2998.3,
            "transcript": "qaillun camek pillrukan qanenrilkan waten tua-i ayuqurciqniluku"
        },
        "324": {
            "start": 2998.3,
            "end": 3011.8,
            "transcript": "qanrutkeksailkaku ca camek alingnaqellriamek pillrungraan, qanrutkeksailkaku camek tuaten tua-i tupagciigaquralarciqniluku."
        },
        "325": {
            "start": 3011.8,
            "end": 3020.36,
            "transcript": "Tua-i-ll' cam iliini uitainanratni atakumi"
        },
        "326": {
            "start": 3020.36,
            "end": 3026.08,
            "transcript": "enemun tauna-gguq nasaurluq camek mingeqnguarluni atakumi."
        },
        "327": {
            "start": 3026.08,
            "end": 3035.04,
            "transcript": "Uitainratni-gguq, enemun-gguq, eniitnun-gguq una arnaq itqerreskili qiuglimek qasperluni."
        },
        "328": {
            "start": 3035.04,
            "end": 3047.2,
            "transcript": "Iigmikun-gguq uuggun yaatiirluku tangerrluku arnaq itqerreskili-gguq qiuglimek qasperluni kavirlimek qaralirluni."
        },
        "329": {
            "start": 3047.2,
            "end": 3053.86,
            "transcript": "Tua-llu-gguq tang itqertellrani imna tauna alangrumi qaspeq atullra neq'aqerluku."
        },
        "330": {
            "start": 3053.86,
            "end": 3060.26,
            "transcript": "Pektesciigali'ircaaqluni-gguq [?] ilani-gguq apqaulrai, \"Kituuga? Yuuguq-qaa?\""
        },
        "331": {
            "start": 3060.26,
            "end": 3066.4,
            "transcript": "Tua-llu taumek apertuut', atra apertuatni maktelliniluni."
        },
        "332": {
            "start": 3066.4,
            "end": 3072.22,
            "transcript": "Makcan-gguq ilain piat qak'iqerrniluku qaill' picianek."
        },
        "333": {
            "start": 3072.22,
            "end": 3087.0,
            "transcript": "Tua-i-gguq tuani qarutaat camek alingnarqellriamek camek-wa tua-i qanrutkeksaitellrukaku qanemcikesqelluku egmianun watua."
        },
        "334": {
            "start": 3087.0,
            "end": 3093.58,
            "transcript": "Ayuqucianun caurut', tua-i-w' caurutngurpailgan assiiruyutekvailgaku."
        },
        "335": {
            "start": 3093.58,
            "end": 3102.74,
            "transcript": "Tua-i-ll' tuani tua-i qanemcikvaalulliniluku nutaan akaurrnerakun."
        },
        "336": {
            "start": 3102.74,
            "end": 3118.34,
            "transcript": "Tua-i qanemcikellmi tua-i, qanemcikellmi tua-i kinguakun imkulliniluni,"
        },
        "337": {
            "start": 3118.34,
            "end": 3124.6,
            "transcript": "tupagciigacuirucetelliniluni [?] tau͡gaam-gguq qanemcikesciigacimallrua ak'anun."
        },
        "338": {
            "start": 3124.6,
            "end": 3128.18,
            "transcript": "Akaurcami-gguq tau͡gaam tua-i qanemcikenrirluku."
        },
        "339": {
            "start": 3128.18,
            "end": 3132.28,
            "transcript": "Tua-i-gguq nangelria qanemciqa una."
        },
        "340": {
            "start": 3132.28,
            "end": 3134.9,
            "transcript": "Ila-i!"
        },
        "341": {
            "start": 3140.84,
            "end": 3151.42,
            "transcript": "Ila-i! Ataki nauggat [?] qalamcit alangrut Qaariitaarviim nalliini."
        },
        "342": {
            "start": 3151.42,
            "end": 3158.38,
            "transcript": "Wiinga tua-ll' waniwa qalamcitqernaumci ikgelengraan."
        },
        "343": {
            "start": 3158.38,
            "end": 3162.55,
            "transcript": "Miklemni niitellruunga waten."
        },
        "344": {
            "start": 3162.55,
            "end": 3167.4,
            "transcript": "Ak'a-gguq tamaani taukut up'nerkiyalriit."
        },
        "345": {
            "start": 3167.4,
            "end": 3175.98,
            "transcript": "Tua-llu-gguq unugmi inarrluteng iralvagluni-gguq qakemna."
        },
        "346": {
            "start": 3175.98,
            "end": 3188.0,
            "transcript": "Iralvaugluni tua-i, uksuarmi iciw', up'nerkami iciw', tua-i-wa piaqami iralvagaqan tanqigcet'lalria."
        },
        "347": {
            "start": 3188.0,
            "end": 3191.94,
            "transcript": "Tua-llu-gguq inarrluteng qavarluteng."
        },
        "348": {
            "start": 3191.94,
            "end": 3199.22,
            "transcript": "Tua-llu-gguq taukut iliit unuumainanrani camek niicami uituq."
        },
        "349": {
            "start": 3199.22,
            "end": 3207.42,
            "transcript": "Uicami amiik ingna pelatekam amiiga tangrraa."
        },
        "350": {
            "start": 3207.42,
            "end": 3217.22,
            "transcript": "Yaani amiigmi iralum ciqenqaluku maaten-gguq piuq tang ingna yuk."
        },
        "351": {
            "start": 3217.22,
            "end": 3223.3,
            "transcript": "Amiik pelatekam pii au͡g'angnaqkai cam."
        },
        "352": {
            "start": 3223.3,
            "end": 3229.3,
            "transcript": "Alingallagluni-llu-gguq tauna tua-i uitaluni tangvaurluku tauna."
        },
        "353": {
            "start": 3229.3,
            "end": 3232.18,
            "transcript": "Piinanermini ikirtaa."
        },
        "354": {
            "start": 3232.18,
            "end": 3236.5,
            "transcript": "Tua-i tan'gercenani tau͡gaam tungungqapiarluni."
        },
        "355": {
            "start": 3236.5,
            "end": 3239.94,
            "transcript": "Aurrluni-llu-gguq iterluni."
        },
        "356": {
            "start": 3239.94,
            "end": 3242.76,
            "transcript": "Tauna-llu-gguq uisngaluni kiimi."
        },
        "357": {
            "start": 3242.76,
            "end": 3247.447,
            "transcript": "Tauna-llu-gguq kiingan uisngalria. Ilai-gguq tau͡gken ukut qavarluteng."
        },
        "358": {
            "start": 3247.447,
            "end": 3251.68,
            "transcript": "Tauna kiingan ullagluku uisngalria."
        },
        "359": {
            "start": 3251.68,
            "end": 3259.32,
            "transcript": "Ullagmiu caavteqataryaaqaa, it'gaikun caavteqataryaaqaa."
        },
        "360": {
            "start": 3259.32,
            "end": 3265.62,
            "transcript": "Tauna-gguq alingqapiarluni tangvakii tauna yuk tauna."
        },
        "361": {
            "start": 3265.62,
            "end": 3268.96,
            "transcript": "Umyuaqercami espickaaminek anciuq."
        },
        "362": {
            "start": 3268.96,
            "end": 3279.46,
            "transcript": "Ancirraarluni-llu cukailcaarluni agtuqata'arluku it'gaikun cukailcaarluni espickaaq kumaleraa."
        },
        "363": {
            "start": 3279.46,
            "end": 3284.88,
            "transcript": "Kumaleramiu yaavet ellileraa, maaten-gguq piuq ingna yulkuk."
        },
        "364": {
            "start": 3284.88,
            "end": 3290.74,
            "transcript": "Kegginani-llu-gguq patulerluku, yulkuk."
        },
        "365": {
            "start": 3290.74,
            "end": 3296.04,
            "transcript": "Unatelkui-gguq-wa cetugpauluteng."
        },
        "366": {
            "start": 3296.04,
            "end": 3304.82,
            "transcript": "Tua-i-gguq patukii kegginani tuiggluni-llu-gguq anqerluni ayagarluni."
        },
        "367": {
            "start": 3304.82,
            "end": 3312.2,
            "transcript": "Tauna-llu-gguq mak'arrluni, ugaani-wa alingem pillilria, anqerluni maliggluku yuararluku."
        },
        "368": {
            "start": 3312.2,
            "end": 3324.96,
            "transcript": "Maaten-gguq piuq qagaa-i nanvam akiani ca-gguq au͡gna aqvaqulria cukaqapiaq aaraluni-gguq."
        },
        "369": {
            "start": 3324.96,
            "end": 3333.68,
            "transcript": "Maaten-gguq tangrraa mecikengnaqluni alurpallraak."
        },
        "370": {
            "start": 3333.68,
            "end": 3336.16,
            "transcript": "Aluuyugnarqut makut."
        },
        "371": {
            "start": 3336.16,
            "end": 3339.44,
            "transcript": "Aren, tallirpallraak."
        },
        "372": {
            "start": 3339.44,
            "end": 3349.1,
            "transcript": "Yaavet-gguq nunamun kaugutraarluki tua-i waten pinaurtuq cukaluni ava-i ayalria."
        },
        "373": {
            "start": 3349.1,
            "end": 3354.68,
            "transcript": "Tua-i taumek niigartellruunga alingnarqellriamek. Alingellruunga niitellemni."
        },
        "374": {
            "start": 3354.68,
            "end": 3358.114,
            "transcript": "Tua-i quyana tangvallruluci."
        },
        "375": {
            "start": 3358.114,
            "end": 3367.88,
            "transcript": "Alcicuaraaq-llu [?] Nuqaq'aq-llu quyaviklukek niicelluci-wa tua-i alangrut makunek."
        },
        "376": {
            "start": 3367.88,
            "end": 3374.1,
            "transcript": "Alangrutangqelartuq-qaa? Ila-i! Ca una?"
        },
        "377": {
            "start": 3374.1,
            "end": 3378.02,
            "transcript": "Cauyaqa, tang usuuq, cam imum tegungnaqkii."
        },
        "378": {
            "start": 3378.02,
            "end": 3381.64,
            "transcript": "Aullu-wa-i! Alangrutangqertuq-qaa?"
        },
        "379": {
            "start": 3381.64,
            "end": 3384.26,
            "transcript": "Ca pia?"
        },
        "380": {
            "start": 3384.26,
            "end": 3389.94,
            "transcript": "Quyana tua-i Qaariitaarviim nalliini tangvagluci."
        },
        "381": {
            "start": 3389.94,
            "end": 3395.64,
            "transcript": "Cali kiaku, aren, allraku piciqukut makunek."
        },
        "382": {
            "start": 3395.64,
            "end": 3400.18,
            "transcript": "Quyana tangvagluci, piurci."
        }
    },
    "vsDR410Q21M": {
        "1": {
            "start": 18.8,
            "end": 21.0,
            "transcript": "Yaa, naspaacikaqa."
        },
        "2": {
            "start": 24.98,
            "end": 35.88,
            "transcript": "Ilungarmaanelkan tamatumek piaqa ikayuqsagmi, yaa, maamin palaruta qanengssakut'laragmek."
        },
        "3": {
            "start": 38.08,
            "end": 42.68,
            "transcript": "Yaa, waniwa qanelqek-gguq waniwa."
        },
        "4": {
            "start": 46.56,
            "end": 49.1,
            "transcript": "Tangvagluku. Ii-i."
        },
        "5": {
            "start": 49.1,
            "end": 58.34,
            "transcript": "Qanengssaasqeńgatnga ukut elluarrluku pingailngalengramku qanengssauteqataranka."
        },
        "6": {
            "start": 58.34,
            "end": 67.24,
            "transcript": "Ikika tua-i KYUK-kun alaiteskatgu tutgarama tangvagciqaatnga tayim'."
        },
        "7": {
            "start": 67.24,
            "end": 80.8,
            "transcript": "Qanengssak man'a tangelqenritaqa wii tauna-ll' nanvaq nalluaqa, tau͡gaam ak'a qanengssautelaraitkuk, qanengssautelallruitkuk ilungaqa-llu."
        },
        "8": {
            "start": 80.8,
            "end": 88.62,
            "transcript": "Ilungaqa nallunritaat yuut amlleret friend-apiaqaqa Elena Spee [?] maanelkan aipaqsarqa."
        },
        "9": {
            "start": 88.62,
            "end": 98.68,
            "transcript": "Tua-i imumek qanengssaasqeńgatnga, wii elluarrluku pingailngalengramku nulirqellriik kiagmi maa-i yuumalriik."
        },
        "10": {
            "start": 98.68,
            "end": 107.22,
            "transcript": "Tua-i-llu ingrini pissurturalaameng pitateng kinerciqu'urluki."
        },
        "11": {
            "start": 107.22,
            "end": 114.72,
            "transcript": "Tamatum-llu nalliini natmun kumlivigmun kurciigalata, kinercirturluki tau͡gaam."
        },
        "12": {
            "start": 114.72,
            "end": 123.08,
            "transcript": "Tua-i-ll' piqerluni tauna atii taum nasaurluum kiingan-llu-gguq irniarrluku nulirqellriik."
        },
        "13": {
            "start": 123.08,
            "end": 132.46,
            "transcript": "Tekitelliniluni tuntumek tekiulluni angutvagmek tunurrlainat ilui-llu-gguq tunurrlainaat ut'rutliniluki."
        },
        "14": {
            "start": 132.46,
            "end": 144.96,
            "transcript": "Tua-i-llu-gguq taum aaniin ellimerrluku taukut wangkuta Yugcetun ap'lalput cungarnit, tau͡gaam arnarni makuni yuum taungucingengaitai."
        },
        "15": {
            "start": 144.96,
            "end": 148.8,
            "transcript": "Cungarnit eruryartuusqelluki nanvam ceńiinun."
        },
        "16": {
            "start": 148.8,
            "end": 161.08,
            "transcript": "Tua-i-ll' tuani erurnginanrani, eruinanrani ak'araurcuaraqerluku erullra akervagluni im'ulliniluni."
        },
        "17": {
            "start": 161.08,
            "end": 168.04,
            "transcript": "Ulyuiciyaqeng'e'rmi tauna tangvalaatni ellaita mayurvikngamegteggu kiagmi."
        },
        "18": {
            "start": 168.04,
            "end": 179.74,
            "transcript": "Ulutelliniluku tua-i-ll' keluqvaqanirluni, tua-i-ll' cal' eruqcaarnginanermini cali ulucani, cali keluqvaqanirluni."
        },
        "19": {
            "start": 179.74,
            "end": 190.56,
            "transcript": "Ulutaqani keluqvaqaniraqluni, tua-i-llu qanellrani aanani qayagaurluq qanrutlinia, ellii-gguq tang mer'em ulutelaqii."
        },
        "20": {
            "start": 190.56,
            "end": 196.92,
            "transcript": "Tua-i-ll' aaniin piyaaqliniluku keluqvaarnun tagluku cipeq'uraasqelluki."
        },
        "21": {
            "start": 196.92,
            "end": 204.44,
            "transcript": "Tua-i-llam niigartevkenaki, meq tau͡gaam qimakarrluku eruriuralliniluni."
        },
        "22": {
            "start": 204.44,
            "end": 217.44,
            "transcript": "Tua-i-ll' pinginanermini ulucani cali tagkanirluni, tua-i-ll' aanii tauna keluanun piluni tangvauralliniluku qaill' piluni ulucianek."
        },
        "23": {
            "start": 217.44,
            "end": 226.88,
            "transcript": "Tua-i-ll' tangvaurnginanrani akercian mer'em iluanek camaken tuarpiaq-gguq."
        },
        "24": {
            "start": 226.88,
            "end": 240.58,
            "transcript": "Kinguqvani maa-i taum qanemcikestek'lallma, qanemcikesteltelmegnuk nanvani pagaani murilkelaasqelluta qanrutakuk."
        },
        "25": {
            "start": 240.58,
            "end": 247.78,
            "transcript": "Tuarpiaq-gguq kenurqutanek tangerrsaurcami maa-i taum qanengsi nek'alaraa."
        },
        "26": {
            "start": 247.78,
            "end": 260.2,
            "transcript": "Mer'em iluanek tanqillagaqluni cunawa-gguq neqerpallraam iik akertemun ciqenqautaqagnek tanqillalallinilria."
        },
        "27": {
            "start": 260.2,
            "end": 272.88,
            "transcript": "Tua-i-llu-gguq aaniin piyaaqluku ataki tang ilangcivkenaki taukut taqenrilengraata tagutesqelluki qantalgirameggnun ekesqessaaqluki."
        },
        "28": {
            "start": 272.88,
            "end": 281.86,
            "transcript": "Tua-i-am cali taum niigartenritliniluni. Niigartenritqerluku-llu tanqillagaqerluku imna."
        },
        "29": {
            "start": 281.86,
            "end": 291.2,
            "transcript": "Neqem culuan nuuga ivgaan aaniin patagcaryaaqellinia kelutmun aqvaquusqelluku."
        },
        "30": {
            "start": 291.2,
            "end": 297.78,
            "transcript": "Cali ilangcivkenani cali niitevkenani tauna neviarcaq."
        },
        "31": {
            "start": 297.78,
            "end": 310.74,
            "transcript": "Pinginanrani tauna imna culua tunuani ivgalliniuq kinguakun-gguq ayuqekutelaraat pimun."
        },
        "32": {
            "start": 310.74,
            "end": 316.2,
            "transcript": "Tengalrautamun, tengalrautacuarpagmun."
        },
        "33": {
            "start": 316.2,
            "end": 322.42,
            "transcript": "Pinginanermini keluqvaqanirangarteqerluku."
        },
        "34": {
            "start": 322.42,
            "end": 334.2,
            "transcript": "Ivvgalliniuq qanra taum neqerpallraam qilagarpallriit tua-i-gguq carpall'er agluryarluni iciw' agluryatun perluni."
        },
        "35": {
            "start": 334.2,
            "end": 349.2,
            "transcript": "Tua-i-ll' cauciinaku ellilkenka, tua-i-ll' imna tauna cungarninek eruriuralleq alqunaq tekiarluki iqemkarluki tayima-ll' murugtelliniluni."
        },
        "36": {
            "start": 349.2,
            "end": 358.52,
            "transcript": "Tua-i-ll' kinguani, kinguani atii taun kiingan irniaqngamegnegu qivruqapiarallermini."
        },
        "37": {
            "start": 358.52,
            "end": 373.2,
            "transcript": "Imkunek ak'a iqluvkenani nutaan ak'a tamaani pitegcautet nuugitnek teggalqunek pililliniluni angtuarraurrluki cakneq ip'iluki."
        },
        "38": {
            "start": 373.2,
            "end": 380.92,
            "transcript": "Nutaan-llu-gguq pitegcauciami cali pitegcauciluni, cingililiamiki-llu-gguq qanerluni."
        },
        "39": {
            "start": 382.58,
            "end": 388.86,
            "transcript": "Pitgauskuniki pitsaqevkenani iluvanqigeskan aitareskan."
        },
        "40": {
            "start": 388.86,
            "end": 394.2,
            "transcript": "Igyaranun pitgauskuniki tamakut un'gartaararkauniluki."
        },
        "41": {
            "start": 394.2,
            "end": 406.2,
            "transcript": "Tamakut pitegcautet anengraata tamakut teggalqut iluani igyarani uitarkauniluku aipaagni-ll' tamakunun tuqutnayukluku."
        },
        "42": {
            "start": 406.2,
            "end": 418.66,
            "transcript": "Tua-i-ll' tuaten pirraarluni caliani taukut pitalqeryukngamiki nutaramek tuntussurraarluni."
        },
        "43": {
            "start": 418.66,
            "end": 428.02,
            "transcript": "Nutaan qugtuqurra ernerni makuni nalluaci tamakut avani ciuqvani ilavkuukellrit."
        },
        "44": {
            "start": 428.02,
            "end": 435.2,
            "transcript": "Tau͡gaam wangkuta angustaitni nallunritaput tamakut aterpagtelarait taprarnek."
        },
        "45": {
            "start": 435.2,
            "end": 446.2,
            "transcript": "Walrus-aanun amiqnilarait wall'u maklagnun taprarnek aciraqluki tamaa-i ak'a avani ciuqvani ilavkuit."
        },
        "46": {
            "start": 446.2,
            "end": 454.86,
            "transcript": "Tua-i-ll' tamakucimek uskurirluku tauna iverluni ketmun egqaarluki egqaarluku."
        },
        "47": {
            "start": 454.86,
            "end": 463.86,
            "transcript": "Nutaan piaken keluanek nayurluku uluungraan taucetun imutun nasaurluum panimi."
        },
        "48": {
            "start": 463.86,
            "end": 473.2,
            "transcript": "Ulutaallratun ulqetaaranga'arcan [?] kingupiarraqluni tagkaniraqluni piuralliniluni."
        },
        "49": {
            "start": 473.2,
            "end": 487.7,
            "transcript": "Tua-i-llu imna culua pugngan culuksuani kingupiaqanirluni imna urluvni pitegcautet-llu atmakalliniluki."
        },
        "50": {
            "start": 487.7,
            "end": 497.96,
            "transcript": "Tua-i-ll' tuaten uita qanrakun imutun uumicetun pania iqmikatallermitun aitarcan."
        },
        "51": {
            "start": 497.96,
            "end": 505.7,
            "transcript": "Maligcetautekluki-gguq pitgarluku pingayurquneng maligcetautekluki pitgarluki."
        },
        "52": {
            "start": 505.7,
            "end": 516.34,
            "transcript": "Tua-i-ll' pitgaatni-gguq pitgaani-gguq ceqcillallermini meq cakneq pekcillap'agluni."
        },
        "53": {
            "start": 516.34,
            "end": 529.7,
            "transcript": "Tua-i-llu-gguq tayima peqcillap'aggaarluni kingupiarngami kingutmun tayima anglluami pugenqigtevkenani, meq-llu-gguq peqcillaganqigtevkenani."
        },
        "54": {
            "start": 529.7,
            "end": 538.28,
            "transcript": "Tua-i tayima tuqranun ayalliuq qaill' pia nutaan, nutaan allamiani cali."
        },
        "55": {
            "start": 538.28,
            "end": 549.7,
            "transcript": "Tamaavet mayutulit qanganarcurturatulliniameng kiagmi, tuntut-llu pitarkat amlleratni angutet cali tamakunek pissuagurluteng."
        },
        "56": {
            "start": 549.7,
            "end": 556.46,
            "transcript": "Cali-am tuavet mayulriit utercameng qanlliniluteng."
        },
        "57": {
            "start": 556.46,
            "end": 566.62,
            "transcript": "Waniwa-gguq allamiani uksuarmi neqerpakayagpall'er."
        },
        "58": {
            "start": 566.62,
            "end": 578.7,
            "transcript": "Kiugkenalirneran tunglirneranun pilliuq tepellrullinikii ak'a-llu kiagpak aruluni."
        },
        "59": {
            "start": 578.7,
            "end": 590.7,
            "transcript": "Arulliniluni nerpakayallrai tau͡gaam uneggluteng, kemga tayima ak'a aruluni catairutliniluni."
        },
        "60": {
            "start": 590.7,
            "end": 605.7,
            "transcript": "Tua-i-gguq taum kinguani tamakut enret kinrata tanglaraput, enret cailkamtaqameng kinenqegcaaraumalartut tuar pukunqegcaaraumalriit."
        },
        "61": {
            "start": 605.7,
            "end": 612.06,
            "transcript": "Tau͡gaam-gguq taum makut enret qukamegteggun ukinerrarluteng."
        },
        "62": {
            "start": 612.06,
            "end": 620.14,
            "transcript": "Imna-ll cali kanani iluan augan aug'um pim wani."
        },
        "63": {
            "start": 620.14,
            "end": 626.7,
            "transcript": "Taqerpangalnguum nunii tamana cali amiicuartun ayuqluni."
        },
        "64": {
            "start": 626.7,
            "end": 635.04,
            "transcript": "Taukut elliin taum qanengsaucetmegnuk qanrut'laraakut."
        },
        "65": {
            "start": 635.04,
            "end": 643.1,
            "transcript": "Taukut-gguq nasaurluuk malruk tauna-ll' tan'gaurluuk mikcuayagaunricaaqut."
        },
        "66": {
            "start": 643.1,
            "end": 653.38,
            "transcript": "Naanguallermeggni-gguq erenrani tayima iluvaryarrliata-gguq aanait aptait nantellruciitnek."
        },
        "67": {
            "start": 653.38,
            "end": 662.42,
            "transcript": "Kanani-gguq nanvam keluani naanguartut au͡gkuni kepuumarpalriani cani tuar-gguq enret."
        },
        "68": {
            "start": 662.42,
            "end": 671.16,
            "transcript": "Ukinerkun-gguq uuggun itraqluteng, an'aqluteng-llu, pikaggun-llu-gguq uyanglluteng."
        },
        "69": {
            "start": 671.16,
            "end": 678.54,
            "transcript": "Egaleqnguarluku uyangtaqluteng im'uggun quka enrem qukaani ukineruayaarku."
        },
        "70": {
            "start": 679.54,
            "end": 689.66,
            "transcript": "Tua-i-ll' tuavet ayaganesqenrilengraiceteng-llu anglanak' assikluku tauna naanguarvik'lalliniluku."
        },
        "71": {
            "start": 689.66,
            "end": 698.34,
            "transcript": "Tua-i-ll' tuavet nengelkarrluku waniw' tauna nallunritaqa qanemciq augkut tuaten taktaluku qanengsautelallruakut."
        },
        "72": {
            "start": 698.34,
            "end": 712.68,
            "transcript": "Tau͡gaam inerquaqluta pagaani ingrini nanvarpagni murilkelluki yuut pilaasqelluki ceńaqirpek'naki-llu tamakunun tautun pinayukluki."
        },
        "73": {
            "start": 712.68,
            "end": 716.6,
            "transcript": "Ciuqliq-llu wani wani qanengssaka nangluni."
        },
        "74": {
            "start": 749.14,
            "end": 757.92,
            "transcript": "Tua-i-llu cali ataam ayanqigglua waniw' cali, ayanqigglua cali qanengssakqatarluku."
        },
        "75": {
            "start": 757.92,
            "end": 766.16,
            "transcript": "Quyalua qanengssallerkamnek tutgaranka, tutgararuganka-ll' umyuaqluku, quliriyuitanka-llu."
        },
        "76": {
            "start": 766.16,
            "end": 774.38,
            "transcript": "Yaa-wa, waniwa nutaan au͡gna qanengssakelqa nanvaq wii ullayuitaqa."
        },
        "77": {
            "start": 774.38,
            "end": 786.26,
            "transcript": "Ullayuitellruaqa tamaavet mayuucuitellruatnga, waniw' nutaan wangkuta mayulallemteńun mikraanemteńek u'nerkallra tamalkuan."
        },
        "78": {
            "start": 786.26,
            "end": 802.6,
            "transcript": "Kuigglugmi uitayaaqukut Kuigglugmiunek aterpagcimaluta tau͡gaam ataka Kuigglugmiungunrilami Akiarmiut maligqurluki mayurturatullruukut yugyapiapiarluteng, nunaniqpiarluteng."
        },
        "79": {
            "start": 802.6,
            "end": 810.14,
            "transcript": "Tau͡gaam ernerni makuni mayullgutkelallemta ilait tayim ak'a mernuinerciameng arenqiatut."
        },
        "80": {
            "start": 810.14,
            "end": 819.76,
            "transcript": "Tua-i-llu waniwa tauna up'nerkilallerput atengqertuq, atengqertuq nanvarpall'er Engell'irmek."
        },
        "81": {
            "start": 819.76,
            "end": 833.42,
            "transcript": "Engell'irmek atengqertuq tau͡gaam makuni ernerni aterpagtelaraat atra cimiqerluku Teksigmek, Teksim Qagatiinek."
        },
        "82": {
            "start": 833.42,
            "end": 841.84,
            "transcript": "Tua-i-ll' ak'a cali au͡g'um angutem cali angutngurtellriim qanengssautelallruakut cali."
        },
        "83": {
            "start": 841.84,
            "end": 846.02,
            "transcript": "Tauna nanvaq Engell'iq."
        },
        "84": {
            "start": 846.02,
            "end": 861.4,
            "transcript": "Ak'a avani ciuqvani maaken Kusquqvagmek atam ak'akika ernerni makuni yuut tua-i-am au͡gkut yuut ciuqliit aturciigaitait yuut."
        },
        "85": {
            "start": 861.4,
            "end": 867.22,
            "transcript": "Pissurluteng pissungermeng aturciigatait assilrianek pissuryugyaqeng'e'rmeng."
        },
        "86": {
            "start": 867.22,
            "end": 873.62,
            "transcript": "Piyualuteng ayagaqluteng ak'akika pakmavet tuavet nanvarpall'ermeng."
        },
        "87": {
            "start": 873.62,
            "end": 885.7,
            "transcript": "Tuavet tekilluteng pissuinanratni katngaat-gguq, katngaat-gguq tuntupiapiat."
        },
        "88": {
            "start": 885.7,
            "end": 898.24,
            "transcript": "Nani-ll' kuptayagarnek makut irulget maa-i ernerni makun tuntupianek aterpagtalarait caribou-nek wii tangrraqamki caribou-qeksaitanka, tanglallruamki caribou-t."
        },
        "89": {
            "start": 898.24,
            "end": 907.18,
            "transcript": "Tua-i-llu-gguq iliit au͡gna apqiit angutvagpall'er cirunerpagluni-llu cirunerluni."
        },
        "90": {
            "start": 907.18,
            "end": 924.62,
            "transcript": "Naluinanermeggni agaavet qacarnermun ualirnermun tunglirneranun elliqerluki tauna angenrat tuntut angllullagangluni."
        },
        "91": {
            "start": 924.62,
            "end": 938.22,
            "transcript": "Murukaqungluni epsallagnganani-gguq neplirluni pugyaaqaqami ayakarluni cali ataam angllullagaqluni."
        },
        "92": {
            "start": 938.22,
            "end": 948.42,
            "transcript": "Tua-i-llu-gguq angllullanret iliitni tayima murukalriim mululriim imna tayima-ll' pugunqigtevkenani."
        },
        "93": {
            "start": 948.42,
            "end": 957.8,
            "transcript": "Taukut-gguq pissulriit tegganrata qanrutait tua-i ava-i qanrutkelallratnun neqerpagmun igniluku tayima."
        },
        "94": {
            "start": 957.8,
            "end": 966.4,
            "transcript": "Ciungani tamakut allat cataitelallruniluki tuntut tuaten nalugaqata."
        },
        "95": {
            "start": 966.4,
            "end": 979.04,
            "transcript": "Taumek wangkuta-ll' inerqurturalaitkut, inerqurturalallruitkut manalrianun atrarasqevkenata."
        },
        "96": {
            "start": 982.3,
            "end": 994.98,
            "transcript": "Tauna tamakunek cali ang'ami agna-llu ualirnera imkunek ingrirpallernek pingqerrami."
        },
        "97": {
            "start": 994.98,
            "end": 1009.28,
            "transcript": "Akerciraqan-gguq kiagmi tamakut pissulriit tamaa-i tamatutangqerrucia taringelaraat mer'em iluanek tanqillagaqata tamakut-gguq neqerpiit tamaa-i iingit."
        },
        "98": {
            "start": 1011.82,
            "end": 1021.94,
            "transcript": "Tauna amllerqunek, amllermek qalamcigka tua-i taum tungiinek tau͡gaam quyanarquq, quyalartua wiinga."
        },
        "99": {
            "start": 1021.94,
            "end": 1034.12,
            "transcript": "Man'a tekisamku umyuaqela'arqa up'nerkallra-llu tamalkuin imkut anglicartemta Akiarmiut, wangkuta-llu Kuigglugmek maliguquraaqluta."
        },
        "100": {
            "start": 1034.12,
            "end": 1047.82,
            "transcript": "Tua-i tuavet up'nerkiyaraqluta Engell'irmun tau͡gaam maa-i Kass'acetun-llu cat yuut-llu aciryaurtatki tauna Tikchik [?] Lake-amek piyaurtellruat."
        },
        "101": {
            "start": 1048.8,
            "end": 1056.86,
            "transcript": "Tua-i-ll' tuaken cali waniwa cali allamun-qaa au͡g'umun qanengssaaritnun qeckarciqngatua."
        },
        "102": {
            "start": 1060.88,
            "end": 1071.16,
            "transcript": "Tua-i-llam cali waniw' qeckarlua, tuamta-llu-am cali qanengssagaut una ak'a, ak'a niitellrularyaaqekek'a avani ciuqvani."
        },
        "103": {
            "start": 1071.16,
            "end": 1083.18,
            "transcript": "Au͡gkut imkut angutngurtellriit qanengssautelaitkut, nepaitevkarluta, aqumevkarluta cauvkarluteng tangvaurtelluteng pektaarcetevkenata."
        },
        "104": {
            "start": 1083.18,
            "end": 1089.4,
            "transcript": "Qanengssautaakut taum qanengssani man' murilkeqapigtesqelluku."
        },
        "105": {
            "start": 1089.4,
            "end": 1101.2,
            "transcript": "Ciuqvani avani taukut-am angutet qavcin tuaggun cali pamaggun tevvliniluteng amalirnermek."
        },
        "106": {
            "start": 1101.2,
            "end": 1110.1,
            "transcript": "Tamatum nalliini anguyalallratni-gguq, anguterrlainauluteng pektaalaameng."
        },
        "107": {
            "start": 1110.1,
            "end": 1122.68,
            "transcript": "Tua-i-ll' Kiillaraliitem kangiakun nanvaq qavaggun cali tev'aqluteng, kiituan Kiillaraliitem kangianun kanaameng."
        },
        "108": {
            "start": 1122.68,
            "end": 1134.36,
            "transcript": "Aguuterluteng tev'aqluteng ilarrarluteng taumek angutmek cikmiumaluni tangesciiganani. Tau͡gaam ucikurluku ayauqurluku."
        },
        "109": {
            "start": 1134.36,
            "end": 1148.82,
            "transcript": "Tau͡gaam-am taukut ucik' aulukurtain tuavet igceńamun imumun ukaqvaggun-am qanngarutekellsaaqellratnun kenurramun qagaciugluki."
        },
        "110": {
            "start": 1149.1,
            "end": 1159.64,
            "transcript": "Tuavet-am tekicameng taukut angutet tauna ilarraurluteng ellaita ilakniluku yuullgutekniluku nakmiin."
        },
        "111": {
            "start": 1159.64,
            "end": 1168.24,
            "transcript": "Ilakluku nunalgutekluku tuqucuumiitniluku tuaggun igceńakun tuqucugluku."
        },
        "112": {
            "start": 1168.24,
            "end": 1173.84,
            "transcript": "Tua-i-ll' tuavet aguutmun, egelrutmun-wa ekluku."
        },
        "113": {
            "start": 1173.84,
            "end": 1184.54,
            "transcript": "Pii-ll' qanrutliniluku cangaitniluku, ellaita pairrsagciqniluku ingrim qainga tevyarakun tev'arrluteng."
        },
        "114": {
            "start": 1184.82,
            "end": 1191.16,
            "transcript": "Utaqayartuqatarniluku yaani, iksaraten angyaratii teksaraatni yaani."
        },
        "115": {
            "start": 1191.16,
            "end": 1201.2,
            "transcript": "Tua-i mayurluteng-gguq tevluteng ciunerkaanun amavet ayagarrluteng ayagmek-llu-gguq ilaseng piqunqellria."
        },
        "116": {
            "start": 1201.2,
            "end": 1208.88,
            "transcript": "Ellimerrluku ivrumauraasqelluku tauna atullra elrun pisqelluku."
        }
    },
    "hW24xBzqLE8": {
        "1": {
            "start": 41.16,
            "end": 43.68,
            "transcript": "Ii-i."
        },
        "2": {
            "start": 43.68,
            "end": 54.68,
            "transcript": "Yaa, qanengssakatartua anguyagnek tau͡gaam piciatun ullagtaarulluki piciqanka waniw'."
        },
        "3": {
            "start": 54.68,
            "end": 66.44,
            "transcript": "Taukut tuaten piqapiaralriit quyungqallrat-llu tayim' nalluyagulluku, akaurrluni qanengssaget niitelallrenka."
        },
        "4": {
            "start": 66.44,
            "end": 78.94,
            "transcript": "Taukut ayalliniut Apanuugpagmek ilaluteng yaatmun avavet, ayalliniut tua-i uatmun."
        },
        "5": {
            "start": 78.94,
            "end": 87.78,
            "transcript": "Taukut tua-i atrit atengqerrsaaqut tamarmeng tau͡gaam tauna."
        },
        "6": {
            "start": 87.78,
            "end": 90.96,
            "transcript": "Tauna-gguq..."
        },
        "7": {
            "start": 90.96,
            "end": 95.8,
            "transcript": "Agturavkenaku? Arenqiapakarpaa-ll' au [?]!"
        },
        "8": {
            "start": 95.8,
            "end": 96.94,
            "transcript": "Nutaan."
        },
        "9": {
            "start": 96.94,
            "end": 101.2,
            "transcript": "Ii-i, aullu-wa-i tauna pivkenaku tauna."
        },
        "10": {
            "start": 101.2,
            "end": 105.46,
            "transcript": "Ii-i, nutaan tua-i ayalliniluteng taukut"
        },
        "11": {
            "start": 105.46,
            "end": 116.1,
            "transcript": "Tua-i atam, un'gani tua-i, au͡gkut anguyaungameng Kusquqviim ungalalirneranun tua-i anliuteng."
        },
        "12": {
            "start": 116.1,
            "end": 131.82,
            "transcript": "Apanuugpak-llu tauna ilakluku, tauna-llu Putukuilnguq, Putukuilnguq ilakluku, ilakluku tua-i."
        },
        "13": {
            "start": 131.82,
            "end": 146.42,
            "transcript": "Tua-i-llu tamaani Kusquqviim tua-i painga pellugluku yaatmun ayagluteng anguyagnek malirqalliniluteng."
        },
        "14": {
            "start": 146.42,
            "end": 154.38,
            "transcript": "Tua-i ketmun tayim' ima-am [?] tungiinun qimallinilutek."
        },
        "15": {
            "start": 154.38,
            "end": 156.64,
            "transcript": "Qimaglutek tua-i tayima."
        },
        "16": {
            "start": 156.64,
            "end": 169.34,
            "transcript": "Tauna tua-i Putukuilnguq, Putukuilnguum taum malirqallinilukek tayim' ketmun."
        },
        "17": {
            "start": 169.34,
            "end": 174.6,
            "transcript": "Tua-i tayim' pellaluteng unavet imarpigmun."
        },
        "18": {
            "start": 174.6,
            "end": 179.06,
            "transcript": "Tua-i uitalliniluteng arulairluteng."
        },
        "19": {
            "start": 179.06,
            "end": 191.04,
            "transcript": "Tua-i kaingameng-llu tua-i tayima nerrlilriit tau͡gaam tua-i kellilluteng, curugluteng piameng, curulriaruameng."
        },
        "20": {
            "start": 191.04,
            "end": 195.8,
            "transcript": "Tua-i qanqaqungelliniluteng, \"Arenqiapaa!\""
        },
        "21": {
            "start": 195.8,
            "end": 201.34,
            "transcript": "Tauna Putukuilnguum atii-llu tauna ilakluku tua-i tamaa-i."
        },
        "22": {
            "start": 201.34,
            "end": 210.1,
            "transcript": "Pilliniuq, pilalliniuk, \"Arenqiapaa! Putukuilnguq imna caciitenrituq.\""
        },
        "23": {
            "start": 210.1,
            "end": 217.68,
            "transcript": "Tua-i tayima imkuk tua-i piunriraak-llu."
        },
        "24": {
            "start": 217.68,
            "end": 221.3,
            "transcript": "Tua-i ak'anivkenateng qanraqluteng."
        },
        "25": {
            "start": 221.3,
            "end": 240.48,
            "transcript": "Tua-i-ll' tauna tuaten qalartellratni atii qanlliniuq, \"Putukuilnguq kaigiatuq. Kaingekuni uterciiquq.\""
        },
        "26": {
            "start": 240.48,
            "end": 253.6,
            "transcript": "Tua-i tayima atam piqerluni tua-i qakemna qaill' erneq elliqerluku agiirtellinilria Putukuilnguq."
        },
        "27": {
            "start": 253.6,
            "end": 259.42,
            "transcript": "Qayaq man'a camaken tua-i uka-i agiirtelliniluni."
        },
        "28": {
            "start": 259.42,
            "end": 264.04,
            "transcript": "Tua-i-ll' maaten ukaqsigillniuq Putukuilnguq."
        },
        "29": {
            "start": 264.04,
            "end": 269.32,
            "transcript": "Tua-i tekicami wavet ketiitnun uiyaqaalliniluni."
        },
        "30": {
            "start": 269.32,
            "end": 286.06,
            "transcript": "Uiyaqaarami qayani kauluku ciuliurluni, ciunga kautuarraarluku ancilliniuq nukalpiam qamiqurranek, nuyaikun qegcugmiaqluni."
        },
        "31": {
            "start": 286.06,
            "end": 290.6,
            "transcript": "Egtelliniluku-ll' ilami tungiitnun."
        },
        "32": {
            "start": 290.6,
            "end": 298.62,
            "transcript": "Tuamtell' kinguliurluni, taum pirraarluni, kinguliurluni ancilliniuq nukalpiam qamiqurranek."
        },
        "33": {
            "start": 298.62,
            "end": 305.18,
            "transcript": "Ilami-ll' tungiitnun egtelliniluku. Alingnaqvaa."
        },
        "34": {
            "start": 305.18,
            "end": 316.96,
            "transcript": "Putukuilngukayak! Aling. Curugluni. Curulrian maligutenrarluni."
        },
        "35": {
            "start": 316.96,
            "end": 326.16,
            "transcript": "Atiin taum piaqluku tua-i tuani peng'gartellratni."
        },
        "36": {
            "start": 326.16,
            "end": 335.76,
            "transcript": "Pilliniluki, \"Kaingekuni-gguq Putukuilnguq kaigiatuq uterciiquq, peng'garcugnaunaku.\""
        },
        "37": {
            "start": 335.76,
            "end": 341.94,
            "transcript": "Tua-i yaatmun ayalliniluteng tua-i tuaken."
        },
        "38": {
            "start": 341.94,
            "end": 357.02,
            "transcript": "Tua-i-ll' tamaani ayallermeggni, tua-i pairpairesketeng tua-i piunriraqluki tua-i."
        },
        "39": {
            "start": 357.02,
            "end": 366.46,
            "transcript": "Malirquulliniluteng piyagarnek, ingtarnek-wa avani yaqulegnek."
        },
        "40": {
            "start": 366.46,
            "end": 379.16,
            "transcript": "Tua-i malirquullermeggni tauna Paluqtaaralek-gguq una iliit paangrutairtelliniluni. Paangrutek asmarrlutek."
        },
        "41": {
            "start": 379.16,
            "end": 386.52,
            "transcript": "Tua-i paangrutaunak alivkenaqeqluni [?]."
        },
        "42": {
            "start": 386.52,
            "end": 390.2,
            "transcript": "Tua-i paangrutaunani tua-i."
        },
        "43": {
            "start": 390.2,
            "end": 403.68,
            "transcript": "Tua-i atam caqvag' [?] piinanermeggni tua-i erenret iliitni nukalpiamek tua-i tangllinilriit ava-i."
        },
        "44": {
            "start": 403.68,
            "end": 408.6,
            "transcript": "Tua-i maligtelliniluku."
        },
        "45": {
            "start": 408.6,
            "end": 422.48,
            "transcript": "Maligtelliniluku tua-i avanlluni tua-i avantarluni piturnilliniameng mallegciiganaku."
        },
        "46": {
            "start": 422.48,
            "end": 441.12,
            "transcript": "Tua-i tuani maliggnginanermeggni nunat ketiitnun tua-i tekiararutelliniluki taum, taum tua-i maligeskiita."
        },
        "47": {
            "start": 441.12,
            "end": 455.0,
            "transcript": "Tua-i nunat ketiitnun tekiararulluki qayat tua-i imkut taukut taukumiut atraqertelliniluteng elaqvaggun."
        },
        "48": {
            "start": 455.0,
            "end": 462.22,
            "transcript": "Tua-i waten elaqvaggun avatairluki. Avatairluki tua-i."
        },
        "49": {
            "start": 462.22,
            "end": 468.74,
            "transcript": "Tua-i imkut Apanuugpiinkut."
        },
        "50": {
            "start": 468.74,
            "end": 476.8,
            "transcript": "Tua-i qayat iluatni nunat ketiitni quy'uqerturlulliniluteng."
        },
        "51": {
            "start": 476.8,
            "end": 481.76,
            "transcript": "Apanuugpak tua-i una cauyugturluku."
        },
        "52": {
            "start": 481.76,
            "end": 490.32,
            "transcript": "Ukatmun tua-i anguaksuarturni waten ayaksuartura'arqan imkut kingunrakun maligquraraqluku."
        },
        "53": {
            "start": 490.32,
            "end": 496.98,
            "transcript": "Tua-i wani tunuani qamanratni tau͡gaam piurluteng."
        },
        "54": {
            "start": 496.98,
            "end": 508.74,
            "transcript": "Tua-i-gguq pama-i taukut nunat, taukut-gguq Eqtarmiut, Eqtarmiunguut."
        },
        "55": {
            "start": 508.74,
            "end": 513.1,
            "transcript": "Tua-i nanikualliniluteng tua-i."
        },
        "56": {
            "start": 513.1,
            "end": 517.64,
            "transcript": "Tua-i nauggun tua-i anagvigkaunateng."
        },
        "57": {
            "start": 517.64,
            "end": 526.98,
            "transcript": "Tua-i-llu piinanratni atam nukalpiaq pamaken atrallinilria."
        },
        "58": {
            "start": 526.98,
            "end": 533.52,
            "transcript": "Tauna tua-i nukalpiaq taukumiu qayani uqurquallinikii."
        },
        "59": {
            "start": 533.52,
            "end": 542.52,
            "transcript": "Uqumek tua-i qainga mingugluku piiragcarluku ugaani tua-i piqatam."
        },
        "60": {
            "start": 542.52,
            "end": 556.02,
            "transcript": "Nukalpiaq tauna atraqercami qayani taman' qaqican, paangerluni-w' pillilria wall'u-qaa piurqerluni."
        },
        "61": {
            "start": 556.02,
            "end": 562.92,
            "transcript": "Elatiitgun maaggun qayat iluatgun uivellinilria tauna nukalpiaq."
        },
        "62": {
            "start": 562.92,
            "end": 573.94,
            "transcript": "Piyungaqami qayami painganun ayaperyarak ukuk teguqerlukek waten qayam painga."
        },
        "63": {
            "start": 573.94,
            "end": 577.72,
            "transcript": "Ukuk ayaperyaranek wani avatiitni pituit."
        },
        "64": {
            "start": 577.72,
            "end": 584.04,
            "transcript": "Taukuk teguqerlukek kan'aqertelallinilria irugni qulliqlukek."
        },
        "65": {
            "start": 584.04,
            "end": 592.76,
            "transcript": "Qanerluni, \"Waten-gguq pitgaqatni aviciiquq. Avitarciquq.\""
        },
        "66": {
            "start": 592.76,
            "end": 597.08,
            "transcript": "Uivelliniluni tua-i tamaani."
        },
        "67": {
            "start": 597.08,
            "end": 614.72,
            "transcript": "Tua-i-llu piqerluni caqerluni tuaten pilriim una wani qayaan painganun pikii uquliami piiriimi qayaan painga qurrasqiarrluni paluartelliniluni."
        },
        "68": {
            "start": 614.72,
            "end": 630.52,
            "transcript": "Qayat-wa tua-i makut tayim' elaqvani maani tua-i, taukurluut-wa tua-i Apanuugpiim quyurrameng tuan iluatni tamana-wa tua-i iluqvaarkun tamana uivelleq kitnguluni."
        },
        "69": {
            "start": 630.52,
            "end": 638.1,
            "transcript": "Tua-i-ll' paluarcan Apanuugpak quaqualliniluni."
        },
        "70": {
            "start": 638.1,
            "end": 640.84,
            "transcript": "\"Qua-qua-quaq.\""
        },
        "71": {
            "start": 640.84,
            "end": 650.84,
            "transcript": "Maklaarmek pugelriacetun quaqualliniluni."
        },
        "72": {
            "start": 650.84,
            "end": 662.3,
            "transcript": "Nagiiquyallerani-ll' teguluku tauna tua-i yura'artellrani nalugvagluku egutelliniluku."
        },
        "73": {
            "start": 662.3,
            "end": 667.1,
            "transcript": "Tuarpiaq-gguq wavet pugumallrani."
        },
        "74": {
            "start": 667.1,
            "end": 681.72,
            "transcript": "Tamana-llu nagiiquyallerii anluni caningqaqerluni. Pugtaqerluni-ll' tauna, pugtaluni."
        },
        "75": {
            "start": 681.72,
            "end": 687.86,
            "transcript": "Apanuugpiim curukalliniluku pitaqngamiu."
        },
        "76": {
            "start": 687.86,
            "end": 699.38,
            "transcript": "Pitaqngamiu curukaamiu qayaa tekiarcamiu palungqallrani mak'arrluku paangrutek cayugartellinilukek."
        },
        "77": {
            "start": 699.38,
            "end": 704.1,
            "transcript": "Cayugarqaarluku-ll' uterrluni nauwaalliniluni."
        },
        "78": {
            "start": 704.1,
            "end": 709.38,
            "transcript": "\"Nauwa Paluqtaaralek? Paangrutairtellruuq.\""
        },
        "79": {
            "start": 709.38,
            "end": 713.46,
            "transcript": "Tunlliniluku Paluqtaaralegmun."
        },
        "80": {
            "start": 713.46,
            "end": 723.46,
            "transcript": "Paluqtaaralek makurtuamikek Paluqtaaralek ellakun paangerualliniluni."
        },
        "81": {
            "start": 723.46,
            "end": 733.84,
            "transcript": "Paangerualliniluni ellakun qanerluni, \"Tuarpiaq waniwa Kusquqviim painganun kautellria.\""
        },
        "82": {
            "start": 737.02,
            "end": 743.74,
            "transcript": "Pingailnguten. Anguyiit akuliitni."
        },
        "83": {
            "start": 743.74,
            "end": 748.88,
            "transcript": "Wiinga-ll' pingailngua alingtaama."
        },
        "84": {
            "start": 748.88,
            "end": 752.4,
            "transcript": "Alingnaqvaa-ll'."
        },
        "85": {
            "start": 752.4,
            "end": 761.12,
            "transcript": "Paangerualliniluni iqulirluku-ll' qanerluni, \"Tuarpiaq waniw' Kusquqviim painganun kautellria.\""
        },
        "86": {
            "start": 761.12,
            "end": 768.72,
            "transcript": "Aling."
        },
        "87": {
            "start": 768.72,
            "end": 784.56,
            "transcript": "Tua-i tauna Paluqtaaralek taumek Apanuugpak aiparluni Turrulumek."
        },
        "88": {
            "start": 784.56,
            "end": 797.42,
            "transcript": "Iqluyugnarqua. Pillugtuulliuq. Pillugtuq. Ii-i, Pillugtuq."
        },
        "89": {
            "start": 797.42,
            "end": 805.38,
            "transcript": "Taun' iqluyugnarqamken. Ayuquciirtanka atrit."
        },
        "90": {
            "start": 805.38,
            "end": 813.52,
            "transcript": "Uu, Iruvertum. Tauna-gguq cunaw' tua-i Iruvertuq tekiararutestiit."
        },
        "91": {
            "start": 813.52,
            "end": 819.28,
            "transcript": "Una-wa Pillugtuq qanqatailnguq."
        },
        "92": {
            "start": 819.28,
            "end": 836.9,
            "transcript": "Pillugtum tuani tua-i, Pillugtum tauna tuqlulallinia Apanuugpak Pillugtum."
        },
        "93": {
            "start": 842.6,
            "end": 855.4,
            "transcript": "Turrull', Turrull'aminek kipullgutelliniaqa au͡gna Turrull'amegnek-am tuqluutaqluni-ll', Turrull'."
        },
        "94": {
            "start": 855.4,
            "end": 866.94,
            "transcript": "\"Erinan-ggem anguyagnun alikniaqaat, qaku-mi an'arteqatarciu?\" Nanikuallermeggni."
        },
        "95": {
            "start": 866.94,
            "end": 869.42,
            "transcript": "Qaill' kiuksaunaku."
        },
        "96": {
            "start": 869.42,
            "end": 877.62,
            "transcript": "Tua-i-gguq tau͡gaam waten, qanren mamenqegpiiqnak atam tangerqernga."
        },
        "97": {
            "start": 877.62,
            "end": 888.22,
            "transcript": "Apanuugpakayak. Man'a-wa tua-i meq. Taryu. Meqaunrilnguq. Taryu."
        },
        "98": {
            "start": 888.22,
            "end": 894.16,
            "transcript": "Tuani tua-i taukut tua-i pillermini."
        },
        "99": {
            "start": 894.16,
            "end": 899.5,
            "transcript": "Tamaaken unatni qalutaartualallinii taryumek."
        },
        "100": {
            "start": 899.5,
            "end": 910.32,
            "transcript": "Aalemtaartualuni waten elliur', qanra kineryugluni."
        },
        "101": {
            "start": 910.32,
            "end": 923.1,
            "transcript": "Ukut-gguq-wa tau͡gaam tan'gaurluut pitekluki alingelria alinguskai picurlautnayukluki."
        },
        "102": {
            "start": 923.1,
            "end": 941.86,
            "transcript": "Tua-i erinii taqluni tauna. \"Turrull', qaku-mi erinan an'arteqatarciu? Anguyagnun-ggem malikniaqaat.\" Elaqsikluteng maa-i makut."
        },
        "103": {
            "start": 941.86,
            "end": 949.02,
            "transcript": "Tua-i-ll' tauna taum Paluqtaaralgem tauna,"
        },
        "104": {
            "start": 949.02,
            "end": 952.22,
            "transcript": "kitumek ima aterpagareskii,"
        },
        "105": {
            "start": 952.22,
            "end": 960.3,
            "transcript": "Pillugtuq ataataklinia. Ataataklinia-gguq."
        },
        "106": {
            "start": 960.3,
            "end": 966.86,
            "transcript": "Tua-i ataatakucia-llu nalluaqluku. Cakucia nalluluku."
        },
        "107": {
            "start": 966.86,
            "end": 976.16,
            "transcript": "Tuani tua-i pillinia taum paangrutegnek, paangrut'ngaartellrem pillinia,"
        },
        "108": {
            "start": 976.16,
            "end": 999.78,
            "transcript": "\"Imumirpak-llu,\" tauna ataatani taum tan'gaurluum, \"Qaillun pisit? Imumirpak-ggem pamaiturlurpakaucimnek pilararpenga,\" taum ayagyuam, \"pilararpenga. Nutaan-am waniw' pamailtaaqaqatartukut.\""
        },
        "109": {
            "start": 999.78,
            "end": 1004.68,
            "transcript": "Alingnaq'."
        },
        "110": {
            "start": 1004.68,
            "end": 1009.66,
            "transcript": "Kiumakuvga tua-i assiryartuten."
        },
        "111": {
            "start": 1009.66,
            "end": 1018.54,
            "transcript": "Neq'angutelaryartuten. Kangiituqa'aqluteng pikuvet wavet tailuten caulua, caulua."
        },
        "112": {
            "start": 1018.54,
            "end": 1020.62,
            "transcript": "Tarnanun uitayuumiitua."
        },
        "113": {
            "start": 1020.62,
            "end": 1032.04,
            "transcript": "Ii-i, tua-i-wa tutgara'urluqkemken. Tutgara'urluteng pituit piaqameng, cumiksiaqameng [?]."
        },
        "114": {
            "start": 1032.04,
            "end": 1034.84,
            "transcript": "Calilartatki tuaten piaqata?"
        },
        "115": {
            "start": 1034.84,
            "end": 1035.76,
            "transcript": "Qaillun?"
        },
        "116": {
            "start": 1035.76,
            "end": 1038.5,
            "transcript": "Tua-i-w' au͡gna quliravcia."
        },
        "117": {
            "start": 1038.5,
            "end": 1049.0,
            "transcript": "Ii-i, tua-i-wa tauna qamluni ataatii tauna tau͡gken qamevkenani ayagyuaq."
        },
        "118": {
            "start": 1049.0,
            "end": 1058.26,
            "transcript": "Tua-i-ll' tuaten pian aguagcan qemitaagiin Apanuugpiim tuqlullinia Turrull'."
        },
        "119": {
            "start": 1058.26,
            "end": 1067.4,
            "transcript": "Nauggun-mi waniwa elpet kiimelkuvet, aren, tamakut-gguq waten line-aumalriit avatairumastait."
        },
        "120": {
            "start": 1067.4,
            "end": 1068.12,
            "transcript": "Anguyak."
        },
        "121": {
            "start": 1068.12,
            "end": 1073.2,
            "transcript": "Anguyiit. Government-aat anguyiit."
        },
        "122": {
            "start": 1073.2,
            "end": 1082.4,
            "transcript": "Akultuluteng-gguq makut. Unkut-wa-gguq tang makut quyuryugluteng, quyuryugluteng."
        },
        "123": {
            "start": 1082.4,
            "end": 1092.14,
            "transcript": "Pamkut-wa-gguq arnat taukurmiut neplirluteng ngel'allagaqluteng qanerluteng,"
        },
        "124": {
            "start": 1092.14,
            "end": 1097.44,
            "transcript": "\"Tuarpiaq-gguq una-i unkut Kusquqvagmiurluut piyagaat.\""
        },
        "125": {
            "start": 1097.44,
            "end": 1108.78,
            "transcript": "Tauna tua-i Apanuugpak piluku, \"Tuar-gguq una-i piyagaat aanameggnek maligcuaralriit ukatmun caqirtaqan kingunrakun maligqura'aqluteng.\""
        },
        "126": {
            "start": 1108.78,
            "end": 1120.0,
            "transcript": "Ugaani tua-i una-i tua-i pitaqeqataitki taukut angutem  anguyameng."
        },
        "127": {
            "start": 1120.0,
            "end": 1127.4,
            "transcript": "Tua-i caqerluku tua-i pillinat taun' nutaan."
        },
        "128": {
            "start": 1127.4,
            "end": 1138.42,
            "transcript": "\"Turrull', tua-i-mi kiimelkuvet ukut wani tan'gaurluut ukut kiimelkuvet nauggun anangnaqucarciki?\""
        },
        "129": {
            "start": 1138.42,
            "end": 1147.64,
            "transcript": "Akultulriit niilliniluki taum wani Pillugtum."
        },
        "130": {
            "start": 1147.64,
            "end": 1157.1,
            "transcript": "Akultulriit niillinii, \"Maa-i-gguq-wa makut akultulriit anangnaqvigkaulriit.\""
        },
        "131": {
            "start": 1157.1,
            "end": 1163.64,
            "transcript": "Taum kiullinia, \"Qanga, tamakut pivigkaunritut akultulriit."
        },
        "132": {
            "start": 1163.64,
            "end": 1167.96,
            "transcript": "Maa-i-gguq tang tau͡gaam makut akulkilnguut quyuryulriit."
        },
        "133": {
            "start": 1167.96,
            "end": 1172.38,
            "transcript": "Maa-i-gguq makut anangnaqvigkaugut."
        },
        "134": {
            "start": 1172.38,
            "end": 1181.64,
            "transcript": "Maa-i-gguq caceskilnguut ayagyuarit.\""
        },
        "135": {
            "start": 1181.64,
            "end": 1194.6,
            "transcript": "Apanuugpak atam piuraqerluni sugturtellinill'. Tamakut cauluki anerquciaralliniluki."
        },
        "136": {
            "start": 1194.6,
            "end": 1198.44,
            "transcript": "Anerquciaracia nalluaqa."
        },
        "137": {
            "start": 1204.64,
            "end": 1212.64,
            "transcript": "Anerquciaralliniluki tamaaken taryumek aalemtaartualang'e'rmi."
        },
        "138": {
            "start": 1216.64,
            "end": 1220.76,
            "transcript": "Nepelkitliniluteng eriinii iqukliarcan."
        },
        "139": {
            "start": 1220.76,
            "end": 1232.86,
            "transcript": "\"Ilii,\" waten, \"ilii, qayumi tanem ukut.\""
        },
        "140": {
            "start": 1232.86,
            "end": 1250.64,
            "transcript": "Pamailtaarpakalriit yugkilnge'rmi, Apanuugpagmek ilangqelliniameng waten-llu tang qayangqelaami qanerrlugyuguarpalegmek alingnaqvall'aarnaluni."
        },
        "141": {
            "start": 1256.18,
            "end": 1274.0,
            "transcript": "Atam taukut nutaan tua-i anerquciarallni iquklican ayaumaarallinilria paangrutegnek tegulukek taukut tungiitnun."
        },
        "142": {
            "start": 1274.0,
            "end": 1285.92,
            "transcript": "Makut akulkilnguut cauluki qukviryartulliniluteng-llu."
        },
        "143": {
            "start": 1285.92,
            "end": 1300.6,
            "transcript": "Tauna imna paangrutairtelleq Paluqtaaralek ayagluki tua-i waten anqercaaqelliniluni-llu mengliikun paangerluni."
        },
        "144": {
            "start": 1305.32,
            "end": 1313.68,
            "transcript": "Qayaan kinguakun pamyuakun Apanuugpiim teguqerluku cayugartelliniluku."
        },
        "145": {
            "start": 1313.68,
            "end": 1321.26,
            "transcript": "\"Paluqtaaralek, qaillun pisit? Atam ilaten tangerqerki.\""
        },
        "146": {
            "start": 1321.26,
            "end": 1329.18,
            "transcript": "Maaten-gguq ilani tangrrai ellakun paangeruallinilriit ellarrlainarkun."
        },
        "147": {
            "start": 1330.4,
            "end": 1333.58,
            "transcript": "Alingnaq'."
        },
        "148": {
            "start": 1336.3,
            "end": 1341.46,
            "transcript": "Tua-i atam nutaan mermun kautellinikai paangrutet."
        },
        "149": {
            "start": 1341.46,
            "end": 1345.5,
            "transcript": "Unkut-llu tua-i imkut qukviryartulliniluteng."
        },
        "150": {
            "start": 1345.5,
            "end": 1351.1,
            "transcript": "Tua-i tuaten qukviryartuata tua-i caumaluki."
        },
        "151": {
            "start": 1351.1,
            "end": 1364.0,
            "transcript": "Ukuk tau͡gaam waten qukvillrata avatekek waten pitateksaguteqerluki nutaan puyur' anlliniluni."
        },
        "152": {
            "start": 1364.0,
            "end": 1369.62,
            "transcript": "Puyuat, pakillrat meq."
        },
        "153": {
            "start": 1369.62,
            "end": 1382.02,
            "transcript": "Imkut-llu maaken avatiitni-llu [?] aqercaaqellriit, aren, tau͡gaam-gguq tua-i tayima puyuq ketmun."
        },
        "154": {
            "start": 1382.02,
            "end": 1385.44,
            "transcript": "Ketmun tua-i puyuq tayima."
        },
        "155": {
            "start": 1386.5,
            "end": 1390.98,
            "transcript": "Una-am tape-aq nang'uq. Tuaken ataam piniartuten."
        }
    },
    "N9lX4sQZxO4": {
        "1": {
            "start": 16.34,
            "end": 21.71,
            "transcript": "Pinirniluku niitelartua wall'u-qaa im'a."
        },
        "2": {
            "start": 28.32,
            "end": 32.0,
            "transcript": "Pissuyuniluku-wa."
        },
        "3": {
            "start": 45.84,
            "end": 51.92,
            "transcript": "Apanuugpak-qaa chief-aqellriacetun pilallruuq?"
        },
        "4": {
            "start": 51.92,
            "end": 68.04,
            "transcript": "Chief-aqluku. Chief-auluni. Anguyiit curunraralriit-llu malikaqluki, malikaqluki. (Ready?)"
        },
        "5": {
            "start": 68.04,
            "end": 73.38,
            "transcript": "Naken ima taqetellrulua? (Ava-i ima tanem puyuq...)"
        },
        "6": {
            "start": 73.38,
            "end": 85.26,
            "transcript": "Ii-i, tua-i-gguq tuaten waniwa tua-i qukvilriit tamakut yuut, qukvilriit anluki igvarluki."
        },
        "7": {
            "start": 85.26,
            "end": 91.22,
            "transcript": "Tua-i-gguq pitariqerluki nutaan tua-i tamalkiut."
        },
        "8": {
            "start": 91.22,
            "end": 98.6,
            "transcript": "Nutaan tua-i tayim' puyuq tua-i caleryaryaaqeken cayugnaunaki."
        },
        "9": {
            "start": 98.6,
            "end": 114.46,
            "transcript": "Ava-i tau͡gaam tua-i imam tungiinun ketnguqapiar puyuq tua-i tau͡gaam ava-i puyuat paangrutaita pakillrat."
        },
        "10": {
            "start": 114.46,
            "end": 127.86,
            "transcript": "Paangelrianek tangeqsaituten? Wii tanglallruunga, tangvalallruunga arrluknginanek."
        },
        "11": {
            "start": 127.86,
            "end": 139.32,
            "transcript": "Whale-anek beluga-nek pitullernek ugkunek tangvatullruunga tamakunek tamakutgun."
        },
        "12": {
            "start": 139.32,
            "end": 147.18,
            "transcript": "Tutuliarmiullrat ciuliaritnek Qinarmiunek."
        },
        "13": {
            "start": 147.18,
            "end": 159.62,
            "transcript": "Anguyagcuutnguvailngermeng [?] neqkateng anguyagaqamegteki ucurnarqerrlugluteng."
        },
        "14": {
            "start": 159.62,
            "end": 170.28,
            "transcript": "Tua-i tayima tua-i. Aren, caqtaqyaryaaqegceteng [?] cayugnaunaki, tau͡gaam pivkenaki, tua-i taqluki."
        },
        "15": {
            "start": 170.28,
            "end": 176.42,
            "transcript": "Unaken ataam caukaceteng inerquutngullrulliniuq tamaani."
        },
        "16": {
            "start": 176.42,
            "end": 186.46,
            "transcript": "Imam-gguq tungiinun qimalriam maligcesqevkenaku, anguyiit inerquutngullrulliniat anguyiim nalliini."
        },
        "17": {
            "start": 186.46,
            "end": 192.32,
            "transcript": "Ii-i, cauciqngateng-gguq, cauciqngan."
        },
        "18": {
            "start": 192.32,
            "end": 195.34,
            "transcript": "Yukapiullrunrilameng."
        },
        "19": {
            "start": 195.34,
            "end": 216.72,
            "transcript": "Tua-i-llu nutaan caarkaircameng tauna imna paangerluni uivelleq imna taukunek tua-i piciqiarluni imna qayami pianek kitngulleq ayaperyarani qurrasqilluku."
        },
        "20": {
            "start": 216.72,
            "end": 225.78,
            "transcript": "Maaten-gguq ullagaat tuntum cirunran qungukuanek."
        },
        "21": {
            "start": 225.78,
            "end": 232.22,
            "transcript": "Tauna cingilengqellinilria qungukugmek."
        },
        "22": {
            "start": 232.22,
            "end": 236.36,
            "transcript": "Nakruutai-wa-gguq qucillginraat."
        },
        "23": {
            "start": 236.36,
            "end": 248.9,
            "transcript": "Qucillginrarnek tamana nagiiquyaller, Apanuugpiim nagiiquyallerii nakrutengqellinilria makunek tua-i qucillgallraat yaqurritnek."
        },
        "24": {
            "start": 248.9,
            "end": 252.84,
            "transcript": "Tua-i-gguq tauna nekakellruat."
        },
        "25": {
            "start": 252.84,
            "end": 257.68,
            "transcript": "Tauna-ll' tua-i tamana nagiiquyaller."
        },
        "26": {
            "start": 264.22,
            "end": 267.52,
            "transcript": "Tua-i tayima nutaan tua-i."
        },
        "27": {
            "start": 267.52,
            "end": 278.48,
            "transcript": "Tamaani ayagallrat, ayagallrat ilii ayuquciitaqa tua-i tau͡gaam tua-i piunririurluteng."
        },
        "28": {
            "start": 278.48,
            "end": 283.0,
            "transcript": "Piunriraqluki tua-i nall'arqengateng."
        },
        "29": {
            "start": 283.0,
            "end": 292.26,
            "transcript": "Tua-i-llu caqerluteng unugmi tua-i nunanun tekitelliniluteng."
        },
        "30": {
            "start": 292.26,
            "end": 303.58,
            "transcript": "Tuani tua-i nunanun tekicameng unugmi qayateng cimilliniut."
        },
        "31": {
            "start": 303.58,
            "end": 312.04,
            "transcript": "Tan'germi tua-i unugmi qayateng cimirluki anguyagtarnek."
        },
        "32": {
            "start": 312.04,
            "end": 316.4,
            "transcript": "Qayateng unilluki tuavet."
        },
        "33": {
            "start": 316.4,
            "end": 340.2,
            "transcript": "Tua-i maaten-gguq ertuq Apanuugpak tauna Apanuugpiim qayani cimillinikii taprirtuumaksailngurmek nutaq'apiarmek piluaqalkugluni."
        },
        "34": {
            "start": 340.2,
            "end": 349.84,
            "transcript": "Nutaan-gguq tua-i qayangarcameng anguyagtarnek, anguyag' amlleq piunrillruat."
        },
        "35": {
            "start": 349.84,
            "end": 359.96,
            "transcript": "Ellaita piitnek atuameng qayaitnek, qanerrluku yuguarpailgunek."
        },
        "36": {
            "start": 359.96,
            "end": 362.12,
            "transcript": "Tua-i,"
        },
        "37": {
            "start": 365.74,
            "end": 375.86,
            "transcript": "tua-i pivakaqateng cat iliitni mat'um iquk'ngatellruakut tua-i piaqa amllerrsaaquq, taksaaquq."
        },
        "38": {
            "start": 375.86,
            "end": 384.1,
            "transcript": "Er'artelliniluki unuakumi."
        },
        "39": {
            "start": 384.1,
            "end": 387.98,
            "transcript": "Tua-i iiralliniluteng."
        },
        "40": {
            "start": 387.98,
            "end": 394.4,
            "transcript": "Iliit-llu tua-i tauna palurutliniluni qayamun-wa pillill'."
        },
        "41": {
            "start": 394.4,
            "end": 397.38,
            "transcript": "Palurullun tua-i iterluni."
        },
        "42": {
            "start": 397.38,
            "end": 406.08,
            "transcript": "Iliit-llu qungut aciatnun keggautat pulaluni."
        },
        "43": {
            "start": 406.08,
            "end": 408.38,
            "transcript": "Aciat niirluni."
        },
        "44": {
            "start": 408.38,
            "end": 415.42,
            "transcript": "Iliit-llu uksuaq waniw' pilliameng. Iliit-llu can'gutnun pulaluni."
        },
        "45": {
            "start": 415.42,
            "end": 418.58,
            "transcript": "Ilait tayim' ayuquciitanka."
        },
        "46": {
            "start": 418.58,
            "end": 424.12,
            "transcript": "Tua-i taukut."
        },
        "47": {
            "start": 424.12,
            "end": 427.84,
            "transcript": "Tuaten pillrulliniut. Er'arrluki."
        },
        "48": {
            "start": 427.84,
            "end": 439.08,
            "transcript": "Tua-i-llu-gguq tuani ertellrani yaa-i-gguq tua-i ama-i tauna mikelnguq anguaruaryullria."
        },
        "49": {
            "start": 439.08,
            "end": 443.44,
            "transcript": "Anguaruarucetaalria tauna."
        },
        "50": {
            "start": 443.44,
            "end": 446.94,
            "transcript": "Tua-i-gguq qayaq tamana palungqaluni."
        },
        "51": {
            "start": 446.94,
            "end": 457.18,
            "transcript": "Tuani-gguq tua-i cali taum mikelnguum ullagluku maktessaalaryaaqaa pisciiganani. Yugmek-w' imangqerrami."
        },
        "52": {
            "start": 457.18,
            "end": 460.9,
            "transcript": "Tua-i uivagcirluni maknayukluku."
        },
        "53": {
            "start": 460.9,
            "end": 470.24,
            "transcript": "Aren, tua-i taum pinrilliniluku tua-i."
        },
        "54": {
            "start": 470.24,
            "end": 474.54,
            "transcript": "Unulliniluni tua-i ataam."
        },
        "55": {
            "start": 474.54,
            "end": 481.02,
            "transcript": "Tua-i-ll' elpekevkenaki cali tuani."
        },
        "56": {
            "start": 481.02,
            "end": 497.22,
            "transcript": "Tua-ll' nunat taukut iliitni elpekqanripakaqataiceteng-gguq cali tauna iliit uqilaliat amllinilliniluni taukut tua-i ketiitni."
        },
        "57": {
            "start": 497.22,
            "end": 503.52,
            "transcript": "Amllinilliniluni qau͡gyami, marayami-w' tua-i pillilria."
        },
        "58": {
            "start": 503.52,
            "end": 511.04,
            "transcript": "Amllinilliniluni tua-i aqvaqurluni ayakataameng."
        },
        "59": {
            "start": 511.04,
            "end": 513.68,
            "transcript": "Amllinilliniluni, cauga tamana?"
        },
        "60": {
            "start": 513.68,
            "end": 522.72,
            "transcript": "Amelvagtaarluni aqvaqurluni yaaqvanun tut'aqluni, amelvagtaarluni."
        },
        "61": {
            "start": 522.72,
            "end": 529.46,
            "transcript": "Tua-i ercan tamakut amllinret tanglliniluki."
        },
        "62": {
            "start": 529.46,
            "end": 535.4,
            "transcript": "Maaten-gguq cuqtait tamakut tamaa-i paangercuutet waten."
        },
        "63": {
            "start": 535.4,
            "end": 537.92,
            "transcript": "Tak'lartut."
        },
        "64": {
            "start": 537.92,
            "end": 543.88,
            "transcript": "Yaaken tua-i cuqtelliniluku waken it'gain tut'ellratnek ayagluku."
        },
        "65": {
            "start": 543.88,
            "end": 554.42,
            "transcript": "Akuliin-ll' yaani waten ulpetluku nutaan amani aipaini, aipiriluni amllellra nutaan tekilluku."
        },
        "66": {
            "start": 554.42,
            "end": 557.36,
            "transcript": "Yaqulgulliniuq tauna."
        },
        "67": {
            "start": 557.36,
            "end": 562.6,
            "transcript": "Wagg'uq un' qaguyaurluq."
        },
        "68": {
            "start": 562.6,
            "end": 568.82,
            "transcript": "Uqilaliat."
        },
        "69": {
            "start": 568.82,
            "end": 572.54,
            "transcript": "Tua-i tayima tuaken tua-i."
        },
        "70": {
            "start": 572.54,
            "end": 586.4,
            "transcript": "Tua-i tauna Apanuugpiim pian, anqarautiin apalluqaa tauna."
        },
        "71": {
            "start": 586.4,
            "end": 599.2,
            "transcript": "\"Nani-mi-lli nanilliurcia. Eqtaat-qaa keluatni. Elivernun paallaganemni-qaa.\""
        },
        "72": {
            "start": 599.2,
            "end": 603.0,
            "transcript": "Tua-i aipiriami apallirluku."
        },
        "73": {
            "start": 603.0,
            "end": 619.88,
            "transcript": "\"Nani-mi-lli nunakiqercia. Iyuussiim iluani. Eyarralek paiqatanemni-qaa.\""
        },
        "74": {
            "start": 619.88,
            "end": 624.9,
            "transcript": "Apanuugpallraam alairtellri tamaa-i."
        },
        "75": {
            "start": 624.9,
            "end": 635.76,
            "transcript": "Tua-i tamaa-i tamaani callrit amllerrsaaqut, tungliquciit tayima nalluyagutanka."
        },
        "76": {
            "start": 635.76,
            "end": 640.98,
            "transcript": "Tua-i-ll' caqerluteng utertelliniluteng."
        },
        "77": {
            "start": 640.98,
            "end": 647.72,
            "transcript": "Maa-i waten ullagtaarluki pianka. Ullagtaarluki pianka wani."
        },
        "78": {
            "start": 647.72,
            "end": 652.98,
            "transcript": "Utertelliniluteng anguyiit piangssallrit."
        },
        "79": {
            "start": 652.98,
            "end": 659.46,
            "transcript": "Tauna tua-i Putukuilnguq, Putukuilnguuguq."
        },
        "80": {
            "start": 663.68,
            "end": 670.02,
            "transcript": "Ii-i, Putukuilnguq, tauna curunrarnun maligutelleq."
        },
        "81": {
            "start": 670.02,
            "end": 678.5,
            "transcript": "Tauna tua-i peng'gartellrat."
        },
        "82": {
            "start": 678.5,
            "end": 687.7,
            "transcript": "Atiin tau͡gaam peng'gartevkenaku uterciiqniluku kaingekan."
        },
        "83": {
            "start": 687.7,
            "end": 692.66,
            "transcript": "Utertelliniluteng cam iliini tua-i tuani."
        },
        "84": {
            "start": 692.66,
            "end": 704.42,
            "transcript": "Tauna-gguq Putukuilnguq Uivngayagmiunguq, Uivngayagmi, Napaskiarmi."
        },
        "85": {
            "start": 704.42,
            "end": 715.32,
            "transcript": "Tua-i-llu kan'a Unguquutaq, Naparyarraarmiut kiatiitni tua-i una kuicuayaaq tanglaqan. Tagqercaraq kelukuiryaraq."
        },
        "86": {
            "start": 715.32,
            "end": 719.38,
            "transcript": "Tamana-gguq tamaa-i Kusquqvaullruuq."
        },
        "87": {
            "start": 719.38,
            "end": 726.92,
            "transcript": "Un'a tua-i Kusquqvagkaq cataunani, tau͡gaam tunguiruka'artarluni."
        },
        "88": {
            "start": 729.96,
            "end": 743.3,
            "transcript": "Tua-i-am utertelliniluteng maavet tua-i Kusquqvagmun kautniararluki tayima-wa pillilriit tauna Putukuilnguum atii, angutngurrluni."
        },
        "89": {
            "start": 743.3,
            "end": 749.52,
            "transcript": "Qimallermeggni katalliniluni, katagluni."
        },
        "90": {
            "start": 749.52,
            "end": 754.44,
            "transcript": "Mat'umek iqulirqa uumek au͡gna."
        },
        "91": {
            "start": 756.34,
            "end": 762.86,
            "transcript": "Tua-i tayim' katagluni uka-i tua-i tauna Putukuilnguum atii."
        },
        "92": {
            "start": 762.86,
            "end": 776.92,
            "transcript": "Tua-i pilalliniat tauna qetunraa, \"Aullutarr'u, Putukuilnguuq! Ataurluun ukna anguyiit teguqataraat.\""
        },
        "93": {
            "start": 776.92,
            "end": 781.56,
            "transcript": "Tua-i qimagluteng ilangciksaunak."
        },
        "94": {
            "start": 781.56,
            "end": 794.3,
            "transcript": "Tua-i am pilliniat, \"Putukuilnguuq, aullutarr'u. Ataurluun ukna anguyiit teguqataraat.\""
        },
        "95": {
            "start": 794.3,
            "end": 801.58,
            "transcript": "Tuam tua-i qetunraan pillinii, \"Uitaciu! Qerruircariuq.\""
        },
        "96": {
            "start": 801.58,
            "end": 805.28,
            "transcript": "Alingucugnaunaku."
        },
        "97": {
            "start": 805.28,
            "end": 807.36,
            "transcript": "Cauga qerruircaraq?"
        },
        "98": {
            "start": 807.36,
            "end": 810.08,
            "transcript": "Qerruiq pitegcautaircariuq."
        },
        "99": {
            "start": 810.08,
            "end": 811.3,
            "transcript": "[?]"
        },
        "100": {
            "start": 811.3,
            "end": 817.96,
            "transcript": "Ii-i, qerrunek, qerrunek pitegcautengqerrameng teggalqunek uminek."
        },
        "101": {
            "start": 817.96,
            "end": 823.52,
            "transcript": "Tamaa-i qerrunek pitullrit anguyagcuutet."
        },
        "102": {
            "start": 828.22,
            "end": 839.78,
            "transcript": "Tua-i kanavet Unguquutaq iciw' Naparyarram kiatiitni anqertellrani pingna qemikucuk canlilriani nallunritan."
        },
        "103": {
            "start": 839.78,
            "end": 856.58,
            "transcript": "Tauna ketairqamegteggu curuggaarluteng utertaqameng Putukuilnguum aklegallerani teguaqellinia, aklegallerii-gguq Putukuilnguum."
        },
        "104": {
            "start": 856.58,
            "end": 867.82,
            "transcript": "Tua-i-llu Kaucameng anguarturluteng tua-i, tuavet tua-i Kaucameng iciw' Naparyarrarmiut canimelkii."
        },
        "105": {
            "start": 867.82,
            "end": 875.34,
            "transcript": "Tamana tua-i nalugvagaluku egtaqluku pagg'un, pagg'un tua-i ayagaqluni."
        },
        "106": {
            "start": 875.34,
            "end": 884.9,
            "transcript": "Tut'aqami tua-i qatngerpak cermegpallartaqluni nalugvagaluni egqaqussiarluni."
        },
        "107": {
            "start": 884.9,
            "end": 901.18,
            "transcript": "Tua-i-gguq tuaken tuaten piaqan Napaskiarmiut ciuliarita tamana aklegallerii nepii niitaqaat qatngerpallagallra cingqullagallra."
        },
        "108": {
            "start": 901.18,
            "end": 904.28,
            "transcript": "Alingnaq'."
        },
        "109": {
            "start": 904.28,
            "end": 915.92,
            "transcript": "Ugaani tuknim tut'ellra mermun tut'aqami cingqullagaqluni qatngerpallarrluni Napaskiarnek-llu nepii nilluku."
        },
        "110": {
            "start": 915.92,
            "end": 920.0,
            "transcript": "Nalluvkenaku tua-i Napaskiarmium."
        },
        "111": {
            "start": 920.0,
            "end": 924.82,
            "transcript": "Tangerrluku utertellinillriit."
        },
        "112": {
            "start": 929.62,
            "end": 937.4,
            "transcript": "Nallunailkutaqluku aklegalleran igqaqaqaku."
        },
        "113": {
            "start": 937.4,
            "end": 940.02,
            "transcript": "Tua-i natmun ayagviirutua."
        },
        "114": {
            "start": 940.02,
            "end": 944.98,
            "transcript": "Tua-i-llu tekilluteng, tekilluteng."
        },
        "115": {
            "start": 944.98,
            "end": 958.44,
            "transcript": "Tekicameng tag'aqami imna Putukuilnguum atii, man'a naqugneni petengtaqlinia nangerrluni."
        },
        "116": {
            "start": 958.44,
            "end": 967.86,
            "transcript": "Petengcaku-llu avirlungluni uminek qerruircarilriit."
        },
        "117": {
            "start": 967.86,
            "end": 970.32,
            "transcript": "Tua-i-gguq tuaten katangaquq."
        },
        "118": {
            "start": 970.32,
            "end": 978.76,
            "transcript": "Tua-i tayim' anguyiit tua-i teguyukluku-ll' tayim' yaaqsigiluni tua-i cukamek tua-i qimalaameng."
        },
        "119": {
            "start": 978.76,
            "end": 988.98,
            "transcript": "Tua-i-llu-gguq tuaten pirraarluni ataam alairluni angulluni ilaminun qerruircarirraarluni."
        },
        "120": {
            "start": 988.98,
            "end": 994.1,
            "transcript": "Tauna-am tua-i call' tuaten anguyagcuun taum qanrutetullruut."
        },
        "121": {
            "start": 994.1,
            "end": 999.22,
            "transcript": "Apanuugpagglainaq pivkenani."
        },
        "122": {
            "start": 999.22,
            "end": 1008.68,
            "transcript": "Qerruircariluni pitegcautait nanglallikai-wa."
        },
        "123": {
            "start": 1008.68,
            "end": 1018.48,
            "transcript": "Tua-i-gguq imar', cani, imarniterluni-w' pilallill' qaillun."
        },
        "124": {
            "start": 1018.48,
            "end": 1029.72,
            "transcript": "Naqugni petengtaqaku avirlungaquq uminek pitegcautnek imkut qainganun turqellret tuqsaaqellinillret."
        },
        "125": {
            "start": 1029.72,
            "end": 1036.9,
            "transcript": "Kiituumayuunani tauna."
        },
        "126": {
            "start": 1036.9,
            "end": 1039.14,
            "transcript": "Tua-i-gguq tuaten piyaqut."
        },
        "127": {
            "start": 1039.14,
            "end": 1042.52,
            "transcript": "Ayagviirutua."
        },
        "128": {
            "start": 1042.52,
            "end": 1055.94,
            "transcript": "Nangenruluku anguyagturarrlainalartut saskuut-qaa tamaani, ak'a tamaani?"
        },
        "129": {
            "start": 1055.94,
            "end": 1060.38,
            "transcript": "Ilakucuitallrulriit ak'a tamaani."
        },
        "130": {
            "start": 1060.38,
            "end": 1069.02,
            "transcript": "Ii-i, curukata'arqameng tau͡gaam tua-i pet'ullrulliniut."
        },
        "131": {
            "start": 1069.02,
            "end": 1071.5,
            "transcript": "Tua-i curukata'arqameng."
        },
        "132": {
            "start": 1071.5,
            "end": 1086.86,
            "transcript": "Ciunerkateng-llu imkuluki tua-i-w' nallungqertengnaqluki tuaten uptetullruut, anguyagturrlainarpek'nateng arulairaqluteng."
        },
        "133": {
            "start": 1086.86,
            "end": 1097.98,
            "transcript": "Maaggun-llu un'ggun anguyiit ukatngurtaqameng Kialirkun asgurluteng pilallrulliniut."
        },
        "134": {
            "start": 1097.98,
            "end": 1106.62,
            "transcript": "Tua-i-am tuaten un'ggun pillratni pikani Nunacuarmiullret piatni Akulura'armiullerni."
        },
        "135": {
            "start": 1106.62,
            "end": 1121.7,
            "transcript": "Uksuaqvani, Tuntussurnam nalliini Akulura'armiullerni Ikiaramtaqvani [?] anguyiit agiirtellinillriit."
        },
        "136": {
            "start": 1121.7,
            "end": 1132.86,
            "transcript": "Tua-i-am allanerluteng taukut qau͡gkunek tuar tang Kuigglugmiungunikait anguyuutulinek."
        },
        "137": {
            "start": 1132.86,
            "end": 1140.46,
            "transcript": "Tau͡gken-gguq ellivigkiurartarluni qilailngurmek."
        },
        "138": {
            "start": 1140.46,
            "end": 1147.46,
            "transcript": "Un'a-wa-gguq angyaq ketiitni akivingqalria."
        },
        "139": {
            "start": 1147.46,
            "end": 1162.3,
            "transcript": "Ugkut-wa-gguq Akuluram ceńiini atsautait, atsautait, atsat kalngagnek caquluteng-llu maani yuilqurrarmi uitatullratni."
        },
        "140": {
            "start": 1162.3,
            "end": 1169.52,
            "transcript": "Taukut tua-i Akulura'armiullret Nunacuarmi ciuliarit."
        },
        "141": {
            "start": 1169.52,
            "end": 1179.3,
            "transcript": "Angutait tayim' pissuryaumaluteng arnarpalluuluteng."
        },
        "142": {
            "start": 1179.3,
            "end": 1186.4,
            "transcript": "Anguyiit tua-i agiirtellinillriit pikani Igyarami."
        },
        "143": {
            "start": 1186.4,
            "end": 1203.92,
            "transcript": "Tua-i-ll' ua-i ca tua-i elqiateng, elqiarit anguyiurcuuteteng uimeng at'elliniluki taukut arnat."
        },
        "144": {
            "start": 1203.92,
            "end": 1209.58,
            "transcript": "Taukuk-wa allanrek angutek saskurlutek."
        },
        "145": {
            "start": 1209.58,
            "end": 1216.38,
            "transcript": "Tua-i anguyiit taukut tailliniluteng maa-i tua-i."
        },
        "146": {
            "start": 1216.38,
            "end": 1230.04,
            "transcript": "Tua-i waten makuteng qaurateng alailkitarturtelluki taum iluani ukineliluku-llu tauna pitegcautem anvigkaanek."
        },
        "147": {
            "start": 1230.04,
            "end": 1247.46,
            "transcript": "Anguyiit taukut taingameng angyaq tamana caputekluku. It'gai tau͡gaam kana-i alairurluteng."
        },
        "148": {
            "start": 1247.46,
            "end": 1257.74,
            "transcript": "Taukuk tua-i angutek aipagnek it'gai cuqluki angyaq capumetengraaku pitgalliniluku iliit."
        },
        "149": {
            "start": 1257.74,
            "end": 1261.74,
            "transcript": "Angyaq tamana qetqallalliniluni."
        },
        "150": {
            "start": 1261.74,
            "end": 1270.8,
            "transcript": "Tauna tua-i ilii tuqulluku ayakalliniluteng-llu au͡gkut."
        },
        "151": {
            "start": 1270.8,
            "end": 1280.32,
            "transcript": "Tuamtellu tauna iliit atsanek nerluni, anguyiit taun' iliit atsaryunqellralliniami."
        },
        "152": {
            "start": 1280.32,
            "end": 1289.84,
            "transcript": "Iliita egtarluku taum pitgalliniluki ikigngallrani ua-i kan'a."
        },
        "153": {
            "start": 1289.84,
            "end": 1297.66,
            "transcript": "Nulluan nall'arrluku, camaggun anarcuutiikun nall'arrluku tuqulluku."
        },
        "154": {
            "start": 1297.66,
            "end": 1306.46,
            "transcript": "Ayakalliniluteng taukut anguyiit qanerluteng, \"Aullu, tua-i!\""
        },
        "155": {
            "start": 1306.46,
            "end": 1320.08,
            "transcript": "Qaillun ima tanem nalluyaguartaqa. Qanrutlerkam tayima nalluyaguarteqa'arqa."
        },
        "156": {
            "start": 1320.08,
            "end": 1326.02,
            "transcript": "Ii-i, ayallerkartek, ayallerkartek? (Nuu.)"
        },
        "157": {
            "start": 1326.02,
            "end": 1343.0,
            "transcript": "Waten ima pillinilria, taukut qanlliniut, \"Aullu-wa-i! Nangqataraitkut ukut. Ayagnaurtukut. Akulura'armiut, arenqiatelliniut ukut Akulura'armiut, ketiit-llu tang man'a angayaapcuulliniami [?].\""
        },
        "158": {
            "start": 1348.78,
            "end": 1352.68,
            "transcript": "Cali-qaa ilayuumiituten wall' taqsuqnguten?"
        }
    },
    "HyBIcPLbNVM": {
        "1": {
            "start": 65.14,
            "end": 68.74,
            "transcript": "Egan"
        },
        "2": {
            "start": 68.74,
            "end": 72.02,
            "transcript": "Egan"
        },
        "3": {
            "start": 78.62,
            "end": 80.8,
            "transcript": "Calisit?"
        },
        "4": {
            "start": 80.82,
            "end": 83.34,
            "transcript": "Kenirtua. Egan taikaniqerru."
        },
        "5": {
            "start": 85.62,
            "end": 87.74,
            "transcript": "Una-qaa?"
        },
        "6": {
            "start": 87.74,
            "end": 90.04,
            "transcript": "Ii-i, egan."
        },
        "7": {
            "start": 99.6,
            "end": 101.28,
            "transcript": "Egan"
        },
        "8": {
            "start": 102.54,
            "end": 105.4,
            "transcript": "Egan"
        },
        "9": {
            "start": 110.0,
            "end": 116.62,
            "transcript": "Nallunrikaniryuukuvgu alngaqiu Yugtun Qaneryaram Calivik."
        },
        "10": {
            "start": 116.62,
            "end": 123.1,
            "transcript": "Box 368, Mamterilleq, AK, 99559"
        },
        "11": {
            "start": 171.44,
            "end": 173.68,
            "transcript": "Kuuvviaq"
        },
        "12": {
            "start": 179.54,
            "end": 181.5,
            "transcript": "Kuuvviaq qallanguq?"
        },
        "13": {
            "start": 181.5,
            "end": 186.38,
            "transcript": "Aullu-wa-i, kuuvviaq."
        },
        "14": {
            "start": 186.38,
            "end": 188.1,
            "transcript": "Kuuvviryugtuci?"
        },
        "15": {
            "start": 188.1,
            "end": 191.06,
            "transcript": "Aang. Ii-i. Ii-i."
        },
        "16": {
            "start": 192.92,
            "end": 194.18,
            "transcript": "Un'."
        },
        "17": {
            "start": 198.58,
            "end": 200.82,
            "transcript": "Waniwa kuuvviaq."
        },
        "18": {
            "start": 212.14,
            "end": 213.06,
            "transcript": "Quyana."
        },
        "19": {
            "start": 213.06,
            "end": 215.02,
            "transcript": "Quyana. Ii-i."
        },
        "20": {
            "start": 215.02,
            "end": 216.46,
            "transcript": "Luuskaq."
        },
        "21": {
            "start": 228.32,
            "end": 230.32,
            "transcript": "Kuuvviaq"
        },
        "22": {
            "start": 312.94,
            "end": 318.18,
            "transcript": "Aullu-wa-i, waqaa-mi tanem."
        },
        "23": {
            "start": 318.18,
            "end": 320.2,
            "transcript": "Caugak taukuk tegumiagken?"
        },
        "24": {
            "start": 320.2,
            "end": 325.06,
            "transcript": "Igauguk. Waten nepengqertuk, t, t."
        },
        "25": {
            "start": 325.06,
            "end": 326.84,
            "transcript": "Ciin-mi ayuqenritak?"
        },
        "26": {
            "start": 326.84,
            "end": 332.98,
            "transcript": "Ayuqsaaquk, uum tau͡gaam ayagnitui atret waten,"
        },
        "27": {
            "start": 332.98,
            "end": 337.02,
            "transcript": "Tun'aq, Tanuk'aq."
        },
        "28": {
            "start": 337.02,
            "end": 342.9,
            "transcript": "Igat-llu ayagnitui waten, tau͡gaam, cataunani."
        },
        "29": {
            "start": 342.9,
            "end": 344.24,
            "transcript": "Taringan?"
        },
        "30": {
            "start": 344.24,
            "end": 347.5,
            "transcript": "Naamikika. Tauna-mi mikellra?"
        },
        "31": {
            "start": 347.5,
            "end": 352.64,
            "transcript": "Una-llu atutuuq tamalkuitnun t-aalrianun."
        },
        "32": {
            "start": 352.64,
            "end": 358.86,
            "transcript": "Tan'gerliq, aatam, neqet."
        },
        "33": {
            "start": 417.74,
            "end": 420.06,
            "transcript": "[?]"
        },
        "34": {
            "start": 420.06,
            "end": 421.88,
            "transcript": "yaassiiget"
        },
        "35": {
            "start": 421.88,
            "end": 423.68,
            "transcript": "Qavciugat-kiq?"
        },
        "36": {
            "start": 423.68,
            "end": 425.46,
            "transcript": "yaassiiget"
        },
        "37": {
            "start": 425.46,
            "end": 428.6,
            "transcript": "Naaqlauk. Ii-i."
        },
        "38": {
            "start": 428.6,
            "end": 432.46,
            "transcript": "Atauciq. Atauciq yaassiik."
        },
        "39": {
            "start": 432.54,
            "end": 437.34,
            "transcript": "Malruk. Malruk yaassiik."
        },
        "40": {
            "start": 437.34,
            "end": 441.82,
            "transcript": "Pingayun. Pingayun yaassiiget."
        },
        "41": {
            "start": 441.82,
            "end": 446.16,
            "transcript": "Cetaman. Cetaman yaassiiget."
        },
        "42": {
            "start": 446.16,
            "end": 450.42,
            "transcript": "Talliman. Talliman yaassiiget."
        },
        "43": {
            "start": 450.42,
            "end": 454.1,
            "transcript": "Arvinlegen. Aullu, aullu-wa-i."
        },
        "44": {
            "start": 454.1,
            "end": 457.2,
            "transcript": "Aullu-wa-i."
        },
        "45": {
            "start": 457.2,
            "end": 462.0,
            "transcript": "Yaassiiget ayagtut."
        },
        "46": {
            "start": 527.8,
            "end": 530.18,
            "transcript": "Keggucet"
        },
        "47": {
            "start": 536.16,
            "end": 539.72,
            "transcript": "Nauwa imkut keggutet?"
        },
        "48": {
            "start": 545.36,
            "end": 546.96,
            "transcript": "Keggutet"
        },
        "49": {
            "start": 549.18,
            "end": 553.42,
            "transcript": "Nauwa imkut keggutet?"
        },
        "50": {
            "start": 563.06,
            "end": 565.06,
            "transcript": "Waniwa!"
        },
        "51": {
            "start": 566.52,
            "end": 571.72,
            "transcript": "Aa-a, waniwa keggutet."
        },
        "52": {
            "start": 661.94,
            "end": 665.0,
            "transcript": "Qitevvluni."
        },
        "53": {
            "start": 694.1,
            "end": 700.36,
            "transcript": "Qitevvluni taringesciiganaku-ll' wii qalartellra."
        },
        "54": {
            "start": 763.66,
            "end": 767.9,
            "transcript": "Wiinga arrurkagyulirta wii-ayu-ayu."
        },
        "55": {
            "start": 767.9,
            "end": 770.12,
            "transcript": "Wiinga"
        },
        "56": {
            "start": 770.12,
            "end": 773.3,
            "transcript": "Wiinga saskaqa."
        },
        "57": {
            "start": 773.3,
            "end": 776.5,
            "transcript": "Wiinga luuskaaqa."
        },
        "58": {
            "start": 776.5,
            "end": 780.92,
            "transcript": "Wiinga inuguaqa. Wiinga pikamken iciwa."
        },
        "59": {
            "start": 780.92,
            "end": 782.68,
            "transcript": "Ii-i."
        },
        "60": {
            "start": 784.22,
            "end": 787.22,
            "transcript": "Wiinga angqaqa."
        },
        "61": {
            "start": 787.22,
            "end": 789.64,
            "transcript": "Qang'a, wiinga pikaqa."
        },
        "62": {
            "start": 789.64,
            "end": 792.0,
            "transcript": "Ala-i."
        },
        "63": {
            "start": 795.18,
            "end": 797.34,
            "transcript": "Wiinga"
        },
        "64": {
            "start": 989.92,
            "end": 992.88,
            "transcript": "Cangyuipaa"
        },
        "65": {
            "start": 998.18,
            "end": 1001.24,
            "transcript": "Ii-i, cangyuipaa."
        },
        "66": {
            "start": 1001.8,
            "end": 1003.84,
            "transcript": "Cangeksaituten-qaa?"
        },
        "67": {
            "start": 1003.88,
            "end": 1006.58,
            "transcript": "Yaa, cangeksaitua."
        },
        "68": {
            "start": 1006.58,
            "end": 1008.0,
            "transcript": "Aa-a."
        },
        "69": {
            "start": 1009.06,
            "end": 1011.4,
            "transcript": "Elpesmi?"
        },
        "70": {
            "start": 1011.4,
            "end": 1014.0,
            "transcript": "Cangeksaitua-llu."
        },
        "71": {
            "start": 1019.72,
            "end": 1023.0,
            "transcript": "Cangyuipaa"
        },
        "72": {
            "start": 1023.0,
            "end": 1028.32,
            "transcript": "Tua-i-w' cangeksaitukuk [?], uterrluk."
        },
        "73": {
            "start": 1028.32,
            "end": 1032.32,
            "transcript": "Yaa, cangnaitsiyaagtuq."
        },
        "74": {
            "start": 1033.64,
            "end": 1036.0,
            "transcript": "Cangnaituq."
        },
        "75": {
            "start": 1036.0,
            "end": 1038.86,
            "transcript": "Cangyuipaa"
        },
        "76": {
            "start": 1042.76,
            "end": 1045.58,
            "transcript": "Waqaa camna."
        },
        "77": {
            "start": 1047.02,
            "end": 1049.4,
            "transcript": "Cangyugnarqua."
        },
        "78": {
            "start": 1049.4,
            "end": 1052.98,
            "transcript": "Cangyugnarqua-ll' tau͡g' naamell'."
        },
        "79": {
            "start": 1058.44,
            "end": 1061.0,
            "transcript": "Cangenritlinianga."
        },
        "80": {
            "start": 1128.52,
            "end": 1130.52,
            "transcript": "Ella"
        },
        "81": {
            "start": 1131.28,
            "end": 1144.68,
            "transcript": "Iciw' erenret avani elqilak [?] alaiksuarturalalria tanqigcenani unuakuarmi akertem tua-i tunglirnerani alaiksuaralalria ernernek tamakut pituit."
        },
        "82": {
            "start": 1144.68,
            "end": 1153.0,
            "transcript": "Tua-i tanqigcenani alaiksuararqan tanqigcenani tua-i au͡gna acia mat'um amirlum."
        },
        "83": {
            "start": 1153.2,
            "end": 1161.0,
            "transcript": "Tanqigcenani ayuqekan ernermiku assiriarkauluni ayuqetuuq tuaten erenremainanrani."
        },
        "84": {
            "start": 1161.0,
            "end": 1162.12,
            "transcript": "Kavircetaqan?"
        },
        "85": {
            "start": 1162.12,
            "end": 1165.0,
            "transcript": "Qatraqan. Qatraqan. Qaternun piaqan."
        },
        "86": {
            "start": 1165.0,
            "end": 1173.34,
            "transcript": "Tua-i-ll' kavircenani pikan atam qanerciqut, erneq-gguq iquklisngaitaa kegg'um ellam wani ellaqerciiquq erenremainanrani."
        },
        "87": {
            "start": 1173.34,
            "end": 1175.0,
            "transcript": "Ella"
        },
        "88": {
            "start": 1222.56,
            "end": 1224.54,
            "transcript": "Patuu!"
        },
        "89": {
            "start": 1226.32,
            "end": 1229.18,
            "transcript": "Patuuq."
        },
        "90": {
            "start": 1230.1,
            "end": 1232.66,
            "transcript": "Ikiirtuq. Patuu!!"
        },
        "91": {
            "start": 1234.58,
            "end": 1238.0,
            "transcript": "Patuuq."
        },
        "92": {
            "start": 1238.92,
            "end": 1241.78,
            "transcript": "Ikiirtuq. Patuu!!!"
        },
        "93": {
            "start": 1243.7,
            "end": 1246.3,
            "transcript": "Patuuq."
        },
        "94": {
            "start": 1247.68,
            "end": 1250.88,
            "transcript": "Ataam ikiirtuq. Patuu!!"
        },
        "95": {
            "start": 1255.14,
            "end": 1258.28,
            "transcript": "Akleng!"
        },
        "96": {
            "start": 1258.42,
            "end": 1260.66,
            "transcript": "Akleng."
        },
        "97": {
            "start": 1260.66,
            "end": 1262.62,
            "transcript": "Patuuguq-qaa?"
        },
        "98": {
            "start": 1262.62,
            "end": 1265.0,
            "transcript": "Amiiguuq."
        },
        "99": {
            "start": 1267.72,
            "end": 1271.0,
            "transcript": "Patuuq."
        },
        "100": {
            "start": 1397.8,
            "end": 1400.0,
            "transcript": "Caugak?"
        },
        "101": {
            "start": 1402.04,
            "end": 1404.56,
            "transcript": "Cauga?"
        },
        "102": {
            "start": 1405.68,
            "end": 1409.74,
            "transcript": "Aullu! Ila-i!"
        },
        "103": {
            "start": 1409.74,
            "end": 1411.7,
            "transcript": "Caugak."
        },
        "104": {
            "start": 1412.62,
            "end": 1414.34,
            "transcript": "Angqak."
        },
        "105": {
            "start": 1414.96,
            "end": 1419.12,
            "transcript": "Aarra, angqak."
        }
    },
    "Kjcw1u0CD1g": {
        "1": {
            "start": 11.52,
            "end": 21.08,
            "transcript": "Uncle John. John Qusauyaq yuurtellruuq Nunivaarmi, Carvarmiut nuniitni 1909-am nalliini."
        },
        "2": {
            "start": 21.08,
            "end": 29.68,
            "transcript": "Ilani malikluki up'nerkaliyatullruuq, kiagivigmun, uksuarvigmun, tua-i-llu uksuvimun."
        },
        "3": {
            "start": 29.68,
            "end": 34.94,
            "transcript": "Makut taqukat, yaqulget, cali allat neqkat maliggluki."
        },
        "4": {
            "start": 34.94,
            "end": 38.84,
            "transcript": "Angliluni-llu ataatiin anglicarluku."
        },
        "5": {
            "start": 38.84,
            "end": 42.28,
            "transcript": "Atairutellruuq ayagyuallermini."
        },
        "6": {
            "start": 42.28,
            "end": 50.18,
            "transcript": "Nerluni-llu ataatiin nayiiraraam tegullrani piluguirucuirutniluni."
        },
        "7": {
            "start": 50.18,
            "end": 57.48,
            "transcript": "Elitellruuq yuuyaramek pissiryarallracetun tangvagluki tegganret qasgimi."
        },
        "8": {
            "start": 57.48,
            "end": 64.0,
            "transcript": "Ellminek-llu pissuryaurrluni urluvetgun cali-llu negatgun."
        },
        "9": {
            "start": 64.0,
            "end": 77.86,
            "transcript": "Tamaani calinguatulriit murilketullrui qantaliaqata kegginaquliaqata canguanek cali-llu mertarcuutnek pililriit allanernun tuniaqetukait."
        },
        "10": {
            "start": 77.86,
            "end": 84.66,
            "transcript": "Canaryaramek kia elicungcallrunritlinia. Ellminek elitellrui tangvagluki."
        },
        "11": {
            "start": 84.66,
            "end": 89.8,
            "transcript": "[?] Ak'a kua-i calineq nallullrusiaqaqatkut neku makunek."
        },
        "12": {
            "start": 89.8,
            "end": 98.8,
            "transcript": "[?] Taugaam pilriit tangerturluki ayuqniarluni ayuqnguigurluki calliuqaturiunga."
        },
        "13": {
            "start": 98.8,
            "end": 103.56,
            "transcript": "Ciuliaminek elitellermitun saskuminek pililartuq."
        },
        "14": {
            "start": 103.56,
            "end": 108.24,
            "transcript": "Kepun aturluku ciumek muriit caliaqelarai."
        },
        "15": {
            "start": 108.24,
            "end": 115.4,
            "transcript": "Tua-i-llu assircaarnariat canassuutmek aturluni qaqilluki."
        },
        "16": {
            "start": 115.4,
            "end": 125.82,
            "transcript": "Umyuangellrit canalallrit-llu piliarit mat'um nalliini ayuqenritut Uncle John-am tanglallratun."
        },
        "17": {
            "start": 125.82,
            "end": 131.06,
            "transcript": "[?] Makunun ellaitnun pililriit amllellrunritut."
        },
        "18": {
            "start": 131.06,
            "end": 139.2,
            "transcript": "[?] Carvualriit pilitullruut caliyuilnguut amllellruut makunek tan'gurrauluni."
        },
        "19": {
            "start": 142.08,
            "end": 153.6,
            "transcript": "[?] Una tua-i kinguqvakun elilluteng akingeqtaaruteklagyarnek calilriit amlleriut makuliurallrit."
        },
        "20": {
            "start": 153.6,
            "end": 159.8,
            "transcript": "[?] Ellmeggnek elissarluteng calliurluteng, ilait calilguarluteng."
        },
        "21": {
            "start": 162.44,
            "end": 171.14,
            "transcript": "Uncle John-aq yuungnaqluni anangnaqluni yuuguq maaken nunamek imarpiim-llu ungssianek."
        },
        "22": {
            "start": 171.14,
            "end": 190.58,
            "transcript": "Canallermikun aklungqertuq qantanek kegginaqunek wall' cauyanek yurarcuuciaqluni, ipuutnek akuyutsuuciaqluni, mertarcuutnek wall' canguanek tuneniaraqluni Nunivaarmun tekitellrianun."
        },
        "23": {
            "start": 190.58,
            "end": 197.94,
            "transcript": "Cali tuyuqaqluki Sitka-mun wall' Juneau-mun kipusvicuarnun tuneniaqesqelluki."
        },
        "24": {
            "start": 197.94,
            "end": 207.76,
            "transcript": "Akingutni aturyulrianun neqkanun kiircautet uquitnun wall' camek piyullerminek unangevkaraqluku."
        },
        "25": {
            "start": 210.84,
            "end": 217.7,
            "transcript": "[?] Makunek-ll' pilayuitellruut tamaani miktellemni nallulqait."
        },
        "26": {
            "start": 221.76,
            "end": 235.76,
            "transcript": "[?] Akaurtellria piliyaurcama tau͡gaam tunuvicugtalqut, tuna uitaruartelluki kesianek tunuvingqaqa'arqata tuniaqluki."
        },
        "27": {
            "start": 235.76,
            "end": 245.6,
            "transcript": "[?] Tunqaraqluki casruarun anruarnek navurtaqaraqateng cat tan'gurraullemni quyanarqeqatarluteng."
        },
        "28": {
            "start": 245.6,
            "end": 249.08,
            "transcript": "[?] Carpagmun tunelriatun."
        },
        "29": {
            "start": 252.82,
            "end": 260.38,
            "transcript": "[?] Tamana kass'at nurnatellrunrilata tan'gurraullemteńi."
        },
        "30": {
            "start": 260.38,
            "end": 268.6,
            "transcript": "[?] Alingnaruarluteng cali nalluluni tangellrat, tangenraraller."
        },
        "31": {
            "start": 268.6,
            "end": 278.48,
            "transcript": "[?] Alingtuluta tan'gur' kuyalingaling tua-llu kass'anek tangrraqama angyarpigcuutnek tekiartellrianek."
        },
        "32": {
            "start": 290.4,
            "end": 296.44,
            "transcript": "[?] Maa-i kinguqvakun tunelciryarqut kass'at amlleringata makut."
        },
        "33": {
            "start": 296.44,
            "end": 300.44,
            "transcript": "[?] Cangta-wa makut calliat."
        },
        "34": {
            "start": 323.36,
            "end": 326.26,
            "transcript": "Igaruarun."
        },
        "35": {
            "start": 333.12,
            "end": 336.14,
            "transcript": "[?] Igaruarun caluni."
        },
        "36": {
            "start": 342.42,
            "end": 347.36,
            "transcript": "[?] Ukatmun pissuutekluku, una-llu ukatmun."
        },
        "37": {
            "start": 350.28,
            "end": 359.28,
            "transcript": "[?] Makut-llu ukatmun. Cuucunguaruluku. Qanliraqluku."
        },
        "38": {
            "start": 365.48,
            "end": 369.26,
            "transcript": "[?] Una-llu qilagcuun."
        },
        "39": {
            "start": 369.26,
            "end": 371.32,
            "transcript": "Kegguciurcuun."
        },
        "40": {
            "start": 371.32,
            "end": 382.1,
            "transcript": "[?] Kanavet iqugglainamun tuntaaranka. Kat'umun callianek kiputetulimun."
        },
        "41": {
            "start": 382.1,
            "end": 389.1,
            "transcript": "[?] Laavkaaq kan'a equgglainaq tuskarunrilnguq, tuavet tuntaaranka."
        },
        "42": {
            "start": 389.1,
            "end": 400.3,
            "transcript": "[?] Cali kiani itercellem ketiini arnamun Cup'igmun. Taumun cali tun'itartuanga."
        },
        "43": {
            "start": 402.88,
            "end": 413.42,
            "transcript": "[?] Tua-i-ll' tauna pissiyaanriqertuanga maa-i kat'um kiputetarngatki, kanavet maniaqameng."
        },
        "44": {
            "start": 413.42,
            "end": 421.28,
            "transcript": "[?] Ak'a-llu Anchorage-amun tun'iqutallruunga makuneg' ayagluanga tamaavet ayallemni."
        },
        "45": {
            "start": 431.58,
            "end": 437.42,
            "transcript": "Canaarkaminek unangelartuq camaken Nunivaarmek."
        },
        "46": {
            "start": 437.42,
            "end": 447.7,
            "transcript": "Muragtelartuq ceńamek, mingunek-llu nunamek, cali-llu melquit metraat imarpigmi ingtetulit."
        },
        "47": {
            "start": 447.7,
            "end": 457.84,
            "transcript": "Ellminek makunek avulartuq Nunivaarmek cali-llu Qaluyaanek, tau͡gaam maa-i ilaminun unangevkalartuq."
        },
        "48": {
            "start": 461.96,
            "end": 471.84,
            "transcript": "Mamterillernun upallruuq Nunivaarmek 1980-mi, malikluki nuliani cetaman-llu anglicarani."
        },
        "49": {
            "start": 471.84,
            "end": 477.94,
            "transcript": "Amlleret nallunritaat Nunivaarmiut piciryaraicetun canalallra."
        },
        "50": {
            "start": 477.94,
            "end": 483.36,
            "transcript": "Aprumaluni-llu uum Dorothy Jean Ray-am kalikaini."
        },
        "51": {
            "start": 483.36,
            "end": 491.26,
            "transcript": "Caliari qelkaat wall' tuneniarkat paivcimaut Yugtarvigmi maani Mamterillermi."
        },
        "52": {
            "start": 491.26,
            "end": 496.92,
            "transcript": "Ilakellruat-llu canallermeng kegginaqunek elitnauriluteng."
        },
        "53": {
            "start": 496.92,
            "end": 504.3,
            "transcript": "Maa-i-llu kegginaquliarit aturaqluki yuraraqameng ukut Mamterillermiut yurartait."
        },
        "54": {
            "start": 519.32,
            "end": 529.66,
            "transcript": "[?] Qemagpilima nallumyugtuq yugtuqaqarlua pinirnayukaqamku pililaagaraqlua piniriruanrilengraata."
        },
        "55": {
            "start": 529.66,
            "end": 533.1,
            "transcript": "[?] Canatiirutervagngan."
        },
        "56": {
            "start": 541.08,
            "end": 548.74,
            "transcript": "[?] Taugaam amkut calliarkirinriqertuan, calliarkaucunguan."
        },
        "57": {
            "start": 548.74,
            "end": 558.02,
            "transcript": "[?] Uitauraller pininrilan calliurtarilan calliar una kan'a uitauraller enuqipaallagnarqetaartuq."
        },
        "58": {
            "start": 558.02,
            "end": 563.54,
            "transcript": "[?] Calinguarturaller kesangcikarmek unangnarqenrutartuq."
        },
        "59": {
            "start": 570.54,
            "end": 577.44,
            "transcript": "[?] Taiyungarrlua tuniaqamki yurqeryugnariaqlua."
        },
        "60": {
            "start": 577.44,
            "end": 581.24,
            "transcript": "[?] Akikuyugarmun tunqerraqamki."
        },
        "61": {
            "start": 679.04,
            "end": 691.2,
            "transcript": "Waniwa aturpakatartukut wani aturcetaarcuutgun \"Sing to the Lord Alleluia\", wani-gguq 234."
        },
        "62": {
            "start": 691.2,
            "end": 700.28,
            "transcript": "Nicholas Charles Sr., Ayagina'ar, yuurtellruuq Qaluyaarmi uksuarmi 1912-aam nalliini."
        },
        "63": {
            "start": 700.28,
            "end": 705.14,
            "transcript": "Ilai yaqulegcullratni uksumi neqkameggnek."
        },
        "64": {
            "start": 705.14,
            "end": 712.54,
            "transcript": "Angliluni-llu yuullermegcetun tamaani neqengqellriit ullagtaarluki."
        },
        "65": {
            "start": 712.54,
            "end": 718.66,
            "transcript": "Elitellruuq yuungnaqsaramek ciuliat qanellrit niilluki qasgimi."
        },
        "66": {
            "start": 718.66,
            "end": 729.38,
            "transcript": "Cali-llu pissurcuutnek, canassuutnek, pissuryaraq, neqsuryaraq, qaillun-llu yuuyaraq elitellrua tangerrluki."
        },
        "67": {
            "start": 729.38,
            "end": 736.08,
            "transcript": "Ayagina'ar upallruuq Kassiglumun tamaani-llu nulirturluni Nengeq'amek."
        },
        "68": {
            "start": 736.08,
            "end": 742.24,
            "transcript": "Pivakarlutek-llu upallruuk Mamterillermun 1943-aami."
        },
        "69": {
            "start": 742.24,
            "end": 747.2,
            "transcript": "Pelatekami uitallruuk Ayagina'ar nel'inatkaanun."
        },
        "70": {
            "start": 747.2,
            "end": 750.94,
            "transcript": "Mamterillerni calitullruuq akingluni."
        },
        "71": {
            "start": 750.94,
            "end": 760.14,
            "transcript": "Makunek angyanek kituggluki, tuskaliluni, cali-llu kuvyaluni tuneniarkanek."
        },
        "72": {
            "start": 760.14,
            "end": 769.04,
            "transcript": "Nel'iluni caliangqellruuq, maa-i-llu neliari mat'um nalliini cali napaluteng kuigem ceńiini."
        },
        "73": {
            "start": 769.04,
            "end": 780.26,
            "transcript": "Tamaani tulunek calinguatullruuq, tau͡gaam maa-i canalartuq muragnek arcaqerluki makunek kegginaqunek pilivallugtuq."
        },
        "74": {
            "start": 780.26,
            "end": 790.2,
            "transcript": "Cali-llu kegginaqulillni pitekluki ayallruuq akmavet Washington, D.C.-mun Smithsonian Institution-aam pivkarluku."
        },
        "75": {
            "start": 790.2,
            "end": 795.84,
            "transcript": "Cali-llu nunuliutengaqluni anagtassiigutellriani."
        },
        "76": {
            "start": 795.84,
            "end": 800.46,
            "transcript": "Ayagina'ar Mamterillerni yuratulit ilakaat."
        },
        "77": {
            "start": 800.46,
            "end": 803.82,
            "transcript": "Aturteńguluni cauyarluni."
        },
        "78": {
            "start": 803.82,
            "end": 808.5,
            "transcript": "Man'a-llu elitnaurutkaqluku ayagyuanun."
        },
        "79": {
            "start": 808.5,
            "end": 815.62,
            "transcript": "Cali-llu agayulirtet ilakluku Catholic-aat maani Mamterillermi."
        },
        "80": {
            "start": 818.3,
            "end": 828.96,
            "transcript": "Maa-irpak Ayagina'ar canatuuq kegginaqunek, qantanek, cauyanek, qayat anguarutaitnek, cali-llu tegumianek."
        },
        "81": {
            "start": 828.96,
            "end": 838.18,
            "transcript": "Canalartuq akingengnaqluki tua-i-wa maa-i yuullermi akiilnguitesciigaliamta."
        },
        "82": {
            "start": 838.18,
            "end": 847.1,
            "transcript": "Maa-i-llu yuungnaqsaram ilakengluku maani Kuigpiim Kusquqviim paingagnek iluani."
        },
        "83": {
            "start": 847.1,
            "end": 857.46,
            "transcript": "Umyuangcarturluni calilleq anglanarquq. Tua-i umyuartequ'urluni qaillun ayuqluku taqlerkaa, qaillun piyunaqluni, qaillun assirluni taqlerkaa."
        },
        "84": {
            "start": 857.46,
            "end": 862.22,
            "transcript": "Elluarrluni taqumallerkaa umyuartequ'urluni."
        },
        "85": {
            "start": 862.22,
            "end": 867.34,
            "transcript": "Ca tamarmi tuaten umyuartequ'urluni caliaqellrat assirtuq."
        },
        "86": {
            "start": 867.34,
            "end": 879.38,
            "transcript": "Umyuameggni umyuartequ'urluni kiituan' tuaten tua-i piyullemtun piaqluku, assirarkaungelliniaqan [?] tuaten piqatarraarluku taqluku all'amek cimiraqluteng."
        },
        "87": {
            "start": 879.38,
            "end": 885.78,
            "transcript": "Tuaten calinarquq makunek. Piyugtacimtun tua-i pilliin [?] umyuangtacimtun."
        },
        "88": {
            "start": 885.78,
            "end": 892.92,
            "transcript": "Wii-w' tuaten calilalrianga umyuangtacimtun tua-i tuaten piyullemtun."
        },
        "89": {
            "start": 892.92,
            "end": 898.16,
            "transcript": "Ca tamarmi umyuarteqevkenani cakviituq, umyuarteqluni tau͡gaam."
        },
        "90": {
            "start": 898.16,
            "end": 902.6,
            "transcript": "Umyuartequ'urluni qaillun assirluni taqlerkaanek."
        },
        "91": {
            "start": 902.6,
            "end": 908.96,
            "transcript": "Tua-i umyuarteqevkenani tau͡gkun caucirkaunaku tua-i caliaqeciqaa."
        },
        "92": {
            "start": 908.96,
            "end": 917.06,
            "transcript": "Ayaginaraam canatullni assirluki mat'umun yuungnaqsaratullminun atania."
        },
        "93": {
            "start": 917.06,
            "end": 920.92,
            "transcript": "Tua-i yuullruami tuaten."
        },
        "94": {
            "start": 920.92,
            "end": 927.46,
            "transcript": "Tamaani angutet nunarrarni uitayuitellruut."
        },
        "95": {
            "start": 927.46,
            "end": 937.18,
            "transcript": "Pissunrilkuneng wall' neqsunrilkuneng uitavkenateng calissuutnek pilitullruut wall'u kituggluki."
        },
        "96": {
            "start": 937.18,
            "end": 946.32,
            "transcript": "Qayaliluteng cali ikamraliluteng makut tua-i neqkameggnek unangengnaqssuutekngamegteki."
        },
        "97": {
            "start": 947.22,
            "end": 961.0,
            "transcript": "Uksuarmi-llu tamaavet uksiyaramteńun taigaqameng, kiagmi piciatun uitalaameng, pelatekarluteng nani piyarameggnun neqsuryarameggnun."
        },
        "98": {
            "start": 961.0,
            "end": 965.1,
            "transcript": "Tamaani tua-i uitaaqameng canaluteng ellami."
        },
        "99": {
            "start": 965.1,
            "end": 968.92,
            "transcript": "Pelatekameggni caliaqluteng."
        },
        "100": {
            "start": 968.92,
            "end": 976.46,
            "transcript": "Angelrianek ellami caliaqluteng, mikellrianek-llu tua-i pilatekameggni caliluteng."
        },
        "101": {
            "start": 976.46,
            "end": 982.1,
            "transcript": "Qaciggsuunateng angutet canarrlainarluteng tua-i calirrlainarluteng."
        },
        "102": {
            "start": 983.64,
            "end": 991.3,
            "transcript": "Uitqapiaralriamek tangvayuunata, canarrlainarluteng tau͡gaam caliuraluteng piciatun."
        },
        "103": {
            "start": 991.3,
            "end": 1001.44,
            "transcript": "Canatullni Ayaginaraam elitellrua ayagyuallermini tayima 1900-aam kinguani."
        },
        "104": {
            "start": 1001.44,
            "end": 1008.12,
            "transcript": "Angutet quyurtetullruut canaraqameng qasgimi cikiqulluteng."
        },
        "105": {
            "start": 1008.12,
            "end": 1019.2,
            "transcript": "Tamaani-llu ayagyuat elitelallruut canaryaramek piciatun pililuteng cali-llu ciuliateng murilkelluki."
        },
        "106": {
            "start": 1019.2,
            "end": 1024.42,
            "transcript": "Ukugnek keputmek cali mellgarmek aturluteng."
        },
        "107": {
            "start": 1024.42,
            "end": 1037.72,
            "transcript": "Unisteḿa-llu atamun makucia egartakenritqerkaku [?] teguluku canaaqlua, nunurciraqlua ipgialiluku."
        },
        "108": {
            "start": 1037.72,
            "end": 1042.94,
            "transcript": "Tau͡gaam pilillruanga tamakut allakama wii pikamnek."
        },
        "109": {
            "start": 1042.94,
            "end": 1051.42,
            "transcript": "Una canayaurtellruunga canalriit tamakut tangerrluki piliarit ayuqelingnaqluki."
        },
        "110": {
            "start": 1051.42,
            "end": 1057.62,
            "transcript": "Wangnek-llu pitegcauteliaqlua."
        },
        "111": {
            "start": 1057.62,
            "end": 1065.14,
            "transcript": "Tamakut pililriit tangerrluki ayuqelingnaqluki, assiilengraata tua-i taqumariaqameng cayuunateng."
        },
        "112": {
            "start": 1068.58,
            "end": 1079.62,
            "transcript": "Pingnatugluki assiilengraata tamakut piliarit una taqput ayuqenrilengraata, taq'aqluteng tua-i elucingluteng."
        },
        "113": {
            "start": 1082.3,
            "end": 1094.76,
            "transcript": "Kepun una-llu mellgar aturlukek qaqicilallruut angelrianek qayanek ikamranek-llu wall'u qantanek pitasqellrianek."
        },
        "114": {
            "start": 1094.76,
            "end": 1102.98,
            "transcript": "Ayagniraqameng keputmek atutuut tua-i-llu qaqivsiarluku mellgaq aturluku."
        },
        "115": {
            "start": 1102.98,
            "end": 1108.28,
            "transcript": "Calissuutait tamarmeng unatemegteggun qaqitelallruit."
        },
        "116": {
            "start": 1108.86,
            "end": 1114.9,
            "transcript": "Caperrnarqellruut tamakut calissuutait angtuanek taqutelallrat."
        },
        "117": {
            "start": 1114.9,
            "end": 1119.86,
            "transcript": "Makugg' uumi calissuuterluki [?]."
        },
        "118": {
            "start": 1121.78,
            "end": 1127.64,
            "transcript": "Mellgar una canaraqameng arcaqertuq caliameggnun."
        },
        "119": {
            "start": 1127.64,
            "end": 1136.04,
            "transcript": "Maa-i-rpak nutaranek calissuutnek atutuyaaqut, tau͡gaam qaqitaqluki mellgaq aturluku."
        },
        "120": {
            "start": 1136.04,
            "end": 1141.48,
            "transcript": "Taluyaliyugngaluni-llu canassuutmek kiingan aturluni."
        },
        "121": {
            "start": 1141.78,
            "end": 1146.12,
            "transcript": "Taluyaliluteng makucimek caskurluteng."
        },
        "122": {
            "start": 1146.12,
            "end": 1155.58,
            "transcript": "Una wani taluyaliaqameng quvrurissuutekluku [?] taluyanun amatiin-llu [?] canaluku maliggluki."
        },
        "123": {
            "start": 1155.58,
            "end": 1163.46,
            "transcript": "Una kiingan calissuutekluku tegumiaqluku kiingan. Unicuunaku-ll' ayagaqameng natmun malikerrlainarluku yuilqumi."
        },
        "124": {
            "start": 1163.46,
            "end": 1167.44,
            "transcript": "Arulairameng-llu camek piameng canaluteng tua-i."
        },
        "125": {
            "start": 1167.44,
            "end": 1174.1,
            "transcript": "Una canaluku caliaqluku, tegumiaqluku kiingan  calissuutekluku kiingan calissuutekvallurluku."
        },
        "126": {
            "start": 1174.1,
            "end": 1179.86,
            "transcript": "Allanek calissuutnek pingqeng'e'rmeng, una tau͡gaam kiingan tegu' calissuutekpiarluku."
        },
        "127": {
            "start": 1179.86,
            "end": 1189.42,
            "transcript": "Canek tua-i piciatun cali taqutessuutekluku piciatun akulutmek [?], piciatun canaurluki waten manigqurluki."
        },
        "128": {
            "start": 1189.42,
            "end": 1193.3,
            "transcript": "Taquluteng tamalkuita canarrlainarluki."
        },
        "129": {
            "start": 1194.6,
            "end": 1202.7,
            "transcript": "Ayagina'ar ilakaat maani Kusquqvagmi makunek muragnek qantalitulit."
        },
        "130": {
            "start": 1202.7,
            "end": 1210.54,
            "transcript": "Qantat atutullruit yuullermeggni angtateggmeggnek-llu pingqerraqluteng."
        },
        "131": {
            "start": 1210.54,
            "end": 1217.44,
            "transcript": "Al'uruyatangqetullruuq, qaltarpiit-wa mertarcuutet-llu."
        },
        "132": {
            "start": 1217.44,
            "end": 1224.24,
            "transcript": "Ayagnaraam aperturai qaillun muragnek pilillrat qantanek."
        },
        "133": {
            "start": 1224.42,
            "end": 1228.42,
            "transcript": "Una cimek taqluku manigqurluki."
        },
        "134": {
            "start": 1228.42,
            "end": 1233.8,
            "transcript": "Tua-i-llu puqlamun ekciquq qallamalriamun ekumaluni."
        },
        "135": {
            "start": 1233.8,
            "end": 1236.92,
            "transcript": "Uuqnarian-llu taun' tang perrluku."
        },
        "136": {
            "start": 1236.92,
            "end": 1240.2,
            "transcript": "Uluk [?] malruk tuaten ayuqlukek."
        },
        "137": {
            "start": 1240.2,
            "end": 1246.86,
            "transcript": "Tua-i taqngagnek percimariagnek manigquarraarluku-gguq nutaan usgullukek."
        },
        "138": {
            "start": 1246.86,
            "end": 1250.98,
            "transcript": "Tamaa-i usgulriik [?] makuk."
        },
        "139": {
            "start": 1250.98,
            "end": 1260.08,
            "transcript": "Kelugullukek tusgullukek cali uitallu [?] kinqak nutaan manigquarraarluku man'a cali ilulirluku tuaten."
        },
        "140": {
            "start": 1260.08,
            "end": 1265.7,
            "transcript": "Tuarraarluku [?] nutaan taqngan nutaan makuciq kingumek makucirtua."
        },
        "141": {
            "start": 1265.7,
            "end": 1271.4,
            "transcript": "Caliaqluku cet'rulluku angtacirkaa. Caliaqumanarquq waten."
        },
        "142": {
            "start": 1271.4,
            "end": 1284.74,
            "transcript": "Calilaagluku nutaan manigcimarraarluku."
        },
        "143": {
            "start": 1284.74,
            "end": 1290.32,
            "transcript": "Una-w' tuaten elliluku negtaarraarluku mamiksicaqaqluku [?]."
        },
        "144": {
            "start": 1290.32,
            "end": 1294.42,
            "transcript": "Tua-i-ll' pivakarluni ek'arrluni."
        },
        "145": {
            "start": 1294.42,
            "end": 1306.58,
            "transcript": "Cali imumek waten ekvailgan nelqayagutqata'arqa. Menglii man'a waten uumek elliurturluku uivutmun."
        },
        "146": {
            "start": 1306.58,
            "end": 1311.38,
            "transcript": "Neggluku, tua-i-llu ek'arrluku, ekluku nutaan."
        },
        "147": {
            "start": 1311.38,
            "end": 1321.16,
            "transcript": "Nutaan negterraatma [?] tamatum pinguani ataam angliriluni alturyagulluni [?] nutaan, au͡g'arrngairulluni."
        },
        "148": {
            "start": 1321.16,
            "end": 1327.82,
            "transcript": "Cali-llu [?] yukutareskuni cali nutaan au͡g'arrngairulluni nutaan."
        },
        "149": {
            "start": 1327.82,
            "end": 1332.18,
            "transcript": "Man'a tua-i ilutulriamun ekumauq man'a."
        },
        "150": {
            "start": 1332.18,
            "end": 1337.04,
            "transcript": "Waten mat'umun ilulirmun waten."
        },
        "151": {
            "start": 1337.84,
            "end": 1342.34,
            "transcript": "Maa-irpak Ayagina'ar muragnek canauratuuq."
        },
        "152": {
            "start": 1342.34,
            "end": 1347.34,
            "transcript": "Kegginaquliani-llu tuneniaqaqluki maani Yugtarvigmi."
        },
        "153": {
            "start": 1347.34,
            "end": 1352.64,
            "transcript": "Cali-llu kina kegginaqulisqaqan piliaqluku."
        },
        "154": {
            "start": 1352.64,
            "end": 1357.62,
            "transcript": "Maa-i elitnaurilartuq canaryaramek eliculrianun."
        },
        "155": {
            "start": 1357.62,
            "end": 1363.1,
            "transcript": "Kinguvartaa qaillun elitnaurat assirluki elitellerkait."
        },
        "156": {
            "start": 1363.1,
            "end": 1376.56,
            "transcript": "Tanglallrukenka canalallrulriit tang makunek alerqualuki pitullruit ellaitnek pingnatugluki canalaasqelluki assiilengraata."
        },
        "157": {
            "start": 1376.56,
            "end": 1381.0,
            "transcript": "Ellaitnek piyaurtellerkaat elitengnaqluku."
        },
        "158": {
            "start": 1381.0,
            "end": 1387.14,
            "transcript": "Uitaurluki calicuilan. Yuum elisngailkii tangvagluku-ll' waten elisngaunaku."
        },
        "159": {
            "start": 1387.14,
            "end": 1395.56,
            "transcript": "Tangvagluku tua-i cauciata tuaten piyugngayaaqluku. Tau͡gaam pikuniu canaksailkuni elluarrluku taqngaunaku assirluku taqngaunaku."
        },
        "160": {
            "start": 1395.56,
            "end": 1399.22,
            "transcript": "Tau͡gken assiilengraan pingnatugluku."
        },
        "161": {
            "start": 1399.22,
            "end": 1406.42,
            "transcript": "Pingnatugluku assiilengraata piinanermi-ll' assiriurainarluteng calillrat."
        },
        "162": {
            "start": 1406.42,
            "end": 1413.42,
            "transcript": "Unatai eliskuneng tamatumek caliyaramek assirluki taqsuarrluki."
        },
        "163": {
            "start": 1413.42,
            "end": 1421.62,
            "transcript": "Ciuqlimi elluatuuvkenateng caliari tua-i-ll' piinanermeggni assiriluteng caliari assiriniartut."
        },
        "164": {
            "start": 1421.62,
            "end": 1428.24,
            "transcript": "Tuaten qanrutetullruitkut ikayuayuunata-llu canek calingnaqaqamta."
        },
        "165": {
            "start": 1428.24,
            "end": 1435.56,
            "transcript": "Tangvagluta tua-i tau͡gaam uitalluku assiilengraata-ll' tuaten piyuunaki. Wangkutnek tau͡gaam pingnatugluta."
        },
        "166": {
            "start": 1435.56,
            "end": 1441.88,
            "transcript": "Tuaten caliyaurtellerkarput assilrianek umyuaqluku."
        }
    },
    "Dm9d7qBJLlM": {
        "1": {
            "start": 101.16,
            "end": 103.82,
            "transcript": "Caugak?"
        },
        "2": {
            "start": 105.78,
            "end": 108.54,
            "transcript": "Cauga?"
        },
        "3": {
            "start": 109.28,
            "end": 113.3,
            "transcript": "Aullu! Ila-i!"
        },
        "4": {
            "start": 113.3,
            "end": 116.2,
            "transcript": "Caugak?"
        },
        "5": {
            "start": 116.2,
            "end": 118.54,
            "transcript": "Angqak"
        },
        "6": {
            "start": 118.54,
            "end": 123.74,
            "transcript": "Aarra, angqak."
        },
        "7": {
            "start": 125.38,
            "end": 131.88,
            "transcript": "Nallunrikaniryukuvgu alngaqiu Yugtun Qaneryaramek Calivik"
        },
        "8": {
            "start": 131.88,
            "end": 138.64,
            "transcript": "Box 368, Mamterilleq, Alaska, 99559."
        },
        "9": {
            "start": 175.64,
            "end": 177.4,
            "transcript": "Cauga tauna?"
        },
        "10": {
            "start": 177.4,
            "end": 181.06,
            "transcript": "Ukut-qaa? Iralurcuutet."
        },
        "11": {
            "start": 183.76,
            "end": 186.1,
            "transcript": "Caugat iralurcuutet?"
        },
        "12": {
            "start": 186.1,
            "end": 195.02,
            "transcript": "Makut wani iralurcuutet erenret nallunrit'laraput makutgun, caucia-llu unuamek."
        },
        "13": {
            "start": 195.02,
            "end": 197.74,
            "transcript": "Maa-i-llu erenret atrit."
        },
        "14": {
            "start": 197.74,
            "end": 202.52,
            "transcript": "Agayuneq, Pekyun, Aipirin, Pingayirin, Cetamirin, Tallimirin, Maqineq."
        },
        "15": {
            "start": 202.52,
            "end": 205.3,
            "transcript": "Makutgun-llu iralut atrit."
        },
        "16": {
            "start": 205.3,
            "end": 216.46,
            "transcript": "Iralull'er, Kanruyauciq, Kepnerciq, Tengmiirvik, Kayangut Anutiit, Kaugun, Ingun, Tengun, Amirairvik, Qaariitaarvik, Cauyarvik, Uivik-llu."
        },
        "17": {
            "start": 266.66,
            "end": 270.0,
            "transcript": "Kankilriit"
        },
        "18": {
            "start": 291.44,
            "end": 294.0,
            "transcript": "Kankilriit."
        },
        "19": {
            "start": 341.0,
            "end": 343.8,
            "transcript": "Naliatarluk."
        },
        "20": {
            "start": 343.8,
            "end": 345.42,
            "transcript": "Ii-i."
        },
        "21": {
            "start": 347.28,
            "end": 353.06,
            "transcript": "Naliat qimugteńgua?"
        },
        "22": {
            "start": 353.06,
            "end": 355.28,
            "transcript": "Una."
        },
        "23": {
            "start": 355.28,
            "end": 356.66,
            "transcript": "Ii-i."
        },
        "24": {
            "start": 358.32,
            "end": 363.78,
            "transcript": "Naliat maqaruarua?"
        },
        "25": {
            "start": 365.34,
            "end": 367.68,
            "transcript": "Una-qaa?"
        },
        "26": {
            "start": 367.68,
            "end": 372.24,
            "transcript": "Qang'a, tauna qayuqeggliuguq."
        },
        "27": {
            "start": 372.24,
            "end": 374.28,
            "transcript": "Una maqaruaruuq."
        },
        "28": {
            "start": 374.28,
            "end": 376.06,
            "transcript": "Oh."
        },
        "29": {
            "start": 376.06,
            "end": 381.3,
            "transcript": "Naliat-mi qanganauga?"
        },
        "30": {
            "start": 385.08,
            "end": 386.1,
            "transcript": "Una?"
        },
        "31": {
            "start": 386.1,
            "end": 394.54,
            "transcript": "Ii-i, naliat-mi paluqtauga?"
        },
        "32": {
            "start": 396.3,
            "end": 398.32,
            "transcript": "Una-qaa?"
        },
        "33": {
            "start": 398.32,
            "end": 402.34,
            "transcript": "Ii-i, naliat-mi kanaqlauga?"
        },
        "34": {
            "start": 402.34,
            "end": 405.14,
            "transcript": "Aam, una?"
        },
        "35": {
            "start": 405.14,
            "end": 410.98,
            "transcript": "Ii-i. Tua-i waten pitaluk. Uumiku naliataarniartukuk."
        },
        "36": {
            "start": 410.98,
            "end": 412.16,
            "transcript": "Ii-i."
        },
        "37": {
            "start": 467.4,
            "end": 469.04,
            "transcript": "Qangvaq"
        },
        "38": {
            "start": 469.04,
            "end": 471.08,
            "transcript": "Qangvaq tekicit?"
        },
        "39": {
            "start": 471.08,
            "end": 476.02,
            "transcript": "Watua tekitua. Maavet nugtartua."
        },
        "40": {
            "start": 476.02,
            "end": 477.18,
            "transcript": "Qangvaq?"
        },
        "41": {
            "start": 477.18,
            "end": 479.54,
            "transcript": "Maa-i-rpak."
        },
        "42": {
            "start": 479.54,
            "end": 482.38,
            "transcript": "Qaku maantengciqsit?"
        },
        "43": {
            "start": 482.38,
            "end": 486.06,
            "transcript": "Agayunrem kinguakun."
        },
        "44": {
            "start": 486.06,
            "end": 489.42,
            "transcript": "Qangvaq nugtarcunga'artellrusit?"
        },
        "45": {
            "start": 489.42,
            "end": 496.6,
            "transcript": "Nugtarcunga'arteksaicaaqua. Maani caliangellruunga."
        },
        "46": {
            "start": 496.6,
            "end": 497.92,
            "transcript": "Qangvaq?"
        },
        "47": {
            "start": 497.92,
            "end": 501.08,
            "transcript": "Nutaan uumi."
        },
        "48": {
            "start": 501.08,
            "end": 503.1,
            "transcript": "Qangvaq"
        },
        "49": {
            "start": 561.36,
            "end": 563.32,
            "transcript": "Iraluq"
        },
        "50": {
            "start": 564.06,
            "end": 566.12,
            "transcript": "Iraluq"
        },
        "51": {
            "start": 571.18,
            "end": 573.38,
            "transcript": "Iraluq"
        },
        "52": {
            "start": 575.26,
            "end": 577.66,
            "transcript": "Iraluq"
        },
        "53": {
            "start": 579.66,
            "end": 583.52,
            "transcript": "Iraluq, iraluq, iraluq"
        },
        "54": {
            "start": 586.12,
            "end": 587.86,
            "transcript": "Iraluq"
        },
        "55": {
            "start": 589.24,
            "end": 594.52,
            "transcript": "Iraluq, wiinga iraluq."
        },
        "56": {
            "start": 646.18,
            "end": 648.5,
            "transcript": "Waqaa, calisit?"
        },
        "57": {
            "start": 648.5,
            "end": 649.8,
            "transcript": "Airrartua."
        },
        "58": {
            "start": 649.8,
            "end": 651.88,
            "transcript": "Cauga tanem airraq?"
        },
        "59": {
            "start": 651.88,
            "end": 653.18,
            "transcript": "Una."
        },
        "60": {
            "start": 653.18,
            "end": 655.02,
            "transcript": "Tauna-qaa pelacinak?"
        },
        "61": {
            "start": 655.02,
            "end": 656.24,
            "transcript": "Ii-i."
        },
        "62": {
            "start": 656.24,
            "end": 658.68,
            "transcript": "Qaillun-mi airralartat?"
        },
        "63": {
            "start": 658.68,
            "end": 659.98,
            "transcript": "Waten."
        },
        "64": {
            "start": 661.72,
            "end": 664.48,
            "transcript": "Kitak' wiinga elitnaungatua."
        },
        "65": {
            "start": 668.44,
            "end": 670.82,
            "transcript": "Tua-i-gguq tauna cauga?"
        },
        "66": {
            "start": 670.82,
            "end": 673.62,
            "transcript": "Agciun."
        },
        "67": {
            "start": 673.62,
            "end": 675.94,
            "transcript": "(Cauga?) Navegtuq."
        },
        "68": {
            "start": 677.9,
            "end": 680.64,
            "transcript": "Kitak' airraa."
        },
        "69": {
            "start": 680.64,
            "end": 684.82,
            "transcript": "Oh, waten atam. Atam [?] piqaa."
        },
        "70": {
            "start": 687.98,
            "end": 690.3,
            "transcript": "Tua-i-ll' caqatarluni?"
        },
        "71": {
            "start": 755.7,
            "end": 757.78,
            "transcript": "Tangerrsaqlirpaa!"
        },
        "72": {
            "start": 757.78,
            "end": 759.3,
            "transcript": "Ii-i, cangacit?"
        },
        "73": {
            "start": 759.3,
            "end": 760.8,
            "transcript": "Assirtua."
        },
        "74": {
            "start": 760.8,
            "end": 762.28,
            "transcript": "Qavciklaagta?"
        },
        "75": {
            "start": 762.28,
            "end": 763.52,
            "transcript": "Naamell'."
        },
        "76": {
            "start": 765.2,
            "end": 767.24,
            "transcript": "Ila-i, cauga?"
        },
        "77": {
            "start": 767.8,
            "end": 769.58,
            "transcript": "Naamell', cauga?"
        },
        "78": {
            "start": 769.58,
            "end": 770.66,
            "transcript": "Cauga?"
        },
        "79": {
            "start": 771.62,
            "end": 773.42,
            "transcript": "Waqaa."
        },
        "80": {
            "start": 774.02,
            "end": 775.68,
            "transcript": "Waqaa, causit?"
        },
        "81": {
            "start": 775.68,
            "end": 776.6,
            "transcript": "Wiinga?"
        },
        "82": {
            "start": 776.6,
            "end": 778.08,
            "transcript": "Ii-i."
        },
        "83": {
            "start": 778.08,
            "end": 781.08,
            "transcript": "Wiinga sass'augua."
        },
        "84": {
            "start": 781.08,
            "end": 783.7,
            "transcript": "Aarra."
        },
        "85": {
            "start": 783.7,
            "end": 785.48,
            "transcript": "Qavciklaagcit?"
        },
        "86": {
            "start": 785.48,
            "end": 789.62,
            "transcript": "Naamell', tangerciigata kegginaqa."
        },
        "87": {
            "start": 789.62,
            "end": 790.96,
            "transcript": "Ataki."
        },
        "88": {
            "start": 791.72,
            "end": 794.66,
            "transcript": "Unuk qukallinia."
        },
        "89": {
            "start": 794.66,
            "end": 798.68,
            "transcript": "Aarra, inarrnarianga."
        }
    },
    "4y9W5fiOLks": {
        "1": {
            "start": 2711.01,
            "end": 2718.3,
            "transcript": "Mat'umek tang qaneryulrianga ayagyuanun imkunun tan'gaurlurnun nasaurlurnun-llu."
        },
        "2": {
            "start": 2718.3,
            "end": 2724.72,
            "transcript": "Imkunun kenkekngamnun allragni Alussistuam nalliini imkunun qanrutlemnun."
        },
        "3": {
            "start": 2724.72,
            "end": 2728.5,
            "transcript": "Cali man'a pulenglluku qanruteksuraqa."
        },
        "4": {
            "start": 2730.45,
            "end": 2740.34,
            "transcript": "Yuk pegcikuni aturyullminek tamalkuita tamakut aturyullni pegeskunikii."
        },
        "5": {
            "start": 2740.34,
            "end": 2746.32,
            "transcript": "Agayutmun cauquni, agayutem aulukarkaugaa."
        },
        "6": {
            "start": 2746.32,
            "end": 2751.62,
            "transcript": "Elliini-llu cat tamakut atulallri amlleqapiarang'e'rmeng."
        },
        "7": {
            "start": 2751.62,
            "end": 2758.96,
            "transcript": "Niitekegtaaralallemcetun naaqicimangaituq, assiilngurugaminek."
        },
        "8": {
            "start": 2758.96,
            "end": 2767.56,
            "transcript": "Yaani-llu tangerrngaunaki, kiaresngialutekngaunaki-llu maa-irpagnun-am qaingantellermini pegeskuniki."
        },
        "9": {
            "start": 2767.56,
            "end": 2774.36,
            "transcript": "Yuum kinguneni nallunritaa, tau͡gaam ciunerkani nallua."
        },
        "10": {
            "start": 2774.36,
            "end": 2781.2,
            "transcript": "Unguvami-llu anernemi, agayutem cikiutiin, qaill' taktacia nallua."
        },
        "11": {
            "start": 2781.2,
            "end": 2789.08,
            "transcript": "Nalluamiu-llu tunen'arquq agayutmun watua cikiutekluni ellminek."
        },
        "12": {
            "start": 2789.08,
            "end": 2799.5,
            "transcript": "Cikiqengyuumilartukut, Alussistuam nalliini, kenkekput-llu canek cikiryuumilaraput, cakneq ilungluta."
        },
        "13": {
            "start": 2799.5,
            "end": 2805.82,
            "transcript": "Aanaulriani-llu irniaput assirluki yuusqumalaraput."
        },
        "14": {
            "start": 2805.82,
            "end": 2814.1,
            "transcript": "Wiinga ayagyuallemni aanama umyugaa navgulaucia nallruaqa."
        },
        "15": {
            "start": 2814.1,
            "end": 2818.56,
            "transcript": "Tua-i-llu caqerlua cangayagulluku ayuquciqa."
        },
        "16": {
            "start": 2818.56,
            "end": 2825.4,
            "transcript": "Ayuquciqa maaten tangrraqa arenqiapaa tua-i atuqaunritlinilria."
        },
        "17": {
            "start": 2825.4,
            "end": 2831.66,
            "transcript": "Aanama umyugai navgullinikek'a tuaten wiinga ayuqellemkun."
        },
        "18": {
            "start": 2831.66,
            "end": 2839.02,
            "transcript": "Amta-llu aanaka piasqumanritaqluku, iluteqesqumanritaqluku-llu."
        },
        "19": {
            "start": 2839.5,
            "end": 2846.64,
            "transcript": "Tau͡gaam wiinga kaugtualriatun aanaka ayuqellrulliniaqa qanrucunaitellemkun."
        },
        "20": {
            "start": 2846.64,
            "end": 2860.9,
            "transcript": "Tamana elpeklemni pegtellemni assiilkessaagutellruaqa, aturyuumiitellruaqa-llu ataam-llu teguluku piyuumiitellruaqa."
        },
        "21": {
            "start": 2860.9,
            "end": 2869.88,
            "transcript": "Tangerrluku yuk umyualinqigtarkaullinilria pegcikuni tauna piluaqarkaulliniuq."
        },
        "22": {
            "start": 2869.88,
            "end": 2878.0,
            "transcript": "Atengqerrarkauluni-llu umyualinqigtellriamek, man'a-llu cakneq piyuumirnaqvaa."
        },
        "23": {
            "start": 2878.0,
            "end": 2885.6,
            "transcript": "Yuk caperrnarqelriamek atullruyaaqeciqelliniuq. Agayutem au͡g'aryugngallinia."
        },
        "24": {
            "start": 2885.6,
            "end": 2892.0,
            "transcript": "Maa-i ayagyuani tayima umyuarteq'lallilriaci waten."
        },
        "25": {
            "start": 2892.0,
            "end": 2898.64,
            "transcript": "Wii umyuaqlemnek waten au͡g'umek caperrnaqsuklemnek."
        },
        "26": {
            "start": 2898.64,
            "end": 2905.7,
            "transcript": "Aanama-llu umyugaa qiavkalallra-llu iluteqevkalallra-llu."
        },
        "27": {
            "start": 2905.7,
            "end": 2911.06,
            "transcript": "Nallunrillemni tuaten piyuumiirutellruunga."
        },
        "28": {
            "start": 2911.06,
            "end": 2919.86,
            "transcript": "Yuum ayuqucini tau͡gaam tangrraarluku Agayutmun tangerquniu egmianun tun'arkaulliniuq."
        },
        "29": {
            "start": 2919.86,
            "end": 2928.22,
            "transcript": "Elliin kitugtestekaanun ayuqucini, man'a allrakuq nutaraqugtellemteńi."
        },
        "30": {
            "start": 2928.22,
            "end": 2934.96,
            "transcript": "Waniwa tunellrukumta wangkutnek cikiutekluta Agayutmun."
        },
        "31": {
            "start": 2934.96,
            "end": 2941.72,
            "transcript": "Piluaqerciqukut, angnirnaqvaa-lli mat'umi, quyanaqvaa-lli mat'umi, Agayutem."
        },
        "32": {
            "start": 2941.72,
            "end": 2951.38,
            "transcript": "Agayun taivkarillrullinilria qetunraminek mikelnguyagauluku kia-llu ciuniurpek'naku."
        },
        "33": {
            "start": 2951.38,
            "end": 2961.48,
            "transcript": "Tang ciuniunricunaitelliniuq, ciuniurnarqelliniuq, nekaiturtecunaitelliniuq-llu tau͡gaam nengqertelluku."
        },
        "34": {
            "start": 2961.48,
            "end": 2968.4,
            "transcript": "Waten apcimalaucimcetun yuarutmi, waten apcimalartukut yuarutmi."
        },
        "35": {
            "start": 2968.4,
            "end": 2979.32,
            "transcript": "Pivigkangqertuq-qaa Jesus-aaq assiilngurpet atmagtiit?"
        },
        "36": {
            "start": 2979.32,
            "end": 2986.74,
            "transcript": "Man'a calillruuq wangnii qavaryaaqlua tau͡gaam mamkilngurmek qavarlua."
        },
        "37": {
            "start": 2986.74,
            "end": 2994.3,
            "transcript": "Erinat niitellrunak yugugaat atralriit atrarluteng aturpaulkiitnga mat'umek."
        },
        "38": {
            "start": 2994.3,
            "end": 3001.96,
            "transcript": "Aptaqlua waten, \"Pivigkangqertuq-qaa Jesus-aaq assiilngurpet atmagtiit?\""
        },
        "39": {
            "start": 3001.96,
            "end": 3006.6,
            "transcript": "Tukriartuq iteryugluni itercecuumiitan-qaa?"
        },
        "40": {
            "start": 3006.6,
            "end": 3015.98,
            "transcript": "Apyutii man'a egmianun wangnun tut'ellruuq, akngirnaqluni cakneq, ciuniuryuuminaqluni."
        },
        "41": {
            "start": 3015.98,
            "end": 3028.4,
            "transcript": "Waniwa allrakum nutaram nugtellrani yuk umyualinqigeskuni angli-lli taumi yugmi piluaqerpaa."
        }
    },
    "IruCDl1Ljio": {
        "1": {
            "start": 37.52,
            "end": 39.54,
            "transcript": "Nacan all'uku."
        },
        "2": {
            "start": 40.16,
            "end": 42.74,
            "transcript": "Nacan all'uku."
        },
        "3": {
            "start": 43.88,
            "end": 47.24,
            "transcript": "Nacan all'uku."
        },
        "4": {
            "start": 57.86,
            "end": 59.66,
            "transcript": "Nacan all'uku."
        },
        "5": {
            "start": 60.64,
            "end": 62.2,
            "transcript": "Nacan all'uku."
        },
        "6": {
            "start": 106.12,
            "end": 107.84,
            "transcript": "Ingna kiuqerru."
        },
        "7": {
            "start": 111.08,
            "end": 113.1,
            "transcript": "Ingna kiuqerru."
        },
        "8": {
            "start": 118.86,
            "end": 121.1,
            "transcript": "Una wani kiuqerru."
        },
        "9": {
            "start": 148.2,
            "end": 149.52,
            "transcript": "Kuuvviaryugtuten?"
        },
        "10": {
            "start": 156.42,
            "end": 158.74,
            "transcript": "Kuuvviaryugtuten? Yaa."
        },
        "11": {
            "start": 167.04,
            "end": 169.3,
            "transcript": "Kuuvviaryugtuten? Ii-i."
        },
        "12": {
            "start": 176.86,
            "end": 179.0,
            "transcript": "Kuuvviaryugtuten? Ii-i."
        },
        "13": {
            "start": 183.0,
            "end": 184.88,
            "transcript": "Quyana."
        },
        "14": {
            "start": 211.96,
            "end": 213.5,
            "transcript": "Ikirteqarru."
        },
        "15": {
            "start": 214.68,
            "end": 216.56,
            "transcript": "Ikirteqarru."
        },
        "16": {
            "start": 217.88,
            "end": 220.42,
            "transcript": "Ikirteqarru."
        },
        "17": {
            "start": 265.64,
            "end": 267.08,
            "transcript": "Ikirrluku."
        },
        "18": {
            "start": 268.12,
            "end": 269.5,
            "transcript": "Ikirrluku."
        },
        "19": {
            "start": 275.92,
            "end": 277.18,
            "transcript": "Patuluku."
        },
        "20": {
            "start": 277.86,
            "end": 279.26,
            "transcript": "Patuluku."
        },
        "21": {
            "start": 280.28,
            "end": 282.16,
            "transcript": "Patuluku."
        },
        "22": {
            "start": 316.96,
            "end": 318.4,
            "transcript": "Kita."
        },
        "23": {
            "start": 321.02,
            "end": 322.44,
            "transcript": "Kita."
        },
        "24": {
            "start": 325.26,
            "end": 327.0,
            "transcript": "Kita."
        },
        "25": {
            "start": 329.32,
            "end": 330.84,
            "transcript": "Kita."
        },
        "26": {
            "start": 333.88,
            "end": 335.48,
            "transcript": "Kita."
        }
    },
    "k2TEQNlt230": {
        "1": {
            "start": 569.18,
            "end": 576.74,
            "transcript": "Waqaa ellaliurciqua ciumek unuamek ellakaan pianek."
        },
        "2": {
            "start": 576.74,
            "end": 586.44,
            "transcript": "Kallirciquq-gguq maa-i hurricane-araqluni-ll' atakurpak, tau͡gaam-gguq allmernaq taq'arkauluni cimirluni-llu."
        },
        "3": {
            "start": 589.42,
            "end": 595.98,
            "transcript": "Kallirluni ellallirluni qanirluni-ll' taiciraqluni-llu-gguq."
        },
        "4": {
            "start": 595.98,
            "end": 603.06,
            "transcript": "Ukut-llu-gguq, temperature-arkait maani unuamek quigciquq 101 degrees."
        },
        "5": {
            "start": 603.06,
            "end": 607.68,
            "transcript": "Una-llu aciqcillra ataku 75 below."
        },
        "6": {
            "start": 607.68,
            "end": 612.58,
            "transcript": "Una-llu-gguq chill factor-aarka 90 below atakurpak."
        },
        "7": {
            "start": 612.58,
            "end": 624.02,
            "transcript": "Akerta-llu-gguq tevircuguq atata 11:59 p.m. pugluni-llu-gguq unuakumi 3:05 a.m."
        },
        "8": {
            "start": 624.02,
            "end": 631.38,
            "transcript": "Ulellerkaa-llu-gguq unuamek-gguq ulelriartangqerrngaituq."
        },
        "9": {
            "start": 631.38,
            "end": 643.5,
            "transcript": "Ukut-gguq wani qimugcet maani Mamterillermi ucuqellruit maani anirturiata mat'umek una Mamterillermek, nitilini kitullerni."
        },
        "10": {
            "start": 643.5,
            "end": 653.88,
            "transcript": "Ukut-gguq city-t wani state-at-llu atanret quyurtellruut wani malrugni sass'agni kat'um qanercetaarviim caniani."
        },
        "11": {
            "start": 653.88,
            "end": 662.68,
            "transcript": "Uum-llu-guq mat'um Mamterillerem mayor-aara John Guinn-am una quyurtellrat ayagnirluku qanerluni."
        },
        "12": {
            "start": 662.68,
            "end": 672.62,
            "transcript": "Man'a unuamek erneq wani Mamterilleret qimugtaitnun erneqesqelluku."
        },
        "13": {
            "start": 673.0,
            "end": 687.36,
            "transcript": "Una-gguq 17-aanek allrakulek, Lionel-aaq una-ll' 19-aanek allrakulek Kirk Eaglelight-aq under subdivision-aami uitalriit."
        },
        "14": {
            "start": 687.36,
            "end": 693.62,
            "transcript": "Tarrisnginanermeggni makut ciqiciviit caniatni niitellruuk camek neplilriamek."
        },
        "15": {
            "start": 693.62,
            "end": 702.42,
            "transcript": "Taum ciqiciviim aciani. Maaten-gguq ukuk tan'gaurluuk mayurtaaguni ciqicivik."
        },
        "16": {
            "start": 702.42,
            "end": 718.32,
            "transcript": "Makunek wani tua-i amlleqapiaralrianek wani paralirluni man'a, tua-i-w' amlleqapiaralrianek wani paralirluni."
        },
        "17": {
            "start": 718.32,
            "end": 726.96,
            "transcript": "Tua-llu-q' kinguani makut paralut wani sagtelliniluteng makunun ciqiciviitnun maani Mamterillermi."
        },
        "18": {
            "start": 726.96,
            "end": 739.36,
            "transcript": "Makut-llu-gguq qimugcet wani tamakut wani makunek ciqiciviit caquitni uitangraata callerrluki nerrlinikait."
        },
        "19": {
            "start": 739.36,
            "end": 748.32,
            "transcript": "Qimugcet-gguq tau͡gaam naulluunritut qaill' pivkenateng-llu man'a-llu Mamterilleq cakanissiiyaagpek'nani."
        },
        "20": {
            "start": 748.32,
            "end": 755.32,
            "transcript": "Tua-i-ll' ukut avelngarnek, avelngat kemgitnek qalartellriit."
        },
        "21": {
            "start": 755.32,
            "end": 766.62,
            "transcript": "Makut-gguq ukut Fish and Wildlife-at murilkestiiit una Joe D'Amico-q qanertuq akimiat ukut avelngaat kemgit."
        },
        "22": {
            "start": 766.62,
            "end": 779.94,
            "transcript": "Maavet cikiutekellruniluki state-amun uum K. Bromans-am [?] pissurtain makut arnacaluit up'nerkami tegullrullinikait makut."
        },
        "23": {
            "start": 779.94,
            "end": 791.84,
            "transcript": "Wani subsistence migratory-nek, tua-i-w' makunek lemming-aanek pissullermeggni, tau͡gaam-gguq maa-i caksaunateng cali."
        },
        "24": {
            "start": 791.84,
            "end": 809.36,
            "transcript": "Una-gguq D'Amico-q wani qanertuq makut kemgit, makut wani kemgit tua-i-w' cikiutekumallruut maaken state-amek."
        },
        "25": {
            "start": 809.36,
            "end": 823.0,
            "transcript": "Ukunek K. Bromans-aarit pissurtaitnek tegullrullinikait makut arnacaluit wani up'nerkami wani makunek pissutellermeggni."
        },
        "26": {
            "start": 825.18,
            "end": 832.34,
            "transcript": "Una-llu waniw' qanrartangqellruuq wani."
        },
        "27": {
            "start": 832.34,
            "end": 848.44,
            "transcript": "Waqaa. Waqaa. Uss?"
        },
        "28": {
            "start": 848.44,
            "end": 851.44,
            "transcript": "Kiunritliniuq."
        },
        "29": {
            "start": 851.44,
            "end": 870.7,
            "transcript": "Ukut-gguq D'Amico-q qanertuq makut kemgit wani makut avelngaat cikiutekumallruut ukut, ukut, ukunun, tua-i-w' local agency-nun makunun."
        },
        "30": {
            "start": 870.7,
            "end": 880.54,
            "transcript": "Tua-i-wa makut kemgit qaillun-wa qaill' waten qalarta?"
        },
        "31": {
            "start": 880.54,
            "end": 886.94,
            "transcript": "Tuar' cikiutekumaciqnikait, Tanqilnguum qaqivsiarnauraa."
        },
        "32": {
            "start": 886.94,
            "end": 893.44,
            "transcript": "Quyana. D'Amico-q qanilliniuq makut maani avcellngaat kemgiit makunun maani tunciqniiluki Mamterillermun."
        },
        "33": {
            "start": 893.44,
            "end": 903.06,
            "transcript": "Cali-llu-gguq makut maani waten melqurrit waten tunciqniiluki mat'um State-amun tayim cali erenrat nalluniluki tamakut tamaani."
        },
        "34": {
            "start": 903.06,
            "end": 912.56,
            "transcript": "Tua-i-llu-gguq cali makut maani temiit tegullrit cali-llu makut maani melqurrit maani, makut maani arnacalut tegullrit, pissullermeggni tavani."
        },
        "35": {
            "start": 912.56,
            "end": 918.02,
            "transcript": "Tau͡gaam makut maani qanellruyaaqelliniut angucalurrlainarnun tuani pissurarkauniluki."
        },
        "36": {
            "start": 918.02,
            "end": 926.88,
            "transcript": "D'Amico-q cali qanlliniuq tayim maa-i waten qussigpaakaata alartelluteng pissullrit tamakunek tamaani avcellngarnek maa-i mat'umi ikirtellratni."
        },
        "37": {
            "start": 926.88,
            "end": 933.02,
            "transcript": "Ukut-gguq wani melqul'irtut ayagciqniiluki tamaavet K. Bromans-aavvamun waten elitnaurirturluki."
        },
        "38": {
            "start": 933.02,
            "end": 937.66,
            "transcript": "Nallunriceqelluki tamakut tamaani pissutulit makunek maani avcellngarnek."
        },
        "39": {
            "start": 937.66,
            "end": 942.12,
            "transcript": "Waten nall'arkaavkenaki waten arnacaluullrit."
        },
        "40": {
            "start": 942.12,
            "end": 953.24,
            "transcript": "Cali-llu avcellngaullrit. Tua-llu-gguq cali Tami-gguq qanlliniuq elisngaqapiarnaqniluku makut maani waten pissullerkait nallunritlerkait arnacaliullrit wall' angucaliullrit."
        },
        "41": {
            "start": 953.24,
            "end": 963.34,
            "transcript": "Tayima-llu-gguq makut maani elitnaullret tamaani waten credit-aangeciiqelliniut ataucimek waten biology-mi maani Kuskokwim Community College-aami."
        },
        "42": {
            "start": 963.34,
            "end": 973.8,
            "transcript": "Cali-llu-gguq una wani James Watt-aq qanlliniuq waten cetamanek waten nunakuarcuutnek, tumyarait cetamanek nunakuarcuutnek piyuumalrianek tumyaranek piliciqliniuq."
        },
        "43": {
            "start": 973.8,
            "end": 981.32,
            "transcript": "Waten maaken Mamterillermek yaavet Anchorage-amun. Cali-gguq ukut wani United States Army Corps of Engineers elitnaulliniut."
        },
        "44": {
            "start": 981.32,
            "end": 989.14,
            "transcript": "Tua-llu tamana tamaani yuvrilliniat tuaten-gguq una James Watt-aq qanlliniuq ernerpak camani Washington, D.C.-mi."
        },
        "45": {
            "start": 989.14,
            "end": 998.0,
            "transcript": "Man'a-gguq maani nunakuarcuutet tumyaraurkait waten ayagciqliniluni. Maaken maavet makut maani wilderness-aanek pilallrit."
        },
        "46": {
            "start": 998.0,
            "end": 1005.38,
            "transcript": "Tamakut tamaani iliitni una-gguq wani Interior Secretary-m atanret qanlliniuq tayim elliin."
        },
        "47": {
            "start": 1005.38,
            "end": 1016.7,
            "transcript": "Waten ayagnillruniluku tamana umyuarteqluteng makut maani amlleqapigtellriit maani America-mi ciuqliluku tangerrsuumaciqniluku mat'um maani anglanarqeqapigtellra maani Alaska-mi."
        },
        "48": {
            "start": 1016.7,
            "end": 1024.22,
            "transcript": "Tua-llu-gguq cali man'a maani pilinginanratgu waten nunakuarcuutet tumyaraat wall'u-qaa acirluku waten Highwatt-amek."
        },
        "49": {
            "start": 1024.22,
            "end": 1034.16,
            "transcript": "Tua-llu-gguq qanlliniuq wall'u, tua-llu qanlliniuq makut maani waten tamaani amllertalriit uitaciqniluki waten nerviit acirluki McDonald's, Shakies."
        },
        "50": {
            "start": 1034.16,
            "end": 1042.82,
            "transcript": "Cali-llu ukut wani Howard Johnson-aat nerviit. Cali-llu-gguq tamaani waten gasoline-anek kipucuumaciqluteng amllertaluteng 25-auluteng."
        },
        "51": {
            "start": 1042.82,
            "end": 1052.06,
            "transcript": "Tua-llu-gguq cali aptellratni ciin man'a Mamterilleq waten tuaten tumaitni ayagniullerkaatnek aptellrulliniat? Secretary-q qanlliniuq waten."
        },
        "52": {
            "start": 1052.06,
            "end": 1058.2,
            "transcript": "Ellaita yurvillruniluku. Tayima waten amllerrluki yuut tamaavet maaken Anchorage-amek ayaglarniluki."
        },
        "53": {
            "start": 1058.2,
            "end": 1063.86,
            "transcript": "Tua-llu-gguq tuaten amlleqapilluteng piata tamaaggun piqatarniiluku."
        },
        "54": {
            "start": 1063.86,
            "end": 1070.24,
            "transcript": "Tua-llu-gguq cali qanlliniuq ellaita akiliriumaciqniluku, elliinek akiliriumaciqniluku."
        },
        "55": {
            "start": 1070.24,
            "end": 1080.28,
            "transcript": "Waten-gguq tamaani itqatalriit akiliraqluteng piarkauluteng. Ayagalriit-gguq tamaaggun nunakuarcuutet tumyaraitgun akilirarkauluteng $40 dollars."
        },
        "56": {
            "start": 1080.28,
            "end": 1085.0,
            "transcript": "Tayima-gguq waten yuinaat allrakut iliitni tamana akilirciiqelliniuq."
        },
        "57": {
            "start": 1085.0,
            "end": 1091.4,
            "transcript": "Tua-llu-gguq cali makut maani yuut maani uitalriit ellaita piciatun umyuarteqellermeggni tamatum tungiinun."
        },
        "58": {
            "start": 1091.4,
            "end": 1099.74,
            "transcript": "Qanerrsuuterniaraat nunam pelluceci wall'u makut maani waten representative-aput senator-aarput-llu tamaani Washington, D.C.-ami."
        }
    },
    "QsqRXLq0FfY": {
        "1": {
            "start": 150.22,
            "end": 154.8,
            "transcript": "Nukaaq, naanguarpiiqnak! Nerqatartukut."
        },
        "2": {
            "start": 159.88,
            "end": 165.8,
            "transcript": "Ataneq quyavikamteggen assiavet, naklekilaucin-llu nang'arkaunrilan. Amen."
        },
        "3": {
            "start": 165.8,
            "end": 166.92,
            "transcript": "Amen."
        },
        "4": {
            "start": 169.2,
            "end": 171.36,
            "transcript": "Nauwa-am Tanuk'aq?"
        },
        "5": {
            "start": 171.36,
            "end": 172.96,
            "transcript": "Cali-qaa qavartuq?"
        },
        "6": {
            "start": 172.96,
            "end": 175.58,
            "transcript": "Ii-i, unugpak-am itenrituq."
        },
        "7": {
            "start": 175.58,
            "end": 178.22,
            "transcript": "Peng'gartelaqeka tang mer'anguangyukluku."
        },
        "8": {
            "start": 186.3,
            "end": 188.34,
            "transcript": "Angli-ll' qavalar'!"
        },
        "9": {
            "start": 188.34,
            "end": 191.3,
            "transcript": "Erneren-llu qukarluni caarkaten pivailegpeki."
        },
        "10": {
            "start": 191.3,
            "end": 192.76,
            "transcript": "Neri."
        },
        "11": {
            "start": 194.42,
            "end": 197.66,
            "transcript": "Maa, Tanuk'aq tangellruaqa akwaugaq."
        },
        "12": {
            "start": 197.66,
            "end": 199.84,
            "transcript": "Qaa? Nani?"
        },
        "13": {
            "start": 199.84,
            "end": 208.98,
            "transcript": "Taliciviim [?] elatiitni yugyagluteng arnartarluteng neplirluteng camek-llu mer'aqluteng."
        },
        "14": {
            "start": 209.38,
            "end": 212.3,
            "transcript": "Piciuguq-qaa? Mer'angualalliuten."
        },
        "15": {
            "start": 212.3,
            "end": 216.56,
            "transcript": "Arnanek-llu caarkaitulalliuten."
        },
        "16": {
            "start": 216.56,
            "end": 219.94,
            "transcript": "Niicuiterrlainarluni."
        },
        "17": {
            "start": 219.94,
            "end": 224.0,
            "transcript": "Umyuan-llu atungnaqerrlainarluku."
        },
        "18": {
            "start": 224.0,
            "end": 226.48,
            "transcript": "Atam-llu tua-i uyaquani."
        },
        "19": {
            "start": 226.48,
            "end": 227.9,
            "transcript": "Angli-lli!"
        },
        "20": {
            "start": 227.9,
            "end": 229.8,
            "transcript": "Tua-llam."
        },
        "21": {
            "start": 246.52,
            "end": 254.0,
            "transcript": "Ak'a-gguq tamaani tan'gaurlurtangqertuq pissuryaryunqellriamek."
        },
        "22": {
            "start": 254.0,
            "end": 262.26,
            "transcript": "Ekviim-gguq, ekvik-gguq kituraqamiu kuigem iquani, neqkarrarnek unicirrlainarluni."
        },
        "23": {
            "start": 262.26,
            "end": 266.84,
            "transcript": "Tuatelluni-gguq piculuni cangliqluni utertaqluni."
        },
        "24": {
            "start": 268.84,
            "end": 276.06,
            "transcript": "Ataucimi-gguq ayagpakarluni arnamek tangertuq atkukegciluni."
        },
        "25": {
            "start": 276.06,
            "end": 280.34,
            "transcript": "Atkuan-llu-gguq qagkuit qevleqtaarluteng."
        },
        "26": {
            "start": 280.34,
            "end": 285.48,
            "transcript": "Tamakucimek-gguq atkugmek tangeqsaunani ciungani."
        },
        "27": {
            "start": 285.5,
            "end": 298.68,
            "transcript": "Tauna-gguq angun tangertuq arnamek allayugmek atkulegmek, akui-llu-gguq tangniqpiaq qevleqtaarluteng-llu."
        },
        "28": {
            "start": 298.68,
            "end": 302.28,
            "transcript": "Arnaq-gguq tauna qimanrituq,"
        },
        "29": {
            "start": 302.28,
            "end": 306.98,
            "transcript": "\"Ala-i! Cunaw' allanek yugtangqellria.\""
        },
        "30": {
            "start": 306.98,
            "end": 314.84,
            "transcript": "Arnam-gguq taum pia, \"Nakleng elpet! Pissuryarraarluten kiivet uterterrlainarluten.\""
        },
        "31": {
            "start": 314.84,
            "end": 331.96,
            "transcript": "Tua-llu-gguq taum arnam qanrutaa, \"Quyavkarrlainaurqeravnga angnircellua-llu pikaitellemni neqkanek unicirrlainarluten. Tuatelluten cangliq'lalriaten.\""
        },
        "32": {
            "start": 331.96,
            "end": 337.58,
            "transcript": "Tua-ll' angutem taum pillinia, \"Maligeskia ut'reskuma.\""
        },
        "33": {
            "start": 337.58,
            "end": 345.84,
            "transcript": "Arnam pia, \"Aa-ang, tau͡gaam wani ayagpailemnuk nererraaqerluk.\""
        },
        "34": {
            "start": 349.36,
            "end": 364.24,
            "transcript": "Tua-llu-gguq ayautellinia ekviim amiakun itrutellinia nek'egtaarmun nunaniqpiarluni tanqigcenani uitayunaqluni-llu."
        },
        "35": {
            "start": 364.24,
            "end": 371.02,
            "transcript": "\"Kitek aqumluten.\" neqliullinia akutamek tan'gerpagnek atsalegmek."
        },
        "36": {
            "start": 371.02,
            "end": 380.58,
            "transcript": "Neqniqpiarluni-gguq cakneq tauna akutaq tuntupiam tunuanek avungqelliniami."
        },
        "37": {
            "start": 380.58,
            "end": 385.6,
            "transcript": "Tua-i-llu-gguq aipaqsagutuk taukuk."
        },
        "38": {
            "start": 385.6,
            "end": 390.86,
            "transcript": "Pissuryarturluni-gguq tauna angun ayagauryaurtuq."
        },
        "39": {
            "start": 390.86,
            "end": 399.38,
            "transcript": "Piliqluni uterrnaurtuq cangtai-llu-gguq pinqegcaarluki taum arnam caliaqnaurai."
        },
        "40": {
            "start": 399.38,
            "end": 403.38,
            "transcript": "Aturallrai-llu mingqaqluki."
        },
        "41": {
            "start": 403.38,
            "end": 411.32,
            "transcript": "Tua-ll' qingarraarluni tan'gaurlucuarmek irniangelliniuk."
        },
        "42": {
            "start": 411.32,
            "end": 417.48,
            "transcript": "Tauna-gguq angun pissuryarrlainarluni,"
        },
        "43": {
            "start": 417.48,
            "end": 423.34,
            "transcript": "utertaqan-llu-gguq cat cangtai caliaqaqluki pinqegcaarluki."
        },
        "44": {
            "start": 423.34,
            "end": 433.2,
            "transcript": "Tau͡gaam-gguq aipangqerrngami piipicuarmek taumek cangalliuyuunani pissuryarrlainangraan."
        },
        "45": {
            "start": 433.2,
            "end": 442.84,
            "transcript": "Irniani-llu-gguq tauna inqaqluku qanaataqluku-llu aliayuyuunani-llu."
        },
        "46": {
            "start": 442.84,
            "end": 450.02,
            "transcript": "Mingqaqamiku-gguq aturallrai callmagluki-llu piaqamiki,"
        },
        "47": {
            "start": 450.02,
            "end": 463.7,
            "transcript": "allayugcinaurtuq mingqaanek elliin pillrunritlermininek, taumek-gguq taumek qanyuunani tau͡gaam-gguq paqnayungluni."
        },
        "48": {
            "start": 463.7,
            "end": 475.06,
            "transcript": "Tua-llu-gguq pissuryaraqami ayagaqami akaarnun uitayaurtuq kiituani-llu-gguq qavartaraqluni."
        },
        "49": {
            "start": 475.06,
            "end": 482.18,
            "transcript": "Tua-llu ataucirqumek ayagngami utertenrituq."
        },
        "50": {
            "start": 482.18,
            "end": 490.04,
            "transcript": "Tua-i-llu-gguq taum arnam peng'gallagaa tuqullruyukluku-llu."
        },
        "51": {
            "start": 494.76,
            "end": 501.98,
            "transcript": "Tau͡gken-gguq umyuangcallermini paqnayugluni, kia-kiq au͡gkut mingqaqellartaki [?]."
        },
        "52": {
            "start": 501.98,
            "end": 522.88,
            "transcript": "Tua-i-llu-gguq tamakut wani ayautarkani katuqcaararraarluki, irniani-llu amarraarluku ayakcaaralliniluni, qanikcaq cikuq-llu urungellragni tuma-llu-gguq aspiaq."
        },
        "53": {
            "start": 522.88,
            "end": 535.1,
            "transcript": "Kiagpak-gguq ayaumalria taqsuqaqami atakumi inartaqlutek."
        },
        "54": {
            "start": 535.1,
            "end": 543.1,
            "transcript": "Tua-i-llu-gguq ayagturainanermini uksuami nunallermun tekituq."
        },
        "55": {
            "start": 543.1,
            "end": 550.82,
            "transcript": "Tua-i-llu-gguq maaten niicugniqertuq neplirluni qavani."
        },
        "56": {
            "start": 550.82,
            "end": 557.24,
            "transcript": "Tua-i-llu taqsuqsiyaagami tuani inarculliniluni."
        },
        "57": {
            "start": 557.24,
            "end": 576.38,
            "transcript": "Tua-i-llu-gguq upterraarluni napam tuqumalriim caniani inarrliurraarluni-llu malrugnek wani ellalliurcuutegnek at'elliniluni."
        },
        "58": {
            "start": 576.38,
            "end": 583.88,
            "transcript": "Tua-i-llu-gguq nengllian-llu irniani malkanirluku qavangcalliniluni."
        },
        "59": {
            "start": 583.88,
            "end": 594.68,
            "transcript": "Qavaqerluni-llu-gguq unuumainanrani epsalnguluni uigartuq."
        },
        "60": {
            "start": 594.68,
            "end": 602.72,
            "transcript": "Tua-i-llu-gguq tatamluni nang'artelliniluni irniani-llu kiartelaalliniluku."
        },
        "61": {
            "start": 602.72,
            "end": 612.38,
            "transcript": "Nakleng-gguq maaten pia irniarlua wani epluni tuqullrullinilria inangqallrani."
        },
        "62": {
            "start": 612.38,
            "end": 621.58,
            "transcript": "Tua-i-gguq alianiurluni cakneq iluteqluni-llu irniani tauna tumagtelliniluku."
        },
        "63": {
            "start": 626.6,
            "end": 642.7,
            "transcript": "Tuai-llu-gguq pinercikanirluni aipani yuaralliniluku ayagturluni, nutaan-llu-gguq taumun nunamun tekilluni atakuarmi."
        },
        "64": {
            "start": 642.7,
            "end": 650.0,
            "transcript": "Nunat-llu-gguq iquatni wani enemun itliniluni elaturraanun."
        },
        "65": {
            "start": 650.0,
            "end": 654.42,
            "transcript": "Arnassagartangqerrluni tutgarangqerrluni-llu."
        },
        "66": {
            "start": 654.42,
            "end": 663.34,
            "transcript": "Tutgariin-gguq maurluni pia, \"Maurluuq, atam ugna arnaq! Allanruluni!\""
        },
        "67": {
            "start": 663.34,
            "end": 674.44,
            "transcript": "Tua-llu-gguq arnassagaam tutgarani pia, \"Kiiki kitek patagmek itercelluku! Arenqiallugtelliuq!\""
        },
        "68": {
            "start": 674.44,
            "end": 676.84,
            "transcript": "Arnaq-gguq iterluni."
        },
        "69": {
            "start": 676.84,
            "end": 684.52,
            "transcript": "Tua-llu-gguq tauna arnaq itran, maurluum taum pillinia, \"Aa-a, allaneq.\""
        },
        "70": {
            "start": 684.52,
            "end": 693.42,
            "transcript": "Tua-llu taum arnam pillinia, \"Kiimetellrunricaaqua agiirtellemni ukani. Irniangqellruyaaqua."
        },
        "71": {
            "start": 693.42,
            "end": 707.18,
            "transcript": "Pitsaqevkenaku tau͡gaam nalatellruaqa epevkarluku. Taqsuqsiyaallemni acimnun pillrulliniuq.\""
        },
        "72": {
            "start": 707.18,
            "end": 718.02,
            "transcript": "Tua-i-llu taum maurluum tutgarani pillinia, \"Aullu, kailliuq! Neqliurluku!\""
        },
        "73": {
            "start": 718.02,
            "end": 728.56,
            "transcript": "Taum-gguq arnam kiugaa, \"Watua kainritua. Cangaitut-qaa atakurpak?\""
        },
        "74": {
            "start": 728.56,
            "end": 737.6,
            "transcript": "Arnam-gguq taum kiugaa, \"Atakurpak-wa maani kalukarciqellriit atualuteng yurarluteng-llu.\""
        },
        "75": {
            "start": 737.6,
            "end": 745.34,
            "transcript": "Tua-i-llu-gguq taum arnam pia, \"Taikuma nerciqua yuraliyarraarlua.\""
        },
        "76": {
            "start": 745.34,
            "end": 749.88,
            "transcript": "Tua-i-ll' anqataami-gguq atkuni cimiraa."
        },
        "77": {
            "start": 749.88,
            "end": 757.52,
            "transcript": "Atkukegtaarmek-gguq akuit wani qevleqtaalrianek at'uq."
        },
        "78": {
            "start": 757.52,
            "end": 760.26,
            "transcript": "Tua-llu-gguq agluni qasgimun."
        },
        "79": {
            "start": 760.26,
            "end": 767.2,
            "transcript": "Maaten-gguq uyangtuq atualriit yurarluteng-llu, angutii kia-i."
        },
        "80": {
            "start": 769.7,
            "end": 775.34,
            "transcript": "Tua-llu-gguq imumek cumilnguqerrnganani iterluni."
        },
        "81": {
            "start": 775.34,
            "end": 782.86,
            "transcript": "\"Atuusngaitarpenga elpet wiinga. Wangnek atuullua yurarciqua.\""
        },
        "82": {
            "start": 782.86,
            "end": 787.88,
            "transcript": "Tua-llu-gguq cikemqerluni atuqcaarluni."
        },
        "83": {
            "start": 787.88,
            "end": 791.52,
            "transcript": "Kiituani-gguq qasturiinartuq."
        },
        "84": {
            "start": 791.52,
            "end": 795.78,
            "transcript": "Qasturiinaan-llu-gguq tauna qasgiq wani"
        },
        "85": {
            "start": 795.78,
            "end": 800.4,
            "transcript": "pektengluni igqaqengluteng-llu-gguq cat navgualuteng."
        },
        "86": {
            "start": 800.4,
            "end": 809.92,
            "transcript": "Igteqataan-llu-gguq anqerrluni. Aqvaqurluni anqerrluni."
        },
        "87": {
            "start": 809.92,
            "end": 814.5,
            "transcript": "Agqertelliniluni taum arnassagaam eniinun."
        },
        "88": {
            "start": 814.5,
            "end": 817.72,
            "transcript": "Maaten-gguq itertuq kiiryukapiggluni."
        },
        "89": {
            "start": 817.72,
            "end": 824.24,
            "transcript": "Matarterraarluni atkuni cimirraarluku, taukuk wani pilliniak,"
        },
        "90": {
            "start": 824.24,
            "end": 831.68,
            "transcript": "\"Ukuk wani atakurpak anguqapiar anyaqunatek.\""
        },
        "91": {
            "start": 831.68,
            "end": 835.22,
            "transcript": "Tua-llu-gguq inarterraarluteng unuakumi,"
        },
        "92": {
            "start": 835.22,
            "end": 845.5,
            "transcript": "unuakumi maaten-gguq uyangtuk wani nunaq tauna catairutellrullinia,"
        },
        "93": {
            "start": 845.5,
            "end": 852.54,
            "transcript": "yugg'artaunani, cat-llu-gguq tamarmeng navguumaluteng."
        },
        "94": {
            "start": 852.54,
            "end": 861.76,
            "transcript": "Tua-llu-gguq taum arnassagaam pia, \"Maani ilagarlunuk uitayaureskina.\""
        },
        "95": {
            "start": 861.76,
            "end": 868.26,
            "transcript": "Akaurcami-llu-gguq tauna arnassagaq yuunrilliniluni."
        },
        "96": {
            "start": 868.26,
            "end": 879.04,
            "transcript": "Tauna-llu-gguq angun arnaq-llu aipaqsagutellinilutek irniangelliniluni-llu-gguq."
        },
        "97": {
            "start": 879.04,
            "end": 889.28,
            "transcript": "Tua-llu-gguq tauna arnaq wani nanilliungluni, aipaan-gguq pia, \"Nani uitayugyaaqelliuten?\""
        },
        "98": {
            "start": 889.28,
            "end": 900.92,
            "transcript": "Tauna-gguq arnaq kiuguq, \"Ii-i, alianiungelrianga tang wiinga nunallemnun-llu utercugyaaqlua.\""
        },
        "99": {
            "start": 900.92,
            "end": 906.6,
            "transcript": "Aipaan-gguq kiugaa, \"Ii-i, cam iliini uterciiqukuk.\""
        },
        "100": {
            "start": 906.6,
            "end": 915.54,
            "transcript": "Tua-llu-gguq uksuarmi cikuqerraarcelluku ayallinilutek upterraarlutek,"
        },
        "101": {
            "start": 915.54,
            "end": 925.18,
            "transcript": "ayaumalutek-gguq atakuarmi-gguq nuniinun taum arnam tekitellinilutek."
        },
        "102": {
            "start": 925.18,
            "end": 931.66,
            "transcript": "Tamaani-llu-gguq uitayaurrlutek. Kiituani-gguq irniangenguk amllernek."
        },
        "103": {
            "start": 931.66,
            "end": 936.04,
            "transcript": "Irniarak-llu-gguq taukuk wani irnianglutek."
        },
        "104": {
            "start": 936.04,
            "end": 943.0,
            "transcript": "Kiituani-gguq yugyagiuq tauna nunaq, nunarpaurtengluni-llu-gguq."
        },
        "105": {
            "start": 943.0,
            "end": 948.24,
            "transcript": "Yugyagiluteng-llu tuantellriit nunami."
        },
        "106": {
            "start": 949.64,
            "end": 951.18,
            "transcript": "Tua-i."
        },
        "107": {
            "start": 968.28,
            "end": 971.26,
            "transcript": "Qaillurluq pisit?"
        },
        "108": {
            "start": 972.6,
            "end": 974.48,
            "transcript": "Alingua."
        },
        "109": {
            "start": 974.48,
            "end": 979.54,
            "transcript": "Qalarucugyaaqamken tuquyuumiitua."
        },
        "110": {
            "start": 979.54,
            "end": 987.28,
            "transcript": "Alingeng'e'rpet arenqialluguteten qalarutkiki, assirinaurtuten."
        }
    },
    "PCT74QzzFao": {
        "1": {
            "start": 12.12,
            "end": 17.14,
            "transcript": "Man'a tangvagarkarci piyunarivkaumauq Kwethluk Native Store,"
        },
        "2": {
            "start": 17.14,
            "end": 21.64,
            "transcript": "Kuigglugmiut kipusviat 1949-aarminirnek."
        },
        "3": {
            "start": 38.84,
            "end": 48.44,
            "transcript": "Apqangssinariuq maani ciuqlikacagauluni Yugtun apyutnek nallunricetassiarluten."
        },
        "4": {
            "start": 48.44,
            "end": 53.24,
            "transcript": "Kitak' waniwa Kakianeq."
        },
        "5": {
            "start": 56.34,
            "end": 60.84,
            "transcript": "Waqaa, Apqangssiit tangvakatallerpeni ciuniuramci."
        },
        "6": {
            "start": 60.84,
            "end": 68.34,
            "transcript": "Apqangssiit apyutet kiutait-llu upingaut, upcimaut wani Yugtun Calivigmi."
        },
        "7": {
            "start": 68.34,
            "end": 72.88,
            "transcript": "Ukut waniwa pingayun anagtassiigutqatartut."
        },
        "8": {
            "start": 72.88,
            "end": 75.9,
            "transcript": "Ciuqliuluni waniwa Qay'aq."
        },
        "9": {
            "start": 75.9,
            "end": 77.7,
            "transcript": "Camiungusit Qay'aq?"
        },
        "10": {
            "start": 77.7,
            "end": 80.3,
            "transcript": "Tuntutuliarmiunguunga."
        },
        "11": {
            "start": 80.3,
            "end": 83.06,
            "transcript": "Maani-llu-q' elitnaurluten?"
        },
        "12": {
            "start": 83.06,
            "end": 84.48,
            "transcript": "Yaa."
        },
        "13": {
            "start": 84.48,
            "end": 86.36,
            "transcript": "Ca, what grade-aarusit?"
        },
        "14": {
            "start": 86.36,
            "end": 89.58,
            "transcript": "Nutaan ayagnirtua maani KCC-mi."
        },
        "15": {
            "start": 89.58,
            "end": 92.28,
            "transcript": "Ii-i, elitnaullren-qaa assikluku?"
        },
        "16": {
            "start": 92.28,
            "end": 93.56,
            "transcript": "Yaa, assirtuq."
        },
        "17": {
            "start": 93.56,
            "end": 98.94,
            "transcript": "Ii-i, kitak' kinguqlia-wa Cuucuq. Cali, naken kingunengqercit?"
        },
        "18": {
            "start": 98.94,
            "end": 101.84,
            "transcript": "Tuntutuliarmiumek cali."
        },
        "19": {
            "start": 101.84,
            "end": 106.98,
            "transcript": "Yaa, cali-qaa maa-i nutaan wall'u-qaa qavcilirluten elitnaurtuten?"
        },
        "20": {
            "start": 106.98,
            "end": 112.02,
            "transcript": "Nutaan elitnaurtua wani KCC-mi."
        },
        "21": {
            "start": 112.02,
            "end": 115.16,
            "transcript": "Pingayuak-wa Angall'aq, right?"
        },
        "22": {
            "start": 115.16,
            "end": 117.12,
            "transcript": "Yaa, camiunguluten?"
        },
        "23": {
            "start": 117.12,
            "end": 119.08,
            "transcript": "Kassiglurmiunguunga."
        },
        "24": {
            "start": 119.08,
            "end": 121.72,
            "transcript": "Cali-qaa maa-i first year-aqluku?"
        },
        "25": {
            "start": 121.72,
            "end": 125.1,
            "transcript": "Yaa, nutaan ayagnirtua maa-i elitnaunermek."
        },
        "26": {
            "start": 125.1,
            "end": 127.9,
            "transcript": "Okay, yaa."
        },
        "27": {
            "start": 127.9,
            "end": 138.8,
            "transcript": "Ii-i, ukut waniwa pingayun anagtassiigutarkat ayagnirpailemta number-aanek tegulluteng kina tayim' ciuqliugarkaucia pillruat."
        },
        "28": {
            "start": 138.8,
            "end": 143.24,
            "transcript": "Tua-i-llu una Qay'aq waniwa ciuqliuluni."
        },
        "29": {
            "start": 143.24,
            "end": 150.58,
            "transcript": "Ukut-llu cikiutait waniwa Kuiggluk Corporation-aamek kingunengqelliniut kankut cikiutet."
        },
        "30": {
            "start": 150.58,
            "end": 158.08,
            "transcript": "First prize-aq kana-i drill-amek, electric drill-aamek unangeciqelliniuq."
        },
        "31": {
            "start": 158.08,
            "end": 165.0,
            "transcript": "Kinguqliat-llu second place-aq kankunek angicissuutnek kana-i unangluni."
        },
        "32": {
            "start": 165.0,
            "end": 176.14,
            "transcript": "Pingayuat-wa ingkunek kakiviit taum ingkunek-llu call' ilaluteng canek atu'urkaitnek elitnauqata."
        },
        "33": {
            "start": 176.14,
            "end": 179.54,
            "transcript": "Waniwa ayagnirluki ukut wani."
        },
        "34": {
            "start": 179.54,
            "end": 184.04,
            "transcript": "Ayagyuat 10 points pingqertut. Nallunaunateng."
        },
        "35": {
            "start": 184.04,
            "end": 192.86,
            "transcript": "Kinguqliit-wa taqneret. Nallunarqenruurluteng ukuni, yuinarnek point-arluteng, 20 points."
        },
        "36": {
            "start": 192.86,
            "end": 199.84,
            "transcript": "Ukut-llu tegganret. Nallunarqenruluteng ukuni wani."
        },
        "37": {
            "start": 199.84,
            "end": 206.38,
            "transcript": "Tayim' ayainanemteńi regular question-aat piaqata 10 seconds piciquci."
        },
        "38": {
            "start": 206.38,
            "end": 209.46,
            "transcript": "Estimate question-aat-llu 20 seconds."
        },
        "39": {
            "start": 209.46,
            "end": 218.18,
            "transcript": "Waniku-llu taqniaraqumta apallugpagciqukut. Apallugpakumta 30 seconds time-amek cikiumaciquci."
        },
        "40": {
            "start": 218.18,
            "end": 221.4,
            "transcript": "Taum ilani kiugarkauluci."
        },
        "41": {
            "start": 221.4,
            "end": 227.12,
            "transcript": "Kitak'-wa Apqangssiit ayagnirluki wani waniw' Qay'am ayagniuteqataraakut."
        },
        "42": {
            "start": 227.12,
            "end": 229.62,
            "transcript": "Ayagyuat five."
        },
        "43": {
            "start": 229.62,
            "end": 232.14,
            "transcript": "Ayagyuat five."
        },
        "44": {
            "start": 232.14,
            "end": 233.74,
            "transcript": "Ii-i, waniw' apyun."
        },
        "45": {
            "start": 233.74,
            "end": 237.44,
            "transcript": "Doctor-aat Yugtun canek pilartatki?"
        },
        "46": {
            "start": 237.44,
            "end": 238.68,
            "transcript": "Yungcaristet."
        },
        "47": {
            "start": 238.68,
            "end": 241.9,
            "transcript": "Assirtuq, 10 points."
        },
        "48": {
            "start": 241.9,
            "end": 246.12,
            "transcript": "Ii-i, kitak'-wa cali cucukesciiqatartuten."
        },
        "49": {
            "start": 246.12,
            "end": 249.0,
            "transcript": "Ayagyuat one."
        },
        "50": {
            "start": 249.0,
            "end": 253.32,
            "transcript": "Ayagyuat one. Ayagyuat cukaciqsugnarqut."
        },
        "51": {
            "start": 253.32,
            "end": 259.42,
            "transcript": "Tape recorder-aat Yugcetun canek pilartatki?"
        },
        "52": {
            "start": 259.42,
            "end": 261.74,
            "transcript": "Imirissuutet."
        },
        "53": {
            "start": 261.74,
            "end": 269.5,
            "transcript": "Nuu, nall'artenritan kiutii. Kitak' Cuucuq, tape recorder-aat Yugcetun canek pilartatki?"
        },
        "54": {
            "start": 269.5,
            "end": 271.34,
            "transcript": "Aturcetaanek?"
        },
        "55": {
            "start": 271.34,
            "end": 282.8,
            "transcript": "No, kitak' Angass'aq, tape recorder-aat Yugcetun canek pilartatki?"
        },
        "56": {
            "start": 282.8,
            "end": 285.84,
            "transcript": "Naamell', nalluaqa."
        },
        "57": {
            "start": 285.84,
            "end": 292.58,
            "transcript": "Waniwa kiutii, erinairissuutnek. Tape recorder-aat Yugtun pilalliniit."
        },
        "58": {
            "start": 292.58,
            "end": 294.46,
            "transcript": "Ii-i, kitak' Cuucuq."
        },
        "59": {
            "start": 294.46,
            "end": 299.2,
            "transcript": "Taqneret one."
        },
        "60": {
            "start": 299.2,
            "end": 301.5,
            "transcript": "Nallunarqenruurtut ukut."
        },
        "61": {
            "start": 301.5,
            "end": 306.64,
            "transcript": "Elliviit qertulrianek tusnganelget canek pilarceta?"
        },
        "62": {
            "start": 313.66,
            "end": 315.16,
            "transcript": "Naam'."
        },
        "63": {
            "start": 316.82,
            "end": 326.0,
            "transcript": "Cuucuq, elliviit, oh, Angass'aq, excuse me, elliviit qertulrianek tusnganelget canek pilarceta?"
        },
        "64": {
            "start": 326.0,
            "end": 327.1,
            "transcript": "Qulvarvik?"
        },
        "65": {
            "start": 327.1,
            "end": 333.68,
            "transcript": "Assirtuq, 20 points. Tua-llu tua-i cucukesciiqatartuq."
        },
        "66": {
            "start": 333.68,
            "end": 336.32,
            "transcript": "Taqneret number two."
        },
        "67": {
            "start": 336.32,
            "end": 340.72,
            "transcript": "Taqneret number two."
        },
        "68": {
            "start": 340.72,
            "end": 351.58,
            "transcript": "Una bonus question-aaruq. Right-aquvgu wani double-score-arciquten 40 points. Waniwa."
        },
        "69": {
            "start": 351.58,
            "end": 357.0,
            "transcript": "Napat akunliitgun tumyarat ayalriit canek pilartatki?"
        },
        "70": {
            "start": 357.0,
            "end": 358.64,
            "transcript": "Pulayarat?"
        },
        "71": {
            "start": 358.64,
            "end": 364.7,
            "transcript": "Assirtuq, 40 points. Ii-i, tua-llu tua-i cali."
        },
        "72": {
            "start": 364.7,
            "end": 369.22,
            "transcript": "Tungliat taqneret number three."
        },
        "73": {
            "start": 369.22,
            "end": 371.8,
            "transcript": "Taqneret number three."
        },
        "74": {
            "start": 375.72,
            "end": 384.32,
            "transcript": "Kuvyalriit neqtateng tunyarturaqatki calarniitki?"
        },
        "75": {
            "start": 384.32,
            "end": 385.8,
            "transcript": "Ikugyartulartut."
        },
        "76": {
            "start": 385.8,
            "end": 391.42,
            "transcript": "Assirtuq, 20 points. Ii-i, tua-llu tua-i cali Angass'aq."
        },
        "77": {
            "start": 391.42,
            "end": 394.38,
            "transcript": "Number four, taqneret."
        },
        "78": {
            "start": 394.38,
            "end": 401.48,
            "transcript": "Number four, taqneret. Una? Yaa."
        },
        "79": {
            "start": 401.48,
            "end": 408.8,
            "transcript": "Maklaarnek pissuryaraqata canilartatki?"
        },
        "80": {
            "start": 408.8,
            "end": 410.44,
            "transcript": "Qamigalartut."
        },
        "81": {
            "start": 410.44,
            "end": 415.72,
            "transcript": "Yaa, assirtuq, cali 20 points. Ii-i, tua-llu tua-i, kiik' ayagturluten."
        },
        "82": {
            "start": 415.72,
            "end": 422.44,
            "transcript": "Taqneret number five."
        },
        "83": {
            "start": 422.44,
            "end": 425.82,
            "transcript": "Halloween-aaq Yugcetun camek pilartatgu?"
        },
        "84": {
            "start": 425.82,
            "end": 427.28,
            "transcript": "Qaariitaarvik."
        },
        "85": {
            "start": 427.28,
            "end": 433.62,
            "transcript": "Assirtuq, cali 20 points. Ii-i, tua-llu tua-i cali."
        },
        "86": {
            "start": 433.62,
            "end": 436.18,
            "transcript": "Taqneret number nine."
        },
        "87": {
            "start": 436.18,
            "end": 438.5,
            "transcript": "Taqneret number nine."
        },
        "88": {
            "start": 442.64,
            "end": 445.82,
            "transcript": "Rope-aq cauga Yugcetun?"
        },
        "89": {
            "start": 445.82,
            "end": 452.18,
            "transcript": "Rope-aq? Yaa."
        },
        "90": {
            "start": 452.18,
            "end": 453.62,
            "transcript": "Taqmak."
        },
        "91": {
            "start": 453.62,
            "end": 458.88,
            "transcript": "Nuu. Kitak' Qay'aq, rope-aq Yugcetun cauga?"
        },
        "92": {
            "start": 458.88,
            "end": 460.0,
            "transcript": "Ilavkuk?"
        },
        "93": {
            "start": 460.0,
            "end": 465.22,
            "transcript": "Assirtuq, 20 points. Ii-i, tua-llu tua-i."
        },
        "94": {
            "start": 465.24,
            "end": 468.76,
            "transcript": "Tegganret number 10."
        },
        "95": {
            "start": 468.76,
            "end": 471.28,
            "transcript": "Taqneret tua-ll' ukut taqneret."
        },
        "96": {
            "start": 471.28,
            "end": 474.16,
            "transcript": "Yaa, taqneret number 10. Okay."
        },
        "97": {
            "start": 477.38,
            "end": 488.24,
            "transcript": "Pelacinagmek naangualriit canilarceta?"
        },
        "98": {
            "start": 500.4,
            "end": 506.34,
            "transcript": "Kinguraututen. Kitak' Cuucuq, pelacinagmek naangualriit canilarceta?"
        },
        "99": {
            "start": 506.34,
            "end": 507.86,
            "transcript": "Aarrarluteng."
        },
        "100": {
            "start": 507.86,
            "end": 513.18,
            "transcript": "Yaa, assirtuq, 20 points. Ii-i tua-llu tua-i."
        },
        "101": {
            "start": 513.18,
            "end": 515.7,
            "transcript": "Taqneret six."
        },
        "102": {
            "start": 515.7,
            "end": 518.32,
            "transcript": "Taqneret six."
        },
        "103": {
            "start": 518.32,
            "end": 528.9,
            "transcript": "Una estimate question-aaruuq. Kiuteci kalikamun igaulluki piciqaci qanrutkevkenaki, 20 seconds-llu cali time-angqerciqluci."
        },
        "104": {
            "start": 528.9,
            "end": 530.7,
            "transcript": "Waniwa apyun."
        },
        "105": {
            "start": 530.7,
            "end": 536.64,
            "transcript": "Atmaulluarmiut Mamterillermek qaillun tengssuutekun yaaqsigtaat?"
        },
        "106": {
            "start": 536.64,
            "end": 542.86,
            "transcript": "Atmaulluarmiut Mamterillermek qaillun tengssuutekun yaaqsigtaat?"
        },
        "107": {
            "start": 559.24,
            "end": 561.08,
            "transcript": "Taq'uci-qaa tamarpeci?"
        },
        "108": {
            "start": 561.08,
            "end": 562.9,
            "transcript": "Ii-i, tua-ll' Qay'aq camek kiutengqercit?"
        },
        "109": {
            "start": 562.9,
            "end": 568.78,
            "transcript": "20 miles, Cuucuq, 20 miles, Angass'aq, 10 miles."
        },
        "110": {
            "start": 568.78,
            "end": 584.32,
            "transcript": "19 miles yaaqsigtauq. Angass'am unakaa acitmun mallenruamiu. 20 points imanguq. Ii-i, tua-llu tua-i cucukelciiqatartuq."
        },
        "111": {
            "start": 584.32,
            "end": 586.72,
            "transcript": "Taqneret number seven."
        },
        "112": {
            "start": 586.72,
            "end": 591.42,
            "transcript": "Taqneret number seven."
        },
        "113": {
            "start": 591.42,
            "end": 595.5,
            "transcript": "Ekvicuarmiut camek pilarceta? Camiumek."
        },
        "114": {
            "start": 595.5,
            "end": 601.54,
            "transcript": "Aren, camiunek pilarceta?"
        },
        "115": {
            "start": 601.54,
            "end": 603.56,
            "transcript": "Urr'acuarmiut?"
        },
        "116": {
            "start": 603.56,
            "end": 610.42,
            "transcript": "Nuu. Kitek' Qay'aq, Ekvicuarmiut camiunek pilarceta?"
        },
        "117": {
            "start": 610.42,
            "end": 612.54,
            "transcript": "Eek, Alaska."
        },
        "118": {
            "start": 612.54,
            "end": 621.62,
            "transcript": "Yaa, assirtuq. Iigmiut, 20 points. Ii-i, tua-llu tua-i."
        },
        "119": {
            "start": 621.62,
            "end": 624.46,
            "transcript": "Tegganret eight."
        },
        "120": {
            "start": 624.46,
            "end": 630.88,
            "transcript": "Tegganret eight. (I mean.) Taqneret? (Yaa, taqneret eight.) Taqneret nangqatartut, look."
        },
        "121": {
            "start": 630.88,
            "end": 636.46,
            "transcript": "Bonus question. Assirluku call' kiukuvgu 40 points pingciquten."
        },
        "122": {
            "start": 636.46,
            "end": 644.12,
            "transcript": "Twine-aq cauga Yugcetun?"
        },
        "123": {
            "start": 644.12,
            "end": 646.44,
            "transcript": "Naamell'."
        },
        "124": {
            "start": 646.44,
            "end": 653.68,
            "transcript": "Kitak' Cuucuq, twine-aq cauga Yugcetun?"
        },
        "125": {
            "start": 653.68,
            "end": 654.96,
            "transcript": "Pelacinak."
        },
        "126": {
            "start": 654.96,
            "end": 660.4,
            "transcript": "Assirtuq. 40 points. Ii-i, tua-llu tua-i."
        },
        "127": {
            "start": 660.4,
            "end": 663.42,
            "transcript": "Taqneret 11."
        },
        "128": {
            "start": 663.48,
            "end": 665.74,
            "transcript": "Taqnereteng nangqatartut."
        },
        "129": {
            "start": 665.74,
            "end": 672.04,
            "transcript": "Estimate question. Tamarpeci call' kiuqatararci, igautniararci kiuteci."
        },
        "130": {
            "start": 672.04,
            "end": 677.96,
            "transcript": "Kangirnarmiut Mamterillernek tengssuutekun qaillun yaaqsigtaat?"
        },
        "131": {
            "start": 677.96,
            "end": 685.8,
            "transcript": "Kangirnarmiut Mamterillernek tengssuutekun qaillun yaaqsigtaat?"
        },
        "132": {
            "start": 693.64,
            "end": 706.3,
            "transcript": "Estimate question-aq taringumanrilkuvciu, acitmun wani, acitmun mallenqurri answer-aara wani right-arciquq tau͡gkun kiturluku mallengqerpeciu wani unakevkenaku."
        },
        "133": {
            "start": 706.3,
            "end": 717.58,
            "transcript": "Ii-i tua-llu tua-i, Qay'aq 40 miles, Cuucuq 65, Angass'aq 60 miles."
        },
        "134": {
            "start": 717.58,
            "end": 725.78,
            "transcript": "80 miles wani yaaqsigtauq. Cuucum unakaa, 20 points."
        },
        "135": {
            "start": 725.78,
            "end": 737.22,
            "transcript": "Waniwa Qay'aq 50 points unangellrurtuq, Cuucuq 80 points, Angass'aq 140, ciuqliuluni Angass'aq."
        },
        "136": {
            "start": 737.22,
            "end": 748.1,
            "transcript": "Waniwa elpeci qagaani uitalriani, im'umek, call-in question-aamek apteqatartua."
        },
        "137": {
            "start": 748.1,
            "end": 753.16,
            "transcript": "Kinguakun wani phone number-aaq aqerturciqaqa apyun apqaarluku."
        },
        "138": {
            "start": 753.16,
            "end": 756.46,
            "transcript": "Waniwa apyun."
        },
        "139": {
            "start": 756.46,
            "end": 761.56,
            "transcript": "Qayuss'aat caugat? Qayuss'aat caugat?"
        },
        "140": {
            "start": 761.56,
            "end": 770.12,
            "transcript": "Wani phone number-aq call-ararkarci 3654, 3654."
        },
        "141": {
            "start": 770.12,
            "end": 771.8,
            "transcript": "Qayussaaq."
        },
        "142": {
            "start": 771.8,
            "end": 777.38,
            "transcript": "Qayussaaq caugat?"
        },
        "143": {
            "start": 777.38,
            "end": 784.62,
            "transcript": "Aipaagni una wani apcurlagyugnarqaqa, qayussaat, waten igausngauq."
        },
        "144": {
            "start": 784.62,
            "end": 791.56,
            "transcript": "Yaa, waniwa ava-i kiugarkarci. Phone number-aaq-wa 3654."
        },
        "145": {
            "start": 791.56,
            "end": 795.74,
            "transcript": "Ii-i, kitek' ayagluta kina ava-i wani taqellrua?"
        },
        "146": {
            "start": 795.74,
            "end": 798.5,
            "transcript": "Cuucuq-qaa cucukeciqatartuq, okay?"
        },
        "147": {
            "start": 800.7,
            "end": 803.5,
            "transcript": "Taqneret twelve."
        },
        "148": {
            "start": 803.5,
            "end": 806.81,
            "transcript": "Taqneret nangqatartut. Atauciq tayima."
        },
        "149": {
            "start": 806.81,
            "end": 817.945,
            "transcript": "Qimugtetgun anagtassiigutellriit canilarceta?"
        },
        "150": {
            "start": 817.945,
            "end": 819.559,
            "transcript": "Aqvautaarluteng."
        },
        "151": {
            "start": 819.559,
            "end": 824.851,
            "transcript": "Assirtuq, 20 points. Ii-i, tua-llu tua-i-am cali."
        },
        "152": {
            "start": 824.851,
            "end": 827.241,
            "transcript": "Taqneret thirteen."
        },
        "153": {
            "start": 827.241,
            "end": 830.715,
            "transcript": "Taqneret thirteen. Tua-ll' nangluni."
        },
        "154": {
            "start": 830.919,
            "end": 846.447,
            "transcript": "Cat angtaciit nallunringnaqaqamteki canilartat?"
        },
        "155": {
            "start": 846.447,
            "end": 847.591,
            "transcript": "Kitek' nutaan."
        },
        "156": {
            "start": 847.591,
            "end": 854.947,
            "transcript": "Cat angtaciit nallunringnaqaqamegteki canilartat?"
        },
        "157": {
            "start": 859.088,
            "end": 861.324,
            "transcript": "Cuqnguaqerluni."
        },
        "158": {
            "start": 861.324,
            "end": 868.323,
            "transcript": "Assirtuq, cuqniluteng, 20 points. Ii-i, tua-llu tua-i."
        },
        "159": {
            "start": 868.323,
            "end": 871.543,
            "transcript": "Tegganret five."
        },
        "160": {
            "start": 871.543,
            "end": 875.97,
            "transcript": "Tegganret five. 30 points una pingqertuq."
        },
        "161": {
            "start": 875.97,
            "end": 880.308,
            "transcript": "Yaqulget tengesciigaliaqata canek pilarceta?"
        },
        "162": {
            "start": 880.308,
            "end": 881.537,
            "transcript": "Ingtanek."
        },
        "163": {
            "start": 881.537,
            "end": 887.239,
            "transcript": "Assirtuq, 30 points. Ii-i, tua-llu tua-i cali."
        },
        "164": {
            "start": 887.239,
            "end": 889.632,
            "transcript": "Tegganret one."
        },
        "165": {
            "start": 889.654,
            "end": 894.752,
            "transcript": "Tegganret one."
        },
        "166": {
            "start": 894.752,
            "end": 897.413,
            "transcript": "Okay, waniw' apyun."
        },
        "167": {
            "start": 897.413,
            "end": 904.724,
            "transcript": "Arnat uilget qamiqumeggni camek atulartat?"
        },
        "168": {
            "start": 904.724,
            "end": 908.84,
            "transcript": "Arnat uilget qamiqumeggni camek atulartat?"
        },
        "169": {
            "start": 913.6,
            "end": 914.919,
            "transcript": "Pelatuugmek."
        },
        "170": {
            "start": 914.919,
            "end": 919.012,
            "transcript": "Nuu. Ii-i, kitek' Angass'aq."
        },
        "171": {
            "start": 919.012,
            "end": 924.4,
            "transcript": "Arnat uilget qamiqumeggni camek atulartat?"
        },
        "172": {
            "start": 924.4,
            "end": 925.652,
            "transcript": "Kaapaamek."
        },
        "173": {
            "start": 925.652,
            "end": 934.96,
            "transcript": "Assirtuq, 30 points. Una wani apyun kingunengqertuq Eileen Jenkins Nunapicuarmek. Ii-i, tua-llu tua-i."
        },
        "174": {
            "start": 934.96,
            "end": 940.432,
            "transcript": "Tegganret number two."
        },
        "175": {
            "start": 940.432,
            "end": 947.743,
            "transcript": "Estimate question, tamarpeci call' kiuqatararci. 20 points cikiumaciiquci."
        },
        "176": {
            "start": 947.743,
            "end": 953.199,
            "transcript": "Kuigglugmiut qaillun tengssuutekun yaaqsigtaat?"
        },
        "177": {
            "start": 953.199,
            "end": 958.789,
            "transcript": "Kuigglugmiut qaillun tengssuutetgun yaaqsigtaat?"
        },
        "178": {
            "start": 967.375,
            "end": 980.567,
            "transcript": "Ii-i, taq'uci-qaa? Tua-ll' Qay'aq, four miles, Cuucuq, 15 miles, Angass'aq, 12 miles."
        },
        "179": {
            "start": 980.567,
            "end": 986.514,
            "transcript": "Angass'aq right-artuq. 12 miles yaaqsigtauq. 30 points unangluni."
        },
        "180": {
            "start": 986.514,
            "end": 1003.06,
            "transcript": "Waniw' ava-i wani au͡g'um call-in question-aam kiutii Margaret Ayapan, Kuigglugmek kingunerluni. Taum assirluku una kiullinia waniw' apyutleq."
        },
        "181": {
            "start": 1003.06,
            "end": 1013.189,
            "transcript": "Qayuss'aat caugat? Qayussaat caugat? Kiutii-wa yuurqaaraat."
        },
        "182": {
            "start": 1013.189,
            "end": 1018.51,
            "transcript": "Tua-i tauna wani taum Margaret Ayapan-am unakellinia Kuigglugmium."
        },
        "183": {
            "start": 1018.51,
            "end": 1029.109,
            "transcript": "Unangutii-wa una waniwa. Alarcugnarqua, uungunricugnarquq."
        },
        "184": {
            "start": 1029.109,
            "end": 1044.783,
            "transcript": "$25 gift certificate-aamek unangellrulliniuq. Naken tayim'? Nutarat Elitnaurcuutet, tuaken kingunerluni $25 gift certificate-aamek unangluni."
        },
        "185": {
            "start": 1044.783,
            "end": 1050.484,
            "transcript": "Ii-i, kitak' ayagluta wani Angass'aq ava-i kiutii assillruuq. Cucukelciiqatartuq."
        },
        "186": {
            "start": 1050.484,
            "end": 1055.135,
            "transcript": "Tegganret number three."
        },
        "187": {
            "start": 1055.135,
            "end": 1062.76,
            "transcript": "30 points una pingqertuq. Bonus question, assirluku kiukuvu 60 points pingciquten."
        },
        "188": {
            "start": 1062.76,
            "end": 1069.244,
            "transcript": "Cat kayangulartat uksuuluku?"
        },
        "189": {
            "start": 1069.244,
            "end": 1073.492,
            "transcript": "Cat kayangulartat uksuuluku?"
        },
        "190": {
            "start": 1079.462,
            "end": 1083.263,
            "transcript": "Sass'an nangqertuq. Ii-i, tua-llu tua-i Qay'aq."
        },
        "191": {
            "start": 1083.263,
            "end": 1086.684,
            "transcript": "Cat kayangulartat uksuuluku?"
        },
        "192": {
            "start": 1086.684,
            "end": 1088.16,
            "transcript": "Tulukaruut."
        },
        "193": {
            "start": 1088.16,
            "end": 1094.935,
            "transcript": "Assirtuq, 60 points. Ii-i, tua-llu tua-i."
        },
        "194": {
            "start": 1094.935,
            "end": 1097.148,
            "transcript": "Tegganret six."
        },
        "195": {
            "start": 1097.148,
            "end": 1103.789,
            "transcript": "Tegganret six."
        },
        "196": {
            "start": 1103.789,
            "end": 1108.44,
            "transcript": "Aarraangit canek cali pilarceta?"
        },
        "197": {
            "start": 1118.367,
            "end": 1122.168,
            "transcript": "Sass'an nangqertuq. Cuucuq, aarraangit canek pilarceta?"
        },
        "198": {
            "start": 1122.168,
            "end": 1123.778,
            "transcript": "Allgiarnek."
        },
        "199": {
            "start": 1123.778,
            "end": 1131.514,
            "transcript": "Assirtuq, 30 points. Yaa, 30 points unanguq. Ii-i, tua-llu tua-i cali."
        },
        "200": {
            "start": 1131.514,
            "end": 1137.551,
            "transcript": "Tegganret four."
        },
        "201": {
            "start": 1137.551,
            "end": 1139.698,
            "transcript": "Waniw' apyun."
        },
        "202": {
            "start": 1139.698,
            "end": 1150.43,
            "transcript": "Cat yaquleyagaat uivvaarturalartat mecagglugni?"
        },
        "203": {
            "start": 1150.43,
            "end": 1152.219,
            "transcript": "Imaqcaaraat."
        },
        "204": {
            "start": 1152.219,
            "end": 1159.262,
            "transcript": "Yaa, assirtuq. Una wani cali Eileen Jenkins-aamek kingunengqertuq Nunapicuamek apyun."
        },
        "205": {
            "start": 1159.262,
            "end": 1165.009,
            "transcript": "Ii-i, tua-llu tua-i cali Cuucuq ayakatartuq. 30 points unangellruuq."
        },
        "206": {
            "start": 1165.009,
            "end": 1169.96,
            "transcript": "Tegganret seven."
        },
        "207": {
            "start": 1169.96,
            "end": 1176.233,
            "transcript": "Bonus question. Assirluku kiukuvu 60 points unangeciquten."
        },
        "208": {
            "start": 1176.233,
            "end": 1187.211,
            "transcript": "Aaqiitaayaurrluarluq kia at'ullallruagu?"
        },
        "209": {
            "start": 1187.211,
            "end": 1189.246,
            "transcript": "Joe Paul."
        },
        "210": {
            "start": 1189.581,
            "end": 1197.765,
            "transcript": "Wait, atuutellruagu?"
        },
        "211": {
            "start": 1197.765,
            "end": 1204.316,
            "transcript": "Aaqiitaayaurrluarluq kia atuutellruagu?"
        },
        "212": {
            "start": 1204.316,
            "end": 1210.912,
            "transcript": "Sass'aq nangqertuq. Kitak' Angass'aq, Aaqiitaayaurrluarluq kia atuutellruagu?"
        },
        "213": {
            "start": 1210.912,
            "end": 1212.097,
            "transcript": "Kaviarem?"
        },
        "214": {
            "start": 1212.097,
            "end": 1220.791,
            "transcript": "Nuu. Kitak' Qay'aq, kia atuutellruagu aaqiitaayaurrluarluq?"
        },
        "215": {
            "start": 1220.791,
            "end": 1222.15,
            "transcript": "Joe Paul."
        },
        "216": {
            "start": 1224.153,
            "end": 1232.419,
            "transcript": "Nuu. Kiutii waniwa, Inuguam. Inuguam atuutellrullinia Aaqiitaayaurrluarluq."
        },
        "217": {
            "start": 1232.419,
            "end": 1240.846,
            "transcript": "Kitak' Qay'aq piqatalliuq-qaa? Cucukelciiqatartuten."
        },
        "218": {
            "start": 1240.846,
            "end": 1242.411,
            "transcript": "Tegganret eight."
        },
        "219": {
            "start": 1245.451,
            "end": 1247.108,
            "transcript": "Waniw' apyun."
        },
        "220": {
            "start": 1247.108,
            "end": 1264.976,
            "transcript": "Nunapicuaq number two-mi kina kipusvingqerqaarraallrua?"
        },
        "221": {
            "start": 1268.96,
            "end": 1270.755,
            "transcript": "Naamell'."
        },
        "222": {
            "start": 1270.755,
            "end": 1277.524,
            "transcript": "Ii-i, kitek' Cuucuq, Nunapicuaq number two-mi kina kipusvingqerqaarraallrua?"
        },
        "223": {
            "start": 1277.524,
            "end": 1279.849,
            "transcript": "Herman Neck-aq?"
        },
        "224": {
            "start": 1279.849,
            "end": 1282.981,
            "transcript": "Kina? Herman Neck? Nuu."
        },
        "225": {
            "start": 1282.981,
            "end": 1289.543,
            "transcript": "Angass'aq, Nunapicuaq number two-mi kina kipusvingqerqaarraallrua?"
        },
        "226": {
            "start": 1289.566,
            "end": 1290.878,
            "transcript": "Mochin?"
        },
        "227": {
            "start": 1290.878,
            "end": 1297.509,
            "transcript": "Mochin? Nuu, Cakayak, John Cakayak kipusvingqerqaarraallrulliniuq."
        },
        "228": {
            "start": 1297.509,
            "end": 1300.986,
            "transcript": "Ii-i, tua-ll' Cuucuq."
        },
        "229": {
            "start": 1300.986,
            "end": 1302.96,
            "transcript": "Tegganret nine."
        },
        "230": {
            "start": 1305.683,
            "end": 1311.969,
            "transcript": "Waniw' apyun, estimate question. Tamarpeci kiuciqaci."
        },
        "231": {
            "start": 1311.969,
            "end": 1319.797,
            "transcript": "Tuntutuliaq Mamterillermek qaillun tengssuutekun yaaqsigtaa?"
        },
        "232": {
            "start": 1319.797,
            "end": 1327.211,
            "transcript": "Tuntutuliaq tengssuutekun qaillun yaaqsigtaa?"
        },
        "233": {
            "start": 1327.211,
            "end": 1337.02,
            "transcript": "Tuar taq'erci wani. Tamarpet kiugarci. Sass'arci apaqsaicaaquq. Taqkuvci taugaam. (Taqngatua.) Taq'uci ai?"
        },
        "234": {
            "start": 1337.02,
            "end": 1345.654,
            "transcript": "Ii-i, tua-ll' Qay'aq, camek kiutengqercit? 50 miles, Cuucuq, 48, Angass'aq, 45."
        },
        "235": {
            "start": 1345.654,
            "end": 1349.798,
            "transcript": "Naparyarrarmium right-arluku kiugaa wani, 45 miles."
        },
        "236": {
            "start": 1351.433,
            "end": 1356.66,
            "transcript": "[?] 30 points unanguq."
        },
        "237": {
            "start": 1356.66,
            "end": 1366.745,
            "transcript": "Waniw' apaallugpakatartukut. Apallugpakumta bet-arciquci score-aci qanrutekciqaqa waniwa."
        },
        "238": {
            "start": 1366.745,
            "end": 1377.083,
            "transcript": "Qay'aq 110, 110-aanek point-angqertuq, Cuucuq 210, Angass'aq 230."
        },
        "239": {
            "start": 1377.083,
            "end": 1389.562,
            "transcript": "Bet-aquvci wani score-aci ciptevkenaku bet-arciquci. Waniw' apyun apepailemku bet-arciquci, bet-arluci."
        },
        "240": {
            "start": 1397.413,
            "end": 1405.173,
            "transcript": "Qay'aq 110, Cuucuq 210, Angass'aq-llu 230."
        },
        "241": {
            "start": 1410.584,
            "end": 1419.955,
            "transcript": "Ii-i, tua-i taq'uci tamarpeci. Waniw' apyun. Apyutesci cali igauciiqaci, igaulluki piciqaci. Oh."
        },
        "242": {
            "start": 1419.955,
            "end": 1422.764,
            "transcript": "Ii-i, kitak' bet-alci caugat?"
        },
        "243": {
            "start": 1422.764,
            "end": 1430.822,
            "transcript": "Qay'aq 60 points bet-artuq, Cuucuq 60, Angass'aq 30."
        },
        "244": {
            "start": 1430.822,
            "end": 1435.082,
            "transcript": "Ii-i, waniw' apyun. Igaulluku call' kiutesci piciqaci."
        },
        "245": {
            "start": 1435.082,
            "end": 1442.864,
            "transcript": "Kuiget nanvanun anumalartut. Nanvaq kuigem cakau?"
        },
        "246": {
            "start": 1442.864,
            "end": 1452.488,
            "transcript": "Kuiget nanvanun anumalartut. Nanvaq kuigem cakau?"
        },
        "247": {
            "start": 1452.488,
            "end": 1456.96,
            "transcript": "Igaulluku wani kiuteci."
        },
        "248": {
            "start": 1460.087,
            "end": 1465.934,
            "transcript": "Tua-i-q' taq'uci? Taqsugnarqut tamarmeng."
        },
        "249": {
            "start": 1465.96,
            "end": 1482.351,
            "transcript": "Waniwa Qay'aq, Qay'am kiutii qagatekaa, qagatii. Cuucuq qagatii. Angass'aq..."
        },
        "250": {
            "start": 1482.351,
            "end": 1483.94,
            "transcript": "Egmiumaneq."
        },
        "251": {
            "start": 1483.94,
            "end": 1484.723,
            "transcript": "Natii?"
        },
        "252": {
            "start": 1484.746,
            "end": 1485.759,
            "transcript": "Egmiumaneq."
        },
        "253": {
            "start": 1485.759,
            "end": 1487.325,
            "transcript": "Egmiumaneq."
        },
        "254": {
            "start": 1487.325,
            "end": 1499.597,
            "transcript": "Ukuk wani uum kiutii apallugpiim qagatiii. Assirluku ukuk wani kiugaak malruk, Cuucunkuk Qay'aq-llu."
        },
        "255": {
            "start": 1499.597,
            "end": 1508.715,
            "transcript": "60 points tamarmek wani bet-allruuk. Angass'aq 30 points."
        },
        "256": {
            "start": 1508.715,
            "end": 1517.51,
            "transcript": "Waniw' ukut wani im'ullret, score-ait waten ayuqut."
        },
        "257": {
            "start": 1517.51,
            "end": 1524.418,
            "transcript": "Qay'aq 160, Cuucuq 270, Angass'aq 200."
        },
        "258": {
            "start": 1524.418,
            "end": 1541.962,
            "transcript": "Anagngaunani waniwa Cuucuq unangluni kat'umek drill-amek. Angass'aq kankunek angicissuutnek. Kakiviitamek-llu Qay'aq."
        },
        "259": {
            "start": 1541.962,
            "end": 1549.284,
            "transcript": "Waniw' ava-i wani unangekait."
        },
        "260": {
            "start": 1549.284,
            "end": 1555.086,
            "transcript": "Quyanaqvaa-ll' tailuci. (Quyana.)"
        },
        "261": {
            "start": 1616.746,
            "end": 1626.509,
            "transcript": "Man'a tangvalci piunarivkaumauq Kwethluk Native Store, Kuigglugmiut kipusviat 1949-aarminirnek."
        },
        "262": {
            "start": 1653.747,
            "end": 1664.845,
            "transcript": "Apqangssinariuq cuqlikacagauluni maani KYUK TV-tgun Yugtun nallunricetassiarluteng apyutnek."
        },
        "263": {
            "start": 1664.845,
            "end": 1668.736,
            "transcript": "Kitaki waniwa Kaukaq."
        },
        "264": {
            "start": 1669.749,
            "end": 1679.12,
            "transcript": "Waqaa! Ciuniramceci apqangssiqatallemteńi wall'u elpeci tangvakatallerpeceńi apqangssagnek."
        },
        "265": {
            "start": 1679.12,
            "end": 1683.794,
            "transcript": "Apyutet kiutait-llu Yugtun Qaneryaramek Calivigmi taqumaut."
        },
        "266": {
            "start": 1683.794,
            "end": 1695.145,
            "transcript": "Waniwa-llu ukut wani apqaurutkat, ayagyuat nallunrilkacagaat, taqneret nallunarqenruurluteng, tegganret-llu nallunarqenrukacaarluteng."
        },
        "267": {
            "start": 1695.145,
            "end": 1699.29,
            "transcript": "Ukut-llu waniwa apqangssagni uitaqatalriit."
        },
        "268": {
            "start": 1699.29,
            "end": 1701.109,
            "transcript": "Nunuq'aq, camiungusit?"
        },
        "269": {
            "start": 1701.109,
            "end": 1702.905,
            "transcript": "Nunapicuarmek."
        },
        "270": {
            "start": 1702.905,
            "end": 1704.77,
            "transcript": "Nani-qaa calilartuten?"
        },
        "271": {
            "start": 1704.77,
            "end": 1706.819,
            "transcript": "Calinritua maa-i."
        },
        "272": {
            "start": 1706.819,
            "end": 1710.664,
            "transcript": "Una-wa tunglia Tanuk'aq, camiungusit?"
        },
        "273": {
            "start": 1710.664,
            "end": 1712.391,
            "transcript": "Naparyarrarmiunguunga."
        },
        "274": {
            "start": 1712.391,
            "end": 1714.049,
            "transcript": "Calilartuten-qaa?"
        },
        "275": {
            "start": 1714.049,
            "end": 1715.062,
            "transcript": "Yaa."
        },
        "276": {
            "start": 1715.062,
            "end": 1717.157,
            "transcript": "Nani maani Mamterillerni?"
        },
        "277": {
            "start": 1717.157,
            "end": 1718.147,
            "transcript": "Mamterillerni."
        },
        "278": {
            "start": 1718.147,
            "end": 1722.591,
            "transcript": "Yaa, una-wa nangneqliq Al'aq, camiungusit?"
        },
        "279": {
            "start": 1722.591,
            "end": 1726.16,
            "transcript": "Kuigglugmiunguunga."
        },
        "280": {
            "start": 1727.219,
            "end": 1728.831,
            "transcript": "Calilartuten-qaa?"
        },
        "281": {
            "start": 1728.831,
            "end": 1738.179,
            "transcript": "High school-ami calilartua Yugtun qaneryaramek caliyaramek-llu elitnauringuarlua."
        },
        "282": {
            "start": 1738.179,
            "end": 1745.523,
            "transcript": "Yaa, waniwa ukut anagtassiigutqatalriit tua-i naliat elisnganruurciqluki."
        },
        "283": {
            "start": 1745.523,
            "end": 1764.312,
            "transcript": "Waniwa-llu ukut akiliutekait. Anagkengelriim ingna gift certificate-aaq pikarkauluku, tunglia-wa kakivik, una-wa aqutellria kavirlimek wani uumek puqlassutmek piarkauluni."
        },
        "284": {
            "start": 1764.749,
            "end": 1779.255,
            "transcript": "Apallugpagciqukut wall'u qukaqan man'a pillerput call-in-aarciqukut qanercuutetgun piarkauluta, apallugpagarkauluta-llu nangnermi."
        },
        "285": {
            "start": 1779.255,
            "end": 1793.622,
            "transcript": "Cali-llu nangnermek wani apqangssikumta akingutkaci paqnanarqeciqluteng."
        },
        "286": {
            "start": 1793.622,
            "end": 1808.404,
            "transcript": "Yaa, tua-llu waniwa Nunuq'aq uani wani nampanek tegutellermeggni ciuqlikacagauluni pillrulliniami waniw' ciumek cucukliqatarluni apyutmek."
        },
        "287": {
            "start": 1808.404,
            "end": 1809.578,
            "transcript": "Tegganret one."
        },
        "288": {
            "start": 1809.578,
            "end": 1816.002,
            "transcript": "Tegganret number one, nallunarqengkacagaat."
        },
        "289": {
            "start": 1816.002,
            "end": 1821.735,
            "transcript": "Scammon Bay-rmiut Yugcetun camiunguat?"
        },
        "290": {
            "start": 1821.735,
            "end": 1829.932,
            "transcript": "Scammon Bay-rmiut Yugcetun camiunguat?"
        },
        "291": {
            "start": 1829.932,
            "end": 1830.715,
            "transcript": "Naamell'."
        },
        "292": {
            "start": 1830.715,
            "end": 1833.386,
            "transcript": "Time-an nangqertuq. Tua-ll' Tanuk'aq."
        },
        "293": {
            "start": 1833.386,
            "end": 1837.231,
            "transcript": "Tua-ll' Scammon Bay-rmiut Yugtun camiunguat?"
        },
        "294": {
            "start": 1837.231,
            "end": 1838.359,
            "transcript": "Marayaarmiu?"
        },
        "295": {
            "start": 1838.359,
            "end": 1845.96,
            "transcript": "Marayaarmiu assirtuq, 30 points unangluni."
        },
        "296": {
            "start": 1845.96,
            "end": 1849.964,
            "transcript": "Kitek' elpet cucukliqatartuten."
        },
        "297": {
            "start": 1849.964,
            "end": 1851.529,
            "transcript": "Taqneret six."
        },
        "298": {
            "start": 1851.529,
            "end": 1858.091,
            "transcript": "Taqneret six, nallunaillruuralriit tegganermi."
        },
        "299": {
            "start": 1858.091,
            "end": 1868.59,
            "transcript": "Una wani estimate question-aarulliniuq, tamarpeci igaulluku nallarcetassiarluku kitunritengnaqluku piniartuci."
        },
        "300": {
            "start": 1868.59,
            "end": 1870.202,
            "transcript": "Waniw' apyun."
        },
        "301": {
            "start": 1870.202,
            "end": 1875.291,
            "transcript": "Mat'um nalliini paluqtaat naanret qavciugat?"
        },
        "302": {
            "start": 1875.291,
            "end": 1882.267,
            "transcript": "Mat'um nalliini paluqtaat naanret qavciugat? Kitak' igaulluku."
        },
        "303": {
            "start": 1891.822,
            "end": 1898.016,
            "transcript": "Qaqiutuci-qaa? Kitak' kalikaci nasvilluki. Wani? Yaa."
        },
        "304": {
            "start": 1898.016,
            "end": 1900.986,
            "transcript": "Yaa, nasvillua kalikaq."
        },
        "305": {
            "start": 1900.986,
            "end": 1907.571,
            "transcript": "Nunuq'aq qulnek pilliniuq, Tanuk'aq-llu qulngunrita'arnek, Al'aq-llu akimiaq."
        },
        "306": {
            "start": 1907.571,
            "end": 1912.982,
            "transcript": "waniwa-llu una kiutii 20, yuinarnek."
        },
        "307": {
            "start": 1912.982,
            "end": 1917.495,
            "transcript": "Al'aq wani 20 points unanguq."
        },
        "308": {
            "start": 1920.235,
            "end": 1924.54,
            "transcript": "Kitak' apyutmek wani cali cucuklirluten. Elpet piqatartuten."
        },
        "309": {
            "start": 1924.54,
            "end": 1926.451,
            "transcript": "Taqneret number one."
        },
        "310": {
            "start": 1926.451,
            "end": 1932.093,
            "transcript": "Taqneret number one. Ukut 20 points taqneret pilartut."
        },
        "311": {
            "start": 1932.093,
            "end": 1941.533,
            "transcript": "Qulirani Tulukaruller camek nulirtullrua?"
        },
        "312": {
            "start": 1941.533,
            "end": 1942.73,
            "transcript": "Qanganarmek?"
        },
        "313": {
            "start": 1942.73,
            "end": 1950.881,
            "transcript": "Yaa, assirtuq. Qanganaq assirtuq. 20 points unanguq call'."
        },
        "314": {
            "start": 1950.881,
            "end": 1953.736,
            "transcript": "Kitak' cali Al'aq cucukliqatartuten."
        },
        "315": {
            "start": 1953.736,
            "end": 1957.604,
            "transcript": "Taqneret manruk, number two."
        },
        "316": {
            "start": 1957.604,
            "end": 1963.728,
            "transcript": "Taqneret aipaa. Waniwa apyun."
        },
        "317": {
            "start": 1963.728,
            "end": 1967.412,
            "transcript": "Kinertaat maklaaret kemgit caugat?"
        },
        "318": {
            "start": 1967.412,
            "end": 1968.425,
            "transcript": "Kinengyiit?"
        },
        "319": {
            "start": 1968.425,
            "end": 1973.951,
            "transcript": "Yaa, assirtuq call'. 20 points tua-i unanguq."
        },
        "320": {
            "start": 1973.951,
            "end": 1977.175,
            "transcript": "Cali cucukliqatartuten."
        },
        "321": {
            "start": 1977.175,
            "end": 1978.948,
            "transcript": "Taqneret number three."
        },
        "322": {
            "start": 1978.948,
            "end": 1983.53,
            "transcript": "Taqneret number three."
        },
        "323": {
            "start": 1983.53,
            "end": 1987.96,
            "transcript": "Nani Tulukaruk nunangqellrua?"
        },
        "324": {
            "start": 1987.96,
            "end": 1989.171,
            "transcript": "Ingrini?"
        },
        "325": {
            "start": 1989.171,
            "end": 1992.693,
            "transcript": "Nuu. Tua-ll' Nunuq'aq."
        },
        "326": {
            "start": 1992.693,
            "end": 2002.96,
            "transcript": "Nani Tulukaruk nunangqellrua?"
        },
        "327": {
            "start": 2002.96,
            "end": 2008.58,
            "transcript": "Qulirami-qaa? Yaa."
        },
        "328": {
            "start": 2008.58,
            "end": 2016.24,
            "transcript": "Time-an nangqertuq. Tua-ll' Tanuk'aq, nani Tulukaruller nunangqellrua?"
        },
        "329": {
            "start": 2016.24,
            "end": 2017.445,
            "transcript": "Nalluaqa."
        },
        "330": {
            "start": 2017.445,
            "end": 2027.507,
            "transcript": "Nalluarci-qaa? Waniwa una kiutii uum, Tulukaruller nunangqellruuq Qaluyaarni."
        },
        "331": {
            "start": 2027.507,
            "end": 2035.519,
            "transcript": "Tua-llu Al'am pillruaku Nunuq'aq cucukliqatarluni."
        },
        "332": {
            "start": 2035.519,
            "end": 2038.282,
            "transcript": "Tegganret six."
        },
        "333": {
            "start": 2038.282,
            "end": 2044.338,
            "transcript": "Tegganret six. Nallunarqengkacagiit. Ayuquciircaaqua-am wiinga."
        },
        "334": {
            "start": 2055.228,
            "end": 2061.261,
            "transcript": "Cug'em miikesaa [?]?"
        },
        "335": {
            "start": 2061.261,
            "end": 2063.92,
            "transcript": "Cuyauterviit [?]?"
        },
        "336": {
            "start": 2063.92,
            "end": 2073.349,
            "transcript": "Yaa, assirtuq. Cunawa-am pillruuq. Yaa, kitak' cali. Cali kitak'."
        },
        "337": {
            "start": 2073.349,
            "end": 2075.306,
            "transcript": "Nunuq'aq cucukliqatartuq. Tegganret two."
        },
        "338": {
            "start": 2075.306,
            "end": 2081.039,
            "transcript": "Number two tegganret."
        },
        "339": {
            "start": 2081.039,
            "end": 2084.907,
            "transcript": "Nallunar', ukut 30 points pilartut."
        },
        "340": {
            "start": 2084.907,
            "end": 2090.525,
            "transcript": "Yuut quliraitni kina yul'illrua?"
        },
        "341": {
            "start": 2090.525,
            "end": 2095.245,
            "transcript": "Yupiit quliraitni kina yul'illrua?"
        },
        "342": {
            "start": 2095.245,
            "end": 2097.58,
            "transcript": "Yugmek."
        },
        "343": {
            "start": 2097.58,
            "end": 2100.587,
            "transcript": "Yul'illrua."
        },
        "344": {
            "start": 2100.587,
            "end": 2108.277,
            "transcript": "Time-an nangqertuq. Tua-ll' Tanuk'aq, Yupiit quliraitni kina yul'illrua?"
        },
        "345": {
            "start": 2108.277,
            "end": 2109.406,
            "transcript": "Nalluaqa."
        },
        "346": {
            "start": 2109.406,
            "end": 2115.139,
            "transcript": "Nalluan-qaa? Tua-ll' Al'aq, Yupiit quliraitni kina yul'illrua?"
        },
        "347": {
            "start": 2115.139,
            "end": 2116.451,
            "transcript": "Tulukaruller?"
        },
        "348": {
            "start": 2116.451,
            "end": 2120.757,
            "transcript": "Yaa, assirtuq. 30 points Al'aq unanguq."
        },
        "349": {
            "start": 2120.757,
            "end": 2125.293,
            "transcript": "Tua-llu Al'aq cucukliqatartuq call'."
        },
        "350": {
            "start": 2125.293,
            "end": 2127.48,
            "transcript": "Tegganret number 10 naspaaqerru."
        },
        "351": {
            "start": 2127.48,
            "end": 2132.845,
            "transcript": "Teganret number 10. Ukut wani 30 points pilartut."
        },
        "352": {
            "start": 2132.845,
            "end": 2144.242,
            "transcript": "Nelson Island-aaq Yugcetun cauga?"
        },
        "353": {
            "start": 2144.242,
            "end": 2146.32,
            "transcript": "Kis'arcaaqaqa. Qaluyaarmiut?"
        },
        "354": {
            "start": 2146.32,
            "end": 2152.393,
            "transcript": "Yaa, assirtuq. Unakaa. Qaluyaaq. 30 points."
        },
        "355": {
            "start": 2152.393,
            "end": 2158.195,
            "transcript": "Tua-llu cali cucukliqatartuten."
        },
        "356": {
            "start": 2158.195,
            "end": 2160.4,
            "transcript": "Taqneret number four."
        },
        "357": {
            "start": 2160.4,
            "end": 2173.944,
            "transcript": "Taqneret number four. Ukut wani 20 points pilartut. Tua-llu waniw' una bonus question-aarullinian nall'areskugu 40 points  unangeciquten."
        },
        "358": {
            "start": 2173.944,
            "end": 2175.44,
            "transcript": "Waniw' apyun."
        },
        "359": {
            "start": 2175.44,
            "end": 2180.437,
            "transcript": "Camek murak taluyiarkarteng pilartatgu"
        },
        "360": {
            "start": 2180.437,
            "end": 2181.611,
            "transcript": "Taperrnat?"
        },
        "361": {
            "start": 2181.611,
            "end": 2189.485,
            "transcript": "Nuu, alartuten. Nunuq'aq, camek murak taluyiarkarteng pilartatgu?"
        },
        "362": {
            "start": 2189.485,
            "end": 2190.66,
            "transcript": "Unarciaq?"
        },
        "363": {
            "start": 2190.66,
            "end": 2202.287,
            "transcript": "Yaa, unarciaq assirtuq. 40 points unakaa Nunuq'am. Kitak' Nunuq'aq cucukliqatartuq."
        },
        "364": {
            "start": 2202.287,
            "end": 2204.244,
            "transcript": "Taqneret 10."
        },
        "365": {
            "start": 2204.244,
            "end": 2214.882,
            "transcript": "Taqneret 10. 20 points ukut pilartut. Ak'a-am una bonus question-aarulliniuq nall'areskuvgu 40 points unangeciquten."
        },
        "366": {
            "start": 2214.882,
            "end": 2219.556,
            "transcript": "Nunapiim qaingani naparrluyagaat caugat?"
        },
        "367": {
            "start": 2219.556,
            "end": 2220.615,
            "transcript": "Cukcukuat?"
        },
        "368": {
            "start": 2220.615,
            "end": 2230.078,
            "transcript": "Yaa, assirtuq. 40 points unanguq. Cali cucukliqatarluni Nunuq'aq."
        },
        "369": {
            "start": 2230.078,
            "end": 2231.621,
            "transcript": "Tegganret seven"
        },
        "370": {
            "start": 2231.621,
            "end": 2246.471,
            "transcript": "Tegganret seven. Aren, tegganret. Alarcaaqelliniunga. Tua-lli [?] nepusngauvaa. Assiryugnarquq. Kitak' waniwa apyun."
        },
        "371": {
            "start": 2253.724,
            "end": 2259.573,
            "transcript": "Napayaarni cukililriani naumatulit atsat caugat?"
        },
        "372": {
            "start": 2259.573,
            "end": 2260.632,
            "transcript": "Tuutaruat?"
        },
        "373": {
            "start": 2260.632,
            "end": 2268.253,
            "transcript": "Yaa, tuutarruat assirtut. 30 points call' unangluten. Kitak' cali cucukliqatartuten."
        },
        "374": {
            "start": 2268.253,
            "end": 2270.141,
            "transcript": "Taqneret five."
        },
        "375": {
            "start": 2270.141,
            "end": 2279.627,
            "transcript": "Taqneret five. Tegusciigacugpaa-ll' ukuni. Kitak'-wa waniwa apyun."
        },
        "376": {
            "start": 2279.627,
            "end": 2285.153,
            "transcript": "Qaluyaarmiut ukatiitni nanvarpakayak cauga?"
        },
        "377": {
            "start": 2285.153,
            "end": 2286.44,
            "transcript": "Taklirrlak?"
        },
        "378": {
            "start": 2286.44,
            "end": 2298.484,
            "transcript": "Nuu, alartuten. Tua-ll' Tanuk'aq, Qaluyaarmiut ukatiitni nanvarpakayak cauga? Nalluan-qaa?"
        },
        "379": {
            "start": 2298.484,
            "end": 2304.632,
            "transcript": "Tua-ll' Al'aq, Qaluyaarmiut ukatiitni nanvarpakayak cauga?"
        },
        "380": {
            "start": 2304.632,
            "end": 2306.543,
            "transcript": "Naamell'. Nanvarpak?"
        },
        "381": {
            "start": 2306.543,
            "end": 2313.519,
            "transcript": "Tamarpeci unakenritarci. Nanvaruk. Nanvaruk."
        },
        "382": {
            "start": 2313.519,
            "end": 2320.519,
            "transcript": "Yaa, tua-llu Tanuk'aq cucukliqatarluni waniwa Nunuq'am au͡gna nall'artellrunrilaku."
        },
        "383": {
            "start": 2320.519,
            "end": 2321.9,
            "transcript": "Ayagyuat one."
        },
        "384": {
            "start": 2321.9,
            "end": 2329.13,
            "transcript": "Tua-llu, ayagyuat 10 points ukut pilartut. Tua-llu waniwa apyun."
        },
        "385": {
            "start": 2329.13,
            "end": 2333.413,
            "transcript": "Kanaqliit enait canek pilartatki?"
        },
        "386": {
            "start": 2333.413,
            "end": 2335.093,
            "transcript": "Ngel'umek?"
        },
        "387": {
            "start": 2335.324,
            "end": 2347.366,
            "transcript": "Nuu, alartuten. Tua-llu Al'aq, kanaqliit enait canek pilartatki?"
        },
        "388": {
            "start": 2347.366,
            "end": 2350.888,
            "transcript": "Caulriat ima?"
        },
        "389": {
            "start": 2350.888,
            "end": 2353.168,
            "transcript": "Naamell'."
        },
        "390": {
            "start": 2353.168,
            "end": 2359.131,
            "transcript": "Tua-llu Nunuq'aq, kanaqliit enait canek pilartatki?"
        },
        "391": {
            "start": 2359.131,
            "end": 2361.71,
            "transcript": "Umyuaqenritaqa-ll' wii."
        },
        "392": {
            "start": 2361.71,
            "end": 2367.835,
            "transcript": "Tamarpeci nalluavciu waniwa kiutii, anlut."
        },
        "393": {
            "start": 2367.835,
            "end": 2370.252,
            "transcript": "Anlut."
        },
        "394": {
            "start": 2370.252,
            "end": 2376.676,
            "transcript": "Tua-llu Tanuk'am unakellrunrilaku Al'aq wani cucukliqatarluni."
        },
        "395": {
            "start": 2376.676,
            "end": 2378.541,
            "transcript": "Taqneret number seven."
        },
        "396": {
            "start": 2378.541,
            "end": 2386.231,
            "transcript": "Taqneret number seven. 20 points. Kitak' waniwa apyun."
        },
        "397": {
            "start": 2386.231,
            "end": 2392.149,
            "transcript": "Imarpiim ceńiini uiluyagaat tungulriit canek pilartatki?"
        },
        "398": {
            "start": 2392.149,
            "end": 2393.392,
            "transcript": "Uiluruyiit."
        },
        "399": {
            "start": 2393.392,
            "end": 2400.599,
            "transcript": "Nuu. Avelngayagaat [?] pamyurpiit."
        },
        "400": {
            "start": 2400.599,
            "end": 2410.269,
            "transcript": "Tua-llu Nunuq'aq, imarpiim ceńiini uiluyagaat tungulriit canek pilartatki?"
        },
        "401": {
            "start": 2410.269,
            "end": 2411.259,
            "transcript": "Uilut."
        },
        "402": {
            "start": 2411.259,
            "end": 2420.653,
            "transcript": "Nuu, ak'a-am alartuten. Tua-llu Tanuk'amun, imarpiim ceńiini uiluyagaat tungulriit canek pilartatki?"
        },
        "403": {
            "start": 2423.738,
            "end": 2430.577,
            "transcript": "Canek ima tanem allragni pilallruut. [?]"
        },
        "404": {
            "start": 2430.577,
            "end": 2437.899,
            "transcript": "Tua-ll' sass'an nangqerrluni. Waniwa kiutii, qapilaat, qapilaat."
        },
        "405": {
            "start": 2437.899,
            "end": 2451.46,
            "transcript": "Tua-llu waniwa ukut unangutait. Una wani Nunuq'aq 140 unangkengangqelliniuq, Tanuk'aq-llu 30, Al'aq-llu 120."
        },
        "406": {
            "start": 2451.46,
            "end": 2465.482,
            "transcript": "Waniwa call-in-aaqatartuci nunarrarnek tau͡gaam pilriit piarkauluteng kiimeng. Una wani kiugarkauluku. Murilkeńiartuci."
        },
        "407": {
            "start": 2465.482,
            "end": 2467.163,
            "transcript": "Call-in-aaq waniwa."
        },
        "408": {
            "start": 2467.163,
            "end": 2483.971,
            "transcript": "Avnerpak angalkulleq kituullrua Avnerpaurpailegmi? Cali ataam apyutkenqiggluku, Avnerpak angalkulleq kituullrua Avnerpaurpailegmi?"
        },
        "409": {
            "start": 2483.971,
            "end": 2496.22,
            "transcript": "Nunarrarnek una wani kiugarkaugarci, qayagaurarkarci-llu number-aaq alairciquq."
        },
        "410": {
            "start": 2496.22,
            "end": 2508.607,
            "transcript": "Number-amek wii cikillrunritaatnga. Oh, waniwa call-in-aaquvci number-aq, 543-3131. Nunarrarnelnguut tau͡gaam call-in-aararkauluteng uumek."
        },
        "411": {
            "start": 2508.607,
            "end": 2513.903,
            "transcript": "Ataam cali question-aaq naaqenqigteqataraqa."
        },
        "412": {
            "start": 2513.903,
            "end": 2519.199,
            "transcript": "Avnerpak angalkulleq kituullrua Avnerpaurpailegmi."
        },
        "413": {
            "start": 2519.199,
            "end": 2522.169,
            "transcript": "Tauna tua-i kiussaakcaarniaraci."
        },
        "414": {
            "start": 2522.169,
            "end": 2530.964,
            "transcript": "Ataam naliat avani cucuklillrua? Ataam piqatartukut."
        },
        "415": {
            "start": 2530.964,
            "end": 2538.332,
            "transcript": "Al'aq umilumek cucuklillruuq. Nunuq'aq piqatartuq."
        },
        "416": {
            "start": 2538.332,
            "end": 2543.213,
            "transcript": "Nunuq'aq cucukliqatartuq. Al'aq-gguq uilumek cucuklillruuq."
        },
        "417": {
            "start": 2543.213,
            "end": 2544.503,
            "transcript": "Tegganret three."
        },
        "418": {
            "start": 2544.503,
            "end": 2549.614,
            "transcript": "Tegganret number three, 30 points. Tua-llu,"
        },
        "419": {
            "start": 2549.614,
            "end": 2559.216,
            "transcript": "Ak'a tamaani anguyiit Yugni, calriik ayagnircetellruagnegu?"
        },
        "420": {
            "start": 2559.216,
            "end": 2564.488,
            "transcript": "Una wani nall'areskuvgu, 60 points unangarkauluten."
        },
        "421": {
            "start": 2564.488,
            "end": 2572.685,
            "transcript": "Ak'a tamaani anguyiit Yugni, Yup'igni, calriik ayagnertellruagnegu?"
        },
        "422": {
            "start": 2572.685,
            "end": 2574.389,
            "transcript": "Iingirutellriik."
        },
        "423": {
            "start": 2574.389,
            "end": 2589.24,
            "transcript": "Iingirutellriik, alartellinuten. Tua-llu Tanuk'aq. Ak'a tamaani anguyiit Yugni, calriik ayagnertellruagnegu?"
        },
        "424": {
            "start": 2589.24,
            "end": 2590.391,
            "transcript": "Aavcaalriik?"
        },
        "425": {
            "start": 2590.391,
            "end": 2605.104,
            "transcript": "Ya, aavcaalriik assirtuq, 60 points unanguten. Kitak' cali cucuklia. Elpet Tanuk'aq cucukliqatartuq nall'arcamiu."
        },
        "426": {
            "start": 2605.104,
            "end": 2606.554,
            "transcript": "Tegganret four."
        },
        "427": {
            "start": 2606.554,
            "end": 2615.166,
            "transcript": "Tegganret number four. Tua-llu, apyun waniwa."
        },
        "428": {
            "start": 2615.166,
            "end": 2621.635,
            "transcript": "Qemit iluatni nunam aciani uitatulit yuut, canek pilartatki?"
        },
        "429": {
            "start": 2621.635,
            "end": 2623.063,
            "transcript": "Ircenrraat?"
        },
        "430": {
            "start": 2623.063,
            "end": 2630.408,
            "transcript": "Ya, assirtuq, 30 points. Ataam cali cucuklirarkauluten Tanuk'aq."
        },
        "431": {
            "start": 2630.408,
            "end": 2632.44,
            "transcript": "Five-aaq, tegganret."
        },
        "432": {
            "start": 2632.44,
            "end": 2645.535,
            "transcript": "Tegganret five. Cali waniwa una igaulluku piarkaulliniaci tamarpeci. Waniwa una apyun."
        },
        "433": {
            "start": 2645.535,
            "end": 2656.44,
            "transcript": "Cauga yuinaat akimairuluteng? Yuinaat akimairuluteng?"
        },
        "434": {
            "start": 2656.44,
            "end": 2659.166,
            "transcript": "Tua-i apyuci."
        },
        "435": {
            "start": 2667.432,
            "end": 2677.701,
            "transcript": "Tua-i-ll' iqukliarrluni. Tua-llu nasvillua piarkauguci. Nunuq'aq 300, Tanuk'aq 300."
        },
        "436": {
            "start": 2677.701,
            "end": 2682.628,
            "transcript": "Alartellruunga wii yuinamek. 20-yukluku. Canrituq."
        },
        "437": {
            "start": 2682.628,
            "end": 2694.324,
            "transcript": "Al'aq-ll' alartelliniluni. Tua-llu Nunuq'ankuk Tanuk'aq-llu tamarmek 30 points unanglutek nall'arcamegnegu."
        },
        "438": {
            "start": 2694.324,
            "end": 2703.44,
            "transcript": "Nalirtek cucukellruagnegu au͡gna. Tanuk'am? Tanuk'aq call' ayakatalliniluni."
        },
        "439": {
            "start": 2707.356,
            "end": 2709.36,
            "transcript": "Ayagyuat six."
        },
        "440": {
            "start": 2709.36,
            "end": 2720.688,
            "transcript": "Ayagyuat six. Nallunaitessiyaalaata taukut cucuksuitelaryugnarqaten. 10 points unangeciquten nall'areskuvgu."
        },
        "441": {
            "start": 2720.688,
            "end": 2725.592,
            "transcript": "Quagcit kenirat canek pilartatki?"
        },
        "442": {
            "start": 2725.592,
            "end": 2729.506,
            "transcript": "Quagcit kenirat canek pilartatki?"
        },
        "443": {
            "start": 2729.506,
            "end": 2731.44,
            "transcript": "Quagciliuranek?"
        },
        "444": {
            "start": 2731.44,
            "end": 2736.413,
            "transcript": "Nuu. Tua-llu Al'aq, quagcit kenirat canek pilartatki?"
        },
        "445": {
            "start": 2736.413,
            "end": 2737.15,
            "transcript": "Cuasaat."
        },
        "446": {
            "start": 2737.15,
            "end": 2745.762,
            "transcript": "Cuasaat assirtut. Ten points Al'aq. Tua-llu Al'aq cucukliqatarluni."
        },
        "447": {
            "start": 2745.762,
            "end": 2747.258,
            "transcript": "Taqneret eleven."
        },
        "448": {
            "start": 2747.258,
            "end": 2754.718,
            "transcript": "Taqneret eleven. Tua-llu waniwa apyun."
        },
        "449": {
            "start": 2754.718,
            "end": 2758.909,
            "transcript": "Nuna pugtalria camek pilartatgu?"
        },
        "450": {
            "start": 2758.909,
            "end": 2763.79,
            "transcript": "Nuna pugtalria mermi camek pilartatgu?"
        },
        "451": {
            "start": 2763.79,
            "end": 2764.757,
            "transcript": "Pugtalria."
        },
        "452": {
            "start": 2764.757,
            "end": 2777.72,
            "transcript": "Nuu. Tua-llu nall'artenritan. Nunuq'amun nugtarrluni. Nuna pugtalria mermi camek pilartatgu?"
        },
        "453": {
            "start": 2777.72,
            "end": 2778.641,
            "transcript": "Puglegneq."
        },
        "454": {
            "start": 2778.641,
            "end": 2787.574,
            "transcript": "Puglegneq assirtuq. Ten points, 20 points unangelliniuten. Kitak' cali cucuklirluten."
        },
        "455": {
            "start": 2787.574,
            "end": 2788.726,
            "transcript": "Tegganret eleven."
        },
        "456": {
            "start": 2788.726,
            "end": 2790.959,
            "transcript": "Tegganret eleven."
        },
        "457": {
            "start": 2794.159,
            "end": 2797.429,
            "transcript": "Waniwa apyun."
        },
        "458": {
            "start": 2797.429,
            "end": 2807.951,
            "transcript": "Napat qikmiruarpaulriit canek pilartatki aruvakuratukait?"
        },
        "459": {
            "start": 2807.951,
            "end": 2809.724,
            "transcript": "Naamell'."
        },
        "460": {
            "start": 2809.724,
            "end": 2817.622,
            "transcript": "Nalluaten-qaa? Kitak' Tanuk'aq, napat qikmiruarpaulriit canek pilartatki aruvakuratukait?"
        },
        "461": {
            "start": 2817.622,
            "end": 2818.612,
            "transcript": "Naucit."
        },
        "462": {
            "start": 2818.612,
            "end": 2830.515,
            "transcript": "Naucit assirtut. Thirty points unanguten. Cali kitak' cucuklirarkauluten, Tanuk'."
        },
        "463": {
            "start": 2830.515,
            "end": 2832.081,
            "transcript": "Tegganret eight."
        },
        "464": {
            "start": 2832.081,
            "end": 2854.898,
            "transcript": "Tegganret eight, twenty points. Aren, thirty points. Alarqaqu'urtua wiinga wani piurayuilama. Kitak' waniwa call' bonus question-aarulliniluni unakekuvgu 60 points unangarkauluten."
        },
        "465": {
            "start": 2854.898,
            "end": 2859.964,
            "transcript": "Tukniniaqamegteki neqet tepait canilartatki?"
        },
        "466": {
            "start": 2859.964,
            "end": 2866.388,
            "transcript": "Tukniniaqamegteki neqet tepait canilartatki?"
        },
        "467": {
            "start": 2866.388,
            "end": 2867.516,
            "transcript": "Qanerlua?"
        },
        "468": {
            "start": 2867.516,
            "end": 2873.594,
            "transcript": "Yaa. Tukniniluku neqem tepii caniciqsiu?"
        },
        "469": {
            "start": 2873.594,
            "end": 2875.44,
            "transcript": "Anagcenani?"
        },
        "470": {
            "start": 2875.44,
            "end": 2888.44,
            "transcript": "Nuu, alarartuten. Al'aq, unakekuvgu un' 60 points unangeciquten. Tukniniaqamegteki neqet tepait canilartatki?"
        },
        "471": {
            "start": 2888.44,
            "end": 2895.1,
            "transcript": "Angli-ll' arumavaa."
        },
        "472": {
            "start": 2895.1,
            "end": 2906.336,
            "transcript": "Tua-llu Nunuq'aq, tukniniaqamegteki neqet tepait canilartatki?"
        },
        "473": {
            "start": 2906.336,
            "end": 2907.579,
            "transcript": "Naamell'."
        },
        "474": {
            "start": 2907.579,
            "end": 2913.496,
            "transcript": "Nalluan-qaa? Waniwa una kiutii, camirnaqniluki."
        },
        "475": {
            "start": 2913.496,
            "end": 2918.631,
            "transcript": "Tua-llu call-in-aaq cali ataam naaqenqigtesqelliniat."
        },
        "476": {
            "start": 2918.631,
            "end": 2929.107,
            "transcript": "Waniwa naaqenqigteqataraqa. Avnerpak-gguq angalkulleq ak'a tamaani kituullrua Avnerpaurpailegmi?"
        },
        "477": {
            "start": 2929.107,
            "end": 2942.346,
            "transcript": "Ataam cali naaqenqiggluku. Avnerpak angalkulleq kituullrua Avnerpaurpailegmi? Number-aaq-llu call-ararkarci, 543-3131."
        },
        "478": {
            "start": 2944.395,
            "end": 2951.073,
            "transcript": "Tua-llu naliata au͡gna pim [?] pilqatgu? Nalirpeci? Tanuk'am."
        },
        "479": {
            "start": 2951.073,
            "end": 2953.859,
            "transcript": "Nunuq'aq-qaa cucukliqatartuq?"
        },
        "480": {
            "start": 2953.859,
            "end": 2956.069,
            "transcript": "Wii-q' piqatartua?"
        },
        "481": {
            "start": 2956.069,
            "end": 2957.704,
            "transcript": "Al'aq piqataryukluku."
        },
        "482": {
            "start": 2962.976,
            "end": 2966.476,
            "transcript": "Oh, kitak-wa Nunuq'aq cucukliqatarviuguq [?]."
        },
        "483": {
            "start": 2966.476,
            "end": 2967.811,
            "transcript": "Taqneret eight."
        },
        "484": {
            "start": 2967.811,
            "end": 2970.39,
            "transcript": "Taqneret eight."
        },
        "485": {
            "start": 2971.887,
            "end": 2978.173,
            "transcript": "Tua-llu waniwa apyun, Mamterarmiut Kass'atun camiunguat?"
        },
        "486": {
            "start": 2978.173,
            "end": 2979.393,
            "transcript": "Goodnews."
        },
        "487": {
            "start": 2979.393,
            "end": 2985.725,
            "transcript": "Goodnews-aq assirtuq. 20 points unanguten."
        },
        "488": {
            "start": 2985.725,
            "end": 2990.33,
            "transcript": "Tua-llu waniwa apallugpagnarilliniluni."
        },
        "489": {
            "start": 2990.33,
            "end": 3002.487,
            "transcript": "Apallugpakatartukut. Apallugpagpailemta wani Nunuq'aq 210-aaruuq, Tanuk'aq-llu 210-aaruluni, Al'aq-llu 130."
        },
        "490": {
            "start": 3002.487,
            "end": 3007.598,
            "transcript": "Ukuk wani aipaquralalliamek ayuquralliniuk."
        },
        "491": {
            "start": 3007.598,
            "end": 3019.456,
            "transcript": "Kitak-wa iliinek bet-ararkauguci tau͡gaam ciptevkenaku. Nangeng'erpeciu ciptelluku piyaqunaci."
        },
        "492": {
            "start": 3019.456,
            "end": 3024.44,
            "transcript": "Bet-arraarluci tau͡gaam apallugpagmek apciiqamci."
        },
        "493": {
            "start": 3024.44,
            "end": 3031.267,
            "transcript": "Kalikarrarmun igaulluku qavcitun elliqallerkarci."
        },
        "494": {
            "start": 3035.734,
            "end": 3046.026,
            "transcript": "Tua-llu-qaa unakarci? Bet-artuci ak'a. Kitak' number-aaci tangercetqerciu scorekeeper-aamteńun pivkarniaranka."
        },
        "495": {
            "start": 3046.026,
            "end": 3052.749,
            "transcript": "Nunuq'aq 50 points, Tanuk'aq-llu 35, Al'aq-llu 60."
        },
        "496": {
            "start": 3052.749,
            "end": 3057.4,
            "transcript": "Kitak' waniwa una wani apallugpak."
        },
        "497": {
            "start": 3057.4,
            "end": 3065.298,
            "transcript": "Igaulluku answer-aarci igaulluku qanerpek'naci kalikamun piarkaugaci. Waniw' apyun."
        },
        "498": {
            "start": 3065.298,
            "end": 3071.215,
            "transcript": "Ungungssiaraat naliit nel'ipiayaarluteng pituat?"
        },
        "499": {
            "start": 3071.215,
            "end": 3080.563,
            "transcript": "Ataam cali apyun naaqenqiggluku. Ungungssiaraat naliit nel'ipiayaarluteng pituat?"
        },
        "500": {
            "start": 3080.563,
            "end": 3087.54,
            "transcript": "Igaulluku answer-aarci piniartuci, kiuteci."
        },
        "501": {
            "start": 3104.44,
            "end": 3117.011,
            "transcript": "Tua-llu waniwa time-arci nangqertuq. Kiuteci kitak' tangercetqerciki. Tua-llu..."
        },
        "502": {
            "start": 3122.33,
            "end": 3131.724,
            "transcript": "Nunuq'aq wani pilliniuq kauturyaraat, Tanuk'aq-llu beaver, Al'aq-llu avelngaat."
        },
        "503": {
            "start": 3131.724,
            "end": 3145.44,
            "transcript": "Waniwa kiutii aipaagnek pingqerquvci paluqtaat wall'u kanaqliit nepiayalirluteng [?] pitulriit. Tua-llu Tanuk'aq..."
        },
        "504": {
            "start": 3145.44,
            "end": 3166.261,
            "transcript": "Tanuk'am nall'arcamiu ilangluni score-aa, 35 points ilangluni. Nunuq'am-llu 50 points ilangarrluni. Al'am-llu cali 60 points ilangarrluni."
        },
        "505": {
            "start": 3166.261,
            "end": 3174.32,
            "transcript": "Tua-llu score-ait waniwa Al'am pii iitugnginanraki, Nunuq'aq iggluni 160-urrluni."
        },
        "506": {
            "start": 3174.32,
            "end": 3184.013,
            "transcript": "Una-llu Tanuk'aq may'uqerrluni anagkengerkaurrluni 245-aaruqerrluni."
        },
        "507": {
            "start": 3184.013,
            "end": 3191.911,
            "transcript": "Al'aq-llu aqutetmurrluni 70 unangluni."
        },
        "508": {
            "start": 3191.911,
            "end": 3201.028,
            "transcript": "Tua-llu waniw' Tanuk'aq ciuqliuluni, Nunuq'aq tungliuluni, Al'aq-llu pingayuk-llu [?]. Quyanaqvaa-lli tailuci Apqangssiyarturluci."
        },
        "509": {
            "start": 3205.38,
            "end": 3216.708,
            "transcript": "Call-in-aaq-gguq kia unakellrunritaa ava-i. Una wani, Avnerpak angalkulleq ak'a tamaani yuulleq..."
        },
        "510": {
            "start": 3216.708,
            "end": 3219.886,
            "transcript": "Nancia? Oh, yaani-qaa?"
        },
        "511": {
            "start": 3219.886,
            "end": 3229.418,
            "transcript": "Angalkulleq una Avnerpaurpailegmi-gguq Ay'aqulluullruuq. Kia-gguq unakenritaa."
        },
        "512": {
            "start": 3229.418,
            "end": 3249.058,
            "transcript": "Waniwa-llu ukut prize-at. First prize-aq gift certificate Native Store-amek Video Tape Club-anun. Una-llu second prize-arkaq kakivignek, una-llu pingayuat puqlassuutmek."
        },
        "513": {
            "start": 3249.058,
            "end": 3251.44,
            "transcript": "Tua-i quyana tailuci!"
        },
        "514": {
            "start": 3298.377,
            "end": 3306.44,
            "transcript": "Apqangssiit ikayuutiin ilii kingunengqertuq Anika store 1948-aanirnek Mamterillrem avatiinlluni."
        },
        "515": {
            "start": 3309.797,
            "end": 3319.44,
            "transcript": "Man'a tangvagarkarci piyunarivkaumauq, Kwethluk Native Store, Kuigglugmiut kipusviat 1949-aarminirnek."
        },
        "516": {
            "start": 3330.473,
            "end": 3340.143,
            "transcript": "Apqangssinariuq maani ciuqlikacagauluni Yugtun apyutnek nallunricetassiarluten."
        },
        "517": {
            "start": 3340.143,
            "end": 3344.426,
            "transcript": "Kitak' waniwa Kakianeq."
        },
        "518": {
            "start": 3348.248,
            "end": 3354.442,
            "transcript": "Waqaa, Apqangssiit tangvakatallerpeni ciunuiramci."
        },
        "519": {
            "start": 3354.442,
            "end": 3364.204,
            "transcript": "Apyutet kiutait-llu upingaut, upcimaut wani KCC-mi Yugtun Calivigmi."
        },
        "520": {
            "start": 3364.204,
            "end": 3376.592,
            "transcript": "Ukut waniwa pingayun anagtassiigutqatartut. Ayagnirpailemta number-aanek tegulluteng uani pillruut."
        },
        "521": {
            "start": 3376.592,
            "end": 3383.084,
            "transcript": "Tua-i-ll' ciuqliuqatarluni waniwa Nanugaq. Nanugaq, camiungusit?"
        },
        "522": {
            "start": 3383.084,
            "end": 3386.308,
            "transcript": "Kangirnaq."
        },
        "523": {
            "start": 3386.308,
            "end": 3389.232,
            "transcript": "Caliluten-llu-qaa maani?"
        },
        "524": {
            "start": 3389.232,
            "end": 3390.153,
            "transcript": "Yes."
        },
        "525": {
            "start": 3390.153,
            "end": 3392.248,
            "transcript": "Nani calisit?"
        },
        "526": {
            "start": 3392.248,
            "end": 3393.63,
            "transcript": "Kegguciurvigmi."
        },
        "527": {
            "start": 3393.63,
            "end": 3402.725,
            "transcript": "Kegguciurvigmi hospital-aami pamani. Qangvarnek wani? Qavciurtat allrakut calillren?"
        },
        "528": {
            "start": 3402.725,
            "end": 3403.692,
            "transcript": "Three years."
        },
        "529": {
            "start": 3403.692,
            "end": 3412.372,
            "transcript": "Three years? Yaa, tunglait-wa Taarr'aq. Naken kingunengqercit?"
        },
        "530": {
            "start": 3412.372,
            "end": 3413.293,
            "transcript": "Qipnermek."
        },
        "531": {
            "start": 3413.293,
            "end": 3416.033,
            "transcript": "Qipnermek? Cali maani caliuten elpet?"
        },
        "532": {
            "start": 3416.033,
            "end": 3423.723,
            "transcript": "Nuu, KCC-rtua, im'umi-ll' Mikelnguut Elitnaurvaitni teacher aide-aulua in Yup'ik."
        },
        "533": {
            "start": 3423.723,
            "end": 3427.706,
            "transcript": "Nutaan-qaa maa-i KCC-rtuten?"
        },
        "534": {
            "start": 3427.706,
            "end": 3431.505,
            "transcript": "Nuu, second year, aren, fourth semester-aaqaqa."
        },
        "535": {
            "start": 3431.505,
            "end": 3439.44,
            "transcript": "Yaa. Ii-i, pingayauk-wa Kaligtuq. Cali Kaligtuq, camiunguluten?"
        },
        "536": {
            "start": 3439.449,
            "end": 3440.899,
            "transcript": "Makumiunguunga."
        },
        "537": {
            "start": 3440.899,
            "end": 3446.932,
            "transcript": "Qangvarnek makumiunguluten?"
        },
        "538": {
            "start": 3446.932,
            "end": 3449.672,
            "transcript": "Naamell'. Ak'aurtuq."
        },
        "539": {
            "start": 3449.672,
            "end": 3460.447,
            "transcript": "Yaa, ii-i waniw' ukut wani pingayun anagtassiigutqatartut. Waniku taqniaraqumta apallugpagciqukut."
        },
        "540": {
            "start": 3460.447,
            "end": 3484.462,
            "transcript": "Kankut-llu kana-i akingutkait wani ciuqliq kat'umek kenurramek wani unangeciquq. Tungliat-llu wani kat'umek manigcissuutmek iron-aamek. Pingayuat-llu third place-aq mingugmek king'umek unangarkauluni."
        },
        "541": {
            "start": 3484.462,
            "end": 3497.609,
            "transcript": "Kana-i kankut naken kingunqerruciitanka. Kwethluk Native Store-am-gguq kingunqertut kankut cikiutekait ukut wani."
        },
        "542": {
            "start": 3497.609,
            "end": 3506.059,
            "transcript": "Ukut waniwa apyutet ayagyuat nallunaitut, 10 points piluteng."
        },
        "543": {
            "start": 3506.059,
            "end": 3513.358,
            "transcript": "Tungliit-llu taqneret, 20 points, nallunarqenruurluteng"
        },
        "544": {
            "start": 3513.358,
            "end": 3520.726,
            "transcript": "Ukut-llu tegganret nallunarqenruluteng ukuni wani, 30 points piluteng."
        },
        "545": {
            "start": 3520.726,
            "end": 3527.933,
            "transcript": "Tayima ayainanemteńi bonus question-aanun tekitelarciqukut wall'u-qaa estimate question-aanun."
        },
        "546": {
            "start": 3527.933,
            "end": 3535.715,
            "transcript": "Tamakunrilnguut wani 10 seconds time-angqerciqut, 10 seconds wani cikiumaluci kiullerkarpecenek."
        },
        "547": {
            "start": 3535.715,
            "end": 3550.52,
            "transcript": "Tua-i-llu bonus question-aaq wani, 20, 15 seconds. Yaa, bonus-aaq tuaten taktalriamek wani time-arluni kiullerkarci."
        },
        "548": {
            "start": 3550.52,
            "end": 3563.598,
            "transcript": "Tua-llu waniwa apallugpakumta taqniaraqumta sass'angqerciquci 30 seconds wani kiuyuumaarkauluku wani within that time."
        },
        "549": {
            "start": 3563.598,
            "end": 3573.982,
            "transcript": "Ii-i, kitek' waniw' ayagnirluta wani."
        },
        "550": {
            "start": 3573.982,
            "end": 3582.386,
            "transcript": "Ii-i, kitak'-wa Nanugam ayagniuteqataraakut. Piciatun-wa pick-aryugngaluku. Yaa, ukut iliitnek wani pick-arluten."
        },
        "551": {
            "start": 3582.386,
            "end": 3590.376,
            "transcript": "Ten. Naliitnek? Ayagyuan, tegganret? Ayagyuat."
        },
        "552": {
            "start": 3590.376,
            "end": 3604.881,
            "transcript": "Estimate question-aaruuq una wani. Estimate question-aaraameng tamermeng wani igarcuutkun kalikamun igaulluku qanerpek'naci wani igauciiqerci answer-aarci."
        },
        "553": {
            "start": 3604.881,
            "end": 3609.808,
            "transcript": "Time-angqerciqluci-llu 10 seconds. Waniw' apyun."
        },
        "554": {
            "start": 3609.808,
            "end": 3618.443,
            "transcript": "Qavciugat ayuqenrilnguut yaqulget maani avatemteńi uksurpak uitatulit?"
        },
        "555": {
            "start": 3618.443,
            "end": 3629.978,
            "transcript": "Waniwa, qavciugat ayuqenrilnguut yaqulget maani avatemteńi uksurpak uitatulit?"
        },
        "556": {
            "start": 3629.978,
            "end": 3632.304,
            "transcript": "Estimate question-aaruluni."
        },
        "557": {
            "start": 3637.737,
            "end": 3646.556,
            "transcript": "Sass'aq. Kitak' nalugluki wani kiuteci."
        },
        "558": {
            "start": 3646.556,
            "end": 3652.266,
            "transcript": "Nanugaq seven, Taarr'aq one, Kaligtuq five."
        },
        "559": {
            "start": 3652.266,
            "end": 3656.042,
            "transcript": "Waniwa-llu kiutii 13."
        },
        "560": {
            "start": 3656.042,
            "end": 3664.745,
            "transcript": "Nanugaam wani mallenruamiu acitmun point-angluni, 10 points unanguq Nanugaq."
        },
        "561": {
            "start": 3666.472,
            "end": 3671.054,
            "transcript": "Ii-i, kitek' cali cucukeciqatartuten ukut iliitnek, yaa."
        },
        "562": {
            "start": 3673.863,
            "end": 3678.33,
            "transcript": "Six ayagyuat."
        },
        "563": {
            "start": 3681.484,
            "end": 3691.316,
            "transcript": "Bonus question-aaruq una wani, right-aquvgu wani 20 points pingciquten, okay? Waniwa apyun."
        },
        "564": {
            "start": 3691.316,
            "end": 3709.482,
            "transcript": "Kiagmi mikurluteng yuut augitnek nerengnaquratulit caugat?"
        },
        "565": {
            "start": 3709.482,
            "end": 3711.37,
            "transcript": "Egturyat."
        },
        "566": {
            "start": 3711.37,
            "end": 3713.35,
            "transcript": "Egturyat, assirtuq."
        },
        "567": {
            "start": 3716.182,
            "end": 3720.833,
            "transcript": "Kiugaqavci wani qasturikaniicuarluci wani kiugaqluci, okay?"
        },
        "568": {
            "start": 3720.833,
            "end": 3724.609,
            "transcript": "Kitak' cali, yaa."
        },
        "569": {
            "start": 3724.609,
            "end": 3729.951,
            "transcript": "Six taqneret."
        },
        "570": {
            "start": 3729.951,
            "end": 3736.743,
            "transcript": "20 points una pingqertuq. Estimate question-aarulliniuq cali tamarpeci kiuqatararci wani kiuteci."
        },
        "571": {
            "start": 3736.743,
            "end": 3743.352,
            "transcript": "Mallenqurri acitmun wani answer-arci wani tauna win-arciquq. Waniwa."
        },
        "572": {
            "start": 3743.352,
            "end": 3749.775,
            "transcript": "Qavciugat Alaska-m flag-aan agyai?"
        },
        "573": {
            "start": 3749.775,
            "end": 3754.403,
            "transcript": "Qavciugat Alaska-m flag-aan agyai?"
        },
        "574": {
            "start": 3761.219,
            "end": 3771.303,
            "transcript": "Una wani apyun kingunengqertuq Florence Tobeluk Nunapicuarmek. Ii-i, kitak' kiuteci wani nalugluki."
        },
        "575": {
            "start": 3775.471,
            "end": 3781.365,
            "transcript": "Agyai? Yaa, agyai. Agyai wani ak'a time-aq nangellruuq."
        },
        "576": {
            "start": 3781.365,
            "end": 3786.937,
            "transcript": "Ii-i, kitak' Nanugaq wani seven, Taarr'aq seven, Kaligtuq-llu eight."
        },
        "577": {
            "start": 3786.937,
            "end": 3795.44,
            "transcript": "Eight-aaruut wani agyai. Kaligtum unakaa. Ii-i, tua-ll' cucukeciqatartuten ukut iliitnek."
        },
        "578": {
            "start": 3795.44,
            "end": 3798.058,
            "transcript": "Ayagyuat seven."
        },
        "579": {
            "start": 3798.058,
            "end": 3801.949,
            "transcript": "Ayagyuat seven."
        },
        "580": {
            "start": 3801.949,
            "end": 3807.153,
            "transcript": "Bible-aani kina napamek ekualriamek tangellrua?"
        },
        "581": {
            "start": 3807.153,
            "end": 3809.363,
            "transcript": "Moses-aaq. Assirtuq."
        },
        "582": {
            "start": 3809.363,
            "end": 3816.04,
            "transcript": "Una Anna Alexie-mek Naparyarrarmiunek kinguneqertuq. Ii-i, kitak' cali cucukliluten."
        },
        "583": {
            "start": 3816.04,
            "end": 3818.44,
            "transcript": "Cali kinguqlianek eight-aamek."
        },
        "584": {
            "start": 3820.461,
            "end": 3827.346,
            "transcript": "Camek aturluteng calugcilartat?"
        },
        "585": {
            "start": 3827.346,
            "end": 3830.27,
            "transcript": "Camek aturluteng calugcilartat?"
        },
        "586": {
            "start": 3830.27,
            "end": 3832.71,
            "transcript": "Naamell'. Nalluaqa. Nalluan?"
        },
        "587": {
            "start": 3832.71,
            "end": 3837.753,
            "transcript": "Ii-i, kitak' Nanugaq, camek aturluteng calugcilartat?"
        },
        "588": {
            "start": 3837.753,
            "end": 3845.44,
            "transcript": "Wire? Camek? Cavigmek?"
        },
        "589": {
            "start": 3845.44,
            "end": 3849.633,
            "transcript": "Nuu, kitak' Taarr'aq, camek aturluteng calugcilartat?"
        },
        "590": {
            "start": 3849.633,
            "end": 3852.258,
            "transcript": "Calurun?"
        },
        "591": {
            "start": 3852.258,
            "end": 3860.248,
            "transcript": "Assirtuq, 10 points unanguq. Kitak' cucukelciqatartuten?"
        },
        "592": {
            "start": 3860.248,
            "end": 3864.024,
            "transcript": "Ayagyuat one."
        },
        "593": {
            "start": 3864.024,
            "end": 3865.728,
            "transcript": "Waniw' apyun."
        },
        "594": {
            "start": 3865.728,
            "end": 3875.651,
            "transcript": "Quuleciraq uucimalria camek pilartatgu?"
        },
        "595": {
            "start": 3875.651,
            "end": 3882.44,
            "transcript": "Quuleciraq uucimalria camek pilartatgu?"
        },
        "596": {
            "start": 3883.618,
            "end": 3889.788,
            "transcript": "Ii-i, sass'an nangqertuq. Ii-i, kitak' Kaligtuq, quuleciraq uucimalria camek pilartatgu?"
        },
        "597": {
            "start": 3889.788,
            "end": 3891.124,
            "transcript": "Yugtun wall'u-q' Kass'atun?"
        },
        "598": {
            "start": 3891.124,
            "end": 3892.44,
            "transcript": "Yugtun."
        },
        "599": {
            "start": 3892.782,
            "end": 3897.202,
            "transcript": "Naamell'. Nalluaqa. Kass'atun taugaam nallunritaqa. Ii-i, kitak' Nanugaq."
        },
        "600": {
            "start": 3897.202,
            "end": 3901.922,
            "transcript": "Camek pilartatgu quuleciraq uucimalria?"
        },
        "601": {
            "start": 3901.922,
            "end": 3903.44,
            "transcript": "Assaliaq."
        },
        "602": {
            "start": 3903.44,
            "end": 3912.214,
            "transcript": "Nuu, kelipacuggluk. Taumek pituat. Una apyun Anna Alexie-mek Naparyarrarmek kingunengqertuq."
        },
        "603": {
            "start": 3912.214,
            "end": 3919.628,
            "transcript": "Ii-i, kitak' kina ava-i wani pillrua? Kaligtuq cucukelciqatartuq."
        },
        "604": {
            "start": 3924.371,
            "end": 3926.628,
            "transcript": "Kitak' Nanugaq-wa. Uum pillrua."
        },
        "605": {
            "start": 3926.628,
            "end": 3928.44,
            "transcript": "Uum pillrua question-aq."
        },
        "606": {
            "start": 3928.44,
            "end": 3930.197,
            "transcript": "Yaa, Kaligtuq."
        },
        "607": {
            "start": 3930.197,
            "end": 3933.052,
            "transcript": "Ayagyuat nine."
        },
        "608": {
            "start": 3933.052,
            "end": 3936.321,
            "transcript": "Ayagyuat ukut nangqatartut."
        },
        "609": {
            "start": 3936.321,
            "end": 3939.44,
            "transcript": "Cavik qantarpak cauga?"
        },
        "610": {
            "start": 3939.44,
            "end": 3940.765,
            "transcript": "Miiskaaq."
        },
        "611": {
            "start": 3940.765,
            "end": 3945.393,
            "transcript": "Assirtuq, 10 points. Kitak' cali."
        },
        "612": {
            "start": 3945.393,
            "end": 3951.31,
            "transcript": "Two-aamek ayagyuanek."
        },
        "613": {
            "start": 3951.31,
            "end": 3954.258,
            "transcript": "Mattress-aaq Yugtun cauga?"
        },
        "614": {
            "start": 3959.899,
            "end": 3961.648,
            "transcript": "Nalluaqa."
        },
        "615": {
            "start": 3961.648,
            "end": 3967.888,
            "transcript": "Kitak' Nanugaq, mattress-aaq Yugtun cauga?"
        },
        "616": {
            "start": 3974.105,
            "end": 3976.085,
            "transcript": "Naam'."
        },
        "617": {
            "start": 3976.085,
            "end": 3982.555,
            "transcript": "Ii-i, kitak'. Ca? Taarr'aq, Mattress-aaq Yugtun cauga?"
        },
        "618": {
            "start": 3982.555,
            "end": 3985.295,
            "transcript": "Inarrvik? Inarrvii?"
        },
        "619": {
            "start": 3985.295,
            "end": 4000.44,
            "transcript": "Nuu, waniwa pustiilaaq. Taungulliniuq. Assirluku-qaa? Assirluku piyugnarqa. Pustiilaq, yaa, tua-i taungulliniuq una."
        },
        "620": {
            "start": 4000.44,
            "end": 4004.912,
            "transcript": "Anna Alexie-mek Naparyarrarmiumek kingunengqertuq."
        },
        "621": {
            "start": 4004.912,
            "end": 4008.273,
            "transcript": "Nanugaq tua-ll' cucukelciqatartuq."
        },
        "622": {
            "start": 4008.273,
            "end": 4011.911,
            "transcript": "Taqneret one."
        },
        "623": {
            "start": 4013.615,
            "end": 4029.525,
            "transcript": "Bonus question. Assirluku kiukuvgu 40 points pingciquten. Waniwa. Bible-aani kina petmigmun ekellruatgu?"
        },
        "624": {
            "start": 4029.525,
            "end": 4032.657,
            "transcript": "Bible-aani kina petmigmun ekellruatgu?"
        },
        "625": {
            "start": 4032.657,
            "end": 4034.084,
            "transcript": "Daniel?"
        },
        "626": {
            "start": 4034.084,
            "end": 4043.547,
            "transcript": "Nuu, kitak' Taarr'aq, Bible-aani kina petmigmun ekellruatgu?"
        },
        "627": {
            "start": 4043.547,
            "end": 4046.126,
            "transcript": "Cauga petmigmun?"
        },
        "628": {
            "start": 4046.126,
            "end": 4056.165,
            "transcript": "Petmik cauciicugnarqaat. Nalluaqa. Teq'amun, yaa, teq'allermun wani."
        },
        "629": {
            "start": 4056.165,
            "end": 4063.072,
            "transcript": "Bible-aani kina teq'allermun ekellruatgu?"
        },
        "630": {
            "start": 4063.072,
            "end": 4066.273,
            "transcript": "Nalluvakar'. Josh"
        },
        "631": {
            "start": 4066.273,
            "end": 4074.44,
            "transcript": "Joshua? Nuu, ii-i kitek' Kaligtuq. Bible-aani kina petmigmun ekellruatgu?"
        },
        "632": {
            "start": 4074.44,
            "end": 4076.38,
            "transcript": "Nalluaqa."
        },
        "633": {
            "start": 4076.38,
            "end": 4079.696,
            "transcript": "Joseph-aaq."
        },
        "634": {
            "start": 4079.696,
            "end": 4083.979,
            "transcript": "Waniw' Anna Alexie-mek waniw' kingunengqertuq una wani."
        },
        "635": {
            "start": 4083.979,
            "end": 4095.399,
            "transcript": "Nanugaq waniwa 30 points pingellrurtuq. Taarr'aq-llu 10 points. Kaligtuq 40 points."
        },
        "636": {
            "start": 4095.399,
            "end": 4100.004,
            "transcript": "Wani call-in question-aamek piqatartukut."
        },
        "637": {
            "start": 4100.004,
            "end": 4109.467,
            "transcript": "Kinkut tayima kinkunun ikirusngauq call-in question-aaq una wani. Waniw' apyun."
        },
        "638": {
            "start": 4109.467,
            "end": 4119.44,
            "transcript": "Mikelnguum apa'urluan wall'u maurluan angayuqaak cagnek taum mikelnguum pilartakek?"
        },
        "639": {
            "start": 4120.219,
            "end": 4129.913,
            "transcript": "Mikelnguum apa'urluan wall' maurluan angayuqaak cagnek taum mikelnguum pilartakek?"
        },
        "640": {
            "start": 4129.913,
            "end": 4134.886,
            "transcript": "Tua-i waniwa un' apyun call-in question-aaruluni."
        },
        "641": {
            "start": 4134.886,
            "end": 4139.652,
            "transcript": "Ii-i, kitek' ayagturluta wani Taarr'aq cucukelciiqataryugnarquq maa-i."
        },
        "642": {
            "start": 4146.813,
            "end": 4155.516,
            "transcript": "3133-mek wani phone number-aangqeciqelliniuq una wani apyun."
        },
        "643": {
            "start": 4155.516,
            "end": 4158.072,
            "transcript": "Kitak', nutaan Taarr'aq."
        },
        "644": {
            "start": 4158.072,
            "end": 4160.374,
            "transcript": "Taqneret 10."
        },
        "645": {
            "start": 4164.933,
            "end": 4182.018,
            "transcript": "Angyani atulaqiit lumarraq anuqliraqan cukassuutekluku cauga?"
        },
        "646": {
            "start": 4186.6,
            "end": 4193.576,
            "transcript": "Angyani atulaqiit lumarraq anuqliraqan cukassuutekluku cauga?"
        },
        "647": {
            "start": 4193.576,
            "end": 4197.536,
            "transcript": "Cingyaaq? Nalluaqa."
        },
        "648": {
            "start": 4197.536,
            "end": 4199.724,
            "transcript": "Kitak' Kaligtuq."
        },
        "649": {
            "start": 4199.724,
            "end": 4205.44,
            "transcript": "Yugtun-qaa? Yaa. Nalluaqa Yugtun."
        },
        "650": {
            "start": 4205.44,
            "end": 4215.496,
            "transcript": "Ii-i, kitak' Nanugaq, angyani atulaqiit lumarraq anuqliraqan cukassuutekluku cauga?"
        },
        "651": {
            "start": 4219.64,
            "end": 4222.44,
            "transcript": "Nalluaqa."
        },
        "652": {
            "start": 4222.44,
            "end": 4231.567,
            "transcript": "Tengalrautaq. Taunguuq wani, tengalrautauguq kiutii. Anna Alexie-mek cali Naparyarrarnek una kingunengqertuq."
        },
        "653": {
            "start": 4231.567,
            "end": 4237.44,
            "transcript": "Ii-i, kitak' ava-i wani kina. Kaligtuq wani cucukelciiqatartuq maa-i."
        },
        "654": {
            "start": 4237.44,
            "end": 4239.718,
            "transcript": "Ayagyuani three-aamek."
        },
        "655": {
            "start": 4243.033,
            "end": 4250.355,
            "transcript": "Waniwa bonus question-aaruq una wani. Right-aquvgu 20 points pingciquten."
        },
        "656": {
            "start": 4250.355,
            "end": 4256.825,
            "transcript": "Unatni yuarat mikellrat camek pilartatgu?"
        },
        "657": {
            "start": 4256.825,
            "end": 4258.091,
            "transcript": "Iqelqumek?"
        },
        "658": {
            "start": 4258.091,
            "end": 4264.884,
            "transcript": "Assirtuq, 20 points. Ii-i, tua-llu tua-i cali ayagturluten."
        },
        "659": {
            "start": 4264.884,
            "end": 4267.44,
            "transcript": "Four-aamek ayagyuani."
        },
        "660": {
            "start": 4270.041,
            "end": 4275.774,
            "transcript": "Saaniik qallangeqatarqami calarta?"
        },
        "661": {
            "start": 4275.774,
            "end": 4277.202,
            "transcript": "Cumingetuuq."
        },
        "662": {
            "start": 4277.202,
            "end": 4283.44,
            "transcript": "Yaa, assirtuq. Cumingelartuq. Cali 10 points unanguq. Ii-i, cali kitak'."
        },
        "663": {
            "start": 4283.44,
            "end": 4287.517,
            "transcript": "Five-aamek cali ayagyuani."
        },
        "664": {
            "start": 4287.517,
            "end": 4296.865,
            "transcript": "Estimate question. Tamarpeci kiuqatalliniarci una wani, au͡g'utun igaulluku wani kiuteci piniararci."
        },
        "665": {
            "start": 4296.865,
            "end": 4308.308,
            "transcript": "Napaskiarmiut Naparyarrarmiunek qaillun yaaqsigtaat?"
        },
        "666": {
            "start": 4308.308,
            "end": 4313.604,
            "transcript": "Napaskiarmiut Naparyarrarmiunek qaillun yaaqsigtaat?"
        },
        "667": {
            "start": 4325.623,
            "end": 4329.652,
            "transcript": "Ii-i kitak'. Qaill', waten piaqa."
        },
        "668": {
            "start": 4329.652,
            "end": 4333.451,
            "transcript": "Kiuteci wani piluki."
        },
        "669": {
            "start": 4333.451,
            "end": 4338.839,
            "transcript": "Ten miles, Nanugaq. 20 minutes. Angya?"
        },
        "670": {
            "start": 4338.839,
            "end": 4340.52,
            "transcript": "Qaillun? Mile-aitgun."
        },
        "671": {
            "start": 4340.52,
            "end": 4348.901,
            "transcript": "Yaa, mile-aitgun pillruut tau͡gaam ak'a sass'aq... Kaligtuq five miles."
        },
        "672": {
            "start": 4348.901,
            "end": 4355.255,
            "transcript": "Two miles wani yaaqsigtalliniuq Napaskiarmiut Naparyarrarnek wani akunlii."
        },
        "673": {
            "start": 4355.255,
            "end": 4359.975,
            "transcript": "Tamarpeci wani unakenritarci, ciptaci two miles."
        },
        "674": {
            "start": 4359.975,
            "end": 4364.649,
            "transcript": "Ava-i wani apyun una waten."
        },
        "675": {
            "start": 4371.004,
            "end": 4376.208,
            "transcript": "Seven miles-aarugquq au͡gna, tau͡gaam caciitaqa."
        },
        "676": {
            "start": 4376.208,
            "end": 4379.869,
            "transcript": "Waniwa call-in question-aaq waten ayuquq."
        },
        "677": {
            "start": 4379.869,
            "end": 4388.618,
            "transcript": "Mikelnguum apa'urluan wall' maurluan angayuqaak cagnek taum mikelnguum pilartaket?"
        },
        "678": {
            "start": 4388.618,
            "end": 4390.092,
            "transcript": "Amaurak."
        },
        "679": {
            "start": 4390.092,
            "end": 4397.321,
            "transcript": "Tua-i kiutii Mary Gregory maani Mamterillermi unakaa ava-i."
        },
        "680": {
            "start": 4397.321,
            "end": 4407.913,
            "transcript": "Unangutii-wa una wani I.D. Variety-nek gift certificate-aaq waniw' Mary Gregory-mun unangutii au͡g'umun apyutmun."
        },
        "681": {
            "start": 4407.913,
            "end": 4417.44,
            "transcript": "Ii-i, kitak' cali ayagturluci wani kina ava-i wani pillrua. Wiinga. Ii-i."
        },
        "682": {
            "start": 4417.44,
            "end": 4420.185,
            "transcript": "Nanugaq wani piqatartuq."
        },
        "683": {
            "start": 4420.185,
            "end": 4425.803,
            "transcript": "Ayagyuat 11."
        },
        "684": {
            "start": 4425.803,
            "end": 4431.03,
            "transcript": "Alaska-m flag-aa cakucinek color-aangqerta?"
        },
        "685": {
            "start": 4431.03,
            "end": 4432.44,
            "transcript": "Yugcetun?"
        },
        "686": {
            "start": 4432.44,
            "end": 4433.885,
            "transcript": "Kass'atun piyukuvgu."
        },
        "687": {
            "start": 4433.885,
            "end": 4435.427,
            "transcript": "Blue and gold."
        },
        "688": {
            "start": 4435.427,
            "end": 4439.756,
            "transcript": "Yaa, assirtuq. 10 points unanguq."
        },
        "689": {
            "start": 4439.756,
            "end": 4446.848,
            "transcript": "Wani una Florence Tobeluk-mek Nunapicuarmiunek kingunengqertuq. Ii-i, kitak' cali ayagturluten."
        },
        "690": {
            "start": 4446.848,
            "end": 4451.959,
            "transcript": "Ayagyuat 12."
        },
        "691": {
            "start": 4451.959,
            "end": 4456.564,
            "transcript": "Piluguum iluani can'get caugat?"
        },
        "692": {
            "start": 4466.672,
            "end": 4472.152,
            "transcript": "Ii-i, kitak' Taarr'aq, piluguum iluani can'get caugat?"
        },
        "693": {
            "start": 4472.152,
            "end": 4473.648,
            "transcript": "Tuceńat?"
        },
        "694": {
            "start": 4473.648,
            "end": 4478.115,
            "transcript": "Yaa, assirtuq, 10 points unanguq."
        },
        "695": {
            "start": 4478.115,
            "end": 4481.039,
            "transcript": "Ii-i, kitak' cali cucukelciiluten."
        },
        "696": {
            "start": 4481.039,
            "end": 4483.48,
            "transcript": "Tauna ayagyuat 13."
        },
        "697": {
            "start": 4483.48,
            "end": 4488.269,
            "transcript": "Ayagyuat-llu tua-i waniw' nangluteng. Waniw' apyun."
        },
        "698": {
            "start": 4488.269,
            "end": 4490.71,
            "transcript": "North-aq cauga Yugtun?"
        },
        "699": {
            "start": 4490.71,
            "end": 4491.999,
            "transcript": "Ungalaq?"
        },
        "700": {
            "start": 4491.999,
            "end": 4500.44,
            "transcript": "Nuu. Ii-i, kitak' Kaligtuq, north-aq cauga Yugtun?"
        },
        "701": {
            "start": 4500.44,
            "end": 4502.084,
            "transcript": "Kakneq?"
        },
        "702": {
            "start": 4502.084,
            "end": 4508.44,
            "transcript": "Nuu. Ii-i, kitak' Nanugaq, north-aq cauga Yugtun?"
        },
        "703": {
            "start": 4508.899,
            "end": 4510.44,
            "transcript": "Ungalanek?"
        },
        "704": {
            "start": 4510.44,
            "end": 4517.741,
            "transcript": "Nuu, negeqvaq. Una cali Anna Alexie-mek kingunengqertuq Naparyarrarmek."
        },
        "705": {
            "start": 4519.582,
            "end": 4522.44,
            "transcript": "Kaligtuq cucukelciiqatartuq nutaan."
        },
        "706": {
            "start": 4522.44,
            "end": 4527.44,
            "transcript": "Taqneret two."
        },
        "707": {
            "start": 4527.44,
            "end": 4534.387,
            "transcript": "Estimate question. Tamarpeci call' kiuqatararci wani. Waniw' apyun."
        },
        "708": {
            "start": 4534.387,
            "end": 4539.269,
            "transcript": "Cami allrakumi Alaska-q state-aurtellrua?"
        },
        "709": {
            "start": 4539.269,
            "end": 4543.943,
            "transcript": "Cami allrakumi Alaska-q state-aurtellrua?"
        },
        "710": {
            "start": 4551.633,
            "end": 4564.619,
            "transcript": "Year-aq wani kiingan igauciiqerci, year-aa. Yaa. Ii-i, kitak' kiuteci wani maniluki."
        },
        "711": {
            "start": 4564.619,
            "end": 4568.487,
            "transcript": "Nanugaq 1949."
        },
        "712": {
            "start": 4568.487,
            "end": 4570.858,
            "transcript": "Wiinga pinritua."
        },
        "713": {
            "start": 4570.858,
            "end": 4572.056,
            "transcript": "Taarr'aq..."
        },
        "714": {
            "start": 4572.056,
            "end": 4574.082,
            "transcript": "Maniilluku kiingan."
        },
        "715": {
            "start": 4574.082,
            "end": 4580.621,
            "transcript": "Yaa, kitak' camek tayim' piyaaqaa. Kaligtuq-llu 1945."
        },
        "716": {
            "start": 4580.621,
            "end": 4596.44,
            "transcript": "1959-aami wani state-aurtellruuq. Kia, Nanugaam unakaa, 10 points wani, 20 points unanguq. Ii-i, kitak' cali cucukelciiluten."
        },
        "717": {
            "start": 4596.44,
            "end": 4603.922,
            "transcript": "Taqneret three."
        },
        "718": {
            "start": 4603.922,
            "end": 4619.901,
            "transcript": "Missuullret qilagat suukiiruluteng canek pilartatki?"
        },
        "719": {
            "start": 4625.266,
            "end": 4627.545,
            "transcript": "Naam'. Nalluaqa."
        },
        "720": {
            "start": 4627.545,
            "end": 4635.166,
            "transcript": "Ii-i, kitak' Taarr'aq, missuullret qilagat suukiiruluteng canek pilartatki?"
        },
        "721": {
            "start": 4635.166,
            "end": 4636.893,
            "transcript": "Nalluaqa."
        },
        "722": {
            "start": 4636.893,
            "end": 4644.676,
            "transcript": "Kiik' Kaligtuq, missuullret qilagat suukiiruluteng canek pilartatki?"
        },
        "723": {
            "start": 4644.676,
            "end": 4646.218,
            "transcript": "Alliqsagnek?"
        },
        "724": {
            "start": 4646.218,
            "end": 4652.205,
            "transcript": "Assirtuq, 20 points. Kitak' cucukelciiluten."
        },
        "725": {
            "start": 4652.205,
            "end": 4654.277,
            "transcript": "Taqneret four."
        },
        "726": {
            "start": 4657.132,
            "end": 4658.859,
            "transcript": "Waniw' apyun."
        },
        "727": {
            "start": 4658.859,
            "end": 4668.552,
            "transcript": "Napat upnerkami cuyangvailegmeng calartat?"
        },
        "728": {
            "start": 4668.552,
            "end": 4670.44,
            "transcript": "Naam'. Meq'lartut?"
        },
        "729": {
            "start": 4670.44,
            "end": 4680.686,
            "transcript": "Nalluaqa. Kitak' Nanugaq, napat upnerkami cuyangvailegmeng calartat?"
        },
        "730": {
            "start": 4684.808,
            "end": 4691.991,
            "transcript": "Cuyangvailegmeng. Pussy willow-ngtuut. Naam', caugat-wa."
        },
        "731": {
            "start": 4691.991,
            "end": 4698.714,
            "transcript": "Nuu. Kitak' Taarr'aq, napat upnerkami cuyangvailegmeng calartat?"
        },
        "732": {
            "start": 4698.714,
            "end": 4701.385,
            "transcript": "Nallukeka tang-llu wii."
        },
        "733": {
            "start": 4701.385,
            "end": 4707.44,
            "transcript": "Kitak', uqungelartut. Uqungelartut-gguq upnerkami."
        },
        "734": {
            "start": 4707.44,
            "end": 4712.921,
            "transcript": "Una cali Anna Alexie-mek Naparyarrarmek kingunengqertuq."
        },
        "735": {
            "start": 4712.921,
            "end": 4720.058,
            "transcript": "Kina ava-i wani. Kina? Taarr'aq wani cucukelciiqataryugnarquq."
        },
        "736": {
            "start": 4720.058,
            "end": 4727.44,
            "transcript": "Pikaken? Seven, taqneret seven."
        },
        "737": {
            "start": 4727.44,
            "end": 4737.373,
            "transcript": "Muriit kuigem ceńiini uitalriit canek pilartatki?"
        },
        "738": {
            "start": 4737.373,
            "end": 4742.876,
            "transcript": "Nalluvakar'. Nalluaqa."
        },
        "739": {
            "start": 4742.876,
            "end": 4751.372,
            "transcript": "Ii-i, kitak' Kaligtuq, muriit kuigem ceńiini uitalriit canek pilartatki?"
        },
        "740": {
            "start": 4751.372,
            "end": 4753.352,
            "transcript": "Atertanek?"
        },
        "741": {
            "start": 4753.352,
            "end": 4757.335,
            "transcript": "Nuu. kitak' Nanugaq."
        },
        "742": {
            "start": 4757.335,
            "end": 4761.687,
            "transcript": "Muriit kuigem ceńiini uitalriit canek pilartatki?"
        },
        "743": {
            "start": 4768.157,
            "end": 4770.897,
            "transcript": "Nalluaqa."
        },
        "744": {
            "start": 4770.897,
            "end": 4783.307,
            "transcript": "Tep'arneq [?]. Taunguut, tep'arnek. Anna Alexie-mek Naparyarrarmi call' kingunerluni tauna."
        },
        "745": {
            "start": 4783.307,
            "end": 4788.28,
            "transcript": "Ii-i, kitak waniw' apallugpakatartut."
        },
        "746": {
            "start": 4788.28,
            "end": 4798.434,
            "transcript": "Nanugaq 60 points pingellrurtuq. Taarr'aq 20 points. Kaligtuq 20 points."
        },
        "747": {
            "start": 4798.434,
            "end": 4808.934,
            "transcript": "Bet-aqatartuci wani point-arpeci iliitnek ciptevkenaku, tamalkuan-llu bet-auteksugngaluku. Taringavcia-qaa?"
        },
        "748": {
            "start": 4808.934,
            "end": 4810.799,
            "transcript": "Iliinek-qaa point-amek? Ii-i."
        },
        "749": {
            "start": 4810.799,
            "end": 4817.453,
            "transcript": "Point-arpeci wani iliinek bet-aryugngauci tau͡gaam ciptevkenaku."
        },
        "750": {
            "start": 4817.453,
            "end": 4821.367,
            "transcript": "Tua-i-ll'-qaa lose-arluku?"
        },
        "751": {
            "start": 4821.367,
            "end": 4830.393,
            "transcript": "Unakenrilkuvciu wani apyun lose-arciqaci bet-alci. Unakekuvciu-llu ilangutekluku bet-auteci."
        },
        "752": {
            "start": 4830.393,
            "end": 4837.208,
            "transcript": "Cimek wani, (Bet-arluta?) Yaa, bet-aqatartuci. (Wanirpak?) Igaulluku wani bet-alci."
        },
        "753": {
            "start": 4845.589,
            "end": 4854.937,
            "transcript": "Tua-i bet-artuten ak'a. Yaa. Ii-i, kitak' taqkuvci wani, caugat bet-aci?"
        },
        "754": {
            "start": 4854.937,
            "end": 4867.531,
            "transcript": "Nanugaq 10 points bet-artuq. Taarr'aq five points. Kaligtuq-llu 20 points. Waniwa apallugpak."
        },
        "755": {
            "start": 4867.531,
            "end": 4885.974,
            "transcript": "Qanganaat aipaingit kavircetellriit canek pilartatki? Kitak' nutaan."
        },
        "756": {
            "start": 4885.974,
            "end": 4891.28,
            "transcript": "Qanganaat aipaingit kavircetellriit canek pilartatki?"
        },
        "757": {
            "start": 4892.651,
            "end": 4903.266,
            "transcript": "Kass'atun igauteng'erpeciu wani. 30 seconds time-aqerciquci. (Cauga qanganaat? Squirrel.) Waniw' apyun."
        },
        "758": {
            "start": 4903.266,
            "end": 4908.446,
            "transcript": "Qanganaat aipaingit kavircetellriit canek pilartatki?"
        },
        "759": {
            "start": 4913.811,
            "end": 4918.163,
            "transcript": "30 seconds. Kass'atun-ll' igaucukuvciki wani."
        },
        "760": {
            "start": 4935.823,
            "end": 4940.013,
            "transcript": "Kitak' kiuteci wani. Kiik' maniiteqernga. Nalluaqa."
        },
        "761": {
            "start": 4940.013,
            "end": 4956.268,
            "transcript": "Flying squirrel, Nanuga flying squirrel-amek piuq. Taarr'aq mink. Kaligtuq, (Kass'atun.) marmot."
        },
        "762": {
            "start": 4956.268,
            "end": 4970.28,
            "transcript": "Kiutii-wa, flying squirrel-aq-qaa? Yaa, flying squirrel-aulliniuq waniw' kiutii. Nanugam unakluku 10 points ava-i bet-allruuq. Unakaa."
        },
        "763": {
            "start": 4973.836,
            "end": 4978.28,
            "transcript": "Kana-i wani Nanugam unangutii-wa first place."
        },
        "764": {
            "start": 4980.28,
            "end": 4982.28,
            "transcript": "Kina wani?"
        },
        "765": {
            "start": 4989.562,
            "end": 4998.28,
            "transcript": "Nanugaq wani 70 points pingqertuq. Taarr'aq 15. Kaligtuq-llu 20. Kaligtuq anagngaunani."
        },
        "766": {
            "start": 5000.28,
            "end": 5004.28,
            "transcript": "Oh, 80. Yaa, 80-nek wani Kaligtuq pingqertuq."
        },
        "767": {
            "start": 5004.28,
            "end": 5016.777,
            "transcript": "Kana-i kenurramek unangluni first place-aungami. Second place-aq-llu Nanugaq manigcissuutmek unangluni. Mingugmek-llu Taarr'aq. Ava-i unangut cali."
        },
        "768": {
            "start": 5051.959,
            "end": 5061.284,
            "transcript": "Man'a tangvalci piyunarivkaumauq Kwethluk Native Store, Kuigglukmiut kipusviat 1949-aarminirnek."
        },
        "769": {
            "start": 5078.875,
            "end": 5089.881,
            "transcript": "Man'a tangvagarkarci piyunarivkaumauq ukunek Drew's Gillnet Supplies, maani Mamterillermi kuvyanek tuniatuli."
        },
        "770": {
            "start": 5101.209,
            "end": 5110.211,
            "transcript": "Apqangssinariuq maani ciuqlikacagauluni Yugtun apyutnek nallunricetassiarluten."
        },
        "771": {
            "start": 5110.879,
            "end": 5115.28,
            "transcript": "Kitak' waniwa Kakianeq."
        },
        "772": {
            "start": 5118.017,
            "end": 5131.44,
            "transcript": "Waqaa, Apqangssikatallemteńi ciuniuramci apyutet kiutait-llu wani upingaut KCC-mi Yup'igtun Calivigmi."
        },
        "773": {
            "start": 5131.44,
            "end": 5142.837,
            "transcript": "Maa-i atakurpak man'a apqangssillerkarput nangenruuq up'nerkarpak maa-i pellullermi."
        },
        "774": {
            "start": 5142.837,
            "end": 5156.905,
            "transcript": "Tayima atakurpak ukut wani up'nerkaq aquigurallemteńi quyinqurrarnek wani point-alget cucukelciumallruut."
        },
        "775": {
            "start": 5156.905,
            "end": 5165.28,
            "transcript": "Ukut-llu tua-i pingayuuluteng waniw' atakurpak anagtassiigutqatarluteng quyinqurraullret maa-i."
        },
        "776": {
            "start": 5165.28,
            "end": 5172.28,
            "transcript": "Ciuqliq waniwa Inguq'aq. Mamterillermi maani uitalartuten?"
        },
        "777": {
            "start": 5172.28,
            "end": 5173.28,
            "transcript": "Ii-i."
        },
        "778": {
            "start": 5173.28,
            "end": 5176.753,
            "transcript": "Yaa, camek calianqercit?"
        },
        "779": {
            "start": 5176.753,
            "end": 5181.979,
            "transcript": "Wani Alaska Moravian Church-aq ataniumaluku."
        },
        "780": {
            "start": 5181.979,
            "end": 5191.12,
            "transcript": "Ii-i, kinguqlia-wa Uy'uq. Uy'uq, yaa. Uyuq?"
        },
        "781": {
            "start": 5191.12,
            "end": 5198.787,
            "transcript": "Okay, nallunritaqa Uyuq calillgutkelaqa YKHC-mi kanami."
        },
        "782": {
            "start": 5198.787,
            "end": 5201.28,
            "transcript": "Naken kingunengqercit?"
        },
        "783": {
            "start": 5201.28,
            "end": 5203.945,
            "transcript": "Chevak-ami."
        },
        "784": {
            "start": 5203.945,
            "end": 5206.777,
            "transcript": "How long maantellrurcit Mamterillermi?"
        },
        "785": {
            "start": 5206.777,
            "end": 5208.02,
            "transcript": "Sixteen months."
        },
        "786": {
            "start": 5208.02,
            "end": 5213.707,
            "transcript": "Sixteen months, that's year and a half, tuaten pitayarpiarluni."
        },
        "787": {
            "start": 5213.707,
            "end": 5217.806,
            "transcript": "Pingayuak-wa Angall'aq. Naken kingunengqercit, Angall'aq?"
        },
        "788": {
            "start": 5217.806,
            "end": 5218.727,
            "transcript": "Kassiglumek."
        },
        "789": {
            "start": 5218.727,
            "end": 5221.674,
            "transcript": "Kassiglumek, nutaan-ll' unuamek atrarluteng aquiyarluten?"
        },
        "790": {
            "start": 5221.674,
            "end": 5224.28,
            "transcript": "Nuu, maani caliunga, this is my third year."
        },
        "791": {
            "start": 5224.28,
            "end": 5226.555,
            "transcript": "Oh, nani caliluten?"
        },
        "792": {
            "start": 5226.555,
            "end": 5228.996,
            "transcript": "Kilbuck-aami bilingual teacher-aaruunga."
        },
        "793": {
            "start": 5228.996,
            "end": 5236.709,
            "transcript": "Ii-i. Yaa, waniwa ukut wani anagtassiiguciiqut."
        },
        "794": {
            "start": 5236.709,
            "end": 5247.96,
            "transcript": "Kankut tau͡gaam kana-i akingutkait naken kingunengqertut. Drew's Gillnet Supply-anek kingunengqelliniut kana-i."
        },
        "795": {
            "start": 5247.96,
            "end": 5253.74,
            "transcript": "Ciuqliq unangeciquq kuvyamek. Kuvyamek unangeciquq."
        },
        "796": {
            "start": 5253.74,
            "end": 5271.8,
            "transcript": "Kinguqliak-llu un'umek qiuglimek wani color-lek kic'aqun. Wani kit'essuun camek tua-i-am piyullerpeceńek piluku unangeciquq second-aaq."
        },
        "797": {
            "start": 5271.8,
            "end": 5281.54,
            "transcript": "Pingayuat-wa qemirkamek. Qemirkamek wani unangeciquq una-i wani aquinginanemteńi."
        },
        "798": {
            "start": 5281.54,
            "end": 5299.72,
            "transcript": "Tayima waniwa ciungani aquillrukuvciu umyuaqeksailkuvci wani number-aamek tayima ukut tegulluteng aquivailemta pillruut, ciuqliuqatarluni-llu waniwa Inguq'aq."
        },
        "799": {
            "start": 5299.72,
            "end": 5305.04,
            "transcript": "Waten waniwa tungliqutacimegcetun waniw' aqumgaluteng."
        },
        "800": {
            "start": 5305.04,
            "end": 5308.82,
            "transcript": "Aquivailemta ukut wani waniw' apyutet."
        },
        "801": {
            "start": 5308.82,
            "end": 5313.774,
            "transcript": "Ayagyuat 10 points pingqertut nallunaunateng."
        },
        "802": {
            "start": 5313.774,
            "end": 5320.054,
            "transcript": "20 points-llu ukut tungliit taqneret, taqneruluteng."
        },
        "803": {
            "start": 5320.054,
            "end": 5329.401,
            "transcript": "Pingayuat-wa tegganret, 30 points piluteng nallunarqenruluteng ukut wani ukugni."
        },
        "804": {
            "start": 5329.401,
            "end": 5334.774,
            "transcript": "Ukut nallunaqcuarluteng nallunaitenqurrauluteng-llu"
        },
        "805": {
            "start": 5334.774,
            "end": 5350.361,
            "transcript": "Tayim' taqniaraqumta apallugpagciqukut waniku. Cali aquinginanemteńi pinarikan call-in question-aamek piciqukut. Phone number-aaq wani apyunaaqerraarluku [?] tunciqaqa elpecenun."
        },
        "806": {
            "start": 5350.361,
            "end": 5358.881,
            "transcript": "Ii-i, kitak' waniw' ayagnirpailemta ukut wani waten cama-irluki good luck-aarluki tuaten."
        },
        "807": {
            "start": 5358.881,
            "end": 5365.667,
            "transcript": "Ii-i, kitaki. Inguq'am ayagniutqataraakut."
        },
        "808": {
            "start": 5365.667,
            "end": 5369.814,
            "transcript": "Tegganret one."
        },
        "809": {
            "start": 5369.814,
            "end": 5371.961,
            "transcript": "Waniw' apyun."
        },
        "810": {
            "start": 5371.961,
            "end": 5380.667,
            "transcript": "Tuntut wall'u tan'gerlit cur'ut canek pilartatki? Curut."
        },
        "811": {
            "start": 5380.667,
            "end": 5382.28,
            "transcript": "Assirat."
        },
        "812": {
            "start": 5382.28,
            "end": 5390.227,
            "transcript": "Assirtuq, 30 points. Ii-i, tua-i-ll' tua-i cali piluten."
        },
        "813": {
            "start": 5390.227,
            "end": 5392.921,
            "transcript": "Cali tegganret six-aaq piqerru."
        },
        "814": {
            "start": 5392.921,
            "end": 5403.467,
            "transcript": "Ii-i, bonus question-aaruuq una wani. Unakekuvgu double-aarluku point-angciquten 60-nek."
        },
        "815": {
            "start": 5403.467,
            "end": 5409.921,
            "transcript": "Canyagaat maqarcetellriit canek pilartatki?"
        },
        "816": {
            "start": 5409.921,
            "end": 5411.374,
            "transcript": "Usraaraat."
        },
        "817": {
            "start": 5411.374,
            "end": 5418.827,
            "transcript": "Assirtuq, 60 points unanguq. Ii-i, tua-i-ll' ayagturluten."
        },
        "818": {
            "start": 5418.827,
            "end": 5421.747,
            "transcript": "Ten-aaq tegganret."
        },
        "819": {
            "start": 5426.187,
            "end": 5430.841,
            "transcript": "Tutemqat caugat?"
        },
        "820": {
            "start": 5430.841,
            "end": 5432.347,
            "transcript": "Mayurautet."
        },
        "821": {
            "start": 5432.347,
            "end": 5440.387,
            "transcript": "Assirtuq, 30 points. Ii-i, tua-i-ll' cali piqatalliniuq Inguq'aq."
        },
        "822": {
            "start": 5440.387,
            "end": 5445.041,
            "transcript": "Yaa, tuaken ten-aanek taqneret."
        },
        "823": {
            "start": 5445.041,
            "end": 5463.387,
            "transcript": "Taqneret? Yaa. 20 points pingqertuq. Estimate question-aarulliniq una wani. Tamarpeci answer-ara igaulluku piciqerci qanrutkevkenaku. 15 seconds alartenrilkuma time-angqerciquci."
        },
        "824": {
            "start": 5463.387,
            "end": 5466.027,
            "transcript": "Ii-i, tua-ll' waniwa apyun."
        },
        "825": {
            "start": 5466.027,
            "end": 5475.547,
            "transcript": "Cami allrakumi KYUK-q niicugnissuutengqellrua?"
        },
        "826": {
            "start": 5475.547,
            "end": 5481.241,
            "transcript": "Cami allrakumi KYUK-q niicugnissuutengellrua?"
        },
        "827": {
            "start": 5481.241,
            "end": 5486.201,
            "transcript": "Tua-i apyun."
        },
        "828": {
            "start": 5491.041,
            "end": 5497.547,
            "transcript": "Waq' taq'uci tamarpeci? Ii-i, kitak' mayurrluki wani kiuteci."
        },
        "829": {
            "start": 5497.547,
            "end": 5508.641,
            "transcript": "Inguq'aq 1976, Uyuq 1969, Angall'aq-llu 1960. Kiutii-wa 1972."
        },
        "830": {
            "start": 5508.641,
            "end": 5516.134,
            "transcript": "Uyuq mallenruluni. Mallenruami wani unakaa. 20 points pinguq."
        },
        "831": {
            "start": 5516.134,
            "end": 5518.427,
            "transcript": "Ii-i, tua-ll' ayaulluta."
        },
        "832": {
            "start": 5521.174,
            "end": 5525.934,
            "transcript": "Tegganret 11."
        },
        "833": {
            "start": 5525.934,
            "end": 5533.894,
            "transcript": "30 points una pingqertuq. Bonus question-aarulliniq. 60 points unakekuvgu piciqan."
        },
        "834": {
            "start": 5533.894,
            "end": 5547.641,
            "transcript": "Pertaq qaltaq'lallrat ak'a tamaani mertarcuutekaqluku-llu camek pilallruatgu?"
        },
        "835": {
            "start": 5552.147,
            "end": 5553.787,
            "transcript": "Mertarrsuun?"
        },
        "836": {
            "start": 5553.787,
            "end": 5565.547,
            "transcript": "Nuu. Ii-i, tua-ll' Angall'aq piqatartuq, pertaq qaltaq'lallrat ak'a tamaani mertarcuutekaqluku-llu camek pilallruatgu?"
        },
        "837": {
            "start": 5565.547,
            "end": 5566.667,
            "transcript": "Tuqmak?"
        },
        "838": {
            "start": 5566.667,
            "end": 5576.307,
            "transcript": "Assirtuq, tuqmik, 60 points. Ii-i, tua-ll' tua-i Angall'aq piqatartuq."
        },
        "839": {
            "start": 5576.307,
            "end": 5580.214,
            "transcript": "Tegganret two."
        },
        "840": {
            "start": 5580.214,
            "end": 5584.414,
            "transcript": "30 points una pingqertuq."
        },
        "841": {
            "start": 5584.414,
            "end": 5592.121,
            "transcript": "Naparraat quyungqalriit canek pilartatki?"
        },
        "842": {
            "start": 5596.227,
            "end": 5597.641,
            "transcript": "Culugtaat?"
        },
        "843": {
            "start": 5597.641,
            "end": 5603.294,
            "transcript": "Assirtuq, culugtaat, 30 points."
        },
        "844": {
            "start": 5606.054,
            "end": 5607.854,
            "transcript": "Ii-i, tua-llu tua-i."
        },
        "845": {
            "start": 5607.854,
            "end": 5610.587,
            "transcript": "Tegganret seven."
        },
        "846": {
            "start": 5610.587,
            "end": 5616.894,
            "transcript": "Tegganret ukut caliaqait. Ii-i, tua-llu tua-i."
        },
        "847": {
            "start": 5616.894,
            "end": 5632.934,
            "transcript": "Paluqtaat kuik qerrarluku muraganek patularaat, canek taukut muriit pilartatki?"
        },
        "848": {
            "start": 5632.934,
            "end": 5634.094,
            "transcript": "Caputet."
        },
        "849": {
            "start": 5634.094,
            "end": 5640.454,
            "transcript": "Assirtuq, 30 points. Ii-i, tua-llu tua-i."
        },
        "850": {
            "start": 5640.454,
            "end": 5642.507,
            "transcript": "Tegganret three."
        },
        "851": {
            "start": 5644.841,
            "end": 5646.601,
            "transcript": "Waniw' apyun."
        },
        "852": {
            "start": 5646.601,
            "end": 5653.374,
            "transcript": "Kuigkun carvaneq maliggluku anelraraqameng canilartat?"
        },
        "853": {
            "start": 5653.374,
            "end": 5654.667,
            "transcript": "Cetuluteng."
        },
        "854": {
            "start": 5654.667,
            "end": 5661.974,
            "transcript": "Assirtuq tauna. 30 points. Ii-i, tua-llu tua-i-am wani."
        },
        "855": {
            "start": 5661.974,
            "end": 5664.681,
            "transcript": "Tegganret four."
        },
        "856": {
            "start": 5664.681,
            "end": 5668.187,
            "transcript": "Tegganret ukut cukangnaqut."
        },
        "857": {
            "start": 5668.187,
            "end": 5679.627,
            "transcript": "Qulirani kia iigni tamarillruakek?"
        },
        "858": {
            "start": 5679.627,
            "end": 5683.681,
            "transcript": "Qulirani kia iigni tamarillruakek?"
        },
        "859": {
            "start": 5683.681,
            "end": 5685.134,
            "transcript": "Qucillgaam."
        },
        "860": {
            "start": 5685.134,
            "end": 5692.081,
            "transcript": "Assirtuq, 30 points. Ii-i, tua-llu tua-i."
        },
        "861": {
            "start": 5692.081,
            "end": 5695.854,
            "transcript": "Taqneret one."
        },
        "862": {
            "start": 5695.854,
            "end": 5698.574,
            "transcript": "Un' 20 points pingqertuq."
        },
        "863": {
            "start": 5698.574,
            "end": 5707.307,
            "transcript": "Taperrnarnek mingqaaq camek pilartatgu?"
        },
        "864": {
            "start": 5707.307,
            "end": 5708.521,
            "transcript": "Ag'umaq?"
        },
        "865": {
            "start": 5708.521,
            "end": 5713.614,
            "transcript": "Assirtuq, agumaq, 20 points."
        },
        "866": {
            "start": 5713.614,
            "end": 5716.801,
            "transcript": "Tegganret 12."
        },
        "867": {
            "start": 5720.481,
            "end": 5728.974,
            "transcript": "Tuntut tunuatni yualuq canek pilartatki?"
        },
        "868": {
            "start": 5728.974,
            "end": 5736.267,
            "transcript": "Tuntut tunuatni yualut canek pilartatki?"
        },
        "869": {
            "start": 5736.267,
            "end": 5738.121,
            "transcript": "Naam'."
        },
        "870": {
            "start": 5743.414,
            "end": 5749.654,
            "transcript": "Ii-i, sass'an nangqertuq. Tua-ll' Inguq'aq, tuntut tunuatni yualut canek pilartatki."
        },
        "871": {
            "start": 5749.654,
            "end": 5750.921,
            "transcript": "Uliutet."
        },
        "872": {
            "start": 5750.921,
            "end": 5758.334,
            "transcript": "Assirtuq, uliutet, 30 points. Ii-i, tua-llu tua-i."
        },
        "873": {
            "start": 5758.334,
            "end": 5760.281,
            "transcript": "Tegganret 13."
        },
        "874": {
            "start": 5762.374,
            "end": 5766.774,
            "transcript": "Waniwa, Scammon Bay-rmiut Yugtun camiunguat?"
        },
        "875": {
            "start": 5766.774,
            "end": 5768.014,
            "transcript": "Marayaarmiut."
        },
        "876": {
            "start": 5768.014,
            "end": 5774.574,
            "transcript": "Assirtuq, 30 points. Ii-i, tua-llu tua-i."
        },
        "877": {
            "start": 5774.574,
            "end": 5776.481,
            "transcript": "Tegganret five."
        },
        "878": {
            "start": 5778.574,
            "end": 5785.761,
            "transcript": "Estimate question. Tamarpeci uum kiuqatalliniarci igaulluku kiuteci pinairarci. Waniw' apyun."
        },
        "879": {
            "start": 5785.761,
            "end": 5795.107,
            "transcript": "1982-mi qavciullruat yuut maani Mamterillermi?"
        },
        "880": {
            "start": 5795.107,
            "end": 5800.974,
            "transcript": "1982-mi qavciullruat yuut maani Mamterillermi?"
        },
        "881": {
            "start": 5816.454,
            "end": 5820.307,
            "transcript": "Ii-i, tua-ll' waniwa kiuteci mayurrluki."
        },
        "882": {
            "start": 5820.307,
            "end": 5834.707,
            "transcript": "Inguq'aq 2200, Uyuq 2800, Angall'aq 1900. Kiutii-wa 3732."
        },
        "883": {
            "start": 5834.707,
            "end": 5845.694,
            "transcript": "Naliata unakau? Uyuq. Unakellinia. 30 points unanguq. Ii-i, tua-llu tua-i."
        },
        "884": {
            "start": 5845.694,
            "end": 5847.28,
            "transcript": "Taqneret six."
        },
        "885": {
            "start": 5850.28,
            "end": 5855.694,
            "transcript": "Estimate question. Cali tamarpeci kiuqatararci."
        },
        "886": {
            "start": 5855.694,
            "end": 5861.001,
            "transcript": "Cami allrakumi KYUK-q tiiviingellrua?"
        },
        "887": {
            "start": 5861.001,
            "end": 5866.454,
            "transcript": "Cami allrakumi KYUK-q tiiviingellrua."
        },
        "888": {
            "start": 5878.667,
            "end": 5882.481,
            "transcript": "Upingarikuvci wani."
        },
        "889": {
            "start": 5882.481,
            "end": 5899.881,
            "transcript": "Inguq'aq 1979, yaa, 1979, Uyuq 1971, Angall'aq 1972. Kiutii-wa 1972. 1976-aarulliniuq ing'um pia, 1976."
        },
        "890": {
            "start": 5899.881,
            "end": 5905.694,
            "transcript": "Uyuq wani unanguq 20 points."
        },
        "891": {
            "start": 5906.961,
            "end": 5923.227,
            "transcript": "Waniw' cucukelciirpailegpet wani. Inguq'aq 180-nek point-angellrurtuq, Uyuq 70 points, Angall'aq 200 points."
        },
        "892": {
            "start": 5923.227,
            "end": 5928.107,
            "transcript": "Waniwa call-in question-aamek piqatartukut."
        },
        "893": {
            "start": 5928.107,
            "end": 5938.881,
            "transcript": "Elpeci kinkuni tayim' niicugnilriani nunat wani Mamterillermiut-llu apluki piqatartukut."
        },
        "894": {
            "start": 5938.881,
            "end": 5952.707,
            "transcript": "Waniwa apyun."
        },
        "895": {
            "start": 5952.707,
            "end": 5957.841,
            "transcript": "Yuk qaneqsaunani uitauraraqan canilartatgu?"
        },
        "896": {
            "start": 5957.841,
            "end": 5970.961,
            "transcript": "Waniwa number-aaq call-ararkarci, 543-3654. Ava-i apyun, yuk qaneqsaunani uitararaqan canilartatgu?"
        },
        "897": {
            "start": 5970.961,
            "end": 5976.854,
            "transcript": "Ii-i, kitak' ayagturluta wani Uyuq cucukelciiqatartuq."
        },
        "898": {
            "start": 5976.854,
            "end": 5979.507,
            "transcript": "Taqneret seven."
        },
        "899": {
            "start": 5981.441,
            "end": 5992.547,
            "transcript": "Waniwa apyun, kamilarmi piyualria it'gai uluryata'arluteng canilarceta?"
        },
        "900": {
            "start": 5992.547,
            "end": 5995.361,
            "transcript": "Cukilata'ararnilaran?"
        },
        "901": {
            "start": 5995.361,
            "end": 6007.507,
            "transcript": "Yaa, assirtuq, cukilata'ararniluni. Una wani Eileen Jenkins-aamek kingunengqertuq Nunapicuarnek. Ii-i, 20 points-llu unangluni. Ii-i, kitaki."
        },
        "902": {
            "start": 6007.507,
            "end": 6011.067,
            "transcript": "Taqneret two."
        },
        "903": {
            "start": 6014.174,
            "end": 6017.654,
            "transcript": "Manam nuuga camek pilartatgu?"
        },
        "904": {
            "start": 6019.867,
            "end": 6021.187,
            "transcript": "Which part?"
        },
        "905": {
            "start": 6021.187,
            "end": 6024.28,
            "transcript": "Manam nuuga camek pilartatgu?"
        },
        "906": {
            "start": 6028.921,
            "end": 6034.267,
            "transcript": "Naam'. Manami."
        },
        "907": {
            "start": 6034.28,
            "end": 6041.161,
            "transcript": "Nuu. Ii-i, kitak' Angall'aq, manam nuuga camek pilartatgu?"
        },
        "908": {
            "start": 6045.041,
            "end": 6046.441,
            "transcript": "Ipga [?]."
        },
        "909": {
            "start": 6046.441,
            "end": 6053.094,
            "transcript": "Nuu. Ii-i, kitak' Inguq'aq, manam nuuga camek pilartatgu?"
        },
        "910": {
            "start": 6053.094,
            "end": 6055.281,
            "transcript": "Pakganek."
        },
        "911": {
            "start": 6055.281,
            "end": 6061.974,
            "transcript": "Assirtuq, 20 points, 20 points unanguq. Ii-i, tua-llu tua-i-am."
        },
        "912": {
            "start": 6061.974,
            "end": 6065.147,
            "transcript": "Eight-aaq tauna tegganernek."
        },
        "913": {
            "start": 6067.814,
            "end": 6070.094,
            "transcript": "Waniw' apyun."
        },
        "914": {
            "start": 6070.094,
            "end": 6080.387,
            "transcript": "Tanglurarallret pagaani qilagmi kitumun tumeknilartatki?"
        },
        "915": {
            "start": 6080.387,
            "end": 6081.707,
            "transcript": "Tulukarugmun."
        },
        "916": {
            "start": 6081.707,
            "end": 6089.547,
            "transcript": "Assirtuq, 30 points. Ii-i, tua-llu tua-i-am."
        },
        "917": {
            "start": 6089.547,
            "end": 6091.28,
            "transcript": "Taqneret 11."
        },
        "918": {
            "start": 6094.854,
            "end": 6096.734,
            "transcript": "Tengmiat caugat?"
        },
        "919": {
            "start": 6096.734,
            "end": 6098.054,
            "transcript": "Yaqulget."
        },
        "920": {
            "start": 6098.054,
            "end": 6104.707,
            "transcript": "20 points unanguq. Ii-i, tua-llu tua-i-am cali."
        },
        "921": {
            "start": 6104.707,
            "end": 6106.334,
            "transcript": "Tegganret nine."
        },
        "922": {
            "start": 6107.627,
            "end": 6117.201,
            "transcript": "Tegganret nine. Nangneq waniw' apyun. Estimate question. Tamarpeci-am kiuqatararci. Upingarikuvci waniw' apyun."
        },
        "923": {
            "start": 6117.201,
            "end": 6127.681,
            "transcript": "Cami allrakumi anguyagtem tuntut yugnun auluk'ngevkallruaki ak'a tamaani?"
        },
        "924": {
            "start": 6127.681,
            "end": 6136.681,
            "transcript": "Cami allrakumi anguyagtem tuntut yugnun auluk'ngevkallruaki ak'a tamaani?"
        },
        "925": {
            "start": 6148.494,
            "end": 6153.654,
            "transcript": "Ii-i, upingarikuvci."
        },
        "926": {
            "start": 6153.654,
            "end": 6163.507,
            "transcript": "Inguq'aq 1920, Uyuq 1922, Angall'aq 1939. Kiutii-wa 1939."
        },
        "927": {
            "start": 6163.507,
            "end": 6174.481,
            "transcript": "Nall'arteqapiarluku waniw' Angall'am kiugaa. 30 points unanguq. Ii-i, tua-llu tua-i cucukelciiluten."
        },
        "928": {
            "start": 6176.614,
            "end": 6178.587,
            "transcript": "Tegganret three."
        },
        "929": {
            "start": 6184.521,
            "end": 6191.281,
            "transcript": "Bonus question. Nall'areskuvgu 40 points pingciquten. Waniwa apyun."
        },
        "930": {
            "start": 6191.281,
            "end": 6196.841,
            "transcript": "Kass'atun Milky Way Yugtun cauga?"
        },
        "931": {
            "start": 6201.107,
            "end": 6204.88,
            "transcript": "Naamell'."
        },
        "932": {
            "start": 6205.28,
            "end": 6213.174,
            "transcript": "Nalluan-qaa? Kiusciigatan. Ii-i, kitak' Inguq'aq, Kass'atun Milky Way Yugtun cauga?"
        },
        "933": {
            "start": 6213.174,
            "end": 6218.014,
            "transcript": "Ciungani-w' niiteksailamkun nallukeka."
        },
        "934": {
            "start": 6218.014,
            "end": 6220.641,
            "transcript": "Ii-i, kitaki Uyuq."
        },
        "935": {
            "start": 6220.641,
            "end": 6224.601,
            "transcript": "Pagaani-qaa Milky Way-aq qang'a-llu candy bar-aq?"
        },
        "936": {
            "start": 6224.601,
            "end": 6228.121,
            "transcript": "Nuu, pagaanelnguq piyugnarquq."
        },
        "937": {
            "start": 6228.121,
            "end": 6231.707,
            "transcript": "Oh, candy bar-aq wii piullrukeka."
        },
        "938": {
            "start": 6231.707,
            "end": 6233.854,
            "transcript": "Ii-i, kitaki."
        },
        "939": {
            "start": 6235.721,
            "end": 6237.28,
            "transcript": "Agyarugaat."
        },
        "940": {
            "start": 6237.28,
            "end": 6246.467,
            "transcript": "Nuu. Waniwa kiutii, Tanglurarallret."
        },
        "941": {
            "start": 6246.467,
            "end": 6253.694,
            "transcript": "Tua-i tauna wani Milky Way Yugtun taungulliniuq. Pagaani qilagmi uitatuli."
        },
        "942": {
            "start": 6253.694,
            "end": 6262.387,
            "transcript": "Ii-i, kitak' waniwa ava-i call-in question-aaq pillemteggu."
        },
        "943": {
            "start": 6262.387,
            "end": 6267.147,
            "transcript": "Yuk qaneqsaunani uitauraraqan canilartatgu?"
        },
        "944": {
            "start": 6267.147,
            "end": 6282.054,
            "transcript": "Uum Ina Oscar Mamterillermi maani kiutii unakellinia. Waniwa kiutii, qilnganerluni."
        },
        "945": {
            "start": 6282.054,
            "end": 6292.187,
            "transcript": "Tua-i tauna wani kiutii uum, yuk qaneqsaunani uitauraraqan tuaten pinilalliniat. Ina Oscar-aam maani Mamterillermi unakluku."
        },
        "946": {
            "start": 6297.414,
            "end": 6303.721,
            "transcript": "Kitak' au͡gna wani camek unangutkaa nalluamku pinritaqa."
        },
        "947": {
            "start": 6303.721,
            "end": 6317.094,
            "transcript": "Nani? Okay. anywhere. Yaa."
        },
        "948": {
            "start": 6317.094,
            "end": 6324.147,
            "transcript": "Atata wani au͡gna akingutii au͡g'um Ina Oscar-aam nalaqekumku wani qanrutekciqaqa."
        },
        "949": {
            "start": 6324.147,
            "end": 6332.827,
            "transcript": "Ii-i, kitak' ava-i wani kina pillrua? Inguq'aq piqatalliniuq."
        },
        "950": {
            "start": 6332.827,
            "end": 6335.107,
            "transcript": "Taqneret four."
        },
        "951": {
            "start": 6337.707,
            "end": 6342.347,
            "transcript": "Tunutuliarmiut upagpailegmeng camiungullruat?"
        },
        "952": {
            "start": 6342.347,
            "end": 6343.547,
            "transcript": "Qinarmiut."
        },
        "953": {
            "start": 6343.547,
            "end": 6350.614,
            "transcript": "Assirtuq, 20 points. Ii-i, cali kitak'."
        },
        "954": {
            "start": 6350.614,
            "end": 6353.481,
            "transcript": "Taqneret 12."
        },
        "955": {
            "start": 6357.041,
            "end": 6369.334,
            "transcript": "Nengelvagmi unatet kumlilluteng qatlingataqata canilarceta?"
        },
        "956": {
            "start": 6369.334,
            "end": 6371.054,
            "transcript": "Pupingqua."
        },
        "957": {
            "start": 6371.054,
            "end": 6377.867,
            "transcript": "Assirtuq, 20 points. Ii-i, kitak' cali."
        },
        "958": {
            "start": 6377.867,
            "end": 6382.694,
            "transcript": "Ingkurluut ayagyuat 10-aq piqerru."
        },
        "959": {
            "start": 6382.694,
            "end": 6384.667,
            "transcript": "Agturyaqlirluku waniwa."
        },
        "960": {
            "start": 6384.667,
            "end": 6392.721,
            "transcript": "Ii-i, waniwa estimate question-aarulliniuq-am cali, ima tanem. Waniw' apyun."
        },
        "961": {
            "start": 6392.721,
            "end": 6398.801,
            "transcript": "Qangvaq Kuskokwim Community College-aaq piurtellrua?"
        },
        "962": {
            "start": 6398.801,
            "end": 6405.907,
            "transcript": "Qangvaq Kuskokwim Community College-aaq piurtellrua? Tua-i apyun."
        },
        "963": {
            "start": 6416.281,
            "end": 6429.894,
            "transcript": "Ii-i, kitak' Inguq'aq 1973, Uyuq 1969, Angall'aq 1974. Kiutii-wa 1972."
        },
        "964": {
            "start": 6429.894,
            "end": 6437.734,
            "transcript": "Uyuq unakaa, 10 points. Ii-i, kitaki."
        },
        "965": {
            "start": 6437.734,
            "end": 6439.681,
            "transcript": "Taqneret five."
        },
        "966": {
            "start": 6443.28,
            "end": 6451.641,
            "transcript": "Naparyarrarmiut kuigata kelutmun anellrat camek pilartatgu?"
        },
        "967": {
            "start": 6451.641,
            "end": 6456.334,
            "transcript": "Niiteqaqsaitaqa. Nalluaqa."
        },
        "968": {
            "start": 6456.334,
            "end": 6466.281,
            "transcript": "Kitak' Angall'aq, kinguqlia piqatartuq."
        },
        "969": {
            "start": 6466.281,
            "end": 6471.001,
            "transcript": "Naparyarrarmiut kuigata kelutmun anellrat camek pilartatgu?"
        },
        "970": {
            "start": 6471.001,
            "end": 6472.601,
            "transcript": "An'arciiq?"
        },
        "971": {
            "start": 6472.601,
            "end": 6480.534,
            "transcript": "Nuu. Kitak' Inguq'aq, Naparyarrarmiut kuigata anellra kelutmun camek pilartatgu?"
        },
        "972": {
            "start": 6480.534,
            "end": 6481.787,
            "transcript": "Anumalleq."
        },
        "973": {
            "start": 6481.787,
            "end": 6490.307,
            "transcript": "Assirtuq, 20 points. Anna Alexie-mek Naparyarrarmium kingunengqelliniuq."
        },
        "974": {
            "start": 6490.307,
            "end": 6496.921,
            "transcript": "Waniw' apallugpagnariuq. Apallugpagaqamta bet-alartukut wani."
        },
        "975": {
            "start": 6496.921,
            "end": 6508.014,
            "transcript": "Inguq'aq waniw' 310-aarnek point-angqertuq, Uyuq 100, Angall'aq 230."
        },
        "976": {
            "start": 6508.014,
            "end": 6514.174,
            "transcript": "Apyutekvailemku wani ciumek bet-arciquci. Bet-arluci ciumek."
        },
        "977": {
            "start": 6523.654,
            "end": 6532.747,
            "transcript": "Bet-alci maniniaraci wani igauqaarluku. Ak'a-q' bet-artuten. Okay."
        },
        "978": {
            "start": 6532.747,
            "end": 6541.721,
            "transcript": "Inguq'aq 150-nek bet-artuq, Uyuq 100, Angall'aq 30."
        },
        "979": {
            "start": 6541.721,
            "end": 6549.121,
            "transcript": "Waniw' apyun. Igaulluki wani kiuteci piniararci."
        },
        "980": {
            "start": 6549.121,
            "end": 6572.054,
            "transcript": "Uksurpak kumlanrutngullret akakiiget wall'u allat neqet up'nerkami ulliggluki ellamun iniluki kinerciqteng canek pilartatki?"
        },
        "981": {
            "start": 6572.054,
            "end": 6573.854,
            "transcript": "Igaulluku?"
        },
        "982": {
            "start": 6573.854,
            "end": 6581.721,
            "transcript": "Yaa, igaulluki kiuteci. (Cauga, akakiik cauga? Whitefish. Whitefish.) Akakiiget, yaa."
        },
        "983": {
            "start": 6581.721,
            "end": 6584.014,
            "transcript": "Naaqenqiggluku waniw' apyun."
        },
        "984": {
            "start": 6584.014,
            "end": 6600.921,
            "transcript": "Uksurpak kumlanrutngullret akakiiget wall'u allat neqet up'nerkami ulliggluki ellamun iniluki kinerciqteng canek pilartatki?"
        },
        "985": {
            "start": 6600.921,
            "end": 6602.894,
            "transcript": "Tua-i tauna apyun."
        },
        "986": {
            "start": 6603.747,
            "end": 6608.28,
            "transcript": "Tayim' 30 seconds wani pillerkangqertuci, kiullerkangqertuci."
        },
        "987": {
            "start": 6628.147,
            "end": 6632.28,
            "transcript": "Ii-i, taqsugnarqut iganermek."
        },
        "988": {
            "start": 6632.28,
            "end": 6650.147,
            "transcript": "Inguq'am waniw' kiutii, yay'ussat. Uyuq, ulligtaat. Angall'aq, ullipayunguat."
        },
        "989": {
            "start": 6650.147,
            "end": 6654.747,
            "transcript": "Kiutiit-wa ullipayuunguat wall'u yay'ussat."
        },
        "990": {
            "start": 6654.747,
            "end": 6665.667,
            "transcript": "Ukuk wani Inguq'ankuk Angall'aq-llu kiutek assirtuk. Uyuq unakenritaa kiutii."
        },
        "991": {
            "start": 6667.881,
            "end": 6682.601,
            "transcript": "Elpeci qakmani yugni wani tangvalalriani mat'umek apqangssagnek wani igaryukuvci maavet KYUK-mun pilliuq."
        },
        "992": {
            "start": 6682.601,
            "end": 6699.441,
            "transcript": "Wall'u-qaa Yup'ik Language Center-aamun igarluci piniartuci qaillun man'a tangvalallerci wani umyuartequterpeceńek assikluku wall'u-qaa assikevkenaku."
        },
        "993": {
            "start": 6699.441,
            "end": 6706.494,
            "transcript": "Tuaten piyukuvci wani piniartuci."
        },
        "994": {
            "start": 6706.494,
            "end": 6721.28,
            "transcript": "Waniwa Inguq'aq ava-i bet-allermini unakellrua 460-nek unangluni, Uyuq zero-nek wani score-angluni, Angall'aq 260."
        },
        "995": {
            "start": 6721.28,
            "end": 6734.614,
            "transcript": "Kana-i-llu Inguq'am unangutii wani un'a kuvya, una first place taryaqvagcuutnguluni kuvya una-i unangutii."
        },
        "996": {
            "start": 6734.614,
            "end": 6746.707,
            "transcript": "Kinguqlia-wa Angall'aq kis'utmek un'umek call' unangluni, qiugliuluni una-i tangvaggsuutni [?]."
        },
        "997": {
            "start": 6746.707,
            "end": 6751.027,
            "transcript": "Uyuq-llu qemirkamek cali unangluni."
        },
        "998": {
            "start": 6751.027,
            "end": 6754.747,
            "transcript": "Waniw' una-i kankut unangekait."
        },
        "999": {
            "start": 6806.841,
            "end": 6817.28,
            "transcript": "Man'a tangvalci piyunarivkaumallruuq ukunek Drew's Gillnet Supplies, maani Mamterillermi kuvyanek tuniatuli."
        }
    },
    "H13bPXEFzkk": {
        "1": {
            "start": 126.72,
            "end": 130.38,
            "transcript": "Takarnaqvaa. Yugcetun ciumek piciqaqa."
        },
        "2": {
            "start": 133.6,
            "end": 141.3,
            "transcript": "Una waniw' kelumni Wood Center-aamek pilaqiit. Apiatam nalliinek ayagluteng yuralartut. Three-klaagem avatiinun tekilluteng."
        },
        "3": {
            "start": 141.3,
            "end": 147.79,
            "transcript": "Eliita group-at taillret maavet Festival of Native Arts-aaliyarluteng imkuugut Kuigglugmiut yurartait."
        },
        "4": {
            "start": 147.79,
            "end": 152.0,
            "transcript": "Qalarutellruarput ciuliqagtiit Joe Ayagrak [?] Jr."
        },
        "5": {
            "start": 154.77,
            "end": 159.67,
            "transcript": "Assirtuq-qaa? Okay. Kass'acetun pinaurqa."
        },
        "6": {
            "start": 201.0,
            "end": 203.12,
            "transcript": "Takarnaqyarpaa."
        },
        "7": {
            "start": 206.24,
            "end": 207.36,
            "transcript": "Tua-llu?"
        },
        "8": {
            "start": 236.0,
            "end": 244.9,
            "transcript": "Maaken UAF campus-aamek Festival of Native Arts-aat uitaviatnek qanemcilluci KYUK-mek Atmaugua. Aren, KYUK."
        },
        "9": {
            "start": 249.29,
            "end": 257.0,
            "transcript": "Uitavianek Festival of Native Arts-aat maa-i qula pingayunek cipluku allrakungellrat Fairbanks-aami. Qanemcilluci Atmaugua."
        },
        "10": {
            "start": 264.98,
            "end": 267.19,
            "transcript": "Waniw' aperciqukut waniw'..."
        },
        "11": {
            "start": 505.33,
            "end": 508.38,
            "transcript": "Kituusit Kass'acetun naken-llu kingunengqercit?"
        },
        "12": {
            "start": 508.38,
            "end": 512.8,
            "transcript": "Eliza Chase, Mamterillermek Nunapicuarmiunguunga."
        },
        "13": {
            "start": 512.8,
            "end": 515.39,
            "transcript": "Canek waniw' maniisit?"
        },
        "14": {
            "start": 515.39,
            "end": 517.88,
            "transcript": "Nacanek maniigua."
        },
        "15": {
            "start": 517.88,
            "end": 519.21,
            "transcript": "Qaill'-qaa piliyaraitnek?"
        },
        "16": {
            "start": 519.21,
            "end": 521.89,
            "transcript": "Yaa, qaillun piliyarraitnek."
        },
        "17": {
            "start": 521.89,
            "end": 523.88,
            "transcript": "Qangvarnek waten mingqilarcit?"
        },
        "18": {
            "start": 525.44,
            "end": 529.41,
            "transcript": "Seventeen years-allemni mingqenermek ayagnillruunga."
        },
        "19": {
            "start": 529.41,
            "end": 531.05,
            "transcript": "Kia elicungcarluten?"
        },
        "20": {
            "start": 531.05,
            "end": 534.66,
            "transcript": "Wangnek, yugnek-llu tangvaglua."
        },
        "21": {
            "start": 534.66,
            "end": 539.47,
            "transcript": "Qavcinek maa-i amllepiallilriit-wa pilingualten?"
        },
        "22": {
            "start": 539.47,
            "end": 543.22,
            "transcript": "Yaa, amlleriyugnarqut pilillrenka."
        },
        "23": {
            "start": 543.22,
            "end": 550.62,
            "transcript": "Qaillun tamaakenirnek seventeen-aarraanerpenek piliaten qaill' ayuqat?"
        },
        "24": {
            "start": 550.62,
            "end": 553.57,
            "transcript": "Pilianek assiriinartut."
        },
        "25": {
            "start": 553.57,
            "end": 556.61,
            "transcript": "Canek melqunek atularcit?"
        },
        "26": {
            "start": 556.61,
            "end": 558.17,
            "transcript": "Ayuqenrilngurnek."
        },
        "27": {
            "start": 558.17,
            "end": 559.32,
            "transcript": "Tauna cauga?"
        },
        "28": {
            "start": 559.32,
            "end": 566.0,
            "transcript": "Una blue fox-aaruyugnarquq, or silver, maybe it's blue fox."
        },
        "29": {
            "start": 566.0,
            "end": 568.69,
            "transcript": "Canek-llu taitellrusit?"
        },
        "30": {
            "start": 568.69,
            "end": 580.09,
            "transcript": "Seal skin, beaver, calf skin, makunek-llu. Quyana."
        },
        "31": {
            "start": 583.77,
            "end": 585.19,
            "transcript": "Ampi?"
        },
        "32": {
            "start": 585.19,
            "end": 588.54,
            "transcript": "Aterpenek atren apertuqerr'u camiungullren-llu."
        },
        "33": {
            "start": 589.26,
            "end": 593.0,
            "transcript": "Carrie Anvil-aaruunga Bethel-aarmiungulua."
        },
        "34": {
            "start": 593.0,
            "end": 596.54,
            "transcript": "Canek maniisit maa-i festival-aami?"
        },
        "35": {
            "start": 597.67,
            "end": 605.08,
            "transcript": "Makunek wani mingqiilua, tarenrilua maniigua."
        },
        "36": {
            "start": 605.08,
            "end": 611.0,
            "transcript": "Maa-i kanaa-i-ll' basket-aliaqa kanani cali."
        },
        "37": {
            "start": 611.0,
            "end": 614.42,
            "transcript": "Ukuk wani taqeksaitagken-qaa?"
        },
        "38": {
            "start": 614.42,
            "end": 622.49,
            "transcript": "Ukuk taqeksaitagka, ataucik tau͡gaam ak'a taqlukek tayima ayallruuk, kiputellruagket."
        },
        "39": {
            "start": 622.49,
            "end": 624.19,
            "transcript": "Qangvarnek waten pililarcit?"
        },
        "40": {
            "start": 626.11,
            "end": 636.5,
            "transcript": "Qavci, four years-aurcugnarquq mingqiilqa, tau͡gaam ak'arraurtuq ayagnilqa, mingqiilua."
        },
        "41": {
            "start": 636.5,
            "end": 639.35,
            "transcript": "Qangvaq, cami ayagnirngatellrusit?)"
        },
        "42": {
            "start": 641.21,
            "end": 651.51,
            "transcript": "High school dorm-ami dorm-artangqellrani elitnaurillemni dorm-ami elitnautullratni kids-at."
        },
        "43": {
            "start": 651.51,
            "end": 656.36,
            "transcript": "Nunameggni piyaarpailgata. Tuaken ayaglua mingqelartua."
        },
        "44": {
            "start": 656.36,
            "end": 658.26,
            "transcript": "Canek-ll' allanek pililarcit?"
        },
        "45": {
            "start": 658.26,
            "end": 665.9,
            "transcript": "Atkulituunga pilugulilua, malaggaayilua,"
        },
        "46": {
            "start": 665.9,
            "end": 674.0,
            "transcript": "Aliimacilua, aqlit'lilua, tua-i tamaklaita cat caliaqelaranka."
        },
        "47": {
            "start": 674.0,
            "end": 677.18,
            "transcript": "Anglaniuten-qaa waten maa-i maniicillerpenek?"
        },
        "48": {
            "start": 677.18,
            "end": 681.91,
            "transcript": "Anglaniunga waniw' maniicillemni maavet taillemnek-llu."
        },
        "49": {
            "start": 681.91,
            "end": 683.06,
            "transcript": "Quyana."
        },
        "50": {
            "start": 764.06,
            "end": 766.87,
            "transcript": "Atren apertuqerr'u camiungellren-llu."
        },
        "51": {
            "start": 766.87,
            "end": 773.0,
            "transcript": "Mamterillermiunguunga Yugcetun Ayagiinaarmek pituatnga Kass'atun-llu Nick Charles."
        },
        "52": {
            "start": 773.0,
            "end": 775.0,
            "transcript": "Canek waniw' maniisit?"
        },
        "53": {
            "start": 775.0,
            "end": 780.49,
            "transcript": "Makunek calilallemnek makunek muragnek maniigua."
        },
        "54": {
            "start": 780.49,
            "end": 783.0,
            "transcript": "Una-mi waniw' cauga?"
        },
        "55": {
            "start": 783.0,
            "end": 790.47,
            "transcript": "Waniw' cauciituq tua-i imkut yaqulget ilait ayuqellikii tayima."
        },
        "56": {
            "start": 790.47,
            "end": 793.41,
            "transcript": "Cauciinaki pililartua wii piyugtacimtun."
        },
        "57": {
            "start": 793.41,
            "end": 796.21,
            "transcript": "Kegginaquuluku."
        },
        "58": {
            "start": 796.38,
            "end": 805.6,
            "transcript": "Kegginaquluku-w' ata kegginaqunek pilaqait nem'un tau͡gaam agarrluki waten tangnircautek'laqait kipucetait."
        },
        "59": {
            "start": 805.6,
            "end": 808.53,
            "transcript": "Qangvarnek waten muraliularcit?"
        },
        "60": {
            "start": 808.53,
            "end": 815.4,
            "transcript": "Ellangerraanemnek cayaurqaanemnek, caliyaurqaanelget [?] muragnek calituunga."
        },
        "61": {
            "start": 815.4,
            "end": 823.1,
            "transcript": "Ak'a tayim tan'gaurlullraullemnek ayaglua muragnek canalartua. Wangnek pililua pitegcaucilua."
        },
        "62": {
            "start": 823.1,
            "end": 827.73,
            "transcript": "Piyugngariama-llu wangnek anguaruciaqlua, anguatullemteńi."
        },
        "63": {
            "start": 828.45,
            "end": 832.22,
            "transcript": "Maa-i-llu makunek piciatun calinglua, calinguar'."
        },
        "64": {
            "start": 832.22,
            "end": 838.11,
            "transcript": "Piyullemnek-llam paqnakaqamku umyuanglua caliaqela'arqa piyugtacirramtun wii."
        },
        "65": {
            "start": 838.11,
            "end": 840.52,
            "transcript": "Kia-qaa elicungcallruaten waten pinermek?"
        },
        "66": {
            "start": 840.52,
            "end": 843.51,
            "transcript": "Kiingek wangnek elicungcallruunga caliyaramek."
        },
        "67": {
            "start": 843.51,
            "end": 847.0,
            "transcript": "Wangnek umyuaq aturluku caliaqlua piyugtacirramtun."
        },
        "68": {
            "start": 847.0,
            "end": 849.26,
            "transcript": "Tangvagluki-qaa allat yuut?"
        },
        "69": {
            "start": 849.26,
            "end": 852.78,
            "transcript": "Tangvagluku tua-i calilriit tangvagluki."
        },
        "70": {
            "start": 852.78,
            "end": 858.4,
            "transcript": "Tuaten piugaqama ak'aliaq [?] naspaagaqama tua-i tuaten ayuqluki taq'aqluki."
        },
        "71": {
            "start": 858.4,
            "end": 863.42,
            "transcript": "Qaill' umyuartequcekciu waten maniillerpenek maani nunarpagmi?"
        },
        "72": {
            "start": 863.42,
            "end": 869.48,
            "transcript": "Tua-i assikaqa maani waten maniilqa cangalliurpek'nii tua-i."
        },
        "73": {
            "start": 869.48,
            "end": 875.0,
            "transcript": "Wangnek-llu umyuaq aturluku pinrilama tua-i cavkenani wangnii assirluni."
        },
        "74": {
            "start": 875.0,
            "end": 876.0,
            "transcript": "Anglaniluten-qaa tua-i?"
        },
        "75": {
            "start": 876.0,
            "end": 879.12,
            "transcript": "Anglanilua tau͡gaam."
        },
        "76": {
            "start": 879.12,
            "end": 880.78,
            "transcript": "Quyana. (Ii-i.)"
        }
    },
    "Tivj5oGoNBg": {
        "1": {
            "start": 149.72,
            "end": 153.86,
            "transcript": "Alaama uum-wa nutaram inerquutam assiitevkassiiyaakii."
        },
        "2": {
            "start": 153.86,
            "end": 161.28,
            "transcript": "Inerquutaam caucia nalluaqa, tau͡gaam nallunritaqa akwaugaq anngapuk tuquyutellruuq. Camek allamek nalluyugteqenritua."
        },
        "3": {
            "start": 161.28,
            "end": 166.63,
            "transcript": "Nutaan kitek nallunrirru taumek taiskemken, maavet kia imum niisngailkiikuk caarkangqertukuk."
        },
        "4": {
            "start": 166.67,
            "end": 167.66,
            "transcript": "Cauga?"
        },
        "5": {
            "start": 167.71,
            "end": 175.63,
            "transcript": "Creon-am tegullrua anngamegnuk Apangam kemga qungitnaluku pirpakluku. Melqulngutkegtaarautminek-llu aturirluku."
        },
        "6": {
            "start": 175.63,
            "end": 180.49,
            "transcript": "Qukaan [?] taquirluku merkaan-llu tangrrucicesqelluku tuqumalriit nuniitni."
        },
        "7": {
            "start": 180.49,
            "end": 187.9,
            "transcript": "Tau͡gken aipaa Nurauq uayallrulliniluku caskuinani. Unicimaluni yuilqumun, qimugteńun tulukarugnun-llu cagmaarkauluni."
        },
        "8": {
            "start": 187.9,
            "end": 192.36,
            "transcript": "Alangrua unicimaluni caalligtaarluni uitasciigaciiqluni akwarpak."
        },
        "9": {
            "start": 192.9,
            "end": 200.74,
            "transcript": "Kemgaururluuk aturirlukek unilluku tuarpiaq kemga ayuqlilluku nukalpiacetun tuqutarkaugut tuqulluni, mat'um-qaa inerquutem alingevkaraaten?"
        },
        "10": {
            "start": 200.74,
            "end": 202.88,
            "transcript": "Ca-qaa pinarqellria piyugnganriciiqan?"
        },
        "11": {
            "start": 202.88,
            "end": 204.96,
            "transcript": "Ca piluku? Camek piyugngasia?"
        },
        "12": {
            "start": 204.96,
            "end": 208.92,
            "transcript": "Qaillukuarniartuten ikayuqataquvnga wall'u ikayuqatanrilkuvnga."
        },
        "13": {
            "start": 208.97,
            "end": 210.22,
            "transcript": "Camek ikayurluten?"
        },
        "14": {
            "start": 210.22,
            "end": 213.52,
            "transcript": "Qungilluku anngapuk, qungilluku tuqumalriit piyaraicetun."
        },
        "15": {
            "start": 213.58,
            "end": 218.53,
            "transcript": "Qungilluku-qaa? Qanellruuten-ggem una anngamegnuk inerquutaanun pisquumanritniluku."
        },
        "16": {
            "start": 218.57,
            "end": 223.54,
            "transcript": "Anngapuk qungitarkaugapuk. Tauna arcaqenruuq wangkunun uumi nutarami inerquutamni [?]."
        },
        "17": {
            "start": 223.68,
            "end": 226.86,
            "transcript": "Umyuaqerqerru atam qaill' anngamegnuk callerkaa!"
        },
        "18": {
            "start": 226.86,
            "end": 229.95,
            "transcript": "Creon-am watqapik arulaircesciigataanga."
        },
        "19": {
            "start": 229.98,
            "end": 233.98,
            "transcript": "Antigone-iiq kiimellirtukuk wangkuk aliayuglunuk ilamegni,"
        },
        "20": {
            "start": 234.0,
            "end": 239.48,
            "transcript": "Elpet wiinga-llu, qaillun-kiq piniavceńuk unanguamegnegu inerquutaliarai navkuumegnegu,"
        },
        "21": {
            "start": 239.48,
            "end": 247.65,
            "transcript": "Callugciigalluku angutet inglukluki ellait inerquucituut. Narurcesciigatapuk inerquutait tuaten ayuqerrlainartuq."
        },
        "22": {
            "start": 247.65,
            "end": 255.47,
            "transcript": "Pitsaqenritaqa anngaurlurpuk, tau͡gaam piciatun piciqaa anernerlua uitanqegcillerkaanek nunaniryugcetlerkaanek-llu."
        },
        "23": {
            "start": 255.47,
            "end": 259.94,
            "transcript": "Tau͡gaam qaill' pisciigatua kemgan tungiinun, qaill' pisciigatua."
        },
        "24": {
            "start": 259.94,
            "end": 265.92,
            "transcript": "Qanertuten inerquutanek maligngatnek-llu, inerquutasmi [?] piyurtellret anngatiin inerquutai piurpailgata,"
        },
        "25": {
            "start": 265.92,
            "end": 272.05,
            "transcript": "Ciungatni angutet inerquuciaritni. Pitsaqenritamken ikayungcallemnek anngaqa qungiciiqaqa."
        },
        "26": {
            "start": 272.05,
            "end": 280.22,
            "transcript": "Tuqukuma-llu nallunriciiqaqa maligtaqellrunrilengramki nunamta inerquutai maligtaqullruanka anernerma quyaqerkai takaqerkai-llu."
        },
        "27": {
            "start": 280.22,
            "end": 285.43,
            "transcript": "Nanracuglagyuumitelaryaaqanka, tau͡gaam wii angutet ingluturciigatanka pinialama."
        },
        "28": {
            "start": 285.43,
            "end": 289.7,
            "transcript": "Avalitengqertuten tau͡gaam maa-i ayagarkaugua, anngaqa utaqauq taklangqaluni."
        },
        "29": {
            "start": 289.7,
            "end": 292.12,
            "transcript": "Antigone-iiq uitaqaa! Alinguciitamken."
        },
        "30": {
            "start": 292.12,
            "end": 293.65,
            "transcript": "Alinguciiten elpenek."
        },
        "31": {
            "start": 293.65,
            "end": 301.91,
            "transcript": "Uitaqaa ayagyararyaqunak! Akqiit tau͡gaam una kingkunun qanrutekngaitniluku wiinga akqiunga kingkunun qanrutekngaitniluku."
        },
        "32": {
            "start": 301.91,
            "end": 306.89,
            "transcript": "Qang'a qanruskiki yuut nallunrilkengaten, pikiki Ismene equkevsiarciqamken."
        },
        "33": {
            "start": 306.89,
            "end": 308.65,
            "transcript": "Usuuq alingucitamken."
        },
        "34": {
            "start": 308.65,
            "end": 312.64,
            "transcript": "Piunga piarkamnek, elpenun wall'u kitumnun ac'arakesqenritaqa [?]."
        },
        "35": {
            "start": 312.64,
            "end": 316.85,
            "transcript": "Nurauq qungitevkarngaitaat elpenun ciin tua-i pingnaqvakarciu?"
        },
        "36": {
            "start": 316.85,
            "end": 321.52,
            "transcript": "Pingnaqu'urciqua pisciigalillemnun tua-i tau͡gaam pingairuciiqua, tau͡gaam tua-i."
        },
        "37": {
            "start": 321.52,
            "end": 323.08,
            "transcript": "Tau͡gaam pisciigaciiqan."
        },
        "38": {
            "start": 323.08,
            "end": 327.66,
            "transcript": "Eq'ukevkaryaqunak angamegnukk-llu anernera elpenun tusngavkaryaqunaku."
        },
        "39": {
            "start": 327.66,
            "end": 332.64,
            "transcript": "Unesnga wanirpak usviicugtaallemni. Kia imum cali-llu cam wangnek tegusciigataa."
        },
        "40": {
            "start": 332.64,
            "end": 339.72,
            "transcript": "Antigone-iiq, Antigone-iiq, alingucitamken."
        },
        "41": {
            "start": 339.72,
            "end": 346.93,
            "transcript": "Umyaurteqlemni tamakut caarkaten assinritut, tau͡gaam kenkamken, kenkamken."
        },
        "42": {
            "start": 352.11,
            "end": 357.55,
            "transcript": "Unugaanga tamlegitaanga"
        },
        "43": {
            "start": 357.78,
            "end": 363.56,
            "transcript": "Unugaanga tamlegitaanga"
        },
        "44": {
            "start": 363.56,
            "end": 368.25,
            "transcript": "Unugaanga iralungutaanga"
        },
        "45": {
            "start": 368.25,
            "end": 376.23,
            "transcript": "Nunaniritaanga aya aa yaa aa"
        },
        "46": {
            "start": 444.87,
            "end": 449.36,
            "transcript": "Yugiyama tangrraqaanga"
        },
        "47": {
            "start": 449.36,
            "end": 453.67,
            "transcript": "Kinguliaraq-lli takuyarakiinga"
        },
        "48": {
            "start": 453.67,
            "end": 458.24,
            "transcript": "Iralumi pikani aluyarliinga"
        },
        "49": {
            "start": 458.24,
            "end": 463.01,
            "transcript": "Nunaniritaanga aya"
        },
        "50": {
            "start": 463.47,
            "end": 469.02,
            "transcript": "Unugaanga tamlegitaanga"
        },
        "51": {
            "start": 469.02,
            "end": 473.23,
            "transcript": "Unugaanga tamlegitaanga"
        },
        "52": {
            "start": 473.25,
            "end": 477.53,
            "transcript": "Unugaanga iralungutaanga"
        },
        "53": {
            "start": 477.53,
            "end": 483.38,
            "transcript": "Nunaniritaanga aya aa"
        },
        "54": {
            "start": 485.38,
            "end": 486.66,
            "transcript": "Aipaa-llu"
        },
        "55": {
            "start": 491.84,
            "end": 496.14,
            "transcript": "Nunam tegganri, elpeceńun taigua elpeceńun qanertua."
        },
        "56": {
            "start": 496.14,
            "end": 500.48,
            "transcript": "Elpeci tangssullruaci pingayun yuuruciit ciuliqagtait yuullret tuqullret-llu."
        },
        "57": {
            "start": 500.48,
            "end": 504.5,
            "transcript": "Maa-i-rpak-llu usrugma piteklukek nallunrirtua ciuliqagtengurtellra."
        },
        "58": {
            "start": 504.5,
            "end": 509.49,
            "transcript": "Usviicartua caumanrilkumki inerquuceci ciuneliaci-llu."
        },
        "59": {
            "start": 509.49,
            "end": 522.67,
            "transcript": "Nunavut qayatun ayuquq, yuut tamarmeng ekumavikekiitni tamarmeng cavkiitni caliluteng, tamarmeng atanerluteng alulam ciuqerrani uitalriamek."
        },
        "60": {
            "start": 522.67,
            "end": 530.08,
            "transcript": "Pellunerraarput kayungvak tegganemta assiilnguq anuqlilria imarpiim ciamyugtaaqii angyarput, tamamta-llu tuqulluta."
        },
        "61": {
            "start": 530.08,
            "end": 537.82,
            "transcript": "Ilait kanaqallruut tamarluteng-llu, tau͡gaam watua mer'et quunirtut, qanguarluta-llu ciutmun."
        },
        "62": {
            "start": 537.82,
            "end": 542.41,
            "transcript": "Elpecetun ayuqellruunga uumi angyami anguarteńgulua."
        },
        "63": {
            "start": 542.41,
            "end": 552.62,
            "transcript": "Wangnek pitkellruunga cautemnek ilamnek-llu, tau͡gaam watua wangnun tusngauq nunam atanrusqellua, umyuarniurutenka ciunyura'arkaugut [?] wangni."
        },
        "64": {
            "start": 554.77,
            "end": 562.93,
            "transcript": "Uum aliarutii anguyiim pinraam usruma aliarcetellerqaa, augglirluta tuqungnaqesqellemta."
        },
        "65": {
            "start": 562.93,
            "end": 571.31,
            "transcript": "Tau͡gken aipaa Apangaq anguyallruluni ukut nunat pitekluki, anguyallruluni ilani umyuaqluki."
        },
        "66": {
            "start": 571.31,
            "end": 578.75,
            "transcript": "Curuutellruuk narulkarlutek ungungssirpallaracetun ataam tangenqigtellemteńi tamarmek tuqumalutek."
        },
        "67": {
            "start": 580.29,
            "end": 588.78,
            "transcript": "Qenngalriangun kenegnalriallagmun [?], tau͡gaam qaillun-kiq wii kevgiurnaurcia tamarkenka."
        },
        "68": {
            "start": 588.78,
            "end": 600.5,
            "transcript": "Pitsaqeritaqa Nuraum anernera, tau͡gaam wani qaillukuaratemni Apangaq qasqikivkarciqaput qunguani, asqiliciquq uitanqegciluni-ll' anerneret uitaviitni."
        },
        "69": {
            "start": 600.5,
            "end": 605.58,
            "transcript": "Kevgiurciqaput tuqumalriit kalukuviitni."
        },
        "70": {
            "start": 605.58,
            "end": 613.95,
            "transcript": "Tau͡gken Nurauq qungicimaitqapiararkauluni kemga, unicimaciuq nerumaurkauluni tulukarnun qimugteńun-llu."
        },
        "71": {
            "start": 613.95,
            "end": 622.08,
            "transcript": "Wangkutnun tangyunaitqapiararkauluni, wall'u neq'akarkauluku. Waten wii alerquucillruunga."
        },
        "72": {
            "start": 622.08,
            "end": 626.33,
            "transcript": "Elpet kangingqerrauguten wani nunani. Taringumaamteggen."
        },
        "73": {
            "start": 626.33,
            "end": 629.74,
            "transcript": "Tua-i-ll' una inerquun maligcimaurkaulliniaci."
        },
        "74": {
            "start": 629.74,
            "end": 635.81,
            "transcript": "Ak'allaraurtukut, ciumurucukuvgu una inerquun ayagyuat ikayungcararkaugaten."
        },
        "75": {
            "start": 635.81,
            "end": 643.19,
            "transcript": "Umyuarniuryaqunaci ilama ak'a kellucetekaanek pillruunga, cumikestekaanek Nuraum kemga."
        },
        "76": {
            "start": 643.19,
            "end": 645.77,
            "transcript": "Camek-mi wangkutnek piyugcit?"
        },
        "77": {
            "start": 645.77,
            "end": 649.37,
            "transcript": "Ikayungnaqsaqunici yuk [?] kia imum navengnaq' [?] imna inerquun."
        },
        "78": {
            "start": 649.37,
            "end": 652.87,
            "transcript": "Kina imna maani yuk tuquyugteqenrituq."
        },
        "79": {
            "start": 652.87,
            "end": 661.63,
            "transcript": "Neryuniunritelta tua-i-wa tuqu nunuutnguan, ilait yuut tegumaciqngatut cucuknam ciuqerrani kapegcugnaq avisngaumalaryaaquq."
        },
        "80": {
            "start": 661.63,
            "end": 665.52,
            "transcript": "Tang, taqsuqenritua aqvaquallrunrilama maavet."
        },
        "81": {
            "start": 665.52,
            "end": 669.24,
            "transcript": "Aqvaquallrunricartua tau͡gaam wii umyuartequngallruunga."
        },
        "82": {
            "start": 669.24,
            "end": 673.65,
            "transcript": "Camek cukangnaquciqsit? Ciuniskuvet. Asqialliqugnarpagmek."
        },
        "83": {
            "start": 673.65,
            "end": 684.77,
            "transcript": "Tuamek cukaillitalilrianga, tau͡gken wii umyuarteqaqlua, Creon-am nallunriquniu man'a allamek yugmek, taumek cukangnaqelrianga ataam."
        },
        "84": {
            "start": 684.77,
            "end": 691.0,
            "transcript": "Arulairlua ayaglua-llu. Arulairlua ayaglua-llu."
        },
        "85": {
            "start": 691.0,
            "end": 696.41,
            "transcript": "Nangneqlermi-llu umyuaqegtaar ciunrurrluni wangni umyuaqegtaaraugut'lartuq."
        },
        "86": {
            "start": 696.41,
            "end": 699.67,
            "transcript": "Tau͡gaam nallunritan qanlallrat, \"Ca piqatalria..."
        },
        "87": {
            "start": 699.67,
            "end": 701.37,
            "transcript": "Camek qanaasit?"
        },
        "88": {
            "start": 701.37,
            "end": 709.0,
            "transcript": "Tua-i-w' pillrunritaqa! Tangellruvkenaku-llu kitumun picia. Canganarqeciquq nunuumakuma mat'umek pitekluku."
        },
        "89": {
            "start": 709.0,
            "end": 716.0,
            "transcript": "Alangaanaqluten paqnanaqluten-ll' qanemcin ayuqeng'ermi. Paqnanaqvallaayarngatuq taringareskumku camek qanaacin."
        },
        "90": {
            "start": 716.0,
            "end": 719.87,
            "transcript": "Tua-i cukacuumiitelaryaaqanka cat maavet nallunrilken."
        },
        "91": {
            "start": 719.87,
            "end": 724.0,
            "transcript": "Qanrusnga camek wii qanrutarkavnek ayagluten-llu uitasnga."
        },
        "92": {
            "start": 724.0,
            "end": 731.23,
            "transcript": "Kitek tua-i, imuuguq tema, Nurauq."
        },
        "93": {
            "start": 731.23,
            "end": 735.37,
            "transcript": "Kia imum can'get ellillrullinii iigken qainganun."
        },
        "94": {
            "start": 735.37,
            "end": 739.63,
            "transcript": "Ervuqallrulliniluku, aturallrulliniluku."
        },
        "95": {
            "start": 739.63,
            "end": 744.75,
            "transcript": "Murakuinernek-llu ellvikellrulliniluku qaingakun."
        },
        "96": {
            "start": 744.75,
            "end": 751.22,
            "transcript": "Aa-a, kina imna usviitellrullinivagta?"
        },
        "97": {
            "start": 751.22,
            "end": 755.67,
            "transcript": "Kituullrua? Nalluaqa iqlunritamken nalluunga."
        },
        "98": {
            "start": 755.67,
            "end": 761.15,
            "transcript": "Murilkellrunritarput watua tau͡gaam ernerpak, kellucestekak enaiyartullranikuk."
        },
        "99": {
            "start": 761.15,
            "end": 767.93,
            "transcript": "Qungisvipiarunrituq cali caullruvkenani, tau͡gaam amlleriuq pimallrulliniuq neqaniarumaluki [?]."
        },
        "100": {
            "start": 767.93,
            "end": 776.48,
            "transcript": "Kiagem neqkam' [?] anerni, nallunrilken wangkuk calliutengellrumki kiagem pilqagutellriakun [?]."
        },
        "101": {
            "start": 776.48,
            "end": 786.5,
            "transcript": "Una wani qungvagyuutekellruaqa anerneret ellmeng assiilkaat, ellam iluani imarpiim nunani-llu. Assikelanritaat man'a pilleq."
        },
        "102": {
            "start": 786.5,
            "end": 792.03,
            "transcript": "Tua-i usviituten-qaa ak'alla'araciirpecetun, una Nurauq aipanirnaitellruuq ukunun nunanun."
        },
        "103": {
            "start": 792.03,
            "end": 798.4,
            "transcript": "Mat'umun-llu cakauteng-llu ellamun imarpigmun-llu, ciin ikayuryugtatgu?"
        },
        "104": {
            "start": 798.4,
            "end": 800.57,
            "transcript": "Qanruciiqamken caullranek."
        },
        "105": {
            "start": 800.57,
            "end": 806.92,
            "transcript": "Yugtangqertuq maani inglukesciurutemnek ciuliqagtenguqurranemnek. kemga patusqelluku."
        },
        "106": {
            "start": 806.92,
            "end": 810.92,
            "transcript": "Mat'umek-llu piciunrilngurmek quliriluten. Qavcinek melqulegnek cikillruatgen,"
        },
        "107": {
            "start": 810.92,
            "end": 815.62,
            "transcript": "Wall'u-qaa tugkaraullruuk? Nalaqenrilkuvet yuk uum tungiinun ellistetek paugciqam..."
        },
        "108": {
            "start": 815.62,
            "end": 818.58,
            "transcript": "Uitaqaqaa kitek, wall'u-qaa ayasqumaarpenga?"
        },
        "109": {
            "start": 818.58,
            "end": 822.48,
            "transcript": "Qang'a pisciigatuten tuaten! Erinarpet qenevkaraanga."
        },
        "110": {
            "start": 822.48,
            "end": 826.47,
            "transcript": "Erinama-qaa wall'u ayuqucirpet? (Ca?)"
        },
        "111": {
            "start": 826.47,
            "end": 836.01,
            "transcript": "Wiingunritua alanguten [?], qanruskia, tau͡gaam wiinga nallunrirtangqertua nallunailngurmek. Ataam taringcautek'..."
        },
        "112": {
            "start": 836.01,
            "end": 837.8,
            "transcript": "Arca! Qanerpakartuten!"
        },
        "113": {
            "start": 837.8,
            "end": 844.19,
            "transcript": "Tauna piciuciq'ngatuq tau͡gaam wiinga qanerpakangqerrngama qanellma pivkarsaitaa [?]."
        },
        "114": {
            "start": 844.19,
            "end": 847.6,
            "transcript": "Nunulillruatgen tangessqelluten iqlutun, tamatuuguq-qaa?"
        },
        "115": {
            "start": 847.6,
            "end": 848.7,
            "transcript": "Alartuten."
        },
        "116": {
            "start": 848.7,
            "end": 855.71,
            "transcript": "Aqvacia aulukestellranek ilama, aulukestellran taitenrilkuvgu tangerciqan qaill' alangqataciyugngaqa."
        },
        "117": {
            "start": 861.0,
            "end": 868.1,
            "transcript": "Tua-i-w' nalkekilitgu yuaqengaten angun, tau͡gaam wiinga nallunrilkengangqertua nallunailngurmek."
        },
        "118": {
            "start": 868.1,
            "end": 877.0,
            "transcript": "Narulkaqataryuksaaqellruunga nangengqavimni. Ayakuma [?] ayagyugngnallemni."
        },
        "119": {
            "start": 877.72,
            "end": 884.65,
            "transcript": "Ayayurayaa ayagatnauramkaan."
        },
        "120": {
            "start": 884.69,
            "end": 891.06,
            "transcript": "Ayayurayaa ayagatnauramkaan."
        },
        "121": {
            "start": 891.12,
            "end": 907.66,
            "transcript": "Kia yurayaa caligatnauramkaan iiya iirri ya anga ii."
        },
        "122": {
            "start": 1008.65,
            "end": 1012.34,
            "transcript": "Qanrusnga iigmak tangellrak piciunritniluki Antigone-iiq."
        },
        "123": {
            "start": 1012.34,
            "end": 1015.0,
            "transcript": "Elluanrilnguum panian [?], camek pillrusit?"
        },
        "124": {
            "start": 1015.0,
            "end": 1022.6,
            "transcript": "Uunguuq! Uunguuq pistellra! Angullruaput qungitenqiggluku. Nauwa Creon-aq?"
        },
        "125": {
            "start": 1022.6,
            "end": 1024.3,
            "transcript": "Yaa-i nem'inek taiguq."
        },
        "126": {
            "start": 1024.3,
            "end": 1025.85,
            "transcript": "Camun nall'arulluni?"
        },
        "127": {
            "start": 1025.85,
            "end": 1036.12,
            "transcript": "Nasvitnaluten warnirpauguq angun acivakanirluni cangaitniluni, tuall' caarkaq tekilluni nallunrirpailemteńi catailluni [?] cali pilliniluku."
        },
        "128": {
            "start": 1036.12,
            "end": 1048.51,
            "transcript": "Qanellruunga taingaitnilua maavet, tangnircaryarpiallemni narulkavet iqua, tau͡gaam wiinga caarkaiqekallruunga uumi [?] nasaurluullra. Nasaurluqapiggluni cali."
        },
        "129": {
            "start": 1048.51,
            "end": 1051.81,
            "transcript": "Tua-i nutaan assiriunga uumek assiilngurmek piarkamek."
        },
        "130": {
            "start": 1051.81,
            "end": 1060.26,
            "transcript": "Nangneqlirmek ilama kinguvaqanirluten qanaaqaa, taringnaqluten. Qaill' piqatarciu usruqa Antigone-iq?"
        },
        "131": {
            "start": 1060.26,
            "end": 1067.84,
            "transcript": "Qanaayukua taringnaqlua. Angullruapuk kemga qungisnginanrani, teguaqluku-llu."
        },
        "132": {
            "start": 1067.84,
            "end": 1070.32,
            "transcript": "Camek-qaa qanellren nallunritan?"
        },
        "133": {
            "start": 1070.32,
            "end": 1073.98,
            "transcript": "Nalluaqa qaillun taringnaqluku qanrutkellra, Creon-aaq."
        },
        "134": {
            "start": 1073.98,
            "end": 1077.08,
            "transcript": "Qanrusnga tamalkuan qaill' pillra."
        },
        "135": {
            "start": 1078.79,
            "end": 1087.33,
            "transcript": "Tua-i-ll' qanllemtun, utertellruunga ilamnun. Uitacurlaglua pisciunerraanemnek."
        },
        "136": {
            "start": 1087.33,
            "end": 1094.78,
            "transcript": "Tepngelria tekilluni nangnirpailemteni [?] catairrluni cali pilliniluku."
        },
        "137": {
            "start": 1094.78,
            "end": 1102.24,
            "transcript": "[?] mayuqanirlua, tua-i-ll' uitainanemni anuqem tekiarrlunuk naken piciunani."
        },
        "138": {
            "start": 1102.24,
            "end": 1109.89,
            "transcript": "Niitarpuk qalrialria tulukarugtun maaten nasaurlurtangqellinilria."
        },
        "139": {
            "start": 1109.89,
            "end": 1119.0,
            "transcript": "Aruqiluni iqluuni [?] can'get-llu tamarmeng tungmagtenqiggluki, caarkaiteqallrulrianga [?] nasaurluullra."
        },
        "140": {
            "start": 1119.0,
            "end": 1130.0,
            "transcript": "Tua-ll teguluku [?] caarkaiteqallruunga tau͡gaam una nasaurluq, nasaurluqapiggluni cali."
        },
        "141": {
            "start": 1130.0,
            "end": 1134.13,
            "transcript": "Tau͡gaam cuqkeksaitaqa kitumun ayuqulluku pektellria."
        },
        "142": {
            "start": 1134.13,
            "end": 1143.64,
            "transcript": "Ingsuuq Antigone-iiq agu."
        },
        "143": {
            "start": 1143.64,
            "end": 1148.0,
            "transcript": "Tangerqernga elpet-qaa piksaitaten?"
        },
        "144": {
            "start": 1148.0,
            "end": 1151.0,
            "transcript": "Iqlunritua piciuguq."
        },
        "145": {
            "start": 1151.0,
            "end": 1157.0,
            "transcript": "Kiiki ani assiriuten umyuarteqi ayaginiluten."
        },
        "146": {
            "start": 1157.0,
            "end": 1161.13,
            "transcript": "Kitek tua-i Antigone-iiq qanrusnga assircaarluten."
        },
        "147": {
            "start": 1161.13,
            "end": 1169.0,
            "transcript": "Nallunritan-qaa man'a qungicaamek inerquutangqellra? Kiuvailegpet umyuarteqkina yuullren umyuaqluku."
        },
        "148": {
            "start": 1169.0,
            "end": 1172.0,
            "transcript": "Inerquuten tamalkuan nallunritaqa."
        },
        "149": {
            "start": 1172.0,
            "end": 1175.52,
            "transcript": "Tua-i-llu-qaa man'a inerquun navvgu qaill' pillerkaa nallunritan?"
        },
        "150": {
            "start": 1175.52,
            "end": 1181.0,
            "transcript": "Nallunricaaqaqa. Tau͡gaam quinruut inerquutavni. Ak'allaungertangqerrluni-llu inerquutanek."
        },
        "151": {
            "start": 1181.0,
            "end": 1190.37,
            "transcript": "Tuqullerkaqa tekicaaqan ilutequtekngaitaa, yuunrim tekitelaraakut."
        },
        "152": {
            "start": 1190.37,
            "end": 1194.37,
            "transcript": "Tuqullerkaqa tekicaaqan umyuarniurngaitua."
        },
        "153": {
            "start": 1194.37,
            "end": 1200.58,
            "transcript": "Tau͡gaam unitellrukumku nakmin anngaqa qagaavet ikayuryungnaqevkenaku nutaan iluteqsartua."
        },
        "154": {
            "start": 1200.58,
            "end": 1206.25,
            "transcript": "Qanrucugngaamken usviicukekngerpenga, tau͡gaam elpet inerquutaten-llu usviitellriaruut."
        },
        "155": {
            "start": 1206.25,
            "end": 1209.0,
            "transcript": "Wiinga-ll' tau͡gaam usviitenritua."
        },
        "156": {
            "start": 1209.0,
            "end": 1215.0,
            "transcript": "Umyuara quviigtuq [?] aatamitun ayuqluni, atervauluni-llu."
        },
        "157": {
            "start": 1215.0,
            "end": 1220.41,
            "transcript": "Camek elicessiiyaaksaicugnarquq-qaa, napat-qaa teggenrret navkaaryukaartut?"
        },
        "158": {
            "start": 1220.41,
            "end": 1226.0,
            "transcript": "Qimugtet-llu ciumurranqurrait elitelartut ketiumacirteng [?] assiksagulluku, aling, nangnirtuq una."
        },
        "159": {
            "start": 1226.0,
            "end": 1238.1,
            "transcript": "Tua-ll' picurlautni aipiriluku, arnaurcetengnaqerpenga-qaa tua-i Nayagam panikngaten, kituuga arnaq una, kituuga angun nasaurlurmun akiliutekciqan."
        },
        "160": {
            "start": 1238.1,
            "end": 1248.6,
            "transcript": "Tamarpetek alqan-llu mat'um ikayuutelleq nallunritaqa, unuakumi iqumssaurluni maktellruuq tua-i-ll' enem kangrani uitaluten ak'araarnun, arnassatun cirliqtaluni."
        },
        "161": {
            "start": 1248.6,
            "end": 1251.52,
            "transcript": "Cali-qaa piyugtuten? Amlleriuq-qaa tuquteka?"
        },
        "162": {
            "start": 1251.52,
            "end": 1254.0,
            "transcript": "Cali piyuumiitua, cali imna ikgellruvkenaku."
        },
        "163": {
            "start": 1254.0,
            "end": 1260.05,
            "transcript": "Tuqusnga kitek qanauterkairutukuk, ayagnarianga anngama tungiinun caarkanka qaqiutut."
        },
        "164": {
            "start": 1260.05,
            "end": 1268.0,
            "transcript": "Tuqukegtaarluni tuqunarquq, yuut waken una maligtaquutellruut-llu, tau͡gaam elpet nasvagcetenritaten alingutait."
        },
        "165": {
            "start": 1268.0,
            "end": 1270.0,
            "transcript": "Piciunrituq tamana."
        },
        "166": {
            "start": 1270.0,
            "end": 1272.57,
            "transcript": "Kayunruuten makuni yugni alikaatget."
        },
        "167": {
            "start": 1272.57,
            "end": 1276.32,
            "transcript": "Alikutkaitut tungemnun tau͡gaam alikutkangqerciqut avalitengqellriit."
        },
        "168": {
            "start": 1276.32,
            "end": 1278.58,
            "transcript": "Canganiurutkaitua anngama tungiinun."
        },
        "169": {
            "start": 1278.58,
            "end": 1280.63,
            "transcript": "Apangaq-mi, anngaqellruan-llu-ggem cali?"
        },
        "170": {
            "start": 1280.63,
            "end": 1282.19,
            "transcript": "Ii-i, anngaaqellruaqa."
        },
        "171": {
            "start": 1282.19,
            "end": 1285.05,
            "transcript": "Ciin-mi Apangaq takaqellruniciu aipaa-ll' takaqluku?"
        },
        "172": {
            "start": 1285.05,
            "end": 1287.7,
            "transcript": "Apangam tuaten taringyanritaa."
        },
        "173": {
            "start": 1287.7,
            "end": 1290.86,
            "transcript": "Cangallruvkenaku niiculria wall'u niicuilnguq ciuniuryaraten."
        },
        "174": {
            "start": 1290.86,
            "end": 1293.85,
            "transcript": "Kituulriaten atanirciqsiki tuqumalriit."
        },
        "175": {
            "start": 1293.85,
            "end": 1298.46,
            "transcript": "Kituulriaten kina qerrusngaitaa uitacurlagluni anerneret uitaviitni."
        },
        "176": {
            "start": 1298.46,
            "end": 1302.66,
            "transcript": "Kituulriaten kina qerruciiqa kaigluni wall' asqialliqluni."
        },
        "177": {
            "start": 1302.66,
            "end": 1306.0,
            "transcript": "Kituulriaten makut ciuniurciqsiki."
        },
        "178": {
            "start": 1306.0,
            "end": 1310.0,
            "transcript": "Inglun tua-i tuqukan ilaksaguciiqan takaqsagulluku-llu?"
        },
        "179": {
            "start": 1310.0,
            "end": 1314.63,
            "transcript": "Wiinga man'a kenkun tuvqakerrlainalararqa. Equtka pivkenaku."
        },
        "180": {
            "start": 1314.63,
            "end": 1322.44,
            "transcript": "Tuqu kitek! Tua-i-ll' kenkuten peksaggluku [?] anerneret uitaviitni. Arnauguten, cali qaillun qanrusciigatarpenga man'a nunaput qaill' arulacesqelluku."
        },
        "181": {
            "start": 1323.35,
            "end": 1326.2,
            "transcript": "Tangrriu ingna! Ismene-iuguq."
        },
        "182": {
            "start": 1326.2,
            "end": 1331.13,
            "transcript": "Ingsuuq! Ismene-iiq! Mat'umek-ll' ikayugyutellruuten, alartenritua-qaa?"
        },
        "183": {
            "start": 1331.14,
            "end": 1336.47,
            "transcript": "Nemni uitalartuten, qavaraqluten, ilanka ilagarluki, tua-i-ll' aliarluni auka melugaluku."
        },
        "184": {
            "start": 1336.47,
            "end": 1340.4,
            "transcript": "Camek kiutekangqercit? Ikayutellruuten-qaa Nurauq qungilluku?"
        },
        "185": {
            "start": 1340.42,
            "end": 1349.11,
            "transcript": "Antigone-iiq, wiinga, ii-i! Elliitun amllertalrianek avalitengqertua."
        },
        "186": {
            "start": 1349.11,
            "end": 1356.0,
            "transcript": "Iqluuten Ismene-iiq, ikayuryunritaanga anngaak qessallruuq wii kiima pillruaqa."
        },
        "187": {
            "start": 1356.0,
            "end": 1360.0,
            "transcript": "Alangqanrituten pillerpenek elgartesqumanritamken kiirrarpet."
        },
        "188": {
            "start": 1360.0,
            "end": 1363.0,
            "transcript": "Nantellrusit qungitengnaqlemni Nurauq?"
        },
        "189": {
            "start": 1363.0,
            "end": 1366.0,
            "transcript": "Tuqukuvet tuquyugtua unicaqunii kiirrarma."
        },
        "190": {
            "start": 1366.0,
            "end": 1369.0,
            "transcript": "Tuquyugtekarkaituten ilagautellrunrituten."
        },
        "191": {
            "start": 1369.0,
            "end": 1372.0,
            "transcript": "Qaillun-mi yuut akaringqerrsartua [?] elpet cataunak?"
        },
        "192": {
            "start": 1372.0,
            "end": 1377.87,
            "transcript": "Apesgu Creon-aq Angakan, eniini uitalartuten, inerquutai maligtaqularaten."
        },
        "193": {
            "start": 1377.87,
            "end": 1380.25,
            "transcript": "Apesgu mat'um yullrem ayuqucia."
        },
        "194": {
            "start": 1380.25,
            "end": 1385.0,
            "transcript": "Ciin tua-i aknirtengnaqvakarcia? Ciin wanirpak?"
        },
        "195": {
            "start": 1385.0,
            "end": 1388.04,
            "transcript": "Pitsaqenritamken Al'a, pitsaqenritamken."
        },
        "196": {
            "start": 1388.04,
            "end": 1389.43,
            "transcript": "Ikayuryugamken."
        },
        "197": {
            "start": 1389.43,
            "end": 1390.64,
            "transcript": "Yuusqumaamken."
        },
        "198": {
            "start": 1390.64,
            "end": 1393.0,
            "transcript": "Elpet kiivet ilaksagutamken."
        },
        "199": {
            "start": 1393.0,
            "end": 1395.67,
            "transcript": "Ciungani maligtaquvkenanuk pillruukuk."
        },
        "200": {
            "start": 1395.67,
            "end": 1400.0,
            "transcript": "Unguvanaluten cucukellruuten, wiinga-llu cucuklua tuqunalua."
        },
        "201": {
            "start": 1400.0,
            "end": 1402.66,
            "transcript": "Qanrutengnaqsaaqellruamken qanru'..."
        },
        "202": {
            "start": 1402.66,
            "end": 1407.0,
            "transcript": "Yuut avalitekngaitaatgen, Ismene. Pillruuten pillerkarpenek ak'a?"
        },
        "203": {
            "start": 1407.0,
            "end": 1410.0,
            "transcript": "Mat'um nalliini assiilngurmun [?] avalitengqertukuk."
        },
        "204": {
            "start": 1410.0,
            "end": 1416.51,
            "transcript": "Tamamegnuk pinritukuk, Ismene. Elpenek makluten Ismene-iiq. Makluten cali unguva."
        },
        "205": {
            "start": 1416.51,
            "end": 1421.87,
            "transcript": "Tamarmek usviituk! Aipaa usviiqurallruuq yuurqanerminek aipaa-llu nutaan anguluku."
        },
        "206": {
            "start": 1421.87,
            "end": 1424.28,
            "transcript": "Qaillun-mi yuuyarcia Antigone-iiq cataunaku?"
        },
        "207": {
            "start": 1424.28,
            "end": 1428.0,
            "transcript": "Antigone-mek qanaaviiqnak, Antigone-iq tuqumalriatun ayuquq."
        },
        "208": {
            "start": 1428.0,
            "end": 1432.0,
            "transcript": "Qetunraan uikaqsaaqellrua, tuqucaran-qaa ukurraan?"
        },
        "209": {
            "start": 1432.0,
            "end": 1435.39,
            "transcript": "Nunam qaingani allamnek arnatangqertuq."
        },
        "210": {
            "start": 1435.39,
            "end": 1439.0,
            "transcript": "Qetunraqa allamek nuliarkaminek nalkucugngauq."
        },
        "211": {
            "start": 1439.0,
            "end": 1442.21,
            "transcript": "Tau͡gaam ayuqenriartaituq Antigone-iinkunek Haemon-aaq-llu."
        },
        "212": {
            "start": 1442.21,
            "end": 1445.0,
            "transcript": "Qetunraama kassuusngaitaa una arnacaluq!"
        },
        "213": {
            "start": 1445.0,
            "end": 1448.0,
            "transcript": "Haemon-aaq, aatavet qanellri niiteski."
        },
        "214": {
            "start": 1448.0,
            "end": 1451.0,
            "transcript": "Tuqlunqigcaqunaku qetunrama atra."
        },
        "215": {
            "start": 1457.61,
            "end": 1461.37,
            "transcript": "Una-qaa arnaq teguyaran qetunrarpenek?"
        },
        "216": {
            "start": 1461.37,
            "end": 1466.97,
            "transcript": "Wiinga pingaitaqa tegganeq. Tuqum. Tuqum teguciqaa una arnaq qetunramnek."
        },
        "217": {
            "start": 1466.97,
            "end": 1472.0,
            "transcript": "Una-qaa piciuguq Creon-aaq? Ingna-qaa Antigone-iiq tuqugarkauguq?"
        },
        "218": {
            "start": 1472.0,
            "end": 1476.49,
            "transcript": "Camek unitellrunritaanga cucuklirkaamni. Tua-i piarkaurtuq nallunairutuq."
        },
        "219": {
            "start": 1476.49,
            "end": 1480.81,
            "transcript": "Ingkuuk nem'un itertek, enem ilua arnat uitavikegtaarauguq."
        },
        "220": {
            "start": 1480.81,
            "end": 1484.45,
            "transcript": "Tua-i caprirtaarluten tuqumek qanaavagcit Antigone-iiq."
        },
        "221": {
            "start": 1484.45,
            "end": 1489.0,
            "transcript": "Tau͡gaam patagturpek'nak nalluciqamteggen natmun ayakuvet."
        },
        "222": {
            "start": 1619.43,
            "end": 1624.67,
            "transcript": "Haemon-aaq qetunramaa. Niitellruan man'a assiilnguq picirkiutelqa arnavet tungiinun."
        },
        "223": {
            "start": 1624.73,
            "end": 1631.34,
            "transcript": "Taiguten-qaa maavet qenerrluten, wall'u ilakurqiluk ciuliqatengulua waten pivkallruanga?"
        },
        "224": {
            "start": 1631.38,
            "end": 1635.84,
            "transcript": "Elpet aatakamken. Maligtaquralarciqanka inerquuceten."
        },
        "225": {
            "start": 1635.84,
            "end": 1641.0,
            "transcript": "Tau͡gaam kassuuyaurqainligkuma [?], aliayugturalaryartua."
        },
        "226": {
            "start": 1646.22,
            "end": 1653.0,
            "transcript": "Quyana qetunramaa. Quyana tamakunek qanaakegtaallerpenek."
        },
        "227": {
            "start": 1653.0,
            "end": 1659.73,
            "transcript": "Qanaalten tamakut aataulriani niicugnarqut, man'a cap'aqa Haemon-aaq."
        },
        "228": {
            "start": 1659.73,
            "end": 1665.79,
            "transcript": "Una arnaq nakmiin ilakaput. Arnaq-qaa qetunrama caniani qavalartuq?"
        },
        "229": {
            "start": 1665.79,
            "end": 1673.81,
            "transcript": "Tau͡gaam tamana naguteksuumiitaqa. Angutem ataniurciigalkaku nem'i qaill' ataniurciqaku nunani?"
        },
        "230": {
            "start": 1673.81,
            "end": 1678.87,
            "transcript": "Nuna angucetun piniacartuq, arulaircelluni ingluminun."
        },
        "231": {
            "start": 1678.87,
            "end": 1686.99,
            "transcript": "Yuullma qaingani elitellruunga, maligtaqunaluki makut ciuliqagtemta qaneryarallrit, cali yuut pisqumayaaqanka ayuqluki."
        },
        "232": {
            "start": 1686.99,
            "end": 1691.42,
            "transcript": "Inerquutet cataunaki cauyanritukut makumiut umyuaqluki."
        },
        "233": {
            "start": 1691.42,
            "end": 1697.54,
            "transcript": "Kangingqerrnganani tamana qanellren Creon-aaq. Ciuqlirmek picingssaagyuksaaqellruamken."
        },
        "234": {
            "start": 1697.54,
            "end": 1703.41,
            "transcript": "Qenertevkenak quvigpeknak-llu, tau͡gaam tamana umyuarqerraluku qanaangama [?]."
        },
        "235": {
            "start": 1703.41,
            "end": 1709.0,
            "transcript": "Aat, taringumallemni yuum arcaqautait murilkun assinqerrauguq."
        },
        "236": {
            "start": 1709.0,
            "end": 1714.0,
            "transcript": "Niicugninaluki pillruunga taillren man'a ciuliqagtenun cali yugnun allanun maani."
        },
        "237": {
            "start": 1714.0,
            "end": 1724.5,
            "transcript": "Qemagcimaaput umyuaqutkegtaarauceten, tau͡gken yuut nunamteńi alingaqluteng qanlerqameg' [?], elpet ciuliqagtenguavet quvigluten."
        },
        "238": {
            "start": 1724.5,
            "end": 1733.42,
            "transcript": "Tuamek-im ayagyuarulua elitellruunga arcangraan wall'u yuk umyuartengraan niicugniarkaugai wall'u ciuliqag'"
        },
        "239": {
            "start": 1733.7,
            "end": 1741.0,
            "transcript": "Niicugniqerru atam tauna qetunraan Creon-aaq. Usvituluni qanaaguq, tamarpetek usvitulutek qanaagutek."
        },
        "240": {
            "start": 1741.0,
            "end": 1746.0,
            "transcript": "Qanertuten-qaa allrakurtellren [?] niicugnisqellua, cali-llu nallunrilngurmek tan'gurrarmek."
        },
        "241": {
            "start": 1746.0,
            "end": 1750.12,
            "transcript": "Wiinga allrakuqa avalitngungaituq. Qanaallrukuma piciulriamek."
        },
        "242": {
            "start": 1750.12,
            "end": 1752.88,
            "transcript": "Piciulriamek qanaalriaten tua-i-ll' yuurusketen ingluput."
        },
        "243": {
            "start": 1752.88,
            "end": 1756.4,
            "transcript": "Inglumeggnuk qanaanritua, Antigone-iim qanaayaaqua."
        },
        "244": {
            "start": 1756.4,
            "end": 1758.88,
            "transcript": "Inerquutet maligtaqutengricestain inglukapuk."
        },
        "245": {
            "start": 1758.88,
            "end": 1761.52,
            "transcript": "Uum-qaa arnam maligtaquksuitai inerquutaput?"
        },
        "246": {
            "start": 1761.52,
            "end": 1764.48,
            "transcript": "Yuut umyuarteqellruuten maligngaitekluku Antigone-iq."
        },
        "247": {
            "start": 1764.48,
            "end": 1767.07,
            "transcript": "Nunamta yuin kinkuulriameng qaill' ataniurtatnga?"
        },
        "248": {
            "start": 1767.07,
            "end": 1769.1,
            "transcript": "Tua-i-ll' una qaillun qanaaga tan'gurra'arcetun?"
        },
        "249": {
            "start": 1769.1,
            "end": 1771.05,
            "transcript": "Wiinga ciuliqagtengua ukunun nunanun."
        },
        "250": {
            "start": 1771.05,
            "end": 1772.52,
            "transcript": "Elpet nunaunrituten."
        },
        "251": {
            "start": 1772.52,
            "end": 1774.26,
            "transcript": "Ciuliqagtenguunga-ggem!"
        },
        "252": {
            "start": 1774.64,
            "end": 1779.2,
            "transcript": "Imarpiim cikum qaingani kiirrarpet ciuliqagtengukumta assinruciquten."
        },
        "253": {
            "start": 1779.2,
            "end": 1783.0,
            "transcript": "Quvigluten qanaalriaten aatavnun. Tangrraqa yuurucillernun uumun arnamun."
        },
        "254": {
            "start": 1783.0,
            "end": 1784.79,
            "transcript": "Elpet arcaqakluten piyaaqamken."
        },
        "255": {
            "start": 1784.79,
            "end": 1788.63,
            "transcript": "Wiinga-qaa ciuqamni nangengqaluten arivtaarluten-llu?"
        },
        "256": {
            "start": 1788.63,
            "end": 1791.2,
            "transcript": "Elpet tau͡gaam aturan iqlutmun."
        },
        "257": {
            "start": 1791.2,
            "end": 1794.39,
            "transcript": "Alangqaunga-qaa atanruciima qigciyuutekelqa?"
        },
        "258": {
            "start": 1794.39,
            "end": 1797.84,
            "transcript": "Antigone-iim kiingan qanaanritua."
        },
        "259": {
            "start": 1797.92,
            "end": 1801.1,
            "transcript": "Qanaayaaqua wangkunun tamamteńun."
        },
        "260": {
            "start": 1801.1,
            "end": 1804.02,
            "transcript": "Kaiyulriarunrituten! Elpet arnam pistekaaten."
        },
        "261": {
            "start": 1804.02,
            "end": 1806.4,
            "transcript": "Wiinga pistenguunga piciulriamun."
        },
        "262": {
            "start": 1806.4,
            "end": 1810.56,
            "transcript": "Aa, piciulriamunemta-qaa qangvaq Antigone-im manillruagu piciulria."
        },
        "263": {
            "start": 1810.56,
            "end": 1815.72,
            "transcript": "Antigone-iim kiingan qanaanritua. Qanaayaaqua wangkunun tamamteńun."
        },
        "264": {
            "start": 1815.72,
            "end": 1818.0,
            "transcript": "Arnauten tuquqatartuq, Haemon-aaq."
        },
        "265": {
            "start": 1818.0,
            "end": 1819.68,
            "transcript": "Tuqungaituq kiimi."
        },
        "266": {
            "start": 1819.68,
            "end": 1821.76,
            "transcript": "Alingcetaararpenga-qaa?"
        },
        "267": {
            "start": 1821.76,
            "end": 1825.31,
            "transcript": "Qaillun tan'guram alingcetaaryartau kayulria ciuliqagta?"
        },
        "268": {
            "start": 1825.31,
            "end": 1830.04,
            "transcript": "Pinqigcuumiirciiqan mat'umek qanaallerpenek Haemon-aaq ukvekia."
        },
        "269": {
            "start": 1830.04,
            "end": 1831.64,
            "transcript": "Aataaq, ampi."
        },
        "270": {
            "start": 1831.64,
            "end": 1834.57,
            "transcript": "Aa, cali-am aataarluten elpet arnam pistekaaten."
        },
        "271": {
            "start": 1834.57,
            "end": 1838.4,
            "transcript": "Elpet qaneryugngauten ciutaituten cali iinginak."
        },
        "272": {
            "start": 1838.4,
            "end": 1844.16,
            "transcript": "Ak'a-qaa tangerrsugngauten tamaita. Man'a kingurcumiiciiqan."
        },
        "273": {
            "start": 1844.16,
            "end": 1848.92,
            "transcript": "Anusgu Antigone-iq, uikaa maanciiquq tangvagkarluku nuliarkani ciuqerrani aunrarcelluku."
        },
        "274": {
            "start": 1848.92,
            "end": 1851.0,
            "transcript": "Qang'a!"
        },
        "275": {
            "start": 1879.38,
            "end": 1885.09,
            "transcript": "Qang'a, qang'a, tuqusngaitan ciuqamni."
        },
        "276": {
            "start": 1885.2,
            "end": 1890.84,
            "transcript": "Nangnermek tangerqernga, angun qutegngalria cali usvillnguq,"
        },
        "277": {
            "start": 1890.84,
            "end": 1897.52,
            "transcript": "Taukut tegganret ciuqerratni qanrutsaagniaraten ciuliqastenguniluten."
        },
        "278": {
            "start": 1897.52,
            "end": 1902.24,
            "transcript": "Tamartuq Creon-aaq, tan'gurraq cakneq qenerrluni alingnarquq."
        },
        "279": {
            "start": 1902.24,
            "end": 1906.28,
            "transcript": "Ayagcessgu, nepairuciiquq."
        },
        "280": {
            "start": 1906.28,
            "end": 1914.88,
            "transcript": "Ellii tan'gurrauguq angelriamek qavangurluni, tau͡gaam nunamek [?] Antigone-iq arulaircesciigataa."
        },
        "281": {
            "start": 1914.96,
            "end": 1916.96,
            "transcript": "Antigone-iq-qaa?"
        },
        "282": {
            "start": 1916.96,
            "end": 1924.16,
            "transcript": "Teguciqapuk iterrluku-ll' nayunermun yaaqsilriamun tan'gercetellriamun yuilngurmun-llu."
        },
        "283": {
            "start": 1924.16,
            "end": 1930.72,
            "transcript": "Qungitellerkaminek arcaqayutuli qungicimaciquq unguvangraan."
        },
        "284": {
            "start": 1933.29,
            "end": 1940.54,
            "transcript": "Yulrai-iiya aiya aiya ngai-ya"
        },
        "285": {
            "start": 1940.54,
            "end": 1946.9,
            "transcript": "Yulrai-iiya aiya aiya ngai-ya"
        },
        "286": {
            "start": 1946.9,
            "end": 1963.48,
            "transcript": "Yulrai-iiya aiya aiya ngai-ya aiya aarraa aiya ii"
        },
        "287": {
            "start": 2024.92,
            "end": 2039.84,
            "transcript": "Uivaarluten."
        },
        "288": {
            "start": 2046.89,
            "end": 2057.05,
            "transcript": "Yugiyama ullagaqamken kanaqlayagamqa agumgayarani."
        },
        "289": {
            "start": 2064.07,
            "end": 2069.58,
            "transcript": "Yulrai-iiya aiya aiya ngai-ya"
        },
        "290": {
            "start": 2069.58,
            "end": 2077.91,
            "transcript": "Yulrai-iiya aiya aiya ngai-ya aiya aarraa aiyaarra"
        },
        "291": {
            "start": 2115.0,
            "end": 2122.67,
            "transcript": "Elpecesnun nangnermek qanertua, ilakluci tangerciqaqa akerta imum-llu ak'allaurtellriim ilama, nangnermek tua-i."
        },
        "292": {
            "start": 2122.67,
            "end": 2132.36,
            "transcript": "Yuuqallma nalliini aturarkauyaaqellruuten cali kalukangqerkauyaaqluten, angun maligtarkauyaaqellruaqa kassuuyucimnun acimnun, tau͡gaam ciulerkamnun ayagtua."
        },
        "293": {
            "start": 2132.36,
            "end": 2137.26,
            "transcript": "Inangqayarturlua aipaqluku tuqunaq. Tuqunaq kiingan."
        },
        "294": {
            "start": 2137.26,
            "end": 2143.86,
            "transcript": "Imuuguq Antigone-iiq, ayagciigatuten qigciiyutekaunak [?], cali-llu nakleksaunak [?] aprumaluten yuulgutevnek."
        },
        "295": {
            "start": 2143.86,
            "end": 2148.19,
            "transcript": "Tuquqatanrituten naklegtaunak cali-llu pitsaqluni tuqulluni."
        },
        "296": {
            "start": 2148.19,
            "end": 2151.64,
            "transcript": "Tau͡gaam elpet tuquqatartuten cucuklirpenek."
        },
        "297": {
            "start": 2151.64,
            "end": 2159.08,
            "transcript": "Ungagpalegtun tang ayuqellrianga yuullrani, yuullutek qayameggnek aatiin pisquciatun pikiutekellriaten imarpiim anurviinun."
        },
        "298": {
            "start": 2159.08,
            "end": 2167.58,
            "transcript": "Ataucitaarluki aatiin yuarani kepellrullinikai, tegumiaqesciigalami ak'anun kill'uni camavet imarpiim terr'anun."
        },
        "299": {
            "start": 2167.58,
            "end": 2170.81,
            "transcript": "Ungagpalek tuknilriaruuq anerneq, Antigone-iiq."
        },
        "300": {
            "start": 2170.81,
            "end": 2176.2,
            "transcript": "Yuarai-llu neqngurrluteng, taqukaurrluteng cali allat mermiutaurrluteng."
        },
        "301": {
            "start": 2176.2,
            "end": 2181.72,
            "transcript": "Ungagpalek tuknilriaruuq. Elpet kiivet arnauguten maani nunani nasaurluuguten."
        },
        "302": {
            "start": 2181.72,
            "end": 2186.57,
            "transcript": "Qacungevkararpenga, ayaggaulria-llam pillrunrituten?"
        },
        "303": {
            "start": 2186.57,
            "end": 2192.8,
            "transcript": "Kiima ullagciqaqa una tuqunaq, ayagciqua neqtangkan neqtellerkaq [?] teskiskan maavet nunamteńun."
        },
        "304": {
            "start": 2192.8,
            "end": 2196.95,
            "transcript": "Ayagciqua miknii alinglua-llu."
        },
        "305": {
            "start": 2198.4,
            "end": 2204.35,
            "transcript": "Pingnaqsaaqellruan ca imna assiryukluku Antigone-iiq. Anngaan ikayungnaqsaaqellruan."
        },
        "306": {
            "start": 2204.35,
            "end": 2209.08,
            "transcript": "Qacucetaanritamteggen. Nanrarciqamteggen taqsuunata."
        },
        "307": {
            "start": 2209.08,
            "end": 2217.56,
            "transcript": "Nanrarlua-qaa, tau͡gken aiparnirraunii man'a nangnermek yuulqa atuqumku. Tangerpegnii-llu kitumun qiagutkamnun."
        },
        "308": {
            "start": 2217.56,
            "end": 2221.96,
            "transcript": "Qanellrem-llu kayuan tuqu ayagcecugngakaku yaavet imarpiim cikuyunqigtellranun."
        },
        "309": {
            "start": 2221.96,
            "end": 2227.13,
            "transcript": "Ayausgu umegluku-llu, anlircetellriamun [?] yuilngurmun-llu."
        },
        "310": {
            "start": 2227.13,
            "end": 2237.4,
            "transcript": "Ellminek tuqucukuni tuqutniartuq wall'u unguvayukuni unguvaniartuq ak'arrarnun, tuaten auga tangvaumanritniartuq unatemegni. Wall'u anernera alangrukenritniararput."
        },
        "311": {
            "start": 2239.52,
            "end": 2247.64,
            "transcript": "Kumassuutaunii-llu-qaa tan'gercetellriami nayunermi? Kumassuutaunii tan'germi nayunermi kanaquma anerneret uitaviitni."
        },
        "312": {
            "start": 2247.64,
            "end": 2251.71,
            "transcript": "Tau͡gaam uitaciqsugnarqut uitacurlallret ilanka."
        },
        "313": {
            "start": 2251.71,
            "end": 2256.05,
            "transcript": "Utaqaluteng ciuniurnalua talligteng yaagiingaatuut."
        },
        "314": {
            "start": 2256.05,
            "end": 2262.72,
            "transcript": "Ataucitaarluteng, aataka aanaka apangaq-llu tuqullruut angnirpek'nateng anglanivkenateng-llu."
        },
        "315": {
            "start": 2262.72,
            "end": 2270.31,
            "transcript": "Ataucitaarluki kenkutaciqa aturluku eruullruanka aturirluki qungilluki, wangnun tusngaan piarkaqluku."
        },
        "316": {
            "start": 2270.37,
            "end": 2274.6,
            "transcript": "Panikegtaaraulua nayagacuungaulua-llu."
        },
        "317": {
            "start": 2274.6,
            "end": 2282.23,
            "transcript": "Nurauq-wa pingnaqsaaqellruyaaqekek'a allaunruvkenaku ilamni, ellii nangenrullruuq nangenruluni-llu."
        },
        "318": {
            "start": 2282.23,
            "end": 2294.36,
            "transcript": "Angayuqaagka catairutellrulukek allamek anngamtun ayuqellriartaicartuq. Uikellrungraamku kassuutenqigtellruyartua wall'u-q' qetunrama. Allamek qetungrangenqigtellruyartua [?]."
        },
        "319": {
            "start": 2294.36,
            "end": 2301.55,
            "transcript": "Man'a maa-i pitekluku anngama tuqutaanga taumek tuqulrianga, nalluluku qaillun assilria ayagyuam uiksaryaaqellra."
        },
        "320": {
            "start": 2301.55,
            "end": 2305.93,
            "transcript": "Wall'u mikelnguq irniaqsarluku."
        },
        "321": {
            "start": 2305.93,
            "end": 2309.64,
            "transcript": "Uitacurlagcellrukumki anerneret pitsaqenritamci."
        },
        "322": {
            "start": 2309.64,
            "end": 2313.84,
            "transcript": "Nallunriciiqaat umyuamkun assiryukluku pilqa."
        },
        "323": {
            "start": 2313.84,
            "end": 2320.17,
            "transcript": "Tau͡gaam alartellrukuma Creon-am inerquutainek canganiurutaitua."
        },
        "324": {
            "start": 2320.17,
            "end": 2328.0,
            "transcript": "Umyuarteqsaaqua anerneret cangakellrunrilkait man'a pilqa tayima unguvavkaryaraatnga tayima qaillun."
        },
        "325": {
            "start": 2328.0,
            "end": 2335.75,
            "transcript": "Anernera imarpiim anuqiitun ayuquq, caknenguaqluni tukniriaqluni, nepngaaqluni agyumcuaraqluni kinguaggun."
        },
        "326": {
            "start": 2335.75,
            "end": 2344.16,
            "transcript": "Una ciumiikesta umyuarteqsaaqeciquq camek kianun imarpiim anuqiicetun, una arnaq ayautenrilkaku patagmek wanirpak-llu."
        },
        "327": {
            "start": 2344.16,
            "end": 2346.25,
            "transcript": "Niitaqa tuquq erinarpeni."
        },
        "328": {
            "start": 2346.25,
            "end": 2349.37,
            "transcript": "Alartenrituten Antigone-iiq."
        },
        "329": {
            "start": 2351.05,
            "end": 2354.53,
            "transcript": "Elpet qanruskiki."
        },
        "330": {
            "start": 2361.33,
            "end": 2373.16,
            "transcript": "Elpet qanruskiki waken kinguanelget Antigone-iiq-gguq tuqullruuq anerneret inerquutait navegyunrilamiki. Ukvekellret ciunerinrilamiki [?]. Nutaan qanruskiki."
        },
        "331": {
            "start": 2383.12,
            "end": 2387.76,
            "transcript": "Iyaar iyaar iiya nga."
        },
        "332": {
            "start": 2387.76,
            "end": 2395.6,
            "transcript": "Iyaar iyaar iiya nga ya iiya nga."
        },
        "333": {
            "start": 2395.6,
            "end": 2403.66,
            "transcript": "Iyaar iyaar iiya nga ya iiya nga."
        },
        "334": {
            "start": 2481.17,
            "end": 2485.48,
            "transcript": "Kinakiq au͡gna atralria."
        },
        "335": {
            "start": 2485.48,
            "end": 2492.02,
            "transcript": "Kanavet imna aturviminun ya iiya nga."
        },
        "336": {
            "start": 2492.02,
            "end": 2497.68,
            "transcript": "Iyaar iyaar iiya nga ya iiya nga."
        },
        "337": {
            "start": 2497.68,
            "end": 2501.89,
            "transcript": "Iyaar iyaar iiya nga."
        },
        "338": {
            "start": 2501.89,
            "end": 2507.87,
            "transcript": "Iyaar iyaar iiya nga ya iiya nga."
        },
        "339": {
            "start": 2507.87,
            "end": 2514.02,
            "transcript": "Iyaar iyaar iiya nga ya iiya nga."
        },
        "340": {
            "start": 2533.53,
            "end": 2538.3,
            "transcript": "Tekitukut iigmek ataucimek aturluku."
        },
        "341": {
            "start": 2538.3,
            "end": 2544.81,
            "transcript": "Tamakut ayagyuat ilanka iikegcilriit wiinga igiirutellruanga."
        },
        "342": {
            "start": 2544.81,
            "end": 2547.36,
            "transcript": "Cam maavet taivkartaten angalkuuq?"
        },
        "343": {
            "start": 2547.36,
            "end": 2551.78,
            "transcript": "Ellangcarluten, ellangcarnaluten teguyugngakuvgu."
        },
        "344": {
            "start": 2551.78,
            "end": 2555.02,
            "transcript": "Niicugnilaramken ellangcaraqavet angalkuuq."
        },
        "345": {
            "start": 2555.02,
            "end": 2559.02,
            "transcript": "Taumek nunaput kayulriarulria nangtequtaunani-llu."
        },
        "346": {
            "start": 2559.02,
            "end": 2561.02,
            "transcript": "Nunuliutekalirtuten."
        },
        "347": {
            "start": 2561.02,
            "end": 2571.02,
            "transcript": "Nunuliutekaituci tungemnun, nunuliutkarartuci [?] tau͡gaam elpeci penam menglii tangvagpek'naku."
        },
        "348": {
            "start": 2571.02,
            "end": 2576.02,
            "transcript": "Alingnaqvagta tamakut qanaalten, cali qanrutqerrnga."
        },
        "349": {
            "start": 2576.02,
            "end": 2585.02,
            "transcript": "Qavangurtullruunga Creon-aaq, qavangurtuvlacaglua-llu callullriagnek yaqulegpak-llu uginarpak-llu."
        },
        "350": {
            "start": 2585.02,
            "end": 2590.73,
            "transcript": "Ella neplirlini piciatun, nuna-llu aulirluku."
        },
        "351": {
            "start": 2590.73,
            "end": 2598.02,
            "transcript": "Man'a atullruat naaqinailngurnek ernernek agayunernek-llu."
        },
        "352": {
            "start": 2598.24,
            "end": 2605.02,
            "transcript": "Tua-i-ll' tenglua pakmavet qilagmun, kailriarturlua ungungssit alainqesqelluki."
        },
        "353": {
            "start": 2605.02,
            "end": 2614.02,
            "transcript": "Tau͡gaam catailuni, pitaitellruuq, cartaitellruuq."
        },
        "354": {
            "start": 2614.02,
            "end": 2623.02,
            "transcript": "Tenglua-llu cali imarpigmi amllerlua-llu neqet alainqesqelluki."
        },
        "355": {
            "start": 2623.02,
            "end": 2628.67,
            "transcript": "Ungagpalek cali alainqesqelluku."
        },
        "356": {
            "start": 2628.67,
            "end": 2637.4,
            "transcript": "Tau͡gaam cataunani, pitaitellruuq, cartaitellruuq."
        },
        "357": {
            "start": 2640.69,
            "end": 2652.95,
            "transcript": "Anerneret qenertut Creon-aaq, kemek unitaallruami nunam qaingani, qimugteńun nerumauvkaurluni anerneret qenertut."
        },
        "358": {
            "start": 2660.52,
            "end": 2664.02,
            "transcript": "Uyamin-qaa tamana nutarauguq?"
        },
        "359": {
            "start": 2664.02,
            "end": 2669.28,
            "transcript": "Nutaranek-qaa kaviarutengqertuten pelatekarpeni?"
        },
        "360": {
            "start": 2669.28,
            "end": 2677.71,
            "transcript": "Arnatangqelliuq-llu tayima. Tegganret nasaurlurkaitnek akilirluten taisqelluten ciuqamnun uumek pisia piciunrilngurmek."
        },
        "361": {
            "start": 2677.71,
            "end": 2681.56,
            "transcript": "Aa Creon-aaq yugmek-qaa yugtai'..."
        },
        "362": {
            "start": 2681.56,
            "end": 2684.92,
            "transcript": "Nutaan-atam allamek aturyugngamteńek qaneryarrautevnek!"
        },
        "363": {
            "start": 2684.92,
            "end": 2688.67,
            "transcript": "Yugmek-qaa yugtaituq nallunrilkengamnek arcaqautemnek?"
        },
        "364": {
            "start": 2688.67,
            "end": 2690.76,
            "transcript": "Tamana assissiyaanricaaqvagta."
        },
        "365": {
            "start": 2690.76,
            "end": 2692.11,
            "transcript": "Usviilnguq angun!"
        },
        "366": {
            "start": 2692.11,
            "end": 2694.02,
            "transcript": "Ingluku'uryuumiitaqa angalkuk?"
        },
        "367": {
            "start": 2694.02,
            "end": 2696.02,
            "transcript": "Iqlungarlua-qaa piarpenga?"
        },
        "368": {
            "start": 2696.02,
            "end": 2700.02,
            "transcript": "Nallunrilkeka-wa angalkut akiliraqameng maligtaqucukaarallret."
        },
        "369": {
            "start": 2700.02,
            "end": 2702.88,
            "transcript": "Qenerqayuliit atanercetnun?"
        },
        "370": {
            "start": 2702.88,
            "end": 2704.62,
            "transcript": "Kitumnun-qaa qanaalten nallunritan?"
        },
        "371": {
            "start": 2704.62,
            "end": 2711.02,
            "transcript": "Angutmun qanaagua ciuliqagtengulriamun nunaminun?"
        },
        "372": {
            "start": 2711.02,
            "end": 2716.88,
            "transcript": "Qanenritua assiitniluten wall'u kayulriarunritniluten. Tau͡gaam iliini qunum pilaraaten."
        },
        "373": {
            "start": 2716.88,
            "end": 2724.0,
            "transcript": "Cumikekina! Qenevkaryuararpenga qavanguma ilait man'a qanrutevkaryuaraten elpenun."
        },
        "374": {
            "start": 2724.0,
            "end": 2727.02,
            "transcript": "Kiiki qanrusnga."
        },
        "375": {
            "start": 2727.02,
            "end": 2733.02,
            "transcript": "Akiliryugciqerpenga man'a qavangiasqelluku [?] Creon-aaq"
        },
        "376": {
            "start": 2733.51,
            "end": 2738.02,
            "transcript": "Kiiki qanrusnga tau͡gaam umyuarteqsaqunak akilirnayukluten."
        },
        "377": {
            "start": 2748.65,
            "end": 2753.65,
            "transcript": "Akerta Creon-aaq, akerta atakuartuq."
        },
        "378": {
            "start": 2753.65,
            "end": 2757.64,
            "transcript": "Erpailgan cali tuqucillren akimiarumaciquq [?]."
        },
        "379": {
            "start": 2757.64,
            "end": 2763.02,
            "transcript": "Miklengurmek-am qaunqillruuten, nauwa qamiqun put'ellrunrilken."
        },
        "380": {
            "start": 2764.21,
            "end": 2773.02,
            "transcript": "Yuum-llu yuullra elpet piaqluni tegganret-llu nunamteńi elpet auluksiinaki."
        },
        "381": {
            "start": 2774.39,
            "end": 2780.62,
            "transcript": "Uumek-qaa narulkam taivkaraaten, nunamteńi tangssirciqaten [?] tegganret quyuaritnek."
        },
        "382": {
            "start": 2780.62,
            "end": 2789.6,
            "transcript": "Tangrru. Una ekualria nepngaitaa mer'em wall' anuqem. Augum tau͡gaam auganek Creon-aam, auget auganek."
        },
        "383": {
            "start": 2789.6,
            "end": 2796.42,
            "transcript": "Una elliyarturru Creon-am eniinun, tumqiurciqai makut taigarkat."
        },
        "384": {
            "start": 2798.33,
            "end": 2811.29,
            "transcript": "Creon-aam nallunriyullruan, tua-i nallunriran. Quvigluten nangerallrulriaten nauwa qamiqun put'ellrunrilken."
        },
        "385": {
            "start": 2811.29,
            "end": 2816.49,
            "transcript": "Tua-i, taiqaa aipa [?]."
        },
        "386": {
            "start": 2816.49,
            "end": 2825.02,
            "transcript": "Ayagnariakut. Qanrarkapuk ak'a. Qaqituq. Ayagnariakut."
        },
        "387": {
            "start": 2825.02,
            "end": 2831.02,
            "transcript": "Tamartuq Creon-aaq, yuum-qaa taktaciatun nutaan taringauq alangqatacia."
        },
        "388": {
            "start": 2831.02,
            "end": 2841.76,
            "transcript": "Nallunritaqa, nallunritaqa... wii uunguciitua, tau͡gaam..."
        },
        "389": {
            "start": 2841.76,
            "end": 2846.02,
            "transcript": "Niicugniqaa atam, niicugniten [?] maligtaquniaraten."
        },
        "390": {
            "start": 2846.02,
            "end": 2855.02,
            "transcript": "Ii-i... ii-i, qanrusnga qaillun pisqellua, qanrusnga qaill' piciatun piciqaqa."
        },
        "391": {
            "start": 2855.02,
            "end": 2861.02,
            "transcript": "Arnaq unguvaluku qungitellren ayagcessgu, angun-llu tuqumalria qungilluku!"
        },
        "392": {
            "start": 2861.02,
            "end": 2866.6,
            "transcript": "Qungilluku angun tuqumalria? Tamatumek piarkangqertua? Taq'ilua-qaa?"
        },
        "393": {
            "start": 2866.6,
            "end": 2872.02,
            "transcript": "Patagmek, anerneret pinarii, atakuq taiguq, cukangnaqluten!"
        },
        "394": {
            "start": 2872.02,
            "end": 2876.29,
            "transcript": "Man'a caperrnarqellriaruuq, caperrnaqluni-llu."
        },
        "395": {
            "start": 2876.29,
            "end": 2880.29,
            "transcript": "Tau͡gaam ciuniusciigataqa, tua-i maaten maligtaqulii."
        },
        "396": {
            "start": 2880.29,
            "end": 2883.7,
            "transcript": "Patagmek cass'atairutuq, elpet piarkaugan!"
        },
        "397": {
            "start": 2883.7,
            "end": 2886.9,
            "transcript": "Merniurcaryaqunak caarkat tau͡gaam qaqiskata!"
        },
        "398": {
            "start": 2886.9,
            "end": 2892.02,
            "transcript": "Merniunircirlua, qang'a, qang'a ayagnarianga."
        },
        "399": {
            "start": 2937.07,
            "end": 2945.02,
            "transcript": "Nakleng kinguliarkaqa. Kanavirallinilria."
        },
        "400": {
            "start": 2945.02,
            "end": 2958.91,
            "transcript": "Maqikailami. Angayiirriya agiya yiirriya yiirri yarra yiiya ii."
        },
        "401": {
            "start": 2966.17,
            "end": 2975.18,
            "transcript": "Nakleng kinguliarkaqa. Kanavirallinilria."
        },
        "402": {
            "start": 2975.18,
            "end": 2987.06,
            "transcript": "Ellacuayaarmun. Angayiirriya agiya yiirriya yiirri yarra yiiya ii."
        },
        "403": {
            "start": 2987.61,
            "end": 2995.03,
            "transcript": "Arulallalaku arulallalaku."
        },
        "404": {
            "start": 2995.03,
            "end": 3005.04,
            "transcript": "Angayiirriya agiya yiirriya yiirri yarra yiiya iirrii."
        },
        "405": {
            "start": 3014.65,
            "end": 3021.55,
            "transcript": "Tegganeq, ak'alleq ellaqliq. Naulluugua mernurlua-llu."
        },
        "406": {
            "start": 3021.55,
            "end": 3027.07,
            "transcript": "Atakurpak alianarqellrianek tangellruunga, nep'ut-llu man'a allaurrluni."
        },
        "407": {
            "start": 3027.07,
            "end": 3034.02,
            "transcript": "Creon-am kaiyua [?] tukua-llu aglumanaryaaqellruaqa tau͡gaam aglumayuirutaqa."
        },
        "408": {
            "start": 3034.02,
            "end": 3036.78,
            "transcript": "Cauga? Ca pillrua?"
        },
        "409": {
            "start": 3036.78,
            "end": 3039.83,
            "transcript": "Tuquq alairtuq, yuumalriit alaivkarluku."
        },
        "410": {
            "start": 3039.83,
            "end": 3041.02,
            "transcript": "Kina tuqua?"
        },
        "411": {
            "start": 3041.02,
            "end": 3044.02,
            "transcript": "Haemon-aaq tuquuq, tua-i-w' aatani tuqucillruat."
        },
        "412": {
            "start": 3044.02,
            "end": 3045.23,
            "transcript": "Aatiin-qaa?"
        },
        "413": {
            "start": 3045.23,
            "end": 3049.35,
            "transcript": "Qang'a, ellminek tuqutellruuq."
        },
        "414": {
            "start": 3049.35,
            "end": 3060.19,
            "transcript": "Angalkuuq, angalkuuq, ak'anivkenateng ak'a qavanguten piciurtellriit."
        },
        "415": {
            "start": 3060.19,
            "end": 3064.02,
            "transcript": "Caciqceńugmi, wanirpak cayarteńuk?"
        },
        "416": {
            "start": 3064.02,
            "end": 3070.02,
            "transcript": "Tangrriu ingna, aanauguq, qanarkangqelliuq qetunraminek."
        },
        "417": {
            "start": 3070.02,
            "end": 3077.02,
            "transcript": "Qanqalrianga qaneltek niitellruanka, qaneltek niitellruanka qetunrama Haemon-aamek."
        },
        "418": {
            "start": 3077.02,
            "end": 3081.03,
            "transcript": "Qanrusnga qaill' pillrua."
        },
        "419": {
            "start": 3082.79,
            "end": 3092.02,
            "transcript": "Nunanirqellriamek-kiq quliramek qanemcitqerlaken, tau͡gaam iqlungaryartua, tau͡gaam tamalkuan niiciiqan."
        },
        "420": {
            "start": 3092.39,
            "end": 3097.58,
            "transcript": "Amllerrluta ayagaurtellriakut uin maliggluku tuqlullrani-llu."
        },
        "421": {
            "start": 3097.58,
            "end": 3101.02,
            "transcript": "Ciumek Nuraum qungisvianun agluta."
        },
        "422": {
            "start": 3101.02,
            "end": 3106.4,
            "transcript": "Tekipailemteku tangrraput tulukaruut qimugtet-llu ak'a pillrullinikiit."
        },
        "423": {
            "start": 3106.4,
            "end": 3109.02,
            "transcript": "Tua-ll' piarkaput qaqilluki."
        },
        "424": {
            "start": 3109.02,
            "end": 3113.02,
            "transcript": "Qungicuvigkaanek taqulluta kemga tamarmi uitanrilengraan."
        },
        "425": {
            "start": 3113.02,
            "end": 3119.57,
            "transcript": "Tuamtell' cukangnaqluta aqvaqurlumun nayunermun agluta. Antigone-iurluum uitavianun."
        },
        "426": {
            "start": 3119.57,
            "end": 3125.19,
            "transcript": "Tekipailemteggu niilluta qialriamek Creon-am qetunraqaliniiken niilluku."
        },
        "427": {
            "start": 3125.19,
            "end": 3128.71,
            "transcript": "Creon-llu keggina qakiqerrluni qanerluni-llu,"
        },
        "428": {
            "start": 3128.71,
            "end": 3133.02,
            "transcript": "Alingua. Yuuqallemni makut assiilqurraaqciiqanka."
        },
        "429": {
            "start": 3133.02,
            "end": 3138.02,
            "transcript": "Tuamtell' cukangnaqluta aqvaqurluta nayunermun Antigone-im uitavianun."
        },
        "430": {
            "start": 3138.02,
            "end": 3142.6,
            "transcript": "Maaten tangrraput amiigan navgumaluni."
        },
        "431": {
            "start": 3142.6,
            "end": 3150.12,
            "transcript": "Iluani Antigone-iq ilavkuq ellminek qillrutellrulliniluni agarrluni-llu."
        },
        "432": {
            "start": 3150.12,
            "end": 3154.99,
            "transcript": "Tua-i-ll' tuaten imna nalkellrulliniluku qell'uku-llu."
        },
        "433": {
            "start": 3154.99,
            "end": 3159.02,
            "transcript": "Ellminek-llu tua-i qillrutliniluni canianun."
        },
        "434": {
            "start": 3159.02,
            "end": 3162.3,
            "transcript": "Tua-ll' aatiin arulaircetengnaqsaaqekii."
        },
        "435": {
            "start": 3162.3,
            "end": 3167.63,
            "transcript": "Haemon-aam cavigaq teguluku aataminun urniucaaqluku."
        },
        "436": {
            "start": 3167.63,
            "end": 3171.02,
            "transcript": "Tau͡gaam aatii agturcetevkenani."
        },
        "437": {
            "start": 3171.02,
            "end": 3179.99,
            "transcript": "Tua-ll' arulaircetengnaqsaaqekii Haemon-aaq usviilngurtun ayuqluni tauna caviggaq teguluku kapulluku ircaquminun."
        },
        "438": {
            "start": 3179.99,
            "end": 3189.85,
            "transcript": "Kingutmun tuqulluni, Antigone-iurluum kegginaanun tull'uni catairulluni."
        },
        "439": {
            "start": 3192.35,
            "end": 3196.24,
            "transcript": "Aanaaq, ciuqamteńi piunrirluni."
        },
        "440": {
            "start": 3211.48,
            "end": 3213.71,
            "transcript": "Nepailnguum alingevkaraanga."
        },
        "441": {
            "start": 3213.71,
            "end": 3218.68,
            "transcript": "Paqteqerlauk usviilkarcuartuq."
        },
        "442": {
            "start": 3220.38,
            "end": 3225.02,
            "transcript": "Creon-aaq, Creon-aaq."
        },
        "443": {
            "start": 3225.02,
            "end": 3232.35,
            "transcript": "Qaneng'erpeci piciatun aknirrngairutua, tangellruaqa tamalkuan, elpekluku-ll' tamalkuan."
        },
        "444": {
            "start": 3232.35,
            "end": 3240.02,
            "transcript": "Tangvagtuci angutmek qetunraminek tuqucillermek qangiarminek nunaniryutminek-llu."
        },
        "445": {
            "start": 3240.02,
            "end": 3244.41,
            "transcript": "Maani tuqullret amlleriut, tua-i."
        },
        "446": {
            "start": 3244.41,
            "end": 3249.23,
            "transcript": "Nunakuami [?] nunanirqellriartangqerciiquq."
        },
        "447": {
            "start": 3249.75,
            "end": 3254.54,
            "transcript": "Ciin pillrua? Caullrua?"
        },
        "448": {
            "start": 3254.54,
            "end": 3261.02,
            "transcript": "Tunrangayiim itellruanga. Nalluaqa. Tunrangayiilkum-wa."
        },
        "449": {
            "start": 3261.02,
            "end": 3269.02,
            "transcript": "Nalluaqa. Yuurtellruukut maavet nunamun caperrnarqellriamun nunaniryugngaunata-llu."
        },
        "450": {
            "start": 3271.02,
            "end": 3275.88,
            "transcript": "Cali tau͡gaam pitangqertuq, Creon-aaq, nevni pitangqertuq."
        },
        "451": {
            "start": 3275.88,
            "end": 3277.32,
            "transcript": "Camek pitangqerta?"
        },
        "452": {
            "start": 3277.32,
            "end": 3284.02,
            "transcript": "Nuliarpenek elpenek tuqutellruuq, tua-i-q' qetunraagni tuqullruagnek?"
        },
        "453": {
            "start": 3284.02,
            "end": 3290.64,
            "transcript": "Angalkuum qavanguan man'a ilakaa matuusciigatuq."
        },
        "454": {
            "start": 3290.64,
            "end": 3297.65,
            "transcript": "Wall'u-qaa wiinguunga? Tuqucillren qanertuq, akinaurumaciqniluku."
        },
        "455": {
            "start": 3297.65,
            "end": 3301.79,
            "transcript": "Camek qanercit cali qanrusnga."
        },
        "456": {
            "start": 3301.79,
            "end": 3304.0,
            "transcript": "Elpenek paqesgu."
        },
        "457": {
            "start": 3311.02,
            "end": 3321.74,
            "transcript": "Angalkuuq... angalkuuq... irniaqa tegumiaqellruaqa talliigemkun tuqumaluni."
        },
        "458": {
            "start": 3321.74,
            "end": 3326.02,
            "transcript": "Tua-i-ll' nuliaqa, nuliaqa..."
        },
        "459": {
            "start": 3327.6,
            "end": 3331.08,
            "transcript": "Qetunraminek qanellruuq ak'a tuqullermun."
        },
        "460": {
            "start": 3331.08,
            "end": 3336.34,
            "transcript": "Qetunraminek qanellruuq akwaugaq tuqullermek elpenun tuquvkallruniluki."
        },
        "461": {
            "start": 3336.34,
            "end": 3341.02,
            "transcript": "Tua-i-ll' kan'a kurpatuli narulkaan teguluku ellminek tuqulluni."
        },
        "462": {
            "start": 3341.02,
            "end": 3344.02,
            "transcript": "Nalirci elliitun piqerlia?"
        },
        "463": {
            "start": 3344.02,
            "end": 3351.02,
            "transcript": "Antigone-mek qanellruuq, ukurrarkaqsaaqellminek, elpenun call' tuquvkallruniluku."
        },
        "464": {
            "start": 3351.38,
            "end": 3352.77,
            "transcript": "Antigone-iq."
        },
        "465": {
            "start": 3352.77,
            "end": 3358.02,
            "transcript": "Aunrairluni-ll' tua-i iquluni qanenrirluni-llu."
        },
        "466": {
            "start": 3359.51,
            "end": 3366.02,
            "transcript": "Piciuguq... tuqutellruaqa. Tuqutellruanga tamalkuita."
        },
        "467": {
            "start": 3367.02,
            "end": 3373.62,
            "transcript": "Kia imum tumkiuqerlia man'a nunavut unilluku, ampi."
        },
        "468": {
            "start": 3373.62,
            "end": 3378.83,
            "transcript": "Wanirpak qanaiyunaitaaten tuaten Creon-aaq."
        },
        "469": {
            "start": 3379.33,
            "end": 3384.03,
            "transcript": "Tua-i maani tuqullret amlleriut."
        },
        "470": {
            "start": 3384.03,
            "end": 3386.97,
            "transcript": "Akerta tangenqigcuumitaqa!"
        },
        "471": {
            "start": 3386.97,
            "end": 3395.09,
            "transcript": "Creon-aaq ca piarkaq pilartuq, wangkuta aulukarkaqenritaput."
        },
        "472": {
            "start": 3395.09,
            "end": 3396.19,
            "transcript": "Qang'a tangenqig'..."
        },
        "473": {
            "start": 3396.19,
            "end": 3402.12,
            "transcript": "Creon-aaq! Tuaten qanenqigcaqunak. Ca piarkaq pilartuq."
        },
        "474": {
            "start": 3402.12,
            "end": 3408.23,
            "transcript": "Wangkuta aulukarkaqenritaput. Aulukarkaqenritaput anernercetun."
        },
        "475": {
            "start": 3408.23,
            "end": 3413.27,
            "transcript": "Pitsaqluku tuquteksaitenka tamalkuita."
        },
        "476": {
            "start": 3413.27,
            "end": 3422.37,
            "transcript": "Tangvagtuci angutmek usviilngurmek, tua-i wiinga maaken nunamteńek, ayagnarianga."
        }
    },
    "7Cajo84Yz3M": {
        "1": {
            "start": 265.35,
            "end": 270.22,
            "transcript": "Qangvaq-gguq man'a yurallren civumeng eliteqarrallrulivakaa? [?]"
        },
        "2": {
            "start": 270.33,
            "end": 276.66,
            "transcript": "Wani-gguq tan'gurracuaraulua piyuumariama."
        },
        "3": {
            "start": 276.66,
            "end": 282.54,
            "transcript": "Mikenii anguvkenii tau͡gaam angrrelua."
        },
        "4": {
            "start": 282.54,
            "end": 289.04,
            "transcript": "Elitelqaqa tamakut civuliat avaken yaaqvaneng man'a."
        },
        "5": {
            "start": 289.04,
            "end": 296.51,
            "transcript": "Eglertellriaruuq tau͡gaten yuratuluteng, keyiin piciryaraqluku yuratung'ermeng amllerneng."
        },
        "6": {
            "start": 296.51,
            "end": 300.71,
            "transcript": "Man'a tau͡ga ilakluku tauna yuratullrat."
        },
        "7": {
            "start": 300.71,
            "end": 303.8,
            "transcript": "Qayuteng alerqungqellrunganeng [?] tamaani?"
        },
        "8": {
            "start": 304.0,
            "end": 314.6,
            "transcript": "Tamaani akimiam avatiini akimiqluni nuqluku alerqungqellrungata egmian-ll' tua-i yuraryaurtellruunga."
        },
        "9": {
            "start": 314.6,
            "end": 317.74,
            "transcript": "Maa-i-rpak qayuteng alerqungqercit [?]?"
        },
        "10": {
            "start": 317.74,
            "end": 329.1,
            "transcript": "Sixty cipluku, seventy-q cip'araqluku alerqungqertua tayima alerqungqerqan [?] naumalriit nalluanka maa-i."
        },
        "11": {
            "start": 354.22,
            "end": 357.15,
            "transcript": "Eliteqarraallerpeni-kiq-qaa arnat-llu pitullruut?"
        },
        "12": {
            "start": 358.18,
            "end": 361.76,
            "transcript": "(Yes) Pituluteng tua-i tamalkurmeng arnat-llu."
        },
        "13": {
            "start": 365.74,
            "end": 371.17,
            "transcript": "Tamana-qaa keniutaq ayuqaa ak'a tamaani? (Una.)"
        },
        "14": {
            "start": 371.33,
            "end": 377.55,
            "transcript": "Una-gguq wanigg' uitaut tangelqa [?] avaken cal' makuk imna [?] tailriik."
        },
        "15": {
            "start": 377.55,
            "end": 385.19,
            "transcript": "Waten tau͡ga kiqliqlutek pitulutek inglua tegumiaqesterluku [?] agaani wii-llu tegumiaqkaqsaqluku."
        },
        "16": {
            "start": 385.19,
            "end": 389.24,
            "transcript": "Tau͡gaam pistekailami waten aliayuituq akiani."
        },
        "17": {
            "start": 417.33,
            "end": 424.78,
            "transcript": "Cauyat-qaa maa-i ayuqait wall'u-qaa (waniggun) wall'u-q' cimirtut ilait-gguq plastic-aaneng pingqetuut?"
        },
        "18": {
            "start": 424.78,
            "end": 435.43,
            "transcript": "Makut-gguq plastic-aat aliacuitellruut imkutgguq kaugpiit ukuit-llu anrutiit pingqetullruut."
        },
        "19": {
            "start": 435.43,
            "end": 439.96,
            "transcript": "Makut cauyat waten muraganeng pingerrluteng."
        },
        "20": {
            "start": 439.96,
            "end": 445.18,
            "transcript": "Tamakut-gguq tau͡gaam cimirtut nallimegtenun plastic-aaneng piyuirrluteng."
        },
        "21": {
            "start": 467.98,
            "end": 475.74,
            "transcript": "Tamaani-gguq eliteqarraallerpeni amlleret-gguq-qaa yuratullruut naliak-ll' [?] maa-irpak waten yuratuluteng amllertaluteng?"
        },
        "22": {
            "start": 475.79,
            "end": 483.11,
            "transcript": "Amlleqapiarat-gguq waten ilarunun pingayuneng cetamaneng-llu pilirluku."
        },
        "23": {
            "start": 483.11,
            "end": 490.57,
            "transcript": "Ataungrameng-llu taklaraurtengrameng ataurtengameng arnaurtengameng-llu."
        },
        "24": {
            "start": 490.57,
            "end": 494.88,
            "transcript": "Qang'a-lli makut kevgaraat cali."
        },
        "25": {
            "start": 494.88,
            "end": 503.51,
            "transcript": "Cali arnat angelriit yuratullruut tau͡ga piciatun ivarutet-gguq amlletullruut tamaani."
        },
        "26": {
            "start": 503.51,
            "end": 509.64,
            "transcript": "Ivarunun atauciq iliin cetamaneng arnat tangerrlemni pingayun ukut nurcuunaki."
        },
        "27": {
            "start": 550.36,
            "end": 559.333,
            "transcript": "Cameng-gguq nalliini yuratullruat tamaani cameng-gguq pingqetullruat tamaani?"
        },
        "28": {
            "start": 559.333,
            "end": 565.333,
            "transcript": "Waten una yurallrat cacigyaraitni tamalkuita."
        },
        "29": {
            "start": 565.333,
            "end": 573.6,
            "transcript": "Aren, maa-i taklirilria kinguqvaarni avani uitayugnarquq civuqvaarni taklirilria."
        },
        "30": {
            "start": 573.6,
            "end": 584.093,
            "transcript": "Kinguqlikacagauluni tauna man'a maa-i waten yuraryaraat imquqerrluteng-llu-gguq muraganeng atutuluteng."
        },
        "31": {
            "start": 584.093,
            "end": 590.147,
            "transcript": "Cakleq-gguq assiqapiarluteng, ilait-llu ang'aqluteng, ilait-ll' mik'etaqluteng."
        },
        "32": {
            "start": 590.147,
            "end": 604.533,
            "transcript": "Maa-i-gguq tau͡ga kinguqlikacagautullruuq man'a kinguqlikacagautuluku caciryaraumteni pitulqaatni imkut tayim' tamalri [?]."
        },
        "33": {
            "start": 604.533,
            "end": 606.4,
            "transcript": "Uksurpak-qaa yurarturatuluteng?"
        },
        "34": {
            "start": 606.4,
            "end": 609.48,
            "transcript": "Ii-i, kesian tau͡ga piciryaraq-llu."
        },
        "35": {
            "start": 609.533,
            "end": 622.56,
            "transcript": "Ayagngameng taumek assiyuun' nuna ungungssit-llu ilaqluteng [?] pillermeggneng tekitellra nallunaunani mat'umek, kegginaquq."
        },
        "36": {
            "start": 653.866,
            "end": 662.24,
            "transcript": "Cameng-gguq makut yuralriit yurallrit kangingeqtullruat wall'?"
        },
        "37": {
            "start": 662.24,
            "end": 672.293,
            "transcript": "Uum-gguq ilarutem piyullni tauna apqauluku cat iliit pitarkat-ll' iliit apqauluku qang'a-llu."
        },
        "38": {
            "start": 672.293,
            "end": 683.267,
            "transcript": "Umyugani waten wani imkuraqan nunakilivkenani piaqan amuluku amuluni pininauraat."
        },
        "39": {
            "start": 683.267,
            "end": 693.6,
            "transcript": "Tau͡gaam-ll' cairturluku, pinayuklukuurluku-llu [?] anguvkenaku pisqelluku, tamakuneng-gguq kangilirturluteng pitullruut."
        },
        "40": {
            "start": 693.6,
            "end": 702.4,
            "transcript": "Tau͡gaam-llu neqkaq piugaqamteggu uum ivarutem apaaluku tauna pituluku."
        },
        "41": {
            "start": 702.4,
            "end": 711.293,
            "transcript": "Tamaa-i-gguq piciatun mat'um ivarutem kangia amllertuq piciatun qang'a-ll' imkut aqevgit piyukuni."
        },
        "42": {
            "start": 725.347,
            "end": 739.813,
            "transcript": "Civuqvani-gguq maa-i-gguq tau͡gaam Cupiit piliyaurtut waten umyugamegteggun avani-gguq aipaita tamakut angalkut makut ivarutet piliaqetullrit."
        },
        "43": {
            "start": 739.813,
            "end": 746.213,
            "transcript": "Maa-i-gguq tau͡gaam Cupiit piliyaurtut wii-llu-gguq cali pilitulua piliqsainatulua."
        },
        "44": {
            "start": 788.507,
            "end": 798.787,
            "transcript": "Mat'um yuratullratneng wangkuta-gguq makut ivgarutet qanellrit [?] ellait-wa.."
        },
        "45": {
            "start": 801.293,
            "end": 803.04,
            "transcript": "Niitesciigatatgen."
        },
        "46": {
            "start": 811.44,
            "end": 814.64,
            "transcript": "Civuqlim-gguq mat'um kangia cauga?"
        },
        "47": {
            "start": 814.64,
            "end": 828.467,
            "transcript": "Mat'um-gguq civuqlim kangia imkuuguq umyugarteqluni nauguq [?] tamakut ak'a tangtultait tamakut cuuruluteng angllutuluteng."
        },
        "48": {
            "start": 828.467,
            "end": 834.173,
            "transcript": "Ugtatuluteng-llu qalingqerrluteng, ivrucingqerrluteng, arillungqerrluteng."
        },
        "49": {
            "start": 834.173,
            "end": 840.48,
            "transcript": "Waten piluteng cikum qaingani uitauratuluteng civvluteng-gguq makut."
        },
        "50": {
            "start": 840.48,
            "end": 846.88,
            "transcript": "Civuqluni-gguq uguraqluni, tau͡ga-llu-gguq tamatum taumeng kangingqertuq."
        },
        "51": {
            "start": 846.88,
            "end": 859.333,
            "transcript": "Mermun qecet'uluteng tau͡ga angllurluteng, taumeng-gguq kangingqertuq, meq-gguq kaluivluku [?], imarpigput wangkuta taumun ping'urcelluku."
        },
        "52": {
            "start": 859.333,
            "end": 862.573,
            "transcript": "Qunugni [?] im' atengqerrluni."
        },
        "53": {
            "start": 928.013,
            "end": 938.093,
            "transcript": "Yugtun piqarraarluk una. Natalia, Nayamin, Tony Umagak [?], Henry Stone."
        },
        "54": {
            "start": 938.093,
            "end": 942.44,
            "transcript": "Aipaa-wa pike, Ulrich, Nayamin, Jerome Woods."
        },
        "55": {
            "start": 1281.48,
            "end": 1286.653,
            "transcript": "Kinguqlia-gguq cameng piciqa? (Kinguqlia-qaa?)"
        },
        "56": {
            "start": 1286.653,
            "end": 1299.0,
            "transcript": "Calriami-im yurauten-im. Ii-i, elpet. Imna yuratukut."
        },
        "57": {
            "start": 1318.4,
            "end": 1321.067,
            "transcript": "Tau͡ga un' asqigglaku [?]? (Ii-i.)"
        },
        "58": {
            "start": 1321.067,
            "end": 1328.307,
            "transcript": "Waten-gguq tamana ivarun kangingqertuq."
        },
        "59": {
            "start": 1328.307,
            "end": 1341.0,
            "transcript": "Mermeng kanaken cameng piyuumirluni cali napameng muragarkamineng pamaken yaaqvaneng piyuumirluni unavet napartailan, napatailan."
        },
        "60": {
            "start": 1356.0,
            "end": 1361.213,
            "transcript": "Uksularungraan cataituq agelriamun uksuyagagakcuar' [?]"
        },
        "61": {
            "start": 1374.573,
            "end": 1376.213,
            "transcript": "Kinguqlia-qaa?"
        },
        "62": {
            "start": 1386.52,
            "end": 1389.0,
            "transcript": "Am'i yuraqerciu."
        },
        "63": {
            "start": 1392.667,
            "end": 1400.173,
            "transcript": "Cukaitnarqenrit' aqumluten [?] ..."
        },
        "64": {
            "start": 1538.547,
            "end": 1540.653,
            "transcript": "Kinguqlingqertut-llu-q' cali?"
        },
        "65": {
            "start": 1555.413,
            "end": 1558.027,
            "transcript": "Alirayarat nayayaaqerrnguq. (Cauga?)"
        },
        "66": {
            "start": 1558.027,
            "end": 1561.187,
            "transcript": "Cauga?"
        },
        "67": {
            "start": 1563.12,
            "end": 1568.72,
            "transcript": "Nayirmeng-gguq waten imarpigmi kuimatulit makut."
        },
        "68": {
            "start": 1568.72,
            "end": 1573.827,
            "transcript": "Waten cinaam uitalriit apalluqvallurait [?] ivarutaita."
        },
        "69": {
            "start": 1573.827,
            "end": 1578.36,
            "transcript": "Apalluqvallurait [?] tamakut imarpigmi kuimatulit."
        },
        "70": {
            "start": 1578.36,
            "end": 1582.067,
            "transcript": "Imarpik [?] neqengnatugutngamegteggu."
        },
        "71": {
            "start": 1582.067,
            "end": 1583.747,
            "transcript": "Man'a cam?"
        },
        "72": {
            "start": 1583.747,
            "end": 1589.32,
            "transcript": "Anrutarteng pitekluku tamana tau͡ga kangingqertuq uum ivarutem."
        },
        "73": {
            "start": 1589.32,
            "end": 1596.2,
            "transcript": "Nerengnatullernerteng pitekluku tamaaken nayiq piyuumiryaqluku."
        },
        "74": {
            "start": 1625.013,
            "end": 1637.2,
            "transcript": "Qanrutqerru waten-gguq nunam man'a imarpik-llu cuut bank-alriatun ayuqellrat keyiin neqvikluku, allameng-ll' nervigkuunateng naugg'un."
        },
        "75": {
            "start": 1668.2,
            "end": 1671.2,
            "transcript": "Aliirayagaat."
        },
        "76": {
            "start": 1805.2,
            "end": 1816.053,
            "transcript": "Waniwa iciwa-qaa quyurtellermeggni ukut wani board-at nutarat Calista-m board-angnerraayaa."
        },
        "77": {
            "start": 1816.053,
            "end": 1826.2,
            "transcript": "Ciuqliuluku caliaqellruat una wani office-aam Calista-m office-aaran Anchorage-aamek maavet nugtartellerkaa."
        },
        "78": {
            "start": 1832.48,
            "end": 1843.08,
            "transcript": "Ciuqliuluku caliaqellruat una wani office-aam Calista-m office-aaran Anchorage-aamek maavet nugtartellerkaa."
        },
        "79": {
            "start": 1843.08,
            "end": 1852.653,
            "transcript": "Tua-ll' maa-i report-auteqerluku qaillun pitarillra tamatum maa-i."
        },
        "80": {
            "start": 1852.653,
            "end": 1860.373,
            "transcript": "Uumi quyurtellermeggni board-at una waniwa-w' nunaliurtet uptellriit ukut nunaliulrianun."
        },
        "81": {
            "start": 1860.373,
            "end": 1870.667,
            "transcript": "Anchorage-aami caliuraqaqatartut kiagpak tayim' uksuaqu-aa tayim' upingarikuneng nugtartarkauluteng maavet Mamterillernun."
        },
        "82": {
            "start": 1870.667,
            "end": 1877.533,
            "transcript": "Nugtareskuneng tua-i nunanun malkaniutarkauluteng ikayurarkamteńun."
        },
        "83": {
            "start": 1877.533,
            "end": 1883.387,
            "transcript": "Tuamta-llu cali una im' accounting department-aara Calistam."
        },
        "84": {
            "start": 1883.387,
            "end": 1890.133,
            "transcript": "Imkut bookkeeper-aat cali audit-aumai caliaqellran qaingani."
        },
        "85": {
            "start": 1890.133,
            "end": 1903.36,
            "transcript": "Yaani uitaurararkauluteng audit-aaq qaqiskan tayim' July-am iraluan iluani tayim' qaqiuskata nugtartarkauluni cali tauna maavet Mamterillernun."
        },
        "86": {
            "start": 1903.36,
            "end": 1912.987,
            "transcript": "Tua-ll' quyurtellermeggni uumi board-at general manager-aarkanek mat'um corporation-aam piyugtut."
        },
        "87": {
            "start": 1912.987,
            "end": 1921.107,
            "transcript": "Taum wani general manager-aam ukut wani calilriit man'a-llu corporation-aaq aulukarkauluku."
        },
        "88": {
            "start": 1921.107,
            "end": 1930.147,
            "transcript": "Tua-ll' general manager-aangnatkaatnun ellimerraatnga murilkesqelluki ukut murilkurluki pisqelluki calilriit."
        },
        "89": {
            "start": 1930.147,
            "end": 1937.907,
            "transcript": "Man'a ilerquralqa mat'um corporation-aamta murilkelluku pisqelluku."
        },
        "90": {
            "start": 1937.907,
            "end": 1947.44,
            "transcript": "Tua-ll' maa-i im' tauna office-aaq im' apqiitnek una administration office-aara."
        },
        "91": {
            "start": 1947.44,
            "end": 1955.947,
            "transcript": "Maavet nugtartuq maaken Mamterillernek wii caliarkaulua maa-i kanani office-aaratni."
        },
        "92": {
            "start": 1955.947,
            "end": 1961.333,
            "transcript": "Uitaluni kanani maa-i Kuskokwim office building-aami."
        },
        "93": {
            "start": 1961.333,
            "end": 1979.107,
            "transcript": "Tua-ll' maa-i im' cali arcaqalriit quyurtellermeggni caliaqellrit im piqaqata'arqa una wani arcaqanrulria nunamun mat'umun calillerput."
        },
        "94": {
            "start": 1979.107,
            "end": 1990.467,
            "transcript": "Tuani nangnermi uumi board-at quyurtellermeggni una wani nunamek cucuklillerkarput ciuqliurrluku caliarkamteńi ellillruat."
        },
        "95": {
            "start": 1990.467,
            "end": 1996.24,
            "transcript": "Ikayuutellerkarput waten nunanun nunamek cucukliqata."
        },
        "96": {
            "start": 1996.24,
            "end": 2005.027,
            "transcript": "Tua-ll' maa-i tamana pitekluku waten nunat nalluata amlleret mat'umek nunam qaillun cucukellerkaanek."
        },
        "97": {
            "start": 2005.027,
            "end": 2011.453,
            "transcript": "Calilriit ukut nunaliurtet ilallruaput qulnek."
        },
        "98": {
            "start": 2011.453,
            "end": 2018.68,
            "transcript": "Qulen ukut calilriit imkuni unit-aani caliarkauluteng tamaani uitaluteng."
        },
        "99": {
            "start": 2018.68,
            "end": 2023.36,
            "transcript": "Nunat imkut unit-aam iluanelnguut ikayualuki caliarkauluteng."
        },
        "100": {
            "start": 2023.36,
            "end": 2035.547,
            "transcript": "Maa-i-llu ilait ayagnirluteng imna maa-i malruurtuk calingellrak im' William Tyson-aaq, una-llu Gilbert Henrickson-aaq maa-i ayagnirluteng."
        },
        "101": {
            "start": 2035.547,
            "end": 2047.653,
            "transcript": "Taumek nunani administrative unit-aani wall'u imkuni broad member-aani kemyukek'ngangqerkuvci elluarrluni caliarkamek."
        },
        "102": {
            "start": 2047.653,
            "end": 2056.92,
            "transcript": "Atrit maavet igaulluki office-aamun taivkaquvciki tamaa-i maa-i ayagnirarkauluteng taukut."
        },
        "103": {
            "start": 2056.92,
            "end": 2067.693,
            "transcript": "Ilait tayima cucukumalriit elitnaurnarciqngata maa-i kiagpak elitnauresqelluki uksuaqu."
        },
        "104": {
            "start": 2067.693,
            "end": 2077.76,
            "transcript": "Yuut waten nunani im' elkartengkata cali imkut caliyartullertuterqaqengkata egmianun ayagaarkaurrluki."
        },
        "105": {
            "start": 2077.76,
            "end": 2085.2,
            "transcript": "Tau͡gaam pingraan ilaitnun nunatnun kiagpak tayim' ayagaqluteng piciqluteng."
        },
        "106": {
            "start": 2085.2,
            "end": 2094.68,
            "transcript": "Taumek tamana tamaa-i arcaqerluku maa-i im' ciuqliurrluku pillruarput quyurtellemteńi."
        },
        "107": {
            "start": 2094.68,
            "end": 2104.6,
            "transcript": "Tua-llu cali im' makunek ava-i aipangqertuq ciuqliuluteng incorporate-allerkaatnek nunat."
        },
        "108": {
            "start": 2104.6,
            "end": 2119.307,
            "transcript": "Ava-i akwaugaq imna attorney-rput Russell Gallagher-aaq qalangssagaqallrulliniuq makunek incorporate-allerkamteńek nunamteńek village corporation-aanek."
        },
        "109": {
            "start": 2119.307,
            "end": 2130.96,
            "transcript": "Maa-i, maani mat'um Calista-m iluani yuinaak malruk cipluku nunat amllertaut incorporate-ararkat."
        },
        "110": {
            "start": 2130.96,
            "end": 2141.307,
            "transcript": "Tua-i-ll maa-i uumi au͡gkut sign-allrenka nangneret naaqutekluki yuinaq cipluku incorporate-allrurrluteng nunat."
        },
        "111": {
            "start": 2141.307,
            "end": 2149.307,
            "transcript": "Tamakut article-aarit bylaw-rit-llu tayim' sign-aumariluteng ayagcecimariluteng Juneau-mun."
        },
        "112": {
            "start": 2149.307,
            "end": 2166.44,
            "transcript": "Tayim' akurtuumarikatki approve-aumarikatki imkut Department of Commerce-aam tayim' utercetarkauluteng taukut nunanun, akurtuquvciki-ll' tua-i nunani incorporate-aumariluteng piarkauluteng corporation-aaci."
        },
        "113": {
            "start": 2166.44,
            "end": 2177.987,
            "transcript": "Imkut-llu incorporater-aanek aterpagcimallret cucukelci talliman Board of Director-aarurtarkaurrluteng taum nalliini."
        },
        "114": {
            "start": 2177.987,
            "end": 2192.76,
            "transcript": "Tua-ll maa-i cali im' quyurtellerkaat im' board-at maa-i amllerikanillermeggni thirteen-aarurrluteng board-at."
        },
        "115": {
            "start": 2192.76,
            "end": 2209.52,
            "transcript": "Imkuni administrative policy-ni alerquukarni pillemteńi allrakum mat'um iluani cetamarqunek waten qaqigmirrluteng quyurtarkauluteng, quyurtarkauluteng piut quarterly meeting-aararkauluteng."
        },
        "116": {
            "start": 2209.52,
            "end": 2219.934,
            "transcript": "Tua-i-llu taukut akunliigni maani iralut, iralumi ataucirqumek tua-i quyurqurluteng imkut executive committee-t quyurtarkauluteng."
        },
        "117": {
            "start": 2219.934,
            "end": 2229.04,
            "transcript": "Executive committee-ni-llu uitaluta. Wiinga, Raymond Christansen-aaq, Sue Walter-Smith-aq."
        },
        "118": {
            "start": 2229.04,
            "end": 2244.134,
            "transcript": "Imna-llu Gladys Young-aq, tuamta-llu cali Scammon Bay-rmiut Timothy Kaganak, tallimauluta taukuni executive committee-ni uitaluta maa-i."
        },
        "119": {
            "start": 2244.134,
            "end": 2251.0,
            "transcript": "Iraluq man'a twenty-urtaqan quyurtarkauluta makut caliarkaput caliaqluki."
        }
    },
    "_iLtzfg3dik": {
        "1": {
            "start": 44.53,
            "end": 52.46,
            "transcript": "Tangellruanka pissurcet yurallratni ak'a pissulallret ayagyuanrit-llu angutet tan'gaurluut-llu."
        },
        "2": {
            "start": 52.46,
            "end": 60.78,
            "transcript": "Niitellruanka yuk yuarutait pissurcet cauyallrit-llu cauyameggni yurautellratki yuut."
        },
        "3": {
            "start": 97.42,
            "end": 104.32,
            "transcript": "Tangellruanka-llu arnat yuralriit, arnaurqellriit ayagyuanrit-llu arnat nasaurluut-llu."
        },
        "4": {
            "start": 104.32,
            "end": 114.92,
            "transcript": "Yurayuluteng cukaluteng tegumiarit paptaqluteng [?] canegcetun, yaqucetun, qanikcatun, yurautellratki yuut."
        },
        "5": {
            "start": 182.12,
            "end": 187.74,
            "transcript": "Wangkuta Yupiugukut, Yupiit kuigit paingitni imarpiit-llu."
        },
        "6": {
            "start": 187.74,
            "end": 192.92,
            "transcript": "Yuratuluta yuugukut yuarutnek atutuluta yuugukut."
        },
        "7": {
            "start": 192.92,
            "end": 198.0,
            "transcript": "Neq'alaraput ak'allaat qanemcit quyurrluteng-llu yuralallrit."
        },
        "8": {
            "start": 232.86,
            "end": 245.42,
            "transcript": "Tangellruanka quyurtellriit Yupiit yuraryarait Negeqlirmiut yuin qilillratki qulngunrita'araat nunat kuigat cikuyartullrani uksuarmi maa-i."
        },
        "9": {
            "start": 299.62,
            "end": 313.5,
            "transcript": "Taisqumallret yurarcet aturtet-llu qulnekaukan maatesqumayaaqait. Tununermiut, Taprarmiut, Cev'armiut."
        },
        "10": {
            "start": 313.5,
            "end": 320.94,
            "transcript": "Tangellruanka pingayuni ernerni yurallrani, kalukallratni potluck-aallratni-llu."
        },
        "11": {
            "start": 320.94,
            "end": 329.16,
            "transcript": "Aturcet-llu kelgumallret maavet maani 8-o'clock-an quyumasqessaaqait ukut."
        },
        "12": {
            "start": 708.92,
            "end": 713.96,
            "transcript": "Tangellruanka Taprarmiut pissurcet Stebbins-aamek."
        },
        "13": {
            "start": 713.96,
            "end": 722.26,
            "transcript": "Ilakluki Cev'armiut, Imangarmiut, Qerrulligmiut, Nunakauyarmiut, Tununermiut-llu."
        },
        "14": {
            "start": 722.26,
            "end": 730.4,
            "transcript": "Cali Negeqlirmiut, Tuutalgarmiut, Massercullermiut-llu. Melqulegcutulit pissurtet-llu Kuigpagmek."
        },
        "15": {
            "start": 802.78,
            "end": 808.12,
            "transcript": "Tangellruanka yurallratni Yupiit yuraryaraatni."
        },
        "16": {
            "start": 859.24,
            "end": 864.68,
            "transcript": "Tangellruanka pissurtet atullratni wangkuta qaneryaramcetun."
        },
        "17": {
            "start": 864.68,
            "end": 869.86,
            "transcript": "Ak'allaat yuarutet, yuarutet-llu ellait piliallrit."
        },
        "18": {
            "start": 869.86,
            "end": 874.82,
            "transcript": "Yuarutet pissulrianek, neqsulrianek, quyurtelallritnek-llu."
        },
        "19": {
            "start": 874.82,
            "end": 884.18,
            "transcript": "Cali yuarutet ayagalallritnek unuaquaqan-llu calallritnek, atullruut ungungssinek yaqulegnek-llu."
        },
        "20": {
            "start": 977.8,
            "end": 983.52,
            "transcript": "Tangellruanka arnat yurallratni tangnircautnek aturluteng."
        },
        "21": {
            "start": 983.52,
            "end": 991.16,
            "transcript": "Qaraliit qasperitni pekenqellrit tegumiarita unatait-llu pektellrit."
        },
        "22": {
            "start": 1056.8,
            "end": 1061.72,
            "transcript": "Ngel'allrucillruanka yuut iiput maqnatkaatnun."
        },
        "23": {
            "start": 1061.72,
            "end": 1069.86,
            "transcript": "Temcikellruit anglanarqellriit kegginaliullrit aarallrit-llu anglanim ugaani."
        },
        "24": {
            "start": 1199.06,
            "end": 1203.9,
            "transcript": "Tangellruanka pinirtaciit pissurtet yuraraqata."
        },
        "25": {
            "start": 1203.9,
            "end": 1209.94,
            "transcript": "Ak'arraar pissulallret ayagyuanrit-llu angutet tan'gaurluut-llu."
        },
        "26": {
            "start": 1209.94,
            "end": 1215.98,
            "transcript": "Tanglallermeggnek yuaruterluteng arenqialluga'artelallermeggnek-llu."
        },
        "27": {
            "start": 1215.98,
            "end": 1221.22,
            "transcript": "Tangellruanka angnilriit ayagyuat angutet yurallratni."
        },
        "28": {
            "start": 1221.22,
            "end": 1226.78,
            "transcript": "Tangellruanka cali anglanillrat ak'arraar pissulallret."
        },
        "29": {
            "start": 1320.08,
            "end": 1324.26,
            "transcript": "Tangellruanka yurayutaciit arnat yurallratni."
        },
        "30": {
            "start": 1324.26,
            "end": 1329.28,
            "transcript": "Arnaurqellriit ayagyuanrit arnat nasaurluut-llu."
        },
        "31": {
            "start": 1329.28,
            "end": 1334.7,
            "transcript": "Ellait tangellrit irniangellrit calillgutlallrat-lu."
        },
        "32": {
            "start": 1334.7,
            "end": 1339.42,
            "transcript": "Tangellruanka assirtaciit ayagyuat arnat yurallratni."
        },
        "33": {
            "start": 1339.42,
            "end": 1343.22,
            "transcript": "Tangellruluki-llu arnaurtellriit."
        },
        "34": {
            "start": 1400.92,
            "end": 1410.04,
            "transcript": "Tangellruanka yuut ilautellriit cikiriaqluteng ikayuqluteng-llu calillrit."
        },
        "35": {
            "start": 1410.04,
            "end": 1418.64,
            "transcript": "Tangellruanka-llu ikayurluteng pillrat kenekluki tamaita tegganret mikelnguut-llu ilakluki."
        },
        "36": {
            "start": 1446.5,
            "end": 1453.76,
            "transcript": "Wangkuta Yupiugukut. Yui kuiget avatemteni, imarpik-llu ilakluku."
        },
        "37": {
            "start": 1453.76,
            "end": 1459.88,
            "transcript": "Yuratuluta yuugukut. Yuarutnek aturaqluta yuugukut."
        },
        "38": {
            "start": 1459.88,
            "end": 1465.42,
            "transcript": "Umyuaqelaraput qanemcik'lallrit quyurtelallritni."
        },
        "39": {
            "start": 1567.04,
            "end": 1572.22,
            "transcript": "Tangellruanka quyurtellratni Yupiit yuraryaraatni."
        },
        "40": {
            "start": 1572.22,
            "end": 1582.16,
            "transcript": "Negeqlirmiut yuin kelellratki qulngunrita'araat nunat kuigat cikuyartuutiitni uksuarmi maa-i."
        },
        "41": {
            "start": 1652.8,
            "end": 1662.42,
            "transcript": "Yupiit yuraryarait piunarivkarimallruuq elliitaitgun ukut Alaska State Council on Arts."
        },
        "42": {
            "start": 1662.42,
            "end": 1667.1,
            "transcript": "Cali-llu National Endowment for the Arts."
        },
        "43": {
            "start": 1710.1,
            "end": 1719.24,
            "transcript": "Kencikutkun una tangelci taqumallruuq pitekluki tegganret qulngunrita'arni nunani."
        }
    },
    "U2JMGyhWH5U": {
        "1": {
            "start": 10.1,
            "end": 14.64,
            "transcript": "Qununaqsaaquq man'a, kallagnarqenricaaquq piciryararput."
        },
        "2": {
            "start": 14.835,
            "end": 17.145,
            "transcript": "Qununarqeqap'iartuq."
        },
        "3": {
            "start": 17.275,
            "end": 27.885,
            "transcript": "Taumek picirluta, una-llu arcaqerlunuk cing'arpuk ayagyuat makut maani tangerqaasqelluki, cellangcaqaasqelluki."
        },
        "4": {
            "start": 28.555,
            "end": 33.595,
            "transcript": "Waten-llu nunacuarni, nani piciatun"
        },
        "5": {
            "start": 33.66,
            "end": 40.47,
            "transcript": "Man'a piciryararput Yup'igtaq qessakevkenaku, nasvagluku makunun ayagyuanun."
        },
        "6": {
            "start": 40.6,
            "end": 47.6,
            "transcript": "Tangvagluteng aturlaqumta wangkuta qessakevkenaku maligtengciqaitkut."
        },
        "7": {
            "start": 48.035,
            "end": 54.265,
            "transcript": "Kass'amirtatun mat'utun ingluartessiyaagpek'naki pinarqai."
        },
        "8": {
            "start": 54.435,
            "end": 60.945,
            "transcript": "Wangkutnun taug͡aam atauq man'a maani Yugtun piciryaraq eglerutellerkaa."
        },
        "9": {
            "start": 60.945,
            "end": 66.585,
            "transcript": "Wangkuta aturyunrilkumteggu makut maani ayagyuat aturyugngaitaat."
        },
        "10": {
            "start": 66.8,
            "end": 77.02,
            "transcript": "Tangvagluci tau͡gaam, tangvagluta-llu wangkuta Yup'igtaq man'a ciumuuluku qessakevkenaku tengrukluku pikumta nutaan tuani maligtengciqaitkut."
        },
        "11": {
            "start": 77.225,
            "end": 85.42,
            "transcript": "Qanaatenrilengramteki, \"Usuuq, yuralrianun agi. Usuuq, atulrianun niicugniyartua.\""
        },
        "12": {
            "start": 85.42,
            "end": 93.08,
            "transcript": "Tuaten arca qanaaviiqnata. Wangkutnek nangerrluta, aqumluta pingkumta maligtengciqaitkut."
        },
        "13": {
            "start": 93.465,
            "end": 96.415,
            "transcript": "Taumek tua-i qanqe'rtua."
        },
        "14": {
            "start": 197.38,
            "end": 202.75,
            "transcript": "Wanigga tangrarpecia wani. Tapramek taillruunga."
        },
        "15": {
            "start": 202.75,
            "end": 209.72,
            "transcript": "Wanigga ilaitni ak'allarrarni elitaqngatarpecia."
        },
        "16": {
            "start": 212.33,
            "end": 218.37,
            "transcript": "Wanigga quyanarqellria tangrrutamta."
        },
        "17": {
            "start": 218.765,
            "end": 224.905,
            "transcript": "Quyanarqeq'apiartuq. Ak'all[artarnek] cali ak'allat piciuluteng."
        },
        "18": {
            "start": 225.97,
            "end": 233.91,
            "transcript": "Imumi wani ak'a tan'gurraullemni qaneryaranek niicimallruunga."
        },
        "19": {
            "start": 234.265,
            "end": 238.155,
            "transcript": "Miklua tamaani ayagnillruunga, atairullua-llu."
        },
        "20": {
            "start": 238.155,
            "end": 244.305,
            "transcript": "Ak'arraq ataka tuqullruluni tayima. Pingyurivailegma ataka tuqullruuq."
        },
        "21": {
            "start": 244.335,
            "end": 247.355,
            "transcript": "Aanama tau͡gaam nautellruanga."
        },
        "22": {
            "start": 249.85,
            "end": 255.66,
            "transcript": "Cali wanigga makut kinguqliput"
        },
        "23": {
            "start": 256.375,
            "end": 260.715,
            "transcript": "Mat'umek wani ak'allat piciryaraatnek"
        },
        "24": {
            "start": 267.28,
            "end": 271.72,
            "transcript": "Ak'a qaneryaraitnek elicimasqumayaaqluki."
        },
        "25": {
            "start": 273.875,
            "end": 280.995,
            "transcript": "Makut ak'allat qaneryaraat tamasqumanricaaqluku"
        },
        "26": {
            "start": 283.27,
            "end": 287.9,
            "transcript": "Catairuskumta tamalriatun ayuqeciqngan."
        },
        "27": {
            "start": 288.61,
            "end": 295.85,
            "transcript": "Wanigga-am wani atakurpak quyanarqellriit qanaalriit."
        },
        "28": {
            "start": 296.155,
            "end": 301.495,
            "transcript": "Mat'umek cali maa-i anglaniyaurtellriakut tamamta nunani."
        },
        "29": {
            "start": 302.12,
            "end": 305.85,
            "transcript": "Quyanarqelartuq cakneq tangrrutaqamta."
        },
        "30": {
            "start": 306.04,
            "end": 314.18,
            "transcript": "Makut cali kinguqlimta tayima catairuskumta tamana tayima eneqakciqaat cali."
        },
        "31": {
            "start": 314.605,
            "end": 321.085,
            "transcript": "Tamarcessngailngataat tamana makut umyuarteqellriit kinguqlimta."
        },
        "32": {
            "start": 322.29,
            "end": 327.6,
            "transcript": "Ak'anun-llu wani ilait wangkuta yuugurngaicugnarqukut."
        },
        "33": {
            "start": 327.612,
            "end": 341.124,
            "transcript": "Tayima-tuq camek wani navguatmek wani, navguatmek makut kiinguqliput nutaraq"
        },
        "34": {
            "start": 341.287,
            "end": 348.337,
            "transcript": "Ak'allat piciryarait-tuq tayima malirqengkilitki."
        },
        "35": {
            "start": 351.719,
            "end": 357.144,
            "transcript": "Anarullua wii Kass'atun qanerciigalmiunga."
        },
        "36": {
            "start": 360.088,
            "end": 363.263,
            "transcript": "Qanssiyaagciigatua Kass'acetun."
        },
        "37": {
            "start": 365.444,
            "end": 376.494,
            "transcript": "Wanigga-am, wanigga-m quyalrianga caknek ukut wani taivkaatkut"
        },
        "38": {
            "start": 376.501,
            "end": 386.801,
            "transcript": "Asaacaryarmiut cali, Tuqsugmiut cali tangerrluki, cali qau͡gkut Negeqlirmek pilriit cali tangerrluki."
        },
        "39": {
            "start": 387.895,
            "end": 394.558,
            "transcript": "Ilakqapiaralriatun waten ayuqlirtukut. Quyanaqluni-am cakneq."
        },
        "40": {
            "start": 396.845,
            "end": 401.683,
            "transcript": "Camek anagullua qanerciigalmiunga."
        },
        "41": {
            "start": 420.189,
            "end": 432.139,
            "transcript": "Umyugamteggun tangrruarturpegnaki ilaput maani uitalriit, caput, ilaput tangvagluki, tangvakapigcelluki"
        },
        "42": {
            "start": 432.158,
            "end": 438.658,
            "transcript": "Taitaa ukut uukucirluta Ayaacaryarmiut tangvagcilluki."
        },
        "43": {
            "start": 438.665,
            "end": 442.302,
            "transcript": "Tamatumek tau͡ga quyatengqertua wii."
        },
        "44": {
            "start": 442.752,
            "end": 458.802,
            "transcript": "Tau͡gaam tau͡ga waten wanigga imkut civuliamta imkut atullrat au͡gna umyugamteńi, umyugamni keyianeng uitarrlainatuuq."
        },
        "45": {
            "start": 460.184,
            "end": 466.934,
            "transcript": "Ilakutqapiggluteng ilakellengnaarat civuliamta imkut."
        },
        "46": {
            "start": 467.141,
            "end": 470.603,
            "transcript": "Cakneq naklekulluteng-llu."
        },
        "47": {
            "start": 470.841,
            "end": 476.841,
            "transcript": "Waten wanigga wangkuta piniartukut:"
        },
        "48": {
            "start": 476.973,
            "end": 486.173,
            "transcript": "Au͡gkut qaneryaraqegtaaraat, civumni qanellret qaneryarait pegtenritniaraput"
        },
        "49": {
            "start": 486.18,
            "end": 492.692,
            "transcript": "Qang'a-llu maavet, qang'a-llu ankumta peggluki."
        },
        "50": {
            "start": 492.705,
            "end": 497.605,
            "transcript": "Tegumiaqerkauluki cuullemta taktacirraatun."
        },
        "51": {
            "start": 497.874,
            "end": 505.324,
            "transcript": "Tegumiaqluki pegtarkauvkenaki, kingunitengramta-llu pegtevkenaki."
        },
        "52": {
            "start": 505.468,
            "end": 514.881,
            "transcript": "Makunun wangkuta irniaramteńun cali atungnaqureniaraput tamakut kenekluki, cagyuunaki."
        },
        "53": {
            "start": 515.893,
            "end": 528.581,
            "transcript": "Elluarrluteng tamakut teggenret imkut ayagyugameggni qanaataqkaitkut naklekulluta ilakulluta pisqelluta."
        },
        "54": {
            "start": 528.744,
            "end": 538.956,
            "transcript": "Ilaput-llu inerqur[luki], inerqurluta cali ilaput-gguq piciqenrilkaitnek picilirluki qanaayaqunata."
        },
        "55": {
            "start": 539.719,
            "end": 549.469,
            "transcript": "Cali waten camun nall'aruteqerluta pikumta, assinrilngurmek aturtiinun"
        },
        "56": {
            "start": 549.776,
            "end": 557.688,
            "transcript": "Tau͡gaggun-gguq tangvagpegnaku, assillrakun tau͡gaam tangvagniararput, tangvagniarput."
        },
        "57": {
            "start": 559.101,
            "end": 568.526,
            "transcript": "Waten wanigga imkut civuliaput elluarrluteng pisqumaillruut ayagyugameggneng."
        },
        "58": {
            "start": 568.607,
            "end": 576.582,
            "transcript": "Wangkuta cali atungnaqureluki piniaraput tamakut civuliamta imkut piciryarallrat."
        },
        "59": {
            "start": 576.838,
            "end": 590.238,
            "transcript": "Makunun irniaramteńun atungnaqureluki, qang'a-llu irniaqenrilengramteki. Makunun ayagyugaat tungiitnun cali atungnaqureluki piniartukut."
        },
        "60": {
            "start": 590.482,
            "end": 599.832,
            "transcript": "Maa-i man'a quyanerqelria, waten taivkallerput maavet tangrrutesqelluta."
        },
        "61": {
            "start": 599.843,
            "end": 611.218,
            "transcript": "Ilaput tungelquput-llu tangaasqelluki tamatum iluani ilukegcinarqeqap'iareluni cakneq tamana tau͡gatnallerput"
        },
        "62": {
            "start": 611.237,
            "end": 620.312,
            "transcript": "Ilaput tangrraqluki, umyugamteggun tangrraurtu'rpegnaki tangpiggluki tangerrluki."
        },
        "63": {
            "start": 620.706,
            "end": 632.118,
            "transcript": "Cali waten una wanigga atu[?]: ukisqaqengnaqureluku Agayutmek pituniartukut."
        },
        "64": {
            "start": 632.131,
            "end": 640.569,
            "transcript": "Ukisqaqengnaqerrlainarluku piyuutemteńek niitenrilengraitkut."
        },
        "65": {
            "start": 640.807,
            "end": 646.432,
            "transcript": "Niiqurainarniaraakut atam niitenriqaarluta-llu."
        },
        "66": {
            "start": 646.951,
            "end": 652.913,
            "transcript": "Piyuutvut tauna wangkutnun taiqurainarniaraa atam."
        },
        "67": {
            "start": 652.926,
            "end": 663.876,
            "transcript": "Cali makut wangkuta kingunemteńun ayakumta tamakuneng au͡gkut qaneryaraqegtaa'rneng au͡gkut civumi qanaallerneng"
        },
        "68": {
            "start": 663.895,
            "end": 672.945,
            "transcript": "Qaneryaraqegtaaraat tamakut makunun mikelngurramteńun wangkuta egmirqurluki piniaraput."
        },
        "69": {
            "start": 672.952,
            "end": 677.102,
            "transcript": "Taringyuitaitkut waten Cup'igtun qanengramta."
        },
        "70": {
            "start": 677.434,
            "end": 687.821,
            "transcript": "Tau͡gaam wangkuta tau͡gaten pingraata, taringyuilengraata, aulukengnatugarkaugaput makut mikelnguput irniarraput."
        },
        "71": {
            "start": 687.834,
            "end": 691.659,
            "transcript": "Tau͡g qinuitellerkaatnun tekisngaqulluki."
        },
        "72": {
            "start": 692.228,
            "end": 700.34,
            "transcript": "Tau͡ga tamatumeng quyatengqertua wii ukuneng taivkartemteńeng."
        },
        "73": {
            "start": 837.108,
            "end": 844.871,
            "transcript": "...maani ayagyuat waten mikellriit nalqigulluki cat kangiitnek tamakut tangllerpeci nallunrilkuvciki."
        },
        "74": {
            "start": 844.883,
            "end": 852.996,
            "transcript": "Tuani aturyugyaaqamceci nalqigtesqelluki tamakut calinguat Yup'igtaat."
        },
        "75": {
            "start": 853.471,
            "end": 858.033,
            "transcript": "Cali cetamanek yugnek quyayugyaaquq..."
        },
        "76": {
            "start": 858.459,
            "end": 864.496,
            "transcript": "...enirturallritnek tailluta waniwa tangvagciqaci. Paqeskiciki unuaqu."
        },
        "77": {
            "start": 864.509,
            "end": 869.446,
            "transcript": "Tau͡gaam aturyugamceci nallunrilkuvciki tamakut kangiit."
        },
        "78": {
            "start": 961.578,
            "end": 964.315,
            "transcript": "Qanelriinaryunritua."
        },
        "79": {
            "start": 964.328,
            "end": 970.215,
            "transcript": "Yugtun mumigtenrilengraata. Makut maani mikelnguaraat taringetuut kinguput."
        },
        "80": {
            "start": 970.228,
            "end": 973.053,
            "transcript": "Nayangangnaurtukut. Arenqiarutukut."
        },
        "81": {
            "start": 979.809,
            "end": 986.147,
            "transcript": "Waniwa atukurpak ukut nunat, 12 villages, malrugnek aturtaar[ciqut]."
        }
    },
    "_Bpstt_S_ps": {
        "1": {
            "start": 516.56,
            "end": 525.5,
            "transcript": "Wanirpak, wanirpak una wani ciutmurrluku-wa waten."
        },
        "2": {
            "start": 620.02,
            "end": 626.7,
            "transcript": "Una [?] maa-i allrakumi Arnaucuaq, Maryann Sundown."
        },
        "3": {
            "start": 626.7,
            "end": 637.82,
            "transcript": "Elitaqumauq man'a yuraryaraq kinguvarcaram ketvarrluku wangkutnun Marayarmiut pikuliarit [?] taukut wani cal' elitesqelluki."
        },
        "4": {
            "start": 637.82,
            "end": 643.62,
            "transcript": "Ilarugait waniwa nangengqauta maanelnguut patguurluki quyana."
        },
        "5": {
            "start": 648.9,
            "end": 658.2,
            "transcript": "Una wani nunuliutnguuq tua-ll' tunumaciqluni maa-i allrakumi una wani qanrumauq."
        },
        "6": {
            "start": 658.2,
            "end": 667.94,
            "transcript": "Cingumallerkun elitnaurutlerkait yuuyaram."
        },
        "7": {
            "start": 667.94,
            "end": 678.94,
            "transcript": "Quyavikamteggen quyana cakneq ircaqumteńi uitaciquten, waniwa elliinun tunluku, quyanaqvaa cakneq."
        },
        "8": {
            "start": 679.44,
            "end": 682.84,
            "transcript": "Panimanritut tutgarama."
        },
        "9": {
            "start": 685.12,
            "end": 694.96,
            "transcript": "Aanamnek qanruarrnaluci. Waniwa nakmiin qulngunrita'arnek paningqertuq atauciq nakmiin qetunraraa."
        },
        "10": {
            "start": 694.96,
            "end": 701.52,
            "transcript": "Tau͡gaam malrunek angutegnek call' anglicarillruluni, ataucimek arnamek."
        },
        "11": {
            "start": 701.52,
            "end": 715.84,
            "transcript": "Tutgarai-wa yuinaak malruk malrunlegnek cipluku, 57, wall'u-q' yuinaak malruk akimiaq malrunek cipluku."
        },
        "12": {
            "start": 715.84,
            "end": 724.44,
            "transcript": "Iluperai-wa yuinaat pingayun akimiarmek cipluku, 75."
        },
        "13": {
            "start": 724.44,
            "end": 734.74,
            "transcript": "Unaggun wangkuta kingunemteńi ukatmun tutgarai maurluuvkaqata iluragnilarai."
        },
        "14": {
            "start": 734.74,
            "end": 743.14,
            "transcript": "Malrunek ilurangqertuq, two great great sons. Waniwa ilarugakut cataitut maani."
        },
        "15": {
            "start": 743.14,
            "end": 748.14,
            "transcript": "Tau͡gaam qanqautnaluci aanaka-llam ellimeyungarqekaten-gguq."
        },
        "16": {
            "start": 748.14,
            "end": 756.84,
            "transcript": "Ukatmun pisqaqami qessangaituq wangkuta-gguq engel'alkamtenek wall'u-q' yuut, quyana."
        },
        "17": {
            "start": 760.72,
            "end": 769.36,
            "transcript": "Quyana man'a tekilluku tuutau-llu [?] nangengqalqa quyaqapigtaqa cakneq caligaugauteka."
        },
        "18": {
            "start": 769.36,
            "end": 776.92,
            "transcript": "Cali waniwa aglumalua ataam allrakun pinqigceskata cali nangengqaqeryugyaaqlua."
        },
        "19": {
            "start": 776.92,
            "end": 783.8,
            "transcript": "Tayima tua-i-w' tamamta elpeci-llu agayutem bless-aumaniaraaci."
        },
        "20": {
            "start": 888.76,
            "end": 897.66,
            "transcript": "Kenkutellria man'a ircaqutun uuggun pinir' assilriamek kenqellriamek."
        },
        "21": {
            "start": 897.66,
            "end": 905.52,
            "transcript": "Una cakneq pinirtuq kenka wantuq cakneq."
        },
        "22": {
            "start": 905.52,
            "end": 914.22,
            "transcript": "Quyana aqvallua mat'um nalliini 2000-aaq tekilluku piarput."
        },
        "23": {
            "start": 914.22,
            "end": 929.46,
            "transcript": "Waniwa tau͡gaam wiinga uumek ayarungqerrama imumek cancer-aamek pingqerrama iruka patqa uumek ayarungqertua."
        },
        "24": {
            "start": 929.46,
            "end": 937.28,
            "transcript": "Tau͡gaam agayut umyuaqurluku piarqa waniwa assillmun kiingan pisqelluku."
        },
        "25": {
            "start": 937.28,
            "end": 951.24,
            "transcript": "Cali-llu quyaviksugyaaqlukek angayuqaagka waniwa call' unguvallragni quyaanka cakneq."
        },
        "26": {
            "start": 951.24,
            "end": 966.22,
            "transcript": "Cali-llu una quyaviksugyaaqluku Paul John-aq angevlaaqaa [?] cakneq aanallrat-llu waten mat'um yuramek pillrukiinga."
        },
        "27": {
            "start": 966.5,
            "end": 979.38,
            "transcript": "Cunawa maa-i mat'um nalliini waten nelkavvlua [?] inerciigatellrung'e'rma asriullrung'e'rma tau͡gaam tamakut pellugtut."
        },
        "28": {
            "start": 979.38,
            "end": 985.36,
            "transcript": "Kenka taugaam aturluku wangkuta piarkaugaput."
        },
        "29": {
            "start": 985.36,
            "end": 995.0,
            "transcript": "Uuggun ircaqumteggun waniwa kenka cakneq. Taumek illiini kneka cakneq pila'arqa."
        },
        "30": {
            "start": 995.0,
            "end": 1008.98,
            "transcript": "Cikirrautemnek-llu waniwa piyunqelaama unuvkenii pilaamteggen neqet tamaita puluvtaqata tun'aqluki aruskevkenaki."
        },
        "31": {
            "start": 1008.98,
            "end": 1020.28,
            "transcript": "Makut-llu ak'allaraat tangellrit piciuqapiartut, quyavikengqercaaranka Kuigpagmiut au͡gkut."
        },
        "32": {
            "start": 1020.28,
            "end": 1033.98,
            "transcript": "Qerruulliigmiut-llu au͡gkut Imangarmiut-llu au͡gkut Negeqlirmiut-llu au͡gkut yurarturallret eliteltet wangnun tayima."
        },
        "33": {
            "start": 1033.98,
            "end": 1042.2,
            "transcript": "Arcaqerluku-llu man'a wangkuta pinilria cakneq umyuaq cacestuqulluku [?] pakemna."
        },
        "34": {
            "start": 1042.2,
            "end": 1056.74,
            "transcript": "Wangkuta nallunritaput quyanaqeqapiarpallruunga mat'um nalliini waniwa tekilluku, agayun kiingan umyuaqluku cakneq piciqaput ii-i, quyana."
        },
        "35": {
            "start": 1072.8,
            "end": 1084.28,
            "transcript": "Uumek wiinga cikirramken atuqamek tua-i anuqliurcuutekaminek qasperkaminek patercaarkaminek-llu."
        },
        "36": {
            "start": 1099.44,
            "end": 1110.94,
            "transcript": "Yaa wiinga-ll' quyaunga umkusrumnek [?] erinitelriaten ayuqellruyaaqngamku waten quyallmek piqallerkaa mat'um ciungani."
        },
        "37": {
            "start": 1110.94,
            "end": 1129.46,
            "transcript": "Uum Mamterillerem avatiini yuraq paivtellriatun ayagyuangullrutminun ayuqellruagu aruliqallratnek egmian tua-i-wa elimavkarluku alerquatengani pivkaraqluci waniwa."
        },
        "38": {
            "start": 1129.46,
            "end": 1137.34,
            "transcript": "Tua-i ilakngamteggu ullagarput quyaliurta waten quyatnek pimallranek."
        },
        "39": {
            "start": 1137.34,
            "end": 1152.94,
            "transcript": "Waniwa Yugcetun alqama yukaa Kass'atun tau͡gken first cousin-aama yukluku tua-i-wa amllermek qanenriteng'e'rma au͡gna nalqigacupiarqa quyana."
        },
        "40": {
            "start": 1155.3,
            "end": 1161.22,
            "transcript": "Ii-i quyanaqpiit-lli tua-i anglanilalriakut tau͡gaam."
        },
        "41": {
            "start": 1183.96,
            "end": 1186.14,
            "transcript": "Ak'allarllainarnek atuqatartukut."
        }
    }
};